/* Auto-generated by scripts/compile-content.mjs. Do not edit. */
import type { KnowledgePoint, ManifestEntry } from "../types/content";

export const manifestEntries = [
  {
    "id": "u1-01-economics-social-science",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "经济学作为社会科学",
      "en": "Economics as a social science"
    },
    "pages": [
      3
    ]
  },
  {
    "id": "u1-02-microeconomics",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "微观经济学",
      "en": "Microeconomics"
    },
    "pages": [
      3
    ]
  },
  {
    "id": "u1-03-macroeconomics",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "宏观经济学",
      "en": "Macroeconomics"
    },
    "pages": [
      3
    ]
  },
  {
    "id": "u1-04-scarcity",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "稀缺性",
      "en": "Scarcity"
    },
    "pages": [
      4
    ]
  },
  {
    "id": "u1-05-choice",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "选择",
      "en": "Choice"
    },
    "pages": [
      4
    ]
  },
  {
    "id": "u1-06-efficiency",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "效率",
      "en": "Efficiency"
    },
    "pages": [
      5
    ]
  },
  {
    "id": "u1-07-equity",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "公平",
      "en": "Equity"
    },
    "pages": [
      5
    ]
  },
  {
    "id": "u1-08-economic-wellbeing",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "经济福祉",
      "en": "Economic well-being"
    },
    "pages": [
      5
    ]
  },
  {
    "id": "u1-09-sustainability",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "可持续性",
      "en": "Sustainability"
    },
    "pages": [
      6
    ]
  },
  {
    "id": "u1-10-change",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "变化",
      "en": "Change"
    },
    "pages": [
      6
    ]
  },
  {
    "id": "u1-11-interdependence",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "相互依存",
      "en": "Interdependence"
    },
    "pages": [
      6
    ]
  },
  {
    "id": "u1-12-intervention",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "干预",
      "en": "Intervention"
    },
    "pages": [
      7
    ]
  },
  {
    "id": "u1-13-factors-of-production",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "四类生产要素",
      "en": "Factors of production"
    },
    "pages": [
      7,
      8
    ]
  },
  {
    "id": "u1-14-opportunity-cost",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "机会成本",
      "en": "Opportunity cost"
    },
    "pages": [
      8,
      9
    ]
  },
  {
    "id": "u1-15-free-goods",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "免费物品",
      "en": "Free goods"
    },
    "pages": [
      9
    ]
  },
  {
    "id": "u1-16-basic-economic-questions",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "三个基本经济问题",
      "en": "The three basic economic questions"
    },
    "pages": [
      10
    ]
  },
  {
    "id": "u1-17-resource-allocation",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "资源配置与重新配置",
      "en": "Resource allocation and reallocation"
    },
    "pages": [
      10,
      11
    ]
  },
  {
    "id": "u1-18-income-distribution",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "收入与产出分配",
      "en": "Income and output distribution"
    },
    "pages": [
      10,
      11
    ]
  },
  {
    "id": "u1-19-market-mechanism",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "市场机制",
      "en": "The market mechanism"
    },
    "pages": [
      12
    ]
  },
  {
    "id": "u1-20-government-intervention",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "政府干预",
      "en": "Government intervention"
    },
    "pages": [
      12
    ]
  },
  {
    "id": "u1-21-free-market-economy",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "自由市场经济",
      "en": "The free-market economy"
    },
    "pages": [
      13
    ]
  },
  {
    "id": "u1-22-planned-economy",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "计划经济",
      "en": "The planned economy"
    },
    "pages": [
      13
    ]
  },
  {
    "id": "u1-23-mixed-economy",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "混合经济",
      "en": "The mixed economy"
    },
    "pages": [
      14
    ]
  },
  {
    "id": "u1-24-economic-models",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "经济模型的作用与局限",
      "en": "Purposes and limits of economic models"
    },
    "pages": [
      15
    ]
  },
  {
    "id": "u1-25-ppc-construction",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "生产可能性曲线的构造",
      "en": "Constructing a PPC"
    },
    "pages": [
      15,
      16
    ]
  },
  {
    "id": "u1-26-ppc-scarcity-choice-cost",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "PPC中的稀缺、选择与机会成本",
      "en": "Scarcity choice and cost on a PPC"
    },
    "pages": [
      17,
      18
    ]
  },
  {
    "id": "u1-27-ppc-unemployment-efficiency",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "PPC中的失业与生产效率",
      "en": "Unemployment and efficiency on a PPC"
    },
    "pages": [
      16,
      19
    ]
  },
  {
    "id": "u1-28-ppc-growth",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "实际增长与生产潜力增长",
      "en": "Actual and potential growth"
    },
    "pages": [
      19,
      20
    ]
  },
  {
    "id": "u1-29-ppc-opportunity-cost-shapes",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "递增与不变机会成本",
      "en": "Increasing and constant opportunity cost"
    },
    "pages": [
      21,
      22
    ]
  },
  {
    "id": "u1-30-positive-economics",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "实证经济学",
      "en": "Positive economics"
    },
    "pages": [
      23,
      24
    ]
  },
  {
    "id": "u1-31-normative-economics",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "规范经济学与价值判断",
      "en": "Normative economics and value judgements"
    },
    "pages": [
      23,
      24
    ]
  },
  {
    "id": "u1-32-logic-hypotheses-theories",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "逻辑、假设、理论与模型",
      "en": "Logic hypotheses theories and models"
    },
    "pages": [
      24,
      25
    ]
  },
  {
    "id": "u1-33-ceteris-paribus",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "其他条件不变",
      "en": "Ceteris paribus"
    },
    "pages": [
      26
    ]
  },
  {
    "id": "u1-34-evidence-refutation",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "经验证据与证伪",
      "en": "Empirical evidence and refutation"
    },
    "pages": [
      27,
      28
    ]
  },
  {
    "id": "u1-35-equality-equity",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "平等与公平",
      "en": "Equality and equity"
    },
    "pages": [
      30
    ]
  },
  {
    "id": "u1-36-adam-smith",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "亚当·斯密与自由放任",
      "en": "Adam Smith and laissez-faire"
    },
    "pages": [
      31,
      32
    ]
  },
  {
    "id": "u1-37-utility-marginalism",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "效用理论与边际主义",
      "en": "Utility theory and marginalism"
    },
    "pages": [
      33,
      34
    ]
  },
  {
    "id": "u1-38-says-law",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "萨伊定律",
      "en": "Say's Law"
    },
    "pages": [
      34
    ]
  },
  {
    "id": "u1-39-marxist-critique",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "马克思主义批判",
      "en": "The Marxist critique"
    },
    "pages": [
      35
    ]
  },
  {
    "id": "u1-40-keynesian-revolution",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "凯恩斯革命与宏观政策",
      "en": "The Keynesian revolution and macroeconomic policy"
    },
    "pages": [
      36,
      37
    ]
  },
  {
    "id": "u1-41-monetarist-new-classical",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "货币主义与新古典反革命",
      "en": "The monetarist and new classical counter-revolution"
    },
    "pages": [
      38,
      39
    ]
  },
  {
    "id": "u1-42-behavioural-economics",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "行为经济学",
      "en": "Behavioural economics"
    },
    "pages": [
      40
    ]
  },
  {
    "id": "u1-43-circular-economy",
    "section": "1.2",
    "level": "core",
    "title": {
      "zh-CN": "相互依存与循环经济",
      "en": "Interdependence and the circular economy"
    },
    "pages": [
      41
    ]
  },
  {
    "id": "u1-44-circular-flow",
    "section": "1.1",
    "level": "core",
    "title": {
      "zh-CN": "收入循环、漏出与注入",
      "en": "Circular flow, leakages and injections"
    },
    "pages": [
      15
    ]
  },
  {
    "id": "u2-01-demand",
    "section": "2.1",
    "level": "core",
    "title": {
      "zh-CN": "需求与需求量",
      "en": "Demand and quantity demanded"
    },
    "pages": [
      43
    ]
  },
  {
    "id": "u2-02-law-of-demand",
    "section": "2.1",
    "level": "core",
    "title": {
      "zh-CN": "需求定律",
      "en": "The law of demand"
    },
    "pages": [
      43
    ]
  },
  {
    "id": "u2-03-demand-shifts",
    "section": "2.1",
    "level": "core",
    "title": {
      "zh-CN": "需求的非价格决定因素",
      "en": "Non-price determinants of demand"
    },
    "pages": [
      43
    ]
  },
  {
    "id": "u2-04-market-demand",
    "section": "2.1",
    "level": "core",
    "title": {
      "zh-CN": "个人需求与市场需求",
      "en": "Individual and market demand"
    },
    "pages": [
      43
    ]
  },
  {
    "id": "u2-05-marginal-utility",
    "section": "2.1",
    "level": "hl",
    "title": {
      "zh-CN": "边际效用与消费者选择",
      "en": "Marginal utility and consumer choice"
    },
    "pages": [
      43
    ]
  },
  {
    "id": "u2-06-supply",
    "section": "2.2",
    "level": "core",
    "title": {
      "zh-CN": "供给与供给量",
      "en": "Supply and quantity supplied"
    },
    "pages": [
      49
    ]
  },
  {
    "id": "u2-07-supply-shifts",
    "section": "2.2",
    "level": "core",
    "title": {
      "zh-CN": "供给的非价格决定因素",
      "en": "Non-price determinants of supply"
    },
    "pages": [
      49
    ]
  },
  {
    "id": "u2-08-market-supply",
    "section": "2.2",
    "level": "core",
    "title": {
      "zh-CN": "市场供给与时间尺度",
      "en": "Market supply and time horizons"
    },
    "pages": [
      49
    ]
  },
  {
    "id": "u2-09-diminishing-returns",
    "section": "2.2",
    "level": "hl",
    "title": {
      "zh-CN": "边际报酬递减",
      "en": "Diminishing marginal returns"
    },
    "pages": [
      49
    ]
  },
  {
    "id": "u2-10-costs-and-supply",
    "section": "2.2",
    "level": "hl",
    "title": {
      "zh-CN": "边际成本与供给决策",
      "en": "Marginal cost and supply decisions"
    },
    "pages": [
      49
    ]
  },
  {
    "id": "u2-11-equilibrium",
    "section": "2.3",
    "level": "core",
    "title": {
      "zh-CN": "竞争市场均衡",
      "en": "Competitive market equilibrium"
    },
    "pages": [
      57
    ]
  },
  {
    "id": "u2-12-shortage-surplus",
    "section": "2.3",
    "level": "core",
    "title": {
      "zh-CN": "短缺、过剩与价格调整",
      "en": "Shortages, surpluses and price adjustment"
    },
    "pages": [
      57
    ]
  },
  {
    "id": "u2-13-equilibrium-shifts",
    "section": "2.3",
    "level": "core",
    "title": {
      "zh-CN": "均衡变化与同时移动",
      "en": "Equilibrium changes and simultaneous shifts"
    },
    "pages": [
      57
    ]
  },
  {
    "id": "u2-14-price-mechanism",
    "section": "2.3",
    "level": "core",
    "title": {
      "zh-CN": "价格的信号、激励与配给",
      "en": "Price signals, incentives and rationing"
    },
    "pages": [
      57
    ]
  },
  {
    "id": "u2-15-surplus-efficiency",
    "section": "2.3",
    "level": "core",
    "title": {
      "zh-CN": "消费者剩余、生产者剩余与效率",
      "en": "Surplus and allocative efficiency"
    },
    "pages": [
      62
    ]
  },
  {
    "id": "u2-16-bounded-rationality",
    "section": "2.4",
    "level": "hl",
    "title": {
      "zh-CN": "理性选择与有限理性",
      "en": "Rational choice and bounded rationality"
    },
    "pages": [
      72
    ]
  },
  {
    "id": "u2-17-biases-nudges",
    "section": "2.4",
    "level": "hl",
    "title": {
      "zh-CN": "行为偏差与助推",
      "en": "Behavioural biases and nudges"
    },
    "pages": [
      72
    ]
  },
  {
    "id": "u2-18-firm-objectives",
    "section": "2.4",
    "level": "hl",
    "title": {
      "zh-CN": "企业的多重目标",
      "en": "Alternative objectives of firms"
    },
    "pages": [
      72
    ]
  },
  {
    "id": "u2-19-ped",
    "section": "2.5",
    "level": "core",
    "title": {
      "zh-CN": "需求价格弹性 PED",
      "en": "Price elasticity of demand"
    },
    "pages": [
      85
    ]
  },
  {
    "id": "u2-20-ped-determinants",
    "section": "2.5",
    "level": "core",
    "title": {
      "zh-CN": "PED 的决定因素",
      "en": "Determinants of PED"
    },
    "pages": [
      85
    ]
  },
  {
    "id": "u2-21-ped-revenue",
    "section": "2.5",
    "level": "core",
    "title": {
      "zh-CN": "PED 与总收入",
      "en": "PED and total revenue"
    },
    "pages": [
      85
    ]
  },
  {
    "id": "u2-22-yed",
    "section": "2.5",
    "level": "core",
    "title": {
      "zh-CN": "需求收入弹性 YED",
      "en": "Income elasticity of demand"
    },
    "pages": [
      97
    ]
  },
  {
    "id": "u2-23-elasticity-extremes",
    "section": "2.5",
    "level": "hl",
    "title": {
      "zh-CN": "弹性、斜率与收入变化",
      "en": "Elasticity, slope and changing income"
    },
    "pages": [
      85
    ]
  },
  {
    "id": "u2-24-pes",
    "section": "2.6",
    "level": "core",
    "title": {
      "zh-CN": "供给价格弹性 PES",
      "en": "Price elasticity of supply"
    },
    "pages": [
      104
    ]
  },
  {
    "id": "u2-25-pes-determinants",
    "section": "2.6",
    "level": "core",
    "title": {
      "zh-CN": "PES、产能与时间",
      "en": "PES, capacity and time"
    },
    "pages": [
      104
    ]
  },
  {
    "id": "u2-26-pes-application",
    "section": "2.6",
    "level": "core",
    "title": {
      "zh-CN": "PES 的计算与政策含义",
      "en": "PES calculations and policy implications"
    },
    "pages": [
      104
    ]
  },
  {
    "id": "u2-27-price-ceiling",
    "section": "2.7",
    "level": "core",
    "title": {
      "zh-CN": "最高限价",
      "en": "Price ceilings"
    },
    "pages": [
      114
    ]
  },
  {
    "id": "u2-28-price-floor",
    "section": "2.7",
    "level": "core",
    "title": {
      "zh-CN": "最低限价与最低工资",
      "en": "Price floors and minimum wages"
    },
    "pages": [
      121
    ]
  },
  {
    "id": "u2-29-indirect-tax",
    "section": "2.7",
    "level": "core",
    "title": {
      "zh-CN": "间接税与税收负担",
      "en": "Indirect taxes and tax incidence"
    },
    "pages": [
      127
    ]
  },
  {
    "id": "u2-30-subsidy",
    "section": "2.7",
    "level": "core",
    "title": {
      "zh-CN": "补贴与财政成本",
      "en": "Subsidies and fiscal cost"
    },
    "pages": [
      134
    ]
  },
  {
    "id": "u2-31-intervention-evaluation",
    "section": "2.7",
    "level": "core",
    "title": {
      "zh-CN": "干预的利益相关者与评价",
      "en": "Stakeholders and intervention evaluation"
    },
    "pages": [
      113
    ]
  },
  {
    "id": "u2-32-tax-welfare-calculation",
    "section": "2.7",
    "level": "hl",
    "title": {
      "zh-CN": "税补的福利计算",
      "en": "Tax and subsidy welfare calculations"
    },
    "pages": [
      130
    ]
  },
  {
    "id": "u2-33-market-failure",
    "section": "2.8",
    "level": "core",
    "title": {
      "zh-CN": "市场失灵与社会最优",
      "en": "Market failure and the social optimum"
    },
    "pages": [
      147
    ]
  },
  {
    "id": "u2-34-negative-production",
    "section": "2.8",
    "level": "core",
    "title": {
      "zh-CN": "负生产外部性",
      "en": "Negative production externalities"
    },
    "pages": [
      150
    ]
  },
  {
    "id": "u2-35-negative-consumption",
    "section": "2.8",
    "level": "core",
    "title": {
      "zh-CN": "负消费外部性",
      "en": "Negative consumption externalities"
    },
    "pages": [
      164
    ]
  },
  {
    "id": "u2-36-positive-production",
    "section": "2.8",
    "level": "core",
    "title": {
      "zh-CN": "正生产外部性",
      "en": "Positive production externalities"
    },
    "pages": [
      174
    ]
  },
  {
    "id": "u2-37-positive-consumption",
    "section": "2.8",
    "level": "core",
    "title": {
      "zh-CN": "正消费外部性与优值品",
      "en": "Positive consumption externalities and merit goods"
    },
    "pages": [
      177
    ]
  },
  {
    "id": "u2-38-common-resources",
    "section": "2.8",
    "level": "core",
    "title": {
      "zh-CN": "共同资源与公地悲剧",
      "en": "Common resources and the tragedy of the commons"
    },
    "pages": [
      144
    ]
  },
  {
    "id": "u2-39-externality-policies",
    "section": "2.8",
    "level": "core",
    "title": {
      "zh-CN": "外部性政策与可持续性",
      "en": "Externality policies and sustainability"
    },
    "pages": [
      154
    ]
  },
  {
    "id": "u2-40-external-welfare",
    "section": "2.8",
    "level": "hl",
    "title": {
      "zh-CN": "外部性与福利损失计算",
      "en": "Externalities and welfare-loss calculations"
    },
    "pages": [
      153
    ]
  },
  {
    "id": "u2-41-public-goods",
    "section": "2.9",
    "level": "core",
    "title": {
      "zh-CN": "公共物品的特征",
      "en": "Characteristics of public goods"
    },
    "pages": [
      184
    ]
  },
  {
    "id": "u2-42-free-rider",
    "section": "2.9",
    "level": "core",
    "title": {
      "zh-CN": "搭便车与市场提供不足",
      "en": "Free riding and underprovision"
    },
    "pages": [
      184
    ]
  },
  {
    "id": "u2-43-public-provision",
    "section": "2.9",
    "level": "core",
    "title": {
      "zh-CN": "公共物品的提供与评价",
      "en": "Provision and evaluation of public goods"
    },
    "pages": [
      184
    ]
  },
  {
    "id": "u2-44-adverse-selection",
    "section": "2.10",
    "level": "hl",
    "title": {
      "zh-CN": "信息不对称与逆向选择",
      "en": "Asymmetric information and adverse selection"
    },
    "pages": [
      187
    ]
  },
  {
    "id": "u2-45-moral-hazard",
    "section": "2.10",
    "level": "hl",
    "title": {
      "zh-CN": "道德风险",
      "en": "Moral hazard"
    },
    "pages": [
      187
    ]
  },
  {
    "id": "u2-46-information-remedies",
    "section": "2.10",
    "level": "hl",
    "title": {
      "zh-CN": "信息不对称的应对",
      "en": "Remedies for asymmetric information"
    },
    "pages": [
      187
    ]
  },
  {
    "id": "u2-47-market-structures",
    "section": "2.11",
    "level": "hl",
    "title": {
      "zh-CN": "市场结构与进入壁垒",
      "en": "Market structures and entry barriers"
    },
    "pages": [
      196
    ]
  },
  {
    "id": "u2-48-cost-curves",
    "section": "2.11",
    "level": "hl",
    "title": {
      "zh-CN": "总成本、平均成本与边际成本",
      "en": "Total, average and marginal costs"
    },
    "pages": [
      199
    ]
  },
  {
    "id": "u2-49-scale",
    "section": "2.11",
    "level": "hl",
    "title": {
      "zh-CN": "规模经济与规模不经济",
      "en": "Economies and diseconomies of scale"
    },
    "pages": [
      204
    ]
  },
  {
    "id": "u2-50-revenue-profit",
    "section": "2.11",
    "level": "hl",
    "title": {
      "zh-CN": "收益、经济利润与正常利润",
      "en": "Revenue, economic and normal profit"
    },
    "pages": [
      205
    ]
  },
  {
    "id": "u2-51-profit-maximisation",
    "section": "2.11",
    "level": "hl",
    "title": {
      "zh-CN": "利润最大化与停产",
      "en": "Profit maximisation and shutdown"
    },
    "pages": [
      206
    ]
  },
  {
    "id": "u2-52-perfect-competition",
    "section": "2.11",
    "level": "hl",
    "title": {
      "zh-CN": "完全竞争",
      "en": "Perfect competition"
    },
    "pages": [
      207
    ]
  },
  {
    "id": "u2-53-monopoly",
    "section": "2.11",
    "level": "hl",
    "title": {
      "zh-CN": "垄断定价与效率",
      "en": "Monopoly pricing and efficiency"
    },
    "pages": [
      215
    ]
  },
  {
    "id": "u2-54-natural-monopoly",
    "section": "2.11",
    "level": "hl",
    "title": {
      "zh-CN": "自然垄断与价格监管",
      "en": "Natural monopoly and price regulation"
    },
    "pages": [
      220
    ]
  },
  {
    "id": "u2-55-monopolistic-competition",
    "section": "2.11",
    "level": "hl",
    "title": {
      "zh-CN": "垄断竞争",
      "en": "Monopolistic competition"
    },
    "pages": [
      225
    ]
  },
  {
    "id": "u2-56-oligopoly",
    "section": "2.11",
    "level": "hl",
    "title": {
      "zh-CN": "寡头、相互依赖与博弈",
      "en": "Oligopoly, interdependence and game theory"
    },
    "pages": [
      230
    ]
  },
  {
    "id": "u2-57-competition-policy",
    "section": "2.11",
    "level": "hl",
    "title": {
      "zh-CN": "竞争政策与市场势力评价",
      "en": "Competition policy and evaluation of market power"
    },
    "pages": [
      239
    ]
  },
  {
    "id": "u2-58-equity-distribution",
    "section": "2.12",
    "level": "hl",
    "title": {
      "zh-CN": "市场分配与公平",
      "en": "Market distribution and equity"
    },
    "pages": [
      191
    ]
  },
  {
    "id": "u2-59-income-wealth",
    "section": "2.12",
    "level": "hl",
    "title": {
      "zh-CN": "收入、财富与机会",
      "en": "Income, wealth and opportunity"
    },
    "pages": [
      191
    ]
  },
  {
    "id": "u2-60-redistribution",
    "section": "2.12",
    "level": "hl",
    "title": {
      "zh-CN": "再分配与政策权衡",
      "en": "Redistribution and policy trade-offs"
    },
    "pages": [
      191
    ]
  },
  {
    "id": "u3-01-circular-flow",
    "section": "3.1",
    "level": "core",
    "title": {
      "zh-CN": "收入循环与五部门经济",
      "en": "Circular flow and the five-sector economy"
    },
    "pages": [
      248
    ]
  },
  {
    "id": "u3-02-gdp",
    "section": "3.1",
    "level": "core",
    "title": {
      "zh-CN": "国内生产总值与增加值",
      "en": "GDP and value added"
    },
    "pages": [
      250
    ]
  },
  {
    "id": "u3-03-expenditure",
    "section": "3.1",
    "level": "core",
    "title": {
      "zh-CN": "支出法 GDP",
      "en": "GDP by expenditure"
    },
    "pages": [
      256
    ]
  },
  {
    "id": "u3-04-nominal-real",
    "section": "3.1",
    "level": "core",
    "title": {
      "zh-CN": "名义与实际 GDP",
      "en": "Nominal and real GDP"
    },
    "pages": [
      250
    ]
  },
  {
    "id": "u3-05-deflator",
    "section": "3.1",
    "level": "core",
    "title": {
      "zh-CN": "GDP 平减指数与核算计算",
      "en": "GDP deflator and national-account calculations"
    },
    "pages": [
      256
    ]
  },
  {
    "id": "u3-06-gni",
    "section": "3.1",
    "level": "core",
    "title": {
      "zh-CN": "GNI、折旧与净收入",
      "en": "GNI, depreciation and net income"
    },
    "pages": [
      250
    ]
  },
  {
    "id": "u3-07-per-capita-ppp",
    "section": "3.1",
    "level": "core",
    "title": {
      "zh-CN": "人均实际收入与 PPP",
      "en": "Real income per capita and PPP"
    },
    "pages": [
      264
    ]
  },
  {
    "id": "u3-08-business-cycle",
    "section": "3.1",
    "level": "core",
    "title": {
      "zh-CN": "经济周期与趋势",
      "en": "Business cycles and trend output"
    },
    "pages": [
      260
    ]
  },
  {
    "id": "u3-09-gdp-limitations",
    "section": "3.1",
    "level": "core",
    "title": {
      "zh-CN": "GDP 与生活水平的局限",
      "en": "GDP and limits as a living-standard measure"
    },
    "pages": [
      264
    ]
  },
  {
    "id": "u3-10-wellbeing-indicators",
    "section": "3.1",
    "level": "core",
    "title": {
      "zh-CN": "替代福利指标",
      "en": "Alternative wellbeing indicators"
    },
    "pages": [
      264
    ]
  },
  {
    "id": "u3-11-aggregate-demand",
    "section": "3.2",
    "level": "core",
    "title": {
      "zh-CN": "总需求与 AD 曲线",
      "en": "Aggregate demand and the AD curve"
    },
    "pages": [
      272
    ]
  },
  {
    "id": "u3-12-consumption",
    "section": "3.2",
    "level": "core",
    "title": {
      "zh-CN": "消费与总需求移动",
      "en": "Consumption and shifts in aggregate demand"
    },
    "pages": [
      272
    ]
  },
  {
    "id": "u3-13-investment",
    "section": "3.2",
    "level": "core",
    "title": {
      "zh-CN": "投资与加速、信心和利率",
      "en": "Investment, confidence and interest rates"
    },
    "pages": [
      272
    ]
  },
  {
    "id": "u3-14-sras",
    "section": "3.2",
    "level": "core",
    "title": {
      "zh-CN": "短期总供给 SRAS",
      "en": "Short-run aggregate supply"
    },
    "pages": [
      276
    ]
  },
  {
    "id": "u3-15-lras",
    "section": "3.2",
    "level": "core",
    "title": {
      "zh-CN": "长期总供给与潜在产出",
      "en": "Long-run aggregate supply and potential output"
    },
    "pages": [
      281
    ]
  },
  {
    "id": "u3-16-keynesian-as",
    "section": "3.2",
    "level": "core",
    "title": {
      "zh-CN": "凯恩斯总供给模型",
      "en": "The Keynesian aggregate supply model"
    },
    "pages": [
      286
    ]
  },
  {
    "id": "u3-17-macro-equilibrium",
    "section": "3.2",
    "level": "core",
    "title": {
      "zh-CN": "宏观均衡与比较静态",
      "en": "Macroeconomic equilibrium and comparative statics"
    },
    "pages": [
      276
    ]
  },
  {
    "id": "u3-18-output-gaps",
    "section": "3.2",
    "level": "core",
    "title": {
      "zh-CN": "衰退缺口与通胀缺口",
      "en": "Recessionary and inflationary gaps"
    },
    "pages": [
      292
    ]
  },
  {
    "id": "u3-19-macro-shocks",
    "section": "3.2",
    "level": "core",
    "title": {
      "zh-CN": "需求冲击、供给冲击与滞胀",
      "en": "Demand shocks, supply shocks and stagflation"
    },
    "pages": [
      276
    ]
  },
  {
    "id": "u3-20-potential-growth",
    "section": "3.2",
    "level": "core",
    "title": {
      "zh-CN": "潜在增长与总供给右移",
      "en": "Potential growth and rightward aggregate supply shifts"
    },
    "pages": [
      290
    ]
  },
  {
    "id": "u3-21-unemployment-rate",
    "section": "3.3",
    "level": "core",
    "title": {
      "zh-CN": "失业率与劳动参与率",
      "en": "Unemployment and participation rates"
    },
    "pages": [
      298
    ]
  },
  {
    "id": "u3-22-unemployment-types",
    "section": "3.3",
    "level": "core",
    "title": {
      "zh-CN": "失业类型与自然失业",
      "en": "Types of unemployment and natural unemployment"
    },
    "pages": [
      298
    ]
  },
  {
    "id": "u3-23-unemployment-costs",
    "section": "3.3",
    "level": "core",
    "title": {
      "zh-CN": "失业的经济与社会成本",
      "en": "Economic and social costs of unemployment"
    },
    "pages": [
      298
    ]
  },
  {
    "id": "u3-24-cpi",
    "section": "3.3",
    "level": "core",
    "title": {
      "zh-CN": "CPI 与通胀率计算",
      "en": "CPI and inflation calculations"
    },
    "pages": [
      308
    ]
  },
  {
    "id": "u3-25-demand-pull",
    "section": "3.3",
    "level": "core",
    "title": {
      "zh-CN": "需求拉动型通胀",
      "en": "Demand-pull inflation"
    },
    "pages": [
      308
    ]
  },
  {
    "id": "u3-26-cost-push",
    "section": "3.3",
    "level": "core",
    "title": {
      "zh-CN": "成本推动型通胀",
      "en": "Cost-push inflation"
    },
    "pages": [
      313
    ]
  },
  {
    "id": "u3-27-disinflation-deflation",
    "section": "3.3",
    "level": "core",
    "title": {
      "zh-CN": "通胀放缓、通缩与实际债务",
      "en": "Disinflation, deflation and real debt"
    },
    "pages": [
      316
    ]
  },
  {
    "id": "u3-28-growth-measure",
    "section": "3.3",
    "level": "core",
    "title": {
      "zh-CN": "实际经济增长的衡量",
      "en": "Measuring real economic growth"
    },
    "pages": [
      332
    ]
  },
  {
    "id": "u3-29-growth-evaluation",
    "section": "3.3",
    "level": "core",
    "title": {
      "zh-CN": "增长的来源、收益与代价",
      "en": "Sources, benefits and costs of growth"
    },
    "pages": [
      338
    ]
  },
  {
    "id": "u3-30-public-debt",
    "section": "3.3",
    "level": "hl",
    "title": {
      "zh-CN": "政府债务与可持续性",
      "en": "Government debt and sustainability"
    },
    "pages": [
      346
    ]
  },
  {
    "id": "u3-31-phillips-curve",
    "section": "3.3",
    "level": "hl",
    "title": {
      "zh-CN": "短期与长期菲利普斯曲线",
      "en": "Short-run and long-run Phillips curves"
    },
    "pages": [
      322
    ]
  },
  {
    "id": "u3-32-objective-conflicts",
    "section": "3.3",
    "level": "core",
    "title": {
      "zh-CN": "宏观目标的冲突与协同",
      "en": "Conflicts and complementarities among objectives"
    },
    "pages": [
      350
    ]
  },
  {
    "id": "u3-33-poverty",
    "section": "3.4",
    "level": "core",
    "title": {
      "zh-CN": "绝对贫困与相对贫困",
      "en": "Absolute and relative poverty"
    },
    "pages": [
      359
    ]
  },
  {
    "id": "u3-34-inequality-causes",
    "section": "3.4",
    "level": "core",
    "title": {
      "zh-CN": "不平等与贫困的成因",
      "en": "Causes of inequality and poverty"
    },
    "pages": [
      365
    ]
  },
  {
    "id": "u3-35-lorenz-gini",
    "section": "3.4",
    "level": "core",
    "title": {
      "zh-CN": "洛伦兹曲线与 Gini 系数",
      "en": "Lorenz curves and the Gini coefficient"
    },
    "pages": [
      353
    ]
  },
  {
    "id": "u3-36-poverty-effects",
    "section": "3.4",
    "level": "core",
    "title": {
      "zh-CN": "不平等与贫困的影响",
      "en": "Effects of inequality and poverty"
    },
    "pages": [
      369
    ]
  },
  {
    "id": "u3-37-progressive-tax",
    "section": "3.4",
    "level": "core",
    "title": {
      "zh-CN": "累进税、转移支付与可支配收入",
      "en": "Progressive taxes, transfers and disposable income"
    },
    "pages": [
      371
    ]
  },
  {
    "id": "u3-38-poverty-policies",
    "section": "3.4",
    "level": "core",
    "title": {
      "zh-CN": "减贫与再分配政策评价",
      "en": "Evaluating poverty and redistribution policies"
    },
    "pages": [
      371
    ]
  },
  {
    "id": "u3-39-money-interest",
    "section": "3.5",
    "level": "core",
    "title": {
      "zh-CN": "中央银行与利率",
      "en": "Central banks and interest rates"
    },
    "pages": [
      387
    ]
  },
  {
    "id": "u3-40-monetary-transmission",
    "section": "3.5",
    "level": "core",
    "title": {
      "zh-CN": "货币政策传导",
      "en": "Monetary transmission"
    },
    "pages": [
      387
    ]
  },
  {
    "id": "u3-41-expansionary-monetary",
    "section": "3.5",
    "level": "core",
    "title": {
      "zh-CN": "扩张性货币政策",
      "en": "Expansionary monetary policy"
    },
    "pages": [
      387
    ]
  },
  {
    "id": "u3-42-contractionary-monetary",
    "section": "3.5",
    "level": "core",
    "title": {
      "zh-CN": "紧缩性货币政策",
      "en": "Contractionary monetary policy"
    },
    "pages": [
      387
    ]
  },
  {
    "id": "u3-43-unconventional-policy",
    "section": "3.5",
    "level": "hl",
    "title": {
      "zh-CN": "非常规货币政策",
      "en": "Unconventional monetary policy"
    },
    "pages": [
      387
    ]
  },
  {
    "id": "u3-44-monetary-limits",
    "section": "3.5",
    "level": "core",
    "title": {
      "zh-CN": "货币政策的有效性与约束",
      "en": "Effectiveness and limits of monetary policy"
    },
    "pages": [
      387
    ]
  },
  {
    "id": "u3-45-fiscal-budget",
    "section": "3.6",
    "level": "core",
    "title": {
      "zh-CN": "财政预算与政策立场",
      "en": "Fiscal budgets and policy stance"
    },
    "pages": [
      398
    ]
  },
  {
    "id": "u3-46-expansionary-fiscal",
    "section": "3.6",
    "level": "core",
    "title": {
      "zh-CN": "扩张性财政政策",
      "en": "Expansionary fiscal policy"
    },
    "pages": [
      398
    ]
  },
  {
    "id": "u3-47-contractionary-fiscal",
    "section": "3.6",
    "level": "core",
    "title": {
      "zh-CN": "紧缩性财政政策",
      "en": "Contractionary fiscal policy"
    },
    "pages": [
      398
    ]
  },
  {
    "id": "u3-48-automatic-stabilisers",
    "section": "3.6",
    "level": "hl",
    "title": {
      "zh-CN": "自动稳定器",
      "en": "Automatic stabilisers"
    },
    "pages": [
      398
    ]
  },
  {
    "id": "u3-49-multiplier",
    "section": "3.6",
    "level": "hl",
    "title": {
      "zh-CN": "凯恩斯乘数",
      "en": "The Keynesian multiplier"
    },
    "pages": [
      407
    ]
  },
  {
    "id": "u3-50-crowding-out",
    "section": "3.6",
    "level": "hl",
    "title": {
      "zh-CN": "挤出效应",
      "en": "Crowding out"
    },
    "pages": [
      398
    ]
  },
  {
    "id": "u3-51-fiscal-evaluation",
    "section": "3.6",
    "level": "core",
    "title": {
      "zh-CN": "财政政策评价",
      "en": "Evaluating fiscal policy"
    },
    "pages": [
      398
    ]
  },
  {
    "id": "u3-52-market-based-supply",
    "section": "3.7",
    "level": "core",
    "title": {
      "zh-CN": "市场导向供给侧政策",
      "en": "Market-based supply-side policies"
    },
    "pages": [
      412
    ]
  },
  {
    "id": "u3-53-interventionist-supply",
    "section": "3.7",
    "level": "core",
    "title": {
      "zh-CN": "干预型供给侧政策",
      "en": "Interventionist supply-side policies"
    },
    "pages": [
      412
    ]
  },
  {
    "id": "u3-54-labour-market",
    "section": "3.7",
    "level": "core",
    "title": {
      "zh-CN": "劳动力市场政策",
      "en": "Labour-market policies"
    },
    "pages": [
      412
    ]
  },
  {
    "id": "u3-55-infrastructure-innovation",
    "section": "3.7",
    "level": "core",
    "title": {
      "zh-CN": "基础设施与创新",
      "en": "Infrastructure and innovation"
    },
    "pages": [
      412
    ]
  },
  {
    "id": "u3-56-policy-mix",
    "section": "3.7",
    "level": "core",
    "title": {
      "zh-CN": "宏观政策组合与评价",
      "en": "Macroeconomic policy mixes"
    },
    "pages": [
      424
    ]
  },
  {
    "id": "u3-57-bank-money-creation",
    "section": "3.5",
    "level": "hl",
    "title": {
      "zh-CN": "商业银行的货币创造",
      "en": "Money creation by commercial banks"
    },
    "pages": [
      387
    ]
  },
  {
    "id": "u3-58-monetary-tools",
    "section": "3.5",
    "level": "hl",
    "title": {
      "zh-CN": "货币政策工具",
      "en": "Monetary policy instruments"
    },
    "pages": [
      387
    ]
  },
  {
    "id": "u3-59-money-market",
    "section": "3.5",
    "level": "hl",
    "title": {
      "zh-CN": "货币市场与均衡利率",
      "en": "The money market and equilibrium interest"
    },
    "pages": [
      387
    ]
  },
  {
    "id": "u3-60-inflation-costs",
    "section": "3.3",
    "level": "core",
    "title": {
      "zh-CN": "通胀成本与失业的比较",
      "en": "Inflation costs and comparison with unemployment"
    },
    "pages": [
      308
    ]
  },
  {
    "id": "u4-01-trade-benefits",
    "section": "4.1",
    "level": "core",
    "title": {
      "zh-CN": "贸易、专业化与竞争",
      "en": "Trade, specialisation and competition"
    },
    "pages": [
      433
    ]
  },
  {
    "id": "u4-02-free-trade-imports",
    "section": "4.1",
    "level": "core",
    "title": {
      "zh-CN": "小国自由贸易与进口",
      "en": "Free trade and imports in a small economy"
    },
    "pages": [
      433
    ]
  },
  {
    "id": "u4-03-free-trade-exports",
    "section": "4.1",
    "level": "core",
    "title": {
      "zh-CN": "小国自由贸易与出口",
      "en": "Free trade and exports in a small economy"
    },
    "pages": [
      433
    ]
  },
  {
    "id": "u4-04-absolute-advantage",
    "section": "4.1",
    "level": "hl",
    "title": {
      "zh-CN": "绝对优势",
      "en": "Absolute advantage"
    },
    "pages": [
      438
    ]
  },
  {
    "id": "u4-05-comparative-advantage",
    "section": "4.1",
    "level": "hl",
    "title": {
      "zh-CN": "比较优势与贸易区间",
      "en": "Comparative advantage and the trading interval"
    },
    "pages": [
      438
    ]
  },
  {
    "id": "u4-06-trade-evaluation",
    "section": "4.1",
    "level": "core",
    "title": {
      "zh-CN": "贸易收益的条件与分配",
      "en": "Conditions and distribution of trade gains"
    },
    "pages": [
      433
    ]
  },
  {
    "id": "u4-07-tariff",
    "section": "4.2",
    "level": "core",
    "title": {
      "zh-CN": "关税与小国福利",
      "en": "Tariffs and small-country welfare"
    },
    "pages": [
      444
    ]
  },
  {
    "id": "u4-08-quota",
    "section": "4.2",
    "level": "core",
    "title": {
      "zh-CN": "进口配额与配额租",
      "en": "Import quotas and quota rents"
    },
    "pages": [
      444
    ]
  },
  {
    "id": "u4-09-production-subsidy",
    "section": "4.2",
    "level": "core",
    "title": {
      "zh-CN": "生产补贴与进口替代",
      "en": "Production subsidies and import displacement"
    },
    "pages": [
      444
    ]
  },
  {
    "id": "u4-10-export-subsidy",
    "section": "4.2",
    "level": "core",
    "title": {
      "zh-CN": "出口补贴",
      "en": "Export subsidies"
    },
    "pages": [
      444
    ]
  },
  {
    "id": "u4-11-administrative-barriers",
    "section": "4.2",
    "level": "core",
    "title": {
      "zh-CN": "行政壁垒与标准",
      "en": "Administrative barriers and standards"
    },
    "pages": [
      444
    ]
  },
  {
    "id": "u4-12-infant-industry",
    "section": "4.3",
    "level": "core",
    "title": {
      "zh-CN": "幼稚产业与战略保护",
      "en": "Infant industries and strategic protection"
    },
    "pages": [
      465
    ]
  },
  {
    "id": "u4-13-protection-arguments",
    "section": "4.3",
    "level": "core",
    "title": {
      "zh-CN": "就业、安全与反倾销论据",
      "en": "Employment, security and anti-dumping arguments"
    },
    "pages": [
      465
    ]
  },
  {
    "id": "u4-14-protection-evaluation",
    "section": "4.3",
    "level": "core",
    "title": {
      "zh-CN": "保护政策的综合评价",
      "en": "Evaluating protection policies"
    },
    "pages": [
      465
    ]
  },
  {
    "id": "u4-15-wto",
    "section": "4.4",
    "level": "core",
    "title": {
      "zh-CN": "世界贸易组织与合作",
      "en": "The WTO and trade cooperation"
    },
    "pages": [
      483
    ]
  },
  {
    "id": "u4-16-trading-blocs",
    "section": "4.4",
    "level": "core",
    "title": {
      "zh-CN": "优惠协定、自由贸易区与关税同盟",
      "en": "Preferential agreements, free trade areas and customs unions"
    },
    "pages": [
      472
    ]
  },
  {
    "id": "u4-17-common-market",
    "section": "4.4",
    "level": "core",
    "title": {
      "zh-CN": "共同市场与经济一体化",
      "en": "Common markets and economic integration"
    },
    "pages": [
      472
    ]
  },
  {
    "id": "u4-18-trade-creation-diversion",
    "section": "4.4",
    "level": "hl",
    "title": {
      "zh-CN": "贸易创造与贸易转移",
      "en": "Trade creation and trade diversion"
    },
    "pages": [
      472
    ]
  },
  {
    "id": "u4-19-monetary-union",
    "section": "4.4",
    "level": "core",
    "title": {
      "zh-CN": "货币联盟的含义",
      "en": "The meaning of monetary union"
    },
    "pages": [
      482
    ]
  },
  {
    "id": "u4-20-integration-evaluation",
    "section": "4.4",
    "level": "core",
    "title": {
      "zh-CN": "一体化的动态评价",
      "en": "Dynamic evaluation of integration"
    },
    "pages": [
      472
    ]
  },
  {
    "id": "u4-21-floating-exchange-rate",
    "section": "4.5",
    "level": "core",
    "title": {
      "zh-CN": "浮动汇率与报价方向",
      "en": "Floating exchange rates and quotation"
    },
    "pages": [
      491
    ]
  },
  {
    "id": "u4-22-currency-demand-supply",
    "section": "4.5",
    "level": "core",
    "title": {
      "zh-CN": "外汇需求与供给的决定因素",
      "en": "Determinants of currency demand and supply"
    },
    "pages": [
      491
    ]
  },
  {
    "id": "u4-23-exchange-rate-effects",
    "section": "4.5",
    "level": "core",
    "title": {
      "zh-CN": "升贬值的经济影响",
      "en": "Effects of appreciation and depreciation"
    },
    "pages": [
      500
    ]
  },
  {
    "id": "u4-24-fixed-exchange-rate",
    "section": "4.5",
    "level": "core",
    "title": {
      "zh-CN": "固定汇率与储备干预",
      "en": "Fixed exchange rates and reserve intervention"
    },
    "pages": [
      504
    ]
  },
  {
    "id": "u4-25-managed-exchange-rate",
    "section": "4.5",
    "level": "core",
    "title": {
      "zh-CN": "管理浮动与干预",
      "en": "Managed exchange rates and intervention"
    },
    "pages": [
      504
    ]
  },
  {
    "id": "u4-26-exchange-calculations",
    "section": "4.5",
    "level": "core",
    "title": {
      "zh-CN": "汇率换算与百分比",
      "en": "Currency conversion and percentage changes"
    },
    "pages": [
      491
    ]
  },
  {
    "id": "u4-27-exchange-policy-trilemma",
    "section": "4.5",
    "level": "hl",
    "title": {
      "zh-CN": "汇率制度与政策约束",
      "en": "Exchange regimes and policy constraints"
    },
    "pages": [
      523
    ]
  },
  {
    "id": "u4-28-current-account",
    "section": "4.6",
    "level": "core",
    "title": {
      "zh-CN": "经常账户的构成",
      "en": "Components of the current account"
    },
    "pages": [
      509
    ]
  },
  {
    "id": "u4-29-capital-financial-account",
    "section": "4.6",
    "level": "core",
    "title": {
      "zh-CN": "资本账户与金融账户",
      "en": "Capital and financial accounts"
    },
    "pages": [
      509
    ]
  },
  {
    "id": "u4-30-bop-identity",
    "section": "4.6",
    "level": "core",
    "title": {
      "zh-CN": "国际收支恒等式与符号",
      "en": "Balance-of-payments identity and signs"
    },
    "pages": [
      520
    ]
  },
  {
    "id": "u4-31-current-account-imbalances",
    "section": "4.6",
    "level": "hl",
    "title": {
      "zh-CN": "经常账户失衡的原因与可持续性",
      "en": "Causes and sustainability of current-account imbalances"
    },
    "pages": [
      530
    ]
  },
  {
    "id": "u4-32-marshall-lerner",
    "section": "4.6",
    "level": "hl",
    "title": {
      "zh-CN": "马歇尔—勒纳条件",
      "en": "The Marshall–Lerner condition"
    },
    "pages": [
      530
    ]
  },
  {
    "id": "u4-33-j-curve",
    "section": "4.6",
    "level": "hl",
    "title": {
      "zh-CN": "J 曲线与调整时滞",
      "en": "The J-curve and adjustment lags"
    },
    "pages": [
      530
    ]
  },
  {
    "id": "u4-34-imbalance-policies",
    "section": "4.6",
    "level": "hl",
    "title": {
      "zh-CN": "支出转换、支出减少与供给侧措施",
      "en": "Expenditure switching, reduction and supply policies"
    },
    "pages": [
      530
    ]
  },
  {
    "id": "u4-35-sustainable-development",
    "section": "4.7",
    "level": "core",
    "title": {
      "zh-CN": "增长、发展与可持续性",
      "en": "Growth, development and sustainability"
    },
    "pages": [
      540
    ]
  },
  {
    "id": "u4-36-environment-poverty",
    "section": "4.7",
    "level": "hl",
    "title": {
      "zh-CN": "贫困、环境与共同资源",
      "en": "Poverty, environment and common resources"
    },
    "pages": [
      540
    ]
  },
  {
    "id": "u4-37-sdg-policy",
    "section": "4.7",
    "level": "core",
    "title": {
      "zh-CN": "可持续发展目标与政策权衡",
      "en": "Sustainable development goals and policy trade-offs"
    },
    "pages": [
      540
    ]
  },
  {
    "id": "u4-38-development-indicators",
    "section": "4.8",
    "level": "core",
    "title": {
      "zh-CN": "人均收入与 PPP 比较",
      "en": "Income per capita and PPP comparison"
    },
    "pages": [
      541
    ]
  },
  {
    "id": "u4-39-hdi",
    "section": "4.8",
    "level": "core",
    "title": {
      "zh-CN": "人类发展指数",
      "en": "The Human Development Index"
    },
    "pages": [
      541
    ]
  },
  {
    "id": "u4-40-multidimensional-poverty",
    "section": "4.8",
    "level": "core",
    "title": {
      "zh-CN": "多维贫困与不平等调整",
      "en": "Multidimensional poverty and inequality adjustment"
    },
    "pages": [
      541
    ]
  },
  {
    "id": "u4-41-measurement-limits",
    "section": "4.8",
    "level": "core",
    "title": {
      "zh-CN": "发展数据的可比性与局限",
      "en": "Comparability and limits of development data"
    },
    "pages": [
      541
    ]
  },
  {
    "id": "u4-42-poverty-cycle",
    "section": "4.9",
    "level": "core",
    "title": {
      "zh-CN": "贫困循环与资本形成",
      "en": "Poverty cycles and capital formation"
    },
    "pages": [
      564
    ]
  },
  {
    "id": "u4-43-human-capital-infrastructure",
    "section": "4.9",
    "level": "core",
    "title": {
      "zh-CN": "人力资本与基础设施不足",
      "en": "Human-capital and infrastructure gaps"
    },
    "pages": [
      566
    ]
  },
  {
    "id": "u4-44-primary-dependence",
    "section": "4.9",
    "level": "core",
    "title": {
      "zh-CN": "初级产品依赖与收入波动",
      "en": "Primary-product dependence and revenue volatility"
    },
    "pages": [
      566
    ]
  },
  {
    "id": "u4-45-debt-finance-barriers",
    "section": "4.9",
    "level": "core",
    "title": {
      "zh-CN": "债务、金融排斥与资本外逃",
      "en": "Debt, financial exclusion and capital flight"
    },
    "pages": [
      566
    ]
  },
  {
    "id": "u4-46-institutions-barriers",
    "section": "4.9",
    "level": "core",
    "title": {
      "zh-CN": "制度、冲突与社会排斥",
      "en": "Institutions, conflict and social exclusion"
    },
    "pages": [
      581
    ]
  },
  {
    "id": "u4-47-geography-informality",
    "section": "4.9",
    "level": "core",
    "title": {
      "zh-CN": "地理、非正规经济与多重障碍",
      "en": "Geography, informality and interacting barriers"
    },
    "pages": [
      566
    ]
  },
  {
    "id": "u4-48-trade-strategies",
    "section": "4.10",
    "level": "core",
    "title": {
      "zh-CN": "进口替代与出口导向",
      "en": "Import substitution and export promotion"
    },
    "pages": [
      595
    ]
  },
  {
    "id": "u4-49-diversification-enterprise",
    "section": "4.10",
    "level": "core",
    "title": {
      "zh-CN": "多样化与社会企业",
      "en": "Diversification and social enterprise"
    },
    "pages": [
      599
    ]
  },
  {
    "id": "u4-50-market-based-development",
    "section": "4.10",
    "level": "core",
    "title": {
      "zh-CN": "市场导向的发展政策",
      "en": "Market-based development policies"
    },
    "pages": [
      602
    ]
  },
  {
    "id": "u4-51-public-services-development",
    "section": "4.10",
    "level": "core",
    "title": {
      "zh-CN": "公共服务、再分配与发展",
      "en": "Public services, redistribution and development"
    },
    "pages": [
      606
    ]
  },
  {
    "id": "u4-52-fdi-mncs",
    "section": "4.10",
    "level": "core",
    "title": {
      "zh-CN": "外国直接投资与跨国公司",
      "en": "Foreign direct investment and multinational firms"
    },
    "pages": [
      611
    ]
  },
  {
    "id": "u4-53-aid-ngos",
    "section": "4.10",
    "level": "core",
    "title": {
      "zh-CN": "援助、非政府组织与本地参与",
      "en": "Aid, NGOs and local participation"
    },
    "pages": [
      615
    ]
  },
  {
    "id": "u4-54-multilateral-debt-relief",
    "section": "4.10",
    "level": "core",
    "title": {
      "zh-CN": "多边机构与债务减免",
      "en": "Multilateral institutions and debt relief"
    },
    "pages": [
      623
    ]
  },
  {
    "id": "u4-55-institutional-change",
    "section": "4.10",
    "level": "core",
    "title": {
      "zh-CN": "制度改革、包容性金融与赋权",
      "en": "Institutional reform, inclusive finance and empowerment"
    },
    "pages": [
      627
    ]
  },
  {
    "id": "u4-56-development-policy-mix",
    "section": "4.10",
    "level": "core",
    "title": {
      "zh-CN": "发展战略组合与证据评价",
      "en": "Development policy mixes and evidence"
    },
    "pages": [
      633
    ]
  },
  {
    "id": "u4-57-monetary-union-evaluation",
    "section": "4.4",
    "level": "hl",
    "title": {
      "zh-CN": "货币联盟的评价",
      "en": "Evaluating monetary union"
    },
    "pages": [
      482
    ]
  },
  {
    "id": "u4-58-exchange-regime-evaluation",
    "section": "4.5",
    "level": "hl",
    "title": {
      "zh-CN": "固定与浮动汇率的评价",
      "en": "Evaluating fixed and floating exchange rates"
    },
    "pages": [
      523
    ]
  },
  {
    "id": "u4-59-development-composite-indices",
    "section": "4.8",
    "level": "core",
    "title": {
      "zh-CN": "GII、IHDI 与快乐星球指数",
      "en": "GII, IHDI and the Happy Planet Index"
    },
    "pages": [
      541
    ]
  },
  {
    "id": "u4-60-sdg-country-comparison",
    "section": "4.10",
    "level": "core",
    "title": {
      "zh-CN": "用两国数据评价健康发展",
      "en": "Evaluating health development using two countries"
    },
    "pages": [
      636
    ]
  },
  {
    "id": "u4-61-current-account-surplus",
    "section": "4.6",
    "level": "hl",
    "title": {
      "zh-CN": "持续经常账户顺差的影响",
      "en": "Implications of persistent current-account surpluses"
    },
    "pages": [
      530
    ]
  },
  {
    "id": "u4-62-external-accounts-exchange-rate",
    "section": "4.6",
    "level": "hl",
    "title": {
      "zh-CN": "外部账户与汇率的联系",
      "en": "External accounts and exchange rates"
    },
    "pages": [
      520
    ]
  },
  {
    "id": "u4-63-terms-of-trade-enrichment",
    "section": "4.9",
    "level": "extension",
    "title": {
      "zh-CN": "贸易条件指数（扩展）",
      "en": "Terms-of-trade index (enrichment)"
    },
    "pages": [
      566
    ]
  }
] as ManifestEntry[];

export const knowledgePoints = [
  {
    "meta": {
      "id": "u1-01-economics-social-science",
      "slug": "economics-social-science",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            3
          ]
        }
      ],
      "prerequisites": [],
      "related": [
        "u1-02-microeconomics",
        "u1-03-macroeconomics",
        "u1-34-evidence-refutation"
      ],
      "terms": [
        "Economics as a social science",
        "经济学作为社会科学"
      ],
      "synonyms": {
        "zh-CN": [
          "社会科学",
          "资源配置研究",
          "经济选择"
        ],
        "en": [
          "social science",
          "study of allocation",
          "economic choice"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-01-economics-social-science-flash-1",
        "u1-01-economics-social-science-mcq-1",
        "u1-01-economics-social-science-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-01-economics-social-science",
        "locale": "zh-CN",
        "title": "经济学作为社会科学",
        "takeaway": "经济学研究人在稀缺条件下如何选择，并用模型与证据解释这些选择如何影响他人和社会。",
        "definition": "经济学是一门社会科学，研究个人、企业、政府等经济主体如何配置稀缺资源，以及这些决定产生的分配、效率与福祉后果。",
        "causalChain": [
          "资源和时间有限",
          "经济主体在制度约束下选择",
          "选择汇聚为市场或政策结果",
          "经济学用证据检验对这些结果的解释"
        ],
        "realWorldExample": {
          "title": "用跨国数据比较经济结果",
          "sourceUrl": "https://data.oecd.org/",
          "observedAt": "2026-09-29",
          "explanation": "OECD 数据库把就业、收入、价格和公共政策指标放在可比较框架中。经济学家可以提出关于制度与结果的解释，再用数据判断解释是否站得住脚。"
        },
        "misconceptions": [
          "经济学不只研究金钱；时间、环境、教育与健康资源同样属于分析对象。",
          "社会科学的结论带有条件，并不等于可以随意表达没有证据的意见。"
        ],
        "examApplication": [
          "定义经济学时连接稀缺、选择和后果，而不要只写‘研究经济’。",
          "评价经济结论时说明假设、证据和人的行为为何可能限制普遍性。"
        ],
        "summary": [
          "经济学分析稀缺资源的配置。",
          "人的选择受到激励、制度与信息影响。",
          "模型提供解释，证据用于检验。"
        ],
        "explanation": "经济学把人类选择作为研究对象。家庭安排时间和收入，企业决定生产什么，政府决定如何征税和支出；这些决定都发生在资源有限、目标相互竞争的条件下。\n\n与自然科学相比，经济学较难把社会隔离成完全受控的实验环境。研究者因此会结合逻辑模型、历史比较、调查、自然实验和统计证据。结论通常应写成“在这些条件成立时，更可能出现某结果”，而不是没有边界的定律。"
      },
      "en": {
        "id": "u1-01-economics-social-science",
        "locale": "en",
        "title": "Economics as a social science",
        "takeaway": "Economics studies choice under scarcity and uses models and evidence to explain how those choices shape outcomes for other people and society.",
        "definition": "Economics is a social science concerned with how households, firms, governments, and other agents allocate scarce resources, and with the consequences for distribution, efficiency, and well-being.",
        "causalChain": [
          "Time and resources are constrained",
          "Agents choose within institutions and incentives",
          "Individual decisions combine into market or policy outcomes",
          "Evidence is used to test economic explanations"
        ],
        "realWorldExample": {
          "title": "Comparing economic outcomes across countries",
          "sourceUrl": "https://data.oecd.org/",
          "observedAt": "2026-09-29",
          "explanation": "The OECD data portal brings together comparable measures of employment, income, prices, and policy. Economists can frame an explanation about institutions and then examine whether the observed patterns support it."
        },
        "misconceptions": [
          "Economics is not confined to money; time, health, education, and environmental resources also involve economic choice.",
          "A conditional social-science claim is not the same as an unsupported opinion."
        ],
        "examApplication": [
          "A definition should connect scarcity, choice, and consequences rather than merely say that economics studies the economy.",
          "When evaluating a claim, identify how assumptions, evidence, and changing human behaviour limit its reach."
        ],
        "summary": [
          "Economics examines the allocation of scarce resources.",
          "Choice responds to incentives, institutions, and information.",
          "Models explain; evidence tests those explanations."
        ],
        "explanation": "Economics starts with decisions made by people and organisations. Households divide time and income, firms choose what to produce, and governments decide how to tax and spend. Each choice takes place where resources are limited and objectives compete.\n\nSocieties cannot always be placed in controlled laboratory conditions. Economists therefore combine deductive models with historical comparisons, surveys, natural experiments, and statistical evidence. A careful conclusion is usually conditional—an outcome is more likely under stated circumstances—rather than a law without boundaries."
      }
    },
    "practice": [
      {
        "id": "u1-01-economics-social-science-flash-1",
        "knowledgePointId": "u1-01-economics-social-science",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“经济学作为社会科学”。",
          "en": "Without notes, explain “Economics as a social science” in your own words."
        },
        "answer": {
          "zh-CN": "经济学是一门社会科学，研究个人、企业、政府等经济主体如何配置稀缺资源，以及这些决定产生的分配、效率与福祉后果。",
          "en": "Economics is a social science concerned with how households, firms, governments, and other agents allocate scarce resources, and with the consequences for distribution, efficiency, and well-being."
        },
        "explanation": {
          "zh-CN": "经济学研究人在稀缺条件下如何选择，并用模型与证据解释这些选择如何影响他人和社会。",
          "en": "Economics studies choice under scarcity and uses models and evidence to explain how those choices shape outcomes for other people and society."
        }
      },
      {
        "id": "u1-01-economics-social-science-mcq-1",
        "knowledgePointId": "u1-01-economics-social-science",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“经济学作为社会科学”？",
          "en": "Which statement best captures “Economics as a social science”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只研究货币且排除人的选择",
            "en": "It studies money alone, excluding human choices"
          },
          {
            "id": "b",
            "zh-CN": "经济学研究人在稀缺条件下如何选择，并用模型与证据解释这些选择如何影响他人和社会。",
            "en": "Economics studies choice under scarcity and uses models and evidence to explain how those choices shape outcomes for other people and society."
          },
          {
            "id": "c",
            "zh-CN": "资源无限时如何无限生产",
            "en": "How to produce without limits using unlimited resources"
          },
          {
            "id": "d",
            "zh-CN": "只对个人应如何消费作道德评价",
            "en": "Only moral judgements about personal consumption"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "经济学是一门社会科学，研究个人、企业、政府等经济主体如何配置稀缺资源，以及这些决定产生的分配、效率与福祉后果。",
          "en": "Economics is a social science concerned with how households, firms, governments, and other agents allocate scarce resources, and with the consequences for distribution, efficiency, and well-being."
        }
      },
      {
        "id": "u1-01-economics-social-science-short-1",
        "knowledgePointId": "u1-01-economics-social-science",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“经济学作为社会科学”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Economics as a social science”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "经济学作为社会科学：经济学是一门社会科学，研究个人、企业、政府等经济主体如何配置稀缺资源，以及这些决定产生的分配、效率与福祉后果。 资源和时间有限；经济主体在制度约束下选择；选择汇聚为市场或政策结果；经济学用证据检验对这些结果的解释 经济学分析稀缺资源的配置。",
          "en": "Economics as a social science: Economics is a social science concerned with how households, firms, governments, and other agents allocate scarce resources, and with the consequences for distribution, efficiency, and well-being. Time and resources are constrained; Agents choose within institutions and incentives; Individual decisions combine into market or policy outcomes; Evidence is used to test economic explanations Economics examines the allocation of scarce resources."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "经济学作为社会科学",
                "社会科学",
                "资源配置研究",
                "经济选择"
              ],
              "en": [
                "Economics as a social science",
                "social science",
                "study of allocation",
                "economic choice"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "资源和时间有限",
                "经济主体在制度约束下选择"
              ],
              "en": [
                "Time and resources are constrained",
                "Agents choose within institutions and incentives"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "经济学分析稀缺资源的配置。",
                "人的选择受到激励、制度与信息影响。"
              ],
              "en": [
                "Economics examines the allocation of scarce resources.",
                "Choice responds to incentives, institutions, and information."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-02-microeconomics",
      "slug": "microeconomics",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            3
          ]
        }
      ],
      "prerequisites": [
        "u1-01-economics-social-science"
      ],
      "related": [
        "u1-03-macroeconomics",
        "u1-19-market-mechanism",
        "u1-20-government-intervention"
      ],
      "terms": [
        "Microeconomics",
        "微观经济学"
      ],
      "synonyms": {
        "zh-CN": [
          "个体经济分析",
          "市场层面",
          "micro"
        ],
        "en": [
          "individual-market analysis",
          "market-level economics",
          "micro"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-02-microeconomics-flash-1",
        "u1-02-microeconomics-mcq-1",
        "u1-02-microeconomics-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-02-microeconomics",
        "locale": "zh-CN",
        "title": "微观经济学",
        "takeaway": "微观经济学从消费者、劳动者、企业和具体市场出发，分析价格、产量与资源配置。",
        "definition": "微观经济学研究单个经济主体和特定市场的选择、相互作用及其对价格、产量、效率和公平的影响。",
        "causalChain": [
          "消费者和企业面对约束",
          "他们对价格与激励作出选择",
          "供给和需求在具体市场相遇",
          "形成价格、数量与福利结果"
        ],
        "realWorldExample": {
          "title": "竞争机构调查具体市场",
          "sourceUrl": "https://www.gov.uk/government/organisations/competition-and-markets-authority",
          "observedAt": "2026-09-29",
          "explanation": "英国竞争与市场管理局会研究住房、数字平台或零售等具体市场中的企业行为和消费者结果。这类分析聚焦市场参与者与规则，属于典型的微观视角。"
        },
        "misconceptions": [
          "“微观”表示分析单位较小，不代表问题不重要。",
          "研究一家企业并不只看企业本身，还要看消费者、竞争者和制度环境。"
        ],
        "examApplication": [
          "先明确研究对象是某个主体或市场，再解释激励如何改变选择。",
          "涉及福利时区分消费者、生产者、政府和第三方受到的影响。"
        ],
        "summary": [
          "微观分析关注主体和具体市场。",
          "价格与激励连接个体决定。",
          "结果可从效率与公平两个维度评价。"
        ],
        "explanation": "微观经济学把镜头对准组成经济体的基本单位。它研究消费者为什么购买、劳动者如何分配时间、企业为何调整产量，以及这些选择如何在某个市场中相互影响。\n\n分析通常从约束和激励开始，再追踪到均衡价格、交易数量和不同群体的得失。微观结论也为税收、补贴、价格管制和竞争政策的设计提供基础。"
      },
      "en": {
        "id": "u1-02-microeconomics",
        "locale": "en",
        "title": "Microeconomics",
        "takeaway": "Microeconomics begins with consumers, workers, firms, and individual markets to explain prices, output, and resource allocation.",
        "definition": "Microeconomics studies the choices and interactions of individual economic agents and particular markets, including their effects on prices, quantities, efficiency, and equity.",
        "causalChain": [
          "Consumers and firms face constraints",
          "They respond to prices and incentives",
          "Supply and demand interact in a particular market",
          "Price, quantity, and welfare outcomes emerge"
        ],
        "realWorldExample": {
          "title": "A competition authority investigates a market",
          "sourceUrl": "https://www.gov.uk/government/organisations/competition-and-markets-authority",
          "observedAt": "2026-09-29",
          "explanation": "The UK Competition and Markets Authority examines firm conduct and consumer outcomes in particular sectors such as housing, retail, and digital platforms. Its focus on participants and market rules is distinctly microeconomic."
        },
        "misconceptions": [
          "Micro refers to the unit of analysis, not to the importance of the issue.",
          "Studying one firm still requires attention to consumers, rivals, and the institutional setting."
        ],
        "examApplication": [
          "Identify the agent or specific market first, then trace how an incentive changes behaviour.",
          "For welfare analysis, separate consequences for consumers, producers, government, and third parties."
        ],
        "summary": [
          "Microeconomics focuses on agents and particular markets.",
          "Prices and incentives connect individual decisions.",
          "Outcomes can be judged through both efficiency and equity."
        ],
        "explanation": "Microeconomics places the analytical lens on the building blocks of an economy. It asks why consumers buy, how workers allocate time, why firms alter output, and how those decisions meet in a particular market.\n\nA typical argument starts from constraints and incentives and follows them to equilibrium price, traded quantity, and the gains or losses of different groups. The same reasoning supports analysis of taxes, subsidies, price controls, and competition policy."
      }
    },
    "practice": [
      {
        "id": "u1-02-microeconomics-flash-1",
        "knowledgePointId": "u1-02-microeconomics",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“微观经济学”。",
          "en": "Without notes, explain “Microeconomics” in your own words."
        },
        "answer": {
          "zh-CN": "微观经济学研究单个经济主体和特定市场的选择、相互作用及其对价格、产量、效率和公平的影响。",
          "en": "Microeconomics studies the choices and interactions of individual economic agents and particular markets, including their effects on prices, quantities, efficiency, and equity."
        },
        "explanation": {
          "zh-CN": "微观经济学从消费者、劳动者、企业和具体市场出发，分析价格、产量与资源配置。",
          "en": "Microeconomics begins with consumers, workers, firms, and individual markets to explain prices, output, and resource allocation."
        }
      },
      {
        "id": "u1-02-microeconomics-mcq-1",
        "knowledgePointId": "u1-02-microeconomics",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“微观经济学”？",
          "en": "Which statement best captures “Microeconomics”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "整个经济的通胀总率",
            "en": "Only economy-wide inflation"
          },
          {
            "id": "b",
            "zh-CN": "整个经济的总失业率",
            "en": "Only the national unemployment rate"
          },
          {
            "id": "c",
            "zh-CN": "微观经济学从消费者、劳动者、企业和具体市场出发，分析价格、产量与资源配置。",
            "en": "Microeconomics begins with consumers, workers, firms, and individual markets to explain prices, output, and resource allocation."
          },
          {
            "id": "d",
            "zh-CN": "排除企业和市场的全部研究",
            "en": "All analysis excluding firms and markets"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "微观经济学研究单个经济主体和特定市场的选择、相互作用及其对价格、产量、效率和公平的影响。",
          "en": "Microeconomics studies the choices and interactions of individual economic agents and particular markets, including their effects on prices, quantities, efficiency, and equity."
        }
      },
      {
        "id": "u1-02-microeconomics-short-1",
        "knowledgePointId": "u1-02-microeconomics",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“微观经济学”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Microeconomics”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "微观经济学：微观经济学研究单个经济主体和特定市场的选择、相互作用及其对价格、产量、效率和公平的影响。 消费者和企业面对约束；他们对价格与激励作出选择；供给和需求在具体市场相遇；形成价格、数量与福利结果 微观分析关注主体和具体市场。",
          "en": "Microeconomics: Microeconomics studies the choices and interactions of individual economic agents and particular markets, including their effects on prices, quantities, efficiency, and equity. Consumers and firms face constraints; They respond to prices and incentives; Supply and demand interact in a particular market; Price, quantity, and welfare outcomes emerge Microeconomics focuses on agents and particular markets."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "微观经济学",
                "个体经济分析",
                "市场层面",
                "micro"
              ],
              "en": [
                "Microeconomics",
                "individual-market analysis",
                "market-level economics",
                "micro"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "消费者和企业面对约束",
                "他们对价格与激励作出选择"
              ],
              "en": [
                "Consumers and firms face constraints",
                "They respond to prices and incentives"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "微观分析关注主体和具体市场。",
                "价格与激励连接个体决定。"
              ],
              "en": [
                "Microeconomics focuses on agents and particular markets.",
                "Prices and incentives connect individual decisions."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-03-macroeconomics",
      "slug": "macroeconomics",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            3
          ]
        }
      ],
      "prerequisites": [
        "u1-01-economics-social-science"
      ],
      "related": [
        "u1-02-microeconomics",
        "u1-40-keynesian-revolution",
        "u1-41-monetarist-new-classical"
      ],
      "terms": [
        "Macroeconomics",
        "宏观经济学"
      ],
      "synonyms": {
        "zh-CN": [
          "总体经济",
          "经济总量",
          "macro"
        ],
        "en": [
          "economy-wide analysis",
          "aggregate economics",
          "macro"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-03-macroeconomics-flash-1",
        "u1-03-macroeconomics-mcq-1",
        "u1-03-macroeconomics-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-03-macroeconomics",
        "locale": "zh-CN",
        "title": "宏观经济学",
        "takeaway": "宏观经济学研究整个经济体的总量表现，以及政策如何影响增长、就业、物价和对外关系。",
        "definition": "宏观经济学以经济体整体为单位，研究总产出、经济增长、失业、通货膨胀、收入分配和国际收支等总量变量及其相互关系。",
        "causalChain": [
          "家庭、企业和政府作出大量决定",
          "这些决定汇总为总需求和总供给",
          "经济体出现增长、就业与物价变化",
          "财政与货币政策尝试稳定或改变结果"
        ],
        "realWorldExample": {
          "title": "世界经济展望比较宏观表现",
          "sourceUrl": "https://www.imf.org/en/Publications/WEO",
          "observedAt": "2026-09-29",
          "explanation": "国际货币基金组织的《世界经济展望》汇总各经济体的增长、通胀和失业等指标，用于观察总量趋势和政策环境，而不是某一种商品的市场。"
        },
        "misconceptions": [
          "宏观数据是个体结果的汇总，但不能从一个人的经历直接推断整个经济。",
          "经济增长、低通胀和低失业可能同时成为目标，也可能产生权衡。"
        ],
        "examApplication": [
          "用总量变量组织答案，并指出变量之间的传导机制。",
          "评价宏观政策时考虑时间滞后、利益分配和短期长期差异。"
        ],
        "summary": [
          "宏观研究经济体整体。",
          "核心指标包括增长、就业与物价稳定。",
          "政策效果取决于传导、时滞和经济环境。"
        ],
        "explanation": "宏观经济学把许多市场和主体的行为汇总起来，观察一个地区或国家的总产出、收入、就业和价格水平。它回答的问题包括经济为何衰退、通胀为何上升，以及长期生活水平如何提高。\n\n宏观政策不能只看目标方向，还要分析传导路径。政府增加支出或中央银行改变利率，必须经过家庭、企业和金融体系的反应才会影响总需求、产出和物价。"
      },
      "en": {
        "id": "u1-03-macroeconomics",
        "locale": "en",
        "title": "Macroeconomics",
        "takeaway": "Macroeconomics examines economy-wide performance and how policy influences growth, employment, prices, and external relationships.",
        "definition": "Macroeconomics treats the economy as a whole and studies aggregate output, growth, unemployment, inflation, income distribution, and the balance of payments, together with the links among them.",
        "causalChain": [
          "Households, firms, and governments make many decisions",
          "Those decisions aggregate into economy-wide demand and supply",
          "Growth, employment, and the price level change",
          "Fiscal and monetary policy seek to stabilise or redirect outcomes"
        ],
        "realWorldExample": {
          "title": "The World Economic Outlook compares macro performance",
          "sourceUrl": "https://www.imf.org/en/Publications/WEO",
          "observedAt": "2026-09-29",
          "explanation": "The IMF World Economic Outlook brings together growth, inflation, and unemployment measures across economies. It reveals aggregate trends and policy conditions rather than the market for one product."
        },
        "misconceptions": [
          "Aggregate data combine individual outcomes, but one person's experience cannot establish the condition of the entire economy.",
          "Growth, low inflation, and low unemployment can be joint objectives while still creating policy trade-offs."
        ],
        "examApplication": [
          "Organise an answer around aggregate variables and make the transmission mechanism explicit.",
          "Evaluation should consider time lags, distributional effects, and the difference between short-run and long-run outcomes."
        ],
        "summary": [
          "Macroeconomics studies the economy as a whole.",
          "Growth, employment, and price stability are central indicators.",
          "Policy results depend on transmission, timing, and context."
        ],
        "explanation": "Macroeconomics combines activity across many agents and markets to examine total output, income, employment, and the general price level. It addresses why recessions occur, what drives inflation, and how living standards might rise over time.\n\nThe direction of a policy is not enough to predict its effect. A rise in government spending or a change in the policy interest rate influences the economy only through responses by households, firms, banks, and financial markets."
      }
    },
    "practice": [
      {
        "id": "u1-03-macroeconomics-flash-1",
        "knowledgePointId": "u1-03-macroeconomics",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“宏观经济学”。",
          "en": "Without notes, explain “Macroeconomics” in your own words."
        },
        "answer": {
          "zh-CN": "宏观经济学以经济体整体为单位，研究总产出、经济增长、失业、通货膨胀、收入分配和国际收支等总量变量及其相互关系。",
          "en": "Macroeconomics treats the economy as a whole and studies aggregate output, growth, unemployment, inflation, income distribution, and the balance of payments, together with the links among them."
        },
        "explanation": {
          "zh-CN": "宏观经济学研究整个经济体的总量表现，以及政策如何影响增长、就业、物价和对外关系。",
          "en": "Macroeconomics examines economy-wide performance and how policy influences growth, employment, prices, and external relationships."
        }
      },
      {
        "id": "u1-03-macroeconomics-mcq-1",
        "knowledgePointId": "u1-03-macroeconomics",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“宏观经济学”？",
          "en": "Which statement best captures “Macroeconomics”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只研究一家店的定价",
            "en": "Only one shop’s pricing"
          },
          {
            "id": "b",
            "zh-CN": "把每个家庭预算当成国民收入恒等式",
            "en": "Treating each household budget as a national accounting identity"
          },
          {
            "id": "c",
            "zh-CN": "只研究单个消费者偏好",
            "en": "Only one consumer’s preferences"
          },
          {
            "id": "d",
            "zh-CN": "宏观经济学研究整个经济体的总量表现，以及政策如何影响增长、就业、物价和对外关系。",
            "en": "Macroeconomics examines economy-wide performance and how policy influences growth, employment, prices, and external relationships."
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "宏观经济学以经济体整体为单位，研究总产出、经济增长、失业、通货膨胀、收入分配和国际收支等总量变量及其相互关系。",
          "en": "Macroeconomics treats the economy as a whole and studies aggregate output, growth, unemployment, inflation, income distribution, and the balance of payments, together with the links among them."
        }
      },
      {
        "id": "u1-03-macroeconomics-short-1",
        "knowledgePointId": "u1-03-macroeconomics",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“宏观经济学”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Macroeconomics”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "宏观经济学：宏观经济学以经济体整体为单位，研究总产出、经济增长、失业、通货膨胀、收入分配和国际收支等总量变量及其相互关系。 家庭、企业和政府作出大量决定；这些决定汇总为总需求和总供给；经济体出现增长、就业与物价变化；财政与货币政策尝试稳定或改变结果 宏观研究经济体整体。",
          "en": "Macroeconomics: Macroeconomics treats the economy as a whole and studies aggregate output, growth, unemployment, inflation, income distribution, and the balance of payments, together with the links among them. Households, firms, and governments make many decisions; Those decisions aggregate into economy-wide demand and supply; Growth, employment, and the price level change; Fiscal and monetary policy seek to stabilise or redirect outcomes Macroeconomics studies the economy as a whole."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "宏观经济学",
                "总体经济",
                "经济总量",
                "macro"
              ],
              "en": [
                "Macroeconomics",
                "economy-wide analysis",
                "aggregate economics",
                "macro"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "家庭、企业和政府作出大量决定",
                "这些决定汇总为总需求和总供给"
              ],
              "en": [
                "Households, firms, and governments make many decisions",
                "Those decisions aggregate into economy-wide demand and supply"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "宏观研究经济体整体。",
                "核心指标包括增长、就业与物价稳定。"
              ],
              "en": [
                "Macroeconomics studies the economy as a whole.",
                "Growth, employment, and price stability are central indicators."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-04-scarcity",
      "slug": "scarcity",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            4
          ]
        }
      ],
      "prerequisites": [],
      "related": [
        "u1-05-choice",
        "u1-13-factors-of-production",
        "u1-14-opportunity-cost"
      ],
      "terms": [
        "scarcity",
        "稀缺性"
      ],
      "synonyms": {
        "zh-CN": [
          "资源有限",
          "欲望无限",
          "稀缺"
        ],
        "en": [
          "limited resources",
          "unlimited wants",
          "resource constraint"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-04-scarcity-flash-1",
        "u1-04-scarcity-mcq-1",
        "u1-04-scarcity-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-04-scarcity",
        "locale": "zh-CN",
        "title": "稀缺性",
        "takeaway": "稀缺性不是“某样东西很少”，而是有限资源无法同时满足所有欲望，因此任何经济体都必须选择。",
        "definition": "稀缺性是指可用于生产商品与服务的资源有限，而人们希望满足的需求和欲望相对于这些资源没有止境。",
        "causalChain": [
          "人们希望获得更多商品、服务与生活机会",
          "土地、劳动、资本、时间和企业家才能都有约束",
          "所有目标无法被同时实现",
          "个人、企业与政府必须在可行选项之间选择",
          "每项选择都会放弃次优方案并产生机会成本"
        ],
        "realWorldExample": {
          "title": "淡水在不同用途之间的配置",
          "sourceUrl": "https://sdgs.un.org/goals/goal6",
          "observedAt": "2026-09-29",
          "explanation": "安全饮水、农业、工业和生态系统都需要淡水。即使一个地区拥有水资源，特定时间与地点可安全使用的水仍然有限，因此社会必须决定各用途的优先顺序。"
        },
        "misconceptions": [
          "稀缺不等于绝对短缺；即使货架上有商品，只要资源不足以满足所有可能用途，稀缺仍存在。",
          "金钱不是唯一稀缺资源；时间、技能、自然资源和生产能力同样受限。",
          "贫困会加剧资源约束，但富裕社会也面对稀缺性，因为欲望和资源仍不完全匹配。"
        ],
        "examApplication": [
          "遇到“解释稀缺性”时，应同时写出有限资源、相对无限欲望以及必须选择这三层逻辑。",
          "评价政策时，可追问政策使用了哪些稀缺资源，以及这些资源原本还能用于什么。"
        ],
        "summary": [
          "稀缺性来自资源与欲望之间的相对关系。",
          "稀缺性迫使所有经济主体作出选择。",
          "选择的代价由机会成本表示。"
        ],
        "explanation": "稀缺性是经济学问题的起点。它描述的不是偶发的缺货，而是一种长期存在的约束：我们可以利用的资源、时间与生产能力，不足以完成所有想做的事情。\n\n因此，经济问题总是在比较不同用途。学生把两个小时用于复习经济学，就无法把同样的两个小时完整用于另一门课；政府把一块土地用于建设医院，就不能在同一地点同时建设公园。经济学研究的正是这些选择如何形成、由谁作出，以及它们给不同群体带来什么后果。\n\n判断一个情境是否体现稀缺性时，可以问两个问题：资源是否有多个相互竞争的用途？是否必须放弃至少一个可行选择？若答案都是“是”，就存在经济意义上的稀缺性。"
      },
      "en": {
        "id": "u1-04-scarcity",
        "locale": "en",
        "title": "Scarcity",
        "takeaway": "Scarcity does not simply mean that something is rare; it means finite resources cannot satisfy every want at the same time, so every economy must choose.",
        "definition": "Scarcity is the condition in which the resources available to produce goods and services are limited relative to the needs and wants people would like to satisfy.",
        "causalChain": [
          "People seek more goods, services and opportunities",
          "Land, labour, capital, time and entrepreneurship are constrained",
          "Not every objective can be achieved simultaneously",
          "Households, firms and governments must choose among feasible alternatives",
          "Each choice gives up a next-best alternative and creates an opportunity cost"
        ],
        "realWorldExample": {
          "title": "Allocating freshwater between competing uses",
          "sourceUrl": "https://sdgs.un.org/goals/goal6",
          "observedAt": "2026-09-29",
          "explanation": "Safe drinking water, farming, industry and ecosystems all depend on freshwater. Even where water exists, the usable supply at a particular time and place is limited, so societies must set priorities among competing uses."
        },
        "misconceptions": [
          "Scarcity is not the same as an absolute shortage; it exists whenever resources cannot satisfy every possible use, even if shops have stock.",
          "Money is not the only scarce resource; time, skills, natural resources and productive capacity are constrained too.",
          "Poverty can intensify resource constraints, but affluent societies also face scarcity because resources still do not match every want."
        ],
        "examApplication": [
          "An explanation of scarcity should connect limited resources, relatively unlimited wants and the resulting need to choose.",
          "When evaluating a policy, ask which scarce resources it uses and which alternative uses are therefore given up."
        ],
        "summary": [
          "Scarcity is a relative relationship between resources and wants.",
          "Scarcity forces every economic agent to choose.",
          "Opportunity cost expresses what a choice sacrifices."
        ],
        "explanation": "Scarcity is the starting point of the economic problem. It is not a temporary empty shelf. It is the continuing constraint that available resources, time and productive capacity cannot accomplish everything people would like to do.\n\nEconomic questions therefore compare alternative uses. Two hours spent revising economics cannot also be spent in full on another subject. Land used for a hospital cannot simultaneously provide a park on the same site. Economics studies how such choices are made, who makes them and how their consequences are distributed.\n\nTo identify scarcity in a situation, ask whether a resource has competing uses and whether at least one feasible option must be forgone. If both answers are yes, the situation contains scarcity in the economic sense."
      }
    },
    "practice": [
      {
        "id": "u1-04-scarcity-flash-1",
        "knowledgePointId": "u1-04-scarcity",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "用一句完整的话定义经济学中的稀缺性。",
          "en": "Define scarcity in economics in one complete sentence."
        },
        "answer": {
          "zh-CN": "稀缺性是有限资源无法满足相对无限的需求和欲望，因此必须作出选择。",
          "en": "Scarcity exists because limited resources cannot satisfy relatively unlimited needs and wants, so choices must be made."
        },
        "explanation": {
          "zh-CN": "高质量定义必须同时包含资源有限、欲望相对无限和选择不可避免。",
          "en": "A strong definition connects limited resources, relatively unlimited wants and unavoidable choice."
        }
      },
      {
        "id": "u1-04-scarcity-mcq-1",
        "knowledgePointId": "u1-04-scarcity",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一种情境最准确地体现了稀缺性？",
          "en": "Which situation most accurately illustrates scarcity?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "商店暂时卖完一种饮料",
            "en": "A shop temporarily runs out of one drink"
          },
          {
            "id": "b",
            "zh-CN": "政府必须在医院和公共交通之间分配有限预算",
            "en": "A government must divide a limited budget between hospitals and public transport"
          },
          {
            "id": "c",
            "zh-CN": "一件商品的价格下降",
            "en": "The price of a product falls"
          },
          {
            "id": "d",
            "zh-CN": "企业拥有未使用的仓库",
            "en": "A firm owns an unused warehouse"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "有限预算存在相互竞争的用途，选择一种用途会减少另一种用途可获得的资源。",
          "en": "The limited budget has competing uses, so choosing one use reduces the resources available to the other."
        }
      },
      {
        "id": "u1-04-scarcity-short-1",
        "knowledgePointId": "u1-04-scarcity",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释稀缺性，并说明它为什么会导致选择和机会成本。",
          "en": "Explain scarcity and why it gives rise to choice and opportunity cost."
        },
        "modelAnswer": {
          "zh-CN": "资源有限而需求和欲望相对无限，所以所有目标不能同时实现。经济主体必须选择，放弃的最佳可行替代方案就是机会成本。",
          "en": "Resources are limited while needs and wants are relatively unlimited, so not every objective can be achieved. Agents must choose, and the best feasible alternative forgone is the opportunity cost."
        },
        "keywordGroups": [
          {
            "id": "resource-constraint",
            "label": {
              "zh-CN": "资源限制",
              "en": "Resource constraint"
            },
            "alternatives": {
              "zh-CN": [
                "资源有限",
                "有限资源",
                "资源约束"
              ],
              "en": [
                "limited resources",
                "resource constraint",
                "resources are finite"
              ]
            }
          },
          {
            "id": "wants",
            "label": {
              "zh-CN": "欲望与目标",
              "en": "Wants and objectives"
            },
            "alternatives": {
              "zh-CN": [
                "欲望无限",
                "需求无限",
                "不能满足所有目标"
              ],
              "en": [
                "unlimited wants",
                "wants exceed resources",
                "cannot satisfy every objective"
              ]
            }
          },
          {
            "id": "choice-cost",
            "label": {
              "zh-CN": "选择与机会成本",
              "en": "Choice and opportunity cost"
            },
            "alternatives": {
              "zh-CN": [
                "必须选择",
                "机会成本",
                "放弃最佳替代方案"
              ],
              "en": [
                "must choose",
                "opportunity cost",
                "best alternative forgone"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "完整回答应覆盖资源限制、相对无限的欲望，以及选择产生机会成本三部分。",
          "en": "A complete answer covers the resource constraint, relatively unlimited wants, and the opportunity cost created by choice."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-05-choice",
      "slug": "choice",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            4
          ]
        }
      ],
      "prerequisites": [
        "u1-04-scarcity"
      ],
      "related": [
        "u1-14-opportunity-cost",
        "u1-16-basic-economic-questions"
      ],
      "terms": [
        "Choice",
        "选择"
      ],
      "synonyms": {
        "zh-CN": [
          "取舍",
          "决策",
          "经济选择"
        ],
        "en": [
          "trade-off",
          "decision",
          "economic choice"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-05-choice-flash-1",
        "u1-05-choice-mcq-1",
        "u1-05-choice-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-05-choice",
        "locale": "zh-CN",
        "title": "选择",
        "takeaway": "稀缺使选择不可避免；经济学关注选择的依据、放弃的方案和不同人承担的后果。",
        "definition": "选择是在资源约束下，从两个或以上互不完全兼容的可行方案中决定采用哪一种或怎样组合。",
        "causalChain": [
          "目标多于可用资源",
          "经济主体识别可行方案",
          "比较预期收益、成本与价值",
          "采用一个方案并放弃其他用途"
        ],
        "realWorldExample": {
          "title": "比较生活质量的不同维度",
          "sourceUrl": "https://www.oecdbetterlifeindex.org/",
          "observedAt": "2026-09-29",
          "explanation": "OECD Better Life Index 允许使用者改变收入、住房、环境、健康和工作生活平衡的权重，直观显示“更好生活”并非只有一个目标，优先顺序会改变选择。"
        },
        "misconceptions": [
          "选择并不保证得到理想结果，它只表示必须在可行方案之间取舍。",
          "没有支付金钱的选择仍可能消耗时间、注意力或自然资源。"
        ],
        "examApplication": [
          "说明约束是什么，并明确至少两个相互竞争的用途。",
          "不要停在‘作出选择’，继续指出机会成本和利益相关者。"
        ],
        "summary": [
          "选择源于稀缺。",
          "比较需要同时考虑成本、收益和价值。",
          "每项选择都会排除至少一个替代用途。"
        ],
        "explanation": "当所有目标不能同时实现时，个人和社会必须决定优先顺序。可行选择受到收入、时间、技术、法律和信息限制，因此不是所有想象中的方案都属于真正的备选项。\n\n经济分析会比较边际收益与边际成本，也会追问由谁选择、谁受益、谁承担代价。即使同样面对稀缺，不同价值判断和信息也可能带来不同选择。"
      },
      "en": {
        "id": "u1-05-choice",
        "locale": "en",
        "title": "Choice",
        "takeaway": "Scarcity makes choice unavoidable; economics asks what guides a choice, which alternative is forgone, and who bears the consequences.",
        "definition": "Choice is the selection of one option, or a combination of options, from two or more feasible alternatives that cannot all be achieved under the available resource constraint.",
        "causalChain": [
          "Objectives exceed available resources",
          "The agent identifies feasible alternatives",
          "Expected benefits, costs, and values are compared",
          "One course is selected and other uses are forgone"
        ],
        "realWorldExample": {
          "title": "Comparing dimensions of a better life",
          "sourceUrl": "https://www.oecdbetterlifeindex.org/",
          "observedAt": "2026-09-29",
          "explanation": "The OECD Better Life Index lets users change the importance of income, housing, environment, health, and work-life balance. It makes clear that well-being has competing dimensions and that priorities influence choice."
        },
        "misconceptions": [
          "Making a choice does not guarantee the desired result; it means a trade-off among feasible options was necessary.",
          "An option with no monetary payment may still use scarce time, attention, or natural resources."
        ],
        "examApplication": [
          "Name the constraint and identify at least two competing uses.",
          "Do not stop at saying a choice occurs; state the opportunity cost and the affected stakeholders."
        ],
        "summary": [
          "Choice follows from scarcity.",
          "Comparison involves costs, benefits, and values.",
          "Selecting an option rules out at least one alternative use."
        ],
        "explanation": "When objectives cannot all be met, people and societies must establish priorities. Feasible options are limited by income, time, technology, law, and information, so an imagined alternative is not necessarily available in practice.\n\nEconomic analysis may compare marginal benefit and marginal cost, but it also asks who chooses, who gains, and who carries the burden. Identical constraints can still produce different decisions because information and value judgements differ."
      }
    },
    "practice": [
      {
        "id": "u1-05-choice-flash-1",
        "knowledgePointId": "u1-05-choice",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“选择”。",
          "en": "Without notes, explain “Choice” in your own words."
        },
        "answer": {
          "zh-CN": "选择是在资源约束下，从两个或以上互不完全兼容的可行方案中决定采用哪一种或怎样组合。",
          "en": "Choice is the selection of one option, or a combination of options, from two or more feasible alternatives that cannot all be achieved under the available resource constraint."
        },
        "explanation": {
          "zh-CN": "稀缺使选择不可避免；经济学关注选择的依据、放弃的方案和不同人承担的后果。",
          "en": "Scarcity makes choice unavoidable; economics asks what guides a choice, which alternative is forgone, and who bears the consequences."
        }
      },
      {
        "id": "u1-05-choice-mcq-1",
        "knowledgePointId": "u1-05-choice",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“选择”？",
          "en": "Which statement best captures “Choice”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "选择可以绕过所有资源约束",
            "en": "Choice bypasses all resource constraints"
          },
          {
            "id": "b",
            "zh-CN": "稀缺使选择不可避免；经济学关注选择的依据、放弃的方案和不同人承担的后果。",
            "en": "Scarcity makes choice unavoidable; economics asks what guides a choice, which alternative is forgone, and who bears the consequences."
          },
          {
            "id": "c",
            "zh-CN": "可行方案越多机会成本必为零",
            "en": "More feasible options imply zero opportunity cost"
          },
          {
            "id": "d",
            "zh-CN": "只有付钱才构成经济选择",
            "en": "Only monetary purchases involve economic choice"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "选择是在资源约束下，从两个或以上互不完全兼容的可行方案中决定采用哪一种或怎样组合。",
          "en": "Choice is the selection of one option, or a combination of options, from two or more feasible alternatives that cannot all be achieved under the available resource constraint."
        }
      },
      {
        "id": "u1-05-choice-short-1",
        "knowledgePointId": "u1-05-choice",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“选择”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Choice”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "选择：选择是在资源约束下，从两个或以上互不完全兼容的可行方案中决定采用哪一种或怎样组合。 目标多于可用资源；经济主体识别可行方案；比较预期收益、成本与价值；采用一个方案并放弃其他用途 选择源于稀缺。",
          "en": "Choice: Choice is the selection of one option, or a combination of options, from two or more feasible alternatives that cannot all be achieved under the available resource constraint. Objectives exceed available resources; The agent identifies feasible alternatives; Expected benefits, costs, and values are compared; One course is selected and other uses are forgone Choice follows from scarcity."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "选择",
                "取舍",
                "决策",
                "经济选择"
              ],
              "en": [
                "Choice",
                "trade-off",
                "decision",
                "economic choice"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "目标多于可用资源",
                "经济主体识别可行方案"
              ],
              "en": [
                "Objectives exceed available resources",
                "The agent identifies feasible alternatives"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "选择源于稀缺。",
                "比较需要同时考虑成本、收益和价值。"
              ],
              "en": [
                "Choice follows from scarcity.",
                "Comparison involves costs, benefits, and values."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-06-efficiency",
      "slug": "efficiency",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            5
          ]
        }
      ],
      "prerequisites": [
        "u1-04-scarcity"
      ],
      "related": [
        "u1-07-equity",
        "u1-27-ppc-unemployment-efficiency"
      ],
      "terms": [
        "Efficiency",
        "效率"
      ],
      "synonyms": {
        "zh-CN": [
          "经济效率",
          "生产效率",
          "配置效率"
        ],
        "en": [
          "economic efficiency",
          "productive efficiency",
          "allocative efficiency"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-06-efficiency-flash-1",
        "u1-06-efficiency-mcq-1",
        "u1-06-efficiency-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-06-efficiency",
        "locale": "zh-CN",
        "title": "效率",
        "takeaway": "效率意味着在既定资源下避免浪费并把资源用于社会最重视的用途，但它不自动保证公平。",
        "definition": "经济效率描述资源没有被浪费，并在可能范围内被配置到能够产生较大价值或满足较多需求的用途；常区分生产效率与配置效率。",
        "causalChain": [
          "识别有限投入与可能产出",
          "减少闲置和不必要的投入损耗",
          "把生产组合调整到可行边界",
          "再比较产出组合是否符合社会偏好"
        ],
        "realWorldExample": {
          "title": "提高能源使用效率",
          "sourceUrl": "https://www.iea.org/topics/energy-efficiency",
          "observedAt": "2026-09-29",
          "explanation": "国际能源署追踪建筑、交通和工业的能源效率。相同服务若需要更少能源投入，就提高了生产效率，也能减少资源压力和排放。"
        },
        "misconceptions": [
          "生产得更多不一定具有配置效率；社会可能并不最重视新增产出。",
          "高效率的结果仍可能高度不平等，因此效率与公平必须分别判断。"
        ],
        "examApplication": [
          "写清楚讨论的是生产效率还是配置效率。",
          "评价政策时同时检查资源浪费、社会偏好和分配结果。"
        ],
        "summary": [
          "生产效率关注避免投入浪费。",
          "配置效率关注产出是否符合偏好。",
          "效率不等同于公平。"
        ],
        "explanation": "生产效率要求在现有技术和资源下不能在不减少另一种产出的情况下增加某种产出。它关注是否充分利用资源以及是否以较低成本完成生产。\n\n配置效率更进一步，要求生产组合反映社会对不同商品和服务的相对价值。一个经济体可以在生产可能性边界上运行，却仍然生产了社会不需要的组合。"
      },
      "en": {
        "id": "u1-06-efficiency",
        "locale": "en",
        "title": "Efficiency",
        "takeaway": "Efficiency avoids waste and directs scarce resources toward valued uses, but an efficient outcome is not automatically equitable.",
        "definition": "Economic efficiency describes a situation in which resources are not wasted and, as far as possible, are allocated to uses that create greater value or satisfy more highly valued wants; productive and allocative efficiency are commonly distinguished.",
        "causalChain": [
          "Identify scarce inputs and feasible outputs",
          "Remove idle capacity and unnecessary input loss",
          "Move production to the feasible frontier",
          "Ask whether the output mix reflects social preferences"
        ],
        "realWorldExample": {
          "title": "Improving energy efficiency",
          "sourceUrl": "https://www.iea.org/topics/energy-efficiency",
          "observedAt": "2026-09-29",
          "explanation": "The International Energy Agency tracks energy efficiency in buildings, transport, and industry. Providing the same service with less energy raises productive efficiency and can reduce both resource pressure and emissions."
        },
        "misconceptions": [
          "Producing more does not establish allocative efficiency if society places little value on the extra output.",
          "An efficient outcome can be very unequal, so efficiency and equity need separate judgements."
        ],
        "examApplication": [
          "State whether the analysis concerns productive or allocative efficiency.",
          "Evaluation should check resource waste, social preferences, and distribution rather than output alone."
        ],
        "summary": [
          "Productive efficiency concerns avoiding input waste.",
          "Allocative efficiency concerns the preferred output mix.",
          "Efficiency and equity are distinct criteria."
        ],
        "explanation": "Productive efficiency means that, given existing technology and resources, more of one output cannot be produced without reducing another. It asks whether resources are fully employed and whether output is made at low cost.\n\nAllocative efficiency adds a demand-side test: the combination of output should reflect the relative value society places on different goods and services. An economy may operate on its production possibility frontier and still produce the wrong mix."
      }
    },
    "practice": [
      {
        "id": "u1-06-efficiency-flash-1",
        "knowledgePointId": "u1-06-efficiency",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“效率”。",
          "en": "Without notes, explain “Efficiency” in your own words."
        },
        "answer": {
          "zh-CN": "经济效率描述资源没有被浪费，并在可能范围内被配置到能够产生较大价值或满足较多需求的用途；常区分生产效率与配置效率。",
          "en": "Economic efficiency describes a situation in which resources are not wasted and, as far as possible, are allocated to uses that create greater value or satisfy more highly valued wants; productive and allocative efficiency are commonly distinguished."
        },
        "explanation": {
          "zh-CN": "效率意味着在既定资源下避免浪费并把资源用于社会最重视的用途，但它不自动保证公平。",
          "en": "Efficiency avoids waste and directs scarce resources toward valued uses, but an efficient outcome is not automatically equitable."
        }
      },
      {
        "id": "u1-06-efficiency-mcq-1",
        "knowledgePointId": "u1-06-efficiency",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“效率”？",
          "en": "Which statement best captures “Efficiency”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "生产越多任何商品都越有效率",
            "en": "More of any good always means more efficiency"
          },
          {
            "id": "b",
            "zh-CN": "收入完全相同就证明生产有效率",
            "en": "Equal incomes prove productive efficiency"
          },
          {
            "id": "c",
            "zh-CN": "效率意味着在既定资源下避免浪费并把资源用于社会最重视的用途，但它不自动保证公平。",
            "en": "Efficiency avoids waste and directs scarce resources toward valued uses, but an efficient outcome is not automatically equitable."
          },
          {
            "id": "d",
            "zh-CN": "没有利润就必定有效率",
            "en": "No profit guarantees efficiency"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "经济效率描述资源没有被浪费，并在可能范围内被配置到能够产生较大价值或满足较多需求的用途；常区分生产效率与配置效率。",
          "en": "Economic efficiency describes a situation in which resources are not wasted and, as far as possible, are allocated to uses that create greater value or satisfy more highly valued wants; productive and allocative efficiency are commonly distinguished."
        }
      },
      {
        "id": "u1-06-efficiency-short-1",
        "knowledgePointId": "u1-06-efficiency",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“效率”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Efficiency”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "效率：经济效率描述资源没有被浪费，并在可能范围内被配置到能够产生较大价值或满足较多需求的用途；常区分生产效率与配置效率。 识别有限投入与可能产出；减少闲置和不必要的投入损耗；把生产组合调整到可行边界；再比较产出组合是否符合社会偏好 生产效率关注避免投入浪费。",
          "en": "Efficiency: Economic efficiency describes a situation in which resources are not wasted and, as far as possible, are allocated to uses that create greater value or satisfy more highly valued wants; productive and allocative efficiency are commonly distinguished. Identify scarce inputs and feasible outputs; Remove idle capacity and unnecessary input loss; Move production to the feasible frontier; Ask whether the output mix reflects social preferences Productive efficiency concerns avoiding input waste."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "效率",
                "经济效率",
                "生产效率",
                "配置效率"
              ],
              "en": [
                "Efficiency",
                "economic efficiency",
                "productive efficiency",
                "allocative efficiency"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "识别有限投入与可能产出",
                "减少闲置和不必要的投入损耗"
              ],
              "en": [
                "Identify scarce inputs and feasible outputs",
                "Remove idle capacity and unnecessary input loss"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "生产效率关注避免投入浪费。",
                "配置效率关注产出是否符合偏好。"
              ],
              "en": [
                "Productive efficiency concerns avoiding input waste.",
                "Allocative efficiency concerns the preferred output mix."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-07-equity",
      "slug": "equity",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            5
          ]
        }
      ],
      "prerequisites": [
        "u1-01-economics-social-science"
      ],
      "related": [
        "u1-06-efficiency",
        "u1-18-income-distribution",
        "u1-35-equality-equity"
      ],
      "terms": [
        "Equity",
        "公平"
      ],
      "synonyms": {
        "zh-CN": [
          "公正",
          "分配公平",
          "经济公平"
        ],
        "en": [
          "fairness",
          "distributive justice",
          "economic equity"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-07-equity-flash-1",
        "u1-07-equity-mcq-1",
        "u1-07-equity-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-07-equity",
        "locale": "zh-CN",
        "title": "公平",
        "takeaway": "公平判断结果或过程是否公正，它依赖价值标准，因此不能仅由市场数量或平均值决定。",
        "definition": "公平是关于经济资源、机会、负担和结果是否以公正方式分配的规范性概念；不同社会可能采用需要、贡献、机会或权利等标准。",
        "causalChain": [
          "识别资源、机会或负担的分配",
          "选择判断公正的标准",
          "比较不同群体受到的待遇与结果",
          "设计或评价改变分配的政策"
        ],
        "realWorldExample": {
          "title": "比较不平等与贫困政策",
          "sourceUrl": "https://www.oecd.org/en/topics/inequality-and-poverty.html",
          "observedAt": "2026-09-29",
          "explanation": "OECD 对收入不平等、贫困和社会流动的研究展示了税收与转移支付如何改变不同群体的可支配收入，也说明公平评价需要说明采用的标准。"
        },
        "misconceptions": [
          "公平不必意味着每个人获得完全相同的数量。",
          "声称一项政策更公平时，必须说明对谁、按什么原则更公平。"
        ],
        "examApplication": [
          "在评价段落中明确公平标准和受影响群体。",
          "讨论效率—公平权衡时不要假设两者必然冲突，应说明机制。"
        ],
        "summary": [
          "公平是一种规范性判断。",
          "公平标准可能包括需要、机会与贡献。",
          "公平分析必须识别群体和分配机制。"
        ],
        "explanation": "经济政策不仅改变总产出，也改变谁获得收入、服务和机会。公平分析把注意力放在这些分配上，并要求说明用什么原则判断结果。\n\n例如，按需要提供更多支持、按贡献给予回报和确保所有人拥有相同机会，都是可能的公平观。它们可能得出不同政策结论，因此答案应公开价值标准，而不是把“公平”当作无需解释的标签。"
      },
      "en": {
        "id": "u1-07-equity",
        "locale": "en",
        "title": "Equity",
        "takeaway": "Equity judges whether a process or outcome is fair; it depends on an explicit value standard rather than on market quantities or averages alone.",
        "definition": "Equity is a normative concept concerning the fairness of the distribution of economic resources, opportunities, burdens, and outcomes, assessed through principles such as need, contribution, opportunity, or rights.",
        "causalChain": [
          "Identify how resources, opportunities, or burdens are distributed",
          "Choose a principle of fairness",
          "Compare the treatment and outcomes of different groups",
          "Design or evaluate a policy that changes the distribution"
        ],
        "realWorldExample": {
          "title": "Comparing inequality and poverty policies",
          "sourceUrl": "https://www.oecd.org/en/topics/inequality-and-poverty.html",
          "observedAt": "2026-09-29",
          "explanation": "OECD work on inequality, poverty, and mobility shows how taxes and transfers alter disposable income across groups. It also demonstrates why an equity judgement must reveal the standard being applied."
        },
        "misconceptions": [
          "Equity need not mean that every person receives an identical amount.",
          "A claim that a policy is fairer is incomplete unless it specifies for whom and according to which principle."
        ],
        "examApplication": [
          "Name both the fairness criterion and the affected groups in an evaluation paragraph.",
          "Do not assume an efficiency-equity trade-off; explain the mechanism that creates or avoids one."
        ],
        "summary": [
          "Equity is a normative judgement.",
          "Need, opportunity, and contribution are possible standards.",
          "Equity analysis identifies groups and the distribution mechanism."
        ],
        "explanation": "Economic policy changes not only total output but also who receives income, services, and opportunities. Equity analysis concentrates on that distribution and requires a stated principle for judging it.\n\nSupport according to need, reward according to contribution, and equal access to opportunity are all plausible ideas of fairness. Because they can point toward different policies, a strong argument makes its value standard visible rather than treating equity as a self-explanatory label."
      }
    },
    "practice": [
      {
        "id": "u1-07-equity-flash-1",
        "knowledgePointId": "u1-07-equity",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“公平”。",
          "en": "Without notes, explain “Equity” in your own words."
        },
        "answer": {
          "zh-CN": "公平是关于经济资源、机会、负担和结果是否以公正方式分配的规范性概念；不同社会可能采用需要、贡献、机会或权利等标准。",
          "en": "Equity is a normative concept concerning the fairness of the distribution of economic resources, opportunities, burdens, and outcomes, assessed through principles such as need, contribution, opportunity, or rights."
        },
        "explanation": {
          "zh-CN": "公平判断结果或过程是否公正，它依赖价值标准，因此不能仅由市场数量或平均值决定。",
          "en": "Equity judges whether a process or outcome is fair; it depends on an explicit value standard rather than on market quantities or averages alone."
        }
      },
      {
        "id": "u1-07-equity-mcq-1",
        "knowledgePointId": "u1-07-equity",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“公平”？",
          "en": "Which statement best captures “Equity”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "公平总是指每个人获得完全相同收入",
            "en": "Equity always means identical incomes"
          },
          {
            "id": "b",
            "zh-CN": "只有统计方法才能唯一决定公平标准",
            "en": "Statistics alone uniquely determine fairness"
          },
          {
            "id": "c",
            "zh-CN": "市场均衡自动证明分配公平",
            "en": "Market equilibrium automatically proves equity"
          },
          {
            "id": "d",
            "zh-CN": "公平判断结果或过程是否公正，它依赖价值标准，因此不能仅由市场数量或平均值决定。",
            "en": "Equity judges whether a process or outcome is fair; it depends on an explicit value standard rather than on market quantities or averages alone."
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "公平是关于经济资源、机会、负担和结果是否以公正方式分配的规范性概念；不同社会可能采用需要、贡献、机会或权利等标准。",
          "en": "Equity is a normative concept concerning the fairness of the distribution of economic resources, opportunities, burdens, and outcomes, assessed through principles such as need, contribution, opportunity, or rights."
        }
      },
      {
        "id": "u1-07-equity-short-1",
        "knowledgePointId": "u1-07-equity",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“公平”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Equity”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "公平：公平是关于经济资源、机会、负担和结果是否以公正方式分配的规范性概念；不同社会可能采用需要、贡献、机会或权利等标准。 识别资源、机会或负担的分配；选择判断公正的标准；比较不同群体受到的待遇与结果；设计或评价改变分配的政策 公平是一种规范性判断。",
          "en": "Equity: Equity is a normative concept concerning the fairness of the distribution of economic resources, opportunities, burdens, and outcomes, assessed through principles such as need, contribution, opportunity, or rights. Identify how resources, opportunities, or burdens are distributed; Choose a principle of fairness; Compare the treatment and outcomes of different groups; Design or evaluate a policy that changes the distribution Equity is a normative judgement."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "公平",
                "公正",
                "分配公平",
                "经济公平"
              ],
              "en": [
                "Equity",
                "fairness",
                "distributive justice",
                "economic equity"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "识别资源、机会或负担的分配",
                "选择判断公正的标准"
              ],
              "en": [
                "Identify how resources, opportunities, or burdens are distributed",
                "Choose a principle of fairness"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "公平是一种规范性判断。",
                "公平标准可能包括需要、机会与贡献。"
              ],
              "en": [
                "Equity is a normative judgement.",
                "Need, opportunity, and contribution are possible standards."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-08-economic-wellbeing",
      "slug": "economic-wellbeing",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            5
          ]
        }
      ],
      "prerequisites": [
        "u1-01-economics-social-science"
      ],
      "related": [
        "u1-07-equity",
        "u1-09-sustainability"
      ],
      "terms": [
        "Economic well-being",
        "经济福祉"
      ],
      "synonyms": {
        "zh-CN": [
          "生活质量",
          "经济福利",
          "well-being"
        ],
        "en": [
          "quality of life",
          "economic welfare",
          "wellbeing"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-08-economic-wellbeing-flash-1",
        "u1-08-economic-wellbeing-mcq-1",
        "u1-08-economic-wellbeing-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-08-economic-wellbeing",
        "locale": "zh-CN",
        "title": "经济福祉",
        "takeaway": "经济福祉关心人能否过有保障、有选择的生活，收入重要但不是唯一决定因素。",
        "definition": "经济福祉是个人或群体通过收入、消费、公共服务、健康、教育、安全与选择机会满足需要并改善生活质量的程度。",
        "causalChain": [
          "资源与公共服务决定可获得的机会",
          "收入和价格影响实际购买力",
          "健康、教育与安全改变人的能力",
          "这些条件共同形成生活质量与主观体验"
        ],
        "realWorldExample": {
          "title": "人类发展指数超越收入衡量",
          "sourceUrl": "https://hdr.undp.org/",
          "observedAt": "2026-09-29",
          "explanation": "联合国开发计划署的人类发展报告把寿命、教育和收入结合起来，提醒分析者：人均收入上升可能改善福祉，但不能完整代表人的能力与生活质量。"
        },
        "misconceptions": [
          "更高的 GDP 或收入不保证每个群体的福祉都提高。",
          "福祉包含主观因素，但仍可用健康、教育和安全等可观察指标分析。"
        ],
        "examApplication": [
          "评价增长时区分平均收入、收入分配和非收入生活质量。",
          "给指标下结论前说明它捕捉了什么、遗漏了什么。"
        ],
        "summary": [
          "收入是福祉的手段而非全部。",
          "公共服务与人的能力同样重要。",
          "平均指标可能隐藏群体差异。"
        ],
        "explanation": "收入让人购买住房、食品和其他商品，但生活质量也依赖公共医疗、教育、安全、环境和可支配时间。经济福祉因此比单一产出指标更广。\n\n衡量时需要同时看平均水平与分配。一个经济体的人均收入可能上升，而低收入群体的实际购买力、环境质量或工作安全却没有改善。多维指标能补充信息，但不同维度的权重也包含价值判断。"
      },
      "en": {
        "id": "u1-08-economic-wellbeing",
        "locale": "en",
        "title": "Economic well-being",
        "takeaway": "Economic well-being concerns whether people can live secure lives with meaningful choices; income matters, but it is not the whole outcome.",
        "definition": "Economic well-being is the extent to which people or groups can meet needs and improve quality of life through income, consumption, public services, health, education, security, and genuine opportunities.",
        "causalChain": [
          "Resources and public services shape available opportunities",
          "Income and prices determine purchasing power",
          "Health, education, and security expand or restrict capabilities",
          "Together these conditions influence quality of life and lived experience"
        ],
        "realWorldExample": {
          "title": "Human development measurement goes beyond income",
          "sourceUrl": "https://hdr.undp.org/",
          "observedAt": "2026-09-29",
          "explanation": "UNDP Human Development Reports combine longevity, education, and income. The approach recognises that rising income per person may support well-being without fully representing human capabilities or life quality."
        },
        "misconceptions": [
          "A rise in GDP or average income does not show that every group is better off.",
          "Well-being has subjective aspects, but health, education, and security still provide observable evidence."
        ],
        "examApplication": [
          "When evaluating growth, distinguish average income, its distribution, and non-income dimensions of life quality.",
          "Before drawing a conclusion from an indicator, explain what it captures and what it omits."
        ],
        "summary": [
          "Income is one means to well-being, not the whole of it.",
          "Public services and human capabilities matter.",
          "Average measures can conceal differences between groups."
        ],
        "explanation": "Income enables people to obtain housing, food, and other goods, but quality of life also depends on public health care, education, safety, the environment, and control over time. Economic well-being is therefore broader than a single output measure.\n\nMeasurement should combine averages with distribution. Income per person may rise even while a lower-income group sees no improvement in purchasing power, environmental quality, or job security. Multidimensional indices add information, although the weights assigned to their components also express values."
      }
    },
    "practice": [
      {
        "id": "u1-08-economic-wellbeing-flash-1",
        "knowledgePointId": "u1-08-economic-wellbeing",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“经济福祉”。",
          "en": "Without notes, explain “Economic well-being” in your own words."
        },
        "answer": {
          "zh-CN": "经济福祉是个人或群体通过收入、消费、公共服务、健康、教育、安全与选择机会满足需要并改善生活质量的程度。",
          "en": "Economic well-being is the extent to which people or groups can meet needs and improve quality of life through income, consumption, public services, health, education, security, and genuine opportunities."
        },
        "explanation": {
          "zh-CN": "经济福祉关心人能否过有保障、有选择的生活，收入重要但不是唯一决定因素。",
          "en": "Economic well-being concerns whether people can live secure lives with meaningful choices; income matters, but it is not the whole outcome."
        }
      },
      {
        "id": "u1-08-economic-wellbeing-mcq-1",
        "knowledgePointId": "u1-08-economic-wellbeing",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“经济福祉”？",
          "en": "Which statement best captures “Economic well-being”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "经济福祉关心人能否过有保障、有选择的生活，收入重要但不是唯一决定因素。",
            "en": "Economic well-being concerns whether people can live secure lives with meaningful choices; income matters, but it is not the whole outcome."
          },
          {
            "id": "b",
            "zh-CN": "GDP 越高每个人福祉必越高",
            "en": "Higher GDP guarantees higher well-being for everyone"
          },
          {
            "id": "c",
            "zh-CN": "只计算个人拥有的现金",
            "en": "Only the amount of cash held"
          },
          {
            "id": "d",
            "zh-CN": "健康与公共服务不影响福祉",
            "en": "Health and public services cannot affect well-being"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "经济福祉是个人或群体通过收入、消费、公共服务、健康、教育、安全与选择机会满足需要并改善生活质量的程度。",
          "en": "Economic well-being is the extent to which people or groups can meet needs and improve quality of life through income, consumption, public services, health, education, security, and genuine opportunities."
        }
      },
      {
        "id": "u1-08-economic-wellbeing-short-1",
        "knowledgePointId": "u1-08-economic-wellbeing",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“经济福祉”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Economic well-being”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "经济福祉：经济福祉是个人或群体通过收入、消费、公共服务、健康、教育、安全与选择机会满足需要并改善生活质量的程度。 资源与公共服务决定可获得的机会；收入和价格影响实际购买力；健康、教育与安全改变人的能力；这些条件共同形成生活质量与主观体验 收入是福祉的手段而非全部。",
          "en": "Economic well-being: Economic well-being is the extent to which people or groups can meet needs and improve quality of life through income, consumption, public services, health, education, security, and genuine opportunities. Resources and public services shape available opportunities; Income and prices determine purchasing power; Health, education, and security expand or restrict capabilities; Together these conditions influence quality of life and lived experience Income is one means to well-being, not the whole of it."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "经济福祉",
                "生活质量",
                "经济福利",
                "well-being"
              ],
              "en": [
                "Economic well-being",
                "quality of life",
                "economic welfare",
                "wellbeing"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "资源与公共服务决定可获得的机会",
                "收入和价格影响实际购买力"
              ],
              "en": [
                "Resources and public services shape available opportunities",
                "Income and prices determine purchasing power"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "收入是福祉的手段而非全部。",
                "公共服务与人的能力同样重要。"
              ],
              "en": [
                "Income is one means to well-being, not the whole of it.",
                "Public services and human capabilities matter."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-09-sustainability",
      "slug": "sustainability",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            6
          ]
        }
      ],
      "prerequisites": [
        "u1-04-scarcity"
      ],
      "related": [
        "u1-08-economic-wellbeing",
        "u1-43-circular-economy"
      ],
      "terms": [
        "Sustainability",
        "可持续性"
      ],
      "synonyms": {
        "zh-CN": [
          "可持续发展",
          "长期承载力",
          "代际可持续"
        ],
        "en": [
          "sustainable development",
          "long-run carrying capacity",
          "intergenerational sustainability"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-09-sustainability-flash-1",
        "u1-09-sustainability-mcq-1",
        "u1-09-sustainability-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-09-sustainability",
        "locale": "zh-CN",
        "title": "可持续性",
        "takeaway": "可持续的经济选择满足当代需要，同时保留未来人满足其需要的资源和生态能力。",
        "definition": "可持续性是经济活动在长期内能够维持，并避免不可逆地削弱自然系统、社会基础和未来生产与福祉能力的性质。",
        "causalChain": [
          "生产和消费使用自然与社会资源",
          "部分资源会耗竭或积累污染",
          "当前选择改变未来的可行集合",
          "政策与创新尝试把长期成本纳入决策"
        ],
        "realWorldExample": {
          "title": "负责任的消费与生产",
          "sourceUrl": "https://sdgs.un.org/goals/goal12",
          "observedAt": "2026-09-29",
          "explanation": "联合国可持续发展目标 12 追踪资源效率、废弃物和可持续生产。它把当前产出与材料使用和未来环境容量联系起来。"
        },
        "misconceptions": [
          "可持续不等于停止所有增长，而是关注增长的资源和环境路径。",
          "技术进步可以缓解约束，但不能自动消除反弹效应或分配问题。"
        ],
        "examApplication": [
          "区分短期收益与长期外部成本。",
          "评价可持续政策时分析环境成效、转型成本和不同群体的负担。"
        ],
        "summary": [
          "当前选择会改变未来的生产可能。",
          "不可再生资源和生态承载力形成长期约束。",
          "可持续性要求把跨期成本纳入决策。"
        ],
        "explanation": "经济活动依赖能源、材料、生态系统和社会信任。若使用速度超过再生能力，或污染积累超过环境吸收能力，当前产出会损害未来生产与福祉。\n\n可持续性是一种跨期分析。政策需要比较现在和未来的收益与成本，并处理代际公平。资源价格、监管、公共投资和技术创新都可能改变路径，但成效取决于实际行为和制度执行。"
      },
      "en": {
        "id": "u1-09-sustainability",
        "locale": "en",
        "title": "Sustainability",
        "takeaway": "A sustainable economic choice meets present needs while preserving resources and ecological capacity for people in the future.",
        "definition": "Sustainability is the ability of economic activity to continue over time without irreversibly weakening natural systems, social foundations, or the future capacity for production and well-being.",
        "causalChain": [
          "Production and consumption use natural and social resources",
          "Some resources deplete and some pollution accumulates",
          "Present choices alter the future feasible set",
          "Policy and innovation try to incorporate long-run costs"
        ],
        "realWorldExample": {
          "title": "Responsible consumption and production",
          "sourceUrl": "https://sdgs.un.org/goals/goal12",
          "observedAt": "2026-09-29",
          "explanation": "United Nations Sustainable Development Goal 12 tracks resource efficiency, waste, and sustainable production, linking current output to material use and future environmental capacity."
        },
        "misconceptions": [
          "Sustainability does not require an end to all growth; it questions the resource and environmental path of that growth.",
          "Technology can relax a constraint without automatically removing rebound effects or distributional problems."
        ],
        "examApplication": [
          "Separate a short-run benefit from a long-run external cost.",
          "Evaluate environmental effectiveness, transition costs, and how burdens differ across groups."
        ],
        "summary": [
          "Present choices alter future production possibilities.",
          "Finite resources and ecological capacity impose long-run constraints.",
          "Sustainability brings intertemporal costs into decisions."
        ],
        "explanation": "Economic activity relies on energy, materials, ecosystems, and social trust. If use exceeds regeneration or pollution exceeds the environment's capacity to absorb it, today's output can reduce future productive capacity and well-being.\n\nSustainability is an intertemporal test. Policy compares benefits and costs across generations. Resource prices, regulation, public investment, and innovation can redirect the path, but their effect ultimately depends on behaviour and institutional enforcement."
      }
    },
    "practice": [
      {
        "id": "u1-09-sustainability-flash-1",
        "knowledgePointId": "u1-09-sustainability",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“可持续性”。",
          "en": "Without notes, explain “Sustainability” in your own words."
        },
        "answer": {
          "zh-CN": "可持续性是经济活动在长期内能够维持，并避免不可逆地削弱自然系统、社会基础和未来生产与福祉能力的性质。",
          "en": "Sustainability is the ability of economic activity to continue over time without irreversibly weakening natural systems, social foundations, or the future capacity for production and well-being."
        },
        "explanation": {
          "zh-CN": "可持续的经济选择满足当代需要，同时保留未来人满足其需要的资源和生态能力。",
          "en": "A sustainable economic choice meets present needs while preserving resources and ecological capacity for people in the future."
        }
      },
      {
        "id": "u1-09-sustainability-mcq-1",
        "knowledgePointId": "u1-09-sustainability",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“可持续性”？",
          "en": "Which statement best captures “Sustainability”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只要今年产出增加就可持续",
            "en": "Any rise in this year’s output proves sustainability"
          },
          {
            "id": "b",
            "zh-CN": "可持续的经济选择满足当代需要，同时保留未来人满足其需要的资源和生态能力。",
            "en": "A sustainable economic choice meets present needs while preserving resources and ecological capacity for people in the future."
          },
          {
            "id": "c",
            "zh-CN": "可持续性只关乎企业今年利润",
            "en": "Sustainability concerns only current profit"
          },
          {
            "id": "d",
            "zh-CN": "自然资本损耗永远不影响未来选择",
            "en": "Natural-capital depletion never affects future choices"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "可持续性是经济活动在长期内能够维持，并避免不可逆地削弱自然系统、社会基础和未来生产与福祉能力的性质。",
          "en": "Sustainability is the ability of economic activity to continue over time without irreversibly weakening natural systems, social foundations, or the future capacity for production and well-being."
        }
      },
      {
        "id": "u1-09-sustainability-short-1",
        "knowledgePointId": "u1-09-sustainability",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“可持续性”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Sustainability”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "可持续性：可持续性是经济活动在长期内能够维持，并避免不可逆地削弱自然系统、社会基础和未来生产与福祉能力的性质。 生产和消费使用自然与社会资源；部分资源会耗竭或积累污染；当前选择改变未来的可行集合；政策与创新尝试把长期成本纳入决策 当前选择会改变未来的生产可能。",
          "en": "Sustainability: Sustainability is the ability of economic activity to continue over time without irreversibly weakening natural systems, social foundations, or the future capacity for production and well-being. Production and consumption use natural and social resources; Some resources deplete and some pollution accumulates; Present choices alter the future feasible set; Policy and innovation try to incorporate long-run costs Present choices alter future production possibilities."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "可持续性",
                "可持续发展",
                "长期承载力",
                "代际可持续"
              ],
              "en": [
                "Sustainability",
                "sustainable development",
                "long-run carrying capacity",
                "intergenerational sustainability"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "生产和消费使用自然与社会资源",
                "部分资源会耗竭或积累污染"
              ],
              "en": [
                "Production and consumption use natural and social resources",
                "Some resources deplete and some pollution accumulates"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "当前选择会改变未来的生产可能。",
                "不可再生资源和生态承载力形成长期约束。"
              ],
              "en": [
                "Present choices alter future production possibilities.",
                "Finite resources and ecological capacity impose long-run constraints."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-10-change",
      "slug": "change",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            6
          ]
        }
      ],
      "prerequisites": [
        "u1-01-economics-social-science"
      ],
      "related": [
        "u1-11-interdependence",
        "u1-28-ppc-growth"
      ],
      "terms": [
        "Change",
        "变化"
      ],
      "synonyms": {
        "zh-CN": [
          "经济变化",
          "动态调整",
          "结构转型"
        ],
        "en": [
          "economic change",
          "dynamic adjustment",
          "structural transition"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-10-change-flash-1",
        "u1-10-change-mcq-1",
        "u1-10-change-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-10-change",
        "locale": "zh-CN",
        "title": "变化",
        "takeaway": "经济结果会随技术、制度、偏好和外部冲击变化，因此模型结论必须标明时间和条件。",
        "definition": "变化是经济主体、资源、技术、制度或外部环境随时间发生的调整，以及这些调整引起的生产、分配和福祉结果改变。",
        "causalChain": [
          "技术、政策或偏好发生变化",
          "相对成本和激励随之改变",
          "家庭与企业调整行为",
          "市场结构、产出和分配出现新结果"
        ],
        "realWorldExample": {
          "title": "能源体系持续转型",
          "sourceUrl": "https://www.iea.org/reports/world-energy-outlook-2025",
          "observedAt": "2026-09-29",
          "explanation": "国际能源署《世界能源展望》比较能源技术、投资和政策情景，显示成本、基础设施与政策变化会逐步改变能源组合和相关就业。"
        },
        "misconceptions": [
          "变化不是瞬间完成；合同、技能和基础设施会造成调整滞后。",
          "观察到前后变化并不能单独证明某一政策就是原因。"
        ],
        "examApplication": [
          "用清楚的前后状态和传导链表达动态变化。",
          "评价时讨论速度、可逆性、预期和短期长期差异。"
        ],
        "summary": [
          "经济环境不是静止的。",
          "激励变化通过行为调整影响结果。",
          "时间路径和因果识别同样重要。"
        ],
        "explanation": "技术进步、人口结构、偏好、政策和外部冲击都会改变经济约束。经济主体不会机械地留在原有选择上，而会学习、预期并调整。\n\n变化有速度和路径。短期内资本设备、劳动技能或合同可能固定，长期则有更多调整空间。回答动态问题时，应区分触发因素、传导过程和最终结果，而不是只比较两个时间点。"
      },
      "en": {
        "id": "u1-10-change",
        "locale": "en",
        "title": "Change",
        "takeaway": "Economic outcomes evolve with technology, institutions, preferences, and shocks, so a model's conclusion must be located in time and under stated conditions.",
        "definition": "Change refers to adjustment over time in agents, resources, technology, institutions, or the external environment and to the resulting shifts in production, distribution, and well-being.",
        "causalChain": [
          "Technology, policy, or preferences change",
          "Relative costs and incentives move",
          "Households and firms adjust behaviour",
          "Market structure, output, and distribution reach new outcomes"
        ],
        "realWorldExample": {
          "title": "A changing energy system",
          "sourceUrl": "https://www.iea.org/reports/world-energy-outlook-2025",
          "observedAt": "2026-09-29",
          "explanation": "The IEA World Energy Outlook compares scenarios for energy technology, investment, and policy. It shows how costs, infrastructure, and policy gradually alter the energy mix and associated employment."
        },
        "misconceptions": [
          "Adjustment is rarely instantaneous; contracts, skills, and infrastructure create lags.",
          "A before-and-after difference does not by itself prove that one policy caused the change."
        ],
        "examApplication": [
          "Describe a dynamic process with a clear initial state, transmission chain, and later state.",
          "Evaluation can address speed, reversibility, expectations, and short-run versus long-run adjustment."
        ],
        "summary": [
          "The economic environment is not static.",
          "Changing incentives work through behavioural adjustment.",
          "The time path and causal identification both matter."
        ],
        "explanation": "Technology, demography, preferences, policy, and external shocks alter economic constraints. Agents do not remain mechanically attached to previous choices; they learn, form expectations, and respond.\n\nChange has both a speed and a path. Capital equipment, worker skills, or contracts can be fixed in the short run, while the long run permits wider adaptation. A dynamic answer should separate the trigger, the transmission process, and the later outcome rather than simply comparing two dates."
      }
    },
    "practice": [
      {
        "id": "u1-10-change-flash-1",
        "knowledgePointId": "u1-10-change",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“变化”。",
          "en": "Without notes, explain “Change” in your own words."
        },
        "answer": {
          "zh-CN": "变化是经济主体、资源、技术、制度或外部环境随时间发生的调整，以及这些调整引起的生产、分配和福祉结果改变。",
          "en": "Change refers to adjustment over time in agents, resources, technology, institutions, or the external environment and to the resulting shifts in production, distribution, and well-being."
        },
        "explanation": {
          "zh-CN": "经济结果会随技术、制度、偏好和外部冲击变化，因此模型结论必须标明时间和条件。",
          "en": "Economic outcomes evolve with technology, institutions, preferences, and shocks, so a model's conclusion must be located in time and under stated conditions."
        }
      },
      {
        "id": "u1-10-change-mcq-1",
        "knowledgePointId": "u1-10-change",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“变化”？",
          "en": "Which statement best captures “Change”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "变化只指价格变动",
            "en": "Change means price changes alone"
          },
          {
            "id": "b",
            "zh-CN": "变化必定使所有人受益",
            "en": "Change must benefit everyone"
          },
          {
            "id": "c",
            "zh-CN": "经济结果会随技术、制度、偏好和外部冲击变化，因此模型结论必须标明时间和条件。",
            "en": "Economic outcomes evolve with technology, institutions, preferences, and shocks, so a model's conclusion must be located in time and under stated conditions."
          },
          {
            "id": "d",
            "zh-CN": "技术变化不会改变资源配置",
            "en": "Technology never changes allocation"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "变化是经济主体、资源、技术、制度或外部环境随时间发生的调整，以及这些调整引起的生产、分配和福祉结果改变。",
          "en": "Change refers to adjustment over time in agents, resources, technology, institutions, or the external environment and to the resulting shifts in production, distribution, and well-being."
        }
      },
      {
        "id": "u1-10-change-short-1",
        "knowledgePointId": "u1-10-change",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“变化”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Change”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "变化：变化是经济主体、资源、技术、制度或外部环境随时间发生的调整，以及这些调整引起的生产、分配和福祉结果改变。 技术、政策或偏好发生变化；相对成本和激励随之改变；家庭与企业调整行为；市场结构、产出和分配出现新结果 经济环境不是静止的。",
          "en": "Change: Change refers to adjustment over time in agents, resources, technology, institutions, or the external environment and to the resulting shifts in production, distribution, and well-being. Technology, policy, or preferences change; Relative costs and incentives move; Households and firms adjust behaviour; Market structure, output, and distribution reach new outcomes The economic environment is not static."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "变化",
                "经济变化",
                "动态调整",
                "结构转型"
              ],
              "en": [
                "Change",
                "economic change",
                "dynamic adjustment",
                "structural transition"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "技术、政策或偏好发生变化",
                "相对成本和激励随之改变"
              ],
              "en": [
                "Technology, policy, or preferences change",
                "Relative costs and incentives move"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "经济环境不是静止的。",
                "激励变化通过行为调整影响结果。"
              ],
              "en": [
                "The economic environment is not static.",
                "Changing incentives work through behavioural adjustment."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-11-interdependence",
      "slug": "interdependence",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            6
          ]
        }
      ],
      "prerequisites": [
        "u1-01-economics-social-science"
      ],
      "related": [
        "u1-10-change",
        "u1-43-circular-economy"
      ],
      "terms": [
        "Interdependence",
        "相互依存"
      ],
      "synonyms": {
        "zh-CN": [
          "经济联系",
          "相互依赖",
          "传导网络"
        ],
        "en": [
          "economic linkage",
          "mutual dependence",
          "transmission network"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-11-interdependence-flash-1",
        "u1-11-interdependence-mcq-1",
        "u1-11-interdependence-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-11-interdependence",
        "locale": "zh-CN",
        "title": "相互依存",
        "takeaway": "相互依存意味着一个主体的选择会通过贸易、收入、价格、环境或制度影响其他主体。",
        "definition": "相互依存是家庭、企业、政府、国家与自然环境之间通过生产、交换、金融、政策和生态系统形成的双向依赖关系。",
        "causalChain": [
          "主体通过市场或制度建立联系",
          "一方的需求、供给或规则发生变化",
          "价格、收入或资源流动传导冲击",
          "其他主体回应并可能产生反馈"
        ],
        "realWorldExample": {
          "title": "全球贸易网络传导冲击",
          "sourceUrl": "https://www.wto.org/english/res_e/statis_e/statis_e.htm",
          "observedAt": "2026-09-29",
          "explanation": "世界贸易组织的贸易统计展示中间品和最终品跨境流动。一个经济体的需求或运输条件变化，可能通过订单、价格和就业影响多地生产者。"
        },
        "misconceptions": [
          "相互依存不表示各方力量相等；依赖可能高度不对称。",
          "联系既能分散风险，也可能放大和传播冲击。"
        ],
        "examApplication": [
          "至少追踪两个主体之间的双向影响。",
          "评价开放或整合时同时分析收益、脆弱性和反馈效应。"
        ],
        "summary": [
          "经济主体通过多种流动相互连接。",
          "冲击会跨市场和地区传导。",
          "依存关系可能带来收益与风险。"
        ],
        "explanation": "现代生产常由多个企业和地区共同完成，收入又把生产者与消费者连接起来。政府的政策、金融条件和环境变化也会越过单个市场边界。\n\n分析相互依存要寻找传导渠道与反馈。一地成本上升可能提高另一地价格，后者需求下降又会反馈到原生产者。网络带来专业化和风险分担，也可能使局部冲击扩散。"
      },
      "en": {
        "id": "u1-11-interdependence",
        "locale": "en",
        "title": "Interdependence",
        "takeaway": "Interdependence means that one agent's choice affects others through trade, income, prices, the environment, or institutions.",
        "definition": "Interdependence is the two-way reliance among households, firms, governments, countries, and the natural environment created through production, exchange, finance, policy, and ecosystems.",
        "causalChain": [
          "Agents become connected through markets or institutions",
          "Demand, supply, or rules change for one participant",
          "Prices, incomes, or resource flows transmit the shock",
          "Other participants respond and may create feedback"
        ],
        "realWorldExample": {
          "title": "Global trade networks transmit shocks",
          "sourceUrl": "https://www.wto.org/english/res_e/statis_e/statis_e.htm",
          "observedAt": "2026-09-29",
          "explanation": "World Trade Organization statistics track cross-border flows of intermediate and final goods. A change in demand or shipping conditions in one economy can influence orders, prices, and employment across many production locations."
        },
        "misconceptions": [
          "Interdependence does not imply equal power; dependence may be strongly asymmetric.",
          "Connections can diversify risk while also spreading and amplifying a shock."
        ],
        "examApplication": [
          "Trace at least one two-way effect between identifiable agents.",
          "When evaluating integration, consider benefits, vulnerabilities, and feedback effects together."
        ],
        "summary": [
          "Economic agents are connected through several kinds of flow.",
          "Shocks can travel across markets and places.",
          "Interdependence creates both gains and risks."
        ],
        "explanation": "Modern production frequently spans several firms and places, while income connects producers to consumers. Government policy, financial conditions, and environmental change also cross the boundary of a single market.\n\nAnalysis should identify transmission channels and feedback. Higher costs in one location may raise prices elsewhere; the resulting fall in demand can then return to the original producer. Networks support specialisation and risk sharing but can also spread a local disturbance."
      }
    },
    "practice": [
      {
        "id": "u1-11-interdependence-flash-1",
        "knowledgePointId": "u1-11-interdependence",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“相互依存”。",
          "en": "Without notes, explain “Interdependence” in your own words."
        },
        "answer": {
          "zh-CN": "相互依存是家庭、企业、政府、国家与自然环境之间通过生产、交换、金融、政策和生态系统形成的双向依赖关系。",
          "en": "Interdependence is the two-way reliance among households, firms, governments, countries, and the natural environment created through production, exchange, finance, policy, and ecosystems."
        },
        "explanation": {
          "zh-CN": "相互依存意味着一个主体的选择会通过贸易、收入、价格、环境或制度影响其他主体。",
          "en": "Interdependence means that one agent's choice affects others through trade, income, prices, the environment, or institutions."
        }
      },
      {
        "id": "u1-11-interdependence-mcq-1",
        "knowledgePointId": "u1-11-interdependence",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“相互依存”？",
          "en": "Which statement best captures “Interdependence”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "国际贸易使各国完全独立",
            "en": "Trade makes countries completely independent"
          },
          {
            "id": "b",
            "zh-CN": "家庭与企业之间只有单向影响",
            "en": "Households and firms affect each other in only one direction"
          },
          {
            "id": "c",
            "zh-CN": "环境与经济决策没有联系",
            "en": "The environment has no link to economic decisions"
          },
          {
            "id": "d",
            "zh-CN": "相互依存意味着一个主体的选择会通过贸易、收入、价格、环境或制度影响其他主体。",
            "en": "Interdependence means that one agent's choice affects others through trade, income, prices, the environment, or institutions."
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "相互依存是家庭、企业、政府、国家与自然环境之间通过生产、交换、金融、政策和生态系统形成的双向依赖关系。",
          "en": "Interdependence is the two-way reliance among households, firms, governments, countries, and the natural environment created through production, exchange, finance, policy, and ecosystems."
        }
      },
      {
        "id": "u1-11-interdependence-short-1",
        "knowledgePointId": "u1-11-interdependence",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“相互依存”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Interdependence”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "相互依存：相互依存是家庭、企业、政府、国家与自然环境之间通过生产、交换、金融、政策和生态系统形成的双向依赖关系。 主体通过市场或制度建立联系；一方的需求、供给或规则发生变化；价格、收入或资源流动传导冲击；其他主体回应并可能产生反馈 经济主体通过多种流动相互连接。",
          "en": "Interdependence: Interdependence is the two-way reliance among households, firms, governments, countries, and the natural environment created through production, exchange, finance, policy, and ecosystems. Agents become connected through markets or institutions; Demand, supply, or rules change for one participant; Prices, incomes, or resource flows transmit the shock; Other participants respond and may create feedback Economic agents are connected through several kinds of flow."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "相互依存",
                "经济联系",
                "相互依赖",
                "传导网络"
              ],
              "en": [
                "Interdependence",
                "economic linkage",
                "mutual dependence",
                "transmission network"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "主体通过市场或制度建立联系",
                "一方的需求、供给或规则发生变化"
              ],
              "en": [
                "Agents become connected through markets or institutions",
                "Demand, supply, or rules change for one participant"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "经济主体通过多种流动相互连接。",
                "冲击会跨市场和地区传导。"
              ],
              "en": [
                "Economic agents are connected through several kinds of flow.",
                "Shocks can travel across markets and places."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-12-intervention",
      "slug": "intervention",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            7
          ]
        }
      ],
      "prerequisites": [
        "u1-02-microeconomics"
      ],
      "related": [
        "u1-19-market-mechanism",
        "u1-20-government-intervention"
      ],
      "terms": [
        "Intervention",
        "干预"
      ],
      "synonyms": {
        "zh-CN": [
          "政策干预",
          "政府介入",
          "经济调控"
        ],
        "en": [
          "policy intervention",
          "government action",
          "economic regulation"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-12-intervention-flash-1",
        "u1-12-intervention-mcq-1",
        "u1-12-intervention-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-12-intervention",
        "locale": "zh-CN",
        "title": "干预",
        "takeaway": "干预通过改变规则、价格或资源分配来影响经济行为，其成效要与副作用和执行成本一起评价。",
        "definition": "经济干预是政府、中央银行或其他机构有意改变市场激励、交易条件、资源配置或收入分配的行动。",
        "causalChain": [
          "识别市场结果或社会目标之间的差距",
          "选择税收、监管、支出或信息等工具",
          "工具改变主体面对的激励与约束",
          "行为反应形成预期成效与非预期后果"
        ],
        "realWorldExample": {
          "title": "伦敦拥堵费改变驾车激励",
          "sourceUrl": "https://tfl.gov.uk/modes/driving/congestion-charge",
          "observedAt": "2026-09-29",
          "explanation": "伦敦交通局对特定区域和时段驾车收费，把道路拥堵的部分社会成本转化为驾驶者面对的货币成本，试图改变出行方式和时段。"
        },
        "misconceptions": [
          "宣布政策不等于实现目标；行为反应和执行能力决定实际结果。",
          "干预既可能纠正市场问题，也可能产生政府失灵。"
        ],
        "examApplication": [
          "按目标—工具—激励—行为—结果写出完整政策链。",
          "评价时加入弹性、时滞、行政成本和利益相关者。"
        ],
        "summary": [
          "干预有明确目标和政策工具。",
          "政策通过改变激励影响行为。",
          "有效性与副作用都需证据支持。"
        ],
        "explanation": "市场结果可能与效率、公平、稳定或可持续目标不一致，机构于是使用税收、补贴、监管、公共供给或信息政策改变条件。\n\n干预不是直接把目标变成结果。政策先改变价格或约束，再由家庭与企业回应。若反应与预期不同、执行困难或信息不足，净效果可能小于预期甚至产生新问题。"
      },
      "en": {
        "id": "u1-12-intervention",
        "locale": "en",
        "title": "Intervention",
        "takeaway": "Intervention changes rules, prices, or resource allocation to influence behaviour; its benefits must be assessed alongside side effects and implementation costs.",
        "definition": "Economic intervention is deliberate action by a government, central bank, or other institution to alter market incentives, trading conditions, resource allocation, or income distribution.",
        "causalChain": [
          "Identify a gap between a market outcome and a social objective",
          "Select a tax, regulation, spending, information, or other instrument",
          "The instrument changes incentives and constraints",
          "Behavioural responses produce intended and unintended outcomes"
        ],
        "realWorldExample": {
          "title": "London's congestion charge changes driving incentives",
          "sourceUrl": "https://tfl.gov.uk/modes/driving/congestion-charge",
          "observedAt": "2026-09-29",
          "explanation": "Transport for London charges for driving in a defined area and period. The policy turns part of congestion's social cost into a monetary cost faced by drivers and aims to change routes, modes, or travel times."
        },
        "misconceptions": [
          "Announcing a policy does not achieve its objective; behaviour and implementation determine the result.",
          "Intervention can correct a market problem while also creating government failure."
        ],
        "examApplication": [
          "Build the full chain: objective, instrument, incentive, behavioural response, and outcome.",
          "Evaluation should consider elasticity, time lags, administrative cost, and affected stakeholders."
        ],
        "summary": [
          "Intervention combines an objective with an instrument.",
          "Policy works by changing incentives and behaviour.",
          "Both effectiveness and side effects require evidence."
        ],
        "explanation": "Market outcomes may conflict with objectives for efficiency, equity, stability, or sustainability. Institutions then use taxes, subsidies, regulation, public provision, or information to change economic conditions.\n\nA policy does not turn an objective directly into an outcome. It first changes a price or constraint and agents respond. Unexpected behaviour, weak implementation, or poor information can reduce the net benefit or create a new problem."
      }
    },
    "practice": [
      {
        "id": "u1-12-intervention-flash-1",
        "knowledgePointId": "u1-12-intervention",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“干预”。",
          "en": "Without notes, explain “Intervention” in your own words."
        },
        "answer": {
          "zh-CN": "经济干预是政府、中央银行或其他机构有意改变市场激励、交易条件、资源配置或收入分配的行动。",
          "en": "Economic intervention is deliberate action by a government, central bank, or other institution to alter market incentives, trading conditions, resource allocation, or income distribution."
        },
        "explanation": {
          "zh-CN": "干预通过改变规则、价格或资源分配来影响经济行为，其成效要与副作用和执行成本一起评价。",
          "en": "Intervention changes rules, prices, or resource allocation to influence behaviour; its benefits must be assessed alongside side effects and implementation costs."
        }
      },
      {
        "id": "u1-12-intervention-mcq-1",
        "knowledgePointId": "u1-12-intervention",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“干预”？",
          "en": "Which statement best captures “Intervention”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "干预通过改变规则、价格或资源分配来影响经济行为，其成效要与副作用和执行成本一起评价。",
            "en": "Intervention changes rules, prices, or resource allocation to influence behaviour; its benefits must be assessed alongside side effects and implementation costs."
          },
          {
            "id": "b",
            "zh-CN": "干预只可能是禁止交易",
            "en": "Intervention can only mean banning trade"
          },
          {
            "id": "c",
            "zh-CN": "干预总能无成本改善所有结果",
            "en": "Intervention always improves all outcomes without cost"
          },
          {
            "id": "d",
            "zh-CN": "任何价格变动都由政府直接决定",
            "en": "Every price change is directly set by government"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "经济干预是政府、中央银行或其他机构有意改变市场激励、交易条件、资源配置或收入分配的行动。",
          "en": "Economic intervention is deliberate action by a government, central bank, or other institution to alter market incentives, trading conditions, resource allocation, or income distribution."
        }
      },
      {
        "id": "u1-12-intervention-short-1",
        "knowledgePointId": "u1-12-intervention",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“干预”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Intervention”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "干预：经济干预是政府、中央银行或其他机构有意改变市场激励、交易条件、资源配置或收入分配的行动。 识别市场结果或社会目标之间的差距；选择税收、监管、支出或信息等工具；工具改变主体面对的激励与约束；行为反应形成预期成效与非预期后果 干预有明确目标和政策工具。",
          "en": "Intervention: Economic intervention is deliberate action by a government, central bank, or other institution to alter market incentives, trading conditions, resource allocation, or income distribution. Identify a gap between a market outcome and a social objective; Select a tax, regulation, spending, information, or other instrument; The instrument changes incentives and constraints; Behavioural responses produce intended and unintended outcomes Intervention combines an objective with an instrument."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "干预",
                "政策干预",
                "政府介入",
                "经济调控"
              ],
              "en": [
                "Intervention",
                "policy intervention",
                "government action",
                "economic regulation"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "识别市场结果或社会目标之间的差距",
                "选择税收、监管、支出或信息等工具"
              ],
              "en": [
                "Identify a gap between a market outcome and a social objective",
                "Select a tax, regulation, spending, information, or other instrument"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "干预有明确目标和政策工具。",
                "政策通过改变激励影响行为。"
              ],
              "en": [
                "Intervention combines an objective with an instrument.",
                "Policy works by changing incentives and behaviour."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-13-factors-of-production",
      "slug": "factors-of-production",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            7,
            8
          ]
        }
      ],
      "prerequisites": [
        "u1-04-scarcity"
      ],
      "related": [
        "u1-14-opportunity-cost",
        "u1-25-ppc-construction"
      ],
      "terms": [
        "Factors of production",
        "四类生产要素"
      ],
      "synonyms": {
        "zh-CN": [
          "生产投入",
          "土地劳动资本企业家",
          "资源要素"
        ],
        "en": [
          "productive inputs",
          "land labour capital entrepreneurship",
          "economic resources"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-13-factors-of-production-flash-1",
        "u1-13-factors-of-production-mcq-1",
        "u1-13-factors-of-production-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-13-factors-of-production",
        "locale": "zh-CN",
        "title": "四类生产要素",
        "takeaway": "生产把土地、劳动、资本与企业家才能组合起来；每类要素的数量和质量都会限制产出。",
        "definition": "生产要素是创造商品和服务所需的投入，通常分为土地（自然资源）、劳动（人的努力与技能）、资本（人造生产资料）和企业家才能（组织、创新与承担风险）。",
        "causalChain": [
          "自然资源提供物质与空间",
          "劳动投入时间、技能和判断",
          "资本提高劳动与资源的生产能力",
          "企业家组合要素并承担不确定性"
        ],
        "realWorldExample": {
          "title": "劳动技能影响生产能力",
          "sourceUrl": "https://www.ilo.org/topics-and-sectors",
          "observedAt": "2026-09-29",
          "explanation": "国际劳工组织关于技能与就业的工作展示教育、培训和劳动条件如何影响劳动要素的质量，而不仅是劳动人数。"
        },
        "misconceptions": [
          "经济学中的资本主要指机器、建筑和工具，不等同于金融资金。",
          "企业家才能不是企业规模，而是组织资源、创新和承担风险的功能。"
        ],
        "examApplication": [
          "案例中逐一识别实际投入，不要只背四个名称。",
          "解释增长时区分要素数量增加与要素生产率提高。"
        ],
        "summary": [
          "土地包括自然资源。",
          "劳动包括人的体力、技能和时间。",
          "资本与企业家才能帮助组合并提高其他投入的产出。"
        ],
        "explanation": "任何生产过程都需要投入。土地涵盖位置、矿产、水和生态服务；劳动涵盖人的时间、体力和知识；资本是为进一步生产而制造的工具与设施；企业家才能负责发现机会并组织其他要素。\n\n分类帮助解释收入来源和增长。工资通常与劳动相关，租金与土地相关，利息或回报与资本相关，利润则补偿企业家承担的不确定性。现实投入可能同时具有多种特征。"
      },
      "en": {
        "id": "u1-13-factors-of-production",
        "locale": "en",
        "title": "Factors of production",
        "takeaway": "Production combines land, labour, capital, and entrepreneurship; both the quantity and quality of each factor constrain output.",
        "definition": "Factors of production are the inputs used to create goods and services: land (natural resources), labour (human effort and skill), capital (produced means of production), and entrepreneurship (organisation, innovation, and risk-bearing).",
        "causalChain": [
          "Natural resources provide materials and location",
          "Labour contributes time, skill, and judgement",
          "Capital raises the productive capacity of labour and resources",
          "Entrepreneurship combines inputs under uncertainty"
        ],
        "realWorldExample": {
          "title": "Workforce skills affect productive capacity",
          "sourceUrl": "https://www.ilo.org/topics-and-sectors",
          "observedAt": "2026-09-29",
          "explanation": "International Labour Organization work on skills and employment demonstrates how education, training, and working conditions influence the quality of labour, not merely the number of workers."
        },
        "misconceptions": [
          "Capital in this classification means machinery, buildings, and tools rather than money itself.",
          "Entrepreneurship is a function—organising, innovating, and taking risk—not the size of a business."
        ],
        "examApplication": [
          "Identify concrete inputs in the case rather than only listing four labels.",
          "When explaining growth, distinguish a larger quantity of a factor from higher factor productivity."
        ],
        "summary": [
          "Land includes natural resources.",
          "Labour includes human time, effort, and skill.",
          "Capital and entrepreneurship organise and raise the productivity of other inputs."
        ],
        "explanation": "Every production process requires inputs. Land includes location, minerals, water, and ecosystem services; labour includes human time, effort, and knowledge; capital consists of tools and facilities made for further production; entrepreneurship identifies opportunities and organises the other factors.\n\nThe classification also helps explain income and growth. Wages are associated with labour, rent with land, returns with capital, and profit with bearing entrepreneurial uncertainty. A real input can contain characteristics of more than one category."
      }
    },
    "practice": [
      {
        "id": "u1-13-factors-of-production-flash-1",
        "knowledgePointId": "u1-13-factors-of-production",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“四类生产要素”。",
          "en": "Without notes, explain “Factors of production” in your own words."
        },
        "answer": {
          "zh-CN": "生产要素是创造商品和服务所需的投入，通常分为土地（自然资源）、劳动（人的努力与技能）、资本（人造生产资料）和企业家才能（组织、创新与承担风险）。",
          "en": "Factors of production are the inputs used to create goods and services: land (natural resources), labour (human effort and skill), capital (produced means of production), and entrepreneurship (organisation, innovation, and risk-bearing)."
        },
        "explanation": {
          "zh-CN": "生产把土地、劳动、资本与企业家才能组合起来；每类要素的数量和质量都会限制产出。",
          "en": "Production combines land, labour, capital, and entrepreneurship; both the quantity and quality of each factor constrain output."
        }
      },
      {
        "id": "u1-13-factors-of-production-mcq-1",
        "knowledgePointId": "u1-13-factors-of-production",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“四类生产要素”？",
          "en": "Which statement best captures “Factors of production”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "银行账户现金就是生产要素中的实物资本",
            "en": "Bank-account cash is the physical capital factor"
          },
          {
            "id": "b",
            "zh-CN": "生产把土地、劳动、资本与企业家才能组合起来；每类要素的数量和质量都会限制产出。",
            "en": "Production combines land, labour, capital, and entrepreneurship; both the quantity and quality of each factor constrain output."
          },
          {
            "id": "c",
            "zh-CN": "企业家才能等同于所有体力劳动",
            "en": "Entrepreneurship is identical to all physical labour"
          },
          {
            "id": "d",
            "zh-CN": "土地只指已建成厂房",
            "en": "Land means only constructed factories"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "生产要素是创造商品和服务所需的投入，通常分为土地（自然资源）、劳动（人的努力与技能）、资本（人造生产资料）和企业家才能（组织、创新与承担风险）。",
          "en": "Factors of production are the inputs used to create goods and services: land (natural resources), labour (human effort and skill), capital (produced means of production), and entrepreneurship (organisation, innovation, and risk-bearing)."
        }
      },
      {
        "id": "u1-13-factors-of-production-short-1",
        "knowledgePointId": "u1-13-factors-of-production",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“四类生产要素”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Factors of production”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "四类生产要素：生产要素是创造商品和服务所需的投入，通常分为土地（自然资源）、劳动（人的努力与技能）、资本（人造生产资料）和企业家才能（组织、创新与承担风险）。 自然资源提供物质与空间；劳动投入时间、技能和判断；资本提高劳动与资源的生产能力；企业家组合要素并承担不确定性 土地包括自然资源。",
          "en": "Factors of production: Factors of production are the inputs used to create goods and services: land (natural resources), labour (human effort and skill), capital (produced means of production), and entrepreneurship (organisation, innovation, and risk-bearing). Natural resources provide materials and location; Labour contributes time, skill, and judgement; Capital raises the productive capacity of labour and resources; Entrepreneurship combines inputs under uncertainty Land includes natural resources."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "四类生产要素",
                "生产投入",
                "土地劳动资本企业家",
                "资源要素"
              ],
              "en": [
                "Factors of production",
                "productive inputs",
                "land labour capital entrepreneurship",
                "economic resources"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "自然资源提供物质与空间",
                "劳动投入时间、技能和判断"
              ],
              "en": [
                "Natural resources provide materials and location",
                "Labour contributes time, skill, and judgement"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "土地包括自然资源。",
                "劳动包括人的体力、技能和时间。"
              ],
              "en": [
                "Land includes natural resources.",
                "Labour includes human time, effort, and skill."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-14-opportunity-cost",
      "slug": "opportunity-cost",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            8,
            9
          ]
        }
      ],
      "prerequisites": [
        "u1-04-scarcity",
        "u1-05-choice"
      ],
      "related": [
        "u1-13-factors-of-production",
        "u1-26-ppc-scarcity-choice-cost"
      ],
      "terms": [
        "Opportunity cost",
        "机会成本"
      ],
      "synonyms": {
        "zh-CN": [
          "替代成本",
          "次优方案价值",
          "trade-off cost"
        ],
        "en": [
          "alternative cost",
          "value of next-best alternative",
          "trade-off cost"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-14-opportunity-cost-flash-1",
        "u1-14-opportunity-cost-mcq-1",
        "u1-14-opportunity-cost-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-14-opportunity-cost",
        "locale": "zh-CN",
        "title": "机会成本",
        "takeaway": "机会成本是作出选择时放弃的最佳可行替代方案的价值，而不是所有放弃选项之和。",
        "definition": "机会成本是在资源用于某项选择后无法获得的次优可行方案的收益或价值。",
        "causalChain": [
          "稀缺产生多个竞争用途",
          "按价值排列可行方案",
          "选择排名最高的方案",
          "排名第二且被放弃的方案构成机会成本"
        ],
        "realWorldExample": {
          "title": "公共预算的替代用途",
          "sourceUrl": "https://www.imf.org/en/Publications/FM",
          "observedAt": "2026-09-29",
          "explanation": "IMF《财政监测》讨论政府支出与财政空间。新增一项支出会占用资金和执行能力，其机会成本是同一资源原本可以支持的最佳替代政策。"
        },
        "misconceptions": [
          "机会成本不是所有被放弃方案的总和，只取最佳替代方案。",
          "沉没成本已经无法收回，不应与当前选择的机会成本混淆。"
        ],
        "examApplication": [
          "用“选择 A 的机会成本是放弃的最佳方案 B”完整表达。",
          "PPC 题中用另一种产品减少的数量衡量机会成本。"
        ],
        "summary": [
          "机会成本源于稀缺和选择。",
          "它只对应最佳被放弃方案。",
          "成本可用金钱、时间、产出或福祉表示。"
        ],
        "explanation": "选择一个用途意味着同一资源不能同时完整用于其他用途。经济学把最有价值的被放弃方案称为机会成本，以此显示决策的真实取舍。\n\n机会成本取决于当时可行的方案和决策者的目标，所以并非固定金额。它可以是失去的收入、时间、产出或环境质量。若替代方案不可行，就不应计入机会成本。"
      },
      "en": {
        "id": "u1-14-opportunity-cost",
        "locale": "en",
        "title": "Opportunity cost",
        "takeaway": "Opportunity cost is the value of the best feasible alternative forgone when a choice is made, not the sum of every rejected option.",
        "definition": "Opportunity cost is the benefit or value of the next-best feasible alternative that cannot be obtained once resources are committed to a chosen use.",
        "causalChain": [
          "Scarcity creates competing uses",
          "Feasible alternatives are ranked by value",
          "The highest-ranked option is selected",
          "The second-ranked forgone option is the opportunity cost"
        ],
        "realWorldExample": {
          "title": "Alternative uses of a public budget",
          "sourceUrl": "https://www.imf.org/en/Publications/FM",
          "observedAt": "2026-09-29",
          "explanation": "The IMF Fiscal Monitor discusses government spending and fiscal space. A new programme uses finance and administrative capacity; its opportunity cost is the best alternative policy that those resources could have supported."
        },
        "misconceptions": [
          "Opportunity cost is not the total of all forgone options; it is the best one.",
          "A sunk cost that cannot be recovered is not the opportunity cost of a decision made now."
        ],
        "examApplication": [
          "Use the complete statement: the opportunity cost of choosing A is the best forgone alternative B.",
          "On a PPC, measure the cost by the reduction in output of the other good."
        ],
        "summary": [
          "Opportunity cost follows from scarcity and choice.",
          "Only the best forgone alternative counts.",
          "Cost may be expressed in money, time, output, or well-being."
        ],
        "explanation": "Selecting one use prevents the same resource from being devoted fully to another. Economics calls the most valuable rejected option the opportunity cost, making the true trade-off in a decision visible.\n\nThe cost depends on the feasible alternatives and the decision-maker's objectives at that moment, so it is not a fixed cash amount. It can take the form of lost income, time, output, or environmental quality. An impossible alternative should not be counted."
      }
    },
    "practice": [
      {
        "id": "u1-14-opportunity-cost-flash-1",
        "knowledgePointId": "u1-14-opportunity-cost",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“机会成本”。",
          "en": "Without notes, explain “Opportunity cost” in your own words."
        },
        "answer": {
          "zh-CN": "机会成本是在资源用于某项选择后无法获得的次优可行方案的收益或价值。",
          "en": "Opportunity cost is the benefit or value of the next-best feasible alternative that cannot be obtained once resources are committed to a chosen use."
        },
        "explanation": {
          "zh-CN": "机会成本是作出选择时放弃的最佳可行替代方案的价值，而不是所有放弃选项之和。",
          "en": "Opportunity cost is the value of the best feasible alternative forgone when a choice is made, not the sum of every rejected option."
        }
      },
      {
        "id": "u1-14-opportunity-cost-mcq-1",
        "knowledgePointId": "u1-14-opportunity-cost",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“机会成本”？",
          "en": "Which statement best captures “Opportunity cost”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "所有放弃方案价值的总和",
            "en": "The sum of every forgone alternative"
          },
          {
            "id": "b",
            "zh-CN": "只有已经支付的现金",
            "en": "Only cash already paid"
          },
          {
            "id": "c",
            "zh-CN": "机会成本是作出选择时放弃的最佳可行替代方案的价值，而不是所有放弃选项之和。",
            "en": "Opportunity cost is the value of the best feasible alternative forgone when a choice is made, not the sum of every rejected option."
          },
          {
            "id": "d",
            "zh-CN": "被选方案的全部收益",
            "en": "The entire benefit of the chosen option"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "机会成本是在资源用于某项选择后无法获得的次优可行方案的收益或价值。",
          "en": "Opportunity cost is the benefit or value of the next-best feasible alternative that cannot be obtained once resources are committed to a chosen use."
        }
      },
      {
        "id": "u1-14-opportunity-cost-short-1",
        "knowledgePointId": "u1-14-opportunity-cost",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“机会成本”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Opportunity cost”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "机会成本：机会成本是在资源用于某项选择后无法获得的次优可行方案的收益或价值。 稀缺产生多个竞争用途；按价值排列可行方案；选择排名最高的方案；排名第二且被放弃的方案构成机会成本 机会成本源于稀缺和选择。",
          "en": "Opportunity cost: Opportunity cost is the benefit or value of the next-best feasible alternative that cannot be obtained once resources are committed to a chosen use. Scarcity creates competing uses; Feasible alternatives are ranked by value; The highest-ranked option is selected; The second-ranked forgone option is the opportunity cost Opportunity cost follows from scarcity and choice."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "机会成本",
                "替代成本",
                "次优方案价值",
                "trade-off cost"
              ],
              "en": [
                "Opportunity cost",
                "alternative cost",
                "value of next-best alternative",
                "trade-off cost"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "稀缺产生多个竞争用途",
                "按价值排列可行方案"
              ],
              "en": [
                "Scarcity creates competing uses",
                "Feasible alternatives are ranked by value"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "机会成本源于稀缺和选择。",
                "它只对应最佳被放弃方案。"
              ],
              "en": [
                "Opportunity cost follows from scarcity and choice.",
                "Only the best forgone alternative counts."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-15-free-goods",
      "slug": "free-goods",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            9
          ]
        }
      ],
      "prerequisites": [
        "u1-04-scarcity"
      ],
      "related": [
        "u1-09-sustainability",
        "u1-14-opportunity-cost"
      ],
      "terms": [
        "Free goods",
        "免费物品"
      ],
      "synonyms": {
        "zh-CN": [
          "非稀缺物品",
          "无机会成本物品",
          "free resource"
        ],
        "en": [
          "non-scarce good",
          "zero-opportunity-cost good",
          "free resource"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-15-free-goods-flash-1",
        "u1-15-free-goods-mcq-1",
        "u1-15-free-goods-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-15-free-goods",
        "locale": "zh-CN",
        "title": "免费物品",
        "takeaway": "免费物品在特定时间地点相对于需求足够充裕，取得更多不需要牺牲其他产出；价格为零并不足以证明它是免费物品。",
        "definition": "免费物品是数量相对于需求如此充裕，以至于在当前条件下增加使用没有机会成本的物品或资源。",
        "causalChain": [
          "资源在特定条件下非常充裕",
          "额外使用不排挤其他人的可行用途",
          "边际机会成本接近零",
          "无需通过价格配置该边际单位"
        ],
        "realWorldExample": {
          "title": "清洁空气可能从免费物品变得稀缺",
          "sourceUrl": "https://www.who.int/health-topics/air-pollution",
          "observedAt": "2026-09-29",
          "explanation": "世界卫生组织记录空气污染带来的健康风险。空气本身没有市场价格，但当排放损害清洁空气时，额外排放会产生机会成本，清洁空气便不能简单视为免费物品。"
        },
        "misconceptions": [
          "零价格商品可能由税收支付或限量提供，仍然具有机会成本。",
          "一种资源可以在某地是免费物品，在人口密集或受污染地区却变得稀缺。"
        ],
        "examApplication": [
          "先检验边际机会成本，而不是只观察价格。",
          "用地点、时间和环境条件说明分类为何可能变化。"
        ],
        "summary": [
          "免费物品的边际机会成本接近零。",
          "零价格不等于没有资源成本。",
          "免费或经济物品的身份取决于条件。"
        ],
        "explanation": "经济物品之所以需要配置，是因为获得更多会排挤其他用途。免费物品在特定情境中足够充裕，使用一个额外单位不会造成有意义的牺牲。\n\n分类不是物品永恒的属性。清洁空气、开放空间或水在不同地点与时间可能从充裕变为稀缺。政府免费提供的教育或医疗仍使用劳动、建筑和设备，因此不是经济学意义上的免费物品。"
      },
      "en": {
        "id": "u1-15-free-goods",
        "locale": "en",
        "title": "Free goods",
        "takeaway": "A free good is abundant relative to demand in a particular place and time, so obtaining more does not displace another output; a zero price alone is not enough.",
        "definition": "A free good is a good or resource so abundant relative to demand that an additional unit has no opportunity cost under the conditions being considered.",
        "causalChain": [
          "A resource is highly abundant in a specific context",
          "Extra use does not exclude a feasible use by someone else",
          "Marginal opportunity cost is approximately zero",
          "No price mechanism is needed to allocate that marginal unit"
        ],
        "realWorldExample": {
          "title": "Clean air can cease to be a free good",
          "sourceUrl": "https://www.who.int/health-topics/air-pollution",
          "observedAt": "2026-09-29",
          "explanation": "The World Health Organization documents the health burden of air pollution. Air has no ordinary purchase price, yet when emissions reduce air quality, additional pollution imposes opportunity costs and clean air cannot simply be treated as free."
        },
        "misconceptions": [
          "A zero-priced service may be tax-funded or rationed and still carry an opportunity cost.",
          "A resource may be free in one location but scarce in a crowded or polluted setting."
        ],
        "examApplication": [
          "Test marginal opportunity cost rather than looking only at the observed price.",
          "Use location, time, and environmental conditions to explain why the classification can change."
        ],
        "summary": [
          "A free good has approximately zero marginal opportunity cost.",
          "Zero price does not mean zero resource cost.",
          "Whether a good is free or economic depends on context."
        ],
        "explanation": "Economic goods require allocation because obtaining more displaces another use. A free good is sufficiently abundant in a given context that one extra unit involves no meaningful sacrifice.\n\nThe category is not a permanent property of an object. Clean air, open space, or water may move from abundance to scarcity across times and places. Education or health care provided without a user charge still uses labour, buildings, and equipment, so it is not free in the economic sense."
      }
    },
    "practice": [
      {
        "id": "u1-15-free-goods-flash-1",
        "knowledgePointId": "u1-15-free-goods",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“免费物品”。",
          "en": "Without notes, explain “Free goods” in your own words."
        },
        "answer": {
          "zh-CN": "免费物品是数量相对于需求如此充裕，以至于在当前条件下增加使用没有机会成本的物品或资源。",
          "en": "A free good is a good or resource so abundant relative to demand that an additional unit has no opportunity cost under the conditions being considered."
        },
        "explanation": {
          "zh-CN": "免费物品在特定时间地点相对于需求足够充裕，取得更多不需要牺牲其他产出；价格为零并不足以证明它是免费物品。",
          "en": "A free good is abundant relative to demand in a particular place and time, so obtaining more does not displace another output; a zero price alone is not enough."
        }
      },
      {
        "id": "u1-15-free-goods-mcq-1",
        "knowledgePointId": "u1-15-free-goods",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“免费物品”？",
          "en": "Which statement best captures “Free goods”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "零售价为零就一定没有机会成本",
            "en": "A zero price always means no opportunity cost"
          },
          {
            "id": "b",
            "zh-CN": "政府提供的所有服务都是免费物品",
            "en": "Every publicly provided service is a free good"
          },
          {
            "id": "c",
            "zh-CN": "价格很低就属于免费物品",
            "en": "Any low-priced item is a free good"
          },
          {
            "id": "d",
            "zh-CN": "免费物品在特定时间地点相对于需求足够充裕，取得更多不需要牺牲其他产出；价格为零并不足以证明它是免费物品。",
            "en": "A free good is abundant relative to demand in a particular place and time, so obtaining more does not displace another output; a zero price alone is not enough."
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "免费物品是数量相对于需求如此充裕，以至于在当前条件下增加使用没有机会成本的物品或资源。",
          "en": "A free good is a good or resource so abundant relative to demand that an additional unit has no opportunity cost under the conditions being considered."
        }
      },
      {
        "id": "u1-15-free-goods-short-1",
        "knowledgePointId": "u1-15-free-goods",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“免费物品”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Free goods”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "免费物品：免费物品是数量相对于需求如此充裕，以至于在当前条件下增加使用没有机会成本的物品或资源。 资源在特定条件下非常充裕；额外使用不排挤其他人的可行用途；边际机会成本接近零；无需通过价格配置该边际单位 免费物品的边际机会成本接近零。",
          "en": "Free goods: A free good is a good or resource so abundant relative to demand that an additional unit has no opportunity cost under the conditions being considered. A resource is highly abundant in a specific context; Extra use does not exclude a feasible use by someone else; Marginal opportunity cost is approximately zero; No price mechanism is needed to allocate that marginal unit A free good has approximately zero marginal opportunity cost."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "免费物品",
                "非稀缺物品",
                "无机会成本物品",
                "free resource"
              ],
              "en": [
                "Free goods",
                "non-scarce good",
                "zero-opportunity-cost good",
                "free resource"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "资源在特定条件下非常充裕",
                "额外使用不排挤其他人的可行用途"
              ],
              "en": [
                "A resource is highly abundant in a specific context",
                "Extra use does not exclude a feasible use by someone else"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "免费物品的边际机会成本接近零。",
                "零价格不等于没有资源成本。"
              ],
              "en": [
                "A free good has approximately zero marginal opportunity cost.",
                "Zero price does not mean zero resource cost."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-16-basic-economic-questions",
      "slug": "basic-economic-questions",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            10
          ]
        }
      ],
      "prerequisites": [
        "u1-04-scarcity",
        "u1-13-factors-of-production"
      ],
      "related": [
        "u1-17-resource-allocation",
        "u1-18-income-distribution",
        "u1-19-market-mechanism"
      ],
      "terms": [
        "The three basic economic questions",
        "三个基本经济问题"
      ],
      "synonyms": {
        "zh-CN": [
          "生产什么怎样生产为谁生产",
          "基本资源配置问题",
          "what how for whom"
        ],
        "en": [
          "what how for whom",
          "basic allocation questions",
          "fundamental economic questions"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-16-basic-economic-questions-flash-1",
        "u1-16-basic-economic-questions-mcq-1",
        "u1-16-basic-economic-questions-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-16-basic-economic-questions",
        "locale": "zh-CN",
        "title": "三个基本经济问题",
        "takeaway": "所有经济制度都必须决定生产什么及多少、怎样生产、为谁生产；差别在于由谁决定以及使用什么机制。",
        "definition": "三个基本经济问题是：生产哪些商品与服务以及数量多少；用哪些资源、技术和组织方式生产；最终产出由哪些人或群体获得。",
        "causalChain": [
          "稀缺资源有多个竞争用途",
          "社会决定产品组合与数量",
          "生产者选择投入和技术",
          "收入与规则决定产出分配"
        ],
        "realWorldExample": {
          "title": "农业体系同时面对三个问题",
          "sourceUrl": "https://www.worldbank.org/en/topic/agriculture/overview",
          "observedAt": "2026-09-29",
          "explanation": "世界银行的农业工作涉及种植结构、生产技术和粮食可负担性。有限土地用于何种作物、采用何种生产方式以及谁能获得食品，分别对应三个基本问题。"
        },
        "misconceptions": [
          "“为谁生产”不是询问生产者身份，而是询问谁有能力或资格获得产出。",
          "三个问题在富裕经济体中仍然存在，因为资源和目标仍有竞争。"
        ],
        "examApplication": [
          "分析案例时逐一标出 what/how much、how 和 for whom。",
          "比较制度时围绕决策者、信息来源和分配规则展开。"
        ],
        "summary": [
          "产品组合回答生产什么及多少。",
          "投入与技术回答怎样生产。",
          "收入、价格或行政规则回答为谁生产。"
        ],
        "explanation": "稀缺意味着社会不能生产每一种想要的商品，也不能无限生产。因此必须先确定产品组合，再决定如何把土地、劳动、资本和企业家才能组织起来。\n\n生产完成后还存在分配问题。市场经济通常由收入与价格影响获得能力，政府也可能通过公共服务、税收或配给改变结果。三个问题彼此关联：生产方式会影响收入，分配又会影响需求和未来生产。"
      },
      "en": {
        "id": "u1-16-basic-economic-questions",
        "locale": "en",
        "title": "The three basic economic questions",
        "takeaway": "Every economic system must decide what and how much to produce, how to produce it, and for whom; systems differ in who decides and which mechanism they use.",
        "definition": "The three basic economic questions ask which goods and services to produce and in what quantities, which resources and techniques to use, and which people or groups ultimately receive the output.",
        "causalChain": [
          "Scarce resources have competing uses",
          "Society determines the output mix and quantities",
          "Producers select inputs, technology, and organisation",
          "Income and allocation rules determine access to output"
        ],
        "realWorldExample": {
          "title": "Agriculture faces all three questions",
          "sourceUrl": "https://www.worldbank.org/en/topic/agriculture/overview",
          "observedAt": "2026-09-29",
          "explanation": "World Bank agricultural work covers crop choices, production techniques, and food affordability. The use of finite land, the production method, and access to food map directly onto what, how, and for whom."
        },
        "misconceptions": [
          "For whom does not ask who the producer is; it asks who can or may obtain the output.",
          "Affluent economies still face all three questions because resources and objectives continue to compete."
        ],
        "examApplication": [
          "Label what/how much, how, and for whom separately in a case.",
          "Compare systems through their decision-makers, information sources, and distribution rules."
        ],
        "summary": [
          "The output mix answers what and how much.",
          "Inputs and technology answer how.",
          "Income, prices, or administrative rules answer for whom."
        ],
        "explanation": "Scarcity prevents a society from producing every desired good without limit. It must first establish an output mix and then organise land, labour, capital, and entrepreneurship to create it.\n\nDistribution remains after production. Income and prices strongly influence access in a market economy, while public services, taxation, or rationing can alter that outcome. The questions interact because production affects income and distribution shapes future demand."
      }
    },
    "practice": [
      {
        "id": "u1-16-basic-economic-questions-flash-1",
        "knowledgePointId": "u1-16-basic-economic-questions",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“三个基本经济问题”。",
          "en": "Without notes, explain “The three basic economic questions” in your own words."
        },
        "answer": {
          "zh-CN": "三个基本经济问题是：生产哪些商品与服务以及数量多少；用哪些资源、技术和组织方式生产；最终产出由哪些人或群体获得。",
          "en": "The three basic economic questions ask which goods and services to produce and in what quantities, which resources and techniques to use, and which people or groups ultimately receive the output."
        },
        "explanation": {
          "zh-CN": "所有经济制度都必须决定生产什么及多少、怎样生产、为谁生产；差别在于由谁决定以及使用什么机制。",
          "en": "Every economic system must decide what and how much to produce, how to produce it, and for whom; systems differ in who decides and which mechanism they use."
        }
      },
      {
        "id": "u1-16-basic-economic-questions-mcq-1",
        "knowledgePointId": "u1-16-basic-economic-questions",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“三个基本经济问题”？",
          "en": "Which statement best captures “The three basic economic questions”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "所有经济制度都必须决定生产什么及多少、怎样生产、为谁生产；差别在于由谁决定以及使用什么机制。",
            "en": "Every economic system must decide what and how much to produce, how to produce it, and for whom; systems differ in who decides and which mechanism they use."
          },
          {
            "id": "b",
            "zh-CN": "只问生产者利润多大",
            "en": "Only how large producer profit is"
          },
          {
            "id": "c",
            "zh-CN": "只问今年通胀率是多少",
            "en": "Only the current inflation rate"
          },
          {
            "id": "d",
            "zh-CN": "为谁生产就是谁拥有机器",
            "en": "For whom to produce means only who owns machines"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "三个基本经济问题是：生产哪些商品与服务以及数量多少；用哪些资源、技术和组织方式生产；最终产出由哪些人或群体获得。",
          "en": "The three basic economic questions ask which goods and services to produce and in what quantities, which resources and techniques to use, and which people or groups ultimately receive the output."
        }
      },
      {
        "id": "u1-16-basic-economic-questions-short-1",
        "knowledgePointId": "u1-16-basic-economic-questions",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“三个基本经济问题”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “The three basic economic questions”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "三个基本经济问题：三个基本经济问题是：生产哪些商品与服务以及数量多少；用哪些资源、技术和组织方式生产；最终产出由哪些人或群体获得。 稀缺资源有多个竞争用途；社会决定产品组合与数量；生产者选择投入和技术；收入与规则决定产出分配 产品组合回答生产什么及多少。",
          "en": "The three basic economic questions: The three basic economic questions ask which goods and services to produce and in what quantities, which resources and techniques to use, and which people or groups ultimately receive the output. Scarce resources have competing uses; Society determines the output mix and quantities; Producers select inputs, technology, and organisation; Income and allocation rules determine access to output The output mix answers what and how much."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "三个基本经济问题",
                "生产什么怎样生产为谁生产",
                "基本资源配置问题",
                "what how for whom"
              ],
              "en": [
                "The three basic economic questions",
                "what how for whom",
                "basic allocation questions",
                "fundamental economic questions"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "稀缺资源有多个竞争用途",
                "社会决定产品组合与数量"
              ],
              "en": [
                "Scarce resources have competing uses",
                "Society determines the output mix and quantities"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "产品组合回答生产什么及多少。",
                "投入与技术回答怎样生产。"
              ],
              "en": [
                "The output mix answers what and how much.",
                "Inputs and technology answer how."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-17-resource-allocation",
      "slug": "resource-allocation",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            10,
            11
          ]
        }
      ],
      "prerequisites": [
        "u1-16-basic-economic-questions"
      ],
      "related": [
        "u1-19-market-mechanism",
        "u1-20-government-intervention"
      ],
      "terms": [
        "Resource allocation and reallocation",
        "资源配置与重新配置"
      ],
      "synonyms": {
        "zh-CN": [
          "资源分配",
          "重新分配生产要素",
          "过度配置不足配置"
        ],
        "en": [
          "resource distribution",
          "factor reallocation",
          "overallocation underallocation"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-17-resource-allocation-flash-1",
        "u1-17-resource-allocation-mcq-1",
        "u1-17-resource-allocation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-17-resource-allocation",
        "locale": "zh-CN",
        "title": "资源配置与重新配置",
        "takeaway": "资源配置决定生产要素流向何处；价格、政策或偏好变化会触发重新配置，并可纠正过度或不足配置。",
        "definition": "资源配置是把生产要素分配到不同用途的过程；重新配置是改变既有用途，过度配置和不足配置分别表示相对于社会最优水平投入过多或过少。",
        "causalChain": [
          "不同用途争夺稀缺要素",
          "价格、收益与政策传递相对价值",
          "资源流向预期回报较高的用途",
          "外部成本或收益可能造成过度或不足配置"
        ],
        "realWorldExample": {
          "title": "碳定价推动资源重新配置",
          "sourceUrl": "https://carbonpricingdashboard.worldbank.org/",
          "observedAt": "2026-09-29",
          "explanation": "世界银行碳定价仪表板记录碳税和排放交易制度。排放成本进入决策后，高碳生产相对回报下降，资本和创新可能转向低碳用途。"
        },
        "misconceptions": [
          "重新配置不是凭空创造资源，而是改变同一资源的用途。",
          "市场投入多并不自动表示社会配置最优，未计价外部成本会造成过度配置。"
        ],
        "examApplication": [
          "明确资源从哪个用途转向哪个用途。",
          "用社会边际成本与收益解释过度或不足配置，而非只用产量大小。"
        ],
        "summary": [
          "配置决定生产要素的用途。",
          "激励变化会推动重新配置。",
          "市场价格遗漏外部影响时可能偏离社会最优。"
        ],
        "explanation": "资源配置把土地、劳动、资本和企业家才能安排到不同生产活动。市场价格和利润、政府预算与法规、家庭偏好都会影响流向。\n\n判断配置是否过度或不足，需要一个社会基准。若生产带来的第三方成本没有进入价格，某活动可能吸引过多资源；若教育等活动产生未获得补偿的外部收益，市场投入可能不足。"
      },
      "en": {
        "id": "u1-17-resource-allocation",
        "locale": "en",
        "title": "Resource allocation and reallocation",
        "takeaway": "Allocation directs factors of production; changes in prices, policy, or preferences cause reallocation and may address over- or underallocation.",
        "definition": "Resource allocation is the assignment of productive factors to different uses. Reallocation changes those uses, while overallocation and underallocation mean that too many or too few resources are devoted to an activity relative to the social optimum.",
        "causalChain": [
          "Alternative uses compete for scarce factors",
          "Prices, returns, and policy signal relative value",
          "Resources move toward uses with higher expected returns",
          "External costs or benefits can create over- or underallocation"
        ],
        "realWorldExample": {
          "title": "Carbon pricing encourages reallocation",
          "sourceUrl": "https://carbonpricingdashboard.worldbank.org/",
          "observedAt": "2026-09-29",
          "explanation": "The World Bank Carbon Pricing Dashboard records carbon taxes and emissions trading systems. Once emissions carry a cost, high-carbon activity becomes less attractive and capital or innovation may shift toward lower-carbon uses."
        },
        "misconceptions": [
          "Reallocation does not create resources; it changes how the same resources are used.",
          "A large market allocation is not necessarily socially optimal when prices omit external costs."
        ],
        "examApplication": [
          "State both the use resources leave and the use they enter.",
          "Explain over- or underallocation through social marginal costs and benefits, not output size alone."
        ],
        "summary": [
          "Allocation determines the uses of productive factors.",
          "Changing incentives cause reallocation.",
          "Omitted external effects can separate market and social outcomes."
        ],
        "explanation": "Resource allocation places land, labour, capital, and entrepreneurship in different productive activities. Market prices and profit, government budgets and rules, and household preferences can all direct those flows.\n\nOver- or underallocation requires a social benchmark. An activity may attract excessive resources if third-party costs are absent from its price. Education and similar activities may receive too little market investment when some benefits accrue beyond the buyer."
      }
    },
    "practice": [
      {
        "id": "u1-17-resource-allocation-flash-1",
        "knowledgePointId": "u1-17-resource-allocation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“资源配置与重新配置”。",
          "en": "Without notes, explain “Resource allocation and reallocation” in your own words."
        },
        "answer": {
          "zh-CN": "资源配置是把生产要素分配到不同用途的过程；重新配置是改变既有用途，过度配置和不足配置分别表示相对于社会最优水平投入过多或过少。",
          "en": "Resource allocation is the assignment of productive factors to different uses. Reallocation changes those uses, while overallocation and underallocation mean that too many or too few resources are devoted to an activity relative to the social optimum."
        },
        "explanation": {
          "zh-CN": "资源配置决定生产要素流向何处；价格、政策或偏好变化会触发重新配置，并可纠正过度或不足配置。",
          "en": "Allocation directs factors of production; changes in prices, policy, or preferences cause reallocation and may address over- or underallocation."
        }
      },
      {
        "id": "u1-17-resource-allocation-mcq-1",
        "knowledgePointId": "u1-17-resource-allocation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“资源配置与重新配置”？",
          "en": "Which statement best captures “Resource allocation and reallocation”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "资源配置只指收入均分",
            "en": "Allocation means only equalising incomes"
          },
          {
            "id": "b",
            "zh-CN": "资源配置决定生产要素流向何处；价格、政策或偏好变化会触发重新配置，并可纠正过度或不足配置。",
            "en": "Allocation directs factors of production; changes in prices, policy, or preferences cause reallocation and may address over- or underallocation."
          },
          {
            "id": "c",
            "zh-CN": "社会最优与任何市场均衡完全相同",
            "en": "The social optimum equals every market equilibrium"
          },
          {
            "id": "d",
            "zh-CN": "重新配置只需增加所有投入而不调整用途",
            "en": "Reallocation only adds inputs without changing uses"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "资源配置是把生产要素分配到不同用途的过程；重新配置是改变既有用途，过度配置和不足配置分别表示相对于社会最优水平投入过多或过少。",
          "en": "Resource allocation is the assignment of productive factors to different uses. Reallocation changes those uses, while overallocation and underallocation mean that too many or too few resources are devoted to an activity relative to the social optimum."
        }
      },
      {
        "id": "u1-17-resource-allocation-short-1",
        "knowledgePointId": "u1-17-resource-allocation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“资源配置与重新配置”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Resource allocation and reallocation”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "资源配置与重新配置：资源配置是把生产要素分配到不同用途的过程；重新配置是改变既有用途，过度配置和不足配置分别表示相对于社会最优水平投入过多或过少。 不同用途争夺稀缺要素；价格、收益与政策传递相对价值；资源流向预期回报较高的用途；外部成本或收益可能造成过度或不足配置 配置决定生产要素的用途。",
          "en": "Resource allocation and reallocation: Resource allocation is the assignment of productive factors to different uses. Reallocation changes those uses, while overallocation and underallocation mean that too many or too few resources are devoted to an activity relative to the social optimum. Alternative uses compete for scarce factors; Prices, returns, and policy signal relative value; Resources move toward uses with higher expected returns; External costs or benefits can create over- or underallocation Allocation determines the uses of productive factors."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "资源配置与重新配置",
                "资源分配",
                "重新分配生产要素",
                "过度配置不足配置"
              ],
              "en": [
                "Resource allocation and reallocation",
                "resource distribution",
                "factor reallocation",
                "overallocation underallocation"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "不同用途争夺稀缺要素",
                "价格、收益与政策传递相对价值"
              ],
              "en": [
                "Alternative uses compete for scarce factors",
                "Prices, returns, and policy signal relative value"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "配置决定生产要素的用途。",
                "激励变化会推动重新配置。"
              ],
              "en": [
                "Allocation determines the uses of productive factors.",
                "Changing incentives cause reallocation."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-18-income-distribution",
      "slug": "income-distribution",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            10,
            11
          ]
        }
      ],
      "prerequisites": [
        "u1-16-basic-economic-questions"
      ],
      "related": [
        "u1-07-equity",
        "u1-35-equality-equity"
      ],
      "terms": [
        "Income and output distribution",
        "收入与产出分配"
      ],
      "synonyms": {
        "zh-CN": [
          "收入分配",
          "产出分配",
          "收入再分配"
        ],
        "en": [
          "income distribution",
          "distribution of output",
          "redistribution"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-18-income-distribution-flash-1",
        "u1-18-income-distribution-mcq-1",
        "u1-18-income-distribution-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-18-income-distribution",
        "locale": "zh-CN",
        "title": "收入与产出分配",
        "takeaway": "收入分配决定不同群体购买产出的能力；再分配通过税收、转移支付和公共服务改变市场形成的结果。",
        "definition": "收入与产出分配描述国民收入和商品服务在个人、家庭或生产要素之间的分布；再分配是政策对初次分配结果的有意改变。",
        "causalChain": [
          "生产要素所有权与市场回报形成初次收入",
          "收入决定大部分市场购买力",
          "税收、现金转移和公共服务介入",
          "可支配收入与实际获得的产出重新分布"
        ],
        "realWorldExample": {
          "title": "税收和转移支付改变可支配收入",
          "sourceUrl": "https://www.oecd.org/en/topics/inequality-and-poverty.html",
          "observedAt": "2026-09-29",
          "explanation": "OECD 的不平等与贫困资料会比较税前收入和税后转移后的可支配收入，显示同一生产结果可通过财政制度产生不同家庭分配。"
        },
        "misconceptions": [
          "产出增长不保证分配更均等，也不保证所有人的实际收入上升。",
          "再分配不仅是现金转移，免费或补贴的公共服务也改变实际获得。"
        ],
        "examApplication": [
          "区分初次收入、可支配收入和实物公共服务。",
          "评价再分配时考虑公平目标、激励影响、行政成本和针对性。"
        ],
        "summary": [
          "要素回报影响初次收入分配。",
          "购买力影响市场产出的获得。",
          "税收、转移和公共服务可实现再分配。"
        ],
        "explanation": "市场收入来自工资、租金、利息和利润，并受生产要素所有权、技能和议价能力影响。收入又决定个人能在市场中表达多少需求，因此与“为谁生产”直接相关。\n\n政府可用累进税、社会保障和公共教育医疗改变结果。评价时既要观察贫困和不平等是否下降，也要考虑融资、工作激励、覆盖遗漏和服务质量。"
      },
      "en": {
        "id": "u1-18-income-distribution",
        "locale": "en",
        "title": "Income and output distribution",
        "takeaway": "Income distribution shapes each group's ability to obtain output; redistribution changes the market outcome through taxes, transfers, and public services.",
        "definition": "Income and output distribution describes how national income and goods or services are divided among people, households, or factors of production. Redistribution is a deliberate policy-induced change to the initial distribution.",
        "causalChain": [
          "Factor ownership and market returns generate original income",
          "Income determines most market purchasing power",
          "Taxes, cash transfers, and public services intervene",
          "Disposable income and effective access to output are redistributed"
        ],
        "realWorldExample": {
          "title": "Taxes and transfers change disposable income",
          "sourceUrl": "https://www.oecd.org/en/topics/inequality-and-poverty.html",
          "observedAt": "2026-09-29",
          "explanation": "OECD inequality and poverty material compares income before and after taxes and transfers, showing how the same production outcome can yield different household distributions under different fiscal systems."
        },
        "misconceptions": [
          "Growth in total output does not guarantee a more equal distribution or a rise in every person's real income.",
          "Redistribution is not confined to cash; free or subsidised public services alter effective access too."
        ],
        "examApplication": [
          "Distinguish original income, disposable income, and public services received in kind.",
          "Evaluate redistribution through equity objectives, incentives, administration, and targeting."
        ],
        "summary": [
          "Factor returns shape original income.",
          "Purchasing power affects access to market output.",
          "Taxation, transfers, and services can redistribute."
        ],
        "explanation": "Market income arises as wages, rent, interest, and profit and reflects factor ownership, skills, and bargaining power. Income then determines how strongly a person can express demand in markets, linking distribution directly to the question of for whom output is produced.\n\nProgressive taxes, social protection, public education, and health provision can alter the result. Evaluation considers whether poverty or inequality falls alongside financing, work incentives, gaps in coverage, and service quality."
      }
    },
    "practice": [
      {
        "id": "u1-18-income-distribution-flash-1",
        "knowledgePointId": "u1-18-income-distribution",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“收入与产出分配”。",
          "en": "Without notes, explain “Income and output distribution” in your own words."
        },
        "answer": {
          "zh-CN": "收入与产出分配描述国民收入和商品服务在个人、家庭或生产要素之间的分布；再分配是政策对初次分配结果的有意改变。",
          "en": "Income and output distribution describes how national income and goods or services are divided among people, households, or factors of production. Redistribution is a deliberate policy-induced change to the initial distribution."
        },
        "explanation": {
          "zh-CN": "收入分配决定不同群体购买产出的能力；再分配通过税收、转移支付和公共服务改变市场形成的结果。",
          "en": "Income distribution shapes each group's ability to obtain output; redistribution changes the market outcome through taxes, transfers, and public services."
        }
      },
      {
        "id": "u1-18-income-distribution-mcq-1",
        "knowledgePointId": "u1-18-income-distribution",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“收入与产出分配”？",
          "en": "Which statement best captures “Income and output distribution”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "收入分配就是把产出平均分给企业",
            "en": "Distribution means dividing output equally among firms"
          },
          {
            "id": "b",
            "zh-CN": "再分配只能通过现金且不能通过服务",
            "en": "Redistribution can only use cash, never services"
          },
          {
            "id": "c",
            "zh-CN": "收入分配决定不同群体购买产出的能力；再分配通过税收、转移支付和公共服务改变市场形成的结果。",
            "en": "Income distribution shapes each group's ability to obtain output; redistribution changes the market outcome through taxes, transfers, and public services."
          },
          {
            "id": "d",
            "zh-CN": "高总收入自动保证低不平等",
            "en": "High total income guarantees low inequality"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "收入与产出分配描述国民收入和商品服务在个人、家庭或生产要素之间的分布；再分配是政策对初次分配结果的有意改变。",
          "en": "Income and output distribution describes how national income and goods or services are divided among people, households, or factors of production. Redistribution is a deliberate policy-induced change to the initial distribution."
        }
      },
      {
        "id": "u1-18-income-distribution-short-1",
        "knowledgePointId": "u1-18-income-distribution",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“收入与产出分配”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Income and output distribution”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "收入与产出分配：收入与产出分配描述国民收入和商品服务在个人、家庭或生产要素之间的分布；再分配是政策对初次分配结果的有意改变。 生产要素所有权与市场回报形成初次收入；收入决定大部分市场购买力；税收、现金转移和公共服务介入；可支配收入与实际获得的产出重新分布 要素回报影响初次收入分配。",
          "en": "Income and output distribution: Income and output distribution describes how national income and goods or services are divided among people, households, or factors of production. Redistribution is a deliberate policy-induced change to the initial distribution. Factor ownership and market returns generate original income; Income determines most market purchasing power; Taxes, cash transfers, and public services intervene; Disposable income and effective access to output are redistributed Factor returns shape original income."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "收入与产出分配",
                "收入分配",
                "产出分配",
                "收入再分配"
              ],
              "en": [
                "Income and output distribution",
                "income distribution",
                "distribution of output",
                "redistribution"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "生产要素所有权与市场回报形成初次收入",
                "收入决定大部分市场购买力"
              ],
              "en": [
                "Factor ownership and market returns generate original income",
                "Income determines most market purchasing power"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "要素回报影响初次收入分配。",
                "购买力影响市场产出的获得。"
              ],
              "en": [
                "Factor returns shape original income.",
                "Purchasing power affects access to market output."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-19-market-mechanism",
      "slug": "market-mechanism",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            12
          ]
        }
      ],
      "prerequisites": [
        "u1-02-microeconomics",
        "u1-16-basic-economic-questions"
      ],
      "related": [
        "u1-17-resource-allocation",
        "u1-21-free-market-economy"
      ],
      "terms": [
        "The market mechanism",
        "市场机制"
      ],
      "synonyms": {
        "zh-CN": [
          "价格机制",
          "供需机制",
          "市场配置"
        ],
        "en": [
          "price mechanism",
          "supply-demand mechanism",
          "market allocation"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-19-market-mechanism-flash-1",
        "u1-19-market-mechanism-mcq-1",
        "u1-19-market-mechanism-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-19-market-mechanism",
        "locale": "zh-CN",
        "title": "市场机制",
        "takeaway": "市场机制用价格变化协调分散的供需决定，并把资源引向愿付价格较高和预期利润较高的用途。",
        "definition": "市场机制是供给与需求的相互作用通过价格信号、激励和配给作用协调买卖决策并配置资源的过程。",
        "causalChain": [
          "买方需求与卖方供给不一致",
          "短缺或剩余推动价格变化",
          "价格改变消费者和生产者激励",
          "数量和资源配置向新的市场结果调整"
        ],
        "realWorldExample": {
          "title": "粮食价格传递稀缺信息",
          "sourceUrl": "https://www.fao.org/worldfoodsituation/foodpricesindex/en/",
          "observedAt": "2026-09-29",
          "explanation": "联合国粮农组织食品价格指数汇总国际食品价格变化。供给冲击提高价格时，信号会影响消费者替代、库存决策和生产者未来种植。"
        },
        "misconceptions": [
          "市场价格反映有效需求，而不等同于社会需要。",
          "价格能协调信息，但若存在市场势力、外部性或信息不对称，结果可能不高效。"
        ],
        "examApplication": [
          "用信号、激励和配给三个功能解释价格作用。",
          "从供需变化追踪到价格、数量和资源移动。"
        ],
        "summary": [
          "价格汇集供需信息。",
          "价格改变买卖双方的激励。",
          "支付能力决定市场配给，不一定符合公平或社会最优。"
        ],
        "explanation": "市场中没有单一主体掌握全部信息。价格把许多买方的愿付和许多卖方的成本压缩成信号。价格上升会鼓励部分生产者增加供给，也会使部分消费者减少需求或寻找替代品。\n\n这种协调具有条件。只有当价格较好地反映私人和社会成本收益、竞争存在且信息充分时，市场结果才更可能有效。收入差异也意味着需求强度部分反映支付能力。"
      },
      "en": {
        "id": "u1-19-market-mechanism",
        "locale": "en",
        "title": "The market mechanism",
        "takeaway": "The market mechanism uses changing prices to coordinate decentralised supply and demand and to draw resources toward higher willingness to pay and expected profit.",
        "definition": "The market mechanism is the process through which supply and demand interact so that price signals, incentives, and rationing coordinate buying and selling decisions and allocate resources.",
        "causalChain": [
          "Desired purchases and sales do not initially match",
          "Shortage or surplus puts pressure on price",
          "Price changes consumer and producer incentives",
          "Quantities and resources adjust toward a new market outcome"
        ],
        "realWorldExample": {
          "title": "Food prices communicate scarcity",
          "sourceUrl": "https://www.fao.org/worldfoodsituation/foodpricesindex/en/",
          "observedAt": "2026-09-29",
          "explanation": "The UN Food and Agriculture Organization Food Price Index summarises international food price movements. When a supply shock raises prices, the signal affects consumer substitution, stockholding, and future planting decisions."
        },
        "misconceptions": [
          "A market price reflects effective demand, not the same thing as social need.",
          "Price can coordinate information without guaranteeing efficiency where market power, externalities, or asymmetric information exist."
        ],
        "examApplication": [
          "Explain the signalling, incentive, and rationing functions of price.",
          "Trace a supply or demand change through price and quantity to the movement of resources."
        ],
        "summary": [
          "Price aggregates information about supply and demand.",
          "Price changes incentives on both sides of a market.",
          "Rationing by purchasing power need not be equitable or socially optimal."
        ],
        "explanation": "No single participant in a market holds all relevant information. Price condenses the willingness to pay of many buyers and the costs of many sellers. A higher price encourages some producers to expand and causes some consumers to reduce demand or find substitutes.\n\nThat coordination is conditional. A market is more likely to perform well when prices reflect private and social costs and benefits, competition is meaningful, and information is available. Income inequality also means that measured demand partly reflects ability to pay."
      }
    },
    "practice": [
      {
        "id": "u1-19-market-mechanism-flash-1",
        "knowledgePointId": "u1-19-market-mechanism",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“市场机制”。",
          "en": "Without notes, explain “The market mechanism” in your own words."
        },
        "answer": {
          "zh-CN": "市场机制是供给与需求的相互作用通过价格信号、激励和配给作用协调买卖决策并配置资源的过程。",
          "en": "The market mechanism is the process through which supply and demand interact so that price signals, incentives, and rationing coordinate buying and selling decisions and allocate resources."
        },
        "explanation": {
          "zh-CN": "市场机制用价格变化协调分散的供需决定，并把资源引向愿付价格较高和预期利润较高的用途。",
          "en": "The market mechanism uses changing prices to coordinate decentralised supply and demand and to draw resources toward higher willingness to pay and expected profit."
        }
      },
      {
        "id": "u1-19-market-mechanism-mcq-1",
        "knowledgePointId": "u1-19-market-mechanism",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“市场机制”？",
          "en": "Which statement best captures “The market mechanism”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "价格只传递信息却从不影响激励",
            "en": "Prices convey information but never affect incentives"
          },
          {
            "id": "b",
            "zh-CN": "价格机制总保证按需要平均配给",
            "en": "Prices always ration equally by need"
          },
          {
            "id": "c",
            "zh-CN": "市场机制要求政府逐笔指定所有买卖",
            "en": "Markets require government to specify every trade"
          },
          {
            "id": "d",
            "zh-CN": "市场机制用价格变化协调分散的供需决定，并把资源引向愿付价格较高和预期利润较高的用途。",
            "en": "The market mechanism uses changing prices to coordinate decentralised supply and demand and to draw resources toward higher willingness to pay and expected profit."
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "市场机制是供给与需求的相互作用通过价格信号、激励和配给作用协调买卖决策并配置资源的过程。",
          "en": "The market mechanism is the process through which supply and demand interact so that price signals, incentives, and rationing coordinate buying and selling decisions and allocate resources."
        }
      },
      {
        "id": "u1-19-market-mechanism-short-1",
        "knowledgePointId": "u1-19-market-mechanism",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“市场机制”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “The market mechanism”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "市场机制：市场机制是供给与需求的相互作用通过价格信号、激励和配给作用协调买卖决策并配置资源的过程。 买方需求与卖方供给不一致；短缺或剩余推动价格变化；价格改变消费者和生产者激励；数量和资源配置向新的市场结果调整 价格汇集供需信息。",
          "en": "The market mechanism: The market mechanism is the process through which supply and demand interact so that price signals, incentives, and rationing coordinate buying and selling decisions and allocate resources. Desired purchases and sales do not initially match; Shortage or surplus puts pressure on price; Price changes consumer and producer incentives; Quantities and resources adjust toward a new market outcome Price aggregates information about supply and demand."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "市场机制",
                "价格机制",
                "供需机制",
                "市场配置"
              ],
              "en": [
                "The market mechanism",
                "price mechanism",
                "supply-demand mechanism",
                "market allocation"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "买方需求与卖方供给不一致",
                "短缺或剩余推动价格变化"
              ],
              "en": [
                "Desired purchases and sales do not initially match",
                "Shortage or surplus puts pressure on price"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "价格汇集供需信息。",
                "价格改变买卖双方的激励。"
              ],
              "en": [
                "Price aggregates information about supply and demand.",
                "Price changes incentives on both sides of a market."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-20-government-intervention",
      "slug": "government-intervention",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            12
          ]
        }
      ],
      "prerequisites": [
        "u1-12-intervention",
        "u1-19-market-mechanism"
      ],
      "related": [
        "u1-17-resource-allocation",
        "u1-23-mixed-economy"
      ],
      "terms": [
        "Government intervention",
        "政府干预"
      ],
      "synonyms": {
        "zh-CN": [
          "公共政策介入",
          "政府调控",
          "government action"
        ],
        "en": [
          "public policy action",
          "government regulation",
          "state intervention"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-20-government-intervention-flash-1",
        "u1-20-government-intervention-mcq-1",
        "u1-20-government-intervention-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-20-government-intervention",
        "locale": "zh-CN",
        "title": "政府干预",
        "takeaway": "政府干预试图纠正市场失灵、改善公平或稳定经济，但是否成功取决于工具设计、信息和执行。",
        "definition": "政府干预是公共部门通过税收、补贴、监管、价格管制、公共供给、信息或宏观政策改变经济行为和结果。",
        "causalChain": [
          "市场结果偏离政策目标",
          "政府选择与问题相匹配的工具",
          "工具改变价格、权利或可获得资源",
          "行为反应决定净社会结果"
        ],
        "realWorldExample": {
          "title": "烟草税改变消费成本",
          "sourceUrl": "https://www.who.int/initiatives/health-taxes/tobacco",
          "observedAt": "2026-09-29",
          "explanation": "世界卫生组织把烟草税列为减少烟草使用的政策工具。税收提高消费者面对的价格，并为健康政策融资，但实际效果取决于需求反应、执法和非法市场。"
        },
        "misconceptions": [
          "存在市场失灵并不能自动证明任何干预都能改善结果。",
          "干预成本包括行政、合规和非预期行为，不只包括财政支出。"
        ],
        "examApplication": [
          "先诊断具体市场失灵或公平目标，再选择政策。",
          "评价时比较政策收益、政府失灵风险和替代工具。"
        ],
        "summary": [
          "干预可以改变价格、规则和公共供给。",
          "工具必须对应问题的成因。",
          "政府也面临信息与激励约束。"
        ],
        "explanation": "市场可能遗漏外部影响、提供不足的公共品、形成市场势力或产生不公平结果。政府可以改变私人决策面对的成本收益，或直接提供服务。\n\n高质量评价不能只写政策优点。政府可能缺乏信息、受到利益集团影响或执行能力有限。应把预期改善与行政成本、逃避行为、机会成本和替代政策比较。"
      },
      "en": {
        "id": "u1-20-government-intervention",
        "locale": "en",
        "title": "Government intervention",
        "takeaway": "Government intervention seeks to correct market failure, improve equity, or stabilise the economy, but success depends on design, information, and implementation.",
        "definition": "Government intervention is public-sector action through taxes, subsidies, regulation, price controls, public provision, information, or macroeconomic policy to alter economic behaviour and outcomes.",
        "causalChain": [
          "A market outcome diverges from a policy objective",
          "Government selects an instrument suited to the cause",
          "The instrument changes prices, rights, or available resources",
          "Behavioural responses determine the net social result"
        ],
        "realWorldExample": {
          "title": "Tobacco taxation changes the cost of consumption",
          "sourceUrl": "https://www.who.int/initiatives/health-taxes/tobacco",
          "observedAt": "2026-09-29",
          "explanation": "The World Health Organization presents tobacco tax as a tool to reduce tobacco use. It raises the price faced by consumers and can finance health priorities, while its effect depends on demand response, enforcement, and illicit markets."
        },
        "misconceptions": [
          "The existence of market failure does not prove that any intervention will improve the outcome.",
          "Intervention costs include administration, compliance, and unintended behaviour, not only budget spending."
        ],
        "examApplication": [
          "Diagnose the specific market failure or equity objective before selecting a policy.",
          "Compare policy benefits, risks of government failure, and alternative instruments."
        ],
        "summary": [
          "Intervention can change prices, rules, and public provision.",
          "An instrument should match the source of the problem.",
          "Government faces information and incentive constraints too."
        ],
        "explanation": "Markets can omit external effects, underprovide public goods, permit market power, or generate outcomes judged unfair. Government can change the costs and benefits facing private decisions or provide a service directly.\n\nStrong evaluation does not list advantages alone. Public authorities may lack information, face lobbying, or have limited enforcement capacity. Expected gains should be set against administration, avoidance, opportunity cost, and plausible alternative policies."
      }
    },
    "practice": [
      {
        "id": "u1-20-government-intervention-flash-1",
        "knowledgePointId": "u1-20-government-intervention",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“政府干预”。",
          "en": "Without notes, explain “Government intervention” in your own words."
        },
        "answer": {
          "zh-CN": "政府干预是公共部门通过税收、补贴、监管、价格管制、公共供给、信息或宏观政策改变经济行为和结果。",
          "en": "Government intervention is public-sector action through taxes, subsidies, regulation, price controls, public provision, information, or macroeconomic policy to alter economic behaviour and outcomes."
        },
        "explanation": {
          "zh-CN": "政府干预试图纠正市场失灵、改善公平或稳定经济，但是否成功取决于工具设计、信息和执行。",
          "en": "Government intervention seeks to correct market failure, improve equity, or stabilise the economy, but success depends on design, information, and implementation."
        }
      },
      {
        "id": "u1-20-government-intervention-mcq-1",
        "knowledgePointId": "u1-20-government-intervention",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“政府干预”？",
          "en": "Which statement best captures “Government intervention”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "政府干预试图纠正市场失灵、改善公平或稳定经济，但是否成功取决于工具设计、信息和执行。",
            "en": "Government intervention seeks to correct market failure, improve equity, or stabilise the economy, but success depends on design, information, and implementation."
          },
          {
            "id": "b",
            "zh-CN": "政府干预不存在机会成本",
            "en": "Government action has no opportunity cost"
          },
          {
            "id": "c",
            "zh-CN": "只要政府支出就一定有效率",
            "en": "Any public spending is efficient"
          },
          {
            "id": "d",
            "zh-CN": "补贴不能影响资源配置",
            "en": "Subsidies cannot affect allocation"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "政府干预是公共部门通过税收、补贴、监管、价格管制、公共供给、信息或宏观政策改变经济行为和结果。",
          "en": "Government intervention is public-sector action through taxes, subsidies, regulation, price controls, public provision, information, or macroeconomic policy to alter economic behaviour and outcomes."
        }
      },
      {
        "id": "u1-20-government-intervention-short-1",
        "knowledgePointId": "u1-20-government-intervention",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“政府干预”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Government intervention”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "政府干预：政府干预是公共部门通过税收、补贴、监管、价格管制、公共供给、信息或宏观政策改变经济行为和结果。 市场结果偏离政策目标；政府选择与问题相匹配的工具；工具改变价格、权利或可获得资源；行为反应决定净社会结果 干预可以改变价格、规则和公共供给。",
          "en": "Government intervention: Government intervention is public-sector action through taxes, subsidies, regulation, price controls, public provision, information, or macroeconomic policy to alter economic behaviour and outcomes. A market outcome diverges from a policy objective; Government selects an instrument suited to the cause; The instrument changes prices, rights, or available resources; Behavioural responses determine the net social result Intervention can change prices, rules, and public provision."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "政府干预",
                "公共政策介入",
                "政府调控",
                "government action"
              ],
              "en": [
                "Government intervention",
                "public policy action",
                "government regulation",
                "state intervention"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "市场结果偏离政策目标",
                "政府选择与问题相匹配的工具"
              ],
              "en": [
                "A market outcome diverges from a policy objective",
                "Government selects an instrument suited to the cause"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "干预可以改变价格、规则和公共供给。",
                "工具必须对应问题的成因。"
              ],
              "en": [
                "Intervention can change prices, rules, and public provision.",
                "An instrument should match the source of the problem."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-21-free-market-economy",
      "slug": "free-market-economy",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            13
          ]
        }
      ],
      "prerequisites": [
        "u1-19-market-mechanism"
      ],
      "related": [
        "u1-22-planned-economy",
        "u1-23-mixed-economy"
      ],
      "terms": [
        "The free-market economy",
        "自由市场经济"
      ],
      "synonyms": {
        "zh-CN": [
          "市场经济",
          "资本主义市场制度",
          "laissez-faire economy"
        ],
        "en": [
          "market economy",
          "capitalist market system",
          "laissez-faire economy"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-21-free-market-economy-flash-1",
        "u1-21-free-market-economy-mcq-1",
        "u1-21-free-market-economy-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-21-free-market-economy",
        "locale": "zh-CN",
        "title": "自由市场经济",
        "takeaway": "自由市场经济主要通过私有产权、价格和利润来协调生产与分配，强调分散选择而非中央指令。",
        "definition": "自由市场经济是一种资源主要由私人主体拥有，生产与消费决策主要通过竞争市场和价格机制协调，政府作用相对有限的制度。",
        "causalChain": [
          "私人产权赋予使用和收益权",
          "消费者支出表达有效需求",
          "利润与亏损引导企业进入或退出",
          "价格协调资源和产出"
        ],
        "realWorldExample": {
          "title": "竞争环境影响私人投资",
          "sourceUrl": "https://www.worldbank.org/en/topic/competitiveness",
          "observedAt": "2026-09-29",
          "explanation": "世界银行关于竞争力的资料关注市场进入、基础设施和制度如何影响企业投资。自由市场的资源流动仍依赖产权、合同和竞争规则。"
        },
        "misconceptions": [
          "自由市场并不等于没有法律；产权和合同需要制度执行。",
          "现实经济体很少符合完全自由市场的极端模型。"
        ],
        "examApplication": [
          "优势可从信息、激励和选择解释，局限可从市场失灵与分配解释。",
          "把制度作为模型使用，不要把某个国家简单贴成纯自由市场标签。"
        ],
        "summary": [
          "私人产权和价格是主要协调机制。",
          "利润提供生产激励。",
          "市场失灵和不平等构成重要局限。"
        ],
        "explanation": "自由市场模型把决策分散给消费者和生产者。愿付价格影响生产什么，企业根据成本和利润选择怎样生产，收入与价格影响谁获得产出。\n\n分散信息和竞争可促进适应与创新，但市场不会自动计入外部性、提供所有公共品或保证公平。即使政府规模较小，司法、货币和竞争框架也不可或缺。"
      },
      "en": {
        "id": "u1-21-free-market-economy",
        "locale": "en",
        "title": "The free-market economy",
        "takeaway": "A free-market economy coordinates production and distribution mainly through private property, prices, and profit rather than central commands.",
        "definition": "A free-market economy is a system in which resources are predominantly privately owned and production and consumption are coordinated mainly through competitive markets and the price mechanism, with a comparatively limited state role.",
        "causalChain": [
          "Private property grants rights to use assets and receive returns",
          "Consumer spending expresses effective demand",
          "Profit and loss encourage entry or exit",
          "Prices coordinate resources and output"
        ],
        "realWorldExample": {
          "title": "The competitive environment shapes private investment",
          "sourceUrl": "https://www.worldbank.org/en/topic/competitiveness",
          "observedAt": "2026-09-29",
          "explanation": "World Bank material on competitiveness considers how entry conditions, infrastructure, and institutions influence business investment. Market allocation still relies on property, contract, and competition rules."
        },
        "misconceptions": [
          "A free market does not mean an absence of law; property and contracts require enforcement.",
          "Very few actual economies match the extreme model of a completely free market."
        ],
        "examApplication": [
          "Explain advantages through information, incentives, and choice, and limitations through market failure and distribution.",
          "Use the system as a model rather than labelling a country a pure free market."
        ],
        "summary": [
          "Private property and prices are primary coordinating institutions.",
          "Profit creates an incentive for production and adaptation.",
          "Market failure and inequality are important limitations."
        ],
        "explanation": "The free-market model decentralises decisions to consumers and producers. Willingness to pay influences what is produced, firms use cost and profit to select methods, and income together with price affects who obtains output.\n\nDecentralised information and competition may support adaptation and innovation, but markets do not automatically price externalities, supply every public good, or secure fairness. Courts, money, and a competition framework remain essential even with a small state."
      }
    },
    "practice": [
      {
        "id": "u1-21-free-market-economy-flash-1",
        "knowledgePointId": "u1-21-free-market-economy",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“自由市场经济”。",
          "en": "Without notes, explain “The free-market economy” in your own words."
        },
        "answer": {
          "zh-CN": "自由市场经济是一种资源主要由私人主体拥有，生产与消费决策主要通过竞争市场和价格机制协调，政府作用相对有限的制度。",
          "en": "A free-market economy is a system in which resources are predominantly privately owned and production and consumption are coordinated mainly through competitive markets and the price mechanism, with a comparatively limited state role."
        },
        "explanation": {
          "zh-CN": "自由市场经济主要通过私有产权、价格和利润来协调生产与分配，强调分散选择而非中央指令。",
          "en": "A free-market economy coordinates production and distribution mainly through private property, prices, and profit rather than central commands."
        }
      },
      {
        "id": "u1-21-free-market-economy-mcq-1",
        "knowledgePointId": "u1-21-free-market-economy",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“自由市场经济”？",
          "en": "Which statement best captures “The free-market economy”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "自由市场要求不存在法律和产权",
            "en": "Free markets require no law or property rights"
          },
          {
            "id": "b",
            "zh-CN": "自由市场经济主要通过私有产权、价格和利润来协调生产与分配，强调分散选择而非中央指令。",
            "en": "A free-market economy coordinates production and distribution mainly through private property, prices, and profit rather than central commands."
          },
          {
            "id": "c",
            "zh-CN": "生产计划全部由中央行政指定",
            "en": "All production is set by central orders"
          },
          {
            "id": "d",
            "zh-CN": "自由市场自动消除所有市场失灵",
            "en": "Free markets automatically eliminate all market failure"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "自由市场经济是一种资源主要由私人主体拥有，生产与消费决策主要通过竞争市场和价格机制协调，政府作用相对有限的制度。",
          "en": "A free-market economy is a system in which resources are predominantly privately owned and production and consumption are coordinated mainly through competitive markets and the price mechanism, with a comparatively limited state role."
        }
      },
      {
        "id": "u1-21-free-market-economy-short-1",
        "knowledgePointId": "u1-21-free-market-economy",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“自由市场经济”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “The free-market economy”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "自由市场经济：自由市场经济是一种资源主要由私人主体拥有，生产与消费决策主要通过竞争市场和价格机制协调，政府作用相对有限的制度。 私人产权赋予使用和收益权；消费者支出表达有效需求；利润与亏损引导企业进入或退出；价格协调资源和产出 私人产权和价格是主要协调机制。",
          "en": "The free-market economy: A free-market economy is a system in which resources are predominantly privately owned and production and consumption are coordinated mainly through competitive markets and the price mechanism, with a comparatively limited state role. Private property grants rights to use assets and receive returns; Consumer spending expresses effective demand; Profit and loss encourage entry or exit; Prices coordinate resources and output Private property and prices are primary coordinating institutions."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "自由市场经济",
                "市场经济",
                "资本主义市场制度",
                "laissez-faire economy"
              ],
              "en": [
                "The free-market economy",
                "market economy",
                "capitalist market system",
                "laissez-faire economy"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "私人产权赋予使用和收益权",
                "消费者支出表达有效需求"
              ],
              "en": [
                "Private property grants rights to use assets and receive returns",
                "Consumer spending expresses effective demand"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "私人产权和价格是主要协调机制。",
                "利润提供生产激励。"
              ],
              "en": [
                "Private property and prices are primary coordinating institutions.",
                "Profit creates an incentive for production and adaptation."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-22-planned-economy",
      "slug": "planned-economy",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            13
          ]
        }
      ],
      "prerequisites": [
        "u1-16-basic-economic-questions"
      ],
      "related": [
        "u1-21-free-market-economy",
        "u1-23-mixed-economy"
      ],
      "terms": [
        "The planned economy",
        "计划经济"
      ],
      "synonyms": {
        "zh-CN": [
          "命令经济",
          "中央计划",
          "command economy"
        ],
        "en": [
          "command economy",
          "central planning",
          "administrative allocation"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-22-planned-economy-flash-1",
        "u1-22-planned-economy-mcq-1",
        "u1-22-planned-economy-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-22-planned-economy",
        "locale": "zh-CN",
        "title": "计划经济",
        "takeaway": "计划经济主要由公共机构设定产出、投入和分配目标，能够集中资源，却面临信息、激励和调整难题。",
        "definition": "计划经济是一种生产资料主要由国家拥有或控制，中央或公共计划机构以行政目标而非分散市场价格来决定资源配置的制度。",
        "causalChain": [
          "计划机构确定社会优先目标",
          "向企业或部门分配投入与产量指标",
          "行政体系协调生产和分配",
          "反馈信息用于修订后续计划"
        ],
        "realWorldExample": {
          "title": "国有企业承担公共与商业目标",
          "sourceUrl": "https://www.oecd.org/en/topics/sub-issues/state-owned-enterprises.html",
          "observedAt": "2026-09-29",
          "explanation": "OECD 对国有企业治理的工作展示公共所有权可用于战略或公共服务目标，同时需要明确授权、绩效信息和问责，以减少多重目标造成的效率问题。"
        },
        "misconceptions": [
          "政府拥有部分企业不代表整个经济是计划经济。",
          "计划可以集中资源，但中央机构仍必须获得及时、准确和地方化的信息。"
        ],
        "examApplication": [
          "优势可讨论协调长期投资和基本服务，局限可讨论信息与激励。",
          "比较时使用程度和机制，不把市场与计划写成只有两个绝对选项。"
        ],
        "summary": [
          "公共计划替代大部分价格协调。",
          "集中力量可服务明确的社会优先事项。",
          "信息不足和弱激励可能导致短缺、剩余与低效率。"
        ],
        "explanation": "计划体系由公共机构回答三个基本问题。计划者确定产品组合、生产技术和分配标准，并把资源与指标传递给生产单位。\n\n集中决策可以把资源快速投向基础设施或基本服务，但复杂经济包含大量不断变化的本地信息。若反馈缓慢、指标设计不当或生产者缺乏改进激励，就可能出现错配。"
      },
      "en": {
        "id": "u1-22-planned-economy",
        "locale": "en",
        "title": "The planned economy",
        "takeaway": "A planned economy relies on public authorities to set output, input, and distribution targets; it can concentrate resources but faces information, incentive, and adjustment problems.",
        "definition": "A planned economy is a system in which productive assets are largely state-owned or controlled and a central or public planning authority allocates resources through administrative targets rather than decentralised market prices.",
        "causalChain": [
          "The planning authority establishes social priorities",
          "Inputs and output targets are assigned to sectors or enterprises",
          "An administrative system coordinates production and distribution",
          "Feedback informs revisions to later plans"
        ],
        "realWorldExample": {
          "title": "State-owned enterprises combine public and commercial goals",
          "sourceUrl": "https://www.oecd.org/en/topics/sub-issues/state-owned-enterprises.html",
          "observedAt": "2026-09-29",
          "explanation": "OECD work on state-owned-enterprise governance shows how public ownership can pursue strategic or service objectives while requiring clear mandates, performance information, and accountability to manage conflicting goals."
        },
        "misconceptions": [
          "Government ownership of some firms does not make the whole economy centrally planned.",
          "Planning can concentrate resources, but the centre still needs timely, accurate, and local information."
        ],
        "examApplication": [
          "Potential strengths include coordinated long-term investment and basic services; limitations include information and incentives.",
          "Compare degrees and mechanisms rather than presenting market and plan as the only two absolute choices."
        ],
        "summary": [
          "Public planning replaces much price coordination.",
          "Concentrated resources can serve stated social priorities.",
          "Weak information and incentives can cause shortage, surplus, and inefficiency."
        ],
        "explanation": "Public authorities answer the three basic questions in a planned system. They establish an output mix, production methods, and distribution criteria before communicating resources and targets to producing units.\n\nCentral direction can move resources rapidly toward infrastructure or essential services. A complex economy, however, contains large volumes of changing local information. Slow feedback, badly designed targets, or weak incentives to improve can create persistent mismatches."
      }
    },
    "practice": [
      {
        "id": "u1-22-planned-economy-flash-1",
        "knowledgePointId": "u1-22-planned-economy",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“计划经济”。",
          "en": "Without notes, explain “The planned economy” in your own words."
        },
        "answer": {
          "zh-CN": "计划经济是一种生产资料主要由国家拥有或控制，中央或公共计划机构以行政目标而非分散市场价格来决定资源配置的制度。",
          "en": "A planned economy is a system in which productive assets are largely state-owned or controlled and a central or public planning authority allocates resources through administrative targets rather than decentralised market prices."
        },
        "explanation": {
          "zh-CN": "计划经济主要由公共机构设定产出、投入和分配目标，能够集中资源，却面临信息、激励和调整难题。",
          "en": "A planned economy relies on public authorities to set output, input, and distribution targets; it can concentrate resources but faces information, incentive, and adjustment problems."
        }
      },
      {
        "id": "u1-22-planned-economy-mcq-1",
        "knowledgePointId": "u1-22-planned-economy",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“计划经济”？",
          "en": "Which statement best captures “The planned economy”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只要存在一家国企就是完全计划经济",
            "en": "One state firm makes an economy wholly planned"
          },
          {
            "id": "b",
            "zh-CN": "所有选择均由竞争价格分散协调",
            "en": "All choices are coordinated only by decentralised prices"
          },
          {
            "id": "c",
            "zh-CN": "计划经济主要由公共机构设定产出、投入和分配目标，能够集中资源，却面临信息、激励和调整难题。",
            "en": "A planned economy relies on public authorities to set output, input, and distribution targets; it can concentrate resources but faces information, incentive, and adjustment problems."
          },
          {
            "id": "d",
            "zh-CN": "中央计划不需任何信息就能最优",
            "en": "Central planning needs no information to be optimal"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "计划经济是一种生产资料主要由国家拥有或控制，中央或公共计划机构以行政目标而非分散市场价格来决定资源配置的制度。",
          "en": "A planned economy is a system in which productive assets are largely state-owned or controlled and a central or public planning authority allocates resources through administrative targets rather than decentralised market prices."
        }
      },
      {
        "id": "u1-22-planned-economy-short-1",
        "knowledgePointId": "u1-22-planned-economy",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“计划经济”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “The planned economy”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "计划经济：计划经济是一种生产资料主要由国家拥有或控制，中央或公共计划机构以行政目标而非分散市场价格来决定资源配置的制度。 计划机构确定社会优先目标；向企业或部门分配投入与产量指标；行政体系协调生产和分配；反馈信息用于修订后续计划 公共计划替代大部分价格协调。",
          "en": "The planned economy: A planned economy is a system in which productive assets are largely state-owned or controlled and a central or public planning authority allocates resources through administrative targets rather than decentralised market prices. The planning authority establishes social priorities; Inputs and output targets are assigned to sectors or enterprises; An administrative system coordinates production and distribution; Feedback informs revisions to later plans Public planning replaces much price coordination."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "计划经济",
                "命令经济",
                "中央计划",
                "command economy"
              ],
              "en": [
                "The planned economy",
                "command economy",
                "central planning",
                "administrative allocation"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "计划机构确定社会优先目标",
                "向企业或部门分配投入与产量指标"
              ],
              "en": [
                "The planning authority establishes social priorities",
                "Inputs and output targets are assigned to sectors or enterprises"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "公共计划替代大部分价格协调。",
                "集中力量可服务明确的社会优先事项。"
              ],
              "en": [
                "Public planning replaces much price coordination.",
                "Concentrated resources can serve stated social priorities."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-23-mixed-economy",
      "slug": "mixed-economy",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            14
          ]
        }
      ],
      "prerequisites": [
        "u1-21-free-market-economy",
        "u1-22-planned-economy"
      ],
      "related": [
        "u1-19-market-mechanism",
        "u1-20-government-intervention"
      ],
      "terms": [
        "The mixed economy",
        "混合经济"
      ],
      "synonyms": {
        "zh-CN": [
          "混合市场经济",
          "公私混合制度",
          "mixed system"
        ],
        "en": [
          "mixed-market economy",
          "public-private system",
          "mixed system"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-23-mixed-economy-flash-1",
        "u1-23-mixed-economy-mcq-1",
        "u1-23-mixed-economy-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-23-mixed-economy",
        "locale": "zh-CN",
        "title": "混合经济",
        "takeaway": "混合经济把市场配置与政府规则、再分配和公共供给结合起来，关键问题是两者边界如何设计。",
        "definition": "混合经济是私人市场和公共部门共同拥有资源并共同决定生产、配置和分配的经济制度。",
        "causalChain": [
          "多数日常选择由价格和私人主体协调",
          "法律与监管设定市场边界",
          "政府通过税收、转移和公共服务改变结果",
          "制度组合随政策目标和证据调整"
        ],
        "realWorldExample": {
          "title": "政府规模和职能因经济体而异",
          "sourceUrl": "https://www.oecd.org/en/publications/government-at-a-glance-2025_0efd0bcd-en.html",
          "observedAt": "2026-09-29",
          "explanation": "OECD《政府概览》比较公共支出、就业、服务和治理。成员经济体都使用市场，也以不同程度的公共供给和再分配形成各自的混合模式。"
        },
        "misconceptions": [
          "混合经济不是市场和计划各占固定一半。",
          "政府介入多寡不能单独说明制度优劣，还要看工具设计和结果。"
        ],
        "examApplication": [
          "用具体部门说明市场与政府分别承担什么角色。",
          "评价制度组合时围绕效率、公平、稳定、自由和可持续性建立标准。"
        ],
        "summary": [
          "现实经济体通常同时使用市场和政府。",
          "组合在行业和时期之间不同。",
          "评价重点是制度如何运作而非标签。"
        ],
        "explanation": "现实经济体通常让价格协调大量消费和生产，同时由政府提供法律框架、公共服务和社会保障。医疗、教育、能源或交通等行业中的组合可能彼此不同。\n\n混合经济没有唯一配方。市场与公共部门的相对范围会随政治价值、历史、技术和政策证据变化。分析应比较具体机制能否处理信息、激励、分配和问责。"
      },
      "en": {
        "id": "u1-23-mixed-economy",
        "locale": "en",
        "title": "The mixed economy",
        "takeaway": "A mixed economy combines market allocation with public rules, redistribution, and provision; the central issue is how the boundary is designed.",
        "definition": "A mixed economy is a system in which private markets and the public sector both own resources and share responsibility for production, allocation, and distribution.",
        "causalChain": [
          "Prices and private agents coordinate many daily choices",
          "Law and regulation set market boundaries",
          "Taxes, transfers, and public services alter outcomes",
          "The institutional mix changes with objectives and evidence"
        ],
        "realWorldExample": {
          "title": "Government scale and functions vary across economies",
          "sourceUrl": "https://www.oecd.org/en/publications/government-at-a-glance-2025_0efd0bcd-en.html",
          "observedAt": "2026-09-29",
          "explanation": "OECD Government at a Glance compares public spending, employment, services, and governance. Member economies all use markets while combining different degrees of public provision and redistribution."
        },
        "misconceptions": [
          "A mixed economy does not require a fixed fifty-fifty split between market and plan.",
          "The amount of intervention cannot establish performance without evidence about instrument design and outcomes."
        ],
        "examApplication": [
          "Use a particular sector to show the distinct roles of market and government.",
          "Evaluate an institutional mix against efficiency, equity, stability, freedom, and sustainability."
        ],
        "summary": [
          "Most actual economies use both markets and government.",
          "The mix differs across sectors and over time.",
          "Analysis should examine mechanisms and outcomes rather than labels."
        ],
        "explanation": "Most economies allow prices to coordinate large areas of consumption and production while government supplies legal infrastructure, public services, and social protection. The blend in health, education, energy, or transport may differ within one country.\n\nThere is no single recipe for a mixed economy. The boundary changes with political values, history, technology, and policy evidence. Useful comparison asks how specific arrangements handle information, incentives, distribution, and accountability."
      }
    },
    "practice": [
      {
        "id": "u1-23-mixed-economy-flash-1",
        "knowledgePointId": "u1-23-mixed-economy",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“混合经济”。",
          "en": "Without notes, explain “The mixed economy” in your own words."
        },
        "answer": {
          "zh-CN": "混合经济是私人市场和公共部门共同拥有资源并共同决定生产、配置和分配的经济制度。",
          "en": "A mixed economy is a system in which private markets and the public sector both own resources and share responsibility for production, allocation, and distribution."
        },
        "explanation": {
          "zh-CN": "混合经济把市场配置与政府规则、再分配和公共供给结合起来，关键问题是两者边界如何设计。",
          "en": "A mixed economy combines market allocation with public rules, redistribution, and provision; the central issue is how the boundary is designed."
        }
      },
      {
        "id": "u1-23-mixed-economy-mcq-1",
        "knowledgePointId": "u1-23-mixed-economy",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“混合经济”？",
          "en": "Which statement best captures “The mixed economy”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "私人和公共部门必须各占恰好一半",
            "en": "Private and public sectors must each be exactly half"
          },
          {
            "id": "b",
            "zh-CN": "混合经济没有私人产权",
            "en": "A mixed economy has no private ownership"
          },
          {
            "id": "c",
            "zh-CN": "混合经济不允许政府提供服务",
            "en": "A mixed economy prohibits public provision"
          },
          {
            "id": "d",
            "zh-CN": "混合经济把市场配置与政府规则、再分配和公共供给结合起来，关键问题是两者边界如何设计。",
            "en": "A mixed economy combines market allocation with public rules, redistribution, and provision; the central issue is how the boundary is designed."
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "混合经济是私人市场和公共部门共同拥有资源并共同决定生产、配置和分配的经济制度。",
          "en": "A mixed economy is a system in which private markets and the public sector both own resources and share responsibility for production, allocation, and distribution."
        }
      },
      {
        "id": "u1-23-mixed-economy-short-1",
        "knowledgePointId": "u1-23-mixed-economy",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“混合经济”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “The mixed economy”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "混合经济：混合经济是私人市场和公共部门共同拥有资源并共同决定生产、配置和分配的经济制度。 多数日常选择由价格和私人主体协调；法律与监管设定市场边界；政府通过税收、转移和公共服务改变结果；制度组合随政策目标和证据调整 现实经济体通常同时使用市场和政府。",
          "en": "The mixed economy: A mixed economy is a system in which private markets and the public sector both own resources and share responsibility for production, allocation, and distribution. Prices and private agents coordinate many daily choices; Law and regulation set market boundaries; Taxes, transfers, and public services alter outcomes; The institutional mix changes with objectives and evidence Most actual economies use both markets and government."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "混合经济",
                "混合市场经济",
                "公私混合制度",
                "mixed system"
              ],
              "en": [
                "The mixed economy",
                "mixed-market economy",
                "public-private system",
                "mixed system"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "多数日常选择由价格和私人主体协调",
                "法律与监管设定市场边界"
              ],
              "en": [
                "Prices and private agents coordinate many daily choices",
                "Law and regulation set market boundaries"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "现实经济体通常同时使用市场和政府。",
                "组合在行业和时期之间不同。"
              ],
              "en": [
                "Most actual economies use both markets and government.",
                "The mix differs across sectors and over time."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-24-economic-models",
      "slug": "economic-models",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            15
          ]
        }
      ],
      "prerequisites": [
        "u1-01-economics-social-science"
      ],
      "related": [
        "u1-25-ppc-construction",
        "u1-32-logic-hypotheses-theories"
      ],
      "terms": [
        "Purposes and limits of economic models",
        "经济模型的作用与局限"
      ],
      "synonyms": {
        "zh-CN": [
          "经济抽象",
          "简化框架",
          "economic representation"
        ],
        "en": [
          "economic abstraction",
          "simplified framework",
          "economic representation"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-24-economic-models-flash-1",
        "u1-24-economic-models-mcq-1",
        "u1-24-economic-models-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-24-economic-models",
        "locale": "zh-CN",
        "title": "经济模型的作用与局限",
        "takeaway": "经济模型有意简化现实来突出关键关系；好模型不是细节最多，而是在明确假设下对问题有解释力。",
        "definition": "经济模型是对现实经济主体、约束和关系的有目的简化，用文字、图形或数学表达因果机制并形成可检验预测。",
        "causalChain": [
          "研究者提出一个具体问题",
          "保留被认为关键的变量和关系",
          "用假设隔离机制并推出预测",
          "把预测与证据比较后修正模型"
        ],
        "realWorldExample": {
          "title": "中央银行用模型解释政策传导",
          "sourceUrl": "https://www.bankofengland.co.uk/education/education-resources",
          "observedAt": "2026-09-29",
          "explanation": "英格兰银行的教育资料把利率、消费、投资、产出和通胀组织为简化关系。模型帮助解释传导方向，但真实效果仍取决于预期、金融状况和时滞。"
        },
        "misconceptions": [
          "模型不现实的某个细节不一定使模型无用；关键是简化是否破坏所研究的机制。",
          "模型结论是有条件的预测，不是任何时间地点都成立的保证。"
        ],
        "examApplication": [
          "使用图形前先写出关键假设，并在评价时放松其中一个假设。",
          "说明模型能解释什么，也说明它遗漏了哪些相关变量或群体。"
        ],
        "summary": [
          "模型把复杂现实压缩成关键关系。",
          "假设决定结论的适用范围。",
          "预测需要证据检验和迭代。"
        ],
        "explanation": "现实经济包含太多同时变化的因素，无法一次全部分析。模型通过选择变量、设定假设和表达关系，使一个机制变得可理解。PPC、供需图和 AD–AS 都属于模型。\n\n简化带来力量也带来局限。若遗漏因素与问题无关，模型仍可有效；若遗漏因素改变结论方向，模型就需要扩展。经济学家会比较预测和证据，而不是把模型当作现实的缩小照片。"
      },
      "en": {
        "id": "u1-24-economic-models",
        "locale": "en",
        "title": "Purposes and limits of economic models",
        "takeaway": "An economic model deliberately simplifies reality to isolate important relationships; the best model is useful for a question under clear assumptions, not the one with the most detail.",
        "definition": "An economic model is a purposeful simplification of agents, constraints, and relationships, expressed verbally, graphically, or mathematically to explain a mechanism and generate testable predictions.",
        "causalChain": [
          "A researcher specifies a focused question",
          "Variables and relationships judged essential are retained",
          "Assumptions isolate a mechanism and yield predictions",
          "Predictions are compared with evidence and the model is revised"
        ],
        "realWorldExample": {
          "title": "A central bank models policy transmission",
          "sourceUrl": "https://www.bankofengland.co.uk/education/education-resources",
          "observedAt": "2026-09-29",
          "explanation": "Bank of England education resources organise interest rates, consumption, investment, output, and inflation into simplified relationships. The model clarifies transmission while expectations, financial conditions, and lags shape the actual effect."
        },
        "misconceptions": [
          "An unrealistic detail does not automatically make a model useless; the test is whether the simplification damages the mechanism being studied.",
          "A model conclusion is a conditional prediction, not a guarantee for every time and place."
        ],
        "examApplication": [
          "State key assumptions before using a diagram, then relax one assumption in evaluation.",
          "Explain both what the model illuminates and which relevant variables or groups it omits."
        ],
        "summary": [
          "Models compress complexity into selected relationships.",
          "Assumptions define the range of a conclusion.",
          "Predictions must face evidence and revision."
        ],
        "explanation": "An economy contains too many changing elements to analyse simultaneously. A model selects variables, sets assumptions, and expresses relationships so that one mechanism becomes intelligible. The PPC, supply and demand, and AD–AS are all models.\n\nSimplification is both the source of power and a limitation. Omitting an irrelevant detail may be harmless; omitting a factor that changes the direction of a result is not. Economists confront predictions with evidence rather than treating a model as a miniature photograph of reality."
      }
    },
    "practice": [
      {
        "id": "u1-24-economic-models-flash-1",
        "knowledgePointId": "u1-24-economic-models",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“经济模型的作用与局限”。",
          "en": "Without notes, explain “Purposes and limits of economic models” in your own words."
        },
        "answer": {
          "zh-CN": "经济模型是对现实经济主体、约束和关系的有目的简化，用文字、图形或数学表达因果机制并形成可检验预测。",
          "en": "An economic model is a purposeful simplification of agents, constraints, and relationships, expressed verbally, graphically, or mathematically to explain a mechanism and generate testable predictions."
        },
        "explanation": {
          "zh-CN": "经济模型有意简化现实来突出关键关系；好模型不是细节最多，而是在明确假设下对问题有解释力。",
          "en": "An economic model deliberately simplifies reality to isolate important relationships; the best model is useful for a question under clear assumptions, not the one with the most detail."
        }
      },
      {
        "id": "u1-24-economic-models-mcq-1",
        "knowledgePointId": "u1-24-economic-models",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“经济模型的作用与局限”？",
          "en": "Which statement best captures “Purposes and limits of economic models”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "经济模型有意简化现实来突出关键关系；好模型不是细节最多，而是在明确假设下对问题有解释力。",
            "en": "An economic model deliberately simplifies reality to isolate important relationships; the best model is useful for a question under clear assumptions, not the one with the most detail."
          },
          {
            "id": "b",
            "zh-CN": "模型必须复制现实全部细节才有用",
            "en": "A model needs every real-world detail to be useful"
          },
          {
            "id": "c",
            "zh-CN": "逻辑自洽就证明经验上永远正确",
            "en": "Logical consistency proves permanent empirical truth"
          },
          {
            "id": "d",
            "zh-CN": "模型不能用观察修正",
            "en": "Models cannot be revised using observation"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "经济模型是对现实经济主体、约束和关系的有目的简化，用文字、图形或数学表达因果机制并形成可检验预测。",
          "en": "An economic model is a purposeful simplification of agents, constraints, and relationships, expressed verbally, graphically, or mathematically to explain a mechanism and generate testable predictions."
        }
      },
      {
        "id": "u1-24-economic-models-short-1",
        "knowledgePointId": "u1-24-economic-models",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“经济模型的作用与局限”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Purposes and limits of economic models”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "经济模型的作用与局限：经济模型是对现实经济主体、约束和关系的有目的简化，用文字、图形或数学表达因果机制并形成可检验预测。 研究者提出一个具体问题；保留被认为关键的变量和关系；用假设隔离机制并推出预测；把预测与证据比较后修正模型 模型把复杂现实压缩成关键关系。",
          "en": "Purposes and limits of economic models: An economic model is a purposeful simplification of agents, constraints, and relationships, expressed verbally, graphically, or mathematically to explain a mechanism and generate testable predictions. A researcher specifies a focused question; Variables and relationships judged essential are retained; Assumptions isolate a mechanism and yield predictions; Predictions are compared with evidence and the model is revised Models compress complexity into selected relationships."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "经济模型的作用与局限",
                "经济抽象",
                "简化框架",
                "economic representation"
              ],
              "en": [
                "Purposes and limits of economic models",
                "economic abstraction",
                "simplified framework",
                "economic representation"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "研究者提出一个具体问题",
                "保留被认为关键的变量和关系"
              ],
              "en": [
                "A researcher specifies a focused question",
                "Variables and relationships judged essential are retained"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "模型把复杂现实压缩成关键关系。",
                "假设决定结论的适用范围。"
              ],
              "en": [
                "Models compress complexity into selected relationships.",
                "Assumptions define the range of a conclusion."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-25-ppc-construction",
      "slug": "ppc-construction",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            15,
            16
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production",
        "u1-24-economic-models"
      ],
      "related": [
        "u1-26-ppc-scarcity-choice-cost",
        "u1-27-ppc-unemployment-efficiency"
      ],
      "terms": [
        "Constructing a PPC",
        "生产可能性曲线的构造"
      ],
      "synonyms": {
        "zh-CN": [
          "生产可能性边界",
          "PPF",
          "production possibility curve"
        ],
        "en": [
          "production possibility frontier",
          "PPF",
          "transformation curve"
        ]
      },
      "diagramIds": [
        "ppc-core"
      ],
      "quizIds": [
        "u1-25-ppc-construction-flash-1",
        "u1-25-ppc-construction-mcq-1",
        "u1-25-ppc-construction-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-25-ppc-construction",
        "locale": "zh-CN",
        "title": "生产可能性曲线的构造",
        "takeaway": "PPC 在资源、技术和时期给定时，连接两类产出所有最大可行组合。",
        "definition": "生产可能性曲线（PPC）是在既定资源、技术和充分有效利用假设下，一个经济体在两类商品或服务之间能够生产的最大组合边界。",
        "causalChain": [
          "固定时期、资源数量与技术",
          "把产出归纳为横纵轴两类",
          "计算每种资源配置下的最大产出组合",
          "连接有效组合形成生产可能性边界"
        ],
        "realWorldExample": {
          "title": "把实际产业数据归纳成两类产出",
          "sourceUrl": "https://data.worldbank.org/indicator/NV.IND.TOTL.ZS",
          "observedAt": "2026-09-29",
          "explanation": "世界银行工业增加值数据展示经济体产出结构。构造教学 PPC 时可把工业与其他产出作为两轴，但必须说明这是对多产品经济的高度简化。"
        },
        "misconceptions": [
          "横轴和纵轴表示产出数量，不是价格或资源投入。",
          "曲线位置不是固定不变；资源或技术改变会移动边界。"
        ],
        "examApplication": [
          "给两轴写清产品名称和单位，并在图中标注曲线。",
          "使用 PPC 结论前说明既定资源、既定技术和有效生产等假设。"
        ],
        "summary": [
          "PPC 是最大可行产出组合的边界。",
          "模型把多种产出简化为两类。",
          "曲线基于资源、技术和效率假设。"
        ],
        "explanation": "PPC 通过假设经济体只生产两类产出来显示资源约束。将更多资源从一种产出转向另一种产出，可以得到一系列最大产出组合；连接这些组合就形成曲线。\n\n曲线本身代表可行集合的边界，而边界内包含未充分利用资源的组合。模型不声称现实只有两种商品，它用两轴使取舍和生产能力可视化。"
      },
      "en": {
        "id": "u1-25-ppc-construction",
        "locale": "en",
        "title": "Constructing a PPC",
        "takeaway": "A PPC joins the maximum feasible combinations of two output categories for a stated period, stock of resources, and technology.",
        "definition": "A production possibility curve (PPC) is the boundary of maximum combinations of two goods or services that an economy can produce when resources and technology are given and resources are fully and efficiently employed.",
        "causalChain": [
          "Fix the period, resource stock, and technology",
          "Aggregate output into two labelled axes",
          "Find maximum output under alternative resource allocations",
          "Join the efficient combinations to form the frontier"
        ],
        "realWorldExample": {
          "title": "Aggregating actual industry data into two outputs",
          "sourceUrl": "https://data.worldbank.org/indicator/NV.IND.TOTL.ZS",
          "observedAt": "2026-09-29",
          "explanation": "World Bank industry value-added data reveal the structure of output. A classroom PPC might place industry and other output on its axes, provided it acknowledges the substantial simplification of a multi-product economy."
        },
        "misconceptions": [
          "The axes measure quantities of output, not prices or the amount of inputs.",
          "The frontier is not permanently fixed; changes in resources or technology shift it."
        ],
        "examApplication": [
          "Label both products and units and name the curve clearly.",
          "Before interpreting the PPC, state assumptions about given resources, technology, and efficient production."
        ],
        "summary": [
          "The PPC is the boundary of maximum feasible output combinations.",
          "It reduces many outputs to two categories.",
          "Its position depends on assumptions about resources, technology, and efficiency."
        ],
        "explanation": "The PPC displays a resource constraint by assuming that an economy produces just two categories of output. Reallocating factors from one output to the other generates a set of maximum combinations; connecting them creates the curve.\n\nThe line is the boundary of the feasible set, while combinations inside it reflect unused or inefficiently used resources. The model does not claim that an economy literally produces only two products. Two axes make trade-offs and productive capacity visible."
      }
    },
    "practice": [
      {
        "id": "u1-25-ppc-construction-flash-1",
        "knowledgePointId": "u1-25-ppc-construction",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“生产可能性曲线的构造”。",
          "en": "Without notes, explain “Constructing a PPC” in your own words."
        },
        "answer": {
          "zh-CN": "生产可能性曲线（PPC）是在既定资源、技术和充分有效利用假设下，一个经济体在两类商品或服务之间能够生产的最大组合边界。",
          "en": "A production possibility curve (PPC) is the boundary of maximum combinations of two goods or services that an economy can produce when resources and technology are given and resources are fully and efficiently employed."
        },
        "explanation": {
          "zh-CN": "PPC 在资源、技术和时期给定时，连接两类产出所有最大可行组合。",
          "en": "A PPC joins the maximum feasible combinations of two output categories for a stated period, stock of resources, and technology."
        }
      },
      {
        "id": "u1-25-ppc-construction-mcq-1",
        "knowledgePointId": "u1-25-ppc-construction",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“生产可能性曲线的构造”？",
          "en": "Which statement best captures “Constructing a PPC”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "PPC 表示消费者最想买的所有组合",
            "en": "A PPC shows all combinations consumers desire"
          },
          {
            "id": "b",
            "zh-CN": "PPC 在资源、技术和时期给定时，连接两类产出所有最大可行组合。",
            "en": "A PPC joins the maximum feasible combinations of two output categories for a stated period, stock of resources, and technology."
          },
          {
            "id": "c",
            "zh-CN": "在资源技术不变时边界外点也可立即达到",
            "en": "Points outside are immediately feasible with unchanged resources and technology"
          },
          {
            "id": "d",
            "zh-CN": "边界内每个点都生产有效率",
            "en": "Every interior point is productively efficient"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "生产可能性曲线（PPC）是在既定资源、技术和充分有效利用假设下，一个经济体在两类商品或服务之间能够生产的最大组合边界。",
          "en": "A production possibility curve (PPC) is the boundary of maximum combinations of two goods or services that an economy can produce when resources and technology are given and resources are fully and efficiently employed."
        }
      },
      {
        "id": "u1-25-ppc-construction-short-1",
        "knowledgePointId": "u1-25-ppc-construction",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“生产可能性曲线的构造”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Constructing a PPC”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "生产可能性曲线的构造：生产可能性曲线（PPC）是在既定资源、技术和充分有效利用假设下，一个经济体在两类商品或服务之间能够生产的最大组合边界。 固定时期、资源数量与技术；把产出归纳为横纵轴两类；计算每种资源配置下的最大产出组合；连接有效组合形成生产可能性边界 PPC 是最大可行产出组合的边界。",
          "en": "Constructing a PPC: A production possibility curve (PPC) is the boundary of maximum combinations of two goods or services that an economy can produce when resources and technology are given and resources are fully and efficiently employed. Fix the period, resource stock, and technology; Aggregate output into two labelled axes; Find maximum output under alternative resource allocations; Join the efficient combinations to form the frontier The PPC is the boundary of maximum feasible output combinations."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "生产可能性曲线的构造",
                "生产可能性边界",
                "PPF",
                "production possibility curve"
              ],
              "en": [
                "Constructing a PPC",
                "production possibility frontier",
                "PPF",
                "transformation curve"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "固定时期、资源数量与技术",
                "把产出归纳为横纵轴两类"
              ],
              "en": [
                "Fix the period, resource stock, and technology",
                "Aggregate output into two labelled axes"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "PPC 是最大可行产出组合的边界。",
                "模型把多种产出简化为两类。"
              ],
              "en": [
                "The PPC is the boundary of maximum feasible output combinations.",
                "It reduces many outputs to two categories."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-26-ppc-scarcity-choice-cost",
      "slug": "ppc-scarcity-choice-cost",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            17,
            18
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost",
        "u1-25-ppc-construction"
      ],
      "related": [
        "u1-27-ppc-unemployment-efficiency",
        "u1-29-ppc-opportunity-cost-shapes"
      ],
      "terms": [
        "Scarcity choice and cost on a PPC",
        "PPC中的稀缺、选择与机会成本"
      ],
      "synonyms": {
        "zh-CN": [
          "PPC取舍",
          "PPC机会成本",
          "production trade-off"
        ],
        "en": [
          "PPC trade-off",
          "PPC opportunity cost",
          "production trade-off"
        ]
      },
      "diagramIds": [
        "ppc-core"
      ],
      "quizIds": [
        "u1-26-ppc-scarcity-choice-cost-flash-1",
        "u1-26-ppc-scarcity-choice-cost-mcq-1",
        "u1-26-ppc-scarcity-choice-cost-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-26-ppc-scarcity-choice-cost",
        "locale": "zh-CN",
        "title": "PPC中的稀缺、选择与机会成本",
        "takeaway": "PPC 外的组合体现当前稀缺，曲线上的不同点体现选择，沿曲线移动时放弃的另一种产出体现机会成本。",
        "definition": "在 PPC 模型中，边界限制表示稀缺；边界上的可选组合表示选择；从一点移动到另一点所减少的另一种产出数量表示机会成本。",
        "causalChain": [
          "资源限制形成生产边界",
          "社会在边界上选择一种产出组合",
          "增加横轴产出需要重新配置资源",
          "纵轴产出的减少量成为横轴产出的机会成本"
        ],
        "realWorldExample": {
          "title": "财政资源在公共目标间取舍",
          "sourceUrl": "https://www.imf.org/en/Publications/FM",
          "observedAt": "2026-09-29",
          "explanation": "IMF《财政监测》分析有限财政空间。若人员和预算都受约束，扩大一种公共服务可能需要放弃另一项支出，逻辑上可用 PPC 的沿线移动表达。"
        },
        "misconceptions": [
          "曲线外的点不是永远不可能，而是在当前资源和技术下不可达。",
          "机会成本由放弃的产出变化衡量，不是曲线上点到点的几何距离。"
        ],
        "examApplication": [
          "在图上标出初始点、终点和两个方向的产量变化。",
          "文字解释必须把曲线位置与稀缺、选择、机会成本逐一对应。"
        ],
        "summary": [
          "边界体现当前生产限制。",
          "曲线上的多个组合迫使社会选择。",
          "沿边界移动显示一种产出的机会成本。"
        ],
        "explanation": "PPC 把抽象的稀缺转化为可见边界。曲线外的组合超过当前能力，因此不能同时实现；曲线上的组合都可行且有效，但社会只能选择其中一个。\n\n沿曲线增加一种产出需要把资源从另一种生产转出。另一种产出的减少就是新增产出的机会成本。回答时要同时写出数量方向与经济含义。"
      },
      "en": {
        "id": "u1-26-ppc-scarcity-choice-cost",
        "locale": "en",
        "title": "Scarcity, choice, and cost on a PPC",
        "takeaway": "Points beyond a PPC reveal current scarcity, alternative points on the line represent choice, and movement along it reveals the other output forgone as opportunity cost.",
        "definition": "Within the PPC model, the frontier represents scarcity, alternative feasible combinations represent choice, and the reduction in one output when moving along the curve measures the opportunity cost of more of the other.",
        "causalChain": [
          "Resource constraints create a production boundary",
          "Society selects one combination on the boundary",
          "More horizontal-axis output requires reallocation",
          "The lost vertical-axis output is its opportunity cost"
        ],
        "realWorldExample": {
          "title": "Fiscal resources trade off across public objectives",
          "sourceUrl": "https://www.imf.org/en/Publications/FM",
          "observedAt": "2026-09-29",
          "explanation": "The IMF Fiscal Monitor examines limited fiscal space. Where budgets and administrative capacity are constrained, expanding one public service may require less of another, a logic represented by movement along a PPC."
        },
        "misconceptions": [
          "A point outside the curve is not impossible forever; it is unattainable with current resources and technology.",
          "Opportunity cost is measured by forgone output, not by the geometric distance between two points."
        ],
        "examApplication": [
          "Mark the starting point, destination, and quantity changes in both directions.",
          "Link frontier position separately to scarcity, choice, and opportunity cost in the written explanation."
        ],
        "summary": [
          "The frontier displays a current productive constraint.",
          "Multiple combinations on the line require choice.",
          "Movement along the frontier reveals the cost in the other output."
        ],
        "explanation": "The PPC turns abstract scarcity into a visible boundary. A combination beyond the curve exceeds current capacity and cannot be produced now. Every point on the curve is feasible and efficient, but society must select one of them.\n\nMore of one output along the curve requires resources to leave production of the other. The fall in that second output is the opportunity cost of the increase. A complete answer states both quantity directions and their economic meaning."
      }
    },
    "practice": [
      {
        "id": "u1-26-ppc-scarcity-choice-cost-flash-1",
        "knowledgePointId": "u1-26-ppc-scarcity-choice-cost",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“PPC中的稀缺、选择与机会成本”。",
          "en": "Without notes, explain “Scarcity, choice, and cost on a PPC” in your own words."
        },
        "answer": {
          "zh-CN": "在 PPC 模型中，边界限制表示稀缺；边界上的可选组合表示选择；从一点移动到另一点所减少的另一种产出数量表示机会成本。",
          "en": "Within the PPC model, the frontier represents scarcity, alternative feasible combinations represent choice, and the reduction in one output when moving along the curve measures the opportunity cost of more of the other."
        },
        "explanation": {
          "zh-CN": "PPC 外的组合体现当前稀缺，曲线上的不同点体现选择，沿曲线移动时放弃的另一种产出体现机会成本。",
          "en": "Points beyond a PPC reveal current scarcity, alternative points on the line represent choice, and movement along it reveals the other output forgone as opportunity cost."
        }
      },
      {
        "id": "u1-26-ppc-scarcity-choice-cost-mcq-1",
        "knowledgePointId": "u1-26-ppc-scarcity-choice-cost",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“PPC中的稀缺、选择与机会成本”？",
          "en": "Which statement best captures “Scarcity, choice, and cost on a PPC”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "沿 PPC 移动不涉及放弃任何产出",
            "en": "Movement along a PPC sacrifices no output"
          },
          {
            "id": "b",
            "zh-CN": "机会成本是两种产出的总和",
            "en": "Opportunity cost is the sum of both outputs"
          },
          {
            "id": "c",
            "zh-CN": "PPC 外的组合体现当前稀缺，曲线上的不同点体现选择，沿曲线移动时放弃的另一种产出体现机会成本。",
            "en": "Points beyond a PPC reveal current scarcity, alternative points on the line represent choice, and movement along it reveals the other output forgone as opportunity cost."
          },
          {
            "id": "d",
            "zh-CN": "每个边界点都使双方产出同时最大",
            "en": "Every frontier point simultaneously maximises both outputs"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "在 PPC 模型中，边界限制表示稀缺；边界上的可选组合表示选择；从一点移动到另一点所减少的另一种产出数量表示机会成本。",
          "en": "Within the PPC model, the frontier represents scarcity, alternative feasible combinations represent choice, and the reduction in one output when moving along the curve measures the opportunity cost of more of the other."
        }
      },
      {
        "id": "u1-26-ppc-scarcity-choice-cost-short-1",
        "knowledgePointId": "u1-26-ppc-scarcity-choice-cost",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“PPC中的稀缺、选择与机会成本”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Scarcity, choice, and cost on a PPC”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "PPC中的稀缺、选择与机会成本：在 PPC 模型中，边界限制表示稀缺；边界上的可选组合表示选择；从一点移动到另一点所减少的另一种产出数量表示机会成本。 资源限制形成生产边界；社会在边界上选择一种产出组合；增加横轴产出需要重新配置资源；纵轴产出的减少量成为横轴产出的机会成本 边界体现当前生产限制。",
          "en": "Scarcity, choice, and cost on a PPC: Within the PPC model, the frontier represents scarcity, alternative feasible combinations represent choice, and the reduction in one output when moving along the curve measures the opportunity cost of more of the other. Resource constraints create a production boundary; Society selects one combination on the boundary; More horizontal-axis output requires reallocation; The lost vertical-axis output is its opportunity cost The frontier displays a current productive constraint."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "PPC中的稀缺、选择与机会成本",
                "PPC取舍",
                "PPC机会成本",
                "production trade-off"
              ],
              "en": [
                "Scarcity, choice, and cost on a PPC",
                "PPC trade-off",
                "PPC opportunity cost",
                "production trade-off"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "资源限制形成生产边界",
                "社会在边界上选择一种产出组合"
              ],
              "en": [
                "Resource constraints create a production boundary",
                "Society selects one combination on the boundary"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "边界体现当前生产限制。",
                "曲线上的多个组合迫使社会选择。"
              ],
              "en": [
                "The frontier displays a current productive constraint.",
                "Multiple combinations on the line require choice."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-27-ppc-unemployment-efficiency",
      "slug": "ppc-unemployment-efficiency",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            16,
            19
          ]
        }
      ],
      "prerequisites": [
        "u1-25-ppc-construction"
      ],
      "related": [
        "u1-06-efficiency",
        "u1-28-ppc-growth"
      ],
      "terms": [
        "Unemployment and efficiency on a PPC",
        "PPC中的失业与生产效率"
      ],
      "synonyms": {
        "zh-CN": [
          "PPC失业",
          "生产低效",
          "inside the PPC"
        ],
        "en": [
          "PPC unemployment",
          "productive inefficiency",
          "inside the PPC"
        ]
      },
      "diagramIds": [
        "ppc-core"
      ],
      "quizIds": [
        "u1-27-ppc-unemployment-efficiency-flash-1",
        "u1-27-ppc-unemployment-efficiency-mcq-1",
        "u1-27-ppc-unemployment-efficiency-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-27-ppc-unemployment-efficiency",
        "locale": "zh-CN",
        "title": "PPC中的失业与生产效率",
        "takeaway": "曲线内点表示当前能力未被充分或有效使用，曲线上点表示生产效率；回到边界可增加一种或两种产出。",
        "definition": "PPC 内部的点代表失业、闲置或低效配置使实际产出低于最大可能；曲线上的点代表既定资源和技术下的生产效率。",
        "causalChain": [
          "部分劳动或资本闲置或错配",
          "实际产出落在生产边界以内",
          "需求恢复、再培训或管理改善提高利用率",
          "经济体移向边界并实现实际增长"
        ],
        "realWorldExample": {
          "title": "劳动未充分利用限制实际产出",
          "sourceUrl": "https://ilostat.ilo.org/topics/unemployment-and-labour-underutilization/",
          "observedAt": "2026-09-29",
          "explanation": "国际劳工组织 ILOSTAT 区分失业和更广泛的劳动未充分利用。可用劳动没有进入有效生产时，经济体可能在其现有生产能力以内运行。"
        },
        "misconceptions": [
          "边界内点不一定只由失业造成，设备闲置和资源错配也可能导致低效率。",
          "曲线上所有点都具有生产效率，但未必具有配置效率。"
        ],
        "examApplication": [
          "用从曲线内到曲线上的箭头表示资源利用改善。",
          "区分这种实际产出增加与曲线向外移动的潜在增长。"
        ],
        "summary": [
          "曲线内表示未充分利用或低效。",
          "曲线上表示生产效率。",
          "向边界移动不要求生产能力本身扩大。"
        ],
        "explanation": "如果劳动失业、机器闲置或资源配置不当，经济体可以生产更多至少一种产品而不减少另一种，因此实际组合位于边界以内。\n\n消除闲置或改善组织会把产出推向曲线。这个过程使用原有能力，属于实际增长或复苏。达到曲线只说明投入得到有效利用，不说明社会选择了最想要的产品组合。"
      },
      "en": {
        "id": "u1-27-ppc-unemployment-efficiency",
        "locale": "en",
        "title": "Unemployment and efficiency on a PPC",
        "takeaway": "A point inside the PPC indicates that current capacity is underused or used inefficiently; a point on the line is productively efficient, and returning to it can raise one or both outputs.",
        "definition": "A point inside a PPC represents actual output below the feasible maximum because of unemployment, idle capacity, or inefficient allocation, while a point on the curve represents productive efficiency for the given resources and technology.",
        "causalChain": [
          "Some labour or capital is idle or mismatched",
          "Actual output lies within the production boundary",
          "Recovery, retraining, or better management raises utilisation",
          "The economy moves toward the frontier and actual output grows"
        ],
        "realWorldExample": {
          "title": "Labour underutilisation restricts actual output",
          "sourceUrl": "https://ilostat.ilo.org/topics/unemployment-and-labour-underutilization/",
          "observedAt": "2026-09-29",
          "explanation": "ILOSTAT distinguishes unemployment from broader labour underutilisation. When available labour is not engaged in effective production, an economy may operate inside its existing productive capacity."
        },
        "misconceptions": [
          "An interior point is not caused only by unemployment; idle equipment and misallocation can also create inefficiency.",
          "Every point on the PPC is productively efficient but not necessarily allocatively efficient."
        ],
        "examApplication": [
          "Use an arrow from inside the curve to the boundary to show improved resource use.",
          "Distinguish this rise in actual output from an outward shift representing greater potential."
        ],
        "summary": [
          "Inside the curve indicates underuse or inefficiency.",
          "On the curve indicates productive efficiency.",
          "Moving to the frontier does not require capacity itself to expand."
        ],
        "explanation": "With unemployed labour, idle machinery, or poor resource allocation, at least one output can rise without reducing the other. The actual combination therefore lies within the frontier.\n\nUsing idle factors or improving organisation moves output toward the curve. This is growth in actual production or recovery using existing capacity. Reaching the curve establishes productive efficiency, not that society has selected its preferred output mix."
      }
    },
    "practice": [
      {
        "id": "u1-27-ppc-unemployment-efficiency-flash-1",
        "knowledgePointId": "u1-27-ppc-unemployment-efficiency",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“PPC中的失业与生产效率”。",
          "en": "Without notes, explain “Unemployment and efficiency on a PPC” in your own words."
        },
        "answer": {
          "zh-CN": "PPC 内部的点代表失业、闲置或低效配置使实际产出低于最大可能；曲线上的点代表既定资源和技术下的生产效率。",
          "en": "A point inside a PPC represents actual output below the feasible maximum because of unemployment, idle capacity, or inefficient allocation, while a point on the curve represents productive efficiency for the given resources and technology."
        },
        "explanation": {
          "zh-CN": "曲线内点表示当前能力未被充分或有效使用，曲线上点表示生产效率；回到边界可增加一种或两种产出。",
          "en": "A point inside the PPC indicates that current capacity is underused or used inefficiently; a point on the line is productively efficient, and returning to it can raise one or both outputs."
        }
      },
      {
        "id": "u1-27-ppc-unemployment-efficiency-mcq-1",
        "knowledgePointId": "u1-27-ppc-unemployment-efficiency",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“PPC中的失业与生产效率”？",
          "en": "Which statement best captures “Unemployment and efficiency on a PPC”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "PPC 内点证明资源已完全有效使用",
            "en": "An interior point proves full efficient resource use"
          },
          {
            "id": "b",
            "zh-CN": "边界上每一点都同时保证配置效率",
            "en": "Every frontier point guarantees allocative efficiency"
          },
          {
            "id": "c",
            "zh-CN": "失业只能表现为 PPC 必定外移",
            "en": "Unemployment can only shift a PPC outward"
          },
          {
            "id": "d",
            "zh-CN": "曲线内点表示当前能力未被充分或有效使用，曲线上点表示生产效率；回到边界可增加一种或两种产出。",
            "en": "A point inside the PPC indicates that current capacity is underused or used inefficiently; a point on the line is productively efficient, and returning to it can raise one or both outputs."
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "PPC 内部的点代表失业、闲置或低效配置使实际产出低于最大可能；曲线上的点代表既定资源和技术下的生产效率。",
          "en": "A point inside a PPC represents actual output below the feasible maximum because of unemployment, idle capacity, or inefficient allocation, while a point on the curve represents productive efficiency for the given resources and technology."
        }
      },
      {
        "id": "u1-27-ppc-unemployment-efficiency-short-1",
        "knowledgePointId": "u1-27-ppc-unemployment-efficiency",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“PPC中的失业与生产效率”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Unemployment and efficiency on a PPC”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "PPC中的失业与生产效率：PPC 内部的点代表失业、闲置或低效配置使实际产出低于最大可能；曲线上的点代表既定资源和技术下的生产效率。 部分劳动或资本闲置或错配；实际产出落在生产边界以内；需求恢复、再培训或管理改善提高利用率；经济体移向边界并实现实际增长 曲线内表示未充分利用或低效。",
          "en": "Unemployment and efficiency on a PPC: A point inside a PPC represents actual output below the feasible maximum because of unemployment, idle capacity, or inefficient allocation, while a point on the curve represents productive efficiency for the given resources and technology. Some labour or capital is idle or mismatched; Actual output lies within the production boundary; Recovery, retraining, or better management raises utilisation; The economy moves toward the frontier and actual output grows Inside the curve indicates underuse or inefficiency."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "PPC中的失业与生产效率",
                "PPC失业",
                "生产低效",
                "inside the PPC"
              ],
              "en": [
                "Unemployment and efficiency on a PPC",
                "PPC unemployment",
                "productive inefficiency",
                "inside the PPC"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "部分劳动或资本闲置或错配",
                "实际产出落在生产边界以内"
              ],
              "en": [
                "Some labour or capital is idle or mismatched",
                "Actual output lies within the production boundary"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "曲线内表示未充分利用或低效。",
                "曲线上表示生产效率。"
              ],
              "en": [
                "Inside the curve indicates underuse or inefficiency.",
                "On the curve indicates productive efficiency."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-28-ppc-growth",
      "slug": "ppc-growth",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            19,
            20
          ]
        }
      ],
      "prerequisites": [
        "u1-25-ppc-construction",
        "u1-27-ppc-unemployment-efficiency"
      ],
      "related": [
        "u1-10-change",
        "u1-13-factors-of-production"
      ],
      "terms": [
        "Actual and potential growth",
        "实际增长与生产潜力增长"
      ],
      "synonyms": {
        "zh-CN": [
          "实际产出增长",
          "潜在增长",
          "PPC外移"
        ],
        "en": [
          "growth in actual output",
          "potential growth",
          "outward PPC shift"
        ]
      },
      "diagramIds": [
        "ppc-core"
      ],
      "quizIds": [
        "u1-28-ppc-growth-flash-1",
        "u1-28-ppc-growth-mcq-1",
        "u1-28-ppc-growth-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-28-ppc-growth",
        "locale": "zh-CN",
        "title": "实际增长与生产潜力增长",
        "takeaway": "向既有 PPC 靠近是实际产出增长，PPC 向外移动是生产潜力增长；两者可发生在不同时间。",
        "definition": "实际增长是实际产出的增加，可来自既有产能利用率提高或新增产能投入使用；生产可能性增长是资源数量、质量或技术改善使最大可行产出边界向外移动。",
        "causalChain": [
          "经济体可能先在边界以内运行",
          "更高资源利用率使实际点靠近边界",
          "投资、教育、资源发现或技术进步扩大能力",
          "PPC 向外移动并允许更高长期产出"
        ],
        "realWorldExample": {
          "title": "增长率不能单独区分复苏与能力扩张",
          "sourceUrl": "https://data.worldbank.org/indicator/NY.GDP.MKTP.KD.ZG",
          "observedAt": "2026-09-29",
          "explanation": "世界银行实际 GDP 增长数据记录产出变化。衰退后增长可能主要来自闲置资源重新使用；持续投资与生产率提升才更可能扩大长期生产边界。"
        },
        "misconceptions": [
          "实际 GDP 上升不一定表示 PPC 已向外移动。",
          "外移可以偏向一种产品，不必始终平行移动。"
        ],
        "examApplication": [
          "用点的移动表示实际增长，用曲线移动表示潜在增长。",
          "把资源、资本、人力资本或技术变化与曲线外移的方向联系起来。"
        ],
        "summary": [
          "边界内向边界移动表示利用率提高。",
          "边界外移表示最大能力扩大。",
          "增长来源决定曲线是否偏向某一轴移动。"
        ],
        "explanation": "经济体低于充分能力时，可以通过提高就业和设备利用率增加产出而不改变 PPC。这通常出现在经济复苏阶段。\n\n若劳动力增加、技能提高、资本积累或技术进步，最大可行组合会扩大，PPC 向外移动。若进步只适用于某一行业，外移可能只明显发生在对应轴的一端。"
      },
      "en": {
        "id": "u1-28-ppc-growth",
        "locale": "en",
        "title": "Actual and potential growth",
        "takeaway": "Movement toward an existing PPC is growth in actual output, while an outward shift is growth in productive potential; the two can occur at different times.",
        "definition": "Actual growth is an increase in real output, whether from using existing capacity more fully or bringing new capacity into use. Growth in production possibilities is an outward shift of the maximum feasible boundary caused by more or better resources or improved technology.",
        "causalChain": [
          "The economy may initially operate inside its frontier",
          "Higher utilisation moves actual output toward the line",
          "Investment, education, resource discovery, or technology expands capacity",
          "The PPC shifts outward and permits greater long-run output"
        ],
        "realWorldExample": {
          "title": "A growth rate alone cannot separate recovery from capacity expansion",
          "sourceUrl": "https://data.worldbank.org/indicator/NY.GDP.MKTP.KD.ZG",
          "observedAt": "2026-09-29",
          "explanation": "World Bank real GDP growth data record changes in output. Growth after recession may mainly reuse idle factors, whereas sustained investment and productivity improvement are more likely to expand the long-run frontier."
        },
        "misconceptions": [
          "A rise in actual GDP does not by itself show that the PPC has shifted outward.",
          "An outward shift can be biased toward one good rather than parallel."
        ],
        "examApplication": [
          "Use movement of a point for actual growth and movement of the curve for potential growth.",
          "Connect changes in resources, physical or human capital, and technology to the direction of the shift."
        ],
        "summary": [
          "Movement from inside toward the frontier raises utilisation.",
          "An outward shift expands maximum capacity.",
          "The source of growth determines whether the shift favours one axis."
        ],
        "explanation": "When an economy operates below full capacity, output can rise through higher employment and capital utilisation without changing the PPC. This pattern often describes a recovery.\n\nA larger or more skilled workforce, capital accumulation, resource discovery, or technological progress expands the feasible set and shifts the PPC outward. Innovation confined to one sector can create a rotation or an uneven shift rather than a parallel movement."
      }
    },
    "practice": [
      {
        "id": "u1-28-ppc-growth-flash-1",
        "knowledgePointId": "u1-28-ppc-growth",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“实际增长与生产潜力增长”。",
          "en": "Without notes, explain “Actual and potential growth” in your own words."
        },
        "answer": {
          "zh-CN": "实际增长是实际产出的增加，可来自既有产能利用率提高或新增产能投入使用；生产可能性增长是资源数量、质量或技术改善使最大可行产出边界向外移动。",
          "en": "Actual growth is an increase in real output, whether from using existing capacity more fully or bringing new capacity into use. Growth in production possibilities is an outward shift of the maximum feasible boundary caused by more or better resources or improved technology."
        },
        "explanation": {
          "zh-CN": "向既有 PPC 靠近是实际产出增长，PPC 向外移动是生产潜力增长；两者可发生在不同时间。",
          "en": "Movement toward an existing PPC is growth in actual output, while an outward shift is growth in productive potential; the two can occur at different times."
        }
      },
      {
        "id": "u1-28-ppc-growth-mcq-1",
        "knowledgePointId": "u1-28-ppc-growth",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“实际增长与生产潜力增长”？",
          "en": "Which statement best captures “Actual and potential growth”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "向既有 PPC 靠近是实际产出增长，PPC 向外移动是生产潜力增长；两者可发生在不同时间。",
            "en": "Movement toward an existing PPC is growth in actual output, while an outward shift is growth in productive potential; the two can occur at different times."
          },
          {
            "id": "b",
            "zh-CN": "当前产出增加必定意味着潜在边界外移",
            "en": "Higher current output necessarily shifts the frontier out"
          },
          {
            "id": "c",
            "zh-CN": "技术改善只能沿原曲线移动",
            "en": "Better technology only moves along an unchanged frontier"
          },
          {
            "id": "d",
            "zh-CN": "潜在产能增加保证产出立即同步增加",
            "en": "More capacity guarantees an immediate matching output increase"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "实际增长是实际产出的增加，可来自既有产能利用率提高或新增产能投入使用；生产可能性增长是资源数量、质量或技术改善使最大可行产出边界向外移动。",
          "en": "Actual growth is an increase in real output, whether from using existing capacity more fully or bringing new capacity into use. Growth in production possibilities is an outward shift of the maximum feasible boundary caused by more or better resources or improved technology."
        }
      },
      {
        "id": "u1-28-ppc-growth-short-1",
        "knowledgePointId": "u1-28-ppc-growth",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“实际增长与生产潜力增长”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Actual and potential growth”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "实际增长与生产潜力增长：实际增长是实际产出的增加，可来自既有产能利用率提高或新增产能投入使用；生产可能性增长是资源数量、质量或技术改善使最大可行产出边界向外移动。 经济体可能先在边界以内运行；更高资源利用率使实际点靠近边界；投资、教育、资源发现或技术进步扩大能力；PPC 向外移动并允许更高长期产出 边界内向边界移动表示利用率提高。",
          "en": "Actual and potential growth: Actual growth is an increase in real output, whether from using existing capacity more fully or bringing new capacity into use. Growth in production possibilities is an outward shift of the maximum feasible boundary caused by more or better resources or improved technology. The economy may initially operate inside its frontier; Higher utilisation moves actual output toward the line; Investment, education, resource discovery, or technology expands capacity; The PPC shifts outward and permits greater long-run output Movement from inside toward the frontier raises utilisation."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "实际增长与生产潜力增长",
                "实际产出增长",
                "潜在增长",
                "PPC外移"
              ],
              "en": [
                "Actual and potential growth",
                "growth in actual output",
                "potential growth",
                "outward PPC shift"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "经济体可能先在边界以内运行",
                "更高资源利用率使实际点靠近边界"
              ],
              "en": [
                "The economy may initially operate inside its frontier",
                "Higher utilisation moves actual output toward the line"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "边界内向边界移动表示利用率提高。",
                "边界外移表示最大能力扩大。"
              ],
              "en": [
                "Movement from inside toward the frontier raises utilisation.",
                "An outward shift expands maximum capacity."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-29-ppc-opportunity-cost-shapes",
      "slug": "ppc-opportunity-cost-shapes",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            21,
            22
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost",
        "u1-26-ppc-scarcity-choice-cost"
      ],
      "related": [
        "u1-13-factors-of-production",
        "u1-25-ppc-construction"
      ],
      "terms": [
        "Increasing and constant opportunity cost",
        "递增与不变机会成本"
      ],
      "synonyms": {
        "zh-CN": [
          "递增机会成本规律",
          "直线PPC",
          "凹向原点PPC"
        ],
        "en": [
          "law of increasing opportunity cost",
          "linear PPC",
          "bowed-out PPC"
        ]
      },
      "diagramIds": [
        "ppc-core"
      ],
      "quizIds": [
        "u1-29-ppc-opportunity-cost-shapes-flash-1",
        "u1-29-ppc-opportunity-cost-shapes-mcq-1",
        "u1-29-ppc-opportunity-cost-shapes-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-29-ppc-opportunity-cost-shapes",
        "locale": "zh-CN",
        "title": "递增与不变机会成本",
        "takeaway": "专业化资源使 PPC 通常向外弯并呈递增机会成本；资源同质且可完全替代时，直线 PPC 表示不变机会成本。",
        "definition": "递增机会成本是连续增加一种产出时每个新增单位需放弃越来越多另一种产出；不变机会成本则表示交换比率保持相同。",
        "causalChain": [
          "资源对两种生产的适用程度不同",
          "先转移最适合新增产品的资源",
          "继续扩大时必须转移越来越不适合的资源",
          "每个新增单位造成更大的另一种产出损失"
        ],
        "realWorldExample": {
          "title": "土地用途具有不同适宜性",
          "sourceUrl": "https://www.fao.org/faostat/en/#data/RL",
          "observedAt": "2026-09-29",
          "explanation": "FAOSTAT 土地利用资料区分耕地、牧场等用途。土地的土壤、气候和位置不同，持续把更多土地转向某作物时，较不适宜土地会带来更高机会成本。"
        },
        "misconceptions": [
          "向外弯曲描述机会成本变化，不表示经济增长。",
          "斜率为负表示取舍；比较机会成本时看斜率绝对值。"
        ],
        "examApplication": [
          "用资源异质性解释递增机会成本，而不要只写‘曲线弯曲’。",
          "从坐标变化计算一段 PPC 的机会成本，并写明单位。"
        ],
        "summary": [
          "异质和专业化资源导致递增成本。",
          "同质可替代资源可产生不变成本。",
          "PPC 斜率的绝对值反映机会成本。"
        ],
        "explanation": "生产要素通常不是对所有用途同样有效。扩大一种产品时，最适合该产品的资源会先被转移；再扩大就要使用更适合另一种产品的资源，因此放弃量递增。\n\n若资源在两种用途间生产率比例完全相同，每转移一单位资源造成的取舍相同，PPC 就是一条直线。这是有用基准，但现实中资源专用性更常见。"
      },
      "en": {
        "id": "u1-29-ppc-opportunity-cost-shapes",
        "locale": "en",
        "title": "Increasing and constant opportunity cost",
        "takeaway": "Specialised resources normally create a bowed-out PPC and increasing opportunity cost; identical, perfectly transferable resources create a straight line and constant cost.",
        "definition": "Increasing opportunity cost means that successive additions to one output require ever larger reductions in the other, while constant opportunity cost means that the trade-off ratio does not change.",
        "causalChain": [
          "Resources differ in suitability for the two outputs",
          "Resources best suited to the expanding good move first",
          "Further expansion transfers increasingly unsuitable factors",
          "Each extra unit requires a larger loss of the other output"
        ],
        "realWorldExample": {
          "title": "Land differs in its suitability for alternative uses",
          "sourceUrl": "https://www.fao.org/faostat/en/#data/RL",
          "observedAt": "2026-09-29",
          "explanation": "FAOSTAT land-use data distinguish arable land, pasture, and other uses. Soil, climate, and location differ, so moving progressively more land toward one crop is likely to involve rising opportunity cost."
        },
        "misconceptions": [
          "A bowed shape describes changing opportunity cost, not economic growth.",
          "The negative slope displays a trade-off; its absolute value is used when comparing opportunity cost."
        ],
        "examApplication": [
          "Explain increasing cost through heterogeneous resources rather than merely saying the curve is bowed.",
          "Calculate opportunity cost from coordinate changes and include units."
        ],
        "summary": [
          "Heterogeneous and specialised resources generate increasing cost.",
          "Homogeneous transferable resources can generate constant cost.",
          "The absolute slope of a PPC reflects opportunity cost."
        ],
        "explanation": "Factors of production are rarely equally productive in every use. Expansion of one good first draws resources well suited to it; further expansion requires resources with stronger productivity in the other activity, so the forgone amount rises.\n\nIf every resource has the same productivity ratio in both uses, each transfer creates the same trade-off and the PPC is a straight line. That case is a useful benchmark, while resource specificity is more common in practice."
      }
    },
    "practice": [
      {
        "id": "u1-29-ppc-opportunity-cost-shapes-flash-1",
        "knowledgePointId": "u1-29-ppc-opportunity-cost-shapes",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“递增与不变机会成本”。",
          "en": "Without notes, explain “Increasing and constant opportunity cost” in your own words."
        },
        "answer": {
          "zh-CN": "递增机会成本是连续增加一种产出时每个新增单位需放弃越来越多另一种产出；不变机会成本则表示交换比率保持相同。",
          "en": "Increasing opportunity cost means that successive additions to one output require ever larger reductions in the other, while constant opportunity cost means that the trade-off ratio does not change."
        },
        "explanation": {
          "zh-CN": "专业化资源使 PPC 通常向外弯并呈递增机会成本；资源同质且可完全替代时，直线 PPC 表示不变机会成本。",
          "en": "Specialised resources normally create a bowed-out PPC and increasing opportunity cost; identical, perfectly transferable resources create a straight line and constant cost."
        }
      },
      {
        "id": "u1-29-ppc-opportunity-cost-shapes-mcq-1",
        "knowledgePointId": "u1-29-ppc-opportunity-cost-shapes",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“递增与不变机会成本”？",
          "en": "Which statement best captures “Increasing and constant opportunity cost”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "直线 PPC 表示递增机会成本",
            "en": "A straight PPC means increasing opportunity cost"
          },
          {
            "id": "b",
            "zh-CN": "专业化资源使 PPC 通常向外弯并呈递增机会成本；资源同质且可完全替代时，直线 PPC 表示不变机会成本。",
            "en": "Specialised resources normally create a bowed-out PPC and increasing opportunity cost; identical, perfectly transferable resources create a straight line and constant cost."
          },
          {
            "id": "c",
            "zh-CN": "弯曲 PPC 表示没有取舍",
            "en": "A bowed PPC means no trade-off"
          },
          {
            "id": "d",
            "zh-CN": "资源用途适应性差异不会影响 PPC 形状",
            "en": "Resource suitability never affects PPC shape"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "递增机会成本是连续增加一种产出时每个新增单位需放弃越来越多另一种产出；不变机会成本则表示交换比率保持相同。",
          "en": "Increasing opportunity cost means that successive additions to one output require ever larger reductions in the other, while constant opportunity cost means that the trade-off ratio does not change."
        }
      },
      {
        "id": "u1-29-ppc-opportunity-cost-shapes-short-1",
        "knowledgePointId": "u1-29-ppc-opportunity-cost-shapes",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“递增与不变机会成本”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Increasing and constant opportunity cost”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "递增与不变机会成本：递增机会成本是连续增加一种产出时每个新增单位需放弃越来越多另一种产出；不变机会成本则表示交换比率保持相同。 资源对两种生产的适用程度不同；先转移最适合新增产品的资源；继续扩大时必须转移越来越不适合的资源；每个新增单位造成更大的另一种产出损失 异质和专业化资源导致递增成本。",
          "en": "Increasing and constant opportunity cost: Increasing opportunity cost means that successive additions to one output require ever larger reductions in the other, while constant opportunity cost means that the trade-off ratio does not change. Resources differ in suitability for the two outputs; Resources best suited to the expanding good move first; Further expansion transfers increasingly unsuitable factors; Each extra unit requires a larger loss of the other output Heterogeneous and specialised resources generate increasing cost."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "递增与不变机会成本",
                "递增机会成本规律",
                "直线PPC",
                "凹向原点PPC"
              ],
              "en": [
                "Increasing and constant opportunity cost",
                "law of increasing opportunity cost",
                "linear PPC",
                "bowed-out PPC"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "资源对两种生产的适用程度不同",
                "先转移最适合新增产品的资源"
              ],
              "en": [
                "Resources differ in suitability for the two outputs",
                "Resources best suited to the expanding good move first"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "异质和专业化资源导致递增成本。",
                "同质可替代资源可产生不变成本。"
              ],
              "en": [
                "Heterogeneous and specialised resources generate increasing cost.",
                "Homogeneous transferable resources can generate constant cost."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-30-positive-economics",
      "slug": "positive-economics",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            23,
            24
          ]
        }
      ],
      "prerequisites": [
        "u1-01-economics-social-science"
      ],
      "related": [
        "u1-31-normative-economics",
        "u1-34-evidence-refutation"
      ],
      "terms": [
        "Positive economics",
        "实证经济学"
      ],
      "synonyms": {
        "zh-CN": [
          "事实性经济学",
          "可检验陈述",
          "positive statement"
        ],
        "en": [
          "descriptive economics",
          "testable statement",
          "positive statement"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-30-positive-economics-flash-1",
        "u1-30-positive-economics-mcq-1",
        "u1-30-positive-economics-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-30-positive-economics",
        "locale": "zh-CN",
        "title": "实证经济学",
        "takeaway": "实证经济学提出关于事实、关系或因果的可检验陈述，重点是证据能否支持或反驳。",
        "definition": "实证经济学描述和解释经济事实，提出原则上可通过观察、数据或实验检验真假的陈述，不以“应该怎样”的价值判断作为结论。",
        "causalChain": [
          "提出对事实或因果关系的陈述",
          "把概念转化为可观察指标",
          "收集并分析相关证据",
          "暂时支持、修正或反驳陈述"
        ],
        "realWorldExample": {
          "title": "公开数据允许检验增长陈述",
          "sourceUrl": "https://data.worldbank.org/",
          "observedAt": "2026-09-29",
          "explanation": "世界银行数据平台提供增长、物价、贸易和社会指标。‘某年实际 GDP 增长率下降’可用明确口径的数据检验，属于实证陈述。"
        },
        "misconceptions": [
          "实证陈述可以是错误的；“可检验”不等于“已经被证实”。",
          "数字看似客观，但指标定义、样本和因果方法仍需判断。"
        ],
        "examApplication": [
          "寻找可验证动词和变量，区分‘是/会’与‘应该/更好’。",
          "说明需要什么证据以及哪些其他因素可能混淆关系。"
        ],
        "summary": [
          "实证陈述涉及可观察事实或因果。",
          "证据可以支持也可以反驳。",
          "测量与识别方法影响结论可信度。"
        ],
        "explanation": "实证分析试图说明经济是什么样以及变量如何关联。例如‘提高某税率会降低消费量’是一个可检验预测，即使研究最终发现消费量没有下降，它仍属于实证命题。\n\n检验并不总是简单。变量可能同时受到收入、政策和预期影响。研究者需要定义指标、选择比较对象并处理其他因素，才能把相关性与因果解释区分开。"
      },
      "en": {
        "id": "u1-30-positive-economics",
        "locale": "en",
        "title": "Positive economics",
        "takeaway": "Positive economics makes testable claims about facts, relationships, or causes and asks whether evidence supports or challenges them.",
        "definition": "Positive economics describes and explains economic reality through statements that can in principle be tested with observation, data, or experiments, without concluding what ought to be done from a value judgement.",
        "causalChain": [
          "State a claim about a fact or causal relationship",
          "Translate concepts into observable measures",
          "Collect and analyse relevant evidence",
          "Provisionally support, revise, or reject the claim"
        ],
        "realWorldExample": {
          "title": "Open data permit a growth claim to be tested",
          "sourceUrl": "https://data.worldbank.org/",
          "observedAt": "2026-09-29",
          "explanation": "The World Bank data platform publishes growth, price, trade, and social indicators. A claim that real GDP growth fell in a specified year can be checked against a defined measure and is positive."
        },
        "misconceptions": [
          "A positive statement can be false; testable does not mean already proven.",
          "Numbers appear objective, but definitions, samples, and causal methods still require judgement."
        ],
        "examApplication": [
          "Look for measurable variables and distinguish is or will from should or better.",
          "State what evidence would be needed and which other factors could confound the relationship."
        ],
        "summary": [
          "Positive claims concern observable facts or causes.",
          "Evidence can support or refute them.",
          "Measurement and identification affect credibility."
        ],
        "explanation": "Positive analysis asks what the economy is like and how variables relate. The prediction that a higher tax will reduce consumption is testable and remains a positive proposition even if research eventually finds no reduction.\n\nTesting is rarely automatic. Income, other policies, and expectations may change at the same time. Researchers define measures, choose comparison groups, and address alternative explanations to distinguish correlation from a credible causal account."
      }
    },
    "practice": [
      {
        "id": "u1-30-positive-economics-flash-1",
        "knowledgePointId": "u1-30-positive-economics",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“实证经济学”。",
          "en": "Without notes, explain “Positive economics” in your own words."
        },
        "answer": {
          "zh-CN": "实证经济学描述和解释经济事实，提出原则上可通过观察、数据或实验检验真假的陈述，不以“应该怎样”的价值判断作为结论。",
          "en": "Positive economics describes and explains economic reality through statements that can in principle be tested with observation, data, or experiments, without concluding what ought to be done from a value judgement."
        },
        "explanation": {
          "zh-CN": "实证经济学提出关于事实、关系或因果的可检验陈述，重点是证据能否支持或反驳。",
          "en": "Positive economics makes testable claims about facts, relationships, or causes and asks whether evidence supports or challenges them."
        }
      },
      {
        "id": "u1-30-positive-economics-mcq-1",
        "knowledgePointId": "u1-30-positive-economics",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“实证经济学”？",
          "en": "Which statement best captures “Positive economics”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "实证陈述必须已经被证明正确",
            "en": "A positive statement must already be proven true"
          },
          {
            "id": "b",
            "zh-CN": "凡带政策字样就一定规范性",
            "en": "Every policy-related statement is normative"
          },
          {
            "id": "c",
            "zh-CN": "实证经济学提出关于事实、关系或因果的可检验陈述，重点是证据能否支持或反驳。",
            "en": "Positive economics makes testable claims about facts, relationships, or causes and asks whether evidence supports or challenges them."
          },
          {
            "id": "d",
            "zh-CN": "实证经济学只讨论应该怎样",
            "en": "Positive economics only concerns what ought to happen"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "实证经济学描述和解释经济事实，提出原则上可通过观察、数据或实验检验真假的陈述，不以“应该怎样”的价值判断作为结论。",
          "en": "Positive economics describes and explains economic reality through statements that can in principle be tested with observation, data, or experiments, without concluding what ought to be done from a value judgement."
        }
      },
      {
        "id": "u1-30-positive-economics-short-1",
        "knowledgePointId": "u1-30-positive-economics",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“实证经济学”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Positive economics”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "实证经济学：实证经济学描述和解释经济事实，提出原则上可通过观察、数据或实验检验真假的陈述，不以“应该怎样”的价值判断作为结论。 提出对事实或因果关系的陈述；把概念转化为可观察指标；收集并分析相关证据；暂时支持、修正或反驳陈述 实证陈述涉及可观察事实或因果。",
          "en": "Positive economics: Positive economics describes and explains economic reality through statements that can in principle be tested with observation, data, or experiments, without concluding what ought to be done from a value judgement. State a claim about a fact or causal relationship; Translate concepts into observable measures; Collect and analyse relevant evidence; Provisionally support, revise, or reject the claim Positive claims concern observable facts or causes."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "实证经济学",
                "事实性经济学",
                "可检验陈述",
                "positive statement"
              ],
              "en": [
                "Positive economics",
                "descriptive economics",
                "testable statement",
                "positive statement"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "提出对事实或因果关系的陈述",
                "把概念转化为可观察指标"
              ],
              "en": [
                "State a claim about a fact or causal relationship",
                "Translate concepts into observable measures"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "实证陈述涉及可观察事实或因果。",
                "证据可以支持也可以反驳。"
              ],
              "en": [
                "Positive claims concern observable facts or causes.",
                "Evidence can support or refute them."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-31-normative-economics",
      "slug": "normative-economics",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            23,
            24
          ]
        }
      ],
      "prerequisites": [
        "u1-30-positive-economics"
      ],
      "related": [
        "u1-07-equity",
        "u1-35-equality-equity"
      ],
      "terms": [
        "Normative economics and value judgements",
        "规范经济学与价值判断"
      ],
      "synonyms": {
        "zh-CN": [
          "价值判断",
          "应然经济学",
          "normative statement"
        ],
        "en": [
          "value judgement",
          "prescriptive economics",
          "normative statement"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-31-normative-economics-flash-1",
        "u1-31-normative-economics-mcq-1",
        "u1-31-normative-economics-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-31-normative-economics",
        "locale": "zh-CN",
        "title": "规范经济学与价值判断",
        "takeaway": "规范经济学讨论经济应当怎样；事实能说明后果，却不能单独决定应优先追求哪一种价值。",
        "definition": "规范经济学根据公平、自由、效率、可持续性或福祉等价值标准，对政策、制度或结果作出“应该”“更好”或“可取”的判断。",
        "causalChain": [
          "社会面对多个可能目标",
          "价值判断确定目标的相对重要性",
          "实证证据预测各方案的后果",
          "决策者依标准权衡并形成规范结论"
        ],
        "realWorldExample": {
          "title": "最低工资讨论包含事实与价值",
          "sourceUrl": "https://www.ilo.org/topics-and-sectors/wages/minimum-wages",
          "observedAt": "2026-09-29",
          "explanation": "国际劳工组织的最低工资资料同时涉及工资保障、就业、覆盖和执行。就业影响属于可检验问题，而‘更公平的工资是否值得某些成本’包含价值判断。"
        },
        "misconceptions": [
          "规范陈述不等于没有逻辑或证据；它应公开价值标准并使用可靠事实。",
          "实证研究不能消除所有分歧，因为人们可能对同一后果赋予不同权重。"
        ],
        "examApplication": [
          "圈出‘应该、公平、更好、过多’等价值词并写明隐含标准。",
          "评价政策时先陈述实证后果，再说明价值权重如何影响结论。"
        ],
        "summary": [
          "规范结论回答应当怎样。",
          "价值判断选择和排序目标。",
          "证据约束判断但不能独自决定价值。"
        ],
        "explanation": "经济政策常涉及多个目标：效率、公平、稳定、选择自由和环境保护。决定哪一目标更重要，需要价值判断，因此无法只由数据推导。\n\n规范论证仍应严谨。先用实证分析说明各方案可能产生什么结果，再公开采用的公平或福祉标准。这样即使结论不同，分歧来自事实还是价值也能被识别。"
      },
      "en": {
        "id": "u1-31-normative-economics",
        "locale": "en",
        "title": "Normative economics and value judgements",
        "takeaway": "Normative economics asks how the economy ought to be; facts reveal consequences but cannot alone decide which values deserve priority.",
        "definition": "Normative economics evaluates policies, institutions, or outcomes as desirable, better, or required by applying value standards such as equity, freedom, efficiency, sustainability, or well-being.",
        "causalChain": [
          "Society faces several possible objectives",
          "Value judgements assign relative importance to them",
          "Positive evidence predicts consequences of alternatives",
          "Decision-makers weigh outcomes and reach a normative conclusion"
        ],
        "realWorldExample": {
          "title": "Minimum-wage debate combines facts and values",
          "sourceUrl": "https://www.ilo.org/topics-and-sectors/wages/minimum-wages",
          "observedAt": "2026-09-29",
          "explanation": "International Labour Organization material on minimum wages covers wage protection, employment, coverage, and enforcement. Employment effects are testable; whether greater wage fairness justifies a cost includes a value judgement."
        },
        "misconceptions": [
          "A normative claim need not be illogical or evidence-free; it should disclose its value standard and use credible facts.",
          "Positive research cannot remove every disagreement because people may attach different weights to the same consequences."
        ],
        "examApplication": [
          "Identify value language such as should, fair, better, or excessive and state the implied criterion.",
          "Present positive consequences first, then explain how value weights influence the final judgement."
        ],
        "summary": [
          "Normative conclusions address what ought to be.",
          "Value judgements select and rank objectives.",
          "Evidence constrains a judgement without determining its values."
        ],
        "explanation": "Economic policy commonly pursues several goals: efficiency, equity, stability, freedom of choice, and environmental protection. Ranking those goals requires a value judgement and cannot be deduced from data alone.\n\nNormative reasoning can still be disciplined. Positive analysis first estimates the consequences of each option, and the fairness or welfare criterion is then made explicit. This allows disagreement about evidence to be separated from disagreement about values."
      }
    },
    "practice": [
      {
        "id": "u1-31-normative-economics-flash-1",
        "knowledgePointId": "u1-31-normative-economics",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“规范经济学与价值判断”。",
          "en": "Without notes, explain “Normative economics and value judgements” in your own words."
        },
        "answer": {
          "zh-CN": "规范经济学根据公平、自由、效率、可持续性或福祉等价值标准，对政策、制度或结果作出“应该”“更好”或“可取”的判断。",
          "en": "Normative economics evaluates policies, institutions, or outcomes as desirable, better, or required by applying value standards such as equity, freedom, efficiency, sustainability, or well-being."
        },
        "explanation": {
          "zh-CN": "规范经济学讨论经济应当怎样；事实能说明后果，却不能单独决定应优先追求哪一种价值。",
          "en": "Normative economics asks how the economy ought to be; facts reveal consequences but cannot alone decide which values deserve priority."
        }
      },
      {
        "id": "u1-31-normative-economics-mcq-1",
        "knowledgePointId": "u1-31-normative-economics",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“规范经济学与价值判断”？",
          "en": "Which statement best captures “Normative economics and value judgements”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "规范陈述可以仅靠数据唯一证明",
            "en": "Data alone uniquely prove normative judgements"
          },
          {
            "id": "b",
            "zh-CN": "规范性意味着完全不能引用事实",
            "en": "Normative reasoning cannot use facts"
          },
          {
            "id": "c",
            "zh-CN": "公平标准属于无价值判断的会计事实",
            "en": "Fairness standards are value-free accounting facts"
          },
          {
            "id": "d",
            "zh-CN": "规范经济学讨论经济应当怎样；事实能说明后果，却不能单独决定应优先追求哪一种价值。",
            "en": "Normative economics asks how the economy ought to be; facts reveal consequences but cannot alone decide which values deserve priority."
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "规范经济学根据公平、自由、效率、可持续性或福祉等价值标准，对政策、制度或结果作出“应该”“更好”或“可取”的判断。",
          "en": "Normative economics evaluates policies, institutions, or outcomes as desirable, better, or required by applying value standards such as equity, freedom, efficiency, sustainability, or well-being."
        }
      },
      {
        "id": "u1-31-normative-economics-short-1",
        "knowledgePointId": "u1-31-normative-economics",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“规范经济学与价值判断”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Normative economics and value judgements”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "规范经济学与价值判断：规范经济学根据公平、自由、效率、可持续性或福祉等价值标准，对政策、制度或结果作出“应该”“更好”或“可取”的判断。 社会面对多个可能目标；价值判断确定目标的相对重要性；实证证据预测各方案的后果；决策者依标准权衡并形成规范结论 规范结论回答应当怎样。",
          "en": "Normative economics and value judgements: Normative economics evaluates policies, institutions, or outcomes as desirable, better, or required by applying value standards such as equity, freedom, efficiency, sustainability, or well-being. Society faces several possible objectives; Value judgements assign relative importance to them; Positive evidence predicts consequences of alternatives; Decision-makers weigh outcomes and reach a normative conclusion Normative conclusions address what ought to be."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "规范经济学与价值判断",
                "价值判断",
                "应然经济学",
                "normative statement"
              ],
              "en": [
                "Normative economics and value judgements",
                "value judgement",
                "prescriptive economics",
                "normative statement"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "社会面对多个可能目标",
                "价值判断确定目标的相对重要性"
              ],
              "en": [
                "Society faces several possible objectives",
                "Value judgements assign relative importance to them"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "规范结论回答应当怎样。",
                "价值判断选择和排序目标。"
              ],
              "en": [
                "Normative conclusions address what ought to be.",
                "Value judgements select and rank objectives."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-32-logic-hypotheses-theories",
      "slug": "logic-hypotheses-theories",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            24,
            25
          ]
        }
      ],
      "prerequisites": [
        "u1-24-economic-models",
        "u1-30-positive-economics"
      ],
      "related": [
        "u1-33-ceteris-paribus",
        "u1-34-evidence-refutation"
      ],
      "terms": [
        "Logic hypotheses theories and models",
        "逻辑、假设、理论与模型"
      ],
      "synonyms": {
        "zh-CN": [
          "经济方法论",
          "假说与理论",
          "model reasoning"
        ],
        "en": [
          "economic methodology",
          "hypothesis and theory",
          "model reasoning"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-32-logic-hypotheses-theories-flash-1",
        "u1-32-logic-hypotheses-theories-mcq-1",
        "u1-32-logic-hypotheses-theories-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-32-logic-hypotheses-theories",
        "locale": "zh-CN",
        "title": "逻辑、假设、理论与模型",
        "takeaway": "经济研究从逻辑一致的假设推导预测，用模型表达机制，再以证据检验和改进理论。",
        "definition": "假设是可检验的暂时命题，理论是解释一组现象的连贯关系体系，模型是理论的简化表达，而逻辑保证从前提到结论的推导一致。",
        "causalChain": [
          "观察现象并提出问题",
          "形成假设和机制解释",
          "把关键关系表达为模型并推导预测",
          "用证据检验后保留、修正或替代理论"
        ],
        "realWorldExample": {
          "title": "政策评价连接理论与证据",
          "sourceUrl": "https://www.oecd.org/en/topics/policy-evaluation.html",
          "observedAt": "2026-09-29",
          "explanation": "OECD 的政策评价资料强调明确政策目标、变化理论、指标和反事实。只有把政策如何产生结果的逻辑写清，证据才能针对关键假设。"
        },
        "misconceptions": [
          "理论不是随意猜测，而是能组织解释和预测的体系。",
          "逻辑正确只表示结论能从前提推出，并不证明前提符合现实。"
        ],
        "examApplication": [
          "把答案写成前提—机制—预测—证据链。",
          "评价模型时分别检查内部逻辑与外部经验有效性。"
        ],
        "summary": [
          "逻辑连接前提与结论。",
          "假设提出可检验命题。",
          "理论和模型需通过证据不断修正。"
        ],
        "explanation": "经济解释通常始于一个观察到的规律或问题。研究者提出可能机制，明确假设，再用模型推导如果机制成立应观察到什么。\n\n内部一致性与经验有效性是不同检验。一个模型可以逻辑严密但建立在不适合某情境的假设上；也可能产生吻合数据的预测，却没有正确识别因果机制。两者都需要审查。"
      },
      "en": {
        "id": "u1-32-logic-hypotheses-theories",
        "locale": "en",
        "title": "Logic, hypotheses, theories, and models",
        "takeaway": "Economic inquiry derives predictions from logically consistent assumptions, represents mechanisms in models, and uses evidence to test and improve theory.",
        "definition": "A hypothesis is a provisional testable proposition; a theory is a coherent system of relationships that explains phenomena; a model is a simplified representation of theory; and logic makes inference from premises to conclusions internally consistent.",
        "causalChain": [
          "Observe a pattern and pose a question",
          "Form a hypothesis and proposed mechanism",
          "Represent key relationships in a model and derive predictions",
          "Use evidence to retain, revise, or replace the theory"
        ],
        "realWorldExample": {
          "title": "Policy evaluation connects theory and evidence",
          "sourceUrl": "https://www.oecd.org/en/topics/policy-evaluation.html",
          "observedAt": "2026-09-29",
          "explanation": "OECD material on policy evaluation stresses clear objectives, a theory of change, indicators, and a counterfactual. Evidence can address key assumptions only after the logic connecting policy to outcome is explicit."
        },
        "misconceptions": [
          "A theory is not a casual guess; it is a system capable of organising explanation and prediction.",
          "Valid logic shows that a conclusion follows from premises, not that the premises accurately represent reality."
        ],
        "examApplication": [
          "Structure an explanation as premises, mechanism, prediction, and evidence.",
          "Evaluate internal logical consistency separately from external empirical validity."
        ],
        "summary": [
          "Logic links premises to conclusions.",
          "A hypothesis states a testable proposition.",
          "Evidence drives revision of theories and models."
        ],
        "explanation": "An economic explanation often begins with an observed pattern or puzzle. A researcher proposes a mechanism, states assumptions, and builds a model to derive what should be observed if the mechanism operates.\n\nInternal consistency and empirical validity are different tests. A model may be logically sound but rest on assumptions unsuited to a context. It can also fit a pattern in data without identifying the true causal mechanism. Both dimensions need scrutiny."
      }
    },
    "practice": [
      {
        "id": "u1-32-logic-hypotheses-theories-flash-1",
        "knowledgePointId": "u1-32-logic-hypotheses-theories",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“逻辑、假设、理论与模型”。",
          "en": "Without notes, explain “Logic, hypotheses, theories, and models” in your own words."
        },
        "answer": {
          "zh-CN": "假设是可检验的暂时命题，理论是解释一组现象的连贯关系体系，模型是理论的简化表达，而逻辑保证从前提到结论的推导一致。",
          "en": "A hypothesis is a provisional testable proposition; a theory is a coherent system of relationships that explains phenomena; a model is a simplified representation of theory; and logic makes inference from premises to conclusions internally consistent."
        },
        "explanation": {
          "zh-CN": "经济研究从逻辑一致的假设推导预测，用模型表达机制，再以证据检验和改进理论。",
          "en": "Economic inquiry derives predictions from logically consistent assumptions, represents mechanisms in models, and uses evidence to test and improve theory."
        }
      },
      {
        "id": "u1-32-logic-hypotheses-theories-mcq-1",
        "knowledgePointId": "u1-32-logic-hypotheses-theories",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“逻辑、假设、理论与模型”？",
          "en": "Which statement best captures “Logic, hypotheses, theories, and models”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "经济研究从逻辑一致的假设推导预测，用模型表达机制，再以证据检验和改进理论。",
            "en": "Economic inquiry derives predictions from logically consistent assumptions, represents mechanisms in models, and uses evidence to test and improve theory."
          },
          {
            "id": "b",
            "zh-CN": "模型拟合相关性就一定识别了因果",
            "en": "Fitting a correlation necessarily identifies causation"
          },
          {
            "id": "c",
            "zh-CN": "理论无需产生任何可检验预测",
            "en": "Theories need no testable predictions"
          },
          {
            "id": "d",
            "zh-CN": "假设一旦提出就不允许修改",
            "en": "A hypothesis can never be revised"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "假设是可检验的暂时命题，理论是解释一组现象的连贯关系体系，模型是理论的简化表达，而逻辑保证从前提到结论的推导一致。",
          "en": "A hypothesis is a provisional testable proposition; a theory is a coherent system of relationships that explains phenomena; a model is a simplified representation of theory; and logic makes inference from premises to conclusions internally consistent."
        }
      },
      {
        "id": "u1-32-logic-hypotheses-theories-short-1",
        "knowledgePointId": "u1-32-logic-hypotheses-theories",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“逻辑、假设、理论与模型”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Logic, hypotheses, theories, and models”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "逻辑、假设、理论与模型：假设是可检验的暂时命题，理论是解释一组现象的连贯关系体系，模型是理论的简化表达，而逻辑保证从前提到结论的推导一致。 观察现象并提出问题；形成假设和机制解释；把关键关系表达为模型并推导预测；用证据检验后保留、修正或替代理论 逻辑连接前提与结论。",
          "en": "Logic, hypotheses, theories, and models: A hypothesis is a provisional testable proposition; a theory is a coherent system of relationships that explains phenomena; a model is a simplified representation of theory; and logic makes inference from premises to conclusions internally consistent. Observe a pattern and pose a question; Form a hypothesis and proposed mechanism; Represent key relationships in a model and derive predictions; Use evidence to retain, revise, or replace the theory Logic links premises to conclusions."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "逻辑、假设、理论与模型",
                "经济方法论",
                "假说与理论",
                "model reasoning"
              ],
              "en": [
                "Logic, hypotheses, theories, and models",
                "economic methodology",
                "hypothesis and theory",
                "model reasoning"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "观察现象并提出问题",
                "形成假设和机制解释"
              ],
              "en": [
                "Observe a pattern and pose a question",
                "Form a hypothesis and proposed mechanism"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "逻辑连接前提与结论。",
                "假设提出可检验命题。"
              ],
              "en": [
                "Logic links premises to conclusions.",
                "A hypothesis states a testable proposition."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-33-ceteris-paribus",
      "slug": "ceteris-paribus",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            26
          ]
        }
      ],
      "prerequisites": [
        "u1-24-economic-models",
        "u1-32-logic-hypotheses-theories"
      ],
      "related": [
        "u1-34-evidence-refutation"
      ],
      "terms": [
        "Ceteris paribus",
        "其他条件不变"
      ],
      "synonyms": {
        "zh-CN": [
          "其余条件相同",
          "控制变量",
          "all else equal"
        ],
        "en": [
          "all else equal",
          "other things constant",
          "controlled-variable assumption"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-33-ceteris-paribus-flash-1",
        "u1-33-ceteris-paribus-mcq-1",
        "u1-33-ceteris-paribus-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-33-ceteris-paribus",
        "locale": "zh-CN",
        "title": "其他条件不变",
        "takeaway": "ceteris paribus 暂时固定其他相关因素，以隔离一个变量的影响；现实预测必须检查这些因素是否真的相近。",
        "definition": "其他条件不变（ceteris paribus）是假设除被研究变量外，其他可能影响结果的相关因素保持不变，从而分析单一关系。",
        "causalChain": [
          "结果同时受到多个因素影响",
          "分析者选择一个关注变量",
          "暂时固定其他影响因素",
          "推导该变量变化的独立方向性影响"
        ],
        "realWorldExample": {
          "title": "分析利率变化需要条件限定",
          "sourceUrl": "https://www.bankofengland.co.uk/monetary-policy",
          "observedAt": "2026-09-29",
          "explanation": "英格兰银行说明货币政策如何通过借贷、支出和预期影响通胀。若同期能源价格或财政政策改变，观察到的通胀变化就不能只归因于利率。"
        },
        "misconceptions": [
          "其他条件不变不是声称现实中其他因素不会变化。",
          "这个假设隔离方向性关系，却不能保证实际结果大小或时间。"
        ],
        "examApplication": [
          "写明被固定的关键因素，而不是只在句尾加入拉丁语。",
          "评价时指出哪个条件最可能变化并改变预测。"
        ],
        "summary": [
          "该假设用于隔离单一关系。",
          "它是分析工具而非现实描述。",
          "放松假设可形成有效评价。"
        ],
        "explanation": "价格、收入、偏好和预期常同时影响选择。若要研究价格本身的作用，就暂时假设收入、偏好等因素不变，从而避免把多个影响混在一起。\n\n应用结论时要重新面对现实。若被固定因素发生显著变化，它可能加强、抵消或反转模型预测。因此 ceteris paribus 同时告诉我们模型能做什么和不能做什么。"
      },
      "en": {
        "id": "u1-33-ceteris-paribus",
        "locale": "en",
        "title": "Ceteris paribus",
        "takeaway": "Ceteris paribus temporarily holds other relevant influences constant to isolate one variable; an applied prediction must ask whether those conditions are genuinely similar.",
        "definition": "Ceteris paribus means assuming that relevant influences other than the variable under study remain unchanged so that one relationship can be analysed separately.",
        "causalChain": [
          "An outcome is influenced by several factors",
          "The analyst selects one variable of interest",
          "Other influences are temporarily held constant",
          "The variable's independent directional effect is derived"
        ],
        "realWorldExample": {
          "title": "An interest-rate analysis requires conditions",
          "sourceUrl": "https://www.bankofengland.co.uk/monetary-policy",
          "observedAt": "2026-09-29",
          "explanation": "The Bank of England explains monetary transmission through borrowing, spending, and expectations. If energy prices or fiscal policy change at the same time, the observed inflation path cannot be attributed to interest rates alone."
        },
        "misconceptions": [
          "Ceteris paribus does not claim that other factors remain unchanged in the real world.",
          "It isolates a directional relationship without guaranteeing the size or timing of an actual outcome."
        ],
        "examApplication": [
          "Name the important factors being held constant rather than merely adding the Latin phrase.",
          "In evaluation, identify the condition most likely to change and alter the prediction."
        ],
        "summary": [
          "The assumption isolates one relationship.",
          "It is an analytical device, not a description of reality.",
          "Relaxing it can produce effective evaluation."
        ],
        "explanation": "Price, income, preferences, and expectations can influence a choice simultaneously. To study the effect of price itself, an analyst temporarily fixes income, preferences, and other influences rather than mixing several changes together.\n\nApplication returns the analysis to reality. A substantial change in a held-constant factor can reinforce, offset, or reverse the model's prediction. Ceteris paribus therefore defines both the value and the limit of the result."
      }
    },
    "practice": [
      {
        "id": "u1-33-ceteris-paribus-flash-1",
        "knowledgePointId": "u1-33-ceteris-paribus",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“其他条件不变”。",
          "en": "Without notes, explain “Ceteris paribus” in your own words."
        },
        "answer": {
          "zh-CN": "其他条件不变（ceteris paribus）是假设除被研究变量外，其他可能影响结果的相关因素保持不变，从而分析单一关系。",
          "en": "Ceteris paribus means assuming that relevant influences other than the variable under study remain unchanged so that one relationship can be analysed separately."
        },
        "explanation": {
          "zh-CN": "ceteris paribus 暂时固定其他相关因素，以隔离一个变量的影响；现实预测必须检查这些因素是否真的相近。",
          "en": "Ceteris paribus temporarily holds other relevant influences constant to isolate one variable; an applied prediction must ask whether those conditions are genuinely similar."
        }
      },
      {
        "id": "u1-33-ceteris-paribus-mcq-1",
        "knowledgePointId": "u1-33-ceteris-paribus",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“其他条件不变”？",
          "en": "Which statement best captures “Ceteris paribus”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "现实中所有变量永远保持不变",
            "en": "Every real-world variable stays constant forever"
          },
          {
            "id": "b",
            "zh-CN": "ceteris paribus 暂时固定其他相关因素，以隔离一个变量的影响；现实预测必须检查这些因素是否真的相近。",
            "en": "Ceteris paribus temporarily holds other relevant influences constant to isolate one variable; an applied prediction must ask whether those conditions are genuinely similar."
          },
          {
            "id": "c",
            "zh-CN": "其他条件不变意味着忽略研究变量",
            "en": "Ceteris paribus ignores the variable being studied"
          },
          {
            "id": "d",
            "zh-CN": "同时改变多个因素就能单独识别每个效应",
            "en": "Changing several factors automatically isolates each effect"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "其他条件不变（ceteris paribus）是假设除被研究变量外，其他可能影响结果的相关因素保持不变，从而分析单一关系。",
          "en": "Ceteris paribus means assuming that relevant influences other than the variable under study remain unchanged so that one relationship can be analysed separately."
        }
      },
      {
        "id": "u1-33-ceteris-paribus-short-1",
        "knowledgePointId": "u1-33-ceteris-paribus",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“其他条件不变”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Ceteris paribus”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "其他条件不变：其他条件不变（ceteris paribus）是假设除被研究变量外，其他可能影响结果的相关因素保持不变，从而分析单一关系。 结果同时受到多个因素影响；分析者选择一个关注变量；暂时固定其他影响因素；推导该变量变化的独立方向性影响 该假设用于隔离单一关系。",
          "en": "Ceteris paribus: Ceteris paribus means assuming that relevant influences other than the variable under study remain unchanged so that one relationship can be analysed separately. An outcome is influenced by several factors; The analyst selects one variable of interest; Other influences are temporarily held constant; The variable's independent directional effect is derived The assumption isolates one relationship."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "其他条件不变",
                "其余条件相同",
                "控制变量",
                "all else equal"
              ],
              "en": [
                "Ceteris paribus",
                "all else equal",
                "other things constant",
                "controlled-variable assumption"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "结果同时受到多个因素影响",
                "分析者选择一个关注变量"
              ],
              "en": [
                "An outcome is influenced by several factors",
                "The analyst selects one variable of interest"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "该假设用于隔离单一关系。",
                "它是分析工具而非现实描述。"
              ],
              "en": [
                "The assumption isolates one relationship.",
                "It is an analytical device, not a description of reality."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-34-evidence-refutation",
      "slug": "evidence-refutation",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            27,
            28
          ]
        }
      ],
      "prerequisites": [
        "u1-30-positive-economics",
        "u1-32-logic-hypotheses-theories"
      ],
      "related": [
        "u1-01-economics-social-science",
        "u1-33-ceteris-paribus"
      ],
      "terms": [
        "Empirical evidence and refutation",
        "经验证据与证伪"
      ],
      "synonyms": {
        "zh-CN": [
          "实证检验",
          "证伪主义",
          "empirical testing"
        ],
        "en": [
          "empirical test",
          "falsification",
          "evidence-based economics"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-34-evidence-refutation-flash-1",
        "u1-34-evidence-refutation-mcq-1",
        "u1-34-evidence-refutation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-34-evidence-refutation",
        "locale": "zh-CN",
        "title": "经验证据与证伪",
        "takeaway": "经验研究把理论预测与观察结果比较；反例会削弱或迫使模型修正，但单一研究很少能终结复杂争论。",
        "definition": "经验证据来自系统观察、数据或实验；证伪是发现可靠证据与理论的可检验预测不一致，从而拒绝或修改该预测。",
        "causalChain": [
          "理论产生明确且可观察的预测",
          "研究设计确定数据和比较方法",
          "证据显示预测是否得到支持",
          "不一致促使检查测量、假设或理论机制"
        ],
        "realWorldExample": {
          "title": "随机评价建立政策反事实",
          "sourceUrl": "https://www.povertyactionlab.org/evaluations",
          "observedAt": "2026-09-29",
          "explanation": "J-PAL 的评价资料展示随机分组如何构造没有政策时的比较结果。观察处理组与对照组差异，可检验特定情境中的因果预测。"
        },
        "misconceptions": [
          "没有拒绝假设不等于证明它永远正确。",
          "与预测不一致时既要考虑理论问题，也要检查数据质量和研究设计。"
        ],
        "examApplication": [
          "评价证据时检查样本、指标、反事实和外部有效性。",
          "使用‘支持、未支持、削弱’等谨慎表述，而非绝对证明。"
        ],
        "summary": [
          "理论必须产生可检验预测。",
          "研究设计决定证据能回答什么。",
          "反驳会推动假设和模型修正。"
        ],
        "explanation": "经济理论要与可观察世界连接，必须产生可能被证据否定的预测。研究者使用统计数据、自然实验、随机试验或历史比较，尝试建立可信反事实。\n\n证据具有不确定性。测量误差、样本差异和外部条件都可能影响结果。重复研究和多种方法得到相近结论，会提高信心；相反证据则要求缩小结论范围或修正机制。"
      },
      "en": {
        "id": "u1-34-evidence-refutation",
        "locale": "en",
        "title": "Empirical evidence and refutation",
        "takeaway": "Empirical work compares theoretical predictions with observation; contrary evidence weakens or forces revision of a model, although one study rarely ends a complex debate.",
        "definition": "Empirical evidence comes from systematic observation, data, or experiment. Refutation occurs when credible evidence conflicts with a testable theoretical prediction, requiring that prediction to be rejected or revised.",
        "causalChain": [
          "A theory generates a clear observable prediction",
          "Research design defines data and comparison",
          "Evidence indicates whether the prediction is supported",
          "Conflict prompts review of measurement, assumptions, or mechanism"
        ],
        "realWorldExample": {
          "title": "Randomised evaluation constructs a policy counterfactual",
          "sourceUrl": "https://www.povertyactionlab.org/evaluations",
          "observedAt": "2026-09-29",
          "explanation": "J-PAL evaluations show how random assignment can create a comparison for what would have happened without a programme. Differences between treatment and control groups test a causal prediction in that setting."
        },
        "misconceptions": [
          "Failing to reject a hypothesis does not prove it is permanently true.",
          "When evidence conflicts, data quality and research design need checking alongside the theory."
        ],
        "examApplication": [
          "Assess a sample, measure, counterfactual, and external validity when judging evidence.",
          "Use calibrated language such as supports, fails to support, or weakens rather than absolute proof."
        ],
        "summary": [
          "Theory must yield testable predictions.",
          "Research design limits what evidence can answer.",
          "Refutation drives revision of assumptions and models."
        ],
        "explanation": "An economic theory connects to the observable world only if it generates predictions that evidence could contradict. Statistical data, natural experiments, randomised trials, and historical comparison all help construct a credible counterfactual.\n\nEvidence remains uncertain. Measurement error, sample differences, and context affect results. Convergence across replications and methods raises confidence, while contrary findings may narrow the domain of a claim or motivate a change in the mechanism."
      }
    },
    "practice": [
      {
        "id": "u1-34-evidence-refutation-flash-1",
        "knowledgePointId": "u1-34-evidence-refutation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“经验证据与证伪”。",
          "en": "Without notes, explain “Empirical evidence and refutation” in your own words."
        },
        "answer": {
          "zh-CN": "经验证据来自系统观察、数据或实验；证伪是发现可靠证据与理论的可检验预测不一致，从而拒绝或修改该预测。",
          "en": "Empirical evidence comes from systematic observation, data, or experiment. Refutation occurs when credible evidence conflicts with a testable theoretical prediction, requiring that prediction to be rejected or revised."
        },
        "explanation": {
          "zh-CN": "经验研究把理论预测与观察结果比较；反例会削弱或迫使模型修正，但单一研究很少能终结复杂争论。",
          "en": "Empirical work compares theoretical predictions with observation; contrary evidence weakens or forces revision of a model, although one study rarely ends a complex debate."
        }
      },
      {
        "id": "u1-34-evidence-refutation-mcq-1",
        "knowledgePointId": "u1-34-evidence-refutation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“经验证据与证伪”？",
          "en": "Which statement best captures “Empirical evidence and refutation”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "单个支持案例足以永远证明理论",
            "en": "One supporting case proves a theory forever"
          },
          {
            "id": "b",
            "zh-CN": "任何反例都不应影响模型",
            "en": "No contrary evidence should affect a model"
          },
          {
            "id": "c",
            "zh-CN": "经验研究把理论预测与观察结果比较；反例会削弱或迫使模型修正，但单一研究很少能终结复杂争论。",
            "en": "Empirical work compares theoretical predictions with observation; contrary evidence weakens or forces revision of a model, although one study rarely ends a complex debate."
          },
          {
            "id": "d",
            "zh-CN": "无法被任何证据挑战的说法更科学",
            "en": "A claim no evidence can challenge is more scientific"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "经验证据来自系统观察、数据或实验；证伪是发现可靠证据与理论的可检验预测不一致，从而拒绝或修改该预测。",
          "en": "Empirical evidence comes from systematic observation, data, or experiment. Refutation occurs when credible evidence conflicts with a testable theoretical prediction, requiring that prediction to be rejected or revised."
        }
      },
      {
        "id": "u1-34-evidence-refutation-short-1",
        "knowledgePointId": "u1-34-evidence-refutation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“经验证据与证伪”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Empirical evidence and refutation”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "经验证据与证伪：经验证据来自系统观察、数据或实验；证伪是发现可靠证据与理论的可检验预测不一致，从而拒绝或修改该预测。 理论产生明确且可观察的预测；研究设计确定数据和比较方法；证据显示预测是否得到支持；不一致促使检查测量、假设或理论机制 理论必须产生可检验预测。",
          "en": "Empirical evidence and refutation: Empirical evidence comes from systematic observation, data, or experiment. Refutation occurs when credible evidence conflicts with a testable theoretical prediction, requiring that prediction to be rejected or revised. A theory generates a clear observable prediction; Research design defines data and comparison; Evidence indicates whether the prediction is supported; Conflict prompts review of measurement, assumptions, or mechanism Theory must yield testable predictions."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "经验证据与证伪",
                "实证检验",
                "证伪主义",
                "empirical testing"
              ],
              "en": [
                "Empirical evidence and refutation",
                "empirical test",
                "falsification",
                "evidence-based economics"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "理论产生明确且可观察的预测",
                "研究设计确定数据和比较方法"
              ],
              "en": [
                "A theory generates a clear observable prediction",
                "Research design defines data and comparison"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "理论必须产生可检验预测。",
                "研究设计决定证据能回答什么。"
              ],
              "en": [
                "Theory must yield testable predictions.",
                "Research design limits what evidence can answer."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-35-equality-equity",
      "slug": "equality-equity",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            30
          ]
        }
      ],
      "prerequisites": [
        "u1-07-equity",
        "u1-31-normative-economics"
      ],
      "related": [
        "u1-18-income-distribution"
      ],
      "terms": [
        "Equality and equity",
        "平等与公平"
      ],
      "synonyms": {
        "zh-CN": [
          "机会平等",
          "结果平等",
          "equality versus equity"
        ],
        "en": [
          "equality of opportunity",
          "equality of outcome",
          "equality versus equity"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-35-equality-equity-flash-1",
        "u1-35-equality-equity-mcq-1",
        "u1-35-equality-equity-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-35-equality-equity",
        "locale": "zh-CN",
        "title": "平等与公平",
        "takeaway": "平等描述相同或较少差异的分配，公平判断分配是否公正；两者可以重合，也可能要求不同待遇。",
        "definition": "平等是资源、机会或结果相同或差异较小的状态；公平是根据明确的公正原则判断待遇与分配是否合理。",
        "causalChain": [
          "观察群体间资源、机会或结果差异",
          "确定平等指标和公平原则",
          "判断相同待遇是否能产生公正机会",
          "选择普遍或有针对性的政策回应"
        ],
        "realWorldExample": {
          "title": "不平等指标与公平判断并不相同",
          "sourceUrl": "https://www.oecd.org/en/topics/inequality-and-poverty.html",
          "observedAt": "2026-09-29",
          "explanation": "OECD 的收入分配资料可以测量群体差异，但某种差异是否公平仍取决于对需要、机会、贡献和权利的价值判断。"
        },
        "misconceptions": [
          "完全相同的投入在起点不同的情况下可能无法实现公平机会。",
          "减少一种不平等不保证其他维度的公平，例如收入更接近但服务可及性仍不同。"
        ],
        "examApplication": [
          "先说明讨论的是收入、财富、机会还是结果平等。",
          "用明确公平原则解释为什么相同或不同待遇是合理的。"
        ],
        "summary": [
          "平等可被描述和测量。",
          "公平需要规范性标准。",
          "公平有时支持差别待遇以克服不同起点。"
        ],
        "explanation": "平等关注差异程度，可以比较收入、财富、教育机会或健康结果。公平则进一步问这些差异是否由公正过程产生，以及政策应不应该改变它们。\n\n相同待遇有时公平，例如同工同酬；有时有针对性的额外支持更公平，例如为存在学习障碍的学生提供资源。关键是公开比较对象、起点和原则。"
      },
      "en": {
        "id": "u1-35-equality-equity",
        "locale": "en",
        "title": "Equality and equity",
        "takeaway": "Equality describes identical or less dispersed distributions, while equity judges whether a distribution is fair; the two may overlap or equity may require different treatment.",
        "definition": "Equality is a condition of sameness or smaller differences in resources, opportunities, or outcomes. Equity evaluates whether treatment and distribution are justified by an explicit principle of fairness.",
        "causalChain": [
          "Observe differences in resources, opportunity, or outcomes",
          "Select an equality measure and fairness principle",
          "Ask whether identical treatment creates fair opportunity",
          "Choose a universal or targeted policy response"
        ],
        "realWorldExample": {
          "title": "Inequality measurement differs from an equity judgement",
          "sourceUrl": "https://www.oecd.org/en/topics/inequality-and-poverty.html",
          "observedAt": "2026-09-29",
          "explanation": "OECD income-distribution evidence measures differences across groups. Whether a measured difference is fair still depends on value judgements about need, opportunity, contribution, and rights."
        },
        "misconceptions": [
          "Identical inputs may fail to create fair opportunity when starting positions differ.",
          "Reducing one inequality does not secure equity in another dimension; incomes may converge while service access remains unequal."
        ],
        "examApplication": [
          "Specify whether equality concerns income, wealth, opportunity, or outcome.",
          "Use a clear fairness principle to justify equal or differentiated treatment."
        ],
        "summary": [
          "Equality can be described and measured.",
          "Equity requires a normative standard.",
          "Equity may support differentiated treatment to address unequal starting points."
        ],
        "explanation": "Equality concerns the degree of difference and may refer to income, wealth, educational opportunity, or health outcomes. Equity goes further by asking whether differences follow from a fair process and whether policy ought to change them.\n\nIdentical treatment can be equitable, as with equal pay for equal work. Targeted support can also be equitable, as when extra resources address a learning barrier. A sound judgement makes the comparison, starting position, and principle explicit."
      }
    },
    "practice": [
      {
        "id": "u1-35-equality-equity-flash-1",
        "knowledgePointId": "u1-35-equality-equity",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“平等与公平”。",
          "en": "Without notes, explain “Equality and equity” in your own words."
        },
        "answer": {
          "zh-CN": "平等是资源、机会或结果相同或差异较小的状态；公平是根据明确的公正原则判断待遇与分配是否合理。",
          "en": "Equality is a condition of sameness or smaller differences in resources, opportunities, or outcomes. Equity evaluates whether treatment and distribution are justified by an explicit principle of fairness."
        },
        "explanation": {
          "zh-CN": "平等描述相同或较少差异的分配，公平判断分配是否公正；两者可以重合，也可能要求不同待遇。",
          "en": "Equality describes identical or less dispersed distributions, while equity judges whether a distribution is fair; the two may overlap or equity may require different treatment."
        }
      },
      {
        "id": "u1-35-equality-equity-mcq-1",
        "knowledgePointId": "u1-35-equality-equity",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“平等与公平”？",
          "en": "Which statement best captures “Equality and equity”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "平等与公平在所有情境都完全相同",
            "en": "Equality and equity are identical in every context"
          },
          {
            "id": "b",
            "zh-CN": "差别待遇必定不公平",
            "en": "Different treatment is always inequitable"
          },
          {
            "id": "c",
            "zh-CN": "结果完全相同就不需要说明公平标准",
            "en": "Identical outcomes remove the need for a fairness criterion"
          },
          {
            "id": "d",
            "zh-CN": "平等描述相同或较少差异的分配，公平判断分配是否公正；两者可以重合，也可能要求不同待遇。",
            "en": "Equality describes identical or less dispersed distributions, while equity judges whether a distribution is fair; the two may overlap or equity may require different treatment."
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "平等是资源、机会或结果相同或差异较小的状态；公平是根据明确的公正原则判断待遇与分配是否合理。",
          "en": "Equality is a condition of sameness or smaller differences in resources, opportunities, or outcomes. Equity evaluates whether treatment and distribution are justified by an explicit principle of fairness."
        }
      },
      {
        "id": "u1-35-equality-equity-short-1",
        "knowledgePointId": "u1-35-equality-equity",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“平等与公平”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Equality and equity”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "平等与公平：平等是资源、机会或结果相同或差异较小的状态；公平是根据明确的公正原则判断待遇与分配是否合理。 观察群体间资源、机会或结果差异；确定平等指标和公平原则；判断相同待遇是否能产生公正机会；选择普遍或有针对性的政策回应 平等可被描述和测量。",
          "en": "Equality and equity: Equality is a condition of sameness or smaller differences in resources, opportunities, or outcomes. Equity evaluates whether treatment and distribution are justified by an explicit principle of fairness. Observe differences in resources, opportunity, or outcomes; Select an equality measure and fairness principle; Ask whether identical treatment creates fair opportunity; Choose a universal or targeted policy response Equality can be described and measured."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "平等与公平",
                "机会平等",
                "结果平等",
                "equality versus equity"
              ],
              "en": [
                "Equality and equity",
                "equality of opportunity",
                "equality of outcome",
                "equality versus equity"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "观察群体间资源、机会或结果差异",
                "确定平等指标和公平原则"
              ],
              "en": [
                "Observe differences in resources, opportunity, or outcomes",
                "Select an equality measure and fairness principle"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "平等可被描述和测量。",
                "公平需要规范性标准。"
              ],
              "en": [
                "Equality can be described and measured.",
                "Equity requires a normative standard."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-36-adam-smith",
      "slug": "adam-smith",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            31,
            32
          ]
        }
      ],
      "prerequisites": [
        "u1-19-market-mechanism",
        "u1-21-free-market-economy"
      ],
      "related": [
        "u1-37-utility-marginalism",
        "u1-38-says-law"
      ],
      "terms": [
        "Adam Smith and laissez-faire",
        "亚当·斯密与自由放任"
      ],
      "synonyms": {
        "zh-CN": [
          "古典自由主义",
          "看不见的手",
          "laissez-faire"
        ],
        "en": [
          "classical liberalism",
          "invisible hand",
          "laissez-faire"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-36-adam-smith-flash-1",
        "u1-36-adam-smith-mcq-1",
        "u1-36-adam-smith-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-36-adam-smith",
        "locale": "zh-CN",
        "title": "亚当·斯密与自由放任",
        "takeaway": "斯密强调分工、交换和竞争如何协调自利行为，但其论述并非主张完全没有法律、公共品或道德约束。",
        "definition": "亚当·斯密的古典经济思想把专业化、市场交换和竞争视为财富增长的重要来源；自由放任指政府避免不必要地替代分散市场决定。",
        "causalChain": [
          "分工提高劳动专门化和熟练度",
          "交换使专业化产出能够互换",
          "价格与利润协调分散选择",
          "竞争限制部分私人权力并推动适应"
        ],
        "realWorldExample": {
          "title": "分工仍是现代生产网络的基础",
          "sourceUrl": "https://www.econlib.org/library/Enc/bios/Smith.html",
          "observedAt": "2026-09-29",
          "explanation": "Econlib 的斯密传记介绍其关于分工、交换和制度的思想。现代供应链把任务分配给专门企业，体现生产率收益，也暴露协调与依赖风险。"
        },
        "misconceptions": [
          "“看不见的手”不是任何市场结果都完美的保证。",
          "斯密承认司法、国防、公共工程和教育等国家职能，并非主张取消政府。"
        ],
        "examApplication": [
          "把分工—生产率—交换—市场扩大的逻辑链写完整。",
          "评价自由放任时同时讨论竞争条件、公共品、外部性和市场权力。"
        ],
        "summary": [
          "分工和交换支持生产率与财富增长。",
          "价格和竞争协调分散决定。",
          "市场运作仍依赖制度与公共职能。"
        ],
        "explanation": "斯密观察到分工可以通过熟练度、节省转换时间和促进工具创新提高产量。只要人们能够交换，生产者就可以专门化，并通过市场获得其他商品。\n\n自由放任更适合被理解为对不必要管制和特权的怀疑，而非无政府状态。产权、合同、竞争和公共基础设施使市场协调成为可能；垄断和权力集中则会削弱其效果。"
      },
      "en": {
        "id": "u1-36-adam-smith",
        "locale": "en",
        "title": "Adam Smith and laissez-faire",
        "takeaway": "Smith explained how specialisation, exchange, and competition can coordinate self-interested action, without arguing that law, public goods, or moral constraints are unnecessary.",
        "definition": "Adam Smith's classical economics treated specialisation, market exchange, and competition as important sources of growing wealth. Laissez-faire favours avoiding unnecessary state replacement of decentralised market decisions.",
        "causalChain": [
          "Division of labour increases specialisation and skill",
          "Exchange allows specialised outputs to be traded",
          "Prices and profit coordinate decentralised choices",
          "Competition constrains some private power and encourages adaptation"
        ],
        "realWorldExample": {
          "title": "Division of labour remains central to production networks",
          "sourceUrl": "https://www.econlib.org/library/Enc/bios/Smith.html",
          "observedAt": "2026-09-29",
          "explanation": "The Econlib biography of Smith introduces his thinking on specialisation, exchange, and institutions. Modern supply chains divide tasks across expert firms, gaining productivity while also creating coordination and dependency risks."
        },
        "misconceptions": [
          "The invisible hand is not a guarantee that every market outcome is ideal.",
          "Smith recognised roles for justice, defence, public works, and education; he did not propose abolishing government."
        ],
        "examApplication": [
          "Complete the chain from specialisation to productivity, exchange, and a wider market.",
          "Evaluation of laissez-faire should address competition, public goods, externalities, and market power."
        ],
        "summary": [
          "Specialisation and exchange support productivity and wealth.",
          "Price and competition coordinate decentralised choices.",
          "Markets still depend on institutions and public functions."
        ],
        "explanation": "Smith argued that division of labour raises output through dexterity, reduced switching time, and invention of tools. Exchange then lets producers specialise while obtaining other goods through a market.\n\nLaissez-faire is better understood as scepticism toward unnecessary controls and privileges than as the absence of the state. Property, contracts, competition, and public infrastructure enable coordination, while monopoly and concentrated power can undermine it."
      }
    },
    "practice": [
      {
        "id": "u1-36-adam-smith-flash-1",
        "knowledgePointId": "u1-36-adam-smith",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“亚当·斯密与自由放任”。",
          "en": "Without notes, explain “Adam Smith and laissez-faire” in your own words."
        },
        "answer": {
          "zh-CN": "亚当·斯密的古典经济思想把专业化、市场交换和竞争视为财富增长的重要来源；自由放任指政府避免不必要地替代分散市场决定。",
          "en": "Adam Smith's classical economics treated specialisation, market exchange, and competition as important sources of growing wealth. Laissez-faire favours avoiding unnecessary state replacement of decentralised market decisions."
        },
        "explanation": {
          "zh-CN": "斯密强调分工、交换和竞争如何协调自利行为，但其论述并非主张完全没有法律、公共品或道德约束。",
          "en": "Smith explained how specialisation, exchange, and competition can coordinate self-interested action, without arguing that law, public goods, or moral constraints are unnecessary."
        }
      },
      {
        "id": "u1-36-adam-smith-mcq-1",
        "knowledgePointId": "u1-36-adam-smith",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“亚当·斯密与自由放任”？",
          "en": "Which statement best captures “Adam Smith and laissez-faire”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "斯密强调分工、交换和竞争如何协调自利行为，但其论述并非主张完全没有法律、公共品或道德约束。",
            "en": "Smith explained how specialisation, exchange, and competition can coordinate self-interested action, without arguing that law, public goods, or moral constraints are unnecessary."
          },
          {
            "id": "b",
            "zh-CN": "斯密主张司法和公共工程都无需政府",
            "en": "Smith rejected all public justice and public works"
          },
          {
            "id": "c",
            "zh-CN": "看不见的手保证任何垄断都最优",
            "en": "The invisible hand guarantees every monopoly is optimal"
          },
          {
            "id": "d",
            "zh-CN": "分工只会减少熟练度",
            "en": "Division of labour only reduces skill"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "亚当·斯密的古典经济思想把专业化、市场交换和竞争视为财富增长的重要来源；自由放任指政府避免不必要地替代分散市场决定。",
          "en": "Adam Smith's classical economics treated specialisation, market exchange, and competition as important sources of growing wealth. Laissez-faire favours avoiding unnecessary state replacement of decentralised market decisions."
        }
      },
      {
        "id": "u1-36-adam-smith-short-1",
        "knowledgePointId": "u1-36-adam-smith",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“亚当·斯密与自由放任”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Adam Smith and laissez-faire”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "亚当·斯密与自由放任：亚当·斯密的古典经济思想把专业化、市场交换和竞争视为财富增长的重要来源；自由放任指政府避免不必要地替代分散市场决定。 分工提高劳动专门化和熟练度；交换使专业化产出能够互换；价格与利润协调分散选择；竞争限制部分私人权力并推动适应 分工和交换支持生产率与财富增长。",
          "en": "Adam Smith and laissez-faire: Adam Smith's classical economics treated specialisation, market exchange, and competition as important sources of growing wealth. Laissez-faire favours avoiding unnecessary state replacement of decentralised market decisions. Division of labour increases specialisation and skill; Exchange allows specialised outputs to be traded; Prices and profit coordinate decentralised choices; Competition constrains some private power and encourages adaptation Specialisation and exchange support productivity and wealth."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "亚当·斯密与自由放任",
                "古典自由主义",
                "看不见的手",
                "laissez-faire"
              ],
              "en": [
                "Adam Smith and laissez-faire",
                "classical liberalism",
                "invisible hand",
                "laissez-faire"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "分工提高劳动专门化和熟练度",
                "交换使专业化产出能够互换"
              ],
              "en": [
                "Division of labour increases specialisation and skill",
                "Exchange allows specialised outputs to be traded"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "分工和交换支持生产率与财富增长。",
                "价格和竞争协调分散决定。"
              ],
              "en": [
                "Specialisation and exchange support productivity and wealth.",
                "Price and competition coordinate decentralised choices."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-37-utility-marginalism",
      "slug": "utility-marginalism",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            33,
            34
          ]
        }
      ],
      "prerequisites": [
        "u1-02-microeconomics"
      ],
      "related": [
        "u1-36-adam-smith",
        "u1-42-behavioural-economics"
      ],
      "terms": [
        "Utility theory and marginalism",
        "效用理论与边际主义"
      ],
      "synonyms": {
        "zh-CN": [
          "边际革命",
          "边际效用",
          "marginal analysis"
        ],
        "en": [
          "marginal revolution",
          "marginal utility",
          "marginal analysis"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-37-utility-marginalism-flash-1",
        "u1-37-utility-marginalism-mcq-1",
        "u1-37-utility-marginalism-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-37-utility-marginalism",
        "locale": "zh-CN",
        "title": "效用理论与边际主义",
        "takeaway": "边际主义用“再增加一单位”带来的收益和成本解释选择，推动价值理论从总量与生产成本转向边际评价。",
        "definition": "效用理论把消费满足作为选择依据；边际主义关注一个变量微小增加所带来的额外效用、产出或成本，并以边际比较解释决策。",
        "causalChain": [
          "经济主体已经拥有一定数量",
          "额外一单位带来边际收益或效用",
          "获得该单位也产生边际成本",
          "主体比较两者并调整直到继续改变不再有利"
        ],
        "realWorldExample": {
          "title": "用边际思维解释用水优先顺序",
          "sourceUrl": "https://www.econlib.org/library/Enc/Marginalism.html",
          "observedAt": "2026-09-29",
          "explanation": "Econlib 对边际主义的介绍说明价值取决于额外单位的用途。水的总价值极高，但供应充足时新增一单位可能用于较低优先级用途，因此边际价值较低。"
        },
        "misconceptions": [
          "边际不等于微不足道，而是指变化中的额外一单位。",
          "总效用高并不意味着最后一单位的边际效用也高。"
        ],
        "examApplication": [
          "用边际收益与边际成本解释选择何时停止。",
          "区分总量、平均量和边际量，写明所比较的新增单位。"
        ],
        "summary": [
          "选择发生在边际。",
          "边际效用通常随消费增加而下降。",
          "最优调整取决于边际收益与边际成本的比较。"
        ],
        "explanation": "古典价值解释较强调生产成本。十九世纪边际主义者指出，实际选择取决于下一个单位能带来的用途与满足，而不是所有单位的总价值。\n\n边际分析成为现代微观经济学的重要方法。消费者比较额外消费的收益和价格，企业比较额外产出的收入和成本。它不要求变化真的无限小，而要求关注选择边缘。"
      },
      "en": {
        "id": "u1-37-utility-marginalism",
        "locale": "en",
        "title": "Utility theory and marginalism",
        "takeaway": "Marginalism explains choice through the benefit and cost of one more unit, shifting value theory from totals and production cost toward evaluation at the margin.",
        "definition": "Utility theory treats satisfaction from consumption as a basis for choice. Marginalism studies the extra utility, output, or cost created by a small increase and explains decisions through marginal comparison.",
        "causalChain": [
          "An agent already holds or produces some quantity",
          "One more unit creates a marginal benefit or utility",
          "Obtaining that unit also creates marginal cost",
          "The agent adjusts until a further change no longer improves the objective"
        ],
        "realWorldExample": {
          "title": "Marginal thinking explains priorities for water use",
          "sourceUrl": "https://www.econlib.org/library/Enc/Marginalism.html",
          "observedAt": "2026-09-29",
          "explanation": "The Econlib account of marginalism explains that value depends on the use of an additional unit. Water has enormous total value, yet when supply is abundant, the next unit may serve a low-priority use and carry a low marginal value."
        },
        "misconceptions": [
          "Marginal does not mean unimportant; it means the additional unit involved in a change.",
          "High total utility does not imply high marginal utility from the final unit."
        ],
        "examApplication": [
          "Use marginal benefit and marginal cost to explain where adjustment stops.",
          "Distinguish total, average, and marginal values and identify the additional unit being compared."
        ],
        "summary": [
          "Choice takes place at the margin.",
          "Marginal utility commonly falls as consumption rises.",
          "Optimal adjustment depends on marginal benefit relative to marginal cost."
        ],
        "explanation": "Classical accounts of value placed substantial weight on production cost. Nineteenth-century marginalists argued that an actual choice depends on the use and satisfaction available from the next unit rather than the total value of all units.\n\nMarginal analysis became a central method in modern microeconomics. Consumers compare the benefit of extra consumption with price, and firms compare extra revenue with extra cost. The change need not be literally infinitesimal; the focus is the decision edge."
      }
    },
    "practice": [
      {
        "id": "u1-37-utility-marginalism-flash-1",
        "knowledgePointId": "u1-37-utility-marginalism",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“效用理论与边际主义”。",
          "en": "Without notes, explain “Utility theory and marginalism” in your own words."
        },
        "answer": {
          "zh-CN": "效用理论把消费满足作为选择依据；边际主义关注一个变量微小增加所带来的额外效用、产出或成本，并以边际比较解释决策。",
          "en": "Utility theory treats satisfaction from consumption as a basis for choice. Marginalism studies the extra utility, output, or cost created by a small increase and explains decisions through marginal comparison."
        },
        "explanation": {
          "zh-CN": "边际主义用“再增加一单位”带来的收益和成本解释选择，推动价值理论从总量与生产成本转向边际评价。",
          "en": "Marginalism explains choice through the benefit and cost of one more unit, shifting value theory from totals and production cost toward evaluation at the margin."
        }
      },
      {
        "id": "u1-37-utility-marginalism-mcq-1",
        "knowledgePointId": "u1-37-utility-marginalism",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“效用理论与边际主义”？",
          "en": "Which statement best captures “Utility theory and marginalism”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "边际分析只看总效用而不看新增单位",
            "en": "Marginal analysis considers only total utility"
          },
          {
            "id": "b",
            "zh-CN": "边际主义用“再增加一单位”带来的收益和成本解释选择，推动价值理论从总量与生产成本转向边际评价。",
            "en": "Marginalism explains choice through the benefit and cost of one more unit, shifting value theory from totals and production cost toward evaluation at the margin."
          },
          {
            "id": "c",
            "zh-CN": "总效用高意味着每个新增单位效用都高",
            "en": "High total utility implies high utility for every extra unit"
          },
          {
            "id": "d",
            "zh-CN": "边际收益一定等于平均收益",
            "en": "Marginal benefit always equals average benefit"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "效用理论把消费满足作为选择依据；边际主义关注一个变量微小增加所带来的额外效用、产出或成本，并以边际比较解释决策。",
          "en": "Utility theory treats satisfaction from consumption as a basis for choice. Marginalism studies the extra utility, output, or cost created by a small increase and explains decisions through marginal comparison."
        }
      },
      {
        "id": "u1-37-utility-marginalism-short-1",
        "knowledgePointId": "u1-37-utility-marginalism",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“效用理论与边际主义”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Utility theory and marginalism”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "效用理论与边际主义：效用理论把消费满足作为选择依据；边际主义关注一个变量微小增加所带来的额外效用、产出或成本，并以边际比较解释决策。 经济主体已经拥有一定数量；额外一单位带来边际收益或效用；获得该单位也产生边际成本；主体比较两者并调整直到继续改变不再有利 选择发生在边际。",
          "en": "Utility theory and marginalism: Utility theory treats satisfaction from consumption as a basis for choice. Marginalism studies the extra utility, output, or cost created by a small increase and explains decisions through marginal comparison. An agent already holds or produces some quantity; One more unit creates a marginal benefit or utility; Obtaining that unit also creates marginal cost; The agent adjusts until a further change no longer improves the objective Choice takes place at the margin."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "效用理论与边际主义",
                "边际革命",
                "边际效用",
                "marginal analysis"
              ],
              "en": [
                "Utility theory and marginalism",
                "marginal revolution",
                "marginal utility",
                "marginal analysis"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "经济主体已经拥有一定数量",
                "额外一单位带来边际收益或效用"
              ],
              "en": [
                "An agent already holds or produces some quantity",
                "One more unit creates a marginal benefit or utility"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "选择发生在边际。",
                "边际效用通常随消费增加而下降。"
              ],
              "en": [
                "Choice takes place at the margin.",
                "Marginal utility commonly falls as consumption rises."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-38-says-law",
      "slug": "says-law",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            34
          ]
        }
      ],
      "prerequisites": [
        "u1-36-adam-smith"
      ],
      "related": [
        "u1-40-keynesian-revolution",
        "u1-41-monetarist-new-classical"
      ],
      "terms": [
        "Say's Law",
        "萨伊定律"
      ],
      "synonyms": {
        "zh-CN": [
          "供给创造需求",
          "市场定律",
          "Say law"
        ],
        "en": [
          "supply creates demand",
          "law of markets",
          "Say law"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-38-says-law-flash-1",
        "u1-38-says-law-mcq-1",
        "u1-38-says-law-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-38-says-law",
        "locale": "zh-CN",
        "title": "萨伊定律",
        "takeaway": "萨伊定律强调生产创造收入并支持需求，因而怀疑普遍长期供给过剩；凯恩斯后来挑战了这一自我调整结论。",
        "definition": "萨伊定律通常概括为供给创造相应需求：生产过程产生收入，使总体购买力能够吸收产出，因此全面持久的总需求不足不应在灵活市场中持续。",
        "causalChain": [
          "企业生产并支付工资、租金与利润",
          "这些要素收入形成购买力",
          "收入用于消费、储蓄或投资融资",
          "价格和利率调整使总体供求重新协调"
        ],
        "realWorldExample": {
          "title": "经济衰退检验自我调整速度",
          "sourceUrl": "https://www.econlib.org/library/Enc/SaysLaw.html",
          "observedAt": "2026-09-29",
          "explanation": "Econlib 对萨伊定律的介绍讨论生产与需求的联系。严重衰退中收入可能被持有而投资不响应，这成为凯恩斯质疑自动恢复机制的关键。"
        },
        "misconceptions": [
          "该命题不声称每一种商品都能自动售出，个别市场仍会供过于求。",
          "‘供给创造需求’不是同一企业购买自己产品，而是生产创造要素收入。"
        ],
        "examApplication": [
          "先说明生产—收入—支出的循环机制，再讨论储蓄、预期和价格刚性。",
          "与凯恩斯观点比较时聚焦总需求不足能否持续。"
        ],
        "summary": [
          "生产创造收入和潜在购买力。",
          "古典框架依赖价格与利率调整。",
          "储蓄不转化为投资时自我调整可能受阻。"
        ],
        "explanation": "萨伊定律来自古典经济学对生产和收入循环的强调。生产商品时也向劳动者和资源所有者支付收入，因此总供给同时创造了购买力来源。\n\n争议集中在收入是否一定及时转化为支出。若储蓄通过利率变化流向投资，全面过剩难以持续；若不确定性使储蓄增加而投资疲弱，总需求可能低于充分就业产出。"
      },
      "en": {
        "id": "u1-38-says-law",
        "locale": "en",
        "title": "Say's Law",
        "takeaway": "Say's Law emphasises that production creates income and supports demand, casting doubt on a persistent general glut; Keynes later challenged the speed and reliability of that adjustment.",
        "definition": "Say's Law is commonly summarised as supply creating corresponding demand: production generates income, giving the economy purchasing power to absorb output, so broad and lasting deficient demand should not persist in flexible markets.",
        "causalChain": [
          "Firms produce and pay wages, rent, and profit",
          "Factor incomes create purchasing power",
          "Income funds consumption or saving that can finance investment",
          "Price and interest-rate adjustment recoordinates aggregate supply and demand"
        ],
        "realWorldExample": {
          "title": "Recession tests the speed of self-correction",
          "sourceUrl": "https://www.econlib.org/library/Enc/SaysLaw.html",
          "observedAt": "2026-09-29",
          "explanation": "The Econlib discussion of Say's Law presents the link between production and demand. In a severe downturn, income may be hoarded while investment fails to respond, forming a central part of Keynes's objection to automatic recovery."
        },
        "misconceptions": [
          "The proposition does not mean every particular product must sell; individual markets can have excess supply.",
          "Supply creates demand through factor income, not because a producer buys its own product."
        ],
        "examApplication": [
          "Explain the production-income-spending cycle before discussing saving, expectations, and sticky prices.",
          "A comparison with Keynes should focus on whether deficient aggregate demand can persist."
        ],
        "summary": [
          "Production generates income and potential purchasing power.",
          "The classical account relies on price and interest-rate adjustment.",
          "Self-correction can fail when saving does not become investment."
        ],
        "explanation": "Say's Law emerges from the classical emphasis on the circular connection between production and income. Producing goods also pays income to workers and resource owners, so aggregate supply creates the source of purchasing power.\n\nThe dispute concerns whether that income reliably returns as expenditure. If interest-rate adjustment channels saving into investment, a general glut should be temporary. If uncertainty raises saving while investment remains weak, aggregate demand can fall below full-employment output."
      }
    },
    "practice": [
      {
        "id": "u1-38-says-law-flash-1",
        "knowledgePointId": "u1-38-says-law",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“萨伊定律”。",
          "en": "Without notes, explain “Say's Law” in your own words."
        },
        "answer": {
          "zh-CN": "萨伊定律通常概括为供给创造相应需求：生产过程产生收入，使总体购买力能够吸收产出，因此全面持久的总需求不足不应在灵活市场中持续。",
          "en": "Say's Law is commonly summarised as supply creating corresponding demand: production generates income, giving the economy purchasing power to absorb output, so broad and lasting deficient demand should not persist in flexible markets."
        },
        "explanation": {
          "zh-CN": "萨伊定律强调生产创造收入并支持需求，因而怀疑普遍长期供给过剩；凯恩斯后来挑战了这一自我调整结论。",
          "en": "Say's Law emphasises that production creates income and supports demand, casting doubt on a persistent general glut; Keynes later challenged the speed and reliability of that adjustment."
        }
      },
      {
        "id": "u1-38-says-law-mcq-1",
        "knowledgePointId": "u1-38-says-law",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“萨伊定律”？",
          "en": "Which statement best captures “Say's Law”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "萨伊定律保证每件商品都能按任意价格售出",
            "en": "Say’s law guarantees every good sells at any price"
          },
          {
            "id": "b",
            "zh-CN": "生产收入与购买力没有联系",
            "en": "Production income has no link to purchasing power"
          },
          {
            "id": "c",
            "zh-CN": "萨伊定律强调生产创造收入并支持需求，因而怀疑普遍长期供给过剩；凯恩斯后来挑战了这一自我调整结论。",
            "en": "Say's Law emphasises that production creates income and supports demand, casting doubt on a persistent general glut; Keynes later challenged the speed and reliability of that adjustment."
          },
          {
            "id": "d",
            "zh-CN": "它与需求不足能持续的凯恩斯分析完全相同",
            "en": "It is identical to Keynesian persistent-demand-deficiency analysis"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "萨伊定律通常概括为供给创造相应需求：生产过程产生收入，使总体购买力能够吸收产出，因此全面持久的总需求不足不应在灵活市场中持续。",
          "en": "Say's Law is commonly summarised as supply creating corresponding demand: production generates income, giving the economy purchasing power to absorb output, so broad and lasting deficient demand should not persist in flexible markets."
        }
      },
      {
        "id": "u1-38-says-law-short-1",
        "knowledgePointId": "u1-38-says-law",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“萨伊定律”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Say's Law”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "萨伊定律：萨伊定律通常概括为供给创造相应需求：生产过程产生收入，使总体购买力能够吸收产出，因此全面持久的总需求不足不应在灵活市场中持续。 企业生产并支付工资、租金与利润；这些要素收入形成购买力；收入用于消费、储蓄或投资融资；价格和利率调整使总体供求重新协调 生产创造收入和潜在购买力。",
          "en": "Say's Law: Say's Law is commonly summarised as supply creating corresponding demand: production generates income, giving the economy purchasing power to absorb output, so broad and lasting deficient demand should not persist in flexible markets. Firms produce and pay wages, rent, and profit; Factor incomes create purchasing power; Income funds consumption or saving that can finance investment; Price and interest-rate adjustment recoordinates aggregate supply and demand Production generates income and potential purchasing power."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "萨伊定律",
                "供给创造需求",
                "市场定律",
                "Say law"
              ],
              "en": [
                "Say's Law",
                "supply creates demand",
                "law of markets",
                "Say law"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "企业生产并支付工资、租金与利润",
                "这些要素收入形成购买力"
              ],
              "en": [
                "Firms produce and pay wages, rent, and profit",
                "Factor incomes create purchasing power"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "生产创造收入和潜在购买力。",
                "古典框架依赖价格与利率调整。"
              ],
              "en": [
                "Production generates income and potential purchasing power.",
                "The classical account relies on price and interest-rate adjustment."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-39-marxist-critique",
      "slug": "marxist-critique",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            35
          ]
        }
      ],
      "prerequisites": [
        "u1-18-income-distribution",
        "u1-21-free-market-economy"
      ],
      "related": [
        "u1-36-adam-smith",
        "u1-40-keynesian-revolution"
      ],
      "terms": [
        "The Marxist critique",
        "马克思主义批判"
      ],
      "synonyms": {
        "zh-CN": [
          "马克思经济学",
          "阶级分析",
          "剩余价值理论"
        ],
        "en": [
          "Marxian economics",
          "class analysis",
          "surplus value theory"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-39-marxist-critique-flash-1",
        "u1-39-marxist-critique-mcq-1",
        "u1-39-marxist-critique-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-39-marxist-critique",
        "locale": "zh-CN",
        "title": "马克思主义批判",
        "takeaway": "马克思主义分析把所有权、阶级关系和资本积累置于核心，质疑市场交换表面的自由是否掩盖生产权力与分配冲突。",
        "definition": "马克思主义经济批判以生产资料所有权、劳动与资本的阶级关系、剩余价值和资本积累为框架，分析资本主义的分配、权力与危机倾向。",
        "causalChain": [
          "生产资料集中在资本所有者手中",
          "无产者出售劳动力获得工资",
          "产出价值与工资之间形成剩余并被积累",
          "积累改变权力、技术、分配并可能加剧冲突"
        ],
        "realWorldExample": {
          "title": "平台劳动重新提出控制与剩余问题",
          "sourceUrl": "https://plato.stanford.edu/entries/marx/",
          "observedAt": "2026-09-29",
          "explanation": "斯坦福哲学百科的马克思条目概述异化、阶级和历史分析。数字平台中算法控制、资产所有和劳动收入的关系，可用这些问题意识研究，但具体结论仍需现代证据。"
        },
        "misconceptions": [
          "马克思主义批判不只是主张收入平均，它首先分析生产关系和所有权。",
          "历史理论不能直接替代对当代企业、劳动市场和制度的实证研究。"
        ],
        "examApplication": [
          "把所有权—劳动过程—剩余—积累的机制写清。",
          "评价时比较其对权力和分配的洞察与预测、制度多样性和历史证据。"
        ],
        "summary": [
          "所有权结构影响生产与分配权力。",
          "剩余和积累是分析核心。",
          "阶级框架强调市场交换背后的生产关系。"
        ],
        "explanation": "马克思把资本主义视为一种历史生产方式，而不只是独立买卖的集合。劳动者不拥有主要生产资料，因此通过出售劳动力参与生产；资本所有者控制投资与剩余使用。\n\n该框架强调技术变化、企业集中和危机与积累过程的联系。应用时需要区分分析概念、历史预测和规范主张，并用当代制度和数据检验哪些机制仍有解释力。"
      },
      "en": {
        "id": "u1-39-marxist-critique",
        "locale": "en",
        "title": "The Marxist critique",
        "takeaway": "Marxist analysis centres ownership, class relations, and capital accumulation, questioning whether formal freedom in exchange conceals power and distributional conflict in production.",
        "definition": "The Marxist critique uses ownership of the means of production, class relations between labour and capital, surplus value, and accumulation to analyse distribution, power, and tendencies toward crisis in capitalism.",
        "causalChain": [
          "Ownership of productive assets is concentrated among capital owners",
          "Workers sell labour power for wages",
          "A surplus between output and labour compensation is accumulated",
          "Accumulation changes power, technology, distribution, and potential conflict"
        ],
        "realWorldExample": {
          "title": "Platform work renews questions about control and surplus",
          "sourceUrl": "https://plato.stanford.edu/entries/marx/",
          "observedAt": "2026-09-29",
          "explanation": "The Stanford Encyclopedia of Philosophy entry on Marx outlines alienation, class, and historical analysis. Algorithmic control, asset ownership, and labour income in digital platforms can be studied through those questions, while modern evidence remains necessary."
        },
        "misconceptions": [
          "Marxist critique is not merely a demand for equal income; it begins with production relations and ownership.",
          "A historical theory cannot substitute directly for empirical study of current firms, labour markets, and institutions."
        ],
        "examApplication": [
          "Make the mechanism from ownership through labour, surplus, and accumulation explicit.",
          "Evaluate insights about power and distribution against predictions, institutional diversity, and historical evidence."
        ],
        "summary": [
          "Ownership structures influence power in production and distribution.",
          "Surplus and accumulation are central analytical ideas.",
          "Class analysis looks behind exchange to production relations."
        ],
        "explanation": "Marx treated capitalism as a historical mode of production, not simply a collection of voluntary trades. Workers lack ownership of the main productive assets and participate by selling labour power, while capital owners control investment and the use of surplus.\n\nThe framework connects technological change, concentration, and crisis to accumulation. Application should separate analytical concepts, historical predictions, and normative positions and test which mechanisms retain explanatory value in contemporary institutions."
      }
    },
    "practice": [
      {
        "id": "u1-39-marxist-critique-flash-1",
        "knowledgePointId": "u1-39-marxist-critique",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“马克思主义批判”。",
          "en": "Without notes, explain “The Marxist critique” in your own words."
        },
        "answer": {
          "zh-CN": "马克思主义经济批判以生产资料所有权、劳动与资本的阶级关系、剩余价值和资本积累为框架，分析资本主义的分配、权力与危机倾向。",
          "en": "The Marxist critique uses ownership of the means of production, class relations between labour and capital, surplus value, and accumulation to analyse distribution, power, and tendencies toward crisis in capitalism."
        },
        "explanation": {
          "zh-CN": "马克思主义分析把所有权、阶级关系和资本积累置于核心，质疑市场交换表面的自由是否掩盖生产权力与分配冲突。",
          "en": "Marxist analysis centres ownership, class relations, and capital accumulation, questioning whether formal freedom in exchange conceals power and distributional conflict in production."
        }
      },
      {
        "id": "u1-39-marxist-critique-mcq-1",
        "knowledgePointId": "u1-39-marxist-critique",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“马克思主义批判”？",
          "en": "Which statement best captures “The Marxist critique”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "马克思主义批判排除生产资料所有权",
            "en": "Marxist critique excludes ownership of production"
          },
          {
            "id": "b",
            "zh-CN": "剩余价值就是任何商品的消费者剩余",
            "en": "Surplus value is identical to consumer surplus"
          },
          {
            "id": "c",
            "zh-CN": "阶级关系与分配没有任何联系",
            "en": "Class relations have no link to distribution"
          },
          {
            "id": "d",
            "zh-CN": "马克思主义分析把所有权、阶级关系和资本积累置于核心，质疑市场交换表面的自由是否掩盖生产权力与分配冲突。",
            "en": "Marxist analysis centres ownership, class relations, and capital accumulation, questioning whether formal freedom in exchange conceals power and distributional conflict in production."
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "马克思主义经济批判以生产资料所有权、劳动与资本的阶级关系、剩余价值和资本积累为框架，分析资本主义的分配、权力与危机倾向。",
          "en": "The Marxist critique uses ownership of the means of production, class relations between labour and capital, surplus value, and accumulation to analyse distribution, power, and tendencies toward crisis in capitalism."
        }
      },
      {
        "id": "u1-39-marxist-critique-short-1",
        "knowledgePointId": "u1-39-marxist-critique",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“马克思主义批判”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “The Marxist critique”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "马克思主义批判：马克思主义经济批判以生产资料所有权、劳动与资本的阶级关系、剩余价值和资本积累为框架，分析资本主义的分配、权力与危机倾向。 生产资料集中在资本所有者手中；无产者出售劳动力获得工资；产出价值与工资之间形成剩余并被积累；积累改变权力、技术、分配并可能加剧冲突 所有权结构影响生产与分配权力。",
          "en": "The Marxist critique: The Marxist critique uses ownership of the means of production, class relations between labour and capital, surplus value, and accumulation to analyse distribution, power, and tendencies toward crisis in capitalism. Ownership of productive assets is concentrated among capital owners; Workers sell labour power for wages; A surplus between output and labour compensation is accumulated; Accumulation changes power, technology, distribution, and potential conflict Ownership structures influence power in production and distribution."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "马克思主义批判",
                "马克思经济学",
                "阶级分析",
                "剩余价值理论"
              ],
              "en": [
                "The Marxist critique",
                "Marxian economics",
                "class analysis",
                "surplus value theory"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "生产资料集中在资本所有者手中",
                "无产者出售劳动力获得工资"
              ],
              "en": [
                "Ownership of productive assets is concentrated among capital owners",
                "Workers sell labour power for wages"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "所有权结构影响生产与分配权力。",
                "剩余和积累是分析核心。"
              ],
              "en": [
                "Ownership structures influence power in production and distribution.",
                "Surplus and accumulation are central analytical ideas."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-40-keynesian-revolution",
      "slug": "keynesian-revolution",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            36,
            37
          ]
        }
      ],
      "prerequisites": [
        "u1-03-macroeconomics",
        "u1-38-says-law"
      ],
      "related": [
        "u1-41-monetarist-new-classical"
      ],
      "terms": [
        "The Keynesian revolution and macroeconomic policy",
        "凯恩斯革命与宏观政策"
      ],
      "synonyms": {
        "zh-CN": [
          "凯恩斯主义",
          "有效需求",
          "需求管理"
        ],
        "en": [
          "Keynesianism",
          "effective demand",
          "demand management"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-40-keynesian-revolution-flash-1",
        "u1-40-keynesian-revolution-mcq-1",
        "u1-40-keynesian-revolution-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-40-keynesian-revolution",
        "locale": "zh-CN",
        "title": "凯恩斯革命与宏观政策",
        "takeaway": "凯恩斯指出总需求不足可使经济长期低于充分就业，并由此奠定用财政和货币政策稳定宏观经济的框架。",
        "definition": "凯恩斯主义认为支出、预期和价格工资刚性会决定短期产出与就业；当私人需求不足且自我调整缓慢时，公共政策可支持总需求。",
        "causalChain": [
          "悲观预期减少消费或投资",
          "总需求下降使企业减产和裁员",
          "收入下降进一步压低支出",
          "逆周期财政或货币政策尝试打破收缩循环"
        ],
        "realWorldExample": {
          "title": "衰退中的逆周期稳定政策",
          "sourceUrl": "https://www.imf.org/external/pubs/ft/fandd/basics/keynes.htm",
          "observedAt": "2026-09-29",
          "explanation": "IMF 对凯恩斯经济学的介绍说明，经济低迷时政府支出或减税可支撑需求，繁荣时则应重建财政空间；具体乘数取决于闲置资源、开放度和政策设计。"
        },
        "misconceptions": [
          "凯恩斯主义不主张任何时期都扩大赤字，而强调逆周期管理。",
          "增加支出不会机械地产生固定乘数，挤出、进口和预期会改变效果。"
        ],
        "examApplication": [
          "用总需求—产出—就业—收入反馈解释衰退。",
          "评价稳定政策时讨论经济余量、乘数、时滞、债务和退出策略。"
        ],
        "summary": [
          "总需求可以持续低于充分就业水平。",
          "工资价格刚性减慢自我调整。",
          "宏观政策可稳定支出但受到条件约束。"
        ],
        "explanation": "大萧条挑战了市场会迅速恢复充分就业的古典观点。凯恩斯强调企业投资取决于不确定的预期，家庭收入下降又会减少消费，使需求不足自我强化。\n\n这套思想推动宏观经济学和稳定政策形成。政府预算、自动稳定器与中央银行政策被用于缓和周期，但政策时机、融资、通胀风险和长期供给仍需要权衡。"
      },
      "en": {
        "id": "u1-40-keynesian-revolution",
        "locale": "en",
        "title": "The Keynesian revolution and macroeconomic policy",
        "takeaway": "Keynes argued that deficient aggregate demand can keep an economy below full employment, establishing a framework for fiscal and monetary stabilisation policy.",
        "definition": "Keynesian economics holds that expenditure, expectations, and wage-price rigidity influence short-run output and employment, and that public policy can support aggregate demand when private demand is weak and self-correction is slow.",
        "causalChain": [
          "Pessimistic expectations reduce consumption or investment",
          "Lower aggregate demand causes firms to cut output and jobs",
          "Falling income further reduces expenditure",
          "Countercyclical fiscal or monetary policy seeks to interrupt the contraction"
        ],
        "realWorldExample": {
          "title": "Countercyclical stabilisation in a downturn",
          "sourceUrl": "https://www.imf.org/external/pubs/ft/fandd/basics/keynes.htm",
          "observedAt": "2026-09-29",
          "explanation": "The IMF introduction to Keynesian economics describes how public spending or tax reductions can support demand in a slump and why fiscal space should be rebuilt in stronger periods. The multiplier varies with slack, openness, and policy design."
        },
        "misconceptions": [
          "Keynesian policy does not prescribe larger deficits in every period; it is countercyclical.",
          "Additional spending does not produce a mechanically fixed multiplier because crowding out, imports, and expectations alter the effect."
        ],
        "examApplication": [
          "Explain recession through feedback among aggregate demand, output, employment, and income.",
          "Evaluate stabilisation through economic slack, the multiplier, time lags, debt, and an exit strategy."
        ],
        "summary": [
          "Aggregate demand can remain below full-employment output.",
          "Sticky wages and prices slow self-correction.",
          "Macroeconomic policy can stabilise spending under important conditions."
        ],
        "explanation": "The Great Depression challenged the classical expectation of rapid return to full employment. Keynes emphasised that business investment depends on uncertain expectations and that lower household income reduces consumption, allowing deficient demand to reinforce itself.\n\nThe argument helped establish macroeconomics and stabilisation policy. Government budgets, automatic stabilisers, and central-bank action can moderate a cycle, while timing, financing, inflation risk, and long-run supply still require evaluation."
      }
    },
    "practice": [
      {
        "id": "u1-40-keynesian-revolution-flash-1",
        "knowledgePointId": "u1-40-keynesian-revolution",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“凯恩斯革命与宏观政策”。",
          "en": "Without notes, explain “The Keynesian revolution and macroeconomic policy” in your own words."
        },
        "answer": {
          "zh-CN": "凯恩斯主义认为支出、预期和价格工资刚性会决定短期产出与就业；当私人需求不足且自我调整缓慢时，公共政策可支持总需求。",
          "en": "Keynesian economics holds that expenditure, expectations, and wage-price rigidity influence short-run output and employment, and that public policy can support aggregate demand when private demand is weak and self-correction is slow."
        },
        "explanation": {
          "zh-CN": "凯恩斯指出总需求不足可使经济长期低于充分就业，并由此奠定用财政和货币政策稳定宏观经济的框架。",
          "en": "Keynes argued that deficient aggregate demand can keep an economy below full employment, establishing a framework for fiscal and monetary stabilisation policy."
        }
      },
      {
        "id": "u1-40-keynesian-revolution-mcq-1",
        "knowledgePointId": "u1-40-keynesian-revolution",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“凯恩斯革命与宏观政策”？",
          "en": "Which statement best captures “The Keynesian revolution and macroeconomic policy”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "凯恩斯指出总需求不足可使经济长期低于充分就业，并由此奠定用财政和货币政策稳定宏观经济的框架。",
            "en": "Keynes argued that deficient aggregate demand can keep an economy below full employment, establishing a framework for fiscal and monetary stabilisation policy."
          },
          {
            "id": "b",
            "zh-CN": "凯恩斯认为价格工资瞬间调整可保证充分就业",
            "en": "Keynes assumed instant adjustment guarantees full employment"
          },
          {
            "id": "c",
            "zh-CN": "凯恩斯认为支出不足不可能持续",
            "en": "Keynes ruled out persistent deficient spending"
          },
          {
            "id": "d",
            "zh-CN": "任何财政扩张都保证没有通胀成本",
            "en": "Any fiscal expansion guarantees no inflation cost"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "凯恩斯主义认为支出、预期和价格工资刚性会决定短期产出与就业；当私人需求不足且自我调整缓慢时，公共政策可支持总需求。",
          "en": "Keynesian economics holds that expenditure, expectations, and wage-price rigidity influence short-run output and employment, and that public policy can support aggregate demand when private demand is weak and self-correction is slow."
        }
      },
      {
        "id": "u1-40-keynesian-revolution-short-1",
        "knowledgePointId": "u1-40-keynesian-revolution",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“凯恩斯革命与宏观政策”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “The Keynesian revolution and macroeconomic policy”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "凯恩斯革命与宏观政策：凯恩斯主义认为支出、预期和价格工资刚性会决定短期产出与就业；当私人需求不足且自我调整缓慢时，公共政策可支持总需求。 悲观预期减少消费或投资；总需求下降使企业减产和裁员；收入下降进一步压低支出；逆周期财政或货币政策尝试打破收缩循环 总需求可以持续低于充分就业水平。",
          "en": "The Keynesian revolution and macroeconomic policy: Keynesian economics holds that expenditure, expectations, and wage-price rigidity influence short-run output and employment, and that public policy can support aggregate demand when private demand is weak and self-correction is slow. Pessimistic expectations reduce consumption or investment; Lower aggregate demand causes firms to cut output and jobs; Falling income further reduces expenditure; Countercyclical fiscal or monetary policy seeks to interrupt the contraction Aggregate demand can remain below full-employment output."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "凯恩斯革命与宏观政策",
                "凯恩斯主义",
                "有效需求",
                "需求管理"
              ],
              "en": [
                "The Keynesian revolution and macroeconomic policy",
                "Keynesianism",
                "effective demand",
                "demand management"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "悲观预期减少消费或投资",
                "总需求下降使企业减产和裁员"
              ],
              "en": [
                "Pessimistic expectations reduce consumption or investment",
                "Lower aggregate demand causes firms to cut output and jobs"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "总需求可以持续低于充分就业水平。",
                "工资价格刚性减慢自我调整。"
              ],
              "en": [
                "Aggregate demand can remain below full-employment output.",
                "Sticky wages and prices slow self-correction."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-41-monetarist-new-classical",
      "slug": "monetarist-new-classical",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            38,
            39
          ]
        }
      ],
      "prerequisites": [
        "u1-40-keynesian-revolution"
      ],
      "related": [
        "u1-03-macroeconomics",
        "u1-33-ceteris-paribus"
      ],
      "terms": [
        "The monetarist and new classical counter-revolution",
        "货币主义与新古典反革命"
      ],
      "synonyms": {
        "zh-CN": [
          "货币主义",
          "新古典宏观",
          "理性预期"
        ],
        "en": [
          "monetarism",
          "new classical macroeconomics",
          "rational expectations"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-41-monetarist-new-classical-flash-1",
        "u1-41-monetarist-new-classical-mcq-1",
        "u1-41-monetarist-new-classical-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-41-monetarist-new-classical",
        "locale": "zh-CN",
        "title": "货币主义与新古典反革命",
        "takeaway": "货币主义和新古典理论重新强调货币稳定、市场调整、预期与政策可信度，并质疑积极需求管理能否持续提高实际产出。",
        "definition": "货币主义强调货币供给与名义支出及通胀的长期关系；新古典宏观理论加入理性预期和市场出清，分析可预见政策为何可能被主体行为抵消。",
        "causalChain": [
          "政策改变货币或总需求路径",
          "家庭和企业形成对通胀与政策的预期",
          "工资、价格和资产选择随预期调整",
          "长期影响更多体现为物价而非持续更高实际产出"
        ],
        "realWorldExample": {
          "title": "中央银行把通胀预期纳入政策",
          "sourceUrl": "https://www.imf.org/external/pubs/ft/fandd/basics/monetarism.htm",
          "observedAt": "2026-09-29",
          "explanation": "IMF 对货币主义的介绍强调货币增长和通胀的长期联系。现代央行会关注政策可信度与预期，因为预期可提前影响工资谈判、定价和金融条件。"
        },
        "misconceptions": [
          "货币主义不等于认为货币在所有时期以固定速度影响经济。",
          "理性预期并不表示人能完美预测，而是不会系统性忽略可用信息。"
        ],
        "examApplication": [
          "比较凯恩斯与货币主义时区分短期非中性和长期名义影响。",
          "评价规则与酌情政策时讨论信息、时滞、可信度和意外冲击。"
        ],
        "summary": [
          "长期通胀与货币和名义需求有关。",
          "预期会改变政策传导。",
          "可预见需求政策难以永久提高实际产出。"
        ],
        "explanation": "二十世纪后期的货币主义者批评对财政微调和稳定乘数的过度信赖，强调政策时滞与货币稳定。新古典理论进一步分析理性预期如何使人提前调整。\n\n这些观点推动独立中央银行、通胀目标和规则可信度的讨论。现实政策通常综合多种思想：承认短期需求波动，同时重视通胀预期、供给约束和长期可持续性。"
      },
      "en": {
        "id": "u1-41-monetarist-new-classical",
        "locale": "en",
        "title": "The monetarist and new classical counter-revolution",
        "takeaway": "Monetarist and new classical thinking renewed emphasis on monetary stability, market adjustment, expectations, and policy credibility, questioning whether activist demand management can raise real output persistently.",
        "definition": "Monetarism stresses the long-run relationship between money growth, nominal spending, and inflation. New classical macroeconomics adds rational expectations and market clearing to examine why predictable policy may be offset by agents' responses.",
        "causalChain": [
          "Policy changes the path of money or aggregate demand",
          "Households and firms form expectations about inflation and policy",
          "Wages, prices, and asset choices adjust to those expectations",
          "Long-run effects appear more in prices than in permanently higher real output"
        ],
        "realWorldExample": {
          "title": "Central banks incorporate inflation expectations",
          "sourceUrl": "https://www.imf.org/external/pubs/ft/fandd/basics/monetarism.htm",
          "observedAt": "2026-09-29",
          "explanation": "The IMF account of monetarism emphasises the long-run connection between monetary growth and inflation. Modern central banks monitor credibility and expectations because they influence wage bargaining, pricing, and financial conditions in advance."
        },
        "misconceptions": [
          "Monetarism does not claim that money affects the economy with an identical speed in every period.",
          "Rational expectations do not mean perfect prediction; they imply that available information is not ignored systematically."
        ],
        "examApplication": [
          "When comparing Keynesian and monetarist views, distinguish short-run non-neutrality from long-run nominal effects.",
          "Evaluate rules and discretion through information, lags, credibility, and unexpected shocks."
        ],
        "summary": [
          "Long-run inflation is linked to money and nominal demand.",
          "Expectations alter policy transmission.",
          "Predictable demand policy cannot permanently raise real output."
        ],
        "explanation": "Late twentieth-century monetarists criticised excessive confidence in fiscal fine-tuning and stable multipliers, drawing attention to policy lags and monetary stability. New classical models developed the role of forward-looking expectations.\n\nThese ideas shaped debates over independent central banks, inflation targets, and credible rules. Actual policymaking often combines traditions: it accepts short-run demand fluctuations while taking inflation expectations, supply constraints, and long-run sustainability seriously."
      }
    },
    "practice": [
      {
        "id": "u1-41-monetarist-new-classical-flash-1",
        "knowledgePointId": "u1-41-monetarist-new-classical",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“货币主义与新古典反革命”。",
          "en": "Without notes, explain “The monetarist and new classical counter-revolution” in your own words."
        },
        "answer": {
          "zh-CN": "货币主义强调货币供给与名义支出及通胀的长期关系；新古典宏观理论加入理性预期和市场出清，分析可预见政策为何可能被主体行为抵消。",
          "en": "Monetarism stresses the long-run relationship between money growth, nominal spending, and inflation. New classical macroeconomics adds rational expectations and market clearing to examine why predictable policy may be offset by agents' responses."
        },
        "explanation": {
          "zh-CN": "货币主义和新古典理论重新强调货币稳定、市场调整、预期与政策可信度，并质疑积极需求管理能否持续提高实际产出。",
          "en": "Monetarist and new classical thinking renewed emphasis on monetary stability, market adjustment, expectations, and policy credibility, questioning whether activist demand management can raise real output persistently."
        }
      },
      {
        "id": "u1-41-monetarist-new-classical-mcq-1",
        "knowledgePointId": "u1-41-monetarist-new-classical",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“货币主义与新古典反革命”？",
          "en": "Which statement best captures “The monetarist and new classical counter-revolution”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "货币主义认为长期货币增长与通胀毫无关系",
            "en": "Monetarism denies any long-run money-inflation link"
          },
          {
            "id": "b",
            "zh-CN": "货币主义和新古典理论重新强调货币稳定、市场调整、预期与政策可信度，并质疑积极需求管理能否持续提高实际产出。",
            "en": "Monetarist and new classical thinking renewed emphasis on monetary stability, market adjustment, expectations, and policy credibility, questioning whether activist demand management can raise real output persistently."
          },
          {
            "id": "c",
            "zh-CN": "理性预期意味着每次预测都无误",
            "en": "Rational expectations mean every forecast is correct"
          },
          {
            "id": "d",
            "zh-CN": "两种学派在全部假设上完全相同",
            "en": "The two schools share every assumption"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "货币主义强调货币供给与名义支出及通胀的长期关系；新古典宏观理论加入理性预期和市场出清，分析可预见政策为何可能被主体行为抵消。",
          "en": "Monetarism stresses the long-run relationship between money growth, nominal spending, and inflation. New classical macroeconomics adds rational expectations and market clearing to examine why predictable policy may be offset by agents' responses."
        }
      },
      {
        "id": "u1-41-monetarist-new-classical-short-1",
        "knowledgePointId": "u1-41-monetarist-new-classical",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“货币主义与新古典反革命”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “The monetarist and new classical counter-revolution”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "货币主义与新古典反革命：货币主义强调货币供给与名义支出及通胀的长期关系；新古典宏观理论加入理性预期和市场出清，分析可预见政策为何可能被主体行为抵消。 政策改变货币或总需求路径；家庭和企业形成对通胀与政策的预期；工资、价格和资产选择随预期调整；长期影响更多体现为物价而非持续更高实际产出 长期通胀与货币和名义需求有关。",
          "en": "The monetarist and new classical counter-revolution: Monetarism stresses the long-run relationship between money growth, nominal spending, and inflation. New classical macroeconomics adds rational expectations and market clearing to examine why predictable policy may be offset by agents' responses. Policy changes the path of money or aggregate demand; Households and firms form expectations about inflation and policy; Wages, prices, and asset choices adjust to those expectations; Long-run effects appear more in prices than in permanently higher real output Long-run inflation is linked to money and nominal demand."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "货币主义与新古典反革命",
                "货币主义",
                "新古典宏观",
                "理性预期"
              ],
              "en": [
                "The monetarist and new classical counter-revolution",
                "monetarism",
                "new classical macroeconomics",
                "rational expectations"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "政策改变货币或总需求路径",
                "家庭和企业形成对通胀与政策的预期"
              ],
              "en": [
                "Policy changes the path of money or aggregate demand",
                "Households and firms form expectations about inflation and policy"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "长期通胀与货币和名义需求有关。",
                "预期会改变政策传导。"
              ],
              "en": [
                "Long-run inflation is linked to money and nominal demand.",
                "Expectations alter policy transmission."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-42-behavioural-economics",
      "slug": "behavioural-economics",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            40
          ]
        }
      ],
      "prerequisites": [
        "u1-02-microeconomics",
        "u1-37-utility-marginalism"
      ],
      "related": [
        "u1-12-intervention",
        "u1-24-economic-models"
      ],
      "terms": [
        "Behavioural economics",
        "行为经济学"
      ],
      "synonyms": {
        "zh-CN": [
          "有限理性",
          "助推",
          "认知偏差经济学"
        ],
        "en": [
          "bounded rationality",
          "nudge",
          "behavioural bias"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-42-behavioural-economics-flash-1",
        "u1-42-behavioural-economics-mcq-1",
        "u1-42-behavioural-economics-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-42-behavioural-economics",
        "locale": "zh-CN",
        "title": "行为经济学",
        "takeaway": "行为经济学把有限理性、自我控制和社会偏好纳入模型，解释现实选择为何系统性偏离完全理性基准。",
        "definition": "行为经济学结合心理学和经济学，研究启发式、偏差、有限注意、自我控制问题与社会偏好如何影响经济决策。",
        "causalChain": [
          "决策者面对复杂信息和认知限制",
          "使用简化规则并受呈现方式影响",
          "实际选择偏离标准理性模型",
          "行为证据推动更真实的模型和政策设计"
        ],
        "realWorldExample": {
          "title": "默认选项改变参与行为",
          "sourceUrl": "https://www.nobelprize.org/prizes/economic-sciences/2017/press-release/",
          "observedAt": "2026-09-29",
          "explanation": "2017 年诺贝尔经济学奖资料总结 Richard Thaler 对有限理性、社会偏好和自我控制的贡献。自动加入并允许退出的默认设计常能改变储蓄或参与率。"
        },
        "misconceptions": [
          "行为经济学不是说人总是不理性，而是偏差在特定条件下具有可预测模式。",
          "助推不一定无害；选择架构也涉及透明度、操控和分配问题。"
        ],
        "examApplication": [
          "识别具体偏差及其如何改变传统模型预测。",
          "评价行为政策时比较有效性、自由、透明度和长期学习。"
        ],
        "summary": [
          "认知和自我控制限制会影响选择。",
          "框架与默认选项可改变行为。",
          "行为证据扩展而非简单替代传统经济模型。"
        ],
        "explanation": "标准模型常把决策者视为信息充分、偏好稳定且能一致优化。行为研究通过实验和现实数据发现，损失厌恶、现状偏好、有限注意和社会规范会系统性影响选择。\n\n这些发现既用于解释，也用于政策设计。改变表格、提醒或默认选项可能改善结果，但政策制定者必须检验不同群体反应，并保护知情选择。"
      },
      "en": {
        "id": "u1-42-behavioural-economics",
        "locale": "en",
        "title": "Behavioural economics",
        "takeaway": "Behavioural economics incorporates bounded rationality, self-control, and social preferences to explain systematic departures from a fully rational benchmark.",
        "definition": "Behavioural economics combines psychology and economics to study how heuristics, biases, limited attention, self-control problems, and social preferences shape economic decisions.",
        "causalChain": [
          "Decision-makers face complexity and cognitive limits",
          "They use shortcuts and respond to framing",
          "Observed choices depart from the standard rational benchmark",
          "Behavioural evidence informs richer models and policy design"
        ],
        "realWorldExample": {
          "title": "Default options change participation",
          "sourceUrl": "https://www.nobelprize.org/prizes/economic-sciences/2017/press-release/",
          "observedAt": "2026-09-29",
          "explanation": "The 2017 Nobel Prize material summarises Richard Thaler's work on limited rationality, social preferences, and self-control. Automatic enrolment with an option to leave often changes saving or participation rates."
        },
        "misconceptions": [
          "Behavioural economics does not claim that people are always irrational; it identifies predictable patterns under particular conditions.",
          "A nudge is not automatically benign; choice architecture raises questions of transparency, manipulation, and distribution."
        ],
        "examApplication": [
          "Identify a specific bias and show how it changes the standard model's prediction.",
          "Evaluate behavioural policy through effectiveness, freedom, transparency, and long-run learning."
        ],
        "summary": [
          "Cognitive and self-control limits affect choice.",
          "Framing and defaults can change behaviour.",
          "Behavioural evidence extends rather than simply replaces standard models."
        ],
        "explanation": "Standard models often represent agents as informed, consistent optimisers with stable preferences. Experiments and field evidence reveal systematic effects from loss aversion, status-quo bias, limited attention, and social norms.\n\nThe findings inform both explanation and intervention. A different form, reminder, or default can improve an outcome, but policymakers still need to test responses across groups and preserve informed choice."
      }
    },
    "practice": [
      {
        "id": "u1-42-behavioural-economics-flash-1",
        "knowledgePointId": "u1-42-behavioural-economics",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“行为经济学”。",
          "en": "Without notes, explain “Behavioural economics” in your own words."
        },
        "answer": {
          "zh-CN": "行为经济学结合心理学和经济学，研究启发式、偏差、有限注意、自我控制问题与社会偏好如何影响经济决策。",
          "en": "Behavioural economics combines psychology and economics to study how heuristics, biases, limited attention, self-control problems, and social preferences shape economic decisions."
        },
        "explanation": {
          "zh-CN": "行为经济学把有限理性、自我控制和社会偏好纳入模型，解释现实选择为何系统性偏离完全理性基准。",
          "en": "Behavioural economics incorporates bounded rationality, self-control, and social preferences to explain systematic departures from a fully rational benchmark."
        }
      },
      {
        "id": "u1-42-behavioural-economics-mcq-1",
        "knowledgePointId": "u1-42-behavioural-economics",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“行为经济学”？",
          "en": "Which statement best captures “Behavioural economics”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "行为经济学认为人永远随机且没有目标",
            "en": "Behavioural economics assumes people are always random and goalless"
          },
          {
            "id": "b",
            "zh-CN": "所有默认选项都是强制禁令",
            "en": "Every default is a compulsory ban"
          },
          {
            "id": "c",
            "zh-CN": "行为经济学把有限理性、自我控制和社会偏好纳入模型，解释现实选择为何系统性偏离完全理性基准。",
            "en": "Behavioural economics incorporates bounded rationality, self-control, and social preferences to explain systematic departures from a fully rational benchmark."
          },
          {
            "id": "d",
            "zh-CN": "心理因素不可能改变经济决策",
            "en": "Psychology cannot affect economic decisions"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "行为经济学结合心理学和经济学，研究启发式、偏差、有限注意、自我控制问题与社会偏好如何影响经济决策。",
          "en": "Behavioural economics combines psychology and economics to study how heuristics, biases, limited attention, self-control problems, and social preferences shape economic decisions."
        }
      },
      {
        "id": "u1-42-behavioural-economics-short-1",
        "knowledgePointId": "u1-42-behavioural-economics",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“行为经济学”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Behavioural economics”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "行为经济学：行为经济学结合心理学和经济学，研究启发式、偏差、有限注意、自我控制问题与社会偏好如何影响经济决策。 决策者面对复杂信息和认知限制；使用简化规则并受呈现方式影响；实际选择偏离标准理性模型；行为证据推动更真实的模型和政策设计 认知和自我控制限制会影响选择。",
          "en": "Behavioural economics: Behavioural economics combines psychology and economics to study how heuristics, biases, limited attention, self-control problems, and social preferences shape economic decisions. Decision-makers face complexity and cognitive limits; They use shortcuts and respond to framing; Observed choices depart from the standard rational benchmark; Behavioural evidence informs richer models and policy design Cognitive and self-control limits affect choice."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "行为经济学",
                "有限理性",
                "助推",
                "认知偏差经济学"
              ],
              "en": [
                "Behavioural economics",
                "bounded rationality",
                "nudge",
                "behavioural bias"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "决策者面对复杂信息和认知限制",
                "使用简化规则并受呈现方式影响"
              ],
              "en": [
                "Decision-makers face complexity and cognitive limits",
                "They use shortcuts and respond to framing"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "认知和自我控制限制会影响选择。",
                "框架与默认选项可改变行为。"
              ],
              "en": [
                "Cognitive and self-control limits affect choice.",
                "Framing and defaults can change behaviour."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-43-circular-economy",
      "slug": "circular-economy",
      "section": "1.2",
      "level": "core",
      "syllabusRefs": [
        "1.2 How do economists approach the world?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.2",
          "pages": [
            41
          ]
        }
      ],
      "prerequisites": [
        "u1-09-sustainability",
        "u1-11-interdependence"
      ],
      "related": [
        "u1-17-resource-allocation",
        "u1-20-government-intervention"
      ],
      "terms": [
        "Interdependence and the circular economy",
        "相互依存与循环经济"
      ],
      "synonyms": {
        "zh-CN": [
          "循环性",
          "闭环经济",
          "经济社会环境相互依存"
        ],
        "en": [
          "circularity",
          "closed-loop economy",
          "economy society environment interdependence"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u1-43-circular-economy-flash-1",
        "u1-43-circular-economy-mcq-1",
        "u1-43-circular-economy-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-43-circular-economy",
        "locale": "zh-CN",
        "title": "相互依存与循环经济",
        "takeaway": "循环经济把经济、社会与环境视为相互依存系统，通过减少材料投入、延长使用和回收价值来替代“开采—生产—丢弃”。",
        "definition": "循环经济是一种设计和组织生产消费的框架，目标是减少资源开采和废弃物，在产品、部件和材料层级维持价值，并促进自然系统恢复。",
        "causalChain": [
          "线性生产开采资源并产生废弃物",
          "设计减少材料并延长产品寿命",
          "维修、再用、再制造和回收形成闭环",
          "较低原生资源需求减轻生态压力并改变商业模式"
        ],
        "realWorldExample": {
          "title": "联合国环境署推动循环性",
          "sourceUrl": "https://www.unep.org/circularity",
          "observedAt": "2026-09-29",
          "explanation": "联合国环境署的循环性工作把资源开采、气候、生物多样性和污染联系起来，强调产品设计、商业模式和公共政策需要协同，而不仅是末端回收。"
        },
        "misconceptions": [
          "循环经济不等于只增加回收；优先级通常从避免、减量和再用开始。",
          "循环过程也使用能源和资源，不可能在所有材料上实现百分之百闭环。"
        ],
        "examApplication": [
          "从产品生命周期追踪资源、价值和废弃物流。",
          "评价时讨论设计激励、基础设施、消费者行为、反弹效应和公平转型。"
        ],
        "summary": [
          "经济活动依赖社会与自然系统。",
          "循环策略在废弃前保留产品和材料价值。",
          "实现循环需要企业、消费者和政府协作。"
        ],
        "explanation": "线性模式从环境取出材料，生产、消费后把残余排回环境。循环框架尝试在设计阶段减少投入，让产品可维护、可共享、可再制造，并在最后回收材料。\n\n循环转型展示相互依存：企业需要回收网络和稳定标准，消费者需要便利与信息，政府可用产品责任、采购和定价政策改变激励。最终成效取决于全生命周期资源节约，而不是单一回收率。"
      },
      "en": {
        "id": "u1-43-circular-economy",
        "locale": "en",
        "title": "Interdependence and the circular economy",
        "takeaway": "A circular economy treats the economy, society, and environment as interdependent systems and replaces take-make-dispose with lower material use, longer use, and retained value.",
        "definition": "A circular economy is a framework for designing and organising production and consumption to reduce extraction and waste, retain value in products, components, and materials, and support regeneration of natural systems.",
        "causalChain": [
          "Linear production extracts resources and generates waste",
          "Design reduces material use and extends product life",
          "Repair, reuse, remanufacture, and recycling create loops",
          "Lower primary-resource demand reduces ecological pressure and changes business models"
        ],
        "realWorldExample": {
          "title": "UN Environment Programme promotes circularity",
          "sourceUrl": "https://www.unep.org/circularity",
          "observedAt": "2026-09-29",
          "explanation": "UNEP work on circularity links resource extraction to climate, biodiversity, and pollution. It emphasises coordinated product design, business models, and public policy rather than relying only on end-of-pipe recycling."
        },
        "misconceptions": [
          "A circular economy is not simply more recycling; prevention, reduction, and reuse usually come first.",
          "Circular processes also use energy and resources, so a perfect loop for every material is not realistic."
        ],
        "examApplication": [
          "Trace resource, value, and waste flows across the whole product life cycle.",
          "Evaluate design incentives, infrastructure, consumer behaviour, rebound effects, and a just transition."
        ],
        "summary": [
          "Economic activity depends on social and natural systems.",
          "Circular strategies preserve product and material value before disposal.",
          "Firms, consumers, and governments must coordinate the transition."
        ],
        "explanation": "A linear model extracts material from the environment, produces and consumes, and returns residuals as waste. Circular design reduces inputs, makes products maintainable and shareable, supports remanufacture, and recovers materials at the end.\n\nThe transition demonstrates interdependence. Firms need collection networks and stable standards, consumers need convenience and information, and government can reshape incentives through producer responsibility, procurement, and pricing. Success depends on life-cycle resource savings rather than a recycling rate alone."
      }
    },
    "practice": [
      {
        "id": "u1-43-circular-economy-flash-1",
        "knowledgePointId": "u1-43-circular-economy",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“相互依存与循环经济”。",
          "en": "Without notes, explain “Interdependence and the circular economy” in your own words."
        },
        "answer": {
          "zh-CN": "循环经济是一种设计和组织生产消费的框架，目标是减少资源开采和废弃物，在产品、部件和材料层级维持价值，并促进自然系统恢复。",
          "en": "A circular economy is a framework for designing and organising production and consumption to reduce extraction and waste, retain value in products, components, and materials, and support regeneration of natural systems."
        },
        "explanation": {
          "zh-CN": "循环经济把经济、社会与环境视为相互依存系统，通过减少材料投入、延长使用和回收价值来替代“开采—生产—丢弃”。",
          "en": "A circular economy treats the economy, society, and environment as interdependent systems and replaces take-make-dispose with lower material use, longer use, and retained value."
        }
      },
      {
        "id": "u1-43-circular-economy-mcq-1",
        "knowledgePointId": "u1-43-circular-economy",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“相互依存与循环经济”？",
          "en": "Which statement best captures “Interdependence and the circular economy”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "循环经济就是收入循环模型",
            "en": "The circular economy is the circular flow of income"
          },
          {
            "id": "b",
            "zh-CN": "只增加末端回收足以替代一切设计改进",
            "en": "More end-stage recycling replaces every design improvement"
          },
          {
            "id": "c",
            "zh-CN": "循环意味着资源和能源不再稀缺",
            "en": "Circularity ends all resource and energy scarcity"
          },
          {
            "id": "d",
            "zh-CN": "循环经济把经济、社会与环境视为相互依存系统，通过减少材料投入、延长使用和回收价值来替代“开采—生产—丢弃”。",
            "en": "A circular economy treats the economy, society, and environment as interdependent systems and replaces take-make-dispose with lower material use, longer use, and retained value."
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "循环经济是一种设计和组织生产消费的框架，目标是减少资源开采和废弃物，在产品、部件和材料层级维持价值，并促进自然系统恢复。",
          "en": "A circular economy is a framework for designing and organising production and consumption to reduce extraction and waste, retain value in products, components, and materials, and support regeneration of natural systems."
        }
      },
      {
        "id": "u1-43-circular-economy-short-1",
        "knowledgePointId": "u1-43-circular-economy",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“相互依存与循环经济”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Interdependence and the circular economy”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "相互依存与循环经济：循环经济是一种设计和组织生产消费的框架，目标是减少资源开采和废弃物，在产品、部件和材料层级维持价值，并促进自然系统恢复。 线性生产开采资源并产生废弃物；设计减少材料并延长产品寿命；维修、再用、再制造和回收形成闭环；较低原生资源需求减轻生态压力并改变商业模式 经济活动依赖社会与自然系统。",
          "en": "Interdependence and the circular economy: A circular economy is a framework for designing and organising production and consumption to reduce extraction and waste, retain value in products, components, and materials, and support regeneration of natural systems. Linear production extracts resources and generates waste; Design reduces material use and extends product life; Repair, reuse, remanufacture, and recycling create loops; Lower primary-resource demand reduces ecological pressure and changes business models Economic activity depends on social and natural systems."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "相互依存与循环经济",
                "循环性",
                "闭环经济",
                "经济社会环境相互依存"
              ],
              "en": [
                "Interdependence and the circular economy",
                "circularity",
                "closed-loop economy",
                "economy society environment interdependence"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "线性生产开采资源并产生废弃物",
                "设计减少材料并延长产品寿命"
              ],
              "en": [
                "Linear production extracts resources and generates waste",
                "Design reduces material use and extends product life"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "经济活动依赖社会与自然系统。",
                "循环策略在废弃前保留产品和材料价值。"
              ],
              "en": [
                "Economic activity depends on social and natural systems.",
                "Circular strategies preserve product and material value before disposal."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u1-44-circular-flow",
      "slug": "circular-flow",
      "section": "1.1",
      "level": "core",
      "syllabusRefs": [
        "1.1 What is economics?"
      ],
      "textbookRefs": [
        {
          "chapter": "1",
          "section": "1.1",
          "pages": [
            15
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u3-01-circular-flow"
      ],
      "terms": [
        "Circular flow, leakages and injections",
        "收入循环、漏出与注入"
      ],
      "synonyms": {
        "zh-CN": [
          "收入循环",
          "漏出",
          "注入"
        ],
        "en": [
          "circular flow",
          "leakages",
          "injections"
        ]
      },
      "diagramIds": [
        "audit-circular-flow"
      ],
      "quizIds": [
        "u1-44-circular-flow-flash-1",
        "u1-44-circular-flow-mcq-1",
        "u1-44-circular-flow-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u1-44-circular-flow",
        "locale": "zh-CN",
        "title": "收入循环、漏出与注入",
        "takeaway": "收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。",
        "definition": "收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。",
        "causalChain": [
          "家庭提供生产要素获得收入",
          "收入用于消费或漏出",
          "注入支出支持企业销售与下一轮收入"
        ],
        "realWorldExample": {
          "title": "原创家庭与企业情境",
          "sourceUrl": "https://www.bankofengland.co.uk/education/education-resources",
          "observedAt": "2026-10-18",
          "explanation": "家庭提供劳动获得工资并购买产出；储蓄、税收、进口为漏出，投资、政府购买、出口为注入。这是模型教学情境，不是国家观测。"
        },
        "misconceptions": [
          "储蓄不是消失的货币；金融部门可将资金引向投资，但不能假设两者自动同时相等。"
        ],
        "examApplication": [
          "写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
        ],
        "summary": [
          "收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。",
          "储蓄不是消失的货币；金融部门可将资金引向投资，但不能假设两者自动同时相等。"
        ],
        "explanation": "家庭提供生产要素获得收入。收入用于消费或漏出。注入支出支持企业销售与下一轮收入。\n\n### 原创情境与推导\n\n原创例：家庭向企业提供劳动并获得工资，再购买企业产出。储蓄 S、税收 T、进口 M 是漏出，投资 I、政府购买 G、出口 X 是注入。简单稳定均衡要求计划注入与漏出相等；这不是说各项分别相等。\n\n储蓄不是消失的货币；金融部门可将资金引向投资，但不能假设两者自动同时相等。\n\n写清指标、公式、单位和局限；区分名义、实际、总量与人均。\n\n实际流量指要素与商品，货币流量指支付。两部门模型省略金融、政府和国外，五部门模型明确其联系。"
      },
      "en": {
        "id": "u1-44-circular-flow",
        "locale": "en",
        "title": "Circular flow, leakages and injections",
        "takeaway": "The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions.",
        "definition": "The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions.",
        "causalChain": [
          "Households supply factors and receive income",
          "income funds consumption or leakages",
          "injections support firms' sales and the next round of income"
        ],
        "realWorldExample": {
          "title": "Original household–firm scenario",
          "sourceUrl": "https://www.bankofengland.co.uk/education/education-resources",
          "observedAt": "2026-10-18",
          "explanation": "Households provide labour and receive wages, then buy output. Saving, taxes and imports are leakages; investment, government purchases and exports are injections. This is a model illustration, not an observed country case."
        },
        "misconceptions": [
          "Saving is not money that vanishes; finance can channel funds into investment without making planned saving and investment automatically identical."
        ],
        "examApplication": [
          "State indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
        ],
        "summary": [
          "The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions.",
          "Saving is not money that vanishes; finance can channel funds into investment without making planned saving and investment automatically identical."
        ],
        "explanation": "Households supply factors and receive income.  income funds consumption or leakages.  injections support firms' sales and the next round of income.\n\n### Original scenario and reasoning\n\nIllustrative example: households supply labour, receive wages and buy firms' output. S, T and M are leakages; I, G and X are injections. Simple steady equilibrium requires planned injections to equal planned leakages, not each individual item to equal its counterpart.\n\nSaving is not money that vanishes; finance can channel funds into investment without making planned saving and investment automatically identical.\n\nState indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures.\n\nReal flows describe factors and goods; money flows describe payments. A two-sector model omits banks, government and foreign trade, while the five-sector version makes their links explicit."
      }
    },
    "practice": [
      {
        "id": "u1-44-circular-flow-flash-1",
        "knowledgePointId": "u1-44-circular-flow",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "不看笔记，用自己的话解释“收入循环、漏出与注入”。",
          "en": "Without notes, explain “Circular flow, leakages and injections” in your own words."
        },
        "answer": {
          "zh-CN": "收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。",
          "en": "The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions."
        },
        "explanation": {
          "zh-CN": "收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。",
          "en": "The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions."
        }
      },
      {
        "id": "u1-44-circular-flow-mcq-1",
        "knowledgePointId": "u1-44-circular-flow",
        "type": "mcq",
        "prompt": {
          "zh-CN": "下列哪一项最准确地概括“收入循环、漏出与注入”？",
          "en": "Which statement best captures “Circular flow, leakages and injections”?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。",
            "en": "The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions."
          },
          {
            "id": "b",
            "zh-CN": "储蓄、税收、进口都是注入",
            "en": "Saving, taxes and imports are all injections"
          },
          {
            "id": "c",
            "zh-CN": "实际流量与货币流量是完全相同的东西",
            "en": "Real and money flows are identical"
          },
          {
            "id": "d",
            "zh-CN": "五部门模型不包含家庭",
            "en": "The five-sector model excludes households"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。",
          "en": "The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions."
        }
      },
      {
        "id": "u1-44-circular-flow-short-1",
        "knowledgePointId": "u1-44-circular-flow",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "简要解释“收入循环、漏出与注入”，并写出一条因果机制和一个重要含义。",
          "en": "Briefly explain “Circular flow, leakages and injections”, including one causal mechanism and one important implication."
        },
        "modelAnswer": {
          "zh-CN": "收入循环、漏出与注入：收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。 家庭提供生产要素获得收入；收入用于消费或漏出；注入支出支持企业销售与下一轮收入 收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。",
          "en": "Circular flow, leakages and injections: The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions. Households supply factors and receive income; income funds consumption or leakages; injections support firms' sales and the next round of income The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions."
        },
        "keywordGroups": [
          {
            "id": "concept",
            "label": {
              "zh-CN": "核心概念",
              "en": "Core concept"
            },
            "alternatives": {
              "zh-CN": [
                "收入循环、漏出与注入",
                "收入循环",
                "漏出",
                "注入"
              ],
              "en": [
                "Circular flow, leakages and injections",
                "circular flow",
                "leakages",
                "injections"
              ]
            }
          },
          {
            "id": "mechanism",
            "label": {
              "zh-CN": "因果机制",
              "en": "Causal mechanism"
            },
            "alternatives": {
              "zh-CN": [
                "家庭提供生产要素获得收入",
                "收入用于消费或漏出"
              ],
              "en": [
                "Households supply factors and receive income",
                "income funds consumption or leakages"
              ]
            }
          },
          {
            "id": "implication",
            "label": {
              "zh-CN": "重要含义",
              "en": "Important implication"
            },
            "alternatives": {
              "zh-CN": [
                "收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。",
                "储蓄不是消失的货币；金融部门可将资金引向投资，但不能假设两者自动同时相等。"
              ],
              "en": [
                "The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions.",
                "Saving is not money that vanishes; finance can channel funds into investment without making planned saving and investment automatically identical."
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "系统按核心概念、因果机制和重要含义三个关键词组计算覆盖率；你可以查看依据并手动修正最终判定。",
          "en": "Coverage is calculated across the core concept, causal mechanism, and implication groups; you can inspect and override the final judgement."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-01-demand",
      "slug": "demand",
      "section": "2.1",
      "level": "core",
      "syllabusRefs": [
        "2.1 Demand"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.2",
          "pages": [
            43
          ]
        }
      ],
      "prerequisites": [
        "u1-04-scarcity",
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u2-02-law-of-demand",
        "u2-03-demand-shifts",
        "u2-04-market-demand"
      ],
      "terms": [
        "需求与需求量",
        "Demand and quantity demanded",
        "需求量",
        "quantity demanded",
        "自身价格",
        "own price",
        "沿曲线",
        "along"
      ],
      "synonyms": {
        "zh-CN": [
          "需求量",
          "自身价格",
          "沿曲线"
        ],
        "en": [
          "quantity demanded",
          "own price",
          "along"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-01-demand-flash-1",
        "u2-01-demand-mcq-1",
        "u2-01-demand-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-01-demand",
        "locale": "zh-CN",
        "title": "需求与需求量",
        "takeaway": "需求是消费者在给定时期、不同价格下愿意且能够购买的数量关系；需求量是其中某一个价格对应的数量。",
        "definition": "需求是消费者在给定时期、不同价格下愿意且能够购买的数量关系；需求量是其中某一个价格对应的数量。",
        "causalChain": [
          "愿望需要购买能力支持",
          "固定收入等条件",
          "价格改变时沿同一需求曲线移动"
        ],
        "misconceptions": [
          "想买但无力支付的数量不属于有效需求。"
        ],
        "examApplication": [
          "画图区分沿曲线移动与移动曲线，并明确其他条件。"
        ],
        "summary": [
          "需求是消费者在给定时期、不同价格下愿意且能够购买的数量关系；需求量是其中某一个价格对应的数量。",
          "想买但无力支付的数量不属于有效需求。"
        ],
        "explanation": "愿望需要购买能力支持。固定收入等条件。价格改变时沿同一需求曲线移动。\n\n### 原创情境与推导\n\n原创例：咖啡从每杯 6 元降到 4 元，某人每周从买 2 杯变为 4 杯。这是需求量增加。若收入和偏好没有变，不能把它画成需求曲线右移。\n\n想买但无力支付的数量不属于有效需求。\n\n画图区分沿曲线移动与移动曲线，并明确其他条件。"
      },
      "en": {
        "id": "u2-01-demand",
        "locale": "en",
        "title": "Demand and quantity demanded",
        "takeaway": "Demand relates the quantities consumers are willing and able to buy at different prices during a specified period. Quantity demanded is the quantity at one particular price.",
        "definition": "Demand relates the quantities consumers are willing and able to buy at different prices during a specified period. Quantity demanded is the quantity at one particular price.",
        "causalChain": [
          "Willingness requires purchasing power",
          "hold income and other conditions constant",
          "a price change moves the buyer along the same demand curve"
        ],
        "misconceptions": [
          "Wanting a good without the ability to pay does not constitute effective demand."
        ],
        "examApplication": [
          "Distinguish movements along demand from shifts and state the ceteris paribus assumptions."
        ],
        "summary": [
          "Demand relates the quantities consumers are willing and able to buy at different prices during a specified period. Quantity demanded is the quantity at one particular price.",
          "Wanting a good without the ability to pay does not constitute effective demand."
        ],
        "explanation": "Willingness requires purchasing power.  hold income and other conditions constant.  a price change moves the buyer along the same demand curve.\n\n### Original scenario and reasoning\n\nIllustrative example: coffee falls from 6 to 4 per cup and weekly purchases rise from two to four. Quantity demanded rises. With income and tastes unchanged, this is a movement along the curve, not a rightward shift.\n\nWanting a good without the ability to pay does not constitute effective demand.\n\nDistinguish movements along demand from shifts and state the ceteris paribus assumptions."
      }
    },
    "practice": [
      {
        "id": "u2-01-demand-flash-1",
        "knowledgePointId": "u2-01-demand",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“需求与需求量”，并说明一个关键条件。",
          "en": "Explain Demand and quantity demanded and state one important condition."
        },
        "answer": {
          "zh-CN": "需求是消费者在给定时期、不同价格下愿意且能够购买的数量关系；需求量是其中某一个价格对应的数量。",
          "en": "Demand relates the quantities consumers are willing and able to buy at different prices during a specified period. Quantity demanded is the quantity at one particular price."
        },
        "explanation": {
          "zh-CN": "想买但无力支付的数量不属于有效需求。",
          "en": "Wanting a good without the ability to pay does not constitute effective demand."
        }
      },
      {
        "id": "u2-01-demand-mcq-1",
        "knowledgePointId": "u2-01-demand",
        "type": "mcq",
        "prompt": {
          "zh-CN": "仅商品自身价格下降，应怎样画图？",
          "en": "How should a fall only in the good's own price be shown?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "沿需求曲线向右下移动",
            "en": "Move down and right along demand"
          },
          {
            "id": "b",
            "zh-CN": "需求曲线右移",
            "en": "Shift demand right"
          },
          {
            "id": "c",
            "zh-CN": "需求曲线左移",
            "en": "Shift demand left"
          },
          {
            "id": "d",
            "zh-CN": "供给曲线右移",
            "en": "Shift supply right"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "沿需求曲线向右下移动。 愿望需要购买能力支持；固定收入等条件；价格改变时沿同一需求曲线移动 想买但无力支付的数量不属于有效需求。",
          "en": "Move down and right along demand. Willingness requires purchasing power; hold income and other conditions constant; a price change moves the buyer along the same demand curve Wanting a good without the ability to pay does not constitute effective demand."
        }
      },
      {
        "id": "u2-01-demand-short-1",
        "knowledgePointId": "u2-01-demand",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释需求与需求量的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Demand and quantity demanded and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "需求是消费者在给定时期、不同价格下愿意且能够购买的数量关系；需求量是其中某一个价格对应的数量。 愿望需要购买能力支持；固定收入等条件；价格改变时沿同一需求曲线移动 原创例：咖啡从每杯 6 元降到 4 元，某人每周从买 2 杯变为 4 杯。这是需求量增加。若收入和偏好没有变，不能把它画成需求曲线右移。",
          "en": "Demand relates the quantities consumers are willing and able to buy at different prices during a specified period. Quantity demanded is the quantity at one particular price. Willingness requires purchasing power; hold income and other conditions constant; a price change moves the buyer along the same demand curve Illustrative example: coffee falls from 6 to 4 per cup and weekly purchases rise from two to four. Quantity demanded rises. With income and tastes unchanged, this is a movement along the curve, not a rightward shift."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "需求量",
              "en": "quantity demanded"
            },
            "alternatives": {
              "zh-CN": [
                "需求量",
                "愿望需要购买能力支持"
              ],
              "en": [
                "quantity demanded",
                "Willingness requires purchasing power"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "自身价格",
              "en": "own price"
            },
            "alternatives": {
              "zh-CN": [
                "自身价格",
                "固定收入等条件"
              ],
              "en": [
                "own price",
                "hold income and other conditions constant"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "沿曲线",
              "en": "along"
            },
            "alternatives": {
              "zh-CN": [
                "沿曲线",
                "价格改变时沿同一需求曲线移动"
              ],
              "en": [
                "along",
                "a price change moves the buyer along the same demand curve"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-02-law-of-demand",
      "slug": "law-of-demand",
      "section": "2.1",
      "level": "core",
      "syllabusRefs": [
        "2.1 Demand"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.2",
          "pages": [
            43
          ]
        }
      ],
      "prerequisites": [
        "u1-04-scarcity",
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u2-01-demand",
        "u2-03-demand-shifts",
        "u2-04-market-demand"
      ],
      "terms": [
        "需求定律",
        "The law of demand",
        "自身价格",
        "own price",
        "其他条件不变",
        "other things equal",
        "沿曲线",
        "along the curve"
      ],
      "synonyms": {
        "zh-CN": [
          "自身价格",
          "其他条件不变",
          "沿曲线"
        ],
        "en": [
          "own price",
          "other things equal",
          "along the curve"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-02-law-of-demand-flash-1",
        "u2-02-law-of-demand-mcq-1",
        "u2-02-law-of-demand-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-02-law-of-demand",
        "locale": "zh-CN",
        "title": "需求定律",
        "takeaway": "其他条件不变时，商品价格上升通常导致需求量减少，价格下降通常导致需求量增加。",
        "definition": "其他条件不变时，商品价格上升通常导致需求量减少，价格下降通常导致需求量增加。",
        "causalChain": [
          "自身价格与需求量反向变化",
          "收入等其他因素保持不变",
          "在既定需求曲线上比较数量"
        ],
        "misconceptions": [
          "曲线向下倾斜是有条件的关系，不能把相关性当成无条件因果。"
        ],
        "examApplication": [
          "画图区分沿曲线移动与移动曲线，并明确其他条件。"
        ],
        "summary": [
          "其他条件不变时，商品价格上升通常导致需求量减少，价格下降通常导致需求量增加。",
          "曲线向下倾斜是有条件的关系，不能把相关性当成无条件因果。"
        ],
        "explanation": "自身价格与需求量反向变化。收入等其他因素保持不变。在既定需求曲线上比较数量。\n\n### 原创情境与推导\n\n原创例：公交票价提高，其他条件不变时需求量通常下降，这是沿曲线移动。收入效应与替代效应的推导属于 HL 深入。\n\n曲线向下倾斜是有条件的关系，不能把相关性当成无条件因果。\n\n画图区分沿曲线移动与移动曲线，并明确其他条件。"
      },
      "en": {
        "id": "u2-02-law-of-demand",
        "locale": "en",
        "title": "The law of demand",
        "takeaway": "Ceteris paribus, a higher price normally reduces quantity demanded and a lower price increases it.",
        "definition": "Ceteris paribus, a higher price normally reduces quantity demanded and a lower price increases it.",
        "causalChain": [
          "Own price and quantity demanded move inversely",
          "hold income and other determinants constant",
          "compare quantities on the existing demand curve"
        ],
        "misconceptions": [
          "A downward slope is a conditional relationship, not unconditional causation inferred from correlation."
        ],
        "examApplication": [
          "Distinguish movements along demand from shifts and state the ceteris paribus assumptions."
        ],
        "summary": [
          "Ceteris paribus, a higher price normally reduces quantity demanded and a lower price increases it.",
          "A downward slope is a conditional relationship, not unconditional causation inferred from correlation."
        ],
        "explanation": "Own price and quantity demanded move inversely.  hold income and other determinants constant.  compare quantities on the existing demand curve.\n\n### Original scenario and reasoning\n\nIllustrative example: a bus fare rises and, other things equal, quantity demanded normally falls along the curve. Deriving income and substitution effects is HL detail.\n\nA downward slope is a conditional relationship, not unconditional causation inferred from correlation.\n\nDistinguish movements along demand from shifts and state the ceteris paribus assumptions."
      }
    },
    "practice": [
      {
        "id": "u2-02-law-of-demand-flash-1",
        "knowledgePointId": "u2-02-law-of-demand",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“需求定律”，并说明一个关键条件。",
          "en": "Explain The law of demand and state one important condition."
        },
        "answer": {
          "zh-CN": "其他条件不变时，商品价格上升通常导致需求量减少，价格下降通常导致需求量增加。",
          "en": "Ceteris paribus, a higher price normally reduces quantity demanded and a lower price increases it."
        },
        "explanation": {
          "zh-CN": "曲线向下倾斜是有条件的关系，不能把相关性当成无条件因果。",
          "en": "A downward slope is a conditional relationship, not unconditional causation inferred from correlation."
        }
      },
      {
        "id": "u2-02-law-of-demand-mcq-1",
        "knowledgePointId": "u2-02-law-of-demand",
        "type": "mcq",
        "prompt": {
          "zh-CN": "只有商品自身价格上升，需求量通常怎样变化？",
          "en": "Only the good’s own price rises. What normally happens to quantity demanded?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "需求曲线必定右移",
            "en": "Demand necessarily shifts right"
          },
          {
            "id": "b",
            "zh-CN": "沿原需求曲线减少",
            "en": "It falls along the existing demand curve"
          },
          {
            "id": "c",
            "zh-CN": "供给曲线必定左移",
            "en": "Supply necessarily shifts left"
          },
          {
            "id": "d",
            "zh-CN": "需求量必定增加",
            "en": "Quantity demanded necessarily rises"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "沿原需求曲线减少。 自身价格与需求量反向变化；收入等其他因素保持不变；在既定需求曲线上比较数量 曲线向下倾斜是有条件的关系，不能把相关性当成无条件因果。",
          "en": "It falls along the existing demand curve. Own price and quantity demanded move inversely; hold income and other determinants constant; compare quantities on the existing demand curve A downward slope is a conditional relationship, not unconditional causation inferred from correlation."
        }
      },
      {
        "id": "u2-02-law-of-demand-short-1",
        "knowledgePointId": "u2-02-law-of-demand",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释需求定律的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of The law of demand and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "其他条件不变时，商品价格上升通常导致需求量减少，价格下降通常导致需求量增加。 自身价格与需求量反向变化；收入等其他因素保持不变；在既定需求曲线上比较数量 原创例：公交票价提高，其他条件不变时需求量通常下降，这是沿曲线移动。收入效应与替代效应的推导属于 HL 深入。",
          "en": "Ceteris paribus, a higher price normally reduces quantity demanded and a lower price increases it. Own price and quantity demanded move inversely; hold income and other determinants constant; compare quantities on the existing demand curve Illustrative example: a bus fare rises and, other things equal, quantity demanded normally falls along the curve. Deriving income and substitution effects is HL detail."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "自身价格",
              "en": "own price"
            },
            "alternatives": {
              "zh-CN": [
                "自身价格",
                "自身价格与需求量反向变化"
              ],
              "en": [
                "own price",
                "Own price and quantity demanded move inversely"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "其他条件不变",
              "en": "other things equal"
            },
            "alternatives": {
              "zh-CN": [
                "其他条件不变",
                "收入等其他因素保持不变"
              ],
              "en": [
                "other things equal",
                "hold income and other determinants constant"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "沿曲线",
              "en": "along the curve"
            },
            "alternatives": {
              "zh-CN": [
                "沿曲线",
                "在既定需求曲线上比较数量"
              ],
              "en": [
                "along the curve",
                "compare quantities on the existing demand curve"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-03-demand-shifts",
      "slug": "demand-shifts",
      "section": "2.1",
      "level": "core",
      "syllabusRefs": [
        "2.1 Demand"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.2",
          "pages": [
            43
          ]
        }
      ],
      "prerequisites": [
        "u1-04-scarcity",
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u2-01-demand",
        "u2-02-law-of-demand",
        "u2-04-market-demand"
      ],
      "terms": [
        "需求的非价格决定因素",
        "Non-price determinants of demand",
        "收入",
        "income",
        "每个价格",
        "every price",
        "右移",
        "right"
      ],
      "synonyms": {
        "zh-CN": [
          "收入",
          "每个价格",
          "右移"
        ],
        "en": [
          "income",
          "every price",
          "right"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-03-demand-shifts-flash-1",
        "u2-03-demand-shifts-mcq-1",
        "u2-03-demand-shifts-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-03-demand-shifts",
        "locale": "zh-CN",
        "title": "需求的非价格决定因素",
        "takeaway": "收入、偏好、相关商品价格、预期和购买者数量变化，会改变每一个价格下的需求量，从而移动需求曲线。",
        "definition": "收入、偏好、相关商品价格、预期和购买者数量变化，会改变每一个价格下的需求量，从而移动需求曲线。",
        "causalChain": [
          "一个非自身价格因素改变",
          "相同价格下购买意愿或能力改变",
          "整条需求曲线移动"
        ],
        "misconceptions": [
          "收入上升对劣等品可能使需求左移，不能一概画右移。"
        ],
        "examApplication": [
          "画图区分沿曲线移动与移动曲线，并明确其他条件。"
        ],
        "summary": [
          "收入、偏好、相关商品价格、预期和购买者数量变化，会改变每一个价格下的需求量，从而移动需求曲线。",
          "收入上升对劣等品可能使需求左移，不能一概画右移。"
        ],
        "explanation": "一个非自身价格因素改变。相同价格下购买意愿或能力改变。整条需求曲线移动。\n\n### 原创情境与推导\n\n原创例：茶和咖啡是替代品。茶变贵会使咖啡需求右移；咖啡机和咖啡是互补品，咖啡机变贵可能使咖啡需求左移。必须明确分析的是哪一种商品。\n\n收入上升对劣等品可能使需求左移，不能一概画右移。\n\n画图区分沿曲线移动与移动曲线，并明确其他条件。"
      },
      "en": {
        "id": "u2-03-demand-shifts",
        "locale": "en",
        "title": "Non-price determinants of demand",
        "takeaway": "Income, tastes, related-good prices, expectations and the number of buyers can change quantity demanded at every price, shifting demand.",
        "definition": "Income, tastes, related-good prices, expectations and the number of buyers can change quantity demanded at every price, shifting demand.",
        "causalChain": [
          "A determinant other than own price changes",
          "willingness or ability changes at the same price",
          "the whole demand curve shifts"
        ],
        "misconceptions": [
          "Higher income can shift demand for an inferior good left, so income increases do not always shift demand right."
        ],
        "examApplication": [
          "Distinguish movements along demand from shifts and state the ceteris paribus assumptions."
        ],
        "summary": [
          "Income, tastes, related-good prices, expectations and the number of buyers can change quantity demanded at every price, shifting demand.",
          "Higher income can shift demand for an inferior good left, so income increases do not always shift demand right."
        ],
        "explanation": "A determinant other than own price changes.  willingness or ability changes at the same price.  the whole demand curve shifts.\n\n### Original scenario and reasoning\n\nIllustrative example: tea and coffee are substitutes, so dearer tea shifts coffee demand right. Coffee machines and coffee are complements, so dearer machines may shift coffee demand left. Always name the market being analysed.\n\nHigher income can shift demand for an inferior good left, so income increases do not always shift demand right.\n\nDistinguish movements along demand from shifts and state the ceteris paribus assumptions."
      }
    },
    "practice": [
      {
        "id": "u2-03-demand-shifts-flash-1",
        "knowledgePointId": "u2-03-demand-shifts",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“需求的非价格决定因素”，并说明一个关键条件。",
          "en": "Explain Non-price determinants of demand and state one important condition."
        },
        "answer": {
          "zh-CN": "收入、偏好、相关商品价格、预期和购买者数量变化，会改变每一个价格下的需求量，从而移动需求曲线。",
          "en": "Income, tastes, related-good prices, expectations and the number of buyers can change quantity demanded at every price, shifting demand."
        },
        "explanation": {
          "zh-CN": "收入上升对劣等品可能使需求左移，不能一概画右移。",
          "en": "Higher income can shift demand for an inferior good left, so income increases do not always shift demand right."
        }
      },
      {
        "id": "u2-03-demand-shifts-mcq-1",
        "knowledgePointId": "u2-03-demand-shifts",
        "type": "mcq",
        "prompt": {
          "zh-CN": "正常品的消费者收入增加，自身价格未变，会怎样？",
          "en": "Income rises for buyers of a normal good while its price is unchanged. What happens?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "仅沿原曲线移动",
            "en": "Only a movement along the original curve"
          },
          {
            "id": "b",
            "zh-CN": "需求必然左移",
            "en": "Demand necessarily shifts left"
          },
          {
            "id": "c",
            "zh-CN": "需求右移",
            "en": "Demand shifts right"
          },
          {
            "id": "d",
            "zh-CN": "供给必然左移",
            "en": "Supply necessarily shifts left"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "需求右移。 一个非自身价格因素改变；相同价格下购买意愿或能力改变；整条需求曲线移动 收入上升对劣等品可能使需求左移，不能一概画右移。",
          "en": "Demand shifts right. A determinant other than own price changes; willingness or ability changes at the same price; the whole demand curve shifts Higher income can shift demand for an inferior good left, so income increases do not always shift demand right."
        }
      },
      {
        "id": "u2-03-demand-shifts-short-1",
        "knowledgePointId": "u2-03-demand-shifts",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释需求的非价格决定因素的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Non-price determinants of demand and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "收入、偏好、相关商品价格、预期和购买者数量变化，会改变每一个价格下的需求量，从而移动需求曲线。 一个非自身价格因素改变；相同价格下购买意愿或能力改变；整条需求曲线移动 原创例：茶和咖啡是替代品。茶变贵会使咖啡需求右移；咖啡机和咖啡是互补品，咖啡机变贵可能使咖啡需求左移。必须明确分析的是哪一种商品。",
          "en": "Income, tastes, related-good prices, expectations and the number of buyers can change quantity demanded at every price, shifting demand. A determinant other than own price changes; willingness or ability changes at the same price; the whole demand curve shifts Illustrative example: tea and coffee are substitutes, so dearer tea shifts coffee demand right. Coffee machines and coffee are complements, so dearer machines may shift coffee demand left. Always name the market being analysed."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "收入",
              "en": "income"
            },
            "alternatives": {
              "zh-CN": [
                "收入",
                "一个非自身价格因素改变"
              ],
              "en": [
                "income",
                "A determinant other than own price changes"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "每个价格",
              "en": "every price"
            },
            "alternatives": {
              "zh-CN": [
                "每个价格",
                "相同价格下购买意愿或能力改变"
              ],
              "en": [
                "every price",
                "willingness or ability changes at the same price"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "右移",
              "en": "right"
            },
            "alternatives": {
              "zh-CN": [
                "右移",
                "整条需求曲线移动"
              ],
              "en": [
                "right",
                "the whole demand curve shifts"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-04-market-demand",
      "slug": "market-demand",
      "section": "2.1",
      "level": "core",
      "syllabusRefs": [
        "2.1 Demand"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.2",
          "pages": [
            43
          ]
        }
      ],
      "prerequisites": [
        "u1-04-scarcity",
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u2-01-demand",
        "u2-02-law-of-demand",
        "u2-03-demand-shifts"
      ],
      "terms": [
        "个人需求与市场需求",
        "Individual and market demand",
        "相同价格",
        "same price",
        "数量",
        "quantities",
        "加总",
        "sum"
      ],
      "synonyms": {
        "zh-CN": [
          "相同价格",
          "数量",
          "加总"
        ],
        "en": [
          "same price",
          "quantities",
          "sum"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-04-market-demand-flash-1",
        "u2-04-market-demand-mcq-1",
        "u2-04-market-demand-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-04-market-demand",
        "locale": "zh-CN",
        "title": "个人需求与市场需求",
        "takeaway": "市场需求是在同一个价格下，将市场内各消费者的个人需求量相加得到的总需求关系。",
        "definition": "市场需求是在同一个价格下，将市场内各消费者的个人需求量相加得到的总需求关系。",
        "causalChain": [
          "先固定一个价格",
          "加总每个消费者的需求量",
          "在其他价格重复以形成市场曲线"
        ],
        "misconceptions": [
          "市场需求不是各人的平均需求，也不是竖直相加价格。"
        ],
        "examApplication": [
          "画图区分沿曲线移动与移动曲线，并明确其他条件。"
        ],
        "summary": [
          "市场需求是在同一个价格下，将市场内各消费者的个人需求量相加得到的总需求关系。",
          "市场需求不是各人的平均需求，也不是竖直相加价格。"
        ],
        "explanation": "先固定一个价格。加总每个消费者的需求量。在其他价格重复以形成市场曲线。\n\n### 原创情境与推导\n\n原创例：价格为 5 元时，甲需求 3 个、乙需求 7 个，市场需求量为 10 个。价格为 8 元时，两人可能只买 1 个和 2 个，市场需求量为 3 个。价格不能相加。\n\n市场需求不是各人的平均需求，也不是竖直相加价格。\n\n画图区分沿曲线移动与移动曲线，并明确其他条件。"
      },
      "en": {
        "id": "u2-04-market-demand",
        "locale": "en",
        "title": "Individual and market demand",
        "takeaway": "Market demand is the horizontal sum of individual quantities demanded at each common price.",
        "definition": "Market demand is the horizontal sum of individual quantities demanded at each common price.",
        "causalChain": [
          "Fix a common price",
          "add each consumer's quantity demanded",
          "repeat at other prices to construct market demand"
        ],
        "misconceptions": [
          "Market demand is neither average individual demand nor a vertical sum of prices."
        ],
        "examApplication": [
          "Distinguish movements along demand from shifts and state the ceteris paribus assumptions."
        ],
        "summary": [
          "Market demand is the horizontal sum of individual quantities demanded at each common price.",
          "Market demand is neither average individual demand nor a vertical sum of prices."
        ],
        "explanation": "Fix a common price.  add each consumer's quantity demanded.  repeat at other prices to construct market demand.\n\n### Original scenario and reasoning\n\nIllustrative example: at a price of 5, A buys three units and B buys seven, so market quantity demanded is ten. At a price of 8 they may buy one and two, yielding three. Add quantities, never prices.\n\nMarket demand is neither average individual demand nor a vertical sum of prices.\n\nDistinguish movements along demand from shifts and state the ceteris paribus assumptions."
      }
    },
    "practice": [
      {
        "id": "u2-04-market-demand-flash-1",
        "knowledgePointId": "u2-04-market-demand",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“个人需求与市场需求”，并说明一个关键条件。",
          "en": "Explain Individual and market demand and state one important condition."
        },
        "answer": {
          "zh-CN": "市场需求是在同一个价格下，将市场内各消费者的个人需求量相加得到的总需求关系。",
          "en": "Market demand is the horizontal sum of individual quantities demanded at each common price."
        },
        "explanation": {
          "zh-CN": "市场需求不是各人的平均需求，也不是竖直相加价格。",
          "en": "Market demand is neither average individual demand nor a vertical sum of prices."
        }
      },
      {
        "id": "u2-04-market-demand-mcq-1",
        "knowledgePointId": "u2-04-market-demand",
        "type": "mcq",
        "prompt": {
          "zh-CN": "同价下三人分别买 2、4、6 个，市场需求量是多少？",
          "en": "At the same price, three buyers demand 2, 4 and 6 units. What is market quantity?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "4",
            "en": "4"
          },
          {
            "id": "b",
            "zh-CN": "6",
            "en": "6"
          },
          {
            "id": "c",
            "zh-CN": "24",
            "en": "24"
          },
          {
            "id": "d",
            "zh-CN": "12",
            "en": "12"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "12。 2 + 4 + 6 = 12 市场需求不是各人的平均需求，也不是竖直相加价格。",
          "en": "12. 2 + 4 + 6 = 12 Market demand is neither average individual demand nor a vertical sum of prices."
        }
      },
      {
        "id": "u2-04-market-demand-short-1",
        "knowledgePointId": "u2-04-market-demand",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释个人需求与市场需求的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Individual and market demand and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "市场需求是在同一个价格下，将市场内各消费者的个人需求量相加得到的总需求关系。 先固定一个价格；加总每个消费者的需求量；在其他价格重复以形成市场曲线 原创例：价格为 5 元时，甲需求 3 个、乙需求 7 个，市场需求量为 10 个。价格为 8 元时，两人可能只买 1 个和 2 个，市场需求量为 3 个。价格不能相加。",
          "en": "Market demand is the horizontal sum of individual quantities demanded at each common price. Fix a common price; add each consumer's quantity demanded; repeat at other prices to construct market demand Illustrative example: at a price of 5, A buys three units and B buys seven, so market quantity demanded is ten. At a price of 8 they may buy one and two, yielding three. Add quantities, never prices."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "相同价格",
              "en": "same price"
            },
            "alternatives": {
              "zh-CN": [
                "相同价格",
                "先固定一个价格"
              ],
              "en": [
                "same price",
                "Fix a common price"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "数量",
              "en": "quantities"
            },
            "alternatives": {
              "zh-CN": [
                "数量",
                "加总每个消费者的需求量"
              ],
              "en": [
                "quantities",
                "add each consumer's quantity demanded"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "加总",
              "en": "sum"
            },
            "alternatives": {
              "zh-CN": [
                "加总",
                "在其他价格重复以形成市场曲线"
              ],
              "en": [
                "sum",
                "repeat at other prices to construct market demand"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-05-marginal-utility",
      "slug": "marginal-utility",
      "section": "2.1",
      "level": "hl",
      "syllabusRefs": [
        "2.1 Demand"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.2",
          "pages": [
            43
          ]
        }
      ],
      "prerequisites": [
        "u1-04-scarcity",
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u2-01-demand",
        "u2-02-law-of-demand",
        "u2-03-demand-shifts"
      ],
      "terms": [
        "边际效用与消费者选择",
        "Marginal utility and consumer choice",
        "额外",
        "extra",
        "递减",
        "diminishing",
        "MU/P",
        "MU/P"
      ],
      "synonyms": {
        "zh-CN": [
          "额外",
          "递减",
          "MU/P"
        ],
        "en": [
          "extra",
          "diminishing",
          "MU/P"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-05-marginal-utility-flash-1",
        "u2-05-marginal-utility-mcq-1",
        "u2-05-marginal-utility-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-05-marginal-utility",
        "locale": "zh-CN",
        "title": "边际效用与消费者选择",
        "takeaway": "边际效用是多消费一单位商品带来的额外满足；边际效用递减指其他条件不变时，连续增加消费带来的额外满足下降。",
        "definition": "边际效用是多消费一单位商品带来的额外满足；边际效用递减指其他条件不变时，连续增加消费带来的额外满足下降。",
        "causalChain": [
          "连续单位满足越来越不迫切的用途",
          "额外效用下降",
          "消费者比较每单位支出的边际效用"
        ],
        "misconceptions": [
          "边际效用递减不等于总效用递减。"
        ],
        "examApplication": [
          "画图区分沿曲线移动与移动曲线，并明确其他条件。"
        ],
        "summary": [
          "边际效用是多消费一单位商品带来的额外满足；边际效用递减指其他条件不变时，连续增加消费带来的额外满足下降。",
          "边际效用递减不等于总效用递减。"
        ],
        "explanation": "连续单位满足越来越不迫切的用途。额外效用下降。消费者比较每单位支出的边际效用。\n\n### 原创情境与推导\n\n原创例：连续三杯饮料的边际效用为 12、8、3，总效用为 23。边际效用下降时，总效用仍可上升。理性分配预算时比较 MU/P；MU 不是可以直接观察的客观幸福指标。 HL 推导：价格上升产生替代效应；对正常品，实际购买力下降的收入效应也减少购买，二者共同解释需求向下倾斜。\n\n边际效用递减不等于总效用递减。\n\n画图区分沿曲线移动与移动曲线，并明确其他条件。"
      },
      "en": {
        "id": "u2-05-marginal-utility",
        "locale": "en",
        "title": "Marginal utility and consumer choice",
        "takeaway": "Marginal utility is the extra satisfaction from an additional unit. Diminishing marginal utility means this extra satisfaction falls as consumption increases, ceteris paribus.",
        "definition": "Marginal utility is the extra satisfaction from an additional unit. Diminishing marginal utility means this extra satisfaction falls as consumption increases, ceteris paribus.",
        "causalChain": [
          "Successive units satisfy less urgent uses",
          "extra utility falls",
          "consumers compare marginal utility per unit of spending"
        ],
        "misconceptions": [
          "Diminishing marginal utility is not the same as diminishing total utility."
        ],
        "examApplication": [
          "Distinguish movements along demand from shifts and state the ceteris paribus assumptions."
        ],
        "summary": [
          "Marginal utility is the extra satisfaction from an additional unit. Diminishing marginal utility means this extra satisfaction falls as consumption increases, ceteris paribus.",
          "Diminishing marginal utility is not the same as diminishing total utility."
        ],
        "explanation": "Successive units satisfy less urgent uses.  extra utility falls.  consumers compare marginal utility per unit of spending.\n\n### Original scenario and reasoning\n\nIllustrative example: three drinks yield marginal utilities of 12, 8 and 3, giving total utility of 23. Total utility rises despite falling marginal utility. Rational budget allocation compares MU/P, although utility is not an objectively observable happiness measure. HL derivation: a price rise induces substitution away from the good; for a normal good the loss of purchasing power also lowers purchases through the income effect.\n\nDiminishing marginal utility is not the same as diminishing total utility.\n\nDistinguish movements along demand from shifts and state the ceteris paribus assumptions."
      }
    },
    "practice": [
      {
        "id": "u2-05-marginal-utility-flash-1",
        "knowledgePointId": "u2-05-marginal-utility",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“边际效用与消费者选择”，并说明一个关键条件。",
          "en": "Explain Marginal utility and consumer choice and state one important condition."
        },
        "answer": {
          "zh-CN": "边际效用是多消费一单位商品带来的额外满足；边际效用递减指其他条件不变时，连续增加消费带来的额外满足下降。",
          "en": "Marginal utility is the extra satisfaction from an additional unit. Diminishing marginal utility means this extra satisfaction falls as consumption increases, ceteris paribus."
        },
        "explanation": {
          "zh-CN": "边际效用递减不等于总效用递减。",
          "en": "Diminishing marginal utility is not the same as diminishing total utility."
        }
      },
      {
        "id": "u2-05-marginal-utility-mcq-1",
        "knowledgePointId": "u2-05-marginal-utility",
        "type": "mcq",
        "prompt": {
          "zh-CN": "前三单位 MU 为 9、6、2，总效用增加多少？",
          "en": "The first three units have MU 9, 6 and 2. How much total utility is gained?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "17",
            "en": "17"
          },
          {
            "id": "b",
            "zh-CN": "2",
            "en": "2"
          },
          {
            "id": "c",
            "zh-CN": "9",
            "en": "9"
          },
          {
            "id": "d",
            "zh-CN": "54",
            "en": "54"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "17。 9 + 6 + 2 = 17 边际效用递减不等于总效用递减。",
          "en": "17. 9 + 6 + 2 = 17 Diminishing marginal utility is not the same as diminishing total utility."
        }
      },
      {
        "id": "u2-05-marginal-utility-short-1",
        "knowledgePointId": "u2-05-marginal-utility",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释边际效用与消费者选择的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Marginal utility and consumer choice and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "边际效用是多消费一单位商品带来的额外满足；边际效用递减指其他条件不变时，连续增加消费带来的额外满足下降。 连续单位满足越来越不迫切的用途；额外效用下降；消费者比较每单位支出的边际效用 原创例：连续三杯饮料的边际效用为 12、8、3，总效用为 23。边际效用下降时，总效用仍可上升。理性分配预算时比较 MU/P；MU 不是可以直接观察的客观幸福指标。 HL 推导：价格上升产生替代效应；对正常品，实际购买力下降的收入效应也减少购买，二者共同解释需求向下倾斜。",
          "en": "Marginal utility is the extra satisfaction from an additional unit. Diminishing marginal utility means this extra satisfaction falls as consumption increases, ceteris paribus. Successive units satisfy less urgent uses; extra utility falls; consumers compare marginal utility per unit of spending Illustrative example: three drinks yield marginal utilities of 12, 8 and 3, giving total utility of 23. Total utility rises despite falling marginal utility. Rational budget allocation compares MU/P, although utility is not an objectively observable happiness measure. HL derivation: a price rise induces substitution away from the good; for a normal good the loss of purchasing power also lowers purchases through the income effect."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "额外",
              "en": "extra"
            },
            "alternatives": {
              "zh-CN": [
                "额外",
                "连续单位满足越来越不迫切的用途"
              ],
              "en": [
                "extra",
                "Successive units satisfy less urgent uses"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "递减",
              "en": "diminishing"
            },
            "alternatives": {
              "zh-CN": [
                "递减",
                "额外效用下降"
              ],
              "en": [
                "diminishing",
                "extra utility falls"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "MU/P",
              "en": "MU/P"
            },
            "alternatives": {
              "zh-CN": [
                "MU/P",
                "消费者比较每单位支出的边际效用"
              ],
              "en": [
                "MU/P",
                "consumers compare marginal utility per unit of spending"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-06-supply",
      "slug": "supply",
      "section": "2.2",
      "level": "core",
      "syllabusRefs": [
        "2.2 Supply"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.3",
          "pages": [
            49
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u2-07-supply-shifts",
        "u2-08-market-supply",
        "u2-09-diminishing-returns"
      ],
      "terms": [
        "供给与供给量",
        "Supply and quantity supplied",
        "自身价格",
        "own price",
        "收益",
        "return",
        "沿曲线",
        "along"
      ],
      "synonyms": {
        "zh-CN": [
          "自身价格",
          "收益",
          "沿曲线"
        ],
        "en": [
          "own price",
          "return",
          "along"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-06-supply-flash-1",
        "u2-06-supply-mcq-1",
        "u2-06-supply-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-06-supply",
        "locale": "zh-CN",
        "title": "供给与供给量",
        "takeaway": "供给是生产者在给定时期、不同价格下愿意且能够出售的数量关系；供给量是某一个价格下的数量。",
        "definition": "供给是生产者在给定时期、不同价格下愿意且能够出售的数量关系；供给量是某一个价格下的数量。",
        "causalChain": [
          "其他生产条件保持不变",
          "价格上升提高额外生产的收益",
          "供给量通常沿原曲线增加"
        ],
        "misconceptions": [
          "供给不等于仓库存货；存货只有在相应价格下愿意出售才进入供给。"
        ],
        "examApplication": [
          "写清商品自身价格、成本与时间的不同作用。"
        ],
        "summary": [
          "供给是生产者在给定时期、不同价格下愿意且能够出售的数量关系；供给量是某一个价格下的数量。",
          "供给不等于仓库存货；存货只有在相应价格下愿意出售才进入供给。"
        ],
        "explanation": "其他生产条件保持不变。价格上升提高额外生产的收益。供给量通常沿原曲线增加。\n\n### 原创情境与推导\n\n原创例：蛋糕价格从 20 升到 25 元，糕点师延长工作时间而多做 10 个。若投入价格和技术未变，这是沿供给曲线移动，不是供给曲线右移。\n\n供给不等于仓库存货；存货只有在相应价格下愿意出售才进入供给。\n\n写清商品自身价格、成本与时间的不同作用。"
      },
      "en": {
        "id": "u2-06-supply",
        "locale": "en",
        "title": "Supply and quantity supplied",
        "takeaway": "Supply relates quantities producers are willing and able to sell at different prices during a period. Quantity supplied is the quantity at one price.",
        "definition": "Supply relates quantities producers are willing and able to sell at different prices during a period. Quantity supplied is the quantity at one price.",
        "causalChain": [
          "Hold production conditions constant",
          "a higher price increases the return on extra production",
          "quantity supplied normally rises along the curve"
        ],
        "misconceptions": [
          "Supply is not simply inventory; inventory enters supply when the producer is willing to sell it at the relevant price."
        ],
        "examApplication": [
          "Separate own price, costs and time when explaining supply."
        ],
        "summary": [
          "Supply relates quantities producers are willing and able to sell at different prices during a period. Quantity supplied is the quantity at one price.",
          "Supply is not simply inventory; inventory enters supply when the producer is willing to sell it at the relevant price."
        ],
        "explanation": "Hold production conditions constant.  a higher price increases the return on extra production.  quantity supplied normally rises along the curve.\n\n### Original scenario and reasoning\n\nIllustrative example: cake prices rise from 20 to 25 and a baker works longer to make ten more. With input prices and technology unchanged, this is a movement along supply, not a shift.\n\nSupply is not simply inventory; inventory enters supply when the producer is willing to sell it at the relevant price.\n\nSeparate own price, costs and time when explaining supply."
      }
    },
    "practice": [
      {
        "id": "u2-06-supply-flash-1",
        "knowledgePointId": "u2-06-supply",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“供给与供给量”，并说明一个关键条件。",
          "en": "Explain Supply and quantity supplied and state one important condition."
        },
        "answer": {
          "zh-CN": "供给是生产者在给定时期、不同价格下愿意且能够出售的数量关系；供给量是某一个价格下的数量。",
          "en": "Supply relates quantities producers are willing and able to sell at different prices during a period. Quantity supplied is the quantity at one price."
        },
        "explanation": {
          "zh-CN": "供给不等于仓库存货；存货只有在相应价格下愿意出售才进入供给。",
          "en": "Supply is not simply inventory; inventory enters supply when the producer is willing to sell it at the relevant price."
        }
      },
      {
        "id": "u2-06-supply-mcq-1",
        "knowledgePointId": "u2-06-supply",
        "type": "mcq",
        "prompt": {
          "zh-CN": "商品自身价格上升，其他条件不变，通常出现什么？",
          "en": "Own price rises with other conditions unchanged. What normally follows?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "供给曲线左移",
            "en": "Supply shifts left"
          },
          {
            "id": "b",
            "zh-CN": "沿供给曲线增加供给量",
            "en": "Higher quantity supplied along supply"
          },
          {
            "id": "c",
            "zh-CN": "供给曲线右移",
            "en": "Supply shifts right"
          },
          {
            "id": "d",
            "zh-CN": "需求曲线必然右移",
            "en": "Demand necessarily shifts right"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "沿供给曲线增加供给量。 其他生产条件保持不变；价格上升提高额外生产的收益；供给量通常沿原曲线增加 供给不等于仓库存货；存货只有在相应价格下愿意出售才进入供给。",
          "en": "Higher quantity supplied along supply. Hold production conditions constant; a higher price increases the return on extra production; quantity supplied normally rises along the curve Supply is not simply inventory; inventory enters supply when the producer is willing to sell it at the relevant price."
        }
      },
      {
        "id": "u2-06-supply-short-1",
        "knowledgePointId": "u2-06-supply",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释供给与供给量的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Supply and quantity supplied and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "供给是生产者在给定时期、不同价格下愿意且能够出售的数量关系；供给量是某一个价格下的数量。 其他生产条件保持不变；价格上升提高额外生产的收益；供给量通常沿原曲线增加 原创例：蛋糕价格从 20 升到 25 元，糕点师延长工作时间而多做 10 个。若投入价格和技术未变，这是沿供给曲线移动，不是供给曲线右移。",
          "en": "Supply relates quantities producers are willing and able to sell at different prices during a period. Quantity supplied is the quantity at one price. Hold production conditions constant; a higher price increases the return on extra production; quantity supplied normally rises along the curve Illustrative example: cake prices rise from 20 to 25 and a baker works longer to make ten more. With input prices and technology unchanged, this is a movement along supply, not a shift."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "自身价格",
              "en": "own price"
            },
            "alternatives": {
              "zh-CN": [
                "自身价格",
                "其他生产条件保持不变"
              ],
              "en": [
                "own price",
                "Hold production conditions constant"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "收益",
              "en": "return"
            },
            "alternatives": {
              "zh-CN": [
                "收益",
                "价格上升提高额外生产的收益"
              ],
              "en": [
                "return",
                "a higher price increases the return on extra production"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "沿曲线",
              "en": "along"
            },
            "alternatives": {
              "zh-CN": [
                "沿曲线",
                "供给量通常沿原曲线增加"
              ],
              "en": [
                "along",
                "quantity supplied normally rises along the curve"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-07-supply-shifts",
      "slug": "supply-shifts",
      "section": "2.2",
      "level": "core",
      "syllabusRefs": [
        "2.2 Supply"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.3",
          "pages": [
            49
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u2-06-supply",
        "u2-08-market-supply",
        "u2-09-diminishing-returns"
      ],
      "terms": [
        "供给的非价格决定因素",
        "Non-price determinants of supply",
        "成本",
        "cost",
        "每个价格",
        "every price",
        "供给",
        "supply"
      ],
      "synonyms": {
        "zh-CN": [
          "成本",
          "每个价格",
          "供给"
        ],
        "en": [
          "cost",
          "every price",
          "supply"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-07-supply-shifts-flash-1",
        "u2-07-supply-shifts-mcq-1",
        "u2-07-supply-shifts-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-07-supply-shifts",
        "locale": "zh-CN",
        "title": "供给的非价格决定因素",
        "takeaway": "投入成本、技术、税补、生产者数量、相关产品价格及自然条件改变，可移动整个供给曲线。",
        "definition": "投入成本、技术、税补、生产者数量、相关产品价格及自然条件改变，可移动整个供给曲线。",
        "causalChain": [
          "单位生产成本或生产能力改变",
          "相同产品价格下生产意愿改变",
          "供给向右或向左移动"
        ],
        "misconceptions": [
          "成本变化移动供给，自身价格变化通常沿供给移动。"
        ],
        "examApplication": [
          "写清商品自身价格、成本与时间的不同作用。"
        ],
        "summary": [
          "投入成本、技术、税补、生产者数量、相关产品价格及自然条件改变，可移动整个供给曲线。",
          "成本变化移动供给，自身价格变化通常沿供给移动。"
        ],
        "explanation": "单位生产成本或生产能力改变。相同产品价格下生产意愿改变。供给向右或向左移动。\n\n### 原创情境与推导\n\n原创例：面粉价格上升提高面包成本。每一个面包价格下，原先可获利的一部分产量不再可获利，所以面包供给左移。把结果画为价格不变的需求减少会混淆市场两侧。\n\n成本变化移动供给，自身价格变化通常沿供给移动。\n\n写清商品自身价格、成本与时间的不同作用。"
      },
      "en": {
        "id": "u2-07-supply-shifts",
        "locale": "en",
        "title": "Non-price determinants of supply",
        "takeaway": "Input costs, technology, taxes and subsidies, producer numbers, related-product prices and natural conditions can shift the entire supply curve.",
        "definition": "Input costs, technology, taxes and subsidies, producer numbers, related-product prices and natural conditions can shift the entire supply curve.",
        "causalChain": [
          "Unit costs or productive capacity change",
          "willingness to produce changes at the same output price",
          "supply shifts right or left"
        ],
        "misconceptions": [
          "Changing costs shifts supply; changing the output's own price normally moves along supply."
        ],
        "examApplication": [
          "Separate own price, costs and time when explaining supply."
        ],
        "summary": [
          "Input costs, technology, taxes and subsidies, producer numbers, related-product prices and natural conditions can shift the entire supply curve.",
          "Changing costs shifts supply; changing the output's own price normally moves along supply."
        ],
        "explanation": "Unit costs or productive capacity change.  willingness to produce changes at the same output price.  supply shifts right or left.\n\n### Original scenario and reasoning\n\nIllustrative example: dearer flour raises bread production costs. At each bread price, some previously profitable output becomes unprofitable, shifting bread supply left. Showing this as a demand reduction confuses the two sides of the market.\n\nChanging costs shifts supply; changing the output's own price normally moves along supply.\n\nSeparate own price, costs and time when explaining supply."
      }
    },
    "practice": [
      {
        "id": "u2-07-supply-shifts-flash-1",
        "knowledgePointId": "u2-07-supply-shifts",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“供给的非价格决定因素”，并说明一个关键条件。",
          "en": "Explain Non-price determinants of supply and state one important condition."
        },
        "answer": {
          "zh-CN": "投入成本、技术、税补、生产者数量、相关产品价格及自然条件改变，可移动整个供给曲线。",
          "en": "Input costs, technology, taxes and subsidies, producer numbers, related-product prices and natural conditions can shift the entire supply curve."
        },
        "explanation": {
          "zh-CN": "成本变化移动供给，自身价格变化通常沿供给移动。",
          "en": "Changing costs shifts supply; changing the output's own price normally moves along supply."
        }
      },
      {
        "id": "u2-07-supply-shifts-mcq-1",
        "knowledgePointId": "u2-07-supply-shifts",
        "type": "mcq",
        "prompt": {
          "zh-CN": "更便宜的生产技术通常怎样影响供给？",
          "en": "How does a cheaper production technique normally affect supply?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "供给左移",
            "en": "Supply shifts left"
          },
          {
            "id": "b",
            "zh-CN": "仅沿供给向上移动",
            "en": "Only move up along supply"
          },
          {
            "id": "c",
            "zh-CN": "供给右移",
            "en": "Supply shifts right"
          },
          {
            "id": "d",
            "zh-CN": "需求必然右移",
            "en": "Demand necessarily shifts right"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "供给右移。 单位生产成本或生产能力改变；相同产品价格下生产意愿改变；供给向右或向左移动 成本变化移动供给，自身价格变化通常沿供给移动。",
          "en": "Supply shifts right. Unit costs or productive capacity change; willingness to produce changes at the same output price; supply shifts right or left Changing costs shifts supply; changing the output's own price normally moves along supply."
        }
      },
      {
        "id": "u2-07-supply-shifts-short-1",
        "knowledgePointId": "u2-07-supply-shifts",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释供给的非价格决定因素的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Non-price determinants of supply and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "投入成本、技术、税补、生产者数量、相关产品价格及自然条件改变，可移动整个供给曲线。 单位生产成本或生产能力改变；相同产品价格下生产意愿改变；供给向右或向左移动 原创例：面粉价格上升提高面包成本。每一个面包价格下，原先可获利的一部分产量不再可获利，所以面包供给左移。把结果画为价格不变的需求减少会混淆市场两侧。",
          "en": "Input costs, technology, taxes and subsidies, producer numbers, related-product prices and natural conditions can shift the entire supply curve. Unit costs or productive capacity change; willingness to produce changes at the same output price; supply shifts right or left Illustrative example: dearer flour raises bread production costs. At each bread price, some previously profitable output becomes unprofitable, shifting bread supply left. Showing this as a demand reduction confuses the two sides of the market."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "成本",
              "en": "cost"
            },
            "alternatives": {
              "zh-CN": [
                "成本",
                "单位生产成本或生产能力改变"
              ],
              "en": [
                "cost",
                "Unit costs or productive capacity change"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "每个价格",
              "en": "every price"
            },
            "alternatives": {
              "zh-CN": [
                "每个价格",
                "相同产品价格下生产意愿改变"
              ],
              "en": [
                "every price",
                "willingness to produce changes at the same output price"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "供给",
              "en": "supply"
            },
            "alternatives": {
              "zh-CN": [
                "供给",
                "供给向右或向左移动"
              ],
              "en": [
                "supply",
                "supply shifts right or left"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-08-market-supply",
      "slug": "market-supply",
      "section": "2.2",
      "level": "core",
      "syllabusRefs": [
        "2.2 Supply"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.3",
          "pages": [
            49
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u2-06-supply",
        "u2-07-supply-shifts",
        "u2-09-diminishing-returns"
      ],
      "terms": [
        "市场供给与时间尺度",
        "Market supply and time horizons",
        "同价",
        "common price",
        "加总",
        "sum",
        "固定",
        "fixed"
      ],
      "synonyms": {
        "zh-CN": [
          "同价",
          "加总",
          "固定"
        ],
        "en": [
          "common price",
          "sum",
          "fixed"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-08-market-supply-flash-1",
        "u2-08-market-supply-mcq-1",
        "u2-08-market-supply-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-08-market-supply",
        "locale": "zh-CN",
        "title": "市场供给与时间尺度",
        "takeaway": "市场供给是在同一价格下各生产者供给量的横向加总；生产能力调整所需时间会限制这种反应。",
        "definition": "市场供给是在同一价格下各生产者供给量的横向加总；生产能力调整所需时间会限制这种反应。",
        "causalChain": [
          "短期部分投入固定",
          "生产者只能调整可变投入",
          "长期可以扩建和进入市场"
        ],
        "misconceptions": [
          "短期和长期不是统一的月数，而是投入是否可以全部改变。"
        ],
        "examApplication": [
          "写清商品自身价格、成本与时间的不同作用。"
        ],
        "summary": [
          "市场供给是在同一价格下各生产者供给量的横向加总；生产能力调整所需时间会限制这种反应。",
          "短期和长期不是统一的月数，而是投入是否可以全部改变。"
        ],
        "explanation": "短期部分投入固定。生产者只能调整可变投入。长期可以扩建和进入市场。\n\n### 原创情境与推导\n\n原创例：同价时甲厂供给 30 台、乙厂供给 20 台，总供给为 50 台。一个月内厂房固定，一年内可建新厂，因此不能把短期限制解释成永久无法增加产量。\n\n短期和长期不是统一的月数，而是投入是否可以全部改变。\n\n写清商品自身价格、成本与时间的不同作用。"
      },
      "en": {
        "id": "u2-08-market-supply",
        "locale": "en",
        "title": "Market supply and time horizons",
        "takeaway": "Market supply horizontally sums producers' quantities at each common price. The time needed to adjust capacity constrains that response.",
        "definition": "Market supply horizontally sums producers' quantities at each common price. The time needed to adjust capacity constrains that response.",
        "causalChain": [
          "Some inputs are fixed in the short run",
          "firms adjust variable inputs",
          "in the long run capacity and market entry can change"
        ],
        "misconceptions": [
          "Short and long run are defined by input flexibility, not universal calendar durations."
        ],
        "examApplication": [
          "Separate own price, costs and time when explaining supply."
        ],
        "summary": [
          "Market supply horizontally sums producers' quantities at each common price. The time needed to adjust capacity constrains that response.",
          "Short and long run are defined by input flexibility, not universal calendar durations."
        ],
        "explanation": "Some inputs are fixed in the short run.  firms adjust variable inputs.  in the long run capacity and market entry can change.\n\n### Original scenario and reasoning\n\nIllustrative example: two firms supply 30 and 20 units at the same price, yielding market supply of 50. Buildings may be fixed for a month but adjustable over a year, so a short-run limit need not be permanent.\n\nShort and long run are defined by input flexibility, not universal calendar durations.\n\nSeparate own price, costs and time when explaining supply."
      }
    },
    "practice": [
      {
        "id": "u2-08-market-supply-flash-1",
        "knowledgePointId": "u2-08-market-supply",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“市场供给与时间尺度”，并说明一个关键条件。",
          "en": "Explain Market supply and time horizons and state one important condition."
        },
        "answer": {
          "zh-CN": "市场供给是在同一价格下各生产者供给量的横向加总；生产能力调整所需时间会限制这种反应。",
          "en": "Market supply horizontally sums producers' quantities at each common price. The time needed to adjust capacity constrains that response."
        },
        "explanation": {
          "zh-CN": "短期和长期不是统一的月数，而是投入是否可以全部改变。",
          "en": "Short and long run are defined by input flexibility, not universal calendar durations."
        }
      },
      {
        "id": "u2-08-market-supply-mcq-1",
        "knowledgePointId": "u2-08-market-supply",
        "type": "mcq",
        "prompt": {
          "zh-CN": "两厂同价供给 15 和 25 单位，市场供给量为多少？",
          "en": "Two firms supply 15 and 25 units at a common price. What is market quantity?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "20",
            "en": "20"
          },
          {
            "id": "b",
            "zh-CN": "25",
            "en": "25"
          },
          {
            "id": "c",
            "zh-CN": "375",
            "en": "375"
          },
          {
            "id": "d",
            "zh-CN": "40",
            "en": "40"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "40。 15 + 25 = 40 短期和长期不是统一的月数，而是投入是否可以全部改变。",
          "en": "40. 15 + 25 = 40 Short and long run are defined by input flexibility, not universal calendar durations."
        }
      },
      {
        "id": "u2-08-market-supply-short-1",
        "knowledgePointId": "u2-08-market-supply",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释市场供给与时间尺度的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Market supply and time horizons and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "市场供给是在同一价格下各生产者供给量的横向加总；生产能力调整所需时间会限制这种反应。 短期部分投入固定；生产者只能调整可变投入；长期可以扩建和进入市场 原创例：同价时甲厂供给 30 台、乙厂供给 20 台，总供给为 50 台。一个月内厂房固定，一年内可建新厂，因此不能把短期限制解释成永久无法增加产量。",
          "en": "Market supply horizontally sums producers' quantities at each common price. The time needed to adjust capacity constrains that response. Some inputs are fixed in the short run; firms adjust variable inputs; in the long run capacity and market entry can change Illustrative example: two firms supply 30 and 20 units at the same price, yielding market supply of 50. Buildings may be fixed for a month but adjustable over a year, so a short-run limit need not be permanent."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "同价",
              "en": "common price"
            },
            "alternatives": {
              "zh-CN": [
                "同价",
                "短期部分投入固定"
              ],
              "en": [
                "common price",
                "Some inputs are fixed in the short run"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "加总",
              "en": "sum"
            },
            "alternatives": {
              "zh-CN": [
                "加总",
                "生产者只能调整可变投入"
              ],
              "en": [
                "sum",
                "firms adjust variable inputs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "固定",
              "en": "fixed"
            },
            "alternatives": {
              "zh-CN": [
                "固定",
                "长期可以扩建和进入市场"
              ],
              "en": [
                "fixed",
                "in the long run capacity and market entry can change"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-09-diminishing-returns",
      "slug": "diminishing-returns",
      "section": "2.2",
      "level": "hl",
      "syllabusRefs": [
        "2.2 Supply"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.3",
          "pages": [
            49
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u2-06-supply",
        "u2-07-supply-shifts",
        "u2-08-market-supply"
      ],
      "terms": [
        "边际报酬递减",
        "Diminishing marginal returns",
        "固定投入",
        "fixed input",
        "边际产量",
        "marginal product",
        "边际成本",
        "marginal cost"
      ],
      "synonyms": {
        "zh-CN": [
          "固定投入",
          "边际产量",
          "边际成本"
        ],
        "en": [
          "fixed input",
          "marginal product",
          "marginal cost"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-09-diminishing-returns-flash-1",
        "u2-09-diminishing-returns-mcq-1",
        "u2-09-diminishing-returns-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-09-diminishing-returns",
        "locale": "zh-CN",
        "title": "边际报酬递减",
        "takeaway": "短期至少一个投入固定时，连续增加一种可变投入，超过某点后额外产量会下降。",
        "definition": "短期至少一个投入固定时，连续增加一种可变投入，超过某点后额外产量会下降。",
        "causalChain": [
          "资本等投入固定",
          "可变投入不断增加",
          "拥挤使边际产量下降并推高边际成本"
        ],
        "misconceptions": [
          "报酬递减涉及固定投入，不同于长期所有投入变化的规模不经济。"
        ],
        "examApplication": [
          "写清商品自身价格、成本与时间的不同作用。"
        ],
        "summary": [
          "短期至少一个投入固定时，连续增加一种可变投入，超过某点后额外产量会下降。",
          "报酬递减涉及固定投入，不同于长期所有投入变化的规模不经济。"
        ],
        "explanation": "资本等投入固定。可变投入不断增加。拥挤使边际产量下降并推高边际成本。\n\n### 原创情境与推导\n\n原创例：一台烤箱配 1、2、3 名工人的日产量为 10、25、35。第二名工人的边际产量为 15，第三名为 10。总产量仍在上升；技术不变是这一比较的条件。\n\n报酬递减涉及固定投入，不同于长期所有投入变化的规模不经济。\n\n写清商品自身价格、成本与时间的不同作用。"
      },
      "en": {
        "id": "u2-09-diminishing-returns",
        "locale": "en",
        "title": "Diminishing marginal returns",
        "takeaway": "With at least one input fixed in the short run, successive additions of a variable input eventually yield less extra output.",
        "definition": "With at least one input fixed in the short run, successive additions of a variable input eventually yield less extra output.",
        "causalChain": [
          "Capital or another input is fixed",
          "variable inputs increase",
          "crowding reduces marginal product and raises marginal cost"
        ],
        "misconceptions": [
          "Diminishing returns concerns fixed inputs and differs from diseconomies when all inputs vary in the long run."
        ],
        "examApplication": [
          "Separate own price, costs and time when explaining supply."
        ],
        "summary": [
          "With at least one input fixed in the short run, successive additions of a variable input eventually yield less extra output.",
          "Diminishing returns concerns fixed inputs and differs from diseconomies when all inputs vary in the long run."
        ],
        "explanation": "Capital or another input is fixed.  variable inputs increase.  crowding reduces marginal product and raises marginal cost.\n\n### Original scenario and reasoning\n\nIllustrative example: one oven with one, two and three workers produces 10, 25 and 35 units. The second worker adds 15, the third adds ten. Total output still rises. Technology must be held constant for this comparison.\n\nDiminishing returns concerns fixed inputs and differs from diseconomies when all inputs vary in the long run.\n\nSeparate own price, costs and time when explaining supply."
      }
    },
    "practice": [
      {
        "id": "u2-09-diminishing-returns-flash-1",
        "knowledgePointId": "u2-09-diminishing-returns",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“边际报酬递减”，并说明一个关键条件。",
          "en": "Explain Diminishing marginal returns and state one important condition."
        },
        "answer": {
          "zh-CN": "短期至少一个投入固定时，连续增加一种可变投入，超过某点后额外产量会下降。",
          "en": "With at least one input fixed in the short run, successive additions of a variable input eventually yield less extra output."
        },
        "explanation": {
          "zh-CN": "报酬递减涉及固定投入，不同于长期所有投入变化的规模不经济。",
          "en": "Diminishing returns concerns fixed inputs and differs from diseconomies when all inputs vary in the long run."
        }
      },
      {
        "id": "u2-09-diminishing-returns-mcq-1",
        "knowledgePointId": "u2-09-diminishing-returns",
        "type": "mcq",
        "prompt": {
          "zh-CN": "总产量从 25 增至 35，新增工人的边际产量是多少？",
          "en": "Total output rises from 25 to 35. What is the added worker's marginal product?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "10",
            "en": "10"
          },
          {
            "id": "b",
            "zh-CN": "35",
            "en": "35"
          },
          {
            "id": "c",
            "zh-CN": "25",
            "en": "25"
          },
          {
            "id": "d",
            "zh-CN": "60",
            "en": "60"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "10。 35 − 25 = 10 报酬递减涉及固定投入，不同于长期所有投入变化的规模不经济。",
          "en": "10. 35 − 25 = 10 Diminishing returns concerns fixed inputs and differs from diseconomies when all inputs vary in the long run."
        }
      },
      {
        "id": "u2-09-diminishing-returns-short-1",
        "knowledgePointId": "u2-09-diminishing-returns",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释边际报酬递减的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Diminishing marginal returns and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "短期至少一个投入固定时，连续增加一种可变投入，超过某点后额外产量会下降。 资本等投入固定；可变投入不断增加；拥挤使边际产量下降并推高边际成本 原创例：一台烤箱配 1、2、3 名工人的日产量为 10、25、35。第二名工人的边际产量为 15，第三名为 10。总产量仍在上升；技术不变是这一比较的条件。",
          "en": "With at least one input fixed in the short run, successive additions of a variable input eventually yield less extra output. Capital or another input is fixed; variable inputs increase; crowding reduces marginal product and raises marginal cost Illustrative example: one oven with one, two and three workers produces 10, 25 and 35 units. The second worker adds 15, the third adds ten. Total output still rises. Technology must be held constant for this comparison."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "固定投入",
              "en": "fixed input"
            },
            "alternatives": {
              "zh-CN": [
                "固定投入",
                "资本等投入固定"
              ],
              "en": [
                "fixed input",
                "Capital or another input is fixed"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "边际产量",
              "en": "marginal product"
            },
            "alternatives": {
              "zh-CN": [
                "边际产量",
                "可变投入不断增加"
              ],
              "en": [
                "marginal product",
                "variable inputs increase"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "边际成本",
              "en": "marginal cost"
            },
            "alternatives": {
              "zh-CN": [
                "边际成本",
                "拥挤使边际产量下降并推高边际成本"
              ],
              "en": [
                "marginal cost",
                "crowding reduces marginal product and raises marginal cost"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-10-costs-and-supply",
      "slug": "costs-and-supply",
      "section": "2.2",
      "level": "hl",
      "syllabusRefs": [
        "2.2 Supply"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.3",
          "pages": [
            49
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u2-06-supply",
        "u2-07-supply-shifts",
        "u2-08-market-supply"
      ],
      "terms": [
        "边际成本与供给决策",
        "Marginal cost and supply decisions",
        "额外成本",
        "extra cost",
        "边际收益",
        "marginal revenue",
        "利润",
        "profit"
      ],
      "synonyms": {
        "zh-CN": [
          "额外成本",
          "边际收益",
          "利润"
        ],
        "en": [
          "extra cost",
          "marginal revenue",
          "profit"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-10-costs-and-supply-flash-1",
        "u2-10-costs-and-supply-mcq-1",
        "u2-10-costs-and-supply-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-10-costs-and-supply",
        "locale": "zh-CN",
        "title": "边际成本与供给决策",
        "takeaway": "边际成本 MC 是多生产一单位引起的总成本增加；生产者比较额外收益与额外成本来选择产量。",
        "definition": "边际成本 MC 是多生产一单位引起的总成本增加；生产者比较额外收益与额外成本来选择产量。",
        "causalChain": [
          "额外单位需要更多投入",
          "边际收益超过边际成本时增产提高利润",
          "达到合适的边际条件后停止扩张"
        ],
        "misconceptions": [
          "价格等于 MC 不能单独证明企业总利润为正，还需要比较价格与平均成本。"
        ],
        "examApplication": [
          "写清商品自身价格、成本与时间的不同作用。"
        ],
        "summary": [
          "边际成本 MC 是多生产一单位引起的总成本增加；生产者比较额外收益与额外成本来选择产量。",
          "价格等于 MC 不能单独证明企业总利润为正，还需要比较价格与平均成本。"
        ],
        "explanation": "额外单位需要更多投入。边际收益超过边际成本时增产提高利润。达到合适的边际条件后停止扩张。\n\n### 原创情境与推导\n\n原创例：产量从 10 到 11，总成本从 80 到 92，MC 为 12。若该单位售价为 15，且企业接受市场价格，增产增加 3 的利润。固定成本决定是否进入，却不直接改变这一个单位的 MC。\n\n价格等于 MC 不能单独证明企业总利润为正，还需要比较价格与平均成本。\n\n写清商品自身价格、成本与时间的不同作用。"
      },
      "en": {
        "id": "u2-10-costs-and-supply",
        "locale": "en",
        "title": "Marginal cost and supply decisions",
        "takeaway": "Marginal cost, MC, is the addition to total cost from one more unit. Producers compare incremental revenue and cost when choosing output.",
        "definition": "Marginal cost, MC, is the addition to total cost from one more unit. Producers compare incremental revenue and cost when choosing output.",
        "causalChain": [
          "Extra output requires inputs",
          "expansion increases profit when marginal revenue exceeds marginal cost",
          "stop expanding at the relevant marginal condition"
        ],
        "misconceptions": [
          "Price equal to MC does not prove total profit is positive; price must also be compared with average cost."
        ],
        "examApplication": [
          "Separate own price, costs and time when explaining supply."
        ],
        "summary": [
          "Marginal cost, MC, is the addition to total cost from one more unit. Producers compare incremental revenue and cost when choosing output.",
          "Price equal to MC does not prove total profit is positive; price must also be compared with average cost."
        ],
        "explanation": "Extra output requires inputs.  expansion increases profit when marginal revenue exceeds marginal cost.  stop expanding at the relevant marginal condition.\n\n### Original scenario and reasoning\n\nIllustrative example: output rises from ten to eleven and total cost from 80 to 92, so MC is 12. At a price-taking firm's price of 15, the extra unit adds three to profit. Fixed cost matters for entry but does not directly alter this unit's MC.\n\nPrice equal to MC does not prove total profit is positive; price must also be compared with average cost.\n\nSeparate own price, costs and time when explaining supply."
      }
    },
    "practice": [
      {
        "id": "u2-10-costs-and-supply-flash-1",
        "knowledgePointId": "u2-10-costs-and-supply",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“边际成本与供给决策”，并说明一个关键条件。",
          "en": "Explain Marginal cost and supply decisions and state one important condition."
        },
        "answer": {
          "zh-CN": "边际成本 MC 是多生产一单位引起的总成本增加；生产者比较额外收益与额外成本来选择产量。",
          "en": "Marginal cost, MC, is the addition to total cost from one more unit. Producers compare incremental revenue and cost when choosing output."
        },
        "explanation": {
          "zh-CN": "价格等于 MC 不能单独证明企业总利润为正，还需要比较价格与平均成本。",
          "en": "Price equal to MC does not prove total profit is positive; price must also be compared with average cost."
        }
      },
      {
        "id": "u2-10-costs-and-supply-mcq-1",
        "knowledgePointId": "u2-10-costs-and-supply",
        "type": "mcq",
        "prompt": {
          "zh-CN": "增加一单位使成本由 60 变为 68，MC 为多少？",
          "en": "One more unit raises total cost from 60 to 68. What is MC?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "68",
            "en": "68"
          },
          {
            "id": "b",
            "zh-CN": "8",
            "en": "8"
          },
          {
            "id": "c",
            "zh-CN": "60",
            "en": "60"
          },
          {
            "id": "d",
            "zh-CN": "128",
            "en": "128"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "8。 MC = (68 − 60) / (11 − 10) = 8 价格等于 MC 不能单独证明企业总利润为正，还需要比较价格与平均成本。",
          "en": "8. MC = (68 − 60) / (11 − 10) = 8 Price equal to MC does not prove total profit is positive; price must also be compared with average cost."
        }
      },
      {
        "id": "u2-10-costs-and-supply-short-1",
        "knowledgePointId": "u2-10-costs-and-supply",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释边际成本与供给决策的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Marginal cost and supply decisions and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "边际成本 MC 是多生产一单位引起的总成本增加；生产者比较额外收益与额外成本来选择产量。 额外单位需要更多投入；边际收益超过边际成本时增产提高利润；达到合适的边际条件后停止扩张 原创例：产量从 10 到 11，总成本从 80 到 92，MC 为 12。若该单位售价为 15，且企业接受市场价格，增产增加 3 的利润。固定成本决定是否进入，却不直接改变这一个单位的 MC。",
          "en": "Marginal cost, MC, is the addition to total cost from one more unit. Producers compare incremental revenue and cost when choosing output. Extra output requires inputs; expansion increases profit when marginal revenue exceeds marginal cost; stop expanding at the relevant marginal condition Illustrative example: output rises from ten to eleven and total cost from 80 to 92, so MC is 12. At a price-taking firm's price of 15, the extra unit adds three to profit. Fixed cost matters for entry but does not directly alter this unit's MC."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "额外成本",
              "en": "extra cost"
            },
            "alternatives": {
              "zh-CN": [
                "额外成本",
                "额外单位需要更多投入"
              ],
              "en": [
                "extra cost",
                "Extra output requires inputs"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "边际收益",
              "en": "marginal revenue"
            },
            "alternatives": {
              "zh-CN": [
                "边际收益",
                "边际收益超过边际成本时增产提高利润"
              ],
              "en": [
                "marginal revenue",
                "expansion increases profit when marginal revenue exceeds marginal cost"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "利润",
              "en": "profit"
            },
            "alternatives": {
              "zh-CN": [
                "利润",
                "达到合适的边际条件后停止扩张"
              ],
              "en": [
                "profit",
                "stop expanding at the relevant marginal condition"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-11-equilibrium",
      "slug": "equilibrium",
      "section": "2.3",
      "level": "core",
      "syllabusRefs": [
        "2.3 Competitive market equilibrium"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.4",
          "pages": [
            57
          ]
        }
      ],
      "prerequisites": [
        "u2-01-demand",
        "u2-06-supply"
      ],
      "related": [
        "u2-12-shortage-surplus",
        "u2-13-equilibrium-shifts",
        "u2-14-price-mechanism"
      ],
      "terms": [
        "竞争市场均衡",
        "Competitive market equilibrium",
        "需求量",
        "quantity demanded",
        "供给量",
        "quantity supplied",
        "相等",
        "equal"
      ],
      "synonyms": {
        "zh-CN": [
          "需求量",
          "供给量",
          "相等"
        ],
        "en": [
          "quantity demanded",
          "quantity supplied",
          "equal"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-11-equilibrium-flash-1",
        "u2-11-equilibrium-mcq-1",
        "u2-11-equilibrium-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-11-equilibrium",
        "locale": "zh-CN",
        "title": "竞争市场均衡",
        "takeaway": "市场均衡是在某价格下需求量等于供给量，买卖双方计划一致且没有改变价格的内生压力。",
        "definition": "市场均衡是在某价格下需求量等于供给量，买卖双方计划一致且没有改变价格的内生压力。",
        "causalChain": [
          "买卖双方在相同价格作出计划",
          "需求量等于供给量",
          "市场出清但不保证结果公平"
        ],
        "misconceptions": [
          "均衡不意味着所有需要都被满足，也不意味着社会最优。"
        ],
        "examApplication": [
          "先指出变化因素，再比较新旧价格、数量与利益相关者。"
        ],
        "summary": [
          "市场均衡是在某价格下需求量等于供给量，买卖双方计划一致且没有改变价格的内生压力。",
          "均衡不意味着所有需要都被满足，也不意味着社会最优。"
        ],
        "explanation": "买卖双方在相同价格作出计划。需求量等于供给量。市场出清但不保证结果公平。\n\n### 原创情境与推导\n\n原创例：价格 8 元时买方想买 60 个、卖方想卖 60 个，这是一组均衡。均衡是模型的比较基准，现实调整可能因合约、库存或信息延迟而缓慢。\n\n均衡不意味着所有需要都被满足，也不意味着社会最优。\n\n先指出变化因素，再比较新旧价格、数量与利益相关者。"
      },
      "en": {
        "id": "u2-11-equilibrium",
        "locale": "en",
        "title": "Competitive market equilibrium",
        "takeaway": "Equilibrium occurs at the price where quantity demanded equals quantity supplied, making buyers' and sellers' plans compatible without endogenous pressure for price to change.",
        "definition": "Equilibrium occurs at the price where quantity demanded equals quantity supplied, making buyers' and sellers' plans compatible without endogenous pressure for price to change.",
        "causalChain": [
          "Buyers and sellers plan at a common price",
          "quantities demanded and supplied coincide",
          "the market clears without guaranteeing equity"
        ],
        "misconceptions": [
          "Equilibrium does not mean all needs are met or that the outcome is socially optimal."
        ],
        "examApplication": [
          "Identify the changed determinant before comparing prices, quantities and stakeholders."
        ],
        "summary": [
          "Equilibrium occurs at the price where quantity demanded equals quantity supplied, making buyers' and sellers' plans compatible without endogenous pressure for price to change.",
          "Equilibrium does not mean all needs are met or that the outcome is socially optimal."
        ],
        "explanation": "Buyers and sellers plan at a common price.  quantities demanded and supplied coincide.  the market clears without guaranteeing equity.\n\n### Original scenario and reasoning\n\nIllustrative example: at a price of 8 buyers demand 60 units and sellers supply 60. This is an equilibrium pair. Equilibrium is a comparison benchmark; contracts, inventories and information delays can slow actual adjustment.\n\nEquilibrium does not mean all needs are met or that the outcome is socially optimal.\n\nIdentify the changed determinant before comparing prices, quantities and stakeholders."
      }
    },
    "practice": [
      {
        "id": "u2-11-equilibrium-flash-1",
        "knowledgePointId": "u2-11-equilibrium",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“竞争市场均衡”，并说明一个关键条件。",
          "en": "Explain Competitive market equilibrium and state one important condition."
        },
        "answer": {
          "zh-CN": "市场均衡是在某价格下需求量等于供给量，买卖双方计划一致且没有改变价格的内生压力。",
          "en": "Equilibrium occurs at the price where quantity demanded equals quantity supplied, making buyers' and sellers' plans compatible without endogenous pressure for price to change."
        },
        "explanation": {
          "zh-CN": "均衡不意味着所有需要都被满足，也不意味着社会最优。",
          "en": "Equilibrium does not mean all needs are met or that the outcome is socially optimal."
        }
      },
      {
        "id": "u2-11-equilibrium-mcq-1",
        "knowledgePointId": "u2-11-equilibrium",
        "type": "mcq",
        "prompt": {
          "zh-CN": "价格下 Qd=70、Qs=70，该市场处于什么状态？",
          "en": "At a price Qd=70 and Qs=70. What is the market's state?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "短缺 70",
            "en": "Shortage of 70"
          },
          {
            "id": "b",
            "zh-CN": "过剩 140",
            "en": "Surplus of 140"
          },
          {
            "id": "c",
            "zh-CN": "均衡",
            "en": "Equilibrium"
          },
          {
            "id": "d",
            "zh-CN": "需求为零",
            "en": "Zero demand"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "均衡。 买卖双方在相同价格作出计划；需求量等于供给量；市场出清但不保证结果公平 均衡不意味着所有需要都被满足，也不意味着社会最优。",
          "en": "Equilibrium. Buyers and sellers plan at a common price; quantities demanded and supplied coincide; the market clears without guaranteeing equity Equilibrium does not mean all needs are met or that the outcome is socially optimal."
        }
      },
      {
        "id": "u2-11-equilibrium-short-1",
        "knowledgePointId": "u2-11-equilibrium",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释竞争市场均衡的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Competitive market equilibrium and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "市场均衡是在某价格下需求量等于供给量，买卖双方计划一致且没有改变价格的内生压力。 买卖双方在相同价格作出计划；需求量等于供给量；市场出清但不保证结果公平 原创例：价格 8 元时买方想买 60 个、卖方想卖 60 个，这是一组均衡。均衡是模型的比较基准，现实调整可能因合约、库存或信息延迟而缓慢。",
          "en": "Equilibrium occurs at the price where quantity demanded equals quantity supplied, making buyers' and sellers' plans compatible without endogenous pressure for price to change. Buyers and sellers plan at a common price; quantities demanded and supplied coincide; the market clears without guaranteeing equity Illustrative example: at a price of 8 buyers demand 60 units and sellers supply 60. This is an equilibrium pair. Equilibrium is a comparison benchmark; contracts, inventories and information delays can slow actual adjustment."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "需求量",
              "en": "quantity demanded"
            },
            "alternatives": {
              "zh-CN": [
                "需求量",
                "买卖双方在相同价格作出计划"
              ],
              "en": [
                "quantity demanded",
                "Buyers and sellers plan at a common price"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "供给量",
              "en": "quantity supplied"
            },
            "alternatives": {
              "zh-CN": [
                "供给量",
                "需求量等于供给量"
              ],
              "en": [
                "quantity supplied",
                "quantities demanded and supplied coincide"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "相等",
              "en": "equal"
            },
            "alternatives": {
              "zh-CN": [
                "相等",
                "市场出清但不保证结果公平"
              ],
              "en": [
                "equal",
                "the market clears without guaranteeing equity"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-12-shortage-surplus",
      "slug": "shortage-surplus",
      "section": "2.3",
      "level": "core",
      "syllabusRefs": [
        "2.3 Competitive market equilibrium"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.4",
          "pages": [
            57
          ]
        }
      ],
      "prerequisites": [
        "u2-01-demand",
        "u2-06-supply"
      ],
      "related": [
        "u2-11-equilibrium",
        "u2-13-equilibrium-shifts",
        "u2-14-price-mechanism"
      ],
      "terms": [
        "短缺、过剩与价格调整",
        "Shortages, surpluses and price adjustment",
        "短缺",
        "shortage",
        "过剩",
        "surplus",
        "价格调整",
        "price adjustment"
      ],
      "synonyms": {
        "zh-CN": [
          "短缺",
          "过剩",
          "价格调整"
        ],
        "en": [
          "shortage",
          "surplus",
          "price adjustment"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-12-shortage-surplus-flash-1",
        "u2-12-shortage-surplus-mcq-1",
        "u2-12-shortage-surplus-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-12-shortage-surplus",
        "locale": "zh-CN",
        "title": "短缺、过剩与价格调整",
        "takeaway": "短缺是给定价格下需求量超过供给量；过剩是供给量超过需求量。在灵活价格模型中，两者分别带来涨价和降价压力。",
        "definition": "短缺是给定价格下需求量超过供给量；过剩是供给量超过需求量。在灵活价格模型中，两者分别带来涨价和降价压力。",
        "causalChain": [
          "非均衡价格使交易计划不一致",
          "买方竞争或卖方积压",
          "价格调整改变双方数量"
        ],
        "misconceptions": [
          "短缺的大小是 Qd−Qs，不是需求量本身。"
        ],
        "examApplication": [
          "先指出变化因素，再比较新旧价格、数量与利益相关者。"
        ],
        "summary": [
          "短缺是给定价格下需求量超过供给量；过剩是供给量超过需求量。在灵活价格模型中，两者分别带来涨价和降价压力。",
          "短缺的大小是 Qd−Qs，不是需求量本身。"
        ],
        "explanation": "非均衡价格使交易计划不一致。买方竞争或卖方积压。价格调整改变双方数量。\n\n### 原创情境与推导\n\n原创例：Qd=90、Qs=50，短缺为 40。涨价会沿需求减少需求量、沿供给增加供给量。价格管制可能阻止这一调整，因此不能假设任何短缺都会自动立即消失。\n\n短缺的大小是 Qd−Qs，不是需求量本身。\n\n先指出变化因素，再比较新旧价格、数量与利益相关者。"
      },
      "en": {
        "id": "u2-12-shortage-surplus",
        "locale": "en",
        "title": "Shortages, surpluses and price adjustment",
        "takeaway": "A shortage means quantity demanded exceeds quantity supplied at a given price; a surplus means the reverse. In a flexible-price model they create upward and downward price pressure respectively.",
        "definition": "A shortage means quantity demanded exceeds quantity supplied at a given price; a surplus means the reverse. In a flexible-price model they create upward and downward price pressure respectively.",
        "causalChain": [
          "A disequilibrium price makes trading plans incompatible",
          "buyers compete or sellers accumulate stock",
          "changing price adjusts quantities on both sides"
        ],
        "misconceptions": [
          "The size of a shortage is Qd minus Qs, not quantity demanded itself."
        ],
        "examApplication": [
          "Identify the changed determinant before comparing prices, quantities and stakeholders."
        ],
        "summary": [
          "A shortage means quantity demanded exceeds quantity supplied at a given price; a surplus means the reverse. In a flexible-price model they create upward and downward price pressure respectively.",
          "The size of a shortage is Qd minus Qs, not quantity demanded itself."
        ],
        "explanation": "A disequilibrium price makes trading plans incompatible.  buyers compete or sellers accumulate stock.  changing price adjusts quantities on both sides.\n\n### Original scenario and reasoning\n\nIllustrative example: Qd=90 and Qs=50 imply a shortage of 40. A price rise lowers quantity demanded and increases quantity supplied along the curves. Controls can prevent adjustment, so shortages need not disappear immediately.\n\nThe size of a shortage is Qd minus Qs, not quantity demanded itself.\n\nIdentify the changed determinant before comparing prices, quantities and stakeholders."
      }
    },
    "practice": [
      {
        "id": "u2-12-shortage-surplus-flash-1",
        "knowledgePointId": "u2-12-shortage-surplus",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“短缺、过剩与价格调整”，并说明一个关键条件。",
          "en": "Explain Shortages, surpluses and price adjustment and state one important condition."
        },
        "answer": {
          "zh-CN": "短缺是给定价格下需求量超过供给量；过剩是供给量超过需求量。在灵活价格模型中，两者分别带来涨价和降价压力。",
          "en": "A shortage means quantity demanded exceeds quantity supplied at a given price; a surplus means the reverse. In a flexible-price model they create upward and downward price pressure respectively."
        },
        "explanation": {
          "zh-CN": "短缺的大小是 Qd−Qs，不是需求量本身。",
          "en": "The size of a shortage is Qd minus Qs, not quantity demanded itself."
        }
      },
      {
        "id": "u2-12-shortage-surplus-mcq-1",
        "knowledgePointId": "u2-12-shortage-surplus",
        "type": "mcq",
        "prompt": {
          "zh-CN": "Qd=80、Qs=110 时，过剩为多少？",
          "en": "Qd=80 and Qs=110. How large is the surplus?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "80",
            "en": "80"
          },
          {
            "id": "b",
            "zh-CN": "110",
            "en": "110"
          },
          {
            "id": "c",
            "zh-CN": "190",
            "en": "190"
          },
          {
            "id": "d",
            "zh-CN": "30",
            "en": "30"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "30。 110 − 80 = 30 短缺的大小是 Qd−Qs，不是需求量本身。",
          "en": "30. 110 − 80 = 30 The size of a shortage is Qd minus Qs, not quantity demanded itself."
        }
      },
      {
        "id": "u2-12-shortage-surplus-short-1",
        "knowledgePointId": "u2-12-shortage-surplus",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释短缺、过剩与价格调整的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Shortages, surpluses and price adjustment and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "短缺是给定价格下需求量超过供给量；过剩是供给量超过需求量。在灵活价格模型中，两者分别带来涨价和降价压力。 非均衡价格使交易计划不一致；买方竞争或卖方积压；价格调整改变双方数量 原创例：Qd=90、Qs=50，短缺为 40。涨价会沿需求减少需求量、沿供给增加供给量。价格管制可能阻止这一调整，因此不能假设任何短缺都会自动立即消失。",
          "en": "A shortage means quantity demanded exceeds quantity supplied at a given price; a surplus means the reverse. In a flexible-price model they create upward and downward price pressure respectively. A disequilibrium price makes trading plans incompatible; buyers compete or sellers accumulate stock; changing price adjusts quantities on both sides Illustrative example: Qd=90 and Qs=50 imply a shortage of 40. A price rise lowers quantity demanded and increases quantity supplied along the curves. Controls can prevent adjustment, so shortages need not disappear immediately."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "短缺",
              "en": "shortage"
            },
            "alternatives": {
              "zh-CN": [
                "短缺",
                "非均衡价格使交易计划不一致"
              ],
              "en": [
                "shortage",
                "A disequilibrium price makes trading plans incompatible"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "过剩",
              "en": "surplus"
            },
            "alternatives": {
              "zh-CN": [
                "过剩",
                "买方竞争或卖方积压"
              ],
              "en": [
                "surplus",
                "buyers compete or sellers accumulate stock"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "价格调整",
              "en": "price adjustment"
            },
            "alternatives": {
              "zh-CN": [
                "价格调整",
                "价格调整改变双方数量"
              ],
              "en": [
                "price adjustment",
                "changing price adjusts quantities on both sides"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-13-equilibrium-shifts",
      "slug": "equilibrium-shifts",
      "section": "2.3",
      "level": "core",
      "syllabusRefs": [
        "2.3 Competitive market equilibrium"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.4",
          "pages": [
            57
          ]
        }
      ],
      "prerequisites": [
        "u2-01-demand",
        "u2-06-supply"
      ],
      "related": [
        "u2-11-equilibrium",
        "u2-12-shortage-surplus",
        "u2-14-price-mechanism"
      ],
      "terms": [
        "均衡变化与同时移动",
        "Equilibrium changes and simultaneous shifts",
        "移动",
        "shift",
        "数量",
        "quantity",
        "不确定",
        "ambiguous"
      ],
      "synonyms": {
        "zh-CN": [
          "移动",
          "数量",
          "不确定"
        ],
        "en": [
          "shift",
          "quantity",
          "ambiguous"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-13-equilibrium-shifts-flash-1",
        "u2-13-equilibrium-shifts-mcq-1",
        "u2-13-equilibrium-shifts-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-13-equilibrium-shifts",
        "locale": "zh-CN",
        "title": "均衡变化与同时移动",
        "takeaway": "非价格因素使需求或供给移动，产生新的均衡；两条曲线同时移动时，有些方向需要比较移动幅度才能判断。",
        "definition": "非价格因素使需求或供给移动，产生新的均衡；两条曲线同时移动时，有些方向需要比较移动幅度才能判断。",
        "causalChain": [
          "识别变化的决定因素",
          "移动相关曲线而保持其他关系不变",
          "比较新旧均衡价格和数量"
        ],
        "misconceptions": [
          "同时移动时必须保留不确定性，不能随意假定移动幅度相同。"
        ],
        "examApplication": [
          "先指出变化因素，再比较新旧价格、数量与利益相关者。"
        ],
        "summary": [
          "非价格因素使需求或供给移动，产生新的均衡；两条曲线同时移动时，有些方向需要比较移动幅度才能判断。",
          "同时移动时必须保留不确定性，不能随意假定移动幅度相同。"
        ],
        "explanation": "识别变化的决定因素。移动相关曲线而保持其他关系不变。比较新旧均衡价格和数量。\n\n### 原创情境与推导\n\n原创例：需求和供给都右移时，均衡数量增加，但价格可能升、降或不变。只知道移动方向，不能断言价格上涨。若需求右移且供给左移，价格上涨，而数量方向不确定。\n\n同时移动时必须保留不确定性，不能随意假定移动幅度相同。\n\n先指出变化因素，再比较新旧价格、数量与利益相关者。"
      },
      "en": {
        "id": "u2-13-equilibrium-shifts",
        "locale": "en",
        "title": "Equilibrium changes and simultaneous shifts",
        "takeaway": "Non-price changes shift demand or supply and produce a new equilibrium. With simultaneous shifts, some effects depend on their relative magnitudes.",
        "definition": "Non-price changes shift demand or supply and produce a new equilibrium. With simultaneous shifts, some effects depend on their relative magnitudes.",
        "causalChain": [
          "Identify the changed determinant",
          "shift the relevant curve while holding other relationships constant",
          "compare old and new equilibrium price and quantity"
        ],
        "misconceptions": [
          "Preserve ambiguity under simultaneous shifts rather than silently assuming equal magnitudes."
        ],
        "examApplication": [
          "Identify the changed determinant before comparing prices, quantities and stakeholders."
        ],
        "summary": [
          "Non-price changes shift demand or supply and produce a new equilibrium. With simultaneous shifts, some effects depend on their relative magnitudes.",
          "Preserve ambiguity under simultaneous shifts rather than silently assuming equal magnitudes."
        ],
        "explanation": "Identify the changed determinant.  shift the relevant curve while holding other relationships constant.  compare old and new equilibrium price and quantity.\n\n### Original scenario and reasoning\n\nIllustrative example: when demand and supply both shift right, equilibrium quantity rises but price may rise, fall or stay unchanged. Directions alone cannot determine price. With demand right and supply left, price rises but quantity is ambiguous.\n\nPreserve ambiguity under simultaneous shifts rather than silently assuming equal magnitudes.\n\nIdentify the changed determinant before comparing prices, quantities and stakeholders."
      }
    },
    "practice": [
      {
        "id": "u2-13-equilibrium-shifts-flash-1",
        "knowledgePointId": "u2-13-equilibrium-shifts",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“均衡变化与同时移动”，并说明一个关键条件。",
          "en": "Explain Equilibrium changes and simultaneous shifts and state one important condition."
        },
        "answer": {
          "zh-CN": "非价格因素使需求或供给移动，产生新的均衡；两条曲线同时移动时，有些方向需要比较移动幅度才能判断。",
          "en": "Non-price changes shift demand or supply and produce a new equilibrium. With simultaneous shifts, some effects depend on their relative magnitudes."
        },
        "explanation": {
          "zh-CN": "同时移动时必须保留不确定性，不能随意假定移动幅度相同。",
          "en": "Preserve ambiguity under simultaneous shifts rather than silently assuming equal magnitudes."
        }
      },
      {
        "id": "u2-13-equilibrium-shifts-mcq-1",
        "knowledgePointId": "u2-13-equilibrium-shifts",
        "type": "mcq",
        "prompt": {
          "zh-CN": "需求与供给同时右移，什么可以确定？",
          "en": "Demand and supply both shift right. What can be determined?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "均衡数量增加",
            "en": "Equilibrium quantity rises"
          },
          {
            "id": "b",
            "zh-CN": "价格必然上升",
            "en": "Price must rise"
          },
          {
            "id": "c",
            "zh-CN": "价格必然下降",
            "en": "Price must fall"
          },
          {
            "id": "d",
            "zh-CN": "数量必然减少",
            "en": "Quantity must fall"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "均衡数量增加。 识别变化的决定因素；移动相关曲线而保持其他关系不变；比较新旧均衡价格和数量 同时移动时必须保留不确定性，不能随意假定移动幅度相同。",
          "en": "Equilibrium quantity rises. Identify the changed determinant; shift the relevant curve while holding other relationships constant; compare old and new equilibrium price and quantity Preserve ambiguity under simultaneous shifts rather than silently assuming equal magnitudes."
        }
      },
      {
        "id": "u2-13-equilibrium-shifts-short-1",
        "knowledgePointId": "u2-13-equilibrium-shifts",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释均衡变化与同时移动的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Equilibrium changes and simultaneous shifts and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "非价格因素使需求或供给移动，产生新的均衡；两条曲线同时移动时，有些方向需要比较移动幅度才能判断。 识别变化的决定因素；移动相关曲线而保持其他关系不变；比较新旧均衡价格和数量 原创例：需求和供给都右移时，均衡数量增加，但价格可能升、降或不变。只知道移动方向，不能断言价格上涨。若需求右移且供给左移，价格上涨，而数量方向不确定。",
          "en": "Non-price changes shift demand or supply and produce a new equilibrium. With simultaneous shifts, some effects depend on their relative magnitudes. Identify the changed determinant; shift the relevant curve while holding other relationships constant; compare old and new equilibrium price and quantity Illustrative example: when demand and supply both shift right, equilibrium quantity rises but price may rise, fall or stay unchanged. Directions alone cannot determine price. With demand right and supply left, price rises but quantity is ambiguous."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "移动",
              "en": "shift"
            },
            "alternatives": {
              "zh-CN": [
                "移动",
                "识别变化的决定因素"
              ],
              "en": [
                "shift",
                "Identify the changed determinant"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "数量",
              "en": "quantity"
            },
            "alternatives": {
              "zh-CN": [
                "数量",
                "移动相关曲线而保持其他关系不变"
              ],
              "en": [
                "quantity",
                "shift the relevant curve while holding other relationships constant"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "不确定",
              "en": "ambiguous"
            },
            "alternatives": {
              "zh-CN": [
                "不确定",
                "比较新旧均衡价格和数量"
              ],
              "en": [
                "ambiguous",
                "compare old and new equilibrium price and quantity"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-14-price-mechanism",
      "slug": "price-mechanism",
      "section": "2.3",
      "level": "core",
      "syllabusRefs": [
        "2.3 Competitive market equilibrium"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.4",
          "pages": [
            57
          ]
        }
      ],
      "prerequisites": [
        "u2-01-demand",
        "u2-06-supply"
      ],
      "related": [
        "u2-11-equilibrium",
        "u2-12-shortage-surplus",
        "u2-13-equilibrium-shifts"
      ],
      "terms": [
        "价格的信号、激励与配给",
        "Price signals, incentives and rationing",
        "信号",
        "signal",
        "激励",
        "incentive",
        "配给",
        "rationing"
      ],
      "synonyms": {
        "zh-CN": [
          "信号",
          "激励",
          "配给"
        ],
        "en": [
          "signal",
          "incentive",
          "rationing"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-14-price-mechanism-flash-1",
        "u2-14-price-mechanism-mcq-1",
        "u2-14-price-mechanism-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-14-price-mechanism",
        "locale": "zh-CN",
        "title": "价格的信号、激励与配给",
        "takeaway": "价格通过传递相对稀缺信息、改变买卖激励及按支付意愿与能力分配有限商品，协调分散决策。",
        "definition": "价格通过传递相对稀缺信息、改变买卖激励及按支付意愿与能力分配有限商品，协调分散决策。",
        "causalChain": [
          "需求相对供给增加",
          "涨价传递稀缺信号",
          "生产者扩张且部分消费者减少购买"
        ],
        "misconceptions": [
          "高价反映市场相对稀缺，并不直接衡量人的需要有多迫切。"
        ],
        "examApplication": [
          "先指出变化因素，再比较新旧价格、数量与利益相关者。"
        ],
        "summary": [
          "价格通过传递相对稀缺信息、改变买卖激励及按支付意愿与能力分配有限商品，协调分散决策。",
          "高价反映市场相对稀缺，并不直接衡量人的需要有多迫切。"
        ],
        "explanation": "需求相对供给增加。涨价传递稀缺信号。生产者扩张且部分消费者减少购买。\n\n### 原创情境与推导\n\n原创例：雨季蔬菜受损，价格上涨既鼓励其他农场运来产品，也使部分买家节约用量。支付能力影响谁买得到，所以有效配给与公平分配不是同一评价标准。\n\n高价反映市场相对稀缺，并不直接衡量人的需要有多迫切。\n\n先指出变化因素，再比较新旧价格、数量与利益相关者。"
      },
      "en": {
        "id": "u2-14-price-mechanism",
        "locale": "en",
        "title": "Price signals, incentives and rationing",
        "takeaway": "Prices coordinate decentralised decisions by signalling relative scarcity, changing incentives and rationing scarce goods according to willingness and ability to pay.",
        "definition": "Prices coordinate decentralised decisions by signalling relative scarcity, changing incentives and rationing scarce goods according to willingness and ability to pay.",
        "causalChain": [
          "Demand rises relative to supply",
          "a higher price signals scarcity",
          "producers expand while some buyers reduce purchases"
        ],
        "misconceptions": [
          "A high price reflects relative market scarcity, not a direct measure of urgency of human need."
        ],
        "examApplication": [
          "Identify the changed determinant before comparing prices, quantities and stakeholders."
        ],
        "summary": [
          "Prices coordinate decentralised decisions by signalling relative scarcity, changing incentives and rationing scarce goods according to willingness and ability to pay.",
          "A high price reflects relative market scarcity, not a direct measure of urgency of human need."
        ],
        "explanation": "Demand rises relative to supply.  a higher price signals scarcity.  producers expand while some buyers reduce purchases.\n\n### Original scenario and reasoning\n\nIllustrative example: rain damages vegetables and prices rise, encouraging other farms to deliver more and buyers to economise. Ability to pay affects access, so efficient rationing and equitable distribution are distinct criteria.\n\nA high price reflects relative market scarcity, not a direct measure of urgency of human need.\n\nIdentify the changed determinant before comparing prices, quantities and stakeholders."
      }
    },
    "practice": [
      {
        "id": "u2-14-price-mechanism-flash-1",
        "knowledgePointId": "u2-14-price-mechanism",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“价格的信号、激励与配给”，并说明一个关键条件。",
          "en": "Explain Price signals, incentives and rationing and state one important condition."
        },
        "answer": {
          "zh-CN": "价格通过传递相对稀缺信息、改变买卖激励及按支付意愿与能力分配有限商品，协调分散决策。",
          "en": "Prices coordinate decentralised decisions by signalling relative scarcity, changing incentives and rationing scarce goods according to willingness and ability to pay."
        },
        "explanation": {
          "zh-CN": "高价反映市场相对稀缺，并不直接衡量人的需要有多迫切。",
          "en": "A high price reflects relative market scarcity, not a direct measure of urgency of human need."
        }
      },
      {
        "id": "u2-14-price-mechanism-mcq-1",
        "knowledgePointId": "u2-14-price-mechanism",
        "type": "mcq",
        "prompt": {
          "zh-CN": "涨价鼓励企业增产体现哪项功能？",
          "en": "A higher price encouraging firms to expand illustrates which function?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "消除所有稀缺",
            "en": "Eliminate all scarcity"
          },
          {
            "id": "b",
            "zh-CN": "激励",
            "en": "Incentive"
          },
          {
            "id": "c",
            "zh-CN": "保证收入平等",
            "en": "Guarantee equal income"
          },
          {
            "id": "d",
            "zh-CN": "固定生产配额",
            "en": "Fix production quotas"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "激励。 需求相对供给增加；涨价传递稀缺信号；生产者扩张且部分消费者减少购买 高价反映市场相对稀缺，并不直接衡量人的需要有多迫切。",
          "en": "Incentive. Demand rises relative to supply; a higher price signals scarcity; producers expand while some buyers reduce purchases A high price reflects relative market scarcity, not a direct measure of urgency of human need."
        }
      },
      {
        "id": "u2-14-price-mechanism-short-1",
        "knowledgePointId": "u2-14-price-mechanism",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释价格的信号、激励与配给的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Price signals, incentives and rationing and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "价格通过传递相对稀缺信息、改变买卖激励及按支付意愿与能力分配有限商品，协调分散决策。 需求相对供给增加；涨价传递稀缺信号；生产者扩张且部分消费者减少购买 原创例：雨季蔬菜受损，价格上涨既鼓励其他农场运来产品，也使部分买家节约用量。支付能力影响谁买得到，所以有效配给与公平分配不是同一评价标准。",
          "en": "Prices coordinate decentralised decisions by signalling relative scarcity, changing incentives and rationing scarce goods according to willingness and ability to pay. Demand rises relative to supply; a higher price signals scarcity; producers expand while some buyers reduce purchases Illustrative example: rain damages vegetables and prices rise, encouraging other farms to deliver more and buyers to economise. Ability to pay affects access, so efficient rationing and equitable distribution are distinct criteria."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "信号",
              "en": "signal"
            },
            "alternatives": {
              "zh-CN": [
                "信号",
                "需求相对供给增加"
              ],
              "en": [
                "signal",
                "Demand rises relative to supply"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "激励",
              "en": "incentive"
            },
            "alternatives": {
              "zh-CN": [
                "激励",
                "涨价传递稀缺信号"
              ],
              "en": [
                "incentive",
                "a higher price signals scarcity"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "配给",
              "en": "rationing"
            },
            "alternatives": {
              "zh-CN": [
                "配给",
                "生产者扩张且部分消费者减少购买"
              ],
              "en": [
                "rationing",
                "producers expand while some buyers reduce purchases"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-15-surplus-efficiency",
      "slug": "surplus-efficiency",
      "section": "2.3",
      "level": "core",
      "syllabusRefs": [
        "2.3 Competitive market equilibrium"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.5",
          "pages": [
            62
          ]
        }
      ],
      "prerequisites": [
        "u2-01-demand",
        "u2-06-supply"
      ],
      "related": [
        "u2-11-equilibrium",
        "u2-12-shortage-surplus",
        "u2-13-equilibrium-shifts"
      ],
      "terms": [
        "消费者剩余、生产者剩余与效率",
        "Surplus and allocative efficiency",
        "支付意愿",
        "willingness to pay",
        "边际成本",
        "marginal cost",
        "总剩余",
        "total surplus"
      ],
      "synonyms": {
        "zh-CN": [
          "支付意愿",
          "边际成本",
          "总剩余"
        ],
        "en": [
          "willingness to pay",
          "marginal cost",
          "total surplus"
        ]
      },
      "diagramIds": [
        "demand-supply"
      ],
      "quizIds": [
        "u2-15-surplus-efficiency-flash-1",
        "u2-15-surplus-efficiency-mcq-1",
        "u2-15-surplus-efficiency-short-1",
        "u2-15-surplus-efficiency-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-15-surplus-efficiency",
        "locale": "zh-CN",
        "hlExtension": "原创例：一件商品支付意愿 15、成交价 10、边际成本 7，则消费者剩余 5、生产者剩余 3，总剩余 8。若存在污染成本 4，私人总剩余并不完整代表社会净收益。",
        "title": "消费者剩余、生产者剩余与效率",
        "takeaway": "消费者剩余是支付意愿超过实付价格的部分；生产者剩余是所收价格超过边际供给成本的部分。无市场失灵的竞争均衡可最大化两者之和。",
        "definition": "消费者剩余是支付意愿超过实付价格的部分；生产者剩余是所收价格超过边际供给成本的部分。无市场失灵的竞争均衡可最大化两者之和。",
        "causalChain": [
          "需求代表边际利益、供给代表边际成本",
          "交易使利益超过成本的单位被生产",
          "MB=MC 时总剩余达到最大"
        ],
        "misconceptions": [
          "生产者剩余不等于利润，因为它通常没有扣除固定成本。"
        ],
        "examApplication": [
          "先指出变化因素，再比较新旧价格、数量与利益相关者。"
        ],
        "summary": [
          "消费者剩余是支付意愿超过实付价格的部分；生产者剩余是所收价格超过边际供给成本的部分。无市场失灵的竞争均衡可最大化两者之和。",
          "生产者剩余不等于利润，因为它通常没有扣除固定成本。"
        ],
        "explanation": "需求代表边际利益、供给代表边际成本。交易使利益超过成本的单位被生产。MB=MC 时总剩余达到最大。\n\n### 原创情境与推导\n\n原创例：在无外部性且信息充分的竞争市场，消费者支付低于其支付意愿、生产者收入超过边际成本时形成剩余；固定成本使生产者剩余不同于利润。图形剩余计算属于 HL。\n\n生产者剩余不等于利润，因为它通常没有扣除固定成本。\n\n先指出变化因素，再比较新旧价格、数量与利益相关者。"
      },
      "en": {
        "id": "u2-15-surplus-efficiency",
        "locale": "en",
        "hlExtension": "Illustrative example: willingness to pay is 15, price is ten and marginal cost is seven. Consumer surplus is five, producer surplus three and total surplus eight. An external pollution cost of four would make private surplus an incomplete welfare measure.",
        "title": "Surplus and allocative efficiency",
        "takeaway": "Consumer surplus is willingness to pay above the price paid; producer surplus is price received above marginal supply cost. Competitive equilibrium can maximise their sum when market-failure assumptions are absent.",
        "definition": "Consumer surplus is willingness to pay above the price paid; producer surplus is price received above marginal supply cost. Competitive equilibrium can maximise their sum when market-failure assumptions are absent.",
        "causalChain": [
          "Demand represents marginal benefit and supply marginal cost",
          "units whose benefits exceed costs are traded",
          "total surplus is maximised at MB=MC"
        ],
        "misconceptions": [
          "Producer surplus is not identical to profit because fixed costs have not generally been deducted."
        ],
        "examApplication": [
          "Identify the changed determinant before comparing prices, quantities and stakeholders."
        ],
        "summary": [
          "Consumer surplus is willingness to pay above the price paid; producer surplus is price received above marginal supply cost. Competitive equilibrium can maximise their sum when market-failure assumptions are absent.",
          "Producer surplus is not identical to profit because fixed costs have not generally been deducted."
        ],
        "explanation": "Demand represents marginal benefit and supply marginal cost.  units whose benefits exceed costs are traded.  total surplus is maximised at MB=MC.\n\n### Original scenario and reasoning\n\nIllustrative example: in a competitive market without externalities and with adequate information, willingness to pay above price creates consumer surplus and price above marginal cost creates producer surplus. Fixed costs distinguish producer surplus from profit. Diagram-area calculations are HL.\n\nProducer surplus is not identical to profit because fixed costs have not generally been deducted.\n\nIdentify the changed determinant before comparing prices, quantities and stakeholders."
      }
    },
    "practice": [
      {
        "id": "u2-15-surplus-efficiency-flash-1",
        "knowledgePointId": "u2-15-surplus-efficiency",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“消费者剩余、生产者剩余与效率”，并说明一个关键条件。",
          "en": "Explain Surplus and allocative efficiency and state one important condition."
        },
        "answer": {
          "zh-CN": "消费者剩余是支付意愿超过实付价格的部分；生产者剩余是所收价格超过边际供给成本的部分。无市场失灵的竞争均衡可最大化两者之和。",
          "en": "Consumer surplus is willingness to pay above the price paid; producer surplus is price received above marginal supply cost. Competitive equilibrium can maximise their sum when market-failure assumptions are absent."
        },
        "explanation": {
          "zh-CN": "生产者剩余不等于利润，因为它通常没有扣除固定成本。",
          "en": "Producer surplus is not identical to profit because fixed costs have not generally been deducted."
        }
      },
      {
        "id": "u2-15-surplus-efficiency-mcq-1",
        "knowledgePointId": "u2-15-surplus-efficiency",
        "type": "mcq",
        "prompt": {
          "zh-CN": "消费者剩余对应哪种差额？",
          "en": "Which gap describes consumer surplus?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "总收入减全部成本",
            "en": "Revenue minus all costs"
          },
          {
            "id": "b",
            "zh-CN": "税收减补贴",
            "en": "Tax revenue minus subsidies"
          },
          {
            "id": "c",
            "zh-CN": "支付意愿与实际支付价格之差",
            "en": "Willingness to pay minus the price paid"
          },
          {
            "id": "d",
            "zh-CN": "价格减固定成本",
            "en": "Price minus fixed cost"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "支付意愿与实际支付价格之差。 需求代表边际利益、供给代表边际成本；交易使利益超过成本的单位被生产；MB=MC 时总剩余达到最大 生产者剩余不等于利润，因为它通常没有扣除固定成本。",
          "en": "Willingness to pay minus the price paid. Demand represents marginal benefit and supply marginal cost; units whose benefits exceed costs are traded; total surplus is maximised at MB=MC Producer surplus is not identical to profit because fixed costs have not generally been deducted."
        }
      },
      {
        "id": "u2-15-surplus-efficiency-short-1",
        "knowledgePointId": "u2-15-surplus-efficiency",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释消费者剩余、生产者剩余与效率的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Surplus and allocative efficiency and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "消费者剩余是支付意愿超过实付价格的部分；生产者剩余是所收价格超过边际供给成本的部分。无市场失灵的竞争均衡可最大化两者之和。 需求代表边际利益、供给代表边际成本；交易使利益超过成本的单位被生产；MB=MC 时总剩余达到最大 原创例：在无外部性且信息充分的竞争市场，消费者支付低于其支付意愿、生产者收入超过边际成本时形成剩余；固定成本使生产者剩余不同于利润。图形剩余计算属于 HL。",
          "en": "Consumer surplus is willingness to pay above the price paid; producer surplus is price received above marginal supply cost. Competitive equilibrium can maximise their sum when market-failure assumptions are absent. Demand represents marginal benefit and supply marginal cost; units whose benefits exceed costs are traded; total surplus is maximised at MB=MC Illustrative example: in a competitive market without externalities and with adequate information, willingness to pay above price creates consumer surplus and price above marginal cost creates producer surplus. Fixed costs distinguish producer surplus from profit. Diagram-area calculations are HL."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "支付意愿",
              "en": "willingness to pay"
            },
            "alternatives": {
              "zh-CN": [
                "支付意愿",
                "需求代表边际利益、供给代表边际成本"
              ],
              "en": [
                "willingness to pay",
                "Demand represents marginal benefit and supply marginal cost"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "边际成本",
              "en": "marginal cost"
            },
            "alternatives": {
              "zh-CN": [
                "边际成本",
                "交易使利益超过成本的单位被生产"
              ],
              "en": [
                "marginal cost",
                "units whose benefits exceed costs are traded"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "总剩余",
              "en": "total surplus"
            },
            "alternatives": {
              "zh-CN": [
                "总剩余",
                "MB=MC 时总剩余达到最大"
              ],
              "en": [
                "total surplus",
                "total surplus is maximised at MB=MC"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u2-15-surplus-efficiency-mcq-hl-1",
        "knowledgePointId": "u2-15-surplus-efficiency",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "支付意愿 18、价格 12，消费者剩余是多少？",
          "en": "Willingness to pay is 18 and price 12. What is consumer surplus?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "12",
            "en": "12"
          },
          {
            "id": "b",
            "zh-CN": "18",
            "en": "18"
          },
          {
            "id": "c",
            "zh-CN": "30",
            "en": "30"
          },
          {
            "id": "d",
            "zh-CN": "6",
            "en": "6"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "6。 18 − 12 = 6",
          "en": "6. 18 − 12 = 6"
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-16-bounded-rationality",
      "slug": "bounded-rationality",
      "section": "2.4",
      "level": "hl",
      "syllabusRefs": [
        "2.4 Critique of maximizing behaviour"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.6",
          "pages": [
            72
          ]
        }
      ],
      "prerequisites": [
        "u1-24-economic-models"
      ],
      "related": [
        "u2-17-biases-nudges",
        "u2-18-firm-objectives"
      ],
      "terms": [
        "理性选择与有限理性",
        "Rational choice and bounded rationality",
        "信息",
        "information",
        "决策成本",
        "decision costs",
        "满意",
        "satisficing"
      ],
      "synonyms": {
        "zh-CN": [
          "信息",
          "决策成本",
          "满意"
        ],
        "en": [
          "information",
          "decision costs",
          "satisficing"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-16-bounded-rationality-flash-1",
        "u2-16-bounded-rationality-mcq-1",
        "u2-16-bounded-rationality-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-16-bounded-rationality",
        "locale": "zh-CN",
        "title": "理性选择与有限理性",
        "takeaway": "理性选择模型假设消费者偏好一致并在约束下最大化效用；有限理性强调信息、时间和处理能力限制，可能促使人选择足够满意的方案。",
        "definition": "理性选择模型假设消费者偏好一致并在约束下最大化效用；有限理性强调信息、时间和处理能力限制，可能促使人选择足够满意的方案。",
        "causalChain": [
          "可比较的选项很多",
          "搜索和计算有成本",
          "消费者采用简化规则或满意方案"
        ],
        "misconceptions": [
          "有限理性不是说人没有目标或随机选择。"
        ],
        "examApplication": [
          "用具体决策说明模型假设与行为证据的差异。"
        ],
        "summary": [
          "理性选择模型假设消费者偏好一致并在约束下最大化效用；有限理性强调信息、时间和处理能力限制，可能促使人选择足够满意的方案。",
          "有限理性不是说人没有目标或随机选择。"
        ],
        "explanation": "可比较的选项很多。搜索和计算有成本。消费者采用简化规则或满意方案。\n\n### 原创情境与推导\n\n原创例：购买手机时，不可能逐一比较所有品牌的每个参数。消费者可能先设价格上限和最低电池时长，再选第一个达标产品。这个策略节约决策成本，但未必最大化模型中的效用。 有限自控可使人偏离长期储蓄目标；有限自利表示社会偏好、互惠或公平也影响选择，并非所有人只考虑自身物质收益。\n\n有限理性不是说人没有目标或随机选择。\n\n用具体决策说明模型假设与行为证据的差异。"
      },
      "en": {
        "id": "u2-16-bounded-rationality",
        "locale": "en",
        "title": "Rational choice and bounded rationality",
        "takeaway": "Rational choice assumes consistent preferences and utility maximisation subject to constraints. Bounded rationality recognises limits to information, time and processing ability that can lead to satisficing.",
        "definition": "Rational choice assumes consistent preferences and utility maximisation subject to constraints. Bounded rationality recognises limits to information, time and processing ability that can lead to satisficing.",
        "causalChain": [
          "Many options must be compared",
          "search and calculation are costly",
          "consumers adopt simplifying rules or satisfactory options"
        ],
        "misconceptions": [
          "Bounded rationality does not mean consumers have no goals or choose randomly."
        ],
        "examApplication": [
          "Use a concrete decision to explain the gap between assumptions and observed behaviour."
        ],
        "summary": [
          "Rational choice assumes consistent preferences and utility maximisation subject to constraints. Bounded rationality recognises limits to information, time and processing ability that can lead to satisficing.",
          "Bounded rationality does not mean consumers have no goals or choose randomly."
        ],
        "explanation": "Many options must be compared.  search and calculation are costly.  consumers adopt simplifying rules or satisfactory options.\n\n### Original scenario and reasoning\n\nIllustrative example: a phone buyer cannot compare every attribute of every model. They set a budget and minimum battery life, then choose the first acceptable model. This saves decision costs without necessarily maximising modelled utility. Bounded self-control can undermine long-term saving plans; bounded selfishness recognises social preferences, reciprocity and fairness rather than pure material self-interest.\n\nBounded rationality does not mean consumers have no goals or choose randomly.\n\nUse a concrete decision to explain the gap between assumptions and observed behaviour."
      }
    },
    "practice": [
      {
        "id": "u2-16-bounded-rationality-flash-1",
        "knowledgePointId": "u2-16-bounded-rationality",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“理性选择与有限理性”，并说明一个关键条件。",
          "en": "Explain Rational choice and bounded rationality and state one important condition."
        },
        "answer": {
          "zh-CN": "理性选择模型假设消费者偏好一致并在约束下最大化效用；有限理性强调信息、时间和处理能力限制，可能促使人选择足够满意的方案。",
          "en": "Rational choice assumes consistent preferences and utility maximisation subject to constraints. Bounded rationality recognises limits to information, time and processing ability that can lead to satisficing."
        },
        "explanation": {
          "zh-CN": "有限理性不是说人没有目标或随机选择。",
          "en": "Bounded rationality does not mean consumers have no goals or choose randomly."
        }
      },
      {
        "id": "u2-16-bounded-rationality-mcq-1",
        "knowledgePointId": "u2-16-bounded-rationality",
        "type": "mcq",
        "prompt": {
          "zh-CN": "选第一个满足最低要求的产品属于什么？",
          "en": "Choosing the first product that meets minimum requirements is what?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "完全信息下精确最优",
            "en": "Exact optimisation with perfect information"
          },
          {
            "id": "b",
            "zh-CN": "固定成本增加",
            "en": "Higher fixed cost"
          },
          {
            "id": "c",
            "zh-CN": "纯公共物品",
            "en": "A pure public good"
          },
          {
            "id": "d",
            "zh-CN": "满意化",
            "en": "Satisficing"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "满意化。 可比较的选项很多；搜索和计算有成本；消费者采用简化规则或满意方案 有限理性不是说人没有目标或随机选择。",
          "en": "Satisficing. Many options must be compared; search and calculation are costly; consumers adopt simplifying rules or satisfactory options Bounded rationality does not mean consumers have no goals or choose randomly."
        }
      },
      {
        "id": "u2-16-bounded-rationality-short-1",
        "knowledgePointId": "u2-16-bounded-rationality",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释理性选择与有限理性的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Rational choice and bounded rationality and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "理性选择模型假设消费者偏好一致并在约束下最大化效用；有限理性强调信息、时间和处理能力限制，可能促使人选择足够满意的方案。 可比较的选项很多；搜索和计算有成本；消费者采用简化规则或满意方案 原创例：购买手机时，不可能逐一比较所有品牌的每个参数。消费者可能先设价格上限和最低电池时长，再选第一个达标产品。这个策略节约决策成本，但未必最大化模型中的效用。 有限自控可使人偏离长期储蓄目标；有限自利表示社会偏好、互惠或公平也影响选择，并非所有人只考虑自身物质收益。",
          "en": "Rational choice assumes consistent preferences and utility maximisation subject to constraints. Bounded rationality recognises limits to information, time and processing ability that can lead to satisficing. Many options must be compared; search and calculation are costly; consumers adopt simplifying rules or satisfactory options Illustrative example: a phone buyer cannot compare every attribute of every model. They set a budget and minimum battery life, then choose the first acceptable model. This saves decision costs without necessarily maximising modelled utility. Bounded self-control can undermine long-term saving plans; bounded selfishness recognises social preferences, reciprocity and fairness rather than pure material self-interest."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "信息",
              "en": "information"
            },
            "alternatives": {
              "zh-CN": [
                "信息",
                "可比较的选项很多"
              ],
              "en": [
                "information",
                "Many options must be compared"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "决策成本",
              "en": "decision costs"
            },
            "alternatives": {
              "zh-CN": [
                "决策成本",
                "搜索和计算有成本"
              ],
              "en": [
                "decision costs",
                "search and calculation are costly"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "满意",
              "en": "satisficing"
            },
            "alternatives": {
              "zh-CN": [
                "满意",
                "消费者采用简化规则或满意方案"
              ],
              "en": [
                "satisficing",
                "consumers adopt simplifying rules or satisfactory options"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-17-biases-nudges",
      "slug": "biases-nudges",
      "section": "2.4",
      "level": "hl",
      "syllabusRefs": [
        "2.4 Critique of maximizing behaviour"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.6",
          "pages": [
            72
          ]
        }
      ],
      "prerequisites": [
        "u1-24-economic-models"
      ],
      "related": [
        "u2-16-bounded-rationality",
        "u2-18-firm-objectives"
      ],
      "terms": [
        "行为偏差与助推",
        "Behavioural biases and nudges",
        "默认",
        "default",
        "选择环境",
        "choice architecture",
        "退出",
        "opt-out"
      ],
      "synonyms": {
        "zh-CN": [
          "默认",
          "选择环境",
          "退出"
        ],
        "en": [
          "default",
          "choice architecture",
          "opt-out"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-17-biases-nudges-flash-1",
        "u2-17-biases-nudges-mcq-1",
        "u2-17-biases-nudges-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-17-biases-nudges",
        "locale": "zh-CN",
        "title": "行为偏差与助推",
        "takeaway": "锚定、损失厌恶、现在偏好及默认选项等可改变选择；助推通过调整选择环境影响行为，同时保留选择自由。",
        "definition": "锚定、损失厌恶、现在偏好及默认选项等可改变选择；助推通过调整选择环境影响行为，同时保留选择自由。",
        "causalChain": [
          "注意力与判断受到呈现方式影响",
          "默认或框架改变心理参照",
          "选择在价格未变时也可改变"
        ],
        "misconceptions": [
          "助推不是税收或禁止；减少选择自由的措施需要另行分类。"
        ],
        "examApplication": [
          "用具体决策说明模型假设与行为证据的差异。"
        ],
        "summary": [
          "锚定、损失厌恶、现在偏好及默认选项等可改变选择；助推通过调整选择环境影响行为，同时保留选择自由。",
          "助推不是税收或禁止；减少选择自由的措施需要另行分类。"
        ],
        "explanation": "注意力与判断受到呈现方式影响。默认或框架改变心理参照。选择在价格未变时也可改变。\n\n### 原创情境与推导\n\n原创例：退休储蓄从主动加入改为默认加入但允许退出，可能提高参与率。默认选项不是强制。评价时应讨论退出是否容易、受益者是谁及是否存在操纵风险。 锚定是过度依赖最先出现的数值；框架效应是同义信息因表达不同而影响选择；可得性偏差是以容易回想的例子替代概率判断。默认选择允许退出，限制选择缩小选项集，强制选择要求主动表态。\n\n助推不是税收或禁止；减少选择自由的措施需要另行分类。\n\n用具体决策说明模型假设与行为证据的差异。"
      },
      "en": {
        "id": "u2-17-biases-nudges",
        "locale": "en",
        "title": "Behavioural biases and nudges",
        "takeaway": "Anchoring, loss aversion, present bias and defaults can influence choices. A nudge changes choice architecture while preserving freedom to choose.",
        "definition": "Anchoring, loss aversion, present bias and defaults can influence choices. A nudge changes choice architecture while preserving freedom to choose.",
        "causalChain": [
          "Presentation influences attention and judgement",
          "defaults or framing alter reference points",
          "choices can change even without a price change"
        ],
        "misconceptions": [
          "A nudge is not a tax or prohibition; policies restricting choice require a different classification."
        ],
        "examApplication": [
          "Use a concrete decision to explain the gap between assumptions and observed behaviour."
        ],
        "summary": [
          "Anchoring, loss aversion, present bias and defaults can influence choices. A nudge changes choice architecture while preserving freedom to choose.",
          "A nudge is not a tax or prohibition; policies restricting choice require a different classification."
        ],
        "explanation": "Presentation influences attention and judgement.  defaults or framing alter reference points.  choices can change even without a price change.\n\n### Original scenario and reasoning\n\nIllustrative example: pension saving changes from opt-in to default enrolment with an opt-out. Participation may rise. A default is not compulsion. Evaluate ease of opting out, who benefits and potential manipulation. Anchoring overweights an initial number; framing changes choices through presentation of equivalent information; availability substitutes easily recalled examples for probability. Defaults allow opting out, restricted choice narrows options, and mandated choice requires an active decision.\n\nA nudge is not a tax or prohibition; policies restricting choice require a different classification.\n\nUse a concrete decision to explain the gap between assumptions and observed behaviour."
      }
    },
    "practice": [
      {
        "id": "u2-17-biases-nudges-flash-1",
        "knowledgePointId": "u2-17-biases-nudges",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“行为偏差与助推”，并说明一个关键条件。",
          "en": "Explain Behavioural biases and nudges and state one important condition."
        },
        "answer": {
          "zh-CN": "锚定、损失厌恶、现在偏好及默认选项等可改变选择；助推通过调整选择环境影响行为，同时保留选择自由。",
          "en": "Anchoring, loss aversion, present bias and defaults can influence choices. A nudge changes choice architecture while preserving freedom to choose."
        },
        "explanation": {
          "zh-CN": "助推不是税收或禁止；减少选择自由的措施需要另行分类。",
          "en": "A nudge is not a tax or prohibition; policies restricting choice require a different classification."
        }
      },
      {
        "id": "u2-17-biases-nudges-mcq-1",
        "knowledgePointId": "u2-17-biases-nudges",
        "type": "mcq",
        "prompt": {
          "zh-CN": "默认加入且可自由退出的储蓄方案最接近什么？",
          "en": "Default enrolment in saving with a free opt-out is closest to what?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "助推",
            "en": "A nudge"
          },
          {
            "id": "b",
            "zh-CN": "强制禁令",
            "en": "A compulsory ban"
          },
          {
            "id": "c",
            "zh-CN": "单位生产补贴",
            "en": "A per-unit production subsidy"
          },
          {
            "id": "d",
            "zh-CN": "价格下限",
            "en": "A price floor"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "助推。 注意力与判断受到呈现方式影响；默认或框架改变心理参照；选择在价格未变时也可改变 助推不是税收或禁止；减少选择自由的措施需要另行分类。",
          "en": "A nudge. Presentation influences attention and judgement; defaults or framing alter reference points; choices can change even without a price change A nudge is not a tax or prohibition; policies restricting choice require a different classification."
        }
      },
      {
        "id": "u2-17-biases-nudges-short-1",
        "knowledgePointId": "u2-17-biases-nudges",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释行为偏差与助推的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Behavioural biases and nudges and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "锚定、损失厌恶、现在偏好及默认选项等可改变选择；助推通过调整选择环境影响行为，同时保留选择自由。 注意力与判断受到呈现方式影响；默认或框架改变心理参照；选择在价格未变时也可改变 原创例：退休储蓄从主动加入改为默认加入但允许退出，可能提高参与率。默认选项不是强制。评价时应讨论退出是否容易、受益者是谁及是否存在操纵风险。 锚定是过度依赖最先出现的数值；框架效应是同义信息因表达不同而影响选择；可得性偏差是以容易回想的例子替代概率判断。默认选择允许退出，限制选择缩小选项集，强制选择要求主动表态。",
          "en": "Anchoring, loss aversion, present bias and defaults can influence choices. A nudge changes choice architecture while preserving freedom to choose. Presentation influences attention and judgement; defaults or framing alter reference points; choices can change even without a price change Illustrative example: pension saving changes from opt-in to default enrolment with an opt-out. Participation may rise. A default is not compulsion. Evaluate ease of opting out, who benefits and potential manipulation. Anchoring overweights an initial number; framing changes choices through presentation of equivalent information; availability substitutes easily recalled examples for probability. Defaults allow opting out, restricted choice narrows options, and mandated choice requires an active decision."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "默认",
              "en": "default"
            },
            "alternatives": {
              "zh-CN": [
                "默认",
                "注意力与判断受到呈现方式影响"
              ],
              "en": [
                "default",
                "Presentation influences attention and judgement"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "选择环境",
              "en": "choice architecture"
            },
            "alternatives": {
              "zh-CN": [
                "选择环境",
                "默认或框架改变心理参照"
              ],
              "en": [
                "choice architecture",
                "defaults or framing alter reference points"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "退出",
              "en": "opt-out"
            },
            "alternatives": {
              "zh-CN": [
                "退出",
                "选择在价格未变时也可改变"
              ],
              "en": [
                "opt-out",
                "choices can change even without a price change"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-18-firm-objectives",
      "slug": "firm-objectives",
      "section": "2.4",
      "level": "hl",
      "syllabusRefs": [
        "2.4 Critique of maximizing behaviour"
      ],
      "textbookRefs": [
        {
          "chapter": "2",
          "section": "2.6",
          "pages": [
            72
          ]
        }
      ],
      "prerequisites": [
        "u1-24-economic-models"
      ],
      "related": [
        "u2-16-bounded-rationality",
        "u2-17-biases-nudges"
      ],
      "terms": [
        "企业的多重目标",
        "Alternative objectives of firms",
        "目标",
        "objectives",
        "收入",
        "revenue",
        "成本",
        "cost"
      ],
      "synonyms": {
        "zh-CN": [
          "目标",
          "收入",
          "成本"
        ],
        "en": [
          "objectives",
          "revenue",
          "cost"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-18-firm-objectives-flash-1",
        "u2-18-firm-objectives-mcq-1",
        "u2-18-firm-objectives-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-18-firm-objectives",
        "locale": "zh-CN",
        "title": "企业的多重目标",
        "takeaway": "企业可能追求利润、收入、增长、市场份额、社会目标或足够利润；管理者与所有者目标也可能不同。",
        "definition": "企业可能追求利润、收入、增长、市场份额、社会目标或足够利润；管理者与所有者目标也可能不同。",
        "causalChain": [
          "所有者与管理者面临不同激励",
          "增长或声誉可能优先",
          "短期产量不一定对应最大利润"
        ],
        "misconceptions": [
          "收入最大化忽略成本，不能直接当作利润最大化。"
        ],
        "examApplication": [
          "用具体决策说明模型假设与行为证据的差异。"
        ],
        "summary": [
          "企业可能追求利润、收入、增长、市场份额、社会目标或足够利润；管理者与所有者目标也可能不同。",
          "收入最大化忽略成本，不能直接当作利润最大化。"
        ],
        "explanation": "所有者与管理者面临不同激励。增长或声誉可能优先。短期产量不一定对应最大利润。\n\n### 原创情境与推导\n\n原创例：平台低价吸引用户以扩大市场份额，短期利润可能为负。不能仅凭低利润判断决策错误，需考虑长期回报、融资约束和竞争者反应。收入最大化与利润最大化也不同。 企业还可能追求企业社会责任、销售增长或满意利润；这些目标可能牺牲短期利润，也可能通过声誉支持长期收益。\n\n收入最大化忽略成本，不能直接当作利润最大化。\n\n用具体决策说明模型假设与行为证据的差异。"
      },
      "en": {
        "id": "u2-18-firm-objectives",
        "locale": "en",
        "title": "Alternative objectives of firms",
        "takeaway": "Firms may seek profit, revenue, growth, market share, social objectives or satisfactory profit. Managers and owners may have different objectives.",
        "definition": "Firms may seek profit, revenue, growth, market share, social objectives or satisfactory profit. Managers and owners may have different objectives.",
        "causalChain": [
          "Owners and managers face different incentives",
          "growth or reputation may take priority",
          "short-run output need not maximise profit"
        ],
        "misconceptions": [
          "Revenue maximisation ignores costs and is not equivalent to profit maximisation."
        ],
        "examApplication": [
          "Use a concrete decision to explain the gap between assumptions and observed behaviour."
        ],
        "summary": [
          "Firms may seek profit, revenue, growth, market share, social objectives or satisfactory profit. Managers and owners may have different objectives.",
          "Revenue maximisation ignores costs and is not equivalent to profit maximisation."
        ],
        "explanation": "Owners and managers face different incentives.  growth or reputation may take priority.  short-run output need not maximise profit.\n\n### Original scenario and reasoning\n\nIllustrative example: a platform charges low prices to build market share despite a short-run loss. Low profit alone does not prove a mistaken decision; consider future returns, financing and rivals' responses. Revenue and profit maximisation differ. Firms may also pursue corporate social responsibility, sales growth or satisfactory profit, potentially sacrificing short-run profit or supporting long-run returns through reputation.\n\nRevenue maximisation ignores costs and is not equivalent to profit maximisation.\n\nUse a concrete decision to explain the gap between assumptions and observed behaviour."
      }
    },
    "practice": [
      {
        "id": "u2-18-firm-objectives-flash-1",
        "knowledgePointId": "u2-18-firm-objectives",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“企业的多重目标”，并说明一个关键条件。",
          "en": "Explain Alternative objectives of firms and state one important condition."
        },
        "answer": {
          "zh-CN": "企业可能追求利润、收入、增长、市场份额、社会目标或足够利润；管理者与所有者目标也可能不同。",
          "en": "Firms may seek profit, revenue, growth, market share, social objectives or satisfactory profit. Managers and owners may have different objectives."
        },
        "explanation": {
          "zh-CN": "收入最大化忽略成本，不能直接当作利润最大化。",
          "en": "Revenue maximisation ignores costs and is not equivalent to profit maximisation."
        }
      },
      {
        "id": "u2-18-firm-objectives-mcq-1",
        "knowledgePointId": "u2-18-firm-objectives",
        "type": "mcq",
        "prompt": {
          "zh-CN": "企业收入上升但成本增加更多，利润怎样？",
          "en": "Revenue rises but costs increase by more. What happens to profit?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "利润必然上升",
            "en": "Profit must rise"
          },
          {
            "id": "b",
            "zh-CN": "利润下降",
            "en": "Profit falls"
          },
          {
            "id": "c",
            "zh-CN": "利润一定为零",
            "en": "Profit is necessarily zero"
          },
          {
            "id": "d",
            "zh-CN": "收入下降",
            "en": "Revenue falls"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "利润下降。 所有者与管理者面临不同激励；增长或声誉可能优先；短期产量不一定对应最大利润 收入最大化忽略成本，不能直接当作利润最大化。",
          "en": "Profit falls. Owners and managers face different incentives; growth or reputation may take priority; short-run output need not maximise profit Revenue maximisation ignores costs and is not equivalent to profit maximisation."
        }
      },
      {
        "id": "u2-18-firm-objectives-short-1",
        "knowledgePointId": "u2-18-firm-objectives",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释企业的多重目标的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Alternative objectives of firms and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "企业可能追求利润、收入、增长、市场份额、社会目标或足够利润；管理者与所有者目标也可能不同。 所有者与管理者面临不同激励；增长或声誉可能优先；短期产量不一定对应最大利润 原创例：平台低价吸引用户以扩大市场份额，短期利润可能为负。不能仅凭低利润判断决策错误，需考虑长期回报、融资约束和竞争者反应。收入最大化与利润最大化也不同。 企业还可能追求企业社会责任、销售增长或满意利润；这些目标可能牺牲短期利润，也可能通过声誉支持长期收益。",
          "en": "Firms may seek profit, revenue, growth, market share, social objectives or satisfactory profit. Managers and owners may have different objectives. Owners and managers face different incentives; growth or reputation may take priority; short-run output need not maximise profit Illustrative example: a platform charges low prices to build market share despite a short-run loss. Low profit alone does not prove a mistaken decision; consider future returns, financing and rivals' responses. Revenue and profit maximisation differ. Firms may also pursue corporate social responsibility, sales growth or satisfactory profit, potentially sacrificing short-run profit or supporting long-run returns through reputation."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "目标",
              "en": "objectives"
            },
            "alternatives": {
              "zh-CN": [
                "目标",
                "所有者与管理者面临不同激励"
              ],
              "en": [
                "objectives",
                "Owners and managers face different incentives"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "收入",
              "en": "revenue"
            },
            "alternatives": {
              "zh-CN": [
                "收入",
                "增长或声誉可能优先"
              ],
              "en": [
                "revenue",
                "growth or reputation may take priority"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "成本",
              "en": "cost"
            },
            "alternatives": {
              "zh-CN": [
                "成本",
                "短期产量不一定对应最大利润"
              ],
              "en": [
                "cost",
                "short-run output need not maximise profit"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-19-ped",
      "slug": "ped",
      "section": "2.5",
      "level": "core",
      "syllabusRefs": [
        "2.5 Elasticity of demand"
      ],
      "textbookRefs": [
        {
          "chapter": "3",
          "section": "3.1",
          "pages": [
            85
          ]
        }
      ],
      "prerequisites": [
        "u2-01-demand"
      ],
      "related": [
        "u2-20-ped-determinants",
        "u2-21-ped-revenue",
        "u2-22-yed"
      ],
      "terms": [
        "需求价格弹性 PED",
        "Price elasticity of demand",
        "百分比",
        "percentage",
        "自身价格",
        "own price",
        "绝对值",
        "absolute value"
      ],
      "synonyms": {
        "zh-CN": [
          "百分比",
          "自身价格",
          "绝对值"
        ],
        "en": [
          "percentage",
          "own price",
          "absolute value"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-19-ped-flash-1",
        "u2-19-ped-mcq-1",
        "u2-19-ped-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-19-ped",
        "locale": "zh-CN",
        "title": "需求价格弹性 PED",
        "takeaway": "PED 衡量需求量对自身价格变化的反应程度，等于需求量百分比变化除以价格百分比变化；分类通常使用绝对值。",
        "definition": "PED 衡量需求量对自身价格变化的反应程度，等于需求量百分比变化除以价格百分比变化；分类通常使用绝对值。",
        "causalChain": [
          "先计算数量与价格的百分比变化",
          "用数量百分比除以价格百分比",
          "绝对值大于一表示富有弹性"
        ],
        "misconceptions": [
          "弹性是百分比之比，不是曲线斜率，也不是数量变化除以价格变化。"
        ],
        "examApplication": [
          "列公式、代入同一基数的百分比、解释符号与分类。"
        ],
        "summary": [
          "PED 衡量需求量对自身价格变化的反应程度，等于需求量百分比变化除以价格百分比变化；分类通常使用绝对值。",
          "弹性是百分比之比，不是曲线斜率，也不是数量变化除以价格变化。"
        ],
        "explanation": "先计算数量与价格的百分比变化。用数量百分比除以价格百分比。绝对值大于一表示富有弹性。\n\n### 原创情境与推导\n\n原创例：价格上涨 10%，需求量下降 20%，PED=-2，绝对值为 2，属于富有弹性。必须说明采用基期还是中点法；比较同一个变化时不要混用两种基数。\n\n弹性是百分比之比，不是曲线斜率，也不是数量变化除以价格变化。\n\n列公式、代入同一基数的百分比、解释符号与分类。"
      },
      "en": {
        "id": "u2-19-ped",
        "locale": "en",
        "title": "Price elasticity of demand",
        "takeaway": "PED measures the responsiveness of quantity demanded to own-price changes: percentage change in quantity demanded divided by percentage change in price. Classification normally uses its absolute value.",
        "definition": "PED measures the responsiveness of quantity demanded to own-price changes: percentage change in quantity demanded divided by percentage change in price. Classification normally uses its absolute value.",
        "causalChain": [
          "Calculate percentage changes in quantity and price",
          "divide the quantity percentage by the price percentage",
          "magnitude above one means elastic demand"
        ],
        "misconceptions": [
          "Elasticity is a ratio of percentage changes, not the slope or a ratio of absolute changes."
        ],
        "examApplication": [
          "State the formula, use consistent percentage bases and interpret sign and classification."
        ],
        "summary": [
          "PED measures the responsiveness of quantity demanded to own-price changes: percentage change in quantity demanded divided by percentage change in price. Classification normally uses its absolute value.",
          "Elasticity is a ratio of percentage changes, not the slope or a ratio of absolute changes."
        ],
        "explanation": "Calculate percentage changes in quantity and price.  divide the quantity percentage by the price percentage.  magnitude above one means elastic demand.\n\n### Original scenario and reasoning\n\nIllustrative example: price rises 10% and quantity demanded falls 20%, so PED is -2, with magnitude two: elastic. State whether base-period or midpoint percentages are used and do not mix denominators within a calculation.\n\nElasticity is a ratio of percentage changes, not the slope or a ratio of absolute changes.\n\nState the formula, use consistent percentage bases and interpret sign and classification."
      }
    },
    "practice": [
      {
        "id": "u2-19-ped-flash-1",
        "knowledgePointId": "u2-19-ped",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“需求价格弹性 PED”，并说明一个关键条件。",
          "en": "Explain Price elasticity of demand and state one important condition."
        },
        "answer": {
          "zh-CN": "PED 衡量需求量对自身价格变化的反应程度，等于需求量百分比变化除以价格百分比变化；分类通常使用绝对值。",
          "en": "PED measures the responsiveness of quantity demanded to own-price changes: percentage change in quantity demanded divided by percentage change in price. Classification normally uses its absolute value."
        },
        "explanation": {
          "zh-CN": "弹性是百分比之比，不是曲线斜率，也不是数量变化除以价格变化。",
          "en": "Elasticity is a ratio of percentage changes, not the slope or a ratio of absolute changes."
        }
      },
      {
        "id": "u2-19-ped-mcq-1",
        "knowledgePointId": "u2-19-ped",
        "type": "mcq",
        "prompt": {
          "zh-CN": "价格涨 5%、需求量降 15%，PED 绝对值是多少？",
          "en": "Price rises 5% and quantity falls 15%. What is the magnitude of PED?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "0.33",
            "en": "0.33"
          },
          {
            "id": "b",
            "zh-CN": "10",
            "en": "10"
          },
          {
            "id": "c",
            "zh-CN": "3",
            "en": "3"
          },
          {
            "id": "d",
            "zh-CN": "75",
            "en": "75"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "3。 PED = −15% / 5% = −3; |PED| = 3 弹性是百分比之比，不是曲线斜率，也不是数量变化除以价格变化。",
          "en": "3. PED = −15% / 5% = −3; |PED| = 3 Elasticity is a ratio of percentage changes, not the slope or a ratio of absolute changes."
        }
      },
      {
        "id": "u2-19-ped-short-1",
        "knowledgePointId": "u2-19-ped",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释需求价格弹性 PED的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Price elasticity of demand and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "PED 衡量需求量对自身价格变化的反应程度，等于需求量百分比变化除以价格百分比变化；分类通常使用绝对值。 先计算数量与价格的百分比变化；用数量百分比除以价格百分比；绝对值大于一表示富有弹性 原创例：价格上涨 10%，需求量下降 20%，PED=-2，绝对值为 2，属于富有弹性。必须说明采用基期还是中点法；比较同一个变化时不要混用两种基数。",
          "en": "PED measures the responsiveness of quantity demanded to own-price changes: percentage change in quantity demanded divided by percentage change in price. Classification normally uses its absolute value. Calculate percentage changes in quantity and price; divide the quantity percentage by the price percentage; magnitude above one means elastic demand Illustrative example: price rises 10% and quantity demanded falls 20%, so PED is -2, with magnitude two: elastic. State whether base-period or midpoint percentages are used and do not mix denominators within a calculation."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "百分比",
              "en": "percentage"
            },
            "alternatives": {
              "zh-CN": [
                "百分比",
                "先计算数量与价格的百分比变化"
              ],
              "en": [
                "percentage",
                "Calculate percentage changes in quantity and price"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "自身价格",
              "en": "own price"
            },
            "alternatives": {
              "zh-CN": [
                "自身价格",
                "用数量百分比除以价格百分比"
              ],
              "en": [
                "own price",
                "divide the quantity percentage by the price percentage"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "绝对值",
              "en": "absolute value"
            },
            "alternatives": {
              "zh-CN": [
                "绝对值",
                "绝对值大于一表示富有弹性"
              ],
              "en": [
                "absolute value",
                "magnitude above one means elastic demand"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-20-ped-determinants",
      "slug": "ped-determinants",
      "section": "2.5",
      "level": "core",
      "syllabusRefs": [
        "2.5 Elasticity of demand"
      ],
      "textbookRefs": [
        {
          "chapter": "3",
          "section": "3.1",
          "pages": [
            85
          ]
        }
      ],
      "prerequisites": [
        "u2-01-demand"
      ],
      "related": [
        "u2-19-ped",
        "u2-21-ped-revenue",
        "u2-22-yed"
      ],
      "terms": [
        "PED 的决定因素",
        "Determinants of PED",
        "替代品",
        "substitutes",
        "时间",
        "time",
        "反应",
        "responsiveness"
      ],
      "synonyms": {
        "zh-CN": [
          "替代品",
          "时间",
          "反应"
        ],
        "en": [
          "substitutes",
          "time",
          "responsiveness"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-20-ped-determinants-flash-1",
        "u2-20-ped-determinants-mcq-1",
        "u2-20-ped-determinants-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-20-ped-determinants",
        "locale": "zh-CN",
        "title": "PED 的决定因素",
        "takeaway": "替代品的可得性、必要程度、收入占比和调整时间会影响消费者的价格反应。",
        "definition": "替代品的可得性、必要程度、收入占比和调整时间会影响消费者的价格反应。",
        "causalChain": [
          "替代品更多或调整时间更长",
          "消费者更容易改变购买方式",
          "需求通常更富有弹性"
        ],
        "misconceptions": [
          "必需品通常缺乏弹性，但并非需求量完全不变。"
        ],
        "examApplication": [
          "列公式、代入同一基数的百分比、解释符号与分类。"
        ],
        "summary": [
          "替代品的可得性、必要程度、收入占比和调整时间会影响消费者的价格反应。",
          "必需品通常缺乏弹性，但并非需求量完全不变。"
        ],
        "explanation": "替代品更多或调整时间更长。消费者更容易改变购买方式。需求通常更富有弹性。\n\n### 原创情境与推导\n\n原创例：某一品牌瓶装水有很多替代品，全部饮用水的替代选择却较少。狭义市场的需求可能比广义市场更富有弹性。评价税收时还需区分短期习惯和长期适应。\n\n必需品通常缺乏弹性，但并非需求量完全不变。\n\n列公式、代入同一基数的百分比、解释符号与分类。"
      },
      "en": {
        "id": "u2-20-ped-determinants",
        "locale": "en",
        "title": "Determinants of PED",
        "takeaway": "Availability of substitutes, necessity, share of income and time to adjust influence consumers' responsiveness to price.",
        "definition": "Availability of substitutes, necessity, share of income and time to adjust influence consumers' responsiveness to price.",
        "causalChain": [
          "More substitutes or more adjustment time",
          "consumers can change purchases more easily",
          "demand is normally more elastic"
        ],
        "misconceptions": [
          "Necessities are often inelastic, but their quantity demanded is not necessarily completely fixed."
        ],
        "examApplication": [
          "State the formula, use consistent percentage bases and interpret sign and classification."
        ],
        "summary": [
          "Availability of substitutes, necessity, share of income and time to adjust influence consumers' responsiveness to price.",
          "Necessities are often inelastic, but their quantity demanded is not necessarily completely fixed."
        ],
        "explanation": "More substitutes or more adjustment time.  consumers can change purchases more easily.  demand is normally more elastic.\n\n### Original scenario and reasoning\n\nIllustrative example: one bottled-water brand has many substitutes, whereas drinking water as a whole has fewer. Narrowly defined markets may be more elastic than broad ones. Tax evaluation should distinguish short-run habits from long-run adaptation.\n\nNecessities are often inelastic, but their quantity demanded is not necessarily completely fixed.\n\nState the formula, use consistent percentage bases and interpret sign and classification."
      }
    },
    "practice": [
      {
        "id": "u2-20-ped-determinants-flash-1",
        "knowledgePointId": "u2-20-ped-determinants",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“PED 的决定因素”，并说明一个关键条件。",
          "en": "Explain Determinants of PED and state one important condition."
        },
        "answer": {
          "zh-CN": "替代品的可得性、必要程度、收入占比和调整时间会影响消费者的价格反应。",
          "en": "Availability of substitutes, necessity, share of income and time to adjust influence consumers' responsiveness to price."
        },
        "explanation": {
          "zh-CN": "必需品通常缺乏弹性，但并非需求量完全不变。",
          "en": "Necessities are often inelastic, but their quantity demanded is not necessarily completely fixed."
        }
      },
      {
        "id": "u2-20-ped-determinants-mcq-1",
        "knowledgePointId": "u2-20-ped-determinants",
        "type": "mcq",
        "prompt": {
          "zh-CN": "其他条件相同，增加近似替代品通常怎样改变 PED？",
          "en": "Other conditions equal, more close substitutes normally do what to PED?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "降至零",
            "en": "Reduce it to zero"
          },
          {
            "id": "b",
            "zh-CN": "变成供给弹性",
            "en": "Turn it into PES"
          },
          {
            "id": "c",
            "zh-CN": "必然保持不变",
            "en": "Necessarily leave it unchanged"
          },
          {
            "id": "d",
            "zh-CN": "提高绝对值",
            "en": "Increase its magnitude"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "提高绝对值。 替代品更多或调整时间更长；消费者更容易改变购买方式；需求通常更富有弹性 必需品通常缺乏弹性，但并非需求量完全不变。",
          "en": "Increase its magnitude. More substitutes or more adjustment time; consumers can change purchases more easily; demand is normally more elastic Necessities are often inelastic, but their quantity demanded is not necessarily completely fixed."
        }
      },
      {
        "id": "u2-20-ped-determinants-short-1",
        "knowledgePointId": "u2-20-ped-determinants",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释PED 的决定因素的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Determinants of PED and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "替代品的可得性、必要程度、收入占比和调整时间会影响消费者的价格反应。 替代品更多或调整时间更长；消费者更容易改变购买方式；需求通常更富有弹性 原创例：某一品牌瓶装水有很多替代品，全部饮用水的替代选择却较少。狭义市场的需求可能比广义市场更富有弹性。评价税收时还需区分短期习惯和长期适应。",
          "en": "Availability of substitutes, necessity, share of income and time to adjust influence consumers' responsiveness to price. More substitutes or more adjustment time; consumers can change purchases more easily; demand is normally more elastic Illustrative example: one bottled-water brand has many substitutes, whereas drinking water as a whole has fewer. Narrowly defined markets may be more elastic than broad ones. Tax evaluation should distinguish short-run habits from long-run adaptation."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "替代品",
              "en": "substitutes"
            },
            "alternatives": {
              "zh-CN": [
                "替代品",
                "替代品更多或调整时间更长"
              ],
              "en": [
                "substitutes",
                "More substitutes or more adjustment time"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "时间",
              "en": "time"
            },
            "alternatives": {
              "zh-CN": [
                "时间",
                "消费者更容易改变购买方式"
              ],
              "en": [
                "time",
                "consumers can change purchases more easily"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "反应",
              "en": "responsiveness"
            },
            "alternatives": {
              "zh-CN": [
                "反应",
                "需求通常更富有弹性"
              ],
              "en": [
                "responsiveness",
                "demand is normally more elastic"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-21-ped-revenue",
      "slug": "ped-revenue",
      "section": "2.5",
      "level": "core",
      "syllabusRefs": [
        "2.5 Elasticity of demand"
      ],
      "textbookRefs": [
        {
          "chapter": "3",
          "section": "3.1",
          "pages": [
            85
          ]
        }
      ],
      "prerequisites": [
        "u2-01-demand"
      ],
      "related": [
        "u2-19-ped",
        "u2-20-ped-determinants",
        "u2-22-yed"
      ],
      "terms": [
        "PED 与总收入",
        "PED and total revenue",
        "P×Q",
        "P×Q",
        "百分比",
        "percentage",
        "收入",
        "revenue"
      ],
      "synonyms": {
        "zh-CN": [
          "P×Q",
          "百分比",
          "收入"
        ],
        "en": [
          "P×Q",
          "percentage",
          "revenue"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-21-ped-revenue-flash-1",
        "u2-21-ped-revenue-mcq-1",
        "u2-21-ped-revenue-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-21-ped-revenue",
        "locale": "zh-CN",
        "title": "PED 与总收入",
        "takeaway": "总收入 TR=P×Q；需求缺乏弹性时涨价提高收入，富有弹性时涨价降低收入，单位弹性时小幅价格变化近似保持收入不变。",
        "definition": "总收入 TR=P×Q；需求缺乏弹性时涨价提高收入，富有弹性时涨价降低收入，单位弹性时小幅价格变化近似保持收入不变。",
        "causalChain": [
          "价格上升而数量下降",
          "比较两者百分比变化",
          "数量反应更大时乘积下降"
        ],
        "misconceptions": [
          "收入与利润必须分开；利润还需扣除成本。"
        ],
        "examApplication": [
          "列公式、代入同一基数的百分比、解释符号与分类。"
        ],
        "summary": [
          "总收入 TR=P×Q；需求缺乏弹性时涨价提高收入，富有弹性时涨价降低收入，单位弹性时小幅价格变化近似保持收入不变。",
          "收入与利润必须分开；利润还需扣除成本。"
        ],
        "explanation": "价格上升而数量下降。比较两者百分比变化。数量反应更大时乘积下降。\n\n### 原创情境与推导\n\n原创例：价格由 10 到 11，数量由 100 到 80，总收入由 1000 到 880。总收入下降并不直接证明利润下降，因为成本也可能随数量改变。有限变化可直接算 P×Q 来核对。\n\n收入与利润必须分开；利润还需扣除成本。\n\n列公式、代入同一基数的百分比、解释符号与分类。"
      },
      "en": {
        "id": "u2-21-ped-revenue",
        "locale": "en",
        "title": "PED and total revenue",
        "takeaway": "Total revenue is P times Q. A price rise increases revenue with inelastic demand and reduces it with elastic demand; unit elasticity approximately preserves revenue for a small change.",
        "definition": "Total revenue is P times Q. A price rise increases revenue with inelastic demand and reduces it with elastic demand; unit elasticity approximately preserves revenue for a small change.",
        "causalChain": [
          "Price rises while quantity falls",
          "compare their percentage changes",
          "if quantity responds proportionately more, the product falls"
        ],
        "misconceptions": [
          "Keep revenue separate from profit, which also deducts costs."
        ],
        "examApplication": [
          "State the formula, use consistent percentage bases and interpret sign and classification."
        ],
        "summary": [
          "Total revenue is P times Q. A price rise increases revenue with inelastic demand and reduces it with elastic demand; unit elasticity approximately preserves revenue for a small change.",
          "Keep revenue separate from profit, which also deducts costs."
        ],
        "explanation": "Price rises while quantity falls.  compare their percentage changes.  if quantity responds proportionately more, the product falls.\n\n### Original scenario and reasoning\n\nIllustrative example: price rises from ten to eleven and quantity falls from 100 to 80. Revenue falls from 1000 to 880. This does not by itself prove profit falls because costs may change too. For finite changes, check the actual P×Q products.\n\nKeep revenue separate from profit, which also deducts costs.\n\nState the formula, use consistent percentage bases and interpret sign and classification."
      }
    },
    "practice": [
      {
        "id": "u2-21-ped-revenue-flash-1",
        "knowledgePointId": "u2-21-ped-revenue",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“PED 与总收入”，并说明一个关键条件。",
          "en": "Explain PED and total revenue and state one important condition."
        },
        "answer": {
          "zh-CN": "总收入 TR=P×Q；需求缺乏弹性时涨价提高收入，富有弹性时涨价降低收入，单位弹性时小幅价格变化近似保持收入不变。",
          "en": "Total revenue is P times Q. A price rise increases revenue with inelastic demand and reduces it with elastic demand; unit elasticity approximately preserves revenue for a small change."
        },
        "explanation": {
          "zh-CN": "收入与利润必须分开；利润还需扣除成本。",
          "en": "Keep revenue separate from profit, which also deducts costs."
        }
      },
      {
        "id": "u2-21-ped-revenue-mcq-1",
        "knowledgePointId": "u2-21-ped-revenue",
        "type": "mcq",
        "prompt": {
          "zh-CN": "需求富有弹性时小幅降价通常怎样影响总收入？",
          "en": "With elastic demand, a small price cut normally does what to total revenue?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "增加",
            "en": "Increase it"
          },
          {
            "id": "b",
            "zh-CN": "减少",
            "en": "Decrease it"
          },
          {
            "id": "c",
            "zh-CN": "变为零",
            "en": "Make it zero"
          },
          {
            "id": "d",
            "zh-CN": "一定不变",
            "en": "Necessarily leave it unchanged"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "增加。 价格上升而数量下降；比较两者百分比变化；数量反应更大时乘积下降 收入与利润必须分开；利润还需扣除成本。",
          "en": "Increase it. Price rises while quantity falls; compare their percentage changes; if quantity responds proportionately more, the product falls Keep revenue separate from profit, which also deducts costs."
        }
      },
      {
        "id": "u2-21-ped-revenue-short-1",
        "knowledgePointId": "u2-21-ped-revenue",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释PED 与总收入的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of PED and total revenue and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "总收入 TR=P×Q；需求缺乏弹性时涨价提高收入，富有弹性时涨价降低收入，单位弹性时小幅价格变化近似保持收入不变。 价格上升而数量下降；比较两者百分比变化；数量反应更大时乘积下降 原创例：价格由 10 到 11，数量由 100 到 80，总收入由 1000 到 880。总收入下降并不直接证明利润下降，因为成本也可能随数量改变。有限变化可直接算 P×Q 来核对。",
          "en": "Total revenue is P times Q. A price rise increases revenue with inelastic demand and reduces it with elastic demand; unit elasticity approximately preserves revenue for a small change. Price rises while quantity falls; compare their percentage changes; if quantity responds proportionately more, the product falls Illustrative example: price rises from ten to eleven and quantity falls from 100 to 80. Revenue falls from 1000 to 880. This does not by itself prove profit falls because costs may change too. For finite changes, check the actual P×Q products."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "P×Q",
              "en": "P×Q"
            },
            "alternatives": {
              "zh-CN": [
                "P×Q",
                "价格上升而数量下降"
              ],
              "en": [
                "P×Q",
                "Price rises while quantity falls"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "百分比",
              "en": "percentage"
            },
            "alternatives": {
              "zh-CN": [
                "百分比",
                "比较两者百分比变化"
              ],
              "en": [
                "percentage",
                "compare their percentage changes"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "收入",
              "en": "revenue"
            },
            "alternatives": {
              "zh-CN": [
                "收入",
                "数量反应更大时乘积下降"
              ],
              "en": [
                "revenue",
                "if quantity responds proportionately more, the product falls"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-22-yed",
      "slug": "yed",
      "section": "2.5",
      "level": "core",
      "syllabusRefs": [
        "2.5 Elasticity of demand"
      ],
      "textbookRefs": [
        {
          "chapter": "3",
          "section": "3.2",
          "pages": [
            97
          ]
        }
      ],
      "prerequisites": [
        "u2-01-demand"
      ],
      "related": [
        "u2-19-ped",
        "u2-20-ped-determinants",
        "u2-21-ped-revenue"
      ],
      "terms": [
        "需求收入弹性 YED",
        "Income elasticity of demand",
        "收入",
        "income",
        "正常品",
        "normal good",
        "劣等品",
        "inferior good"
      ],
      "synonyms": {
        "zh-CN": [
          "收入",
          "正常品",
          "劣等品"
        ],
        "en": [
          "income",
          "normal good",
          "inferior good"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-22-yed-flash-1",
        "u2-22-yed-mcq-1",
        "u2-22-yed-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-22-yed",
        "locale": "zh-CN",
        "title": "需求收入弹性 YED",
        "takeaway": "YED=需求量百分比变化/收入百分比变化；正值表示正常品，负值表示劣等品。正值超过一通常表示奢侈品，零到一通常表示必需品。",
        "definition": "YED=需求量百分比变化/收入百分比变化；正值表示正常品，负值表示劣等品。正值超过一通常表示奢侈品，零到一通常表示必需品。",
        "causalChain": [
          "收入改变而商品价格保持不变",
          "消费者重新配置预算",
          "数量反应的方向和比例确定 YED"
        ],
        "misconceptions": [
          "YED 分类保留正负号，不能像 PED 分类一样去掉符号。"
        ],
        "examApplication": [
          "列公式、代入同一基数的百分比、解释符号与分类。"
        ],
        "summary": [
          "YED=需求量百分比变化/收入百分比变化；正值表示正常品，负值表示劣等品。正值超过一通常表示奢侈品，零到一通常表示必需品。",
          "YED 分类保留正负号，不能像 PED 分类一样去掉符号。"
        ],
        "explanation": "收入改变而商品价格保持不变。消费者重新配置预算。数量反应的方向和比例确定 YED。\n\n### 原创情境与推导\n\n原创例：收入增加 10%，某商品购买量下降 5%，YED=-0.5，属于劣等品。劣等是需求与收入的关系，不是道德评价，也不必意味着产品质量差。 恩格尔曲线以收入为横轴、需求量为纵轴；正常品向上、劣等品在相关收入区间向下，其斜率本身不等于 YED。\n\nYED 分类保留正负号，不能像 PED 分类一样去掉符号。\n\n列公式、代入同一基数的百分比、解释符号与分类。"
      },
      "en": {
        "id": "u2-22-yed",
        "locale": "en",
        "title": "Income elasticity of demand",
        "takeaway": "YED is percentage change in quantity demanded divided by percentage change in income. Positive values indicate normal goods and negative values inferior goods. Values above one usually indicate luxuries; between zero and one, necessities.",
        "definition": "YED is percentage change in quantity demanded divided by percentage change in income. Positive values indicate normal goods and negative values inferior goods. Values above one usually indicate luxuries; between zero and one, necessities.",
        "causalChain": [
          "Income changes with product price held constant",
          "consumers reallocate budgets",
          "the direction and proportion of quantity response determine YED"
        ],
        "misconceptions": [
          "Retain the sign when classifying YED; do not discard it as with PED magnitude classifications."
        ],
        "examApplication": [
          "State the formula, use consistent percentage bases and interpret sign and classification."
        ],
        "summary": [
          "YED is percentage change in quantity demanded divided by percentage change in income. Positive values indicate normal goods and negative values inferior goods. Values above one usually indicate luxuries; between zero and one, necessities.",
          "Retain the sign when classifying YED; do not discard it as with PED magnitude classifications."
        ],
        "explanation": "Income changes with product price held constant.  consumers reallocate budgets.  the direction and proportion of quantity response determine YED.\n\n### Original scenario and reasoning\n\nIllustrative example: income rises 10% and purchases of a good fall 5%, so YED is -0.5: an inferior good. Inferior describes the income-demand relationship, not a moral judgement or necessarily poor quality. An Engel curve plots income horizontally and quantity demanded vertically: it slopes up for normal goods and down over the relevant range for inferior goods. Its slope is not itself YED.\n\nRetain the sign when classifying YED; do not discard it as with PED magnitude classifications.\n\nState the formula, use consistent percentage bases and interpret sign and classification."
      }
    },
    "practice": [
      {
        "id": "u2-22-yed-flash-1",
        "knowledgePointId": "u2-22-yed",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“需求收入弹性 YED”，并说明一个关键条件。",
          "en": "Explain Income elasticity of demand and state one important condition."
        },
        "answer": {
          "zh-CN": "YED=需求量百分比变化/收入百分比变化；正值表示正常品，负值表示劣等品。正值超过一通常表示奢侈品，零到一通常表示必需品。",
          "en": "YED is percentage change in quantity demanded divided by percentage change in income. Positive values indicate normal goods and negative values inferior goods. Values above one usually indicate luxuries; between zero and one, necessities."
        },
        "explanation": {
          "zh-CN": "YED 分类保留正负号，不能像 PED 分类一样去掉符号。",
          "en": "Retain the sign when classifying YED; do not discard it as with PED magnitude classifications."
        }
      },
      {
        "id": "u2-22-yed-mcq-1",
        "knowledgePointId": "u2-22-yed",
        "type": "mcq",
        "prompt": {
          "zh-CN": "YED=-0.4 的商品属于什么？",
          "en": "A good has YED=-0.4. How is it classified?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "奢侈品",
            "en": "Luxury"
          },
          {
            "id": "b",
            "zh-CN": "劣等品",
            "en": "Inferior good"
          },
          {
            "id": "c",
            "zh-CN": "正常必需品",
            "en": "Normal necessity"
          },
          {
            "id": "d",
            "zh-CN": "公共物品",
            "en": "Public good"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "劣等品。 收入改变而商品价格保持不变；消费者重新配置预算；数量反应的方向和比例确定 YED YED 分类保留正负号，不能像 PED 分类一样去掉符号。",
          "en": "Inferior good. Income changes with product price held constant; consumers reallocate budgets; the direction and proportion of quantity response determine YED Retain the sign when classifying YED; do not discard it as with PED magnitude classifications."
        }
      },
      {
        "id": "u2-22-yed-short-1",
        "knowledgePointId": "u2-22-yed",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释需求收入弹性 YED的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Income elasticity of demand and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "YED=需求量百分比变化/收入百分比变化；正值表示正常品，负值表示劣等品。正值超过一通常表示奢侈品，零到一通常表示必需品。 收入改变而商品价格保持不变；消费者重新配置预算；数量反应的方向和比例确定 YED 原创例：收入增加 10%，某商品购买量下降 5%，YED=-0.5，属于劣等品。劣等是需求与收入的关系，不是道德评价，也不必意味着产品质量差。 恩格尔曲线以收入为横轴、需求量为纵轴；正常品向上、劣等品在相关收入区间向下，其斜率本身不等于 YED。",
          "en": "YED is percentage change in quantity demanded divided by percentage change in income. Positive values indicate normal goods and negative values inferior goods. Values above one usually indicate luxuries; between zero and one, necessities. Income changes with product price held constant; consumers reallocate budgets; the direction and proportion of quantity response determine YED Illustrative example: income rises 10% and purchases of a good fall 5%, so YED is -0.5: an inferior good. Inferior describes the income-demand relationship, not a moral judgement or necessarily poor quality. An Engel curve plots income horizontally and quantity demanded vertically: it slopes up for normal goods and down over the relevant range for inferior goods. Its slope is not itself YED."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "收入",
              "en": "income"
            },
            "alternatives": {
              "zh-CN": [
                "收入",
                "收入改变而商品价格保持不变"
              ],
              "en": [
                "income",
                "Income changes with product price held constant"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "正常品",
              "en": "normal good"
            },
            "alternatives": {
              "zh-CN": [
                "正常品",
                "消费者重新配置预算"
              ],
              "en": [
                "normal good",
                "consumers reallocate budgets"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "劣等品",
              "en": "inferior good"
            },
            "alternatives": {
              "zh-CN": [
                "劣等品",
                "数量反应的方向和比例确定 YED"
              ],
              "en": [
                "inferior good",
                "the direction and proportion of quantity response determine YED"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-23-elasticity-extremes",
      "slug": "elasticity-extremes",
      "section": "2.5",
      "level": "hl",
      "syllabusRefs": [
        "2.5 Elasticity of demand"
      ],
      "textbookRefs": [
        {
          "chapter": "3",
          "section": "3.1",
          "pages": [
            85
          ]
        }
      ],
      "prerequisites": [
        "u2-01-demand"
      ],
      "related": [
        "u2-19-ped",
        "u2-20-ped-determinants",
        "u2-21-ped-revenue"
      ],
      "terms": [
        "弹性、斜率与收入变化",
        "Elasticity, slope and changing income",
        "百分比",
        "percentage",
        "P/Q",
        "P/Q",
        "斜率",
        "slope"
      ],
      "synonyms": {
        "zh-CN": [
          "百分比",
          "P/Q",
          "斜率"
        ],
        "en": [
          "percentage",
          "P/Q",
          "slope"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-23-elasticity-extremes-flash-1",
        "u2-23-elasticity-extremes-mcq-1",
        "u2-23-elasticity-extremes-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-23-elasticity-extremes",
        "locale": "zh-CN",
        "title": "弹性、斜率与收入变化",
        "takeaway": "同一条直线需求曲线斜率恒定但 PED 会随位置改变；YED 可帮助分析收入增长引起的产业需求变化。",
        "definition": "同一条直线需求曲线斜率恒定但 PED 会随位置改变；YED 可帮助分析收入增长引起的产业需求变化。",
        "causalChain": [
          "弹性公式包含价格与数量的比例",
          "曲线上位置改变 P/Q",
          "同一斜率产生不同弹性"
        ],
        "misconceptions": [
          "不同坐标尺度下视觉陡峭程度不可直接用于比较弹性。"
        ],
        "examApplication": [
          "列公式、代入同一基数的百分比、解释符号与分类。"
        ],
        "summary": [
          "同一条直线需求曲线斜率恒定但 PED 会随位置改变；YED 可帮助分析收入增长引起的产业需求变化。",
          "不同坐标尺度下视觉陡峭程度不可直接用于比较弹性。"
        ],
        "explanation": "弹性公式包含价格与数量的比例。曲线上位置改变 P/Q。同一斜率产生不同弹性。\n\n### 原创情境与推导\n\n原创例：直线 Q=100−2P 上，P=10、Q=80 时 PED=-0.25，P=40、Q=20 时 PED=-4。这里的函数仅用于解释斜率与弹性，并非所有现实需求都是线性的。高 YED 服务在收入增长时可能扩张较快。 初级食品短期替代品少、属必需品，因此 PED 往往较低；高 YED 产品随收入增长扩张更快，但这不是对每种服务的保证。\n\n不同坐标尺度下视觉陡峭程度不可直接用于比较弹性。\n\n列公式、代入同一基数的百分比、解释符号与分类。"
      },
      "en": {
        "id": "u2-23-elasticity-extremes",
        "locale": "en",
        "title": "Elasticity, slope and changing income",
        "takeaway": "A straight demand curve has constant slope but different PED at different points. YED also helps analyse how income growth changes demand across industries.",
        "definition": "A straight demand curve has constant slope but different PED at different points. YED also helps analyse how income growth changes demand across industries.",
        "causalChain": [
          "Elasticity contains the ratio of price to quantity",
          "location changes P/Q",
          "the same slope therefore produces different elasticity"
        ],
        "misconceptions": [
          "Visual steepness with different axis scales cannot directly establish relative elasticity."
        ],
        "examApplication": [
          "State the formula, use consistent percentage bases and interpret sign and classification."
        ],
        "summary": [
          "A straight demand curve has constant slope but different PED at different points. YED also helps analyse how income growth changes demand across industries.",
          "Visual steepness with different axis scales cannot directly establish relative elasticity."
        ],
        "explanation": "Elasticity contains the ratio of price to quantity.  location changes P/Q.  the same slope therefore produces different elasticity.\n\n### Original scenario and reasoning\n\nIllustrative example: on Q=100−2P, PED is -0.25 at P=10, Q=80 and -4 at P=40, Q=20. The function illustrates slope versus elasticity; real demand need not be linear. High-YED services may expand faster as incomes grow. Basic primary foods often have lower short-run PED because they are necessities with fewer substitutes. High-YED goods can expand faster as incomes grow, without implying every service is a luxury.\n\nVisual steepness with different axis scales cannot directly establish relative elasticity.\n\nState the formula, use consistent percentage bases and interpret sign and classification."
      }
    },
    "practice": [
      {
        "id": "u2-23-elasticity-extremes-flash-1",
        "knowledgePointId": "u2-23-elasticity-extremes",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“弹性、斜率与收入变化”，并说明一个关键条件。",
          "en": "Explain Elasticity, slope and changing income and state one important condition."
        },
        "answer": {
          "zh-CN": "同一条直线需求曲线斜率恒定但 PED 会随位置改变；YED 可帮助分析收入增长引起的产业需求变化。",
          "en": "A straight demand curve has constant slope but different PED at different points. YED also helps analyse how income growth changes demand across industries."
        },
        "explanation": {
          "zh-CN": "不同坐标尺度下视觉陡峭程度不可直接用于比较弹性。",
          "en": "Visual steepness with different axis scales cannot directly establish relative elasticity."
        }
      },
      {
        "id": "u2-23-elasticity-extremes-mcq-1",
        "knowledgePointId": "u2-23-elasticity-extremes",
        "type": "mcq",
        "prompt": {
          "zh-CN": "直线需求曲线的斜率恒定，PED 是否也恒定？",
          "en": "A straight demand curve has constant slope. Is PED constant too?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "是，两者相同",
            "en": "Yes, they are identical"
          },
          {
            "id": "b",
            "zh-CN": "PED 恒为零",
            "en": "PED is always zero"
          },
          {
            "id": "c",
            "zh-CN": "否，P/Q 改变",
            "en": "No, P/Q changes"
          },
          {
            "id": "d",
            "zh-CN": "PED 恒为一",
            "en": "PED is always one"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "否，P/Q 改变。 弹性公式包含价格与数量的比例；曲线上位置改变 P/Q；同一斜率产生不同弹性 不同坐标尺度下视觉陡峭程度不可直接用于比较弹性。",
          "en": "No, P/Q changes. Elasticity contains the ratio of price to quantity; location changes P/Q; the same slope therefore produces different elasticity Visual steepness with different axis scales cannot directly establish relative elasticity."
        }
      },
      {
        "id": "u2-23-elasticity-extremes-short-1",
        "knowledgePointId": "u2-23-elasticity-extremes",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释弹性、斜率与收入变化的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Elasticity, slope and changing income and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "同一条直线需求曲线斜率恒定但 PED 会随位置改变；YED 可帮助分析收入增长引起的产业需求变化。 弹性公式包含价格与数量的比例；曲线上位置改变 P/Q；同一斜率产生不同弹性 原创例：直线 Q=100−2P 上，P=10、Q=80 时 PED=-0.25，P=40、Q=20 时 PED=-4。这里的函数仅用于解释斜率与弹性，并非所有现实需求都是线性的。高 YED 服务在收入增长时可能扩张较快。 初级食品短期替代品少、属必需品，因此 PED 往往较低；高 YED 产品随收入增长扩张更快，但这不是对每种服务的保证。",
          "en": "A straight demand curve has constant slope but different PED at different points. YED also helps analyse how income growth changes demand across industries. Elasticity contains the ratio of price to quantity; location changes P/Q; the same slope therefore produces different elasticity Illustrative example: on Q=100−2P, PED is -0.25 at P=10, Q=80 and -4 at P=40, Q=20. The function illustrates slope versus elasticity; real demand need not be linear. High-YED services may expand faster as incomes grow. Basic primary foods often have lower short-run PED because they are necessities with fewer substitutes. High-YED goods can expand faster as incomes grow, without implying every service is a luxury."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "百分比",
              "en": "percentage"
            },
            "alternatives": {
              "zh-CN": [
                "百分比",
                "弹性公式包含价格与数量的比例"
              ],
              "en": [
                "percentage",
                "Elasticity contains the ratio of price to quantity"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "P/Q",
              "en": "P/Q"
            },
            "alternatives": {
              "zh-CN": [
                "P/Q",
                "曲线上位置改变 P/Q"
              ],
              "en": [
                "P/Q",
                "location changes P/Q"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "斜率",
              "en": "slope"
            },
            "alternatives": {
              "zh-CN": [
                "斜率",
                "同一斜率产生不同弹性"
              ],
              "en": [
                "slope",
                "the same slope therefore produces different elasticity"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-24-pes",
      "slug": "pes",
      "section": "2.6",
      "level": "core",
      "syllabusRefs": [
        "2.6 Elasticity of supply"
      ],
      "textbookRefs": [
        {
          "chapter": "3",
          "section": "3.3",
          "pages": [
            104
          ]
        }
      ],
      "prerequisites": [
        "u2-06-supply"
      ],
      "related": [
        "u2-25-pes-determinants",
        "u2-26-pes-application"
      ],
      "terms": [
        "供给价格弹性 PES",
        "Price elasticity of supply",
        "供给量",
        "quantity supplied",
        "百分比",
        "percentage",
        "价格",
        "price"
      ],
      "synonyms": {
        "zh-CN": [
          "供给量",
          "百分比",
          "价格"
        ],
        "en": [
          "quantity supplied",
          "percentage",
          "price"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-24-pes-flash-1",
        "u2-24-pes-mcq-1",
        "u2-24-pes-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-24-pes",
        "locale": "zh-CN",
        "title": "供给价格弹性 PES",
        "takeaway": "PES=供给量百分比变化/价格百分比变化，用于衡量生产者对价格变化的数量反应。",
        "definition": "PES=供给量百分比变化/价格百分比变化，用于衡量生产者对价格变化的数量反应。",
        "causalChain": [
          "价格改变生产激励",
          "投入和产能约束决定可增加的数量",
          "百分比数量反应与价格反应比较"
        ],
        "misconceptions": [
          "PES 衡量供给量反应，不衡量需求变化或供给移动。"
        ],
        "examApplication": [
          "结合闲置产能与调整时间解释供给反应。"
        ],
        "summary": [
          "PES=供给量百分比变化/价格百分比变化，用于衡量生产者对价格变化的数量反应。",
          "PES 衡量供给量反应，不衡量需求变化或供给移动。"
        ],
        "explanation": "价格改变生产激励。投入和产能约束决定可增加的数量。百分比数量反应与价格反应比较。\n\n### 原创情境与推导\n\n原创例：价格上涨 10%，供给量增加 5%，PES=0.5，缺乏弹性。完全固定的即时产量可以画成竖直供给；并非每一种短期供给都完全无弹性。\n\nPES 衡量供给量反应，不衡量需求变化或供给移动。\n\n结合闲置产能与调整时间解释供给反应。"
      },
      "en": {
        "id": "u2-24-pes",
        "locale": "en",
        "title": "Price elasticity of supply",
        "takeaway": "PES equals percentage change in quantity supplied divided by percentage change in price and measures producers' quantity response to a price change.",
        "definition": "PES equals percentage change in quantity supplied divided by percentage change in price and measures producers' quantity response to a price change.",
        "causalChain": [
          "Price changes incentives to produce",
          "input and capacity limits determine feasible expansion",
          "compare percentage quantity and price changes"
        ],
        "misconceptions": [
          "PES measures quantity supplied response, not a demand change or a supply shift."
        ],
        "examApplication": [
          "Use spare capacity and adjustment time to explain supply responsiveness."
        ],
        "summary": [
          "PES equals percentage change in quantity supplied divided by percentage change in price and measures producers' quantity response to a price change.",
          "PES measures quantity supplied response, not a demand change or a supply shift."
        ],
        "explanation": "Price changes incentives to produce.  input and capacity limits determine feasible expansion.  compare percentage quantity and price changes.\n\n### Original scenario and reasoning\n\nIllustrative example: price rises 10% and quantity supplied rises 5%, so PES=0.5: inelastic. Completely fixed immediate output gives a vertical supply curve, but not all short-run supply is perfectly inelastic.\n\nPES measures quantity supplied response, not a demand change or a supply shift.\n\nUse spare capacity and adjustment time to explain supply responsiveness."
      }
    },
    "practice": [
      {
        "id": "u2-24-pes-flash-1",
        "knowledgePointId": "u2-24-pes",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“供给价格弹性 PES”，并说明一个关键条件。",
          "en": "Explain Price elasticity of supply and state one important condition."
        },
        "answer": {
          "zh-CN": "PES=供给量百分比变化/价格百分比变化，用于衡量生产者对价格变化的数量反应。",
          "en": "PES equals percentage change in quantity supplied divided by percentage change in price and measures producers' quantity response to a price change."
        },
        "explanation": {
          "zh-CN": "PES 衡量供给量反应，不衡量需求变化或供给移动。",
          "en": "PES measures quantity supplied response, not a demand change or a supply shift."
        }
      },
      {
        "id": "u2-24-pes-mcq-1",
        "knowledgePointId": "u2-24-pes",
        "type": "mcq",
        "prompt": {
          "zh-CN": "价格涨 8%、供给量涨 12%，PES 为多少？",
          "en": "Price rises 8% and quantity supplied 12%. What is PES?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "0.67",
            "en": "0.67"
          },
          {
            "id": "b",
            "zh-CN": "4",
            "en": "4"
          },
          {
            "id": "c",
            "zh-CN": "96",
            "en": "96"
          },
          {
            "id": "d",
            "zh-CN": "1.5",
            "en": "1.5"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "1.5。 PES = 12% / 8% = 1.5 PES 衡量供给量反应，不衡量需求变化或供给移动。",
          "en": "1.5. PES = 12% / 8% = 1.5 PES measures quantity supplied response, not a demand change or a supply shift."
        }
      },
      {
        "id": "u2-24-pes-short-1",
        "knowledgePointId": "u2-24-pes",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释供给价格弹性 PES的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Price elasticity of supply and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "PES=供给量百分比变化/价格百分比变化，用于衡量生产者对价格变化的数量反应。 价格改变生产激励；投入和产能约束决定可增加的数量；百分比数量反应与价格反应比较 原创例：价格上涨 10%，供给量增加 5%，PES=0.5，缺乏弹性。完全固定的即时产量可以画成竖直供给；并非每一种短期供给都完全无弹性。",
          "en": "PES equals percentage change in quantity supplied divided by percentage change in price and measures producers' quantity response to a price change. Price changes incentives to produce; input and capacity limits determine feasible expansion; compare percentage quantity and price changes Illustrative example: price rises 10% and quantity supplied rises 5%, so PES=0.5: inelastic. Completely fixed immediate output gives a vertical supply curve, but not all short-run supply is perfectly inelastic."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "供给量",
              "en": "quantity supplied"
            },
            "alternatives": {
              "zh-CN": [
                "供给量",
                "价格改变生产激励"
              ],
              "en": [
                "quantity supplied",
                "Price changes incentives to produce"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "百分比",
              "en": "percentage"
            },
            "alternatives": {
              "zh-CN": [
                "百分比",
                "投入和产能约束决定可增加的数量"
              ],
              "en": [
                "percentage",
                "input and capacity limits determine feasible expansion"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "价格",
              "en": "price"
            },
            "alternatives": {
              "zh-CN": [
                "价格",
                "百分比数量反应与价格反应比较"
              ],
              "en": [
                "price",
                "compare percentage quantity and price changes"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-25-pes-determinants",
      "slug": "pes-determinants",
      "section": "2.6",
      "level": "core",
      "syllabusRefs": [
        "2.6 Elasticity of supply"
      ],
      "textbookRefs": [
        {
          "chapter": "3",
          "section": "3.3",
          "pages": [
            104
          ]
        }
      ],
      "prerequisites": [
        "u2-06-supply"
      ],
      "related": [
        "u2-24-pes",
        "u2-26-pes-application"
      ],
      "terms": [
        "PES、产能与时间",
        "PES, capacity and time",
        "闲置产能",
        "spare capacity",
        "时间",
        "time",
        "投入",
        "inputs"
      ],
      "synonyms": {
        "zh-CN": [
          "闲置产能",
          "时间",
          "投入"
        ],
        "en": [
          "spare capacity",
          "time",
          "inputs"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-25-pes-determinants-flash-1",
        "u2-25-pes-determinants-mcq-1",
        "u2-25-pes-determinants-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-25-pes-determinants",
        "locale": "zh-CN",
        "hlExtension": "HL 深入：农作物生产周期长、天气和土地约束较强，短期 PES 往往低于可用闲置设备增产的制成品，但可储存性和具体产能会改变比较。",
        "title": "PES、产能与时间",
        "takeaway": "闲置产能、库存、投入可移动性、生产周期和调整时间决定供给对价格的反应程度。",
        "definition": "闲置产能、库存、投入可移动性、生产周期和调整时间决定供给对价格的反应程度。",
        "causalChain": [
          "可动用库存或闲置机器",
          "生产可迅速扩张",
          "供给反应较大且 PES 通常较高"
        ],
        "misconceptions": [
          "时间更长通常提高 PES，但不是无条件保证。"
        ],
        "examApplication": [
          "结合闲置产能与调整时间解释供给反应。"
        ],
        "summary": [
          "闲置产能、库存、投入可移动性、生产周期和调整时间决定供给对价格的反应程度。",
          "时间更长通常提高 PES，但不是无条件保证。"
        ],
        "explanation": "可动用库存或闲置机器。生产可迅速扩张。供给反应较大且 PES 通常较高。\n\n### 原创情境与推导\n\n原创例：印刷厂有空闲机器，可迅速响应价格上涨；果园需要多年才能增加成熟果树。长期投入更可调整，供给通常更富有弹性，但土地和生态约束仍可存在。\n\n时间更长通常提高 PES，但不是无条件保证。\n\n结合闲置产能与调整时间解释供给反应。"
      },
      "en": {
        "id": "u2-25-pes-determinants",
        "locale": "en",
        "hlExtension": "HL detail: long biological cycles, weather and land constraints often make primary-product PES lower in the short run than manufactured goods with spare capacity. Storage and actual capacity can change the comparison.",
        "title": "PES, capacity and time",
        "takeaway": "Spare capacity, inventories, factor mobility, production periods and adjustment time determine how readily supply responds to price.",
        "definition": "Spare capacity, inventories, factor mobility, production periods and adjustment time determine how readily supply responds to price.",
        "causalChain": [
          "Inventories or idle machines are available",
          "production expands quickly",
          "quantity response is larger and PES is normally higher"
        ],
        "misconceptions": [
          "More time normally increases PES but does not guarantee it under every constraint."
        ],
        "examApplication": [
          "Use spare capacity and adjustment time to explain supply responsiveness."
        ],
        "summary": [
          "Spare capacity, inventories, factor mobility, production periods and adjustment time determine how readily supply responds to price.",
          "More time normally increases PES but does not guarantee it under every constraint."
        ],
        "explanation": "Inventories or idle machines are available.  production expands quickly.  quantity response is larger and PES is normally higher.\n\n### Original scenario and reasoning\n\nIllustrative example: a printer with idle machines can respond quickly to higher prices, while an orchard needs years to grow mature trees. Long-run input flexibility normally raises elasticity, but land and ecological limits may persist.\n\nMore time normally increases PES but does not guarantee it under every constraint.\n\nUse spare capacity and adjustment time to explain supply responsiveness."
      }
    },
    "practice": [
      {
        "id": "u2-25-pes-determinants-flash-1",
        "knowledgePointId": "u2-25-pes-determinants",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“PES、产能与时间”，并说明一个关键条件。",
          "en": "Explain PES, capacity and time and state one important condition."
        },
        "answer": {
          "zh-CN": "闲置产能、库存、投入可移动性、生产周期和调整时间决定供给对价格的反应程度。",
          "en": "Spare capacity, inventories, factor mobility, production periods and adjustment time determine how readily supply responds to price."
        },
        "explanation": {
          "zh-CN": "时间更长通常提高 PES，但不是无条件保证。",
          "en": "More time normally increases PES but does not guarantee it under every constraint."
        }
      },
      {
        "id": "u2-25-pes-determinants-mcq-1",
        "knowledgePointId": "u2-25-pes-determinants",
        "type": "mcq",
        "prompt": {
          "zh-CN": "其他条件相同，哪项通常提高 PES？",
          "en": "Other things equal, which normally raises PES?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "更多闲置产能",
            "en": "More spare capacity"
          },
          {
            "id": "b",
            "zh-CN": "更长生产周期",
            "en": "A longer production period"
          },
          {
            "id": "c",
            "zh-CN": "投入完全不可移动",
            "en": "Completely immobile inputs"
          },
          {
            "id": "d",
            "zh-CN": "不能储存且满产",
            "en": "No storage and full capacity"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "更多闲置产能。 可动用库存或闲置机器；生产可迅速扩张；供给反应较大且 PES 通常较高 时间更长通常提高 PES，但不是无条件保证。",
          "en": "More spare capacity. Inventories or idle machines are available; production expands quickly; quantity response is larger and PES is normally higher More time normally increases PES but does not guarantee it under every constraint."
        }
      },
      {
        "id": "u2-25-pes-determinants-short-1",
        "knowledgePointId": "u2-25-pes-determinants",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释PES、产能与时间的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of PES, capacity and time and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "闲置产能、库存、投入可移动性、生产周期和调整时间决定供给对价格的反应程度。 可动用库存或闲置机器；生产可迅速扩张；供给反应较大且 PES 通常较高 原创例：印刷厂有空闲机器，可迅速响应价格上涨；果园需要多年才能增加成熟果树。长期投入更可调整，供给通常更富有弹性，但土地和生态约束仍可存在。",
          "en": "Spare capacity, inventories, factor mobility, production periods and adjustment time determine how readily supply responds to price. Inventories or idle machines are available; production expands quickly; quantity response is larger and PES is normally higher Illustrative example: a printer with idle machines can respond quickly to higher prices, while an orchard needs years to grow mature trees. Long-run input flexibility normally raises elasticity, but land and ecological limits may persist."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "闲置产能",
              "en": "spare capacity"
            },
            "alternatives": {
              "zh-CN": [
                "闲置产能",
                "可动用库存或闲置机器"
              ],
              "en": [
                "spare capacity",
                "Inventories or idle machines are available"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "时间",
              "en": "time"
            },
            "alternatives": {
              "zh-CN": [
                "时间",
                "生产可迅速扩张"
              ],
              "en": [
                "time",
                "production expands quickly"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "投入",
              "en": "inputs"
            },
            "alternatives": {
              "zh-CN": [
                "投入",
                "供给反应较大且 PES 通常较高"
              ],
              "en": [
                "inputs",
                "quantity response is larger and PES is normally higher"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-26-pes-application",
      "slug": "pes-application",
      "section": "2.6",
      "level": "core",
      "syllabusRefs": [
        "2.6 Elasticity of supply"
      ],
      "textbookRefs": [
        {
          "chapter": "3",
          "section": "3.3",
          "pages": [
            104
          ]
        }
      ],
      "prerequisites": [
        "u2-06-supply"
      ],
      "related": [
        "u2-24-pes",
        "u2-25-pes-determinants"
      ],
      "terms": [
        "PES 的计算与政策含义",
        "PES calculations and policy implications",
        "产能",
        "capacity",
        "价格",
        "price",
        "数量",
        "quantity"
      ],
      "synonyms": {
        "zh-CN": [
          "产能",
          "价格",
          "数量"
        ],
        "en": [
          "capacity",
          "price",
          "quantity"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-26-pes-application-flash-1",
        "u2-26-pes-application-mcq-1",
        "u2-26-pes-application-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-26-pes-application",
        "locale": "zh-CN",
        "title": "PES 的计算与政策含义",
        "takeaway": "判断政策的数量效应需要供给弹性；数量反应弱时，刺激需求更可能推高价格而非显著扩大产量。",
        "definition": "判断政策的数量效应需要供给弹性；数量反应弱时，刺激需求更可能推高价格而非显著扩大产量。",
        "causalChain": [
          "需求刺激使需求右移",
          "产能限制供给反应",
          "供给越缺乏弹性价格反应通常越大"
        ],
        "misconceptions": [
          "需求补助不能自动消除供给侧限制。"
        ],
        "examApplication": [
          "结合闲置产能与调整时间解释供给反应。"
        ],
        "summary": [
          "判断政策的数量效应需要供给弹性；数量反应弱时，刺激需求更可能推高价格而非显著扩大产量。",
          "需求补助不能自动消除供给侧限制。"
        ],
        "explanation": "需求刺激使需求右移。产能限制供给反应。供给越缺乏弹性价格反应通常越大。\n\n### 原创情境与推导\n\n原创例：价格从 20 到 22，供给量从 100 到 105，按原值计算 PES=(5/100)/(2/20)=0.5。住房补助若面对固定住房存量，短期部分收益可能进入房租，而不是增加住房数量。\n\n需求补助不能自动消除供给侧限制。\n\n结合闲置产能与调整时间解释供给反应。"
      },
      "en": {
        "id": "u2-26-pes-application",
        "locale": "en",
        "title": "PES calculations and policy implications",
        "takeaway": "Supply elasticity matters for a policy's quantity effect: weak supply response makes demand stimulation more likely to raise prices than greatly expand output.",
        "definition": "Supply elasticity matters for a policy's quantity effect: weak supply response makes demand stimulation more likely to raise prices than greatly expand output.",
        "causalChain": [
          "Demand stimulus shifts demand right",
          "capacity constrains supply response",
          "more inelastic supply normally creates a larger price response"
        ],
        "misconceptions": [
          "A demand subsidy does not automatically remove supply-side constraints."
        ],
        "examApplication": [
          "Use spare capacity and adjustment time to explain supply responsiveness."
        ],
        "summary": [
          "Supply elasticity matters for a policy's quantity effect: weak supply response makes demand stimulation more likely to raise prices than greatly expand output.",
          "A demand subsidy does not automatically remove supply-side constraints."
        ],
        "explanation": "Demand stimulus shifts demand right.  capacity constrains supply response.  more inelastic supply normally creates a larger price response.\n\n### Original scenario and reasoning\n\nIllustrative example: price rises from 20 to 22 and supply from 100 to 105. Using initial values, PES=(5/100)/(2/20)=0.5. With a fixed housing stock, a rent subsidy can raise rents in the short run rather than add many homes.\n\nA demand subsidy does not automatically remove supply-side constraints.\n\nUse spare capacity and adjustment time to explain supply responsiveness."
      }
    },
    "practice": [
      {
        "id": "u2-26-pes-application-flash-1",
        "knowledgePointId": "u2-26-pes-application",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“PES 的计算与政策含义”，并说明一个关键条件。",
          "en": "Explain PES calculations and policy implications and state one important condition."
        },
        "answer": {
          "zh-CN": "判断政策的数量效应需要供给弹性；数量反应弱时，刺激需求更可能推高价格而非显著扩大产量。",
          "en": "Supply elasticity matters for a policy's quantity effect: weak supply response makes demand stimulation more likely to raise prices than greatly expand output."
        },
        "explanation": {
          "zh-CN": "需求补助不能自动消除供给侧限制。",
          "en": "A demand subsidy does not automatically remove supply-side constraints."
        }
      },
      {
        "id": "u2-26-pes-application-mcq-1",
        "knowledgePointId": "u2-26-pes-application",
        "type": "mcq",
        "prompt": {
          "zh-CN": "固定数量供给遇到需求右移，主要结果是什么？",
          "en": "Demand shifts right against fixed quantity supply. What is the main result?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "数量上涨，价格不变",
            "en": "Quantity rises, price unchanged"
          },
          {
            "id": "b",
            "zh-CN": "价格上涨，数量不变",
            "en": "Price rises, quantity unchanged"
          },
          {
            "id": "c",
            "zh-CN": "价格与数量都下降",
            "en": "Both fall"
          },
          {
            "id": "d",
            "zh-CN": "供给自动无限扩张",
            "en": "Supply automatically expands without limit"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "价格上涨，数量不变。 需求刺激使需求右移；产能限制供给反应；供给越缺乏弹性价格反应通常越大 需求补助不能自动消除供给侧限制。",
          "en": "Price rises, quantity unchanged. Demand stimulus shifts demand right; capacity constrains supply response; more inelastic supply normally creates a larger price response A demand subsidy does not automatically remove supply-side constraints."
        }
      },
      {
        "id": "u2-26-pes-application-short-1",
        "knowledgePointId": "u2-26-pes-application",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释PES 的计算与政策含义的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of PES calculations and policy implications and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "判断政策的数量效应需要供给弹性；数量反应弱时，刺激需求更可能推高价格而非显著扩大产量。 需求刺激使需求右移；产能限制供给反应；供给越缺乏弹性价格反应通常越大 原创例：价格从 20 到 22，供给量从 100 到 105，按原值计算 PES=(5/100)/(2/20)=0.5。住房补助若面对固定住房存量，短期部分收益可能进入房租，而不是增加住房数量。",
          "en": "Supply elasticity matters for a policy's quantity effect: weak supply response makes demand stimulation more likely to raise prices than greatly expand output. Demand stimulus shifts demand right; capacity constrains supply response; more inelastic supply normally creates a larger price response Illustrative example: price rises from 20 to 22 and supply from 100 to 105. Using initial values, PES=(5/100)/(2/20)=0.5. With a fixed housing stock, a rent subsidy can raise rents in the short run rather than add many homes."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "产能",
              "en": "capacity"
            },
            "alternatives": {
              "zh-CN": [
                "产能",
                "需求刺激使需求右移"
              ],
              "en": [
                "capacity",
                "Demand stimulus shifts demand right"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "价格",
              "en": "price"
            },
            "alternatives": {
              "zh-CN": [
                "价格",
                "产能限制供给反应"
              ],
              "en": [
                "price",
                "capacity constrains supply response"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "数量",
              "en": "quantity"
            },
            "alternatives": {
              "zh-CN": [
                "数量",
                "供给越缺乏弹性价格反应通常越大"
              ],
              "en": [
                "quantity",
                "more inelastic supply normally creates a larger price response"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-27-price-ceiling",
      "slug": "price-ceiling",
      "section": "2.7",
      "level": "core",
      "syllabusRefs": [
        "2.7 Government intervention"
      ],
      "textbookRefs": [
        {
          "chapter": "4",
          "section": "4.2",
          "pages": [
            114
          ]
        }
      ],
      "prerequisites": [
        "u2-11-equilibrium",
        "u2-19-ped",
        "u2-24-pes"
      ],
      "related": [
        "u2-28-price-floor",
        "u2-29-indirect-tax",
        "u2-30-subsidy"
      ],
      "terms": [
        "最高限价",
        "Price ceilings",
        "低于均衡",
        "below equilibrium",
        "短缺",
        "shortage",
        "配给",
        "rationing"
      ],
      "synonyms": {
        "zh-CN": [
          "低于均衡",
          "短缺",
          "配给"
        ],
        "en": [
          "below equilibrium",
          "shortage",
          "rationing"
        ]
      },
      "diagramIds": [
        "price-ceiling"
      ],
      "quizIds": [
        "u2-27-price-ceiling-flash-1",
        "u2-27-price-ceiling-mcq-1",
        "u2-27-price-ceiling-short-1",
        "u2-27-price-ceiling-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-27-price-ceiling",
        "locale": "zh-CN",
        "hlExtension": "原创例：限价 6 元时 Qd=100、Qs=60，短缺为 40，实际合法交易最多 60。排队、关系或黑市可能分配商品；低租金并不保证所有低收入家庭都能获得住房。",
        "title": "最高限价",
        "takeaway": "最高限价规定合法最高价格；低于均衡价格时具有约束力，并通常导致需求量超过供给量。",
        "definition": "最高限价规定合法最高价格；低于均衡价格时具有约束力，并通常导致需求量超过供给量。",
        "causalChain": [
          "价格被限制在均衡以下",
          "买方需求量增加、卖方供给量减少",
          "短缺需要非价格配给"
        ],
        "misconceptions": [
          "高于均衡的最高限价通常没有约束力。"
        ],
        "examApplication": [
          "在图中标出价格、数量和政策楔子；评价弹性、财政与分配。"
        ],
        "summary": [
          "最高限价规定合法最高价格；低于均衡价格时具有约束力，并通常导致需求量超过供给量。",
          "高于均衡的最高限价通常没有约束力。"
        ],
        "explanation": "价格被限制在均衡以下。买方需求量增加、卖方供给量减少。短缺需要非价格配给。\n\n### 原创情境与推导\n\n原创例：低于均衡的最高限价使需求量超过供给量，可能出现排队、黑市和非价格配给；低租金不保证人人有房。数量与支出计算属于 HL。\n\n高于均衡的最高限价通常没有约束力。\n\n在图中标出价格、数量和政策楔子；评价弹性、财政与分配。"
      },
      "en": {
        "id": "u2-27-price-ceiling",
        "locale": "en",
        "hlExtension": "Illustrative example: at a ceiling of six, Qd=100 and Qs=60, leaving a shortage of 40 and at most 60 legal trades. Queues, connections or black markets may allocate goods. Low controlled rent does not guarantee access for every low-income household.",
        "title": "Price ceilings",
        "takeaway": "A price ceiling sets a legal maximum price. Below equilibrium it is binding and normally creates excess demand.",
        "definition": "A price ceiling sets a legal maximum price. Below equilibrium it is binding and normally creates excess demand.",
        "causalChain": [
          "Price is held below equilibrium",
          "quantity demanded rises and quantity supplied falls",
          "shortages require non-price rationing"
        ],
        "misconceptions": [
          "A ceiling above equilibrium is normally non-binding."
        ],
        "examApplication": [
          "Label prices, quantities and the policy wedge; evaluate elasticities, public finance and distribution."
        ],
        "summary": [
          "A price ceiling sets a legal maximum price. Below equilibrium it is binding and normally creates excess demand.",
          "A ceiling above equilibrium is normally non-binding."
        ],
        "explanation": "Price is held below equilibrium.  quantity demanded rises and quantity supplied falls.  shortages require non-price rationing.\n\n### Original scenario and reasoning\n\nIllustrative example: a ceiling below equilibrium creates excess demand and can lead to queues, black markets and non-price rationing. Low rent does not guarantee housing access. Quantity and expenditure calculations are HL.\n\nA ceiling above equilibrium is normally non-binding.\n\nLabel prices, quantities and the policy wedge; evaluate elasticities, public finance and distribution."
      }
    },
    "practice": [
      {
        "id": "u2-27-price-ceiling-flash-1",
        "knowledgePointId": "u2-27-price-ceiling",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“最高限价”，并说明一个关键条件。",
          "en": "Explain Price ceilings and state one important condition."
        },
        "answer": {
          "zh-CN": "最高限价规定合法最高价格；低于均衡价格时具有约束力，并通常导致需求量超过供给量。",
          "en": "A price ceiling sets a legal maximum price. Below equilibrium it is binding and normally creates excess demand."
        },
        "explanation": {
          "zh-CN": "高于均衡的最高限价通常没有约束力。",
          "en": "A ceiling above equilibrium is normally non-binding."
        }
      },
      {
        "id": "u2-27-price-ceiling-mcq-1",
        "knowledgePointId": "u2-27-price-ceiling",
        "type": "mcq",
        "prompt": {
          "zh-CN": "低于均衡的最高限价通常产生什么？",
          "en": "What normally follows a price ceiling below equilibrium?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "过剩",
            "en": "A surplus"
          },
          {
            "id": "b",
            "zh-CN": "价格必升至均衡以上",
            "en": "Price must rise above equilibrium"
          },
          {
            "id": "c",
            "zh-CN": "短缺",
            "en": "A shortage"
          },
          {
            "id": "d",
            "zh-CN": "供需曲线必同时右移",
            "en": "Both curves must shift right"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "短缺。 价格被限制在均衡以下；买方需求量增加、卖方供给量减少；短缺需要非价格配给 高于均衡的最高限价通常没有约束力。",
          "en": "A shortage. Price is held below equilibrium; quantity demanded rises and quantity supplied falls; shortages require non-price rationing A ceiling above equilibrium is normally non-binding."
        }
      },
      {
        "id": "u2-27-price-ceiling-short-1",
        "knowledgePointId": "u2-27-price-ceiling",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释最高限价的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Price ceilings and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "最高限价规定合法最高价格；低于均衡价格时具有约束力，并通常导致需求量超过供给量。 价格被限制在均衡以下；买方需求量增加、卖方供给量减少；短缺需要非价格配给 原创例：低于均衡的最高限价使需求量超过供给量，可能出现排队、黑市和非价格配给；低租金不保证人人有房。数量与支出计算属于 HL。",
          "en": "A price ceiling sets a legal maximum price. Below equilibrium it is binding and normally creates excess demand. Price is held below equilibrium; quantity demanded rises and quantity supplied falls; shortages require non-price rationing Illustrative example: a ceiling below equilibrium creates excess demand and can lead to queues, black markets and non-price rationing. Low rent does not guarantee housing access. Quantity and expenditure calculations are HL."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "低于均衡",
              "en": "below equilibrium"
            },
            "alternatives": {
              "zh-CN": [
                "低于均衡",
                "价格被限制在均衡以下"
              ],
              "en": [
                "below equilibrium",
                "Price is held below equilibrium"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "短缺",
              "en": "shortage"
            },
            "alternatives": {
              "zh-CN": [
                "短缺",
                "买方需求量增加、卖方供给量减少"
              ],
              "en": [
                "shortage",
                "quantity demanded rises and quantity supplied falls"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "配给",
              "en": "rationing"
            },
            "alternatives": {
              "zh-CN": [
                "配给",
                "短缺需要非价格配给"
              ],
              "en": [
                "rationing",
                "shortages require non-price rationing"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u2-27-price-ceiling-mcq-hl-1",
        "knowledgePointId": "u2-27-price-ceiling",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "限价下 Qd=120、Qs=80，短缺多少？",
          "en": "At a ceiling Qd=120 and Qs=80. What is the shortage?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "80",
            "en": "80"
          },
          {
            "id": "b",
            "zh-CN": "120",
            "en": "120"
          },
          {
            "id": "c",
            "zh-CN": "200",
            "en": "200"
          },
          {
            "id": "d",
            "zh-CN": "40",
            "en": "40"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "40。 120 − 80 = 40",
          "en": "40. 120 − 80 = 40"
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-28-price-floor",
      "slug": "price-floor",
      "section": "2.7",
      "level": "core",
      "syllabusRefs": [
        "2.7 Government intervention"
      ],
      "textbookRefs": [
        {
          "chapter": "4",
          "section": "4.2",
          "pages": [
            121
          ]
        }
      ],
      "prerequisites": [
        "u2-11-equilibrium",
        "u2-19-ped",
        "u2-24-pes"
      ],
      "related": [
        "u2-27-price-ceiling",
        "u2-29-indirect-tax",
        "u2-30-subsidy"
      ],
      "terms": [
        "最低限价与最低工资",
        "Price floors and minimum wages",
        "高于均衡",
        "above equilibrium",
        "过剩",
        "surplus",
        "政府购买",
        "government purchase"
      ],
      "synonyms": {
        "zh-CN": [
          "高于均衡",
          "过剩",
          "政府购买"
        ],
        "en": [
          "above equilibrium",
          "surplus",
          "government purchase"
        ]
      },
      "diagramIds": [
        "price-floor"
      ],
      "quizIds": [
        "u2-28-price-floor-flash-1",
        "u2-28-price-floor-mcq-1",
        "u2-28-price-floor-short-1",
        "u2-28-price-floor-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-28-price-floor",
        "locale": "zh-CN",
        "hlExtension": "原创例：农业最低价下 Qs=90、Qd=60，过剩 30。若政府购买全部过剩，财政成本为最低价乘以 30；劳动市场结果也取决于雇主势力、执行和生产率，不能将竞争模型预测当成所有情况的事实。",
        "title": "最低限价与最低工资",
        "takeaway": "最低限价规定合法最低价格；高于均衡时具有约束力并产生过剩。在竞争劳动市场模型中，最低工资可产生劳动力供给过剩。",
        "definition": "最低限价规定合法最低价格；高于均衡时具有约束力并产生过剩。在竞争劳动市场模型中，最低工资可产生劳动力供给过剩。",
        "causalChain": [
          "价格被保持在均衡以上",
          "供给量上升、需求量下降",
          "过剩可能由政府购买或积累"
        ],
        "misconceptions": [
          "低于均衡的最低限价通常不改变市场交易。"
        ],
        "examApplication": [
          "在图中标出价格、数量和政策楔子；评价弹性、财政与分配。"
        ],
        "summary": [
          "最低限价规定合法最低价格；高于均衡时具有约束力并产生过剩。在竞争劳动市场模型中，最低工资可产生劳动力供给过剩。",
          "低于均衡的最低限价通常不改变市场交易。"
        ],
        "explanation": "价格被保持在均衡以上。供给量上升、需求量下降。过剩可能由政府购买或积累。\n\n### 原创情境与推导\n\n原创例：高于均衡的最低价使供给量超过需求量；政府若购买过剩需承担财政成本。竞争劳动市场的最低工资可增加劳动过剩，但实际结果也取决于雇主势力、执行与生产率。数值计算属于 HL。\n\n低于均衡的最低限价通常不改变市场交易。\n\n在图中标出价格、数量和政策楔子；评价弹性、财政与分配。"
      },
      "en": {
        "id": "u2-28-price-floor",
        "locale": "en",
        "hlExtension": "Illustrative example: a farm price floor yields Qs=90 and Qd=60, a surplus of 30. Buying all the surplus costs the floor price times 30. Labour outcomes also depend on employer power, enforcement and productivity; the competitive prediction is not a universal empirical fact.",
        "title": "Price floors and minimum wages",
        "takeaway": "A price floor sets a legal minimum price. Above equilibrium it is binding and creates excess supply. A minimum wage can create excess labour supply in the competitive labour-market model.",
        "definition": "A price floor sets a legal minimum price. Above equilibrium it is binding and creates excess supply. A minimum wage can create excess labour supply in the competitive labour-market model.",
        "causalChain": [
          "Price is held above equilibrium",
          "supply rises and demand falls",
          "surplus may be bought by government or accumulate"
        ],
        "misconceptions": [
          "A floor below equilibrium normally does not change market trades."
        ],
        "examApplication": [
          "Label prices, quantities and the policy wedge; evaluate elasticities, public finance and distribution."
        ],
        "summary": [
          "A price floor sets a legal minimum price. Above equilibrium it is binding and creates excess supply. A minimum wage can create excess labour supply in the competitive labour-market model.",
          "A floor below equilibrium normally does not change market trades."
        ],
        "explanation": "Price is held above equilibrium.  supply rises and demand falls.  surplus may be bought by government or accumulate.\n\n### Original scenario and reasoning\n\nIllustrative example: a floor above equilibrium creates excess supply, with public costs if government buys it. A minimum wage can create excess labour supply in a competitive model; actual outcomes also depend on employer power, enforcement and productivity. Numerical calculations are HL.\n\nA floor below equilibrium normally does not change market trades.\n\nLabel prices, quantities and the policy wedge; evaluate elasticities, public finance and distribution."
      }
    },
    "practice": [
      {
        "id": "u2-28-price-floor-flash-1",
        "knowledgePointId": "u2-28-price-floor",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“最低限价与最低工资”，并说明一个关键条件。",
          "en": "Explain Price floors and minimum wages and state one important condition."
        },
        "answer": {
          "zh-CN": "最低限价规定合法最低价格；高于均衡时具有约束力并产生过剩。在竞争劳动市场模型中，最低工资可产生劳动力供给过剩。",
          "en": "A price floor sets a legal minimum price. Above equilibrium it is binding and creates excess supply. A minimum wage can create excess labour supply in the competitive labour-market model."
        },
        "explanation": {
          "zh-CN": "低于均衡的最低限价通常不改变市场交易。",
          "en": "A floor below equilibrium normally does not change market trades."
        }
      },
      {
        "id": "u2-28-price-floor-mcq-1",
        "knowledgePointId": "u2-28-price-floor",
        "type": "mcq",
        "prompt": {
          "zh-CN": "高于均衡的最低价通常造成什么？",
          "en": "What normally follows a price floor above equilibrium?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "需求量超过供给量",
            "en": "Quantity demanded exceeds supply"
          },
          {
            "id": "b",
            "zh-CN": "所有企业利润必定为零",
            "en": "Every firm must earn zero profit"
          },
          {
            "id": "c",
            "zh-CN": "消费者购买必无限增加",
            "en": "Consumer purchases must rise without limit"
          },
          {
            "id": "d",
            "zh-CN": "供给量超过需求量",
            "en": "Quantity supplied exceeds quantity demanded"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "供给量超过需求量。 价格被保持在均衡以上；供给量上升、需求量下降；过剩可能由政府购买或积累 低于均衡的最低限价通常不改变市场交易。",
          "en": "Quantity supplied exceeds quantity demanded. Price is held above equilibrium; supply rises and demand falls; surplus may be bought by government or accumulate A floor below equilibrium normally does not change market trades."
        }
      },
      {
        "id": "u2-28-price-floor-short-1",
        "knowledgePointId": "u2-28-price-floor",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释最低限价与最低工资的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Price floors and minimum wages and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "最低限价规定合法最低价格；高于均衡时具有约束力并产生过剩。在竞争劳动市场模型中，最低工资可产生劳动力供给过剩。 价格被保持在均衡以上；供给量上升、需求量下降；过剩可能由政府购买或积累 原创例：高于均衡的最低价使供给量超过需求量；政府若购买过剩需承担财政成本。竞争劳动市场的最低工资可增加劳动过剩，但实际结果也取决于雇主势力、执行与生产率。数值计算属于 HL。",
          "en": "A price floor sets a legal minimum price. Above equilibrium it is binding and creates excess supply. A minimum wage can create excess labour supply in the competitive labour-market model. Price is held above equilibrium; supply rises and demand falls; surplus may be bought by government or accumulate Illustrative example: a floor above equilibrium creates excess supply, with public costs if government buys it. A minimum wage can create excess labour supply in a competitive model; actual outcomes also depend on employer power, enforcement and productivity. Numerical calculations are HL."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "高于均衡",
              "en": "above equilibrium"
            },
            "alternatives": {
              "zh-CN": [
                "高于均衡",
                "价格被保持在均衡以上"
              ],
              "en": [
                "above equilibrium",
                "Price is held above equilibrium"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "过剩",
              "en": "surplus"
            },
            "alternatives": {
              "zh-CN": [
                "过剩",
                "供给量上升、需求量下降"
              ],
              "en": [
                "surplus",
                "supply rises and demand falls"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "政府购买",
              "en": "government purchase"
            },
            "alternatives": {
              "zh-CN": [
                "政府购买",
                "过剩可能由政府购买或积累"
              ],
              "en": [
                "government purchase",
                "surplus may be bought by government or accumulate"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u2-28-price-floor-mcq-hl-1",
        "knowledgePointId": "u2-28-price-floor",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "最低价下 Qs=75、Qd=50，过剩多少？",
          "en": "At a floor Qs=75 and Qd=50. What is the surplus?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "25",
            "en": "25"
          },
          {
            "id": "b",
            "zh-CN": "50",
            "en": "50"
          },
          {
            "id": "c",
            "zh-CN": "75",
            "en": "75"
          },
          {
            "id": "d",
            "zh-CN": "125",
            "en": "125"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "25。 75 − 50 = 25",
          "en": "25. 75 − 50 = 25"
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-29-indirect-tax",
      "slug": "indirect-tax",
      "section": "2.7",
      "level": "core",
      "syllabusRefs": [
        "2.7 Government intervention"
      ],
      "textbookRefs": [
        {
          "chapter": "4",
          "section": "4.3",
          "pages": [
            127
          ]
        }
      ],
      "prerequisites": [
        "u2-11-equilibrium",
        "u2-19-ped",
        "u2-24-pes"
      ],
      "related": [
        "u2-27-price-ceiling",
        "u2-28-price-floor",
        "u2-30-subsidy"
      ],
      "terms": [
        "间接税与税收负担",
        "Indirect taxes and tax incidence",
        "楔子",
        "wedge",
        "弹性",
        "elasticity",
        "负担",
        "incidence"
      ],
      "synonyms": {
        "zh-CN": [
          "楔子",
          "弹性",
          "负担"
        ],
        "en": [
          "wedge",
          "elasticity",
          "incidence"
        ]
      },
      "diagramIds": [
        "tax-wedge"
      ],
      "quizIds": [
        "u2-29-indirect-tax-flash-1",
        "u2-29-indirect-tax-mcq-1",
        "u2-29-indirect-tax-short-1",
        "u2-29-indirect-tax-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-29-indirect-tax",
        "locale": "zh-CN",
        "hlExtension": "原创例：税前价格 10，税后买方支付 13，卖方净收 9，单位税为 4。买方承担 3、卖方承担 1。若交易量为 50，政府收入为 200；这些数字是教学假设。",
        "title": "间接税与税收负担",
        "takeaway": "单位间接税在买方支付价格与卖方净收入之间造成税额楔子；经济负担由相对弹性决定，而非仅由法定缴税者决定。",
        "definition": "单位间接税在买方支付价格与卖方净收入之间造成税额楔子；经济负担由相对弹性决定，而非仅由法定缴税者决定。",
        "causalChain": [
          "税提高交易边际成本",
          "交易量下降并形成买卖价格差",
          "较缺乏弹性的一方通常承担更大负担"
        ],
        "misconceptions": [
          "向企业征税并不意味着企业承担全部经济负担。"
        ],
        "examApplication": [
          "在图中标出价格、数量和政策楔子；评价弹性、财政与分配。"
        ],
        "summary": [
          "单位间接税在买方支付价格与卖方净收入之间造成税额楔子；经济负担由相对弹性决定，而非仅由法定缴税者决定。",
          "向企业征税并不意味着企业承担全部经济负担。"
        ],
        "explanation": "税提高交易边际成本。交易量下降并形成买卖价格差。较缺乏弹性的一方通常承担更大负担。\n\n### 原创情境与推导\n\n原创例：单位税使买方支付与卖方净收之间出现楔子，通常减少交易量。相对缺乏弹性的一方通常承担较大税负；法定向谁征税不决定最终负担。税额与收入计算属于 HL。\n\n向企业征税并不意味着企业承担全部经济负担。\n\n在图中标出价格、数量和政策楔子；评价弹性、财政与分配。"
      },
      "en": {
        "id": "u2-29-indirect-tax",
        "locale": "en",
        "hlExtension": "Illustrative example: the pre-tax price is ten; buyers then pay 13 and sellers receive nine. The tax is four: buyers bear three and sellers one. At 50 trades, government revenue is 200. These are hypothetical teaching numbers.",
        "title": "Indirect taxes and tax incidence",
        "takeaway": "A specific indirect tax creates a per-unit wedge between the buyer's price and the seller's net receipt. Economic incidence depends on relative elasticities, not just on who legally remits the tax.",
        "definition": "A specific indirect tax creates a per-unit wedge between the buyer's price and the seller's net receipt. Economic incidence depends on relative elasticities, not just on who legally remits the tax.",
        "causalChain": [
          "Tax raises the marginal cost of trading",
          "quantity falls and buyer/seller prices diverge",
          "the relatively inelastic side usually bears more burden"
        ],
        "misconceptions": [
          "Collecting the tax from firms does not mean firms bear the entire economic burden."
        ],
        "examApplication": [
          "Label prices, quantities and the policy wedge; evaluate elasticities, public finance and distribution."
        ],
        "summary": [
          "A specific indirect tax creates a per-unit wedge between the buyer's price and the seller's net receipt. Economic incidence depends on relative elasticities, not just on who legally remits the tax.",
          "Collecting the tax from firms does not mean firms bear the entire economic burden."
        ],
        "explanation": "Tax raises the marginal cost of trading.  quantity falls and buyer/seller prices diverge.  the relatively inelastic side usually bears more burden.\n\n### Original scenario and reasoning\n\nIllustrative example: a per-unit tax creates a wedge between buyer payment and seller receipts, normally reducing quantity. The relatively inelastic side normally bears more burden; statutory collection does not determine incidence. Numerical tax and revenue calculations are HL.\n\nCollecting the tax from firms does not mean firms bear the entire economic burden.\n\nLabel prices, quantities and the policy wedge; evaluate elasticities, public finance and distribution."
      }
    },
    "practice": [
      {
        "id": "u2-29-indirect-tax-flash-1",
        "knowledgePointId": "u2-29-indirect-tax",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“间接税与税收负担”，并说明一个关键条件。",
          "en": "Explain Indirect taxes and tax incidence and state one important condition."
        },
        "answer": {
          "zh-CN": "单位间接税在买方支付价格与卖方净收入之间造成税额楔子；经济负担由相对弹性决定，而非仅由法定缴税者决定。",
          "en": "A specific indirect tax creates a per-unit wedge between the buyer's price and the seller's net receipt. Economic incidence depends on relative elasticities, not just on who legally remits the tax."
        },
        "explanation": {
          "zh-CN": "向企业征税并不意味着企业承担全部经济负担。",
          "en": "Collecting the tax from firms does not mean firms bear the entire economic burden."
        }
      },
      {
        "id": "u2-29-indirect-tax-mcq-1",
        "knowledgePointId": "u2-29-indirect-tax",
        "type": "mcq",
        "prompt": {
          "zh-CN": "在通常的竞争模型中，哪方承担较大单位税负？",
          "en": "In the usual competitive model, which side bears more of a unit tax?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "相对缺乏弹性的一方",
            "en": "The relatively inelastic side"
          },
          {
            "id": "b",
            "zh-CN": "法定缴税方必承担全部",
            "en": "The statutory payer always bears all of it"
          },
          {
            "id": "c",
            "zh-CN": "相对有弹性的一方必承担全部",
            "en": "The more elastic side always bears all of it"
          },
          {
            "id": "d",
            "zh-CN": "双方始终各半",
            "en": "The split is always equal"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "相对缺乏弹性的一方。 税提高交易边际成本；交易量下降并形成买卖价格差；较缺乏弹性的一方通常承担更大负担 向企业征税并不意味着企业承担全部经济负担。",
          "en": "The relatively inelastic side. Tax raises the marginal cost of trading; quantity falls and buyer/seller prices diverge; the relatively inelastic side usually bears more burden Collecting the tax from firms does not mean firms bear the entire economic burden."
        }
      },
      {
        "id": "u2-29-indirect-tax-short-1",
        "knowledgePointId": "u2-29-indirect-tax",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释间接税与税收负担的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Indirect taxes and tax incidence and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "单位间接税在买方支付价格与卖方净收入之间造成税额楔子；经济负担由相对弹性决定，而非仅由法定缴税者决定。 税提高交易边际成本；交易量下降并形成买卖价格差；较缺乏弹性的一方通常承担更大负担 原创例：单位税使买方支付与卖方净收之间出现楔子，通常减少交易量。相对缺乏弹性的一方通常承担较大税负；法定向谁征税不决定最终负担。税额与收入计算属于 HL。",
          "en": "A specific indirect tax creates a per-unit wedge between the buyer's price and the seller's net receipt. Economic incidence depends on relative elasticities, not just on who legally remits the tax. Tax raises the marginal cost of trading; quantity falls and buyer/seller prices diverge; the relatively inelastic side usually bears more burden Illustrative example: a per-unit tax creates a wedge between buyer payment and seller receipts, normally reducing quantity. The relatively inelastic side normally bears more burden; statutory collection does not determine incidence. Numerical tax and revenue calculations are HL."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "楔子",
              "en": "wedge"
            },
            "alternatives": {
              "zh-CN": [
                "楔子",
                "税提高交易边际成本"
              ],
              "en": [
                "wedge",
                "Tax raises the marginal cost of trading"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "弹性",
              "en": "elasticity"
            },
            "alternatives": {
              "zh-CN": [
                "弹性",
                "交易量下降并形成买卖价格差"
              ],
              "en": [
                "elasticity",
                "quantity falls and buyer/seller prices diverge"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "负担",
              "en": "incidence"
            },
            "alternatives": {
              "zh-CN": [
                "负担",
                "较缺乏弹性的一方通常承担更大负担"
              ],
              "en": [
                "incidence",
                "the relatively inelastic side usually bears more burden"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u2-29-indirect-tax-mcq-hl-1",
        "knowledgePointId": "u2-29-indirect-tax",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "买方支付 14、卖方净收 10，单位税为多少？",
          "en": "Buyers pay 14 and sellers receive ten. What is the per-unit tax?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "10",
            "en": "10"
          },
          {
            "id": "b",
            "zh-CN": "4",
            "en": "4"
          },
          {
            "id": "c",
            "zh-CN": "14",
            "en": "14"
          },
          {
            "id": "d",
            "zh-CN": "24",
            "en": "24"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "4。 14 − 10 = 4",
          "en": "4. 14 − 10 = 4"
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-30-subsidy",
      "slug": "subsidy",
      "section": "2.7",
      "level": "core",
      "syllabusRefs": [
        "2.7 Government intervention"
      ],
      "textbookRefs": [
        {
          "chapter": "4",
          "section": "4.4",
          "pages": [
            134
          ]
        }
      ],
      "prerequisites": [
        "u2-11-equilibrium",
        "u2-19-ped",
        "u2-24-pes"
      ],
      "related": [
        "u2-27-price-ceiling",
        "u2-28-price-floor",
        "u2-29-indirect-tax"
      ],
      "terms": [
        "补贴与财政成本",
        "Subsidies and fiscal cost",
        "补贴",
        "subsidy",
        "数量",
        "quantity",
        "财政",
        "government spending"
      ],
      "synonyms": {
        "zh-CN": [
          "补贴",
          "数量",
          "财政"
        ],
        "en": [
          "subsidy",
          "quantity",
          "government spending"
        ]
      },
      "diagramIds": [
        "subsidy-wedge"
      ],
      "quizIds": [
        "u2-30-subsidy-flash-1",
        "u2-30-subsidy-mcq-1",
        "u2-30-subsidy-short-1",
        "u2-30-subsidy-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-30-subsidy",
        "locale": "zh-CN",
        "hlExtension": "原创例：买方付 8、卖方收 11，补贴为 3。补贴数量 60 时政府花费 180。若资助污染产品，增产可能扩大外部成本；补贴必须结合政策目标评价，而非只看数量增加。",
        "title": "补贴与财政成本",
        "takeaway": "单位补贴使卖方收到的金额高于买方支付价格，鼓励生产和消费；政府支出为单位补贴乘以补贴数量。",
        "definition": "单位补贴使卖方收到的金额高于买方支付价格，鼓励生产和消费；政府支出为单位补贴乘以补贴数量。",
        "causalChain": [
          "补贴降低生产者净边际成本",
          "供给右移、数量增加",
          "财政支出与收益在买卖双方间分配"
        ],
        "misconceptions": [
          "补贴后的均衡数量应进入财政成本计算，不能使用税补前数量。"
        ],
        "examApplication": [
          "在图中标出价格、数量和政策楔子；评价弹性、财政与分配。"
        ],
        "summary": [
          "单位补贴使卖方收到的金额高于买方支付价格，鼓励生产和消费；政府支出为单位补贴乘以补贴数量。",
          "补贴后的均衡数量应进入财政成本计算，不能使用税补前数量。"
        ],
        "explanation": "补贴降低生产者净边际成本。供给右移、数量增加。财政支出与收益在买卖双方间分配。\n\n### 原创情境与推导\n\n原创例：单位补贴使生产者净收高于消费者支付，通常增加数量并产生财政支出；应比较消费者与生产者收益、融资机会成本及外部性。财政支出数值计算属于 HL。\n\n补贴后的均衡数量应进入财政成本计算，不能使用税补前数量。\n\n在图中标出价格、数量和政策楔子；评价弹性、财政与分配。"
      },
      "en": {
        "id": "u2-30-subsidy",
        "locale": "en",
        "hlExtension": "Illustrative example: buyers pay eight and sellers receive eleven, giving a subsidy of three. At 60 subsidised units, spending is 180. Subsidising a polluting good may expand external costs, so evaluate the objective rather than output growth alone.",
        "title": "Subsidies and fiscal cost",
        "takeaway": "A per-unit subsidy makes the seller's receipt exceed the buyer's payment and encourages production and consumption. Government spending is the subsidy per unit times subsidised quantity.",
        "definition": "A per-unit subsidy makes the seller's receipt exceed the buyer's payment and encourages production and consumption. Government spending is the subsidy per unit times subsidised quantity.",
        "causalChain": [
          "A subsidy lowers producers' net marginal cost",
          "supply shifts right and quantity rises",
          "spending and gains are distributed between buyers and sellers"
        ],
        "misconceptions": [
          "Use the subsidised equilibrium quantity in the spending calculation, not the pre-policy quantity."
        ],
        "examApplication": [
          "Label prices, quantities and the policy wedge; evaluate elasticities, public finance and distribution."
        ],
        "summary": [
          "A per-unit subsidy makes the seller's receipt exceed the buyer's payment and encourages production and consumption. Government spending is the subsidy per unit times subsidised quantity.",
          "Use the subsidised equilibrium quantity in the spending calculation, not the pre-policy quantity."
        ],
        "explanation": "A subsidy lowers producers' net marginal cost.  supply shifts right and quantity rises.  spending and gains are distributed between buyers and sellers.\n\n### Original scenario and reasoning\n\nIllustrative example: a subsidy raises producer receipts above consumer payment, normally increasing quantity with a fiscal cost. Compare consumer and producer gains, financing opportunity cost and externalities. Numerical fiscal calculations are HL.\n\nUse the subsidised equilibrium quantity in the spending calculation, not the pre-policy quantity.\n\nLabel prices, quantities and the policy wedge; evaluate elasticities, public finance and distribution."
      }
    },
    "practice": [
      {
        "id": "u2-30-subsidy-flash-1",
        "knowledgePointId": "u2-30-subsidy",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“补贴与财政成本”，并说明一个关键条件。",
          "en": "Explain Subsidies and fiscal cost and state one important condition."
        },
        "answer": {
          "zh-CN": "单位补贴使卖方收到的金额高于买方支付价格，鼓励生产和消费；政府支出为单位补贴乘以补贴数量。",
          "en": "A per-unit subsidy makes the seller's receipt exceed the buyer's payment and encourages production and consumption. Government spending is the subsidy per unit times subsidised quantity."
        },
        "explanation": {
          "zh-CN": "补贴后的均衡数量应进入财政成本计算，不能使用税补前数量。",
          "en": "Use the subsidised equilibrium quantity in the spending calculation, not the pre-policy quantity."
        }
      },
      {
        "id": "u2-30-subsidy-mcq-1",
        "knowledgePointId": "u2-30-subsidy",
        "type": "mcq",
        "prompt": {
          "zh-CN": "补贴的财政成本为何重要？",
          "en": "Why does a subsidy’s fiscal cost matter?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "政府资金没有资源成本",
            "en": "Government funds have no resource cost"
          },
          {
            "id": "b",
            "zh-CN": "资金具有其他用途的机会成本",
            "en": "Funds have an opportunity cost in alternative uses"
          },
          {
            "id": "c",
            "zh-CN": "补贴必使所有外部性消失",
            "en": "Subsidies remove every externality"
          },
          {
            "id": "d",
            "zh-CN": "产量越高必定越有效率",
            "en": "More output always means more efficiency"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "资金具有其他用途的机会成本。 补贴降低生产者净边际成本；供给右移、数量增加；财政支出与收益在买卖双方间分配 补贴后的均衡数量应进入财政成本计算，不能使用税补前数量。",
          "en": "Funds have an opportunity cost in alternative uses. A subsidy lowers producers' net marginal cost; supply shifts right and quantity rises; spending and gains are distributed between buyers and sellers Use the subsidised equilibrium quantity in the spending calculation, not the pre-policy quantity."
        }
      },
      {
        "id": "u2-30-subsidy-short-1",
        "knowledgePointId": "u2-30-subsidy",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释补贴与财政成本的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Subsidies and fiscal cost and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "单位补贴使卖方收到的金额高于买方支付价格，鼓励生产和消费；政府支出为单位补贴乘以补贴数量。 补贴降低生产者净边际成本；供给右移、数量增加；财政支出与收益在买卖双方间分配 原创例：单位补贴使生产者净收高于消费者支付，通常增加数量并产生财政支出；应比较消费者与生产者收益、融资机会成本及外部性。财政支出数值计算属于 HL。",
          "en": "A per-unit subsidy makes the seller's receipt exceed the buyer's payment and encourages production and consumption. Government spending is the subsidy per unit times subsidised quantity. A subsidy lowers producers' net marginal cost; supply shifts right and quantity rises; spending and gains are distributed between buyers and sellers Illustrative example: a subsidy raises producer receipts above consumer payment, normally increasing quantity with a fiscal cost. Compare consumer and producer gains, financing opportunity cost and externalities. Numerical fiscal calculations are HL."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "补贴",
              "en": "subsidy"
            },
            "alternatives": {
              "zh-CN": [
                "补贴",
                "补贴降低生产者净边际成本"
              ],
              "en": [
                "subsidy",
                "A subsidy lowers producers' net marginal cost"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "数量",
              "en": "quantity"
            },
            "alternatives": {
              "zh-CN": [
                "数量",
                "供给右移、数量增加"
              ],
              "en": [
                "quantity",
                "supply shifts right and quantity rises"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "财政",
              "en": "government spending"
            },
            "alternatives": {
              "zh-CN": [
                "财政",
                "财政支出与收益在买卖双方间分配"
              ],
              "en": [
                "government spending",
                "spending and gains are distributed between buyers and sellers"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u2-30-subsidy-mcq-hl-1",
        "knowledgePointId": "u2-30-subsidy",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "单位补贴 5，补贴数量 40，政府支出为多少？",
          "en": "A subsidy is five per unit on 40 units. What is government spending?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "8",
            "en": "8"
          },
          {
            "id": "b",
            "zh-CN": "40",
            "en": "40"
          },
          {
            "id": "c",
            "zh-CN": "200",
            "en": "200"
          },
          {
            "id": "d",
            "zh-CN": "45",
            "en": "45"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "200。 5 × 40 = 200",
          "en": "200. 5 × 40 = 200"
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-31-intervention-evaluation",
      "slug": "intervention-evaluation",
      "section": "2.7",
      "level": "core",
      "syllabusRefs": [
        "2.7 Government intervention"
      ],
      "textbookRefs": [
        {
          "chapter": "4",
          "section": "4.1",
          "pages": [
            113
          ]
        }
      ],
      "prerequisites": [
        "u2-11-equilibrium",
        "u2-19-ped",
        "u2-24-pes"
      ],
      "related": [
        "u2-27-price-ceiling",
        "u2-28-price-floor",
        "u2-29-indirect-tax"
      ],
      "terms": [
        "干预的利益相关者与评价",
        "Stakeholders and intervention evaluation",
        "利益相关者",
        "stakeholders",
        "财政成本",
        "fiscal cost",
        "弹性",
        "elasticity"
      ],
      "synonyms": {
        "zh-CN": [
          "利益相关者",
          "财政成本",
          "弹性"
        ],
        "en": [
          "stakeholders",
          "fiscal cost",
          "elasticity"
        ]
      },
      "diagramIds": [
        "tax-wedge"
      ],
      "quizIds": [
        "u2-31-intervention-evaluation-flash-1",
        "u2-31-intervention-evaluation-mcq-1",
        "u2-31-intervention-evaluation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-31-intervention-evaluation",
        "locale": "zh-CN",
        "title": "干预的利益相关者与评价",
        "takeaway": "评价干预应比较消费者、生产者、政府及第三方的收益与成本，并考虑时间、弹性、执行、分配和替代政策。",
        "definition": "评价干预应比较消费者、生产者、政府及第三方的收益与成本，并考虑时间、弹性、执行、分配和替代政策。",
        "causalChain": [
          "政策改变价格、数量或激励",
          "不同群体受到不同影响",
          "效率、公平和可执行性需要共同权衡"
        ],
        "misconceptions": [
          "评价不能只写优缺点清单，必须说明何种条件使某种效果更重要。"
        ],
        "examApplication": [
          "在图中标出价格、数量和政策楔子；评价弹性、财政与分配。"
        ],
        "summary": [
          "评价干预应比较消费者、生产者、政府及第三方的收益与成本，并考虑时间、弹性、执行、分配和替代政策。",
          "评价不能只写优缺点清单，必须说明何种条件使某种效果更重要。"
        ],
        "explanation": "政策改变价格、数量或激励。不同群体受到不同影响。效率、公平和可执行性需要共同权衡。\n\n### 原创情境与推导\n\n原创例：食品补贴帮助消费者，但需要税收融资，且没有针对性时高收入消费者也会获益。比较现金转移时，应讨论贫困识别、覆盖遗漏、行政成本和供给能否增加。\n\n评价不能只写优缺点清单，必须说明何种条件使某种效果更重要。\n\n在图中标出价格、数量和政策楔子；评价弹性、财政与分配。"
      },
      "en": {
        "id": "u2-31-intervention-evaluation",
        "locale": "en",
        "title": "Stakeholders and intervention evaluation",
        "takeaway": "Evaluate intervention through gains and costs to consumers, producers, government and third parties, considering time, elasticity, enforcement, distribution and alternative policies.",
        "definition": "Evaluate intervention through gains and costs to consumers, producers, government and third parties, considering time, elasticity, enforcement, distribution and alternative policies.",
        "causalChain": [
          "Policy changes prices, quantities or incentives",
          "groups experience different effects",
          "efficiency, equity and feasibility must be weighed together"
        ],
        "misconceptions": [
          "Evaluation is not merely a list of advantages and disadvantages; explain which conditions make an effect matter more."
        ],
        "examApplication": [
          "Label prices, quantities and the policy wedge; evaluate elasticities, public finance and distribution."
        ],
        "summary": [
          "Evaluate intervention through gains and costs to consumers, producers, government and third parties, considering time, elasticity, enforcement, distribution and alternative policies.",
          "Evaluation is not merely a list of advantages and disadvantages; explain which conditions make an effect matter more."
        ],
        "explanation": "Policy changes prices, quantities or incentives.  groups experience different effects.  efficiency, equity and feasibility must be weighed together.\n\n### Original scenario and reasoning\n\nIllustrative example: a food subsidy helps consumers but requires financing and may also benefit rich households. Compare targeted cash transfers using identification of need, exclusion errors, administrative cost and the ability of supply to expand.\n\nEvaluation is not merely a list of advantages and disadvantages; explain which conditions make an effect matter more.\n\nLabel prices, quantities and the policy wedge; evaluate elasticities, public finance and distribution."
      }
    },
    "practice": [
      {
        "id": "u2-31-intervention-evaluation-flash-1",
        "knowledgePointId": "u2-31-intervention-evaluation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“干预的利益相关者与评价”，并说明一个关键条件。",
          "en": "Explain Stakeholders and intervention evaluation and state one important condition."
        },
        "answer": {
          "zh-CN": "评价干预应比较消费者、生产者、政府及第三方的收益与成本，并考虑时间、弹性、执行、分配和替代政策。",
          "en": "Evaluate intervention through gains and costs to consumers, producers, government and third parties, considering time, elasticity, enforcement, distribution and alternative policies."
        },
        "explanation": {
          "zh-CN": "评价不能只写优缺点清单，必须说明何种条件使某种效果更重要。",
          "en": "Evaluation is not merely a list of advantages and disadvantages; explain which conditions make an effect matter more."
        }
      },
      {
        "id": "u2-31-intervention-evaluation-mcq-1",
        "knowledgePointId": "u2-31-intervention-evaluation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪项最能支持有条件的补贴评价？",
          "en": "Which best supports a conditional evaluation of a subsidy?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只看消费者价格下降",
            "en": "Consider only the lower consumer price"
          },
          {
            "id": "b",
            "zh-CN": "认为财政资源无限",
            "en": "Assume unlimited fiscal resources"
          },
          {
            "id": "c",
            "zh-CN": "结合供给弹性和受益分布",
            "en": "Consider supply elasticity and distribution of gains"
          },
          {
            "id": "d",
            "zh-CN": "忽略所有第三方",
            "en": "Ignore every third party"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "结合供给弹性和受益分布。 政策改变价格、数量或激励；不同群体受到不同影响；效率、公平和可执行性需要共同权衡 评价不能只写优缺点清单，必须说明何种条件使某种效果更重要。",
          "en": "Consider supply elasticity and distribution of gains. Policy changes prices, quantities or incentives; groups experience different effects; efficiency, equity and feasibility must be weighed together Evaluation is not merely a list of advantages and disadvantages; explain which conditions make an effect matter more."
        }
      },
      {
        "id": "u2-31-intervention-evaluation-short-1",
        "knowledgePointId": "u2-31-intervention-evaluation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释干预的利益相关者与评价的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Stakeholders and intervention evaluation and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "评价干预应比较消费者、生产者、政府及第三方的收益与成本，并考虑时间、弹性、执行、分配和替代政策。 政策改变价格、数量或激励；不同群体受到不同影响；效率、公平和可执行性需要共同权衡 原创例：食品补贴帮助消费者，但需要税收融资，且没有针对性时高收入消费者也会获益。比较现金转移时，应讨论贫困识别、覆盖遗漏、行政成本和供给能否增加。",
          "en": "Evaluate intervention through gains and costs to consumers, producers, government and third parties, considering time, elasticity, enforcement, distribution and alternative policies. Policy changes prices, quantities or incentives; groups experience different effects; efficiency, equity and feasibility must be weighed together Illustrative example: a food subsidy helps consumers but requires financing and may also benefit rich households. Compare targeted cash transfers using identification of need, exclusion errors, administrative cost and the ability of supply to expand."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "利益相关者",
              "en": "stakeholders"
            },
            "alternatives": {
              "zh-CN": [
                "利益相关者",
                "政策改变价格、数量或激励"
              ],
              "en": [
                "stakeholders",
                "Policy changes prices, quantities or incentives"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "财政成本",
              "en": "fiscal cost"
            },
            "alternatives": {
              "zh-CN": [
                "财政成本",
                "不同群体受到不同影响"
              ],
              "en": [
                "fiscal cost",
                "groups experience different effects"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "弹性",
              "en": "elasticity"
            },
            "alternatives": {
              "zh-CN": [
                "弹性",
                "效率、公平和可执行性需要共同权衡"
              ],
              "en": [
                "elasticity",
                "efficiency, equity and feasibility must be weighed together"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-32-tax-welfare-calculation",
      "slug": "tax-welfare-calculation",
      "section": "2.7",
      "level": "hl",
      "syllabusRefs": [
        "2.7 Government intervention"
      ],
      "textbookRefs": [
        {
          "chapter": "4",
          "section": "4.3",
          "pages": [
            130
          ]
        }
      ],
      "prerequisites": [
        "u2-11-equilibrium",
        "u2-19-ped",
        "u2-24-pes"
      ],
      "related": [
        "u2-27-price-ceiling",
        "u2-28-price-floor",
        "u2-29-indirect-tax"
      ],
      "terms": [
        "税补的福利计算",
        "Tax and subsidy welfare calculations",
        "三角形",
        "triangle",
        "交易减少",
        "lost trades",
        "转移",
        "transfer"
      ],
      "synonyms": {
        "zh-CN": [
          "三角形",
          "交易减少",
          "转移"
        ],
        "en": [
          "triangle",
          "lost trades",
          "transfer"
        ]
      },
      "diagramIds": [
        "tax-wedge"
      ],
      "quizIds": [
        "u2-32-tax-welfare-calculation-flash-1",
        "u2-32-tax-welfare-calculation-mcq-1",
        "u2-32-tax-welfare-calculation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-32-tax-welfare-calculation",
        "locale": "zh-CN",
        "title": "税补的福利计算",
        "takeaway": "无外部性的线性竞争模型中，单位税减少有效交易并产生无谓损失；矩形税收收入是转移，不能与净社会损失混同。",
        "definition": "无外部性的线性竞争模型中，单位税减少有效交易并产生无谓损失；矩形税收收入是转移，不能与净社会损失混同。",
        "causalChain": [
          "税使数量由 Q0 降至 Qt",
          "消失单位原有利益超过成本",
          "三角形面积给出无谓损失"
        ],
        "misconceptions": [
          "三角形公式需要线性曲线等假设，且政府收入并非全部损失。"
        ],
        "examApplication": [
          "在图中标出价格、数量和政策楔子；评价弹性、财政与分配。"
        ],
        "summary": [
          "无外部性的线性竞争模型中，单位税减少有效交易并产生无谓损失；矩形税收收入是转移，不能与净社会损失混同。",
          "三角形公式需要线性曲线等假设，且政府收入并非全部损失。"
        ],
        "explanation": "税使数量由 Q0 降至 Qt。消失单位原有利益超过成本。三角形面积给出无谓损失。\n\n### 原创情境与推导\n\n原创例：单位税 4，数量由 100 降到 80，线性曲线下无谓损失为 ½×4×20=40，税收为 4×80=320。若税纠正污染，此无外部性公式不能直接用来判断税的净福利效果。\n\n三角形公式需要线性曲线等假设，且政府收入并非全部损失。\n\n在图中标出价格、数量和政策楔子；评价弹性、财政与分配。"
      },
      "en": {
        "id": "u2-32-tax-welfare-calculation",
        "locale": "en",
        "title": "Tax and subsidy welfare calculations",
        "takeaway": "In a linear competitive model without externalities, a per-unit tax removes beneficial trades and creates deadweight loss. Rectangular tax revenue is a transfer, not itself a net social loss.",
        "definition": "In a linear competitive model without externalities, a per-unit tax removes beneficial trades and creates deadweight loss. Rectangular tax revenue is a transfer, not itself a net social loss.",
        "causalChain": [
          "Tax lowers quantity from Q0 to Qt",
          "lost units previously had benefit above cost",
          "the triangle measures deadweight loss"
        ],
        "misconceptions": [
          "The triangle formula needs assumptions such as linear curves; government revenue is not entirely lost welfare."
        ],
        "examApplication": [
          "Label prices, quantities and the policy wedge; evaluate elasticities, public finance and distribution."
        ],
        "summary": [
          "In a linear competitive model without externalities, a per-unit tax removes beneficial trades and creates deadweight loss. Rectangular tax revenue is a transfer, not itself a net social loss.",
          "The triangle formula needs assumptions such as linear curves; government revenue is not entirely lost welfare."
        ],
        "explanation": "Tax lowers quantity from Q0 to Qt.  lost units previously had benefit above cost.  the triangle measures deadweight loss.\n\n### Original scenario and reasoning\n\nIllustrative example: tax is four and output falls from 100 to 80. With linear curves, DWL is ½×4×20=40 and revenue 4×80=320. If the tax corrects pollution, this no-externality formula cannot directly establish its net welfare effect.\n\nThe triangle formula needs assumptions such as linear curves; government revenue is not entirely lost welfare.\n\nLabel prices, quantities and the policy wedge; evaluate elasticities, public finance and distribution."
      }
    },
    "practice": [
      {
        "id": "u2-32-tax-welfare-calculation-flash-1",
        "knowledgePointId": "u2-32-tax-welfare-calculation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“税补的福利计算”，并说明一个关键条件。",
          "en": "Explain Tax and subsidy welfare calculations and state one important condition."
        },
        "answer": {
          "zh-CN": "无外部性的线性竞争模型中，单位税减少有效交易并产生无谓损失；矩形税收收入是转移，不能与净社会损失混同。",
          "en": "In a linear competitive model without externalities, a per-unit tax removes beneficial trades and creates deadweight loss. Rectangular tax revenue is a transfer, not itself a net social loss."
        },
        "explanation": {
          "zh-CN": "三角形公式需要线性曲线等假设，且政府收入并非全部损失。",
          "en": "The triangle formula needs assumptions such as linear curves; government revenue is not entirely lost welfare."
        }
      },
      {
        "id": "u2-32-tax-welfare-calculation-mcq-1",
        "knowledgePointId": "u2-32-tax-welfare-calculation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "线性无外部性市场税额 6，数量减少 10，DWL 多少？",
          "en": "In a linear no-externality market, tax is six and quantity falls ten. What is DWL?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "60",
            "en": "60"
          },
          {
            "id": "b",
            "zh-CN": "6",
            "en": "6"
          },
          {
            "id": "c",
            "zh-CN": "10",
            "en": "10"
          },
          {
            "id": "d",
            "zh-CN": "30",
            "en": "30"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "30。 DWL = ½ × 6 × 10 = 30 三角形公式需要线性曲线等假设，且政府收入并非全部损失。",
          "en": "30. DWL = ½ × 6 × 10 = 30 The triangle formula needs assumptions such as linear curves; government revenue is not entirely lost welfare."
        }
      },
      {
        "id": "u2-32-tax-welfare-calculation-short-1",
        "knowledgePointId": "u2-32-tax-welfare-calculation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释税补的福利计算的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Tax and subsidy welfare calculations and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "无外部性的线性竞争模型中，单位税减少有效交易并产生无谓损失；矩形税收收入是转移，不能与净社会损失混同。 税使数量由 Q0 降至 Qt；消失单位原有利益超过成本；三角形面积给出无谓损失 原创例：单位税 4，数量由 100 降到 80，线性曲线下无谓损失为 ½×4×20=40，税收为 4×80=320。若税纠正污染，此无外部性公式不能直接用来判断税的净福利效果。",
          "en": "In a linear competitive model without externalities, a per-unit tax removes beneficial trades and creates deadweight loss. Rectangular tax revenue is a transfer, not itself a net social loss. Tax lowers quantity from Q0 to Qt; lost units previously had benefit above cost; the triangle measures deadweight loss Illustrative example: tax is four and output falls from 100 to 80. With linear curves, DWL is ½×4×20=40 and revenue 4×80=320. If the tax corrects pollution, this no-externality formula cannot directly establish its net welfare effect."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "三角形",
              "en": "triangle"
            },
            "alternatives": {
              "zh-CN": [
                "三角形",
                "税使数量由 Q0 降至 Qt"
              ],
              "en": [
                "triangle",
                "Tax lowers quantity from Q0 to Qt"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "交易减少",
              "en": "lost trades"
            },
            "alternatives": {
              "zh-CN": [
                "交易减少",
                "消失单位原有利益超过成本"
              ],
              "en": [
                "lost trades",
                "lost units previously had benefit above cost"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "转移",
              "en": "transfer"
            },
            "alternatives": {
              "zh-CN": [
                "转移",
                "三角形面积给出无谓损失"
              ],
              "en": [
                "transfer",
                "the triangle measures deadweight loss"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-33-market-failure",
      "slug": "market-failure",
      "section": "2.8",
      "level": "core",
      "syllabusRefs": [
        "2.8 Externalities and common resources"
      ],
      "textbookRefs": [
        {
          "chapter": "5",
          "section": "5.2",
          "pages": [
            147
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency"
      ],
      "related": [
        "u2-34-negative-production",
        "u2-35-negative-consumption",
        "u2-36-positive-production"
      ],
      "terms": [
        "市场失灵与社会最优",
        "Market failure and the social optimum",
        "社会边际成本",
        "marginal social cost",
        "社会边际收益",
        "marginal social benefit",
        "配置效率",
        "allocative efficiency"
      ],
      "synonyms": {
        "zh-CN": [
          "社会边际成本",
          "社会边际收益",
          "配置效率"
        ],
        "en": [
          "marginal social cost",
          "marginal social benefit",
          "allocative efficiency"
        ]
      },
      "diagramIds": [
        "negative-production"
      ],
      "quizIds": [
        "u2-33-market-failure-flash-1",
        "u2-33-market-failure-mcq-1",
        "u2-33-market-failure-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-33-market-failure",
        "locale": "zh-CN",
        "title": "市场失灵与社会最优",
        "takeaway": "市场失灵是市场无法实现配置效率。社会最优数量满足社会边际收益 MSB 等于社会边际成本 MSC。",
        "definition": "市场失灵是市场无法实现配置效率。社会最优数量满足社会边际收益 MSB 等于社会边际成本 MSC。",
        "causalChain": [
          "私人决策只考虑私人收益与成本",
          "外部影响或制度缺陷使其偏离社会量",
          "市场数量与 MSB=MSC 数量不一致"
        ],
        "misconceptions": [
          "高价格或不平等本身不能单独证明配置失灵，需说明偏离效率的机制。"
        ],
        "examApplication": [
          "明确生产或消费、正或负，标出私人均衡和社会最优。"
        ],
        "summary": [
          "市场失灵是市场无法实现配置效率。社会最优数量满足社会边际收益 MSB 等于社会边际成本 MSC。",
          "高价格或不平等本身不能单独证明配置失灵，需说明偏离效率的机制。"
        ],
        "explanation": "私人决策只考虑私人收益与成本。外部影响或制度缺陷使其偏离社会量。市场数量与 MSB=MSC 数量不一致。\n\n### 原创情境与推导\n\n原创例：生产者多生产一单位获得 12 的收益，私人成本 9，但污染成本 5，使社会成本为 14。这一单位私人有利、社会净收益为负。应比较边际量，不是平均收益和平均成本。\n\n高价格或不平等本身不能单独证明配置失灵，需说明偏离效率的机制。\n\n明确生产或消费、正或负，标出私人均衡和社会最优。"
      },
      "en": {
        "id": "u2-33-market-failure",
        "locale": "en",
        "title": "Market failure and the social optimum",
        "takeaway": "Market failure occurs when a market does not achieve allocative efficiency. The socially optimal quantity satisfies marginal social benefit, MSB, equal to marginal social cost, MSC.",
        "definition": "Market failure occurs when a market does not achieve allocative efficiency. The socially optimal quantity satisfies marginal social benefit, MSB, equal to marginal social cost, MSC.",
        "causalChain": [
          "Private decisions consider private benefits and costs",
          "external effects or institutional failures separate them from social values",
          "market output differs from the MSB=MSC quantity"
        ],
        "misconceptions": [
          "A high price or inequality alone does not establish allocative failure; identify the mechanism producing inefficiency."
        ],
        "examApplication": [
          "Identify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
        ],
        "summary": [
          "Market failure occurs when a market does not achieve allocative efficiency. The socially optimal quantity satisfies marginal social benefit, MSB, equal to marginal social cost, MSC.",
          "A high price or inequality alone does not establish allocative failure; identify the mechanism producing inefficiency."
        ],
        "explanation": "Private decisions consider private benefits and costs.  external effects or institutional failures separate them from social values.  market output differs from the MSB=MSC quantity.\n\n### Original scenario and reasoning\n\nIllustrative example: one more unit yields benefit 12, private cost nine and external pollution cost five, making social cost 14. The unit is privately beneficial but socially harmful. Compare marginal values, not average benefits and costs.\n\nA high price or inequality alone does not establish allocative failure; identify the mechanism producing inefficiency.\n\nIdentify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
      }
    },
    "practice": [
      {
        "id": "u2-33-market-failure-flash-1",
        "knowledgePointId": "u2-33-market-failure",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“市场失灵与社会最优”，并说明一个关键条件。",
          "en": "Explain Market failure and the social optimum and state one important condition."
        },
        "answer": {
          "zh-CN": "市场失灵是市场无法实现配置效率。社会最优数量满足社会边际收益 MSB 等于社会边际成本 MSC。",
          "en": "Market failure occurs when a market does not achieve allocative efficiency. The socially optimal quantity satisfies marginal social benefit, MSB, equal to marginal social cost, MSC."
        },
        "explanation": {
          "zh-CN": "高价格或不平等本身不能单独证明配置失灵，需说明偏离效率的机制。",
          "en": "A high price or inequality alone does not establish allocative failure; identify the mechanism producing inefficiency."
        }
      },
      {
        "id": "u2-33-market-failure-mcq-1",
        "knowledgePointId": "u2-33-market-failure",
        "type": "mcq",
        "prompt": {
          "zh-CN": "社会最优的边际条件是什么？",
          "en": "What marginal condition defines the social optimum?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "MSB=MSC",
            "en": "MSB=MSC"
          },
          {
            "id": "b",
            "zh-CN": "总收入最大",
            "en": "Maximum total revenue"
          },
          {
            "id": "c",
            "zh-CN": "价格为零",
            "en": "Zero price"
          },
          {
            "id": "d",
            "zh-CN": "私人利润最大一定足够",
            "en": "Maximum private profit is always sufficient"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "MSB=MSC。 私人决策只考虑私人收益与成本；外部影响或制度缺陷使其偏离社会量；市场数量与 MSB=MSC 数量不一致 高价格或不平等本身不能单独证明配置失灵，需说明偏离效率的机制。",
          "en": "MSB=MSC. Private decisions consider private benefits and costs; external effects or institutional failures separate them from social values; market output differs from the MSB=MSC quantity A high price or inequality alone does not establish allocative failure; identify the mechanism producing inefficiency."
        }
      },
      {
        "id": "u2-33-market-failure-short-1",
        "knowledgePointId": "u2-33-market-failure",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释市场失灵与社会最优的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Market failure and the social optimum and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "市场失灵是市场无法实现配置效率。社会最优数量满足社会边际收益 MSB 等于社会边际成本 MSC。 私人决策只考虑私人收益与成本；外部影响或制度缺陷使其偏离社会量；市场数量与 MSB=MSC 数量不一致 原创例：生产者多生产一单位获得 12 的收益，私人成本 9，但污染成本 5，使社会成本为 14。这一单位私人有利、社会净收益为负。应比较边际量，不是平均收益和平均成本。",
          "en": "Market failure occurs when a market does not achieve allocative efficiency. The socially optimal quantity satisfies marginal social benefit, MSB, equal to marginal social cost, MSC. Private decisions consider private benefits and costs; external effects or institutional failures separate them from social values; market output differs from the MSB=MSC quantity Illustrative example: one more unit yields benefit 12, private cost nine and external pollution cost five, making social cost 14. The unit is privately beneficial but socially harmful. Compare marginal values, not average benefits and costs."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "社会边际成本",
              "en": "marginal social cost"
            },
            "alternatives": {
              "zh-CN": [
                "社会边际成本",
                "私人决策只考虑私人收益与成本"
              ],
              "en": [
                "marginal social cost",
                "Private decisions consider private benefits and costs"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "社会边际收益",
              "en": "marginal social benefit"
            },
            "alternatives": {
              "zh-CN": [
                "社会边际收益",
                "外部影响或制度缺陷使其偏离社会量"
              ],
              "en": [
                "marginal social benefit",
                "external effects or institutional failures separate them from social values"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "配置效率",
              "en": "allocative efficiency"
            },
            "alternatives": {
              "zh-CN": [
                "配置效率",
                "市场数量与 MSB=MSC 数量不一致"
              ],
              "en": [
                "allocative efficiency",
                "market output differs from the MSB=MSC quantity"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-34-negative-production",
      "slug": "negative-production",
      "section": "2.8",
      "level": "core",
      "syllabusRefs": [
        "2.8 Externalities and common resources"
      ],
      "textbookRefs": [
        {
          "chapter": "5",
          "section": "5.3",
          "pages": [
            150
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency"
      ],
      "related": [
        "u2-33-market-failure",
        "u2-35-negative-consumption",
        "u2-36-positive-production"
      ],
      "terms": [
        "负生产外部性",
        "Negative production externalities",
        "第三方",
        "third parties",
        "MSC",
        "MSC",
        "过度生产",
        "overproduction"
      ],
      "synonyms": {
        "zh-CN": [
          "第三方",
          "MSC",
          "过度生产"
        ],
        "en": [
          "third parties",
          "MSC",
          "overproduction"
        ]
      },
      "diagramIds": [
        "negative-production"
      ],
      "quizIds": [
        "u2-34-negative-production-flash-1",
        "u2-34-negative-production-mcq-1",
        "u2-34-negative-production-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-34-negative-production",
        "locale": "zh-CN",
        "title": "负生产外部性",
        "takeaway": "负生产外部性是生产给未获补偿的第三方造成成本，因而 MSC=MPC+外部边际成本，并高于私人边际成本。",
        "definition": "负生产外部性是生产给未获补偿的第三方造成成本，因而 MSC=MPC+外部边际成本，并高于私人边际成本。",
        "causalChain": [
          "生产造成第三方损害",
          "企业没有承担全部成本",
          "私人均衡产量高于社会最优"
        ],
        "misconceptions": [
          "将污染画成 MSB 低于 MPB 会混淆生产外部性和消费外部性。"
        ],
        "examApplication": [
          "明确生产或消费、正或负，标出私人均衡和社会最优。"
        ],
        "summary": [
          "负生产外部性是生产给未获补偿的第三方造成成本，因而 MSC=MPC+外部边际成本，并高于私人边际成本。",
          "将污染画成 MSB 低于 MPB 会混淆生产外部性和消费外部性。"
        ],
        "explanation": "生产造成第三方损害。企业没有承担全部成本。私人均衡产量高于社会最优。\n\n### 原创情境与推导\n\n原创例：工厂向河流排污使下游净水成本增加。画图时将 MSC 放在 MPC 上方，假定 MSB=MPB，以 MSC 与 MSB 相交确定 Q*。比较 Qm 与 Q* 之间社会成本超过收益的区域。\n\n将污染画成 MSB 低于 MPB 会混淆生产外部性和消费外部性。\n\n明确生产或消费、正或负，标出私人均衡和社会最优。"
      },
      "en": {
        "id": "u2-34-negative-production",
        "locale": "en",
        "title": "Negative production externalities",
        "takeaway": "A negative production externality imposes uncompensated costs on third parties. MSC equals MPC plus marginal external cost and exceeds private marginal cost.",
        "definition": "A negative production externality imposes uncompensated costs on third parties. MSC equals MPC plus marginal external cost and exceeds private marginal cost.",
        "causalChain": [
          "Production damages third parties",
          "firms do not bear the full cost",
          "private equilibrium output exceeds the social optimum"
        ],
        "misconceptions": [
          "Showing pollution as MSB below MPB confuses production and consumption externalities."
        ],
        "examApplication": [
          "Identify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
        ],
        "summary": [
          "A negative production externality imposes uncompensated costs on third parties. MSC equals MPC plus marginal external cost and exceeds private marginal cost.",
          "Showing pollution as MSB below MPB confuses production and consumption externalities."
        ],
        "explanation": "Production damages third parties.  firms do not bear the full cost.  private equilibrium output exceeds the social optimum.\n\n### Original scenario and reasoning\n\nIllustrative example: factory discharge raises downstream water-treatment costs. Draw MSC above MPC, assume MSB=MPB and locate Q* where MSC meets MSB. Between Q* and Qm, social costs exceed benefits.\n\nShowing pollution as MSB below MPB confuses production and consumption externalities.\n\nIdentify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
      }
    },
    "practice": [
      {
        "id": "u2-34-negative-production-flash-1",
        "knowledgePointId": "u2-34-negative-production",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“负生产外部性”，并说明一个关键条件。",
          "en": "Explain Negative production externalities and state one important condition."
        },
        "answer": {
          "zh-CN": "负生产外部性是生产给未获补偿的第三方造成成本，因而 MSC=MPC+外部边际成本，并高于私人边际成本。",
          "en": "A negative production externality imposes uncompensated costs on third parties. MSC equals MPC plus marginal external cost and exceeds private marginal cost."
        },
        "explanation": {
          "zh-CN": "将污染画成 MSB 低于 MPB 会混淆生产外部性和消费外部性。",
          "en": "Showing pollution as MSB below MPB confuses production and consumption externalities."
        }
      },
      {
        "id": "u2-34-negative-production-mcq-1",
        "knowledgePointId": "u2-34-negative-production",
        "type": "mcq",
        "prompt": {
          "zh-CN": "负生产外部性下，哪项关系成立？",
          "en": "With a negative production externality, which relationship holds?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "MSC<MPC",
            "en": "MSC<MPC"
          },
          {
            "id": "b",
            "zh-CN": "MSC>MPC",
            "en": "MSC>MPC"
          },
          {
            "id": "c",
            "zh-CN": "MSB 必然大于 MPB",
            "en": "MSB must exceed MPB"
          },
          {
            "id": "d",
            "zh-CN": "市场必然生产不足",
            "en": "The market necessarily underproduces"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "MSC>MPC。 生产造成第三方损害；企业没有承担全部成本；私人均衡产量高于社会最优 将污染画成 MSB 低于 MPB 会混淆生产外部性和消费外部性。",
          "en": "MSC>MPC. Production damages third parties; firms do not bear the full cost; private equilibrium output exceeds the social optimum Showing pollution as MSB below MPB confuses production and consumption externalities."
        }
      },
      {
        "id": "u2-34-negative-production-short-1",
        "knowledgePointId": "u2-34-negative-production",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释负生产外部性的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Negative production externalities and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "负生产外部性是生产给未获补偿的第三方造成成本，因而 MSC=MPC+外部边际成本，并高于私人边际成本。 生产造成第三方损害；企业没有承担全部成本；私人均衡产量高于社会最优 原创例：工厂向河流排污使下游净水成本增加。画图时将 MSC 放在 MPC 上方，假定 MSB=MPB，以 MSC 与 MSB 相交确定 Q*。比较 Qm 与 Q* 之间社会成本超过收益的区域。",
          "en": "A negative production externality imposes uncompensated costs on third parties. MSC equals MPC plus marginal external cost and exceeds private marginal cost. Production damages third parties; firms do not bear the full cost; private equilibrium output exceeds the social optimum Illustrative example: factory discharge raises downstream water-treatment costs. Draw MSC above MPC, assume MSB=MPB and locate Q* where MSC meets MSB. Between Q* and Qm, social costs exceed benefits."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "第三方",
              "en": "third parties"
            },
            "alternatives": {
              "zh-CN": [
                "第三方",
                "生产造成第三方损害"
              ],
              "en": [
                "third parties",
                "Production damages third parties"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "MSC",
              "en": "MSC"
            },
            "alternatives": {
              "zh-CN": [
                "MSC",
                "企业没有承担全部成本"
              ],
              "en": [
                "MSC",
                "firms do not bear the full cost"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "过度生产",
              "en": "overproduction"
            },
            "alternatives": {
              "zh-CN": [
                "过度生产",
                "私人均衡产量高于社会最优"
              ],
              "en": [
                "overproduction",
                "private equilibrium output exceeds the social optimum"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-35-negative-consumption",
      "slug": "negative-consumption",
      "section": "2.8",
      "level": "core",
      "syllabusRefs": [
        "2.8 Externalities and common resources"
      ],
      "textbookRefs": [
        {
          "chapter": "5",
          "section": "5.4",
          "pages": [
            164
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency"
      ],
      "related": [
        "u2-33-market-failure",
        "u2-34-negative-production",
        "u2-36-positive-production"
      ],
      "terms": [
        "负消费外部性",
        "Negative consumption externalities",
        "第三方",
        "third party",
        "MSB",
        "MSB",
        "过度消费",
        "overconsumption"
      ],
      "synonyms": {
        "zh-CN": [
          "第三方",
          "MSB",
          "过度消费"
        ],
        "en": [
          "third party",
          "MSB",
          "overconsumption"
        ]
      },
      "diagramIds": [
        "negative-consumption"
      ],
      "quizIds": [
        "u2-35-negative-consumption-flash-1",
        "u2-35-negative-consumption-mcq-1",
        "u2-35-negative-consumption-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-35-negative-consumption",
        "locale": "zh-CN",
        "title": "负消费外部性",
        "takeaway": "负消费外部性是消费给未获补偿的第三方造成成本，通常表现为 MSB=MPB−外部边际成本。",
        "definition": "负消费外部性是消费给未获补偿的第三方造成成本，通常表现为 MSB=MPB−外部边际成本。",
        "causalChain": [
          "消费者获得私人收益",
          "消费对他人造成损害",
          "社会边际收益低于私人收益并导致过度消费"
        ],
        "misconceptions": [
          "自身损害与第三方损害必须区分。"
        ],
        "examApplication": [
          "明确生产或消费、正或负，标出私人均衡和社会最优。"
        ],
        "summary": [
          "负消费外部性是消费给未获补偿的第三方造成成本，通常表现为 MSB=MPB−外部边际成本。",
          "自身损害与第三方损害必须区分。"
        ],
        "explanation": "消费者获得私人收益。消费对他人造成损害。社会边际收益低于私人收益并导致过度消费。\n\n### 原创情境与推导\n\n原创例：夜间高声播放音乐给邻居带来噪音损害。MSB 位于 MPB 下方，若没有生产外部性则 MSC=MPC。对本人健康的损害不是外部成本，但可涉及信息不足和不良品。\n\n自身损害与第三方损害必须区分。\n\n明确生产或消费、正或负，标出私人均衡和社会最优。"
      },
      "en": {
        "id": "u2-35-negative-consumption",
        "locale": "en",
        "title": "Negative consumption externalities",
        "takeaway": "A negative consumption externality imposes uncompensated costs on third parties and is normally represented by MSB equal to MPB minus marginal external cost.",
        "definition": "A negative consumption externality imposes uncompensated costs on third parties and is normally represented by MSB equal to MPB minus marginal external cost.",
        "causalChain": [
          "The consumer receives private benefit",
          "consumption harms others",
          "social marginal benefit lies below private benefit and consumption is excessive"
        ],
        "misconceptions": [
          "Distinguish harm to oneself from harm to third parties."
        ],
        "examApplication": [
          "Identify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
        ],
        "summary": [
          "A negative consumption externality imposes uncompensated costs on third parties and is normally represented by MSB equal to MPB minus marginal external cost.",
          "Distinguish harm to oneself from harm to third parties."
        ],
        "explanation": "The consumer receives private benefit.  consumption harms others.  social marginal benefit lies below private benefit and consumption is excessive.\n\n### Original scenario and reasoning\n\nIllustrative example: loud night-time music disturbs neighbours. MSB lies below MPB; without production externalities MSC=MPC. Harm to the consumer's own health is not an external cost, although it may involve imperfect information and demerit goods.\n\nDistinguish harm to oneself from harm to third parties.\n\nIdentify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
      }
    },
    "practice": [
      {
        "id": "u2-35-negative-consumption-flash-1",
        "knowledgePointId": "u2-35-negative-consumption",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“负消费外部性”，并说明一个关键条件。",
          "en": "Explain Negative consumption externalities and state one important condition."
        },
        "answer": {
          "zh-CN": "负消费外部性是消费给未获补偿的第三方造成成本，通常表现为 MSB=MPB−外部边际成本。",
          "en": "A negative consumption externality imposes uncompensated costs on third parties and is normally represented by MSB equal to MPB minus marginal external cost."
        },
        "explanation": {
          "zh-CN": "自身损害与第三方损害必须区分。",
          "en": "Distinguish harm to oneself from harm to third parties."
        }
      },
      {
        "id": "u2-35-negative-consumption-mcq-1",
        "knowledgePointId": "u2-35-negative-consumption",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪项最清楚属于负消费外部性？",
          "en": "Which most clearly represents a negative consumption externality?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "工厂支付自己的电费",
            "en": "A factory pays its own electricity bill"
          },
          {
            "id": "b",
            "zh-CN": "本人支付商品价格",
            "en": "The buyer pays the product price"
          },
          {
            "id": "c",
            "zh-CN": "邻居被消费噪音打扰",
            "en": "Neighbours disturbed by consumption noise"
          },
          {
            "id": "d",
            "zh-CN": "学习提高本人工资",
            "en": "Study raises the student's own wages"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "邻居被消费噪音打扰。 消费者获得私人收益；消费对他人造成损害；社会边际收益低于私人收益并导致过度消费 自身损害与第三方损害必须区分。",
          "en": "Neighbours disturbed by consumption noise. The consumer receives private benefit; consumption harms others; social marginal benefit lies below private benefit and consumption is excessive Distinguish harm to oneself from harm to third parties."
        }
      },
      {
        "id": "u2-35-negative-consumption-short-1",
        "knowledgePointId": "u2-35-negative-consumption",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释负消费外部性的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Negative consumption externalities and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "负消费外部性是消费给未获补偿的第三方造成成本，通常表现为 MSB=MPB−外部边际成本。 消费者获得私人收益；消费对他人造成损害；社会边际收益低于私人收益并导致过度消费 原创例：夜间高声播放音乐给邻居带来噪音损害。MSB 位于 MPB 下方，若没有生产外部性则 MSC=MPC。对本人健康的损害不是外部成本，但可涉及信息不足和不良品。",
          "en": "A negative consumption externality imposes uncompensated costs on third parties and is normally represented by MSB equal to MPB minus marginal external cost. The consumer receives private benefit; consumption harms others; social marginal benefit lies below private benefit and consumption is excessive Illustrative example: loud night-time music disturbs neighbours. MSB lies below MPB; without production externalities MSC=MPC. Harm to the consumer's own health is not an external cost, although it may involve imperfect information and demerit goods."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "第三方",
              "en": "third party"
            },
            "alternatives": {
              "zh-CN": [
                "第三方",
                "消费者获得私人收益"
              ],
              "en": [
                "third party",
                "The consumer receives private benefit"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "MSB",
              "en": "MSB"
            },
            "alternatives": {
              "zh-CN": [
                "MSB",
                "消费对他人造成损害"
              ],
              "en": [
                "MSB",
                "consumption harms others"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "过度消费",
              "en": "overconsumption"
            },
            "alternatives": {
              "zh-CN": [
                "过度消费",
                "社会边际收益低于私人收益并导致过度消费"
              ],
              "en": [
                "overconsumption",
                "social marginal benefit lies below private benefit and consumption is excessive"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-36-positive-production",
      "slug": "positive-production",
      "section": "2.8",
      "level": "core",
      "syllabusRefs": [
        "2.8 Externalities and common resources"
      ],
      "textbookRefs": [
        {
          "chapter": "6",
          "section": "6.1",
          "pages": [
            174
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency"
      ],
      "related": [
        "u2-33-market-failure",
        "u2-34-negative-production",
        "u2-35-negative-consumption"
      ],
      "terms": [
        "正生产外部性",
        "Positive production externalities",
        "外溢",
        "spillover",
        "MSC",
        "MSC",
        "生产不足",
        "underproduction"
      ],
      "synonyms": {
        "zh-CN": [
          "外溢",
          "MSC",
          "生产不足"
        ],
        "en": [
          "spillover",
          "MSC",
          "underproduction"
        ]
      },
      "diagramIds": [
        "positive-production"
      ],
      "quizIds": [
        "u2-36-positive-production-flash-1",
        "u2-36-positive-production-mcq-1",
        "u2-36-positive-production-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-36-positive-production",
        "locale": "zh-CN",
        "title": "正生产外部性",
        "takeaway": "正生产外部性是生产使第三方获益且未获补偿，通常表示为 MSC=MPC−外部边际收益。",
        "definition": "正生产外部性是生产使第三方获益且未获补偿，通常表示为 MSC=MPC−外部边际收益。",
        "causalChain": [
          "生产产生知识等外溢",
          "企业不能收回全部社会收益",
          "市场配置资源不足"
        ],
        "misconceptions": [
          "正外部性不是企业自身销售收益，而是未计价的第三方收益。"
        ],
        "examApplication": [
          "明确生产或消费、正或负，标出私人均衡和社会最优。"
        ],
        "summary": [
          "正生产外部性是生产使第三方获益且未获补偿，通常表示为 MSC=MPC−外部边际收益。",
          "正外部性不是企业自身销售收益，而是未计价的第三方收益。"
        ],
        "explanation": "生产产生知识等外溢。企业不能收回全部社会收益。市场配置资源不足。\n\n### 原创情境与推导\n\n原创例：企业研发改善生产方法，知识外溢让其他企业降低成本。MSC 可画在 MPC 下方，以同一 MSB 与两条成本曲线确定社会和私人数量。专利与研发补贴可能增强激励，但应考虑垄断代价和补贴针对性。\n\n正外部性不是企业自身销售收益，而是未计价的第三方收益。\n\n明确生产或消费、正或负，标出私人均衡和社会最优。"
      },
      "en": {
        "id": "u2-36-positive-production",
        "locale": "en",
        "title": "Positive production externalities",
        "takeaway": "A positive production externality benefits third parties without compensation and is normally shown as MSC equal to MPC minus marginal external benefit.",
        "definition": "A positive production externality benefits third parties without compensation and is normally shown as MSC equal to MPC minus marginal external benefit.",
        "causalChain": [
          "Production creates spillovers such as knowledge",
          "firms cannot capture all social gains",
          "the market allocates too few resources"
        ],
        "misconceptions": [
          "The external benefit is an unpriced gain to third parties, not the firm's own sales revenue."
        ],
        "examApplication": [
          "Identify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
        ],
        "summary": [
          "A positive production externality benefits third parties without compensation and is normally shown as MSC equal to MPC minus marginal external benefit.",
          "The external benefit is an unpriced gain to third parties, not the firm's own sales revenue."
        ],
        "explanation": "Production creates spillovers such as knowledge.  firms cannot capture all social gains.  the market allocates too few resources.\n\n### Original scenario and reasoning\n\nIllustrative example: a firm's research generates knowledge that lowers other firms' costs. Draw MSC below MPC and use the same MSB to locate social and private output. Patents or research subsidies can strengthen incentives, but market-power costs and targeting matter.\n\nThe external benefit is an unpriced gain to third parties, not the firm's own sales revenue.\n\nIdentify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
      }
    },
    "practice": [
      {
        "id": "u2-36-positive-production-flash-1",
        "knowledgePointId": "u2-36-positive-production",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“正生产外部性”，并说明一个关键条件。",
          "en": "Explain Positive production externalities and state one important condition."
        },
        "answer": {
          "zh-CN": "正生产外部性是生产使第三方获益且未获补偿，通常表示为 MSC=MPC−外部边际收益。",
          "en": "A positive production externality benefits third parties without compensation and is normally shown as MSC equal to MPC minus marginal external benefit."
        },
        "explanation": {
          "zh-CN": "正外部性不是企业自身销售收益，而是未计价的第三方收益。",
          "en": "The external benefit is an unpriced gain to third parties, not the firm's own sales revenue."
        }
      },
      {
        "id": "u2-36-positive-production-mcq-1",
        "knowledgePointId": "u2-36-positive-production",
        "type": "mcq",
        "prompt": {
          "zh-CN": "正生产外部性通常意味着什么？",
          "en": "A positive production externality normally implies what?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "市场过度生产",
            "en": "Market overproduction"
          },
          {
            "id": "b",
            "zh-CN": "没有任何成本",
            "en": "No costs exist"
          },
          {
            "id": "c",
            "zh-CN": "所有收益都归生产者",
            "en": "All benefits accrue to producers"
          },
          {
            "id": "d",
            "zh-CN": "市场生产不足",
            "en": "Market underproduction"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "市场生产不足。 生产产生知识等外溢；企业不能收回全部社会收益；市场配置资源不足 正外部性不是企业自身销售收益，而是未计价的第三方收益。",
          "en": "Market underproduction. Production creates spillovers such as knowledge; firms cannot capture all social gains; the market allocates too few resources The external benefit is an unpriced gain to third parties, not the firm's own sales revenue."
        }
      },
      {
        "id": "u2-36-positive-production-short-1",
        "knowledgePointId": "u2-36-positive-production",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释正生产外部性的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Positive production externalities and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "正生产外部性是生产使第三方获益且未获补偿，通常表示为 MSC=MPC−外部边际收益。 生产产生知识等外溢；企业不能收回全部社会收益；市场配置资源不足 原创例：企业研发改善生产方法，知识外溢让其他企业降低成本。MSC 可画在 MPC 下方，以同一 MSB 与两条成本曲线确定社会和私人数量。专利与研发补贴可能增强激励，但应考虑垄断代价和补贴针对性。",
          "en": "A positive production externality benefits third parties without compensation and is normally shown as MSC equal to MPC minus marginal external benefit. Production creates spillovers such as knowledge; firms cannot capture all social gains; the market allocates too few resources Illustrative example: a firm's research generates knowledge that lowers other firms' costs. Draw MSC below MPC and use the same MSB to locate social and private output. Patents or research subsidies can strengthen incentives, but market-power costs and targeting matter."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "外溢",
              "en": "spillover"
            },
            "alternatives": {
              "zh-CN": [
                "外溢",
                "生产产生知识等外溢"
              ],
              "en": [
                "spillover",
                "Production creates spillovers such as knowledge"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "MSC",
              "en": "MSC"
            },
            "alternatives": {
              "zh-CN": [
                "MSC",
                "企业不能收回全部社会收益"
              ],
              "en": [
                "MSC",
                "firms cannot capture all social gains"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "生产不足",
              "en": "underproduction"
            },
            "alternatives": {
              "zh-CN": [
                "生产不足",
                "市场配置资源不足"
              ],
              "en": [
                "underproduction",
                "the market allocates too few resources"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-37-positive-consumption",
      "slug": "positive-consumption",
      "section": "2.8",
      "level": "core",
      "syllabusRefs": [
        "2.8 Externalities and common resources"
      ],
      "textbookRefs": [
        {
          "chapter": "6",
          "section": "6.2",
          "pages": [
            177
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency"
      ],
      "related": [
        "u2-33-market-failure",
        "u2-34-negative-production",
        "u2-35-negative-consumption"
      ],
      "terms": [
        "正消费外部性与优值品",
        "Positive consumption externalities and merit goods",
        "第三方收益",
        "external benefit",
        "MSB",
        "MSB",
        "消费不足",
        "underconsumption"
      ],
      "synonyms": {
        "zh-CN": [
          "第三方收益",
          "MSB",
          "消费不足"
        ],
        "en": [
          "external benefit",
          "MSB",
          "underconsumption"
        ]
      },
      "diagramIds": [
        "positive-consumption"
      ],
      "quizIds": [
        "u2-37-positive-consumption-flash-1",
        "u2-37-positive-consumption-mcq-1",
        "u2-37-positive-consumption-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-37-positive-consumption",
        "locale": "zh-CN",
        "title": "正消费外部性与优值品",
        "takeaway": "正消费外部性使第三方获益，MSB 高于 MPB；优值品可能因消费者低估其私人收益而消费不足，两种概念可重叠但并不相同。",
        "definition": "正消费外部性使第三方获益，MSB 高于 MPB；优值品可能因消费者低估其私人收益而消费不足，两种概念可重叠但并不相同。",
        "causalChain": [
          "消费者只比较私人收益与价格",
          "第三方收益未进入其选择",
          "市场数量低于社会最优"
        ],
        "misconceptions": [
          "教育或医疗并不是因为有社会价值就自动成为纯公共物品。"
        ],
        "examApplication": [
          "明确生产或消费、正或负，标出私人均衡和社会最优。"
        ],
        "summary": [
          "正消费外部性使第三方获益，MSB 高于 MPB；优值品可能因消费者低估其私人收益而消费不足，两种概念可重叠但并不相同。",
          "教育或医疗并不是因为有社会价值就自动成为纯公共物品。"
        ],
        "explanation": "消费者只比较私人收益与价格。第三方收益未进入其选择。市场数量低于社会最优。\n\n### 原创情境与推导\n\n原创例：接种疫苗可能降低传染风险，使他人受益。MSB 画在 MPB 上方。补贴、公共提供和信息宣传可提高数量，但政策效果取决于接种能力、信任和第三方收益的大小。\n\n教育或医疗并不是因为有社会价值就自动成为纯公共物品。\n\n明确生产或消费、正或负，标出私人均衡和社会最优。"
      },
      "en": {
        "id": "u2-37-positive-consumption",
        "locale": "en",
        "title": "Positive consumption externalities and merit goods",
        "takeaway": "A positive consumption externality benefits third parties, so MSB exceeds MPB. A merit good may be underconsumed because buyers underestimate private benefits; these concepts may overlap but are distinct.",
        "definition": "A positive consumption externality benefits third parties, so MSB exceeds MPB. A merit good may be underconsumed because buyers underestimate private benefits; these concepts may overlap but are distinct.",
        "causalChain": [
          "Consumers compare private benefit and price",
          "third-party gains are absent from their choice",
          "market consumption is below the social optimum"
        ],
        "misconceptions": [
          "Education or healthcare does not automatically become a pure public good because it has social value."
        ],
        "examApplication": [
          "Identify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
        ],
        "summary": [
          "A positive consumption externality benefits third parties, so MSB exceeds MPB. A merit good may be underconsumed because buyers underestimate private benefits; these concepts may overlap but are distinct.",
          "Education or healthcare does not automatically become a pure public good because it has social value."
        ],
        "explanation": "Consumers compare private benefit and price.  third-party gains are absent from their choice.  market consumption is below the social optimum.\n\n### Original scenario and reasoning\n\nIllustrative example: vaccination may reduce transmission risk and benefit others. Draw MSB above MPB. Subsidies, public provision and information can increase uptake, but capacity, trust and the size of external benefit determine effectiveness.\n\nEducation or healthcare does not automatically become a pure public good because it has social value.\n\nIdentify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
      }
    },
    "practice": [
      {
        "id": "u2-37-positive-consumption-flash-1",
        "knowledgePointId": "u2-37-positive-consumption",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“正消费外部性与优值品”，并说明一个关键条件。",
          "en": "Explain Positive consumption externalities and merit goods and state one important condition."
        },
        "answer": {
          "zh-CN": "正消费外部性使第三方获益，MSB 高于 MPB；优值品可能因消费者低估其私人收益而消费不足，两种概念可重叠但并不相同。",
          "en": "A positive consumption externality benefits third parties, so MSB exceeds MPB. A merit good may be underconsumed because buyers underestimate private benefits; these concepts may overlap but are distinct."
        },
        "explanation": {
          "zh-CN": "教育或医疗并不是因为有社会价值就自动成为纯公共物品。",
          "en": "Education or healthcare does not automatically become a pure public good because it has social value."
        }
      },
      {
        "id": "u2-37-positive-consumption-mcq-1",
        "knowledgePointId": "u2-37-positive-consumption",
        "type": "mcq",
        "prompt": {
          "zh-CN": "正消费外部性的图中哪项成立？",
          "en": "Which holds in a positive consumption externality diagram?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "MSB>MPB",
            "en": "MSB>MPB"
          },
          {
            "id": "b",
            "zh-CN": "MSB<MPB",
            "en": "MSB<MPB"
          },
          {
            "id": "c",
            "zh-CN": "MSC 必然为零",
            "en": "MSC must be zero"
          },
          {
            "id": "d",
            "zh-CN": "市场数量一定过多",
            "en": "Market output must be excessive"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "MSB>MPB。 消费者只比较私人收益与价格；第三方收益未进入其选择；市场数量低于社会最优 教育或医疗并不是因为有社会价值就自动成为纯公共物品。",
          "en": "MSB>MPB. Consumers compare private benefit and price; third-party gains are absent from their choice; market consumption is below the social optimum Education or healthcare does not automatically become a pure public good because it has social value."
        }
      },
      {
        "id": "u2-37-positive-consumption-short-1",
        "knowledgePointId": "u2-37-positive-consumption",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释正消费外部性与优值品的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Positive consumption externalities and merit goods and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "正消费外部性使第三方获益，MSB 高于 MPB；优值品可能因消费者低估其私人收益而消费不足，两种概念可重叠但并不相同。 消费者只比较私人收益与价格；第三方收益未进入其选择；市场数量低于社会最优 原创例：接种疫苗可能降低传染风险，使他人受益。MSB 画在 MPB 上方。补贴、公共提供和信息宣传可提高数量，但政策效果取决于接种能力、信任和第三方收益的大小。",
          "en": "A positive consumption externality benefits third parties, so MSB exceeds MPB. A merit good may be underconsumed because buyers underestimate private benefits; these concepts may overlap but are distinct. Consumers compare private benefit and price; third-party gains are absent from their choice; market consumption is below the social optimum Illustrative example: vaccination may reduce transmission risk and benefit others. Draw MSB above MPB. Subsidies, public provision and information can increase uptake, but capacity, trust and the size of external benefit determine effectiveness."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "第三方收益",
              "en": "external benefit"
            },
            "alternatives": {
              "zh-CN": [
                "第三方收益",
                "消费者只比较私人收益与价格"
              ],
              "en": [
                "external benefit",
                "Consumers compare private benefit and price"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "MSB",
              "en": "MSB"
            },
            "alternatives": {
              "zh-CN": [
                "MSB",
                "第三方收益未进入其选择"
              ],
              "en": [
                "MSB",
                "third-party gains are absent from their choice"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "消费不足",
              "en": "underconsumption"
            },
            "alternatives": {
              "zh-CN": [
                "消费不足",
                "市场数量低于社会最优"
              ],
              "en": [
                "underconsumption",
                "market consumption is below the social optimum"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-38-common-resources",
      "slug": "common-resources",
      "section": "2.8",
      "level": "core",
      "syllabusRefs": [
        "2.8 Externalities and common resources"
      ],
      "textbookRefs": [
        {
          "chapter": "5",
          "section": "5.1",
          "pages": [
            144
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency"
      ],
      "related": [
        "u2-33-market-failure",
        "u2-34-negative-production",
        "u2-35-negative-consumption"
      ],
      "terms": [
        "共同资源与公地悲剧",
        "Common resources and the tragedy of the commons",
        "竞争性",
        "rival",
        "排他",
        "exclusion",
        "过度开采",
        "overexploitation"
      ],
      "synonyms": {
        "zh-CN": [
          "竞争性",
          "排他",
          "过度开采"
        ],
        "en": [
          "rival",
          "exclusion",
          "overexploitation"
        ]
      },
      "diagramIds": [
        "goods-matrix"
      ],
      "quizIds": [
        "u2-38-common-resources-flash-1",
        "u2-38-common-resources-mcq-1",
        "u2-38-common-resources-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-38-common-resources",
        "locale": "zh-CN",
        "title": "共同资源与公地悲剧",
        "takeaway": "共同资源具有竞争性且难以排他；个人使用会减少他人可用数量，而难以排除使用者可导致过度开采。",
        "definition": "共同资源具有竞争性且难以排他；个人使用会减少他人可用数量，而难以排除使用者可导致过度开采。",
        "causalChain": [
          "使用者获得私人收益",
          "资源耗减成本由群体承担",
          "缺少协调时开采量超过可持续水平"
        ],
        "misconceptions": [
          "公地悲剧不是不可避免的自然定律；有效社区规则可以改变激励。"
        ],
        "examApplication": [
          "明确生产或消费、正或负，标出私人均衡和社会最优。"
        ],
        "summary": [
          "共同资源具有竞争性且难以排他；个人使用会减少他人可用数量，而难以排除使用者可导致过度开采。",
          "公地悲剧不是不可避免的自然定律；有效社区规则可以改变激励。"
        ],
        "explanation": "使用者获得私人收益。资源耗减成本由群体承担。缺少协调时开采量超过可持续水平。\n\n### 原创情境与推导\n\n原创例：渔民多捕鱼获得收益，却减少未来所有人的鱼群。捕捞配额、可执行产权或社区管理可限制开采。把共同资源称为非竞争物品会遗漏这一核心机制。\n\n公地悲剧不是不可避免的自然定律；有效社区规则可以改变激励。\n\n明确生产或消费、正或负，标出私人均衡和社会最优。"
      },
      "en": {
        "id": "u2-38-common-resources",
        "locale": "en",
        "title": "Common resources and the tragedy of the commons",
        "takeaway": "Common resources are rival and difficult to exclude users from. Individual use reduces availability to others, and weak exclusion can lead to overexploitation.",
        "definition": "Common resources are rival and difficult to exclude users from. Individual use reduces availability to others, and weak exclusion can lead to overexploitation.",
        "causalChain": [
          "Users receive private gains",
          "depletion costs are shared",
          "without coordination extraction exceeds a sustainable level"
        ],
        "misconceptions": [
          "The tragedy is not an unavoidable law of nature; effective community rules can change incentives."
        ],
        "examApplication": [
          "Identify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
        ],
        "summary": [
          "Common resources are rival and difficult to exclude users from. Individual use reduces availability to others, and weak exclusion can lead to overexploitation.",
          "The tragedy is not an unavoidable law of nature; effective community rules can change incentives."
        ],
        "explanation": "Users receive private gains.  depletion costs are shared.  without coordination extraction exceeds a sustainable level.\n\n### Original scenario and reasoning\n\nIllustrative example: a fisher earns from an extra catch while reducing future fish stocks available to everyone. Quotas, enforceable rights or community management can limit extraction. Calling the resource non-rival would miss the central mechanism.\n\nThe tragedy is not an unavoidable law of nature; effective community rules can change incentives.\n\nIdentify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
      }
    },
    "practice": [
      {
        "id": "u2-38-common-resources-flash-1",
        "knowledgePointId": "u2-38-common-resources",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“共同资源与公地悲剧”，并说明一个关键条件。",
          "en": "Explain Common resources and the tragedy of the commons and state one important condition."
        },
        "answer": {
          "zh-CN": "共同资源具有竞争性且难以排他；个人使用会减少他人可用数量，而难以排除使用者可导致过度开采。",
          "en": "Common resources are rival and difficult to exclude users from. Individual use reduces availability to others, and weak exclusion can lead to overexploitation."
        },
        "explanation": {
          "zh-CN": "公地悲剧不是不可避免的自然定律；有效社区规则可以改变激励。",
          "en": "The tragedy is not an unavoidable law of nature; effective community rules can change incentives."
        }
      },
      {
        "id": "u2-38-common-resources-mcq-1",
        "knowledgePointId": "u2-38-common-resources",
        "type": "mcq",
        "prompt": {
          "zh-CN": "共同资源的典型特征是什么？",
          "en": "What are the typical characteristics of a common resource?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "非竞争、非排他",
            "en": "Non-rival, non-excludable"
          },
          {
            "id": "b",
            "zh-CN": "竞争性、难以排他",
            "en": "Rival, difficult to exclude"
          },
          {
            "id": "c",
            "zh-CN": "非竞争、可排他",
            "en": "Non-rival, excludable"
          },
          {
            "id": "d",
            "zh-CN": "无成本且无限",
            "en": "Costless and unlimited"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "竞争性、难以排他。 使用者获得私人收益；资源耗减成本由群体承担；缺少协调时开采量超过可持续水平 公地悲剧不是不可避免的自然定律；有效社区规则可以改变激励。",
          "en": "Rival, difficult to exclude. Users receive private gains; depletion costs are shared; without coordination extraction exceeds a sustainable level The tragedy is not an unavoidable law of nature; effective community rules can change incentives."
        }
      },
      {
        "id": "u2-38-common-resources-short-1",
        "knowledgePointId": "u2-38-common-resources",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释共同资源与公地悲剧的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Common resources and the tragedy of the commons and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "共同资源具有竞争性且难以排他；个人使用会减少他人可用数量，而难以排除使用者可导致过度开采。 使用者获得私人收益；资源耗减成本由群体承担；缺少协调时开采量超过可持续水平 原创例：渔民多捕鱼获得收益，却减少未来所有人的鱼群。捕捞配额、可执行产权或社区管理可限制开采。把共同资源称为非竞争物品会遗漏这一核心机制。",
          "en": "Common resources are rival and difficult to exclude users from. Individual use reduces availability to others, and weak exclusion can lead to overexploitation. Users receive private gains; depletion costs are shared; without coordination extraction exceeds a sustainable level Illustrative example: a fisher earns from an extra catch while reducing future fish stocks available to everyone. Quotas, enforceable rights or community management can limit extraction. Calling the resource non-rival would miss the central mechanism."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "竞争性",
              "en": "rival"
            },
            "alternatives": {
              "zh-CN": [
                "竞争性",
                "使用者获得私人收益"
              ],
              "en": [
                "rival",
                "Users receive private gains"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "排他",
              "en": "exclusion"
            },
            "alternatives": {
              "zh-CN": [
                "排他",
                "资源耗减成本由群体承担"
              ],
              "en": [
                "exclusion",
                "depletion costs are shared"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "过度开采",
              "en": "overexploitation"
            },
            "alternatives": {
              "zh-CN": [
                "过度开采",
                "缺少协调时开采量超过可持续水平"
              ],
              "en": [
                "overexploitation",
                "without coordination extraction exceeds a sustainable level"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-39-externality-policies",
      "slug": "externality-policies",
      "section": "2.8",
      "level": "core",
      "syllabusRefs": [
        "2.8 Externalities and common resources"
      ],
      "textbookRefs": [
        {
          "chapter": "5",
          "section": "5.3",
          "pages": [
            154
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency"
      ],
      "related": [
        "u2-33-market-failure",
        "u2-34-negative-production",
        "u2-35-negative-consumption"
      ],
      "terms": [
        "外部性政策与可持续性",
        "Externality policies and sustainability",
        "内部化",
        "internalise",
        "监测",
        "monitoring",
        "可持续",
        "sustainable"
      ],
      "synonyms": {
        "zh-CN": [
          "内部化",
          "监测",
          "可持续"
        ],
        "en": [
          "internalise",
          "monitoring",
          "sustainable"
        ]
      },
      "diagramIds": [
        "negative-production"
      ],
      "quizIds": [
        "u2-39-externality-policies-flash-1",
        "u2-39-externality-policies-mcq-1",
        "u2-39-externality-policies-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-39-externality-policies",
        "locale": "zh-CN",
        "title": "外部性政策与可持续性",
        "takeaway": "税、补贴、法规、交易许可和产权安排可以将外部影响纳入私人决策；政策选择取决于信息、执行成本和分配影响。",
        "definition": "税、补贴、法规、交易许可和产权安排可以将外部影响纳入私人决策；政策选择取决于信息、执行成本和分配影响。",
        "causalChain": [
          "识别未计价的社会影响",
          "调整价格或数量约束",
          "比较纠正效果与执行和分配成本"
        ],
        "misconceptions": [
          "纠正外部性未必消除全部污染；最优并不总是零排放。"
        ],
        "examApplication": [
          "明确生产或消费、正或负，标出私人均衡和社会最优。"
        ],
        "summary": [
          "税、补贴、法规、交易许可和产权安排可以将外部影响纳入私人决策；政策选择取决于信息、执行成本和分配影响。",
          "纠正外部性未必消除全部污染；最优并不总是零排放。"
        ],
        "explanation": "识别未计价的社会影响。调整价格或数量约束。比较纠正效果与执行和分配成本。\n\n### 原创情境与推导\n\n原创例：排放税固定每单位排放的价格，排放许可固定允许的总量。税需要了解损害与减排反应，许可需要监测、合理总量和可靠交易。两者都可能把部分成本传给消费者。\n\n纠正外部性未必消除全部污染；最优并不总是零排放。\n\n明确生产或消费、正或负，标出私人均衡和社会最优。"
      },
      "en": {
        "id": "u2-39-externality-policies",
        "locale": "en",
        "title": "Externality policies and sustainability",
        "takeaway": "Taxes, subsidies, regulation, tradable permits and rights can incorporate external effects into private decisions. The choice depends on information, enforcement cost and distribution.",
        "definition": "Taxes, subsidies, regulation, tradable permits and rights can incorporate external effects into private decisions. The choice depends on information, enforcement cost and distribution.",
        "causalChain": [
          "Identify unpriced social effects",
          "adjust prices or quantity constraints",
          "compare correction with enforcement and distribution costs"
        ],
        "misconceptions": [
          "Correction need not eliminate all pollution; the optimum is not always zero emissions."
        ],
        "examApplication": [
          "Identify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
        ],
        "summary": [
          "Taxes, subsidies, regulation, tradable permits and rights can incorporate external effects into private decisions. The choice depends on information, enforcement cost and distribution.",
          "Correction need not eliminate all pollution; the optimum is not always zero emissions."
        ],
        "explanation": "Identify unpriced social effects.  adjust prices or quantity constraints.  compare correction with enforcement and distribution costs.\n\n### Original scenario and reasoning\n\nIllustrative example: an emissions tax fixes the price per emission unit, while permits fix the allowed total quantity. Taxes need information about harm and abatement response; permits need monitoring, a sound cap and reliable trading. Both may pass some costs to consumers.\n\nCorrection need not eliminate all pollution; the optimum is not always zero emissions.\n\nIdentify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
      }
    },
    "practice": [
      {
        "id": "u2-39-externality-policies-flash-1",
        "knowledgePointId": "u2-39-externality-policies",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“外部性政策与可持续性”，并说明一个关键条件。",
          "en": "Explain Externality policies and sustainability and state one important condition."
        },
        "answer": {
          "zh-CN": "税、补贴、法规、交易许可和产权安排可以将外部影响纳入私人决策；政策选择取决于信息、执行成本和分配影响。",
          "en": "Taxes, subsidies, regulation, tradable permits and rights can incorporate external effects into private decisions. The choice depends on information, enforcement cost and distribution."
        },
        "explanation": {
          "zh-CN": "纠正外部性未必消除全部污染；最优并不总是零排放。",
          "en": "Correction need not eliminate all pollution; the optimum is not always zero emissions."
        }
      },
      {
        "id": "u2-39-externality-policies-mcq-1",
        "knowledgePointId": "u2-39-externality-policies",
        "type": "mcq",
        "prompt": {
          "zh-CN": "交易许可与排放税的关键区别是什么？",
          "en": "What is a key difference between permits and an emissions tax?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "两者都不需要监测",
            "en": "Neither requires monitoring"
          },
          {
            "id": "b",
            "zh-CN": "税一定消除排放",
            "en": "Tax necessarily eliminates emissions"
          },
          {
            "id": "c",
            "zh-CN": "许可确定总量，税确定单位价格",
            "en": "Permits fix the total cap; tax fixes the unit price"
          },
          {
            "id": "d",
            "zh-CN": "许可完全没有成本",
            "en": "Permits have no costs"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "许可确定总量，税确定单位价格。 识别未计价的社会影响；调整价格或数量约束；比较纠正效果与执行和分配成本 纠正外部性未必消除全部污染；最优并不总是零排放。",
          "en": "Permits fix the total cap; tax fixes the unit price. Identify unpriced social effects; adjust prices or quantity constraints; compare correction with enforcement and distribution costs Correction need not eliminate all pollution; the optimum is not always zero emissions."
        }
      },
      {
        "id": "u2-39-externality-policies-short-1",
        "knowledgePointId": "u2-39-externality-policies",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释外部性政策与可持续性的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Externality policies and sustainability and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "税、补贴、法规、交易许可和产权安排可以将外部影响纳入私人决策；政策选择取决于信息、执行成本和分配影响。 识别未计价的社会影响；调整价格或数量约束；比较纠正效果与执行和分配成本 原创例：排放税固定每单位排放的价格，排放许可固定允许的总量。税需要了解损害与减排反应，许可需要监测、合理总量和可靠交易。两者都可能把部分成本传给消费者。",
          "en": "Taxes, subsidies, regulation, tradable permits and rights can incorporate external effects into private decisions. The choice depends on information, enforcement cost and distribution. Identify unpriced social effects; adjust prices or quantity constraints; compare correction with enforcement and distribution costs Illustrative example: an emissions tax fixes the price per emission unit, while permits fix the allowed total quantity. Taxes need information about harm and abatement response; permits need monitoring, a sound cap and reliable trading. Both may pass some costs to consumers."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "内部化",
              "en": "internalise"
            },
            "alternatives": {
              "zh-CN": [
                "内部化",
                "识别未计价的社会影响"
              ],
              "en": [
                "internalise",
                "Identify unpriced social effects"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "监测",
              "en": "monitoring"
            },
            "alternatives": {
              "zh-CN": [
                "监测",
                "调整价格或数量约束"
              ],
              "en": [
                "monitoring",
                "adjust prices or quantity constraints"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "可持续",
              "en": "sustainable"
            },
            "alternatives": {
              "zh-CN": [
                "可持续",
                "比较纠正效果与执行和分配成本"
              ],
              "en": [
                "sustainable",
                "compare correction with enforcement and distribution costs"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-40-external-welfare",
      "slug": "external-welfare",
      "section": "2.8",
      "level": "hl",
      "syllabusRefs": [
        "2.8 Externalities and common resources"
      ],
      "textbookRefs": [
        {
          "chapter": "5",
          "section": "5.3",
          "pages": [
            153
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency"
      ],
      "related": [
        "u2-33-market-failure",
        "u2-34-negative-production",
        "u2-35-negative-consumption"
      ],
      "terms": [
        "外部性与福利损失计算",
        "Externalities and welfare-loss calculations",
        "社会最优",
        "social optimum",
        "边际差额",
        "marginal gap",
        "三角形",
        "triangle"
      ],
      "synonyms": {
        "zh-CN": [
          "社会最优",
          "边际差额",
          "三角形"
        ],
        "en": [
          "social optimum",
          "marginal gap",
          "triangle"
        ]
      },
      "diagramIds": [
        "negative-production"
      ],
      "quizIds": [
        "u2-40-external-welfare-flash-1",
        "u2-40-external-welfare-mcq-1",
        "u2-40-external-welfare-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-40-external-welfare",
        "locale": "zh-CN",
        "title": "外部性与福利损失计算",
        "takeaway": "外部性福利损失是市场数量与社会最优数量之间，社会边际成本与收益差额的累积；线性模型下可计算三角形面积。",
        "definition": "外部性福利损失是市场数量与社会最优数量之间，社会边际成本与收益差额的累积；线性模型下可计算三角形面积。",
        "causalChain": [
          "先确定市场与社会数量",
          "比较错误配置单位的 MSC 与 MSB",
          "累加差额而非把税收视为损失"
        ],
        "misconceptions": [
          "图上三角形高度必须取相应社会成本收益差，不能任取市场价格。"
        ],
        "examApplication": [
          "明确生产或消费、正或负，标出私人均衡和社会最优。"
        ],
        "summary": [
          "外部性福利损失是市场数量与社会最优数量之间，社会边际成本与收益差额的累积；线性模型下可计算三角形面积。",
          "图上三角形高度必须取相应社会成本收益差，不能任取市场价格。"
        ],
        "explanation": "先确定市场与社会数量。比较错误配置单位的 MSC 与 MSB。累加差额而非把税收视为损失。\n\n### 原创情境与推导\n\n原创例：Q*=80、Qm=100，Qm 处 MSC−MSB=6，若差距由零线性增至 6，损失为 ½×20×6=60。最优矫正税应等于 Q* 处外部边际成本，不应机械采用 Qm 处的差额。\n\n图上三角形高度必须取相应社会成本收益差，不能任取市场价格。\n\n明确生产或消费、正或负，标出私人均衡和社会最优。"
      },
      "en": {
        "id": "u2-40-external-welfare",
        "locale": "en",
        "title": "Externalities and welfare-loss calculations",
        "takeaway": "Externality welfare loss accumulates the gap between social marginal cost and benefit between market and optimal quantities. A linear model permits a triangle-area calculation.",
        "definition": "Externality welfare loss accumulates the gap between social marginal cost and benefit between market and optimal quantities. A linear model permits a triangle-area calculation.",
        "causalChain": [
          "Identify market and optimal quantities",
          "compare MSC and MSB on misallocated units",
          "sum the gaps rather than treating tax revenue as the loss"
        ],
        "misconceptions": [
          "The triangle's height must be the relevant social cost-benefit gap, not an arbitrary market price."
        ],
        "examApplication": [
          "Identify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
        ],
        "summary": [
          "Externality welfare loss accumulates the gap between social marginal cost and benefit between market and optimal quantities. A linear model permits a triangle-area calculation.",
          "The triangle's height must be the relevant social cost-benefit gap, not an arbitrary market price."
        ],
        "explanation": "Identify market and optimal quantities.  compare MSC and MSB on misallocated units.  sum the gaps rather than treating tax revenue as the loss.\n\n### Original scenario and reasoning\n\nIllustrative example: Q*=80, Qm=100 and MSC−MSB is six at Qm. If the gap grows linearly from zero, loss is ½×20×6=60. An optimal corrective tax equals marginal external cost at Q*, not mechanically the gap at Qm.\n\nThe triangle's height must be the relevant social cost-benefit gap, not an arbitrary market price.\n\nIdentify production/consumption and positive/negative effects, and label private equilibrium and the social optimum."
      }
    },
    "practice": [
      {
        "id": "u2-40-external-welfare-flash-1",
        "knowledgePointId": "u2-40-external-welfare",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“外部性与福利损失计算”，并说明一个关键条件。",
          "en": "Explain Externalities and welfare-loss calculations and state one important condition."
        },
        "answer": {
          "zh-CN": "外部性福利损失是市场数量与社会最优数量之间，社会边际成本与收益差额的累积；线性模型下可计算三角形面积。",
          "en": "Externality welfare loss accumulates the gap between social marginal cost and benefit between market and optimal quantities. A linear model permits a triangle-area calculation."
        },
        "explanation": {
          "zh-CN": "图上三角形高度必须取相应社会成本收益差，不能任取市场价格。",
          "en": "The triangle's height must be the relevant social cost-benefit gap, not an arbitrary market price."
        }
      },
      {
        "id": "u2-40-external-welfare-mcq-1",
        "knowledgePointId": "u2-40-external-welfare",
        "type": "mcq",
        "prompt": {
          "zh-CN": "线性福利三角形底为 12、高为 5，损失多少？",
          "en": "A linear welfare triangle has base 12 and height five. What is the loss?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "60",
            "en": "60"
          },
          {
            "id": "b",
            "zh-CN": "12",
            "en": "12"
          },
          {
            "id": "c",
            "zh-CN": "5",
            "en": "5"
          },
          {
            "id": "d",
            "zh-CN": "30",
            "en": "30"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "30。 DWL = ½ × 12 × 5 = 30 图上三角形高度必须取相应社会成本收益差，不能任取市场价格。",
          "en": "30. DWL = ½ × 12 × 5 = 30 The triangle's height must be the relevant social cost-benefit gap, not an arbitrary market price."
        }
      },
      {
        "id": "u2-40-external-welfare-short-1",
        "knowledgePointId": "u2-40-external-welfare",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释外部性与福利损失计算的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Externalities and welfare-loss calculations and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "外部性福利损失是市场数量与社会最优数量之间，社会边际成本与收益差额的累积；线性模型下可计算三角形面积。 先确定市场与社会数量；比较错误配置单位的 MSC 与 MSB；累加差额而非把税收视为损失 原创例：Q*=80、Qm=100，Qm 处 MSC−MSB=6，若差距由零线性增至 6，损失为 ½×20×6=60。最优矫正税应等于 Q* 处外部边际成本，不应机械采用 Qm 处的差额。",
          "en": "Externality welfare loss accumulates the gap between social marginal cost and benefit between market and optimal quantities. A linear model permits a triangle-area calculation. Identify market and optimal quantities; compare MSC and MSB on misallocated units; sum the gaps rather than treating tax revenue as the loss Illustrative example: Q*=80, Qm=100 and MSC−MSB is six at Qm. If the gap grows linearly from zero, loss is ½×20×6=60. An optimal corrective tax equals marginal external cost at Q*, not mechanically the gap at Qm."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "社会最优",
              "en": "social optimum"
            },
            "alternatives": {
              "zh-CN": [
                "社会最优",
                "先确定市场与社会数量"
              ],
              "en": [
                "social optimum",
                "Identify market and optimal quantities"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "边际差额",
              "en": "marginal gap"
            },
            "alternatives": {
              "zh-CN": [
                "边际差额",
                "比较错误配置单位的 MSC 与 MSB"
              ],
              "en": [
                "marginal gap",
                "compare MSC and MSB on misallocated units"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "三角形",
              "en": "triangle"
            },
            "alternatives": {
              "zh-CN": [
                "三角形",
                "累加差额而非把税收视为损失"
              ],
              "en": [
                "triangle",
                "sum the gaps rather than treating tax revenue as the loss"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-41-public-goods",
      "slug": "public-goods",
      "section": "2.9",
      "level": "core",
      "syllabusRefs": [
        "2.9 Public goods"
      ],
      "textbookRefs": [
        {
          "chapter": "6",
          "section": "6.3",
          "pages": [
            184
          ]
        }
      ],
      "prerequisites": [
        "u2-33-market-failure"
      ],
      "related": [
        "u2-42-free-rider",
        "u2-43-public-provision"
      ],
      "terms": [
        "公共物品的特征",
        "Characteristics of public goods",
        "非竞争",
        "non-rival",
        "非排他",
        "non-excludable",
        "使用",
        "use"
      ],
      "synonyms": {
        "zh-CN": [
          "非竞争",
          "非排他",
          "使用"
        ],
        "en": [
          "non-rival",
          "non-excludable",
          "use"
        ]
      },
      "diagramIds": [
        "goods-matrix"
      ],
      "quizIds": [
        "u2-41-public-goods-flash-1",
        "u2-41-public-goods-mcq-1",
        "u2-41-public-goods-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-41-public-goods",
        "locale": "zh-CN",
        "title": "公共物品的特征",
        "takeaway": "纯公共物品同时具有非竞争性和非排他性：一人使用不减少他人可用数量，而且难以阻止未付费者使用。",
        "definition": "纯公共物品同时具有非竞争性和非排他性：一人使用不减少他人可用数量，而且难以阻止未付费者使用。",
        "causalChain": [
          "额外使用者不消耗同一服务",
          "阻止使用者的成本高",
          "按个人使用收费难以融资"
        ],
        "misconceptions": [
          "公共提供不等于公共物品，收费学校仍可排他。"
        ],
        "examApplication": [
          "用竞争性和排他性分类，解释融资机制而不只说政府提供。"
        ],
        "summary": [
          "纯公共物品同时具有非竞争性和非排他性：一人使用不减少他人可用数量，而且难以阻止未付费者使用。",
          "公共提供不等于公共物品，收费学校仍可排他。"
        ],
        "explanation": "额外使用者不消耗同一服务。阻止使用者的成本高。按个人使用收费难以融资。\n\n### 原创情境与推导\n\n原创例：国防对区域内居民的保护通常不因多一个居民而减少，且难以单独排除未付费者。拥堵公路在高峰期具有竞争性，所以不能始终按纯公共物品分析。\n\n公共提供不等于公共物品，收费学校仍可排他。\n\n用竞争性和排他性分类，解释融资机制而不只说政府提供。"
      },
      "en": {
        "id": "u2-41-public-goods",
        "locale": "en",
        "title": "Characteristics of public goods",
        "takeaway": "A pure public good is both non-rival and non-excludable: one person's use does not reduce availability to others, and non-payers are difficult to exclude.",
        "definition": "A pure public good is both non-rival and non-excludable: one person's use does not reduce availability to others, and non-payers are difficult to exclude.",
        "causalChain": [
          "An additional user does not consume the same service away",
          "exclusion is difficult or costly",
          "individual use charges struggle to finance provision"
        ],
        "misconceptions": [
          "Public provision is not the same as a public good; a school can still exclude users."
        ],
        "examApplication": [
          "Classify rivalry and excludability and explain financing rather than merely stating government provision."
        ],
        "summary": [
          "A pure public good is both non-rival and non-excludable: one person's use does not reduce availability to others, and non-payers are difficult to exclude.",
          "Public provision is not the same as a public good; a school can still exclude users."
        ],
        "explanation": "An additional user does not consume the same service away.  exclusion is difficult or costly.  individual use charges struggle to finance provision.\n\n### Original scenario and reasoning\n\nIllustrative example: national defence generally protects one more resident without reducing protection for others and cannot easily exclude non-payers. A congested road is rival at peak times, so it cannot always be treated as a pure public good.\n\nPublic provision is not the same as a public good; a school can still exclude users.\n\nClassify rivalry and excludability and explain financing rather than merely stating government provision."
      }
    },
    "practice": [
      {
        "id": "u2-41-public-goods-flash-1",
        "knowledgePointId": "u2-41-public-goods",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“公共物品的特征”，并说明一个关键条件。",
          "en": "Explain Characteristics of public goods and state one important condition."
        },
        "answer": {
          "zh-CN": "纯公共物品同时具有非竞争性和非排他性：一人使用不减少他人可用数量，而且难以阻止未付费者使用。",
          "en": "A pure public good is both non-rival and non-excludable: one person's use does not reduce availability to others, and non-payers are difficult to exclude."
        },
        "explanation": {
          "zh-CN": "公共提供不等于公共物品，收费学校仍可排他。",
          "en": "Public provision is not the same as a public good; a school can still exclude users."
        }
      },
      {
        "id": "u2-41-public-goods-mcq-1",
        "knowledgePointId": "u2-41-public-goods",
        "type": "mcq",
        "prompt": {
          "zh-CN": "纯公共物品需要哪两种特征？",
          "en": "Which two characteristics define a pure public good?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "非竞争与非排他",
            "en": "Non-rivalry and non-excludability"
          },
          {
            "id": "b",
            "zh-CN": "竞争与排他",
            "en": "Rivalry and excludability"
          },
          {
            "id": "c",
            "zh-CN": "只有政府拥有",
            "en": "Government ownership alone"
          },
          {
            "id": "d",
            "zh-CN": "价格高和利润低",
            "en": "High price and low profit"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "非竞争与非排他。 额外使用者不消耗同一服务；阻止使用者的成本高；按个人使用收费难以融资 公共提供不等于公共物品，收费学校仍可排他。",
          "en": "Non-rivalry and non-excludability. An additional user does not consume the same service away; exclusion is difficult or costly; individual use charges struggle to finance provision Public provision is not the same as a public good; a school can still exclude users."
        }
      },
      {
        "id": "u2-41-public-goods-short-1",
        "knowledgePointId": "u2-41-public-goods",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释公共物品的特征的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Characteristics of public goods and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "纯公共物品同时具有非竞争性和非排他性：一人使用不减少他人可用数量，而且难以阻止未付费者使用。 额外使用者不消耗同一服务；阻止使用者的成本高；按个人使用收费难以融资 原创例：国防对区域内居民的保护通常不因多一个居民而减少，且难以单独排除未付费者。拥堵公路在高峰期具有竞争性，所以不能始终按纯公共物品分析。",
          "en": "A pure public good is both non-rival and non-excludable: one person's use does not reduce availability to others, and non-payers are difficult to exclude. An additional user does not consume the same service away; exclusion is difficult or costly; individual use charges struggle to finance provision Illustrative example: national defence generally protects one more resident without reducing protection for others and cannot easily exclude non-payers. A congested road is rival at peak times, so it cannot always be treated as a pure public good."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "非竞争",
              "en": "non-rival"
            },
            "alternatives": {
              "zh-CN": [
                "非竞争",
                "额外使用者不消耗同一服务"
              ],
              "en": [
                "non-rival",
                "An additional user does not consume the same service away"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "非排他",
              "en": "non-excludable"
            },
            "alternatives": {
              "zh-CN": [
                "非排他",
                "阻止使用者的成本高"
              ],
              "en": [
                "non-excludable",
                "exclusion is difficult or costly"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "使用",
              "en": "use"
            },
            "alternatives": {
              "zh-CN": [
                "使用",
                "按个人使用收费难以融资"
              ],
              "en": [
                "use",
                "individual use charges struggle to finance provision"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-42-free-rider",
      "slug": "free-rider",
      "section": "2.9",
      "level": "core",
      "syllabusRefs": [
        "2.9 Public goods"
      ],
      "textbookRefs": [
        {
          "chapter": "6",
          "section": "6.3",
          "pages": [
            184
          ]
        }
      ],
      "prerequisites": [
        "u2-33-market-failure"
      ],
      "related": [
        "u2-41-public-goods",
        "u2-43-public-provision"
      ],
      "terms": [
        "搭便车与市场提供不足",
        "Free riding and underprovision",
        "搭便车",
        "free riding",
        "付费",
        "payment",
        "提供不足",
        "underprovision"
      ],
      "synonyms": {
        "zh-CN": [
          "搭便车",
          "付费",
          "提供不足"
        ],
        "en": [
          "free riding",
          "payment",
          "underprovision"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-42-free-rider-flash-1",
        "u2-42-free-rider-mcq-1",
        "u2-42-free-rider-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-42-free-rider",
        "locale": "zh-CN",
        "title": "搭便车与市场提供不足",
        "takeaway": "搭便车是享受物品收益却不付费。非排他性使人有动机隐藏支付意愿，私人提供者难以收回成本，导致提供不足。",
        "definition": "搭便车是享受物品收益却不付费。非排他性使人有动机隐藏支付意愿，私人提供者难以收回成本，导致提供不足。",
        "causalChain": [
          "使用者可以不支付仍获益",
          "自愿付款不足",
          "私人融资难覆盖生产成本"
        ],
        "misconceptions": [
          "搭便车问题不能仅用提高售价解决，因为未付款者仍可获益。"
        ],
        "examApplication": [
          "用竞争性和排他性分类，解释融资机制而不只说政府提供。"
        ],
        "summary": [
          "搭便车是享受物品收益却不付费。非排他性使人有动机隐藏支付意愿，私人提供者难以收回成本，导致提供不足。",
          "搭便车问题不能仅用提高售价解决，因为未付款者仍可获益。"
        ],
        "explanation": "使用者可以不支付仍获益。自愿付款不足。私人融资难覆盖生产成本。\n\n### 原创情境与推导\n\n原创例：街区照明惠及每户，任何人不付款仍享受灯光。即使住户合计收益超过安装成本，自愿收费也可能失败。税收或社区制度可协调融资，但并不保证支出效率。\n\n搭便车问题不能仅用提高售价解决，因为未付款者仍可获益。\n\n用竞争性和排他性分类，解释融资机制而不只说政府提供。"
      },
      "en": {
        "id": "u2-42-free-rider",
        "locale": "en",
        "title": "Free riding and underprovision",
        "takeaway": "Free riding means enjoying benefits without paying. Non-excludability encourages concealed willingness to pay, making cost recovery difficult and causing underprovision.",
        "definition": "Free riding means enjoying benefits without paying. Non-excludability encourages concealed willingness to pay, making cost recovery difficult and causing underprovision.",
        "causalChain": [
          "Users can benefit without payment",
          "voluntary contributions are insufficient",
          "private financing may fail to cover production costs"
        ],
        "misconceptions": [
          "Simply raising the price cannot solve free riding when non-payers still receive benefits."
        ],
        "examApplication": [
          "Classify rivalry and excludability and explain financing rather than merely stating government provision."
        ],
        "summary": [
          "Free riding means enjoying benefits without paying. Non-excludability encourages concealed willingness to pay, making cost recovery difficult and causing underprovision.",
          "Simply raising the price cannot solve free riding when non-payers still receive benefits."
        ],
        "explanation": "Users can benefit without payment.  voluntary contributions are insufficient.  private financing may fail to cover production costs.\n\n### Original scenario and reasoning\n\nIllustrative example: neighbourhood lighting benefits every household, including non-payers. Even if combined benefit exceeds installation cost, voluntary charging may fail. Taxes or community rules can coordinate financing without guaranteeing spending efficiency.\n\nSimply raising the price cannot solve free riding when non-payers still receive benefits.\n\nClassify rivalry and excludability and explain financing rather than merely stating government provision."
      }
    },
    "practice": [
      {
        "id": "u2-42-free-rider-flash-1",
        "knowledgePointId": "u2-42-free-rider",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“搭便车与市场提供不足”，并说明一个关键条件。",
          "en": "Explain Free riding and underprovision and state one important condition."
        },
        "answer": {
          "zh-CN": "搭便车是享受物品收益却不付费。非排他性使人有动机隐藏支付意愿，私人提供者难以收回成本，导致提供不足。",
          "en": "Free riding means enjoying benefits without paying. Non-excludability encourages concealed willingness to pay, making cost recovery difficult and causing underprovision."
        },
        "explanation": {
          "zh-CN": "搭便车问题不能仅用提高售价解决，因为未付款者仍可获益。",
          "en": "Simply raising the price cannot solve free riding when non-payers still receive benefits."
        }
      },
      {
        "id": "u2-42-free-rider-mcq-1",
        "knowledgePointId": "u2-42-free-rider",
        "type": "mcq",
        "prompt": {
          "zh-CN": "为什么非排他性会导致提供不足？",
          "en": "Why can non-excludability lead to underprovision?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "所有人无收益",
            "en": "Nobody benefits"
          },
          {
            "id": "b",
            "zh-CN": "难以让所有受益者付费",
            "en": "It is hard to charge every beneficiary"
          },
          {
            "id": "c",
            "zh-CN": "生产成本必然为零",
            "en": "Production cost is necessarily zero"
          },
          {
            "id": "d",
            "zh-CN": "数量越多效用必然负",
            "en": "More output necessarily has negative utility"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "难以让所有受益者付费。 使用者可以不支付仍获益；自愿付款不足；私人融资难覆盖生产成本 搭便车问题不能仅用提高售价解决，因为未付款者仍可获益。",
          "en": "It is hard to charge every beneficiary. Users can benefit without payment; voluntary contributions are insufficient; private financing may fail to cover production costs Simply raising the price cannot solve free riding when non-payers still receive benefits."
        }
      },
      {
        "id": "u2-42-free-rider-short-1",
        "knowledgePointId": "u2-42-free-rider",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释搭便车与市场提供不足的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Free riding and underprovision and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "搭便车是享受物品收益却不付费。非排他性使人有动机隐藏支付意愿，私人提供者难以收回成本，导致提供不足。 使用者可以不支付仍获益；自愿付款不足；私人融资难覆盖生产成本 原创例：街区照明惠及每户，任何人不付款仍享受灯光。即使住户合计收益超过安装成本，自愿收费也可能失败。税收或社区制度可协调融资，但并不保证支出效率。",
          "en": "Free riding means enjoying benefits without paying. Non-excludability encourages concealed willingness to pay, making cost recovery difficult and causing underprovision. Users can benefit without payment; voluntary contributions are insufficient; private financing may fail to cover production costs Illustrative example: neighbourhood lighting benefits every household, including non-payers. Even if combined benefit exceeds installation cost, voluntary charging may fail. Taxes or community rules can coordinate financing without guaranteeing spending efficiency."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "搭便车",
              "en": "free riding"
            },
            "alternatives": {
              "zh-CN": [
                "搭便车",
                "使用者可以不支付仍获益"
              ],
              "en": [
                "free riding",
                "Users can benefit without payment"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "付费",
              "en": "payment"
            },
            "alternatives": {
              "zh-CN": [
                "付费",
                "自愿付款不足"
              ],
              "en": [
                "payment",
                "voluntary contributions are insufficient"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "提供不足",
              "en": "underprovision"
            },
            "alternatives": {
              "zh-CN": [
                "提供不足",
                "私人融资难覆盖生产成本"
              ],
              "en": [
                "underprovision",
                "private financing may fail to cover production costs"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-43-public-provision",
      "slug": "public-provision",
      "section": "2.9",
      "level": "core",
      "syllabusRefs": [
        "2.9 Public goods"
      ],
      "textbookRefs": [
        {
          "chapter": "6",
          "section": "6.3",
          "pages": [
            184
          ]
        }
      ],
      "prerequisites": [
        "u2-33-market-failure"
      ],
      "related": [
        "u2-41-public-goods",
        "u2-42-free-rider"
      ],
      "terms": [
        "公共物品的提供与评价",
        "Provision and evaluation of public goods",
        "融资",
        "financing",
        "机会成本",
        "opportunity cost",
        "监督",
        "monitoring"
      ],
      "synonyms": {
        "zh-CN": [
          "融资",
          "机会成本",
          "监督"
        ],
        "en": [
          "financing",
          "opportunity cost",
          "monitoring"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-43-public-provision-flash-1",
        "u2-43-public-provision-mcq-1",
        "u2-43-public-provision-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-43-public-provision",
        "locale": "zh-CN",
        "title": "公共物品的提供与评价",
        "takeaway": "政府可用税收融资并直接提供或委托生产公共物品；融资方式、生产者身份和物品性质是不同问题。",
        "definition": "政府可用税收融资并直接提供或委托生产公共物品；融资方式、生产者身份和物品性质是不同问题。",
        "causalChain": [
          "强制融资减少搭便车",
          "选择供给数量与生产方式",
          "监督成本、质量和分配"
        ],
        "misconceptions": [
          "市场提供不足支持干预理由，但不证明任意政府项目都值得实施。"
        ],
        "examApplication": [
          "用竞争性和排他性分类，解释融资机制而不只说政府提供。"
        ],
        "summary": [
          "政府可用税收融资并直接提供或委托生产公共物品；融资方式、生产者身份和物品性质是不同问题。",
          "市场提供不足支持干预理由，但不证明任意政府项目都值得实施。"
        ],
        "explanation": "强制融资减少搭便车。选择供给数量与生产方式。监督成本、质量和分配。\n\n### 原创情境与推导\n\n原创例：市政府用税收支付路灯工程，私人承包商安装。物品可由公共资金提供而由私人企业生产。评价要比较居民收益、机会成本、招标竞争及维护责任。\n\n市场提供不足支持干预理由，但不证明任意政府项目都值得实施。\n\n用竞争性和排他性分类，解释融资机制而不只说政府提供。"
      },
      "en": {
        "id": "u2-43-public-provision",
        "locale": "en",
        "title": "Provision and evaluation of public goods",
        "takeaway": "Government may finance public goods through taxation and produce them directly or contract production out. Financing, producer identity and the good's characteristics are separate questions.",
        "definition": "Government may finance public goods through taxation and produce them directly or contract production out. Financing, producer identity and the good's characteristics are separate questions.",
        "causalChain": [
          "Compulsory financing reduces free riding",
          "choose quantity and production method",
          "monitor cost, quality and distribution"
        ],
        "misconceptions": [
          "Underprovision supports a case for intervention but does not prove every government project is worthwhile."
        ],
        "examApplication": [
          "Classify rivalry and excludability and explain financing rather than merely stating government provision."
        ],
        "summary": [
          "Government may finance public goods through taxation and produce them directly or contract production out. Financing, producer identity and the good's characteristics are separate questions.",
          "Underprovision supports a case for intervention but does not prove every government project is worthwhile."
        ],
        "explanation": "Compulsory financing reduces free riding.  choose quantity and production method.  monitor cost, quality and distribution.\n\n### Original scenario and reasoning\n\nIllustrative example: a city pays for street lighting from taxes while a private contractor installs it. Public financing can coexist with private production. Evaluate residents' benefits, opportunity cost, competitive tendering and maintenance accountability.\n\nUnderprovision supports a case for intervention but does not prove every government project is worthwhile.\n\nClassify rivalry and excludability and explain financing rather than merely stating government provision."
      }
    },
    "practice": [
      {
        "id": "u2-43-public-provision-flash-1",
        "knowledgePointId": "u2-43-public-provision",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“公共物品的提供与评价”，并说明一个关键条件。",
          "en": "Explain Provision and evaluation of public goods and state one important condition."
        },
        "answer": {
          "zh-CN": "政府可用税收融资并直接提供或委托生产公共物品；融资方式、生产者身份和物品性质是不同问题。",
          "en": "Government may finance public goods through taxation and produce them directly or contract production out. Financing, producer identity and the good's characteristics are separate questions."
        },
        "explanation": {
          "zh-CN": "市场提供不足支持干预理由，但不证明任意政府项目都值得实施。",
          "en": "Underprovision supports a case for intervention but does not prove every government project is worthwhile."
        }
      },
      {
        "id": "u2-43-public-provision-mcq-1",
        "knowledgePointId": "u2-43-public-provision",
        "type": "mcq",
        "prompt": {
          "zh-CN": "税收融资、私人承包安装路灯属于什么？",
          "en": "Tax-financed lighting installed by a private contractor represents what?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "路灯因此必然成为私人品",
            "en": "Lighting necessarily becomes a private good"
          },
          {
            "id": "b",
            "zh-CN": "完全自愿付费",
            "en": "Entirely voluntary funding"
          },
          {
            "id": "c",
            "zh-CN": "公共融资与私人生产并存",
            "en": "Public financing with private production"
          },
          {
            "id": "d",
            "zh-CN": "不存在机会成本",
            "en": "No opportunity cost"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "公共融资与私人生产并存。 强制融资减少搭便车；选择供给数量与生产方式；监督成本、质量和分配 市场提供不足支持干预理由，但不证明任意政府项目都值得实施。",
          "en": "Public financing with private production. Compulsory financing reduces free riding; choose quantity and production method; monitor cost, quality and distribution Underprovision supports a case for intervention but does not prove every government project is worthwhile."
        }
      },
      {
        "id": "u2-43-public-provision-short-1",
        "knowledgePointId": "u2-43-public-provision",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释公共物品的提供与评价的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Provision and evaluation of public goods and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "政府可用税收融资并直接提供或委托生产公共物品；融资方式、生产者身份和物品性质是不同问题。 强制融资减少搭便车；选择供给数量与生产方式；监督成本、质量和分配 原创例：市政府用税收支付路灯工程，私人承包商安装。物品可由公共资金提供而由私人企业生产。评价要比较居民收益、机会成本、招标竞争及维护责任。",
          "en": "Government may finance public goods through taxation and produce them directly or contract production out. Financing, producer identity and the good's characteristics are separate questions. Compulsory financing reduces free riding; choose quantity and production method; monitor cost, quality and distribution Illustrative example: a city pays for street lighting from taxes while a private contractor installs it. Public financing can coexist with private production. Evaluate residents' benefits, opportunity cost, competitive tendering and maintenance accountability."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "融资",
              "en": "financing"
            },
            "alternatives": {
              "zh-CN": [
                "融资",
                "强制融资减少搭便车"
              ],
              "en": [
                "financing",
                "Compulsory financing reduces free riding"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "机会成本",
              "en": "opportunity cost"
            },
            "alternatives": {
              "zh-CN": [
                "机会成本",
                "选择供给数量与生产方式"
              ],
              "en": [
                "opportunity cost",
                "choose quantity and production method"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "监督",
              "en": "monitoring"
            },
            "alternatives": {
              "zh-CN": [
                "监督",
                "监督成本、质量和分配"
              ],
              "en": [
                "monitoring",
                "monitor cost, quality and distribution"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-44-adverse-selection",
      "slug": "adverse-selection",
      "section": "2.10",
      "level": "hl",
      "syllabusRefs": [
        "2.10 Asymmetric information"
      ],
      "textbookRefs": [
        {
          "chapter": "6",
          "section": "6.4",
          "pages": [
            187
          ]
        }
      ],
      "prerequisites": [
        "u2-33-market-failure"
      ],
      "related": [
        "u2-45-moral-hazard",
        "u2-46-information-remedies"
      ],
      "terms": [
        "信息不对称与逆向选择",
        "Asymmetric information and adverse selection",
        "信息不对称",
        "asymmetric information",
        "交易前",
        "before",
        "退出",
        "exit"
      ],
      "synonyms": {
        "zh-CN": [
          "信息不对称",
          "交易前",
          "退出"
        ],
        "en": [
          "asymmetric information",
          "before",
          "exit"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-44-adverse-selection-flash-1",
        "u2-44-adverse-selection-mcq-1",
        "u2-44-adverse-selection-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-44-adverse-selection",
        "locale": "zh-CN",
        "title": "信息不对称与逆向选择",
        "takeaway": "信息不对称是交易一方掌握另一方没有的相关信息。逆向选择发生在交易前，隐藏类型使高风险或低质量交易占比增加。",
        "definition": "信息不对称是交易一方掌握另一方没有的相关信息。逆向选择发生在交易前，隐藏类型使高风险或低质量交易占比增加。",
        "causalChain": [
          "买方难辨质量或风险",
          "统一价格使优质类型退出",
          "平均质量下降并可能使市场萎缩"
        ],
        "misconceptions": [
          "逆向选择发生在交易前，不能与交易后的行为变化混淆。"
        ],
        "examApplication": [
          "写清信息差发生在交易前还是交易后，评价解决方式的可信度。"
        ],
        "summary": [
          "信息不对称是交易一方掌握另一方没有的相关信息。逆向选择发生在交易前，隐藏类型使高风险或低质量交易占比增加。",
          "逆向选择发生在交易前，不能与交易后的行为变化混淆。"
        ],
        "explanation": "买方难辨质量或风险。统一价格使优质类型退出。平均质量下降并可能使市场萎缩。\n\n### 原创情境与推导\n\n原创例：二手车买家不能识别好车，只愿支付平均价格。好车卖家不愿接受该价而退出，剩余车质量更差。检测、担保和可靠认证可减少信息差，但认证机构也需可信。\n\n逆向选择发生在交易前，不能与交易后的行为变化混淆。\n\n写清信息差发生在交易前还是交易后，评价解决方式的可信度。"
      },
      "en": {
        "id": "u2-44-adverse-selection",
        "locale": "en",
        "title": "Asymmetric information and adverse selection",
        "takeaway": "Asymmetric information means one party has relevant information the other lacks. Adverse selection arises before exchange when hidden types increase the share of high-risk or low-quality transactions.",
        "definition": "Asymmetric information means one party has relevant information the other lacks. Adverse selection arises before exchange when hidden types increase the share of high-risk or low-quality transactions.",
        "causalChain": [
          "Buyers cannot distinguish quality or risk",
          "pooled prices drive good types away",
          "average quality falls and the market may shrink"
        ],
        "misconceptions": [
          "Adverse selection occurs before exchange, not as a post-contract behavioural change."
        ],
        "examApplication": [
          "State whether the information problem occurs before or after exchange and evaluate credibility of remedies."
        ],
        "summary": [
          "Asymmetric information means one party has relevant information the other lacks. Adverse selection arises before exchange when hidden types increase the share of high-risk or low-quality transactions.",
          "Adverse selection occurs before exchange, not as a post-contract behavioural change."
        ],
        "explanation": "Buyers cannot distinguish quality or risk.  pooled prices drive good types away.  average quality falls and the market may shrink.\n\n### Original scenario and reasoning\n\nIllustrative example: used-car buyers cannot identify good cars and offer an average price. Good-car owners exit, worsening remaining quality. Inspection, warranties and credible certification can narrow the information gap, but certifiers must be trustworthy.\n\nAdverse selection occurs before exchange, not as a post-contract behavioural change.\n\nState whether the information problem occurs before or after exchange and evaluate credibility of remedies."
      }
    },
    "practice": [
      {
        "id": "u2-44-adverse-selection-flash-1",
        "knowledgePointId": "u2-44-adverse-selection",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“信息不对称与逆向选择”，并说明一个关键条件。",
          "en": "Explain Asymmetric information and adverse selection and state one important condition."
        },
        "answer": {
          "zh-CN": "信息不对称是交易一方掌握另一方没有的相关信息。逆向选择发生在交易前，隐藏类型使高风险或低质量交易占比增加。",
          "en": "Asymmetric information means one party has relevant information the other lacks. Adverse selection arises before exchange when hidden types increase the share of high-risk or low-quality transactions."
        },
        "explanation": {
          "zh-CN": "逆向选择发生在交易前，不能与交易后的行为变化混淆。",
          "en": "Adverse selection occurs before exchange, not as a post-contract behavioural change."
        }
      },
      {
        "id": "u2-44-adverse-selection-mcq-1",
        "knowledgePointId": "u2-44-adverse-selection",
        "type": "mcq",
        "prompt": {
          "zh-CN": "隐藏车况在签约前导致好车退出属于什么？",
          "en": "Hidden car quality before purchase drives good cars out. What is this?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "道德风险",
            "en": "Moral hazard"
          },
          {
            "id": "b",
            "zh-CN": "规模经济",
            "en": "Economies of scale"
          },
          {
            "id": "c",
            "zh-CN": "正消费外部性",
            "en": "Positive consumption externality"
          },
          {
            "id": "d",
            "zh-CN": "逆向选择",
            "en": "Adverse selection"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "逆向选择。 买方难辨质量或风险；统一价格使优质类型退出；平均质量下降并可能使市场萎缩 逆向选择发生在交易前，不能与交易后的行为变化混淆。",
          "en": "Adverse selection. Buyers cannot distinguish quality or risk; pooled prices drive good types away; average quality falls and the market may shrink Adverse selection occurs before exchange, not as a post-contract behavioural change."
        }
      },
      {
        "id": "u2-44-adverse-selection-short-1",
        "knowledgePointId": "u2-44-adverse-selection",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释信息不对称与逆向选择的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Asymmetric information and adverse selection and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "信息不对称是交易一方掌握另一方没有的相关信息。逆向选择发生在交易前，隐藏类型使高风险或低质量交易占比增加。 买方难辨质量或风险；统一价格使优质类型退出；平均质量下降并可能使市场萎缩 原创例：二手车买家不能识别好车，只愿支付平均价格。好车卖家不愿接受该价而退出，剩余车质量更差。检测、担保和可靠认证可减少信息差，但认证机构也需可信。",
          "en": "Asymmetric information means one party has relevant information the other lacks. Adverse selection arises before exchange when hidden types increase the share of high-risk or low-quality transactions. Buyers cannot distinguish quality or risk; pooled prices drive good types away; average quality falls and the market may shrink Illustrative example: used-car buyers cannot identify good cars and offer an average price. Good-car owners exit, worsening remaining quality. Inspection, warranties and credible certification can narrow the information gap, but certifiers must be trustworthy."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "信息不对称",
              "en": "asymmetric information"
            },
            "alternatives": {
              "zh-CN": [
                "信息不对称",
                "买方难辨质量或风险"
              ],
              "en": [
                "asymmetric information",
                "Buyers cannot distinguish quality or risk"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "交易前",
              "en": "before"
            },
            "alternatives": {
              "zh-CN": [
                "交易前",
                "统一价格使优质类型退出"
              ],
              "en": [
                "before",
                "pooled prices drive good types away"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "退出",
              "en": "exit"
            },
            "alternatives": {
              "zh-CN": [
                "退出",
                "平均质量下降并可能使市场萎缩"
              ],
              "en": [
                "exit",
                "average quality falls and the market may shrink"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-45-moral-hazard",
      "slug": "moral-hazard",
      "section": "2.10",
      "level": "hl",
      "syllabusRefs": [
        "2.10 Asymmetric information"
      ],
      "textbookRefs": [
        {
          "chapter": "6",
          "section": "6.4",
          "pages": [
            187
          ]
        }
      ],
      "prerequisites": [
        "u2-33-market-failure"
      ],
      "related": [
        "u2-44-adverse-selection",
        "u2-46-information-remedies"
      ],
      "terms": [
        "道德风险",
        "Moral hazard",
        "交易后",
        "after",
        "行为",
        "actions",
        "激励",
        "incentives"
      ],
      "synonyms": {
        "zh-CN": [
          "交易后",
          "行为",
          "激励"
        ],
        "en": [
          "after",
          "actions",
          "incentives"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-45-moral-hazard-flash-1",
        "u2-45-moral-hazard-mcq-1",
        "u2-45-moral-hazard-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-45-moral-hazard",
        "locale": "zh-CN",
        "title": "道德风险",
        "takeaway": "道德风险发生在交易后：一方的行为难被观察且不承担全部后果，因而可能改变风险或努力程度。",
        "definition": "道德风险发生在交易后：一方的行为难被观察且不承担全部后果，因而可能改变风险或努力程度。",
        "causalChain": [
          "合约分担风险",
          "行为难被完全监测",
          "当事人可能采取更多风险或更少预防"
        ],
        "misconceptions": [
          "道德风险是激励结构，不是对当事人的道德判决。"
        ],
        "examApplication": [
          "写清信息差发生在交易前还是交易后，评价解决方式的可信度。"
        ],
        "summary": [
          "道德风险发生在交易后：一方的行为难被观察且不承担全部后果，因而可能改变风险或努力程度。",
          "道德风险是激励结构，不是对当事人的道德判决。"
        ],
        "explanation": "合约分担风险。行为难被完全监测。当事人可能采取更多风险或更少预防。\n\n### 原创情境与推导\n\n原创例：全额保险后，驾驶者可能减少防盗措施。免赔额使其承担部分损失，监测也可降低风险；但过高免赔额会削弱保险保障，不能只看激励。\n\n道德风险是激励结构，不是对当事人的道德判决。\n\n写清信息差发生在交易前还是交易后，评价解决方式的可信度。"
      },
      "en": {
        "id": "u2-45-moral-hazard",
        "locale": "en",
        "title": "Moral hazard",
        "takeaway": "Moral hazard occurs after a contract when actions are hard to observe and a party does not bear their full consequences, encouraging changes in risk or effort.",
        "definition": "Moral hazard occurs after a contract when actions are hard to observe and a party does not bear their full consequences, encouraging changes in risk or effort.",
        "causalChain": [
          "A contract shares risk",
          "actions cannot be fully monitored",
          "a party may take more risk or less precaution"
        ],
        "misconceptions": [
          "Moral hazard describes incentives, not a moral judgement about the person."
        ],
        "examApplication": [
          "State whether the information problem occurs before or after exchange and evaluate credibility of remedies."
        ],
        "summary": [
          "Moral hazard occurs after a contract when actions are hard to observe and a party does not bear their full consequences, encouraging changes in risk or effort.",
          "Moral hazard describes incentives, not a moral judgement about the person."
        ],
        "explanation": "A contract shares risk.  actions cannot be fully monitored.  a party may take more risk or less precaution.\n\n### Original scenario and reasoning\n\nIllustrative example: full insurance may reduce a driver's precautions against theft. A deductible shares losses and monitoring can reduce risk, but an excessive deductible weakens protection. Incentives are not the only evaluation criterion.\n\nMoral hazard describes incentives, not a moral judgement about the person.\n\nState whether the information problem occurs before or after exchange and evaluate credibility of remedies."
      }
    },
    "practice": [
      {
        "id": "u2-45-moral-hazard-flash-1",
        "knowledgePointId": "u2-45-moral-hazard",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“道德风险”，并说明一个关键条件。",
          "en": "Explain Moral hazard and state one important condition."
        },
        "answer": {
          "zh-CN": "道德风险发生在交易后：一方的行为难被观察且不承担全部后果，因而可能改变风险或努力程度。",
          "en": "Moral hazard occurs after a contract when actions are hard to observe and a party does not bear their full consequences, encouraging changes in risk or effort."
        },
        "explanation": {
          "zh-CN": "道德风险是激励结构，不是对当事人的道德判决。",
          "en": "Moral hazard describes incentives, not a moral judgement about the person."
        }
      },
      {
        "id": "u2-45-moral-hazard-mcq-1",
        "knowledgePointId": "u2-45-moral-hazard",
        "type": "mcq",
        "prompt": {
          "zh-CN": "购买保险后减少预防，主要属于什么？",
          "en": "Reducing precautions after buying insurance primarily illustrates what?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "道德风险",
            "en": "Moral hazard"
          },
          {
            "id": "b",
            "zh-CN": "逆向选择",
            "en": "Adverse selection"
          },
          {
            "id": "c",
            "zh-CN": "需求定律失效必然",
            "en": "Necessary failure of the law of demand"
          },
          {
            "id": "d",
            "zh-CN": "纯公共物品",
            "en": "A pure public good"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "道德风险。 合约分担风险；行为难被完全监测；当事人可能采取更多风险或更少预防 道德风险是激励结构，不是对当事人的道德判决。",
          "en": "Moral hazard. A contract shares risk; actions cannot be fully monitored; a party may take more risk or less precaution Moral hazard describes incentives, not a moral judgement about the person."
        }
      },
      {
        "id": "u2-45-moral-hazard-short-1",
        "knowledgePointId": "u2-45-moral-hazard",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释道德风险的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Moral hazard and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "道德风险发生在交易后：一方的行为难被观察且不承担全部后果，因而可能改变风险或努力程度。 合约分担风险；行为难被完全监测；当事人可能采取更多风险或更少预防 原创例：全额保险后，驾驶者可能减少防盗措施。免赔额使其承担部分损失，监测也可降低风险；但过高免赔额会削弱保险保障，不能只看激励。",
          "en": "Moral hazard occurs after a contract when actions are hard to observe and a party does not bear their full consequences, encouraging changes in risk or effort. A contract shares risk; actions cannot be fully monitored; a party may take more risk or less precaution Illustrative example: full insurance may reduce a driver's precautions against theft. A deductible shares losses and monitoring can reduce risk, but an excessive deductible weakens protection. Incentives are not the only evaluation criterion."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "交易后",
              "en": "after"
            },
            "alternatives": {
              "zh-CN": [
                "交易后",
                "合约分担风险"
              ],
              "en": [
                "after",
                "A contract shares risk"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "行为",
              "en": "actions"
            },
            "alternatives": {
              "zh-CN": [
                "行为",
                "行为难被完全监测"
              ],
              "en": [
                "actions",
                "actions cannot be fully monitored"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "激励",
              "en": "incentives"
            },
            "alternatives": {
              "zh-CN": [
                "激励",
                "当事人可能采取更多风险或更少预防"
              ],
              "en": [
                "incentives",
                "a party may take more risk or less precaution"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-46-information-remedies",
      "slug": "information-remedies",
      "section": "2.10",
      "level": "hl",
      "syllabusRefs": [
        "2.10 Asymmetric information"
      ],
      "textbookRefs": [
        {
          "chapter": "6",
          "section": "6.4",
          "pages": [
            187
          ]
        }
      ],
      "prerequisites": [
        "u2-33-market-failure"
      ],
      "related": [
        "u2-44-adverse-selection",
        "u2-45-moral-hazard"
      ],
      "terms": [
        "信息不对称的应对",
        "Remedies for asymmetric information",
        "信号",
        "signalling",
        "筛选",
        "screening",
        "可信",
        "credible"
      ],
      "synonyms": {
        "zh-CN": [
          "信号",
          "筛选",
          "可信"
        ],
        "en": [
          "signalling",
          "screening",
          "credible"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-46-information-remedies-flash-1",
        "u2-46-information-remedies-mcq-1",
        "u2-46-information-remedies-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-46-information-remedies",
        "locale": "zh-CN",
        "title": "信息不对称的应对",
        "takeaway": "信号、筛选、担保、信息披露和监管可减少信息差；有效性取决于可信度、监测能力与实施成本。",
        "definition": "信号、筛选、担保、信息披露和监管可减少信息差；有效性取决于可信度、监测能力与实施成本。",
        "causalChain": [
          "识别隐藏类型或行为",
          "设计可验证的披露和激励",
          "减少错误交易但增加行政成本"
        ],
        "misconceptions": [
          "无成本且容易伪造的信号可能无法区分类型。"
        ],
        "examApplication": [
          "写清信息差发生在交易前还是交易后，评价解决方式的可信度。"
        ],
        "summary": [
          "信号、筛选、担保、信息披露和监管可减少信息差；有效性取决于可信度、监测能力与实施成本。",
          "无成本且容易伪造的信号可能无法区分类型。"
        ],
        "explanation": "识别隐藏类型或行为。设计可验证的披露和激励。减少错误交易但增加行政成本。\n\n### 原创情境与推导\n\n原创例：卖家提供昂贵担保可以传递质量信号，买家独立检测则是筛选。强制营养标签可能改善选择，但需便于理解且经过核验；大量难读信息并不等于充分信息。\n\n无成本且容易伪造的信号可能无法区分类型。\n\n写清信息差发生在交易前还是交易后，评价解决方式的可信度。"
      },
      "en": {
        "id": "u2-46-information-remedies",
        "locale": "en",
        "title": "Remedies for asymmetric information",
        "takeaway": "Signalling, screening, warranties, disclosure and regulation can reduce information gaps. Effectiveness depends on credibility, monitoring and implementation costs.",
        "definition": "Signalling, screening, warranties, disclosure and regulation can reduce information gaps. Effectiveness depends on credibility, monitoring and implementation costs.",
        "causalChain": [
          "Identify hidden types or actions",
          "design verifiable disclosure and incentives",
          "reduce mistaken trades while incurring administrative cost"
        ],
        "misconceptions": [
          "A cheap, easily faked signal may fail to distinguish types."
        ],
        "examApplication": [
          "State whether the information problem occurs before or after exchange and evaluate credibility of remedies."
        ],
        "summary": [
          "Signalling, screening, warranties, disclosure and regulation can reduce information gaps. Effectiveness depends on credibility, monitoring and implementation costs.",
          "A cheap, easily faked signal may fail to distinguish types."
        ],
        "explanation": "Identify hidden types or actions.  design verifiable disclosure and incentives.  reduce mistaken trades while incurring administrative cost.\n\n### Original scenario and reasoning\n\nIllustrative example: a seller's costly warranty can signal quality, while a buyer's independent inspection screens it. Mandatory nutrition labels can improve choices if understandable and verified; a mass of unreadable information is not effective information.\n\nA cheap, easily faked signal may fail to distinguish types.\n\nState whether the information problem occurs before or after exchange and evaluate credibility of remedies."
      }
    },
    "practice": [
      {
        "id": "u2-46-information-remedies-flash-1",
        "knowledgePointId": "u2-46-information-remedies",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“信息不对称的应对”，并说明一个关键条件。",
          "en": "Explain Remedies for asymmetric information and state one important condition."
        },
        "answer": {
          "zh-CN": "信号、筛选、担保、信息披露和监管可减少信息差；有效性取决于可信度、监测能力与实施成本。",
          "en": "Signalling, screening, warranties, disclosure and regulation can reduce information gaps. Effectiveness depends on credibility, monitoring and implementation costs."
        },
        "explanation": {
          "zh-CN": "无成本且容易伪造的信号可能无法区分类型。",
          "en": "A cheap, easily faked signal may fail to distinguish types."
        }
      },
      {
        "id": "u2-46-information-remedies-mcq-1",
        "knowledgePointId": "u2-46-information-remedies",
        "type": "mcq",
        "prompt": {
          "zh-CN": "买方安排独立车检最接近什么？",
          "en": "A buyer arranges an independent car inspection. What is this closest to?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "买方发出的质量信号",
            "en": "A quality signal from the buyer"
          },
          {
            "id": "b",
            "zh-CN": "筛选",
            "en": "Screening"
          },
          {
            "id": "c",
            "zh-CN": "排放许可证",
            "en": "An emissions permit"
          },
          {
            "id": "d",
            "zh-CN": "最高限价",
            "en": "A price ceiling"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "筛选。 识别隐藏类型或行为；设计可验证的披露和激励；减少错误交易但增加行政成本 无成本且容易伪造的信号可能无法区分类型。",
          "en": "Screening. Identify hidden types or actions; design verifiable disclosure and incentives; reduce mistaken trades while incurring administrative cost A cheap, easily faked signal may fail to distinguish types."
        }
      },
      {
        "id": "u2-46-information-remedies-short-1",
        "knowledgePointId": "u2-46-information-remedies",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释信息不对称的应对的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Remedies for asymmetric information and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "信号、筛选、担保、信息披露和监管可减少信息差；有效性取决于可信度、监测能力与实施成本。 识别隐藏类型或行为；设计可验证的披露和激励；减少错误交易但增加行政成本 原创例：卖家提供昂贵担保可以传递质量信号，买家独立检测则是筛选。强制营养标签可能改善选择，但需便于理解且经过核验；大量难读信息并不等于充分信息。",
          "en": "Signalling, screening, warranties, disclosure and regulation can reduce information gaps. Effectiveness depends on credibility, monitoring and implementation costs. Identify hidden types or actions; design verifiable disclosure and incentives; reduce mistaken trades while incurring administrative cost Illustrative example: a seller's costly warranty can signal quality, while a buyer's independent inspection screens it. Mandatory nutrition labels can improve choices if understandable and verified; a mass of unreadable information is not effective information."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "信号",
              "en": "signalling"
            },
            "alternatives": {
              "zh-CN": [
                "信号",
                "识别隐藏类型或行为"
              ],
              "en": [
                "signalling",
                "Identify hidden types or actions"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "筛选",
              "en": "screening"
            },
            "alternatives": {
              "zh-CN": [
                "筛选",
                "设计可验证的披露和激励"
              ],
              "en": [
                "screening",
                "design verifiable disclosure and incentives"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "可信",
              "en": "credible"
            },
            "alternatives": {
              "zh-CN": [
                "可信",
                "减少错误交易但增加行政成本"
              ],
              "en": [
                "credible",
                "reduce mistaken trades while incurring administrative cost"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-47-market-structures",
      "slug": "market-structures",
      "section": "2.11",
      "level": "hl",
      "syllabusRefs": [
        "2.11 Market power"
      ],
      "textbookRefs": [
        {
          "chapter": "7",
          "section": "7.1",
          "pages": [
            196
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency",
        "u2-10-costs-and-supply"
      ],
      "related": [
        "u2-48-cost-curves",
        "u2-49-scale",
        "u2-50-revenue-profit"
      ],
      "terms": [
        "市场结构与进入壁垒",
        "Market structures and entry barriers",
        "壁垒",
        "barrier",
        "替代品",
        "substitutes",
        "定价权",
        "pricing power"
      ],
      "synonyms": {
        "zh-CN": [
          "壁垒",
          "替代品",
          "定价权"
        ],
        "en": [
          "barrier",
          "substitutes",
          "pricing power"
        ]
      },
      "diagramIds": [
        "monopoly"
      ],
      "quizIds": [
        "u2-47-market-structures-flash-1",
        "u2-47-market-structures-mcq-1",
        "u2-47-market-structures-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-47-market-structures",
        "locale": "zh-CN",
        "title": "市场结构与进入壁垒",
        "takeaway": "市场结构由企业数量、产品差异、进入壁垒和信息条件等描述；市场势力是企业影响价格的能力。",
        "definition": "市场结构由企业数量、产品差异、进入壁垒和信息条件等描述；市场势力是企业影响价格的能力。",
        "causalChain": [
          "专利、规模优势或战略行为限制进入",
          "替代竞争减弱",
          "企业可能有更大定价权"
        ],
        "misconceptions": [
          "企业规模大不自动等于垄断，必须先定义相关市场。"
        ],
        "examApplication": [
          "明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
        ],
        "summary": [
          "市场结构由企业数量、产品差异、进入壁垒和信息条件等描述；市场势力是企业影响价格的能力。",
          "企业规模大不自动等于垄断，必须先定义相关市场。"
        ],
        "explanation": "专利、规模优势或战略行为限制进入。替代竞争减弱。企业可能有更大定价权。\n\n### 原创情境与推导\n\n原创例：一个持有独家专利的药品可能缺少同类竞争，专利到期后仿制品进入可改变定价权。企业数量是线索，但市场定义、替代品和进入威胁也必须考察。 集中率 CRn 为最大 n 家企业市场份额之和。原创例：前四家为 40%、25%、15%、10%，CR4=90%。集中率依赖市场界定，不能单独证明滥用势力。\n\n企业规模大不自动等于垄断，必须先定义相关市场。\n\n明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
      },
      "en": {
        "id": "u2-47-market-structures",
        "locale": "en",
        "title": "Market structures and entry barriers",
        "takeaway": "Market structure describes firm numbers, product differentiation, entry barriers and information conditions. Market power is the ability to influence price.",
        "definition": "Market structure describes firm numbers, product differentiation, entry barriers and information conditions. Market power is the ability to influence price.",
        "causalChain": [
          "Patents, scale advantages or strategic behaviour restrict entry",
          "competitive substitutes weaken",
          "firms may gain pricing power"
        ],
        "misconceptions": [
          "A large firm is not automatically a monopoly; first define the relevant market."
        ],
        "examApplication": [
          "Separate firm and market diagrams, identify MR=MC output and read price from demand."
        ],
        "summary": [
          "Market structure describes firm numbers, product differentiation, entry barriers and information conditions. Market power is the ability to influence price.",
          "A large firm is not automatically a monopoly; first define the relevant market."
        ],
        "explanation": "Patents, scale advantages or strategic behaviour restrict entry.  competitive substitutes weaken.  firms may gain pricing power.\n\n### Original scenario and reasoning\n\nIllustrative example: a patented medicine may lack close competition; generic entry after expiry can change pricing power. Firm numbers are informative, but market definition, substitutes and entry threats also matter. A concentration ratio CRn sums the n largest firms’ market shares. Original example: shares 40%, 25%, 15%, 10% give CR4=90%. Market definition matters; concentration alone does not establish abuse.\n\nA large firm is not automatically a monopoly; first define the relevant market.\n\nSeparate firm and market diagrams, identify MR=MC output and read price from demand."
      }
    },
    "practice": [
      {
        "id": "u2-47-market-structures-flash-1",
        "knowledgePointId": "u2-47-market-structures",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“市场结构与进入壁垒”，并说明一个关键条件。",
          "en": "Explain Market structures and entry barriers and state one important condition."
        },
        "answer": {
          "zh-CN": "市场结构由企业数量、产品差异、进入壁垒和信息条件等描述；市场势力是企业影响价格的能力。",
          "en": "Market structure describes firm numbers, product differentiation, entry barriers and information conditions. Market power is the ability to influence price."
        },
        "explanation": {
          "zh-CN": "企业规模大不自动等于垄断，必须先定义相关市场。",
          "en": "A large firm is not automatically a monopoly; first define the relevant market."
        }
      },
      {
        "id": "u2-47-market-structures-mcq-1",
        "knowledgePointId": "u2-47-market-structures",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪项最可能构成进入壁垒？",
          "en": "Which is most likely an entry barrier?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "消费者容易比较价格",
            "en": "Easy price comparison"
          },
          {
            "id": "b",
            "zh-CN": "相同技术公开可得",
            "en": "Identical technology freely available"
          },
          {
            "id": "c",
            "zh-CN": "独家法律专利",
            "en": "An exclusive legal patent"
          },
          {
            "id": "d",
            "zh-CN": "新企业可无成本进入",
            "en": "Costless entry"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "独家法律专利。 专利、规模优势或战略行为限制进入；替代竞争减弱；企业可能有更大定价权 企业规模大不自动等于垄断，必须先定义相关市场。",
          "en": "An exclusive legal patent. Patents, scale advantages or strategic behaviour restrict entry; competitive substitutes weaken; firms may gain pricing power A large firm is not automatically a monopoly; first define the relevant market."
        }
      },
      {
        "id": "u2-47-market-structures-short-1",
        "knowledgePointId": "u2-47-market-structures",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释市场结构与进入壁垒的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Market structures and entry barriers and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "市场结构由企业数量、产品差异、进入壁垒和信息条件等描述；市场势力是企业影响价格的能力。 专利、规模优势或战略行为限制进入；替代竞争减弱；企业可能有更大定价权 原创例：一个持有独家专利的药品可能缺少同类竞争，专利到期后仿制品进入可改变定价权。企业数量是线索，但市场定义、替代品和进入威胁也必须考察。 集中率 CRn 为最大 n 家企业市场份额之和。原创例：前四家为 40%、25%、15%、10%，CR4=90%。集中率依赖市场界定，不能单独证明滥用势力。",
          "en": "Market structure describes firm numbers, product differentiation, entry barriers and information conditions. Market power is the ability to influence price. Patents, scale advantages or strategic behaviour restrict entry; competitive substitutes weaken; firms may gain pricing power Illustrative example: a patented medicine may lack close competition; generic entry after expiry can change pricing power. Firm numbers are informative, but market definition, substitutes and entry threats also matter. A concentration ratio CRn sums the n largest firms’ market shares. Original example: shares 40%, 25%, 15%, 10% give CR4=90%. Market definition matters; concentration alone does not establish abuse."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "壁垒",
              "en": "barrier"
            },
            "alternatives": {
              "zh-CN": [
                "壁垒",
                "专利、规模优势或战略行为限制进入"
              ],
              "en": [
                "barrier",
                "Patents, scale advantages or strategic behaviour restrict entry"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "替代品",
              "en": "substitutes"
            },
            "alternatives": {
              "zh-CN": [
                "替代品",
                "替代竞争减弱"
              ],
              "en": [
                "substitutes",
                "competitive substitutes weaken"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "定价权",
              "en": "pricing power"
            },
            "alternatives": {
              "zh-CN": [
                "定价权",
                "企业可能有更大定价权"
              ],
              "en": [
                "pricing power",
                "firms may gain pricing power"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-48-cost-curves",
      "slug": "cost-curves",
      "section": "2.11",
      "level": "hl",
      "syllabusRefs": [
        "2.11 Market power"
      ],
      "textbookRefs": [
        {
          "chapter": "7",
          "section": "7.2",
          "pages": [
            199
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency",
        "u2-10-costs-and-supply"
      ],
      "related": [
        "u2-47-market-structures",
        "u2-49-scale",
        "u2-50-revenue-profit"
      ],
      "terms": [
        "总成本、平均成本与边际成本",
        "Total, average and marginal costs",
        "平均成本",
        "average cost",
        "边际成本",
        "marginal cost",
        "固定成本",
        "fixed cost"
      ],
      "synonyms": {
        "zh-CN": [
          "平均成本",
          "边际成本",
          "固定成本"
        ],
        "en": [
          "average cost",
          "marginal cost",
          "fixed cost"
        ]
      },
      "diagramIds": [
        "monopoly"
      ],
      "quizIds": [
        "u2-48-cost-curves-flash-1",
        "u2-48-cost-curves-mcq-1",
        "u2-48-cost-curves-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-48-cost-curves",
        "locale": "zh-CN",
        "title": "总成本、平均成本与边际成本",
        "takeaway": "TC=TFC+TVC，ATC=TC/Q，AVC=TVC/Q，MC=ΔTC/ΔQ；边际成本低于平均成本时平均成本下降，高于时上升。",
        "definition": "TC=TFC+TVC，ATC=TC/Q，AVC=TVC/Q，MC=ΔTC/ΔQ；边际成本低于平均成本时平均成本下降，高于时上升。",
        "causalChain": [
          "固定成本被更多单位分摊",
          "可变投入受边际报酬变化影响",
          "MC 与平均值关系决定平均成本方向"
        ],
        "misconceptions": [
          "固定成本增加抬高 ATC，但不直接移动 MC 与 AVC。"
        ],
        "examApplication": [
          "明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
        ],
        "summary": [
          "TC=TFC+TVC，ATC=TC/Q，AVC=TVC/Q，MC=ΔTC/ΔQ；边际成本低于平均成本时平均成本下降，高于时上升。",
          "固定成本增加抬高 ATC，但不直接移动 MC 与 AVC。"
        ],
        "explanation": "固定成本被更多单位分摊。可变投入受边际报酬变化影响。MC 与平均值关系决定平均成本方向。\n\n### 原创情境与推导\n\n原创例：Q=10、TFC=40、TVC=60，则 TC=100、ATC=10、AVC=6、AFC=4。增加一单位的 MC 若为 8，新的 ATC=(100+8)/11≈9.82。MC 不是 TC/Q。\n\n固定成本增加抬高 ATC，但不直接移动 MC 与 AVC。\n\n明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
      },
      "en": {
        "id": "u2-48-cost-curves",
        "locale": "en",
        "title": "Total, average and marginal costs",
        "takeaway": "TC=TFC+TVC, ATC=TC/Q, AVC=TVC/Q and MC=ΔTC/ΔQ. Average cost falls when marginal cost is below it and rises when marginal cost is above it.",
        "definition": "TC=TFC+TVC, ATC=TC/Q, AVC=TVC/Q and MC=ΔTC/ΔQ. Average cost falls when marginal cost is below it and rises when marginal cost is above it.",
        "causalChain": [
          "Fixed cost is spread over more units",
          "changing marginal returns affect variable inputs",
          "the relation of MC to the average determines its direction"
        ],
        "misconceptions": [
          "Higher fixed cost raises ATC but does not directly shift MC or AVC."
        ],
        "examApplication": [
          "Separate firm and market diagrams, identify MR=MC output and read price from demand."
        ],
        "summary": [
          "TC=TFC+TVC, ATC=TC/Q, AVC=TVC/Q and MC=ΔTC/ΔQ. Average cost falls when marginal cost is below it and rises when marginal cost is above it.",
          "Higher fixed cost raises ATC but does not directly shift MC or AVC."
        ],
        "explanation": "Fixed cost is spread over more units.  changing marginal returns affect variable inputs.  the relation of MC to the average determines its direction.\n\n### Original scenario and reasoning\n\nIllustrative example: Q=10, TFC=40 and TVC=60 give TC=100, ATC=10, AVC=6 and AFC=4. If the next unit's MC is eight, new ATC=(100+8)/11≈9.82. MC is not TC/Q.\n\nHigher fixed cost raises ATC but does not directly shift MC or AVC.\n\nSeparate firm and market diagrams, identify MR=MC output and read price from demand."
      }
    },
    "practice": [
      {
        "id": "u2-48-cost-curves-flash-1",
        "knowledgePointId": "u2-48-cost-curves",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“总成本、平均成本与边际成本”，并说明一个关键条件。",
          "en": "Explain Total, average and marginal costs and state one important condition."
        },
        "answer": {
          "zh-CN": "TC=TFC+TVC，ATC=TC/Q，AVC=TVC/Q，MC=ΔTC/ΔQ；边际成本低于平均成本时平均成本下降，高于时上升。",
          "en": "TC=TFC+TVC, ATC=TC/Q, AVC=TVC/Q and MC=ΔTC/ΔQ. Average cost falls when marginal cost is below it and rises when marginal cost is above it."
        },
        "explanation": {
          "zh-CN": "固定成本增加抬高 ATC，但不直接移动 MC 与 AVC。",
          "en": "Higher fixed cost raises ATC but does not directly shift MC or AVC."
        }
      },
      {
        "id": "u2-48-cost-curves-mcq-1",
        "knowledgePointId": "u2-48-cost-curves",
        "type": "mcq",
        "prompt": {
          "zh-CN": "TC=120、Q=20，ATC 为多少？",
          "en": "TC=120 and Q=20. What is ATC?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "100",
            "en": "100"
          },
          {
            "id": "b",
            "zh-CN": "140",
            "en": "140"
          },
          {
            "id": "c",
            "zh-CN": "2400",
            "en": "2400"
          },
          {
            "id": "d",
            "zh-CN": "6",
            "en": "6"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "6。 ATC = 120 / 20 = 6 固定成本增加抬高 ATC，但不直接移动 MC 与 AVC。",
          "en": "6. ATC = 120 / 20 = 6 Higher fixed cost raises ATC but does not directly shift MC or AVC."
        }
      },
      {
        "id": "u2-48-cost-curves-short-1",
        "knowledgePointId": "u2-48-cost-curves",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释总成本、平均成本与边际成本的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Total, average and marginal costs and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "TC=TFC+TVC，ATC=TC/Q，AVC=TVC/Q，MC=ΔTC/ΔQ；边际成本低于平均成本时平均成本下降，高于时上升。 固定成本被更多单位分摊；可变投入受边际报酬变化影响；MC 与平均值关系决定平均成本方向 原创例：Q=10、TFC=40、TVC=60，则 TC=100、ATC=10、AVC=6、AFC=4。增加一单位的 MC 若为 8，新的 ATC=(100+8)/11≈9.82。MC 不是 TC/Q。",
          "en": "TC=TFC+TVC, ATC=TC/Q, AVC=TVC/Q and MC=ΔTC/ΔQ. Average cost falls when marginal cost is below it and rises when marginal cost is above it. Fixed cost is spread over more units; changing marginal returns affect variable inputs; the relation of MC to the average determines its direction Illustrative example: Q=10, TFC=40 and TVC=60 give TC=100, ATC=10, AVC=6 and AFC=4. If the next unit's MC is eight, new ATC=(100+8)/11≈9.82. MC is not TC/Q."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "平均成本",
              "en": "average cost"
            },
            "alternatives": {
              "zh-CN": [
                "平均成本",
                "固定成本被更多单位分摊"
              ],
              "en": [
                "average cost",
                "Fixed cost is spread over more units"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "边际成本",
              "en": "marginal cost"
            },
            "alternatives": {
              "zh-CN": [
                "边际成本",
                "可变投入受边际报酬变化影响"
              ],
              "en": [
                "marginal cost",
                "changing marginal returns affect variable inputs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "固定成本",
              "en": "fixed cost"
            },
            "alternatives": {
              "zh-CN": [
                "固定成本",
                "MC 与平均值关系决定平均成本方向"
              ],
              "en": [
                "fixed cost",
                "the relation of MC to the average determines its direction"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-49-scale",
      "slug": "scale",
      "section": "2.11",
      "level": "hl",
      "syllabusRefs": [
        "2.11 Market power"
      ],
      "textbookRefs": [
        {
          "chapter": "7",
          "section": "7.2",
          "pages": [
            204
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency",
        "u2-10-costs-and-supply"
      ],
      "related": [
        "u2-47-market-structures",
        "u2-48-cost-curves",
        "u2-50-revenue-profit"
      ],
      "terms": [
        "规模经济与规模不经济",
        "Economies and diseconomies of scale",
        "长期",
        "long run",
        "平均成本",
        "average cost",
        "专业化",
        "specialisation"
      ],
      "synonyms": {
        "zh-CN": [
          "长期",
          "平均成本",
          "专业化"
        ],
        "en": [
          "long run",
          "average cost",
          "specialisation"
        ]
      },
      "diagramIds": [
        "monopoly"
      ],
      "quizIds": [
        "u2-49-scale-flash-1",
        "u2-49-scale-mcq-1",
        "u2-49-scale-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-49-scale",
        "locale": "zh-CN",
        "title": "规模经济与规模不经济",
        "takeaway": "长期所有投入可变时，产量扩张使长期平均成本下降为规模经济，上升为规模不经济。",
        "definition": "长期所有投入可变时，产量扩张使长期平均成本下降为规模经济，上升为规模不经济。",
        "causalChain": [
          "扩大生产规模允许专业化和分摊",
          "管理和沟通复杂度也上升",
          "净影响决定长期平均成本"
        ],
        "misconceptions": [
          "规模经济看平均成本，不是总成本下降。"
        ],
        "examApplication": [
          "明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
        ],
        "summary": [
          "长期所有投入可变时，产量扩张使长期平均成本下降为规模经济，上升为规模不经济。",
          "规模经济看平均成本，不是总成本下降。"
        ],
        "explanation": "扩大生产规模允许专业化和分摊。管理和沟通复杂度也上升。净影响决定长期平均成本。\n\n### 原创情境与推导\n\n原创例：大型运输企业可利用专门维修团队降低每单成本，但跨地区管理过于复杂可能增加协调成本。这涉及所有投入可变的长期分析，不是固定厂房中加工人的边际报酬递减。\n\n规模经济看平均成本，不是总成本下降。\n\n明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
      },
      "en": {
        "id": "u2-49-scale",
        "locale": "en",
        "title": "Economies and diseconomies of scale",
        "takeaway": "In the long run, with all inputs variable, expansion that lowers long-run average cost is an economy of scale; expansion that raises it is a diseconomy.",
        "definition": "In the long run, with all inputs variable, expansion that lowers long-run average cost is an economy of scale; expansion that raises it is a diseconomy.",
        "causalChain": [
          "Larger scale permits specialisation and spreading costs",
          "management and communication grow more complex",
          "the net effect determines long-run average cost"
        ],
        "misconceptions": [
          "Economies of scale concerns average cost, not necessarily falling total cost."
        ],
        "examApplication": [
          "Separate firm and market diagrams, identify MR=MC output and read price from demand."
        ],
        "summary": [
          "In the long run, with all inputs variable, expansion that lowers long-run average cost is an economy of scale; expansion that raises it is a diseconomy.",
          "Economies of scale concerns average cost, not necessarily falling total cost."
        ],
        "explanation": "Larger scale permits specialisation and spreading costs.  management and communication grow more complex.  the net effect determines long-run average cost.\n\n### Original scenario and reasoning\n\nIllustrative example: a large carrier can use specialised maintenance teams to lower cost per delivery, but complex regional management can increase coordination costs. This is long-run analysis with all inputs variable, not diminishing returns from adding workers to a fixed plant.\n\nEconomies of scale concerns average cost, not necessarily falling total cost.\n\nSeparate firm and market diagrams, identify MR=MC output and read price from demand."
      }
    },
    "practice": [
      {
        "id": "u2-49-scale-flash-1",
        "knowledgePointId": "u2-49-scale",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“规模经济与规模不经济”，并说明一个关键条件。",
          "en": "Explain Economies and diseconomies of scale and state one important condition."
        },
        "answer": {
          "zh-CN": "长期所有投入可变时，产量扩张使长期平均成本下降为规模经济，上升为规模不经济。",
          "en": "In the long run, with all inputs variable, expansion that lowers long-run average cost is an economy of scale; expansion that raises it is a diseconomy."
        },
        "explanation": {
          "zh-CN": "规模经济看平均成本，不是总成本下降。",
          "en": "Economies of scale concerns average cost, not necessarily falling total cost."
        }
      },
      {
        "id": "u2-49-scale-mcq-1",
        "knowledgePointId": "u2-49-scale",
        "type": "mcq",
        "prompt": {
          "zh-CN": "产量增加、LRAC 下降，应称为什么？",
          "en": "Output expands and LRAC falls. What is this called?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "规模经济",
            "en": "Economies of scale"
          },
          {
            "id": "b",
            "zh-CN": "规模不经济",
            "en": "Diseconomies of scale"
          },
          {
            "id": "c",
            "zh-CN": "总产量减少",
            "en": "Falling total output"
          },
          {
            "id": "d",
            "zh-CN": "需求完全无弹性",
            "en": "Perfectly inelastic demand"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "规模经济。 扩大生产规模允许专业化和分摊；管理和沟通复杂度也上升；净影响决定长期平均成本 规模经济看平均成本，不是总成本下降。",
          "en": "Economies of scale. Larger scale permits specialisation and spreading costs; management and communication grow more complex; the net effect determines long-run average cost Economies of scale concerns average cost, not necessarily falling total cost."
        }
      },
      {
        "id": "u2-49-scale-short-1",
        "knowledgePointId": "u2-49-scale",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释规模经济与规模不经济的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Economies and diseconomies of scale and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "长期所有投入可变时，产量扩张使长期平均成本下降为规模经济，上升为规模不经济。 扩大生产规模允许专业化和分摊；管理和沟通复杂度也上升；净影响决定长期平均成本 原创例：大型运输企业可利用专门维修团队降低每单成本，但跨地区管理过于复杂可能增加协调成本。这涉及所有投入可变的长期分析，不是固定厂房中加工人的边际报酬递减。",
          "en": "In the long run, with all inputs variable, expansion that lowers long-run average cost is an economy of scale; expansion that raises it is a diseconomy. Larger scale permits specialisation and spreading costs; management and communication grow more complex; the net effect determines long-run average cost Illustrative example: a large carrier can use specialised maintenance teams to lower cost per delivery, but complex regional management can increase coordination costs. This is long-run analysis with all inputs variable, not diminishing returns from adding workers to a fixed plant."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "长期",
              "en": "long run"
            },
            "alternatives": {
              "zh-CN": [
                "长期",
                "扩大生产规模允许专业化和分摊"
              ],
              "en": [
                "long run",
                "Larger scale permits specialisation and spreading costs"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "平均成本",
              "en": "average cost"
            },
            "alternatives": {
              "zh-CN": [
                "平均成本",
                "管理和沟通复杂度也上升"
              ],
              "en": [
                "average cost",
                "management and communication grow more complex"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "专业化",
              "en": "specialisation"
            },
            "alternatives": {
              "zh-CN": [
                "专业化",
                "净影响决定长期平均成本"
              ],
              "en": [
                "specialisation",
                "the net effect determines long-run average cost"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-50-revenue-profit",
      "slug": "revenue-profit",
      "section": "2.11",
      "level": "hl",
      "syllabusRefs": [
        "2.11 Market power"
      ],
      "textbookRefs": [
        {
          "chapter": "7",
          "section": "7.2",
          "pages": [
            205
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency",
        "u2-10-costs-and-supply"
      ],
      "related": [
        "u2-47-market-structures",
        "u2-48-cost-curves",
        "u2-49-scale"
      ],
      "terms": [
        "收益、经济利润与正常利润",
        "Revenue, economic and normal profit",
        "机会成本",
        "opportunity cost",
        "经济利润",
        "economic profit",
        "正常利润",
        "normal profit"
      ],
      "synonyms": {
        "zh-CN": [
          "机会成本",
          "经济利润",
          "正常利润"
        ],
        "en": [
          "opportunity cost",
          "economic profit",
          "normal profit"
        ]
      },
      "diagramIds": [
        "monopoly"
      ],
      "quizIds": [
        "u2-50-revenue-profit-flash-1",
        "u2-50-revenue-profit-mcq-1",
        "u2-50-revenue-profit-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-50-revenue-profit",
        "locale": "zh-CN",
        "title": "收益、经济利润与正常利润",
        "takeaway": "TR=P×Q，AR=TR/Q，MR=ΔTR/ΔQ。经济利润扣除显性与隐性机会成本；正常利润已包含在经济成本中，经济利润为零仍可维持生产。",
        "definition": "TR=P×Q，AR=TR/Q，MR=ΔTR/ΔQ。经济利润扣除显性与隐性机会成本；正常利润已包含在经济成本中，经济利润为零仍可维持生产。",
        "causalChain": [
          "销售产生收入",
          "扣除支付与机会成本",
          "剩余为超额经济利润或亏损"
        ],
        "misconceptions": [
          "垄断降价扩大销售时 MR 可低于 AR，因为较低价格可能适用于所有销售。"
        ],
        "examApplication": [
          "明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
        ],
        "summary": [
          "TR=P×Q，AR=TR/Q，MR=ΔTR/ΔQ。经济利润扣除显性与隐性机会成本；正常利润已包含在经济成本中，经济利润为零仍可维持生产。",
          "垄断降价扩大销售时 MR 可低于 AR，因为较低价格可能适用于所有销售。"
        ],
        "explanation": "销售产生收入。扣除支付与机会成本。剩余为超额经济利润或亏损。\n\n### 原创情境与推导\n\n原创例：收入 200、显性成本 140、隐性成本 40，会计利润 60、经济利润 20。若收入为 180，经济利润零，但所有机会成本已获补偿。不能把正常利润等同于零会计收入。\n\n垄断降价扩大销售时 MR 可低于 AR，因为较低价格可能适用于所有销售。\n\n明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
      },
      "en": {
        "id": "u2-50-revenue-profit",
        "locale": "en",
        "title": "Revenue, economic and normal profit",
        "takeaway": "TR=P×Q, AR=TR/Q and MR=ΔTR/ΔQ. Economic profit deducts explicit and implicit opportunity costs. Normal profit is included in economic cost, so zero economic profit can sustain production.",
        "definition": "TR=P×Q, AR=TR/Q and MR=ΔTR/ΔQ. Economic profit deducts explicit and implicit opportunity costs. Normal profit is included in economic cost, so zero economic profit can sustain production.",
        "causalChain": [
          "Sales generate revenue",
          "deduct payments and opportunity costs",
          "the remainder is economic profit or loss"
        ],
        "misconceptions": [
          "A monopolist's MR can lie below AR because the lower price may apply to all units sold."
        ],
        "examApplication": [
          "Separate firm and market diagrams, identify MR=MC output and read price from demand."
        ],
        "summary": [
          "TR=P×Q, AR=TR/Q and MR=ΔTR/ΔQ. Economic profit deducts explicit and implicit opportunity costs. Normal profit is included in economic cost, so zero economic profit can sustain production.",
          "A monopolist's MR can lie below AR because the lower price may apply to all units sold."
        ],
        "explanation": "Sales generate revenue.  deduct payments and opportunity costs.  the remainder is economic profit or loss.\n\n### Original scenario and reasoning\n\nIllustrative example: revenue 200, explicit costs 140 and implicit costs 40 yield accounting profit 60 and economic profit 20. Revenue of 180 gives zero economic profit while covering all opportunity costs. Normal profit is not zero accounting income.\n\nA monopolist's MR can lie below AR because the lower price may apply to all units sold.\n\nSeparate firm and market diagrams, identify MR=MC output and read price from demand."
      }
    },
    "practice": [
      {
        "id": "u2-50-revenue-profit-flash-1",
        "knowledgePointId": "u2-50-revenue-profit",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“收益、经济利润与正常利润”，并说明一个关键条件。",
          "en": "Explain Revenue, economic and normal profit and state one important condition."
        },
        "answer": {
          "zh-CN": "TR=P×Q，AR=TR/Q，MR=ΔTR/ΔQ。经济利润扣除显性与隐性机会成本；正常利润已包含在经济成本中，经济利润为零仍可维持生产。",
          "en": "TR=P×Q, AR=TR/Q and MR=ΔTR/ΔQ. Economic profit deducts explicit and implicit opportunity costs. Normal profit is included in economic cost, so zero economic profit can sustain production."
        },
        "explanation": {
          "zh-CN": "垄断降价扩大销售时 MR 可低于 AR，因为较低价格可能适用于所有销售。",
          "en": "A monopolist's MR can lie below AR because the lower price may apply to all units sold."
        }
      },
      {
        "id": "u2-50-revenue-profit-mcq-1",
        "knowledgePointId": "u2-50-revenue-profit",
        "type": "mcq",
        "prompt": {
          "zh-CN": "收入 150、显性成本 100、隐性成本 30，经济利润多少？",
          "en": "Revenue is 150, explicit cost 100, implicit cost 30. What is economic profit?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "50",
            "en": "50"
          },
          {
            "id": "b",
            "zh-CN": "20",
            "en": "20"
          },
          {
            "id": "c",
            "zh-CN": "120",
            "en": "120"
          },
          {
            "id": "d",
            "zh-CN": "150",
            "en": "150"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "20。 150 − 100 − 30 = 20 垄断降价扩大销售时 MR 可低于 AR，因为较低价格可能适用于所有销售。",
          "en": "20. 150 − 100 − 30 = 20 A monopolist's MR can lie below AR because the lower price may apply to all units sold."
        }
      },
      {
        "id": "u2-50-revenue-profit-short-1",
        "knowledgePointId": "u2-50-revenue-profit",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释收益、经济利润与正常利润的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Revenue, economic and normal profit and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "TR=P×Q，AR=TR/Q，MR=ΔTR/ΔQ。经济利润扣除显性与隐性机会成本；正常利润已包含在经济成本中，经济利润为零仍可维持生产。 销售产生收入；扣除支付与机会成本；剩余为超额经济利润或亏损 原创例：收入 200、显性成本 140、隐性成本 40，会计利润 60、经济利润 20。若收入为 180，经济利润零，但所有机会成本已获补偿。不能把正常利润等同于零会计收入。",
          "en": "TR=P×Q, AR=TR/Q and MR=ΔTR/ΔQ. Economic profit deducts explicit and implicit opportunity costs. Normal profit is included in economic cost, so zero economic profit can sustain production. Sales generate revenue; deduct payments and opportunity costs; the remainder is economic profit or loss Illustrative example: revenue 200, explicit costs 140 and implicit costs 40 yield accounting profit 60 and economic profit 20. Revenue of 180 gives zero economic profit while covering all opportunity costs. Normal profit is not zero accounting income."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "机会成本",
              "en": "opportunity cost"
            },
            "alternatives": {
              "zh-CN": [
                "机会成本",
                "销售产生收入"
              ],
              "en": [
                "opportunity cost",
                "Sales generate revenue"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "经济利润",
              "en": "economic profit"
            },
            "alternatives": {
              "zh-CN": [
                "经济利润",
                "扣除支付与机会成本"
              ],
              "en": [
                "economic profit",
                "deduct payments and opportunity costs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "正常利润",
              "en": "normal profit"
            },
            "alternatives": {
              "zh-CN": [
                "正常利润",
                "剩余为超额经济利润或亏损"
              ],
              "en": [
                "normal profit",
                "the remainder is economic profit or loss"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-51-profit-maximisation",
      "slug": "profit-maximisation",
      "section": "2.11",
      "level": "hl",
      "syllabusRefs": [
        "2.11 Market power"
      ],
      "textbookRefs": [
        {
          "chapter": "7",
          "section": "7.2",
          "pages": [
            206
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency",
        "u2-10-costs-and-supply"
      ],
      "related": [
        "u2-47-market-structures",
        "u2-48-cost-curves",
        "u2-49-scale"
      ],
      "terms": [
        "利润最大化与停产",
        "Profit maximisation and shutdown",
        "MR=MC",
        "MR=MC",
        "可变成本",
        "variable cost",
        "停产",
        "shutdown"
      ],
      "synonyms": {
        "zh-CN": [
          "MR=MC",
          "可变成本",
          "停产"
        ],
        "en": [
          "MR=MC",
          "variable cost",
          "shutdown"
        ]
      },
      "diagramIds": [
        "monopoly"
      ],
      "quizIds": [
        "u2-51-profit-maximisation-flash-1",
        "u2-51-profit-maximisation-mcq-1",
        "u2-51-profit-maximisation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-51-profit-maximisation",
        "locale": "zh-CN",
        "title": "利润最大化与停产",
        "takeaway": "内部利润最大点通常满足 MR=MC 且 MC 从下方穿过 MR；短期价格低于 AVC 时，价格接受者通常选择停产以避免进一步可变损失。",
        "definition": "内部利润最大点通常满足 MR=MC 且 MC 从下方穿过 MR；短期价格低于 AVC 时，价格接受者通常选择停产以避免进一步可变损失。",
        "causalChain": [
          "MR>MC 时增产提高利润",
          "MC>MR 时减产提高利润",
          "比较可变成本覆盖以判断是否继续生产"
        ],
        "misconceptions": [
          "有亏损不意味着短期必须停产；MR=MC 也不保证正利润。"
        ],
        "examApplication": [
          "明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
        ],
        "summary": [
          "内部利润最大点通常满足 MR=MC 且 MC 从下方穿过 MR；短期价格低于 AVC 时，价格接受者通常选择停产以避免进一步可变损失。",
          "有亏损不意味着短期必须停产；MR=MC 也不保证正利润。"
        ],
        "explanation": "MR>MC 时增产提高利润。MC>MR 时减产提高利润。比较可变成本覆盖以判断是否继续生产。\n\n### 原创情境与推导\n\n原创例：P=9、AVC=7、ATC=11，企业亏损但生产可贡献每单位 2 去支付固定成本，短期可继续。若 P=6<AVC，生产会增加损失。长期退出还需比较总机会成本。\n\n有亏损不意味着短期必须停产；MR=MC 也不保证正利润。\n\n明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
      },
      "en": {
        "id": "u2-51-profit-maximisation",
        "locale": "en",
        "title": "Profit maximisation and shutdown",
        "takeaway": "An interior profit maximum normally has MR=MC with MC crossing MR from below. A price taker normally shuts down in the short run when price is below AVC, avoiding additional variable losses.",
        "definition": "An interior profit maximum normally has MR=MC with MC crossing MR from below. A price taker normally shuts down in the short run when price is below AVC, avoiding additional variable losses.",
        "causalChain": [
          "When MR>MC expansion raises profit",
          "when MC>MR contraction raises profit",
          "compare coverage of variable costs to decide whether to operate"
        ],
        "misconceptions": [
          "A loss does not necessarily require short-run shutdown; MR=MC does not guarantee positive profit."
        ],
        "examApplication": [
          "Separate firm and market diagrams, identify MR=MC output and read price from demand."
        ],
        "summary": [
          "An interior profit maximum normally has MR=MC with MC crossing MR from below. A price taker normally shuts down in the short run when price is below AVC, avoiding additional variable losses.",
          "A loss does not necessarily require short-run shutdown; MR=MC does not guarantee positive profit."
        ],
        "explanation": "When MR>MC expansion raises profit.  when MC>MR contraction raises profit.  compare coverage of variable costs to decide whether to operate.\n\n### Original scenario and reasoning\n\nIllustrative example: P=9, AVC=7 and ATC=11 give a loss, but output contributes two per unit toward fixed cost, so short-run operation can be rational. At P=6<AVC production adds to losses. Long-run exit also compares total opportunity costs.\n\nA loss does not necessarily require short-run shutdown; MR=MC does not guarantee positive profit.\n\nSeparate firm and market diagrams, identify MR=MC output and read price from demand."
      }
    },
    "practice": [
      {
        "id": "u2-51-profit-maximisation-flash-1",
        "knowledgePointId": "u2-51-profit-maximisation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“利润最大化与停产”，并说明一个关键条件。",
          "en": "Explain Profit maximisation and shutdown and state one important condition."
        },
        "answer": {
          "zh-CN": "内部利润最大点通常满足 MR=MC 且 MC 从下方穿过 MR；短期价格低于 AVC 时，价格接受者通常选择停产以避免进一步可变损失。",
          "en": "An interior profit maximum normally has MR=MC with MC crossing MR from below. A price taker normally shuts down in the short run when price is below AVC, avoiding additional variable losses."
        },
        "explanation": {
          "zh-CN": "有亏损不意味着短期必须停产；MR=MC 也不保证正利润。",
          "en": "A loss does not necessarily require short-run shutdown; MR=MC does not guarantee positive profit."
        }
      },
      {
        "id": "u2-51-profit-maximisation-mcq-1",
        "knowledgePointId": "u2-51-profit-maximisation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "P=8、AVC=6、ATC=10，竞争企业短期最可能怎样？",
          "en": "P=8, AVC=6, ATC=10. What is a competitive firm's likely short-run choice?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "因为亏损必停产",
            "en": "Must shut down because of the loss"
          },
          {
            "id": "b",
            "zh-CN": "获得每单位利润 2",
            "en": "Earns profit of two per unit"
          },
          {
            "id": "c",
            "zh-CN": "可继续生产并承担亏损",
            "en": "May operate despite a loss"
          },
          {
            "id": "d",
            "zh-CN": "固定成本消失",
            "en": "Fixed costs disappear"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "可继续生产并承担亏损。 MR>MC 时增产提高利润；MC>MR 时减产提高利润；比较可变成本覆盖以判断是否继续生产 有亏损不意味着短期必须停产；MR=MC 也不保证正利润。",
          "en": "May operate despite a loss. When MR>MC expansion raises profit; when MC>MR contraction raises profit; compare coverage of variable costs to decide whether to operate A loss does not necessarily require short-run shutdown; MR=MC does not guarantee positive profit."
        }
      },
      {
        "id": "u2-51-profit-maximisation-short-1",
        "knowledgePointId": "u2-51-profit-maximisation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释利润最大化与停产的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Profit maximisation and shutdown and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "内部利润最大点通常满足 MR=MC 且 MC 从下方穿过 MR；短期价格低于 AVC 时，价格接受者通常选择停产以避免进一步可变损失。 MR>MC 时增产提高利润；MC>MR 时减产提高利润；比较可变成本覆盖以判断是否继续生产 原创例：P=9、AVC=7、ATC=11，企业亏损但生产可贡献每单位 2 去支付固定成本，短期可继续。若 P=6<AVC，生产会增加损失。长期退出还需比较总机会成本。",
          "en": "An interior profit maximum normally has MR=MC with MC crossing MR from below. A price taker normally shuts down in the short run when price is below AVC, avoiding additional variable losses. When MR>MC expansion raises profit; when MC>MR contraction raises profit; compare coverage of variable costs to decide whether to operate Illustrative example: P=9, AVC=7 and ATC=11 give a loss, but output contributes two per unit toward fixed cost, so short-run operation can be rational. At P=6<AVC production adds to losses. Long-run exit also compares total opportunity costs."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "MR=MC",
              "en": "MR=MC"
            },
            "alternatives": {
              "zh-CN": [
                "MR=MC",
                "MR>MC 时增产提高利润"
              ],
              "en": [
                "MR=MC",
                "When MR>MC expansion raises profit"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "可变成本",
              "en": "variable cost"
            },
            "alternatives": {
              "zh-CN": [
                "可变成本",
                "MC>MR 时减产提高利润"
              ],
              "en": [
                "variable cost",
                "when MC>MR contraction raises profit"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "停产",
              "en": "shutdown"
            },
            "alternatives": {
              "zh-CN": [
                "停产",
                "比较可变成本覆盖以判断是否继续生产"
              ],
              "en": [
                "shutdown",
                "compare coverage of variable costs to decide whether to operate"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-52-perfect-competition",
      "slug": "perfect-competition",
      "section": "2.11",
      "level": "hl",
      "syllabusRefs": [
        "2.11 Market power"
      ],
      "textbookRefs": [
        {
          "chapter": "7",
          "section": "7.3",
          "pages": [
            207
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency",
        "u2-10-costs-and-supply"
      ],
      "related": [
        "u2-47-market-structures",
        "u2-48-cost-curves",
        "u2-49-scale"
      ],
      "terms": [
        "完全竞争",
        "Perfect competition",
        "价格接受",
        "price taker",
        "自由进入",
        "free entry",
        "正常利润",
        "normal profit"
      ],
      "synonyms": {
        "zh-CN": [
          "价格接受",
          "自由进入",
          "正常利润"
        ],
        "en": [
          "price taker",
          "free entry",
          "normal profit"
        ]
      },
      "diagramIds": [
        "perfect-competition"
      ],
      "quizIds": [
        "u2-52-perfect-competition-flash-1",
        "u2-52-perfect-competition-mcq-1",
        "u2-52-perfect-competition-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-52-perfect-competition",
        "locale": "zh-CN",
        "title": "完全竞争",
        "takeaway": "完全竞争模型假设大量企业、同质产品、充分信息和自由进入退出；个别企业接受市场价格，因此 P=AR=MR。",
        "definition": "完全竞争模型假设大量企业、同质产品、充分信息和自由进入退出；个别企业接受市场价格，因此 P=AR=MR。",
        "causalChain": [
          "个别企业不能改变市场价",
          "企业按 MR=MC 选择产量",
          "长期进入退出消除超额经济利润"
        ],
        "misconceptions": [
          "个别企业的水平需求曲线不同于整个市场向下倾斜的需求曲线。"
        ],
        "examApplication": [
          "明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
        ],
        "summary": [
          "完全竞争模型假设大量企业、同质产品、充分信息和自由进入退出；个别企业接受市场价格，因此 P=AR=MR。",
          "个别企业的水平需求曲线不同于整个市场向下倾斜的需求曲线。"
        ],
        "explanation": "个别企业不能改变市场价。企业按 MR=MC 选择产量。长期进入退出消除超额经济利润。\n\n### 原创情境与推导\n\n原创例：某企业获得超额利润，进入增加市场供给并压低价格，直到 P=min ATC。模型长期同时体现生产效率与 P=MC 配置效率，但信息、产品同质性等条件在现实中可能不成立。\n\n个别企业的水平需求曲线不同于整个市场向下倾斜的需求曲线。\n\n明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
      },
      "en": {
        "id": "u2-52-perfect-competition",
        "locale": "en",
        "title": "Perfect competition",
        "takeaway": "Perfect competition assumes many firms, homogeneous goods, adequate information and free entry/exit. Each firm takes the market price, giving P=AR=MR.",
        "definition": "Perfect competition assumes many firms, homogeneous goods, adequate information and free entry/exit. Each firm takes the market price, giving P=AR=MR.",
        "causalChain": [
          "A firm cannot influence market price",
          "it chooses output at MR=MC",
          "long-run entry and exit remove supernormal economic profit"
        ],
        "misconceptions": [
          "The firm's horizontal demand curve differs from the downward-sloping demand curve of the whole market."
        ],
        "examApplication": [
          "Separate firm and market diagrams, identify MR=MC output and read price from demand."
        ],
        "summary": [
          "Perfect competition assumes many firms, homogeneous goods, adequate information and free entry/exit. Each firm takes the market price, giving P=AR=MR.",
          "The firm's horizontal demand curve differs from the downward-sloping demand curve of the whole market."
        ],
        "explanation": "A firm cannot influence market price.  it chooses output at MR=MC.  long-run entry and exit remove supernormal economic profit.\n\n### Original scenario and reasoning\n\nIllustrative example: supernormal profit attracts entry, expanding market supply and reducing price until P=min ATC. The long-run model achieves productive efficiency and P=MC allocative efficiency, but homogeneity and information assumptions may fail in practice.\n\nThe firm's horizontal demand curve differs from the downward-sloping demand curve of the whole market.\n\nSeparate firm and market diagrams, identify MR=MC output and read price from demand."
      }
    },
    "practice": [
      {
        "id": "u2-52-perfect-competition-flash-1",
        "knowledgePointId": "u2-52-perfect-competition",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“完全竞争”，并说明一个关键条件。",
          "en": "Explain Perfect competition and state one important condition."
        },
        "answer": {
          "zh-CN": "完全竞争模型假设大量企业、同质产品、充分信息和自由进入退出；个别企业接受市场价格，因此 P=AR=MR。",
          "en": "Perfect competition assumes many firms, homogeneous goods, adequate information and free entry/exit. Each firm takes the market price, giving P=AR=MR."
        },
        "explanation": {
          "zh-CN": "个别企业的水平需求曲线不同于整个市场向下倾斜的需求曲线。",
          "en": "The firm's horizontal demand curve differs from the downward-sloping demand curve of the whole market."
        }
      },
      {
        "id": "u2-52-perfect-competition-mcq-1",
        "knowledgePointId": "u2-52-perfect-competition",
        "type": "mcq",
        "prompt": {
          "zh-CN": "完全竞争企业的 MR 与价格关系是什么？",
          "en": "What is the relation between MR and price for a perfectly competitive firm?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "MR 恒为零",
            "en": "MR is always zero"
          },
          {
            "id": "b",
            "zh-CN": "MR 必大于 P",
            "en": "MR must exceed P"
          },
          {
            "id": "c",
            "zh-CN": "企业可任意定价",
            "en": "The firm can set any price"
          },
          {
            "id": "d",
            "zh-CN": "MR=P",
            "en": "MR=P"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "MR=P。 个别企业不能改变市场价；企业按 MR=MC 选择产量；长期进入退出消除超额经济利润 个别企业的水平需求曲线不同于整个市场向下倾斜的需求曲线。",
          "en": "MR=P. A firm cannot influence market price; it chooses output at MR=MC; long-run entry and exit remove supernormal economic profit The firm's horizontal demand curve differs from the downward-sloping demand curve of the whole market."
        }
      },
      {
        "id": "u2-52-perfect-competition-short-1",
        "knowledgePointId": "u2-52-perfect-competition",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释完全竞争的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Perfect competition and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "完全竞争模型假设大量企业、同质产品、充分信息和自由进入退出；个别企业接受市场价格，因此 P=AR=MR。 个别企业不能改变市场价；企业按 MR=MC 选择产量；长期进入退出消除超额经济利润 原创例：某企业获得超额利润，进入增加市场供给并压低价格，直到 P=min ATC。模型长期同时体现生产效率与 P=MC 配置效率，但信息、产品同质性等条件在现实中可能不成立。",
          "en": "Perfect competition assumes many firms, homogeneous goods, adequate information and free entry/exit. Each firm takes the market price, giving P=AR=MR. A firm cannot influence market price; it chooses output at MR=MC; long-run entry and exit remove supernormal economic profit Illustrative example: supernormal profit attracts entry, expanding market supply and reducing price until P=min ATC. The long-run model achieves productive efficiency and P=MC allocative efficiency, but homogeneity and information assumptions may fail in practice."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "价格接受",
              "en": "price taker"
            },
            "alternatives": {
              "zh-CN": [
                "价格接受",
                "个别企业不能改变市场价"
              ],
              "en": [
                "price taker",
                "A firm cannot influence market price"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "自由进入",
              "en": "free entry"
            },
            "alternatives": {
              "zh-CN": [
                "自由进入",
                "企业按 MR=MC 选择产量"
              ],
              "en": [
                "free entry",
                "it chooses output at MR=MC"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "正常利润",
              "en": "normal profit"
            },
            "alternatives": {
              "zh-CN": [
                "正常利润",
                "长期进入退出消除超额经济利润"
              ],
              "en": [
                "normal profit",
                "long-run entry and exit remove supernormal economic profit"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-53-monopoly",
      "slug": "monopoly",
      "section": "2.11",
      "level": "hl",
      "syllabusRefs": [
        "2.11 Market power"
      ],
      "textbookRefs": [
        {
          "chapter": "7",
          "section": "7.4",
          "pages": [
            215
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency",
        "u2-10-costs-and-supply"
      ],
      "related": [
        "u2-47-market-structures",
        "u2-48-cost-curves",
        "u2-49-scale"
      ],
      "terms": [
        "垄断定价与效率",
        "Monopoly pricing and efficiency",
        "MR=MC",
        "MR=MC",
        "需求曲线",
        "demand",
        "P>MC",
        "P>MC"
      ],
      "synonyms": {
        "zh-CN": [
          "MR=MC",
          "需求曲线",
          "P>MC"
        ],
        "en": [
          "MR=MC",
          "demand",
          "P>MC"
        ]
      },
      "diagramIds": [
        "monopoly"
      ],
      "quizIds": [
        "u2-53-monopoly-flash-1",
        "u2-53-monopoly-mcq-1",
        "u2-53-monopoly-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-53-monopoly",
        "locale": "zh-CN",
        "title": "垄断定价与效率",
        "takeaway": "垄断者面对市场需求，先在 MR=MC 选择数量，再从需求曲线读取价格；进入壁垒可使超额利润持续。",
        "definition": "垄断者面对市场需求，先在 MR=MC 选择数量，再从需求曲线读取价格；进入壁垒可使超额利润持续。",
        "causalChain": [
          "降低价格才能扩大销售",
          "MR 低于价格",
          "利润最大点通常 P>MC 并低于配置有效数量"
        ],
        "misconceptions": [
          "垄断者不能独立任选价格与数量，需求约束仍在。"
        ],
        "examApplication": [
          "明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
        ],
        "summary": [
          "垄断者面对市场需求，先在 MR=MC 选择数量，再从需求曲线读取价格；进入壁垒可使超额利润持续。",
          "垄断者不能独立任选价格与数量，需求约束仍在。"
        ],
        "explanation": "降低价格才能扩大销售。MR 低于价格。利润最大点通常 P>MC 并低于配置有效数量。\n\n### 原创情境与推导\n\n原创例：MR=MC 时 Q=40，而需求曲线上该数量价格为 12、MC 为 7，定价为 12 而不是 7。单凭垄断地位不能保证获利，还需比较 ATC；创新和规模经济可能改变成本比较。\n\n垄断者不能独立任选价格与数量，需求约束仍在。\n\n明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
      },
      "en": {
        "id": "u2-53-monopoly",
        "locale": "en",
        "title": "Monopoly pricing and efficiency",
        "takeaway": "A monopolist faces market demand, selects quantity at MR=MC and then reads price from demand. Entry barriers can allow supernormal profit to persist.",
        "definition": "A monopolist faces market demand, selects quantity at MR=MC and then reads price from demand. Entry barriers can allow supernormal profit to persist.",
        "causalChain": [
          "A lower price is needed to expand sales",
          "MR is below price",
          "at the profit maximum P normally exceeds MC and output is below the allocatively efficient level"
        ],
        "misconceptions": [
          "A monopolist cannot choose price and quantity independently; demand still constrains it."
        ],
        "examApplication": [
          "Separate firm and market diagrams, identify MR=MC output and read price from demand."
        ],
        "summary": [
          "A monopolist faces market demand, selects quantity at MR=MC and then reads price from demand. Entry barriers can allow supernormal profit to persist.",
          "A monopolist cannot choose price and quantity independently; demand still constrains it."
        ],
        "explanation": "A lower price is needed to expand sales.  MR is below price.  at the profit maximum P normally exceeds MC and output is below the allocatively efficient level.\n\n### Original scenario and reasoning\n\nIllustrative example: MR=MC at Q=40, where demand gives price 12 and MC is seven. Price is 12, not seven. Monopoly does not guarantee profit: compare ATC. Innovation and scale economies can change cost comparisons.\n\nA monopolist cannot choose price and quantity independently; demand still constrains it.\n\nSeparate firm and market diagrams, identify MR=MC output and read price from demand."
      }
    },
    "practice": [
      {
        "id": "u2-53-monopoly-flash-1",
        "knowledgePointId": "u2-53-monopoly",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“垄断定价与效率”，并说明一个关键条件。",
          "en": "Explain Monopoly pricing and efficiency and state one important condition."
        },
        "answer": {
          "zh-CN": "垄断者面对市场需求，先在 MR=MC 选择数量，再从需求曲线读取价格；进入壁垒可使超额利润持续。",
          "en": "A monopolist faces market demand, selects quantity at MR=MC and then reads price from demand. Entry barriers can allow supernormal profit to persist."
        },
        "explanation": {
          "zh-CN": "垄断者不能独立任选价格与数量，需求约束仍在。",
          "en": "A monopolist cannot choose price and quantity independently; demand still constrains it."
        }
      },
      {
        "id": "u2-53-monopoly-mcq-1",
        "knowledgePointId": "u2-53-monopoly",
        "type": "mcq",
        "prompt": {
          "zh-CN": "垄断者在哪条曲线上读取所选数量的价格？",
          "en": "Where does a monopolist read the price for its chosen quantity?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "需求/AR 曲线",
            "en": "Demand/AR"
          },
          {
            "id": "b",
            "zh-CN": "MC 曲线",
            "en": "MC"
          },
          {
            "id": "c",
            "zh-CN": "MR 曲线",
            "en": "MR"
          },
          {
            "id": "d",
            "zh-CN": "固定成本曲线",
            "en": "Fixed cost"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "需求/AR 曲线。 降低价格才能扩大销售；MR 低于价格；利润最大点通常 P>MC 并低于配置有效数量 垄断者不能独立任选价格与数量，需求约束仍在。",
          "en": "Demand/AR. A lower price is needed to expand sales; MR is below price; at the profit maximum P normally exceeds MC and output is below the allocatively efficient level A monopolist cannot choose price and quantity independently; demand still constrains it."
        }
      },
      {
        "id": "u2-53-monopoly-short-1",
        "knowledgePointId": "u2-53-monopoly",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释垄断定价与效率的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Monopoly pricing and efficiency and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "垄断者面对市场需求，先在 MR=MC 选择数量，再从需求曲线读取价格；进入壁垒可使超额利润持续。 降低价格才能扩大销售；MR 低于价格；利润最大点通常 P>MC 并低于配置有效数量 原创例：MR=MC 时 Q=40，而需求曲线上该数量价格为 12、MC 为 7，定价为 12 而不是 7。单凭垄断地位不能保证获利，还需比较 ATC；创新和规模经济可能改变成本比较。",
          "en": "A monopolist faces market demand, selects quantity at MR=MC and then reads price from demand. Entry barriers can allow supernormal profit to persist. A lower price is needed to expand sales; MR is below price; at the profit maximum P normally exceeds MC and output is below the allocatively efficient level Illustrative example: MR=MC at Q=40, where demand gives price 12 and MC is seven. Price is 12, not seven. Monopoly does not guarantee profit: compare ATC. Innovation and scale economies can change cost comparisons."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "MR=MC",
              "en": "MR=MC"
            },
            "alternatives": {
              "zh-CN": [
                "MR=MC",
                "降低价格才能扩大销售"
              ],
              "en": [
                "MR=MC",
                "A lower price is needed to expand sales"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "需求曲线",
              "en": "demand"
            },
            "alternatives": {
              "zh-CN": [
                "需求曲线",
                "MR 低于价格"
              ],
              "en": [
                "demand",
                "MR is below price"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "P>MC",
              "en": "P>MC"
            },
            "alternatives": {
              "zh-CN": [
                "P>MC",
                "利润最大点通常 P>MC 并低于配置有效数量"
              ],
              "en": [
                "P>MC",
                "at the profit maximum P normally exceeds MC and output is below the allocatively efficient level"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-54-natural-monopoly",
      "slug": "natural-monopoly",
      "section": "2.11",
      "level": "hl",
      "syllabusRefs": [
        "2.11 Market power"
      ],
      "textbookRefs": [
        {
          "chapter": "7",
          "section": "7.4",
          "pages": [
            220
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency",
        "u2-10-costs-and-supply"
      ],
      "related": [
        "u2-47-market-structures",
        "u2-48-cost-curves",
        "u2-49-scale"
      ],
      "terms": [
        "自然垄断与价格监管",
        "Natural monopoly and price regulation",
        "平均成本",
        "average cost",
        "边际成本",
        "marginal cost",
        "监管",
        "regulation"
      ],
      "synonyms": {
        "zh-CN": [
          "平均成本",
          "边际成本",
          "监管"
        ],
        "en": [
          "average cost",
          "marginal cost",
          "regulation"
        ]
      },
      "diagramIds": [
        "monopoly"
      ],
      "quizIds": [
        "u2-54-natural-monopoly-flash-1",
        "u2-54-natural-monopoly-mcq-1",
        "u2-54-natural-monopoly-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-54-natural-monopoly",
        "locale": "zh-CN",
        "title": "自然垄断与价格监管",
        "takeaway": "自然垄断发生在相关市场需求范围内平均成本持续下降，使一家企业供给全部市场比多家重复建设成本更低。",
        "definition": "自然垄断发生在相关市场需求范围内平均成本持续下降，使一家企业供给全部市场比多家重复建设成本更低。",
        "causalChain": [
          "大额固定网络成本可被分摊",
          "单一供应者有成本优势",
          "监管需平衡效率与成本回收"
        ],
        "misconceptions": [
          "自然垄断指成本结构，不等于任何国有企业或任何规模大的企业。"
        ],
        "examApplication": [
          "明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
        ],
        "summary": [
          "自然垄断发生在相关市场需求范围内平均成本持续下降，使一家企业供给全部市场比多家重复建设成本更低。",
          "自然垄断指成本结构，不等于任何国有企业或任何规模大的企业。"
        ],
        "explanation": "大额固定网络成本可被分摊。单一供应者有成本优势。监管需平衡效率与成本回收。\n\n### 原创情境与推导\n\n原创例：重复铺设供水管网可能浪费成本。P=MC 定价可提高配置效率，但成本下降区间 MC<ATC，企业可能亏损并需补贴；P=ATC 可回收成本，却未必配置有效。\n\n自然垄断指成本结构，不等于任何国有企业或任何规模大的企业。\n\n明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
      },
      "en": {
        "id": "u2-54-natural-monopoly",
        "locale": "en",
        "title": "Natural monopoly and price regulation",
        "takeaway": "Natural monopoly exists when average cost declines over the relevant demand range, so one supplier can serve the market at lower cost than several duplicating infrastructure.",
        "definition": "Natural monopoly exists when average cost declines over the relevant demand range, so one supplier can serve the market at lower cost than several duplicating infrastructure.",
        "causalChain": [
          "Large fixed network costs can be spread",
          "a single supplier has a cost advantage",
          "regulation balances efficiency with cost recovery"
        ],
        "misconceptions": [
          "Natural monopoly describes a cost structure, not every state-owned or large firm."
        ],
        "examApplication": [
          "Separate firm and market diagrams, identify MR=MC output and read price from demand."
        ],
        "summary": [
          "Natural monopoly exists when average cost declines over the relevant demand range, so one supplier can serve the market at lower cost than several duplicating infrastructure.",
          "Natural monopoly describes a cost structure, not every state-owned or large firm."
        ],
        "explanation": "Large fixed network costs can be spread.  a single supplier has a cost advantage.  regulation balances efficiency with cost recovery.\n\n### Original scenario and reasoning\n\nIllustrative example: duplicating water pipes can waste resources. P=MC pricing improves allocative efficiency, but MC<ATC in a declining-cost range can create losses requiring subsidy. P=ATC recovers cost without necessarily achieving allocative efficiency.\n\nNatural monopoly describes a cost structure, not every state-owned or large firm.\n\nSeparate firm and market diagrams, identify MR=MC output and read price from demand."
      }
    },
    "practice": [
      {
        "id": "u2-54-natural-monopoly-flash-1",
        "knowledgePointId": "u2-54-natural-monopoly",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“自然垄断与价格监管”，并说明一个关键条件。",
          "en": "Explain Natural monopoly and price regulation and state one important condition."
        },
        "answer": {
          "zh-CN": "自然垄断发生在相关市场需求范围内平均成本持续下降，使一家企业供给全部市场比多家重复建设成本更低。",
          "en": "Natural monopoly exists when average cost declines over the relevant demand range, so one supplier can serve the market at lower cost than several duplicating infrastructure."
        },
        "explanation": {
          "zh-CN": "自然垄断指成本结构，不等于任何国有企业或任何规模大的企业。",
          "en": "Natural monopoly describes a cost structure, not every state-owned or large firm."
        }
      },
      {
        "id": "u2-54-natural-monopoly-mcq-1",
        "knowledgePointId": "u2-54-natural-monopoly",
        "type": "mcq",
        "prompt": {
          "zh-CN": "自然垄断中 MC<ATC，按 P=MC 收费可能怎样？",
          "en": "In a natural monopoly MC<ATC. What may P=MC pricing cause?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "必然超额利润",
            "en": "Guaranteed supernormal profit"
          },
          {
            "id": "b",
            "zh-CN": "亏损，需要融资安排",
            "en": "Losses requiring financing"
          },
          {
            "id": "c",
            "zh-CN": "成本为零",
            "en": "Zero cost"
          },
          {
            "id": "d",
            "zh-CN": "需求消失",
            "en": "Demand disappears"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "亏损，需要融资安排。 大额固定网络成本可被分摊；单一供应者有成本优势；监管需平衡效率与成本回收 自然垄断指成本结构，不等于任何国有企业或任何规模大的企业。",
          "en": "Losses requiring financing. Large fixed network costs can be spread; a single supplier has a cost advantage; regulation balances efficiency with cost recovery Natural monopoly describes a cost structure, not every state-owned or large firm."
        }
      },
      {
        "id": "u2-54-natural-monopoly-short-1",
        "knowledgePointId": "u2-54-natural-monopoly",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释自然垄断与价格监管的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Natural monopoly and price regulation and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "自然垄断发生在相关市场需求范围内平均成本持续下降，使一家企业供给全部市场比多家重复建设成本更低。 大额固定网络成本可被分摊；单一供应者有成本优势；监管需平衡效率与成本回收 原创例：重复铺设供水管网可能浪费成本。P=MC 定价可提高配置效率，但成本下降区间 MC<ATC，企业可能亏损并需补贴；P=ATC 可回收成本，却未必配置有效。",
          "en": "Natural monopoly exists when average cost declines over the relevant demand range, so one supplier can serve the market at lower cost than several duplicating infrastructure. Large fixed network costs can be spread; a single supplier has a cost advantage; regulation balances efficiency with cost recovery Illustrative example: duplicating water pipes can waste resources. P=MC pricing improves allocative efficiency, but MC<ATC in a declining-cost range can create losses requiring subsidy. P=ATC recovers cost without necessarily achieving allocative efficiency."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "平均成本",
              "en": "average cost"
            },
            "alternatives": {
              "zh-CN": [
                "平均成本",
                "大额固定网络成本可被分摊"
              ],
              "en": [
                "average cost",
                "Large fixed network costs can be spread"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "边际成本",
              "en": "marginal cost"
            },
            "alternatives": {
              "zh-CN": [
                "边际成本",
                "单一供应者有成本优势"
              ],
              "en": [
                "marginal cost",
                "a single supplier has a cost advantage"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "监管",
              "en": "regulation"
            },
            "alternatives": {
              "zh-CN": [
                "监管",
                "监管需平衡效率与成本回收"
              ],
              "en": [
                "regulation",
                "regulation balances efficiency with cost recovery"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-55-monopolistic-competition",
      "slug": "monopolistic-competition",
      "section": "2.11",
      "level": "hl",
      "syllabusRefs": [
        "2.11 Market power"
      ],
      "textbookRefs": [
        {
          "chapter": "7",
          "section": "7.5",
          "pages": [
            225
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency",
        "u2-10-costs-and-supply"
      ],
      "related": [
        "u2-47-market-structures",
        "u2-48-cost-curves",
        "u2-49-scale"
      ],
      "terms": [
        "垄断竞争",
        "Monopolistic competition",
        "差异化",
        "differentiated",
        "进入",
        "entry",
        "剩余产能",
        "excess capacity"
      ],
      "synonyms": {
        "zh-CN": [
          "差异化",
          "进入",
          "剩余产能"
        ],
        "en": [
          "differentiated",
          "entry",
          "excess capacity"
        ]
      },
      "diagramIds": [
        "monopoly"
      ],
      "quizIds": [
        "u2-55-monopolistic-competition-flash-1",
        "u2-55-monopolistic-competition-mcq-1",
        "u2-55-monopolistic-competition-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-55-monopolistic-competition",
        "locale": "zh-CN",
        "title": "垄断竞争",
        "takeaway": "垄断竞争有许多企业、差异化产品及较低进入壁垒；差异化带来定价权，长期进入使经济利润趋于零。",
        "definition": "垄断竞争有许多企业、差异化产品及较低进入壁垒；差异化带来定价权，长期进入使经济利润趋于零。",
        "causalChain": [
          "产品差异使企业需求向下",
          "超额利润吸引相近产品进入",
          "需求减弱直至正常利润"
        ],
        "misconceptions": [
          "正常利润不意味着完全竞争，P 仍可大于 MC。"
        ],
        "examApplication": [
          "明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
        ],
        "summary": [
          "垄断竞争有许多企业、差异化产品及较低进入壁垒；差异化带来定价权，长期进入使经济利润趋于零。",
          "正常利润不意味着完全竞争，P 仍可大于 MC。"
        ],
        "explanation": "产品差异使企业需求向下。超额利润吸引相近产品进入。需求减弱直至正常利润。\n\n### 原创情境与推导\n\n原创例：咖啡店以环境和品牌区别产品。长期正常利润时需求与 ATC 相切，但通常不在 ATC 最低点，存在剩余产能。消费者可能重视多样性，所以不能只凭成本图评价所有福利。\n\n正常利润不意味着完全竞争，P 仍可大于 MC。\n\n明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
      },
      "en": {
        "id": "u2-55-monopolistic-competition",
        "locale": "en",
        "title": "Monopolistic competition",
        "takeaway": "Monopolistic competition features many firms, differentiated products and relatively low entry barriers. Differentiation gives pricing power while long-run entry tends to eliminate economic profit.",
        "definition": "Monopolistic competition features many firms, differentiated products and relatively low entry barriers. Differentiation gives pricing power while long-run entry tends to eliminate economic profit.",
        "causalChain": [
          "Differentiation gives downward-sloping firm demand",
          "supernormal profit attracts close substitutes",
          "demand weakens until normal profit"
        ],
        "misconceptions": [
          "Normal profit does not imply perfect competition; P may still exceed MC."
        ],
        "examApplication": [
          "Separate firm and market diagrams, identify MR=MC output and read price from demand."
        ],
        "summary": [
          "Monopolistic competition features many firms, differentiated products and relatively low entry barriers. Differentiation gives pricing power while long-run entry tends to eliminate economic profit.",
          "Normal profit does not imply perfect competition; P may still exceed MC."
        ],
        "explanation": "Differentiation gives downward-sloping firm demand.  supernormal profit attracts close substitutes.  demand weakens until normal profit.\n\n### Original scenario and reasoning\n\nIllustrative example: cafes differentiate through atmosphere and branding. At long-run normal profit, demand is tangent to ATC, normally above its minimum, implying excess capacity. Consumers may value variety, so a cost diagram alone does not capture all welfare.\n\nNormal profit does not imply perfect competition; P may still exceed MC.\n\nSeparate firm and market diagrams, identify MR=MC output and read price from demand."
      }
    },
    "practice": [
      {
        "id": "u2-55-monopolistic-competition-flash-1",
        "knowledgePointId": "u2-55-monopolistic-competition",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“垄断竞争”，并说明一个关键条件。",
          "en": "Explain Monopolistic competition and state one important condition."
        },
        "answer": {
          "zh-CN": "垄断竞争有许多企业、差异化产品及较低进入壁垒；差异化带来定价权，长期进入使经济利润趋于零。",
          "en": "Monopolistic competition features many firms, differentiated products and relatively low entry barriers. Differentiation gives pricing power while long-run entry tends to eliminate economic profit."
        },
        "explanation": {
          "zh-CN": "正常利润不意味着完全竞争，P 仍可大于 MC。",
          "en": "Normal profit does not imply perfect competition; P may still exceed MC."
        }
      },
      {
        "id": "u2-55-monopolistic-competition-mcq-1",
        "knowledgePointId": "u2-55-monopolistic-competition",
        "type": "mcq",
        "prompt": {
          "zh-CN": "长期垄断竞争最典型的组合是什么？",
          "en": "Which is typical of long-run monopolistic competition?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "同质产品与零壁垒下水平需求",
            "en": "Homogeneous goods and horizontal firm demand"
          },
          {
            "id": "b",
            "zh-CN": "只有一家企业",
            "en": "Exactly one firm"
          },
          {
            "id": "c",
            "zh-CN": "正常利润与剩余产能",
            "en": "Normal profit and excess capacity"
          },
          {
            "id": "d",
            "zh-CN": "价格总等于 MC",
            "en": "Price always equals MC"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "正常利润与剩余产能。 产品差异使企业需求向下；超额利润吸引相近产品进入；需求减弱直至正常利润 正常利润不意味着完全竞争，P 仍可大于 MC。",
          "en": "Normal profit and excess capacity. Differentiation gives downward-sloping firm demand; supernormal profit attracts close substitutes; demand weakens until normal profit Normal profit does not imply perfect competition; P may still exceed MC."
        }
      },
      {
        "id": "u2-55-monopolistic-competition-short-1",
        "knowledgePointId": "u2-55-monopolistic-competition",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释垄断竞争的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Monopolistic competition and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "垄断竞争有许多企业、差异化产品及较低进入壁垒；差异化带来定价权，长期进入使经济利润趋于零。 产品差异使企业需求向下；超额利润吸引相近产品进入；需求减弱直至正常利润 原创例：咖啡店以环境和品牌区别产品。长期正常利润时需求与 ATC 相切，但通常不在 ATC 最低点，存在剩余产能。消费者可能重视多样性，所以不能只凭成本图评价所有福利。",
          "en": "Monopolistic competition features many firms, differentiated products and relatively low entry barriers. Differentiation gives pricing power while long-run entry tends to eliminate economic profit. Differentiation gives downward-sloping firm demand; supernormal profit attracts close substitutes; demand weakens until normal profit Illustrative example: cafes differentiate through atmosphere and branding. At long-run normal profit, demand is tangent to ATC, normally above its minimum, implying excess capacity. Consumers may value variety, so a cost diagram alone does not capture all welfare."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "差异化",
              "en": "differentiated"
            },
            "alternatives": {
              "zh-CN": [
                "差异化",
                "产品差异使企业需求向下"
              ],
              "en": [
                "differentiated",
                "Differentiation gives downward-sloping firm demand"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "进入",
              "en": "entry"
            },
            "alternatives": {
              "zh-CN": [
                "进入",
                "超额利润吸引相近产品进入"
              ],
              "en": [
                "entry",
                "supernormal profit attracts close substitutes"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "剩余产能",
              "en": "excess capacity"
            },
            "alternatives": {
              "zh-CN": [
                "剩余产能",
                "需求减弱直至正常利润"
              ],
              "en": [
                "excess capacity",
                "demand weakens until normal profit"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-56-oligopoly",
      "slug": "oligopoly",
      "section": "2.11",
      "level": "hl",
      "syllabusRefs": [
        "2.11 Market power"
      ],
      "textbookRefs": [
        {
          "chapter": "7",
          "section": "7.6",
          "pages": [
            230
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency",
        "u2-10-costs-and-supply"
      ],
      "related": [
        "u2-47-market-structures",
        "u2-48-cost-curves",
        "u2-49-scale"
      ],
      "terms": [
        "寡头、相互依赖与博弈",
        "Oligopoly, interdependence and game theory",
        "相互依赖",
        "interdependence",
        "优势策略",
        "dominant strategy",
        "背离",
        "deviate"
      ],
      "synonyms": {
        "zh-CN": [
          "相互依赖",
          "优势策略",
          "背离"
        ],
        "en": [
          "interdependence",
          "dominant strategy",
          "deviate"
        ]
      },
      "diagramIds": [
        "monopoly"
      ],
      "quizIds": [
        "u2-56-oligopoly-flash-1",
        "u2-56-oligopoly-mcq-1",
        "u2-56-oligopoly-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-56-oligopoly",
        "locale": "zh-CN",
        "title": "寡头、相互依赖与博弈",
        "takeaway": "寡头由少数大企业主导，企业决策取决于竞争者反应。串谋可联合限制产量，但个别企业可能有背离协议的动机。",
        "definition": "寡头由少数大企业主导，企业决策取决于竞争者反应。串谋可联合限制产量，但个别企业可能有背离协议的动机。",
        "causalChain": [
          "少数企业反复互动",
          "价格或数量选择影响竞争者",
          "预期反应决定合作或竞争策略"
        ],
        "misconceptions": [
          "串谋的共同收益不保证协议稳定，也不代表消费者受益。"
        ],
        "examApplication": [
          "明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
        ],
        "summary": [
          "寡头由少数大企业主导，企业决策取决于竞争者反应。串谋可联合限制产量，但个别企业可能有背离协议的动机。",
          "串谋的共同收益不保证协议稳定，也不代表消费者受益。"
        ],
        "explanation": "少数企业反复互动。价格或数量选择影响竞争者。预期反应决定合作或竞争策略。\n\n### 原创情境与推导\n\n原创例：两家航空公司都高价时各赚 8；一方降价而对方高价时赚 12、对方赚 2；都降价时各赚 4。降价是各自优势策略，均衡为 4、4，尽管共同高价收益更高。数字是独立设计的教学支付矩阵。\n\n串谋的共同收益不保证协议稳定，也不代表消费者受益。\n\n明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
      },
      "en": {
        "id": "u2-56-oligopoly",
        "locale": "en",
        "title": "Oligopoly, interdependence and game theory",
        "takeaway": "Oligopoly is dominated by a few large firms whose decisions depend on rivals' reactions. Collusion can jointly restrict output, but individual firms may have incentives to deviate.",
        "definition": "Oligopoly is dominated by a few large firms whose decisions depend on rivals' reactions. Collusion can jointly restrict output, but individual firms may have incentives to deviate.",
        "causalChain": [
          "A few firms interact repeatedly",
          "price or quantity choices affect rivals",
          "anticipated responses shape cooperation and competition"
        ],
        "misconceptions": [
          "Joint gains do not ensure collusion is stable or beneficial to consumers."
        ],
        "examApplication": [
          "Separate firm and market diagrams, identify MR=MC output and read price from demand."
        ],
        "summary": [
          "Oligopoly is dominated by a few large firms whose decisions depend on rivals' reactions. Collusion can jointly restrict output, but individual firms may have incentives to deviate.",
          "Joint gains do not ensure collusion is stable or beneficial to consumers."
        ],
        "explanation": "A few firms interact repeatedly.  price or quantity choices affect rivals.  anticipated responses shape cooperation and competition.\n\n### Original scenario and reasoning\n\nIllustrative example: two airlines each earn eight at high prices. One cutting price alone earns 12 while the other earns two; both cutting earns four each. Cutting is each firm's dominant strategy, giving (4,4) despite higher joint gains at (8,8). The payoffs are original teaching assumptions.\n\nJoint gains do not ensure collusion is stable or beneficial to consumers.\n\nSeparate firm and market diagrams, identify MR=MC output and read price from demand."
      }
    },
    "practice": [
      {
        "id": "u2-56-oligopoly-flash-1",
        "knowledgePointId": "u2-56-oligopoly",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“寡头、相互依赖与博弈”，并说明一个关键条件。",
          "en": "Explain Oligopoly, interdependence and game theory and state one important condition."
        },
        "answer": {
          "zh-CN": "寡头由少数大企业主导，企业决策取决于竞争者反应。串谋可联合限制产量，但个别企业可能有背离协议的动机。",
          "en": "Oligopoly is dominated by a few large firms whose decisions depend on rivals' reactions. Collusion can jointly restrict output, but individual firms may have incentives to deviate."
        },
        "explanation": {
          "zh-CN": "串谋的共同收益不保证协议稳定，也不代表消费者受益。",
          "en": "Joint gains do not ensure collusion is stable or beneficial to consumers."
        }
      },
      {
        "id": "u2-56-oligopoly-mcq-1",
        "knowledgePointId": "u2-56-oligopoly",
        "type": "mcq",
        "prompt": {
          "zh-CN": "两企业都高价各赚8；单方降价赚12而另一方赚2；都降价各赚4。各自的优势策略是什么？",
          "en": "Both firms earn 8 at high prices; a sole price cutter earns 12 while its rival earns 2; both cutting gives 4 each. What is each firm's dominant strategy?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "维持高价",
            "en": "Keep price high"
          },
          {
            "id": "b",
            "zh-CN": "退出市场",
            "en": "Exit"
          },
          {
            "id": "c",
            "zh-CN": "不可能判断，尽管支付已给出",
            "en": "Impossible to determine despite stated payoffs"
          },
          {
            "id": "d",
            "zh-CN": "降价",
            "en": "Cut price"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "降价。 少数企业反复互动；价格或数量选择影响竞争者；预期反应决定合作或竞争策略 串谋的共同收益不保证协议稳定，也不代表消费者受益。",
          "en": "Cut price. A few firms interact repeatedly; price or quantity choices affect rivals; anticipated responses shape cooperation and competition Joint gains do not ensure collusion is stable or beneficial to consumers."
        }
      },
      {
        "id": "u2-56-oligopoly-short-1",
        "knowledgePointId": "u2-56-oligopoly",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释寡头、相互依赖与博弈的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Oligopoly, interdependence and game theory and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "寡头由少数大企业主导，企业决策取决于竞争者反应。串谋可联合限制产量，但个别企业可能有背离协议的动机。 少数企业反复互动；价格或数量选择影响竞争者；预期反应决定合作或竞争策略 原创例：两家航空公司都高价时各赚 8；一方降价而对方高价时赚 12、对方赚 2；都降价时各赚 4。降价是各自优势策略，均衡为 4、4，尽管共同高价收益更高。数字是独立设计的教学支付矩阵。",
          "en": "Oligopoly is dominated by a few large firms whose decisions depend on rivals' reactions. Collusion can jointly restrict output, but individual firms may have incentives to deviate. A few firms interact repeatedly; price or quantity choices affect rivals; anticipated responses shape cooperation and competition Illustrative example: two airlines each earn eight at high prices. One cutting price alone earns 12 while the other earns two; both cutting earns four each. Cutting is each firm's dominant strategy, giving (4,4) despite higher joint gains at (8,8). The payoffs are original teaching assumptions."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "相互依赖",
              "en": "interdependence"
            },
            "alternatives": {
              "zh-CN": [
                "相互依赖",
                "少数企业反复互动"
              ],
              "en": [
                "interdependence",
                "A few firms interact repeatedly"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "优势策略",
              "en": "dominant strategy"
            },
            "alternatives": {
              "zh-CN": [
                "优势策略",
                "价格或数量选择影响竞争者"
              ],
              "en": [
                "dominant strategy",
                "price or quantity choices affect rivals"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "背离",
              "en": "deviate"
            },
            "alternatives": {
              "zh-CN": [
                "背离",
                "预期反应决定合作或竞争策略"
              ],
              "en": [
                "deviate",
                "anticipated responses shape cooperation and competition"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-57-competition-policy",
      "slug": "competition-policy",
      "section": "2.11",
      "level": "hl",
      "syllabusRefs": [
        "2.11 Market power"
      ],
      "textbookRefs": [
        {
          "chapter": "7",
          "section": "7.7",
          "pages": [
            239
          ]
        }
      ],
      "prerequisites": [
        "u2-15-surplus-efficiency",
        "u2-10-costs-and-supply"
      ],
      "related": [
        "u2-47-market-structures",
        "u2-48-cost-curves",
        "u2-49-scale"
      ],
      "terms": [
        "竞争政策与市场势力评价",
        "Competition policy and evaluation of market power",
        "竞争",
        "competition",
        "规模效率",
        "scale efficiency",
        "监管",
        "regulation"
      ],
      "synonyms": {
        "zh-CN": [
          "竞争",
          "规模效率",
          "监管"
        ],
        "en": [
          "competition",
          "scale efficiency",
          "regulation"
        ]
      },
      "diagramIds": [
        "monopoly"
      ],
      "quizIds": [
        "u2-57-competition-policy-flash-1",
        "u2-57-competition-policy-mcq-1",
        "u2-57-competition-policy-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-57-competition-policy",
        "locale": "zh-CN",
        "title": "竞争政策与市场势力评价",
        "takeaway": "竞争政策可限制串谋、滥用支配地位和反竞争并购；评价需比较竞争、规模效率、创新和监管成本。",
        "definition": "竞争政策可限制串谋、滥用支配地位和反竞争并购；评价需比较竞争、规模效率、创新和监管成本。",
        "causalChain": [
          "识别市场势力来源和实际行为",
          "规制或促进进入",
          "比较价格、成本、创新和执行结果"
        ],
        "misconceptions": [
          "不能把企业数量增加当作效率提高的充分条件。"
        ],
        "examApplication": [
          "明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
        ],
        "summary": [
          "竞争政策可限制串谋、滥用支配地位和反竞争并购；评价需比较竞争、规模效率、创新和监管成本。",
          "不能把企业数量增加当作效率提高的充分条件。"
        ],
        "explanation": "识别市场势力来源和实际行为。规制或促进进入。比较价格、成本、创新和执行结果。\n\n### 原创情境与推导\n\n原创例：两家企业合并可减少竞争却节省物流成本。审批应比较消费者是否获得成本节省、进入是否可行及是否更易串谋。拆分自然垄断可能重复固定网络，因此不同市场需要不同措施。\n\n不能把企业数量增加当作效率提高的充分条件。\n\n明确企业图与市场图、MR=MC 数量及需求曲线上的价格。"
      },
      "en": {
        "id": "u2-57-competition-policy",
        "locale": "en",
        "title": "Competition policy and evaluation of market power",
        "takeaway": "Competition policy can address collusion, abuse of dominance and anticompetitive mergers. Evaluation weighs competition, scale efficiency, innovation and regulatory cost.",
        "definition": "Competition policy can address collusion, abuse of dominance and anticompetitive mergers. Evaluation weighs competition, scale efficiency, innovation and regulatory cost.",
        "causalChain": [
          "Identify the source of market power and actual conduct",
          "regulate or enable entry",
          "compare price, cost, innovation and implementation effects"
        ],
        "misconceptions": [
          "More firms is not a sufficient condition for improved efficiency."
        ],
        "examApplication": [
          "Separate firm and market diagrams, identify MR=MC output and read price from demand."
        ],
        "summary": [
          "Competition policy can address collusion, abuse of dominance and anticompetitive mergers. Evaluation weighs competition, scale efficiency, innovation and regulatory cost.",
          "More firms is not a sufficient condition for improved efficiency."
        ],
        "explanation": "Identify the source of market power and actual conduct.  regulate or enable entry.  compare price, cost, innovation and implementation effects.\n\n### Original scenario and reasoning\n\nIllustrative example: a merger may reduce competition but save logistics costs. Assess whether savings reach consumers, whether entry is feasible and whether coordination becomes easier. Splitting a natural monopoly may duplicate fixed networks, so remedies should reflect the market.\n\nMore firms is not a sufficient condition for improved efficiency.\n\nSeparate firm and market diagrams, identify MR=MC output and read price from demand."
      }
    },
    "practice": [
      {
        "id": "u2-57-competition-policy-flash-1",
        "knowledgePointId": "u2-57-competition-policy",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“竞争政策与市场势力评价”，并说明一个关键条件。",
          "en": "Explain Competition policy and evaluation of market power and state one important condition."
        },
        "answer": {
          "zh-CN": "竞争政策可限制串谋、滥用支配地位和反竞争并购；评价需比较竞争、规模效率、创新和监管成本。",
          "en": "Competition policy can address collusion, abuse of dominance and anticompetitive mergers. Evaluation weighs competition, scale efficiency, innovation and regulatory cost."
        },
        "explanation": {
          "zh-CN": "不能把企业数量增加当作效率提高的充分条件。",
          "en": "More firms is not a sufficient condition for improved efficiency."
        }
      },
      {
        "id": "u2-57-competition-policy-mcq-1",
        "knowledgePointId": "u2-57-competition-policy",
        "type": "mcq",
        "prompt": {
          "zh-CN": "并购评价最需要比较什么？",
          "en": "What is central to evaluating a merger?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "竞争损失与成本效率收益",
            "en": "Competition losses and cost-efficiency gains"
          },
          {
            "id": "b",
            "zh-CN": "只看合并后企业名称",
            "en": "Only the merged firm's name"
          },
          {
            "id": "c",
            "zh-CN": "所有并购都禁止",
            "en": "Ban every merger"
          },
          {
            "id": "d",
            "zh-CN": "所有并购都促进公平",
            "en": "All mergers promote equity"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "竞争损失与成本效率收益。 识别市场势力来源和实际行为；规制或促进进入；比较价格、成本、创新和执行结果 不能把企业数量增加当作效率提高的充分条件。",
          "en": "Competition losses and cost-efficiency gains. Identify the source of market power and actual conduct; regulate or enable entry; compare price, cost, innovation and implementation effects More firms is not a sufficient condition for improved efficiency."
        }
      },
      {
        "id": "u2-57-competition-policy-short-1",
        "knowledgePointId": "u2-57-competition-policy",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释竞争政策与市场势力评价的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Competition policy and evaluation of market power and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "竞争政策可限制串谋、滥用支配地位和反竞争并购；评价需比较竞争、规模效率、创新和监管成本。 识别市场势力来源和实际行为；规制或促进进入；比较价格、成本、创新和执行结果 原创例：两家企业合并可减少竞争却节省物流成本。审批应比较消费者是否获得成本节省、进入是否可行及是否更易串谋。拆分自然垄断可能重复固定网络，因此不同市场需要不同措施。",
          "en": "Competition policy can address collusion, abuse of dominance and anticompetitive mergers. Evaluation weighs competition, scale efficiency, innovation and regulatory cost. Identify the source of market power and actual conduct; regulate or enable entry; compare price, cost, innovation and implementation effects Illustrative example: a merger may reduce competition but save logistics costs. Assess whether savings reach consumers, whether entry is feasible and whether coordination becomes easier. Splitting a natural monopoly may duplicate fixed networks, so remedies should reflect the market."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "竞争",
              "en": "competition"
            },
            "alternatives": {
              "zh-CN": [
                "竞争",
                "识别市场势力来源和实际行为"
              ],
              "en": [
                "competition",
                "Identify the source of market power and actual conduct"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "规模效率",
              "en": "scale efficiency"
            },
            "alternatives": {
              "zh-CN": [
                "规模效率",
                "规制或促进进入"
              ],
              "en": [
                "scale efficiency",
                "regulate or enable entry"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "监管",
              "en": "regulation"
            },
            "alternatives": {
              "zh-CN": [
                "监管",
                "比较价格、成本、创新和执行结果"
              ],
              "en": [
                "regulation",
                "compare price, cost, innovation and implementation effects"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-58-equity-distribution",
      "slug": "equity-distribution",
      "section": "2.12",
      "level": "hl",
      "syllabusRefs": [
        "2.12 Markets and equity"
      ],
      "textbookRefs": [
        {
          "chapter": "6",
          "section": "6.5",
          "pages": [
            191
          ]
        }
      ],
      "prerequisites": [
        "u1-35-equality-equity"
      ],
      "related": [
        "u2-59-income-wealth",
        "u2-60-redistribution"
      ],
      "terms": [
        "市场分配与公平",
        "Market distribution and equity",
        "收入",
        "income",
        "公平",
        "equity",
        "效率",
        "efficiency"
      ],
      "synonyms": {
        "zh-CN": [
          "收入",
          "公平",
          "效率"
        ],
        "en": [
          "income",
          "equity",
          "efficiency"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-58-equity-distribution-flash-1",
        "u2-58-equity-distribution-mcq-1",
        "u2-58-equity-distribution-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-58-equity-distribution",
        "locale": "zh-CN",
        "title": "市场分配与公平",
        "takeaway": "市场按收入与资产决定购买能力；配置效率并不保证分配公平。公平是规范性判断，平等描述分配相同程度。",
        "definition": "市场按收入与资产决定购买能力；配置效率并不保证分配公平。公平是规范性判断，平等描述分配相同程度。",
        "causalChain": [
          "资产和要素回报形成收入差异",
          "收入差异影响有效需求",
          "市场配置可能有效却不符合社会公平标准"
        ],
        "misconceptions": [
          "配置效率与公平可能冲突，也可能通过针对性政策共同改善。"
        ],
        "examApplication": [
          "明确公平标准，比较效率、机会、激励和政策针对性。"
        ],
        "summary": [
          "市场按收入与资产决定购买能力；配置效率并不保证分配公平。公平是规范性判断，平等描述分配相同程度。",
          "配置效率与公平可能冲突，也可能通过针对性政策共同改善。"
        ],
        "explanation": "资产和要素回报形成收入差异。收入差异影响有效需求。市场配置可能有效却不符合社会公平标准。\n\n### 原创情境与推导\n\n原创例：两户的支付意愿相同，但一户收入低而买不起教育。市场需求表达的是愿意且能够购买，不是所有人的需要。评价应明确公平标准，而非把任何差异自动称为不公。\n\n配置效率与公平可能冲突，也可能通过针对性政策共同改善。\n\n明确公平标准，比较效率、机会、激励和政策针对性。"
      },
      "en": {
        "id": "u2-58-equity-distribution",
        "locale": "en",
        "title": "Market distribution and equity",
        "takeaway": "Markets distribute purchasing power through income and assets. Allocative efficiency does not guarantee equitable distribution. Equity is a normative judgement; equality describes sameness of distribution.",
        "definition": "Markets distribute purchasing power through income and assets. Allocative efficiency does not guarantee equitable distribution. Equity is a normative judgement; equality describes sameness of distribution.",
        "causalChain": [
          "Assets and factor returns generate income differences",
          "income differences affect effective demand",
          "efficient market allocation may fail society's equity criteria"
        ],
        "misconceptions": [
          "Efficiency and equity can conflict, but targeted policy may improve both."
        ],
        "examApplication": [
          "State the equity criterion and compare efficiency, opportunity, incentives and targeting."
        ],
        "summary": [
          "Markets distribute purchasing power through income and assets. Allocative efficiency does not guarantee equitable distribution. Equity is a normative judgement; equality describes sameness of distribution.",
          "Efficiency and equity can conflict, but targeted policy may improve both."
        ],
        "explanation": "Assets and factor returns generate income differences.  income differences affect effective demand.  efficient market allocation may fail society's equity criteria.\n\n### Original scenario and reasoning\n\nIllustrative example: two households want education equally but one cannot afford it. Market demand reflects willingness and ability to pay, not every person's need. State the equity criterion rather than automatically labelling all differences unfair.\n\nEfficiency and equity can conflict, but targeted policy may improve both.\n\nState the equity criterion and compare efficiency, opportunity, incentives and targeting."
      }
    },
    "practice": [
      {
        "id": "u2-58-equity-distribution-flash-1",
        "knowledgePointId": "u2-58-equity-distribution",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“市场分配与公平”，并说明一个关键条件。",
          "en": "Explain Market distribution and equity and state one important condition."
        },
        "answer": {
          "zh-CN": "市场按收入与资产决定购买能力；配置效率并不保证分配公平。公平是规范性判断，平等描述分配相同程度。",
          "en": "Markets distribute purchasing power through income and assets. Allocative efficiency does not guarantee equitable distribution. Equity is a normative judgement; equality describes sameness of distribution."
        },
        "explanation": {
          "zh-CN": "配置效率与公平可能冲突，也可能通过针对性政策共同改善。",
          "en": "Efficiency and equity can conflict, but targeted policy may improve both."
        }
      },
      {
        "id": "u2-58-equity-distribution-mcq-1",
        "knowledgePointId": "u2-58-equity-distribution",
        "type": "mcq",
        "prompt": {
          "zh-CN": "配置有效的市场是否必然分配公平？",
          "en": "Must an allocatively efficient market distribute outcomes equitably?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "是，定义相同",
            "en": "Yes, the definitions are identical"
          },
          {
            "id": "b",
            "zh-CN": "否，两者评价标准不同",
            "en": "No, the criteria differ"
          },
          {
            "id": "c",
            "zh-CN": "是，所有收入相等",
            "en": "Yes, all incomes are equal"
          },
          {
            "id": "d",
            "zh-CN": "公平只指价格为零",
            "en": "Equity only means a zero price"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "否，两者评价标准不同。 资产和要素回报形成收入差异；收入差异影响有效需求；市场配置可能有效却不符合社会公平标准 配置效率与公平可能冲突，也可能通过针对性政策共同改善。",
          "en": "No, the criteria differ. Assets and factor returns generate income differences; income differences affect effective demand; efficient market allocation may fail society's equity criteria Efficiency and equity can conflict, but targeted policy may improve both."
        }
      },
      {
        "id": "u2-58-equity-distribution-short-1",
        "knowledgePointId": "u2-58-equity-distribution",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释市场分配与公平的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Market distribution and equity and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "市场按收入与资产决定购买能力；配置效率并不保证分配公平。公平是规范性判断，平等描述分配相同程度。 资产和要素回报形成收入差异；收入差异影响有效需求；市场配置可能有效却不符合社会公平标准 原创例：两户的支付意愿相同，但一户收入低而买不起教育。市场需求表达的是愿意且能够购买，不是所有人的需要。评价应明确公平标准，而非把任何差异自动称为不公。",
          "en": "Markets distribute purchasing power through income and assets. Allocative efficiency does not guarantee equitable distribution. Equity is a normative judgement; equality describes sameness of distribution. Assets and factor returns generate income differences; income differences affect effective demand; efficient market allocation may fail society's equity criteria Illustrative example: two households want education equally but one cannot afford it. Market demand reflects willingness and ability to pay, not every person's need. State the equity criterion rather than automatically labelling all differences unfair."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "收入",
              "en": "income"
            },
            "alternatives": {
              "zh-CN": [
                "收入",
                "资产和要素回报形成收入差异"
              ],
              "en": [
                "income",
                "Assets and factor returns generate income differences"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "公平",
              "en": "equity"
            },
            "alternatives": {
              "zh-CN": [
                "公平",
                "收入差异影响有效需求"
              ],
              "en": [
                "equity",
                "income differences affect effective demand"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "效率",
              "en": "efficiency"
            },
            "alternatives": {
              "zh-CN": [
                "效率",
                "市场配置可能有效却不符合社会公平标准"
              ],
              "en": [
                "efficiency",
                "efficient market allocation may fail society's equity criteria"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-59-income-wealth",
      "slug": "income-wealth",
      "section": "2.12",
      "level": "hl",
      "syllabusRefs": [
        "2.12 Markets and equity"
      ],
      "textbookRefs": [
        {
          "chapter": "6",
          "section": "6.5",
          "pages": [
            191
          ]
        }
      ],
      "prerequisites": [
        "u1-35-equality-equity"
      ],
      "related": [
        "u2-58-equity-distribution",
        "u2-60-redistribution"
      ],
      "terms": [
        "收入、财富与机会",
        "Income, wealth and opportunity",
        "流量",
        "flow",
        "存量",
        "stock",
        "资产减负债",
        "assets minus liabilities"
      ],
      "synonyms": {
        "zh-CN": [
          "流量",
          "存量",
          "资产减负债"
        ],
        "en": [
          "flow",
          "stock",
          "assets minus liabilities"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-59-income-wealth-flash-1",
        "u2-59-income-wealth-mcq-1",
        "u2-59-income-wealth-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-59-income-wealth",
        "locale": "zh-CN",
        "title": "收入、财富与机会",
        "takeaway": "收入是一定时期的流量，财富是某时点净资产的存量；资产、技能、继承和市场势力会影响经济机会与分配。",
        "definition": "收入是一定时期的流量，财富是某时点净资产的存量；资产、技能、继承和市场势力会影响经济机会与分配。",
        "causalChain": [
          "资产与教育条件不同",
          "影响收入和未来资产积累",
          "机会差异可能跨代持续"
        ],
        "misconceptions": [
          "财富是资产减负债，不是把当年收入加到资产中重复计算。"
        ],
        "examApplication": [
          "明确公平标准，比较效率、机会、激励和政策针对性。"
        ],
        "summary": [
          "收入是一定时期的流量，财富是某时点净资产的存量；资产、技能、继承和市场势力会影响经济机会与分配。",
          "财富是资产减负债，不是把当年收入加到资产中重复计算。"
        ],
        "explanation": "资产与教育条件不同。影响收入和未来资产积累。机会差异可能跨代持续。\n\n### 原创情境与推导\n\n原创例：家庭年收入 30 万、资产 200 万、负债 80 万，净财富为 120 万。收入与财富可不一致，退休者可能收入低而财富高。判断政策受益者不能只看单一指标。\n\n财富是资产减负债，不是把当年收入加到资产中重复计算。\n\n明确公平标准，比较效率、机会、激励和政策针对性。"
      },
      "en": {
        "id": "u2-59-income-wealth",
        "locale": "en",
        "title": "Income, wealth and opportunity",
        "takeaway": "Income is a flow over a period; wealth is a stock of net assets at a date. Assets, skills, inheritance and market power influence opportunities and distribution.",
        "definition": "Income is a flow over a period; wealth is a stock of net assets at a date. Assets, skills, inheritance and market power influence opportunities and distribution.",
        "causalChain": [
          "Assets and educational conditions differ",
          "income and future asset accumulation respond",
          "opportunity gaps may persist across generations"
        ],
        "misconceptions": [
          "Wealth is assets minus liabilities, not assets plus the year's income counted again."
        ],
        "examApplication": [
          "State the equity criterion and compare efficiency, opportunity, incentives and targeting."
        ],
        "summary": [
          "Income is a flow over a period; wealth is a stock of net assets at a date. Assets, skills, inheritance and market power influence opportunities and distribution.",
          "Wealth is assets minus liabilities, not assets plus the year's income counted again."
        ],
        "explanation": "Assets and educational conditions differ.  income and future asset accumulation respond.  opportunity gaps may persist across generations.\n\n### Original scenario and reasoning\n\nIllustrative example: a household earns 300,000 yearly, owns assets of two million and owes 800,000: net wealth is 1.2 million. Income and wealth can diverge, as for a retired asset owner. A single measure may misidentify policy beneficiaries.\n\nWealth is assets minus liabilities, not assets plus the year's income counted again.\n\nState the equity criterion and compare efficiency, opportunity, incentives and targeting."
      }
    },
    "practice": [
      {
        "id": "u2-59-income-wealth-flash-1",
        "knowledgePointId": "u2-59-income-wealth",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“收入、财富与机会”，并说明一个关键条件。",
          "en": "Explain Income, wealth and opportunity and state one important condition."
        },
        "answer": {
          "zh-CN": "收入是一定时期的流量，财富是某时点净资产的存量；资产、技能、继承和市场势力会影响经济机会与分配。",
          "en": "Income is a flow over a period; wealth is a stock of net assets at a date. Assets, skills, inheritance and market power influence opportunities and distribution."
        },
        "explanation": {
          "zh-CN": "财富是资产减负债，不是把当年收入加到资产中重复计算。",
          "en": "Wealth is assets minus liabilities, not assets plus the year's income counted again."
        }
      },
      {
        "id": "u2-59-income-wealth-mcq-1",
        "knowledgePointId": "u2-59-income-wealth",
        "type": "mcq",
        "prompt": {
          "zh-CN": "资产 90、负债 35，净财富多少？",
          "en": "Assets are 90 and liabilities 35. What is net wealth?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "125",
            "en": "125"
          },
          {
            "id": "b",
            "zh-CN": "90",
            "en": "90"
          },
          {
            "id": "c",
            "zh-CN": "55",
            "en": "55"
          },
          {
            "id": "d",
            "zh-CN": "35",
            "en": "35"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "55。 90 − 35 = 55 财富是资产减负债，不是把当年收入加到资产中重复计算。",
          "en": "55. 90 − 35 = 55 Wealth is assets minus liabilities, not assets plus the year's income counted again."
        }
      },
      {
        "id": "u2-59-income-wealth-short-1",
        "knowledgePointId": "u2-59-income-wealth",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释收入、财富与机会的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Income, wealth and opportunity and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "收入是一定时期的流量，财富是某时点净资产的存量；资产、技能、继承和市场势力会影响经济机会与分配。 资产与教育条件不同；影响收入和未来资产积累；机会差异可能跨代持续 原创例：家庭年收入 30 万、资产 200 万、负债 80 万，净财富为 120 万。收入与财富可不一致，退休者可能收入低而财富高。判断政策受益者不能只看单一指标。",
          "en": "Income is a flow over a period; wealth is a stock of net assets at a date. Assets, skills, inheritance and market power influence opportunities and distribution. Assets and educational conditions differ; income and future asset accumulation respond; opportunity gaps may persist across generations Illustrative example: a household earns 300,000 yearly, owns assets of two million and owes 800,000: net wealth is 1.2 million. Income and wealth can diverge, as for a retired asset owner. A single measure may misidentify policy beneficiaries."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "流量",
              "en": "flow"
            },
            "alternatives": {
              "zh-CN": [
                "流量",
                "资产与教育条件不同"
              ],
              "en": [
                "flow",
                "Assets and educational conditions differ"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "存量",
              "en": "stock"
            },
            "alternatives": {
              "zh-CN": [
                "存量",
                "影响收入和未来资产积累"
              ],
              "en": [
                "stock",
                "income and future asset accumulation respond"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "资产减负债",
              "en": "assets minus liabilities"
            },
            "alternatives": {
              "zh-CN": [
                "资产减负债",
                "机会差异可能跨代持续"
              ],
              "en": [
                "assets minus liabilities",
                "opportunity gaps may persist across generations"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u2-60-redistribution",
      "slug": "redistribution",
      "section": "2.12",
      "level": "hl",
      "syllabusRefs": [
        "2.12 Markets and equity"
      ],
      "textbookRefs": [
        {
          "chapter": "6",
          "section": "6.5",
          "pages": [
            191
          ]
        }
      ],
      "prerequisites": [
        "u1-35-equality-equity"
      ],
      "related": [
        "u2-58-equity-distribution",
        "u2-59-income-wealth"
      ],
      "terms": [
        "再分配与政策权衡",
        "Redistribution and policy trade-offs",
        "针对性",
        "targeting",
        "机会",
        "opportunity",
        "激励",
        "incentives"
      ],
      "synonyms": {
        "zh-CN": [
          "针对性",
          "机会",
          "激励"
        ],
        "en": [
          "targeting",
          "opportunity",
          "incentives"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u2-60-redistribution-flash-1",
        "u2-60-redistribution-mcq-1",
        "u2-60-redistribution-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u2-60-redistribution",
        "locale": "zh-CN",
        "title": "再分配与政策权衡",
        "takeaway": "税收、转移支付和公共服务可改变市场分配；评价应兼顾针对性、机会、工作激励、融资和行政能力。",
        "definition": "税收、转移支付和公共服务可改变市场分配；评价应兼顾针对性、机会、工作激励、融资和行政能力。",
        "causalChain": [
          "政策筹资并确定受益对象",
          "改变可支配收入或服务获得",
          "观察贫困、公平和行为反应"
        ],
        "misconceptions": [
          "再分配不只是现金，也包括教育、医疗等实物服务。"
        ],
        "examApplication": [
          "明确公平标准，比较效率、机会、激励和政策针对性。"
        ],
        "summary": [
          "税收、转移支付和公共服务可改变市场分配；评价应兼顾针对性、机会、工作激励、融资和行政能力。",
          "再分配不只是现金，也包括教育、医疗等实物服务。"
        ],
        "explanation": "政策筹资并确定受益对象。改变可支配收入或服务获得。观察贫困、公平和行为反应。\n\n### 原创情境与推导\n\n原创例：向低收入家庭提供教育补助可能同时改善机会和生产能力。收入审查提高针对性，但可能遗漏没有完整记录的家庭；福利逐步退出可减弱突然丧失福利造成的高有效边际税率。\n\n再分配不只是现金，也包括教育、医疗等实物服务。\n\n明确公平标准，比较效率、机会、激励和政策针对性。"
      },
      "en": {
        "id": "u2-60-redistribution",
        "locale": "en",
        "title": "Redistribution and policy trade-offs",
        "takeaway": "Taxes, transfers and public services can alter market distribution. Evaluate targeting, opportunity, work incentives, financing and administrative capacity.",
        "definition": "Taxes, transfers and public services can alter market distribution. Evaluate targeting, opportunity, work incentives, financing and administrative capacity.",
        "causalChain": [
          "Policy raises funds and identifies beneficiaries",
          "disposable income or access to services changes",
          "assess poverty, equity and behavioural responses"
        ],
        "misconceptions": [
          "Redistribution includes services such as education and healthcare, not just cash."
        ],
        "examApplication": [
          "State the equity criterion and compare efficiency, opportunity, incentives and targeting."
        ],
        "summary": [
          "Taxes, transfers and public services can alter market distribution. Evaluate targeting, opportunity, work incentives, financing and administrative capacity.",
          "Redistribution includes services such as education and healthcare, not just cash."
        ],
        "explanation": "Policy raises funds and identifies beneficiaries.  disposable income or access to services changes.  assess poverty, equity and behavioural responses.\n\n### Original scenario and reasoning\n\nIllustrative example: education support for low-income households can improve opportunity and productive capacity. Means testing improves targeting but may exclude households without records. Gradual withdrawal can reduce high effective marginal tax rates from abrupt benefit loss.\n\nRedistribution includes services such as education and healthcare, not just cash.\n\nState the equity criterion and compare efficiency, opportunity, incentives and targeting."
      }
    },
    "practice": [
      {
        "id": "u2-60-redistribution-flash-1",
        "knowledgePointId": "u2-60-redistribution",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“再分配与政策权衡”，并说明一个关键条件。",
          "en": "Explain Redistribution and policy trade-offs and state one important condition."
        },
        "answer": {
          "zh-CN": "税收、转移支付和公共服务可改变市场分配；评价应兼顾针对性、机会、工作激励、融资和行政能力。",
          "en": "Taxes, transfers and public services can alter market distribution. Evaluate targeting, opportunity, work incentives, financing and administrative capacity."
        },
        "explanation": {
          "zh-CN": "再分配不只是现金，也包括教育、医疗等实物服务。",
          "en": "Redistribution includes services such as education and healthcare, not just cash."
        }
      },
      {
        "id": "u2-60-redistribution-mcq-1",
        "knowledgePointId": "u2-60-redistribution",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪项能改善再分配评价的完整性？",
          "en": "Which makes redistribution evaluation more complete?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "假设行政成本为零",
            "en": "Assume zero administrative cost"
          },
          {
            "id": "b",
            "zh-CN": "只看名义转移金额",
            "en": "Look only at the nominal transfer"
          },
          {
            "id": "c",
            "zh-CN": "认为政策不需要融资",
            "en": "Assume no financing is needed"
          },
          {
            "id": "d",
            "zh-CN": "同时考察覆盖遗漏和工作激励",
            "en": "Consider exclusion errors and work incentives"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "同时考察覆盖遗漏和工作激励。 政策筹资并确定受益对象；改变可支配收入或服务获得；观察贫困、公平和行为反应 再分配不只是现金，也包括教育、医疗等实物服务。",
          "en": "Consider exclusion errors and work incentives. Policy raises funds and identifies beneficiaries; disposable income or access to services changes; assess poverty, equity and behavioural responses Redistribution includes services such as education and healthcare, not just cash."
        }
      },
      {
        "id": "u2-60-redistribution-short-1",
        "knowledgePointId": "u2-60-redistribution",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释再分配与政策权衡的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Redistribution and policy trade-offs and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "税收、转移支付和公共服务可改变市场分配；评价应兼顾针对性、机会、工作激励、融资和行政能力。 政策筹资并确定受益对象；改变可支配收入或服务获得；观察贫困、公平和行为反应 原创例：向低收入家庭提供教育补助可能同时改善机会和生产能力。收入审查提高针对性，但可能遗漏没有完整记录的家庭；福利逐步退出可减弱突然丧失福利造成的高有效边际税率。",
          "en": "Taxes, transfers and public services can alter market distribution. Evaluate targeting, opportunity, work incentives, financing and administrative capacity. Policy raises funds and identifies beneficiaries; disposable income or access to services changes; assess poverty, equity and behavioural responses Illustrative example: education support for low-income households can improve opportunity and productive capacity. Means testing improves targeting but may exclude households without records. Gradual withdrawal can reduce high effective marginal tax rates from abrupt benefit loss."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "针对性",
              "en": "targeting"
            },
            "alternatives": {
              "zh-CN": [
                "针对性",
                "政策筹资并确定受益对象"
              ],
              "en": [
                "targeting",
                "Policy raises funds and identifies beneficiaries"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "机会",
              "en": "opportunity"
            },
            "alternatives": {
              "zh-CN": [
                "机会",
                "改变可支配收入或服务获得"
              ],
              "en": [
                "opportunity",
                "disposable income or access to services changes"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "激励",
              "en": "incentives"
            },
            "alternatives": {
              "zh-CN": [
                "激励",
                "观察贫困、公平和行为反应"
              ],
              "en": [
                "incentives",
                "assess poverty, equity and behavioural responses"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-01-circular-flow",
      "slug": "circular-flow",
      "section": "3.1",
      "level": "core",
      "syllabusRefs": [
        "3.1 Measuring economic activity and its variations"
      ],
      "textbookRefs": [
        {
          "chapter": "8",
          "section": "8.1",
          "pages": [
            248
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u3-02-gdp",
        "u3-03-expenditure",
        "u3-04-nominal-real"
      ],
      "terms": [
        "收入循环与五部门经济",
        "Circular flow and the five-sector economy",
        "漏出",
        "leakages",
        "注入",
        "injections",
        "收入",
        "income"
      ],
      "synonyms": {
        "zh-CN": [
          "漏出",
          "注入",
          "收入"
        ],
        "en": [
          "leakages",
          "injections",
          "income"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-01-circular-flow-flash-1",
        "u3-01-circular-flow-mcq-1",
        "u3-01-circular-flow-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-01-circular-flow",
        "locale": "zh-CN",
        "title": "收入循环与五部门经济",
        "takeaway": "收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。",
        "definition": "收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。",
        "causalChain": [
          "家庭提供生产要素获得收入",
          "收入用于消费或漏出",
          "注入支出支持企业销售与下一轮收入"
        ],
        "misconceptions": [
          "储蓄不是消失的货币；金融部门可将资金引向投资，但不能假设两者自动同时相等。"
        ],
        "examApplication": [
          "写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
        ],
        "summary": [
          "收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。",
          "储蓄不是消失的货币；金融部门可将资金引向投资，但不能假设两者自动同时相等。"
        ],
        "explanation": "家庭提供生产要素获得收入。收入用于消费或漏出。注入支出支持企业销售与下一轮收入。\n\n### 原创情境与推导\n\n原创例：家庭向企业提供劳动并获得工资，再购买企业产出。储蓄 S、税收 T、进口 M 是漏出，投资 I、政府购买 G、出口 X 是注入。简单稳定均衡要求计划注入与漏出相等；这不是说各项分别相等。\n\n储蓄不是消失的货币；金融部门可将资金引向投资，但不能假设两者自动同时相等。\n\n写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
      },
      "en": {
        "id": "u3-01-circular-flow",
        "locale": "en",
        "title": "Circular flow and the five-sector economy",
        "takeaway": "The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions.",
        "definition": "The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions.",
        "causalChain": [
          "Households supply factors and receive income",
          "income funds consumption or leakages",
          "injections support firms' sales and the next round of income"
        ],
        "misconceptions": [
          "Saving is not money that vanishes; finance can channel funds into investment without making planned saving and investment automatically identical."
        ],
        "examApplication": [
          "State indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
        ],
        "summary": [
          "The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions.",
          "Saving is not money that vanishes; finance can channel funds into investment without making planned saving and investment automatically identical."
        ],
        "explanation": "Households supply factors and receive income.  income funds consumption or leakages.  injections support firms' sales and the next round of income.\n\n### Original scenario and reasoning\n\nIllustrative example: households supply labour, receive wages and buy firms' output. S, T and M are leakages; I, G and X are injections. Simple steady equilibrium requires planned injections to equal planned leakages, not each individual item to equal its counterpart.\n\nSaving is not money that vanishes; finance can channel funds into investment without making planned saving and investment automatically identical.\n\nState indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
      }
    },
    "practice": [
      {
        "id": "u3-01-circular-flow-flash-1",
        "knowledgePointId": "u3-01-circular-flow",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“收入循环与五部门经济”，并说明一个关键条件。",
          "en": "Explain Circular flow and the five-sector economy and state one important condition."
        },
        "answer": {
          "zh-CN": "收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。",
          "en": "The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions."
        },
        "explanation": {
          "zh-CN": "储蓄不是消失的货币；金融部门可将资金引向投资，但不能假设两者自动同时相等。",
          "en": "Saving is not money that vanishes; finance can channel funds into investment without making planned saving and investment automatically identical."
        }
      },
      {
        "id": "u3-01-circular-flow-mcq-1",
        "knowledgePointId": "u3-01-circular-flow",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪一项是收入循环的注入？",
          "en": "Which is an injection into the circular flow?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "出口 X",
            "en": "Exports X"
          },
          {
            "id": "b",
            "zh-CN": "储蓄 S",
            "en": "Saving S"
          },
          {
            "id": "c",
            "zh-CN": "税收 T",
            "en": "Taxes T"
          },
          {
            "id": "d",
            "zh-CN": "进口 M",
            "en": "Imports M"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "出口 X。 家庭提供生产要素获得收入；收入用于消费或漏出；注入支出支持企业销售与下一轮收入 储蓄不是消失的货币；金融部门可将资金引向投资，但不能假设两者自动同时相等。",
          "en": "Exports X. Households supply factors and receive income; income funds consumption or leakages; injections support firms' sales and the next round of income Saving is not money that vanishes; finance can channel funds into investment without making planned saving and investment automatically identical."
        }
      },
      {
        "id": "u3-01-circular-flow-short-1",
        "knowledgePointId": "u3-01-circular-flow",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释收入循环与五部门经济的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Circular flow and the five-sector economy and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "收入循环描述家庭、企业、金融部门、政府和国外之间的收入、支出与生产联系；实际流量与货币流量方向通常相反。 家庭提供生产要素获得收入；收入用于消费或漏出；注入支出支持企业销售与下一轮收入 原创例：家庭向企业提供劳动并获得工资，再购买企业产出。储蓄 S、税收 T、进口 M 是漏出，投资 I、政府购买 G、出口 X 是注入。简单稳定均衡要求计划注入与漏出相等；这不是说各项分别相等。",
          "en": "The circular flow links income, spending and production among households, firms, finance, government and the foreign sector. Real and monetary flows normally run in opposite directions. Households supply factors and receive income; income funds consumption or leakages; injections support firms' sales and the next round of income Illustrative example: households supply labour, receive wages and buy firms' output. S, T and M are leakages; I, G and X are injections. Simple steady equilibrium requires planned injections to equal planned leakages, not each individual item to equal its counterpart."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "漏出",
              "en": "leakages"
            },
            "alternatives": {
              "zh-CN": [
                "漏出",
                "家庭提供生产要素获得收入"
              ],
              "en": [
                "leakages",
                "Households supply factors and receive income"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "注入",
              "en": "injections"
            },
            "alternatives": {
              "zh-CN": [
                "注入",
                "收入用于消费或漏出"
              ],
              "en": [
                "injections",
                "income funds consumption or leakages"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "收入",
              "en": "income"
            },
            "alternatives": {
              "zh-CN": [
                "收入",
                "注入支出支持企业销售与下一轮收入"
              ],
              "en": [
                "income",
                "injections support firms' sales and the next round of income"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-02-gdp",
      "slug": "gdp",
      "section": "3.1",
      "level": "core",
      "syllabusRefs": [
        "3.1 Measuring economic activity and its variations"
      ],
      "textbookRefs": [
        {
          "chapter": "8",
          "section": "8.2",
          "pages": [
            250
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u3-01-circular-flow",
        "u3-03-expenditure",
        "u3-04-nominal-real"
      ],
      "terms": [
        "国内生产总值与增加值",
        "GDP and value added",
        "最终",
        "final",
        "境内",
        "domestic",
        "增加值",
        "value added"
      ],
      "synonyms": {
        "zh-CN": [
          "最终",
          "境内",
          "增加值"
        ],
        "en": [
          "final",
          "domestic",
          "value added"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-02-gdp-flash-1",
        "u3-02-gdp-mcq-1",
        "u3-02-gdp-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-02-gdp",
        "locale": "zh-CN",
        "title": "国内生产总值与增加值",
        "takeaway": "GDP 是一定时期在一国境内生产的最终商品与服务的市场价值；按增加值核算可避免中间产品重复计算。",
        "definition": "GDP 是一定时期在一国境内生产的最终商品与服务的市场价值；按增加值核算可避免中间产品重复计算。",
        "causalChain": [
          "各生产阶段创造增加值",
          "加总境内当期最终产出价值",
          "生产、收入与支出在核算上相互对应"
        ],
        "misconceptions": [
          "GDP 的境内标准与企业所有者国籍不同。"
        ],
        "examApplication": [
          "写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
        ],
        "summary": [
          "GDP 是一定时期在一国境内生产的最终商品与服务的市场价值；按增加值核算可避免中间产品重复计算。",
          "GDP 的境内标准与企业所有者国籍不同。"
        ],
        "explanation": "各生产阶段创造增加值。加总境内当期最终产出价值。生产、收入与支出在核算上相互对应。\n\n### 原创情境与推导\n\n原创例：农户卖谷物 20、磨坊卖面粉 35、面包店最终卖面包 60，增加值为 20+15+25=60，而非销售额相加的 115。购买旧房本身不是当期新产出，但当期中介服务可计入。\n\nGDP 的境内标准与企业所有者国籍不同。\n\n写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
      },
      "en": {
        "id": "u3-02-gdp",
        "locale": "en",
        "title": "GDP and value added",
        "takeaway": "GDP is the market value of final goods and services produced within a country during a period. Summing value added avoids double counting intermediate products.",
        "definition": "GDP is the market value of final goods and services produced within a country during a period. Summing value added avoids double counting intermediate products.",
        "causalChain": [
          "Each production stage adds value",
          "sum current domestic final output value",
          "production, income and expenditure correspond in national accounts"
        ],
        "misconceptions": [
          "GDP follows domestic production, not the nationality of a firm's owners."
        ],
        "examApplication": [
          "State indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
        ],
        "summary": [
          "GDP is the market value of final goods and services produced within a country during a period. Summing value added avoids double counting intermediate products.",
          "GDP follows domestic production, not the nationality of a firm's owners."
        ],
        "explanation": "Each production stage adds value.  sum current domestic final output value.  production, income and expenditure correspond in national accounts.\n\n### Original scenario and reasoning\n\nIllustrative example: grain sells for 20, flour for 35 and final bread for 60. Value added is 20+15+25=60, not sales summed to 115. Buying an existing house is not new current output, although current brokerage services can count.\n\nGDP follows domestic production, not the nationality of a firm's owners.\n\nState indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
      }
    },
    "practice": [
      {
        "id": "u3-02-gdp-flash-1",
        "knowledgePointId": "u3-02-gdp",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“国内生产总值与增加值”，并说明一个关键条件。",
          "en": "Explain GDP and value added and state one important condition."
        },
        "answer": {
          "zh-CN": "GDP 是一定时期在一国境内生产的最终商品与服务的市场价值；按增加值核算可避免中间产品重复计算。",
          "en": "GDP is the market value of final goods and services produced within a country during a period. Summing value added avoids double counting intermediate products."
        },
        "explanation": {
          "zh-CN": "GDP 的境内标准与企业所有者国籍不同。",
          "en": "GDP follows domestic production, not the nationality of a firm's owners."
        }
      },
      {
        "id": "u3-02-gdp-mcq-1",
        "knowledgePointId": "u3-02-gdp",
        "type": "mcq",
        "prompt": {
          "zh-CN": "中间品 30、最终品 80，只有这条产业链时应计多少最终产出？",
          "en": "Intermediate output sells for 30 and final output for 80 in a single production chain. What final output value counts?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "110",
            "en": "110"
          },
          {
            "id": "b",
            "zh-CN": "80",
            "en": "80"
          },
          {
            "id": "c",
            "zh-CN": "30",
            "en": "30"
          },
          {
            "id": "d",
            "zh-CN": "2400",
            "en": "2400"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "80。 80 (30 is intermediate output) GDP 的境内标准与企业所有者国籍不同。",
          "en": "80. 80 (30 is intermediate output) GDP follows domestic production, not the nationality of a firm's owners."
        }
      },
      {
        "id": "u3-02-gdp-short-1",
        "knowledgePointId": "u3-02-gdp",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释国内生产总值与增加值的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of GDP and value added and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "GDP 是一定时期在一国境内生产的最终商品与服务的市场价值；按增加值核算可避免中间产品重复计算。 各生产阶段创造增加值；加总境内当期最终产出价值；生产、收入与支出在核算上相互对应 原创例：农户卖谷物 20、磨坊卖面粉 35、面包店最终卖面包 60，增加值为 20+15+25=60，而非销售额相加的 115。购买旧房本身不是当期新产出，但当期中介服务可计入。",
          "en": "GDP is the market value of final goods and services produced within a country during a period. Summing value added avoids double counting intermediate products. Each production stage adds value; sum current domestic final output value; production, income and expenditure correspond in national accounts Illustrative example: grain sells for 20, flour for 35 and final bread for 60. Value added is 20+15+25=60, not sales summed to 115. Buying an existing house is not new current output, although current brokerage services can count."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "最终",
              "en": "final"
            },
            "alternatives": {
              "zh-CN": [
                "最终",
                "各生产阶段创造增加值"
              ],
              "en": [
                "final",
                "Each production stage adds value"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "境内",
              "en": "domestic"
            },
            "alternatives": {
              "zh-CN": [
                "境内",
                "加总境内当期最终产出价值"
              ],
              "en": [
                "domestic",
                "sum current domestic final output value"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "增加值",
              "en": "value added"
            },
            "alternatives": {
              "zh-CN": [
                "增加值",
                "生产、收入与支出在核算上相互对应"
              ],
              "en": [
                "value added",
                "production, income and expenditure correspond in national accounts"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-03-expenditure",
      "slug": "expenditure",
      "section": "3.1",
      "level": "core",
      "syllabusRefs": [
        "3.1 Measuring economic activity and its variations"
      ],
      "textbookRefs": [
        {
          "chapter": "8",
          "section": "8.3",
          "pages": [
            256
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u3-01-circular-flow",
        "u3-02-gdp",
        "u3-04-nominal-real"
      ],
      "terms": [
        "支出法 GDP",
        "GDP by expenditure",
        "消费",
        "consumption",
        "净出口",
        "net exports",
        "境内",
        "domestic"
      ],
      "synonyms": {
        "zh-CN": [
          "消费",
          "净出口",
          "境内"
        ],
        "en": [
          "consumption",
          "net exports",
          "domestic"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-03-expenditure-flash-1",
        "u3-03-expenditure-mcq-1",
        "u3-03-expenditure-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-03-expenditure",
        "locale": "zh-CN",
        "title": "支出法 GDP",
        "takeaway": "支出法 GDP=C+I+G+(X−M)，其中 I 是实际资本形成与存货变化，G 是政府商品服务购买，转移支付不直接计入 G。",
        "definition": "支出法 GDP=C+I+G+(X−M)，其中 I 是实际资本形成与存货变化，G 是政府商品服务购买，转移支付不直接计入 G。",
        "causalChain": [
          "加总家庭、企业、政府和国外支出",
          "减去已含在支出中的进口",
          "避免将金融交易或转移支付当作新产出"
        ],
        "misconceptions": [
          "进口不是因为本身有害而扣除，而是因为 GDP 衡量境内产出。"
        ],
        "examApplication": [
          "写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
        ],
        "summary": [
          "支出法 GDP=C+I+G+(X−M)，其中 I 是实际资本形成与存货变化，G 是政府商品服务购买，转移支付不直接计入 G。",
          "进口不是因为本身有害而扣除，而是因为 GDP 衡量境内产出。"
        ],
        "explanation": "加总家庭、企业、政府和国外支出。减去已含在支出中的进口。避免将金融交易或转移支付当作新产出。\n\n### 原创情境与推导\n\n原创例：C=400、I=100、G=150、X=80、M=60，GDP=670。购买股票是所有权交换而非投资 I；失业补助只有被用于购买新产出时才可能进入消费。进口扣除是为排除境外产出。\n\n进口不是因为本身有害而扣除，而是因为 GDP 衡量境内产出。\n\n写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
      },
      "en": {
        "id": "u3-03-expenditure",
        "locale": "en",
        "title": "GDP by expenditure",
        "takeaway": "Expenditure GDP=C+I+G+(X−M). I covers real capital formation and inventory change; G is government purchases of goods and services. Transfers do not directly enter G.",
        "definition": "Expenditure GDP=C+I+G+(X−M). I covers real capital formation and inventory change; G is government purchases of goods and services. Transfers do not directly enter G.",
        "causalChain": [
          "Add household, business, government and foreign spending",
          "subtract imports already included in spending",
          "exclude financial trades and transfers as new output"
        ],
        "misconceptions": [
          "Imports are deducted because GDP measures domestic output, not because imports are inherently harmful."
        ],
        "examApplication": [
          "State indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
        ],
        "summary": [
          "Expenditure GDP=C+I+G+(X−M). I covers real capital formation and inventory change; G is government purchases of goods and services. Transfers do not directly enter G.",
          "Imports are deducted because GDP measures domestic output, not because imports are inherently harmful."
        ],
        "explanation": "Add household, business, government and foreign spending.  subtract imports already included in spending.  exclude financial trades and transfers as new output.\n\n### Original scenario and reasoning\n\nIllustrative example: C=400, I=100, G=150, X=80 and M=60 give GDP=670. Buying shares transfers ownership rather than counting as I. Benefits may enter consumption when spent on new output. Imports are deducted to exclude foreign production.\n\nImports are deducted because GDP measures domestic output, not because imports are inherently harmful.\n\nState indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
      }
    },
    "practice": [
      {
        "id": "u3-03-expenditure-flash-1",
        "knowledgePointId": "u3-03-expenditure",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“支出法 GDP”，并说明一个关键条件。",
          "en": "Explain GDP by expenditure and state one important condition."
        },
        "answer": {
          "zh-CN": "支出法 GDP=C+I+G+(X−M)，其中 I 是实际资本形成与存货变化，G 是政府商品服务购买，转移支付不直接计入 G。",
          "en": "Expenditure GDP=C+I+G+(X−M). I covers real capital formation and inventory change; G is government purchases of goods and services. Transfers do not directly enter G."
        },
        "explanation": {
          "zh-CN": "进口不是因为本身有害而扣除，而是因为 GDP 衡量境内产出。",
          "en": "Imports are deducted because GDP measures domestic output, not because imports are inherently harmful."
        }
      },
      {
        "id": "u3-03-expenditure-mcq-1",
        "knowledgePointId": "u3-03-expenditure",
        "type": "mcq",
        "prompt": {
          "zh-CN": "C=200、I=50、G=70、X=40、M=30，GDP 多少？",
          "en": "C=200, I=50, G=70, X=40, M=30. What is GDP?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "390",
            "en": "390"
          },
          {
            "id": "b",
            "zh-CN": "290",
            "en": "290"
          },
          {
            "id": "c",
            "zh-CN": "330",
            "en": "330"
          },
          {
            "id": "d",
            "zh-CN": "360",
            "en": "360"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "330。 GDP = 200 + 50 + 70 + 40 − 30 = 330 进口不是因为本身有害而扣除，而是因为 GDP 衡量境内产出。",
          "en": "330. GDP = 200 + 50 + 70 + 40 − 30 = 330 Imports are deducted because GDP measures domestic output, not because imports are inherently harmful."
        }
      },
      {
        "id": "u3-03-expenditure-short-1",
        "knowledgePointId": "u3-03-expenditure",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释支出法 GDP的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of GDP by expenditure and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "支出法 GDP=C+I+G+(X−M)，其中 I 是实际资本形成与存货变化，G 是政府商品服务购买，转移支付不直接计入 G。 加总家庭、企业、政府和国外支出；减去已含在支出中的进口；避免将金融交易或转移支付当作新产出 原创例：C=400、I=100、G=150、X=80、M=60，GDP=670。购买股票是所有权交换而非投资 I；失业补助只有被用于购买新产出时才可能进入消费。进口扣除是为排除境外产出。",
          "en": "Expenditure GDP=C+I+G+(X−M). I covers real capital formation and inventory change; G is government purchases of goods and services. Transfers do not directly enter G. Add household, business, government and foreign spending; subtract imports already included in spending; exclude financial trades and transfers as new output Illustrative example: C=400, I=100, G=150, X=80 and M=60 give GDP=670. Buying shares transfers ownership rather than counting as I. Benefits may enter consumption when spent on new output. Imports are deducted to exclude foreign production."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "消费",
              "en": "consumption"
            },
            "alternatives": {
              "zh-CN": [
                "消费",
                "加总家庭、企业、政府和国外支出"
              ],
              "en": [
                "consumption",
                "Add household, business, government and foreign spending"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "净出口",
              "en": "net exports"
            },
            "alternatives": {
              "zh-CN": [
                "净出口",
                "减去已含在支出中的进口"
              ],
              "en": [
                "net exports",
                "subtract imports already included in spending"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "境内",
              "en": "domestic"
            },
            "alternatives": {
              "zh-CN": [
                "境内",
                "避免将金融交易或转移支付当作新产出"
              ],
              "en": [
                "domestic",
                "exclude financial trades and transfers as new output"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-04-nominal-real",
      "slug": "nominal-real",
      "section": "3.1",
      "level": "core",
      "syllabusRefs": [
        "3.1 Measuring economic activity and its variations"
      ],
      "textbookRefs": [
        {
          "chapter": "8",
          "section": "8.2",
          "pages": [
            250
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u3-01-circular-flow",
        "u3-02-gdp",
        "u3-03-expenditure"
      ],
      "terms": [
        "名义与实际 GDP",
        "Nominal and real GDP",
        "价格",
        "prices",
        "产量",
        "volume",
        "平减",
        "deflate"
      ],
      "synonyms": {
        "zh-CN": [
          "价格",
          "产量",
          "平减"
        ],
        "en": [
          "prices",
          "volume",
          "deflate"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-04-nominal-real-flash-1",
        "u3-04-nominal-real-mcq-1",
        "u3-04-nominal-real-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-04-nominal-real",
        "locale": "zh-CN",
        "title": "名义与实际 GDP",
        "takeaway": "名义 GDP 用当期价格衡量产出，实际 GDP 排除价格变化以反映产量变化；名义增长可以同时来自价格和数量。",
        "definition": "名义 GDP 用当期价格衡量产出，实际 GDP 排除价格变化以反映产量变化；名义增长可以同时来自价格和数量。",
        "causalChain": [
          "当期销售价值随价格和数量变化",
          "用价格指数进行平减",
          "比较可比价格下的产量"
        ],
        "misconceptions": [
          "物价下降导致名义 GDP 下降，并不单独证明实际经济衰退。"
        ],
        "examApplication": [
          "写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
        ],
        "summary": [
          "名义 GDP 用当期价格衡量产出，实际 GDP 排除价格变化以反映产量变化；名义增长可以同时来自价格和数量。",
          "物价下降导致名义 GDP 下降，并不单独证明实际经济衰退。"
        ],
        "explanation": "当期销售价值随价格和数量变化。用价格指数进行平减。比较可比价格下的产量。\n\n### 原创情境与推导\n\n原创例：一年生产 100 件、单价 10，下一年仍生产 100 件但单价 12，名义 GDP 从 1000 到 1200，实际产量未增长。使用固定基年价格是教学简化，实际统计可采用链式量指数。\n\n物价下降导致名义 GDP 下降，并不单独证明实际经济衰退。\n\n写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
      },
      "en": {
        "id": "u3-04-nominal-real",
        "locale": "en",
        "title": "Nominal and real GDP",
        "takeaway": "Nominal GDP values output at current prices. Real GDP removes price changes to reflect changes in output volume. Nominal growth can arise from both prices and quantities.",
        "definition": "Nominal GDP values output at current prices. Real GDP removes price changes to reflect changes in output volume. Nominal growth can arise from both prices and quantities.",
        "causalChain": [
          "Current sales value changes with prices and quantities",
          "deflate using a price index",
          "compare output volumes at comparable prices"
        ],
        "misconceptions": [
          "A nominal GDP fall caused by lower prices does not alone prove a real recession."
        ],
        "examApplication": [
          "State indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
        ],
        "summary": [
          "Nominal GDP values output at current prices. Real GDP removes price changes to reflect changes in output volume. Nominal growth can arise from both prices and quantities.",
          "A nominal GDP fall caused by lower prices does not alone prove a real recession."
        ],
        "explanation": "Current sales value changes with prices and quantities.  deflate using a price index.  compare output volumes at comparable prices.\n\n### Original scenario and reasoning\n\nIllustrative example: 100 units at price ten become 100 units at price twelve next year. Nominal GDP rises from 1000 to 1200 but real output does not grow. Fixed base-year prices are a teaching simplification; statistical offices may use chain-volume measures.\n\nA nominal GDP fall caused by lower prices does not alone prove a real recession.\n\nState indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
      }
    },
    "practice": [
      {
        "id": "u3-04-nominal-real-flash-1",
        "knowledgePointId": "u3-04-nominal-real",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“名义与实际 GDP”，并说明一个关键条件。",
          "en": "Explain Nominal and real GDP and state one important condition."
        },
        "answer": {
          "zh-CN": "名义 GDP 用当期价格衡量产出，实际 GDP 排除价格变化以反映产量变化；名义增长可以同时来自价格和数量。",
          "en": "Nominal GDP values output at current prices. Real GDP removes price changes to reflect changes in output volume. Nominal growth can arise from both prices and quantities."
        },
        "explanation": {
          "zh-CN": "物价下降导致名义 GDP 下降，并不单独证明实际经济衰退。",
          "en": "A nominal GDP fall caused by lower prices does not alone prove a real recession."
        }
      },
      {
        "id": "u3-04-nominal-real-mcq-1",
        "knowledgePointId": "u3-04-nominal-real",
        "type": "mcq",
        "prompt": {
          "zh-CN": "只有价格涨 10%、产量不变，哪项正确？",
          "en": "Only prices rise 10%, with unchanged volume. Which is correct?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "实际 GDP 必涨 10%",
            "en": "Real GDP must rise 10%"
          },
          {
            "id": "b",
            "zh-CN": "两者都下降",
            "en": "Both fall"
          },
          {
            "id": "c",
            "zh-CN": "产量必涨 10%",
            "en": "Volume must rise 10%"
          },
          {
            "id": "d",
            "zh-CN": "名义 GDP 增加，实际 GDP 不变",
            "en": "Nominal GDP rises; real GDP is unchanged"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "名义 GDP 增加，实际 GDP 不变。 当期销售价值随价格和数量变化；用价格指数进行平减；比较可比价格下的产量 物价下降导致名义 GDP 下降，并不单独证明实际经济衰退。",
          "en": "Nominal GDP rises; real GDP is unchanged. Current sales value changes with prices and quantities; deflate using a price index; compare output volumes at comparable prices A nominal GDP fall caused by lower prices does not alone prove a real recession."
        }
      },
      {
        "id": "u3-04-nominal-real-short-1",
        "knowledgePointId": "u3-04-nominal-real",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释名义与实际 GDP的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Nominal and real GDP and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "名义 GDP 用当期价格衡量产出，实际 GDP 排除价格变化以反映产量变化；名义增长可以同时来自价格和数量。 当期销售价值随价格和数量变化；用价格指数进行平减；比较可比价格下的产量 原创例：一年生产 100 件、单价 10，下一年仍生产 100 件但单价 12，名义 GDP 从 1000 到 1200，实际产量未增长。使用固定基年价格是教学简化，实际统计可采用链式量指数。",
          "en": "Nominal GDP values output at current prices. Real GDP removes price changes to reflect changes in output volume. Nominal growth can arise from both prices and quantities. Current sales value changes with prices and quantities; deflate using a price index; compare output volumes at comparable prices Illustrative example: 100 units at price ten become 100 units at price twelve next year. Nominal GDP rises from 1000 to 1200 but real output does not grow. Fixed base-year prices are a teaching simplification; statistical offices may use chain-volume measures."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "价格",
              "en": "prices"
            },
            "alternatives": {
              "zh-CN": [
                "价格",
                "当期销售价值随价格和数量变化"
              ],
              "en": [
                "prices",
                "Current sales value changes with prices and quantities"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "产量",
              "en": "volume"
            },
            "alternatives": {
              "zh-CN": [
                "产量",
                "用价格指数进行平减"
              ],
              "en": [
                "volume",
                "deflate using a price index"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "平减",
              "en": "deflate"
            },
            "alternatives": {
              "zh-CN": [
                "平减",
                "比较可比价格下的产量"
              ],
              "en": [
                "deflate",
                "compare output volumes at comparable prices"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-05-deflator",
      "slug": "deflator",
      "section": "3.1",
      "level": "core",
      "syllabusRefs": [
        "3.1 Measuring economic activity and its variations"
      ],
      "textbookRefs": [
        {
          "chapter": "8",
          "section": "8.3",
          "pages": [
            256
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u3-01-circular-flow",
        "u3-02-gdp",
        "u3-03-expenditure"
      ],
      "terms": [
        "GDP 平减指数与核算计算",
        "GDP deflator and national-account calculations",
        "名义",
        "nominal",
        "实际",
        "real",
        "指数",
        "index"
      ],
      "synonyms": {
        "zh-CN": [
          "名义",
          "实际",
          "指数"
        ],
        "en": [
          "nominal",
          "real",
          "index"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-05-deflator-flash-1",
        "u3-05-deflator-mcq-1",
        "u3-05-deflator-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-05-deflator",
        "locale": "zh-CN",
        "title": "GDP 平减指数与核算计算",
        "takeaway": "GDP 平减指数=名义 GDP/实际 GDP×100；重排可得实际 GDP=名义 GDP/平减指数×100。产出法与收入法需使用一致估价口径。",
        "definition": "GDP 平减指数=名义 GDP/实际 GDP×100；重排可得实际 GDP=名义 GDP/平减指数×100。产出法与收入法需使用一致估价口径。",
        "causalChain": [
          "将价格指数与基期 100 比较",
          "名义值除以指数再乘 100",
          "保持单位与估价口径一致"
        ],
        "misconceptions": [
          "指数 110 表示相对基期价格高 10%，不是当年通胀必然为 10%。"
        ],
        "examApplication": [
          "写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
        ],
        "summary": [
          "GDP 平减指数=名义 GDP/实际 GDP×100；重排可得实际 GDP=名义 GDP/平减指数×100。产出法与收入法需使用一致估价口径。",
          "指数 110 表示相对基期价格高 10%，不是当年通胀必然为 10%。"
        ],
        "explanation": "将价格指数与基期 100 比较。名义值除以指数再乘 100。保持单位与估价口径一致。\n\n### 原创情境与推导\n\n原创例：名义 GDP=660，平减指数=110，实际 GDP=600。产出法加总增加值；收入法加总劳动报酬和经营盈余等，在市场价格口径下还需纳入生产与进口税减补贴，不能随意混合含税与不含税数字。\n\n指数 110 表示相对基期价格高 10%，不是当年通胀必然为 10%。\n\n写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
      },
      "en": {
        "id": "u3-05-deflator",
        "locale": "en",
        "title": "GDP deflator and national-account calculations",
        "takeaway": "The GDP deflator is nominal GDP divided by real GDP times 100. Rearranging gives real GDP=nominal GDP/deflator×100. Output and income approaches require consistent valuation conventions.",
        "definition": "The GDP deflator is nominal GDP divided by real GDP times 100. Rearranging gives real GDP=nominal GDP/deflator×100. Output and income approaches require consistent valuation conventions.",
        "causalChain": [
          "Compare the price index with base-period 100",
          "divide nominal value by the index and multiply by 100",
          "keep units and valuation consistent"
        ],
        "misconceptions": [
          "An index of 110 means prices are 10% above the base, not necessarily 10% inflation in the latest year."
        ],
        "examApplication": [
          "State indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
        ],
        "summary": [
          "The GDP deflator is nominal GDP divided by real GDP times 100. Rearranging gives real GDP=nominal GDP/deflator×100. Output and income approaches require consistent valuation conventions.",
          "An index of 110 means prices are 10% above the base, not necessarily 10% inflation in the latest year."
        ],
        "explanation": "Compare the price index with base-period 100.  divide nominal value by the index and multiply by 100.  keep units and valuation consistent.\n\n### Original scenario and reasoning\n\nIllustrative example: nominal GDP is 660 and the deflator 110, giving real GDP of 600. The output approach sums value added. The income approach sums compensation and operating surplus, with taxes less subsidies on production/imports needed for market-price consistency. Do not mix valuation bases.\n\nAn index of 110 means prices are 10% above the base, not necessarily 10% inflation in the latest year.\n\nState indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
      }
    },
    "practice": [
      {
        "id": "u3-05-deflator-flash-1",
        "knowledgePointId": "u3-05-deflator",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“GDP 平减指数与核算计算”，并说明一个关键条件。",
          "en": "Explain GDP deflator and national-account calculations and state one important condition."
        },
        "answer": {
          "zh-CN": "GDP 平减指数=名义 GDP/实际 GDP×100；重排可得实际 GDP=名义 GDP/平减指数×100。产出法与收入法需使用一致估价口径。",
          "en": "The GDP deflator is nominal GDP divided by real GDP times 100. Rearranging gives real GDP=nominal GDP/deflator×100. Output and income approaches require consistent valuation conventions."
        },
        "explanation": {
          "zh-CN": "指数 110 表示相对基期价格高 10%，不是当年通胀必然为 10%。",
          "en": "An index of 110 means prices are 10% above the base, not necessarily 10% inflation in the latest year."
        }
      },
      {
        "id": "u3-05-deflator-mcq-1",
        "knowledgePointId": "u3-05-deflator",
        "type": "mcq",
        "prompt": {
          "zh-CN": "名义 GDP=900、平减指数=120，实际 GDP 多少？",
          "en": "Nominal GDP=900 and deflator=120. What is real GDP?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "750",
            "en": "750"
          },
          {
            "id": "b",
            "zh-CN": "1080",
            "en": "1080"
          },
          {
            "id": "c",
            "zh-CN": "780",
            "en": "780"
          },
          {
            "id": "d",
            "zh-CN": "7.5",
            "en": "7.5"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "750。 GDP (real) = 900 / 120 × 100 = 750 指数 110 表示相对基期价格高 10%，不是当年通胀必然为 10%。",
          "en": "750. GDP (real) = 900 / 120 × 100 = 750 An index of 110 means prices are 10% above the base, not necessarily 10% inflation in the latest year."
        }
      },
      {
        "id": "u3-05-deflator-short-1",
        "knowledgePointId": "u3-05-deflator",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释GDP 平减指数与核算计算的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of GDP deflator and national-account calculations and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "GDP 平减指数=名义 GDP/实际 GDP×100；重排可得实际 GDP=名义 GDP/平减指数×100。产出法与收入法需使用一致估价口径。 将价格指数与基期 100 比较；名义值除以指数再乘 100；保持单位与估价口径一致 原创例：名义 GDP=660，平减指数=110，实际 GDP=600。产出法加总增加值；收入法加总劳动报酬和经营盈余等，在市场价格口径下还需纳入生产与进口税减补贴，不能随意混合含税与不含税数字。",
          "en": "The GDP deflator is nominal GDP divided by real GDP times 100. Rearranging gives real GDP=nominal GDP/deflator×100. Output and income approaches require consistent valuation conventions. Compare the price index with base-period 100; divide nominal value by the index and multiply by 100; keep units and valuation consistent Illustrative example: nominal GDP is 660 and the deflator 110, giving real GDP of 600. The output approach sums value added. The income approach sums compensation and operating surplus, with taxes less subsidies on production/imports needed for market-price consistency. Do not mix valuation bases."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "名义",
              "en": "nominal"
            },
            "alternatives": {
              "zh-CN": [
                "名义",
                "将价格指数与基期 100 比较"
              ],
              "en": [
                "nominal",
                "Compare the price index with base-period 100"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "实际",
              "en": "real"
            },
            "alternatives": {
              "zh-CN": [
                "实际",
                "名义值除以指数再乘 100"
              ],
              "en": [
                "real",
                "divide nominal value by the index and multiply by 100"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "指数",
              "en": "index"
            },
            "alternatives": {
              "zh-CN": [
                "指数",
                "保持单位与估价口径一致"
              ],
              "en": [
                "index",
                "keep units and valuation consistent"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-06-gni",
      "slug": "gni",
      "section": "3.1",
      "level": "core",
      "syllabusRefs": [
        "3.1 Measuring economic activity and its variations"
      ],
      "textbookRefs": [
        {
          "chapter": "8",
          "section": "8.2",
          "pages": [
            250
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u3-01-circular-flow",
        "u3-02-gdp",
        "u3-03-expenditure"
      ],
      "terms": [
        "GNI、折旧与净收入",
        "GNI, depreciation and net income",
        "居民",
        "residents",
        "初次收入",
        "primary income",
        "折旧",
        "depreciation"
      ],
      "synonyms": {
        "zh-CN": [
          "居民",
          "初次收入",
          "折旧"
        ],
        "en": [
          "residents",
          "primary income",
          "depreciation"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-06-gni-flash-1",
        "u3-06-gni-mcq-1",
        "u3-06-gni-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-06-gni",
        "locale": "zh-CN",
        "title": "GNI、折旧与净收入",
        "takeaway": "GNI=GDP+来自国外的净初次收入，关注居民收入；净国民收入还扣除固定资本消耗，即折旧。",
        "definition": "GNI=GDP+来自国外的净初次收入，关注居民收入；净国民收入还扣除固定资本消耗，即折旧。",
        "causalChain": [
          "境内产出形成 GDP",
          "加上居民从国外净获得的初次收入",
          "扣除资本消耗得到净额"
        ],
        "misconceptions": [
          "不能把所有跨境转账都当作初次收入，初次收入与转移应分开。"
        ],
        "examApplication": [
          "写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
        ],
        "summary": [
          "GNI=GDP+来自国外的净初次收入，关注居民收入；净国民收入还扣除固定资本消耗，即折旧。",
          "不能把所有跨境转账都当作初次收入，初次收入与转移应分开。"
        ],
        "explanation": "境内产出形成 GDP。加上居民从国外净获得的初次收入。扣除资本消耗得到净额。\n\n### 原创情境与推导\n\n原创例：GDP=500，来自国外初次收入 40、流向国外 25，GNI=515；折旧 30 时 NNI=485。GDP 与 GNI 的差别是境内生产与居民收入的边界，不是货币单位。\n\n不能把所有跨境转账都当作初次收入，初次收入与转移应分开。\n\n写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
      },
      "en": {
        "id": "u3-06-gni",
        "locale": "en",
        "title": "GNI, depreciation and net income",
        "takeaway": "GNI equals GDP plus net primary income from abroad and focuses on residents' income. Net national income also deducts consumption of fixed capital, or depreciation.",
        "definition": "GNI equals GDP plus net primary income from abroad and focuses on residents' income. Net national income also deducts consumption of fixed capital, or depreciation.",
        "causalChain": [
          "Domestic output forms GDP",
          "add residents' net primary income from abroad",
          "deduct capital consumption to obtain a net measure"
        ],
        "misconceptions": [
          "Not every cross-border payment is primary income; distinguish primary income from transfers."
        ],
        "examApplication": [
          "State indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
        ],
        "summary": [
          "GNI equals GDP plus net primary income from abroad and focuses on residents' income. Net national income also deducts consumption of fixed capital, or depreciation.",
          "Not every cross-border payment is primary income; distinguish primary income from transfers."
        ],
        "explanation": "Domestic output forms GDP.  add residents' net primary income from abroad.  deduct capital consumption to obtain a net measure.\n\n### Original scenario and reasoning\n\nIllustrative example: GDP=500, primary income received from abroad=40 and paid abroad=25 give GNI=515. With depreciation 30, NNI=485. GDP versus GNI distinguishes domestic production from resident income, not different currencies.\n\nNot every cross-border payment is primary income; distinguish primary income from transfers.\n\nState indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
      }
    },
    "practice": [
      {
        "id": "u3-06-gni-flash-1",
        "knowledgePointId": "u3-06-gni",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“GNI、折旧与净收入”，并说明一个关键条件。",
          "en": "Explain GNI, depreciation and net income and state one important condition."
        },
        "answer": {
          "zh-CN": "GNI=GDP+来自国外的净初次收入，关注居民收入；净国民收入还扣除固定资本消耗，即折旧。",
          "en": "GNI equals GDP plus net primary income from abroad and focuses on residents' income. Net national income also deducts consumption of fixed capital, or depreciation."
        },
        "explanation": {
          "zh-CN": "不能把所有跨境转账都当作初次收入，初次收入与转移应分开。",
          "en": "Not every cross-border payment is primary income; distinguish primary income from transfers."
        }
      },
      {
        "id": "u3-06-gni-mcq-1",
        "knowledgePointId": "u3-06-gni",
        "type": "mcq",
        "prompt": {
          "zh-CN": "GDP=300，国外净初次收入=-20，GNI 多少？",
          "en": "GDP=300 and net primary income from abroad=-20. What is GNI?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "320",
            "en": "320"
          },
          {
            "id": "b",
            "zh-CN": "280",
            "en": "280"
          },
          {
            "id": "c",
            "zh-CN": "300",
            "en": "300"
          },
          {
            "id": "d",
            "zh-CN": "20",
            "en": "20"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "280。 GNI = 300 + (−20) = 280 不能把所有跨境转账都当作初次收入，初次收入与转移应分开。",
          "en": "280. GNI = 300 + (−20) = 280 Not every cross-border payment is primary income; distinguish primary income from transfers."
        }
      },
      {
        "id": "u3-06-gni-short-1",
        "knowledgePointId": "u3-06-gni",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释GNI、折旧与净收入的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of GNI, depreciation and net income and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "GNI=GDP+来自国外的净初次收入，关注居民收入；净国民收入还扣除固定资本消耗，即折旧。 境内产出形成 GDP；加上居民从国外净获得的初次收入；扣除资本消耗得到净额 原创例：GDP=500，来自国外初次收入 40、流向国外 25，GNI=515；折旧 30 时 NNI=485。GDP 与 GNI 的差别是境内生产与居民收入的边界，不是货币单位。",
          "en": "GNI equals GDP plus net primary income from abroad and focuses on residents' income. Net national income also deducts consumption of fixed capital, or depreciation. Domestic output forms GDP; add residents' net primary income from abroad; deduct capital consumption to obtain a net measure Illustrative example: GDP=500, primary income received from abroad=40 and paid abroad=25 give GNI=515. With depreciation 30, NNI=485. GDP versus GNI distinguishes domestic production from resident income, not different currencies."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "居民",
              "en": "residents"
            },
            "alternatives": {
              "zh-CN": [
                "居民",
                "境内产出形成 GDP"
              ],
              "en": [
                "residents",
                "Domestic output forms GDP"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "初次收入",
              "en": "primary income"
            },
            "alternatives": {
              "zh-CN": [
                "初次收入",
                "加上居民从国外净获得的初次收入"
              ],
              "en": [
                "primary income",
                "add residents' net primary income from abroad"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "折旧",
              "en": "depreciation"
            },
            "alternatives": {
              "zh-CN": [
                "折旧",
                "扣除资本消耗得到净额"
              ],
              "en": [
                "depreciation",
                "deduct capital consumption to obtain a net measure"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-07-per-capita-ppp",
      "slug": "per-capita-ppp",
      "section": "3.1",
      "level": "core",
      "syllabusRefs": [
        "3.1 Measuring economic activity and its variations"
      ],
      "textbookRefs": [
        {
          "chapter": "8",
          "section": "8.5",
          "pages": [
            264
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u3-01-circular-flow",
        "u3-02-gdp",
        "u3-03-expenditure"
      ],
      "terms": [
        "人均实际收入与 PPP",
        "Real income per capita and PPP",
        "人口",
        "population",
        "平均",
        "average",
        "购买力",
        "purchasing power"
      ],
      "synonyms": {
        "zh-CN": [
          "人口",
          "平均",
          "购买力"
        ],
        "en": [
          "population",
          "average",
          "purchasing power"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-07-per-capita-ppp-flash-1",
        "u3-07-per-capita-ppp-mcq-1",
        "u3-07-per-capita-ppp-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-07-per-capita-ppp",
        "locale": "zh-CN",
        "title": "人均实际收入与 PPP",
        "takeaway": "人均实际收入将实际收入除以人口；购买力平价 PPP 调整跨国价格水平差异，以比较购买相近商品服务的能力。",
        "definition": "人均实际收入将实际收入除以人口；购买力平价 PPP 调整跨国价格水平差异，以比较购买相近商品服务的能力。",
        "causalChain": [
          "总量增长可能伴随人口增长",
          "除以人口观察平均水平",
          "PPP 调整不同国家的购买力"
        ],
        "misconceptions": [
          "人均值是平均数，不表示每个人都获得相同收入。"
        ],
        "examApplication": [
          "写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
        ],
        "summary": [
          "人均实际收入将实际收入除以人口；购买力平价 PPP 调整跨国价格水平差异，以比较购买相近商品服务的能力。",
          "人均值是平均数，不表示每个人都获得相同收入。"
        ],
        "explanation": "总量增长可能伴随人口增长。除以人口观察平均水平。PPP 调整不同国家的购买力。\n\n### 原创情境与推导\n\n原创例：实际 GDP 增长约 4%、人口增长约 2%，人均实际 GDP 增长约 2%，精确值为 1.04/1.02−1≈1.96%。PPP 比较也不能揭示分配、公共服务质量或环境差异。\n\n人均值是平均数，不表示每个人都获得相同收入。\n\n写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
      },
      "en": {
        "id": "u3-07-per-capita-ppp",
        "locale": "en",
        "title": "Real income per capita and PPP",
        "takeaway": "Real income per capita divides real income by population. Purchasing power parity adjusts cross-country price-level differences to compare command over comparable goods and services.",
        "definition": "Real income per capita divides real income by population. Purchasing power parity adjusts cross-country price-level differences to compare command over comparable goods and services.",
        "causalChain": [
          "Aggregate growth may accompany population growth",
          "divide by population to examine averages",
          "PPP adjusts purchasing power across countries"
        ],
        "misconceptions": [
          "A per-capita value is an average, not the income each person actually receives."
        ],
        "examApplication": [
          "State indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
        ],
        "summary": [
          "Real income per capita divides real income by population. Purchasing power parity adjusts cross-country price-level differences to compare command over comparable goods and services.",
          "A per-capita value is an average, not the income each person actually receives."
        ],
        "explanation": "Aggregate growth may accompany population growth.  divide by population to examine averages.  PPP adjusts purchasing power across countries.\n\n### Original scenario and reasoning\n\nIllustrative example: real GDP grows 4% and population 2%, so per-capita growth is about 2%, precisely 1.04/1.02−1≈1.96%. PPP comparisons still do not reveal distribution, service quality or environmental differences.\n\nA per-capita value is an average, not the income each person actually receives.\n\nState indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
      }
    },
    "practice": [
      {
        "id": "u3-07-per-capita-ppp-flash-1",
        "knowledgePointId": "u3-07-per-capita-ppp",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“人均实际收入与 PPP”，并说明一个关键条件。",
          "en": "Explain Real income per capita and PPP and state one important condition."
        },
        "answer": {
          "zh-CN": "人均实际收入将实际收入除以人口；购买力平价 PPP 调整跨国价格水平差异，以比较购买相近商品服务的能力。",
          "en": "Real income per capita divides real income by population. Purchasing power parity adjusts cross-country price-level differences to compare command over comparable goods and services."
        },
        "explanation": {
          "zh-CN": "人均值是平均数，不表示每个人都获得相同收入。",
          "en": "A per-capita value is an average, not the income each person actually receives."
        }
      },
      {
        "id": "u3-07-per-capita-ppp-mcq-1",
        "knowledgePointId": "u3-07-per-capita-ppp",
        "type": "mcq",
        "prompt": {
          "zh-CN": "实际 GDP 不变、人口增加，人均实际 GDP 怎样？",
          "en": "Real GDP is unchanged and population rises. What happens to real GDP per capita?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "上升",
            "en": "Rises"
          },
          {
            "id": "b",
            "zh-CN": "必然不变",
            "en": "Necessarily unchanged"
          },
          {
            "id": "c",
            "zh-CN": "下降",
            "en": "Falls"
          },
          {
            "id": "d",
            "zh-CN": "等于人口增长率",
            "en": "Equals population growth"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "下降。 总量增长可能伴随人口增长；除以人口观察平均水平；PPP 调整不同国家的购买力 人均值是平均数，不表示每个人都获得相同收入。",
          "en": "Falls. Aggregate growth may accompany population growth; divide by population to examine averages; PPP adjusts purchasing power across countries A per-capita value is an average, not the income each person actually receives."
        }
      },
      {
        "id": "u3-07-per-capita-ppp-short-1",
        "knowledgePointId": "u3-07-per-capita-ppp",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释人均实际收入与 PPP的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Real income per capita and PPP and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "人均实际收入将实际收入除以人口；购买力平价 PPP 调整跨国价格水平差异，以比较购买相近商品服务的能力。 总量增长可能伴随人口增长；除以人口观察平均水平；PPP 调整不同国家的购买力 原创例：实际 GDP 增长约 4%、人口增长约 2%，人均实际 GDP 增长约 2%，精确值为 1.04/1.02−1≈1.96%。PPP 比较也不能揭示分配、公共服务质量或环境差异。",
          "en": "Real income per capita divides real income by population. Purchasing power parity adjusts cross-country price-level differences to compare command over comparable goods and services. Aggregate growth may accompany population growth; divide by population to examine averages; PPP adjusts purchasing power across countries Illustrative example: real GDP grows 4% and population 2%, so per-capita growth is about 2%, precisely 1.04/1.02−1≈1.96%. PPP comparisons still do not reveal distribution, service quality or environmental differences."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "人口",
              "en": "population"
            },
            "alternatives": {
              "zh-CN": [
                "人口",
                "总量增长可能伴随人口增长"
              ],
              "en": [
                "population",
                "Aggregate growth may accompany population growth"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "平均",
              "en": "average"
            },
            "alternatives": {
              "zh-CN": [
                "平均",
                "除以人口观察平均水平"
              ],
              "en": [
                "average",
                "divide by population to examine averages"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "购买力",
              "en": "purchasing power"
            },
            "alternatives": {
              "zh-CN": [
                "购买力",
                "PPP 调整不同国家的购买力"
              ],
              "en": [
                "purchasing power",
                "PPP adjusts purchasing power across countries"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-08-business-cycle",
      "slug": "business-cycle",
      "section": "3.1",
      "level": "core",
      "syllabusRefs": [
        "3.1 Measuring economic activity and its variations"
      ],
      "textbookRefs": [
        {
          "chapter": "8",
          "section": "8.4",
          "pages": [
            260
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u3-01-circular-flow",
        "u3-02-gdp",
        "u3-03-expenditure"
      ],
      "terms": [
        "经济周期与趋势",
        "Business cycles and trend output",
        "实际产出",
        "real output",
        "趋势",
        "trend",
        "波动",
        "fluctuations"
      ],
      "synonyms": {
        "zh-CN": [
          "实际产出",
          "趋势",
          "波动"
        ],
        "en": [
          "real output",
          "trend",
          "fluctuations"
        ]
      },
      "diagramIds": [
        "macro-cycle"
      ],
      "quizIds": [
        "u3-08-business-cycle-flash-1",
        "u3-08-business-cycle-mcq-1",
        "u3-08-business-cycle-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-08-business-cycle",
        "locale": "zh-CN",
        "title": "经济周期与趋势",
        "takeaway": "经济周期是实际经济活动围绕长期趋势的波动，通常描述扩张、高峰、收缩与低谷；周期并非固定长度或振幅。",
        "definition": "经济周期是实际经济活动围绕长期趋势的波动，通常描述扩张、高峰、收缩与低谷；周期并非固定长度或振幅。",
        "causalChain": [
          "支出与供给冲击改变产出",
          "实际活动偏离趋势",
          "调整与政策可推动复苏或进一步收缩"
        ],
        "misconceptions": [
          "增长放缓仍可为正，不等于实际产出已经下降。"
        ],
        "examApplication": [
          "写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
        ],
        "summary": [
          "经济周期是实际经济活动围绕长期趋势的波动，通常描述扩张、高峰、收缩与低谷；周期并非固定长度或振幅。",
          "增长放缓仍可为正，不等于实际产出已经下降。"
        ],
        "explanation": "支出与供给冲击改变产出。实际活动偏离趋势。调整与政策可推动复苏或进一步收缩。\n\n### 原创情境与推导\n\n原创例：实际产出从 100 到 104 后降到 102，再到 106，102 阶段是收缩但产出仍高于起点。两个季度负增长是常见简化判据，不是所有统计机构唯一的衰退认定标准。\n\n增长放缓仍可为正，不等于实际产出已经下降。\n\n写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
      },
      "en": {
        "id": "u3-08-business-cycle",
        "locale": "en",
        "title": "Business cycles and trend output",
        "takeaway": "The business cycle describes fluctuations in real activity around a longer-term trend: expansion, peak, contraction and trough. Neither duration nor amplitude is fixed.",
        "definition": "The business cycle describes fluctuations in real activity around a longer-term trend: expansion, peak, contraction and trough. Neither duration nor amplitude is fixed.",
        "causalChain": [
          "Spending and supply shocks change output",
          "actual activity deviates from trend",
          "adjustment and policy may support recovery or further contraction"
        ],
        "misconceptions": [
          "Slower growth can remain positive and is not necessarily falling real output."
        ],
        "examApplication": [
          "State indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
        ],
        "summary": [
          "The business cycle describes fluctuations in real activity around a longer-term trend: expansion, peak, contraction and trough. Neither duration nor amplitude is fixed.",
          "Slower growth can remain positive and is not necessarily falling real output."
        ],
        "explanation": "Spending and supply shocks change output.  actual activity deviates from trend.  adjustment and policy may support recovery or further contraction.\n\n### Original scenario and reasoning\n\nIllustrative example: real output moves from 100 to 104, then 102 and 106. The fall to 102 is a contraction despite output remaining above its initial level. Two negative quarters is a common shorthand, not every agency's sole recession criterion.\n\nSlower growth can remain positive and is not necessarily falling real output.\n\nState indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
      }
    },
    "practice": [
      {
        "id": "u3-08-business-cycle-flash-1",
        "knowledgePointId": "u3-08-business-cycle",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“经济周期与趋势”，并说明一个关键条件。",
          "en": "Explain Business cycles and trend output and state one important condition."
        },
        "answer": {
          "zh-CN": "经济周期是实际经济活动围绕长期趋势的波动，通常描述扩张、高峰、收缩与低谷；周期并非固定长度或振幅。",
          "en": "The business cycle describes fluctuations in real activity around a longer-term trend: expansion, peak, contraction and trough. Neither duration nor amplitude is fixed."
        },
        "explanation": {
          "zh-CN": "增长放缓仍可为正，不等于实际产出已经下降。",
          "en": "Slower growth can remain positive and is not necessarily falling real output."
        }
      },
      {
        "id": "u3-08-business-cycle-mcq-1",
        "knowledgePointId": "u3-08-business-cycle",
        "type": "mcq",
        "prompt": {
          "zh-CN": "实际增长率由 5% 降到 2%，说明什么？",
          "en": "Real growth slows from 5% to 2%. What follows?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "产出下降 3%",
            "en": "Output falls 3%"
          },
          {
            "id": "b",
            "zh-CN": "必然发生通缩",
            "en": "Deflation necessarily occurs"
          },
          {
            "id": "c",
            "zh-CN": "经济活动为零",
            "en": "Activity is zero"
          },
          {
            "id": "d",
            "zh-CN": "产出仍增长，但增速放缓",
            "en": "Output still grows, but more slowly"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "产出仍增长，但增速放缓。 支出与供给冲击改变产出；实际活动偏离趋势；调整与政策可推动复苏或进一步收缩 增长放缓仍可为正，不等于实际产出已经下降。",
          "en": "Output still grows, but more slowly. Spending and supply shocks change output; actual activity deviates from trend; adjustment and policy may support recovery or further contraction Slower growth can remain positive and is not necessarily falling real output."
        }
      },
      {
        "id": "u3-08-business-cycle-short-1",
        "knowledgePointId": "u3-08-business-cycle",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释经济周期与趋势的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Business cycles and trend output and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "经济周期是实际经济活动围绕长期趋势的波动，通常描述扩张、高峰、收缩与低谷；周期并非固定长度或振幅。 支出与供给冲击改变产出；实际活动偏离趋势；调整与政策可推动复苏或进一步收缩 原创例：实际产出从 100 到 104 后降到 102，再到 106，102 阶段是收缩但产出仍高于起点。两个季度负增长是常见简化判据，不是所有统计机构唯一的衰退认定标准。",
          "en": "The business cycle describes fluctuations in real activity around a longer-term trend: expansion, peak, contraction and trough. Neither duration nor amplitude is fixed. Spending and supply shocks change output; actual activity deviates from trend; adjustment and policy may support recovery or further contraction Illustrative example: real output moves from 100 to 104, then 102 and 106. The fall to 102 is a contraction despite output remaining above its initial level. Two negative quarters is a common shorthand, not every agency's sole recession criterion."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "实际产出",
              "en": "real output"
            },
            "alternatives": {
              "zh-CN": [
                "实际产出",
                "支出与供给冲击改变产出"
              ],
              "en": [
                "real output",
                "Spending and supply shocks change output"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "趋势",
              "en": "trend"
            },
            "alternatives": {
              "zh-CN": [
                "趋势",
                "实际活动偏离趋势"
              ],
              "en": [
                "trend",
                "actual activity deviates from trend"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "波动",
              "en": "fluctuations"
            },
            "alternatives": {
              "zh-CN": [
                "波动",
                "调整与政策可推动复苏或进一步收缩"
              ],
              "en": [
                "fluctuations",
                "adjustment and policy may support recovery or further contraction"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-09-gdp-limitations",
      "slug": "gdp-limitations",
      "section": "3.1",
      "level": "core",
      "syllabusRefs": [
        "3.1 Measuring economic activity and its variations"
      ],
      "textbookRefs": [
        {
          "chapter": "8",
          "section": "8.5",
          "pages": [
            264
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u3-01-circular-flow",
        "u3-02-gdp",
        "u3-03-expenditure"
      ],
      "terms": [
        "GDP 与生活水平的局限",
        "GDP and limits as a living-standard measure",
        "福利",
        "welfare",
        "分配",
        "distribution",
        "环境",
        "environment"
      ],
      "synonyms": {
        "zh-CN": [
          "福利",
          "分配",
          "环境"
        ],
        "en": [
          "welfare",
          "distribution",
          "environment"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-09-gdp-limitations-flash-1",
        "u3-09-gdp-limitations-mcq-1",
        "u3-09-gdp-limitations-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-09-gdp-limitations",
        "locale": "zh-CN",
        "title": "GDP 与生活水平的局限",
        "takeaway": "GDP 衡量生产而不是完整福利；非市场劳动、分配、闲暇、环境损害及产出构成都影响它与生活水平的联系。",
        "definition": "GDP 衡量生产而不是完整福利；非市场劳动、分配、闲暇、环境损害及产出构成都影响它与生活水平的联系。",
        "causalChain": [
          "核算记录有市场价值的产出",
          "部分社会收益和成本未被完整记录",
          "总量或人均增长不保证福利普遍改善"
        ],
        "misconceptions": [
          "GDP 有局限不意味着它对衡量经济活动没有用途。"
        ],
        "examApplication": [
          "写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
        ],
        "summary": [
          "GDP 衡量生产而不是完整福利；非市场劳动、分配、闲暇、环境损害及产出构成都影响它与生活水平的联系。",
          "GDP 有局限不意味着它对衡量经济活动没有用途。"
        ],
        "explanation": "核算记录有市场价值的产出。部分社会收益和成本未被完整记录。总量或人均增长不保证福利普遍改善。\n\n### 原创情境与推导\n\n原创例：污染后的清理支出可增加 GDP，但不能据此说污染改善生活。无偿照护转为付费照护可能增加记录产出，实际服务量却未同步增加。比较国家时也要考虑非正规经济和统计质量。\n\nGDP 有局限不意味着它对衡量经济活动没有用途。\n\n写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
      },
      "en": {
        "id": "u3-09-gdp-limitations",
        "locale": "en",
        "title": "GDP and limits as a living-standard measure",
        "takeaway": "GDP measures production rather than comprehensive welfare. Non-market work, distribution, leisure, environmental damage and output composition affect its relationship with living standards.",
        "definition": "GDP measures production rather than comprehensive welfare. Non-market work, distribution, leisure, environmental damage and output composition affect its relationship with living standards.",
        "causalChain": [
          "Accounts record market-valued output",
          "some social gains and costs are incompletely recorded",
          "aggregate or average growth does not guarantee broad welfare gains"
        ],
        "misconceptions": [
          "GDP's limitations do not make it useless for measuring economic activity."
        ],
        "examApplication": [
          "State indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
        ],
        "summary": [
          "GDP measures production rather than comprehensive welfare. Non-market work, distribution, leisure, environmental damage and output composition affect its relationship with living standards.",
          "GDP's limitations do not make it useless for measuring economic activity."
        ],
        "explanation": "Accounts record market-valued output.  some social gains and costs are incompletely recorded.  aggregate or average growth does not guarantee broad welfare gains.\n\n### Original scenario and reasoning\n\nIllustrative example: pollution cleanup can add to GDP without making pollution beneficial. Unpaid care becoming paid care can raise recorded output without an equivalent increase in services. Cross-country comparisons also depend on informal activity and statistical quality.\n\nGDP's limitations do not make it useless for measuring economic activity.\n\nState indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
      }
    },
    "practice": [
      {
        "id": "u3-09-gdp-limitations-flash-1",
        "knowledgePointId": "u3-09-gdp-limitations",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“GDP 与生活水平的局限”，并说明一个关键条件。",
          "en": "Explain GDP and limits as a living-standard measure and state one important condition."
        },
        "answer": {
          "zh-CN": "GDP 衡量生产而不是完整福利；非市场劳动、分配、闲暇、环境损害及产出构成都影响它与生活水平的联系。",
          "en": "GDP measures production rather than comprehensive welfare. Non-market work, distribution, leisure, environmental damage and output composition affect its relationship with living standards."
        },
        "explanation": {
          "zh-CN": "GDP 有局限不意味着它对衡量经济活动没有用途。",
          "en": "GDP's limitations do not make it useless for measuring economic activity."
        }
      },
      {
        "id": "u3-09-gdp-limitations-mcq-1",
        "knowledgePointId": "u3-09-gdp-limitations",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪项最直接说明 GDP 不是完整福利指标？",
          "en": "Which most directly shows GDP is not comprehensive welfare?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "未充分反映环境损害与分配",
            "en": "It incompletely captures environmental harm and distribution"
          },
          {
            "id": "b",
            "zh-CN": "GDP 不记录任何生产",
            "en": "GDP records no production"
          },
          {
            "id": "c",
            "zh-CN": "GDP 必等于幸福",
            "en": "GDP must equal happiness"
          },
          {
            "id": "d",
            "zh-CN": "人口不影响人均值",
            "en": "Population never affects per-capita values"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "未充分反映环境损害与分配。 核算记录有市场价值的产出；部分社会收益和成本未被完整记录；总量或人均增长不保证福利普遍改善 GDP 有局限不意味着它对衡量经济活动没有用途。",
          "en": "It incompletely captures environmental harm and distribution. Accounts record market-valued output; some social gains and costs are incompletely recorded; aggregate or average growth does not guarantee broad welfare gains GDP's limitations do not make it useless for measuring economic activity."
        }
      },
      {
        "id": "u3-09-gdp-limitations-short-1",
        "knowledgePointId": "u3-09-gdp-limitations",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释GDP 与生活水平的局限的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of GDP and limits as a living-standard measure and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "GDP 衡量生产而不是完整福利；非市场劳动、分配、闲暇、环境损害及产出构成都影响它与生活水平的联系。 核算记录有市场价值的产出；部分社会收益和成本未被完整记录；总量或人均增长不保证福利普遍改善 原创例：污染后的清理支出可增加 GDP，但不能据此说污染改善生活。无偿照护转为付费照护可能增加记录产出，实际服务量却未同步增加。比较国家时也要考虑非正规经济和统计质量。",
          "en": "GDP measures production rather than comprehensive welfare. Non-market work, distribution, leisure, environmental damage and output composition affect its relationship with living standards. Accounts record market-valued output; some social gains and costs are incompletely recorded; aggregate or average growth does not guarantee broad welfare gains Illustrative example: pollution cleanup can add to GDP without making pollution beneficial. Unpaid care becoming paid care can raise recorded output without an equivalent increase in services. Cross-country comparisons also depend on informal activity and statistical quality."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "福利",
              "en": "welfare"
            },
            "alternatives": {
              "zh-CN": [
                "福利",
                "核算记录有市场价值的产出"
              ],
              "en": [
                "welfare",
                "Accounts record market-valued output"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "分配",
              "en": "distribution"
            },
            "alternatives": {
              "zh-CN": [
                "分配",
                "部分社会收益和成本未被完整记录"
              ],
              "en": [
                "distribution",
                "some social gains and costs are incompletely recorded"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "环境",
              "en": "environment"
            },
            "alternatives": {
              "zh-CN": [
                "环境",
                "总量或人均增长不保证福利普遍改善"
              ],
              "en": [
                "environment",
                "aggregate or average growth does not guarantee broad welfare gains"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-10-wellbeing-indicators",
      "slug": "wellbeing-indicators",
      "section": "3.1",
      "level": "core",
      "syllabusRefs": [
        "3.1 Measuring economic activity and its variations"
      ],
      "textbookRefs": [
        {
          "chapter": "8",
          "section": "8.5",
          "pages": [
            264
          ]
        }
      ],
      "prerequisites": [
        "u1-13-factors-of-production"
      ],
      "related": [
        "u3-01-circular-flow",
        "u3-02-gdp",
        "u3-03-expenditure"
      ],
      "terms": [
        "替代福利指标",
        "Alternative wellbeing indicators",
        "健康",
        "health",
        "教育",
        "education",
        "权重",
        "weights"
      ],
      "synonyms": {
        "zh-CN": [
          "健康",
          "教育",
          "权重"
        ],
        "en": [
          "health",
          "education",
          "weights"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-10-wellbeing-indicators-flash-1",
        "u3-10-wellbeing-indicators-mcq-1",
        "u3-10-wellbeing-indicators-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-10-wellbeing-indicators",
        "locale": "zh-CN",
        "title": "替代福利指标",
        "takeaway": "替代指标可综合收入、健康、教育、主观生活满意度和生态压力；指标选择与权重涉及价值判断，不能由单一排名代替分析。",
        "definition": "替代指标可综合收入、健康、教育、主观生活满意度和生态压力；指标选择与权重涉及价值判断，不能由单一排名代替分析。",
        "causalChain": [
          "明确希望衡量的福利维度",
          "选择可比较的数据与权重",
          "结合 GDP 解读综合指标的差异"
        ],
        "misconceptions": [
          "不同指标衡量不同目标，不能认为任一综合指数完全客观或无遗漏。"
        ],
        "examApplication": [
          "写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
        ],
        "summary": [
          "替代指标可综合收入、健康、教育、主观生活满意度和生态压力；指标选择与权重涉及价值判断，不能由单一排名代替分析。",
          "不同指标衡量不同目标，不能认为任一综合指数完全客观或无遗漏。"
        ],
        "explanation": "明确希望衡量的福利维度。选择可比较的数据与权重。结合 GDP 解读综合指标的差异。\n\n### 原创情境与推导\n\n原创例：两国人均收入相近，健康预期和教育机会却不同，综合人类发展指标可补充收入比较。主观幸福还受文化与调查方法影响；综合值也可能掩盖国内群体差距。 OECD 美好生活指标比较住房、收入、工作等多个维度；幸福类报告强调主观生活评价，快乐星球指数把福祉和寿命与环境负担联系，不能与 HDI 混为一谈。\n\n不同指标衡量不同目标，不能认为任一综合指数完全客观或无遗漏。\n\n写清指标、公式、单位和局限；区分名义、实际、总量与人均。"
      },
      "en": {
        "id": "u3-10-wellbeing-indicators",
        "locale": "en",
        "title": "Alternative wellbeing indicators",
        "takeaway": "Alternative indicators can combine income, health, education, subjective satisfaction and ecological pressure. Choosing dimensions and weights involves judgement, so a ranking cannot replace analysis.",
        "definition": "Alternative indicators can combine income, health, education, subjective satisfaction and ecological pressure. Choosing dimensions and weights involves judgement, so a ranking cannot replace analysis.",
        "causalChain": [
          "Specify the wellbeing dimensions",
          "select comparable data and weights",
          "interpret composite indicators alongside GDP"
        ],
        "misconceptions": [
          "Different indicators target different outcomes; no composite is completely objective or exhaustive."
        ],
        "examApplication": [
          "State indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
        ],
        "summary": [
          "Alternative indicators can combine income, health, education, subjective satisfaction and ecological pressure. Choosing dimensions and weights involves judgement, so a ranking cannot replace analysis.",
          "Different indicators target different outcomes; no composite is completely objective or exhaustive."
        ],
        "explanation": "Specify the wellbeing dimensions.  select comparable data and weights.  interpret composite indicators alongside GDP.\n\n### Original scenario and reasoning\n\nIllustrative example: two countries have similar income per person but different health prospects and educational opportunities. Human-development measures complement income. Subjective happiness also depends on culture and survey design, while composites can conceal internal group gaps. The OECD Better Life Index compares multiple dimensions such as housing, income and jobs; happiness reports emphasise subjective life evaluation, while the Happy Planet Index relates well-being and longevity to environmental pressure. None is interchangeable with HDI.\n\nDifferent indicators target different outcomes; no composite is completely objective or exhaustive.\n\nState indicators, formulas, units and limits; distinguish nominal, real, aggregate and per-capita measures."
      }
    },
    "practice": [
      {
        "id": "u3-10-wellbeing-indicators-flash-1",
        "knowledgePointId": "u3-10-wellbeing-indicators",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“替代福利指标”，并说明一个关键条件。",
          "en": "Explain Alternative wellbeing indicators and state one important condition."
        },
        "answer": {
          "zh-CN": "替代指标可综合收入、健康、教育、主观生活满意度和生态压力；指标选择与权重涉及价值判断，不能由单一排名代替分析。",
          "en": "Alternative indicators can combine income, health, education, subjective satisfaction and ecological pressure. Choosing dimensions and weights involves judgement, so a ranking cannot replace analysis."
        },
        "explanation": {
          "zh-CN": "不同指标衡量不同目标，不能认为任一综合指数完全客观或无遗漏。",
          "en": "Different indicators target different outcomes; no composite is completely objective or exhaustive."
        }
      },
      {
        "id": "u3-10-wellbeing-indicators-mcq-1",
        "knowledgePointId": "u3-10-wellbeing-indicators",
        "type": "mcq",
        "prompt": {
          "zh-CN": "评价综合福利指标时应检查什么？",
          "en": "What should be checked when evaluating a composite wellbeing index?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只看排名变化",
            "en": "Only changes in rank"
          },
          {
            "id": "b",
            "zh-CN": "维度、权重与数据可比性",
            "en": "Dimensions, weights and data comparability"
          },
          {
            "id": "c",
            "zh-CN": "假设权重无价值判断",
            "en": "Assume weights involve no judgement"
          },
          {
            "id": "d",
            "zh-CN": "忽略国内差距",
            "en": "Ignore within-country gaps"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "维度、权重与数据可比性。 明确希望衡量的福利维度；选择可比较的数据与权重；结合 GDP 解读综合指标的差异 不同指标衡量不同目标，不能认为任一综合指数完全客观或无遗漏。",
          "en": "Dimensions, weights and data comparability. Specify the wellbeing dimensions; select comparable data and weights; interpret composite indicators alongside GDP Different indicators target different outcomes; no composite is completely objective or exhaustive."
        }
      },
      {
        "id": "u3-10-wellbeing-indicators-short-1",
        "knowledgePointId": "u3-10-wellbeing-indicators",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释替代福利指标的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Alternative wellbeing indicators and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "替代指标可综合收入、健康、教育、主观生活满意度和生态压力；指标选择与权重涉及价值判断，不能由单一排名代替分析。 明确希望衡量的福利维度；选择可比较的数据与权重；结合 GDP 解读综合指标的差异 原创例：两国人均收入相近，健康预期和教育机会却不同，综合人类发展指标可补充收入比较。主观幸福还受文化与调查方法影响；综合值也可能掩盖国内群体差距。 OECD 美好生活指标比较住房、收入、工作等多个维度；幸福类报告强调主观生活评价，快乐星球指数把福祉和寿命与环境负担联系，不能与 HDI 混为一谈。",
          "en": "Alternative indicators can combine income, health, education, subjective satisfaction and ecological pressure. Choosing dimensions and weights involves judgement, so a ranking cannot replace analysis. Specify the wellbeing dimensions; select comparable data and weights; interpret composite indicators alongside GDP Illustrative example: two countries have similar income per person but different health prospects and educational opportunities. Human-development measures complement income. Subjective happiness also depends on culture and survey design, while composites can conceal internal group gaps. The OECD Better Life Index compares multiple dimensions such as housing, income and jobs; happiness reports emphasise subjective life evaluation, while the Happy Planet Index relates well-being and longevity to environmental pressure. None is interchangeable with HDI."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "健康",
              "en": "health"
            },
            "alternatives": {
              "zh-CN": [
                "健康",
                "明确希望衡量的福利维度"
              ],
              "en": [
                "health",
                "Specify the wellbeing dimensions"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "教育",
              "en": "education"
            },
            "alternatives": {
              "zh-CN": [
                "教育",
                "选择可比较的数据与权重"
              ],
              "en": [
                "education",
                "select comparable data and weights"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "权重",
              "en": "weights"
            },
            "alternatives": {
              "zh-CN": [
                "权重",
                "结合 GDP 解读综合指标的差异"
              ],
              "en": [
                "weights",
                "interpret composite indicators alongside GDP"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-11-aggregate-demand",
      "slug": "aggregate-demand",
      "section": "3.2",
      "level": "core",
      "syllabusRefs": [
        "3.2 Aggregate demand and aggregate supply"
      ],
      "textbookRefs": [
        {
          "chapter": "9",
          "section": "9.1",
          "pages": [
            272
          ]
        }
      ],
      "prerequisites": [
        "u3-02-gdp"
      ],
      "related": [
        "u3-12-consumption",
        "u3-13-investment",
        "u3-14-sras"
      ],
      "terms": [
        "总需求与 AD 曲线",
        "Aggregate demand and the AD curve",
        "计划支出",
        "planned spending",
        "价格水平",
        "price level",
        "实际 GDP",
        "real GDP"
      ],
      "synonyms": {
        "zh-CN": [
          "计划支出",
          "价格水平",
          "实际 GDP"
        ],
        "en": [
          "planned spending",
          "price level",
          "real GDP"
        ]
      },
      "diagramIds": [
        "macro-ad-as"
      ],
      "quizIds": [
        "u3-11-aggregate-demand-flash-1",
        "u3-11-aggregate-demand-mcq-1",
        "u3-11-aggregate-demand-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-11-aggregate-demand",
        "locale": "zh-CN",
        "title": "总需求与 AD 曲线",
        "takeaway": "总需求 AD 是给定总体价格水平下对境内实际产出的计划总支出，组成是 C+I+G+(X−M)。",
        "definition": "总需求 AD 是给定总体价格水平下对境内实际产出的计划总支出，组成是 C+I+G+(X−M)。",
        "causalChain": [
          "总体价格水平变化影响实际财富、利率和净出口",
          "计划总支出改变",
          "沿 AD 曲线移动"
        ],
        "misconceptions": [
          "AD 向下倾斜不能只用单一商品的替代效应解释。"
        ],
        "examApplication": [
          "标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
        ],
        "summary": [
          "总需求 AD 是给定总体价格水平下对境内实际产出的计划总支出，组成是 C+I+G+(X−M)。",
          "AD 向下倾斜不能只用单一商品的替代效应解释。"
        ],
        "explanation": "总体价格水平变化影响实际财富、利率和净出口。计划总支出改变。沿 AD 曲线移动。\n\n### 原创情境与推导\n\n原创例：总体价格下降可能提高货币资产实际购买力并改善出口价格竞争力，从而增加总需求量。AD 的横轴是实际 GDP，纵轴是总体价格水平，不是某一种产品价格和数量。\n\nAD 向下倾斜不能只用单一商品的替代效应解释。\n\n标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
      },
      "en": {
        "id": "u3-11-aggregate-demand",
        "locale": "en",
        "title": "Aggregate demand and the AD curve",
        "takeaway": "Aggregate demand is planned total spending on domestic real output at each general price level, comprising C+I+G+(X−M).",
        "definition": "Aggregate demand is planned total spending on domestic real output at each general price level, comprising C+I+G+(X−M).",
        "causalChain": [
          "The general price level affects real wealth, interest rates and net exports",
          "planned spending changes",
          "the economy moves along AD"
        ],
        "misconceptions": [
          "AD's downward slope cannot be explained solely by substitution between individual goods."
        ],
        "examApplication": [
          "Label price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
        ],
        "summary": [
          "Aggregate demand is planned total spending on domestic real output at each general price level, comprising C+I+G+(X−M).",
          "AD's downward slope cannot be explained solely by substitution between individual goods."
        ],
        "explanation": "The general price level affects real wealth, interest rates and net exports.  planned spending changes.  the economy moves along AD.\n\n### Original scenario and reasoning\n\nIllustrative example: a lower price level can raise the real value of money balances and improve export price competitiveness, increasing quantity of aggregate demand. The axes are real GDP and the general price level, not one product's price and quantity.\n\nAD's downward slope cannot be explained solely by substitution between individual goods.\n\nLabel price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
      }
    },
    "practice": [
      {
        "id": "u3-11-aggregate-demand-flash-1",
        "knowledgePointId": "u3-11-aggregate-demand",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“总需求与 AD 曲线”，并说明一个关键条件。",
          "en": "Explain Aggregate demand and the AD curve and state one important condition."
        },
        "answer": {
          "zh-CN": "总需求 AD 是给定总体价格水平下对境内实际产出的计划总支出，组成是 C+I+G+(X−M)。",
          "en": "Aggregate demand is planned total spending on domestic real output at each general price level, comprising C+I+G+(X−M)."
        },
        "explanation": {
          "zh-CN": "AD 向下倾斜不能只用单一商品的替代效应解释。",
          "en": "AD's downward slope cannot be explained solely by substitution between individual goods."
        }
      },
      {
        "id": "u3-11-aggregate-demand-mcq-1",
        "knowledgePointId": "u3-11-aggregate-demand",
        "type": "mcq",
        "prompt": {
          "zh-CN": "AD–AS 图横轴应该是什么？",
          "en": "What belongs on the horizontal axis of AD–AS?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "通胀率",
            "en": "Inflation rate"
          },
          {
            "id": "b",
            "zh-CN": "单个企业产量",
            "en": "One firm's output"
          },
          {
            "id": "c",
            "zh-CN": "实际 GDP",
            "en": "Real GDP"
          },
          {
            "id": "d",
            "zh-CN": "名义利率",
            "en": "Nominal interest rate"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "实际 GDP。 总体价格水平变化影响实际财富、利率和净出口；计划总支出改变；沿 AD 曲线移动 AD 向下倾斜不能只用单一商品的替代效应解释。",
          "en": "Real GDP. The general price level affects real wealth, interest rates and net exports; planned spending changes; the economy moves along AD AD's downward slope cannot be explained solely by substitution between individual goods."
        }
      },
      {
        "id": "u3-11-aggregate-demand-short-1",
        "knowledgePointId": "u3-11-aggregate-demand",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释总需求与 AD 曲线的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Aggregate demand and the AD curve and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "总需求 AD 是给定总体价格水平下对境内实际产出的计划总支出，组成是 C+I+G+(X−M)。 总体价格水平变化影响实际财富、利率和净出口；计划总支出改变；沿 AD 曲线移动 原创例：总体价格下降可能提高货币资产实际购买力并改善出口价格竞争力，从而增加总需求量。AD 的横轴是实际 GDP，纵轴是总体价格水平，不是某一种产品价格和数量。",
          "en": "Aggregate demand is planned total spending on domestic real output at each general price level, comprising C+I+G+(X−M). The general price level affects real wealth, interest rates and net exports; planned spending changes; the economy moves along AD Illustrative example: a lower price level can raise the real value of money balances and improve export price competitiveness, increasing quantity of aggregate demand. The axes are real GDP and the general price level, not one product's price and quantity."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "计划支出",
              "en": "planned spending"
            },
            "alternatives": {
              "zh-CN": [
                "计划支出",
                "总体价格水平变化影响实际财富、利率和净出口"
              ],
              "en": [
                "planned spending",
                "The general price level affects real wealth, interest rates and net exports"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "价格水平",
              "en": "price level"
            },
            "alternatives": {
              "zh-CN": [
                "价格水平",
                "计划总支出改变"
              ],
              "en": [
                "price level",
                "planned spending changes"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "实际 GDP",
              "en": "real GDP"
            },
            "alternatives": {
              "zh-CN": [
                "实际 GDP",
                "沿 AD 曲线移动"
              ],
              "en": [
                "real GDP",
                "the economy moves along AD"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-12-consumption",
      "slug": "consumption",
      "section": "3.2",
      "level": "core",
      "syllabusRefs": [
        "3.2 Aggregate demand and aggregate supply"
      ],
      "textbookRefs": [
        {
          "chapter": "9",
          "section": "9.1",
          "pages": [
            272
          ]
        }
      ],
      "prerequisites": [
        "u3-02-gdp"
      ],
      "related": [
        "u3-11-aggregate-demand",
        "u3-13-investment",
        "u3-14-sras"
      ],
      "terms": [
        "消费与总需求移动",
        "Consumption and shifts in aggregate demand",
        "可支配收入",
        "disposable income",
        "信心",
        "confidence",
        "消费",
        "consumption"
      ],
      "synonyms": {
        "zh-CN": [
          "可支配收入",
          "信心",
          "消费"
        ],
        "en": [
          "disposable income",
          "confidence",
          "consumption"
        ]
      },
      "diagramIds": [
        "macro-ad-expansion"
      ],
      "quizIds": [
        "u3-12-consumption-flash-1",
        "u3-12-consumption-mcq-1",
        "u3-12-consumption-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-12-consumption",
        "locale": "zh-CN",
        "title": "消费与总需求移动",
        "takeaway": "消费受可支配收入、财富、信心、利率、家庭债务及预期影响；在价格水平不变时这些因素可移动 AD。",
        "definition": "消费受可支配收入、财富、信心、利率、家庭债务及预期影响；在价格水平不变时这些因素可移动 AD。",
        "causalChain": [
          "可支配收入或信心改变",
          "家庭计划消费改变",
          "消费占比使总需求随之移动"
        ],
        "misconceptions": [
          "收入提高引起消费变化与总体价格水平变化引起沿 AD 移动不是同一过程。"
        ],
        "examApplication": [
          "标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
        ],
        "summary": [
          "消费受可支配收入、财富、信心、利率、家庭债务及预期影响；在价格水平不变时这些因素可移动 AD。",
          "收入提高引起消费变化与总体价格水平变化引起沿 AD 移动不是同一过程。"
        ],
        "explanation": "可支配收入或信心改变。家庭计划消费改变。消费占比使总需求随之移动。\n\n### 原创情境与推导\n\n原创例：减税增加可支配收入，但若家庭担心失业并把新增收入储蓄，消费增加较少。要区分减税金额和实际额外消费，不能假定每一元收入都被花出。\n\n收入提高引起消费变化与总体价格水平变化引起沿 AD 移动不是同一过程。\n\n标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
      },
      "en": {
        "id": "u3-12-consumption",
        "locale": "en",
        "title": "Consumption and shifts in aggregate demand",
        "takeaway": "Consumption depends on disposable income, wealth, confidence, interest rates, household debt and expectations. Changes in these determinants can shift AD at a given price level.",
        "definition": "Consumption depends on disposable income, wealth, confidence, interest rates, household debt and expectations. Changes in these determinants can shift AD at a given price level.",
        "causalChain": [
          "Disposable income or confidence changes",
          "households alter planned consumption",
          "its expenditure share shifts aggregate demand"
        ],
        "misconceptions": [
          "Consumption changes from higher income differ from movements along AD caused by a price-level change."
        ],
        "examApplication": [
          "Label price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
        ],
        "summary": [
          "Consumption depends on disposable income, wealth, confidence, interest rates, household debt and expectations. Changes in these determinants can shift AD at a given price level.",
          "Consumption changes from higher income differ from movements along AD caused by a price-level change."
        ],
        "explanation": "Disposable income or confidence changes.  households alter planned consumption.  its expenditure share shifts aggregate demand.\n\n### Original scenario and reasoning\n\nIllustrative example: a tax cut raises disposable income, but households fearing job loss may save the increase. Distinguish the tax reduction from additional consumption rather than assuming every extra unit of income is spent.\n\nConsumption changes from higher income differ from movements along AD caused by a price-level change.\n\nLabel price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
      }
    },
    "practice": [
      {
        "id": "u3-12-consumption-flash-1",
        "knowledgePointId": "u3-12-consumption",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“消费与总需求移动”，并说明一个关键条件。",
          "en": "Explain Consumption and shifts in aggregate demand and state one important condition."
        },
        "answer": {
          "zh-CN": "消费受可支配收入、财富、信心、利率、家庭债务及预期影响；在价格水平不变时这些因素可移动 AD。",
          "en": "Consumption depends on disposable income, wealth, confidence, interest rates, household debt and expectations. Changes in these determinants can shift AD at a given price level."
        },
        "explanation": {
          "zh-CN": "收入提高引起消费变化与总体价格水平变化引起沿 AD 移动不是同一过程。",
          "en": "Consumption changes from higher income differ from movements along AD caused by a price-level change."
        }
      },
      {
        "id": "u3-12-consumption-mcq-1",
        "knowledgePointId": "u3-12-consumption",
        "type": "mcq",
        "prompt": {
          "zh-CN": "信心下降导致家庭增加预防性储蓄，AD 通常怎样？",
          "en": "Lower confidence raises precautionary saving. What normally happens to AD?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "右移",
            "en": "Shifts right"
          },
          {
            "id": "b",
            "zh-CN": "只沿 AD 移动",
            "en": "Only a movement along AD"
          },
          {
            "id": "c",
            "zh-CN": "LRAS 必然立刻右移",
            "en": "LRAS necessarily shifts right immediately"
          },
          {
            "id": "d",
            "zh-CN": "左移",
            "en": "Shifts left"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "左移。 可支配收入或信心改变；家庭计划消费改变；消费占比使总需求随之移动 收入提高引起消费变化与总体价格水平变化引起沿 AD 移动不是同一过程。",
          "en": "Shifts left. Disposable income or confidence changes; households alter planned consumption; its expenditure share shifts aggregate demand Consumption changes from higher income differ from movements along AD caused by a price-level change."
        }
      },
      {
        "id": "u3-12-consumption-short-1",
        "knowledgePointId": "u3-12-consumption",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释消费与总需求移动的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Consumption and shifts in aggregate demand and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "消费受可支配收入、财富、信心、利率、家庭债务及预期影响；在价格水平不变时这些因素可移动 AD。 可支配收入或信心改变；家庭计划消费改变；消费占比使总需求随之移动 原创例：减税增加可支配收入，但若家庭担心失业并把新增收入储蓄，消费增加较少。要区分减税金额和实际额外消费，不能假定每一元收入都被花出。",
          "en": "Consumption depends on disposable income, wealth, confidence, interest rates, household debt and expectations. Changes in these determinants can shift AD at a given price level. Disposable income or confidence changes; households alter planned consumption; its expenditure share shifts aggregate demand Illustrative example: a tax cut raises disposable income, but households fearing job loss may save the increase. Distinguish the tax reduction from additional consumption rather than assuming every extra unit of income is spent."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "可支配收入",
              "en": "disposable income"
            },
            "alternatives": {
              "zh-CN": [
                "可支配收入",
                "可支配收入或信心改变"
              ],
              "en": [
                "disposable income",
                "Disposable income or confidence changes"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "信心",
              "en": "confidence"
            },
            "alternatives": {
              "zh-CN": [
                "信心",
                "家庭计划消费改变"
              ],
              "en": [
                "confidence",
                "households alter planned consumption"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "消费",
              "en": "consumption"
            },
            "alternatives": {
              "zh-CN": [
                "消费",
                "消费占比使总需求随之移动"
              ],
              "en": [
                "consumption",
                "its expenditure share shifts aggregate demand"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-13-investment",
      "slug": "investment",
      "section": "3.2",
      "level": "core",
      "syllabusRefs": [
        "3.2 Aggregate demand and aggregate supply"
      ],
      "textbookRefs": [
        {
          "chapter": "9",
          "section": "9.1",
          "pages": [
            272
          ]
        }
      ],
      "prerequisites": [
        "u3-02-gdp"
      ],
      "related": [
        "u3-11-aggregate-demand",
        "u3-12-consumption",
        "u3-14-sras"
      ],
      "terms": [
        "投资与加速、信心和利率",
        "Investment, confidence and interest rates",
        "预期回报",
        "expected returns",
        "融资成本",
        "financing costs",
        "产能",
        "capacity"
      ],
      "synonyms": {
        "zh-CN": [
          "预期回报",
          "融资成本",
          "产能"
        ],
        "en": [
          "expected returns",
          "financing costs",
          "capacity"
        ]
      },
      "diagramIds": [
        "macro-ad-expansion"
      ],
      "quizIds": [
        "u3-13-investment-flash-1",
        "u3-13-investment-mcq-1",
        "u3-13-investment-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-13-investment",
        "locale": "zh-CN",
        "title": "投资与加速、信心和利率",
        "takeaway": "宏观投资是新增资本与存货，不是购买证券；它受预期回报、借贷成本、信心、技术、企业税和闲置产能影响。",
        "definition": "宏观投资是新增资本与存货，不是购买证券；它受预期回报、借贷成本、信心、技术、企业税和闲置产能影响。",
        "causalChain": [
          "企业比较预期回报与融资成本",
          "有利可图项目数量变化",
          "投资既改变当前 AD 也可改变未来产能"
        ],
        "misconceptions": [
          "投资的短期需求效应与长期供给效应应分别解释。"
        ],
        "examApplication": [
          "标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
        ],
        "summary": [
          "宏观投资是新增资本与存货，不是购买证券；它受预期回报、借贷成本、信心、技术、企业税和闲置产能影响。",
          "投资的短期需求效应与长期供给效应应分别解释。"
        ],
        "explanation": "企业比较预期回报与融资成本。有利可图项目数量变化。投资既改变当前 AD 也可改变未来产能。\n\n### 原创情境与推导\n\n原创例：项目预期回报 6%，借贷成本从 7% 降至 4%，可能使项目更有吸引力。但销售前景差或企业有大量闲置机器时，降息未必促成投资。新增厂房先增加需求，投入使用后才增加潜力。\n\n投资的短期需求效应与长期供给效应应分别解释。\n\n标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
      },
      "en": {
        "id": "u3-13-investment",
        "locale": "en",
        "title": "Investment, confidence and interest rates",
        "takeaway": "Macroeconomic investment means new capital and inventories, not security purchases. Expected returns, borrowing costs, confidence, technology, business taxes and spare capacity influence it.",
        "definition": "Macroeconomic investment means new capital and inventories, not security purchases. Expected returns, borrowing costs, confidence, technology, business taxes and spare capacity influence it.",
        "causalChain": [
          "Firms compare expected returns with financing costs",
          "the set of profitable projects changes",
          "investment affects current AD and potentially future capacity"
        ],
        "misconceptions": [
          "Explain investment's short-run demand and long-run supply effects separately."
        ],
        "examApplication": [
          "Label price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
        ],
        "summary": [
          "Macroeconomic investment means new capital and inventories, not security purchases. Expected returns, borrowing costs, confidence, technology, business taxes and spare capacity influence it.",
          "Explain investment's short-run demand and long-run supply effects separately."
        ],
        "explanation": "Firms compare expected returns with financing costs.  the set of profitable projects changes.  investment affects current AD and potentially future capacity.\n\n### Original scenario and reasoning\n\nIllustrative example: a project expected to return 6% becomes more attractive when borrowing cost falls from 7% to 4%. Weak sales or substantial idle capacity can still prevent investment. Building a plant first adds demand; operating it later raises capacity.\n\nExplain investment's short-run demand and long-run supply effects separately.\n\nLabel price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
      }
    },
    "practice": [
      {
        "id": "u3-13-investment-flash-1",
        "knowledgePointId": "u3-13-investment",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“投资与加速、信心和利率”，并说明一个关键条件。",
          "en": "Explain Investment, confidence and interest rates and state one important condition."
        },
        "answer": {
          "zh-CN": "宏观投资是新增资本与存货，不是购买证券；它受预期回报、借贷成本、信心、技术、企业税和闲置产能影响。",
          "en": "Macroeconomic investment means new capital and inventories, not security purchases. Expected returns, borrowing costs, confidence, technology, business taxes and spare capacity influence it."
        },
        "explanation": {
          "zh-CN": "投资的短期需求效应与长期供给效应应分别解释。",
          "en": "Explain investment's short-run demand and long-run supply effects separately."
        }
      },
      {
        "id": "u3-13-investment-mcq-1",
        "knowledgePointId": "u3-13-investment",
        "type": "mcq",
        "prompt": {
          "zh-CN": "新建厂房对经济最合理的两阶段影响是什么？",
          "en": "What is the most reasonable two-stage effect of building a new factory?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "先增加 AD，之后可能增加潜在产出",
            "en": "Raises AD first, then may raise potential output"
          },
          {
            "id": "b",
            "zh-CN": "只改变股票价格",
            "en": "Only changes share prices"
          },
          {
            "id": "c",
            "zh-CN": "立刻消除全部失业",
            "en": "Immediately eliminates all unemployment"
          },
          {
            "id": "d",
            "zh-CN": "总是减少资本存量",
            "en": "Always reduces the capital stock"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "先增加 AD，之后可能增加潜在产出。 企业比较预期回报与融资成本；有利可图项目数量变化；投资既改变当前 AD 也可改变未来产能 投资的短期需求效应与长期供给效应应分别解释。",
          "en": "Raises AD first, then may raise potential output. Firms compare expected returns with financing costs; the set of profitable projects changes; investment affects current AD and potentially future capacity Explain investment's short-run demand and long-run supply effects separately."
        }
      },
      {
        "id": "u3-13-investment-short-1",
        "knowledgePointId": "u3-13-investment",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释投资与加速、信心和利率的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Investment, confidence and interest rates and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "宏观投资是新增资本与存货，不是购买证券；它受预期回报、借贷成本、信心、技术、企业税和闲置产能影响。 企业比较预期回报与融资成本；有利可图项目数量变化；投资既改变当前 AD 也可改变未来产能 原创例：项目预期回报 6%，借贷成本从 7% 降至 4%，可能使项目更有吸引力。但销售前景差或企业有大量闲置机器时，降息未必促成投资。新增厂房先增加需求，投入使用后才增加潜力。",
          "en": "Macroeconomic investment means new capital and inventories, not security purchases. Expected returns, borrowing costs, confidence, technology, business taxes and spare capacity influence it. Firms compare expected returns with financing costs; the set of profitable projects changes; investment affects current AD and potentially future capacity Illustrative example: a project expected to return 6% becomes more attractive when borrowing cost falls from 7% to 4%. Weak sales or substantial idle capacity can still prevent investment. Building a plant first adds demand; operating it later raises capacity."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "预期回报",
              "en": "expected returns"
            },
            "alternatives": {
              "zh-CN": [
                "预期回报",
                "企业比较预期回报与融资成本"
              ],
              "en": [
                "expected returns",
                "Firms compare expected returns with financing costs"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "融资成本",
              "en": "financing costs"
            },
            "alternatives": {
              "zh-CN": [
                "融资成本",
                "有利可图项目数量变化"
              ],
              "en": [
                "financing costs",
                "the set of profitable projects changes"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "产能",
              "en": "capacity"
            },
            "alternatives": {
              "zh-CN": [
                "产能",
                "投资既改变当前 AD 也可改变未来产能"
              ],
              "en": [
                "capacity",
                "investment affects current AD and potentially future capacity"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-14-sras",
      "slug": "sras",
      "section": "3.2",
      "level": "core",
      "syllabusRefs": [
        "3.2 Aggregate demand and aggregate supply"
      ],
      "textbookRefs": [
        {
          "chapter": "9",
          "section": "9.2",
          "pages": [
            276
          ]
        }
      ],
      "prerequisites": [
        "u3-02-gdp"
      ],
      "related": [
        "u3-11-aggregate-demand",
        "u3-12-consumption",
        "u3-13-investment"
      ],
      "terms": [
        "短期总供给 SRAS",
        "Short-run aggregate supply",
        "成本",
        "costs",
        "价格水平",
        "price level",
        "实际产出",
        "real output"
      ],
      "synonyms": {
        "zh-CN": [
          "成本",
          "价格水平",
          "实际产出"
        ],
        "en": [
          "costs",
          "price level",
          "real output"
        ]
      },
      "diagramIds": [
        "macro-supply-shock"
      ],
      "quizIds": [
        "u3-14-sras-flash-1",
        "u3-14-sras-mcq-1",
        "u3-14-sras-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-14-sras",
        "locale": "zh-CN",
        "title": "短期总供给 SRAS",
        "takeaway": "SRAS 表示短期部分投入价格或工资调整不充分时，总体价格水平与企业愿意生产的实际产出关系。单位成本提高通常使其左移。",
        "definition": "SRAS 表示短期部分投入价格或工资调整不充分时，总体价格水平与企业愿意生产的实际产出关系。单位成本提高通常使其左移。",
        "causalChain": [
          "投入价格相对固定时产品价格上升",
          "实际生产利润率改善",
          "企业沿 SRAS 增加产出"
        ],
        "misconceptions": [
          "SRAS 左移是成本冲击，不能画成 AD 右移。"
        ],
        "examApplication": [
          "标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
        ],
        "summary": [
          "SRAS 表示短期部分投入价格或工资调整不充分时，总体价格水平与企业愿意生产的实际产出关系。单位成本提高通常使其左移。",
          "SRAS 左移是成本冲击，不能画成 AD 右移。"
        ],
        "explanation": "投入价格相对固定时产品价格上升。实际生产利润率改善。企业沿 SRAS 增加产出。\n\n### 原创情境与推导\n\n原创例：能源涨价提高众多行业成本，使 SRAS 左移，在 AD 不变时价格水平上升而实际产出下降。若产品价格与所有投入价格同比上升，不能仍假定原有短期实际利润激励。\n\nSRAS 左移是成本冲击，不能画成 AD 右移。\n\n标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
      },
      "en": {
        "id": "u3-14-sras",
        "locale": "en",
        "title": "Short-run aggregate supply",
        "takeaway": "SRAS relates the price level to real output when some input prices or wages do not fully adjust in the short run. Higher unit costs normally shift it left.",
        "definition": "SRAS relates the price level to real output when some input prices or wages do not fully adjust in the short run. Higher unit costs normally shift it left.",
        "causalChain": [
          "Output prices rise relative to temporarily fixed input prices",
          "production margins improve",
          "firms expand output along SRAS"
        ],
        "misconceptions": [
          "A leftward SRAS shift is a cost shock, not a rightward AD shift."
        ],
        "examApplication": [
          "Label price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
        ],
        "summary": [
          "SRAS relates the price level to real output when some input prices or wages do not fully adjust in the short run. Higher unit costs normally shift it left.",
          "A leftward SRAS shift is a cost shock, not a rightward AD shift."
        ],
        "explanation": "Output prices rise relative to temporarily fixed input prices.  production margins improve.  firms expand output along SRAS.\n\n### Original scenario and reasoning\n\nIllustrative example: dearer energy shifts SRAS left, raising the price level and reducing real output with unchanged AD. If output and all input prices rise proportionately, the original short-run real-margin incentive cannot simply be assumed.\n\nA leftward SRAS shift is a cost shock, not a rightward AD shift.\n\nLabel price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
      }
    },
    "practice": [
      {
        "id": "u3-14-sras-flash-1",
        "knowledgePointId": "u3-14-sras",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“短期总供给 SRAS”，并说明一个关键条件。",
          "en": "Explain Short-run aggregate supply and state one important condition."
        },
        "answer": {
          "zh-CN": "SRAS 表示短期部分投入价格或工资调整不充分时，总体价格水平与企业愿意生产的实际产出关系。单位成本提高通常使其左移。",
          "en": "SRAS relates the price level to real output when some input prices or wages do not fully adjust in the short run. Higher unit costs normally shift it left."
        },
        "explanation": {
          "zh-CN": "SRAS 左移是成本冲击，不能画成 AD 右移。",
          "en": "A leftward SRAS shift is a cost shock, not a rightward AD shift."
        }
      },
      {
        "id": "u3-14-sras-mcq-1",
        "knowledgePointId": "u3-14-sras",
        "type": "mcq",
        "prompt": {
          "zh-CN": "进口能源成本上升、AD 不变，通常出现什么？",
          "en": "Imported energy costs rise with AD unchanged. What normally follows?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "价格水平降、产出升",
            "en": "Lower price level, higher output"
          },
          {
            "id": "b",
            "zh-CN": "价格水平升、实际产出降",
            "en": "Higher price level, lower real output"
          },
          {
            "id": "c",
            "zh-CN": "两者都必然不变",
            "en": "Both necessarily unchanged"
          },
          {
            "id": "d",
            "zh-CN": "LRAS 必然右移",
            "en": "LRAS necessarily shifts right"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "价格水平升、实际产出降。 投入价格相对固定时产品价格上升；实际生产利润率改善；企业沿 SRAS 增加产出 SRAS 左移是成本冲击，不能画成 AD 右移。",
          "en": "Higher price level, lower real output. Output prices rise relative to temporarily fixed input prices; production margins improve; firms expand output along SRAS A leftward SRAS shift is a cost shock, not a rightward AD shift."
        }
      },
      {
        "id": "u3-14-sras-short-1",
        "knowledgePointId": "u3-14-sras",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释短期总供给 SRAS的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Short-run aggregate supply and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "SRAS 表示短期部分投入价格或工资调整不充分时，总体价格水平与企业愿意生产的实际产出关系。单位成本提高通常使其左移。 投入价格相对固定时产品价格上升；实际生产利润率改善；企业沿 SRAS 增加产出 原创例：能源涨价提高众多行业成本，使 SRAS 左移，在 AD 不变时价格水平上升而实际产出下降。若产品价格与所有投入价格同比上升，不能仍假定原有短期实际利润激励。",
          "en": "SRAS relates the price level to real output when some input prices or wages do not fully adjust in the short run. Higher unit costs normally shift it left. Output prices rise relative to temporarily fixed input prices; production margins improve; firms expand output along SRAS Illustrative example: dearer energy shifts SRAS left, raising the price level and reducing real output with unchanged AD. If output and all input prices rise proportionately, the original short-run real-margin incentive cannot simply be assumed."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "成本",
              "en": "costs"
            },
            "alternatives": {
              "zh-CN": [
                "成本",
                "投入价格相对固定时产品价格上升"
              ],
              "en": [
                "costs",
                "Output prices rise relative to temporarily fixed input prices"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "价格水平",
              "en": "price level"
            },
            "alternatives": {
              "zh-CN": [
                "价格水平",
                "实际生产利润率改善"
              ],
              "en": [
                "price level",
                "production margins improve"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "实际产出",
              "en": "real output"
            },
            "alternatives": {
              "zh-CN": [
                "实际产出",
                "企业沿 SRAS 增加产出"
              ],
              "en": [
                "real output",
                "firms expand output along SRAS"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-15-lras",
      "slug": "lras",
      "section": "3.2",
      "level": "core",
      "syllabusRefs": [
        "3.2 Aggregate demand and aggregate supply"
      ],
      "textbookRefs": [
        {
          "chapter": "9",
          "section": "9.3",
          "pages": [
            281
          ]
        }
      ],
      "prerequisites": [
        "u3-02-gdp"
      ],
      "related": [
        "u3-11-aggregate-demand",
        "u3-12-consumption",
        "u3-13-investment"
      ],
      "terms": [
        "长期总供给与潜在产出",
        "Long-run aggregate supply and potential output",
        "长期",
        "long run",
        "潜在产出",
        "potential output",
        "工资调整",
        "wage adjustment"
      ],
      "synonyms": {
        "zh-CN": [
          "长期",
          "潜在产出",
          "工资调整"
        ],
        "en": [
          "long run",
          "potential output",
          "wage adjustment"
        ]
      },
      "diagramIds": [
        "macro-lras"
      ],
      "quizIds": [
        "u3-15-lras-flash-1",
        "u3-15-lras-mcq-1",
        "u3-15-lras-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-15-lras",
        "locale": "zh-CN",
        "title": "长期总供给与潜在产出",
        "takeaway": "新古典模型中 LRAS 在潜在产出 Yf 处垂直；长期实际产出由资源、技术和制度决定，而非持续提高价格水平。",
        "definition": "新古典模型中 LRAS 在潜在产出 Yf 处垂直；长期实际产出由资源、技术和制度决定，而非持续提高价格水平。",
        "causalChain": [
          "长期工资与投入价格调整",
          "短期实际激励逐步消失",
          "产出回到由生产能力决定的潜在水平"
        ],
        "misconceptions": [
          "潜在产出不等于没有任何失业，摩擦性和结构性失业仍可存在。"
        ],
        "examApplication": [
          "标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
        ],
        "summary": [
          "新古典模型中 LRAS 在潜在产出 Yf 处垂直；长期实际产出由资源、技术和制度决定，而非持续提高价格水平。",
          "潜在产出不等于没有任何失业，摩擦性和结构性失业仍可存在。"
        ],
        "explanation": "长期工资与投入价格调整。短期实际激励逐步消失。产出回到由生产能力决定的潜在水平。\n\n### 原创情境与推导\n\n原创例：AD 增加可短期推动产出超过 Yf。工资成本随后上升，SRAS 左移，长期产出回到 Yf 而价格水平更高。这个结论依赖工资价格调整和竞争等假设，不能当作无条件的即时过程。\n\n潜在产出不等于没有任何失业，摩擦性和结构性失业仍可存在。\n\n标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
      },
      "en": {
        "id": "u3-15-lras",
        "locale": "en",
        "title": "Long-run aggregate supply and potential output",
        "takeaway": "In the neoclassical model LRAS is vertical at potential output Yf. Long-run real output depends on resources, technology and institutions rather than continually raising the price level.",
        "definition": "In the neoclassical model LRAS is vertical at potential output Yf. Long-run real output depends on resources, technology and institutions rather than continually raising the price level.",
        "causalChain": [
          "Wages and input prices adjust over time",
          "short-run real incentives fade",
          "output returns to the level determined by productive capacity"
        ],
        "misconceptions": [
          "Potential output does not imply zero unemployment; frictional and structural unemployment may remain."
        ],
        "examApplication": [
          "Label price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
        ],
        "summary": [
          "In the neoclassical model LRAS is vertical at potential output Yf. Long-run real output depends on resources, technology and institutions rather than continually raising the price level.",
          "Potential output does not imply zero unemployment; frictional and structural unemployment may remain."
        ],
        "explanation": "Wages and input prices adjust over time.  short-run real incentives fade.  output returns to the level determined by productive capacity.\n\n### Original scenario and reasoning\n\nIllustrative example: higher AD may briefly push output above Yf. Rising wages then shift SRAS left, restoring Yf at a higher price level. This conclusion depends on wage-price adjustment and competitive assumptions, not an unconditional instant process.\n\nPotential output does not imply zero unemployment; frictional and structural unemployment may remain.\n\nLabel price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
      }
    },
    "practice": [
      {
        "id": "u3-15-lras-flash-1",
        "knowledgePointId": "u3-15-lras",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“长期总供给与潜在产出”，并说明一个关键条件。",
          "en": "Explain Long-run aggregate supply and potential output and state one important condition."
        },
        "answer": {
          "zh-CN": "新古典模型中 LRAS 在潜在产出 Yf 处垂直；长期实际产出由资源、技术和制度决定，而非持续提高价格水平。",
          "en": "In the neoclassical model LRAS is vertical at potential output Yf. Long-run real output depends on resources, technology and institutions rather than continually raising the price level."
        },
        "explanation": {
          "zh-CN": "潜在产出不等于没有任何失业，摩擦性和结构性失业仍可存在。",
          "en": "Potential output does not imply zero unemployment; frictional and structural unemployment may remain."
        }
      },
      {
        "id": "u3-15-lras-mcq-1",
        "knowledgePointId": "u3-15-lras",
        "type": "mcq",
        "prompt": {
          "zh-CN": "新古典长期中，单纯增加 AD 能永久提高实际产出吗？",
          "en": "In the neoclassical long run, can higher AD alone permanently raise real output?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "可以无限提高",
            "en": "Yes, without limit"
          },
          {
            "id": "b",
            "zh-CN": "只要价格翻倍即可",
            "en": "Yes, by doubling prices"
          },
          {
            "id": "c",
            "zh-CN": "不能，需增加生产能力",
            "en": "No; productive capacity must increase"
          },
          {
            "id": "d",
            "zh-CN": "必然使产能下降",
            "en": "It necessarily lowers capacity"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "不能，需增加生产能力。 长期工资与投入价格调整；短期实际激励逐步消失；产出回到由生产能力决定的潜在水平 潜在产出不等于没有任何失业，摩擦性和结构性失业仍可存在。",
          "en": "No; productive capacity must increase. Wages and input prices adjust over time; short-run real incentives fade; output returns to the level determined by productive capacity Potential output does not imply zero unemployment; frictional and structural unemployment may remain."
        }
      },
      {
        "id": "u3-15-lras-short-1",
        "knowledgePointId": "u3-15-lras",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释长期总供给与潜在产出的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Long-run aggregate supply and potential output and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "新古典模型中 LRAS 在潜在产出 Yf 处垂直；长期实际产出由资源、技术和制度决定，而非持续提高价格水平。 长期工资与投入价格调整；短期实际激励逐步消失；产出回到由生产能力决定的潜在水平 原创例：AD 增加可短期推动产出超过 Yf。工资成本随后上升，SRAS 左移，长期产出回到 Yf 而价格水平更高。这个结论依赖工资价格调整和竞争等假设，不能当作无条件的即时过程。",
          "en": "In the neoclassical model LRAS is vertical at potential output Yf. Long-run real output depends on resources, technology and institutions rather than continually raising the price level. Wages and input prices adjust over time; short-run real incentives fade; output returns to the level determined by productive capacity Illustrative example: higher AD may briefly push output above Yf. Rising wages then shift SRAS left, restoring Yf at a higher price level. This conclusion depends on wage-price adjustment and competitive assumptions, not an unconditional instant process."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "长期",
              "en": "long run"
            },
            "alternatives": {
              "zh-CN": [
                "长期",
                "长期工资与投入价格调整"
              ],
              "en": [
                "long run",
                "Wages and input prices adjust over time"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "潜在产出",
              "en": "potential output"
            },
            "alternatives": {
              "zh-CN": [
                "潜在产出",
                "短期实际激励逐步消失"
              ],
              "en": [
                "potential output",
                "short-run real incentives fade"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "工资调整",
              "en": "wage adjustment"
            },
            "alternatives": {
              "zh-CN": [
                "工资调整",
                "产出回到由生产能力决定的潜在水平"
              ],
              "en": [
                "wage adjustment",
                "output returns to the level determined by productive capacity"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-16-keynesian-as",
      "slug": "keynesian-as",
      "section": "3.2",
      "level": "core",
      "syllabusRefs": [
        "3.2 Aggregate demand and aggregate supply"
      ],
      "textbookRefs": [
        {
          "chapter": "9",
          "section": "9.4",
          "pages": [
            286
          ]
        }
      ],
      "prerequisites": [
        "u3-02-gdp"
      ],
      "related": [
        "u3-11-aggregate-demand",
        "u3-12-consumption",
        "u3-13-investment"
      ],
      "terms": [
        "凯恩斯总供给模型",
        "The Keynesian aggregate supply model",
        "闲置资源",
        "spare resources",
        "瓶颈",
        "bottlenecks",
        "刚性",
        "rigidity"
      ],
      "synonyms": {
        "zh-CN": [
          "闲置资源",
          "瓶颈",
          "刚性"
        ],
        "en": [
          "spare resources",
          "bottlenecks",
          "rigidity"
        ]
      },
      "diagramIds": [
        "macro-keynesian"
      ],
      "quizIds": [
        "u3-16-keynesian-as-flash-1",
        "u3-16-keynesian-as-mcq-1",
        "u3-16-keynesian-as-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-16-keynesian-as",
        "locale": "zh-CN",
        "title": "凯恩斯总供给模型",
        "takeaway": "凯恩斯 AS 示意模型在大量闲置资源时较平坦，接近充分就业时上升并最终趋于垂直；AD 对产出与物价的影响取决于所在区间。",
        "definition": "凯恩斯 AS 示意模型在大量闲置资源时较平坦，接近充分就业时上升并最终趋于垂直；AD 对产出与物价的影响取决于所在区间。",
        "causalChain": [
          "闲置资源允许较低成本扩张",
          "产能瓶颈随利用率上升",
          "接近满负荷时需求扩张主要推高价格"
        ],
        "misconceptions": [
          "曲线水平区间不表示资源永久无限。"
        ],
        "examApplication": [
          "标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
        ],
        "summary": [
          "凯恩斯 AS 示意模型在大量闲置资源时较平坦，接近充分就业时上升并最终趋于垂直；AD 对产出与物价的影响取决于所在区间。",
          "曲线水平区间不表示资源永久无限。"
        ],
        "explanation": "闲置资源允许较低成本扩张。产能瓶颈随利用率上升。接近满负荷时需求扩张主要推高价格。\n\n### 原创情境与推导\n\n原创例：衰退中增加公共支出可能主要扩大产量；已满负荷时同样支出更可能推高价格。工资向下刚性和信心不足可使低于充分就业的均衡持续。应解释假设，再与新古典调整过程比较。\n\n曲线水平区间不表示资源永久无限。\n\n标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
      },
      "en": {
        "id": "u3-16-keynesian-as",
        "locale": "en",
        "title": "The Keynesian aggregate supply model",
        "takeaway": "The Keynesian AS schematic is relatively flat with substantial spare resources, rises near full employment and becomes vertical at capacity. AD's output and price effects depend on the relevant range.",
        "definition": "The Keynesian AS schematic is relatively flat with substantial spare resources, rises near full employment and becomes vertical at capacity. AD's output and price effects depend on the relevant range.",
        "causalChain": [
          "Idle resources permit low-cost expansion",
          "bottlenecks develop as utilisation rises",
          "near capacity demand expansion mainly raises prices"
        ],
        "misconceptions": [
          "A flat range does not imply permanently unlimited resources."
        ],
        "examApplication": [
          "Label price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
        ],
        "summary": [
          "The Keynesian AS schematic is relatively flat with substantial spare resources, rises near full employment and becomes vertical at capacity. AD's output and price effects depend on the relevant range.",
          "A flat range does not imply permanently unlimited resources."
        ],
        "explanation": "Idle resources permit low-cost expansion.  bottlenecks develop as utilisation rises.  near capacity demand expansion mainly raises prices.\n\n### Original scenario and reasoning\n\nIllustrative example: extra public spending in a recession may mainly raise output, while at full capacity it mainly raises prices. Downward wage rigidity and weak confidence can sustain equilibrium below full employment. Explain assumptions before contrasting neoclassical adjustment.\n\nA flat range does not imply permanently unlimited resources.\n\nLabel price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
      }
    },
    "practice": [
      {
        "id": "u3-16-keynesian-as-flash-1",
        "knowledgePointId": "u3-16-keynesian-as",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“凯恩斯总供给模型”，并说明一个关键条件。",
          "en": "Explain The Keynesian aggregate supply model and state one important condition."
        },
        "answer": {
          "zh-CN": "凯恩斯 AS 示意模型在大量闲置资源时较平坦，接近充分就业时上升并最终趋于垂直；AD 对产出与物价的影响取决于所在区间。",
          "en": "The Keynesian AS schematic is relatively flat with substantial spare resources, rises near full employment and becomes vertical at capacity. AD's output and price effects depend on the relevant range."
        },
        "explanation": {
          "zh-CN": "曲线水平区间不表示资源永久无限。",
          "en": "A flat range does not imply permanently unlimited resources."
        }
      },
      {
        "id": "u3-16-keynesian-as-mcq-1",
        "knowledgePointId": "u3-16-keynesian-as",
        "type": "mcq",
        "prompt": {
          "zh-CN": "凯恩斯 AS 平坦区间中 AD 右移，主要结果是什么？",
          "en": "In the flat range of Keynesian AS, what is the main effect of higher AD?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只有价格上涨",
            "en": "Only higher prices"
          },
          {
            "id": "b",
            "zh-CN": "实际产出必降",
            "en": "Real output must fall"
          },
          {
            "id": "c",
            "zh-CN": "所有失业永远消失",
            "en": "All unemployment disappears forever"
          },
          {
            "id": "d",
            "zh-CN": "实际产出增加，价格变化较小",
            "en": "Higher real output with little price change"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "实际产出增加，价格变化较小。 闲置资源允许较低成本扩张；产能瓶颈随利用率上升；接近满负荷时需求扩张主要推高价格 曲线水平区间不表示资源永久无限。",
          "en": "Higher real output with little price change. Idle resources permit low-cost expansion; bottlenecks develop as utilisation rises; near capacity demand expansion mainly raises prices A flat range does not imply permanently unlimited resources."
        }
      },
      {
        "id": "u3-16-keynesian-as-short-1",
        "knowledgePointId": "u3-16-keynesian-as",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释凯恩斯总供给模型的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of The Keynesian aggregate supply model and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "凯恩斯 AS 示意模型在大量闲置资源时较平坦，接近充分就业时上升并最终趋于垂直；AD 对产出与物价的影响取决于所在区间。 闲置资源允许较低成本扩张；产能瓶颈随利用率上升；接近满负荷时需求扩张主要推高价格 原创例：衰退中增加公共支出可能主要扩大产量；已满负荷时同样支出更可能推高价格。工资向下刚性和信心不足可使低于充分就业的均衡持续。应解释假设，再与新古典调整过程比较。",
          "en": "The Keynesian AS schematic is relatively flat with substantial spare resources, rises near full employment and becomes vertical at capacity. AD's output and price effects depend on the relevant range. Idle resources permit low-cost expansion; bottlenecks develop as utilisation rises; near capacity demand expansion mainly raises prices Illustrative example: extra public spending in a recession may mainly raise output, while at full capacity it mainly raises prices. Downward wage rigidity and weak confidence can sustain equilibrium below full employment. Explain assumptions before contrasting neoclassical adjustment."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "闲置资源",
              "en": "spare resources"
            },
            "alternatives": {
              "zh-CN": [
                "闲置资源",
                "闲置资源允许较低成本扩张"
              ],
              "en": [
                "spare resources",
                "Idle resources permit low-cost expansion"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "瓶颈",
              "en": "bottlenecks"
            },
            "alternatives": {
              "zh-CN": [
                "瓶颈",
                "产能瓶颈随利用率上升"
              ],
              "en": [
                "bottlenecks",
                "bottlenecks develop as utilisation rises"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "刚性",
              "en": "rigidity"
            },
            "alternatives": {
              "zh-CN": [
                "刚性",
                "接近满负荷时需求扩张主要推高价格"
              ],
              "en": [
                "rigidity",
                "near capacity demand expansion mainly raises prices"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-17-macro-equilibrium",
      "slug": "macro-equilibrium",
      "section": "3.2",
      "level": "core",
      "syllabusRefs": [
        "3.2 Aggregate demand and aggregate supply"
      ],
      "textbookRefs": [
        {
          "chapter": "9",
          "section": "9.2",
          "pages": [
            276
          ]
        }
      ],
      "prerequisites": [
        "u3-02-gdp"
      ],
      "related": [
        "u3-11-aggregate-demand",
        "u3-12-consumption",
        "u3-13-investment"
      ],
      "terms": [
        "宏观均衡与比较静态",
        "Macroeconomic equilibrium and comparative statics",
        "交点",
        "intersection",
        "曲线移动",
        "shift",
        "价格水平",
        "price level"
      ],
      "synonyms": {
        "zh-CN": [
          "交点",
          "曲线移动",
          "价格水平"
        ],
        "en": [
          "intersection",
          "shift",
          "price level"
        ]
      },
      "diagramIds": [
        "macro-ad-as"
      ],
      "quizIds": [
        "u3-17-macro-equilibrium-flash-1",
        "u3-17-macro-equilibrium-mcq-1",
        "u3-17-macro-equilibrium-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-17-macro-equilibrium",
        "locale": "zh-CN",
        "title": "宏观均衡与比较静态",
        "takeaway": "短期宏观均衡由 AD 与 SRAS 交点确定总体价格水平和实际产出；长期均衡还需与潜在产出及相应长期模型一致。",
        "definition": "短期宏观均衡由 AD 与 SRAS 交点确定总体价格水平和实际产出；长期均衡还需与潜在产出及相应长期模型一致。",
        "causalChain": [
          "识别初始均衡",
          "根据冲击移动对应曲线",
          "比较新均衡并说明调整时间与假设"
        ],
        "misconceptions": [
          "不能把纵轴价格水平直接写成通胀率。"
        ],
        "examApplication": [
          "标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
        ],
        "summary": [
          "短期宏观均衡由 AD 与 SRAS 交点确定总体价格水平和实际产出；长期均衡还需与潜在产出及相应长期模型一致。",
          "不能把纵轴价格水平直接写成通胀率。"
        ],
        "explanation": "识别初始均衡。根据冲击移动对应曲线。比较新均衡并说明调整时间与假设。\n\n### 原创情境与推导\n\n原创例：出口需求上升使 AD 右移，向上倾斜 SRAS 下价格与产出都增加。若 AD 和 SRAS 同时右移，产出增加但价格方向取决于幅度。宏观价格水平上升也不直接给出每年通胀率。\n\n不能把纵轴价格水平直接写成通胀率。\n\n标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
      },
      "en": {
        "id": "u3-17-macro-equilibrium",
        "locale": "en",
        "title": "Macroeconomic equilibrium and comparative statics",
        "takeaway": "Short-run macroeconomic equilibrium is the AD–SRAS intersection giving the price level and real output. Long-run equilibrium must also be consistent with potential output and the relevant long-run model.",
        "definition": "Short-run macroeconomic equilibrium is the AD–SRAS intersection giving the price level and real output. Long-run equilibrium must also be consistent with potential output and the relevant long-run model.",
        "causalChain": [
          "Identify the initial equilibrium",
          "shift the appropriate curve for the shock",
          "compare the new equilibrium while stating timing and assumptions"
        ],
        "misconceptions": [
          "Do not label an AD–AS price-level axis as the inflation rate."
        ],
        "examApplication": [
          "Label price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
        ],
        "summary": [
          "Short-run macroeconomic equilibrium is the AD–SRAS intersection giving the price level and real output. Long-run equilibrium must also be consistent with potential output and the relevant long-run model.",
          "Do not label an AD–AS price-level axis as the inflation rate."
        ],
        "explanation": "Identify the initial equilibrium.  shift the appropriate curve for the shock.  compare the new equilibrium while stating timing and assumptions.\n\n### Original scenario and reasoning\n\nIllustrative example: stronger export demand shifts AD right, raising prices and output along upward SRAS. If AD and SRAS both shift right, output rises but the price direction depends on magnitudes. A higher price level does not by itself specify annual inflation.\n\nDo not label an AD–AS price-level axis as the inflation rate.\n\nLabel price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
      }
    },
    "practice": [
      {
        "id": "u3-17-macro-equilibrium-flash-1",
        "knowledgePointId": "u3-17-macro-equilibrium",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“宏观均衡与比较静态”，并说明一个关键条件。",
          "en": "Explain Macroeconomic equilibrium and comparative statics and state one important condition."
        },
        "answer": {
          "zh-CN": "短期宏观均衡由 AD 与 SRAS 交点确定总体价格水平和实际产出；长期均衡还需与潜在产出及相应长期模型一致。",
          "en": "Short-run macroeconomic equilibrium is the AD–SRAS intersection giving the price level and real output. Long-run equilibrium must also be consistent with potential output and the relevant long-run model."
        },
        "explanation": {
          "zh-CN": "不能把纵轴价格水平直接写成通胀率。",
          "en": "Do not label an AD–AS price-level axis as the inflation rate."
        }
      },
      {
        "id": "u3-17-macro-equilibrium-mcq-1",
        "knowledgePointId": "u3-17-macro-equilibrium",
        "type": "mcq",
        "prompt": {
          "zh-CN": "AD 与 SRAS 都右移，能确定什么？",
          "en": "AD and SRAS both shift right. What can be determined?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "实际产出增加",
            "en": "Real output increases"
          },
          {
            "id": "b",
            "zh-CN": "价格一定上涨",
            "en": "Prices must rise"
          },
          {
            "id": "c",
            "zh-CN": "价格一定下降",
            "en": "Prices must fall"
          },
          {
            "id": "d",
            "zh-CN": "产出一定减少",
            "en": "Output must fall"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "实际产出增加。 识别初始均衡；根据冲击移动对应曲线；比较新均衡并说明调整时间与假设 不能把纵轴价格水平直接写成通胀率。",
          "en": "Real output increases. Identify the initial equilibrium; shift the appropriate curve for the shock; compare the new equilibrium while stating timing and assumptions Do not label an AD–AS price-level axis as the inflation rate."
        }
      },
      {
        "id": "u3-17-macro-equilibrium-short-1",
        "knowledgePointId": "u3-17-macro-equilibrium",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释宏观均衡与比较静态的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Macroeconomic equilibrium and comparative statics and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "短期宏观均衡由 AD 与 SRAS 交点确定总体价格水平和实际产出；长期均衡还需与潜在产出及相应长期模型一致。 识别初始均衡；根据冲击移动对应曲线；比较新均衡并说明调整时间与假设 原创例：出口需求上升使 AD 右移，向上倾斜 SRAS 下价格与产出都增加。若 AD 和 SRAS 同时右移，产出增加但价格方向取决于幅度。宏观价格水平上升也不直接给出每年通胀率。",
          "en": "Short-run macroeconomic equilibrium is the AD–SRAS intersection giving the price level and real output. Long-run equilibrium must also be consistent with potential output and the relevant long-run model. Identify the initial equilibrium; shift the appropriate curve for the shock; compare the new equilibrium while stating timing and assumptions Illustrative example: stronger export demand shifts AD right, raising prices and output along upward SRAS. If AD and SRAS both shift right, output rises but the price direction depends on magnitudes. A higher price level does not by itself specify annual inflation."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "交点",
              "en": "intersection"
            },
            "alternatives": {
              "zh-CN": [
                "交点",
                "识别初始均衡"
              ],
              "en": [
                "intersection",
                "Identify the initial equilibrium"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "曲线移动",
              "en": "shift"
            },
            "alternatives": {
              "zh-CN": [
                "曲线移动",
                "根据冲击移动对应曲线"
              ],
              "en": [
                "shift",
                "shift the appropriate curve for the shock"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "价格水平",
              "en": "price level"
            },
            "alternatives": {
              "zh-CN": [
                "价格水平",
                "比较新均衡并说明调整时间与假设"
              ],
              "en": [
                "price level",
                "compare the new equilibrium while stating timing and assumptions"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-18-output-gaps",
      "slug": "output-gaps",
      "section": "3.2",
      "level": "core",
      "syllabusRefs": [
        "3.2 Aggregate demand and aggregate supply"
      ],
      "textbookRefs": [
        {
          "chapter": "9",
          "section": "9.6",
          "pages": [
            292
          ]
        }
      ],
      "prerequisites": [
        "u3-02-gdp"
      ],
      "related": [
        "u3-11-aggregate-demand",
        "u3-12-consumption",
        "u3-13-investment"
      ],
      "terms": [
        "衰退缺口与通胀缺口",
        "Recessionary and inflationary gaps",
        "实际产出",
        "actual output",
        "潜在产出",
        "potential output",
        "缺口",
        "gap"
      ],
      "synonyms": {
        "zh-CN": [
          "实际产出",
          "潜在产出",
          "缺口"
        ],
        "en": [
          "actual output",
          "potential output",
          "gap"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-18-output-gaps-flash-1",
        "u3-18-output-gaps-mcq-1",
        "u3-18-output-gaps-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-18-output-gaps",
        "locale": "zh-CN",
        "title": "衰退缺口与通胀缺口",
        "takeaway": "负产出缺口是实际产出低于潜在产出，正产出缺口是高于潜在水平；缺口是与估计潜力的比较而非单纯增长率。",
        "definition": "负产出缺口是实际产出低于潜在产出，正产出缺口是高于潜在水平；缺口是与估计潜力的比较而非单纯增长率。",
        "causalChain": [
          "估计可持续潜在产出",
          "比较实际产出与潜在产出",
          "识别闲置资源或过度需求压力"
        ],
        "misconceptions": [
          "负缺口不等同于当期实际增长一定为负。"
        ],
        "examApplication": [
          "标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
        ],
        "summary": [
          "负产出缺口是实际产出低于潜在产出，正产出缺口是高于潜在水平；缺口是与估计潜力的比较而非单纯增长率。",
          "负缺口不等同于当期实际增长一定为负。"
        ],
        "explanation": "估计可持续潜在产出。比较实际产出与潜在产出。识别闲置资源或过度需求压力。\n\n### 原创情境与推导\n\n原创例：潜在 GDP=1000、实际 GDP=950，缺口约为 -5%。即使实际 GDP 从 930 增至 950，仍可存在负缺口。潜在产出无法直接观察，测量误差会影响政策判断。\n\n负缺口不等同于当期实际增长一定为负。\n\n标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
      },
      "en": {
        "id": "u3-18-output-gaps",
        "locale": "en",
        "title": "Recessionary and inflationary gaps",
        "takeaway": "A negative output gap means actual output below potential; a positive gap means above potential. The gap compares output with estimated capacity, not simply with its growth rate.",
        "definition": "A negative output gap means actual output below potential; a positive gap means above potential. The gap compares output with estimated capacity, not simply with its growth rate.",
        "causalChain": [
          "Estimate sustainable potential output",
          "compare actual with potential",
          "identify spare resources or excess-demand pressure"
        ],
        "misconceptions": [
          "A negative gap does not require negative current growth."
        ],
        "examApplication": [
          "Label price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
        ],
        "summary": [
          "A negative output gap means actual output below potential; a positive gap means above potential. The gap compares output with estimated capacity, not simply with its growth rate.",
          "A negative gap does not require negative current growth."
        ],
        "explanation": "Estimate sustainable potential output.  compare actual with potential.  identify spare resources or excess-demand pressure.\n\n### Original scenario and reasoning\n\nIllustrative example: potential GDP=1000 and actual GDP=950 give a gap of about -5%. Output can grow from 930 to 950 and still have a negative gap. Potential is unobservable, so estimation error affects policy choices.\n\nA negative gap does not require negative current growth.\n\nLabel price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
      }
    },
    "practice": [
      {
        "id": "u3-18-output-gaps-flash-1",
        "knowledgePointId": "u3-18-output-gaps",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“衰退缺口与通胀缺口”，并说明一个关键条件。",
          "en": "Explain Recessionary and inflationary gaps and state one important condition."
        },
        "answer": {
          "zh-CN": "负产出缺口是实际产出低于潜在产出，正产出缺口是高于潜在水平；缺口是与估计潜力的比较而非单纯增长率。",
          "en": "A negative output gap means actual output below potential; a positive gap means above potential. The gap compares output with estimated capacity, not simply with its growth rate."
        },
        "explanation": {
          "zh-CN": "负缺口不等同于当期实际增长一定为负。",
          "en": "A negative gap does not require negative current growth."
        }
      },
      {
        "id": "u3-18-output-gaps-mcq-1",
        "knowledgePointId": "u3-18-output-gaps",
        "type": "mcq",
        "prompt": {
          "zh-CN": "Y=108、Yf=100，产出缺口为多少？",
          "en": "Y=108 and Yf=100. What is the output gap?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "-8%",
            "en": "-8%"
          },
          {
            "id": "b",
            "zh-CN": "+8%",
            "en": "+8%"
          },
          {
            "id": "c",
            "zh-CN": "108%",
            "en": "108%"
          },
          {
            "id": "d",
            "zh-CN": "0%",
            "en": "0%"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "+8%。 (108 − 100) / 100 × 100 = +8% 负缺口不等同于当期实际增长一定为负。",
          "en": "+8%. (108 − 100) / 100 × 100 = +8% A negative gap does not require negative current growth."
        }
      },
      {
        "id": "u3-18-output-gaps-short-1",
        "knowledgePointId": "u3-18-output-gaps",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释衰退缺口与通胀缺口的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Recessionary and inflationary gaps and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "负产出缺口是实际产出低于潜在产出，正产出缺口是高于潜在水平；缺口是与估计潜力的比较而非单纯增长率。 估计可持续潜在产出；比较实际产出与潜在产出；识别闲置资源或过度需求压力 原创例：潜在 GDP=1000、实际 GDP=950，缺口约为 -5%。即使实际 GDP 从 930 增至 950，仍可存在负缺口。潜在产出无法直接观察，测量误差会影响政策判断。",
          "en": "A negative output gap means actual output below potential; a positive gap means above potential. The gap compares output with estimated capacity, not simply with its growth rate. Estimate sustainable potential output; compare actual with potential; identify spare resources or excess-demand pressure Illustrative example: potential GDP=1000 and actual GDP=950 give a gap of about -5%. Output can grow from 930 to 950 and still have a negative gap. Potential is unobservable, so estimation error affects policy choices."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "实际产出",
              "en": "actual output"
            },
            "alternatives": {
              "zh-CN": [
                "实际产出",
                "估计可持续潜在产出"
              ],
              "en": [
                "actual output",
                "Estimate sustainable potential output"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "潜在产出",
              "en": "potential output"
            },
            "alternatives": {
              "zh-CN": [
                "潜在产出",
                "比较实际产出与潜在产出"
              ],
              "en": [
                "potential output",
                "compare actual with potential"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "缺口",
              "en": "gap"
            },
            "alternatives": {
              "zh-CN": [
                "缺口",
                "识别闲置资源或过度需求压力"
              ],
              "en": [
                "gap",
                "identify spare resources or excess-demand pressure"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-19-macro-shocks",
      "slug": "macro-shocks",
      "section": "3.2",
      "level": "core",
      "syllabusRefs": [
        "3.2 Aggregate demand and aggregate supply"
      ],
      "textbookRefs": [
        {
          "chapter": "9",
          "section": "9.2",
          "pages": [
            276
          ]
        }
      ],
      "prerequisites": [
        "u3-02-gdp"
      ],
      "related": [
        "u3-11-aggregate-demand",
        "u3-12-consumption",
        "u3-13-investment"
      ],
      "terms": [
        "需求冲击、供给冲击与滞胀",
        "Demand shocks, supply shocks and stagflation",
        "供给冲击",
        "supply shock",
        "产出",
        "output",
        "物价",
        "prices"
      ],
      "synonyms": {
        "zh-CN": [
          "供给冲击",
          "产出",
          "物价"
        ],
        "en": [
          "supply shock",
          "output",
          "prices"
        ]
      },
      "diagramIds": [
        "macro-supply-shock"
      ],
      "quizIds": [
        "u3-19-macro-shocks-flash-1",
        "u3-19-macro-shocks-mcq-1",
        "u3-19-macro-shocks-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-19-macro-shocks",
        "locale": "zh-CN",
        "title": "需求冲击、供给冲击与滞胀",
        "takeaway": "负需求冲击通常降低产出与价格压力；负供给冲击可能同时减少产出并提高价格水平，形成滞胀压力。",
        "definition": "负需求冲击通常降低产出与价格压力；负供给冲击可能同时减少产出并提高价格水平，形成滞胀压力。",
        "causalChain": [
          "先区分支出不足或成本产能问题",
          "移动 AD 或 SRAS",
          "政策选择面对不同目标冲突"
        ],
        "misconceptions": [
          "一次价格水平冲击与持续的通胀过程也需要区分。"
        ],
        "examApplication": [
          "标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
        ],
        "summary": [
          "负需求冲击通常降低产出与价格压力；负供给冲击可能同时减少产出并提高价格水平，形成滞胀压力。",
          "一次价格水平冲击与持续的通胀过程也需要区分。"
        ],
        "explanation": "先区分支出不足或成本产能问题。移动 AD 或 SRAS。政策选择面对不同目标冲突。\n\n### 原创情境与推导\n\n原创例：能源短缺使 SRAS 左移。扩张 AD 可缓解产出损失，却可能进一步提高物价；收缩 AD 可减轻物价压力，却加重衰退。必须识别冲击来源，不能把同一政策视为适用于所有通胀。\n\n一次价格水平冲击与持续的通胀过程也需要区分。\n\n标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
      },
      "en": {
        "id": "u3-19-macro-shocks",
        "locale": "en",
        "title": "Demand shocks, supply shocks and stagflation",
        "takeaway": "A negative demand shock normally lowers output and price pressure. A negative supply shock can reduce output while raising the price level, creating stagflation pressure.",
        "definition": "A negative demand shock normally lowers output and price pressure. A negative supply shock can reduce output while raising the price level, creating stagflation pressure.",
        "causalChain": [
          "Distinguish weak spending from cost/capacity problems",
          "shift AD or SRAS",
          "policy choices face different objective conflicts"
        ],
        "misconceptions": [
          "Distinguish a one-off price-level shock from a continuing inflation process."
        ],
        "examApplication": [
          "Label price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
        ],
        "summary": [
          "A negative demand shock normally lowers output and price pressure. A negative supply shock can reduce output while raising the price level, creating stagflation pressure.",
          "Distinguish a one-off price-level shock from a continuing inflation process."
        ],
        "explanation": "Distinguish weak spending from cost/capacity problems.  shift AD or SRAS.  policy choices face different objective conflicts.\n\n### Original scenario and reasoning\n\nIllustrative example: an energy shortage shifts SRAS left. Expanding AD can limit output losses but raise prices further; contracting AD can limit price pressure but worsen recession. Identify the shock rather than prescribe one policy for every inflation episode.\n\nDistinguish a one-off price-level shock from a continuing inflation process.\n\nLabel price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
      }
    },
    "practice": [
      {
        "id": "u3-19-macro-shocks-flash-1",
        "knowledgePointId": "u3-19-macro-shocks",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“需求冲击、供给冲击与滞胀”，并说明一个关键条件。",
          "en": "Explain Demand shocks, supply shocks and stagflation and state one important condition."
        },
        "answer": {
          "zh-CN": "负需求冲击通常降低产出与价格压力；负供给冲击可能同时减少产出并提高价格水平，形成滞胀压力。",
          "en": "A negative demand shock normally lowers output and price pressure. A negative supply shock can reduce output while raising the price level, creating stagflation pressure."
        },
        "explanation": {
          "zh-CN": "一次价格水平冲击与持续的通胀过程也需要区分。",
          "en": "Distinguish a one-off price-level shock from a continuing inflation process."
        }
      },
      {
        "id": "u3-19-macro-shocks-mcq-1",
        "knowledgePointId": "u3-19-macro-shocks",
        "type": "mcq",
        "prompt": {
          "zh-CN": "负供给冲击下扩张 AD 的主要权衡是什么？",
          "en": "What is a main trade-off of expanding AD after an adverse supply shock?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "必同时降低价格与失业",
            "en": "Must lower both prices and unemployment"
          },
          {
            "id": "b",
            "zh-CN": "立刻增加资源禀赋",
            "en": "Immediately increases resources"
          },
          {
            "id": "c",
            "zh-CN": "支持产出但加重物价压力",
            "en": "Supports output but intensifies price pressure"
          },
          {
            "id": "d",
            "zh-CN": "没有任何权衡",
            "en": "No trade-off exists"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "支持产出但加重物价压力。 先区分支出不足或成本产能问题；移动 AD 或 SRAS；政策选择面对不同目标冲突 一次价格水平冲击与持续的通胀过程也需要区分。",
          "en": "Supports output but intensifies price pressure. Distinguish weak spending from cost/capacity problems; shift AD or SRAS; policy choices face different objective conflicts Distinguish a one-off price-level shock from a continuing inflation process."
        }
      },
      {
        "id": "u3-19-macro-shocks-short-1",
        "knowledgePointId": "u3-19-macro-shocks",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释需求冲击、供给冲击与滞胀的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Demand shocks, supply shocks and stagflation and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "负需求冲击通常降低产出与价格压力；负供给冲击可能同时减少产出并提高价格水平，形成滞胀压力。 先区分支出不足或成本产能问题；移动 AD 或 SRAS；政策选择面对不同目标冲突 原创例：能源短缺使 SRAS 左移。扩张 AD 可缓解产出损失，却可能进一步提高物价；收缩 AD 可减轻物价压力，却加重衰退。必须识别冲击来源，不能把同一政策视为适用于所有通胀。",
          "en": "A negative demand shock normally lowers output and price pressure. A negative supply shock can reduce output while raising the price level, creating stagflation pressure. Distinguish weak spending from cost/capacity problems; shift AD or SRAS; policy choices face different objective conflicts Illustrative example: an energy shortage shifts SRAS left. Expanding AD can limit output losses but raise prices further; contracting AD can limit price pressure but worsen recession. Identify the shock rather than prescribe one policy for every inflation episode."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "供给冲击",
              "en": "supply shock"
            },
            "alternatives": {
              "zh-CN": [
                "供给冲击",
                "先区分支出不足或成本产能问题"
              ],
              "en": [
                "supply shock",
                "Distinguish weak spending from cost/capacity problems"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "产出",
              "en": "output"
            },
            "alternatives": {
              "zh-CN": [
                "产出",
                "移动 AD 或 SRAS"
              ],
              "en": [
                "output",
                "shift AD or SRAS"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "物价",
              "en": "prices"
            },
            "alternatives": {
              "zh-CN": [
                "物价",
                "政策选择面对不同目标冲突"
              ],
              "en": [
                "prices",
                "policy choices face different objective conflicts"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-20-potential-growth",
      "slug": "potential-growth",
      "section": "3.2",
      "level": "core",
      "syllabusRefs": [
        "3.2 Aggregate demand and aggregate supply"
      ],
      "textbookRefs": [
        {
          "chapter": "9",
          "section": "9.5",
          "pages": [
            290
          ]
        }
      ],
      "prerequisites": [
        "u3-02-gdp"
      ],
      "related": [
        "u3-11-aggregate-demand",
        "u3-12-consumption",
        "u3-13-investment"
      ],
      "terms": [
        "潜在增长与总供给右移",
        "Potential growth and rightward aggregate supply shifts",
        "生产率",
        "productivity",
        "产能",
        "capacity",
        "LRAS",
        "LRAS"
      ],
      "synonyms": {
        "zh-CN": [
          "生产率",
          "产能",
          "LRAS"
        ],
        "en": [
          "productivity",
          "capacity",
          "LRAS"
        ]
      },
      "diagramIds": [
        "macro-lras"
      ],
      "quizIds": [
        "u3-20-potential-growth-flash-1",
        "u3-20-potential-growth-mcq-1",
        "u3-20-potential-growth-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-20-potential-growth",
        "locale": "zh-CN",
        "title": "潜在增长与总供给右移",
        "takeaway": "资源数量、质量、技术或制度改善可提高潜在产出，使 LRAS 右移，并可能降低短期单位成本使 SRAS 右移。",
        "definition": "资源数量、质量、技术或制度改善可提高潜在产出，使 LRAS 右移，并可能降低短期单位成本使 SRAS 右移。",
        "causalChain": [
          "生产要素或生产率改善",
          "可持续生产能力增加",
          "给定需求下增长伴随较低物价压力"
        ],
        "misconceptions": [
          "实际增长可能只是填补负缺口，并不必然表示 LRAS 右移。"
        ],
        "examApplication": [
          "标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
        ],
        "summary": [
          "资源数量、质量、技术或制度改善可提高潜在产出，使 LRAS 右移，并可能降低短期单位成本使 SRAS 右移。",
          "实际增长可能只是填补负缺口，并不必然表示 LRAS 右移。"
        ],
        "explanation": "生产要素或生产率改善。可持续生产能力增加。给定需求下增长伴随较低物价压力。\n\n### 原创情境与推导\n\n原创例：电网可靠性提高减少停工，使单位成本下降并扩大长期产能。潜力增加不保证全部新产能立即被使用；若需求不足，实际产出仍可能低于新的潜在水平。\n\n实际增长可能只是填补负缺口，并不必然表示 LRAS 右移。\n\n标明物价水平与实际产出轴，区分 AD、SRAS、LRAS 及模型假设。"
      },
      "en": {
        "id": "u3-20-potential-growth",
        "locale": "en",
        "title": "Potential growth and rightward aggregate supply shifts",
        "takeaway": "More or better resources, technology and institutions can increase potential output, shifting LRAS right, and may reduce short-run unit costs, shifting SRAS right too.",
        "definition": "More or better resources, technology and institutions can increase potential output, shifting LRAS right, and may reduce short-run unit costs, shifting SRAS right too.",
        "causalChain": [
          "Inputs or productivity improve",
          "sustainable capacity expands",
          "growth can occur with less price pressure at a given demand"
        ],
        "misconceptions": [
          "Actual growth may merely close a negative gap rather than shift LRAS right."
        ],
        "examApplication": [
          "Label price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
        ],
        "summary": [
          "More or better resources, technology and institutions can increase potential output, shifting LRAS right, and may reduce short-run unit costs, shifting SRAS right too.",
          "Actual growth may merely close a negative gap rather than shift LRAS right."
        ],
        "explanation": "Inputs or productivity improve.  sustainable capacity expands.  growth can occur with less price pressure at a given demand.\n\n### Original scenario and reasoning\n\nIllustrative example: a more reliable electricity grid reduces downtime, lowering unit costs and expanding long-run capacity. More potential does not ensure immediate full utilisation; weak demand may leave actual output below the new potential.\n\nActual growth may merely close a negative gap rather than shift LRAS right.\n\nLabel price level and real output; distinguish AD, SRAS, LRAS and model assumptions."
      }
    },
    "practice": [
      {
        "id": "u3-20-potential-growth-flash-1",
        "knowledgePointId": "u3-20-potential-growth",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“潜在增长与总供给右移”，并说明一个关键条件。",
          "en": "Explain Potential growth and rightward aggregate supply shifts and state one important condition."
        },
        "answer": {
          "zh-CN": "资源数量、质量、技术或制度改善可提高潜在产出，使 LRAS 右移，并可能降低短期单位成本使 SRAS 右移。",
          "en": "More or better resources, technology and institutions can increase potential output, shifting LRAS right, and may reduce short-run unit costs, shifting SRAS right too."
        },
        "explanation": {
          "zh-CN": "实际增长可能只是填补负缺口，并不必然表示 LRAS 右移。",
          "en": "Actual growth may merely close a negative gap rather than shift LRAS right."
        }
      },
      {
        "id": "u3-20-potential-growth-mcq-1",
        "knowledgePointId": "u3-20-potential-growth",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪项最可能直接提高潜在产出？",
          "en": "Which most directly raises potential output?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只有总体价格翻倍",
            "en": "Only doubling the price level"
          },
          {
            "id": "b",
            "zh-CN": "只增加名义支出且无资源变化",
            "en": "Only more nominal spending with unchanged resources"
          },
          {
            "id": "c",
            "zh-CN": "闲置机器被永久销毁",
            "en": "Permanently destroying idle machines"
          },
          {
            "id": "d",
            "zh-CN": "提高劳动力技能与技术",
            "en": "Improved labour skills and technology"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "提高劳动力技能与技术。 生产要素或生产率改善；可持续生产能力增加；给定需求下增长伴随较低物价压力 实际增长可能只是填补负缺口，并不必然表示 LRAS 右移。",
          "en": "Improved labour skills and technology. Inputs or productivity improve; sustainable capacity expands; growth can occur with less price pressure at a given demand Actual growth may merely close a negative gap rather than shift LRAS right."
        }
      },
      {
        "id": "u3-20-potential-growth-short-1",
        "knowledgePointId": "u3-20-potential-growth",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释潜在增长与总供给右移的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Potential growth and rightward aggregate supply shifts and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "资源数量、质量、技术或制度改善可提高潜在产出，使 LRAS 右移，并可能降低短期单位成本使 SRAS 右移。 生产要素或生产率改善；可持续生产能力增加；给定需求下增长伴随较低物价压力 原创例：电网可靠性提高减少停工，使单位成本下降并扩大长期产能。潜力增加不保证全部新产能立即被使用；若需求不足，实际产出仍可能低于新的潜在水平。",
          "en": "More or better resources, technology and institutions can increase potential output, shifting LRAS right, and may reduce short-run unit costs, shifting SRAS right too. Inputs or productivity improve; sustainable capacity expands; growth can occur with less price pressure at a given demand Illustrative example: a more reliable electricity grid reduces downtime, lowering unit costs and expanding long-run capacity. More potential does not ensure immediate full utilisation; weak demand may leave actual output below the new potential."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "生产率",
              "en": "productivity"
            },
            "alternatives": {
              "zh-CN": [
                "生产率",
                "生产要素或生产率改善"
              ],
              "en": [
                "productivity",
                "Inputs or productivity improve"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "产能",
              "en": "capacity"
            },
            "alternatives": {
              "zh-CN": [
                "产能",
                "可持续生产能力增加"
              ],
              "en": [
                "capacity",
                "sustainable capacity expands"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "LRAS",
              "en": "LRAS"
            },
            "alternatives": {
              "zh-CN": [
                "LRAS",
                "给定需求下增长伴随较低物价压力"
              ],
              "en": [
                "LRAS",
                "growth can occur with less price pressure at a given demand"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-21-unemployment-rate",
      "slug": "unemployment-rate",
      "section": "3.3",
      "level": "core",
      "syllabusRefs": [
        "3.3 Macroeconomic objectives"
      ],
      "textbookRefs": [
        {
          "chapter": "10",
          "section": "10.1",
          "pages": [
            298
          ]
        }
      ],
      "prerequisites": [
        "u3-17-macro-equilibrium"
      ],
      "related": [
        "u3-22-unemployment-types",
        "u3-23-unemployment-costs",
        "u3-24-cpi"
      ],
      "terms": [
        "失业率与劳动参与率",
        "Unemployment and participation rates",
        "劳动力",
        "labour force",
        "失业",
        "unemployment",
        "参与",
        "participation"
      ],
      "synonyms": {
        "zh-CN": [
          "劳动力",
          "失业",
          "参与"
        ],
        "en": [
          "labour force",
          "unemployment",
          "participation"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-21-unemployment-rate-flash-1",
        "u3-21-unemployment-rate-mcq-1",
        "u3-21-unemployment-rate-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-21-unemployment-rate",
        "locale": "zh-CN",
        "title": "失业率与劳动参与率",
        "takeaway": "失业率=失业人数/劳动力人数×100；劳动力包括就业者和符合统计定义的失业者，劳动参与率使用工作年龄人口作分母。",
        "definition": "失业率=失业人数/劳动力人数×100；劳动力包括就业者和符合统计定义的失业者，劳动参与率使用工作年龄人口作分母。",
        "causalChain": [
          "区分就业、失业和非劳动力",
          "用正确分母计算",
          "参与变化可改变失业率而不反映就业同幅变化"
        ],
        "misconceptions": [
          "失业率的分母不是总人口，也不是仅就业人数。"
        ],
        "examApplication": [
          "先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
        ],
        "summary": [
          "失业率=失业人数/劳动力人数×100；劳动力包括就业者和符合统计定义的失业者，劳动参与率使用工作年龄人口作分母。",
          "失业率的分母不是总人口，也不是仅就业人数。"
        ],
        "explanation": "区分就业、失业和非劳动力。用正确分母计算。参与变化可改变失业率而不反映就业同幅变化。\n\n### 原创情境与推导\n\n原创例：就业 900、失业 100、工作年龄人口 1250，失业率 10%、参与率 80%。沮丧者停止找工作可能离开劳动力，使失业率下降但就业不增加。还需观察不足就业和非正规就业。\n\n失业率的分母不是总人口，也不是仅就业人数。\n\n先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
      },
      "en": {
        "id": "u3-21-unemployment-rate",
        "locale": "en",
        "title": "Unemployment and participation rates",
        "takeaway": "The unemployment rate is unemployed people divided by the labour force times 100. The labour force includes employed people and those meeting the unemployment definition; participation uses the working-age population as denominator.",
        "definition": "The unemployment rate is unemployed people divided by the labour force times 100. The labour force includes employed people and those meeting the unemployment definition; participation uses the working-age population as denominator.",
        "causalChain": [
          "Distinguish employment, unemployment and inactivity",
          "calculate using the right denominator",
          "participation changes can alter the rate without an equivalent employment change"
        ],
        "misconceptions": [
          "The unemployment-rate denominator is neither total population nor employed people alone."
        ],
        "examApplication": [
          "Define and measure objectives before analysing causes, stakeholders and conflicts."
        ],
        "summary": [
          "The unemployment rate is unemployed people divided by the labour force times 100. The labour force includes employed people and those meeting the unemployment definition; participation uses the working-age population as denominator.",
          "The unemployment-rate denominator is neither total population nor employed people alone."
        ],
        "explanation": "Distinguish employment, unemployment and inactivity.  calculate using the right denominator.  participation changes can alter the rate without an equivalent employment change.\n\n### Original scenario and reasoning\n\nIllustrative example: 900 employed, 100 unemployed and 1250 working-age people imply unemployment 10% and participation 80%. Discouraged workers leaving job search can lower unemployment without raising employment. Underemployment and informal work also matter.\n\nThe unemployment-rate denominator is neither total population nor employed people alone.\n\nDefine and measure objectives before analysing causes, stakeholders and conflicts."
      }
    },
    "practice": [
      {
        "id": "u3-21-unemployment-rate-flash-1",
        "knowledgePointId": "u3-21-unemployment-rate",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“失业率与劳动参与率”，并说明一个关键条件。",
          "en": "Explain Unemployment and participation rates and state one important condition."
        },
        "answer": {
          "zh-CN": "失业率=失业人数/劳动力人数×100；劳动力包括就业者和符合统计定义的失业者，劳动参与率使用工作年龄人口作分母。",
          "en": "The unemployment rate is unemployed people divided by the labour force times 100. The labour force includes employed people and those meeting the unemployment definition; participation uses the working-age population as denominator."
        },
        "explanation": {
          "zh-CN": "失业率的分母不是总人口，也不是仅就业人数。",
          "en": "The unemployment-rate denominator is neither total population nor employed people alone."
        }
      },
      {
        "id": "u3-21-unemployment-rate-mcq-1",
        "knowledgePointId": "u3-21-unemployment-rate",
        "type": "mcq",
        "prompt": {
          "zh-CN": "就业 180、失业 20，失业率为多少？",
          "en": "There are 180 employed and 20 unemployed. What is the unemployment rate?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "10%",
            "en": "10%"
          },
          {
            "id": "b",
            "zh-CN": "11.11%",
            "en": "11.11%"
          },
          {
            "id": "c",
            "zh-CN": "20%",
            "en": "20%"
          },
          {
            "id": "d",
            "zh-CN": "90%",
            "en": "90%"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "10%。 20 / (180 + 20) × 100 = 10% 失业率的分母不是总人口，也不是仅就业人数。",
          "en": "10%. 20 / (180 + 20) × 100 = 10% The unemployment-rate denominator is neither total population nor employed people alone."
        }
      },
      {
        "id": "u3-21-unemployment-rate-short-1",
        "knowledgePointId": "u3-21-unemployment-rate",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释失业率与劳动参与率的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Unemployment and participation rates and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "失业率=失业人数/劳动力人数×100；劳动力包括就业者和符合统计定义的失业者，劳动参与率使用工作年龄人口作分母。 区分就业、失业和非劳动力；用正确分母计算；参与变化可改变失业率而不反映就业同幅变化 原创例：就业 900、失业 100、工作年龄人口 1250，失业率 10%、参与率 80%。沮丧者停止找工作可能离开劳动力，使失业率下降但就业不增加。还需观察不足就业和非正规就业。",
          "en": "The unemployment rate is unemployed people divided by the labour force times 100. The labour force includes employed people and those meeting the unemployment definition; participation uses the working-age population as denominator. Distinguish employment, unemployment and inactivity; calculate using the right denominator; participation changes can alter the rate without an equivalent employment change Illustrative example: 900 employed, 100 unemployed and 1250 working-age people imply unemployment 10% and participation 80%. Discouraged workers leaving job search can lower unemployment without raising employment. Underemployment and informal work also matter."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "劳动力",
              "en": "labour force"
            },
            "alternatives": {
              "zh-CN": [
                "劳动力",
                "区分就业、失业和非劳动力"
              ],
              "en": [
                "labour force",
                "Distinguish employment, unemployment and inactivity"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "失业",
              "en": "unemployment"
            },
            "alternatives": {
              "zh-CN": [
                "失业",
                "用正确分母计算"
              ],
              "en": [
                "unemployment",
                "calculate using the right denominator"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "参与",
              "en": "participation"
            },
            "alternatives": {
              "zh-CN": [
                "参与",
                "参与变化可改变失业率而不反映就业同幅变化"
              ],
              "en": [
                "participation",
                "participation changes can alter the rate without an equivalent employment change"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-22-unemployment-types",
      "slug": "unemployment-types",
      "section": "3.3",
      "level": "core",
      "syllabusRefs": [
        "3.3 Macroeconomic objectives"
      ],
      "textbookRefs": [
        {
          "chapter": "10",
          "section": "10.1",
          "pages": [
            298
          ]
        }
      ],
      "prerequisites": [
        "u3-17-macro-equilibrium"
      ],
      "related": [
        "u3-21-unemployment-rate",
        "u3-23-unemployment-costs",
        "u3-24-cpi"
      ],
      "terms": [
        "失业类型与自然失业",
        "Types of unemployment and natural unemployment",
        "技能",
        "skills",
        "匹配",
        "matching",
        "需求不足",
        "weak demand"
      ],
      "synonyms": {
        "zh-CN": [
          "技能",
          "匹配",
          "需求不足"
        ],
        "en": [
          "skills",
          "matching",
          "weak demand"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-22-unemployment-types-flash-1",
        "u3-22-unemployment-types-mcq-1",
        "u3-22-unemployment-types-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-22-unemployment-types",
        "locale": "zh-CN",
        "title": "失业类型与自然失业",
        "takeaway": "摩擦性失业来自寻找和转换工作；结构性失业来自技能或地点不匹配；周期性失业来自需求不足；季节性失业随季节变化。",
        "definition": "摩擦性失业来自寻找和转换工作；结构性失业来自技能或地点不匹配；周期性失业来自需求不足；季节性失业随季节变化。",
        "causalChain": [
          "识别失业的主要机制",
          "区分需求不足与匹配问题",
          "选择与成因相符的政策"
        ],
        "misconceptions": [
          "充分就业不是失业率为零；自然失业率也会随制度和匹配条件变化。"
        ],
        "examApplication": [
          "先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
        ],
        "summary": [
          "摩擦性失业来自寻找和转换工作；结构性失业来自技能或地点不匹配；周期性失业来自需求不足；季节性失业随季节变化。",
          "充分就业不是失业率为零；自然失业率也会随制度和匹配条件变化。"
        ],
        "explanation": "识别失业的主要机制。区分需求不足与匹配问题。选择与成因相符的政策。\n\n### 原创情境与推导\n\n原创例：需求衰退中的零售裁员主要属周期性；技术淘汰造成技能错配主要属结构性。按本课程框架，自然失业由摩擦性、结构性和季节性失业组成，不含周期性失业；充分就业并非零失业。\n\n充分就业不是失业率为零；自然失业率也会随制度和匹配条件变化。\n\n先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
      },
      "en": {
        "id": "u3-22-unemployment-types",
        "locale": "en",
        "title": "Types of unemployment and natural unemployment",
        "takeaway": "Frictional unemployment comes from job search, structural unemployment from skill or location mismatch, cyclical unemployment from weak demand, and seasonal unemployment from seasonal activity.",
        "definition": "Frictional unemployment comes from job search, structural unemployment from skill or location mismatch, cyclical unemployment from weak demand, and seasonal unemployment from seasonal activity.",
        "causalChain": [
          "Identify the main mechanism",
          "separate demand deficiency from matching problems",
          "choose a policy that addresses the cause"
        ],
        "misconceptions": [
          "Full employment is not zero unemployment; the natural rate can change with institutions and matching conditions."
        ],
        "examApplication": [
          "Define and measure objectives before analysing causes, stakeholders and conflicts."
        ],
        "summary": [
          "Frictional unemployment comes from job search, structural unemployment from skill or location mismatch, cyclical unemployment from weak demand, and seasonal unemployment from seasonal activity.",
          "Full employment is not zero unemployment; the natural rate can change with institutions and matching conditions."
        ],
        "explanation": "Identify the main mechanism.  separate demand deficiency from matching problems.  choose a policy that addresses the cause.\n\n### Original scenario and reasoning\n\nIllustrative example: retail layoffs in a demand slump are mainly cyclical; technological skill mismatch is mainly structural. In this course framework, natural unemployment includes frictional, structural and seasonal unemployment, excluding cyclical unemployment. Full employment is not zero unemployment.\n\nFull employment is not zero unemployment; the natural rate can change with institutions and matching conditions.\n\nDefine and measure objectives before analysing causes, stakeholders and conflicts."
      }
    },
    "practice": [
      {
        "id": "u3-22-unemployment-types-flash-1",
        "knowledgePointId": "u3-22-unemployment-types",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“失业类型与自然失业”，并说明一个关键条件。",
          "en": "Explain Types of unemployment and natural unemployment and state one important condition."
        },
        "answer": {
          "zh-CN": "摩擦性失业来自寻找和转换工作；结构性失业来自技能或地点不匹配；周期性失业来自需求不足；季节性失业随季节变化。",
          "en": "Frictional unemployment comes from job search, structural unemployment from skill or location mismatch, cyclical unemployment from weak demand, and seasonal unemployment from seasonal activity."
        },
        "explanation": {
          "zh-CN": "充分就业不是失业率为零；自然失业率也会随制度和匹配条件变化。",
          "en": "Full employment is not zero unemployment; the natural rate can change with institutions and matching conditions."
        }
      },
      {
        "id": "u3-22-unemployment-types-mcq-1",
        "knowledgePointId": "u3-22-unemployment-types",
        "type": "mcq",
        "prompt": {
          "zh-CN": "技能过时导致岗位与劳动者不匹配，属于什么？",
          "en": "Obsolete skills cause a mismatch between workers and jobs. Which type is this?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "纯周期性失业",
            "en": "Purely cyclical unemployment"
          },
          {
            "id": "b",
            "zh-CN": "结构性失业",
            "en": "Structural unemployment"
          },
          {
            "id": "c",
            "zh-CN": "纯季节性失业",
            "en": "Purely seasonal unemployment"
          },
          {
            "id": "d",
            "zh-CN": "就业增加",
            "en": "Higher employment"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "结构性失业。 识别失业的主要机制；区分需求不足与匹配问题；选择与成因相符的政策 充分就业不是失业率为零；自然失业率也会随制度和匹配条件变化。",
          "en": "Structural unemployment. Identify the main mechanism; separate demand deficiency from matching problems; choose a policy that addresses the cause Full employment is not zero unemployment; the natural rate can change with institutions and matching conditions."
        }
      },
      {
        "id": "u3-22-unemployment-types-short-1",
        "knowledgePointId": "u3-22-unemployment-types",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释失业类型与自然失业的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Types of unemployment and natural unemployment and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "摩擦性失业来自寻找和转换工作；结构性失业来自技能或地点不匹配；周期性失业来自需求不足；季节性失业随季节变化。 识别失业的主要机制；区分需求不足与匹配问题；选择与成因相符的政策 原创例：需求衰退中的零售裁员主要属周期性；技术淘汰造成技能错配主要属结构性。按本课程框架，自然失业由摩擦性、结构性和季节性失业组成，不含周期性失业；充分就业并非零失业。",
          "en": "Frictional unemployment comes from job search, structural unemployment from skill or location mismatch, cyclical unemployment from weak demand, and seasonal unemployment from seasonal activity. Identify the main mechanism; separate demand deficiency from matching problems; choose a policy that addresses the cause Illustrative example: retail layoffs in a demand slump are mainly cyclical; technological skill mismatch is mainly structural. In this course framework, natural unemployment includes frictional, structural and seasonal unemployment, excluding cyclical unemployment. Full employment is not zero unemployment."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "技能",
              "en": "skills"
            },
            "alternatives": {
              "zh-CN": [
                "技能",
                "识别失业的主要机制"
              ],
              "en": [
                "skills",
                "Identify the main mechanism"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "匹配",
              "en": "matching"
            },
            "alternatives": {
              "zh-CN": [
                "匹配",
                "区分需求不足与匹配问题"
              ],
              "en": [
                "matching",
                "separate demand deficiency from matching problems"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "需求不足",
              "en": "weak demand"
            },
            "alternatives": {
              "zh-CN": [
                "需求不足",
                "选择与成因相符的政策"
              ],
              "en": [
                "weak demand",
                "choose a policy that addresses the cause"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-23-unemployment-costs",
      "slug": "unemployment-costs",
      "section": "3.3",
      "level": "core",
      "syllabusRefs": [
        "3.3 Macroeconomic objectives"
      ],
      "textbookRefs": [
        {
          "chapter": "10",
          "section": "10.1",
          "pages": [
            298
          ]
        }
      ],
      "prerequisites": [
        "u3-17-macro-equilibrium"
      ],
      "related": [
        "u3-21-unemployment-rate",
        "u3-22-unemployment-types",
        "u3-24-cpi"
      ],
      "terms": [
        "失业的经济与社会成本",
        "Economic and social costs of unemployment",
        "收入",
        "income",
        "技能退化",
        "skill loss",
        "产出",
        "output"
      ],
      "synonyms": {
        "zh-CN": [
          "收入",
          "技能退化",
          "产出"
        ],
        "en": [
          "income",
          "skill loss",
          "output"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-23-unemployment-costs-flash-1",
        "u3-23-unemployment-costs-mcq-1",
        "u3-23-unemployment-costs-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-23-unemployment-costs",
        "locale": "zh-CN",
        "title": "失业的经济与社会成本",
        "takeaway": "失业会损失产出、收入和税收，增加财政与社会压力，并可能造成技能退化、健康损害和长期排斥。",
        "definition": "失业会损失产出、收入和税收，增加财政与社会压力，并可能造成技能退化、健康损害和长期排斥。",
        "causalChain": [
          "劳动资源未被利用",
          "收入与需求下降",
          "长期失业进一步损害技能和未来就业能力"
        ],
        "misconceptions": [
          "财政补助可缓解家庭收入损失，却不能自动补回未生产的全部产出。"
        ],
        "examApplication": [
          "先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
        ],
        "summary": [
          "失业会损失产出、收入和税收，增加财政与社会压力，并可能造成技能退化、健康损害和长期排斥。",
          "财政补助可缓解家庭收入损失，却不能自动补回未生产的全部产出。"
        ],
        "explanation": "劳动资源未被利用。收入与需求下降。长期失业进一步损害技能和未来就业能力。\n\n### 原创情境与推导\n\n原创例：工厂关闭不仅影响失业家庭，也影响附近商店和政府税收。培训和求职支持可能防止短期冲击变为长期结构问题，但项目设计、心理健康和地区岗位需求都影响效果。\n\n财政补助可缓解家庭收入损失，却不能自动补回未生产的全部产出。\n\n先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
      },
      "en": {
        "id": "u3-23-unemployment-costs",
        "locale": "en",
        "title": "Economic and social costs of unemployment",
        "takeaway": "Unemployment can reduce output, income and tax receipts, raise fiscal and social pressures, and cause skill loss, ill health and lasting exclusion.",
        "definition": "Unemployment can reduce output, income and tax receipts, raise fiscal and social pressures, and cause skill loss, ill health and lasting exclusion.",
        "causalChain": [
          "Labour resources remain unused",
          "income and demand fall",
          "prolonged joblessness damages skills and future employability"
        ],
        "misconceptions": [
          "Benefits can cushion household income without automatically restoring all lost output."
        ],
        "examApplication": [
          "Define and measure objectives before analysing causes, stakeholders and conflicts."
        ],
        "summary": [
          "Unemployment can reduce output, income and tax receipts, raise fiscal and social pressures, and cause skill loss, ill health and lasting exclusion.",
          "Benefits can cushion household income without automatically restoring all lost output."
        ],
        "explanation": "Labour resources remain unused.  income and demand fall.  prolonged joblessness damages skills and future employability.\n\n### Original scenario and reasoning\n\nIllustrative example: a factory closure affects workers' households, nearby shops and tax receipts. Training and job-search support may prevent a temporary shock becoming structural, but programme quality, mental health and regional vacancies affect outcomes.\n\nBenefits can cushion household income without automatically restoring all lost output.\n\nDefine and measure objectives before analysing causes, stakeholders and conflicts."
      }
    },
    "practice": [
      {
        "id": "u3-23-unemployment-costs-flash-1",
        "knowledgePointId": "u3-23-unemployment-costs",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“失业的经济与社会成本”，并说明一个关键条件。",
          "en": "Explain Economic and social costs of unemployment and state one important condition."
        },
        "answer": {
          "zh-CN": "失业会损失产出、收入和税收，增加财政与社会压力，并可能造成技能退化、健康损害和长期排斥。",
          "en": "Unemployment can reduce output, income and tax receipts, raise fiscal and social pressures, and cause skill loss, ill health and lasting exclusion."
        },
        "explanation": {
          "zh-CN": "财政补助可缓解家庭收入损失，却不能自动补回未生产的全部产出。",
          "en": "Benefits can cushion household income without automatically restoring all lost output."
        }
      },
      {
        "id": "u3-23-unemployment-costs-mcq-1",
        "knowledgePointId": "u3-23-unemployment-costs",
        "type": "mcq",
        "prompt": {
          "zh-CN": "长期失业可能怎样影响潜在产出？",
          "en": "How can prolonged unemployment affect potential output?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "必然提高所有技能",
            "en": "Necessarily improves every skill"
          },
          {
            "id": "b",
            "zh-CN": "只改变名义价格",
            "en": "Only changes nominal prices"
          },
          {
            "id": "c",
            "zh-CN": "技能退化可能降低潜在产出",
            "en": "Skill loss can reduce potential output"
          },
          {
            "id": "d",
            "zh-CN": "完全没有长期影响",
            "en": "Has no possible long-run effect"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "技能退化可能降低潜在产出。 劳动资源未被利用；收入与需求下降；长期失业进一步损害技能和未来就业能力 财政补助可缓解家庭收入损失，却不能自动补回未生产的全部产出。",
          "en": "Skill loss can reduce potential output. Labour resources remain unused; income and demand fall; prolonged joblessness damages skills and future employability Benefits can cushion household income without automatically restoring all lost output."
        }
      },
      {
        "id": "u3-23-unemployment-costs-short-1",
        "knowledgePointId": "u3-23-unemployment-costs",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释失业的经济与社会成本的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Economic and social costs of unemployment and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "失业会损失产出、收入和税收，增加财政与社会压力，并可能造成技能退化、健康损害和长期排斥。 劳动资源未被利用；收入与需求下降；长期失业进一步损害技能和未来就业能力 原创例：工厂关闭不仅影响失业家庭，也影响附近商店和政府税收。培训和求职支持可能防止短期冲击变为长期结构问题，但项目设计、心理健康和地区岗位需求都影响效果。",
          "en": "Unemployment can reduce output, income and tax receipts, raise fiscal and social pressures, and cause skill loss, ill health and lasting exclusion. Labour resources remain unused; income and demand fall; prolonged joblessness damages skills and future employability Illustrative example: a factory closure affects workers' households, nearby shops and tax receipts. Training and job-search support may prevent a temporary shock becoming structural, but programme quality, mental health and regional vacancies affect outcomes."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "收入",
              "en": "income"
            },
            "alternatives": {
              "zh-CN": [
                "收入",
                "劳动资源未被利用"
              ],
              "en": [
                "income",
                "Labour resources remain unused"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "技能退化",
              "en": "skill loss"
            },
            "alternatives": {
              "zh-CN": [
                "技能退化",
                "收入与需求下降"
              ],
              "en": [
                "skill loss",
                "income and demand fall"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "产出",
              "en": "output"
            },
            "alternatives": {
              "zh-CN": [
                "产出",
                "长期失业进一步损害技能和未来就业能力"
              ],
              "en": [
                "output",
                "prolonged joblessness damages skills and future employability"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-24-cpi",
      "slug": "cpi",
      "section": "3.3",
      "level": "core",
      "syllabusRefs": [
        "3.3 Macroeconomic objectives"
      ],
      "textbookRefs": [
        {
          "chapter": "10",
          "section": "10.2",
          "pages": [
            308
          ]
        }
      ],
      "prerequisites": [
        "u3-17-macro-equilibrium"
      ],
      "related": [
        "u3-21-unemployment-rate",
        "u3-22-unemployment-types",
        "u3-23-unemployment-costs"
      ],
      "terms": [
        "CPI 与通胀率计算",
        "CPI and inflation calculations",
        "权重",
        "weights",
        "指数",
        "index",
        "百分比",
        "percentage"
      ],
      "synonyms": {
        "zh-CN": [
          "权重",
          "指数",
          "百分比"
        ],
        "en": [
          "weights",
          "index",
          "percentage"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-24-cpi-flash-1",
        "u3-24-cpi-mcq-1",
        "u3-24-cpi-short-1",
        "u3-24-cpi-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-24-cpi",
        "locale": "zh-CN",
        "hlExtension": "HL 原创计算：基期购买 A 两件、单价 10，B 一件、单价 20，篮子成本 40；现价分别 12、22，固定篮子成本 46，因此 CPI=46/40×100=115。数量作权重，不能直接平均价格涨幅。",
        "title": "CPI 与通胀率计算",
        "takeaway": "CPI 用加权消费篮子衡量消费价格变化；通胀率=(本期指数−上期指数)/上期指数×100。权重和篮子影响其代表性。",
        "definition": "CPI 用加权消费篮子衡量消费价格变化；通胀率=(本期指数−上期指数)/上期指数×100。权重和篮子影响其代表性。",
        "causalChain": [
          "选定代表性商品及支出权重",
          "计算篮子成本与指数",
          "用相邻期指数变化计算通胀"
        ],
        "misconceptions": [
          "指数增加的点数与百分比涨幅不是同一数值。"
        ],
        "examApplication": [
          "先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
        ],
        "summary": [
          "CPI 用加权消费篮子衡量消费价格变化；通胀率=(本期指数−上期指数)/上期指数×100。权重和篮子影响其代表性。",
          "指数增加的点数与百分比涨幅不是同一数值。"
        ],
        "explanation": "选定代表性商品及支出权重。计算篮子成本与指数。用相邻期指数变化计算通胀。\n\n### 原创情境与推导\n\n原创例：CPI 从 120 升至 126，通胀率为 5%，不是 6%。不同家庭的能源或食品支出占比不同，实际感受可能不同；替代、新产品与质量变化也使固定篮子存在局限。\n\n指数增加的点数与百分比涨幅不是同一数值。\n\n先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
      },
      "en": {
        "id": "u3-24-cpi",
        "locale": "en",
        "hlExtension": "HL original calculation: the base basket contains two A at ten and one B at twenty, costing forty. New prices twelve and twenty-two give basket cost forty-six, so CPI=46/40×100=115. Quantity weights matter; do not simply average price changes.",
        "title": "CPI and inflation calculations",
        "takeaway": "CPI measures consumer-price changes using a weighted basket. Inflation=(current index−previous index)/previous index×100. Weights and basket composition affect representativeness.",
        "definition": "CPI measures consumer-price changes using a weighted basket. Inflation=(current index−previous index)/previous index×100. Weights and basket composition affect representativeness.",
        "causalChain": [
          "Select representative goods and expenditure weights",
          "compute basket cost and the index",
          "calculate inflation from successive index changes"
        ],
        "misconceptions": [
          "The index-point increase is not the same as the percentage increase."
        ],
        "examApplication": [
          "Define and measure objectives before analysing causes, stakeholders and conflicts."
        ],
        "summary": [
          "CPI measures consumer-price changes using a weighted basket. Inflation=(current index−previous index)/previous index×100. Weights and basket composition affect representativeness.",
          "The index-point increase is not the same as the percentage increase."
        ],
        "explanation": "Select representative goods and expenditure weights.  compute basket cost and the index.  calculate inflation from successive index changes.\n\n### Original scenario and reasoning\n\nIllustrative example: CPI rises from 120 to 126, so inflation is 5%, not 6%. Households with different food and energy weights experience different changes. Substitution, new products and quality changes also limit a fixed basket.\n\nThe index-point increase is not the same as the percentage increase.\n\nDefine and measure objectives before analysing causes, stakeholders and conflicts."
      }
    },
    "practice": [
      {
        "id": "u3-24-cpi-flash-1",
        "knowledgePointId": "u3-24-cpi",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“CPI 与通胀率计算”，并说明一个关键条件。",
          "en": "Explain CPI and inflation calculations and state one important condition."
        },
        "answer": {
          "zh-CN": "CPI 用加权消费篮子衡量消费价格变化；通胀率=(本期指数−上期指数)/上期指数×100。权重和篮子影响其代表性。",
          "en": "CPI measures consumer-price changes using a weighted basket. Inflation=(current index−previous index)/previous index×100. Weights and basket composition affect representativeness."
        },
        "explanation": {
          "zh-CN": "指数增加的点数与百分比涨幅不是同一数值。",
          "en": "The index-point increase is not the same as the percentage increase."
        }
      },
      {
        "id": "u3-24-cpi-mcq-1",
        "knowledgePointId": "u3-24-cpi",
        "type": "mcq",
        "prompt": {
          "zh-CN": "CPI 从 150 到 156，通胀率多少？",
          "en": "CPI rises from 150 to 156. What is inflation?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "6%",
            "en": "6%"
          },
          {
            "id": "b",
            "zh-CN": "56%",
            "en": "56%"
          },
          {
            "id": "c",
            "zh-CN": "104%",
            "en": "104%"
          },
          {
            "id": "d",
            "zh-CN": "4%",
            "en": "4%"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "4%。 选定代表性商品及支出权重；计算篮子成本与指数；用相邻期指数变化计算通胀 指数增加的点数与百分比涨幅不是同一数值。",
          "en": "4%. Select representative goods and expenditure weights; compute basket cost and the index; calculate inflation from successive index changes The index-point increase is not the same as the percentage increase."
        }
      },
      {
        "id": "u3-24-cpi-short-1",
        "knowledgePointId": "u3-24-cpi",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释CPI 与通胀率计算的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of CPI and inflation calculations and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "CPI 用加权消费篮子衡量消费价格变化；通胀率=(本期指数−上期指数)/上期指数×100。权重和篮子影响其代表性。 选定代表性商品及支出权重；计算篮子成本与指数；用相邻期指数变化计算通胀 原创例：CPI 从 120 升至 126，通胀率为 5%，不是 6%。不同家庭的能源或食品支出占比不同，实际感受可能不同；替代、新产品与质量变化也使固定篮子存在局限。",
          "en": "CPI measures consumer-price changes using a weighted basket. Inflation=(current index−previous index)/previous index×100. Weights and basket composition affect representativeness. Select representative goods and expenditure weights; compute basket cost and the index; calculate inflation from successive index changes Illustrative example: CPI rises from 120 to 126, so inflation is 5%, not 6%. Households with different food and energy weights experience different changes. Substitution, new products and quality changes also limit a fixed basket."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "权重",
              "en": "weights"
            },
            "alternatives": {
              "zh-CN": [
                "权重",
                "选定代表性商品及支出权重"
              ],
              "en": [
                "weights",
                "Select representative goods and expenditure weights"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "指数",
              "en": "index"
            },
            "alternatives": {
              "zh-CN": [
                "指数",
                "计算篮子成本与指数"
              ],
              "en": [
                "index",
                "compute basket cost and the index"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "百分比",
              "en": "percentage"
            },
            "alternatives": {
              "zh-CN": [
                "百分比",
                "用相邻期指数变化计算通胀"
              ],
              "en": [
                "percentage",
                "calculate inflation from successive index changes"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u3-24-cpi-mcq-hl-1",
        "knowledgePointId": "u3-24-cpi",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "基期篮子成本 40、当前同篮子成本 46，CPI 是多少？",
          "en": "Base basket cost is forty and current cost forty-six. What is CPI?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "115",
            "en": "115"
          },
          {
            "id": "b",
            "zh-CN": "15",
            "en": "15"
          },
          {
            "id": "c",
            "zh-CN": "46",
            "en": "46"
          },
          {
            "id": "d",
            "zh-CN": "86.96",
            "en": "86.96"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "115。 (156 − 150) / 150 × 100 = 4%",
          "en": "115. (156 − 150) / 150 × 100 = 4%"
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-25-demand-pull",
      "slug": "demand-pull",
      "section": "3.3",
      "level": "core",
      "syllabusRefs": [
        "3.3 Macroeconomic objectives"
      ],
      "textbookRefs": [
        {
          "chapter": "10",
          "section": "10.2",
          "pages": [
            308
          ]
        }
      ],
      "prerequisites": [
        "u3-17-macro-equilibrium"
      ],
      "related": [
        "u3-21-unemployment-rate",
        "u3-22-unemployment-types",
        "u3-23-unemployment-costs"
      ],
      "terms": [
        "需求拉动型通胀",
        "Demand-pull inflation",
        "总需求",
        "aggregate demand",
        "产能",
        "capacity",
        "物价上涨",
        "price pressure"
      ],
      "synonyms": {
        "zh-CN": [
          "总需求",
          "产能",
          "物价上涨"
        ],
        "en": [
          "aggregate demand",
          "capacity",
          "price pressure"
        ]
      },
      "diagramIds": [
        "macro-ad-expansion"
      ],
      "quizIds": [
        "u3-25-demand-pull-flash-1",
        "u3-25-demand-pull-mcq-1",
        "u3-25-demand-pull-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-25-demand-pull",
        "locale": "zh-CN",
        "title": "需求拉动型通胀",
        "takeaway": "需求拉动型通胀源于总需求相对生产能力增长过快，在供给反应受限时形成广泛物价上涨压力。",
        "definition": "需求拉动型通胀源于总需求相对生产能力增长过快，在供给反应受限时形成广泛物价上涨压力。",
        "causalChain": [
          "消费、投资或其他支出增加",
          "AD 右移接近或超过产能",
          "工资与价格承受上涨压力"
        ],
        "misconceptions": [
          "单一商品涨价不必然意味着总体需求拉动通胀。"
        ],
        "examApplication": [
          "先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
        ],
        "summary": [
          "需求拉动型通胀源于总需求相对生产能力增长过快，在供给反应受限时形成广泛物价上涨压力。",
          "单一商品涨价不必然意味着总体需求拉动通胀。"
        ],
        "explanation": "消费、投资或其他支出增加。AD 右移接近或超过产能。工资与价格承受上涨压力。\n\n### 原创情境与推导\n\n原创例：充分就业附近，信贷和消费快速增加，企业难以迅速增产，涨价压力变大。同样的需求增加在大量闲置资源时可能更多体现为实际增长，而非相同幅度的通胀。\n\n单一商品涨价不必然意味着总体需求拉动通胀。\n\n先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
      },
      "en": {
        "id": "u3-25-demand-pull",
        "locale": "en",
        "title": "Demand-pull inflation",
        "takeaway": "Demand-pull inflation arises when AD grows too quickly relative to productive capacity, creating broad price pressure when supply response is constrained.",
        "definition": "Demand-pull inflation arises when AD grows too quickly relative to productive capacity, creating broad price pressure when supply response is constrained.",
        "causalChain": [
          "Consumption, investment or other spending rises",
          "AD shifts right toward or beyond capacity",
          "wages and prices face upward pressure"
        ],
        "misconceptions": [
          "A price rise in one product does not necessarily imply economy-wide demand-pull inflation."
        ],
        "examApplication": [
          "Define and measure objectives before analysing causes, stakeholders and conflicts."
        ],
        "summary": [
          "Demand-pull inflation arises when AD grows too quickly relative to productive capacity, creating broad price pressure when supply response is constrained.",
          "A price rise in one product does not necessarily imply economy-wide demand-pull inflation."
        ],
        "explanation": "Consumption, investment or other spending rises.  AD shifts right toward or beyond capacity.  wages and prices face upward pressure.\n\n### Original scenario and reasoning\n\nIllustrative example: rapid credit and consumption growth near full employment meets limited production response, raising price pressure. With substantial spare resources, the same demand rise may generate more real growth and less inflation.\n\nA price rise in one product does not necessarily imply economy-wide demand-pull inflation.\n\nDefine and measure objectives before analysing causes, stakeholders and conflicts."
      }
    },
    "practice": [
      {
        "id": "u3-25-demand-pull-flash-1",
        "knowledgePointId": "u3-25-demand-pull",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“需求拉动型通胀”，并说明一个关键条件。",
          "en": "Explain Demand-pull inflation and state one important condition."
        },
        "answer": {
          "zh-CN": "需求拉动型通胀源于总需求相对生产能力增长过快，在供给反应受限时形成广泛物价上涨压力。",
          "en": "Demand-pull inflation arises when AD grows too quickly relative to productive capacity, creating broad price pressure when supply response is constrained."
        },
        "explanation": {
          "zh-CN": "单一商品涨价不必然意味着总体需求拉动通胀。",
          "en": "A price rise in one product does not necessarily imply economy-wide demand-pull inflation."
        }
      },
      {
        "id": "u3-25-demand-pull-mcq-1",
        "knowledgePointId": "u3-25-demand-pull",
        "type": "mcq",
        "prompt": {
          "zh-CN": "接近满产时 AD 大幅右移主要增加哪种风险？",
          "en": "What risk rises when AD expands strongly near full capacity?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "需求拉动型通胀",
            "en": "Demand-pull inflation"
          },
          {
            "id": "b",
            "zh-CN": "总体价格必降",
            "en": "A necessary price-level fall"
          },
          {
            "id": "c",
            "zh-CN": "自然失业永远为零",
            "en": "Permanently zero natural unemployment"
          },
          {
            "id": "d",
            "zh-CN": "潜在产能必立刻翻倍",
            "en": "Instantly doubled capacity"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "需求拉动型通胀。 消费、投资或其他支出增加；AD 右移接近或超过产能；工资与价格承受上涨压力 单一商品涨价不必然意味着总体需求拉动通胀。",
          "en": "Demand-pull inflation. Consumption, investment or other spending rises; AD shifts right toward or beyond capacity; wages and prices face upward pressure A price rise in one product does not necessarily imply economy-wide demand-pull inflation."
        }
      },
      {
        "id": "u3-25-demand-pull-short-1",
        "knowledgePointId": "u3-25-demand-pull",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释需求拉动型通胀的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Demand-pull inflation and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "需求拉动型通胀源于总需求相对生产能力增长过快，在供给反应受限时形成广泛物价上涨压力。 消费、投资或其他支出增加；AD 右移接近或超过产能；工资与价格承受上涨压力 原创例：充分就业附近，信贷和消费快速增加，企业难以迅速增产，涨价压力变大。同样的需求增加在大量闲置资源时可能更多体现为实际增长，而非相同幅度的通胀。",
          "en": "Demand-pull inflation arises when AD grows too quickly relative to productive capacity, creating broad price pressure when supply response is constrained. Consumption, investment or other spending rises; AD shifts right toward or beyond capacity; wages and prices face upward pressure Illustrative example: rapid credit and consumption growth near full employment meets limited production response, raising price pressure. With substantial spare resources, the same demand rise may generate more real growth and less inflation."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "总需求",
              "en": "aggregate demand"
            },
            "alternatives": {
              "zh-CN": [
                "总需求",
                "消费、投资或其他支出增加"
              ],
              "en": [
                "aggregate demand",
                "Consumption, investment or other spending rises"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "产能",
              "en": "capacity"
            },
            "alternatives": {
              "zh-CN": [
                "产能",
                "AD 右移接近或超过产能"
              ],
              "en": [
                "capacity",
                "AD shifts right toward or beyond capacity"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "物价上涨",
              "en": "price pressure"
            },
            "alternatives": {
              "zh-CN": [
                "物价上涨",
                "工资与价格承受上涨压力"
              ],
              "en": [
                "price pressure",
                "wages and prices face upward pressure"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-26-cost-push",
      "slug": "cost-push",
      "section": "3.3",
      "level": "core",
      "syllabusRefs": [
        "3.3 Macroeconomic objectives"
      ],
      "textbookRefs": [
        {
          "chapter": "10",
          "section": "10.2",
          "pages": [
            313
          ]
        }
      ],
      "prerequisites": [
        "u3-17-macro-equilibrium"
      ],
      "related": [
        "u3-21-unemployment-rate",
        "u3-22-unemployment-types",
        "u3-23-unemployment-costs"
      ],
      "terms": [
        "成本推动型通胀",
        "Cost-push inflation",
        "单位成本",
        "unit costs",
        "SRAS",
        "SRAS",
        "生产率",
        "productivity"
      ],
      "synonyms": {
        "zh-CN": [
          "单位成本",
          "SRAS",
          "生产率"
        ],
        "en": [
          "unit costs",
          "SRAS",
          "productivity"
        ]
      },
      "diagramIds": [
        "macro-supply-shock"
      ],
      "quizIds": [
        "u3-26-cost-push-flash-1",
        "u3-26-cost-push-mcq-1",
        "u3-26-cost-push-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-26-cost-push",
        "locale": "zh-CN",
        "title": "成本推动型通胀",
        "takeaway": "成本推动型通胀来自单位生产成本或供给限制引起的物价压力；SRAS 左移可能伴随实际产出下降和失业上升。",
        "definition": "成本推动型通胀来自单位生产成本或供给限制引起的物价压力；SRAS 左移可能伴随实际产出下降和失业上升。",
        "causalChain": [
          "能源、工资相对生产率等成本增加",
          "SRAS 左移",
          "物价与失业可能同时上升"
        ],
        "misconceptions": [
          "名义工资上升若被生产率提高抵消，不必增加单位劳动成本。"
        ],
        "examApplication": [
          "先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
        ],
        "summary": [
          "成本推动型通胀来自单位生产成本或供给限制引起的物价压力；SRAS 左移可能伴随实际产出下降和失业上升。",
          "名义工资上升若被生产率提高抵消，不必增加单位劳动成本。"
        ],
        "explanation": "能源、工资相对生产率等成本增加。SRAS 左移。物价与失业可能同时上升。\n\n### 原创情境与推导\n\n原创例：运输能源成本普遍上升，影响多个行业。货币紧缩可抑制次轮需求和预期，却不能直接生产更多能源，并可能扩大产出损失。评价应区分一次冲击、预期及持续的工资价格互动。\n\n名义工资上升若被生产率提高抵消，不必增加单位劳动成本。\n\n先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
      },
      "en": {
        "id": "u3-26-cost-push",
        "locale": "en",
        "title": "Cost-push inflation",
        "takeaway": "Cost-push inflation comes from higher unit costs or supply constraints. A leftward SRAS shift can combine price pressure with lower real output and higher unemployment.",
        "definition": "Cost-push inflation comes from higher unit costs or supply constraints. A leftward SRAS shift can combine price pressure with lower real output and higher unemployment.",
        "causalChain": [
          "Energy costs or wages relative to productivity rise",
          "SRAS shifts left",
          "prices and unemployment may rise together"
        ],
        "misconceptions": [
          "Higher nominal wages need not increase unit labour cost if offset by productivity gains."
        ],
        "examApplication": [
          "Define and measure objectives before analysing causes, stakeholders and conflicts."
        ],
        "summary": [
          "Cost-push inflation comes from higher unit costs or supply constraints. A leftward SRAS shift can combine price pressure with lower real output and higher unemployment.",
          "Higher nominal wages need not increase unit labour cost if offset by productivity gains."
        ],
        "explanation": "Energy costs or wages relative to productivity rise.  SRAS shifts left.  prices and unemployment may rise together.\n\n### Original scenario and reasoning\n\nIllustrative example: dearer transport energy affects many industries. Monetary tightening can restrain second-round demand and expectations but cannot directly produce energy and may deepen output losses. Distinguish the initial shock, expectations and continuing wage-price interactions.\n\nHigher nominal wages need not increase unit labour cost if offset by productivity gains.\n\nDefine and measure objectives before analysing causes, stakeholders and conflicts."
      }
    },
    "practice": [
      {
        "id": "u3-26-cost-push-flash-1",
        "knowledgePointId": "u3-26-cost-push",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“成本推动型通胀”，并说明一个关键条件。",
          "en": "Explain Cost-push inflation and state one important condition."
        },
        "answer": {
          "zh-CN": "成本推动型通胀来自单位生产成本或供给限制引起的物价压力；SRAS 左移可能伴随实际产出下降和失业上升。",
          "en": "Cost-push inflation comes from higher unit costs or supply constraints. A leftward SRAS shift can combine price pressure with lower real output and higher unemployment."
        },
        "explanation": {
          "zh-CN": "名义工资上升若被生产率提高抵消，不必增加单位劳动成本。",
          "en": "Higher nominal wages need not increase unit labour cost if offset by productivity gains."
        }
      },
      {
        "id": "u3-26-cost-push-mcq-1",
        "knowledgePointId": "u3-26-cost-push",
        "type": "mcq",
        "prompt": {
          "zh-CN": "工资涨 5%、生产率也涨约 5%，单位劳动成本怎样？",
          "en": "Wages and productivity both rise about 5%. What happens to unit labour cost?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "必涨 10%",
            "en": "Must rise 10%"
          },
          {
            "id": "b",
            "zh-CN": "大致不变",
            "en": "Approximately unchanged"
          },
          {
            "id": "c",
            "zh-CN": "必降到零",
            "en": "Must fall to zero"
          },
          {
            "id": "d",
            "zh-CN": "无法计算任何方向即使增幅相同",
            "en": "No inference is possible despite equal proportional changes"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "大致不变。 能源、工资相对生产率等成本增加；SRAS 左移；物价与失业可能同时上升 名义工资上升若被生产率提高抵消，不必增加单位劳动成本。",
          "en": "Approximately unchanged. Energy costs or wages relative to productivity rise; SRAS shifts left; prices and unemployment may rise together Higher nominal wages need not increase unit labour cost if offset by productivity gains."
        }
      },
      {
        "id": "u3-26-cost-push-short-1",
        "knowledgePointId": "u3-26-cost-push",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释成本推动型通胀的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Cost-push inflation and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "成本推动型通胀来自单位生产成本或供给限制引起的物价压力；SRAS 左移可能伴随实际产出下降和失业上升。 能源、工资相对生产率等成本增加；SRAS 左移；物价与失业可能同时上升 原创例：运输能源成本普遍上升，影响多个行业。货币紧缩可抑制次轮需求和预期，却不能直接生产更多能源，并可能扩大产出损失。评价应区分一次冲击、预期及持续的工资价格互动。",
          "en": "Cost-push inflation comes from higher unit costs or supply constraints. A leftward SRAS shift can combine price pressure with lower real output and higher unemployment. Energy costs or wages relative to productivity rise; SRAS shifts left; prices and unemployment may rise together Illustrative example: dearer transport energy affects many industries. Monetary tightening can restrain second-round demand and expectations but cannot directly produce energy and may deepen output losses. Distinguish the initial shock, expectations and continuing wage-price interactions."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "单位成本",
              "en": "unit costs"
            },
            "alternatives": {
              "zh-CN": [
                "单位成本",
                "能源、工资相对生产率等成本增加"
              ],
              "en": [
                "unit costs",
                "Energy costs or wages relative to productivity rise"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "SRAS",
              "en": "SRAS"
            },
            "alternatives": {
              "zh-CN": [
                "SRAS",
                "SRAS 左移"
              ],
              "en": [
                "SRAS",
                "SRAS shifts left"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "生产率",
              "en": "productivity"
            },
            "alternatives": {
              "zh-CN": [
                "生产率",
                "物价与失业可能同时上升"
              ],
              "en": [
                "productivity",
                "prices and unemployment may rise together"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-27-disinflation-deflation",
      "slug": "disinflation-deflation",
      "section": "3.3",
      "level": "core",
      "syllabusRefs": [
        "3.3 Macroeconomic objectives"
      ],
      "textbookRefs": [
        {
          "chapter": "10",
          "section": "10.2",
          "pages": [
            316
          ]
        }
      ],
      "prerequisites": [
        "u3-17-macro-equilibrium"
      ],
      "related": [
        "u3-21-unemployment-rate",
        "u3-22-unemployment-types",
        "u3-23-unemployment-costs"
      ],
      "terms": [
        "通胀放缓、通缩与实际债务",
        "Disinflation, deflation and real debt",
        "通胀放缓",
        "disinflation",
        "通缩",
        "deflation",
        "实际债务",
        "real debt"
      ],
      "synonyms": {
        "zh-CN": [
          "通胀放缓",
          "通缩",
          "实际债务"
        ],
        "en": [
          "disinflation",
          "deflation",
          "real debt"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-27-disinflation-deflation-flash-1",
        "u3-27-disinflation-deflation-mcq-1",
        "u3-27-disinflation-deflation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-27-disinflation-deflation",
        "locale": "zh-CN",
        "title": "通胀放缓、通缩与实际债务",
        "takeaway": "通胀放缓是物价上涨速度下降；通缩是总体价格水平下降。意外通胀或通缩可改变固定名义债务的实际负担。",
        "definition": "通胀放缓是物价上涨速度下降；通缩是总体价格水平下降。意外通胀或通缩可改变固定名义债务的实际负担。",
        "causalChain": [
          "区分物价水平与其变化率",
          "通缩提高给定名义金额的购买力",
          "实际债务与延迟支出可能加重需求疲弱"
        ],
        "misconceptions": [
          "较低通胀率不等于较低价格水平。"
        ],
        "examApplication": [
          "先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
        ],
        "summary": [
          "通胀放缓是物价上涨速度下降；通缩是总体价格水平下降。意外通胀或通缩可改变固定名义债务的实际负担。",
          "较低通胀率不等于较低价格水平。"
        ],
        "explanation": "区分物价水平与其变化率。通缩提高给定名义金额的购买力。实际债务与延迟支出可能加重需求疲弱。\n\n### 原创情境与推导\n\n原创例：通胀率由 8% 到 3% 表示仍在涨价；由 3% 到 -1% 才出现通缩。若工资和收入随物价下降，固定还款负担可能更重。由生产率提高引起的降价与需求崩塌造成的通缩，政策含义不同。\n\n较低通胀率不等于较低价格水平。\n\n先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
      },
      "en": {
        "id": "u3-27-disinflation-deflation",
        "locale": "en",
        "title": "Disinflation, deflation and real debt",
        "takeaway": "Disinflation is slower price growth; deflation is a falling general price level. Unexpected inflation or deflation can alter the real burden of fixed nominal debt.",
        "definition": "Disinflation is slower price growth; deflation is a falling general price level. Unexpected inflation or deflation can alter the real burden of fixed nominal debt.",
        "causalChain": [
          "Separate the price level from its rate of change",
          "deflation raises the purchasing power of a fixed nominal amount",
          "real debt and delayed spending may weaken demand further"
        ],
        "misconceptions": [
          "A lower inflation rate does not mean a lower price level."
        ],
        "examApplication": [
          "Define and measure objectives before analysing causes, stakeholders and conflicts."
        ],
        "summary": [
          "Disinflation is slower price growth; deflation is a falling general price level. Unexpected inflation or deflation can alter the real burden of fixed nominal debt.",
          "A lower inflation rate does not mean a lower price level."
        ],
        "explanation": "Separate the price level from its rate of change.  deflation raises the purchasing power of a fixed nominal amount.  real debt and delayed spending may weaken demand further.\n\n### Original scenario and reasoning\n\nIllustrative example: inflation falling from 8% to 3% still means prices rise; moving from 3% to -1% is deflation. Fixed repayments may become harder when wages and incomes fall. Productivity-driven price falls differ from demand-collapse deflation.\n\nA lower inflation rate does not mean a lower price level.\n\nDefine and measure objectives before analysing causes, stakeholders and conflicts."
      }
    },
    "practice": [
      {
        "id": "u3-27-disinflation-deflation-flash-1",
        "knowledgePointId": "u3-27-disinflation-deflation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“通胀放缓、通缩与实际债务”，并说明一个关键条件。",
          "en": "Explain Disinflation, deflation and real debt and state one important condition."
        },
        "answer": {
          "zh-CN": "通胀放缓是物价上涨速度下降；通缩是总体价格水平下降。意外通胀或通缩可改变固定名义债务的实际负担。",
          "en": "Disinflation is slower price growth; deflation is a falling general price level. Unexpected inflation or deflation can alter the real burden of fixed nominal debt."
        },
        "explanation": {
          "zh-CN": "较低通胀率不等于较低价格水平。",
          "en": "A lower inflation rate does not mean a lower price level."
        }
      },
      {
        "id": "u3-27-disinflation-deflation-mcq-1",
        "knowledgePointId": "u3-27-disinflation-deflation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "通胀从 6% 降至 2%，最准确的描述是什么？",
          "en": "Inflation falls from 6% to 2%. What is the most accurate description?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "价格下降 4%",
            "en": "Prices fall 4%"
          },
          {
            "id": "b",
            "zh-CN": "必然通缩",
            "en": "Deflation necessarily"
          },
          {
            "id": "c",
            "zh-CN": "通胀放缓，价格仍上涨",
            "en": "Disinflation; prices still rise"
          },
          {
            "id": "d",
            "zh-CN": "实际产出下降 2%",
            "en": "Real output falls 2%"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "通胀放缓，价格仍上涨。 区分物价水平与其变化率；通缩提高给定名义金额的购买力；实际债务与延迟支出可能加重需求疲弱 较低通胀率不等于较低价格水平。",
          "en": "Disinflation; prices still rise. Separate the price level from its rate of change; deflation raises the purchasing power of a fixed nominal amount; real debt and delayed spending may weaken demand further A lower inflation rate does not mean a lower price level."
        }
      },
      {
        "id": "u3-27-disinflation-deflation-short-1",
        "knowledgePointId": "u3-27-disinflation-deflation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释通胀放缓、通缩与实际债务的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Disinflation, deflation and real debt and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "通胀放缓是物价上涨速度下降；通缩是总体价格水平下降。意外通胀或通缩可改变固定名义债务的实际负担。 区分物价水平与其变化率；通缩提高给定名义金额的购买力；实际债务与延迟支出可能加重需求疲弱 原创例：通胀率由 8% 到 3% 表示仍在涨价；由 3% 到 -1% 才出现通缩。若工资和收入随物价下降，固定还款负担可能更重。由生产率提高引起的降价与需求崩塌造成的通缩，政策含义不同。",
          "en": "Disinflation is slower price growth; deflation is a falling general price level. Unexpected inflation or deflation can alter the real burden of fixed nominal debt. Separate the price level from its rate of change; deflation raises the purchasing power of a fixed nominal amount; real debt and delayed spending may weaken demand further Illustrative example: inflation falling from 8% to 3% still means prices rise; moving from 3% to -1% is deflation. Fixed repayments may become harder when wages and incomes fall. Productivity-driven price falls differ from demand-collapse deflation."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "通胀放缓",
              "en": "disinflation"
            },
            "alternatives": {
              "zh-CN": [
                "通胀放缓",
                "区分物价水平与其变化率"
              ],
              "en": [
                "disinflation",
                "Separate the price level from its rate of change"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "通缩",
              "en": "deflation"
            },
            "alternatives": {
              "zh-CN": [
                "通缩",
                "通缩提高给定名义金额的购买力"
              ],
              "en": [
                "deflation",
                "deflation raises the purchasing power of a fixed nominal amount"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "实际债务",
              "en": "real debt"
            },
            "alternatives": {
              "zh-CN": [
                "实际债务",
                "实际债务与延迟支出可能加重需求疲弱"
              ],
              "en": [
                "real debt",
                "real debt and delayed spending may weaken demand further"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-28-growth-measure",
      "slug": "growth-measure",
      "section": "3.3",
      "level": "core",
      "syllabusRefs": [
        "3.3 Macroeconomic objectives"
      ],
      "textbookRefs": [
        {
          "chapter": "11",
          "section": "11.1",
          "pages": [
            332
          ]
        }
      ],
      "prerequisites": [
        "u3-17-macro-equilibrium"
      ],
      "related": [
        "u3-21-unemployment-rate",
        "u3-22-unemployment-types",
        "u3-23-unemployment-costs"
      ],
      "terms": [
        "实际经济增长的衡量",
        "Measuring real economic growth",
        "实际 GDP",
        "real GDP",
        "百分比",
        "percentage",
        "人口",
        "population"
      ],
      "synonyms": {
        "zh-CN": [
          "实际 GDP",
          "百分比",
          "人口"
        ],
        "en": [
          "real GDP",
          "percentage",
          "population"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-28-growth-measure-flash-1",
        "u3-28-growth-measure-mcq-1",
        "u3-28-growth-measure-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-28-growth-measure",
        "locale": "zh-CN",
        "title": "实际经济增长的衡量",
        "takeaway": "实际经济增长率是实际 GDP 的百分比增幅；人均实际增长还需考虑人口，长期潜在增长与短期复苏并不相同。",
        "definition": "实际经济增长率是实际 GDP 的百分比增幅；人均实际增长还需考虑人口，长期潜在增长与短期复苏并不相同。",
        "causalChain": [
          "剔除价格变化",
          "比较相邻期间实际产出",
          "结合人口与潜在产能判断增长性质"
        ],
        "misconceptions": [
          "使用名义 GDP 增幅而不处理物价，会混淆产量与价格。"
        ],
        "examApplication": [
          "先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
        ],
        "summary": [
          "实际经济增长率是实际 GDP 的百分比增幅；人均实际增长还需考虑人口，长期潜在增长与短期复苏并不相同。",
          "使用名义 GDP 增幅而不处理物价，会混淆产量与价格。"
        ],
        "explanation": "剔除价格变化。比较相邻期间实际产出。结合人口与潜在产能判断增长性质。\n\n### 原创情境与推导\n\n原创例：实际 GDP 从 800 到 840，增长率为 5%。若同期人口增长 5%，人均实际 GDP 不变。若失业资源被重新使用，增长可能主要来自缺口缩小，而非生产边界外移。\n\n使用名义 GDP 增幅而不处理物价，会混淆产量与价格。\n\n先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
      },
      "en": {
        "id": "u3-28-growth-measure",
        "locale": "en",
        "title": "Measuring real economic growth",
        "takeaway": "Real growth is the percentage increase in real GDP. Per-capita growth also accounts for population; long-run potential growth differs from short-run recovery.",
        "definition": "Real growth is the percentage increase in real GDP. Per-capita growth also accounts for population; long-run potential growth differs from short-run recovery.",
        "causalChain": [
          "Remove price changes",
          "compare real output across periods",
          "use population and capacity to interpret the nature of growth"
        ],
        "misconceptions": [
          "Using nominal GDP growth without adjusting prices confuses volume with prices."
        ],
        "examApplication": [
          "Define and measure objectives before analysing causes, stakeholders and conflicts."
        ],
        "summary": [
          "Real growth is the percentage increase in real GDP. Per-capita growth also accounts for population; long-run potential growth differs from short-run recovery.",
          "Using nominal GDP growth without adjusting prices confuses volume with prices."
        ],
        "explanation": "Remove price changes.  compare real output across periods.  use population and capacity to interpret the nature of growth.\n\n### Original scenario and reasoning\n\nIllustrative example: real GDP rises from 800 to 840, giving growth of 5%. With population also growing 5%, real GDP per person is unchanged. Re-employing idle resources can close a gap rather than shift the production frontier.\n\nUsing nominal GDP growth without adjusting prices confuses volume with prices.\n\nDefine and measure objectives before analysing causes, stakeholders and conflicts."
      }
    },
    "practice": [
      {
        "id": "u3-28-growth-measure-flash-1",
        "knowledgePointId": "u3-28-growth-measure",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“实际经济增长的衡量”，并说明一个关键条件。",
          "en": "Explain Measuring real economic growth and state one important condition."
        },
        "answer": {
          "zh-CN": "实际经济增长率是实际 GDP 的百分比增幅；人均实际增长还需考虑人口，长期潜在增长与短期复苏并不相同。",
          "en": "Real growth is the percentage increase in real GDP. Per-capita growth also accounts for population; long-run potential growth differs from short-run recovery."
        },
        "explanation": {
          "zh-CN": "使用名义 GDP 增幅而不处理物价，会混淆产量与价格。",
          "en": "Using nominal GDP growth without adjusting prices confuses volume with prices."
        }
      },
      {
        "id": "u3-28-growth-measure-mcq-1",
        "knowledgePointId": "u3-28-growth-measure",
        "type": "mcq",
        "prompt": {
          "zh-CN": "实际 GDP 从 500 到 525，增长率多少？",
          "en": "Real GDP rises from 500 to 525. What is growth?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "25%",
            "en": "25%"
          },
          {
            "id": "b",
            "zh-CN": "105%",
            "en": "105%"
          },
          {
            "id": "c",
            "zh-CN": "0.05%",
            "en": "0.05%"
          },
          {
            "id": "d",
            "zh-CN": "5%",
            "en": "5%"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "5%。 (525 − 500) / 500 × 100 = 5% 使用名义 GDP 增幅而不处理物价，会混淆产量与价格。",
          "en": "5%. (525 − 500) / 500 × 100 = 5% Using nominal GDP growth without adjusting prices confuses volume with prices."
        }
      },
      {
        "id": "u3-28-growth-measure-short-1",
        "knowledgePointId": "u3-28-growth-measure",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释实际经济增长的衡量的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Measuring real economic growth and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "实际经济增长率是实际 GDP 的百分比增幅；人均实际增长还需考虑人口，长期潜在增长与短期复苏并不相同。 剔除价格变化；比较相邻期间实际产出；结合人口与潜在产能判断增长性质 原创例：实际 GDP 从 800 到 840，增长率为 5%。若同期人口增长 5%，人均实际 GDP 不变。若失业资源被重新使用，增长可能主要来自缺口缩小，而非生产边界外移。",
          "en": "Real growth is the percentage increase in real GDP. Per-capita growth also accounts for population; long-run potential growth differs from short-run recovery. Remove price changes; compare real output across periods; use population and capacity to interpret the nature of growth Illustrative example: real GDP rises from 800 to 840, giving growth of 5%. With population also growing 5%, real GDP per person is unchanged. Re-employing idle resources can close a gap rather than shift the production frontier."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "实际 GDP",
              "en": "real GDP"
            },
            "alternatives": {
              "zh-CN": [
                "实际 GDP",
                "剔除价格变化"
              ],
              "en": [
                "real GDP",
                "Remove price changes"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "百分比",
              "en": "percentage"
            },
            "alternatives": {
              "zh-CN": [
                "百分比",
                "比较相邻期间实际产出"
              ],
              "en": [
                "percentage",
                "compare real output across periods"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "人口",
              "en": "population"
            },
            "alternatives": {
              "zh-CN": [
                "人口",
                "结合人口与潜在产能判断增长性质"
              ],
              "en": [
                "population",
                "use population and capacity to interpret the nature of growth"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-29-growth-evaluation",
      "slug": "growth-evaluation",
      "section": "3.3",
      "level": "core",
      "syllabusRefs": [
        "3.3 Macroeconomic objectives"
      ],
      "textbookRefs": [
        {
          "chapter": "11",
          "section": "11.1",
          "pages": [
            338
          ]
        }
      ],
      "prerequisites": [
        "u3-17-macro-equilibrium"
      ],
      "related": [
        "u3-21-unemployment-rate",
        "u3-22-unemployment-types",
        "u3-23-unemployment-costs"
      ],
      "terms": [
        "增长的来源、收益与代价",
        "Sources, benefits and costs of growth",
        "生产能力",
        "capacity",
        "分配",
        "distribution",
        "环境成本",
        "environmental costs"
      ],
      "synonyms": {
        "zh-CN": [
          "生产能力",
          "分配",
          "环境成本"
        ],
        "en": [
          "capacity",
          "distribution",
          "environmental costs"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-29-growth-evaluation-flash-1",
        "u3-29-growth-evaluation-mcq-1",
        "u3-29-growth-evaluation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-29-growth-evaluation",
        "locale": "zh-CN",
        "title": "增长的来源、收益与代价",
        "takeaway": "资本、人力资本、技术和制度改善可支持长期增长；增长可增加收入和财政空间，也可能带来分配不均与环境代价。",
        "definition": "资本、人力资本、技术和制度改善可支持长期增长；增长可增加收入和财政空间，也可能带来分配不均与环境代价。",
        "causalChain": [
          "投资与创新提高生产能力",
          "实际收入和税基扩大",
          "结果取决于收益分配与资源环境约束"
        ],
        "misconceptions": [
          "增长与发展及可持续性并非完全相同的概念。"
        ],
        "examApplication": [
          "先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
        ],
        "summary": [
          "资本、人力资本、技术和制度改善可支持长期增长；增长可增加收入和财政空间，也可能带来分配不均与环境代价。",
          "增长与发展及可持续性并非完全相同的概念。"
        ],
        "explanation": "投资与创新提高生产能力。实际收入和税基扩大。结果取决于收益分配与资源环境约束。\n\n### 原创情境与推导\n\n原创例：工厂自动化提高产量但使部分工人岗位消失。再培训、可转移技能和区域流动决定增长能否广泛受益。绿色技术可降低单位排放，但总产出扩张可能抵消部分环境改善。\n\n增长与发展及可持续性并非完全相同的概念。\n\n先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
      },
      "en": {
        "id": "u3-29-growth-evaluation",
        "locale": "en",
        "title": "Sources, benefits and costs of growth",
        "takeaway": "Physical and human capital, technology and institutions support long-run growth. Growth can raise incomes and fiscal capacity while generating unequal gains and environmental costs.",
        "definition": "Physical and human capital, technology and institutions support long-run growth. Growth can raise incomes and fiscal capacity while generating unequal gains and environmental costs.",
        "causalChain": [
          "Investment and innovation raise capacity",
          "real incomes and the tax base expand",
          "outcomes depend on distribution and environmental constraints"
        ],
        "misconceptions": [
          "Growth, development and sustainability are not identical concepts."
        ],
        "examApplication": [
          "Define and measure objectives before analysing causes, stakeholders and conflicts."
        ],
        "summary": [
          "Physical and human capital, technology and institutions support long-run growth. Growth can raise incomes and fiscal capacity while generating unequal gains and environmental costs.",
          "Growth, development and sustainability are not identical concepts."
        ],
        "explanation": "Investment and innovation raise capacity.  real incomes and the tax base expand.  outcomes depend on distribution and environmental constraints.\n\n### Original scenario and reasoning\n\nIllustrative example: automation raises output but removes some jobs. Retraining, transferable skills and mobility affect how widely gains are shared. Cleaner technology lowers emissions per unit, but output expansion may offset part of the environmental improvement.\n\nGrowth, development and sustainability are not identical concepts.\n\nDefine and measure objectives before analysing causes, stakeholders and conflicts."
      }
    },
    "practice": [
      {
        "id": "u3-29-growth-evaluation-flash-1",
        "knowledgePointId": "u3-29-growth-evaluation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“增长的来源、收益与代价”，并说明一个关键条件。",
          "en": "Explain Sources, benefits and costs of growth and state one important condition."
        },
        "answer": {
          "zh-CN": "资本、人力资本、技术和制度改善可支持长期增长；增长可增加收入和财政空间，也可能带来分配不均与环境代价。",
          "en": "Physical and human capital, technology and institutions support long-run growth. Growth can raise incomes and fiscal capacity while generating unequal gains and environmental costs."
        },
        "explanation": {
          "zh-CN": "增长与发展及可持续性并非完全相同的概念。",
          "en": "Growth, development and sustainability are not identical concepts."
        }
      },
      {
        "id": "u3-29-growth-evaluation-mcq-1",
        "knowledgePointId": "u3-29-growth-evaluation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "评价增长是否改善福利时，哪项最有用？",
          "en": "Which is most useful in judging whether growth improves welfare?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "结合人均收益、分配与环境成本",
            "en": "Consider per-capita gains, distribution and environmental costs"
          },
          {
            "id": "b",
            "zh-CN": "只看名义产值",
            "en": "Only nominal output"
          },
          {
            "id": "c",
            "zh-CN": "假设所有人等量受益",
            "en": "Assume identical gains for everyone"
          },
          {
            "id": "d",
            "zh-CN": "忽略机会成本",
            "en": "Ignore opportunity cost"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "结合人均收益、分配与环境成本。 投资与创新提高生产能力；实际收入和税基扩大；结果取决于收益分配与资源环境约束 增长与发展及可持续性并非完全相同的概念。",
          "en": "Consider per-capita gains, distribution and environmental costs. Investment and innovation raise capacity; real incomes and the tax base expand; outcomes depend on distribution and environmental constraints Growth, development and sustainability are not identical concepts."
        }
      },
      {
        "id": "u3-29-growth-evaluation-short-1",
        "knowledgePointId": "u3-29-growth-evaluation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释增长的来源、收益与代价的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Sources, benefits and costs of growth and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "资本、人力资本、技术和制度改善可支持长期增长；增长可增加收入和财政空间，也可能带来分配不均与环境代价。 投资与创新提高生产能力；实际收入和税基扩大；结果取决于收益分配与资源环境约束 原创例：工厂自动化提高产量但使部分工人岗位消失。再培训、可转移技能和区域流动决定增长能否广泛受益。绿色技术可降低单位排放，但总产出扩张可能抵消部分环境改善。",
          "en": "Physical and human capital, technology and institutions support long-run growth. Growth can raise incomes and fiscal capacity while generating unequal gains and environmental costs. Investment and innovation raise capacity; real incomes and the tax base expand; outcomes depend on distribution and environmental constraints Illustrative example: automation raises output but removes some jobs. Retraining, transferable skills and mobility affect how widely gains are shared. Cleaner technology lowers emissions per unit, but output expansion may offset part of the environmental improvement."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "生产能力",
              "en": "capacity"
            },
            "alternatives": {
              "zh-CN": [
                "生产能力",
                "投资与创新提高生产能力"
              ],
              "en": [
                "capacity",
                "Investment and innovation raise capacity"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "分配",
              "en": "distribution"
            },
            "alternatives": {
              "zh-CN": [
                "分配",
                "实际收入和税基扩大"
              ],
              "en": [
                "distribution",
                "real incomes and the tax base expand"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "环境成本",
              "en": "environmental costs"
            },
            "alternatives": {
              "zh-CN": [
                "环境成本",
                "结果取决于收益分配与资源环境约束"
              ],
              "en": [
                "environmental costs",
                "outcomes depend on distribution and environmental constraints"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-30-public-debt",
      "slug": "public-debt",
      "section": "3.3",
      "level": "hl",
      "syllabusRefs": [
        "3.3 Macroeconomic objectives"
      ],
      "textbookRefs": [
        {
          "chapter": "11",
          "section": "11.2",
          "pages": [
            346
          ]
        }
      ],
      "prerequisites": [
        "u3-17-macro-equilibrium"
      ],
      "related": [
        "u3-21-unemployment-rate",
        "u3-22-unemployment-types",
        "u3-23-unemployment-costs"
      ],
      "terms": [
        "政府债务与可持续性",
        "Government debt and sustainability",
        "存量",
        "stock",
        "赤字",
        "deficit",
        "增长",
        "growth"
      ],
      "synonyms": {
        "zh-CN": [
          "存量",
          "赤字",
          "增长"
        ],
        "en": [
          "stock",
          "deficit",
          "growth"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-30-public-debt-flash-1",
        "u3-30-public-debt-mcq-1",
        "u3-30-public-debt-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-30-public-debt",
        "locale": "zh-CN",
        "title": "政府债务与可持续性",
        "takeaway": "预算赤字是一定期间支出超过收入的流量，公共债务是累积存量。债务可持续性取决于增长、利率、初级余额、币种与偿付能力等。",
        "definition": "预算赤字是一定期间支出超过收入的流量，公共债务是累积存量。债务可持续性取决于增长、利率、初级余额、币种与偿付能力等。",
        "causalChain": [
          "赤字通常增加融资需求",
          "债务存量产生利息",
          "增长与初级余额共同影响债务占 GDP 比率"
        ],
        "misconceptions": [
          "政府债务增加不意味着债务占 GDP 比率必然增加。"
        ],
        "examApplication": [
          "先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
        ],
        "summary": [
          "预算赤字是一定期间支出超过收入的流量，公共债务是累积存量。债务可持续性取决于增长、利率、初级余额、币种与偿付能力等。",
          "政府债务增加不意味着债务占 GDP 比率必然增加。"
        ],
        "explanation": "赤字通常增加融资需求。债务存量产生利息。增长与初级余额共同影响债务占 GDP 比率。\n\n### 原创情境与推导\n\n原创例：债务 600、GDP 1000，债务率 60%。债务升至 630 而 GDP 升至 1100，债务率反而降至约 57.3%。没有适用于所有国家的单一安全阈值；借款用途、期限和可信度都重要。\n\n政府债务增加不意味着债务占 GDP 比率必然增加。\n\n先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
      },
      "en": {
        "id": "u3-30-public-debt",
        "locale": "en",
        "title": "Government debt and sustainability",
        "takeaway": "A budget deficit is a flow of spending above revenue over a period; public debt is an accumulated stock. Sustainability depends on growth, interest rates, the primary balance, currency and repayment capacity.",
        "definition": "A budget deficit is a flow of spending above revenue over a period; public debt is an accumulated stock. Sustainability depends on growth, interest rates, the primary balance, currency and repayment capacity.",
        "causalChain": [
          "Deficits normally increase financing needs",
          "debt stocks generate interest costs",
          "growth and primary balances jointly affect the debt-to-GDP ratio"
        ],
        "misconceptions": [
          "More government debt does not necessarily imply a higher debt-to-GDP ratio."
        ],
        "examApplication": [
          "Define and measure objectives before analysing causes, stakeholders and conflicts."
        ],
        "summary": [
          "A budget deficit is a flow of spending above revenue over a period; public debt is an accumulated stock. Sustainability depends on growth, interest rates, the primary balance, currency and repayment capacity.",
          "More government debt does not necessarily imply a higher debt-to-GDP ratio."
        ],
        "explanation": "Deficits normally increase financing needs.  debt stocks generate interest costs.  growth and primary balances jointly affect the debt-to-GDP ratio.\n\n### Original scenario and reasoning\n\nIllustrative example: debt of 600 and GDP 1000 give a 60% ratio. Debt rises to 630 but GDP to 1100, lowering the ratio to about 57.3%. There is no universal safe threshold; use of borrowing, maturity and credibility matter.\n\nMore government debt does not necessarily imply a higher debt-to-GDP ratio.\n\nDefine and measure objectives before analysing causes, stakeholders and conflicts."
      }
    },
    "practice": [
      {
        "id": "u3-30-public-debt-flash-1",
        "knowledgePointId": "u3-30-public-debt",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“政府债务与可持续性”，并说明一个关键条件。",
          "en": "Explain Government debt and sustainability and state one important condition."
        },
        "answer": {
          "zh-CN": "预算赤字是一定期间支出超过收入的流量，公共债务是累积存量。债务可持续性取决于增长、利率、初级余额、币种与偿付能力等。",
          "en": "A budget deficit is a flow of spending above revenue over a period; public debt is an accumulated stock. Sustainability depends on growth, interest rates, the primary balance, currency and repayment capacity."
        },
        "explanation": {
          "zh-CN": "政府债务增加不意味着债务占 GDP 比率必然增加。",
          "en": "More government debt does not necessarily imply a higher debt-to-GDP ratio."
        }
      },
      {
        "id": "u3-30-public-debt-mcq-1",
        "knowledgePointId": "u3-30-public-debt",
        "type": "mcq",
        "prompt": {
          "zh-CN": "债务 240、GDP 400，债务率多少？",
          "en": "Debt is 240 and GDP 400. What is the debt ratio?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "40%",
            "en": "40%"
          },
          {
            "id": "b",
            "zh-CN": "60%",
            "en": "60%"
          },
          {
            "id": "c",
            "zh-CN": "166.7%",
            "en": "166.7%"
          },
          {
            "id": "d",
            "zh-CN": "640%",
            "en": "640%"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "60%。 240 / 400 × 100 = 60% 政府债务增加不意味着债务占 GDP 比率必然增加。",
          "en": "60%. 240 / 400 × 100 = 60% More government debt does not necessarily imply a higher debt-to-GDP ratio."
        }
      },
      {
        "id": "u3-30-public-debt-short-1",
        "knowledgePointId": "u3-30-public-debt",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释政府债务与可持续性的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Government debt and sustainability and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "预算赤字是一定期间支出超过收入的流量，公共债务是累积存量。债务可持续性取决于增长、利率、初级余额、币种与偿付能力等。 赤字通常增加融资需求；债务存量产生利息；增长与初级余额共同影响债务占 GDP 比率 原创例：债务 600、GDP 1000，债务率 60%。债务升至 630 而 GDP 升至 1100，债务率反而降至约 57.3%。没有适用于所有国家的单一安全阈值；借款用途、期限和可信度都重要。",
          "en": "A budget deficit is a flow of spending above revenue over a period; public debt is an accumulated stock. Sustainability depends on growth, interest rates, the primary balance, currency and repayment capacity. Deficits normally increase financing needs; debt stocks generate interest costs; growth and primary balances jointly affect the debt-to-GDP ratio Illustrative example: debt of 600 and GDP 1000 give a 60% ratio. Debt rises to 630 but GDP to 1100, lowering the ratio to about 57.3%. There is no universal safe threshold; use of borrowing, maturity and credibility matter."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "存量",
              "en": "stock"
            },
            "alternatives": {
              "zh-CN": [
                "存量",
                "赤字通常增加融资需求"
              ],
              "en": [
                "stock",
                "Deficits normally increase financing needs"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "赤字",
              "en": "deficit"
            },
            "alternatives": {
              "zh-CN": [
                "赤字",
                "债务存量产生利息"
              ],
              "en": [
                "deficit",
                "debt stocks generate interest costs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "增长",
              "en": "growth"
            },
            "alternatives": {
              "zh-CN": [
                "增长",
                "增长与初级余额共同影响债务占 GDP 比率"
              ],
              "en": [
                "growth",
                "growth and primary balances jointly affect the debt-to-GDP ratio"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-31-phillips-curve",
      "slug": "phillips-curve",
      "section": "3.3",
      "level": "hl",
      "syllabusRefs": [
        "3.3 Macroeconomic objectives"
      ],
      "textbookRefs": [
        {
          "chapter": "10",
          "section": "10.3",
          "pages": [
            322
          ]
        }
      ],
      "prerequisites": [
        "u3-17-macro-equilibrium"
      ],
      "related": [
        "u3-21-unemployment-rate",
        "u3-22-unemployment-types",
        "u3-23-unemployment-costs"
      ],
      "terms": [
        "短期与长期菲利普斯曲线",
        "Short-run and long-run Phillips curves",
        "预期",
        "expectations",
        "自然失业率",
        "natural rate",
        "长期",
        "long run"
      ],
      "synonyms": {
        "zh-CN": [
          "预期",
          "自然失业率",
          "长期"
        ],
        "en": [
          "expectations",
          "natural rate",
          "long run"
        ]
      },
      "diagramIds": [
        "macro-phillips"
      ],
      "quizIds": [
        "u3-31-phillips-curve-flash-1",
        "u3-31-phillips-curve-mcq-1",
        "u3-31-phillips-curve-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-31-phillips-curve",
        "locale": "zh-CN",
        "title": "短期与长期菲利普斯曲线",
        "takeaway": "短期菲利普斯曲线描述给定预期与供给条件下通胀和失业的反向关系；长期预期调整模型中的曲线在自然失业率处垂直。",
        "definition": "短期菲利普斯曲线描述给定预期与供给条件下通胀和失业的反向关系；长期预期调整模型中的曲线在自然失业率处垂直。",
        "causalChain": [
          "需求扩张短期减少周期性失业",
          "工资价格预期随后调整",
          "短期曲线移动使长期权衡消失"
        ],
        "misconceptions": [
          "菲利普斯图纵轴是通胀率，AD–AS 图纵轴是价格水平。"
        ],
        "examApplication": [
          "先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
        ],
        "summary": [
          "短期菲利普斯曲线描述给定预期与供给条件下通胀和失业的反向关系；长期预期调整模型中的曲线在自然失业率处垂直。",
          "菲利普斯图纵轴是通胀率，AD–AS 图纵轴是价格水平。"
        ],
        "explanation": "需求扩张短期减少周期性失业。工资价格预期随后调整。短期曲线移动使长期权衡消失。\n\n### 原创情境与推导\n\n原创例：政策把失业暂时压低至自然率以下，随后预期通胀上升，SRPC 上移。能源供给冲击也可使通胀和失业同时上升，所以不能将一条短期曲线当作永久稳定的政策菜单。\n\n菲利普斯图纵轴是通胀率，AD–AS 图纵轴是价格水平。\n\n先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
      },
      "en": {
        "id": "u3-31-phillips-curve",
        "locale": "en",
        "title": "Short-run and long-run Phillips curves",
        "takeaway": "The short-run Phillips curve describes an inverse inflation–unemployment relationship at given expectations and supply conditions. In the expectations-adjusted long-run model, the curve is vertical at the natural rate.",
        "definition": "The short-run Phillips curve describes an inverse inflation–unemployment relationship at given expectations and supply conditions. In the expectations-adjusted long-run model, the curve is vertical at the natural rate.",
        "causalChain": [
          "Demand expansion initially reduces cyclical unemployment",
          "wage-price expectations adjust",
          "the short-run curve shifts, removing the permanent long-run trade-off"
        ],
        "misconceptions": [
          "Phillips curves use inflation on the vertical axis; AD–AS uses the price level."
        ],
        "examApplication": [
          "Define and measure objectives before analysing causes, stakeholders and conflicts."
        ],
        "summary": [
          "The short-run Phillips curve describes an inverse inflation–unemployment relationship at given expectations and supply conditions. In the expectations-adjusted long-run model, the curve is vertical at the natural rate.",
          "Phillips curves use inflation on the vertical axis; AD–AS uses the price level."
        ],
        "explanation": "Demand expansion initially reduces cyclical unemployment.  wage-price expectations adjust.  the short-run curve shifts, removing the permanent long-run trade-off.\n\n### Original scenario and reasoning\n\nIllustrative example: policy temporarily pushes unemployment below the natural rate, then expected inflation rises and SRPC shifts up. An energy shock can raise both inflation and unemployment, so one short-run curve is not a permanently stable policy menu.\n\nPhillips curves use inflation on the vertical axis; AD–AS uses the price level.\n\nDefine and measure objectives before analysing causes, stakeholders and conflicts."
      }
    },
    "practice": [
      {
        "id": "u3-31-phillips-curve-flash-1",
        "knowledgePointId": "u3-31-phillips-curve",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“短期与长期菲利普斯曲线”，并说明一个关键条件。",
          "en": "Explain Short-run and long-run Phillips curves and state one important condition."
        },
        "answer": {
          "zh-CN": "短期菲利普斯曲线描述给定预期与供给条件下通胀和失业的反向关系；长期预期调整模型中的曲线在自然失业率处垂直。",
          "en": "The short-run Phillips curve describes an inverse inflation–unemployment relationship at given expectations and supply conditions. In the expectations-adjusted long-run model, the curve is vertical at the natural rate."
        },
        "explanation": {
          "zh-CN": "菲利普斯图纵轴是通胀率，AD–AS 图纵轴是价格水平。",
          "en": "Phillips curves use inflation on the vertical axis; AD–AS uses the price level."
        }
      },
      {
        "id": "u3-31-phillips-curve-mcq-1",
        "knowledgePointId": "u3-31-phillips-curve",
        "type": "mcq",
        "prompt": {
          "zh-CN": "长期菲利普斯曲线垂直表示什么？",
          "en": "What does a vertical long-run Phillips curve imply?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "通胀永远为零",
            "en": "Inflation is always zero"
          },
          {
            "id": "b",
            "zh-CN": "失业永远为零",
            "en": "Unemployment is always zero"
          },
          {
            "id": "c",
            "zh-CN": "不存在永久的通胀—失业权衡",
            "en": "No permanent inflation–unemployment trade-off"
          },
          {
            "id": "d",
            "zh-CN": "短期供给冲击不可能发生",
            "en": "Short-run supply shocks cannot occur"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "不存在永久的通胀—失业权衡。 需求扩张短期减少周期性失业；工资价格预期随后调整；短期曲线移动使长期权衡消失 菲利普斯图纵轴是通胀率，AD–AS 图纵轴是价格水平。",
          "en": "No permanent inflation–unemployment trade-off. Demand expansion initially reduces cyclical unemployment; wage-price expectations adjust; the short-run curve shifts, removing the permanent long-run trade-off Phillips curves use inflation on the vertical axis; AD–AS uses the price level."
        }
      },
      {
        "id": "u3-31-phillips-curve-short-1",
        "knowledgePointId": "u3-31-phillips-curve",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释短期与长期菲利普斯曲线的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Short-run and long-run Phillips curves and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "短期菲利普斯曲线描述给定预期与供给条件下通胀和失业的反向关系；长期预期调整模型中的曲线在自然失业率处垂直。 需求扩张短期减少周期性失业；工资价格预期随后调整；短期曲线移动使长期权衡消失 原创例：政策把失业暂时压低至自然率以下，随后预期通胀上升，SRPC 上移。能源供给冲击也可使通胀和失业同时上升，所以不能将一条短期曲线当作永久稳定的政策菜单。",
          "en": "The short-run Phillips curve describes an inverse inflation–unemployment relationship at given expectations and supply conditions. In the expectations-adjusted long-run model, the curve is vertical at the natural rate. Demand expansion initially reduces cyclical unemployment; wage-price expectations adjust; the short-run curve shifts, removing the permanent long-run trade-off Illustrative example: policy temporarily pushes unemployment below the natural rate, then expected inflation rises and SRPC shifts up. An energy shock can raise both inflation and unemployment, so one short-run curve is not a permanently stable policy menu."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "预期",
              "en": "expectations"
            },
            "alternatives": {
              "zh-CN": [
                "预期",
                "需求扩张短期减少周期性失业"
              ],
              "en": [
                "expectations",
                "Demand expansion initially reduces cyclical unemployment"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "自然失业率",
              "en": "natural rate"
            },
            "alternatives": {
              "zh-CN": [
                "自然失业率",
                "工资价格预期随后调整"
              ],
              "en": [
                "natural rate",
                "wage-price expectations adjust"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "长期",
              "en": "long run"
            },
            "alternatives": {
              "zh-CN": [
                "长期",
                "短期曲线移动使长期权衡消失"
              ],
              "en": [
                "long run",
                "the short-run curve shifts, removing the permanent long-run trade-off"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-32-objective-conflicts",
      "slug": "objective-conflicts",
      "section": "3.3",
      "level": "core",
      "syllabusRefs": [
        "3.3 Macroeconomic objectives"
      ],
      "textbookRefs": [
        {
          "chapter": "11",
          "section": "11.3",
          "pages": [
            350
          ]
        }
      ],
      "prerequisites": [
        "u3-17-macro-equilibrium"
      ],
      "related": [
        "u3-21-unemployment-rate",
        "u3-22-unemployment-types",
        "u3-23-unemployment-costs"
      ],
      "terms": [
        "宏观目标的冲突与协同",
        "Conflicts and complementarities among objectives",
        "目标",
        "objectives",
        "短期",
        "short run",
        "生产率",
        "productivity"
      ],
      "synonyms": {
        "zh-CN": [
          "目标",
          "短期",
          "生产率"
        ],
        "en": [
          "objectives",
          "short run",
          "productivity"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-32-objective-conflicts-flash-1",
        "u3-32-objective-conflicts-mcq-1",
        "u3-32-objective-conflicts-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-32-objective-conflicts",
        "locale": "zh-CN",
        "title": "宏观目标的冲突与协同",
        "takeaway": "增长、低失业、价格稳定、公平、可持续性与债务目标可能冲突，也可能因生产率改善等共同推进；权衡依赖起点、冲击和时间。",
        "definition": "增长、低失业、价格稳定、公平、可持续性与债务目标可能冲突，也可能因生产率改善等共同推进；权衡依赖起点、冲击和时间。",
        "causalChain": [
          "明确政策作用渠道",
          "辨认各目标受影响方向",
          "比较短期权衡与长期协同"
        ],
        "misconceptions": [
          "目标之间的关系不是固定不变的，评价应写明条件。"
        ],
        "examApplication": [
          "先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
        ],
        "summary": [
          "增长、低失业、价格稳定、公平、可持续性与债务目标可能冲突，也可能因生产率改善等共同推进；权衡依赖起点、冲击和时间。",
          "目标之间的关系不是固定不变的，评价应写明条件。"
        ],
        "explanation": "明确政策作用渠道。辨认各目标受影响方向。比较短期权衡与长期协同。\n\n### 原创情境与推导\n\n原创例：扩张财政在负缺口时可增加就业，在满产时却更易推升物价。教育支出增加短期赤字，但若有效提高生产率，也可能扩大长期税基。不能仅凭一个目标改善就判定政策成功。\n\n目标之间的关系不是固定不变的，评价应写明条件。\n\n先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
      },
      "en": {
        "id": "u3-32-objective-conflicts",
        "locale": "en",
        "title": "Conflicts and complementarities among objectives",
        "takeaway": "Growth, low unemployment, price stability, equity, sustainability and debt objectives can conflict or complement one another. Trade-offs depend on starting conditions, shocks and time horizons.",
        "definition": "Growth, low unemployment, price stability, equity, sustainability and debt objectives can conflict or complement one another. Trade-offs depend on starting conditions, shocks and time horizons.",
        "causalChain": [
          "Specify the policy channel",
          "identify effects on each objective",
          "compare short-run trade-offs with long-run complementarities"
        ],
        "misconceptions": [
          "Relationships between objectives are not fixed; state the conditions in evaluation."
        ],
        "examApplication": [
          "Define and measure objectives before analysing causes, stakeholders and conflicts."
        ],
        "summary": [
          "Growth, low unemployment, price stability, equity, sustainability and debt objectives can conflict or complement one another. Trade-offs depend on starting conditions, shocks and time horizons.",
          "Relationships between objectives are not fixed; state the conditions in evaluation."
        ],
        "explanation": "Specify the policy channel.  identify effects on each objective.  compare short-run trade-offs with long-run complementarities.\n\n### Original scenario and reasoning\n\nIllustrative example: fiscal expansion can raise employment in a negative gap but more readily raise prices at capacity. Education spending increases the short-run deficit yet may expand the future tax base if it improves productivity. One improved objective alone does not establish success.\n\nRelationships between objectives are not fixed; state the conditions in evaluation.\n\nDefine and measure objectives before analysing causes, stakeholders and conflicts."
      }
    },
    "practice": [
      {
        "id": "u3-32-objective-conflicts-flash-1",
        "knowledgePointId": "u3-32-objective-conflicts",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“宏观目标的冲突与协同”，并说明一个关键条件。",
          "en": "Explain Conflicts and complementarities among objectives and state one important condition."
        },
        "answer": {
          "zh-CN": "增长、低失业、价格稳定、公平、可持续性与债务目标可能冲突，也可能因生产率改善等共同推进；权衡依赖起点、冲击和时间。",
          "en": "Growth, low unemployment, price stability, equity, sustainability and debt objectives can conflict or complement one another. Trade-offs depend on starting conditions, shocks and time horizons."
        },
        "explanation": {
          "zh-CN": "目标之间的关系不是固定不变的，评价应写明条件。",
          "en": "Relationships between objectives are not fixed; state the conditions in evaluation."
        }
      },
      {
        "id": "u3-32-objective-conflicts-mcq-1",
        "knowledgePointId": "u3-32-objective-conflicts",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪种政策更可能同时提高潜力并缓解长期物价压力？",
          "en": "Which may raise capacity while easing long-run price pressure?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "满产时只增加名义需求",
            "en": "Only more nominal demand at capacity"
          },
          {
            "id": "b",
            "zh-CN": "永久降低全部技能",
            "en": "Permanently reducing skills"
          },
          {
            "id": "c",
            "zh-CN": "任意放弃成本评估",
            "en": "Abandoning cost assessment"
          },
          {
            "id": "d",
            "zh-CN": "有效提高生产率的投资",
            "en": "Effective productivity-enhancing investment"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "有效提高生产率的投资。 明确政策作用渠道；辨认各目标受影响方向；比较短期权衡与长期协同 目标之间的关系不是固定不变的，评价应写明条件。",
          "en": "Effective productivity-enhancing investment. Specify the policy channel; identify effects on each objective; compare short-run trade-offs with long-run complementarities Relationships between objectives are not fixed; state the conditions in evaluation."
        }
      },
      {
        "id": "u3-32-objective-conflicts-short-1",
        "knowledgePointId": "u3-32-objective-conflicts",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释宏观目标的冲突与协同的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Conflicts and complementarities among objectives and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "增长、低失业、价格稳定、公平、可持续性与债务目标可能冲突，也可能因生产率改善等共同推进；权衡依赖起点、冲击和时间。 明确政策作用渠道；辨认各目标受影响方向；比较短期权衡与长期协同 原创例：扩张财政在负缺口时可增加就业，在满产时却更易推升物价。教育支出增加短期赤字，但若有效提高生产率，也可能扩大长期税基。不能仅凭一个目标改善就判定政策成功。",
          "en": "Growth, low unemployment, price stability, equity, sustainability and debt objectives can conflict or complement one another. Trade-offs depend on starting conditions, shocks and time horizons. Specify the policy channel; identify effects on each objective; compare short-run trade-offs with long-run complementarities Illustrative example: fiscal expansion can raise employment in a negative gap but more readily raise prices at capacity. Education spending increases the short-run deficit yet may expand the future tax base if it improves productivity. One improved objective alone does not establish success."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "目标",
              "en": "objectives"
            },
            "alternatives": {
              "zh-CN": [
                "目标",
                "明确政策作用渠道"
              ],
              "en": [
                "objectives",
                "Specify the policy channel"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "短期",
              "en": "short run"
            },
            "alternatives": {
              "zh-CN": [
                "短期",
                "辨认各目标受影响方向"
              ],
              "en": [
                "short run",
                "identify effects on each objective"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "生产率",
              "en": "productivity"
            },
            "alternatives": {
              "zh-CN": [
                "生产率",
                "比较短期权衡与长期协同"
              ],
              "en": [
                "productivity",
                "compare short-run trade-offs with long-run complementarities"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-33-poverty",
      "slug": "poverty",
      "section": "3.4",
      "level": "core",
      "syllabusRefs": [
        "3.4 Economics of inequality and poverty"
      ],
      "textbookRefs": [
        {
          "chapter": "12",
          "section": "12.2",
          "pages": [
            359
          ]
        }
      ],
      "prerequisites": [
        "u1-35-equality-equity"
      ],
      "related": [
        "u3-34-inequality-causes",
        "u3-35-lorenz-gini",
        "u3-36-poverty-effects"
      ],
      "terms": [
        "绝对贫困与相对贫困",
        "Absolute and relative poverty",
        "基本需要",
        "basic needs",
        "中位收入",
        "median income",
        "相对",
        "relative"
      ],
      "synonyms": {
        "zh-CN": [
          "基本需要",
          "中位收入",
          "相对"
        ],
        "en": [
          "basic needs",
          "median income",
          "relative"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-33-poverty-flash-1",
        "u3-33-poverty-mcq-1",
        "u3-33-poverty-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-33-poverty",
        "locale": "zh-CN",
        "title": "绝对贫困与相对贫困",
        "takeaway": "绝对贫困依据满足基本需要的最低资源标准，相对贫困依据本社会典型收入或生活标准；两者回答不同问题。",
        "definition": "绝对贫困依据满足基本需要的最低资源标准，相对贫困依据本社会典型收入或生活标准；两者回答不同问题。",
        "causalChain": [
          "选择明确的贫困标准",
          "比较家庭资源和需求",
          "区分基本匮乏与社会相对排斥"
        ],
        "misconceptions": [
          "贫困与不平等相关，但不相同：所有人同样贫穷也可很平等。"
        ],
        "examApplication": [
          "区分收入、财富、贫困与不平等，评价针对性、激励与公平标准。"
        ],
        "summary": [
          "绝对贫困依据满足基本需要的最低资源标准，相对贫困依据本社会典型收入或生活标准；两者回答不同问题。",
          "贫困与不平等相关，但不相同：所有人同样贫穷也可很平等。"
        ],
        "explanation": "选择明确的贫困标准。比较家庭资源和需求。区分基本匮乏与社会相对排斥。\n\n### 原创情境与推导\n\n原创例：一社会中位收入上升，某家庭实际收入不变，可能相对位置下降，却不意味着购买基本食物的能力必然变差。贫困线需要考虑物价、家庭规模和公共服务，不宜把某个过时金额当作永恒标准。\n\n贫困与不平等相关，但不相同：所有人同样贫穷也可很平等。\n\n区分收入、财富、贫困与不平等，评价针对性、激励与公平标准。"
      },
      "en": {
        "id": "u3-33-poverty",
        "locale": "en",
        "title": "Absolute and relative poverty",
        "takeaway": "Absolute poverty uses a minimum-resource standard for basic needs; relative poverty compares resources with typical living standards in a society. They answer different questions.",
        "definition": "Absolute poverty uses a minimum-resource standard for basic needs; relative poverty compares resources with typical living standards in a society. They answer different questions.",
        "causalChain": [
          "Choose an explicit poverty standard",
          "compare household resources and needs",
          "distinguish basic deprivation from relative social exclusion"
        ],
        "misconceptions": [
          "Poverty and inequality are related but distinct: everyone can be equally poor."
        ],
        "examApplication": [
          "Distinguish income, wealth, poverty and inequality; evaluate targeting, incentives and equity criteria."
        ],
        "summary": [
          "Absolute poverty uses a minimum-resource standard for basic needs; relative poverty compares resources with typical living standards in a society. They answer different questions.",
          "Poverty and inequality are related but distinct: everyone can be equally poor."
        ],
        "explanation": "Choose an explicit poverty standard.  compare household resources and needs.  distinguish basic deprivation from relative social exclusion.\n\n### Original scenario and reasoning\n\nIllustrative example: median income rises while a household's real income stays unchanged. Its relative position may worsen without necessarily losing the ability to buy basic food. Poverty thresholds depend on prices, household size and public services; an old monetary threshold is not timeless.\n\nPoverty and inequality are related but distinct: everyone can be equally poor.\n\nDistinguish income, wealth, poverty and inequality; evaluate targeting, incentives and equity criteria."
      }
    },
    "practice": [
      {
        "id": "u3-33-poverty-flash-1",
        "knowledgePointId": "u3-33-poverty",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“绝对贫困与相对贫困”，并说明一个关键条件。",
          "en": "Explain Absolute and relative poverty and state one important condition."
        },
        "answer": {
          "zh-CN": "绝对贫困依据满足基本需要的最低资源标准，相对贫困依据本社会典型收入或生活标准；两者回答不同问题。",
          "en": "Absolute poverty uses a minimum-resource standard for basic needs; relative poverty compares resources with typical living standards in a society. They answer different questions."
        },
        "explanation": {
          "zh-CN": "贫困与不平等相关，但不相同：所有人同样贫穷也可很平等。",
          "en": "Poverty and inequality are related but distinct: everyone can be equally poor."
        }
      },
      {
        "id": "u3-33-poverty-mcq-1",
        "knowledgePointId": "u3-33-poverty",
        "type": "mcq",
        "prompt": {
          "zh-CN": "按中位收入一定比例界定贫困，属于哪类？",
          "en": "A threshold defined as a share of median income measures which poverty?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "相对贫困",
            "en": "Relative poverty"
          },
          {
            "id": "b",
            "zh-CN": "只可能是绝对贫困",
            "en": "Only absolute poverty"
          },
          {
            "id": "c",
            "zh-CN": "仅衡量通胀",
            "en": "Only inflation"
          },
          {
            "id": "d",
            "zh-CN": "与收入无关",
            "en": "Unrelated to income"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "相对贫困。 选择明确的贫困标准；比较家庭资源和需求；区分基本匮乏与社会相对排斥 贫困与不平等相关，但不相同：所有人同样贫穷也可很平等。",
          "en": "Relative poverty. Choose an explicit poverty standard; compare household resources and needs; distinguish basic deprivation from relative social exclusion Poverty and inequality are related but distinct: everyone can be equally poor."
        }
      },
      {
        "id": "u3-33-poverty-short-1",
        "knowledgePointId": "u3-33-poverty",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释绝对贫困与相对贫困的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Absolute and relative poverty and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "绝对贫困依据满足基本需要的最低资源标准，相对贫困依据本社会典型收入或生活标准；两者回答不同问题。 选择明确的贫困标准；比较家庭资源和需求；区分基本匮乏与社会相对排斥 原创例：一社会中位收入上升，某家庭实际收入不变，可能相对位置下降，却不意味着购买基本食物的能力必然变差。贫困线需要考虑物价、家庭规模和公共服务，不宜把某个过时金额当作永恒标准。",
          "en": "Absolute poverty uses a minimum-resource standard for basic needs; relative poverty compares resources with typical living standards in a society. They answer different questions. Choose an explicit poverty standard; compare household resources and needs; distinguish basic deprivation from relative social exclusion Illustrative example: median income rises while a household's real income stays unchanged. Its relative position may worsen without necessarily losing the ability to buy basic food. Poverty thresholds depend on prices, household size and public services; an old monetary threshold is not timeless."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "基本需要",
              "en": "basic needs"
            },
            "alternatives": {
              "zh-CN": [
                "基本需要",
                "选择明确的贫困标准"
              ],
              "en": [
                "basic needs",
                "Choose an explicit poverty standard"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "中位收入",
              "en": "median income"
            },
            "alternatives": {
              "zh-CN": [
                "中位收入",
                "比较家庭资源和需求"
              ],
              "en": [
                "median income",
                "compare household resources and needs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "相对",
              "en": "relative"
            },
            "alternatives": {
              "zh-CN": [
                "相对",
                "区分基本匮乏与社会相对排斥"
              ],
              "en": [
                "relative",
                "distinguish basic deprivation from relative social exclusion"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-34-inequality-causes",
      "slug": "inequality-causes",
      "section": "3.4",
      "level": "core",
      "syllabusRefs": [
        "3.4 Economics of inequality and poverty"
      ],
      "textbookRefs": [
        {
          "chapter": "12",
          "section": "12.3",
          "pages": [
            365
          ]
        }
      ],
      "prerequisites": [
        "u1-35-equality-equity"
      ],
      "related": [
        "u3-33-poverty",
        "u3-35-lorenz-gini",
        "u3-36-poverty-effects"
      ],
      "terms": [
        "不平等与贫困的成因",
        "Causes of inequality and poverty",
        "机会",
        "opportunity",
        "教育",
        "education",
        "收入",
        "income"
      ],
      "synonyms": {
        "zh-CN": [
          "机会",
          "教育",
          "收入"
        ],
        "en": [
          "opportunity",
          "education",
          "income"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-34-inequality-causes-flash-1",
        "u3-34-inequality-causes-mcq-1",
        "u3-34-inequality-causes-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-34-inequality-causes",
        "locale": "zh-CN",
        "title": "不平等与贫困的成因",
        "takeaway": "资产、教育、健康、歧视、制度、地区机会与失业共同影响收入和财富；贫困可能限制人力资本投入并跨代持续。",
        "definition": "资产、教育、健康、歧视、制度、地区机会与失业共同影响收入和财富；贫困可能限制人力资本投入并跨代持续。",
        "causalChain": [
          "初始资源与机会不同",
          "技能和收入积累出现差异",
          "收入不足又限制下一轮教育和健康投入"
        ],
        "misconceptions": [
          "收入差异不能仅凭表面相关性归因于某一个因素。"
        ],
        "examApplication": [
          "区分收入、财富、贫困与不平等，评价针对性、激励与公平标准。"
        ],
        "summary": [
          "资产、教育、健康、歧视、制度、地区机会与失业共同影响收入和财富；贫困可能限制人力资本投入并跨代持续。",
          "收入差异不能仅凭表面相关性归因于某一个因素。"
        ],
        "explanation": "初始资源与机会不同。技能和收入积累出现差异。收入不足又限制下一轮教育和健康投入。\n\n### 原创情境与推导\n\n原创例：家庭缺乏交通和数字设备，孩子难以参加培训，未来就业受限。这种机制不是把结果归因于个人意愿。政策需识别信贷、信息、服务供给与歧视等具体障碍。\n\n收入差异不能仅凭表面相关性归因于某一个因素。\n\n区分收入、财富、贫困与不平等，评价针对性、激励与公平标准。"
      },
      "en": {
        "id": "u3-34-inequality-causes",
        "locale": "en",
        "title": "Causes of inequality and poverty",
        "takeaway": "Assets, education, health, discrimination, institutions, regional opportunity and unemployment shape income and wealth. Poverty can limit human-capital investment and persist across generations.",
        "definition": "Assets, education, health, discrimination, institutions, regional opportunity and unemployment shape income and wealth. Poverty can limit human-capital investment and persist across generations.",
        "causalChain": [
          "Initial resources and opportunities differ",
          "skills and incomes accumulate unequally",
          "low income then limits further education and health investment"
        ],
        "misconceptions": [
          "Observed income differences cannot be attributed to one cause from correlation alone."
        ],
        "examApplication": [
          "Distinguish income, wealth, poverty and inequality; evaluate targeting, incentives and equity criteria."
        ],
        "summary": [
          "Assets, education, health, discrimination, institutions, regional opportunity and unemployment shape income and wealth. Poverty can limit human-capital investment and persist across generations.",
          "Observed income differences cannot be attributed to one cause from correlation alone."
        ],
        "explanation": "Initial resources and opportunities differ.  skills and incomes accumulate unequally.  low income then limits further education and health investment.\n\n### Original scenario and reasoning\n\nIllustrative example: missing transport and digital access restrict a child's training and future employment. This mechanism does not reduce outcomes to personal motivation. Policy should identify credit, information, service-supply and discrimination barriers.\n\nObserved income differences cannot be attributed to one cause from correlation alone.\n\nDistinguish income, wealth, poverty and inequality; evaluate targeting, incentives and equity criteria."
      }
    },
    "practice": [
      {
        "id": "u3-34-inequality-causes-flash-1",
        "knowledgePointId": "u3-34-inequality-causes",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“不平等与贫困的成因”，并说明一个关键条件。",
          "en": "Explain Causes of inequality and poverty and state one important condition."
        },
        "answer": {
          "zh-CN": "资产、教育、健康、歧视、制度、地区机会与失业共同影响收入和财富；贫困可能限制人力资本投入并跨代持续。",
          "en": "Assets, education, health, discrimination, institutions, regional opportunity and unemployment shape income and wealth. Poverty can limit human-capital investment and persist across generations."
        },
        "explanation": {
          "zh-CN": "收入差异不能仅凭表面相关性归因于某一个因素。",
          "en": "Observed income differences cannot be attributed to one cause from correlation alone."
        }
      },
      {
        "id": "u3-34-inequality-causes-mcq-1",
        "knowledgePointId": "u3-34-inequality-causes",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪个机制可使贫困跨代持续？",
          "en": "Which mechanism can perpetuate poverty across generations?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "贫困必然提高全部技能",
            "en": "Poverty necessarily improves all skills"
          },
          {
            "id": "b",
            "zh-CN": "低收入限制教育投资并压低未来收入",
            "en": "Low income limits education investment and future earnings"
          },
          {
            "id": "c",
            "zh-CN": "资源差异完全不存在",
            "en": "Resource differences do not exist"
          },
          {
            "id": "d",
            "zh-CN": "只有价格水平决定技能",
            "en": "Only the price level determines skills"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "低收入限制教育投资并压低未来收入。 初始资源与机会不同；技能和收入积累出现差异；收入不足又限制下一轮教育和健康投入 收入差异不能仅凭表面相关性归因于某一个因素。",
          "en": "Low income limits education investment and future earnings. Initial resources and opportunities differ; skills and incomes accumulate unequally; low income then limits further education and health investment Observed income differences cannot be attributed to one cause from correlation alone."
        }
      },
      {
        "id": "u3-34-inequality-causes-short-1",
        "knowledgePointId": "u3-34-inequality-causes",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释不平等与贫困的成因的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Causes of inequality and poverty and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "资产、教育、健康、歧视、制度、地区机会与失业共同影响收入和财富；贫困可能限制人力资本投入并跨代持续。 初始资源与机会不同；技能和收入积累出现差异；收入不足又限制下一轮教育和健康投入 原创例：家庭缺乏交通和数字设备，孩子难以参加培训，未来就业受限。这种机制不是把结果归因于个人意愿。政策需识别信贷、信息、服务供给与歧视等具体障碍。",
          "en": "Assets, education, health, discrimination, institutions, regional opportunity and unemployment shape income and wealth. Poverty can limit human-capital investment and persist across generations. Initial resources and opportunities differ; skills and incomes accumulate unequally; low income then limits further education and health investment Illustrative example: missing transport and digital access restrict a child's training and future employment. This mechanism does not reduce outcomes to personal motivation. Policy should identify credit, information, service-supply and discrimination barriers."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "机会",
              "en": "opportunity"
            },
            "alternatives": {
              "zh-CN": [
                "机会",
                "初始资源与机会不同"
              ],
              "en": [
                "opportunity",
                "Initial resources and opportunities differ"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "教育",
              "en": "education"
            },
            "alternatives": {
              "zh-CN": [
                "教育",
                "技能和收入积累出现差异"
              ],
              "en": [
                "education",
                "skills and incomes accumulate unequally"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "收入",
              "en": "income"
            },
            "alternatives": {
              "zh-CN": [
                "收入",
                "收入不足又限制下一轮教育和健康投入"
              ],
              "en": [
                "income",
                "low income then limits further education and health investment"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-35-lorenz-gini",
      "slug": "lorenz-gini",
      "section": "3.4",
      "level": "core",
      "syllabusRefs": [
        "3.4 Economics of inequality and poverty"
      ],
      "textbookRefs": [
        {
          "chapter": "12",
          "section": "12.1",
          "pages": [
            353
          ]
        }
      ],
      "prerequisites": [
        "u1-35-equality-equity"
      ],
      "related": [
        "u3-33-poverty",
        "u3-34-inequality-causes",
        "u3-36-poverty-effects"
      ],
      "terms": [
        "洛伦兹曲线与 Gini 系数",
        "Lorenz curves and the Gini coefficient",
        "累计",
        "cumulative",
        "面积",
        "area",
        "平等线",
        "equality line"
      ],
      "synonyms": {
        "zh-CN": [
          "累计",
          "面积",
          "平等线"
        ],
        "en": [
          "cumulative",
          "area",
          "equality line"
        ]
      },
      "diagramIds": [
        "macro-lorenz"
      ],
      "quizIds": [
        "u3-35-lorenz-gini-flash-1",
        "u3-35-lorenz-gini-mcq-1",
        "u3-35-lorenz-gini-short-1",
        "u3-35-lorenz-gini-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-35-lorenz-gini",
        "locale": "zh-CN",
        "hlExtension": "原创例：横纵轴用 0 到 1 表示，平等线下面积为 0.5。若洛伦兹曲线下方面积为 0.3，Gini=(0.5−0.3)/0.5=0.4。曲线交叉时，不同分配变化不能只凭一处距离判断整体排名。 HL 构造：五等分收入份额为 5%、10%、15%、25%、45% 时，累计人口 0、20、40、60、80、100% 对应累计收入 0、5、15、30、55、100%。连接相邻点并画平等线；若分段线性，梯形法近似 Gini=0.38。",
        "title": "洛伦兹曲线与 Gini 系数",
        "takeaway": "洛伦兹曲线按从贫到富排列人口累计占比及收入累计占比；基尼系数为平等线与曲线间面积占平等线下总面积的比例。",
        "definition": "洛伦兹曲线按从贫到富排列人口累计占比及收入累计占比；基尼系数为平等线与曲线间面积占平等线下总面积的比例。",
        "causalChain": [
          "按收入排序并累计份额",
          "与完全平等线比较",
          "面积差越大通常表示收入不平等越高"
        ],
        "misconceptions": [
          "收入基尼不直接等于财富基尼，也不显示绝对贫困人数。"
        ],
        "examApplication": [
          "区分收入、财富、贫困与不平等，评价针对性、激励与公平标准。"
        ],
        "summary": [
          "洛伦兹曲线按从贫到富排列人口累计占比及收入累计占比；基尼系数为平等线与曲线间面积占平等线下总面积的比例。",
          "收入基尼不直接等于财富基尼，也不显示绝对贫困人数。"
        ],
        "explanation": "按收入排序并累计份额。与完全平等线比较。面积差越大通常表示收入不平等越高。\n\n### 原创情境与推导\n\n原创例：人口按从穷到富排列，洛伦兹曲线越偏离平等线，通常表示收入分配越不均。Gini 越接近 0 越平等，越接近 1 越不平等；相交曲线不能只凭局部距离排序。由五等分数据构造曲线属于 HL。\n\n收入基尼不直接等于财富基尼，也不显示绝对贫困人数。\n\n区分收入、财富、贫困与不平等，评价针对性、激励与公平标准。"
      },
      "en": {
        "id": "u3-35-lorenz-gini",
        "locale": "en",
        "hlExtension": "Illustrative example: with both axes from zero to one, equality has area 0.5. If the area under Lorenz is 0.3, Gini=(0.5−0.3)/0.5=0.4. Crossing Lorenz curves cannot be ranked by a single local distance. HL construction: quintile shares of 5%, 10%, 15%, 25%, 45% give cumulative income shares 0%, 5%, 15%, 30%, 55%, 100% at population shares 0%, 20%, 40%, 60%, 80%, 100%. Join adjacent points and draw equality. Piecewise-linear trapezoids give approximate Gini 0.38.",
        "title": "Lorenz curves and the Gini coefficient",
        "takeaway": "A Lorenz curve plots cumulative income shares against cumulative population ranked poorest to richest. Gini is the area between the equality line and Lorenz curve divided by total area under equality.",
        "definition": "A Lorenz curve plots cumulative income shares against cumulative population ranked poorest to richest. Gini is the area between the equality line and Lorenz curve divided by total area under equality.",
        "causalChain": [
          "Rank incomes and cumulate shares",
          "compare with perfect equality",
          "a larger area gap normally indicates more inequality"
        ],
        "misconceptions": [
          "An income Gini is not a wealth Gini and does not directly count absolute poverty."
        ],
        "examApplication": [
          "Distinguish income, wealth, poverty and inequality; evaluate targeting, incentives and equity criteria."
        ],
        "summary": [
          "A Lorenz curve plots cumulative income shares against cumulative population ranked poorest to richest. Gini is the area between the equality line and Lorenz curve divided by total area under equality.",
          "An income Gini is not a wealth Gini and does not directly count absolute poverty."
        ],
        "explanation": "Rank incomes and cumulate shares.  compare with perfect equality.  a larger area gap normally indicates more inequality.\n\n### Original scenario and reasoning\n\nIllustrative example: rank the population from poorest to richest. A Lorenz curve further below equality normally indicates greater inequality. Gini closer to zero means more equality and closer to one more inequality; crossing curves cannot be ranked by one local distance. Constructing the curve from quintile data is HL.\n\nAn income Gini is not a wealth Gini and does not directly count absolute poverty.\n\nDistinguish income, wealth, poverty and inequality; evaluate targeting, incentives and equity criteria."
      }
    },
    "practice": [
      {
        "id": "u3-35-lorenz-gini-flash-1",
        "knowledgePointId": "u3-35-lorenz-gini",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“洛伦兹曲线与 Gini 系数”，并说明一个关键条件。",
          "en": "Explain Lorenz curves and the Gini coefficient and state one important condition."
        },
        "answer": {
          "zh-CN": "洛伦兹曲线按从贫到富排列人口累计占比及收入累计占比；基尼系数为平等线与曲线间面积占平等线下总面积的比例。",
          "en": "A Lorenz curve plots cumulative income shares against cumulative population ranked poorest to richest. Gini is the area between the equality line and Lorenz curve divided by total area under equality."
        },
        "explanation": {
          "zh-CN": "收入基尼不直接等于财富基尼，也不显示绝对贫困人数。",
          "en": "An income Gini is not a wealth Gini and does not directly count absolute poverty."
        }
      },
      {
        "id": "u3-35-lorenz-gini-mcq-1",
        "knowledgePointId": "u3-35-lorenz-gini",
        "type": "mcq",
        "prompt": {
          "zh-CN": "Gini 从 0.3 升到 0.4，通常表示什么？",
          "en": "What does a rise in Gini from 0.3 to 0.4 normally indicate?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "分配变得完全平等",
            "en": "Perfect income equality"
          },
          {
            "id": "b",
            "zh-CN": "收入总量必定下降",
            "en": "Total income must fall"
          },
          {
            "id": "c",
            "zh-CN": "收入分配更不平等",
            "en": "Greater income inequality"
          },
          {
            "id": "d",
            "zh-CN": "贫困率必定等于 40%",
            "en": "Poverty must equal 40%"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "收入分配更不平等。 按收入排序并累计份额；与完全平等线比较；面积差越大通常表示收入不平等越高 收入基尼不直接等于财富基尼，也不显示绝对贫困人数。",
          "en": "Greater income inequality. Rank incomes and cumulate shares; compare with perfect equality; a larger area gap normally indicates more inequality An income Gini is not a wealth Gini and does not directly count absolute poverty."
        }
      },
      {
        "id": "u3-35-lorenz-gini-short-1",
        "knowledgePointId": "u3-35-lorenz-gini",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释洛伦兹曲线与 Gini 系数的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Lorenz curves and the Gini coefficient and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "洛伦兹曲线按从贫到富排列人口累计占比及收入累计占比；基尼系数为平等线与曲线间面积占平等线下总面积的比例。 按收入排序并累计份额；与完全平等线比较；面积差越大通常表示收入不平等越高 原创例：人口按从穷到富排列，洛伦兹曲线越偏离平等线，通常表示收入分配越不均。Gini 越接近 0 越平等，越接近 1 越不平等；相交曲线不能只凭局部距离排序。由五等分数据构造曲线属于 HL。",
          "en": "A Lorenz curve plots cumulative income shares against cumulative population ranked poorest to richest. Gini is the area between the equality line and Lorenz curve divided by total area under equality. Rank incomes and cumulate shares; compare with perfect equality; a larger area gap normally indicates more inequality Illustrative example: rank the population from poorest to richest. A Lorenz curve further below equality normally indicates greater inequality. Gini closer to zero means more equality and closer to one more inequality; crossing curves cannot be ranked by one local distance. Constructing the curve from quintile data is HL."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "累计",
              "en": "cumulative"
            },
            "alternatives": {
              "zh-CN": [
                "累计",
                "按收入排序并累计份额"
              ],
              "en": [
                "cumulative",
                "Rank incomes and cumulate shares"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "面积",
              "en": "area"
            },
            "alternatives": {
              "zh-CN": [
                "面积",
                "与完全平等线比较"
              ],
              "en": [
                "area",
                "compare with perfect equality"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "平等线",
              "en": "equality line"
            },
            "alternatives": {
              "zh-CN": [
                "平等线",
                "面积差越大通常表示收入不平等越高"
              ],
              "en": [
                "equality line",
                "a larger area gap normally indicates more inequality"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u3-35-lorenz-gini-mcq-hl-1",
        "knowledgePointId": "u3-35-lorenz-gini",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "平等线下 0.5、洛伦兹下 0.35，Gini 为多少？",
          "en": "Equality area is 0.5 and Lorenz area 0.35. What is Gini?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "0.15",
            "en": "0.15"
          },
          {
            "id": "b",
            "zh-CN": "0.7",
            "en": "0.7"
          },
          {
            "id": "c",
            "zh-CN": "0.85",
            "en": "0.85"
          },
          {
            "id": "d",
            "zh-CN": "0.3",
            "en": "0.3"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "0.3。 (0.5 − 0.35) / 0.5 = 0.3",
          "en": "0.3. (0.5 − 0.35) / 0.5 = 0.3"
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-36-poverty-effects",
      "slug": "poverty-effects",
      "section": "3.4",
      "level": "core",
      "syllabusRefs": [
        "3.4 Economics of inequality and poverty"
      ],
      "textbookRefs": [
        {
          "chapter": "12",
          "section": "12.4",
          "pages": [
            369
          ]
        }
      ],
      "prerequisites": [
        "u1-35-equality-equity"
      ],
      "related": [
        "u3-33-poverty",
        "u3-34-inequality-causes",
        "u3-35-lorenz-gini"
      ],
      "terms": [
        "不平等与贫困的影响",
        "Effects of inequality and poverty",
        "健康",
        "health",
        "人力资本",
        "human capital",
        "生产率",
        "productivity"
      ],
      "synonyms": {
        "zh-CN": [
          "健康",
          "人力资本",
          "生产率"
        ],
        "en": [
          "health",
          "human capital",
          "productivity"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-36-poverty-effects-flash-1",
        "u3-36-poverty-effects-mcq-1",
        "u3-36-poverty-effects-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-36-poverty-effects",
        "locale": "zh-CN",
        "title": "不平等与贫困的影响",
        "takeaway": "贫困可损害健康、教育与生产率；高不平等可削弱机会与社会信任，但某些回报差异也提供工作和创新激励。",
        "definition": "贫困可损害健康、教育与生产率；高不平等可削弱机会与社会信任，但某些回报差异也提供工作和创新激励。",
        "causalChain": [
          "资源匮乏影响服务获得",
          "人力资本和社会参与受损",
          "未来生产与税基可能因此减弱"
        ],
        "misconceptions": [
          "效率与公平并非在所有政策下都必然冲突。"
        ],
        "examApplication": [
          "区分收入、财富、贫困与不平等，评价针对性、激励与公平标准。"
        ],
        "summary": [
          "贫困可损害健康、教育与生产率；高不平等可削弱机会与社会信任，但某些回报差异也提供工作和创新激励。",
          "效率与公平并非在所有政策下都必然冲突。"
        ],
        "explanation": "资源匮乏影响服务获得。人力资本和社会参与受损。未来生产与税基可能因此减弱。\n\n### 原创情境与推导\n\n原创例：营养不足影响学习与成年劳动能力，公共健康和学校供餐可能打断循环。评价收入差距时须区分机会不平等、激励作用与寻租收益，避免把所有差异视为同一种现象。\n\n效率与公平并非在所有政策下都必然冲突。\n\n区分收入、财富、贫困与不平等，评价针对性、激励与公平标准。"
      },
      "en": {
        "id": "u3-36-poverty-effects",
        "locale": "en",
        "title": "Effects of inequality and poverty",
        "takeaway": "Poverty can damage health, education and productivity. High inequality can weaken opportunity and social trust, while some differences in returns can also incentivise work and innovation.",
        "definition": "Poverty can damage health, education and productivity. High inequality can weaken opportunity and social trust, while some differences in returns can also incentivise work and innovation.",
        "causalChain": [
          "Resource deprivation limits service access",
          "human capital and participation suffer",
          "future production and the tax base may weaken"
        ],
        "misconceptions": [
          "Efficiency and equity need not conflict under every policy."
        ],
        "examApplication": [
          "Distinguish income, wealth, poverty and inequality; evaluate targeting, incentives and equity criteria."
        ],
        "summary": [
          "Poverty can damage health, education and productivity. High inequality can weaken opportunity and social trust, while some differences in returns can also incentivise work and innovation.",
          "Efficiency and equity need not conflict under every policy."
        ],
        "explanation": "Resource deprivation limits service access.  human capital and participation suffer.  future production and the tax base may weaken.\n\n### Original scenario and reasoning\n\nIllustrative example: malnutrition harms learning and adult work capacity; public health and school meals may interrupt the cycle. Assess income gaps by distinguishing opportunity inequality, incentives and rent extraction rather than treating all differences alike.\n\nEfficiency and equity need not conflict under every policy.\n\nDistinguish income, wealth, poverty and inequality; evaluate targeting, incentives and equity criteria."
      }
    },
    "practice": [
      {
        "id": "u3-36-poverty-effects-flash-1",
        "knowledgePointId": "u3-36-poverty-effects",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“不平等与贫困的影响”，并说明一个关键条件。",
          "en": "Explain Effects of inequality and poverty and state one important condition."
        },
        "answer": {
          "zh-CN": "贫困可损害健康、教育与生产率；高不平等可削弱机会与社会信任，但某些回报差异也提供工作和创新激励。",
          "en": "Poverty can damage health, education and productivity. High inequality can weaken opportunity and social trust, while some differences in returns can also incentivise work and innovation."
        },
        "explanation": {
          "zh-CN": "效率与公平并非在所有政策下都必然冲突。",
          "en": "Efficiency and equity need not conflict under every policy."
        }
      },
      {
        "id": "u3-36-poverty-effects-mcq-1",
        "knowledgePointId": "u3-36-poverty-effects",
        "type": "mcq",
        "prompt": {
          "zh-CN": "改善贫困儿童营养为何可能同时改善效率？",
          "en": "Why can better nutrition for poor children also improve efficiency?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "消除全部资源成本",
            "en": "Removes all resource costs"
          },
          {
            "id": "b",
            "zh-CN": "保证所有工资相同",
            "en": "Guarantees identical wages"
          },
          {
            "id": "c",
            "zh-CN": "只增加名义物价",
            "en": "Only raises nominal prices"
          },
          {
            "id": "d",
            "zh-CN": "改善健康、学习与未来生产率",
            "en": "Improves health, learning and future productivity"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "改善健康、学习与未来生产率。 资源匮乏影响服务获得；人力资本和社会参与受损；未来生产与税基可能因此减弱 效率与公平并非在所有政策下都必然冲突。",
          "en": "Improves health, learning and future productivity. Resource deprivation limits service access; human capital and participation suffer; future production and the tax base may weaken Efficiency and equity need not conflict under every policy."
        }
      },
      {
        "id": "u3-36-poverty-effects-short-1",
        "knowledgePointId": "u3-36-poverty-effects",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释不平等与贫困的影响的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Effects of inequality and poverty and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "贫困可损害健康、教育与生产率；高不平等可削弱机会与社会信任，但某些回报差异也提供工作和创新激励。 资源匮乏影响服务获得；人力资本和社会参与受损；未来生产与税基可能因此减弱 原创例：营养不足影响学习与成年劳动能力，公共健康和学校供餐可能打断循环。评价收入差距时须区分机会不平等、激励作用与寻租收益，避免把所有差异视为同一种现象。",
          "en": "Poverty can damage health, education and productivity. High inequality can weaken opportunity and social trust, while some differences in returns can also incentivise work and innovation. Resource deprivation limits service access; human capital and participation suffer; future production and the tax base may weaken Illustrative example: malnutrition harms learning and adult work capacity; public health and school meals may interrupt the cycle. Assess income gaps by distinguishing opportunity inequality, incentives and rent extraction rather than treating all differences alike."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "健康",
              "en": "health"
            },
            "alternatives": {
              "zh-CN": [
                "健康",
                "资源匮乏影响服务获得"
              ],
              "en": [
                "health",
                "Resource deprivation limits service access"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "人力资本",
              "en": "human capital"
            },
            "alternatives": {
              "zh-CN": [
                "人力资本",
                "人力资本和社会参与受损"
              ],
              "en": [
                "human capital",
                "human capital and participation suffer"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "生产率",
              "en": "productivity"
            },
            "alternatives": {
              "zh-CN": [
                "生产率",
                "未来生产与税基可能因此减弱"
              ],
              "en": [
                "productivity",
                "future production and the tax base may weaken"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-37-progressive-tax",
      "slug": "progressive-tax",
      "section": "3.4",
      "level": "core",
      "syllabusRefs": [
        "3.4 Economics of inequality and poverty"
      ],
      "textbookRefs": [
        {
          "chapter": "12",
          "section": "12.5",
          "pages": [
            371
          ]
        }
      ],
      "prerequisites": [
        "u1-35-equality-equity"
      ],
      "related": [
        "u3-33-poverty",
        "u3-34-inequality-causes",
        "u3-35-lorenz-gini"
      ],
      "terms": [
        "累进税、转移支付与可支配收入",
        "Progressive taxes, transfers and disposable income",
        "平均税率",
        "average rate",
        "边际税率",
        "marginal rate",
        "可支配收入",
        "disposable income"
      ],
      "synonyms": {
        "zh-CN": [
          "平均税率",
          "边际税率",
          "可支配收入"
        ],
        "en": [
          "average rate",
          "marginal rate",
          "disposable income"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-37-progressive-tax-flash-1",
        "u3-37-progressive-tax-mcq-1",
        "u3-37-progressive-tax-short-1",
        "u3-37-progressive-tax-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-37-progressive-tax",
        "locale": "zh-CN",
        "hlExtension": "原创例：前 100 免税，其后 100 按 20%，收入 200 的税额为 20，平均税率 10%、边际税率 20%。补助 15 后可支配收入为 195。税后分配还取决于间接税、避税和服务供给。",
        "title": "累进税、转移支付与可支配收入",
        "takeaway": "累进税的平均税率随收入提高；边际税率适用于新增收入，平均税率是税额/总收入。可支配收入为收入减直接税加转移。",
        "definition": "累进税的平均税率随收入提高；边际税率适用于新增收入，平均税率是税额/总收入。可支配收入为收入减直接税加转移。",
        "causalChain": [
          "确定各税档适用收入",
          "分段计算税额而非全部收入乘最高税率",
          "用转移和税收比较最终购买能力"
        ],
        "misconceptions": [
          "最高边际税率不应直接乘以全部收入。"
        ],
        "examApplication": [
          "区分收入、财富、贫困与不平等，评价针对性、激励与公平标准。"
        ],
        "summary": [
          "累进税的平均税率随收入提高；边际税率适用于新增收入，平均税率是税额/总收入。可支配收入为收入减直接税加转移。",
          "最高边际税率不应直接乘以全部收入。"
        ],
        "explanation": "确定各税档适用收入。分段计算税额而非全部收入乘最高税率。用转移和税收比较最终购买能力。\n\n### 原创情境与推导\n\n原创例：边际税率只适用于新增收入，不应把最高档税率乘全部收入。累进税意味着平均税率随收入上升，定向转移支付则增加合资格家庭的可支配收入。税额和平均税率的数值计算属于 HL。\n\n最高边际税率不应直接乘以全部收入。\n\n区分收入、财富、贫困与不平等，评价针对性、激励与公平标准。"
      },
      "en": {
        "id": "u3-37-progressive-tax",
        "locale": "en",
        "hlExtension": "Illustrative example: the first 100 is tax-free and the next 100 taxed at 20%. Income of 200 yields tax 20, average rate 10% and marginal rate 20%. A transfer of 15 gives disposable income 195. Indirect taxes, avoidance and services also affect distribution.",
        "title": "Progressive taxes, transfers and disposable income",
        "takeaway": "Under progressive taxation the average tax rate rises with income. The marginal rate applies to additional income; the average rate is total tax/income. Disposable income subtracts direct taxes and adds transfers.",
        "definition": "Under progressive taxation the average tax rate rises with income. The marginal rate applies to additional income; the average rate is total tax/income. Disposable income subtracts direct taxes and adds transfers.",
        "causalChain": [
          "Identify income within each bracket",
          "calculate tax progressively rather than applying the top rate to all income",
          "compare purchasing power after taxes and transfers"
        ],
        "misconceptions": [
          "Do not apply the highest marginal rate to all income."
        ],
        "examApplication": [
          "Distinguish income, wealth, poverty and inequality; evaluate targeting, incentives and equity criteria."
        ],
        "summary": [
          "Under progressive taxation the average tax rate rises with income. The marginal rate applies to additional income; the average rate is total tax/income. Disposable income subtracts direct taxes and adds transfers.",
          "Do not apply the highest marginal rate to all income."
        ],
        "explanation": "Identify income within each bracket.  calculate tax progressively rather than applying the top rate to all income.  compare purchasing power after taxes and transfers.\n\n### Original scenario and reasoning\n\nIllustrative example: a marginal rate applies to additional income, not automatically all income. Under progressive taxation the average rate rises with income; targeted transfers add to eligible households’ disposable income. Numerical tax and average-rate calculations are HL.\n\nDo not apply the highest marginal rate to all income.\n\nDistinguish income, wealth, poverty and inequality; evaluate targeting, incentives and equity criteria."
      }
    },
    "practice": [
      {
        "id": "u3-37-progressive-tax-flash-1",
        "knowledgePointId": "u3-37-progressive-tax",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“累进税、转移支付与可支配收入”，并说明一个关键条件。",
          "en": "Explain Progressive taxes, transfers and disposable income and state one important condition."
        },
        "answer": {
          "zh-CN": "累进税的平均税率随收入提高；边际税率适用于新增收入，平均税率是税额/总收入。可支配收入为收入减直接税加转移。",
          "en": "Under progressive taxation the average tax rate rises with income. The marginal rate applies to additional income; the average rate is total tax/income. Disposable income subtracts direct taxes and adds transfers."
        },
        "explanation": {
          "zh-CN": "最高边际税率不应直接乘以全部收入。",
          "en": "Do not apply the highest marginal rate to all income."
        }
      },
      {
        "id": "u3-37-progressive-tax-mcq-1",
        "knowledgePointId": "u3-37-progressive-tax",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪种情况定义了累进所得税？",
          "en": "What defines a progressive income tax?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "平均税率随收入上升",
            "en": "The average tax rate rises with income"
          },
          {
            "id": "b",
            "zh-CN": "人人支付相同税额",
            "en": "Everyone pays the same tax amount"
          },
          {
            "id": "c",
            "zh-CN": "平均税率随收入下降",
            "en": "The average tax rate falls with income"
          },
          {
            "id": "d",
            "zh-CN": "所有收入始终按同一比例征税",
            "en": "All income is always taxed at one constant rate"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "平均税率随收入上升。 确定各税档适用收入；分段计算税额而非全部收入乘最高税率；用转移和税收比较最终购买能力 最高边际税率不应直接乘以全部收入。",
          "en": "The average tax rate rises with income. Identify income within each bracket; calculate tax progressively rather than applying the top rate to all income; compare purchasing power after taxes and transfers Do not apply the highest marginal rate to all income."
        }
      },
      {
        "id": "u3-37-progressive-tax-short-1",
        "knowledgePointId": "u3-37-progressive-tax",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释累进税、转移支付与可支配收入的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Progressive taxes, transfers and disposable income and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "累进税的平均税率随收入提高；边际税率适用于新增收入，平均税率是税额/总收入。可支配收入为收入减直接税加转移。 确定各税档适用收入；分段计算税额而非全部收入乘最高税率；用转移和税收比较最终购买能力 原创例：边际税率只适用于新增收入，不应把最高档税率乘全部收入。累进税意味着平均税率随收入上升，定向转移支付则增加合资格家庭的可支配收入。税额和平均税率的数值计算属于 HL。",
          "en": "Under progressive taxation the average tax rate rises with income. The marginal rate applies to additional income; the average rate is total tax/income. Disposable income subtracts direct taxes and adds transfers. Identify income within each bracket; calculate tax progressively rather than applying the top rate to all income; compare purchasing power after taxes and transfers Illustrative example: a marginal rate applies to additional income, not automatically all income. Under progressive taxation the average rate rises with income; targeted transfers add to eligible households’ disposable income. Numerical tax and average-rate calculations are HL."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "平均税率",
              "en": "average rate"
            },
            "alternatives": {
              "zh-CN": [
                "平均税率",
                "确定各税档适用收入"
              ],
              "en": [
                "average rate",
                "Identify income within each bracket"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "边际税率",
              "en": "marginal rate"
            },
            "alternatives": {
              "zh-CN": [
                "边际税率",
                "分段计算税额而非全部收入乘最高税率"
              ],
              "en": [
                "marginal rate",
                "calculate tax progressively rather than applying the top rate to all income"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "可支配收入",
              "en": "disposable income"
            },
            "alternatives": {
              "zh-CN": [
                "可支配收入",
                "用转移和税收比较最终购买能力"
              ],
              "en": [
                "disposable income",
                "compare purchasing power after taxes and transfers"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u3-37-progressive-tax-mcq-hl-1",
        "knowledgePointId": "u3-37-progressive-tax",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "收入 300、税额 45，平均税率多少？",
          "en": "Income is 300 and tax 45. What is the average tax rate?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "45%",
            "en": "45%"
          },
          {
            "id": "b",
            "zh-CN": "15%",
            "en": "15%"
          },
          {
            "id": "c",
            "zh-CN": "6.67%",
            "en": "6.67%"
          },
          {
            "id": "d",
            "zh-CN": "必等于最高边际税率",
            "en": "Must equal the top marginal rate"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "15%。 45 / 300 × 100 = 15%",
          "en": "15%. 45 / 300 × 100 = 15%"
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-38-poverty-policies",
      "slug": "poverty-policies",
      "section": "3.4",
      "level": "core",
      "syllabusRefs": [
        "3.4 Economics of inequality and poverty"
      ],
      "textbookRefs": [
        {
          "chapter": "12",
          "section": "12.5",
          "pages": [
            371
          ]
        }
      ],
      "prerequisites": [
        "u1-35-equality-equity"
      ],
      "related": [
        "u3-33-poverty",
        "u3-34-inequality-causes",
        "u3-35-lorenz-gini"
      ],
      "terms": [
        "减贫与再分配政策评价",
        "Evaluating poverty and redistribution policies",
        "针对性",
        "targeting",
        "覆盖",
        "coverage",
        "激励",
        "incentives"
      ],
      "synonyms": {
        "zh-CN": [
          "针对性",
          "覆盖",
          "激励"
        ],
        "en": [
          "targeting",
          "coverage",
          "incentives"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-38-poverty-policies-flash-1",
        "u3-38-poverty-policies-mcq-1",
        "u3-38-poverty-policies-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-38-poverty-policies",
        "locale": "zh-CN",
        "title": "减贫与再分配政策评价",
        "takeaway": "税转移、教育医疗、就业支持、最低工资和社会保险可改变贫困与分配；应比较覆盖、激励、成本、服务质量和长期机会。",
        "definition": "税转移、教育医疗、就业支持、最低工资和社会保险可改变贫困与分配；应比较覆盖、激励、成本、服务质量和长期机会。",
        "causalChain": [
          "识别收入或机会障碍",
          "选择现金、服务或制度工具",
          "用受益分布及行为反应评估结果"
        ],
        "misconceptions": [
          "转移金额增加不等于实际贫困一定同幅减少。"
        ],
        "examApplication": [
          "区分收入、财富、贫困与不平等，评价针对性、激励与公平标准。"
        ],
        "summary": [
          "税转移、教育医疗、就业支持、最低工资和社会保险可改变贫困与分配；应比较覆盖、激励、成本、服务质量和长期机会。",
          "转移金额增加不等于实际贫困一定同幅减少。"
        ],
        "explanation": "识别收入或机会障碍。选择现金、服务或制度工具。用受益分布及行为反应评估结果。\n\n### 原创情境与推导\n\n原创例：收入审查补助提高针对性，却可能遗漏无完整收入记录的家庭；逐步退出补助可减轻福利悬崖。普遍公共教育覆盖更广，但若地区质量差异大，名义免费并不保证机会平等。\n\n转移金额增加不等于实际贫困一定同幅减少。\n\n区分收入、财富、贫困与不平等，评价针对性、激励与公平标准。"
      },
      "en": {
        "id": "u3-38-poverty-policies",
        "locale": "en",
        "title": "Evaluating poverty and redistribution policies",
        "takeaway": "Taxes/transfers, education and health, employment support, minimum wages and social insurance can alter poverty and distribution. Compare coverage, incentives, cost, quality and long-run opportunity.",
        "definition": "Taxes/transfers, education and health, employment support, minimum wages and social insurance can alter poverty and distribution. Compare coverage, incentives, cost, quality and long-run opportunity.",
        "causalChain": [
          "Identify income or opportunity barriers",
          "choose cash, services or institutional tools",
          "assess benefit distribution and behavioural responses"
        ],
        "misconceptions": [
          "A larger transfer does not necessarily reduce real poverty by the same proportion."
        ],
        "examApplication": [
          "Distinguish income, wealth, poverty and inequality; evaluate targeting, incentives and equity criteria."
        ],
        "summary": [
          "Taxes/transfers, education and health, employment support, minimum wages and social insurance can alter poverty and distribution. Compare coverage, incentives, cost, quality and long-run opportunity.",
          "A larger transfer does not necessarily reduce real poverty by the same proportion."
        ],
        "explanation": "Identify income or opportunity barriers.  choose cash, services or institutional tools.  assess benefit distribution and behavioural responses.\n\n### Original scenario and reasoning\n\nIllustrative example: means-tested support improves targeting but may miss households without records; tapering benefits can reduce benefit cliffs. Universal schooling reaches more people, but unequal local quality means nominally free provision need not equalise opportunity.\n\nA larger transfer does not necessarily reduce real poverty by the same proportion.\n\nDistinguish income, wealth, poverty and inequality; evaluate targeting, incentives and equity criteria."
      }
    },
    "practice": [
      {
        "id": "u3-38-poverty-policies-flash-1",
        "knowledgePointId": "u3-38-poverty-policies",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“减贫与再分配政策评价”，并说明一个关键条件。",
          "en": "Explain Evaluating poverty and redistribution policies and state one important condition."
        },
        "answer": {
          "zh-CN": "税转移、教育医疗、就业支持、最低工资和社会保险可改变贫困与分配；应比较覆盖、激励、成本、服务质量和长期机会。",
          "en": "Taxes/transfers, education and health, employment support, minimum wages and social insurance can alter poverty and distribution. Compare coverage, incentives, cost, quality and long-run opportunity."
        },
        "explanation": {
          "zh-CN": "转移金额增加不等于实际贫困一定同幅减少。",
          "en": "A larger transfer does not necessarily reduce real poverty by the same proportion."
        }
      },
      {
        "id": "u3-38-poverty-policies-mcq-1",
        "knowledgePointId": "u3-38-poverty-policies",
        "type": "mcq",
        "prompt": {
          "zh-CN": "评价收入审查补助应特别考察什么？",
          "en": "What is particularly relevant to evaluating means-tested benefits?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "假设所有人都被准确识别",
            "en": "Assume everyone is identified perfectly"
          },
          {
            "id": "b",
            "zh-CN": "针对性与覆盖遗漏",
            "en": "Targeting and exclusion errors"
          },
          {
            "id": "c",
            "zh-CN": "忽略退出率和激励",
            "en": "Ignore withdrawal rates and incentives"
          },
          {
            "id": "d",
            "zh-CN": "只比较项目名称",
            "en": "Only compare programme names"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "针对性与覆盖遗漏。 识别收入或机会障碍；选择现金、服务或制度工具；用受益分布及行为反应评估结果 转移金额增加不等于实际贫困一定同幅减少。",
          "en": "Targeting and exclusion errors. Identify income or opportunity barriers; choose cash, services or institutional tools; assess benefit distribution and behavioural responses A larger transfer does not necessarily reduce real poverty by the same proportion."
        }
      },
      {
        "id": "u3-38-poverty-policies-short-1",
        "knowledgePointId": "u3-38-poverty-policies",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释减贫与再分配政策评价的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Evaluating poverty and redistribution policies and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "税转移、教育医疗、就业支持、最低工资和社会保险可改变贫困与分配；应比较覆盖、激励、成本、服务质量和长期机会。 识别收入或机会障碍；选择现金、服务或制度工具；用受益分布及行为反应评估结果 原创例：收入审查补助提高针对性，却可能遗漏无完整收入记录的家庭；逐步退出补助可减轻福利悬崖。普遍公共教育覆盖更广，但若地区质量差异大，名义免费并不保证机会平等。",
          "en": "Taxes/transfers, education and health, employment support, minimum wages and social insurance can alter poverty and distribution. Compare coverage, incentives, cost, quality and long-run opportunity. Identify income or opportunity barriers; choose cash, services or institutional tools; assess benefit distribution and behavioural responses Illustrative example: means-tested support improves targeting but may miss households without records; tapering benefits can reduce benefit cliffs. Universal schooling reaches more people, but unequal local quality means nominally free provision need not equalise opportunity."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "针对性",
              "en": "targeting"
            },
            "alternatives": {
              "zh-CN": [
                "针对性",
                "识别收入或机会障碍"
              ],
              "en": [
                "targeting",
                "Identify income or opportunity barriers"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "覆盖",
              "en": "coverage"
            },
            "alternatives": {
              "zh-CN": [
                "覆盖",
                "选择现金、服务或制度工具"
              ],
              "en": [
                "coverage",
                "choose cash, services or institutional tools"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "激励",
              "en": "incentives"
            },
            "alternatives": {
              "zh-CN": [
                "激励",
                "用受益分布及行为反应评估结果"
              ],
              "en": [
                "incentives",
                "assess benefit distribution and behavioural responses"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-39-money-interest",
      "slug": "money-interest",
      "section": "3.5",
      "level": "core",
      "syllabusRefs": [
        "3.5 Monetary policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.2",
          "pages": [
            387
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-40-monetary-transmission",
        "u3-41-expansionary-monetary",
        "u3-42-contractionary-monetary"
      ],
      "terms": [
        "中央银行与利率",
        "Central banks and interest rates",
        "政策利率",
        "policy rate",
        "实际利率",
        "real rate",
        "融资成本",
        "financing costs"
      ],
      "synonyms": {
        "zh-CN": [
          "政策利率",
          "实际利率",
          "融资成本"
        ],
        "en": [
          "policy rate",
          "real rate",
          "financing costs"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-39-money-interest-flash-1",
        "u3-39-money-interest-mcq-1",
        "u3-39-money-interest-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-39-money-interest",
        "locale": "zh-CN",
        "title": "中央银行与利率",
        "takeaway": "中央银行通过政策利率及金融条件影响支出；实际利率近似等于名义利率减预期通胀率。",
        "definition": "中央银行通过政策利率及金融条件影响支出；实际利率近似等于名义利率减预期通胀率。",
        "causalChain": [
          "政策利率影响市场融资成本",
          "借贷者比较实际成本",
          "消费和投资计划随之调整"
        ],
        "misconceptions": [
          "实际利率应使用预期通胀分析事前决策。"
        ],
        "examApplication": [
          "用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
        ],
        "summary": [
          "中央银行通过政策利率及金融条件影响支出；实际利率近似等于名义利率减预期通胀率。",
          "实际利率应使用预期通胀分析事前决策。"
        ],
        "explanation": "政策利率影响市场融资成本。借贷者比较实际成本。消费和投资计划随之调整。\n\n### 原创情境与推导\n\n原创例：名义贷款利率 6%、预期通胀 2%，近似实际利率为 4%。银行风险溢价上升时，贷款利率未必与政策利率同步下降。货币不是收入，新增贷款也不直接等于新增产出。\n\n实际利率应使用预期通胀分析事前决策。\n\n用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
      },
      "en": {
        "id": "u3-39-money-interest",
        "locale": "en",
        "title": "Central banks and interest rates",
        "takeaway": "Central banks influence spending through policy rates and financial conditions. The real interest rate is approximately the nominal rate minus expected inflation.",
        "definition": "Central banks influence spending through policy rates and financial conditions. The real interest rate is approximately the nominal rate minus expected inflation.",
        "causalChain": [
          "Policy rates influence market financing costs",
          "borrowers compare real costs",
          "consumption and investment plans adjust"
        ],
        "misconceptions": [
          "Use expected inflation when analysing ex-ante real rates."
        ],
        "examApplication": [
          "Trace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
        ],
        "summary": [
          "Central banks influence spending through policy rates and financial conditions. The real interest rate is approximately the nominal rate minus expected inflation.",
          "Use expected inflation when analysing ex-ante real rates."
        ],
        "explanation": "Policy rates influence market financing costs.  borrowers compare real costs.  consumption and investment plans adjust.\n\n### Original scenario and reasoning\n\nIllustrative example: a 6% nominal lending rate and 2% expected inflation imply an approximately 4% real rate. If bank risk premiums rise, lending rates need not fall alongside policy rates. Money is not income, and new lending does not directly equal new output.\n\nUse expected inflation when analysing ex-ante real rates.\n\nTrace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
      }
    },
    "practice": [
      {
        "id": "u3-39-money-interest-flash-1",
        "knowledgePointId": "u3-39-money-interest",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“中央银行与利率”，并说明一个关键条件。",
          "en": "Explain Central banks and interest rates and state one important condition."
        },
        "answer": {
          "zh-CN": "中央银行通过政策利率及金融条件影响支出；实际利率近似等于名义利率减预期通胀率。",
          "en": "Central banks influence spending through policy rates and financial conditions. The real interest rate is approximately the nominal rate minus expected inflation."
        },
        "explanation": {
          "zh-CN": "实际利率应使用预期通胀分析事前决策。",
          "en": "Use expected inflation when analysing ex-ante real rates."
        }
      },
      {
        "id": "u3-39-money-interest-mcq-1",
        "knowledgePointId": "u3-39-money-interest",
        "type": "mcq",
        "prompt": {
          "zh-CN": "名义利率 5%、预期通胀 3%，近似实际利率？",
          "en": "Nominal interest is 5% and expected inflation 3%. Approximate real interest?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "8%",
            "en": "8%"
          },
          {
            "id": "b",
            "zh-CN": "15%",
            "en": "15%"
          },
          {
            "id": "c",
            "zh-CN": "2%",
            "en": "2%"
          },
          {
            "id": "d",
            "zh-CN": "必为零",
            "en": "Necessarily zero"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "2%。 r ≈ i − πᵉ = 5% − 3% = 2% 实际利率应使用预期通胀分析事前决策。",
          "en": "2%. r ≈ i − πᵉ = 5% − 3% = 2% Use expected inflation when analysing ex-ante real rates."
        }
      },
      {
        "id": "u3-39-money-interest-short-1",
        "knowledgePointId": "u3-39-money-interest",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释中央银行与利率的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Central banks and interest rates and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "中央银行通过政策利率及金融条件影响支出；实际利率近似等于名义利率减预期通胀率。 政策利率影响市场融资成本；借贷者比较实际成本；消费和投资计划随之调整 原创例：名义贷款利率 6%、预期通胀 2%，近似实际利率为 4%。银行风险溢价上升时，贷款利率未必与政策利率同步下降。货币不是收入，新增贷款也不直接等于新增产出。",
          "en": "Central banks influence spending through policy rates and financial conditions. The real interest rate is approximately the nominal rate minus expected inflation. Policy rates influence market financing costs; borrowers compare real costs; consumption and investment plans adjust Illustrative example: a 6% nominal lending rate and 2% expected inflation imply an approximately 4% real rate. If bank risk premiums rise, lending rates need not fall alongside policy rates. Money is not income, and new lending does not directly equal new output."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "政策利率",
              "en": "policy rate"
            },
            "alternatives": {
              "zh-CN": [
                "政策利率",
                "政策利率影响市场融资成本"
              ],
              "en": [
                "policy rate",
                "Policy rates influence market financing costs"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "实际利率",
              "en": "real rate"
            },
            "alternatives": {
              "zh-CN": [
                "实际利率",
                "借贷者比较实际成本"
              ],
              "en": [
                "real rate",
                "borrowers compare real costs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "融资成本",
              "en": "financing costs"
            },
            "alternatives": {
              "zh-CN": [
                "融资成本",
                "消费和投资计划随之调整"
              ],
              "en": [
                "financing costs",
                "consumption and investment plans adjust"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-40-monetary-transmission",
      "slug": "monetary-transmission",
      "section": "3.5",
      "level": "core",
      "syllabusRefs": [
        "3.5 Monetary policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.2",
          "pages": [
            387
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-39-money-interest",
        "u3-41-expansionary-monetary",
        "u3-42-contractionary-monetary"
      ],
      "terms": [
        "货币政策传导",
        "Monetary transmission",
        "融资成本",
        "financing costs",
        "消费投资",
        "consumption and investment",
        "总需求",
        "aggregate demand"
      ],
      "synonyms": {
        "zh-CN": [
          "融资成本",
          "消费投资",
          "总需求"
        ],
        "en": [
          "financing costs",
          "consumption and investment",
          "aggregate demand"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-40-monetary-transmission-flash-1",
        "u3-40-monetary-transmission-mcq-1",
        "u3-40-monetary-transmission-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-40-monetary-transmission",
        "locale": "zh-CN",
        "title": "货币政策传导",
        "takeaway": "利率通过借贷、储蓄、资产价格、预期和汇率等渠道影响总需求；效果有时滞且取决于金融与汇率制度。",
        "definition": "利率通过借贷、储蓄、资产价格、预期和汇率等渠道影响总需求；效果有时滞且取决于金融与汇率制度。",
        "causalChain": [
          "利率改变融资与储蓄回报",
          "家庭企业调整消费投资",
          "总需求变化影响实际产出和物价"
        ],
        "misconceptions": [
          "降息不保证汇率或投资按固定幅度变化。"
        ],
        "examApplication": [
          "用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
        ],
        "summary": [
          "利率通过借贷、储蓄、资产价格、预期和汇率等渠道影响总需求；效果有时滞且取决于金融与汇率制度。",
          "降息不保证汇率或投资按固定幅度变化。"
        ],
        "explanation": "利率改变融资与储蓄回报。家庭企业调整消费投资。总需求变化影响实际产出和物价。\n\n### 原创情境与推导\n\n原创例：浮动汇率下，相对利率下降可能减少资本流入并使货币贬值，从而支持净出口；但进口成本也会上升。固定利率房贷较多时，家庭现金流反应可能较慢。\n\n降息不保证汇率或投资按固定幅度变化。\n\n用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
      },
      "en": {
        "id": "u3-40-monetary-transmission",
        "locale": "en",
        "title": "Monetary transmission",
        "takeaway": "Interest rates affect aggregate demand through borrowing, saving, asset prices, expectations and exchange rates. Effects have lags and depend on financial and exchange-rate arrangements.",
        "definition": "Interest rates affect aggregate demand through borrowing, saving, asset prices, expectations and exchange rates. Effects have lags and depend on financial and exchange-rate arrangements.",
        "causalChain": [
          "Rates change financing costs and saving returns",
          "households and firms adjust consumption and investment",
          "changing aggregate demand affects output and prices"
        ],
        "misconceptions": [
          "A rate cut does not guarantee a fixed exchange-rate or investment response."
        ],
        "examApplication": [
          "Trace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
        ],
        "summary": [
          "Interest rates affect aggregate demand through borrowing, saving, asset prices, expectations and exchange rates. Effects have lags and depend on financial and exchange-rate arrangements.",
          "A rate cut does not guarantee a fixed exchange-rate or investment response."
        ],
        "explanation": "Rates change financing costs and saving returns.  households and firms adjust consumption and investment.  changing aggregate demand affects output and prices.\n\n### Original scenario and reasoning\n\nIllustrative example: under floating exchange rates, lower relative interest may reduce capital inflows and depreciate the currency, supporting net exports while raising import costs. Household cash-flow responses may be slower where fixed-rate mortgages dominate.\n\nA rate cut does not guarantee a fixed exchange-rate or investment response.\n\nTrace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
      }
    },
    "practice": [
      {
        "id": "u3-40-monetary-transmission-flash-1",
        "knowledgePointId": "u3-40-monetary-transmission",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“货币政策传导”，并说明一个关键条件。",
          "en": "Explain Monetary transmission and state one important condition."
        },
        "answer": {
          "zh-CN": "利率通过借贷、储蓄、资产价格、预期和汇率等渠道影响总需求；效果有时滞且取决于金融与汇率制度。",
          "en": "Interest rates affect aggregate demand through borrowing, saving, asset prices, expectations and exchange rates. Effects have lags and depend on financial and exchange-rate arrangements."
        },
        "explanation": {
          "zh-CN": "降息不保证汇率或投资按固定幅度变化。",
          "en": "A rate cut does not guarantee a fixed exchange-rate or investment response."
        }
      },
      {
        "id": "u3-40-monetary-transmission-mcq-1",
        "knowledgePointId": "u3-40-monetary-transmission",
        "type": "mcq",
        "prompt": {
          "zh-CN": "什么会削弱降息的投资渠道？",
          "en": "What weakens the investment channel of a rate cut?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "所有项目必然盈利",
            "en": "Every project becomes profitable"
          },
          {
            "id": "b",
            "zh-CN": "贷款成本必然为零",
            "en": "Borrowing necessarily becomes free"
          },
          {
            "id": "c",
            "zh-CN": "总需求不含投资",
            "en": "Aggregate demand excludes investment"
          },
          {
            "id": "d",
            "zh-CN": "企业对未来销售缺乏信心",
            "en": "Firms lack confidence in future sales"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "企业对未来销售缺乏信心。 利率改变融资与储蓄回报；家庭企业调整消费投资；总需求变化影响实际产出和物价 降息不保证汇率或投资按固定幅度变化。",
          "en": "Firms lack confidence in future sales. Rates change financing costs and saving returns; households and firms adjust consumption and investment; changing aggregate demand affects output and prices A rate cut does not guarantee a fixed exchange-rate or investment response."
        }
      },
      {
        "id": "u3-40-monetary-transmission-short-1",
        "knowledgePointId": "u3-40-monetary-transmission",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释货币政策传导的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Monetary transmission and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "利率通过借贷、储蓄、资产价格、预期和汇率等渠道影响总需求；效果有时滞且取决于金融与汇率制度。 利率改变融资与储蓄回报；家庭企业调整消费投资；总需求变化影响实际产出和物价 原创例：浮动汇率下，相对利率下降可能减少资本流入并使货币贬值，从而支持净出口；但进口成本也会上升。固定利率房贷较多时，家庭现金流反应可能较慢。",
          "en": "Interest rates affect aggregate demand through borrowing, saving, asset prices, expectations and exchange rates. Effects have lags and depend on financial and exchange-rate arrangements. Rates change financing costs and saving returns; households and firms adjust consumption and investment; changing aggregate demand affects output and prices Illustrative example: under floating exchange rates, lower relative interest may reduce capital inflows and depreciate the currency, supporting net exports while raising import costs. Household cash-flow responses may be slower where fixed-rate mortgages dominate."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "融资成本",
              "en": "financing costs"
            },
            "alternatives": {
              "zh-CN": [
                "融资成本",
                "利率改变融资与储蓄回报"
              ],
              "en": [
                "financing costs",
                "Rates change financing costs and saving returns"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "消费投资",
              "en": "consumption and investment"
            },
            "alternatives": {
              "zh-CN": [
                "消费投资",
                "家庭企业调整消费投资"
              ],
              "en": [
                "consumption and investment",
                "households and firms adjust consumption and investment"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "总需求",
              "en": "aggregate demand"
            },
            "alternatives": {
              "zh-CN": [
                "总需求",
                "总需求变化影响实际产出和物价"
              ],
              "en": [
                "aggregate demand",
                "changing aggregate demand affects output and prices"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-41-expansionary-monetary",
      "slug": "expansionary-monetary",
      "section": "3.5",
      "level": "core",
      "syllabusRefs": [
        "3.5 Monetary policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.2",
          "pages": [
            387
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-39-money-interest",
        "u3-40-monetary-transmission",
        "u3-42-contractionary-monetary"
      ],
      "terms": [
        "扩张性货币政策",
        "Expansionary monetary policy",
        "降低利率",
        "lower interest rates",
        "总需求右移",
        "aggregate demand shifts right",
        "负产出缺口",
        "negative output gap"
      ],
      "synonyms": {
        "zh-CN": [
          "降低利率",
          "总需求右移",
          "负产出缺口"
        ],
        "en": [
          "lower interest rates",
          "aggregate demand shifts right",
          "negative output gap"
        ]
      },
      "diagramIds": [
        "macro-ad-expansion"
      ],
      "quizIds": [
        "u3-41-expansionary-monetary-flash-1",
        "u3-41-expansionary-monetary-mcq-1",
        "u3-41-expansionary-monetary-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-41-expansionary-monetary",
        "locale": "zh-CN",
        "title": "扩张性货币政策",
        "takeaway": "扩张性货币政策放松金融条件以支持总需求，通常用于需求不足；产出与物价反应取决于闲置产能。",
        "definition": "扩张性货币政策放松金融条件以支持总需求，通常用于需求不足；产出与物价反应取决于闲置产能。",
        "causalChain": [
          "降低利率或放松信贷条件",
          "利率敏感支出增加使总需求右移",
          "负产出缺口可能缩小"
        ],
        "misconceptions": [
          "总需求右移不是潜在产出自动增加。"
        ],
        "examApplication": [
          "用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
        ],
        "summary": [
          "扩张性货币政策放松金融条件以支持总需求，通常用于需求不足；产出与物价反应取决于闲置产能。",
          "总需求右移不是潜在产出自动增加。"
        ],
        "explanation": "降低利率或放松信贷条件。利率敏感支出增加使总需求右移。负产出缺口可能缩小。\n\n### 原创情境与推导\n\n原创例：经济存在闲置设备时，融资成本下降使企业恢复部分投资，产量与就业增加。若银行仍限制贷款或家庭偿债，需求增幅可能较小；接近产能上限时，物价压力更大。\n\n总需求右移不是潜在产出自动增加。\n\n用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
      },
      "en": {
        "id": "u3-41-expansionary-monetary",
        "locale": "en",
        "title": "Expansionary monetary policy",
        "takeaway": "Expansionary monetary policy eases financial conditions to support aggregate demand, usually when demand is weak. Output and price responses depend on spare capacity.",
        "definition": "Expansionary monetary policy eases financial conditions to support aggregate demand, usually when demand is weak. Output and price responses depend on spare capacity.",
        "causalChain": [
          "Lower interest rates or ease credit conditions",
          "interest-sensitive spending increases and aggregate demand shifts right",
          "a negative output gap may narrow"
        ],
        "misconceptions": [
          "A rightward AD shift does not automatically increase potential output."
        ],
        "examApplication": [
          "Trace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
        ],
        "summary": [
          "Expansionary monetary policy eases financial conditions to support aggregate demand, usually when demand is weak. Output and price responses depend on spare capacity.",
          "A rightward AD shift does not automatically increase potential output."
        ],
        "explanation": "Lower interest rates or ease credit conditions.  interest-sensitive spending increases and aggregate demand shifts right.  a negative output gap may narrow.\n\n### Original scenario and reasoning\n\nIllustrative example: with idle equipment, cheaper finance restores some investment, raising output and employment. Demand may respond weakly if banks restrict lending or households repay debt. Near capacity, price pressure is greater.\n\nA rightward AD shift does not automatically increase potential output.\n\nTrace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
      }
    },
    "practice": [
      {
        "id": "u3-41-expansionary-monetary-flash-1",
        "knowledgePointId": "u3-41-expansionary-monetary",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“扩张性货币政策”，并说明一个关键条件。",
          "en": "Explain Expansionary monetary policy and state one important condition."
        },
        "answer": {
          "zh-CN": "扩张性货币政策放松金融条件以支持总需求，通常用于需求不足；产出与物价反应取决于闲置产能。",
          "en": "Expansionary monetary policy eases financial conditions to support aggregate demand, usually when demand is weak. Output and price responses depend on spare capacity."
        },
        "explanation": {
          "zh-CN": "总需求右移不是潜在产出自动增加。",
          "en": "A rightward AD shift does not automatically increase potential output."
        }
      },
      {
        "id": "u3-41-expansionary-monetary-mcq-1",
        "knowledgePointId": "u3-41-expansionary-monetary",
        "type": "mcq",
        "prompt": {
          "zh-CN": "存在闲置产能时，成功的需求刺激可能怎样？",
          "en": "With spare capacity, what may successful demand stimulus do?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "提高实际产出并缩小负缺口",
            "en": "Raise real output and narrow a negative gap"
          },
          {
            "id": "b",
            "zh-CN": "必然只提高物价",
            "en": "Necessarily only raise prices"
          },
          {
            "id": "c",
            "zh-CN": "必然使 LRAS 左移",
            "en": "Necessarily shift LRAS left"
          },
          {
            "id": "d",
            "zh-CN": "消除一切结构失业",
            "en": "Eliminate all structural unemployment"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "提高实际产出并缩小负缺口。 降低利率或放松信贷条件；利率敏感支出增加使总需求右移；负产出缺口可能缩小 总需求右移不是潜在产出自动增加。",
          "en": "Raise real output and narrow a negative gap. Lower interest rates or ease credit conditions; interest-sensitive spending increases and aggregate demand shifts right; a negative output gap may narrow A rightward AD shift does not automatically increase potential output."
        }
      },
      {
        "id": "u3-41-expansionary-monetary-short-1",
        "knowledgePointId": "u3-41-expansionary-monetary",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释扩张性货币政策的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Expansionary monetary policy and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "扩张性货币政策放松金融条件以支持总需求，通常用于需求不足；产出与物价反应取决于闲置产能。 降低利率或放松信贷条件；利率敏感支出增加使总需求右移；负产出缺口可能缩小 原创例：经济存在闲置设备时，融资成本下降使企业恢复部分投资，产量与就业增加。若银行仍限制贷款或家庭偿债，需求增幅可能较小；接近产能上限时，物价压力更大。",
          "en": "Expansionary monetary policy eases financial conditions to support aggregate demand, usually when demand is weak. Output and price responses depend on spare capacity. Lower interest rates or ease credit conditions; interest-sensitive spending increases and aggregate demand shifts right; a negative output gap may narrow Illustrative example: with idle equipment, cheaper finance restores some investment, raising output and employment. Demand may respond weakly if banks restrict lending or households repay debt. Near capacity, price pressure is greater."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "降低利率",
              "en": "lower interest rates"
            },
            "alternatives": {
              "zh-CN": [
                "降低利率",
                "降低利率或放松信贷条件"
              ],
              "en": [
                "lower interest rates",
                "Lower interest rates or ease credit conditions"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "总需求右移",
              "en": "aggregate demand shifts right"
            },
            "alternatives": {
              "zh-CN": [
                "总需求右移",
                "利率敏感支出增加使总需求右移"
              ],
              "en": [
                "aggregate demand shifts right",
                "interest-sensitive spending increases and aggregate demand shifts right"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "负产出缺口",
              "en": "negative output gap"
            },
            "alternatives": {
              "zh-CN": [
                "负产出缺口",
                "负产出缺口可能缩小"
              ],
              "en": [
                "negative output gap",
                "a negative output gap may narrow"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-42-contractionary-monetary",
      "slug": "contractionary-monetary",
      "section": "3.5",
      "level": "core",
      "syllabusRefs": [
        "3.5 Monetary policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.2",
          "pages": [
            387
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-39-money-interest",
        "u3-40-monetary-transmission",
        "u3-41-expansionary-monetary"
      ],
      "terms": [
        "紧缩性货币政策",
        "Contractionary monetary policy",
        "提高政策利率",
        "raise policy interest rates",
        "总需求",
        "aggregate demand",
        "周期性失业",
        "cyclical unemployment"
      ],
      "synonyms": {
        "zh-CN": [
          "提高政策利率",
          "总需求",
          "周期性失业"
        ],
        "en": [
          "raise policy interest rates",
          "aggregate demand",
          "cyclical unemployment"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-42-contractionary-monetary-flash-1",
        "u3-42-contractionary-monetary-mcq-1",
        "u3-42-contractionary-monetary-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-42-contractionary-monetary",
        "locale": "zh-CN",
        "title": "紧缩性货币政策",
        "takeaway": "紧缩性货币政策提高融资成本或收紧金融条件以减弱总需求和通胀压力，但可能牺牲短期产出与就业。",
        "definition": "紧缩性货币政策提高融资成本或收紧金融条件以减弱总需求和通胀压力，但可能牺牲短期产出与就业。",
        "causalChain": [
          "提高政策利率",
          "消费投资增速减弱使总需求相对降低",
          "通胀压力下降但周期性失业可能增加"
        ],
        "misconceptions": [
          "抑制通胀通常指降低涨价速度，不等于物价水平下降。"
        ],
        "examApplication": [
          "用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
        ],
        "summary": [
          "紧缩性货币政策提高融资成本或收紧金融条件以减弱总需求和通胀压力，但可能牺牲短期产出与就业。",
          "抑制通胀通常指降低涨价速度，不等于物价水平下降。"
        ],
        "explanation": "提高政策利率。消费投资增速减弱使总需求相对降低。通胀压力下降但周期性失业可能增加。\n\n### 原创情境与推导\n\n原创例：为缓和过热需求而加息后，住宅投资放缓。若通胀来自能源供给中断，加息不能直接恢复能源供给，降低通胀可能需要更大的产出代价。固定利率合同也会延迟影响。\n\n抑制通胀通常指降低涨价速度，不等于物价水平下降。\n\n用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
      },
      "en": {
        "id": "u3-42-contractionary-monetary",
        "locale": "en",
        "title": "Contractionary monetary policy",
        "takeaway": "Contractionary monetary policy raises financing costs or tightens financial conditions to weaken aggregate demand and inflation pressure, potentially sacrificing short-run output and employment.",
        "definition": "Contractionary monetary policy raises financing costs or tightens financial conditions to weaken aggregate demand and inflation pressure, potentially sacrificing short-run output and employment.",
        "causalChain": [
          "Raise policy interest rates",
          "consumption and investment weaken and aggregate demand is lower than otherwise",
          "inflation pressure falls but cyclical unemployment may rise"
        ],
        "misconceptions": [
          "Reducing inflation usually means slower price increases, not a falling price level."
        ],
        "examApplication": [
          "Trace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
        ],
        "summary": [
          "Contractionary monetary policy raises financing costs or tightens financial conditions to weaken aggregate demand and inflation pressure, potentially sacrificing short-run output and employment.",
          "Reducing inflation usually means slower price increases, not a falling price level."
        ],
        "explanation": "Raise policy interest rates.  consumption and investment weaken and aggregate demand is lower than otherwise.  inflation pressure falls but cyclical unemployment may rise.\n\n### Original scenario and reasoning\n\nIllustrative example: higher rates intended to cool excessive demand slow housing investment. If inflation reflects an energy supply disruption, tightening cannot directly restore energy supply and may entail a larger output cost. Fixed-rate contracts can delay the effect.\n\nReducing inflation usually means slower price increases, not a falling price level.\n\nTrace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
      }
    },
    "practice": [
      {
        "id": "u3-42-contractionary-monetary-flash-1",
        "knowledgePointId": "u3-42-contractionary-monetary",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“紧缩性货币政策”，并说明一个关键条件。",
          "en": "Explain Contractionary monetary policy and state one important condition."
        },
        "answer": {
          "zh-CN": "紧缩性货币政策提高融资成本或收紧金融条件以减弱总需求和通胀压力，但可能牺牲短期产出与就业。",
          "en": "Contractionary monetary policy raises financing costs or tightens financial conditions to weaken aggregate demand and inflation pressure, potentially sacrificing short-run output and employment."
        },
        "explanation": {
          "zh-CN": "抑制通胀通常指降低涨价速度，不等于物价水平下降。",
          "en": "Reducing inflation usually means slower price increases, not a falling price level."
        }
      },
      {
        "id": "u3-42-contractionary-monetary-mcq-1",
        "knowledgePointId": "u3-42-contractionary-monetary",
        "type": "mcq",
        "prompt": {
          "zh-CN": "加息应对供给冲击的主要限制？",
          "en": "A major limitation of raising rates against a supply shock?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "立即增加能源产量",
            "en": "Immediately increases energy production"
          },
          {
            "id": "b",
            "zh-CN": "不能直接修复供给且可能压低产出",
            "en": "It cannot directly repair supply and may reduce output"
          },
          {
            "id": "c",
            "zh-CN": "没有时滞",
            "en": "Has no lag"
          },
          {
            "id": "d",
            "zh-CN": "必然提高所有企业利润",
            "en": "Necessarily raises every firm's profit"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "不能直接修复供给且可能压低产出。 提高政策利率；消费投资增速减弱使总需求相对降低；通胀压力下降但周期性失业可能增加 抑制通胀通常指降低涨价速度，不等于物价水平下降。",
          "en": "It cannot directly repair supply and may reduce output. Raise policy interest rates; consumption and investment weaken and aggregate demand is lower than otherwise; inflation pressure falls but cyclical unemployment may rise Reducing inflation usually means slower price increases, not a falling price level."
        }
      },
      {
        "id": "u3-42-contractionary-monetary-short-1",
        "knowledgePointId": "u3-42-contractionary-monetary",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释紧缩性货币政策的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Contractionary monetary policy and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "紧缩性货币政策提高融资成本或收紧金融条件以减弱总需求和通胀压力，但可能牺牲短期产出与就业。 提高政策利率；消费投资增速减弱使总需求相对降低；通胀压力下降但周期性失业可能增加 原创例：为缓和过热需求而加息后，住宅投资放缓。若通胀来自能源供给中断，加息不能直接恢复能源供给，降低通胀可能需要更大的产出代价。固定利率合同也会延迟影响。",
          "en": "Contractionary monetary policy raises financing costs or tightens financial conditions to weaken aggregate demand and inflation pressure, potentially sacrificing short-run output and employment. Raise policy interest rates; consumption and investment weaken and aggregate demand is lower than otherwise; inflation pressure falls but cyclical unemployment may rise Illustrative example: higher rates intended to cool excessive demand slow housing investment. If inflation reflects an energy supply disruption, tightening cannot directly restore energy supply and may entail a larger output cost. Fixed-rate contracts can delay the effect."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "提高政策利率",
              "en": "raise policy interest rates"
            },
            "alternatives": {
              "zh-CN": [
                "提高政策利率",
                "提高政策利率"
              ],
              "en": [
                "raise policy interest rates",
                "Raise policy interest rates"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "总需求",
              "en": "aggregate demand"
            },
            "alternatives": {
              "zh-CN": [
                "总需求",
                "消费投资增速减弱使总需求相对降低"
              ],
              "en": [
                "aggregate demand",
                "consumption and investment weaken and aggregate demand is lower than otherwise"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "周期性失业",
              "en": "cyclical unemployment"
            },
            "alternatives": {
              "zh-CN": [
                "周期性失业",
                "通胀压力下降但周期性失业可能增加"
              ],
              "en": [
                "cyclical unemployment",
                "inflation pressure falls but cyclical unemployment may rise"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-43-unconventional-policy",
      "slug": "unconventional-policy",
      "section": "3.5",
      "level": "hl",
      "syllabusRefs": [
        "3.5 Monetary policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.2",
          "pages": [
            387
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-39-money-interest",
        "u3-40-monetary-transmission",
        "u3-41-expansionary-monetary"
      ],
      "terms": [
        "非常规货币政策",
        "Unconventional monetary policy",
        "购买金融资产",
        "buys financial assets",
        "融资条件",
        "financing conditions",
        "信贷需求",
        "credit demand"
      ],
      "synonyms": {
        "zh-CN": [
          "购买金融资产",
          "融资条件",
          "信贷需求"
        ],
        "en": [
          "buys financial assets",
          "financing conditions",
          "credit demand"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-43-unconventional-policy-flash-1",
        "u3-43-unconventional-policy-mcq-1",
        "u3-43-unconventional-policy-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-43-unconventional-policy",
        "locale": "zh-CN",
        "title": "非常规货币政策",
        "takeaway": "量化宽松等工具在常规降息空间有限时影响资产收益率、流动性和预期；购买金融资产不等同于政府购买商品服务。",
        "definition": "量化宽松等工具在常规降息空间有限时影响资产收益率、流动性和预期；购买金融资产不等同于政府购买商品服务。",
        "causalChain": [
          "中央银行购买金融资产",
          "资产价格和流动性变化影响融资条件",
          "支出反应取决于信贷需求与信心"
        ],
        "misconceptions": [
          "准备金增长不等于消费、贷款或 CPI 按相同比例增长。"
        ],
        "examApplication": [
          "用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
        ],
        "summary": [
          "量化宽松等工具在常规降息空间有限时影响资产收益率、流动性和预期；购买金融资产不等同于政府购买商品服务。",
          "准备金增长不等于消费、贷款或 CPI 按相同比例增长。"
        ],
        "explanation": "中央银行购买金融资产。资产价格和流动性变化影响融资条件。支出反应取决于信贷需求与信心。\n\n### 原创情境与推导\n\n原创例：中央银行购买长期债券可能压低长期收益率，但商业银行不会仅因准备金增加就必然扩大贷款。资产价格上涨还可能使资产持有者受益更多，退出政策时也有市场风险。\n\n准备金增长不等于消费、贷款或 CPI 按相同比例增长。\n\n用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
      },
      "en": {
        "id": "u3-43-unconventional-policy",
        "locale": "en",
        "title": "Unconventional monetary policy",
        "takeaway": "Tools such as quantitative easing influence asset yields, liquidity and expectations when conventional rate cuts have limited room. Financial asset purchases are not government purchases of goods and services.",
        "definition": "Tools such as quantitative easing influence asset yields, liquidity and expectations when conventional rate cuts have limited room. Financial asset purchases are not government purchases of goods and services.",
        "causalChain": [
          "The central bank buys financial assets",
          "asset prices and liquidity alter financing conditions",
          "spending responses depend on credit demand and confidence"
        ],
        "misconceptions": [
          "Reserve growth is not proportional growth in consumption, lending or CPI."
        ],
        "examApplication": [
          "Trace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
        ],
        "summary": [
          "Tools such as quantitative easing influence asset yields, liquidity and expectations when conventional rate cuts have limited room. Financial asset purchases are not government purchases of goods and services.",
          "Reserve growth is not proportional growth in consumption, lending or CPI."
        ],
        "explanation": "The central bank buys financial assets.  asset prices and liquidity alter financing conditions.  spending responses depend on credit demand and confidence.\n\n### Original scenario and reasoning\n\nIllustrative example: central-bank purchases of long-term bonds may lower long-term yields, but more reserves do not compel banks to lend. Asset price increases may benefit asset owners disproportionately, and policy reversal can create market risks.\n\nReserve growth is not proportional growth in consumption, lending or CPI.\n\nTrace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
      }
    },
    "practice": [
      {
        "id": "u3-43-unconventional-policy-flash-1",
        "knowledgePointId": "u3-43-unconventional-policy",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“非常规货币政策”，并说明一个关键条件。",
          "en": "Explain Unconventional monetary policy and state one important condition."
        },
        "answer": {
          "zh-CN": "量化宽松等工具在常规降息空间有限时影响资产收益率、流动性和预期；购买金融资产不等同于政府购买商品服务。",
          "en": "Tools such as quantitative easing influence asset yields, liquidity and expectations when conventional rate cuts have limited room. Financial asset purchases are not government purchases of goods and services."
        },
        "explanation": {
          "zh-CN": "准备金增长不等于消费、贷款或 CPI 按相同比例增长。",
          "en": "Reserve growth is not proportional growth in consumption, lending or CPI."
        }
      },
      {
        "id": "u3-43-unconventional-policy-mcq-1",
        "knowledgePointId": "u3-43-unconventional-policy",
        "type": "mcq",
        "prompt": {
          "zh-CN": "量化宽松首先涉及什么操作？",
          "en": "What operation is central to quantitative easing?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "政府直接购买更多课桌",
            "en": "Government directly buys more desks"
          },
          {
            "id": "b",
            "zh-CN": "自动免除所有私人债务",
            "en": "Automatically cancels all private debt"
          },
          {
            "id": "c",
            "zh-CN": "中央银行购买金融资产",
            "en": "Central-bank purchases of financial assets"
          },
          {
            "id": "d",
            "zh-CN": "保证所有人增加贷款",
            "en": "Guarantees everyone borrows more"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "中央银行购买金融资产。 中央银行购买金融资产；资产价格和流动性变化影响融资条件；支出反应取决于信贷需求与信心 准备金增长不等于消费、贷款或 CPI 按相同比例增长。",
          "en": "Central-bank purchases of financial assets. The central bank buys financial assets; asset prices and liquidity alter financing conditions; spending responses depend on credit demand and confidence Reserve growth is not proportional growth in consumption, lending or CPI."
        }
      },
      {
        "id": "u3-43-unconventional-policy-short-1",
        "knowledgePointId": "u3-43-unconventional-policy",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释非常规货币政策的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Unconventional monetary policy and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "量化宽松等工具在常规降息空间有限时影响资产收益率、流动性和预期；购买金融资产不等同于政府购买商品服务。 中央银行购买金融资产；资产价格和流动性变化影响融资条件；支出反应取决于信贷需求与信心 原创例：中央银行购买长期债券可能压低长期收益率，但商业银行不会仅因准备金增加就必然扩大贷款。资产价格上涨还可能使资产持有者受益更多，退出政策时也有市场风险。",
          "en": "Tools such as quantitative easing influence asset yields, liquidity and expectations when conventional rate cuts have limited room. Financial asset purchases are not government purchases of goods and services. The central bank buys financial assets; asset prices and liquidity alter financing conditions; spending responses depend on credit demand and confidence Illustrative example: central-bank purchases of long-term bonds may lower long-term yields, but more reserves do not compel banks to lend. Asset price increases may benefit asset owners disproportionately, and policy reversal can create market risks."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "购买金融资产",
              "en": "buys financial assets"
            },
            "alternatives": {
              "zh-CN": [
                "购买金融资产",
                "中央银行购买金融资产"
              ],
              "en": [
                "buys financial assets",
                "The central bank buys financial assets"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "融资条件",
              "en": "financing conditions"
            },
            "alternatives": {
              "zh-CN": [
                "融资条件",
                "资产价格和流动性变化影响融资条件"
              ],
              "en": [
                "financing conditions",
                "asset prices and liquidity alter financing conditions"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "信贷需求",
              "en": "credit demand"
            },
            "alternatives": {
              "zh-CN": [
                "信贷需求",
                "支出反应取决于信贷需求与信心"
              ],
              "en": [
                "credit demand",
                "spending responses depend on credit demand and confidence"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-44-monetary-limits",
      "slug": "monetary-limits",
      "section": "3.5",
      "level": "core",
      "syllabusRefs": [
        "3.5 Monetary policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.2",
          "pages": [
            387
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-39-money-interest",
        "u3-40-monetary-transmission",
        "u3-41-expansionary-monetary"
      ],
      "terms": [
        "货币政策的有效性与约束",
        "Effectiveness and limits of monetary policy",
        "供给问题",
        "supply problems",
        "时滞",
        "lags",
        "金融稳定",
        "financial stability"
      ],
      "synonyms": {
        "zh-CN": [
          "供给问题",
          "时滞",
          "金融稳定"
        ],
        "en": [
          "supply problems",
          "lags",
          "financial stability"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-44-monetary-limits-flash-1",
        "u3-44-monetary-limits-mcq-1",
        "u3-44-monetary-limits-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-44-monetary-limits",
        "locale": "zh-CN",
        "title": "货币政策的有效性与约束",
        "takeaway": "货币政策效果取决于信心、债务、银行传导、预期、开放程度和冲击来源；独立性与可信度也影响政策结果。",
        "definition": "货币政策效果取决于信心、债务、银行传导、预期、开放程度和冲击来源；独立性与可信度也影响政策结果。",
        "causalChain": [
          "识别需求或供给问题",
          "检查金融渠道与时滞",
          "比较通胀就业分配及金融稳定的权衡"
        ],
        "misconceptions": [
          "同一利率对储户、借款者和不同地区影响不同。"
        ],
        "examApplication": [
          "用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
        ],
        "summary": [
          "货币政策效果取决于信心、债务、银行传导、预期、开放程度和冲击来源；独立性与可信度也影响政策结果。",
          "同一利率对储户、借款者和不同地区影响不同。"
        ],
        "explanation": "识别需求或供给问题。检查金融渠道与时滞。比较通胀就业分配及金融稳定的权衡。\n\n### 原创情境与推导\n\n原创例：衰退中企业预期销售低迷，利率接近有效下限时再小幅降息未必恢复投资。可信的通胀目标可稳定预期，但独立性并不意味着政策没有问责或不受供给冲击影响。\n\n同一利率对储户、借款者和不同地区影响不同。\n\n用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
      },
      "en": {
        "id": "u3-44-monetary-limits",
        "locale": "en",
        "title": "Effectiveness and limits of monetary policy",
        "takeaway": "Monetary effectiveness depends on confidence, debt, bank transmission, expectations, openness and the source of shocks. Independence and credibility also influence outcomes.",
        "definition": "Monetary effectiveness depends on confidence, debt, bank transmission, expectations, openness and the source of shocks. Independence and credibility also influence outcomes.",
        "causalChain": [
          "Identify demand or supply problems",
          "examine financial channels and lags",
          "compare trade-offs involving inflation, employment, distribution and financial stability"
        ],
        "misconceptions": [
          "The same interest rate affects savers, borrowers and regions differently."
        ],
        "examApplication": [
          "Trace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
        ],
        "summary": [
          "Monetary effectiveness depends on confidence, debt, bank transmission, expectations, openness and the source of shocks. Independence and credibility also influence outcomes.",
          "The same interest rate affects savers, borrowers and regions differently."
        ],
        "explanation": "Identify demand or supply problems.  examine financial channels and lags.  compare trade-offs involving inflation, employment, distribution and financial stability.\n\n### Original scenario and reasoning\n\nIllustrative example: in recession, firms expecting weak sales may not revive investment after a small cut near the effective lower bound. A credible inflation target can anchor expectations, but independence does not remove accountability or exposure to supply shocks.\n\nThe same interest rate affects savers, borrowers and regions differently.\n\nTrace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
      }
    },
    "practice": [
      {
        "id": "u3-44-monetary-limits-flash-1",
        "knowledgePointId": "u3-44-monetary-limits",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“货币政策的有效性与约束”，并说明一个关键条件。",
          "en": "Explain Effectiveness and limits of monetary policy and state one important condition."
        },
        "answer": {
          "zh-CN": "货币政策效果取决于信心、债务、银行传导、预期、开放程度和冲击来源；独立性与可信度也影响政策结果。",
          "en": "Monetary effectiveness depends on confidence, debt, bank transmission, expectations, openness and the source of shocks. Independence and credibility also influence outcomes."
        },
        "explanation": {
          "zh-CN": "同一利率对储户、借款者和不同地区影响不同。",
          "en": "The same interest rate affects savers, borrowers and regions differently."
        }
      },
      {
        "id": "u3-44-monetary-limits-mcq-1",
        "knowledgePointId": "u3-44-monetary-limits",
        "type": "mcq",
        "prompt": {
          "zh-CN": "评价货币政策时最合理的做法？",
          "en": "What is a sound approach to evaluating monetary policy?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只看是否宣布降息",
            "en": "Only check whether a cut was announced"
          },
          {
            "id": "b",
            "zh-CN": "假定所有人反应相同",
            "en": "Assume identical responses"
          },
          {
            "id": "c",
            "zh-CN": "忽略银行信贷条件",
            "en": "Ignore bank credit conditions"
          },
          {
            "id": "d",
            "zh-CN": "结合冲击来源、传导与时滞",
            "en": "Consider shock origin, transmission and lags"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "结合冲击来源、传导与时滞。 识别需求或供给问题；检查金融渠道与时滞；比较通胀就业分配及金融稳定的权衡 同一利率对储户、借款者和不同地区影响不同。",
          "en": "Consider shock origin, transmission and lags. Identify demand or supply problems; examine financial channels and lags; compare trade-offs involving inflation, employment, distribution and financial stability The same interest rate affects savers, borrowers and regions differently."
        }
      },
      {
        "id": "u3-44-monetary-limits-short-1",
        "knowledgePointId": "u3-44-monetary-limits",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释货币政策的有效性与约束的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Effectiveness and limits of monetary policy and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "货币政策效果取决于信心、债务、银行传导、预期、开放程度和冲击来源；独立性与可信度也影响政策结果。 识别需求或供给问题；检查金融渠道与时滞；比较通胀就业分配及金融稳定的权衡 原创例：衰退中企业预期销售低迷，利率接近有效下限时再小幅降息未必恢复投资。可信的通胀目标可稳定预期，但独立性并不意味着政策没有问责或不受供给冲击影响。",
          "en": "Monetary effectiveness depends on confidence, debt, bank transmission, expectations, openness and the source of shocks. Independence and credibility also influence outcomes. Identify demand or supply problems; examine financial channels and lags; compare trade-offs involving inflation, employment, distribution and financial stability Illustrative example: in recession, firms expecting weak sales may not revive investment after a small cut near the effective lower bound. A credible inflation target can anchor expectations, but independence does not remove accountability or exposure to supply shocks."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "供给问题",
              "en": "supply problems"
            },
            "alternatives": {
              "zh-CN": [
                "供给问题",
                "识别需求或供给问题"
              ],
              "en": [
                "supply problems",
                "Identify demand or supply problems"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "时滞",
              "en": "lags"
            },
            "alternatives": {
              "zh-CN": [
                "时滞",
                "检查金融渠道与时滞"
              ],
              "en": [
                "lags",
                "examine financial channels and lags"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "金融稳定",
              "en": "financial stability"
            },
            "alternatives": {
              "zh-CN": [
                "金融稳定",
                "比较通胀就业分配及金融稳定的权衡"
              ],
              "en": [
                "financial stability",
                "compare trade-offs involving inflation, employment, distribution and financial stability"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-45-fiscal-budget",
      "slug": "fiscal-budget",
      "section": "3.6",
      "level": "core",
      "syllabusRefs": [
        "3.6 Fiscal policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.3",
          "pages": [
            398
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-46-expansionary-fiscal",
        "u3-47-contractionary-fiscal",
        "u3-48-automatic-stabilisers"
      ],
      "terms": [
        "财政预算与政策立场",
        "Fiscal budgets and policy stance",
        "预算余额",
        "budget balance",
        "衰退",
        "recession",
        "主动政策",
        "discretionary policy"
      ],
      "synonyms": {
        "zh-CN": [
          "预算余额",
          "衰退",
          "主动政策"
        ],
        "en": [
          "budget balance",
          "recession",
          "discretionary policy"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-45-fiscal-budget-flash-1",
        "u3-45-fiscal-budget-mcq-1",
        "u3-45-fiscal-budget-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-45-fiscal-budget",
        "locale": "zh-CN",
        "title": "财政预算与政策立场",
        "takeaway": "财政政策通过政府支出和税收影响需求与分配；赤字是期间流量，公共债务是时点存量，预算余额也受经济周期影响。",
        "definition": "财政政策通过政府支出和税收影响需求与分配；赤字是期间流量，公共债务是时点存量，预算余额也受经济周期影响。",
        "causalChain": [
          "支出与收入形成预算余额",
          "衰退减少税收并增加部分转移",
          "辨别自动变化和主动政策立场"
        ],
        "misconceptions": [
          "预算盈余或赤字的绝对水平不能单独识别政策变化。"
        ],
        "examApplication": [
          "区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
        ],
        "summary": [
          "财政政策通过政府支出和税收影响需求与分配；赤字是期间流量，公共债务是时点存量，预算余额也受经济周期影响。",
          "预算盈余或赤字的绝对水平不能单独识别政策变化。"
        ],
        "explanation": "支出与收入形成预算余额。衰退减少税收并增加部分转移。辨别自动变化和主动政策立场。\n\n### 原创情境与推导\n\n原创例：收入 90、支出 100，期间赤字为 10；这不是债务总额。衰退导致的赤字扩大不一定意味着政府新宣布刺激计划。结构性余额尝试剔除周期影响，但依赖潜在产出的估算。\n\n预算盈余或赤字的绝对水平不能单独识别政策变化。\n\n区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
      },
      "en": {
        "id": "u3-45-fiscal-budget",
        "locale": "en",
        "title": "Fiscal budgets and policy stance",
        "takeaway": "Fiscal policy affects demand and distribution through government spending and taxation. A deficit is a flow, public debt a stock, and the economic cycle also affects the budget balance.",
        "definition": "Fiscal policy affects demand and distribution through government spending and taxation. A deficit is a flow, public debt a stock, and the economic cycle also affects the budget balance.",
        "causalChain": [
          "Spending and revenue determine the budget balance",
          "recession lowers taxes and raises some transfers",
          "distinguish automatic changes from discretionary policy stance"
        ],
        "misconceptions": [
          "The level of a surplus or deficit alone cannot identify a policy change."
        ],
        "examApplication": [
          "Distinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
        ],
        "summary": [
          "Fiscal policy affects demand and distribution through government spending and taxation. A deficit is a flow, public debt a stock, and the economic cycle also affects the budget balance.",
          "The level of a surplus or deficit alone cannot identify a policy change."
        ],
        "explanation": "Spending and revenue determine the budget balance.  recession lowers taxes and raises some transfers.  distinguish automatic changes from discretionary policy stance.\n\n### Original scenario and reasoning\n\nIllustrative example: revenue of 90 and spending of 100 imply a period deficit of 10, not total debt. A recession-driven larger deficit need not mean a newly announced stimulus. Structural balances try to remove cyclical effects but depend on estimated potential output.\n\nThe level of a surplus or deficit alone cannot identify a policy change.\n\nDistinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
      }
    },
    "practice": [
      {
        "id": "u3-45-fiscal-budget-flash-1",
        "knowledgePointId": "u3-45-fiscal-budget",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“财政预算与政策立场”，并说明一个关键条件。",
          "en": "Explain Fiscal budgets and policy stance and state one important condition."
        },
        "answer": {
          "zh-CN": "财政政策通过政府支出和税收影响需求与分配；赤字是期间流量，公共债务是时点存量，预算余额也受经济周期影响。",
          "en": "Fiscal policy affects demand and distribution through government spending and taxation. A deficit is a flow, public debt a stock, and the economic cycle also affects the budget balance."
        },
        "explanation": {
          "zh-CN": "预算盈余或赤字的绝对水平不能单独识别政策变化。",
          "en": "The level of a surplus or deficit alone cannot identify a policy change."
        }
      },
      {
        "id": "u3-45-fiscal-budget-mcq-1",
        "knowledgePointId": "u3-45-fiscal-budget",
        "type": "mcq",
        "prompt": {
          "zh-CN": "税收 80、支出 95，预算状况？",
          "en": "Revenue is 80 and expenditure 95. Budget position?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "赤字 15",
            "en": "Deficit of 15"
          },
          {
            "id": "b",
            "zh-CN": "盈余 15",
            "en": "Surplus of 15"
          },
          {
            "id": "c",
            "zh-CN": "债务总额 15",
            "en": "Total debt of 15"
          },
          {
            "id": "d",
            "zh-CN": "预算平衡",
            "en": "Balanced budget"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "赤字 15。 95 − 80 = 15 (G > T) 预算盈余或赤字的绝对水平不能单独识别政策变化。",
          "en": "Deficit of 15. 95 − 80 = 15 (G > T) The level of a surplus or deficit alone cannot identify a policy change."
        }
      },
      {
        "id": "u3-45-fiscal-budget-short-1",
        "knowledgePointId": "u3-45-fiscal-budget",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释财政预算与政策立场的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Fiscal budgets and policy stance and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "财政政策通过政府支出和税收影响需求与分配；赤字是期间流量，公共债务是时点存量，预算余额也受经济周期影响。 支出与收入形成预算余额；衰退减少税收并增加部分转移；辨别自动变化和主动政策立场 原创例：收入 90、支出 100，期间赤字为 10；这不是债务总额。衰退导致的赤字扩大不一定意味着政府新宣布刺激计划。结构性余额尝试剔除周期影响，但依赖潜在产出的估算。",
          "en": "Fiscal policy affects demand and distribution through government spending and taxation. A deficit is a flow, public debt a stock, and the economic cycle also affects the budget balance. Spending and revenue determine the budget balance; recession lowers taxes and raises some transfers; distinguish automatic changes from discretionary policy stance Illustrative example: revenue of 90 and spending of 100 imply a period deficit of 10, not total debt. A recession-driven larger deficit need not mean a newly announced stimulus. Structural balances try to remove cyclical effects but depend on estimated potential output."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "预算余额",
              "en": "budget balance"
            },
            "alternatives": {
              "zh-CN": [
                "预算余额",
                "支出与收入形成预算余额"
              ],
              "en": [
                "budget balance",
                "Spending and revenue determine the budget balance"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "衰退",
              "en": "recession"
            },
            "alternatives": {
              "zh-CN": [
                "衰退",
                "衰退减少税收并增加部分转移"
              ],
              "en": [
                "recession",
                "recession lowers taxes and raises some transfers"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "主动政策",
              "en": "discretionary policy"
            },
            "alternatives": {
              "zh-CN": [
                "主动政策",
                "辨别自动变化和主动政策立场"
              ],
              "en": [
                "discretionary policy",
                "distinguish automatic changes from discretionary policy stance"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-46-expansionary-fiscal",
      "slug": "expansionary-fiscal",
      "section": "3.6",
      "level": "core",
      "syllabusRefs": [
        "3.6 Fiscal policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.3",
          "pages": [
            398
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-45-fiscal-budget",
        "u3-47-contractionary-fiscal",
        "u3-48-automatic-stabilisers"
      ],
      "terms": [
        "扩张性财政政策",
        "Expansionary fiscal policy",
        "可支配收入",
        "disposable income",
        "后续消费",
        "further consumption",
        "总需求右移",
        "aggregate demand shifts right"
      ],
      "synonyms": {
        "zh-CN": [
          "可支配收入",
          "后续消费",
          "总需求右移"
        ],
        "en": [
          "disposable income",
          "further consumption",
          "aggregate demand shifts right"
        ]
      },
      "diagramIds": [
        "macro-ad-expansion"
      ],
      "quizIds": [
        "u3-46-expansionary-fiscal-flash-1",
        "u3-46-expansionary-fiscal-mcq-1",
        "u3-46-expansionary-fiscal-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-46-expansionary-fiscal",
        "locale": "zh-CN",
        "title": "扩张性财政政策",
        "takeaway": "增加政府购买、减税或增加转移可支持总需求；政府购买直接计入 G，转移支付则通过受益者支出间接影响需求。",
        "definition": "增加政府购买、减税或增加转移可支持总需求；政府购买直接计入 G，转移支付则通过受益者支出间接影响需求。",
        "causalChain": [
          "增加购买或提高可支配收入",
          "初始支出带来收入及后续消费",
          "总需求右移并可能缩小衰退缺口"
        ],
        "misconceptions": [
          "转移支付不是国民收入核算中的政府最终购买。"
        ],
        "examApplication": [
          "区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
        ],
        "summary": [
          "增加政府购买、减税或增加转移可支持总需求；政府购买直接计入 G，转移支付则通过受益者支出间接影响需求。",
          "转移支付不是国民收入核算中的政府最终购买。"
        ],
        "explanation": "增加购买或提高可支配收入。初始支出带来收入及后续消费。总需求右移并可能缩小衰退缺口。\n\n### 原创情境与推导\n\n原创例：政府维修公共设施直接增加采购，给家庭补助则只有被消费的部分形成当期需求。闲置资源多时产出反应可能较大，进口泄漏、储蓄和执行延迟会削弱国内效果。\n\n转移支付不是国民收入核算中的政府最终购买。\n\n区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
      },
      "en": {
        "id": "u3-46-expansionary-fiscal",
        "locale": "en",
        "title": "Expansionary fiscal policy",
        "takeaway": "Higher government purchases, tax cuts or transfers can support aggregate demand. Purchases enter G directly; transfers affect demand indirectly through recipients' spending.",
        "definition": "Higher government purchases, tax cuts or transfers can support aggregate demand. Purchases enter G directly; transfers affect demand indirectly through recipients' spending.",
        "causalChain": [
          "Increase purchases or disposable income",
          "initial spending creates income and further consumption",
          "aggregate demand shifts right and may narrow a recessionary gap"
        ],
        "misconceptions": [
          "Transfers are not government final purchases in national accounting."
        ],
        "examApplication": [
          "Distinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
        ],
        "summary": [
          "Higher government purchases, tax cuts or transfers can support aggregate demand. Purchases enter G directly; transfers affect demand indirectly through recipients' spending.",
          "Transfers are not government final purchases in national accounting."
        ],
        "explanation": "Increase purchases or disposable income.  initial spending creates income and further consumption.  aggregate demand shifts right and may narrow a recessionary gap.\n\n### Original scenario and reasoning\n\nIllustrative example: repairs to public facilities directly raise purchases, whereas only the spent portion of household support generates current demand. Output may respond more with idle resources; imports, saving and implementation delays weaken domestic effects.\n\nTransfers are not government final purchases in national accounting.\n\nDistinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
      }
    },
    "practice": [
      {
        "id": "u3-46-expansionary-fiscal-flash-1",
        "knowledgePointId": "u3-46-expansionary-fiscal",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“扩张性财政政策”，并说明一个关键条件。",
          "en": "Explain Expansionary fiscal policy and state one important condition."
        },
        "answer": {
          "zh-CN": "增加政府购买、减税或增加转移可支持总需求；政府购买直接计入 G，转移支付则通过受益者支出间接影响需求。",
          "en": "Higher government purchases, tax cuts or transfers can support aggregate demand. Purchases enter G directly; transfers affect demand indirectly through recipients' spending."
        },
        "explanation": {
          "zh-CN": "转移支付不是国民收入核算中的政府最终购买。",
          "en": "Transfers are not government final purchases in national accounting."
        }
      },
      {
        "id": "u3-46-expansionary-fiscal-mcq-1",
        "knowledgePointId": "u3-46-expansionary-fiscal",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪项直接增加总需求中的 G？",
          "en": "Which directly increases G in aggregate demand?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "支付失业补助本身",
            "en": "An unemployment benefit payment itself"
          },
          {
            "id": "b",
            "zh-CN": "政府购买道路维修服务",
            "en": "Government purchases road repair services"
          },
          {
            "id": "c",
            "zh-CN": "个人买旧股票",
            "en": "A person buys existing shares"
          },
          {
            "id": "d",
            "zh-CN": "家庭增加储蓄",
            "en": "Households increase saving"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "政府购买道路维修服务。 增加购买或提高可支配收入；初始支出带来收入及后续消费；总需求右移并可能缩小衰退缺口 转移支付不是国民收入核算中的政府最终购买。",
          "en": "Government purchases road repair services. Increase purchases or disposable income; initial spending creates income and further consumption; aggregate demand shifts right and may narrow a recessionary gap Transfers are not government final purchases in national accounting."
        }
      },
      {
        "id": "u3-46-expansionary-fiscal-short-1",
        "knowledgePointId": "u3-46-expansionary-fiscal",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释扩张性财政政策的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Expansionary fiscal policy and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "增加政府购买、减税或增加转移可支持总需求；政府购买直接计入 G，转移支付则通过受益者支出间接影响需求。 增加购买或提高可支配收入；初始支出带来收入及后续消费；总需求右移并可能缩小衰退缺口 原创例：政府维修公共设施直接增加采购，给家庭补助则只有被消费的部分形成当期需求。闲置资源多时产出反应可能较大，进口泄漏、储蓄和执行延迟会削弱国内效果。",
          "en": "Higher government purchases, tax cuts or transfers can support aggregate demand. Purchases enter G directly; transfers affect demand indirectly through recipients' spending. Increase purchases or disposable income; initial spending creates income and further consumption; aggregate demand shifts right and may narrow a recessionary gap Illustrative example: repairs to public facilities directly raise purchases, whereas only the spent portion of household support generates current demand. Output may respond more with idle resources; imports, saving and implementation delays weaken domestic effects."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "可支配收入",
              "en": "disposable income"
            },
            "alternatives": {
              "zh-CN": [
                "可支配收入",
                "增加购买或提高可支配收入"
              ],
              "en": [
                "disposable income",
                "Increase purchases or disposable income"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "后续消费",
              "en": "further consumption"
            },
            "alternatives": {
              "zh-CN": [
                "后续消费",
                "初始支出带来收入及后续消费"
              ],
              "en": [
                "further consumption",
                "initial spending creates income and further consumption"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "总需求右移",
              "en": "aggregate demand shifts right"
            },
            "alternatives": {
              "zh-CN": [
                "总需求右移",
                "总需求右移并可能缩小衰退缺口"
              ],
              "en": [
                "aggregate demand shifts right",
                "aggregate demand shifts right and may narrow a recessionary gap"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-47-contractionary-fiscal",
      "slug": "contractionary-fiscal",
      "section": "3.6",
      "level": "core",
      "syllabusRefs": [
        "3.6 Fiscal policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.3",
          "pages": [
            398
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-45-fiscal-budget",
        "u3-46-expansionary-fiscal",
        "u3-48-automatic-stabilisers"
      ],
      "terms": [
        "紧缩性财政政策",
        "Contractionary fiscal policy",
        "提高税收",
        "raise taxes",
        "可支配收入",
        "disposable income",
        "通胀压力",
        "inflation pressure"
      ],
      "synonyms": {
        "zh-CN": [
          "提高税收",
          "可支配收入",
          "通胀压力"
        ],
        "en": [
          "raise taxes",
          "disposable income",
          "inflation pressure"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-47-contractionary-fiscal-flash-1",
        "u3-47-contractionary-fiscal-mcq-1",
        "u3-47-contractionary-fiscal-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-47-contractionary-fiscal",
        "locale": "zh-CN",
        "title": "紧缩性财政政策",
        "takeaway": "削减支出或增税可降低总需求以缓和过热或改善财政状况；对产出、分配与长期供给的影响取决于措施构成。",
        "definition": "削减支出或增税可降低总需求以缓和过热或改善财政状况；对产出、分配与长期供给的影响取决于措施构成。",
        "causalChain": [
          "削减购买或提高税收",
          "直接需求或可支配收入降低",
          "总需求相对左移使通胀压力减弱"
        ],
        "misconceptions": [
          "财政改善的直接核算效果与最终宏观效果应区分。"
        ],
        "examApplication": [
          "区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
        ],
        "summary": [
          "削减支出或增税可降低总需求以缓和过热或改善财政状况；对产出、分配与长期供给的影响取决于措施构成。",
          "财政改善的直接核算效果与最终宏观效果应区分。"
        ],
        "explanation": "削减购买或提高税收。直接需求或可支配收入降低。总需求相对左移使通胀压力减弱。\n\n### 原创情境与推导\n\n原创例：过热时提高收入税可能抑制消费，但若削减的是有效培训预算，也可能损害长期生产能力。衰退中紧缩可能降低税基，因此不能假定支出每减一单位，赤字就必减一单位。\n\n财政改善的直接核算效果与最终宏观效果应区分。\n\n区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
      },
      "en": {
        "id": "u3-47-contractionary-fiscal",
        "locale": "en",
        "title": "Contractionary fiscal policy",
        "takeaway": "Spending cuts or tax rises can lower aggregate demand to cool overheating or improve fiscal balances. Output, distribution and long-run supply effects depend on the policy mix.",
        "definition": "Spending cuts or tax rises can lower aggregate demand to cool overheating or improve fiscal balances. Output, distribution and long-run supply effects depend on the policy mix.",
        "causalChain": [
          "Cut purchases or raise taxes",
          "direct demand or disposable income falls",
          "aggregate demand shifts relatively left and inflation pressure weakens"
        ],
        "misconceptions": [
          "Distinguish direct accounting effects from final macroeconomic effects."
        ],
        "examApplication": [
          "Distinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
        ],
        "summary": [
          "Spending cuts or tax rises can lower aggregate demand to cool overheating or improve fiscal balances. Output, distribution and long-run supply effects depend on the policy mix.",
          "Distinguish direct accounting effects from final macroeconomic effects."
        ],
        "explanation": "Cut purchases or raise taxes.  direct demand or disposable income falls.  aggregate demand shifts relatively left and inflation pressure weakens.\n\n### Original scenario and reasoning\n\nIllustrative example: higher income tax during overheating may restrain consumption, but cutting effective training may also damage long-run capacity. In recession, tightening may shrink the tax base, so a unit spending cut need not reduce the deficit by a full unit.\n\nDistinguish direct accounting effects from final macroeconomic effects.\n\nDistinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
      }
    },
    "practice": [
      {
        "id": "u3-47-contractionary-fiscal-flash-1",
        "knowledgePointId": "u3-47-contractionary-fiscal",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“紧缩性财政政策”，并说明一个关键条件。",
          "en": "Explain Contractionary fiscal policy and state one important condition."
        },
        "answer": {
          "zh-CN": "削减支出或增税可降低总需求以缓和过热或改善财政状况；对产出、分配与长期供给的影响取决于措施构成。",
          "en": "Spending cuts or tax rises can lower aggregate demand to cool overheating or improve fiscal balances. Output, distribution and long-run supply effects depend on the policy mix."
        },
        "explanation": {
          "zh-CN": "财政改善的直接核算效果与最终宏观效果应区分。",
          "en": "Distinguish direct accounting effects from final macroeconomic effects."
        }
      },
      {
        "id": "u3-47-contractionary-fiscal-mcq-1",
        "knowledgePointId": "u3-47-contractionary-fiscal",
        "type": "mcq",
        "prompt": {
          "zh-CN": "紧缩政策的合理风险提示？",
          "en": "A reasonable risk of fiscal tightening?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "产出必然上升",
            "en": "Output necessarily rises"
          },
          {
            "id": "b",
            "zh-CN": "分配不可能改变",
            "en": "Distribution cannot change"
          },
          {
            "id": "c",
            "zh-CN": "需求和税基可能同时下降",
            "en": "Demand and the tax base may both fall"
          },
          {
            "id": "d",
            "zh-CN": "所有削支都提高潜在产出",
            "en": "Every spending cut raises potential output"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "需求和税基可能同时下降。 削减购买或提高税收；直接需求或可支配收入降低；总需求相对左移使通胀压力减弱 财政改善的直接核算效果与最终宏观效果应区分。",
          "en": "Demand and the tax base may both fall. Cut purchases or raise taxes; direct demand or disposable income falls; aggregate demand shifts relatively left and inflation pressure weakens Distinguish direct accounting effects from final macroeconomic effects."
        }
      },
      {
        "id": "u3-47-contractionary-fiscal-short-1",
        "knowledgePointId": "u3-47-contractionary-fiscal",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释紧缩性财政政策的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Contractionary fiscal policy and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "削减支出或增税可降低总需求以缓和过热或改善财政状况；对产出、分配与长期供给的影响取决于措施构成。 削减购买或提高税收；直接需求或可支配收入降低；总需求相对左移使通胀压力减弱 原创例：过热时提高收入税可能抑制消费，但若削减的是有效培训预算，也可能损害长期生产能力。衰退中紧缩可能降低税基，因此不能假定支出每减一单位，赤字就必减一单位。",
          "en": "Spending cuts or tax rises can lower aggregate demand to cool overheating or improve fiscal balances. Output, distribution and long-run supply effects depend on the policy mix. Cut purchases or raise taxes; direct demand or disposable income falls; aggregate demand shifts relatively left and inflation pressure weakens Illustrative example: higher income tax during overheating may restrain consumption, but cutting effective training may also damage long-run capacity. In recession, tightening may shrink the tax base, so a unit spending cut need not reduce the deficit by a full unit."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "提高税收",
              "en": "raise taxes"
            },
            "alternatives": {
              "zh-CN": [
                "提高税收",
                "削减购买或提高税收"
              ],
              "en": [
                "raise taxes",
                "Cut purchases or raise taxes"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "可支配收入",
              "en": "disposable income"
            },
            "alternatives": {
              "zh-CN": [
                "可支配收入",
                "直接需求或可支配收入降低"
              ],
              "en": [
                "disposable income",
                "direct demand or disposable income falls"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "通胀压力",
              "en": "inflation pressure"
            },
            "alternatives": {
              "zh-CN": [
                "通胀压力",
                "总需求相对左移使通胀压力减弱"
              ],
              "en": [
                "inflation pressure",
                "aggregate demand shifts relatively left and inflation pressure weakens"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-48-automatic-stabilisers",
      "slug": "automatic-stabilisers",
      "section": "3.6",
      "level": "hl",
      "syllabusRefs": [
        "3.6 Fiscal policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.3",
          "pages": [
            398
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-45-fiscal-budget",
        "u3-46-expansionary-fiscal",
        "u3-47-contractionary-fiscal"
      ],
      "terms": [
        "自动稳定器",
        "Automatic stabilisers",
        "福利支出",
        "benefits",
        "可支配收入",
        "disposable income",
        "总需求",
        "aggregate demand"
      ],
      "synonyms": {
        "zh-CN": [
          "福利支出",
          "可支配收入",
          "总需求"
        ],
        "en": [
          "benefits",
          "disposable income",
          "aggregate demand"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-48-automatic-stabilisers-flash-1",
        "u3-48-automatic-stabilisers-mcq-1",
        "u3-48-automatic-stabilisers-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-48-automatic-stabilisers",
        "locale": "zh-CN",
        "title": "自动稳定器",
        "takeaway": "税收与符合资格的转移随收入和就业自动变化，可缓和周期波动，无须每次通过新的主动决策。",
        "definition": "税收与符合资格的转移随收入和就业自动变化，可缓和周期波动，无须每次通过新的主动决策。",
        "causalChain": [
          "衰退降低税款并提高部分福利支出",
          "可支配收入跌幅得到缓冲",
          "消费与总需求的下降减弱"
        ],
        "misconceptions": [
          "自动不等于没有制度设计，也不等于新刺激法案。"
        ],
        "examApplication": [
          "区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
        ],
        "summary": [
          "税收与符合资格的转移随收入和就业自动变化，可缓和周期波动，无须每次通过新的主动决策。",
          "自动不等于没有制度设计，也不等于新刺激法案。"
        ],
        "explanation": "衰退降低税款并提高部分福利支出。可支配收入跌幅得到缓冲。消费与总需求的下降减弱。\n\n### 原创情境与推导\n\n原创例：失业增加后，原有失业保险规则自动支付更多补助，预算趋向赤字。它缓冲而非消除衰退；覆盖有限、资格限制或低替代率会削弱稳定作用。景气时税收回升则有反向作用。\n\n自动不等于没有制度设计，也不等于新刺激法案。\n\n区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
      },
      "en": {
        "id": "u3-48-automatic-stabilisers",
        "locale": "en",
        "title": "Automatic stabilisers",
        "takeaway": "Taxes and eligible transfers change automatically with income and employment, moderating cyclical fluctuations without a fresh discretionary decision each time.",
        "definition": "Taxes and eligible transfers change automatically with income and employment, moderating cyclical fluctuations without a fresh discretionary decision each time.",
        "causalChain": [
          "Recession lowers tax payments and raises some benefits",
          "disposable income falls less sharply",
          "consumption and aggregate demand decline less"
        ],
        "misconceptions": [
          "Automatic does not mean undesigned or a new stimulus law."
        ],
        "examApplication": [
          "Distinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
        ],
        "summary": [
          "Taxes and eligible transfers change automatically with income and employment, moderating cyclical fluctuations without a fresh discretionary decision each time.",
          "Automatic does not mean undesigned or a new stimulus law."
        ],
        "explanation": "Recession lowers tax payments and raises some benefits.  disposable income falls less sharply.  consumption and aggregate demand decline less.\n\n### Original scenario and reasoning\n\nIllustrative example: existing unemployment insurance rules automatically pay more benefits as unemployment rises, pushing the budget toward deficit. They cushion rather than eliminate recession; limited coverage, eligibility restrictions or low replacement rates weaken stabilisation. Recovering tax revenues work in reverse during expansion.\n\nAutomatic does not mean undesigned or a new stimulus law.\n\nDistinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
      }
    },
    "practice": [
      {
        "id": "u3-48-automatic-stabilisers-flash-1",
        "knowledgePointId": "u3-48-automatic-stabilisers",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“自动稳定器”，并说明一个关键条件。",
          "en": "Explain Automatic stabilisers and state one important condition."
        },
        "answer": {
          "zh-CN": "税收与符合资格的转移随收入和就业自动变化，可缓和周期波动，无须每次通过新的主动决策。",
          "en": "Taxes and eligible transfers change automatically with income and employment, moderating cyclical fluctuations without a fresh discretionary decision each time."
        },
        "explanation": {
          "zh-CN": "自动不等于没有制度设计，也不等于新刺激法案。",
          "en": "Automatic does not mean undesigned or a new stimulus law."
        }
      },
      {
        "id": "u3-48-automatic-stabilisers-mcq-1",
        "knowledgePointId": "u3-48-automatic-stabilisers",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪项属于自动稳定器？",
          "en": "Which is an automatic stabiliser?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "临时新批准的大型基建",
            "en": "A newly approved infrastructure programme"
          },
          {
            "id": "b",
            "zh-CN": "临时改变税率的投票",
            "en": "A vote to change tax rates"
          },
          {
            "id": "c",
            "zh-CN": "央行新一次降息",
            "en": "A fresh central-bank rate cut"
          },
          {
            "id": "d",
            "zh-CN": "按既有规则随失业增加的福利支出",
            "en": "Benefits rising with unemployment under existing rules"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "按既有规则随失业增加的福利支出。 衰退降低税款并提高部分福利支出；可支配收入跌幅得到缓冲；消费与总需求的下降减弱 自动不等于没有制度设计，也不等于新刺激法案。",
          "en": "Benefits rising with unemployment under existing rules. Recession lowers tax payments and raises some benefits; disposable income falls less sharply; consumption and aggregate demand decline less Automatic does not mean undesigned or a new stimulus law."
        }
      },
      {
        "id": "u3-48-automatic-stabilisers-short-1",
        "knowledgePointId": "u3-48-automatic-stabilisers",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释自动稳定器的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Automatic stabilisers and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "税收与符合资格的转移随收入和就业自动变化，可缓和周期波动，无须每次通过新的主动决策。 衰退降低税款并提高部分福利支出；可支配收入跌幅得到缓冲；消费与总需求的下降减弱 原创例：失业增加后，原有失业保险规则自动支付更多补助，预算趋向赤字。它缓冲而非消除衰退；覆盖有限、资格限制或低替代率会削弱稳定作用。景气时税收回升则有反向作用。",
          "en": "Taxes and eligible transfers change automatically with income and employment, moderating cyclical fluctuations without a fresh discretionary decision each time. Recession lowers tax payments and raises some benefits; disposable income falls less sharply; consumption and aggregate demand decline less Illustrative example: existing unemployment insurance rules automatically pay more benefits as unemployment rises, pushing the budget toward deficit. They cushion rather than eliminate recession; limited coverage, eligibility restrictions or low replacement rates weaken stabilisation. Recovering tax revenues work in reverse during expansion."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "福利支出",
              "en": "benefits"
            },
            "alternatives": {
              "zh-CN": [
                "福利支出",
                "衰退降低税款并提高部分福利支出"
              ],
              "en": [
                "benefits",
                "Recession lowers tax payments and raises some benefits"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "可支配收入",
              "en": "disposable income"
            },
            "alternatives": {
              "zh-CN": [
                "可支配收入",
                "可支配收入跌幅得到缓冲"
              ],
              "en": [
                "disposable income",
                "disposable income falls less sharply"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "总需求",
              "en": "aggregate demand"
            },
            "alternatives": {
              "zh-CN": [
                "总需求",
                "消费与总需求的下降减弱"
              ],
              "en": [
                "aggregate demand",
                "consumption and aggregate demand decline less"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-49-multiplier",
      "slug": "multiplier",
      "section": "3.6",
      "level": "hl",
      "syllabusRefs": [
        "3.6 Fiscal policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.4",
          "pages": [
            407
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-45-fiscal-budget",
        "u3-46-expansionary-fiscal",
        "u3-47-contractionary-fiscal"
      ],
      "terms": [
        "凯恩斯乘数",
        "The Keynesian multiplier",
        "首轮收入",
        "first-round income",
        "国内支出",
        "domestic spending",
        "进口",
        "imports"
      ],
      "synonyms": {
        "zh-CN": [
          "首轮收入",
          "国内支出",
          "进口"
        ],
        "en": [
          "first-round income",
          "domestic spending",
          "imports"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-49-multiplier-flash-1",
        "u3-49-multiplier-mcq-1",
        "u3-49-multiplier-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-49-multiplier",
        "locale": "zh-CN",
        "title": "凯恩斯乘数",
        "takeaway": "简单开放经济模型中，边际漏出以同一新增收入为基数时，乘数 k = 1/(MPS + MPT + MPM)，收入变化为 k 乘初始自主支出变化。",
        "definition": "简单开放经济模型中，边际漏出以同一新增收入为基数时，乘数 k = 1/(MPS + MPT + MPM)，收入变化为 k 乘初始自主支出变化。",
        "causalChain": [
          "自主支出创造首轮收入",
          "部分收入形成下一轮国内支出",
          "储蓄税收进口使后续轮次逐渐缩小"
        ],
        "misconceptions": [
          "不要混用税前与税后收入口径的边际倾向。"
        ],
        "examApplication": [
          "区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
        ],
        "summary": [
          "简单开放经济模型中，边际漏出以同一新增收入为基数时，乘数 k = 1/(MPS + MPT + MPM)，收入变化为 k 乘初始自主支出变化。",
          "不要混用税前与税后收入口径的边际倾向。"
        ],
        "explanation": "自主支出创造首轮收入。部分收入形成下一轮国内支出。储蓄税收进口使后续轮次逐渐缩小。\n\n### 原创情境与推导\n\n原创例：以同一新增总收入为基数，MPS=0.2、MPT=0.1、MPM=0.2，k=2，新增政府购买 10 对应模型收入增加 20。封闭无政府模型 k=1/(1−MPC)。若 c 是可支配收入的消费倾向、t 为总收入比例税率、m 为总收入进口倾向，则 k=1/[1−c(1−t)+m]；不能混用基数。模型假定闲置产能、价格不变且忽略挤出与政策反应。\n\n不要混用税前与税后收入口径的边际倾向。\n\n区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
      },
      "en": {
        "id": "u3-49-multiplier",
        "locale": "en",
        "title": "The Keynesian multiplier",
        "takeaway": "In a simple open-economy model, with marginal leakages measured against the same additional income, k = 1/(MPS + MPT + MPM). Income changes by k times the initial autonomous spending change.",
        "definition": "In a simple open-economy model, with marginal leakages measured against the same additional income, k = 1/(MPS + MPT + MPM). Income changes by k times the initial autonomous spending change.",
        "causalChain": [
          "Autonomous spending creates first-round income",
          "part funds further domestic spending",
          "saving, taxes and imports shrink subsequent rounds"
        ],
        "misconceptions": [
          "Do not mix marginal propensities measured against pre-tax and post-tax income."
        ],
        "examApplication": [
          "Distinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
        ],
        "summary": [
          "In a simple open-economy model, with marginal leakages measured against the same additional income, k = 1/(MPS + MPT + MPM). Income changes by k times the initial autonomous spending change.",
          "Do not mix marginal propensities measured against pre-tax and post-tax income."
        ],
        "explanation": "Autonomous spending creates first-round income.  part funds further domestic spending.  saving, taxes and imports shrink subsequent rounds.\n\n### Original scenario and reasoning\n\nIllustrative example: with all leakages measured against the same extra gross income, MPS=0.2, MPT=0.1 and MPM=0.2 give k=2, so ten of extra government purchases yields twenty of model income. In a closed model without government, k=1/(1−MPC). If c is consumption out of disposable income, t a proportional tax on gross income and m imports out of gross income, k=1/[1−c(1−t)+m]. Do not mix bases. Assume spare capacity, fixed prices and no crowding out or policy response.\n\nDo not mix marginal propensities measured against pre-tax and post-tax income.\n\nDistinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
      }
    },
    "practice": [
      {
        "id": "u3-49-multiplier-flash-1",
        "knowledgePointId": "u3-49-multiplier",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“凯恩斯乘数”，并说明一个关键条件。",
          "en": "Explain The Keynesian multiplier and state one important condition."
        },
        "answer": {
          "zh-CN": "简单开放经济模型中，边际漏出以同一新增收入为基数时，乘数 k = 1/(MPS + MPT + MPM)，收入变化为 k 乘初始自主支出变化。",
          "en": "In a simple open-economy model, with marginal leakages measured against the same additional income, k = 1/(MPS + MPT + MPM). Income changes by k times the initial autonomous spending change."
        },
        "explanation": {
          "zh-CN": "不要混用税前与税后收入口径的边际倾向。",
          "en": "Do not mix marginal propensities measured against pre-tax and post-tax income."
        }
      },
      {
        "id": "u3-49-multiplier-mcq-1",
        "knowledgePointId": "u3-49-multiplier",
        "type": "mcq",
        "prompt": {
          "zh-CN": "总边际漏出 0.4，初始支出增加 8，模型 ΔY？",
          "en": "Total marginal leakage is 0.4 and initial spending rises by 8. Model ΔY?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "20",
            "en": "20"
          },
          {
            "id": "b",
            "zh-CN": "3.2",
            "en": "3.2"
          },
          {
            "id": "c",
            "zh-CN": "8",
            "en": "8"
          },
          {
            "id": "d",
            "zh-CN": "0.05",
            "en": "0.05"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "20。 k = 1 / 0.4 = 2.5; ΔY = 2.5 × 8 = 20 不要混用税前与税后收入口径的边际倾向。",
          "en": "20. k = 1 / 0.4 = 2.5; ΔY = 2.5 × 8 = 20 Do not mix marginal propensities measured against pre-tax and post-tax income."
        }
      },
      {
        "id": "u3-49-multiplier-short-1",
        "knowledgePointId": "u3-49-multiplier",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释凯恩斯乘数的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of The Keynesian multiplier and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "简单开放经济模型中，边际漏出以同一新增收入为基数时，乘数 k = 1/(MPS + MPT + MPM)，收入变化为 k 乘初始自主支出变化。 自主支出创造首轮收入；部分收入形成下一轮国内支出；储蓄税收进口使后续轮次逐渐缩小 原创例：以同一新增总收入为基数，MPS=0.2、MPT=0.1、MPM=0.2，k=2，新增政府购买 10 对应模型收入增加 20。封闭无政府模型 k=1/(1−MPC)。若 c 是可支配收入的消费倾向、t 为总收入比例税率、m 为总收入进口倾向，则 k=1/[1−c(1−t)+m]；不能混用基数。模型假定闲置产能、价格不变且忽略挤出与政策反应。",
          "en": "In a simple open-economy model, with marginal leakages measured against the same additional income, k = 1/(MPS + MPT + MPM). Income changes by k times the initial autonomous spending change. Autonomous spending creates first-round income; part funds further domestic spending; saving, taxes and imports shrink subsequent rounds Illustrative example: with all leakages measured against the same extra gross income, MPS=0.2, MPT=0.1 and MPM=0.2 give k=2, so ten of extra government purchases yields twenty of model income. In a closed model without government, k=1/(1−MPC). If c is consumption out of disposable income, t a proportional tax on gross income and m imports out of gross income, k=1/[1−c(1−t)+m]. Do not mix bases. Assume spare capacity, fixed prices and no crowding out or policy response."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "首轮收入",
              "en": "first-round income"
            },
            "alternatives": {
              "zh-CN": [
                "首轮收入",
                "自主支出创造首轮收入"
              ],
              "en": [
                "first-round income",
                "Autonomous spending creates first-round income"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "国内支出",
              "en": "domestic spending"
            },
            "alternatives": {
              "zh-CN": [
                "国内支出",
                "部分收入形成下一轮国内支出"
              ],
              "en": [
                "domestic spending",
                "part funds further domestic spending"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "进口",
              "en": "imports"
            },
            "alternatives": {
              "zh-CN": [
                "进口",
                "储蓄税收进口使后续轮次逐渐缩小"
              ],
              "en": [
                "imports",
                "saving, taxes and imports shrink subsequent rounds"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-50-crowding-out",
      "slug": "crowding-out",
      "section": "3.6",
      "level": "hl",
      "syllabusRefs": [
        "3.6 Fiscal policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.3",
          "pages": [
            398
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-45-fiscal-budget",
        "u3-46-expansionary-fiscal",
        "u3-47-contractionary-fiscal"
      ],
      "terms": [
        "挤出效应",
        "Crowding out",
        "融资",
        "financing",
        "投入成本",
        "input costs",
        "私人投资",
        "private investment"
      ],
      "synonyms": {
        "zh-CN": [
          "融资",
          "投入成本",
          "私人投资"
        ],
        "en": [
          "financing",
          "input costs",
          "private investment"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-50-crowding-out-flash-1",
        "u3-50-crowding-out-mcq-1",
        "u3-50-crowding-out-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-50-crowding-out",
        "locale": "zh-CN",
        "title": "挤出效应",
        "takeaway": "政府扩张可能经利率、资源竞争或汇率挤出私人支出，但程度取决于产能、货币政策和融资条件，并非必然完全挤出。",
        "definition": "政府扩张可能经利率、资源竞争或汇率挤出私人支出，但程度取决于产能、货币政策和融资条件，并非必然完全挤出。",
        "causalChain": [
          "政府扩张增加融资或资源需求",
          "利率或投入成本可能上升",
          "部分私人投资消费或净出口被抵消"
        ],
        "misconceptions": [
          "政府借款增加不能单独证明私人投资等额下降。"
        ],
        "examApplication": [
          "区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
        ],
        "summary": [
          "政府扩张可能经利率、资源竞争或汇率挤出私人支出，但程度取决于产能、货币政策和融资条件，并非必然完全挤出。",
          "政府借款增加不能单独证明私人投资等额下降。"
        ],
        "explanation": "政府扩张增加融资或资源需求。利率或投入成本可能上升。部分私人投资消费或净出口被抵消。\n\n### 原创情境与推导\n\n原创例：满负荷时公共工程争夺建筑工人，私人项目成本上升；深度衰退且货币宽松时，这类压力可能较弱。改善运输的公共投资还可能降低企业成本，形成挤入，需区分短期与长期。\n\n政府借款增加不能单独证明私人投资等额下降。\n\n区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
      },
      "en": {
        "id": "u3-50-crowding-out",
        "locale": "en",
        "title": "Crowding out",
        "takeaway": "Fiscal expansion may displace private spending through interest rates, competition for resources or exchange rates. Its extent depends on capacity, monetary policy and financing conditions; full crowding out is not inevitable.",
        "definition": "Fiscal expansion may displace private spending through interest rates, competition for resources or exchange rates. Its extent depends on capacity, monetary policy and financing conditions; full crowding out is not inevitable.",
        "causalChain": [
          "Fiscal expansion raises financing or resource demand",
          "interest rates or input costs may rise",
          "some private investment, consumption or net exports are offset"
        ],
        "misconceptions": [
          "Higher government borrowing alone does not prove an equal fall in private investment."
        ],
        "examApplication": [
          "Distinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
        ],
        "summary": [
          "Fiscal expansion may displace private spending through interest rates, competition for resources or exchange rates. Its extent depends on capacity, monetary policy and financing conditions; full crowding out is not inevitable.",
          "Higher government borrowing alone does not prove an equal fall in private investment."
        ],
        "explanation": "Fiscal expansion raises financing or resource demand.  interest rates or input costs may rise.  some private investment, consumption or net exports are offset.\n\n### Original scenario and reasoning\n\nIllustrative example: at capacity, public works compete for construction workers and raise private project costs. Such pressure may be weaker in a deep recession with monetary accommodation. Transport investment may also lower firms' costs and crowd investment in over time.\n\nHigher government borrowing alone does not prove an equal fall in private investment.\n\nDistinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
      }
    },
    "practice": [
      {
        "id": "u3-50-crowding-out-flash-1",
        "knowledgePointId": "u3-50-crowding-out",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“挤出效应”，并说明一个关键条件。",
          "en": "Explain Crowding out and state one important condition."
        },
        "answer": {
          "zh-CN": "政府扩张可能经利率、资源竞争或汇率挤出私人支出，但程度取决于产能、货币政策和融资条件，并非必然完全挤出。",
          "en": "Fiscal expansion may displace private spending through interest rates, competition for resources or exchange rates. Its extent depends on capacity, monetary policy and financing conditions; full crowding out is not inevitable."
        },
        "explanation": {
          "zh-CN": "政府借款增加不能单独证明私人投资等额下降。",
          "en": "Higher government borrowing alone does not prove an equal fall in private investment."
        }
      },
      {
        "id": "u3-50-crowding-out-mcq-1",
        "knowledgePointId": "u3-50-crowding-out",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪种条件下资源挤出更可能较强？",
          "en": "When is resource crowding out more likely to be strong?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "大量工人设备闲置",
            "en": "Extensive idle labour and equipment"
          },
          {
            "id": "b",
            "zh-CN": "经济接近产能上限",
            "en": "The economy is close to capacity"
          },
          {
            "id": "c",
            "zh-CN": "所有公共投资毫无成本",
            "en": "All public investment is costless"
          },
          {
            "id": "d",
            "zh-CN": "利率永远不变即可排除资源竞争",
            "en": "Fixed interest alone rules out resource competition"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "经济接近产能上限。 政府扩张增加融资或资源需求；利率或投入成本可能上升；部分私人投资消费或净出口被抵消 政府借款增加不能单独证明私人投资等额下降。",
          "en": "The economy is close to capacity. Fiscal expansion raises financing or resource demand; interest rates or input costs may rise; some private investment, consumption or net exports are offset Higher government borrowing alone does not prove an equal fall in private investment."
        }
      },
      {
        "id": "u3-50-crowding-out-short-1",
        "knowledgePointId": "u3-50-crowding-out",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释挤出效应的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Crowding out and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "政府扩张可能经利率、资源竞争或汇率挤出私人支出，但程度取决于产能、货币政策和融资条件，并非必然完全挤出。 政府扩张增加融资或资源需求；利率或投入成本可能上升；部分私人投资消费或净出口被抵消 原创例：满负荷时公共工程争夺建筑工人，私人项目成本上升；深度衰退且货币宽松时，这类压力可能较弱。改善运输的公共投资还可能降低企业成本，形成挤入，需区分短期与长期。",
          "en": "Fiscal expansion may displace private spending through interest rates, competition for resources or exchange rates. Its extent depends on capacity, monetary policy and financing conditions; full crowding out is not inevitable. Fiscal expansion raises financing or resource demand; interest rates or input costs may rise; some private investment, consumption or net exports are offset Illustrative example: at capacity, public works compete for construction workers and raise private project costs. Such pressure may be weaker in a deep recession with monetary accommodation. Transport investment may also lower firms' costs and crowd investment in over time."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "融资",
              "en": "financing"
            },
            "alternatives": {
              "zh-CN": [
                "融资",
                "政府扩张增加融资或资源需求"
              ],
              "en": [
                "financing",
                "Fiscal expansion raises financing or resource demand"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "投入成本",
              "en": "input costs"
            },
            "alternatives": {
              "zh-CN": [
                "投入成本",
                "利率或投入成本可能上升"
              ],
              "en": [
                "input costs",
                "interest rates or input costs may rise"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "私人投资",
              "en": "private investment"
            },
            "alternatives": {
              "zh-CN": [
                "私人投资",
                "部分私人投资消费或净出口被抵消"
              ],
              "en": [
                "private investment",
                "some private investment, consumption or net exports are offset"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-51-fiscal-evaluation",
      "slug": "fiscal-evaluation",
      "section": "3.6",
      "level": "core",
      "syllabusRefs": [
        "3.6 Fiscal policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.3",
          "pages": [
            398
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-45-fiscal-budget",
        "u3-46-expansionary-fiscal",
        "u3-47-contractionary-fiscal"
      ],
      "terms": [
        "财政政策评价",
        "Evaluating fiscal policy",
        "产出缺口",
        "output gap",
        "漏出",
        "leakages",
        "长期财政供给",
        "long-run fiscal and supply"
      ],
      "synonyms": {
        "zh-CN": [
          "产出缺口",
          "漏出",
          "长期财政供给"
        ],
        "en": [
          "output gap",
          "leakages",
          "long-run fiscal and supply"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-51-fiscal-evaluation-flash-1",
        "u3-51-fiscal-evaluation-mcq-1",
        "u3-51-fiscal-evaluation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-51-fiscal-evaluation",
        "locale": "zh-CN",
        "title": "财政政策评价",
        "takeaway": "财政评价应比较乘数、时滞、债务可持续性、分配和供给效应，并按经济状况与支出税收构成作条件性判断。",
        "definition": "财政评价应比较乘数、时滞、债务可持续性、分配和供给效应，并按经济状况与支出税收构成作条件性判断。",
        "causalChain": [
          "判断产出缺口与政策目标",
          "检查设计审批执行及漏出",
          "权衡短期稳定与长期财政供给结果"
        ],
        "misconceptions": [
          "不能仅凭赤字大小或单一乘数宣布政策成功。"
        ],
        "examApplication": [
          "区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
        ],
        "summary": [
          "财政评价应比较乘数、时滞、债务可持续性、分配和供给效应，并按经济状况与支出税收构成作条件性判断。",
          "不能仅凭赤字大小或单一乘数宣布政策成功。"
        ],
        "explanation": "判断产出缺口与政策目标。检查设计审批执行及漏出。权衡短期稳定与长期财政供给结果。\n\n### 原创情境与推导\n\n原创例：快速现金支持可能较早稳定需求，建设铁路则准备期长却可能提高未来生产能力。高进口倾向会减少国内需求效应，但进口设备也能扩充供给。融资币种、利息与未来税基均关系债务风险。\n\n不能仅凭赤字大小或单一乘数宣布政策成功。\n\n区分购买与转移、流量与存量，评价漏出、时滞、挤出和债务。"
      },
      "en": {
        "id": "u3-51-fiscal-evaluation",
        "locale": "en",
        "title": "Evaluating fiscal policy",
        "takeaway": "Fiscal evaluation compares multipliers, lags, debt sustainability, distribution and supply effects, reaching conditional conclusions based on economic conditions and the spending-tax mix.",
        "definition": "Fiscal evaluation compares multipliers, lags, debt sustainability, distribution and supply effects, reaching conditional conclusions based on economic conditions and the spending-tax mix.",
        "causalChain": [
          "Identify the output gap and objective",
          "examine design, approval, implementation and leakages",
          "weigh short-run stabilisation against long-run fiscal and supply outcomes"
        ],
        "misconceptions": [
          "Neither deficit size nor a single multiplier establishes policy success."
        ],
        "examApplication": [
          "Distinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
        ],
        "summary": [
          "Fiscal evaluation compares multipliers, lags, debt sustainability, distribution and supply effects, reaching conditional conclusions based on economic conditions and the spending-tax mix.",
          "Neither deficit size nor a single multiplier establishes policy success."
        ],
        "explanation": "Identify the output gap and objective.  examine design, approval, implementation and leakages.  weigh short-run stabilisation against long-run fiscal and supply outcomes.\n\n### Original scenario and reasoning\n\nIllustrative example: cash support may stabilise demand sooner, whereas rail construction has long preparation but may raise future capacity. High import propensity reduces domestic demand effects, yet imported equipment can expand supply. Financing currency, interest and future tax bases all matter for debt risk.\n\nNeither deficit size nor a single multiplier establishes policy success.\n\nDistinguish purchases/transfers and flows/stocks; evaluate leakages, lags, crowding out and debt."
      }
    },
    "practice": [
      {
        "id": "u3-51-fiscal-evaluation-flash-1",
        "knowledgePointId": "u3-51-fiscal-evaluation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“财政政策评价”，并说明一个关键条件。",
          "en": "Explain Evaluating fiscal policy and state one important condition."
        },
        "answer": {
          "zh-CN": "财政评价应比较乘数、时滞、债务可持续性、分配和供给效应，并按经济状况与支出税收构成作条件性判断。",
          "en": "Fiscal evaluation compares multipliers, lags, debt sustainability, distribution and supply effects, reaching conditional conclusions based on economic conditions and the spending-tax mix."
        },
        "explanation": {
          "zh-CN": "不能仅凭赤字大小或单一乘数宣布政策成功。",
          "en": "Neither deficit size nor a single multiplier establishes policy success."
        }
      },
      {
        "id": "u3-51-fiscal-evaluation-mcq-1",
        "knowledgePointId": "u3-51-fiscal-evaluation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "比较现金支持与基建时应考虑什么？",
          "en": "What matters when comparing cash support and infrastructure?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只看名称是否积极",
            "en": "Only whether the name sounds positive"
          },
          {
            "id": "b",
            "zh-CN": "假定进口完全无影响",
            "en": "Assume imports have no effects"
          },
          {
            "id": "c",
            "zh-CN": "实施时滞与长期供给效果",
            "en": "Implementation lags and long-run supply effects"
          },
          {
            "id": "d",
            "zh-CN": "忽略融资和分配",
            "en": "Ignore financing and distribution"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "实施时滞与长期供给效果。 判断产出缺口与政策目标；检查设计审批执行及漏出；权衡短期稳定与长期财政供给结果 不能仅凭赤字大小或单一乘数宣布政策成功。",
          "en": "Implementation lags and long-run supply effects. Identify the output gap and objective; examine design, approval, implementation and leakages; weigh short-run stabilisation against long-run fiscal and supply outcomes Neither deficit size nor a single multiplier establishes policy success."
        }
      },
      {
        "id": "u3-51-fiscal-evaluation-short-1",
        "knowledgePointId": "u3-51-fiscal-evaluation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释财政政策评价的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Evaluating fiscal policy and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "财政评价应比较乘数、时滞、债务可持续性、分配和供给效应，并按经济状况与支出税收构成作条件性判断。 判断产出缺口与政策目标；检查设计审批执行及漏出；权衡短期稳定与长期财政供给结果 原创例：快速现金支持可能较早稳定需求，建设铁路则准备期长却可能提高未来生产能力。高进口倾向会减少国内需求效应，但进口设备也能扩充供给。融资币种、利息与未来税基均关系债务风险。",
          "en": "Fiscal evaluation compares multipliers, lags, debt sustainability, distribution and supply effects, reaching conditional conclusions based on economic conditions and the spending-tax mix. Identify the output gap and objective; examine design, approval, implementation and leakages; weigh short-run stabilisation against long-run fiscal and supply outcomes Illustrative example: cash support may stabilise demand sooner, whereas rail construction has long preparation but may raise future capacity. High import propensity reduces domestic demand effects, yet imported equipment can expand supply. Financing currency, interest and future tax bases all matter for debt risk."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "产出缺口",
              "en": "output gap"
            },
            "alternatives": {
              "zh-CN": [
                "产出缺口",
                "判断产出缺口与政策目标"
              ],
              "en": [
                "output gap",
                "Identify the output gap and objective"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "漏出",
              "en": "leakages"
            },
            "alternatives": {
              "zh-CN": [
                "漏出",
                "检查设计审批执行及漏出"
              ],
              "en": [
                "leakages",
                "examine design, approval, implementation and leakages"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "长期财政供给",
              "en": "long-run fiscal and supply"
            },
            "alternatives": {
              "zh-CN": [
                "长期财政供给",
                "权衡短期稳定与长期财政供给结果"
              ],
              "en": [
                "long-run fiscal and supply",
                "weigh short-run stabilisation against long-run fiscal and supply outcomes"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-52-market-based-supply",
      "slug": "market-based-supply",
      "section": "3.7",
      "level": "core",
      "syllabusRefs": [
        "3.7 Supply-side policies"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.6",
          "pages": [
            412
          ]
        }
      ],
      "prerequisites": [
        "u3-15-lras"
      ],
      "related": [
        "u3-53-interventionist-supply",
        "u3-54-labour-market",
        "u3-55-infrastructure-innovation"
      ],
      "terms": [
        "市场导向供给侧政策",
        "Market-based supply-side policies",
        "竞争",
        "competitive",
        "效率",
        "efficiency",
        "生产能力",
        "productive capacity"
      ],
      "synonyms": {
        "zh-CN": [
          "竞争",
          "效率",
          "生产能力"
        ],
        "en": [
          "competitive",
          "efficiency",
          "productive capacity"
        ]
      },
      "diagramIds": [
        "macro-lras"
      ],
      "quizIds": [
        "u3-52-market-based-supply-flash-1",
        "u3-52-market-based-supply-mcq-1",
        "u3-52-market-based-supply-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-52-market-based-supply",
        "locale": "zh-CN",
        "title": "市场导向供给侧政策",
        "takeaway": "竞争、适度放松管制、税收激励和私有化等政策试图改善资源配置与生产激励；成效取决于竞争环境和制度设计。",
        "definition": "竞争、适度放松管制、税收激励和私有化等政策试图改善资源配置与生产激励；成效取决于竞争环境和制度设计。",
        "causalChain": [
          "改变竞争或激励约束",
          "企业改善效率投资与创新",
          "生产能力可能提高使长期总供给右移"
        ],
        "misconceptions": [
          "放松管制不应被理解为移除一切安全和环境规则。"
        ],
        "examApplication": [
          "解释生产率与潜在产出的渠道，区分短期 AD 与长期 AS，并评价机会成本。"
        ],
        "summary": [
          "竞争、适度放松管制、税收激励和私有化等政策试图改善资源配置与生产激励；成效取决于竞争环境和制度设计。",
          "放松管制不应被理解为移除一切安全和环境规则。"
        ],
        "explanation": "改变竞争或激励约束。企业改善效率投资与创新。生产能力可能提高使长期总供给右移。\n\n### 原创情境与推导\n\n原创例：减少新企业不必要的注册障碍可能增强竞争，但将公共垄断直接出售为私人垄断并不保证效率或可负担性改善。减税若没有带来新增投资，财政收入损失未必换来预期产能。\n\n放松管制不应被理解为移除一切安全和环境规则。\n\n解释生产率与潜在产出的渠道，区分短期 AD 与长期 AS，并评价机会成本。"
      },
      "en": {
        "id": "u3-52-market-based-supply",
        "locale": "en",
        "title": "Market-based supply-side policies",
        "takeaway": "Competition, appropriate deregulation, tax incentives and privatisation seek to improve allocation and production incentives. Results depend on competitive conditions and institutional design.",
        "definition": "Competition, appropriate deregulation, tax incentives and privatisation seek to improve allocation and production incentives. Results depend on competitive conditions and institutional design.",
        "causalChain": [
          "Change competitive or incentive constraints",
          "firms improve efficiency, investment and innovation",
          "productive capacity may rise and LRAS shift right"
        ],
        "misconceptions": [
          "Deregulation need not mean removing all safety and environmental rules."
        ],
        "examApplication": [
          "Explain productivity and potential-output channels, distinguish short-run AD from long-run AS and evaluate opportunity costs."
        ],
        "summary": [
          "Competition, appropriate deregulation, tax incentives and privatisation seek to improve allocation and production incentives. Results depend on competitive conditions and institutional design.",
          "Deregulation need not mean removing all safety and environmental rules."
        ],
        "explanation": "Change competitive or incentive constraints.  firms improve efficiency, investment and innovation.  productive capacity may rise and LRAS shift right.\n\n### Original scenario and reasoning\n\nIllustrative example: removing unnecessary entry barriers may strengthen competition, but selling a public monopoly as a private monopoly does not guarantee efficiency or affordability. Tax cuts that fail to induce investment may lose revenue without delivering expected capacity.\n\nDeregulation need not mean removing all safety and environmental rules.\n\nExplain productivity and potential-output channels, distinguish short-run AD from long-run AS and evaluate opportunity costs."
      }
    },
    "practice": [
      {
        "id": "u3-52-market-based-supply-flash-1",
        "knowledgePointId": "u3-52-market-based-supply",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“市场导向供给侧政策”，并说明一个关键条件。",
          "en": "Explain Market-based supply-side policies and state one important condition."
        },
        "answer": {
          "zh-CN": "竞争、适度放松管制、税收激励和私有化等政策试图改善资源配置与生产激励；成效取决于竞争环境和制度设计。",
          "en": "Competition, appropriate deregulation, tax incentives and privatisation seek to improve allocation and production incentives. Results depend on competitive conditions and institutional design."
        },
        "explanation": {
          "zh-CN": "放松管制不应被理解为移除一切安全和环境规则。",
          "en": "Deregulation need not mean removing all safety and environmental rules."
        }
      },
      {
        "id": "u3-52-market-based-supply-mcq-1",
        "knowledgePointId": "u3-52-market-based-supply",
        "type": "mcq",
        "prompt": {
          "zh-CN": "私有化改善效率的重要条件？",
          "en": "An important condition for privatisation to improve efficiency?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "必然形成不受监管垄断",
            "en": "Necessarily unregulated monopoly"
          },
          {
            "id": "b",
            "zh-CN": "所有公共服务同时取消",
            "en": "All public services abolished"
          },
          {
            "id": "c",
            "zh-CN": "所有市场失灵自动消失",
            "en": "All market failures automatically disappear"
          },
          {
            "id": "d",
            "zh-CN": "有效竞争或合适监管",
            "en": "Effective competition or appropriate regulation"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "有效竞争或合适监管。 改变竞争或激励约束；企业改善效率投资与创新；生产能力可能提高使长期总供给右移 放松管制不应被理解为移除一切安全和环境规则。",
          "en": "Effective competition or appropriate regulation. Change competitive or incentive constraints; firms improve efficiency, investment and innovation; productive capacity may rise and LRAS shift right Deregulation need not mean removing all safety and environmental rules."
        }
      },
      {
        "id": "u3-52-market-based-supply-short-1",
        "knowledgePointId": "u3-52-market-based-supply",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释市场导向供给侧政策的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Market-based supply-side policies and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "竞争、适度放松管制、税收激励和私有化等政策试图改善资源配置与生产激励；成效取决于竞争环境和制度设计。 改变竞争或激励约束；企业改善效率投资与创新；生产能力可能提高使长期总供给右移 原创例：减少新企业不必要的注册障碍可能增强竞争，但将公共垄断直接出售为私人垄断并不保证效率或可负担性改善。减税若没有带来新增投资，财政收入损失未必换来预期产能。",
          "en": "Competition, appropriate deregulation, tax incentives and privatisation seek to improve allocation and production incentives. Results depend on competitive conditions and institutional design. Change competitive or incentive constraints; firms improve efficiency, investment and innovation; productive capacity may rise and LRAS shift right Illustrative example: removing unnecessary entry barriers may strengthen competition, but selling a public monopoly as a private monopoly does not guarantee efficiency or affordability. Tax cuts that fail to induce investment may lose revenue without delivering expected capacity."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "竞争",
              "en": "competitive"
            },
            "alternatives": {
              "zh-CN": [
                "竞争",
                "改变竞争或激励约束"
              ],
              "en": [
                "competitive",
                "Change competitive or incentive constraints"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "效率",
              "en": "efficiency"
            },
            "alternatives": {
              "zh-CN": [
                "效率",
                "企业改善效率投资与创新"
              ],
              "en": [
                "efficiency",
                "firms improve efficiency, investment and innovation"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "生产能力",
              "en": "productive capacity"
            },
            "alternatives": {
              "zh-CN": [
                "生产能力",
                "生产能力可能提高使长期总供给右移"
              ],
              "en": [
                "productive capacity",
                "productive capacity may rise and LRAS shift right"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-53-interventionist-supply",
      "slug": "interventionist-supply",
      "section": "3.7",
      "level": "core",
      "syllabusRefs": [
        "3.7 Supply-side policies"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.6",
          "pages": [
            412
          ]
        }
      ],
      "prerequisites": [
        "u3-15-lras"
      ],
      "related": [
        "u3-52-market-based-supply",
        "u3-54-labour-market",
        "u3-55-infrastructure-innovation"
      ],
      "terms": [
        "干预型供给侧政策",
        "Interventionist supply-side policies",
        "瓶颈",
        "bottlenecks",
        "投资",
        "investment",
        "潜在产出",
        "potential output"
      ],
      "synonyms": {
        "zh-CN": [
          "瓶颈",
          "投资",
          "潜在产出"
        ],
        "en": [
          "bottlenecks",
          "investment",
          "potential output"
        ]
      },
      "diagramIds": [
        "macro-lras"
      ],
      "quizIds": [
        "u3-53-interventionist-supply-flash-1",
        "u3-53-interventionist-supply-mcq-1",
        "u3-53-interventionist-supply-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-53-interventionist-supply",
        "locale": "zh-CN",
        "title": "干预型供给侧政策",
        "takeaway": "教育、培训、医疗、基础设施和研发支持旨在提升生产率与潜在产出，常针对外部收益、信息或协调失灵。",
        "definition": "教育、培训、医疗、基础设施和研发支持旨在提升生产率与潜在产出，常针对外部收益、信息或协调失灵。",
        "causalChain": [
          "识别技能健康或资本瓶颈",
          "公共服务和投资改善生产条件",
          "生产率与潜在产出可能长期增加"
        ],
        "misconceptions": [
          "投入金额不是生产率改善的充分证据。"
        ],
        "examApplication": [
          "解释生产率与潜在产出的渠道，区分短期 AD 与长期 AS，并评价机会成本。"
        ],
        "summary": [
          "教育、培训、医疗、基础设施和研发支持旨在提升生产率与潜在产出，常针对外部收益、信息或协调失灵。",
          "投入金额不是生产率改善的充分证据。"
        ],
        "explanation": "识别技能健康或资本瓶颈。公共服务和投资改善生产条件。生产率与潜在产出可能长期增加。\n\n### 原创情境与推导\n\n原创例：针对实际岗位需求的培训可减少技能错配，但没有雇主需求的课程未必增加就业。教育支出当期可能提高总需求，只有改善技能和生产率时才支持长期总供给，且往往需要较长时间。\n\n投入金额不是生产率改善的充分证据。\n\n解释生产率与潜在产出的渠道，区分短期 AD 与长期 AS，并评价机会成本。"
      },
      "en": {
        "id": "u3-53-interventionist-supply",
        "locale": "en",
        "title": "Interventionist supply-side policies",
        "takeaway": "Education, training, health, infrastructure and research support aim to raise productivity and potential output, often addressing external benefits, information or coordination failures.",
        "definition": "Education, training, health, infrastructure and research support aim to raise productivity and potential output, often addressing external benefits, information or coordination failures.",
        "causalChain": [
          "Identify skill, health or capital bottlenecks",
          "public services and investment improve production conditions",
          "productivity and potential output may increase over time"
        ],
        "misconceptions": [
          "Spending amounts are not sufficient evidence of productivity gains."
        ],
        "examApplication": [
          "Explain productivity and potential-output channels, distinguish short-run AD from long-run AS and evaluate opportunity costs."
        ],
        "summary": [
          "Education, training, health, infrastructure and research support aim to raise productivity and potential output, often addressing external benefits, information or coordination failures.",
          "Spending amounts are not sufficient evidence of productivity gains."
        ],
        "explanation": "Identify skill, health or capital bottlenecks.  public services and investment improve production conditions.  productivity and potential output may increase over time.\n\n### Original scenario and reasoning\n\nIllustrative example: training aligned with actual vacancies may reduce mismatch, whereas courses without employer demand may not increase employment. Education spending can raise current demand, but supports long-run supply only if skills and productivity improve, often after a long lag.\n\nSpending amounts are not sufficient evidence of productivity gains.\n\nExplain productivity and potential-output channels, distinguish short-run AD from long-run AS and evaluate opportunity costs."
      }
    },
    "practice": [
      {
        "id": "u3-53-interventionist-supply-flash-1",
        "knowledgePointId": "u3-53-interventionist-supply",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“干预型供给侧政策”，并说明一个关键条件。",
          "en": "Explain Interventionist supply-side policies and state one important condition."
        },
        "answer": {
          "zh-CN": "教育、培训、医疗、基础设施和研发支持旨在提升生产率与潜在产出，常针对外部收益、信息或协调失灵。",
          "en": "Education, training, health, infrastructure and research support aim to raise productivity and potential output, often addressing external benefits, information or coordination failures."
        },
        "explanation": {
          "zh-CN": "投入金额不是生产率改善的充分证据。",
          "en": "Spending amounts are not sufficient evidence of productivity gains."
        }
      },
      {
        "id": "u3-53-interventionist-supply-mcq-1",
        "knowledgePointId": "u3-53-interventionist-supply",
        "type": "mcq",
        "prompt": {
          "zh-CN": "教育支出提高 LRAS 的关键渠道？",
          "en": "The key channel through which education spending raises LRAS?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "提高技能与劳动生产率",
            "en": "Improved skills and labour productivity"
          },
          {
            "id": "b",
            "zh-CN": "仅仅提高当期 G 的账面值",
            "en": "Only a higher accounting value of current G"
          },
          {
            "id": "c",
            "zh-CN": "保证立即消除贫困",
            "en": "Guaranteed immediate elimination of poverty"
          },
          {
            "id": "d",
            "zh-CN": "自动使所有物价下降",
            "en": "Automatically lowers every price"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "提高技能与劳动生产率。 识别技能健康或资本瓶颈；公共服务和投资改善生产条件；生产率与潜在产出可能长期增加 投入金额不是生产率改善的充分证据。",
          "en": "Improved skills and labour productivity. Identify skill, health or capital bottlenecks; public services and investment improve production conditions; productivity and potential output may increase over time Spending amounts are not sufficient evidence of productivity gains."
        }
      },
      {
        "id": "u3-53-interventionist-supply-short-1",
        "knowledgePointId": "u3-53-interventionist-supply",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释干预型供给侧政策的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Interventionist supply-side policies and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "教育、培训、医疗、基础设施和研发支持旨在提升生产率与潜在产出，常针对外部收益、信息或协调失灵。 识别技能健康或资本瓶颈；公共服务和投资改善生产条件；生产率与潜在产出可能长期增加 原创例：针对实际岗位需求的培训可减少技能错配，但没有雇主需求的课程未必增加就业。教育支出当期可能提高总需求，只有改善技能和生产率时才支持长期总供给，且往往需要较长时间。",
          "en": "Education, training, health, infrastructure and research support aim to raise productivity and potential output, often addressing external benefits, information or coordination failures. Identify skill, health or capital bottlenecks; public services and investment improve production conditions; productivity and potential output may increase over time Illustrative example: training aligned with actual vacancies may reduce mismatch, whereas courses without employer demand may not increase employment. Education spending can raise current demand, but supports long-run supply only if skills and productivity improve, often after a long lag."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "瓶颈",
              "en": "bottlenecks"
            },
            "alternatives": {
              "zh-CN": [
                "瓶颈",
                "识别技能健康或资本瓶颈"
              ],
              "en": [
                "bottlenecks",
                "Identify skill, health or capital bottlenecks"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "投资",
              "en": "investment"
            },
            "alternatives": {
              "zh-CN": [
                "投资",
                "公共服务和投资改善生产条件"
              ],
              "en": [
                "investment",
                "public services and investment improve production conditions"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "潜在产出",
              "en": "potential output"
            },
            "alternatives": {
              "zh-CN": [
                "潜在产出",
                "生产率与潜在产出可能长期增加"
              ],
              "en": [
                "potential output",
                "productivity and potential output may increase over time"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-54-labour-market",
      "slug": "labour-market",
      "section": "3.7",
      "level": "core",
      "syllabusRefs": [
        "3.7 Supply-side policies"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.6",
          "pages": [
            412
          ]
        }
      ],
      "prerequisites": [
        "u3-15-lras"
      ],
      "related": [
        "u3-52-market-based-supply",
        "u3-53-interventionist-supply",
        "u3-55-infrastructure-innovation"
      ],
      "terms": [
        "劳动力市场政策",
        "Labour-market policies",
        "结构性失业",
        "structural unemployment",
        "匹配",
        "matching",
        "自然失业率",
        "natural unemployment rate"
      ],
      "synonyms": {
        "zh-CN": [
          "结构性失业",
          "匹配",
          "自然失业率"
        ],
        "en": [
          "structural unemployment",
          "matching",
          "natural unemployment rate"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-54-labour-market-flash-1",
        "u3-54-labour-market-mcq-1",
        "u3-54-labour-market-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-54-labour-market",
        "locale": "zh-CN",
        "title": "劳动力市场政策",
        "takeaway": "培训、就业信息、流动性支持与劳动制度改革可影响就业匹配和激励；效率、收入保障及劳动权利需要共同评价。",
        "definition": "培训、就业信息、流动性支持与劳动制度改革可影响就业匹配和激励；效率、收入保障及劳动权利需要共同评价。",
        "causalChain": [
          "诊断摩擦性或结构性失业原因",
          "改善匹配技能或地区流动",
          "可持续就业增加并可能降低自然失业率"
        ],
        "misconceptions": [
          "培训不直接解决总需求不足造成的所有周期性失业。"
        ],
        "examApplication": [
          "解释生产率与潜在产出的渠道，区分短期 AD 与长期 AS，并评价机会成本。"
        ],
        "summary": [
          "培训、就业信息、流动性支持与劳动制度改革可影响就业匹配和激励；效率、收入保障及劳动权利需要共同评价。",
          "培训不直接解决总需求不足造成的所有周期性失业。"
        ],
        "explanation": "诊断摩擦性或结构性失业原因。改善匹配技能或地区流动。可持续就业增加并可能降低自然失业率。\n\n### 原创情境与推导\n\n原创例：公共岗位平台改善信息，搬迁支持帮助跨地区求职，但高住房成本和照护责任仍可能限制流动。削弱劳动保护可能降低部分招聘成本，也可能加剧不安全感，不能只看工资下降。\n\n培训不直接解决总需求不足造成的所有周期性失业。\n\n解释生产率与潜在产出的渠道，区分短期 AD 与长期 AS，并评价机会成本。"
      },
      "en": {
        "id": "u3-54-labour-market",
        "locale": "en",
        "title": "Labour-market policies",
        "takeaway": "Training, job information, mobility support and labour reforms can affect matching and incentives. Evaluate efficiency alongside income security and labour rights.",
        "definition": "Training, job information, mobility support and labour reforms can affect matching and incentives. Evaluate efficiency alongside income security and labour rights.",
        "causalChain": [
          "Diagnose frictional or structural unemployment",
          "improve matching, skills or regional mobility",
          "sustainable employment rises and the natural unemployment rate may fall"
        ],
        "misconceptions": [
          "Training does not directly solve all cyclical unemployment caused by weak demand."
        ],
        "examApplication": [
          "Explain productivity and potential-output channels, distinguish short-run AD from long-run AS and evaluate opportunity costs."
        ],
        "summary": [
          "Training, job information, mobility support and labour reforms can affect matching and incentives. Evaluate efficiency alongside income security and labour rights.",
          "Training does not directly solve all cyclical unemployment caused by weak demand."
        ],
        "explanation": "Diagnose frictional or structural unemployment.  improve matching, skills or regional mobility.  sustainable employment rises and the natural unemployment rate may fall.\n\n### Original scenario and reasoning\n\nIllustrative example: public vacancy platforms improve information and relocation support aids regional job search, but housing costs and caring duties may still restrict mobility. Weaker protections may lower some hiring costs while increasing insecurity; lower wages alone are not a complete evaluation.\n\nTraining does not directly solve all cyclical unemployment caused by weak demand.\n\nExplain productivity and potential-output channels, distinguish short-run AD from long-run AS and evaluate opportunity costs."
      }
    },
    "practice": [
      {
        "id": "u3-54-labour-market-flash-1",
        "knowledgePointId": "u3-54-labour-market",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“劳动力市场政策”，并说明一个关键条件。",
          "en": "Explain Labour-market policies and state one important condition."
        },
        "answer": {
          "zh-CN": "培训、就业信息、流动性支持与劳动制度改革可影响就业匹配和激励；效率、收入保障及劳动权利需要共同评价。",
          "en": "Training, job information, mobility support and labour reforms can affect matching and incentives. Evaluate efficiency alongside income security and labour rights."
        },
        "explanation": {
          "zh-CN": "培训不直接解决总需求不足造成的所有周期性失业。",
          "en": "Training does not directly solve all cyclical unemployment caused by weak demand."
        }
      },
      {
        "id": "u3-54-labour-market-mcq-1",
        "knowledgePointId": "u3-54-labour-market",
        "type": "mcq",
        "prompt": {
          "zh-CN": "岗位信息服务最直接针对什么？",
          "en": "What do vacancy information services most directly address?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "所有能源进口价格",
            "en": "All imported energy prices"
          },
          {
            "id": "b",
            "zh-CN": "求职与岗位之间的信息和匹配障碍",
            "en": "Information and matching barriers between jobs and applicants"
          },
          {
            "id": "c",
            "zh-CN": "直接增加货币供给",
            "en": "Directly increasing money supply"
          },
          {
            "id": "d",
            "zh-CN": "保证每个岗位都永久存在",
            "en": "Guaranteeing every job exists permanently"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "求职与岗位之间的信息和匹配障碍。 诊断摩擦性或结构性失业原因；改善匹配技能或地区流动；可持续就业增加并可能降低自然失业率 培训不直接解决总需求不足造成的所有周期性失业。",
          "en": "Information and matching barriers between jobs and applicants. Diagnose frictional or structural unemployment; improve matching, skills or regional mobility; sustainable employment rises and the natural unemployment rate may fall Training does not directly solve all cyclical unemployment caused by weak demand."
        }
      },
      {
        "id": "u3-54-labour-market-short-1",
        "knowledgePointId": "u3-54-labour-market",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释劳动力市场政策的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Labour-market policies and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "培训、就业信息、流动性支持与劳动制度改革可影响就业匹配和激励；效率、收入保障及劳动权利需要共同评价。 诊断摩擦性或结构性失业原因；改善匹配技能或地区流动；可持续就业增加并可能降低自然失业率 原创例：公共岗位平台改善信息，搬迁支持帮助跨地区求职，但高住房成本和照护责任仍可能限制流动。削弱劳动保护可能降低部分招聘成本，也可能加剧不安全感，不能只看工资下降。",
          "en": "Training, job information, mobility support and labour reforms can affect matching and incentives. Evaluate efficiency alongside income security and labour rights. Diagnose frictional or structural unemployment; improve matching, skills or regional mobility; sustainable employment rises and the natural unemployment rate may fall Illustrative example: public vacancy platforms improve information and relocation support aids regional job search, but housing costs and caring duties may still restrict mobility. Weaker protections may lower some hiring costs while increasing insecurity; lower wages alone are not a complete evaluation."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "结构性失业",
              "en": "structural unemployment"
            },
            "alternatives": {
              "zh-CN": [
                "结构性失业",
                "诊断摩擦性或结构性失业原因"
              ],
              "en": [
                "structural unemployment",
                "Diagnose frictional or structural unemployment"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "匹配",
              "en": "matching"
            },
            "alternatives": {
              "zh-CN": [
                "匹配",
                "改善匹配技能或地区流动"
              ],
              "en": [
                "matching",
                "improve matching, skills or regional mobility"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "自然失业率",
              "en": "natural unemployment rate"
            },
            "alternatives": {
              "zh-CN": [
                "自然失业率",
                "可持续就业增加并可能降低自然失业率"
              ],
              "en": [
                "natural unemployment rate",
                "sustainable employment rises and the natural unemployment rate may fall"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-55-infrastructure-innovation",
      "slug": "infrastructure-innovation",
      "section": "3.7",
      "level": "core",
      "syllabusRefs": [
        "3.7 Supply-side policies"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.6",
          "pages": [
            412
          ]
        }
      ],
      "prerequisites": [
        "u3-15-lras"
      ],
      "related": [
        "u3-52-market-based-supply",
        "u3-53-interventionist-supply",
        "u3-54-labour-market"
      ],
      "terms": [
        "基础设施与创新",
        "Infrastructure and innovation",
        "知识瓶颈",
        "knowledge bottlenecks",
        "成本",
        "costs",
        "长期供给",
        "long-run supply"
      ],
      "synonyms": {
        "zh-CN": [
          "知识瓶颈",
          "成本",
          "长期供给"
        ],
        "en": [
          "knowledge bottlenecks",
          "costs",
          "long-run supply"
        ]
      },
      "diagramIds": [
        "macro-lras"
      ],
      "quizIds": [
        "u3-55-infrastructure-innovation-flash-1",
        "u3-55-infrastructure-innovation-mcq-1",
        "u3-55-infrastructure-innovation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-55-infrastructure-innovation",
        "locale": "zh-CN",
        "title": "基础设施与创新",
        "takeaway": "交通、数字网络和研发可提高生产率并产生外部收益；项目应按额外收益、机会成本、维护和治理能力评价。",
        "definition": "交通、数字网络和研发可提高生产率并产生外部收益；项目应按额外收益、机会成本、维护和治理能力评价。",
        "causalChain": [
          "识别网络或知识瓶颈",
          "投资降低成本或扩大技术能力",
          "长期供给增加但收益取决于使用与维护"
        ],
        "misconceptions": [
          "增加投资流量不保证资本服务质量和长期回报。"
        ],
        "examApplication": [
          "解释生产率与潜在产出的渠道，区分短期 AD 与长期 AS，并评价机会成本。"
        ],
        "summary": [
          "交通、数字网络和研发可提高生产率并产生外部收益；项目应按额外收益、机会成本、维护和治理能力评价。",
          "增加投资流量不保证资本服务质量和长期回报。"
        ],
        "explanation": "识别网络或知识瓶颈。投资降低成本或扩大技术能力。长期供给增加但收益取决于使用与维护。\n\n### 原创情境与推导\n\n原创例：可靠电网减少停机时间，研发支持可能促进知识溢出。然而低利用率工程、寻租或缺乏维护可能使成本超过收益。研发结果不确定，不能把每一笔补贴都视作新增创新。\n\n增加投资流量不保证资本服务质量和长期回报。\n\n解释生产率与潜在产出的渠道，区分短期 AD 与长期 AS，并评价机会成本。"
      },
      "en": {
        "id": "u3-55-infrastructure-innovation",
        "locale": "en",
        "title": "Infrastructure and innovation",
        "takeaway": "Transport, digital networks and research can raise productivity and generate external benefits. Evaluate additional benefits, opportunity costs, maintenance and governance.",
        "definition": "Transport, digital networks and research can raise productivity and generate external benefits. Evaluate additional benefits, opportunity costs, maintenance and governance.",
        "causalChain": [
          "Identify network or knowledge bottlenecks",
          "investment lowers costs or expands technological capability",
          "long-run supply grows but benefits depend on use and maintenance"
        ],
        "misconceptions": [
          "Higher investment flows do not guarantee capital-service quality or long-run returns."
        ],
        "examApplication": [
          "Explain productivity and potential-output channels, distinguish short-run AD from long-run AS and evaluate opportunity costs."
        ],
        "summary": [
          "Transport, digital networks and research can raise productivity and generate external benefits. Evaluate additional benefits, opportunity costs, maintenance and governance.",
          "Higher investment flows do not guarantee capital-service quality or long-run returns."
        ],
        "explanation": "Identify network or knowledge bottlenecks.  investment lowers costs or expands technological capability.  long-run supply grows but benefits depend on use and maintenance.\n\n### Original scenario and reasoning\n\nIllustrative example: reliable electricity reduces downtime, while research support may generate knowledge spillovers. Underused projects, rent-seeking or poor maintenance can make costs exceed benefits. Research outcomes are uncertain; not every subsidy produces additional innovation.\n\nHigher investment flows do not guarantee capital-service quality or long-run returns.\n\nExplain productivity and potential-output channels, distinguish short-run AD from long-run AS and evaluate opportunity costs."
      }
    },
    "practice": [
      {
        "id": "u3-55-infrastructure-innovation-flash-1",
        "knowledgePointId": "u3-55-infrastructure-innovation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“基础设施与创新”，并说明一个关键条件。",
          "en": "Explain Infrastructure and innovation and state one important condition."
        },
        "answer": {
          "zh-CN": "交通、数字网络和研发可提高生产率并产生外部收益；项目应按额外收益、机会成本、维护和治理能力评价。",
          "en": "Transport, digital networks and research can raise productivity and generate external benefits. Evaluate additional benefits, opportunity costs, maintenance and governance."
        },
        "explanation": {
          "zh-CN": "增加投资流量不保证资本服务质量和长期回报。",
          "en": "Higher investment flows do not guarantee capital-service quality or long-run returns."
        }
      },
      {
        "id": "u3-55-infrastructure-innovation-mcq-1",
        "knowledgePointId": "u3-55-infrastructure-innovation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "评估公共研发支持应考察什么？",
          "en": "What should evaluation of public research support consider?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只统计补贴总额",
            "en": "Only total subsidy spending"
          },
          {
            "id": "b",
            "zh-CN": "假定研发全部成功",
            "en": "Assume all research succeeds"
          },
          {
            "id": "c",
            "zh-CN": "额外创新、外部收益与机会成本",
            "en": "Additional innovation, external benefits and opportunity cost"
          },
          {
            "id": "d",
            "zh-CN": "排除维护和治理",
            "en": "Exclude maintenance and governance"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "额外创新、外部收益与机会成本。 识别网络或知识瓶颈；投资降低成本或扩大技术能力；长期供给增加但收益取决于使用与维护 增加投资流量不保证资本服务质量和长期回报。",
          "en": "Additional innovation, external benefits and opportunity cost. Identify network or knowledge bottlenecks; investment lowers costs or expands technological capability; long-run supply grows but benefits depend on use and maintenance Higher investment flows do not guarantee capital-service quality or long-run returns."
        }
      },
      {
        "id": "u3-55-infrastructure-innovation-short-1",
        "knowledgePointId": "u3-55-infrastructure-innovation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释基础设施与创新的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Infrastructure and innovation and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "交通、数字网络和研发可提高生产率并产生外部收益；项目应按额外收益、机会成本、维护和治理能力评价。 识别网络或知识瓶颈；投资降低成本或扩大技术能力；长期供给增加但收益取决于使用与维护 原创例：可靠电网减少停机时间，研发支持可能促进知识溢出。然而低利用率工程、寻租或缺乏维护可能使成本超过收益。研发结果不确定，不能把每一笔补贴都视作新增创新。",
          "en": "Transport, digital networks and research can raise productivity and generate external benefits. Evaluate additional benefits, opportunity costs, maintenance and governance. Identify network or knowledge bottlenecks; investment lowers costs or expands technological capability; long-run supply grows but benefits depend on use and maintenance Illustrative example: reliable electricity reduces downtime, while research support may generate knowledge spillovers. Underused projects, rent-seeking or poor maintenance can make costs exceed benefits. Research outcomes are uncertain; not every subsidy produces additional innovation."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "知识瓶颈",
              "en": "knowledge bottlenecks"
            },
            "alternatives": {
              "zh-CN": [
                "知识瓶颈",
                "识别网络或知识瓶颈"
              ],
              "en": [
                "knowledge bottlenecks",
                "Identify network or knowledge bottlenecks"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "成本",
              "en": "costs"
            },
            "alternatives": {
              "zh-CN": [
                "成本",
                "投资降低成本或扩大技术能力"
              ],
              "en": [
                "costs",
                "investment lowers costs or expands technological capability"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "长期供给",
              "en": "long-run supply"
            },
            "alternatives": {
              "zh-CN": [
                "长期供给",
                "长期供给增加但收益取决于使用与维护"
              ],
              "en": [
                "long-run supply",
                "long-run supply grows but benefits depend on use and maintenance"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-56-policy-mix",
      "slug": "policy-mix",
      "section": "3.7",
      "level": "core",
      "syllabusRefs": [
        "3.7 Supply-side policies"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.7",
          "pages": [
            424
          ]
        }
      ],
      "prerequisites": [
        "u3-15-lras"
      ],
      "related": [
        "u3-52-market-based-supply",
        "u3-53-interventionist-supply",
        "u3-54-labour-market"
      ],
      "terms": [
        "宏观政策组合与评价",
        "Macroeconomic policy mixes",
        "供给瓶颈",
        "supply bottlenecks",
        "短期稳定",
        "short-run stabilisation",
        "多目标",
        "objectives"
      ],
      "synonyms": {
        "zh-CN": [
          "供给瓶颈",
          "短期稳定",
          "多目标"
        ],
        "en": [
          "supply bottlenecks",
          "short-run stabilisation",
          "objectives"
        ]
      },
      "diagramIds": [
        "macro-lras"
      ],
      "quizIds": [
        "u3-56-policy-mix-flash-1",
        "u3-56-policy-mix-mcq-1",
        "u3-56-policy-mix-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-56-policy-mix",
        "locale": "zh-CN",
        "title": "宏观政策组合与评价",
        "takeaway": "需求管理与供给改革作用于不同机制和时间尺度，应按冲击来源、产能、分配、环境与财政金融约束组合使用。",
        "definition": "需求管理与供给改革作用于不同机制和时间尺度，应按冲击来源、产能、分配、环境与财政金融约束组合使用。",
        "causalChain": [
          "判断需求不足或供给瓶颈",
          "协调短期稳定与长期能力政策",
          "用多目标和时间尺度评价净效果"
        ],
        "misconceptions": [
          "没有脱离经济情境的万能政策排名。"
        ],
        "examApplication": [
          "解释生产率与潜在产出的渠道，区分短期 AD 与长期 AS，并评价机会成本。"
        ],
        "summary": [
          "需求管理与供给改革作用于不同机制和时间尺度，应按冲击来源、产能、分配、环境与财政金融约束组合使用。",
          "没有脱离经济情境的万能政策排名。"
        ],
        "explanation": "判断需求不足或供给瓶颈。协调短期稳定与长期能力政策。用多目标和时间尺度评价净效果。\n\n### 原创情境与推导\n\n原创例：需求不足且技能错配并存时，短期需求支持可配合长期培训；仅培训未必马上创造岗位。若经济已过热，同时刺激需求可能在新增产能形成前加剧通胀，应分析政策先后和实施能力。\n\n没有脱离经济情境的万能政策排名。\n\n解释生产率与潜在产出的渠道，区分短期 AD 与长期 AS，并评价机会成本。"
      },
      "en": {
        "id": "u3-56-policy-mix",
        "locale": "en",
        "title": "Macroeconomic policy mixes",
        "takeaway": "Demand management and supply reforms operate through different mechanisms and time horizons. Combine them according to shocks, capacity, distribution, environment and fiscal-financial constraints.",
        "definition": "Demand management and supply reforms operate through different mechanisms and time horizons. Combine them according to shocks, capacity, distribution, environment and fiscal-financial constraints.",
        "causalChain": [
          "Diagnose weak demand or supply bottlenecks",
          "coordinate short-run stabilisation with long-run capacity policies",
          "evaluate net effects across objectives and time horizons"
        ],
        "misconceptions": [
          "There is no context-free ranking of universally best policies."
        ],
        "examApplication": [
          "Explain productivity and potential-output channels, distinguish short-run AD from long-run AS and evaluate opportunity costs."
        ],
        "summary": [
          "Demand management and supply reforms operate through different mechanisms and time horizons. Combine them according to shocks, capacity, distribution, environment and fiscal-financial constraints.",
          "There is no context-free ranking of universally best policies."
        ],
        "explanation": "Diagnose weak demand or supply bottlenecks.  coordinate short-run stabilisation with long-run capacity policies.  evaluate net effects across objectives and time horizons.\n\n### Original scenario and reasoning\n\nIllustrative example: weak demand alongside skills mismatch can justify short-run demand support with long-run training; training alone may not immediately create jobs. In an overheated economy, stimulating demand may worsen inflation before new capacity arrives, so sequencing and implementation matter.\n\nThere is no context-free ranking of universally best policies.\n\nExplain productivity and potential-output channels, distinguish short-run AD from long-run AS and evaluate opportunity costs."
      }
    },
    "practice": [
      {
        "id": "u3-56-policy-mix-flash-1",
        "knowledgePointId": "u3-56-policy-mix",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“宏观政策组合与评价”，并说明一个关键条件。",
          "en": "Explain Macroeconomic policy mixes and state one important condition."
        },
        "answer": {
          "zh-CN": "需求管理与供给改革作用于不同机制和时间尺度，应按冲击来源、产能、分配、环境与财政金融约束组合使用。",
          "en": "Demand management and supply reforms operate through different mechanisms and time horizons. Combine them according to shocks, capacity, distribution, environment and fiscal-financial constraints."
        },
        "explanation": {
          "zh-CN": "没有脱离经济情境的万能政策排名。",
          "en": "There is no context-free ranking of universally best policies."
        }
      },
      {
        "id": "u3-56-policy-mix-mcq-1",
        "knowledgePointId": "u3-56-policy-mix",
        "type": "mcq",
        "prompt": {
          "zh-CN": "需求低迷与技能错配同时存在，合理分析是？",
          "en": "With weak demand and skills mismatch together, what is a reasonable analysis?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只靠培训立即消除所有失业",
            "en": "Training alone instantly removes all unemployment"
          },
          {
            "id": "b",
            "zh-CN": "任何刺激都无通胀风险",
            "en": "All stimulus has no inflation risk"
          },
          {
            "id": "c",
            "zh-CN": "不必考虑时滞",
            "en": "Lags need not be considered"
          },
          {
            "id": "d",
            "zh-CN": "区分短期需求与长期匹配政策并协调",
            "en": "Distinguish and coordinate short-run demand and long-run matching policies"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "区分短期需求与长期匹配政策并协调。 判断需求不足或供给瓶颈；协调短期稳定与长期能力政策；用多目标和时间尺度评价净效果 没有脱离经济情境的万能政策排名。",
          "en": "Distinguish and coordinate short-run demand and long-run matching policies. Diagnose weak demand or supply bottlenecks; coordinate short-run stabilisation with long-run capacity policies; evaluate net effects across objectives and time horizons There is no context-free ranking of universally best policies."
        }
      },
      {
        "id": "u3-56-policy-mix-short-1",
        "knowledgePointId": "u3-56-policy-mix",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释宏观政策组合与评价的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Macroeconomic policy mixes and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "需求管理与供给改革作用于不同机制和时间尺度，应按冲击来源、产能、分配、环境与财政金融约束组合使用。 判断需求不足或供给瓶颈；协调短期稳定与长期能力政策；用多目标和时间尺度评价净效果 原创例：需求不足且技能错配并存时，短期需求支持可配合长期培训；仅培训未必马上创造岗位。若经济已过热，同时刺激需求可能在新增产能形成前加剧通胀，应分析政策先后和实施能力。",
          "en": "Demand management and supply reforms operate through different mechanisms and time horizons. Combine them according to shocks, capacity, distribution, environment and fiscal-financial constraints. Diagnose weak demand or supply bottlenecks; coordinate short-run stabilisation with long-run capacity policies; evaluate net effects across objectives and time horizons Illustrative example: weak demand alongside skills mismatch can justify short-run demand support with long-run training; training alone may not immediately create jobs. In an overheated economy, stimulating demand may worsen inflation before new capacity arrives, so sequencing and implementation matter."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "供给瓶颈",
              "en": "supply bottlenecks"
            },
            "alternatives": {
              "zh-CN": [
                "供给瓶颈",
                "判断需求不足或供给瓶颈"
              ],
              "en": [
                "supply bottlenecks",
                "Diagnose weak demand or supply bottlenecks"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "短期稳定",
              "en": "short-run stabilisation"
            },
            "alternatives": {
              "zh-CN": [
                "短期稳定",
                "协调短期稳定与长期能力政策"
              ],
              "en": [
                "short-run stabilisation",
                "coordinate short-run stabilisation with long-run capacity policies"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "多目标",
              "en": "objectives"
            },
            "alternatives": {
              "zh-CN": [
                "多目标",
                "用多目标和时间尺度评价净效果"
              ],
              "en": [
                "objectives",
                "evaluate net effects across objectives and time horizons"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-57-bank-money-creation",
      "slug": "bank-money-creation",
      "section": "3.5",
      "level": "hl",
      "syllabusRefs": [
        "3.5 Monetary policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.2",
          "pages": [
            387
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-39-money-interest",
        "u3-40-monetary-transmission",
        "u3-41-expansionary-monetary"
      ],
      "terms": [
        "商业银行的货币创造",
        "Money creation by commercial banks",
        "贷款",
        "loan",
        "存款",
        "deposit",
        "约束",
        "constraints"
      ],
      "synonyms": {
        "zh-CN": [
          "贷款",
          "存款",
          "约束"
        ],
        "en": [
          "loan",
          "deposit",
          "constraints"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-57-bank-money-creation-flash-1",
        "u3-57-bank-money-creation-mcq-1",
        "u3-57-bank-money-creation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-57-bank-money-creation",
        "locale": "zh-CN",
        "title": "商业银行的货币创造",
        "takeaway": "商业银行发放贷款通常同时创造客户存款；贷款偿还可销毁存款货币，但资本、流动性、风险、监管与贷款需求约束扩张。",
        "definition": "商业银行发放贷款通常同时创造客户存款；贷款偿还可销毁存款货币，但资本、流动性、风险、监管与贷款需求约束扩张。",
        "causalChain": [
          "银行记入贷款资产",
          "同时记入客户存款负债",
          "跨行支付需要结算与流动性"
        ],
        "misconceptions": [
          "不能把新增存款等同于新增产出，也不能把创造货币理解为银行没有风险约束。"
        ],
        "examApplication": [
          "用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
        ],
        "summary": [
          "商业银行发放贷款通常同时创造客户存款；贷款偿还可销毁存款货币，但资本、流动性、风险、监管与贷款需求约束扩张。",
          "不能把新增存款等同于新增产出，也不能把创造货币理解为银行没有风险约束。"
        ],
        "explanation": "银行记入贷款资产。同时记入客户存款负债。跨行支付需要结算与流动性。\n\n### 原创情境与推导\n\n原创假设：银行贷出 100，同时客户存款增加 100；客户净财富没有因此增加 100，因为还负有贷款。基础货币与广义货币不同，准备金不是可无限机械倍增的保证。\n\n不能把新增存款等同于新增产出，也不能把创造货币理解为银行没有风险约束。\n\n用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
      },
      "en": {
        "id": "u3-57-bank-money-creation",
        "locale": "en",
        "title": "Money creation by commercial banks",
        "takeaway": "Commercial-bank lending normally creates a matching deposit; principal repayment can destroy deposit money. Capital, liquidity, risk, regulation and loan demand constrain expansion.",
        "definition": "Commercial-bank lending normally creates a matching deposit; principal repayment can destroy deposit money. Capital, liquidity, risk, regulation and loan demand constrain expansion.",
        "causalChain": [
          "The bank records a loan asset",
          "it records a matching deposit liability",
          "interbank payments need settlement and liquidity"
        ],
        "misconceptions": [
          "New deposits are not new output, and money creation does not make banks unconstrained."
        ],
        "examApplication": [
          "Trace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
        ],
        "summary": [
          "Commercial-bank lending normally creates a matching deposit; principal repayment can destroy deposit money. Capital, liquidity, risk, regulation and loan demand constrain expansion.",
          "New deposits are not new output, and money creation does not make banks unconstrained."
        ],
        "explanation": "The bank records a loan asset.  it records a matching deposit liability.  interbank payments need settlement and liquidity.\n\n### Original scenario and reasoning\n\nHypothetical scenario: lending 100 adds a deposit of 100 but also a debt of 100, so it does not add 100 to the borrower’s net wealth. Base and broad money differ; reserves do not guarantee unlimited mechanical expansion.\n\nNew deposits are not new output, and money creation does not make banks unconstrained.\n\nTrace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
      }
    },
    "practice": [
      {
        "id": "u3-57-bank-money-creation-flash-1",
        "knowledgePointId": "u3-57-bank-money-creation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“商业银行的货币创造”，并说明一个关键条件。",
          "en": "Explain Money creation by commercial banks and state one important condition."
        },
        "answer": {
          "zh-CN": "商业银行发放贷款通常同时创造客户存款；贷款偿还可销毁存款货币，但资本、流动性、风险、监管与贷款需求约束扩张。",
          "en": "Commercial-bank lending normally creates a matching deposit; principal repayment can destroy deposit money. Capital, liquidity, risk, regulation and loan demand constrain expansion."
        },
        "explanation": {
          "zh-CN": "不能把新增存款等同于新增产出，也不能把创造货币理解为银行没有风险约束。",
          "en": "New deposits are not new output, and money creation does not make banks unconstrained."
        }
      },
      {
        "id": "u3-57-bank-money-creation-mcq-1",
        "knowledgePointId": "u3-57-bank-money-creation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "银行发放贷款时通常同时创造什么？",
          "en": "What is normally created alongside a new bank loan?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "客户存款负债",
            "en": "A customer deposit liability"
          },
          {
            "id": "b",
            "zh-CN": "央行直接购买的商品",
            "en": "Goods bought directly by the central bank"
          },
          {
            "id": "c",
            "zh-CN": "借款人的无债净财富",
            "en": "Debt-free net wealth for the borrower"
          },
          {
            "id": "d",
            "zh-CN": "已经生产的等额实际产出",
            "en": "Matching real output already produced"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "客户存款负债。 银行记入贷款资产；同时记入客户存款负债；跨行支付需要结算与流动性 不能把新增存款等同于新增产出，也不能把创造货币理解为银行没有风险约束。",
          "en": "A customer deposit liability. The bank records a loan asset; it records a matching deposit liability; interbank payments need settlement and liquidity New deposits are not new output, and money creation does not make banks unconstrained."
        }
      },
      {
        "id": "u3-57-bank-money-creation-short-1",
        "knowledgePointId": "u3-57-bank-money-creation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释商业银行的货币创造的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Money creation by commercial banks and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "商业银行发放贷款通常同时创造客户存款；贷款偿还可销毁存款货币，但资本、流动性、风险、监管与贷款需求约束扩张。 银行记入贷款资产；同时记入客户存款负债；跨行支付需要结算与流动性 原创假设：银行贷出 100，同时客户存款增加 100；客户净财富没有因此增加 100，因为还负有贷款。基础货币与广义货币不同，准备金不是可无限机械倍增的保证。",
          "en": "Commercial-bank lending normally creates a matching deposit; principal repayment can destroy deposit money. Capital, liquidity, risk, regulation and loan demand constrain expansion. The bank records a loan asset; it records a matching deposit liability; interbank payments need settlement and liquidity Hypothetical scenario: lending 100 adds a deposit of 100 but also a debt of 100, so it does not add 100 to the borrower’s net wealth. Base and broad money differ; reserves do not guarantee unlimited mechanical expansion."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "贷款",
              "en": "loan"
            },
            "alternatives": {
              "zh-CN": [
                "贷款",
                "银行记入贷款资产"
              ],
              "en": [
                "loan",
                "The bank records a loan asset"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "存款",
              "en": "deposit"
            },
            "alternatives": {
              "zh-CN": [
                "存款",
                "同时记入客户存款负债"
              ],
              "en": [
                "deposit",
                "it records a matching deposit liability"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "约束",
              "en": "constraints"
            },
            "alternatives": {
              "zh-CN": [
                "约束",
                "跨行支付需要结算与流动性"
              ],
              "en": [
                "constraints",
                "interbank payments need settlement and liquidity"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-58-monetary-tools",
      "slug": "monetary-tools",
      "section": "3.5",
      "level": "hl",
      "syllabusRefs": [
        "3.5 Monetary policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.2",
          "pages": [
            387
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-39-money-interest",
        "u3-40-monetary-transmission",
        "u3-41-expansionary-monetary"
      ],
      "terms": [
        "货币政策工具",
        "Monetary policy instruments",
        "工具",
        "instruments",
        "流动性",
        "liquidity",
        "利率",
        "interest"
      ],
      "synonyms": {
        "zh-CN": [
          "工具",
          "流动性",
          "利率"
        ],
        "en": [
          "instruments",
          "liquidity",
          "interest"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-58-monetary-tools-flash-1",
        "u3-58-monetary-tools-mcq-1",
        "u3-58-monetary-tools-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-58-monetary-tools",
        "locale": "zh-CN",
        "title": "货币政策工具",
        "takeaway": "公开市场操作、准备金要求和央行贷款利率可影响金融条件；具体传导取决于银行体系与政策实施框架。",
        "definition": "公开市场操作、准备金要求和央行贷款利率可影响金融条件；具体传导取决于银行体系与政策实施框架。",
        "causalChain": [
          "央行调整工具",
          "银行资金成本与流动性变化",
          "信贷和利率渠道影响支出"
        ],
        "misconceptions": [
          "不要把央行买金融资产记为财政政策中政府购买商品服务的 G。"
        ],
        "examApplication": [
          "用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
        ],
        "summary": [
          "公开市场操作、准备金要求和央行贷款利率可影响金融条件；具体传导取决于银行体系与政策实施框架。",
          "不要把央行买金融资产记为财政政策中政府购买商品服务的 G。"
        ],
        "explanation": "央行调整工具。银行资金成本与流动性变化。信贷和利率渠道影响支出。\n\n### 原创情境与推导\n\n原创假设：央行买债可增加银行结算余额，在其他条件适当时压低市场收益率；降低准备金要求可能释放流动性，但不保证银行放贷或家庭借款增加。QE 通常针对较长期资产。\n\n不要把央行买金融资产记为财政政策中政府购买商品服务的 G。\n\n用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
      },
      "en": {
        "id": "u3-58-monetary-tools",
        "locale": "en",
        "title": "Monetary policy instruments",
        "takeaway": "Open-market operations, reserve requirements and central-bank lending rates can affect financial conditions; transmission depends on the banking system and operating framework.",
        "definition": "Open-market operations, reserve requirements and central-bank lending rates can affect financial conditions; transmission depends on the banking system and operating framework.",
        "causalChain": [
          "The central bank adjusts instruments",
          "bank funding costs and liquidity change",
          "credit and interest channels affect spending"
        ],
        "misconceptions": [
          "Do not record central-bank purchases of financial assets as fiscal purchases of goods and services in G."
        ],
        "examApplication": [
          "Trace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
        ],
        "summary": [
          "Open-market operations, reserve requirements and central-bank lending rates can affect financial conditions; transmission depends on the banking system and operating framework.",
          "Do not record central-bank purchases of financial assets as fiscal purchases of goods and services in G."
        ],
        "explanation": "The central bank adjusts instruments.  bank funding costs and liquidity change.  credit and interest channels affect spending.\n\n### Original scenario and reasoning\n\nHypothetical scenario: bond purchases can add settlement balances and, under suitable conditions, lower yields. Lower reserve requirements may ease liquidity without guaranteeing more lending or borrowing. QE often targets longer-term assets.\n\nDo not record central-bank purchases of financial assets as fiscal purchases of goods and services in G.\n\nTrace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
      }
    },
    "practice": [
      {
        "id": "u3-58-monetary-tools-flash-1",
        "knowledgePointId": "u3-58-monetary-tools",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“货币政策工具”，并说明一个关键条件。",
          "en": "Explain Monetary policy instruments and state one important condition."
        },
        "answer": {
          "zh-CN": "公开市场操作、准备金要求和央行贷款利率可影响金融条件；具体传导取决于银行体系与政策实施框架。",
          "en": "Open-market operations, reserve requirements and central-bank lending rates can affect financial conditions; transmission depends on the banking system and operating framework."
        },
        "explanation": {
          "zh-CN": "不要把央行买金融资产记为财政政策中政府购买商品服务的 G。",
          "en": "Do not record central-bank purchases of financial assets as fiscal purchases of goods and services in G."
        }
      },
      {
        "id": "u3-58-monetary-tools-mcq-1",
        "knowledgePointId": "u3-58-monetary-tools",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪项是央行公开市场购买？",
          "en": "Which is a central-bank open-market purchase?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "政府购买公路维修",
            "en": "The government buys road repairs"
          },
          {
            "id": "b",
            "zh-CN": "央行购买债券",
            "en": "The central bank buys bonds"
          },
          {
            "id": "c",
            "zh-CN": "家庭买食品",
            "en": "A household buys food"
          },
          {
            "id": "d",
            "zh-CN": "企业支付工资",
            "en": "A firm pays wages"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "央行购买债券。 央行调整工具；银行资金成本与流动性变化；信贷和利率渠道影响支出 不要把央行买金融资产记为财政政策中政府购买商品服务的 G。",
          "en": "The central bank buys bonds. The central bank adjusts instruments; bank funding costs and liquidity change; credit and interest channels affect spending Do not record central-bank purchases of financial assets as fiscal purchases of goods and services in G."
        }
      },
      {
        "id": "u3-58-monetary-tools-short-1",
        "knowledgePointId": "u3-58-monetary-tools",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释货币政策工具的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Monetary policy instruments and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "公开市场操作、准备金要求和央行贷款利率可影响金融条件；具体传导取决于银行体系与政策实施框架。 央行调整工具；银行资金成本与流动性变化；信贷和利率渠道影响支出 原创假设：央行买债可增加银行结算余额，在其他条件适当时压低市场收益率；降低准备金要求可能释放流动性，但不保证银行放贷或家庭借款增加。QE 通常针对较长期资产。",
          "en": "Open-market operations, reserve requirements and central-bank lending rates can affect financial conditions; transmission depends on the banking system and operating framework. The central bank adjusts instruments; bank funding costs and liquidity change; credit and interest channels affect spending Hypothetical scenario: bond purchases can add settlement balances and, under suitable conditions, lower yields. Lower reserve requirements may ease liquidity without guaranteeing more lending or borrowing. QE often targets longer-term assets."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "工具",
              "en": "instruments"
            },
            "alternatives": {
              "zh-CN": [
                "工具",
                "央行调整工具"
              ],
              "en": [
                "instruments",
                "The central bank adjusts instruments"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "流动性",
              "en": "liquidity"
            },
            "alternatives": {
              "zh-CN": [
                "流动性",
                "银行资金成本与流动性变化"
              ],
              "en": [
                "liquidity",
                "bank funding costs and liquidity change"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "利率",
              "en": "interest"
            },
            "alternatives": {
              "zh-CN": [
                "利率",
                "信贷和利率渠道影响支出"
              ],
              "en": [
                "interest",
                "credit and interest channels affect spending"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-59-money-market",
      "slug": "money-market",
      "section": "3.5",
      "level": "hl",
      "syllabusRefs": [
        "3.5 Monetary policy"
      ],
      "textbookRefs": [
        {
          "chapter": "13",
          "section": "13.2",
          "pages": [
            387
          ]
        }
      ],
      "prerequisites": [
        "u3-11-aggregate-demand"
      ],
      "related": [
        "u3-39-money-interest",
        "u3-40-monetary-transmission",
        "u3-41-expansionary-monetary"
      ],
      "terms": [
        "货币市场与均衡利率",
        "The money market and equilibrium interest",
        "利率",
        "interest",
        "货币需求",
        "money demand",
        "供给",
        "supply"
      ],
      "synonyms": {
        "zh-CN": [
          "利率",
          "货币需求",
          "供给"
        ],
        "en": [
          "interest",
          "money demand",
          "supply"
        ]
      },
      "diagramIds": [
        "audit-money-market"
      ],
      "quizIds": [
        "u3-59-money-market-flash-1",
        "u3-59-money-market-mcq-1",
        "u3-59-money-market-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-59-money-market",
        "locale": "zh-CN",
        "title": "货币市场与均衡利率",
        "takeaway": "在简单流动性偏好模型中，货币需求随持币机会成本即名义利率上升而下降；给定货币供给与需求交点确定利率。",
        "definition": "在简单流动性偏好模型中，货币需求随持币机会成本即名义利率上升而下降；给定货币供给与需求交点确定利率。",
        "causalChain": [
          "利率提高持币机会成本",
          "货币需求量下降",
          "供需交点形成模型均衡"
        ],
        "misconceptions": [
          "货币市场纵轴是名义利率，横轴是货币数量，不是商品价格与产量。"
        ],
        "examApplication": [
          "用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
        ],
        "summary": [
          "在简单流动性偏好模型中，货币需求随持币机会成本即名义利率上升而下降；给定货币供给与需求交点确定利率。",
          "货币市场纵轴是名义利率，横轴是货币数量，不是商品价格与产量。"
        ],
        "explanation": "利率提高持币机会成本。货币需求量下降。供需交点形成模型均衡。\n\n### 原创情境与推导\n\n原创假设：收入与价格等不变，货币供给右移可降低均衡利率；真实央行也可直接以政策利率为操作目标，不能把示意模型当作所有制度的逐日流程。\n\n货币市场纵轴是名义利率，横轴是货币数量，不是商品价格与产量。\n\n用利率到支出再到 AD 的链条解释传导，注明汇率制度、时滞与限制。"
      },
      "en": {
        "id": "u3-59-money-market",
        "locale": "en",
        "title": "The money market and equilibrium interest",
        "takeaway": "In a simple liquidity-preference model, money demand falls as the nominal interest opportunity cost of holding money rises. Its intersection with given money supply determines interest.",
        "definition": "In a simple liquidity-preference model, money demand falls as the nominal interest opportunity cost of holding money rises. Its intersection with given money supply determines interest.",
        "causalChain": [
          "Interest raises the opportunity cost of money",
          "quantity of money demanded falls",
          "demand and supply intersect at model equilibrium"
        ],
        "misconceptions": [
          "The axes are nominal interest and money quantity, not a good’s price and output."
        ],
        "examApplication": [
          "Trace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
        ],
        "summary": [
          "In a simple liquidity-preference model, money demand falls as the nominal interest opportunity cost of holding money rises. Its intersection with given money supply determines interest.",
          "The axes are nominal interest and money quantity, not a good’s price and output."
        ],
        "explanation": "Interest raises the opportunity cost of money.  quantity of money demanded falls.  demand and supply intersect at model equilibrium.\n\n### Original scenario and reasoning\n\nHypothetical scenario: holding income and prices constant, a rightward money-supply shift lowers equilibrium interest. Actual central banks may target a policy rate directly; the schematic is not every system’s daily operating process.\n\nThe axes are nominal interest and money quantity, not a good’s price and output.\n\nTrace rates through spending to AD, stating exchange-rate arrangements, lags and limitations."
      }
    },
    "practice": [
      {
        "id": "u3-59-money-market-flash-1",
        "knowledgePointId": "u3-59-money-market",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“货币市场与均衡利率”，并说明一个关键条件。",
          "en": "Explain The money market and equilibrium interest and state one important condition."
        },
        "answer": {
          "zh-CN": "在简单流动性偏好模型中，货币需求随持币机会成本即名义利率上升而下降；给定货币供给与需求交点确定利率。",
          "en": "In a simple liquidity-preference model, money demand falls as the nominal interest opportunity cost of holding money rises. Its intersection with given money supply determines interest."
        },
        "explanation": {
          "zh-CN": "货币市场纵轴是名义利率，横轴是货币数量，不是商品价格与产量。",
          "en": "The axes are nominal interest and money quantity, not a good’s price and output."
        }
      },
      {
        "id": "u3-59-money-market-mcq-1",
        "knowledgePointId": "u3-59-money-market",
        "type": "mcq",
        "prompt": {
          "zh-CN": "其他条件不变，模型货币供给增加通常怎样影响利率？",
          "en": "Other things equal, how does more money supply affect model equilibrium interest?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "利率必上升",
            "en": "Interest must rise"
          },
          {
            "id": "b",
            "zh-CN": "实际产能必立即翻倍",
            "en": "Real capacity must instantly double"
          },
          {
            "id": "c",
            "zh-CN": "利率下降",
            "en": "Interest falls"
          },
          {
            "id": "d",
            "zh-CN": "纵轴改为实际 GDP",
            "en": "The vertical axis becomes real GDP"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "利率下降。 利率提高持币机会成本；货币需求量下降；供需交点形成模型均衡 货币市场纵轴是名义利率，横轴是货币数量，不是商品价格与产量。",
          "en": "Interest falls. Interest raises the opportunity cost of money; quantity of money demanded falls; demand and supply intersect at model equilibrium The axes are nominal interest and money quantity, not a good’s price and output."
        }
      },
      {
        "id": "u3-59-money-market-short-1",
        "knowledgePointId": "u3-59-money-market",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释货币市场与均衡利率的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of The money market and equilibrium interest and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "在简单流动性偏好模型中，货币需求随持币机会成本即名义利率上升而下降；给定货币供给与需求交点确定利率。 利率提高持币机会成本；货币需求量下降；供需交点形成模型均衡 原创假设：收入与价格等不变，货币供给右移可降低均衡利率；真实央行也可直接以政策利率为操作目标，不能把示意模型当作所有制度的逐日流程。",
          "en": "In a simple liquidity-preference model, money demand falls as the nominal interest opportunity cost of holding money rises. Its intersection with given money supply determines interest. Interest raises the opportunity cost of money; quantity of money demanded falls; demand and supply intersect at model equilibrium Hypothetical scenario: holding income and prices constant, a rightward money-supply shift lowers equilibrium interest. Actual central banks may target a policy rate directly; the schematic is not every system’s daily operating process."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "利率",
              "en": "interest"
            },
            "alternatives": {
              "zh-CN": [
                "利率",
                "利率提高持币机会成本"
              ],
              "en": [
                "interest",
                "Interest raises the opportunity cost of money"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "货币需求",
              "en": "money demand"
            },
            "alternatives": {
              "zh-CN": [
                "货币需求",
                "货币需求量下降"
              ],
              "en": [
                "money demand",
                "quantity of money demanded falls"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "供给",
              "en": "supply"
            },
            "alternatives": {
              "zh-CN": [
                "供给",
                "供需交点形成模型均衡"
              ],
              "en": [
                "supply",
                "demand and supply intersect at model equilibrium"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u3-60-inflation-costs",
      "slug": "inflation-costs",
      "section": "3.3",
      "level": "core",
      "syllabusRefs": [
        "3.3 Macroeconomic objectives"
      ],
      "textbookRefs": [
        {
          "chapter": "10",
          "section": "10.2",
          "pages": [
            308
          ]
        }
      ],
      "prerequisites": [
        "u3-17-macro-equilibrium"
      ],
      "related": [
        "u3-21-unemployment-rate",
        "u3-22-unemployment-types",
        "u3-23-unemployment-costs"
      ],
      "terms": [
        "通胀成本与失业的比较",
        "Inflation costs and comparison with unemployment",
        "通胀",
        "inflation",
        "实际",
        "real",
        "分配",
        "distribution"
      ],
      "synonyms": {
        "zh-CN": [
          "通胀",
          "实际",
          "分配"
        ],
        "en": [
          "inflation",
          "real",
          "distribution"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u3-60-inflation-costs-flash-1",
        "u3-60-inflation-costs-mcq-1",
        "u3-60-inflation-costs-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u3-60-inflation-costs",
        "locale": "zh-CN",
        "title": "通胀成本与失业的比较",
        "takeaway": "高且难预测的通胀可损害购买力、计划、储蓄实际回报与价格信号；失业造成产出和社会损失，政策评价需比较冲击来源与分配。",
        "definition": "高且难预测的通胀可损害购买力、计划、储蓄实际回报与价格信号；失业造成产出和社会损失，政策评价需比较冲击来源与分配。",
        "causalChain": [
          "价格变化不均且难预测",
          "实际收入和债务负担重新分配",
          "不确定性影响储蓄投资与资源配置"
        ],
        "misconceptions": [
          "并非所有人因通胀受到相同损失；可预期、低且稳定的通胀与高波动通胀不能混为一谈。"
        ],
        "examApplication": [
          "先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
        ],
        "summary": [
          "高且难预测的通胀可损害购买力、计划、储蓄实际回报与价格信号；失业造成产出和社会损失，政策评价需比较冲击来源与分配。",
          "并非所有人因通胀受到相同损失；可预期、低且稳定的通胀与高波动通胀不能混为一谈。"
        ],
        "explanation": "价格变化不均且难预测。实际收入和债务负担重新分配。不确定性影响储蓄投资与资源配置。\n\n### 原创情境与推导\n\n原创假设：意外通胀可降低固定名义债务的实际负担，使债务人受益、债权人受损；工资能否跟上决定家庭影响。压低成本推动通胀的需求政策可能增加失业，应比较代价。\n\n并非所有人因通胀受到相同损失；可预期、低且稳定的通胀与高波动通胀不能混为一谈。\n\n先定义和衡量目标，再解释成因、利益相关者与目标冲突。"
      },
      "en": {
        "id": "u3-60-inflation-costs",
        "locale": "en",
        "title": "Inflation costs and comparison with unemployment",
        "takeaway": "High unpredictable inflation can harm purchasing power, planning, real saving returns and price signals. Unemployment creates output and social losses; evaluate shock sources and distribution.",
        "definition": "High unpredictable inflation can harm purchasing power, planning, real saving returns and price signals. Unemployment creates output and social losses; evaluate shock sources and distribution.",
        "causalChain": [
          "Prices change unevenly and unpredictably",
          "real incomes and debt burdens redistribute",
          "uncertainty affects saving, investment and allocation"
        ],
        "misconceptions": [
          "Inflation does not affect everyone equally; low predictable inflation differs from high volatile inflation."
        ],
        "examApplication": [
          "Define and measure objectives before analysing causes, stakeholders and conflicts."
        ],
        "summary": [
          "High unpredictable inflation can harm purchasing power, planning, real saving returns and price signals. Unemployment creates output and social losses; evaluate shock sources and distribution.",
          "Inflation does not affect everyone equally; low predictable inflation differs from high volatile inflation."
        ],
        "explanation": "Prices change unevenly and unpredictably.  real incomes and debt burdens redistribute.  uncertainty affects saving, investment and allocation.\n\n### Original scenario and reasoning\n\nHypothetical scenario: unexpected inflation reduces fixed nominal debt’s real burden, potentially helping debtors and hurting creditors. Wage adjustment affects households. Demand restraint against cost-push inflation may raise unemployment, requiring a cost comparison.\n\nInflation does not affect everyone equally; low predictable inflation differs from high volatile inflation.\n\nDefine and measure objectives before analysing causes, stakeholders and conflicts."
      }
    },
    "practice": [
      {
        "id": "u3-60-inflation-costs-flash-1",
        "knowledgePointId": "u3-60-inflation-costs",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“通胀成本与失业的比较”，并说明一个关键条件。",
          "en": "Explain Inflation costs and comparison with unemployment and state one important condition."
        },
        "answer": {
          "zh-CN": "高且难预测的通胀可损害购买力、计划、储蓄实际回报与价格信号；失业造成产出和社会损失，政策评价需比较冲击来源与分配。",
          "en": "High unpredictable inflation can harm purchasing power, planning, real saving returns and price signals. Unemployment creates output and social losses; evaluate shock sources and distribution."
        },
        "explanation": {
          "zh-CN": "并非所有人因通胀受到相同损失；可预期、低且稳定的通胀与高波动通胀不能混为一谈。",
          "en": "Inflation does not affect everyone equally; low predictable inflation differs from high volatile inflation."
        }
      },
      {
        "id": "u3-60-inflation-costs-mcq-1",
        "knowledgePointId": "u3-60-inflation-costs",
        "type": "mcq",
        "prompt": {
          "zh-CN": "意外通胀对固定名义债务的实际负担通常怎样？",
          "en": "What does unexpected inflation normally do to fixed nominal debt’s real burden?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "自动免除本金",
            "en": "Automatically cancels principal"
          },
          {
            "id": "b",
            "zh-CN": "必提高实际负担",
            "en": "Necessarily raises the real burden"
          },
          {
            "id": "c",
            "zh-CN": "与价格完全无关",
            "en": "It has no relation to prices"
          },
          {
            "id": "d",
            "zh-CN": "降低实际负担",
            "en": "Reduces the real burden"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "降低实际负担。 价格变化不均且难预测；实际收入和债务负担重新分配；不确定性影响储蓄投资与资源配置 并非所有人因通胀受到相同损失；可预期、低且稳定的通胀与高波动通胀不能混为一谈。",
          "en": "Reduces the real burden. Prices change unevenly and unpredictably; real incomes and debt burdens redistribute; uncertainty affects saving, investment and allocation Inflation does not affect everyone equally; low predictable inflation differs from high volatile inflation."
        }
      },
      {
        "id": "u3-60-inflation-costs-short-1",
        "knowledgePointId": "u3-60-inflation-costs",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释通胀成本与失业的比较的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Inflation costs and comparison with unemployment and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "高且难预测的通胀可损害购买力、计划、储蓄实际回报与价格信号；失业造成产出和社会损失，政策评价需比较冲击来源与分配。 价格变化不均且难预测；实际收入和债务负担重新分配；不确定性影响储蓄投资与资源配置 原创假设：意外通胀可降低固定名义债务的实际负担，使债务人受益、债权人受损；工资能否跟上决定家庭影响。压低成本推动通胀的需求政策可能增加失业，应比较代价。",
          "en": "High unpredictable inflation can harm purchasing power, planning, real saving returns and price signals. Unemployment creates output and social losses; evaluate shock sources and distribution. Prices change unevenly and unpredictably; real incomes and debt burdens redistribute; uncertainty affects saving, investment and allocation Hypothetical scenario: unexpected inflation reduces fixed nominal debt’s real burden, potentially helping debtors and hurting creditors. Wage adjustment affects households. Demand restraint against cost-push inflation may raise unemployment, requiring a cost comparison."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "通胀",
              "en": "inflation"
            },
            "alternatives": {
              "zh-CN": [
                "通胀",
                "价格变化不均且难预测"
              ],
              "en": [
                "inflation",
                "Prices change unevenly and unpredictably"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "实际",
              "en": "real"
            },
            "alternatives": {
              "zh-CN": [
                "实际",
                "实际收入和债务负担重新分配"
              ],
              "en": [
                "real",
                "real incomes and debt burdens redistribute"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "分配",
              "en": "distribution"
            },
            "alternatives": {
              "zh-CN": [
                "分配",
                "不确定性影响储蓄投资与资源配置"
              ],
              "en": [
                "distribution",
                "uncertainty affects saving, investment and allocation"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-01-trade-benefits",
      "slug": "trade-benefits",
      "section": "4.1",
      "level": "core",
      "syllabusRefs": [
        "4.1 Benefits of international trade"
      ],
      "textbookRefs": [
        {
          "chapter": "14",
          "section": "14.1",
          "pages": [
            433
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-02-free-trade-imports",
        "u4-03-free-trade-exports",
        "u4-04-absolute-advantage"
      ],
      "terms": [
        "贸易、专业化与竞争",
        "Trade, specialisation and competition",
        "专业化",
        "specialisation",
        "规模",
        "scale",
        "竞争",
        "competition"
      ],
      "synonyms": {
        "zh-CN": [
          "专业化",
          "规模",
          "竞争"
        ],
        "en": [
          "specialisation",
          "scale",
          "competition"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-01-trade-benefits-flash-1",
        "u4-01-trade-benefits-mcq-1",
        "u4-01-trade-benefits-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-01-trade-benefits",
        "locale": "zh-CN",
        "title": "贸易、专业化与竞争",
        "takeaway": "国际贸易通过专业化、更大市场、竞争和技术传播扩大消费选择，但收益分配不均。",
        "definition": "国际贸易通过专业化、更大市场、竞争和技术传播扩大消费选择，但收益分配不均。",
        "causalChain": [
          "更大市场支持专业化",
          "规模扩大可降低平均成本",
          "竞争约束价格并促进创新"
        ],
        "misconceptions": [
          "总收益增加不代表每个人都获益；调整成本、环境成本和依赖性需要单独评价。"
        ],
        "examApplication": [
          "说明小国、同质商品和成本假设，比较总福利与分配；HL 计算先写机会成本。"
        ],
        "summary": [
          "国际贸易通过专业化、更大市场、竞争和技术传播扩大消费选择，但收益分配不均。",
          "总收益增加不代表每个人都获益；调整成本、环境成本和依赖性需要单独评价。"
        ],
        "explanation": "更大市场支持专业化。规模扩大可降低平均成本。竞争约束价格并促进创新。\n\n### 原创情境与推导\n\n原创假设：本国药品企业进入更大市场，分摊研发成本；消费者可能获得低价药，但低效率企业的工人可能需要转岗。\n\n总收益增加不代表每个人都获益；调整成本、环境成本和依赖性需要单独评价。\n\n说明小国、同质商品和成本假设，比较总福利与分配；HL 计算先写机会成本。"
      },
      "en": {
        "id": "u4-01-trade-benefits",
        "locale": "en",
        "title": "Trade, specialisation and competition",
        "takeaway": "Trade can widen consumption choices through specialisation, larger markets, competition and technology diffusion, but gains are unevenly distributed.",
        "definition": "Trade can widen consumption choices through specialisation, larger markets, competition and technology diffusion, but gains are unevenly distributed.",
        "causalChain": [
          "Larger markets support specialisation",
          "greater scale can reduce average costs",
          "competition can restrain prices and encourage innovation"
        ],
        "misconceptions": [
          "Aggregate gains do not mean everyone gains; adjustment costs, environmental effects and dependence require separate evaluation."
        ],
        "examApplication": [
          "State small-country, homogeneous-good and cost assumptions; compare welfare and distribution. For HL calculations, start with opportunity costs."
        ],
        "summary": [
          "Trade can widen consumption choices through specialisation, larger markets, competition and technology diffusion, but gains are unevenly distributed.",
          "Aggregate gains do not mean everyone gains; adjustment costs, environmental effects and dependence require separate evaluation."
        ],
        "explanation": "Larger markets support specialisation.  greater scale can reduce average costs.  competition can restrain prices and encourage innovation.\n\n### Original scenario and reasoning\n\nHypothetical scenario: a medicine producer spreads research costs across a larger market. Consumers may obtain cheaper medicines while workers in less efficient firms face retraining.\n\nAggregate gains do not mean everyone gains; adjustment costs, environmental effects and dependence require separate evaluation.\n\nState small-country, homogeneous-good and cost assumptions; compare welfare and distribution. For HL calculations, start with opportunity costs."
      }
    },
    "practice": [
      {
        "id": "u4-01-trade-benefits-flash-1",
        "knowledgePointId": "u4-01-trade-benefits",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“贸易、专业化与竞争”，并说明一个关键条件。",
          "en": "Explain Trade, specialisation and competition and state one important condition."
        },
        "answer": {
          "zh-CN": "国际贸易通过专业化、更大市场、竞争和技术传播扩大消费选择，但收益分配不均。",
          "en": "Trade can widen consumption choices through specialisation, larger markets, competition and technology diffusion, but gains are unevenly distributed."
        },
        "explanation": {
          "zh-CN": "总收益增加不代表每个人都获益；调整成本、环境成本和依赖性需要单独评价。",
          "en": "Aggregate gains do not mean everyone gains; adjustment costs, environmental effects and dependence require separate evaluation."
        }
      },
      {
        "id": "u4-01-trade-benefits-mcq-1",
        "knowledgePointId": "u4-01-trade-benefits",
        "type": "mcq",
        "prompt": {
          "zh-CN": "更大出口市场如何帮助降低单位成本？",
          "en": "How can a larger export market reduce unit costs?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "分摊固定成本",
            "en": "Spreading fixed costs"
          },
          {
            "id": "b",
            "zh-CN": "必然消除所有失业",
            "en": "Necessarily removing all unemployment"
          },
          {
            "id": "c",
            "zh-CN": "使资源不再稀缺",
            "en": "Ending resource scarcity"
          },
          {
            "id": "d",
            "zh-CN": "保证每家企业盈利",
            "en": "Guaranteeing profit for every firm"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "分摊固定成本。 更大市场支持专业化；规模扩大可降低平均成本；竞争约束价格并促进创新 总收益增加不代表每个人都获益；调整成本、环境成本和依赖性需要单独评价。",
          "en": "Spreading fixed costs. Larger markets support specialisation; greater scale can reduce average costs; competition can restrain prices and encourage innovation Aggregate gains do not mean everyone gains; adjustment costs, environmental effects and dependence require separate evaluation."
        }
      },
      {
        "id": "u4-01-trade-benefits-short-1",
        "knowledgePointId": "u4-01-trade-benefits",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释贸易、专业化与竞争的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Trade, specialisation and competition and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "国际贸易通过专业化、更大市场、竞争和技术传播扩大消费选择，但收益分配不均。 更大市场支持专业化；规模扩大可降低平均成本；竞争约束价格并促进创新 原创假设：本国药品企业进入更大市场，分摊研发成本；消费者可能获得低价药，但低效率企业的工人可能需要转岗。",
          "en": "Trade can widen consumption choices through specialisation, larger markets, competition and technology diffusion, but gains are unevenly distributed. Larger markets support specialisation; greater scale can reduce average costs; competition can restrain prices and encourage innovation Hypothetical scenario: a medicine producer spreads research costs across a larger market. Consumers may obtain cheaper medicines while workers in less efficient firms face retraining."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "专业化",
              "en": "specialisation"
            },
            "alternatives": {
              "zh-CN": [
                "专业化",
                "更大市场支持专业化"
              ],
              "en": [
                "specialisation",
                "Larger markets support specialisation"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "规模",
              "en": "scale"
            },
            "alternatives": {
              "zh-CN": [
                "规模",
                "规模扩大可降低平均成本"
              ],
              "en": [
                "scale",
                "greater scale can reduce average costs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "竞争",
              "en": "competition"
            },
            "alternatives": {
              "zh-CN": [
                "竞争",
                "竞争约束价格并促进创新"
              ],
              "en": [
                "competition",
                "competition can restrain prices and encourage innovation"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-02-free-trade-imports",
      "slug": "free-trade-imports",
      "section": "4.1",
      "level": "core",
      "syllabusRefs": [
        "4.1 Benefits of international trade"
      ],
      "textbookRefs": [
        {
          "chapter": "14",
          "section": "14.1",
          "pages": [
            433
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-01-trade-benefits",
        "u4-03-free-trade-exports",
        "u4-04-absolute-advantage"
      ],
      "terms": [
        "小国自由贸易与进口",
        "Free trade and imports in a small economy",
        "世界价格",
        "world price",
        "进口",
        "imports",
        "差额",
        "gap"
      ],
      "synonyms": {
        "zh-CN": [
          "世界价格",
          "进口",
          "差额"
        ],
        "en": [
          "world price",
          "imports",
          "gap"
        ]
      },
      "diagramIds": [
        "global-imports"
      ],
      "quizIds": [
        "u4-02-free-trade-imports-flash-1",
        "u4-02-free-trade-imports-mcq-1",
        "u4-02-free-trade-imports-short-1",
        "u4-02-free-trade-imports-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-02-free-trade-imports",
        "locale": "zh-CN",
        "hlExtension": "原创假设：Pw=10 时 Qd=100、Qs=40，进口 60；消费者获益而生产者受损，在无外部性模型中存在净福利收益。",
        "title": "小国自由贸易与进口",
        "takeaway": "在同质商品、小国和无运输成本模型中，世界价格低于自给均衡价时，国内需求超过供给，差额为进口。",
        "definition": "在同质商品、小国和无运输成本模型中，世界价格低于自给均衡价时，国内需求超过供给，差额为进口。",
        "causalChain": [
          "世界价格低于自给价",
          "国内消费增加而生产减少",
          "进口满足需求与供给差额"
        ],
        "misconceptions": [
          "小国接受世界价格；进口量不是国内总消费量。"
        ],
        "examApplication": [
          "说明小国、同质商品和成本假设，比较总福利与分配；HL 计算先写机会成本。"
        ],
        "summary": [
          "在同质商品、小国和无运输成本模型中，世界价格低于自给均衡价时，国内需求超过供给，差额为进口。",
          "小国接受世界价格；进口量不是国内总消费量。"
        ],
        "explanation": "世界价格低于自给价。国内消费增加而生产减少。进口满足需求与供给差额。\n\n### 原创情境与推导\n\n原创假设：世界价低于自给价，国内消费者增加购买，本国产量减少，进口填补差额；消费者获益、生产者受损。读图计算贸易量、支出和剩余属于 HL。\n\n小国接受世界价格；进口量不是国内总消费量。\n\n说明小国、同质商品和成本假设，比较总福利与分配；HL 计算先写机会成本。"
      },
      "en": {
        "id": "u4-02-free-trade-imports",
        "locale": "en",
        "hlExtension": "Hypothetical scenario: at Pw=10, Qd=100 and Qs=40, so imports are 60. Consumers gain and producers lose, with net welfare gains in a model without externalities.",
        "title": "Free trade and imports in a small economy",
        "takeaway": "In a small-country model with homogeneous goods and no transport costs, a world price below the autarky price creates imports equal to domestic demand minus supply.",
        "definition": "In a small-country model with homogeneous goods and no transport costs, a world price below the autarky price creates imports equal to domestic demand minus supply.",
        "causalChain": [
          "The world price is below autarky",
          "domestic consumption rises and production falls",
          "imports fill the demand-supply gap"
        ],
        "misconceptions": [
          "A small economy takes the world price; imports are not total domestic consumption."
        ],
        "examApplication": [
          "State small-country, homogeneous-good and cost assumptions; compare welfare and distribution. For HL calculations, start with opportunity costs."
        ],
        "summary": [
          "In a small-country model with homogeneous goods and no transport costs, a world price below the autarky price creates imports equal to domestic demand minus supply.",
          "A small economy takes the world price; imports are not total domestic consumption."
        ],
        "explanation": "The world price is below autarky.  domestic consumption rises and production falls.  imports fill the demand-supply gap.\n\n### Original scenario and reasoning\n\nHypothetical scenario: a world price below autarky increases domestic purchases and reduces home output; imports fill the gap. Consumers gain and producers lose. Numerical trade-volume, expenditure and surplus calculations from diagrams are HL.\n\nA small economy takes the world price; imports are not total domestic consumption.\n\nState small-country, homogeneous-good and cost assumptions; compare welfare and distribution. For HL calculations, start with opportunity costs."
      }
    },
    "practice": [
      {
        "id": "u4-02-free-trade-imports-flash-1",
        "knowledgePointId": "u4-02-free-trade-imports",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“小国自由贸易与进口”，并说明一个关键条件。",
          "en": "Explain Free trade and imports in a small economy and state one important condition."
        },
        "answer": {
          "zh-CN": "在同质商品、小国和无运输成本模型中，世界价格低于自给均衡价时，国内需求超过供给，差额为进口。",
          "en": "In a small-country model with homogeneous goods and no transport costs, a world price below the autarky price creates imports equal to domestic demand minus supply."
        },
        "explanation": {
          "zh-CN": "小国接受世界价格；进口量不是国内总消费量。",
          "en": "A small economy takes the world price; imports are not total domestic consumption."
        }
      },
      {
        "id": "u4-02-free-trade-imports-mcq-1",
        "knowledgePointId": "u4-02-free-trade-imports",
        "type": "mcq",
        "prompt": {
          "zh-CN": "世界价低于自给价时，小国通常怎样贸易？",
          "en": "How does a small economy normally trade when world price is below autarky?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "必定出口",
            "en": "It necessarily exports"
          },
          {
            "id": "b",
            "zh-CN": "进口以填补国内需求超过供给的差额",
            "en": "It imports the excess of domestic demand over supply"
          },
          {
            "id": "c",
            "zh-CN": "不再消费该商品",
            "en": "It stops consuming the good"
          },
          {
            "id": "d",
            "zh-CN": "世界价由本国单独决定",
            "en": "It alone sets the world price"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "进口以填补国内需求超过供给的差额。 世界价格低于自给价；国内消费增加而生产减少；进口满足需求与供给差额 小国接受世界价格；进口量不是国内总消费量。",
          "en": "It imports the excess of domestic demand over supply. The world price is below autarky; domestic consumption rises and production falls; imports fill the demand-supply gap A small economy takes the world price; imports are not total domestic consumption."
        }
      },
      {
        "id": "u4-02-free-trade-imports-short-1",
        "knowledgePointId": "u4-02-free-trade-imports",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释小国自由贸易与进口的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Free trade and imports in a small economy and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "在同质商品、小国和无运输成本模型中，世界价格低于自给均衡价时，国内需求超过供给，差额为进口。 世界价格低于自给价；国内消费增加而生产减少；进口满足需求与供给差额 原创假设：世界价低于自给价，国内消费者增加购买，本国产量减少，进口填补差额；消费者获益、生产者受损。读图计算贸易量、支出和剩余属于 HL。",
          "en": "In a small-country model with homogeneous goods and no transport costs, a world price below the autarky price creates imports equal to domestic demand minus supply. The world price is below autarky; domestic consumption rises and production falls; imports fill the demand-supply gap Hypothetical scenario: a world price below autarky increases domestic purchases and reduces home output; imports fill the gap. Consumers gain and producers lose. Numerical trade-volume, expenditure and surplus calculations from diagrams are HL."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "世界价格",
              "en": "world price"
            },
            "alternatives": {
              "zh-CN": [
                "世界价格",
                "世界价格低于自给价"
              ],
              "en": [
                "world price",
                "The world price is below autarky"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "进口",
              "en": "imports"
            },
            "alternatives": {
              "zh-CN": [
                "进口",
                "国内消费增加而生产减少"
              ],
              "en": [
                "imports",
                "domestic consumption rises and production falls"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "差额",
              "en": "gap"
            },
            "alternatives": {
              "zh-CN": [
                "差额",
                "进口满足需求与供给差额"
              ],
              "en": [
                "gap",
                "imports fill the demand-supply gap"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u4-02-free-trade-imports-mcq-hl-1",
        "knowledgePointId": "u4-02-free-trade-imports",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "Qd=90、Qs=30 时进口量是多少？",
          "en": "With Qd=90 and Qs=30, how large are imports?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "120",
            "en": "120"
          },
          {
            "id": "b",
            "zh-CN": "90",
            "en": "90"
          },
          {
            "id": "c",
            "zh-CN": "60",
            "en": "60"
          },
          {
            "id": "d",
            "zh-CN": "30",
            "en": "30"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "60。 90 − 30 = 60",
          "en": "60. 90 − 30 = 60"
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-03-free-trade-exports",
      "slug": "free-trade-exports",
      "section": "4.1",
      "level": "core",
      "syllabusRefs": [
        "4.1 Benefits of international trade"
      ],
      "textbookRefs": [
        {
          "chapter": "14",
          "section": "14.1",
          "pages": [
            433
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-01-trade-benefits",
        "u4-02-free-trade-imports",
        "u4-04-absolute-advantage"
      ],
      "terms": [
        "小国自由贸易与出口",
        "Free trade and exports in a small economy",
        "世界价格",
        "world price",
        "出口",
        "exports",
        "供给",
        "supply"
      ],
      "synonyms": {
        "zh-CN": [
          "世界价格",
          "出口",
          "供给"
        ],
        "en": [
          "world price",
          "exports",
          "supply"
        ]
      },
      "diagramIds": [
        "global-exports"
      ],
      "quizIds": [
        "u4-03-free-trade-exports-flash-1",
        "u4-03-free-trade-exports-mcq-1",
        "u4-03-free-trade-exports-short-1",
        "u4-03-free-trade-exports-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-03-free-trade-exports",
        "locale": "zh-CN",
        "hlExtension": "原创假设：Pw=20 时 Qs=120、Qd=70，出口 50；生产者获益，国内消费者支付更高价格。",
        "title": "小国自由贸易与出口",
        "takeaway": "世界价格高于自给均衡价时，国内供给超过需求，剩余产出出口。",
        "definition": "世界价格高于自给均衡价时，国内供给超过需求，剩余产出出口。",
        "causalChain": [
          "较高世界价格提高生产激励",
          "国内消费者减少购买",
          "出口等于供给减需求"
        ],
        "misconceptions": [
          "出口收益不是纯福利收益；应比较消费者与生产者剩余的变化。"
        ],
        "examApplication": [
          "说明小国、同质商品和成本假设，比较总福利与分配；HL 计算先写机会成本。"
        ],
        "summary": [
          "世界价格高于自给均衡价时，国内供给超过需求，剩余产出出口。",
          "出口收益不是纯福利收益；应比较消费者与生产者剩余的变化。"
        ],
        "explanation": "较高世界价格提高生产激励。国内消费者减少购买。出口等于供给减需求。\n\n### 原创情境与推导\n\n原创假设：世界价高于自给价，生产者扩产、国内消费者减少购买，剩余产出出口；生产者获益但国内消费者受损。读图计算出口量与收入属于 HL。\n\n出口收益不是纯福利收益；应比较消费者与生产者剩余的变化。\n\n说明小国、同质商品和成本假设，比较总福利与分配；HL 计算先写机会成本。"
      },
      "en": {
        "id": "u4-03-free-trade-exports",
        "locale": "en",
        "hlExtension": "Hypothetical scenario: at Pw=20, Qs=120 and Qd=70, so exports are 50. Producers gain while domestic consumers pay a higher price.",
        "title": "Free trade and exports in a small economy",
        "takeaway": "When the world price exceeds the autarky equilibrium price, domestic supply exceeds demand and the surplus is exported.",
        "definition": "When the world price exceeds the autarky equilibrium price, domestic supply exceeds demand and the surplus is exported.",
        "causalChain": [
          "A higher world price encourages production",
          "domestic consumers buy less",
          "exports equal supply minus demand"
        ],
        "misconceptions": [
          "Export receipts are not pure welfare gains; compare changes in consumer and producer surplus."
        ],
        "examApplication": [
          "State small-country, homogeneous-good and cost assumptions; compare welfare and distribution. For HL calculations, start with opportunity costs."
        ],
        "summary": [
          "When the world price exceeds the autarky equilibrium price, domestic supply exceeds demand and the surplus is exported.",
          "Export receipts are not pure welfare gains; compare changes in consumer and producer surplus."
        ],
        "explanation": "A higher world price encourages production.  domestic consumers buy less.  exports equal supply minus demand.\n\n### Original scenario and reasoning\n\nHypothetical scenario: world price above autarky raises domestic output and lowers domestic purchases. The surplus is exported; producers gain but home consumers lose. Numerical exports and revenue from diagrams are HL.\n\nExport receipts are not pure welfare gains; compare changes in consumer and producer surplus.\n\nState small-country, homogeneous-good and cost assumptions; compare welfare and distribution. For HL calculations, start with opportunity costs."
      }
    },
    "practice": [
      {
        "id": "u4-03-free-trade-exports-flash-1",
        "knowledgePointId": "u4-03-free-trade-exports",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“小国自由贸易与出口”，并说明一个关键条件。",
          "en": "Explain Free trade and exports in a small economy and state one important condition."
        },
        "answer": {
          "zh-CN": "世界价格高于自给均衡价时，国内供给超过需求，剩余产出出口。",
          "en": "When the world price exceeds the autarky equilibrium price, domestic supply exceeds demand and the surplus is exported."
        },
        "explanation": {
          "zh-CN": "出口收益不是纯福利收益；应比较消费者与生产者剩余的变化。",
          "en": "Export receipts are not pure welfare gains; compare changes in consumer and producer surplus."
        }
      },
      {
        "id": "u4-03-free-trade-exports-mcq-1",
        "knowledgePointId": "u4-03-free-trade-exports",
        "type": "mcq",
        "prompt": {
          "zh-CN": "世界价高于自给价时，出口来自哪里？",
          "en": "With world price above autarky, what supplies exports?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "国内需求超过供给的部分",
            "en": "Domestic demand exceeding supply"
          },
          {
            "id": "b",
            "zh-CN": "必定来自所有进口",
            "en": "Necessarily all imports"
          },
          {
            "id": "c",
            "zh-CN": "国内供给超过国内需求的部分",
            "en": "Domestic supply exceeding domestic demand"
          },
          {
            "id": "d",
            "zh-CN": "仅来自政府储备",
            "en": "Only government reserves"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "国内供给超过国内需求的部分。 较高世界价格提高生产激励；国内消费者减少购买；出口等于供给减需求 出口收益不是纯福利收益；应比较消费者与生产者剩余的变化。",
          "en": "Domestic supply exceeding domestic demand. A higher world price encourages production; domestic consumers buy less; exports equal supply minus demand Export receipts are not pure welfare gains; compare changes in consumer and producer surplus."
        }
      },
      {
        "id": "u4-03-free-trade-exports-short-1",
        "knowledgePointId": "u4-03-free-trade-exports",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释小国自由贸易与出口的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Free trade and exports in a small economy and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "世界价格高于自给均衡价时，国内供给超过需求，剩余产出出口。 较高世界价格提高生产激励；国内消费者减少购买；出口等于供给减需求 原创假设：世界价高于自给价，生产者扩产、国内消费者减少购买，剩余产出出口；生产者获益但国内消费者受损。读图计算出口量与收入属于 HL。",
          "en": "When the world price exceeds the autarky equilibrium price, domestic supply exceeds demand and the surplus is exported. A higher world price encourages production; domestic consumers buy less; exports equal supply minus demand Hypothetical scenario: world price above autarky raises domestic output and lowers domestic purchases. The surplus is exported; producers gain but home consumers lose. Numerical exports and revenue from diagrams are HL."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "世界价格",
              "en": "world price"
            },
            "alternatives": {
              "zh-CN": [
                "世界价格",
                "较高世界价格提高生产激励"
              ],
              "en": [
                "world price",
                "A higher world price encourages production"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "出口",
              "en": "exports"
            },
            "alternatives": {
              "zh-CN": [
                "出口",
                "国内消费者减少购买"
              ],
              "en": [
                "exports",
                "domestic consumers buy less"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "供给",
              "en": "supply"
            },
            "alternatives": {
              "zh-CN": [
                "供给",
                "出口等于供给减需求"
              ],
              "en": [
                "supply",
                "exports equal supply minus demand"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u4-03-free-trade-exports-mcq-hl-1",
        "knowledgePointId": "u4-03-free-trade-exports",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "Qs=80、Qd=50，出口多少？",
          "en": "If Qs=80 and Qd=50, what are exports?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "130",
            "en": "130"
          },
          {
            "id": "b",
            "zh-CN": "50",
            "en": "50"
          },
          {
            "id": "c",
            "zh-CN": "80",
            "en": "80"
          },
          {
            "id": "d",
            "zh-CN": "30",
            "en": "30"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "30。 80 − 50 = 30",
          "en": "30. 80 − 50 = 30"
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-04-absolute-advantage",
      "slug": "absolute-advantage",
      "section": "4.1",
      "level": "hl",
      "syllabusRefs": [
        "4.1 Benefits of international trade"
      ],
      "textbookRefs": [
        {
          "chapter": "14",
          "section": "14.2",
          "pages": [
            438
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-01-trade-benefits",
        "u4-02-free-trade-imports",
        "u4-03-free-trade-exports"
      ],
      "terms": [
        "绝对优势",
        "Absolute advantage",
        "资源",
        "resources",
        "产量",
        "output",
        "生产率",
        "productivity"
      ],
      "synonyms": {
        "zh-CN": [
          "资源",
          "产量",
          "生产率"
        ],
        "en": [
          "resources",
          "output",
          "productivity"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-04-absolute-advantage-flash-1",
        "u4-04-absolute-advantage-mcq-1",
        "u4-04-absolute-advantage-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-04-absolute-advantage",
        "locale": "zh-CN",
        "title": "绝对优势",
        "takeaway": "使用相同资源能够生产更多某产品，或生产同量产品所需资源更少，即拥有绝对优势。",
        "definition": "使用相同资源能够生产更多某产品，或生产同量产品所需资源更少，即拥有绝对优势。",
        "causalChain": [
          "保持投入可比",
          "比较单位资源的产量",
          "识别生产率优势"
        ],
        "misconceptions": [
          "绝对优势比较生产率，比较优势比较机会成本，二者不能互换。"
        ],
        "examApplication": [
          "说明小国、同质商品和成本假设，比较总福利与分配；HL 计算先写机会成本。"
        ],
        "summary": [
          "使用相同资源能够生产更多某产品，或生产同量产品所需资源更少，即拥有绝对优势。",
          "绝对优势比较生产率，比较优势比较机会成本，二者不能互换。"
        ],
        "explanation": "保持投入可比。比较单位资源的产量。识别生产率优势。\n\n### 原创情境与推导\n\n原创假设：每工时 A 可产 8 件布，B 可产 5 件，A 在布上有绝对优势；仍需比较另一商品才能判断比较优势。\n\n绝对优势比较生产率，比较优势比较机会成本，二者不能互换。\n\n说明小国、同质商品和成本假设，比较总福利与分配；HL 计算先写机会成本。"
      },
      "en": {
        "id": "u4-04-absolute-advantage",
        "locale": "en",
        "title": "Absolute advantage",
        "takeaway": "Absolute advantage means producing more of a good with the same resources, or using fewer resources for the same output.",
        "definition": "Absolute advantage means producing more of a good with the same resources, or using fewer resources for the same output.",
        "causalChain": [
          "Hold inputs comparable",
          "compare output per unit of resources",
          "identify the productivity advantage"
        ],
        "misconceptions": [
          "Absolute advantage compares productivity; comparative advantage compares opportunity cost."
        ],
        "examApplication": [
          "State small-country, homogeneous-good and cost assumptions; compare welfare and distribution. For HL calculations, start with opportunity costs."
        ],
        "summary": [
          "Absolute advantage means producing more of a good with the same resources, or using fewer resources for the same output.",
          "Absolute advantage compares productivity; comparative advantage compares opportunity cost."
        ],
        "explanation": "Hold inputs comparable.  compare output per unit of resources.  identify the productivity advantage.\n\n### Original scenario and reasoning\n\nHypothetical scenario: A produces eight cloth units per hour and B five. A has absolute advantage in cloth, but another good is needed to establish comparative advantage.\n\nAbsolute advantage compares productivity; comparative advantage compares opportunity cost.\n\nState small-country, homogeneous-good and cost assumptions; compare welfare and distribution. For HL calculations, start with opportunity costs."
      }
    },
    "practice": [
      {
        "id": "u4-04-absolute-advantage-flash-1",
        "knowledgePointId": "u4-04-absolute-advantage",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“绝对优势”，并说明一个关键条件。",
          "en": "Explain Absolute advantage and state one important condition."
        },
        "answer": {
          "zh-CN": "使用相同资源能够生产更多某产品，或生产同量产品所需资源更少，即拥有绝对优势。",
          "en": "Absolute advantage means producing more of a good with the same resources, or using fewer resources for the same output."
        },
        "explanation": {
          "zh-CN": "绝对优势比较生产率，比较优势比较机会成本，二者不能互换。",
          "en": "Absolute advantage compares productivity; comparative advantage compares opportunity cost."
        }
      },
      {
        "id": "u4-04-absolute-advantage-mcq-1",
        "knowledgePointId": "u4-04-absolute-advantage",
        "type": "mcq",
        "prompt": {
          "zh-CN": "同一工时产量 8 对 5，谁有绝对优势？",
          "en": "With output of eight versus five per equal hour, who has absolute advantage?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "产量为 5 的经济体",
            "en": "The economy producing five"
          },
          {
            "id": "b",
            "zh-CN": "必然都没有",
            "en": "Neither necessarily"
          },
          {
            "id": "c",
            "zh-CN": "只看汇率判断",
            "en": "Decide only from the exchange rate"
          },
          {
            "id": "d",
            "zh-CN": "产量为 8 的经济体",
            "en": "The economy producing eight"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "产量为 8 的经济体。 保持投入可比；比较单位资源的产量；识别生产率优势 绝对优势比较生产率，比较优势比较机会成本，二者不能互换。",
          "en": "The economy producing eight. Hold inputs comparable; compare output per unit of resources; identify the productivity advantage Absolute advantage compares productivity; comparative advantage compares opportunity cost."
        }
      },
      {
        "id": "u4-04-absolute-advantage-short-1",
        "knowledgePointId": "u4-04-absolute-advantage",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释绝对优势的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Absolute advantage and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "使用相同资源能够生产更多某产品，或生产同量产品所需资源更少，即拥有绝对优势。 保持投入可比；比较单位资源的产量；识别生产率优势 原创假设：每工时 A 可产 8 件布，B 可产 5 件，A 在布上有绝对优势；仍需比较另一商品才能判断比较优势。",
          "en": "Absolute advantage means producing more of a good with the same resources, or using fewer resources for the same output. Hold inputs comparable; compare output per unit of resources; identify the productivity advantage Hypothetical scenario: A produces eight cloth units per hour and B five. A has absolute advantage in cloth, but another good is needed to establish comparative advantage."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "资源",
              "en": "resources"
            },
            "alternatives": {
              "zh-CN": [
                "资源",
                "保持投入可比"
              ],
              "en": [
                "resources",
                "Hold inputs comparable"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "产量",
              "en": "output"
            },
            "alternatives": {
              "zh-CN": [
                "产量",
                "比较单位资源的产量"
              ],
              "en": [
                "output",
                "compare output per unit of resources"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "生产率",
              "en": "productivity"
            },
            "alternatives": {
              "zh-CN": [
                "生产率",
                "识别生产率优势"
              ],
              "en": [
                "productivity",
                "identify the productivity advantage"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-05-comparative-advantage",
      "slug": "comparative-advantage",
      "section": "4.1",
      "level": "hl",
      "syllabusRefs": [
        "4.1 Benefits of international trade"
      ],
      "textbookRefs": [
        {
          "chapter": "14",
          "section": "14.2",
          "pages": [
            438
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-01-trade-benefits",
        "u4-02-free-trade-imports",
        "u4-03-free-trade-exports"
      ],
      "terms": [
        "比较优势与贸易区间",
        "Comparative advantage and the trading interval",
        "机会成本",
        "opportunity cost",
        "专业化",
        "specialisation",
        "交换比率",
        "trading ratio"
      ],
      "synonyms": {
        "zh-CN": [
          "机会成本",
          "专业化",
          "交换比率"
        ],
        "en": [
          "opportunity cost",
          "specialisation",
          "trading ratio"
        ]
      },
      "diagramIds": [
        "audit-comparative-ppc"
      ],
      "quizIds": [
        "u4-05-comparative-advantage-flash-1",
        "u4-05-comparative-advantage-mcq-1",
        "u4-05-comparative-advantage-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-05-comparative-advantage",
        "locale": "zh-CN",
        "title": "比较优势与贸易区间",
        "takeaway": "比较优势是较低机会成本；互利交换比率须位于双方机会成本之间，且须考虑模型假设。",
        "definition": "比较优势是较低机会成本；互利交换比率须位于双方机会成本之间，且须考虑模型假设。",
        "causalChain": [
          "计算放弃的另一商品",
          "比较机会成本",
          "在两者之间确定互利交换比率"
        ],
        "misconceptions": [
          "即使一国两种商品都有绝对优势，仍可在不同机会成本下互利贸易；现实调整和外部性可能削弱收益。"
        ],
        "examApplication": [
          "说明小国、同质商品和成本假设，比较总福利与分配；HL 计算先写机会成本。"
        ],
        "summary": [
          "比较优势是较低机会成本；互利交换比率须位于双方机会成本之间，且须考虑模型假设。",
          "即使一国两种商品都有绝对优势，仍可在不同机会成本下互利贸易；现实调整和外部性可能削弱收益。"
        ],
        "explanation": "计算放弃的另一商品。比较机会成本。在两者之间确定互利交换比率。\n\n### 原创情境与推导\n\n原创假设：A 可产 10 布或 20 粮，B 可产 6 布或 18 粮。1 布成本分别为 2 粮、3 粮；A 专业化布，按 1 布换 2.5 粮双方可获益。假设资源可转移、充分就业且忽略运费。\n\n即使一国两种商品都有绝对优势，仍可在不同机会成本下互利贸易；现实调整和外部性可能削弱收益。\n\n说明小国、同质商品和成本假设，比较总福利与分配；HL 计算先写机会成本。"
      },
      "en": {
        "id": "u4-05-comparative-advantage",
        "locale": "en",
        "title": "Comparative advantage and the trading interval",
        "takeaway": "Comparative advantage means lower opportunity cost. A mutually beneficial trading ratio lies between the two opportunity costs, subject to model assumptions.",
        "definition": "Comparative advantage means lower opportunity cost. A mutually beneficial trading ratio lies between the two opportunity costs, subject to model assumptions.",
        "causalChain": [
          "Calculate the other good forgone",
          "compare opportunity costs",
          "choose a trading ratio between them"
        ],
        "misconceptions": [
          "Even an economy with absolute advantage in both goods can gain from different opportunity costs; adjustment and externalities can weaken gains."
        ],
        "examApplication": [
          "State small-country, homogeneous-good and cost assumptions; compare welfare and distribution. For HL calculations, start with opportunity costs."
        ],
        "summary": [
          "Comparative advantage means lower opportunity cost. A mutually beneficial trading ratio lies between the two opportunity costs, subject to model assumptions.",
          "Even an economy with absolute advantage in both goods can gain from different opportunity costs; adjustment and externalities can weaken gains."
        ],
        "explanation": "Calculate the other good forgone.  compare opportunity costs.  choose a trading ratio between them.\n\n### Original scenario and reasoning\n\nHypothetical scenario: A can make ten cloth or twenty grain; B six cloth or eighteen grain. One cloth costs two grain in A and three in B. A specialises in cloth; trading at 2.5 grain per cloth can benefit both. Assume mobile domestic resources, full employment and no freight costs.\n\nEven an economy with absolute advantage in both goods can gain from different opportunity costs; adjustment and externalities can weaken gains.\n\nState small-country, homogeneous-good and cost assumptions; compare welfare and distribution. For HL calculations, start with opportunity costs."
      }
    },
    "practice": [
      {
        "id": "u4-05-comparative-advantage-flash-1",
        "knowledgePointId": "u4-05-comparative-advantage",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“比较优势与贸易区间”，并说明一个关键条件。",
          "en": "Explain Comparative advantage and the trading interval and state one important condition."
        },
        "answer": {
          "zh-CN": "比较优势是较低机会成本；互利交换比率须位于双方机会成本之间，且须考虑模型假设。",
          "en": "Comparative advantage means lower opportunity cost. A mutually beneficial trading ratio lies between the two opportunity costs, subject to model assumptions."
        },
        "explanation": {
          "zh-CN": "即使一国两种商品都有绝对优势，仍可在不同机会成本下互利贸易；现实调整和外部性可能削弱收益。",
          "en": "Even an economy with absolute advantage in both goods can gain from different opportunity costs; adjustment and externalities can weaken gains."
        }
      },
      {
        "id": "u4-05-comparative-advantage-mcq-1",
        "knowledgePointId": "u4-05-comparative-advantage",
        "type": "mcq",
        "prompt": {
          "zh-CN": "两国 1 布成本为 2 粮和 3 粮，哪个比率可能互利？",
          "en": "If one cloth costs two and three grain respectively, which ratio can benefit both?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "1 布换 2.5 粮",
            "en": "One cloth for 2.5 grain"
          },
          {
            "id": "b",
            "zh-CN": "1 布换 1 粮",
            "en": "One cloth for one grain"
          },
          {
            "id": "c",
            "zh-CN": "1 布换 4 粮",
            "en": "One cloth for four grain"
          },
          {
            "id": "d",
            "zh-CN": "机会成本相同时必有专业化收益",
            "en": "Equal opportunity costs guarantee specialisation gains"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "1 布换 2.5 粮。 计算放弃的另一商品；比较机会成本；在两者之间确定互利交换比率 即使一国两种商品都有绝对优势，仍可在不同机会成本下互利贸易；现实调整和外部性可能削弱收益。",
          "en": "One cloth for 2.5 grain. Calculate the other good forgone; compare opportunity costs; choose a trading ratio between them Even an economy with absolute advantage in both goods can gain from different opportunity costs; adjustment and externalities can weaken gains."
        }
      },
      {
        "id": "u4-05-comparative-advantage-short-1",
        "knowledgePointId": "u4-05-comparative-advantage",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释比较优势与贸易区间的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Comparative advantage and the trading interval and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "比较优势是较低机会成本；互利交换比率须位于双方机会成本之间，且须考虑模型假设。 计算放弃的另一商品；比较机会成本；在两者之间确定互利交换比率 原创假设：A 可产 10 布或 20 粮，B 可产 6 布或 18 粮。1 布成本分别为 2 粮、3 粮；A 专业化布，按 1 布换 2.5 粮双方可获益。假设资源可转移、充分就业且忽略运费。",
          "en": "Comparative advantage means lower opportunity cost. A mutually beneficial trading ratio lies between the two opportunity costs, subject to model assumptions. Calculate the other good forgone; compare opportunity costs; choose a trading ratio between them Hypothetical scenario: A can make ten cloth or twenty grain; B six cloth or eighteen grain. One cloth costs two grain in A and three in B. A specialises in cloth; trading at 2.5 grain per cloth can benefit both. Assume mobile domestic resources, full employment and no freight costs."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "机会成本",
              "en": "opportunity cost"
            },
            "alternatives": {
              "zh-CN": [
                "机会成本",
                "计算放弃的另一商品"
              ],
              "en": [
                "opportunity cost",
                "Calculate the other good forgone"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "专业化",
              "en": "specialisation"
            },
            "alternatives": {
              "zh-CN": [
                "专业化",
                "比较机会成本"
              ],
              "en": [
                "specialisation",
                "compare opportunity costs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "交换比率",
              "en": "trading ratio"
            },
            "alternatives": {
              "zh-CN": [
                "交换比率",
                "在两者之间确定互利交换比率"
              ],
              "en": [
                "trading ratio",
                "choose a trading ratio between them"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-06-trade-evaluation",
      "slug": "trade-evaluation",
      "section": "4.1",
      "level": "core",
      "syllabusRefs": [
        "4.1 Benefits of international trade"
      ],
      "textbookRefs": [
        {
          "chapter": "14",
          "section": "14.1",
          "pages": [
            433
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-01-trade-benefits",
        "u4-02-free-trade-imports",
        "u4-03-free-trade-exports"
      ],
      "terms": [
        "贸易收益的条件与分配",
        "Conditions and distribution of trade gains",
        "效率",
        "efficiency",
        "调整",
        "adjustment",
        "分配",
        "distribution"
      ],
      "synonyms": {
        "zh-CN": [
          "效率",
          "调整",
          "分配"
        ],
        "en": [
          "efficiency",
          "adjustment",
          "distribution"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-06-trade-evaluation-flash-1",
        "u4-06-trade-evaluation-mcq-1",
        "u4-06-trade-evaluation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-06-trade-evaluation",
        "locale": "zh-CN",
        "title": "贸易收益的条件与分配",
        "takeaway": "贸易能提高配置效率，但长期发展收益取决于产业联系、技能、市场势力和收入分配。",
        "definition": "贸易能提高配置效率，但长期发展收益取决于产业联系、技能、市场势力和收入分配。",
        "causalChain": [
          "进口竞争促使资源重新配置",
          "部分企业和工人承担调整成本",
          "再培训与社会保障影响净收益分布"
        ],
        "misconceptions": [
          "把所有进口都视为损失，或把所有贸易都视为人人受益，都会遗漏利益相关者。"
        ],
        "examApplication": [
          "说明小国、同质商品和成本假设，比较总福利与分配；HL 计算先写机会成本。"
        ],
        "summary": [
          "贸易能提高配置效率，但长期发展收益取决于产业联系、技能、市场势力和收入分配。",
          "把所有进口都视为损失，或把所有贸易都视为人人受益，都会遗漏利益相关者。"
        ],
        "explanation": "进口竞争促使资源重新配置。部分企业和工人承担调整成本。再培训与社会保障影响净收益分布。\n\n### 原创情境与推导\n\n原创假设：廉价进口降低家庭支出，但偏远地区唯一工厂关闭；就业转移需要时间，不能用全国净收益否定地区损失。\n\n把所有进口都视为损失，或把所有贸易都视为人人受益，都会遗漏利益相关者。\n\n说明小国、同质商品和成本假设，比较总福利与分配；HL 计算先写机会成本。"
      },
      "en": {
        "id": "u4-06-trade-evaluation",
        "locale": "en",
        "title": "Conditions and distribution of trade gains",
        "takeaway": "Trade can improve allocative efficiency, while long-run development gains depend on linkages, skills, market power and distribution.",
        "definition": "Trade can improve allocative efficiency, while long-run development gains depend on linkages, skills, market power and distribution.",
        "causalChain": [
          "Import competition reallocates resources",
          "some firms and workers bear adjustment costs",
          "retraining and social protection affect the distribution of net gains"
        ],
        "misconceptions": [
          "Treating every import as a loss, or all trade as beneficial to everyone, omits stakeholders."
        ],
        "examApplication": [
          "State small-country, homogeneous-good and cost assumptions; compare welfare and distribution. For HL calculations, start with opportunity costs."
        ],
        "summary": [
          "Trade can improve allocative efficiency, while long-run development gains depend on linkages, skills, market power and distribution.",
          "Treating every import as a loss, or all trade as beneficial to everyone, omits stakeholders."
        ],
        "explanation": "Import competition reallocates resources.  some firms and workers bear adjustment costs.  retraining and social protection affect the distribution of net gains.\n\n### Original scenario and reasoning\n\nHypothetical scenario: cheaper imports lower household spending but close a remote region's only factory. Reallocation takes time; national net gains do not erase local losses.\n\nTreating every import as a loss, or all trade as beneficial to everyone, omits stakeholders.\n\nState small-country, homogeneous-good and cost assumptions; compare welfare and distribution. For HL calculations, start with opportunity costs."
      }
    },
    "practice": [
      {
        "id": "u4-06-trade-evaluation-flash-1",
        "knowledgePointId": "u4-06-trade-evaluation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“贸易收益的条件与分配”，并说明一个关键条件。",
          "en": "Explain Conditions and distribution of trade gains and state one important condition."
        },
        "answer": {
          "zh-CN": "贸易能提高配置效率，但长期发展收益取决于产业联系、技能、市场势力和收入分配。",
          "en": "Trade can improve allocative efficiency, while long-run development gains depend on linkages, skills, market power and distribution."
        },
        "explanation": {
          "zh-CN": "把所有进口都视为损失，或把所有贸易都视为人人受益，都会遗漏利益相关者。",
          "en": "Treating every import as a loss, or all trade as beneficial to everyone, omits stakeholders."
        }
      },
      {
        "id": "u4-06-trade-evaluation-mcq-1",
        "knowledgePointId": "u4-06-trade-evaluation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "评价贸易开放最应补充哪个问题？",
          "en": "Which question best extends an evaluation of trade opening?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "出口是否永远越多越好",
            "en": "Whether more exports are always better"
          },
          {
            "id": "b",
            "zh-CN": "谁获益、谁付出调整成本",
            "en": "Who gains and who bears adjustment costs"
          },
          {
            "id": "c",
            "zh-CN": "为何消费者剩余必为零",
            "en": "Why consumer surplus must be zero"
          },
          {
            "id": "d",
            "zh-CN": "为何不再需要生产要素",
            "en": "Why factors of production are no longer needed"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "谁获益、谁付出调整成本。 进口竞争促使资源重新配置；部分企业和工人承担调整成本；再培训与社会保障影响净收益分布 把所有进口都视为损失，或把所有贸易都视为人人受益，都会遗漏利益相关者。",
          "en": "Who gains and who bears adjustment costs. Import competition reallocates resources; some firms and workers bear adjustment costs; retraining and social protection affect the distribution of net gains Treating every import as a loss, or all trade as beneficial to everyone, omits stakeholders."
        }
      },
      {
        "id": "u4-06-trade-evaluation-short-1",
        "knowledgePointId": "u4-06-trade-evaluation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释贸易收益的条件与分配的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Conditions and distribution of trade gains and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "贸易能提高配置效率，但长期发展收益取决于产业联系、技能、市场势力和收入分配。 进口竞争促使资源重新配置；部分企业和工人承担调整成本；再培训与社会保障影响净收益分布 原创假设：廉价进口降低家庭支出，但偏远地区唯一工厂关闭；就业转移需要时间，不能用全国净收益否定地区损失。",
          "en": "Trade can improve allocative efficiency, while long-run development gains depend on linkages, skills, market power and distribution. Import competition reallocates resources; some firms and workers bear adjustment costs; retraining and social protection affect the distribution of net gains Hypothetical scenario: cheaper imports lower household spending but close a remote region's only factory. Reallocation takes time; national net gains do not erase local losses."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "效率",
              "en": "efficiency"
            },
            "alternatives": {
              "zh-CN": [
                "效率",
                "进口竞争促使资源重新配置"
              ],
              "en": [
                "efficiency",
                "Import competition reallocates resources"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "调整",
              "en": "adjustment"
            },
            "alternatives": {
              "zh-CN": [
                "调整",
                "部分企业和工人承担调整成本"
              ],
              "en": [
                "adjustment",
                "some firms and workers bear adjustment costs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "分配",
              "en": "distribution"
            },
            "alternatives": {
              "zh-CN": [
                "分配",
                "再培训与社会保障影响净收益分布"
              ],
              "en": [
                "distribution",
                "retraining and social protection affect the distribution of net gains"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-07-tariff",
      "slug": "tariff",
      "section": "4.2",
      "level": "core",
      "syllabusRefs": [
        "4.2 Types of trade protection"
      ],
      "textbookRefs": [
        {
          "chapter": "14",
          "section": "14.3",
          "pages": [
            444
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-08-quota",
        "u4-09-production-subsidy",
        "u4-10-export-subsidy"
      ],
      "terms": [
        "关税与小国福利",
        "Tariffs and small-country welfare",
        "关税",
        "tariff",
        "进口",
        "imports",
        "税收",
        "revenue"
      ],
      "synonyms": {
        "zh-CN": [
          "关税",
          "进口",
          "税收"
        ],
        "en": [
          "tariff",
          "imports",
          "revenue"
        ]
      },
      "diagramIds": [
        "global-tariff"
      ],
      "quizIds": [
        "u4-07-tariff-flash-1",
        "u4-07-tariff-mcq-1",
        "u4-07-tariff-short-1",
        "u4-07-tariff-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-07-tariff",
        "locale": "zh-CN",
        "hlExtension": "原创线性情境：Pw=10，t=2；自由贸易 Qs0=30、Qd0=110，税后 Qs1=50、Qd1=90。进口由 80 降为 40；政府税收 c=2×40=80。生产扭曲 b=½×2×(50−30)=20；消费扭曲 d=½×2×(110−90)=20；净福利变化 −40。生产者剩余增量 a=½×(30+50)×2=80；消费者剩余减少 ½×(110+90)×2=200；−200+80+80=−40。数量以单位、价格以货币/单位计，剩余以货币计。三角形与梯形算法依赖线性曲线；税收和转移不能重复相加。",
        "title": "关税与小国福利",
        "takeaway": "关税提高进口的国内成本，重新分配消费者、生产者与政府的收益；小国无外部性模型中，净损失是两个扭曲三角形。",
        "definition": "关税是对进口商品征收的税。单位关税为每单位固定税额 t；从价关税按进口价值的一定比例征收。本页分析单位关税。",
        "causalChain": [
          "小国世界价 Pw 不变；单位关税提高含税进口成本",
          "国内价升至 Pw+t，沿原有 S 增产、沿 D 减少消费",
          "进口差额缩小，政府只对税后进口征税",
          "剩余在消费者、生产者与政府间转移，留下 b+d 净损失"
        ],
        "misconceptions": [
          "征税使国内价格改变，不意味着国内 D 与 S 本身移动。",
          "税收使用税后进口量，是转移收入，不是净福利增加。",
          "本国生产增加不直接证明总就业或净福利增加。",
          "小国净损失结论有条件；真实大国、外部性和报复需另行分析。"
        ],
        "examApplication": [
          "解释题：交代模型假设，画图并用图上标记逐步解释利益相关者变化。",
          "评价题：把真实案例用于论证，比较短期与长期、下游成本及替代措施，给出有条件判断。"
        ],
        "summary": [
          "税后价格 Pw+t；Qs 增、Qd 减、进口缩小。",
          "消费者损失 a+b+c+d；生产者获得 a；政府获得 c。",
          "净损失 b+d 来自生产与消费扭曲；条件与评价需明确。"
        ],
        "realWorldExample": {
          "title": "美国钢材关税：行业收益与下游成本",
          "sourceUrl": "https://www.usitc.gov/press_room/news_release/2023/er0315_63679.htm",
          "observedAt": "2026-10-20",
          "explanation": "美国 USITC 2023 年报告估计：2018–2021 年，232 条款关税使受影响钢材进口减少 24%，美国钢材价格提高 2.4%，产量提高 1.9%；使用钢铝的下游行业产量平均减少 0.6%。这是历史模型估计，不能从产量直接推断就业，也不能据此计算美国整体净福利；美国也不是本页小国模型的直接验证。"
        },
        "explanation": "### 先界定模型与税种\n\n单位关税是对每单位进口品征收固定金额 t；从价关税则按进口价值的一定比例征税。本页图示使用单位关税。小国不能压低世界出口价格；在仍有进口且完全传导的假设下，进口的含税成本是 Pw+t，本国同质商品的市场价也升至这一水平。这里的“小国”指不能影响世界价格，不是国土面积小。\n\n### 按价格变化推导数量，而不是移动国内供需曲线\n\n自由贸易时，消费者按世界价 Pw 购买，国内企业在这一价格供给 Qs0，消费者需求为 Qd0，差额 Qd0−Qs0 从国外进口。征税后国内价提高到 Pw+t，企业沿原有 S 曲线增加供给到 Qs1，消费者沿原有 D 曲线减少购买到 Qd1。国内偏好和生产条件没有改变，因此不应把这一步画成国内 D 或 S 移动。进口从 Qd0−Qs0 减为 Qd1−Qs1。\n\n### 谁得到什么，谁承担什么？\n\n消费者为较少的购买量支付较高价格，消费者剩余减少 a+b+c+d。国内生产者因价格提高、产量增加而获得剩余 a；政府只对税后仍然进口的商品征税，获得矩形 c。a 与 c 是本国内部的转移；把消费者损失与生产者、政府收益相加后，剩下 b+d 的净损失。\n\n生产扭曲 b：一部分本可按 Pw 进口的商品，现在由边际成本高于 Pw 的国内企业生产，额外消耗真实资源。消费扭曲 d：一部分消费者对商品的支付意愿高于 Pw，却低于含税价，原本互利的消费不再发生。两个三角形因此不是交给政府的税款。\n\n### 从图示走向有条件的评价\n\n受保护行业可能扩大生产，但使用进口投入的下游企业会承受更高成本，出口行业也可能受报复影响。短期保住的岗位、长期竞争力、政府税收和社会净福利是不同的判断对象。不能从生产者获益直接推出“整个国家获益”，也不能把本页的小国无外部性结论无条件套用到所有现实政策。\n\n如存在学习外部性或供应安全目标，应先说明具体市场失灵或政策目标，再比较有时限的保护、培训、生产支持和社会保障。大国可能影响世界价格，但贸易条件收益、报复和执行问题需要单独论证。最后应给出取决于行业、时限和替代措施的判断。"
      },
      "en": {
        "id": "u4-07-tariff",
        "locale": "en",
        "hlExtension": "Original linear example: Pw=10 and t=2. Free-trade Qs0=30 and Qd0=110; post-tariff Qs1=50 and Qd1=90. Imports fall from 80 to 40; revenue c=2×40=80. Production loss b=½×2×(50−30)=20 and consumption loss d=½×2×(110−90)=20, giving net welfare change −40. Producer surplus rises by a=½×(30+50)×2=80. Consumer surplus falls by ½×(110+90)×2=200; −200+80+80=−40. Quantities are units, prices currency per unit and surplus currency. Triangle and trapezium calculations assume linear curves; avoid double-counting transfers.",
        "title": "Tariffs and small-country welfare",
        "takeaway": "A tariff reallocates surplus between consumers, producers and government; in the small-country model without externalities, two distortion triangles remain as a net loss.",
        "definition": "A tariff is a tax on imports. A specific tariff charges a fixed amount t per unit; an ad valorem tariff charges a percentage of import value. This lesson analyses a specific tariff.",
        "causalChain": [
          "Pw stays fixed; the tariff raises landed import cost",
          "Domestic price reaches Pw+t; move along unchanged S and D",
          "The import gap shrinks; government taxes remaining imports",
          "Surplus is redistributed, leaving net losses b+d"
        ],
        "misconceptions": [
          "A price change does not itself shift domestic D or S.",
          "Revenue uses post-tariff imports and is a transfer, not a net welfare gain.",
          "More domestic output does not directly establish more aggregate jobs or welfare.",
          "The small-country result is conditional; large-country effects, externalities and retaliation need separate analysis."
        ],
        "examApplication": [
          "Explanation: state assumptions, draw the diagram and use its labels to explain stakeholder effects.",
          "Evaluation: use real-world evidence, compare time horizons, downstream costs and alternatives, then reach a conditional judgement."
        ],
        "summary": [
          "After the tariff: Pw+t, higher Qs, lower Qd and fewer imports.",
          "Consumers lose a+b+c+d; producers gain a and government gains c.",
          "Net losses b+d are production and consumption distortions; state conditions and evaluate."
        ],
        "realWorldExample": {
          "title": "US steel tariffs: protected output and downstream costs",
          "sourceUrl": "https://www.usitc.gov/press_room/news_release/2023/er0315_63679.htm",
          "observedAt": "2026-10-20",
          "explanation": "A 2023 USITC report estimated that, during 2018–2021, section 232 tariffs reduced affected steel imports by 24%, raised US steel prices by 2.4% and raised output by 1.9%. Downstream output fell by 0.6% on average. These historical estimates do not establish employment or economy-wide net welfare, and the US is not a direct test of the small-country model."
        },
        "explanation": "### Define the model and the tax\n\nA specific tariff charges a fixed amount t per unit imported; an ad valorem tariff charges a percentage of import value. This diagram uses a specific tariff. A small economy cannot reduce the world export price. With continued imports and full pass-through, the landed cost and competitive domestic price become Pw+t. “Small” concerns price-setting power, not geographic size.\n\n### Follow price changes along domestic curves\n\nUnder free trade, domestic producers supply Qs0 at Pw while consumers demand Qd0; imports fill Qd0−Qs0. After the tariff, the higher price encourages production along the unchanged S curve to Qs1 and reduces consumption along the unchanged D curve to Qd1. Preferences and domestic production conditions have not changed, so this is not a shift of domestic D or S. Imports contract to Qd1−Qs1.\n\n### Trace stakeholders and surplus\n\nConsumers pay more and buy less, losing surplus a+b+c+d. Domestic producers gain a as price and output rise. Government taxes only the imports that remain, receiving rectangle c. Areas a and c are domestic transfers. Adding consumer, producer and government changes leaves a net loss b+d.\n\nProduction distortion b arises when domestic units with marginal cost above Pw replace cheaper imports, using extra real resources. Consumption distortion d arises when willingness to pay exceeds Pw but is below the tariff-inclusive price, preventing otherwise beneficial consumption. Neither triangle is money collected by government.\n\n### Turn explanation into conditional evaluation\n\nProtected producers may expand, but downstream firms using the product face higher costs and exporters may face retaliation. Protected jobs, long-run competitiveness, revenue and national welfare are different objectives. Producer gains alone cannot establish national gains; the model's conditional conclusion cannot simply be imposed on every real policy.\n\nIf learning spillovers or supply security matter, identify the externality or objective and compare time-limited protection with training, targeted support and social insurance. A large economy may influence world prices, but terms-of-trade gains, retaliation and enforcement need separate analysis. Reach a judgement that depends on the industry, duration and available alternatives."
      }
    },
    "practice": [
      {
        "id": "u4-07-tariff-flash-1",
        "knowledgePointId": "u4-07-tariff",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“关税与小国福利”，并说明一个关键条件。",
          "en": "Explain Tariffs and small-country welfare and state one important condition."
        },
        "answer": {
          "zh-CN": "单位关税对每单位进口征固定税额。假设小国不能改变 Pw 且税后仍有进口，国内价升至 Pw+t，国内供给增加、消费减少、进口缩小；消费者受损，生产者和政府获得转移，无外部性模型留下 b+d 的净损失。",
          "en": "A specific tariff charges a fixed tax per imported unit. If a small economy cannot change Pw and imports remain positive, domestic price rises to Pw+t, supply rises, consumption and imports fall. Consumers lose; producers and government receive transfers, leaving net losses b+d without externalities."
        },
        "explanation": {
          "zh-CN": "关税收入应乘税后进口量；它是转移，不等于净福利增加。",
          "en": "Use post-tariff imports for revenue; revenue is a transfer, not a net welfare gain."
        }
      },
      {
        "id": "u4-07-tariff-mcq-1",
        "knowledgePointId": "u4-07-tariff",
        "type": "mcq",
        "prompt": {
          "zh-CN": "小国关税通常怎样影响进口？",
          "en": "What normally happens to imports after a small-country tariff?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "进口必定扩大",
            "en": "Imports necessarily expand"
          },
          {
            "id": "b",
            "zh-CN": "消费者价格必定不变",
            "en": "Consumer price cannot change"
          },
          {
            "id": "c",
            "zh-CN": "本国供给增加、需求减少，进口缩小",
            "en": "Domestic supply rises, demand falls and imports shrink"
          },
          {
            "id": "d",
            "zh-CN": "税收就是净福利收益",
            "en": "Revenue is the net welfare gain"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "本国供给增加、需求减少，进口缩小。 进口成本提高；国内生产增加消费减少；政府按税后进口量征税 关税收入应乘税后进口量；它是转移，不等于净福利增加。",
          "en": "Domestic supply rises, demand falls and imports shrink. Import costs rise; domestic production rises and consumption falls; revenue is levied on post-tariff imports Use post-tariff imports for revenue; revenue is a transfer, not a net welfare gain."
        }
      },
      {
        "id": "u4-07-tariff-short-1",
        "knowledgePointId": "u4-07-tariff",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释关税与小国福利的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Tariffs and small-country welfare and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "关税是进口税。假定本国是世界价格接受者、商品同质、竞争市场，无外部性或报复，且税后仍有进口。单位关税使国内价由 Pw 升至 Pw+t；企业沿 S 增产至 Qs1，消费者沿 D 减少购买至 Qd1，进口缩小到 Qd1−Qs1。消费者剩余减少 a+b+c+d，生产者获得 a，政府税收为 c；本国转移 a 与 c 相抵后，生产扭曲 b 与消费扭曲 d 构成净损失。例如原创假设某小国对进口大米征单位关税：国内米厂扩产、家庭减少购买，进口差额缩小。不能仅由米厂获益推断全国净福利增加。",
          "en": "A tariff taxes imports. Assume a price-taking economy, homogeneous goods, competition, no externalities or retaliation and positive remaining imports. A specific tariff raises domestic price from Pw to Pw+t. Firms move along S to Qs1 and consumers along D to Qd1; imports fall to Qd1−Qs1. Consumers lose a+b+c+d, producers gain a and government receives revenue c. Transfers a and c cancel, leaving production and consumption losses b+d. In an original hypothetical rice-importing economy, a tariff encourages local mills to expand while households buy less, shrinking the import gap. Producer gains alone do not establish a national welfare gain."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "关税",
              "en": "tariff"
            },
            "alternatives": {
              "zh-CN": [
                "关税",
                "进口成本提高"
              ],
              "en": [
                "tariff",
                "Import costs rise"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "进口",
              "en": "imports"
            },
            "alternatives": {
              "zh-CN": [
                "进口",
                "国内生产增加消费减少"
              ],
              "en": [
                "imports",
                "domestic production rises and consumption falls"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "税收",
              "en": "revenue"
            },
            "alternatives": {
              "zh-CN": [
                "税收",
                "政府按税后进口量征税"
              ],
              "en": [
                "revenue",
                "revenue is levied on post-tariff imports"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u4-07-tariff-mcq-hl-1",
        "knowledgePointId": "u4-07-tariff",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "单位关税 3，税后进口 20，税收多少？",
          "en": "A tariff of three with post-tariff imports of twenty yields what revenue?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "23",
            "en": "23"
          },
          {
            "id": "b",
            "zh-CN": "17",
            "en": "17"
          },
          {
            "id": "c",
            "zh-CN": "必须用税前进口量",
            "en": "The pre-tariff import volume must be used"
          },
          {
            "id": "d",
            "zh-CN": "60",
            "en": "60"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "60。 3 × 20 = 60",
          "en": "60. 3 × 20 = 60"
        }
      }
    ],
    "workshop": {
      "title": {
        "zh-CN": "关税学习工坊",
        "en": "Tariff learning workshop"
      },
      "introduction": {
        "zh-CN": "先画图，再练解释与评价。所有题目和参考答案均为 Atlas 原创；分值仅说明练习规模，自评清单不是 IB 官方评分，也没有自动语义阅卷。",
        "en": "Draw first, then practise explanation and evaluation. These are original Atlas tasks and model answers. Marks indicate task size; the checklist is not official IB marking or automated semantic assessment."
      },
      "assumptions": {
        "zh-CN": "假定本国是世界价格接受者；商品同质、市场竞争，世界供给在 Pw 处完全有弹性，无运输成本、外部性或报复；关税后仍有正进口。这里只看本国该市场的静态总剩余。",
        "en": "Assume a price-taking small economy, homogeneous goods and competitive markets, perfectly elastic world supply at Pw, no transport costs, externalities or retaliation, and positive imports after the tariff. Welfare here means static domestic surplus in this market."
      },
      "diagram": {
        "prompt": {
          "zh-CN": "不看参考图，画出小国单位关税：标出 D、S、Pw、Pw+t、四个数量、税收及两个净损失区域。可在画布或纸上完成。",
          "en": "Without the reference, draw a small-country specific tariff: label D, S, prices, four quantities, revenue and the two deadweight losses. Use the canvas or paper."
        },
        "criteria": [
          {
            "id": "axes",
            "title": {
              "zh-CN": "坐标轴与曲线",
              "en": "Axes and curves"
            },
            "guidance": {
              "zh-CN": "纵轴是价格，横轴是本国产量；D 向下、S 向上，并准确标注。",
              "en": "Price is vertical and domestic quantity horizontal; label downward D and upward S."
            },
            "feedback": {
              "zh-CN": "检查是否把微观价格写成物价水平；国内供需曲线在征税前后保持不变。",
              "en": "Check for confusion with the macro price level; domestic D and S remain unchanged."
            }
          },
          {
            "id": "prices",
            "title": {
              "zh-CN": "两条价格线",
              "en": "Two price lines"
            },
            "guidance": {
              "zh-CN": "Pw 与 Pw+t 水平，Pw+t 高于 Pw，且低于自给均衡价，税后仍有进口。",
              "en": "Both prices are horizontal, Pw+t above Pw and below autarky, retaining imports."
            },
            "feedback": {
              "zh-CN": "若税后价超过自给价，就不能继续使用本例“仍有进口”的数量与税收。",
              "en": "A price above autarky invalidates this continued-import example."
            }
          },
          {
            "id": "quantities",
            "title": {
              "zh-CN": "四个数量与进口差额",
              "en": "Four quantities and import gaps"
            },
            "guidance": {
              "zh-CN": "从曲线交点投影出 Qs0<Qs1<Qd1<Qd0，分别写出税前、税后进口。",
              "en": "Project intersections onto Qs0<Qs1<Qd1<Qd0 and identify both import gaps."
            },
            "feedback": {
              "zh-CN": "把税后进口写成 Qd1−Qs1；不要用国内总需求代替进口。",
              "en": "Use Qd1−Qs1 for post-tariff imports, not total domestic demand."
            }
          },
          {
            "id": "welfare",
            "title": {
              "zh-CN": "福利区域及解释",
              "en": "Welfare areas and interpretation"
            },
            "guidance": {
              "zh-CN": "标出政府税收 c、生产扭曲 b 与消费扭曲 d，并解释它们代表什么。",
              "en": "Identify revenue c, production loss b and consumption loss d, and explain each."
            },
            "feedback": {
              "zh-CN": "c 是税后进口宽度乘税高的矩形；b+d 是净损失，不是税收。",
              "en": "Rectangle c uses post-tariff imports; b+d is lost welfare rather than revenue."
            }
          }
        ]
      },
      "tasks": [
        {
          "id": "explain",
          "marks": 10,
          "minutes": 18,
          "level": "core",
          "title": {
            "zh-CN": "10 分解释题",
            "en": "10-mark explanation"
          },
          "prompt": {
            "zh-CN": "借助图示，解释小国对进口商品征收单位关税如何影响消费者、国内生产者及政府。说明你的假设。",
            "en": "Using a diagram, explain how a specific import tariff affects consumers, domestic producers and government in a small economy. State your assumptions."
          },
          "criteria": [
            {
              "id": "model",
              "title": {
                "zh-CN": "概念与条件",
                "en": "Concept and assumptions"
              },
              "guidance": {
                "zh-CN": "定义单位关税，明确小国、仍有进口等条件。",
                "en": "Define a specific tariff and state price-taking and continued-import assumptions."
              },
              "feedback": {
                "zh-CN": "先解释为什么世界价不变、国内价升至 Pw+t，不能只背结论。",
                "en": "Explain why Pw stays fixed and domestic price reaches Pw+t."
              }
            },
            {
              "id": "diagram",
              "title": {
                "zh-CN": "图文对应",
                "en": "Diagram integration"
              },
              "guidance": {
                "zh-CN": "用自己的图解释两个价格、四个数量和缩小的进口差额。",
                "en": "Use your diagram to explain prices, quantities and the smaller import gap."
              },
              "feedback": {
                "zh-CN": "在文字中引用图上标记，说明沿 D/S 移动，避免图文互相矛盾。",
                "en": "Refer to labels and movements along D/S, keeping diagram and prose consistent."
              }
            },
            {
              "id": "stakeholders",
              "title": {
                "zh-CN": "利益相关者与因果",
                "en": "Stakeholders and causation"
              },
              "guidance": {
                "zh-CN": "解释消费者损失、生产者收益、政府税收和净福利变化。",
                "en": "Explain consumer loss, producer gain, revenue and net welfare."
              },
              "feedback": {
                "zh-CN": "写出“价格改变→行为改变→剩余变化”的链条；收入转移与效率损失要区分。",
                "en": "Connect price, behaviour and surplus; distinguish transfers from efficiency losses."
              }
            }
          ],
          "modelAnswer": {
            "zh-CN": "单位关税是对每单位进口商品征收固定金额的税。假设本国是价格接受者、商品同质、市场竞争，且征税后仍有进口，世界价 Pw 不变，国内价由 Pw 升到 Pw+t。\n\n在图中画出向下 D、向上 S 和两条水平价格线。国内企业因价格提高沿 S 将供给从 Qs0 增至 Qs1；消费者沿 D 把需求从 Qd0 减至 Qd1。因此进口从 Qd0−Qs0 缩小到 Qd1−Qs1。这是国内曲线上的移动，不是偏好或技术改变导致的曲线移动。\n\n消费者支付更高价格且消费减少，剩余减少 a+b+c+d。生产者因价格、产量上升获得 a；政府只对税后进口征税，取得 c=t×(Qd1−Qs1)。把三者变化相加，a 与 c 是国内转移，留下 b+d 的净损失。b 表示用较高成本本国产出替代较低成本进口，d 表示原本收益高于 Pw 的消费不再发生。\n\n此结论限于无外部性等假设下的该市场静态国内福利；若要判断供应安全或长期就业，还需进一步证据。",
            "en": "A specific tariff is a fixed tax per imported unit. Assume a price-taking economy, homogeneous goods, competitive markets and continued imports. Pw remains fixed, while domestic price rises to Pw+t.\n\nDraw downward D, upward S and the two horizontal price lines. The higher price raises domestic supply from Qs0 to Qs1 along S and reduces consumption from Qd0 to Qd1 along D. Imports therefore fall from Qd0−Qs0 to Qd1−Qs1. These are movements along unchanged domestic curves.\n\nConsumers pay more and purchase less, losing surplus a+b+c+d. Producers gain a through the higher price and output. Government collects c=t×(Qd1−Qs1) on the imports that remain. Adding these changes cancels domestic transfers a and c, leaving losses b+d. Area b is the extra resource cost of replacing imports with higher-cost domestic output; d is the lost benefit of consumption valued above Pw but below the new price.\n\nThis is a static domestic-welfare conclusion under the stated assumptions. Supply-security benefits or long-run employment effects require additional evidence."
          },
          "weakAnswer": {
            "zh-CN": "关税使进口减少，政府有税收，所以所有人都会受益。",
            "en": "Tariffs reduce imports and raise revenue, so everyone benefits."
          },
          "diagnosis": {
            "zh-CN": "遗漏价格如何影响数量，没有图文对应，把政府转移收入误当成所有人的净收益；补上消费者损失以及 b+d 的含义。",
            "en": "It omits the price-to-quantity mechanism and diagram integration, and mistakes revenue for a gain to everyone. Explain consumer losses and b+d."
          }
        },
        {
          "id": "evaluate",
          "marks": 15,
          "minutes": 27,
          "level": "core",
          "title": {
            "zh-CN": "15 分评价题",
            "en": "15-mark evaluation"
          },
          "prompt": {
            "zh-CN": "运用一个真实世界案例，评价关税在保护国内就业方面的有效性。",
            "en": "Using a real-world example, evaluate the effectiveness of tariffs in protecting domestic employment."
          },
          "criteria": [
            {
              "id": "application",
              "title": {
                "zh-CN": "现实证据及范围",
                "en": "Evidence and scope"
              },
              "guidance": {
                "zh-CN": "准确使用美国钢材案例，交代时期和来源，避免用产量数据直接证明就业增长。",
                "en": "Apply the dated US steel evidence without treating output as measured employment."
              },
              "feedback": {
                "zh-CN": "案例必须支持论点；报告没有估计整体净福利或长期安全收益。",
                "en": "Use evidence to support the argument within the report’s scope."
              }
            },
            {
              "id": "balance",
              "title": {
                "zh-CN": "分析相互冲突的影响",
                "en": "Analyse competing effects"
              },
              "guidance": {
                "zh-CN": "比较受保护企业、消费者、下游企业和可能受报复的出口商。",
                "en": "Compare protected firms, consumers, downstream users and potentially affected exporters."
              },
              "feedback": {
                "zh-CN": "不能只列“优缺点”；解释成本如何传导，以及不同群体为何结果不同。",
                "en": "Explain transmission and distribution rather than listing advantages and disadvantages."
              }
            },
            {
              "id": "conditions",
              "title": {
                "zh-CN": "条件与替代方案",
                "en": "Conditions and alternatives"
              },
              "guidance": {
                "zh-CN": "讨论弹性、时间、外部性或安全目标，并比较培训等替代措施。",
                "en": "Discuss elasticities, time or security/externality objectives, and compare alternatives such as training."
              },
              "feedback": {
                "zh-CN": "把“取决于”展开：什么条件会改变你的结论，替代方案如何针对问题？",
                "en": "Explain which conditions change the judgement and how an alternative targets the problem."
              }
            },
            {
              "id": "judgement",
              "title": {
                "zh-CN": "有依据的结论",
                "en": "Supported judgement"
              },
              "guidance": {
                "zh-CN": "明确什么情况下保护就业的收益可能值得成本，并承认数据限制。",
                "en": "Judge when employment protection could justify its costs, acknowledging evidence limits."
              },
              "feedback": {
                "zh-CN": "结论应权衡目标与代价；避免“关税永远好／永远坏”的无条件判断。",
                "en": "Weigh the objective against costs and avoid unconditional claims."
              }
            }
          ],
          "modelAnswer": {
            "zh-CN": "关税提高进口的国内成本，使部分消费者转向本国产品，因此可支持受保护行业的产量与劳动需求。小国模型中，Pw+t 下 Qs1 高于 Qs0，这说明保护可能发挥作用的机制，但图示本身没有测量就业。\n\n美国 USITC 2023 年报告对 2018–2021 年的估计显示，232 条款关税使受影响钢材进口下降 24%、美国钢材价格上升 2.4%、产量上升 1.9%。这些证据支持“进口受抑制、本国产出增加”的分析。但产量增长可能来自更多工时、自动化或闲置设备利用，不能把 1.9% 直接写成就业增长率。美国具有影响世界市场的能力，也不能被视作小国模型的严格实例。\n\n更高钢材价格会提高使用钢材的企业成本，削弱其竞争力，可能抵消部分受保护岗位的收益。报告估计使用钢铝的下游行业产量平均下降 0.6%，提醒我们把保护行业和下游行业一起评价。消费者也承担较高价格；若贸易伙伴报复，其他出口行业可能受损。这些效果需要独立分析，不能把行业产量变化或税收直接称为全国净福利变化。\n\n短期内，劳动力难以转移、地区高度依赖钢铁业时，暂时保护可能减轻调整冲击；但长期保护若削弱竞争、维持低效企业，成本可能持续增加。若目标是学习外部性或战略供应，应提供具体证据、明确期限与退出条件，并比较培训、工资保险或针对性的产业支持。培训可能更直接针对技能错配，但见效较慢，也需要资金。\n\n因此，关税可能在特定行业短期支持就业，却不能由此认定它是保护总体就业的最佳工具。政策是否值得采取，取决于行业联系、调整速度、长期能力、报复风险和替代措施。所用报告不评估长期安全收益或全经济净效果；在证据有限时，我更支持目标明确、有期限并配合转岗支持的措施，而非无限期全面保护。",
            "en": "Tariffs raise the domestic cost of imports and can redirect spending towards local producers, supporting output and labour demand in a protected industry. In the small-country diagram, domestic supply rises from Qs0 to Qs1 at Pw+t. This explains a possible mechanism, but the diagram does not measure jobs.\n\nThe 2023 USITC report estimated effects during 2018–2021: section 232 tariffs reduced affected steel imports by 24%, raised US steel prices by 2.4% and raised output by 1.9%. This supports the mechanism of restricted imports and greater domestic output. However, output may rise through hours, automation or spare-capacity use; 1.9% is not an employment-growth estimate. Nor should the US be treated as a strict price-taking small economy.\n\nHigher steel prices increase downstream costs and may offset some employment gains in protected production. The report estimated a 0.6% average output decline in downstream steel- and aluminium-using industries. Consumers face higher prices, while retaliation could hurt other exporters. These effects require analysis across stakeholders. Neither industry output changes nor tariff revenue directly establish national net welfare.\n\nTemporary protection may soften adjustment where workers cannot move easily and a region depends on steel. Over time, however, weaker competitive pressure can sustain inefficient firms and prolong costs. If learning spillovers or strategic supply justify intervention, identify evidence, a time limit and exit conditions. Compare retraining, wage insurance and targeted support. Retraining can address skill mismatch more directly, but takes time and public funds.\n\nTariffs may therefore support particular jobs in the short run without being the best instrument for aggregate employment. Effectiveness depends on industry linkages, adjustment, long-run capability, retaliation and alternatives. The cited report does not establish long-run security benefits or economy-wide net effects. Given these limits, a targeted, time-limited response with transition support is more defensible than indefinite broad protection."
          },
          "weakAnswer": {
            "zh-CN": "美国钢材产量增长 1.9%，所以美国就业增长 1.9%，证明关税对所有国家都有效。",
            "en": "US steel output rose 1.9%, so US employment rose 1.9%, proving tariffs work for every country."
          },
          "diagnosis": {
            "zh-CN": "把产量误写成就业，把行业误写成全国，把历史特定情境推广到所有国家。应注明指标和时期，分析下游成本、条件与替代政策。",
            "en": "It conflates output with employment, an industry with the whole economy, and a historical case with all countries. Preserve the indicator and period, then analyse downstream costs, conditions and alternatives."
          }
        },
        {
          "id": "calculate",
          "marks": 10,
          "minutes": 12,
          "level": "hl",
          "title": {
            "zh-CN": "HL 计算与解释",
            "en": "HL calculation and interpretation"
          },
          "prompt": {
            "zh-CN": "原创线性情境：Pw=10、t=2；税前 Qs0=30、Qd0=110，税后 Qs1=50、Qd1=90。计算税前后进口、税收、两种扭曲损失，以及消费者和生产者剩余变化；验证净福利变化。写出步骤和单位。",
            "en": "Original linear example: Pw=10, t=2; before the tariff Qs0=30, Qd0=110; afterwards Qs1=50, Qd1=90. Calculate imports, revenue, both distortion losses and changes in consumer/producer surplus, then reconcile net welfare. Show workings and units."
          },
          "criteria": [
            {
              "id": "imports",
              "title": {
                "zh-CN": "数量与税基",
                "en": "Quantities and tax base"
              },
              "guidance": {
                "zh-CN": "进口 80→40 单位，税收 80 货币。",
                "en": "Imports 80→40 units; revenue 80 currency units."
              },
              "feedback": {
                "zh-CN": "税率乘税后进口，不能乘 Qd1 或税前进口。",
                "en": "Multiply the tariff by post-tariff imports, not Qd1 or initial imports."
              }
            },
            {
              "id": "areas",
              "title": {
                "zh-CN": "面积与净福利",
                "en": "Areas and net welfare"
              },
              "guidance": {
                "zh-CN": "b=20，d=20，生产者 +80，消费者 −200，合计 −40 货币。",
                "en": "b=20, d=20, producers +80, consumers −200; total −40 currency units."
              },
              "feedback": {
                "zh-CN": "写出三角形或梯形公式、负号与单位，解释收入转移为何抵消。",
                "en": "Show triangle/trapezium workings, signs and units, and explain cancellation of transfers."
              }
            }
          ],
          "modelAnswer": {
            "zh-CN": "原创线性情境：Pw=10，t=2；自由贸易 Qs0=30、Qd0=110，税后 Qs1=50、Qd1=90。进口由 80 降为 40；政府税收 c=2×40=80。生产扭曲 b=½×2×(50−30)=20；消费扭曲 d=½×2×(110−90)=20；净福利变化 −40。生产者剩余增量 a=½×(30+50)×2=80；消费者剩余减少 ½×(110+90)×2=200；−200+80+80=−40。数量以单位、价格以货币/单位计，剩余以货币计。三角形与梯形算法依赖线性曲线；税收和转移不能重复相加。",
            "en": "Original linear example: Pw=10 and t=2. Free-trade Qs0=30 and Qd0=110; post-tariff Qs1=50 and Qd1=90. Imports fall from 80 to 40; revenue c=2×40=80. Production loss b=½×2×(50−30)=20 and consumption loss d=½×2×(110−90)=20, giving net welfare change −40. Producer surplus rises by a=½×(30+50)×2=80. Consumer surplus falls by ½×(110+90)×2=200; −200+80+80=−40. Quantities are units, prices currency per unit and surplus currency. Triangle and trapezium calculations assume linear curves; avoid double-counting transfers."
          },
          "weakAnswer": {
            "zh-CN": "税收=2×110=220，所以福利增加 220。",
            "en": "Revenue=2×110=220, so welfare rises by 220."
          },
          "diagnosis": {
            "zh-CN": "110 是税前需求，既不是税后进口也不是净福利。税收为 2×(90−50)=80；净福利变化为 −40。",
            "en": "110 is initial demand, neither post-tariff imports nor net welfare. Revenue is 2×(90−50)=80 and net welfare changes by −40."
          }
        }
      ],
      "sources": [
        {
          "title": "USITC · 2023 report on 2018–2021 tariff effects",
          "url": "https://www.usitc.gov/press_room/news_release/2023/er0315_63679.htm"
        },
        {
          "title": "IB · Economics examiner guidance (2025)",
          "url": "https://ibpublishing.ibo.org/exinst/apps/exinst/index.html?chapter=2&doc=EX_instructions_2025_e&part=10"
        }
      ]
    }
  },
  {
    "meta": {
      "id": "u4-08-quota",
      "slug": "quota",
      "section": "4.2",
      "level": "core",
      "syllabusRefs": [
        "4.2 Types of trade protection"
      ],
      "textbookRefs": [
        {
          "chapter": "14",
          "section": "14.3",
          "pages": [
            444
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-07-tariff",
        "u4-09-production-subsidy",
        "u4-10-export-subsidy"
      ],
      "terms": [
        "进口配额与配额租",
        "Import quotas and quota rents",
        "数量",
        "quantity",
        "许可证",
        "licences",
        "配额租",
        "quota rents"
      ],
      "synonyms": {
        "zh-CN": [
          "数量",
          "许可证",
          "配额租"
        ],
        "en": [
          "quantity",
          "licences",
          "quota rents"
        ]
      },
      "diagramIds": [
        "global-quota"
      ],
      "quizIds": [
        "u4-08-quota-flash-1",
        "u4-08-quota-mcq-1",
        "u4-08-quota-short-1",
        "u4-08-quota-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-08-quota",
        "locale": "zh-CN",
        "hlExtension": "原创假设：世界价 10、国内价 14，配额 30，配额租为 120。政府拍卖许可可能获得收入，免费给外国出口商则租可能流向国外。",
        "title": "进口配额与配额租",
        "takeaway": "配额直接限制进口数量，通常抬高国内价格；价格差形成配额租，归属取决于许可分配。",
        "definition": "配额直接限制进口数量，通常抬高国内价格；价格差形成配额租，归属取决于许可分配。",
        "causalChain": [
          "进口数量受限",
          "国内稀缺性推高价格",
          "许可证持有人获得配额租"
        ],
        "misconceptions": [
          "配额租不会自动归本国政府；需求增加时配额还可能带来更大涨价。"
        ],
        "examApplication": [
          "从世界价推导数量、进口、财政与福利变化，区分关税收入、配额租和补贴成本。"
        ],
        "summary": [
          "配额直接限制进口数量，通常抬高国内价格；价格差形成配额租，归属取决于许可分配。",
          "配额租不会自动归本国政府；需求增加时配额还可能带来更大涨价。"
        ],
        "explanation": "进口数量受限。国内稀缺性推高价格。许可证持有人获得配额租。\n\n### 原创情境与推导\n\n原创假设：配额限制进口使国内价高于世界价，价差形成租；政府拍卖许可可获得收入，免费给外国出口商时租可流向国外。计算租的数额属于 HL。\n\n配额租不会自动归本国政府；需求增加时配额还可能带来更大涨价。\n\n从世界价推导数量、进口、财政与福利变化，区分关税收入、配额租和补贴成本。"
      },
      "en": {
        "id": "u4-08-quota",
        "locale": "en",
        "hlExtension": "Hypothetical scenario: world price ten, domestic price fourteen and quota thirty create rents of 120. Auctions may generate public revenue; free licences to foreign exporters can transfer rents abroad.",
        "title": "Import quotas and quota rents",
        "takeaway": "A quota directly limits imports and normally raises domestic price. The price gap creates quota rents whose recipients depend on licence allocation.",
        "definition": "A quota directly limits imports and normally raises domestic price. The price gap creates quota rents whose recipients depend on licence allocation.",
        "causalChain": [
          "Imports are capped",
          "scarcity raises domestic price",
          "licence holders receive quota rents"
        ],
        "misconceptions": [
          "Quota rents do not automatically accrue to the home government; a demand increase can further raise price under a fixed quota."
        ],
        "examApplication": [
          "Derive quantities, imports, fiscal and welfare changes from the world price; distinguish tariff revenue, quota rents and subsidy costs."
        ],
        "summary": [
          "A quota directly limits imports and normally raises domestic price. The price gap creates quota rents whose recipients depend on licence allocation.",
          "Quota rents do not automatically accrue to the home government; a demand increase can further raise price under a fixed quota."
        ],
        "explanation": "Imports are capped.  scarcity raises domestic price.  licence holders receive quota rents.\n\n### Original scenario and reasoning\n\nHypothetical scenario: a binding quota raises domestic price above world price and creates rents. Auctions can yield public revenue, while free foreign licences may send rents abroad. Calculating rent amounts is HL.\n\nQuota rents do not automatically accrue to the home government; a demand increase can further raise price under a fixed quota.\n\nDerive quantities, imports, fiscal and welfare changes from the world price; distinguish tariff revenue, quota rents and subsidy costs."
      }
    },
    "practice": [
      {
        "id": "u4-08-quota-flash-1",
        "knowledgePointId": "u4-08-quota",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“进口配额与配额租”，并说明一个关键条件。",
          "en": "Explain Import quotas and quota rents and state one important condition."
        },
        "answer": {
          "zh-CN": "配额直接限制进口数量，通常抬高国内价格；价格差形成配额租，归属取决于许可分配。",
          "en": "A quota directly limits imports and normally raises domestic price. The price gap creates quota rents whose recipients depend on licence allocation."
        },
        "explanation": {
          "zh-CN": "配额租不会自动归本国政府；需求增加时配额还可能带来更大涨价。",
          "en": "Quota rents do not automatically accrue to the home government; a demand increase can further raise price under a fixed quota."
        }
      },
      {
        "id": "u4-08-quota-mcq-1",
        "knowledgePointId": "u4-08-quota",
        "type": "mcq",
        "prompt": {
          "zh-CN": "配额租是否自动归本国政府？",
          "en": "Do quota rents automatically accrue to the home government?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "是，所有配额均如此",
            "en": "Yes, for every quota"
          },
          {
            "id": "b",
            "zh-CN": "租只能归消费者",
            "en": "Only consumers can receive rents"
          },
          {
            "id": "c",
            "zh-CN": "配额永不产生租",
            "en": "Quotas never create rents"
          },
          {
            "id": "d",
            "zh-CN": "不，取决于许可证分配",
            "en": "No; licence allocation determines the recipient"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "不，取决于许可证分配。 进口数量受限；国内稀缺性推高价格；许可证持有人获得配额租 配额租不会自动归本国政府；需求增加时配额还可能带来更大涨价。",
          "en": "No; licence allocation determines the recipient. Imports are capped; scarcity raises domestic price; licence holders receive quota rents Quota rents do not automatically accrue to the home government; a demand increase can further raise price under a fixed quota."
        }
      },
      {
        "id": "u4-08-quota-short-1",
        "knowledgePointId": "u4-08-quota",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释进口配额与配额租的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Import quotas and quota rents and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "配额直接限制进口数量，通常抬高国内价格；价格差形成配额租，归属取决于许可分配。 进口数量受限；国内稀缺性推高价格；许可证持有人获得配额租 原创假设：配额限制进口使国内价高于世界价，价差形成租；政府拍卖许可可获得收入，免费给外国出口商时租可流向国外。计算租的数额属于 HL。",
          "en": "A quota directly limits imports and normally raises domestic price. The price gap creates quota rents whose recipients depend on licence allocation. Imports are capped; scarcity raises domestic price; licence holders receive quota rents Hypothetical scenario: a binding quota raises domestic price above world price and creates rents. Auctions can yield public revenue, while free foreign licences may send rents abroad. Calculating rent amounts is HL."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "数量",
              "en": "quantity"
            },
            "alternatives": {
              "zh-CN": [
                "数量",
                "进口数量受限"
              ],
              "en": [
                "quantity",
                "Imports are capped"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "许可证",
              "en": "licences"
            },
            "alternatives": {
              "zh-CN": [
                "许可证",
                "国内稀缺性推高价格"
              ],
              "en": [
                "licences",
                "scarcity raises domestic price"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "配额租",
              "en": "quota rents"
            },
            "alternatives": {
              "zh-CN": [
                "配额租",
                "许可证持有人获得配额租"
              ],
              "en": [
                "quota rents",
                "licence holders receive quota rents"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u4-08-quota-mcq-hl-1",
        "knowledgePointId": "u4-08-quota",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "配额许可免费给外国出口商，租最可能归谁？",
          "en": "Who may receive rents if quota licences are freely given to foreign exporters?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "外国许可证持有人",
            "en": "Foreign licence holders"
          },
          {
            "id": "b",
            "zh-CN": "必定归本国财政",
            "en": "Always the home treasury"
          },
          {
            "id": "c",
            "zh-CN": "必定归所有消费者",
            "en": "Always all consumers"
          },
          {
            "id": "d",
            "zh-CN": "租必定为零",
            "en": "Rents must be zero"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "外国许可证持有人。 原创假设：世界价 10、国内价 14，配额 30，配额租为 120。政府拍卖许可可能获得收入，免费给外国出口商则租可能流向国外。",
          "en": "Foreign licence holders. Hypothetical scenario: world price ten, domestic price fourteen and quota thirty create rents of 120. Auctions may generate public revenue; free licences to foreign exporters can transfer rents abroad."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-09-production-subsidy",
      "slug": "production-subsidy",
      "section": "4.2",
      "level": "core",
      "syllabusRefs": [
        "4.2 Types of trade protection"
      ],
      "textbookRefs": [
        {
          "chapter": "14",
          "section": "14.3",
          "pages": [
            444
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-07-tariff",
        "u4-08-quota",
        "u4-10-export-subsidy"
      ],
      "terms": [
        "生产补贴与进口替代",
        "Production subsidies and import displacement",
        "补贴",
        "subsidy",
        "供给",
        "supply",
        "财政成本",
        "fiscal cost"
      ],
      "synonyms": {
        "zh-CN": [
          "补贴",
          "供给",
          "财政成本"
        ],
        "en": [
          "subsidy",
          "supply",
          "fiscal cost"
        ]
      },
      "diagramIds": [
        "global-subsidy"
      ],
      "quizIds": [
        "u4-09-production-subsidy-flash-1",
        "u4-09-production-subsidy-mcq-1",
        "u4-09-production-subsidy-short-1",
        "u4-09-production-subsidy-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-09-production-subsidy",
        "locale": "zh-CN",
        "hlExtension": "原创假设：补贴 2、国内产量由 40 增至 60，总成本 120，而非仅对新增 20 单位补贴。模型假定持续进口且世界价不变。",
        "title": "生产补贴与进口替代",
        "takeaway": "小国对国内生产提供补贴可增加国内供给、减少进口；消费者仍按世界价购买，财政承担补贴成本。",
        "definition": "小国对国内生产提供补贴可增加国内供给、减少进口；消费者仍按世界价购买，财政承担补贴成本。",
        "causalChain": [
          "生产者每单位净收入增加",
          "国内供给扩大",
          "进口减少但消费价不必提高"
        ],
        "misconceptions": [
          "补贴未必提高消费者价格；政府机会成本与低效率生产仍需评价。"
        ],
        "examApplication": [
          "从世界价推导数量、进口、财政与福利变化，区分关税收入、配额租和补贴成本。"
        ],
        "summary": [
          "小国对国内生产提供补贴可增加国内供给、减少进口；消费者仍按世界价购买，财政承担补贴成本。",
          "补贴未必提高消费者价格；政府机会成本与低效率生产仍需评价。"
        ],
        "explanation": "生产者每单位净收入增加。国内供给扩大。进口减少但消费价不必提高。\n\n### 原创情境与推导\n\n原创假设：持续进口的小国补贴本国生产，生产者收入高于世界价，国内供给增加、进口减少，消费者仍付世界价；财政须支付所有符合资格的产量，且存在机会成本。数值计算属于 HL。\n\n补贴未必提高消费者价格；政府机会成本与低效率生产仍需评价。\n\n从世界价推导数量、进口、财政与福利变化，区分关税收入、配额租和补贴成本。"
      },
      "en": {
        "id": "u4-09-production-subsidy",
        "locale": "en",
        "hlExtension": "Hypothetical scenario: a subsidy of two raises domestic output from forty to sixty, costing 120, not merely subsidising the twenty extra units. Imports remain positive and the world price is fixed.",
        "title": "Production subsidies and import displacement",
        "takeaway": "A domestic production subsidy in a small economy can increase domestic supply and reduce imports. Consumers still buy at the world price and the government funds the subsidy.",
        "definition": "A domestic production subsidy in a small economy can increase domestic supply and reduce imports. Consumers still buy at the world price and the government funds the subsidy.",
        "causalChain": [
          "Producer receipts per unit rise",
          "domestic supply expands",
          "imports fall without a necessary rise in consumer price"
        ],
        "misconceptions": [
          "A subsidy need not raise consumer price; fiscal opportunity cost and inefficient production still matter."
        ],
        "examApplication": [
          "Derive quantities, imports, fiscal and welfare changes from the world price; distinguish tariff revenue, quota rents and subsidy costs."
        ],
        "summary": [
          "A domestic production subsidy in a small economy can increase domestic supply and reduce imports. Consumers still buy at the world price and the government funds the subsidy.",
          "A subsidy need not raise consumer price; fiscal opportunity cost and inefficient production still matter."
        ],
        "explanation": "Producer receipts per unit rise.  domestic supply expands.  imports fall without a necessary rise in consumer price.\n\n### Original scenario and reasoning\n\nHypothetical scenario: with imports continuing, a domestic production subsidy raises producer receipts above world price, expands supply and reduces imports. Consumers still pay world price. The budget funds all eligible output, with an opportunity cost. Numerical calculations are HL.\n\nA subsidy need not raise consumer price; fiscal opportunity cost and inefficient production still matter.\n\nDerive quantities, imports, fiscal and welfare changes from the world price; distinguish tariff revenue, quota rents and subsidy costs."
      }
    },
    "practice": [
      {
        "id": "u4-09-production-subsidy-flash-1",
        "knowledgePointId": "u4-09-production-subsidy",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“生产补贴与进口替代”，并说明一个关键条件。",
          "en": "Explain Production subsidies and import displacement and state one important condition."
        },
        "answer": {
          "zh-CN": "小国对国内生产提供补贴可增加国内供给、减少进口；消费者仍按世界价购买，财政承担补贴成本。",
          "en": "A domestic production subsidy in a small economy can increase domestic supply and reduce imports. Consumers still buy at the world price and the government funds the subsidy."
        },
        "explanation": {
          "zh-CN": "补贴未必提高消费者价格；政府机会成本与低效率生产仍需评价。",
          "en": "A subsidy need not raise consumer price; fiscal opportunity cost and inefficient production still matter."
        }
      },
      {
        "id": "u4-09-production-subsidy-mcq-1",
        "knowledgePointId": "u4-09-production-subsidy",
        "type": "mcq",
        "prompt": {
          "zh-CN": "小国持续进口时，生产补贴的消费者价格通常怎样？",
          "en": "With continuing imports in a small economy, what normally happens to consumer price under a production subsidy?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "仍为世界价",
            "en": "It remains the world price"
          },
          {
            "id": "b",
            "zh-CN": "必升至生产者补贴后收入",
            "en": "It must rise to producer receipts including subsidy"
          },
          {
            "id": "c",
            "zh-CN": "必变为零",
            "en": "It must become zero"
          },
          {
            "id": "d",
            "zh-CN": "必升至自给价以上",
            "en": "It must exceed autarky price"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "仍为世界价。 生产者每单位净收入增加；国内供给扩大；进口减少但消费价不必提高 补贴未必提高消费者价格；政府机会成本与低效率生产仍需评价。",
          "en": "It remains the world price. Producer receipts per unit rise; domestic supply expands; imports fall without a necessary rise in consumer price A subsidy need not raise consumer price; fiscal opportunity cost and inefficient production still matter."
        }
      },
      {
        "id": "u4-09-production-subsidy-short-1",
        "knowledgePointId": "u4-09-production-subsidy",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释生产补贴与进口替代的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Production subsidies and import displacement and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "小国对国内生产提供补贴可增加国内供给、减少进口；消费者仍按世界价购买，财政承担补贴成本。 生产者每单位净收入增加；国内供给扩大；进口减少但消费价不必提高 原创假设：持续进口的小国补贴本国生产，生产者收入高于世界价，国内供给增加、进口减少，消费者仍付世界价；财政须支付所有符合资格的产量，且存在机会成本。数值计算属于 HL。",
          "en": "A domestic production subsidy in a small economy can increase domestic supply and reduce imports. Consumers still buy at the world price and the government funds the subsidy. Producer receipts per unit rise; domestic supply expands; imports fall without a necessary rise in consumer price Hypothetical scenario: with imports continuing, a domestic production subsidy raises producer receipts above world price, expands supply and reduces imports. Consumers still pay world price. The budget funds all eligible output, with an opportunity cost. Numerical calculations are HL."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "补贴",
              "en": "subsidy"
            },
            "alternatives": {
              "zh-CN": [
                "补贴",
                "生产者每单位净收入增加"
              ],
              "en": [
                "subsidy",
                "Producer receipts per unit rise"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "供给",
              "en": "supply"
            },
            "alternatives": {
              "zh-CN": [
                "供给",
                "国内供给扩大"
              ],
              "en": [
                "supply",
                "domestic supply expands"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "财政成本",
              "en": "fiscal cost"
            },
            "alternatives": {
              "zh-CN": [
                "财政成本",
                "进口减少但消费价不必提高"
              ],
              "en": [
                "fiscal cost",
                "imports fall without a necessary rise in consumer price"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u4-09-production-subsidy-mcq-hl-1",
        "knowledgePointId": "u4-09-production-subsidy",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "补贴 4，补贴后国内总产量 30，财政成本？",
          "en": "A subsidy of four on total domestic output of thirty costs how much?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "仅补新增产量",
            "en": "Only subsidise additional output"
          },
          {
            "id": "b",
            "zh-CN": "120",
            "en": "120"
          },
          {
            "id": "c",
            "zh-CN": "34",
            "en": "34"
          },
          {
            "id": "d",
            "zh-CN": "26",
            "en": "26"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "120。 4 × 30 = 120",
          "en": "120. 4 × 30 = 120"
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-10-export-subsidy",
      "slug": "export-subsidy",
      "section": "4.2",
      "level": "core",
      "syllabusRefs": [
        "4.2 Types of trade protection"
      ],
      "textbookRefs": [
        {
          "chapter": "14",
          "section": "14.3",
          "pages": [
            444
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-07-tariff",
        "u4-08-quota",
        "u4-09-production-subsidy"
      ],
      "terms": [
        "出口补贴",
        "Export subsidies",
        "出口",
        "exports",
        "补贴",
        "subsidy",
        "消费",
        "consumption"
      ],
      "synonyms": {
        "zh-CN": [
          "出口",
          "补贴",
          "消费"
        ],
        "en": [
          "exports",
          "subsidy",
          "consumption"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-10-export-subsidy-flash-1",
        "u4-10-export-subsidy-mcq-1",
        "u4-10-export-subsidy-short-1",
        "u4-10-export-subsidy-mcq-hl-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-10-export-subsidy",
        "locale": "zh-CN",
        "hlExtension": "原创假设：小国世界价 10、出口补贴 2，在可自由转售的简化模型下国内价升至 12；若出口 50，财政成本为 100。",
        "title": "出口补贴",
        "takeaway": "出口补贴按出口量支付，可能提高本国价格并扩大出口，财政支出和国内消费损失影响福利。",
        "definition": "出口补贴按出口量支付，可能提高本国价格并扩大出口，财政支出和国内消费损失影响福利。",
        "causalChain": [
          "出口每单位回报提高",
          "生产者转向出口直到国内价调整",
          "国内生产增加消费下降"
        ],
        "misconceptions": [
          "出口增加不是净福利增加；补贴也可能引发贸易争端，具体规则须核验。"
        ],
        "examApplication": [
          "从世界价推导数量、进口、财政与福利变化，区分关税收入、配额租和补贴成本。"
        ],
        "summary": [
          "出口补贴按出口量支付，可能提高本国价格并扩大出口，财政支出和国内消费损失影响福利。",
          "出口增加不是净福利增加；补贴也可能引发贸易争端，具体规则须核验。"
        ],
        "explanation": "出口每单位回报提高。生产者转向出口直到国内价调整。国内生产增加消费下降。\n\n### 原创情境与推导\n\n原创假设：小国补贴每单位出口，可自由转售时生产者倾向出口直到国内价也上升；国内生产增加、消费下降、出口扩大，但财政与消费者承受成本。计算财政支出属于 HL。\n\n出口增加不是净福利增加；补贴也可能引发贸易争端，具体规则须核验。\n\n从世界价推导数量、进口、财政与福利变化，区分关税收入、配额租和补贴成本。"
      },
      "en": {
        "id": "u4-10-export-subsidy",
        "locale": "en",
        "hlExtension": "Hypothetical scenario: with world price ten and an export subsidy of two, domestic price rises to twelve in a simplified arbitrage model. Fifty exports cost the government 100.",
        "title": "Export subsidies",
        "takeaway": "An export subsidy pays per exported unit and can raise the domestic price and exports; fiscal costs and domestic consumption losses affect welfare.",
        "definition": "An export subsidy pays per exported unit and can raise the domestic price and exports; fiscal costs and domestic consumption losses affect welfare.",
        "causalChain": [
          "Returns per exported unit rise",
          "producers divert sales until domestic price adjusts",
          "domestic output rises and consumption falls"
        ],
        "misconceptions": [
          "More exports do not establish a welfare gain; subsidies can also trigger trade disputes, whose specific rules require verification."
        ],
        "examApplication": [
          "Derive quantities, imports, fiscal and welfare changes from the world price; distinguish tariff revenue, quota rents and subsidy costs."
        ],
        "summary": [
          "An export subsidy pays per exported unit and can raise the domestic price and exports; fiscal costs and domestic consumption losses affect welfare.",
          "More exports do not establish a welfare gain; subsidies can also trigger trade disputes, whose specific rules require verification."
        ],
        "explanation": "Returns per exported unit rise.  producers divert sales until domestic price adjusts.  domestic output rises and consumption falls.\n\n### Original scenario and reasoning\n\nHypothetical scenario: a per-unit export subsidy encourages exporting until domestic price also rises under arbitrage. Domestic output rises, consumption falls and exports expand, at fiscal and consumer cost. Numerical fiscal calculations are HL.\n\nMore exports do not establish a welfare gain; subsidies can also trigger trade disputes, whose specific rules require verification.\n\nDerive quantities, imports, fiscal and welfare changes from the world price; distinguish tariff revenue, quota rents and subsidy costs."
      }
    },
    "practice": [
      {
        "id": "u4-10-export-subsidy-flash-1",
        "knowledgePointId": "u4-10-export-subsidy",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“出口补贴”，并说明一个关键条件。",
          "en": "Explain Export subsidies and state one important condition."
        },
        "answer": {
          "zh-CN": "出口补贴按出口量支付，可能提高本国价格并扩大出口，财政支出和国内消费损失影响福利。",
          "en": "An export subsidy pays per exported unit and can raise the domestic price and exports; fiscal costs and domestic consumption losses affect welfare."
        },
        "explanation": {
          "zh-CN": "出口增加不是净福利增加；补贴也可能引发贸易争端，具体规则须核验。",
          "en": "More exports do not establish a welfare gain; subsidies can also trigger trade disputes, whose specific rules require verification."
        }
      },
      {
        "id": "u4-10-export-subsidy-mcq-1",
        "knowledgePointId": "u4-10-export-subsidy",
        "type": "mcq",
        "prompt": {
          "zh-CN": "出口补贴一定改善本国净福利吗？",
          "en": "Does an export subsidy necessarily improve home welfare?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "是，只要出口增加",
            "en": "Yes, whenever exports rise"
          },
          {
            "id": "b",
            "zh-CN": "不，财政成本与消费者损失也需计算",
            "en": "No; fiscal costs and consumer losses also matter"
          },
          {
            "id": "c",
            "zh-CN": "是，因为不存在财政成本",
            "en": "Yes, because there is no fiscal cost"
          },
          {
            "id": "d",
            "zh-CN": "是，因为消费者价必下降",
            "en": "Yes, because consumer price must fall"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "不，财政成本与消费者损失也需计算。 出口每单位回报提高；生产者转向出口直到国内价调整；国内生产增加消费下降 出口增加不是净福利增加；补贴也可能引发贸易争端，具体规则须核验。",
          "en": "No; fiscal costs and consumer losses also matter. Returns per exported unit rise; producers divert sales until domestic price adjusts; domestic output rises and consumption falls More exports do not establish a welfare gain; subsidies can also trigger trade disputes, whose specific rules require verification."
        }
      },
      {
        "id": "u4-10-export-subsidy-short-1",
        "knowledgePointId": "u4-10-export-subsidy",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释出口补贴的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Export subsidies and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "出口补贴按出口量支付，可能提高本国价格并扩大出口，财政支出和国内消费损失影响福利。 出口每单位回报提高；生产者转向出口直到国内价调整；国内生产增加消费下降 原创假设：小国补贴每单位出口，可自由转售时生产者倾向出口直到国内价也上升；国内生产增加、消费下降、出口扩大，但财政与消费者承受成本。计算财政支出属于 HL。",
          "en": "An export subsidy pays per exported unit and can raise the domestic price and exports; fiscal costs and domestic consumption losses affect welfare. Returns per exported unit rise; producers divert sales until domestic price adjusts; domestic output rises and consumption falls Hypothetical scenario: a per-unit export subsidy encourages exporting until domestic price also rises under arbitrage. Domestic output rises, consumption falls and exports expand, at fiscal and consumer cost. Numerical fiscal calculations are HL."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "出口",
              "en": "exports"
            },
            "alternatives": {
              "zh-CN": [
                "出口",
                "出口每单位回报提高"
              ],
              "en": [
                "exports",
                "Returns per exported unit rise"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "补贴",
              "en": "subsidy"
            },
            "alternatives": {
              "zh-CN": [
                "补贴",
                "生产者转向出口直到国内价调整"
              ],
              "en": [
                "subsidy",
                "producers divert sales until domestic price adjusts"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "消费",
              "en": "consumption"
            },
            "alternatives": {
              "zh-CN": [
                "消费",
                "国内生产增加消费下降"
              ],
              "en": [
                "consumption",
                "domestic output rises and consumption falls"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      },
      {
        "id": "u4-10-export-subsidy-mcq-hl-1",
        "knowledgePointId": "u4-10-export-subsidy",
        "type": "mcq",
        "level": "hl",
        "prompt": {
          "zh-CN": "出口补贴 2、出口 50，财政支出多少？",
          "en": "An export subsidy of two on fifty exports costs how much?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "52",
            "en": "52"
          },
          {
            "id": "b",
            "zh-CN": "48",
            "en": "48"
          },
          {
            "id": "c",
            "zh-CN": "100",
            "en": "100"
          },
          {
            "id": "d",
            "zh-CN": "必然没有成本",
            "en": "Necessarily no cost"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "100。 2 × 50 = 100",
          "en": "100. 2 × 50 = 100"
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-11-administrative-barriers",
      "slug": "administrative-barriers",
      "section": "4.2",
      "level": "core",
      "syllabusRefs": [
        "4.2 Types of trade protection"
      ],
      "textbookRefs": [
        {
          "chapter": "14",
          "section": "14.3",
          "pages": [
            444
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-07-tariff",
        "u4-08-quota",
        "u4-09-production-subsidy"
      ],
      "terms": [
        "行政壁垒与标准",
        "Administrative barriers and standards",
        "合规",
        "compliance",
        "成本",
        "costs",
        "歧视",
        "discrimination"
      ],
      "synonyms": {
        "zh-CN": [
          "合规",
          "成本",
          "歧视"
        ],
        "en": [
          "compliance",
          "costs",
          "discrimination"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-11-administrative-barriers-flash-1",
        "u4-11-administrative-barriers-mcq-1",
        "u4-11-administrative-barriers-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-11-administrative-barriers",
        "locale": "zh-CN",
        "title": "行政壁垒与标准",
        "takeaway": "繁复手续、采购偏好或歧视性标准可增加进口成本；正当健康与环境标准也可能纠正市场失灵。",
        "definition": "繁复手续、采购偏好或歧视性标准可增加进口成本；正当健康与环境标准也可能纠正市场失灵。",
        "causalChain": [
          "合规时间和费用提高",
          "进口供给受限",
          "保护收益与公共利益须分别判断"
        ],
        "misconceptions": [
          "不能因为某标准减少进口就断言它毫无公共利益，也不能忽略隐性歧视。"
        ],
        "examApplication": [
          "从世界价推导数量、进口、财政与福利变化，区分关税收入、配额租和补贴成本。"
        ],
        "summary": [
          "繁复手续、采购偏好或歧视性标准可增加进口成本；正当健康与环境标准也可能纠正市场失灵。",
          "不能因为某标准减少进口就断言它毫无公共利益，也不能忽略隐性歧视。"
        ],
        "explanation": "合规时间和费用提高。进口供给受限。保护收益与公共利益须分别判断。\n\n### 原创情境与推导\n\n原创假设：同样食品安全风险，若进口商被要求重复检验而本地企业无需检验，应评估必要性、证据与非歧视性。\n\n不能因为某标准减少进口就断言它毫无公共利益，也不能忽略隐性歧视。\n\n从世界价推导数量、进口、财政与福利变化，区分关税收入、配额租和补贴成本。"
      },
      "en": {
        "id": "u4-11-administrative-barriers",
        "locale": "en",
        "title": "Administrative barriers and standards",
        "takeaway": "Complex procedures, procurement preferences or discriminatory standards can raise import costs; legitimate health and environmental standards may correct market failure.",
        "definition": "Complex procedures, procurement preferences or discriminatory standards can raise import costs; legitimate health and environmental standards may correct market failure.",
        "causalChain": [
          "Compliance time and costs rise",
          "imports are constrained",
          "protection gains and public benefits need separate assessment"
        ],
        "misconceptions": [
          "Lower imports alone do not prove a standard lacks public value, but hidden discrimination must not be ignored."
        ],
        "examApplication": [
          "Derive quantities, imports, fiscal and welfare changes from the world price; distinguish tariff revenue, quota rents and subsidy costs."
        ],
        "summary": [
          "Complex procedures, procurement preferences or discriminatory standards can raise import costs; legitimate health and environmental standards may correct market failure.",
          "Lower imports alone do not prove a standard lacks public value, but hidden discrimination must not be ignored."
        ],
        "explanation": "Compliance time and costs rise.  imports are constrained.  protection gains and public benefits need separate assessment.\n\n### Original scenario and reasoning\n\nHypothetical scenario: importers face duplicate inspections while local firms with identical food risks do not. Assess necessity, evidence and non-discrimination.\n\nLower imports alone do not prove a standard lacks public value, but hidden discrimination must not be ignored.\n\nDerive quantities, imports, fiscal and welfare changes from the world price; distinguish tariff revenue, quota rents and subsidy costs."
      }
    },
    "practice": [
      {
        "id": "u4-11-administrative-barriers-flash-1",
        "knowledgePointId": "u4-11-administrative-barriers",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“行政壁垒与标准”，并说明一个关键条件。",
          "en": "Explain Administrative barriers and standards and state one important condition."
        },
        "answer": {
          "zh-CN": "繁复手续、采购偏好或歧视性标准可增加进口成本；正当健康与环境标准也可能纠正市场失灵。",
          "en": "Complex procedures, procurement preferences or discriminatory standards can raise import costs; legitimate health and environmental standards may correct market failure."
        },
        "explanation": {
          "zh-CN": "不能因为某标准减少进口就断言它毫无公共利益，也不能忽略隐性歧视。",
          "en": "Lower imports alone do not prove a standard lacks public value, but hidden discrimination must not be ignored."
        }
      },
      {
        "id": "u4-11-administrative-barriers-mcq-1",
        "knowledgePointId": "u4-11-administrative-barriers",
        "type": "mcq",
        "prompt": {
          "zh-CN": "评价进口检验要求最相关的标准是什么？",
          "en": "What matters most when evaluating import inspections?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "进口越少越有效率",
            "en": "Fewer imports always mean more efficiency"
          },
          {
            "id": "b",
            "zh-CN": "所有标准都应取消",
            "en": "Every standard should be removed"
          },
          {
            "id": "c",
            "zh-CN": "是否必要且非歧视",
            "en": "Whether they are necessary and non-discriminatory"
          },
          {
            "id": "d",
            "zh-CN": "只看文件页数",
            "en": "Only count pages of paperwork"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "是否必要且非歧视。 合规时间和费用提高；进口供给受限；保护收益与公共利益须分别判断 不能因为某标准减少进口就断言它毫无公共利益，也不能忽略隐性歧视。",
          "en": "Whether they are necessary and non-discriminatory. Compliance time and costs rise; imports are constrained; protection gains and public benefits need separate assessment Lower imports alone do not prove a standard lacks public value, but hidden discrimination must not be ignored."
        }
      },
      {
        "id": "u4-11-administrative-barriers-short-1",
        "knowledgePointId": "u4-11-administrative-barriers",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释行政壁垒与标准的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Administrative barriers and standards and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "繁复手续、采购偏好或歧视性标准可增加进口成本；正当健康与环境标准也可能纠正市场失灵。 合规时间和费用提高；进口供给受限；保护收益与公共利益须分别判断 原创假设：同样食品安全风险，若进口商被要求重复检验而本地企业无需检验，应评估必要性、证据与非歧视性。",
          "en": "Complex procedures, procurement preferences or discriminatory standards can raise import costs; legitimate health and environmental standards may correct market failure. Compliance time and costs rise; imports are constrained; protection gains and public benefits need separate assessment Hypothetical scenario: importers face duplicate inspections while local firms with identical food risks do not. Assess necessity, evidence and non-discrimination."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "合规",
              "en": "compliance"
            },
            "alternatives": {
              "zh-CN": [
                "合规",
                "合规时间和费用提高"
              ],
              "en": [
                "compliance",
                "Compliance time and costs rise"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "成本",
              "en": "costs"
            },
            "alternatives": {
              "zh-CN": [
                "成本",
                "进口供给受限"
              ],
              "en": [
                "costs",
                "imports are constrained"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "歧视",
              "en": "discrimination"
            },
            "alternatives": {
              "zh-CN": [
                "歧视",
                "保护收益与公共利益须分别判断"
              ],
              "en": [
                "discrimination",
                "protection gains and public benefits need separate assessment"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-12-infant-industry",
      "slug": "infant-industry",
      "section": "4.3",
      "level": "core",
      "syllabusRefs": [
        "4.3 Arguments for and against trade protection"
      ],
      "textbookRefs": [
        {
          "chapter": "15",
          "section": "15.1",
          "pages": [
            465
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-13-protection-arguments",
        "u4-14-protection-evaluation"
      ],
      "terms": [
        "幼稚产业与战略保护",
        "Infant industries and strategic protection",
        "学习",
        "learning",
        "成本",
        "costs",
        "退出",
        "exit"
      ],
      "synonyms": {
        "zh-CN": [
          "学习",
          "成本",
          "退出"
        ],
        "en": [
          "learning",
          "costs",
          "exit"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-12-infant-industry-flash-1",
        "u4-12-infant-industry-mcq-1",
        "u4-12-infant-industry-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-12-infant-industry",
        "locale": "zh-CN",
        "title": "幼稚产业与战略保护",
        "takeaway": "暂时保护可能帮助有学习外部性的产业形成竞争力，但须证明未来收益超过当前成本并设置退出条件。",
        "definition": "暂时保护可能帮助有学习外部性的产业形成竞争力，但须证明未来收益超过当前成本并设置退出条件。",
        "causalChain": [
          "初期规模小成本高",
          "学习与规模扩大降低成本",
          "到期撤销保护检验竞争力"
        ],
        "misconceptions": [
          "产业新不等于值得保护；政府信息不足、寻租和报复可能使净收益为负。"
        ],
        "examApplication": [
          "先陈述保护目标，再评价条件、时限、利益相关者、报复与替代政策。"
        ],
        "summary": [
          "暂时保护可能帮助有学习外部性的产业形成竞争力，但须证明未来收益超过当前成本并设置退出条件。",
          "产业新不等于值得保护；政府信息不足、寻租和报复可能使净收益为负。"
        ],
        "explanation": "初期规模小成本高。学习与规模扩大降低成本。到期撤销保护检验竞争力。\n\n### 原创情境与推导\n\n原创假设：设备产业获三年支持，续期取决于单位成本下降和出口表现；没有绩效条件可能把补贴固化。\n\n产业新不等于值得保护；政府信息不足、寻租和报复可能使净收益为负。\n\n先陈述保护目标，再评价条件、时限、利益相关者、报复与替代政策。"
      },
      "en": {
        "id": "u4-12-infant-industry",
        "locale": "en",
        "title": "Infant industries and strategic protection",
        "takeaway": "Temporary protection may help industries with learning spillovers become competitive, provided future gains exceed current costs and exit conditions are credible.",
        "definition": "Temporary protection may help industries with learning spillovers become competitive, provided future gains exceed current costs and exit conditions are credible.",
        "causalChain": [
          "Small initial scale raises costs",
          "learning and scale reduce costs",
          "removing protection tests competitiveness"
        ],
        "misconceptions": [
          "Being new does not justify protection; poor information, rent seeking and retaliation may outweigh gains."
        ],
        "examApplication": [
          "State protection objectives, then evaluate conditions, duration, stakeholders, retaliation and alternatives."
        ],
        "summary": [
          "Temporary protection may help industries with learning spillovers become competitive, provided future gains exceed current costs and exit conditions are credible.",
          "Being new does not justify protection; poor information, rent seeking and retaliation may outweigh gains."
        ],
        "explanation": "Small initial scale raises costs.  learning and scale reduce costs.  removing protection tests competitiveness.\n\n### Original scenario and reasoning\n\nHypothetical scenario: equipment firms receive three years of support, conditional on lower unit costs and export performance. Unconditional renewal can entrench subsidies.\n\nBeing new does not justify protection; poor information, rent seeking and retaliation may outweigh gains.\n\nState protection objectives, then evaluate conditions, duration, stakeholders, retaliation and alternatives."
      }
    },
    "practice": [
      {
        "id": "u4-12-infant-industry-flash-1",
        "knowledgePointId": "u4-12-infant-industry",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“幼稚产业与战略保护”，并说明一个关键条件。",
          "en": "Explain Infant industries and strategic protection and state one important condition."
        },
        "answer": {
          "zh-CN": "暂时保护可能帮助有学习外部性的产业形成竞争力，但须证明未来收益超过当前成本并设置退出条件。",
          "en": "Temporary protection may help industries with learning spillovers become competitive, provided future gains exceed current costs and exit conditions are credible."
        },
        "explanation": {
          "zh-CN": "产业新不等于值得保护；政府信息不足、寻租和报复可能使净收益为负。",
          "en": "Being new does not justify protection; poor information, rent seeking and retaliation may outweigh gains."
        }
      },
      {
        "id": "u4-12-infant-industry-mcq-1",
        "knowledgePointId": "u4-12-infant-industry",
        "type": "mcq",
        "prompt": {
          "zh-CN": "什么最能增强幼稚产业论据？",
          "en": "What most strengthens the infant-industry case?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "永久保护承诺",
            "en": "A promise of permanent protection"
          },
          {
            "id": "b",
            "zh-CN": "完全不考核成本",
            "en": "No cost evaluation"
          },
          {
            "id": "c",
            "zh-CN": "企业亏损本身",
            "en": "Losses alone"
          },
          {
            "id": "d",
            "zh-CN": "可验证的学习外部性与退出期限",
            "en": "Verifiable learning spillovers and a sunset date"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "可验证的学习外部性与退出期限。 初期规模小成本高；学习与规模扩大降低成本；到期撤销保护检验竞争力 产业新不等于值得保护；政府信息不足、寻租和报复可能使净收益为负。",
          "en": "Verifiable learning spillovers and a sunset date. Small initial scale raises costs; learning and scale reduce costs; removing protection tests competitiveness Being new does not justify protection; poor information, rent seeking and retaliation may outweigh gains."
        }
      },
      {
        "id": "u4-12-infant-industry-short-1",
        "knowledgePointId": "u4-12-infant-industry",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释幼稚产业与战略保护的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Infant industries and strategic protection and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "暂时保护可能帮助有学习外部性的产业形成竞争力，但须证明未来收益超过当前成本并设置退出条件。 初期规模小成本高；学习与规模扩大降低成本；到期撤销保护检验竞争力 原创假设：设备产业获三年支持，续期取决于单位成本下降和出口表现；没有绩效条件可能把补贴固化。",
          "en": "Temporary protection may help industries with learning spillovers become competitive, provided future gains exceed current costs and exit conditions are credible. Small initial scale raises costs; learning and scale reduce costs; removing protection tests competitiveness Hypothetical scenario: equipment firms receive three years of support, conditional on lower unit costs and export performance. Unconditional renewal can entrench subsidies."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "学习",
              "en": "learning"
            },
            "alternatives": {
              "zh-CN": [
                "学习",
                "初期规模小成本高"
              ],
              "en": [
                "learning",
                "Small initial scale raises costs"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "成本",
              "en": "costs"
            },
            "alternatives": {
              "zh-CN": [
                "成本",
                "学习与规模扩大降低成本"
              ],
              "en": [
                "costs",
                "learning and scale reduce costs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "退出",
              "en": "exit"
            },
            "alternatives": {
              "zh-CN": [
                "退出",
                "到期撤销保护检验竞争力"
              ],
              "en": [
                "exit",
                "removing protection tests competitiveness"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-13-protection-arguments",
      "slug": "protection-arguments",
      "section": "4.3",
      "level": "core",
      "syllabusRefs": [
        "4.3 Arguments for and against trade protection"
      ],
      "textbookRefs": [
        {
          "chapter": "15",
          "section": "15.1",
          "pages": [
            465
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-12-infant-industry",
        "u4-14-protection-evaluation"
      ],
      "terms": [
        "就业、安全与反倾销论据",
        "Employment, security and anti-dumping arguments",
        "就业",
        "employment",
        "成本",
        "costs",
        "报复",
        "retaliation"
      ],
      "synonyms": {
        "zh-CN": [
          "就业",
          "成本",
          "报复"
        ],
        "en": [
          "employment",
          "costs",
          "retaliation"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-13-protection-arguments-flash-1",
        "u4-13-protection-arguments-mcq-1",
        "u4-13-protection-arguments-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-13-protection-arguments",
        "locale": "zh-CN",
        "title": "就业、安全与反倾销论据",
        "takeaway": "贸易保护可维护特定岗位或战略供应，但会提高投入成本、影响出口并可能引发报复；倾销不能仅由低价推断。",
        "definition": "贸易保护可维护特定岗位或战略供应，但会提高投入成本、影响出口并可能引发报复；倾销不能仅由低价推断。",
        "causalChain": [
          "进口竞争冲击特定产业",
          "保护减缓调整",
          "下游成本与报复影响其他岗位"
        ],
        "misconceptions": [
          "不能把受保护行业岗位当作净就业效果，也不能把低工资直接等同于不公平竞争。"
        ],
        "examApplication": [
          "先陈述保护目标，再评价条件、时限、利益相关者、报复与替代政策。"
        ],
        "summary": [
          "贸易保护可维护特定岗位或战略供应，但会提高投入成本、影响出口并可能引发报复；倾销不能仅由低价推断。",
          "不能把受保护行业岗位当作净就业效果，也不能把低工资直接等同于不公平竞争。"
        ],
        "explanation": "进口竞争冲击特定产业。保护减缓调整。下游成本与报复影响其他岗位。\n\n### 原创情境与推导\n\n原创假设：钢铁关税保住部分炼钢岗位，却提高机械企业成本；评价需比较净就业、供应韧性与再培训方案。\n\n不能把受保护行业岗位当作净就业效果，也不能把低工资直接等同于不公平竞争。\n\n先陈述保护目标，再评价条件、时限、利益相关者、报复与替代政策。"
      },
      "en": {
        "id": "u4-13-protection-arguments",
        "locale": "en",
        "title": "Employment, security and anti-dumping arguments",
        "takeaway": "Protection may preserve particular jobs or strategic supplies but raises input costs, affects exports and risks retaliation. A low price alone does not establish dumping.",
        "definition": "Protection may preserve particular jobs or strategic supplies but raises input costs, affects exports and risks retaliation. A low price alone does not establish dumping.",
        "causalChain": [
          "Import competition hits particular industries",
          "protection slows adjustment",
          "input costs and retaliation affect jobs elsewhere"
        ],
        "misconceptions": [
          "Protected-sector jobs are not the net employment effect; low wages do not by themselves establish unfair competition."
        ],
        "examApplication": [
          "State protection objectives, then evaluate conditions, duration, stakeholders, retaliation and alternatives."
        ],
        "summary": [
          "Protection may preserve particular jobs or strategic supplies but raises input costs, affects exports and risks retaliation. A low price alone does not establish dumping.",
          "Protected-sector jobs are not the net employment effect; low wages do not by themselves establish unfair competition."
        ],
        "explanation": "Import competition hits particular industries.  protection slows adjustment.  input costs and retaliation affect jobs elsewhere.\n\n### Original scenario and reasoning\n\nHypothetical scenario: a steel tariff preserves some steel jobs but raises machinery producers' costs. Evaluate net jobs, supply resilience and retraining alternatives.\n\nProtected-sector jobs are not the net employment effect; low wages do not by themselves establish unfair competition.\n\nState protection objectives, then evaluate conditions, duration, stakeholders, retaliation and alternatives."
      }
    },
    "practice": [
      {
        "id": "u4-13-protection-arguments-flash-1",
        "knowledgePointId": "u4-13-protection-arguments",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“就业、安全与反倾销论据”，并说明一个关键条件。",
          "en": "Explain Employment, security and anti-dumping arguments and state one important condition."
        },
        "answer": {
          "zh-CN": "贸易保护可维护特定岗位或战略供应，但会提高投入成本、影响出口并可能引发报复；倾销不能仅由低价推断。",
          "en": "Protection may preserve particular jobs or strategic supplies but raises input costs, affects exports and risks retaliation. A low price alone does not establish dumping."
        },
        "explanation": {
          "zh-CN": "不能把受保护行业岗位当作净就业效果，也不能把低工资直接等同于不公平竞争。",
          "en": "Protected-sector jobs are not the net employment effect; low wages do not by themselves establish unfair competition."
        }
      },
      {
        "id": "u4-13-protection-arguments-mcq-1",
        "knowledgePointId": "u4-13-protection-arguments",
        "type": "mcq",
        "prompt": {
          "zh-CN": "钢铁关税评价还应考虑谁？",
          "en": "Whose position also matters in evaluating a steel tariff?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "使用钢材的下游企业",
            "en": "Downstream firms using steel"
          },
          {
            "id": "b",
            "zh-CN": "仅钢铁生产者",
            "en": "Only steel producers"
          },
          {
            "id": "c",
            "zh-CN": "只看关税名称",
            "en": "Only the tariff's name"
          },
          {
            "id": "d",
            "zh-CN": "忽略贸易伙伴",
            "en": "Ignore trading partners"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "使用钢材的下游企业。 进口竞争冲击特定产业；保护减缓调整；下游成本与报复影响其他岗位 不能把受保护行业岗位当作净就业效果，也不能把低工资直接等同于不公平竞争。",
          "en": "Downstream firms using steel. Import competition hits particular industries; protection slows adjustment; input costs and retaliation affect jobs elsewhere Protected-sector jobs are not the net employment effect; low wages do not by themselves establish unfair competition."
        }
      },
      {
        "id": "u4-13-protection-arguments-short-1",
        "knowledgePointId": "u4-13-protection-arguments",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释就业、安全与反倾销论据的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Employment, security and anti-dumping arguments and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "贸易保护可维护特定岗位或战略供应，但会提高投入成本、影响出口并可能引发报复；倾销不能仅由低价推断。 进口竞争冲击特定产业；保护减缓调整；下游成本与报复影响其他岗位 原创假设：钢铁关税保住部分炼钢岗位，却提高机械企业成本；评价需比较净就业、供应韧性与再培训方案。",
          "en": "Protection may preserve particular jobs or strategic supplies but raises input costs, affects exports and risks retaliation. A low price alone does not establish dumping. Import competition hits particular industries; protection slows adjustment; input costs and retaliation affect jobs elsewhere Hypothetical scenario: a steel tariff preserves some steel jobs but raises machinery producers' costs. Evaluate net jobs, supply resilience and retraining alternatives."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "就业",
              "en": "employment"
            },
            "alternatives": {
              "zh-CN": [
                "就业",
                "进口竞争冲击特定产业"
              ],
              "en": [
                "employment",
                "Import competition hits particular industries"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "成本",
              "en": "costs"
            },
            "alternatives": {
              "zh-CN": [
                "成本",
                "保护减缓调整"
              ],
              "en": [
                "costs",
                "protection slows adjustment"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "报复",
              "en": "retaliation"
            },
            "alternatives": {
              "zh-CN": [
                "报复",
                "下游成本与报复影响其他岗位"
              ],
              "en": [
                "retaliation",
                "input costs and retaliation affect jobs elsewhere"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-14-protection-evaluation",
      "slug": "protection-evaluation",
      "section": "4.3",
      "level": "core",
      "syllabusRefs": [
        "4.3 Arguments for and against trade protection"
      ],
      "textbookRefs": [
        {
          "chapter": "15",
          "section": "15.1",
          "pages": [
            465
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-12-infant-industry",
        "u4-13-protection-arguments"
      ],
      "terms": [
        "保护政策的综合评价",
        "Evaluating protection policies",
        "效率",
        "efficiency",
        "公平",
        "equity",
        "替代",
        "alternatives"
      ],
      "synonyms": {
        "zh-CN": [
          "效率",
          "公平",
          "替代"
        ],
        "en": [
          "efficiency",
          "equity",
          "alternatives"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-14-protection-evaluation-flash-1",
        "u4-14-protection-evaluation-mcq-1",
        "u4-14-protection-evaluation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-14-protection-evaluation",
        "locale": "zh-CN",
        "title": "保护政策的综合评价",
        "takeaway": "评价保护应比较效率、公平、财政成本、外部性、时限及贸易伙伴反应，并与针对性替代政策比较。",
        "definition": "评价保护应比较效率、公平、财政成本、外部性、时限及贸易伙伴反应，并与针对性替代政策比较。",
        "causalChain": [
          "确定政策目标",
          "比较各方收益与成本",
          "依据条件和替代方案作判断"
        ],
        "misconceptions": [
          "小国净福利损失结论依赖模型；外部性或大国贸易条件效应应另行论证，不能随意套用。"
        ],
        "examApplication": [
          "先陈述保护目标，再评价条件、时限、利益相关者、报复与替代政策。"
        ],
        "summary": [
          "评价保护应比较效率、公平、财政成本、外部性、时限及贸易伙伴反应，并与针对性替代政策比较。",
          "小国净福利损失结论依赖模型；外部性或大国贸易条件效应应另行论证，不能随意套用。"
        ],
        "explanation": "确定政策目标。比较各方收益与成本。依据条件和替代方案作判断。\n\n### 原创情境与推导\n\n原创假设：衰退地区需要支持，可比较关税、工资保险与培训；若问题是技能错配，培训可能比长期高价保护更直接。\n\n小国净福利损失结论依赖模型；外部性或大国贸易条件效应应另行论证，不能随意套用。\n\n先陈述保护目标，再评价条件、时限、利益相关者、报复与替代政策。"
      },
      "en": {
        "id": "u4-14-protection-evaluation",
        "locale": "en",
        "title": "Evaluating protection policies",
        "takeaway": "Evaluate protection through efficiency, equity, fiscal costs, externalities, duration and partner responses, alongside targeted alternatives.",
        "definition": "Evaluate protection through efficiency, equity, fiscal costs, externalities, duration and partner responses, alongside targeted alternatives.",
        "causalChain": [
          "Specify the objective",
          "compare stakeholder gains and costs",
          "judge using conditions and alternatives"
        ],
        "misconceptions": [
          "Small-country welfare losses are model-dependent; externalities or large-country terms-of-trade effects require separate arguments."
        ],
        "examApplication": [
          "State protection objectives, then evaluate conditions, duration, stakeholders, retaliation and alternatives."
        ],
        "summary": [
          "Evaluate protection through efficiency, equity, fiscal costs, externalities, duration and partner responses, alongside targeted alternatives.",
          "Small-country welfare losses are model-dependent; externalities or large-country terms-of-trade effects require separate arguments."
        ],
        "explanation": "Specify the objective.  compare stakeholder gains and costs.  judge using conditions and alternatives.\n\n### Original scenario and reasoning\n\nHypothetical scenario: compare tariffs, wage insurance and training for a declining region. If skill mismatch is the problem, training may address it more directly than prolonged price protection.\n\nSmall-country welfare losses are model-dependent; externalities or large-country terms-of-trade effects require separate arguments.\n\nState protection objectives, then evaluate conditions, duration, stakeholders, retaliation and alternatives."
      }
    },
    "practice": [
      {
        "id": "u4-14-protection-evaluation-flash-1",
        "knowledgePointId": "u4-14-protection-evaluation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“保护政策的综合评价”，并说明一个关键条件。",
          "en": "Explain Evaluating protection policies and state one important condition."
        },
        "answer": {
          "zh-CN": "评价保护应比较效率、公平、财政成本、外部性、时限及贸易伙伴反应，并与针对性替代政策比较。",
          "en": "Evaluate protection through efficiency, equity, fiscal costs, externalities, duration and partner responses, alongside targeted alternatives."
        },
        "explanation": {
          "zh-CN": "小国净福利损失结论依赖模型；外部性或大国贸易条件效应应另行论证，不能随意套用。",
          "en": "Small-country welfare losses are model-dependent; externalities or large-country terms-of-trade effects require separate arguments."
        }
      },
      {
        "id": "u4-14-protection-evaluation-mcq-1",
        "knowledgePointId": "u4-14-protection-evaluation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "评价保护政策时最完整的做法是什么？",
          "en": "Which approach best evaluates protection?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只计算生产者收益",
            "en": "Count only producer gains"
          },
          {
            "id": "b",
            "zh-CN": "将目标、成本、条件与替代措施连接",
            "en": "Link objectives, costs, conditions and alternatives"
          },
          {
            "id": "c",
            "zh-CN": "认为短期等于长期",
            "en": "Treat short run as long run"
          },
          {
            "id": "d",
            "zh-CN": "把税收当纯福利增量",
            "en": "Treat revenue as a pure welfare gain"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "将目标、成本、条件与替代措施连接。 确定政策目标；比较各方收益与成本；依据条件和替代方案作判断 小国净福利损失结论依赖模型；外部性或大国贸易条件效应应另行论证，不能随意套用。",
          "en": "Link objectives, costs, conditions and alternatives. Specify the objective; compare stakeholder gains and costs; judge using conditions and alternatives Small-country welfare losses are model-dependent; externalities or large-country terms-of-trade effects require separate arguments."
        }
      },
      {
        "id": "u4-14-protection-evaluation-short-1",
        "knowledgePointId": "u4-14-protection-evaluation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释保护政策的综合评价的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Evaluating protection policies and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "评价保护应比较效率、公平、财政成本、外部性、时限及贸易伙伴反应，并与针对性替代政策比较。 确定政策目标；比较各方收益与成本；依据条件和替代方案作判断 原创假设：衰退地区需要支持，可比较关税、工资保险与培训；若问题是技能错配，培训可能比长期高价保护更直接。",
          "en": "Evaluate protection through efficiency, equity, fiscal costs, externalities, duration and partner responses, alongside targeted alternatives. Specify the objective; compare stakeholder gains and costs; judge using conditions and alternatives Hypothetical scenario: compare tariffs, wage insurance and training for a declining region. If skill mismatch is the problem, training may address it more directly than prolonged price protection."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "效率",
              "en": "efficiency"
            },
            "alternatives": {
              "zh-CN": [
                "效率",
                "确定政策目标"
              ],
              "en": [
                "efficiency",
                "Specify the objective"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "公平",
              "en": "equity"
            },
            "alternatives": {
              "zh-CN": [
                "公平",
                "比较各方收益与成本"
              ],
              "en": [
                "equity",
                "compare stakeholder gains and costs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "替代",
              "en": "alternatives"
            },
            "alternatives": {
              "zh-CN": [
                "替代",
                "依据条件和替代方案作判断"
              ],
              "en": [
                "alternatives",
                "judge using conditions and alternatives"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-15-wto",
      "slug": "wto",
      "section": "4.4",
      "level": "core",
      "syllabusRefs": [
        "4.4 Economic integration"
      ],
      "textbookRefs": [
        {
          "chapter": "15",
          "section": "15.4",
          "pages": [
            483
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-16-trading-blocs",
        "u4-17-common-market",
        "u4-18-trade-creation-diversion"
      ],
      "terms": [
        "世界贸易组织与合作",
        "The WTO and trade cooperation",
        "规则",
        "rules",
        "透明度",
        "transparency",
        "争端",
        "dispute"
      ],
      "synonyms": {
        "zh-CN": [
          "规则",
          "透明度",
          "争端"
        ],
        "en": [
          "rules",
          "transparency",
          "dispute"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-15-wto-flash-1",
        "u4-15-wto-mcq-1",
        "u4-15-wto-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-15-wto",
        "locale": "zh-CN",
        "title": "世界贸易组织与合作",
        "takeaway": "WTO 为成员贸易规则、谈判、透明度与争端解决提供制度框架；规则合作可降低不确定性，但利益与执行能力不均。",
        "definition": "WTO 为成员贸易规则、谈判、透明度与争端解决提供制度框架；规则合作可降低不确定性，但利益与执行能力不均。",
        "causalChain": [
          "成员承诺规则",
          "透明度降低政策不确定性",
          "协商与争端程序处理冲突"
        ],
        "misconceptions": [
          "WTO 不是世界政府，也不保证所有贸易壁垒消失；当前争端机构运行状态须查官方资料。"
        ],
        "examApplication": [
          "准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
        ],
        "summary": [
          "WTO 为成员贸易规则、谈判、透明度与争端解决提供制度框架；规则合作可降低不确定性，但利益与执行能力不均。",
          "WTO 不是世界政府，也不保证所有贸易壁垒消失；当前争端机构运行状态须查官方资料。"
        ],
        "explanation": "成员承诺规则。透明度降低政策不确定性。协商与争端程序处理冲突。\n\n### 原创情境与推导\n\n原创假设：两国就进口限制产生分歧，共同规则可使争论围绕证据；小经济体仍可能面临法律资源不足。\n\nWTO 不是世界政府，也不保证所有贸易壁垒消失；当前争端机构运行状态须查官方资料。\n\n准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
      },
      "en": {
        "id": "u4-15-wto",
        "locale": "en",
        "title": "The WTO and trade cooperation",
        "takeaway": "The WTO provides a framework for members' trade rules, negotiations, transparency and dispute settlement. Cooperation can reduce uncertainty, though interests and enforcement capacity differ.",
        "definition": "The WTO provides a framework for members' trade rules, negotiations, transparency and dispute settlement. Cooperation can reduce uncertainty, though interests and enforcement capacity differ.",
        "causalChain": [
          "Members commit to rules",
          "transparency reduces policy uncertainty",
          "negotiation and dispute procedures address conflict"
        ],
        "misconceptions": [
          "The WTO is not a world government and does not remove every barrier; current dispute-body operations require official verification."
        ],
        "examApplication": [
          "Distinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
        ],
        "summary": [
          "The WTO provides a framework for members' trade rules, negotiations, transparency and dispute settlement. Cooperation can reduce uncertainty, though interests and enforcement capacity differ.",
          "The WTO is not a world government and does not remove every barrier; current dispute-body operations require official verification."
        ],
        "explanation": "Members commit to rules.  transparency reduces policy uncertainty.  negotiation and dispute procedures address conflict.\n\n### Original scenario and reasoning\n\nHypothetical scenario: common rules focus a dispute over import restrictions on evidence, while a small economy may lack legal resources.\n\nThe WTO is not a world government and does not remove every barrier; current dispute-body operations require official verification.\n\nDistinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
      }
    },
    "practice": [
      {
        "id": "u4-15-wto-flash-1",
        "knowledgePointId": "u4-15-wto",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“世界贸易组织与合作”，并说明一个关键条件。",
          "en": "Explain The WTO and trade cooperation and state one important condition."
        },
        "answer": {
          "zh-CN": "WTO 为成员贸易规则、谈判、透明度与争端解决提供制度框架；规则合作可降低不确定性，但利益与执行能力不均。",
          "en": "The WTO provides a framework for members' trade rules, negotiations, transparency and dispute settlement. Cooperation can reduce uncertainty, though interests and enforcement capacity differ."
        },
        "explanation": {
          "zh-CN": "WTO 不是世界政府，也不保证所有贸易壁垒消失；当前争端机构运行状态须查官方资料。",
          "en": "The WTO is not a world government and does not remove every barrier; current dispute-body operations require official verification."
        }
      },
      {
        "id": "u4-15-wto-mcq-1",
        "knowledgePointId": "u4-15-wto",
        "type": "mcq",
        "prompt": {
          "zh-CN": "规则透明度如何帮助贸易？",
          "en": "How can rule transparency support trade?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "保证每个争端立即解决",
            "en": "Guarantee instant resolution of every dispute"
          },
          {
            "id": "b",
            "zh-CN": "替代所有国内政策",
            "en": "Replace all domestic policy"
          },
          {
            "id": "c",
            "zh-CN": "降低政策不确定性",
            "en": "Reduce policy uncertainty"
          },
          {
            "id": "d",
            "zh-CN": "固定所有汇率",
            "en": "Fix every exchange rate"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "降低政策不确定性。 成员承诺规则；透明度降低政策不确定性；协商与争端程序处理冲突 WTO 不是世界政府，也不保证所有贸易壁垒消失；当前争端机构运行状态须查官方资料。",
          "en": "Reduce policy uncertainty. Members commit to rules; transparency reduces policy uncertainty; negotiation and dispute procedures address conflict The WTO is not a world government and does not remove every barrier; current dispute-body operations require official verification."
        }
      },
      {
        "id": "u4-15-wto-short-1",
        "knowledgePointId": "u4-15-wto",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释世界贸易组织与合作的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of The WTO and trade cooperation and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "WTO 为成员贸易规则、谈判、透明度与争端解决提供制度框架；规则合作可降低不确定性，但利益与执行能力不均。 成员承诺规则；透明度降低政策不确定性；协商与争端程序处理冲突 原创假设：两国就进口限制产生分歧，共同规则可使争论围绕证据；小经济体仍可能面临法律资源不足。",
          "en": "The WTO provides a framework for members' trade rules, negotiations, transparency and dispute settlement. Cooperation can reduce uncertainty, though interests and enforcement capacity differ. Members commit to rules; transparency reduces policy uncertainty; negotiation and dispute procedures address conflict Hypothetical scenario: common rules focus a dispute over import restrictions on evidence, while a small economy may lack legal resources."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "规则",
              "en": "rules"
            },
            "alternatives": {
              "zh-CN": [
                "规则",
                "成员承诺规则"
              ],
              "en": [
                "rules",
                "Members commit to rules"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "透明度",
              "en": "transparency"
            },
            "alternatives": {
              "zh-CN": [
                "透明度",
                "透明度降低政策不确定性"
              ],
              "en": [
                "transparency",
                "transparency reduces policy uncertainty"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "争端",
              "en": "dispute"
            },
            "alternatives": {
              "zh-CN": [
                "争端",
                "协商与争端程序处理冲突"
              ],
              "en": [
                "dispute",
                "negotiation and dispute procedures address conflict"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-16-trading-blocs",
      "slug": "trading-blocs",
      "section": "4.4",
      "level": "core",
      "syllabusRefs": [
        "4.4 Economic integration"
      ],
      "textbookRefs": [
        {
          "chapter": "15",
          "section": "15.2",
          "pages": [
            472
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-15-wto",
        "u4-17-common-market",
        "u4-18-trade-creation-diversion"
      ],
      "terms": [
        "优惠协定、自由贸易区与关税同盟",
        "Preferential agreements, free trade areas and customs unions",
        "内部",
        "internal",
        "对外关税",
        "external tariff",
        "原产地",
        "origin"
      ],
      "synonyms": {
        "zh-CN": [
          "内部",
          "对外关税",
          "原产地"
        ],
        "en": [
          "internal",
          "external tariff",
          "origin"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-16-trading-blocs-flash-1",
        "u4-16-trading-blocs-mcq-1",
        "u4-16-trading-blocs-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-16-trading-blocs",
        "locale": "zh-CN",
        "title": "优惠协定、自由贸易区与关税同盟",
        "takeaway": "优惠协定降低部分成员壁垒；自由贸易区取消成员间贸易壁垒但保留各自对外关税；关税同盟另有共同对外关税。",
        "definition": "优惠协定降低部分成员壁垒；自由贸易区取消成员间贸易壁垒但保留各自对外关税；关税同盟另有共同对外关税。",
        "causalChain": [
          "成员降低内部壁垒",
          "自由贸易区需原产地规则",
          "共同对外关税形成关税同盟"
        ],
        "misconceptions": [
          "内部自由贸易本身不意味着共同对外关税或共同货币。"
        ],
        "examApplication": [
          "准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
        ],
        "summary": [
          "优惠协定降低部分成员壁垒；自由贸易区取消成员间贸易壁垒但保留各自对外关税；关税同盟另有共同对外关税。",
          "内部自由贸易本身不意味着共同对外关税或共同货币。"
        ],
        "explanation": "成员降低内部壁垒。自由贸易区需原产地规则。共同对外关税形成关税同盟。\n\n### 原创情境与推导\n\n原创假设：A 与 B 内部免税但对 C 税率不同，属于自由贸易区；原产地规则防止经最低税率成员转运规避关税。\n\n内部自由贸易本身不意味着共同对外关税或共同货币。\n\n准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
      },
      "en": {
        "id": "u4-16-trading-blocs",
        "locale": "en",
        "title": "Preferential agreements, free trade areas and customs unions",
        "takeaway": "Preferential agreements reduce selected member barriers. Free trade areas remove internal barriers while retaining separate external tariffs; customs unions add a common external tariff.",
        "definition": "Preferential agreements reduce selected member barriers. Free trade areas remove internal barriers while retaining separate external tariffs; customs unions add a common external tariff.",
        "causalChain": [
          "Members lower internal barriers",
          "free trade areas need rules of origin",
          "a common external tariff creates a customs union"
        ],
        "misconceptions": [
          "Internal free trade alone does not imply a common external tariff or currency."
        ],
        "examApplication": [
          "Distinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
        ],
        "summary": [
          "Preferential agreements reduce selected member barriers. Free trade areas remove internal barriers while retaining separate external tariffs; customs unions add a common external tariff.",
          "Internal free trade alone does not imply a common external tariff or currency."
        ],
        "explanation": "Members lower internal barriers.  free trade areas need rules of origin.  a common external tariff creates a customs union.\n\n### Original scenario and reasoning\n\nHypothetical scenario: A and B trade duty-free but tax C differently. This is a free trade area; rules of origin limit tariff circumvention through the lowest-tariff member.\n\nInternal free trade alone does not imply a common external tariff or currency.\n\nDistinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
      }
    },
    "practice": [
      {
        "id": "u4-16-trading-blocs-flash-1",
        "knowledgePointId": "u4-16-trading-blocs",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“优惠协定、自由贸易区与关税同盟”，并说明一个关键条件。",
          "en": "Explain Preferential agreements, free trade areas and customs unions and state one important condition."
        },
        "answer": {
          "zh-CN": "优惠协定降低部分成员壁垒；自由贸易区取消成员间贸易壁垒但保留各自对外关税；关税同盟另有共同对外关税。",
          "en": "Preferential agreements reduce selected member barriers. Free trade areas remove internal barriers while retaining separate external tariffs; customs unions add a common external tariff."
        },
        "explanation": {
          "zh-CN": "内部自由贸易本身不意味着共同对外关税或共同货币。",
          "en": "Internal free trade alone does not imply a common external tariff or currency."
        }
      },
      {
        "id": "u4-16-trading-blocs-mcq-1",
        "knowledgePointId": "u4-16-trading-blocs",
        "type": "mcq",
        "prompt": {
          "zh-CN": "自由贸易区与关税同盟的关键差别是什么？",
          "en": "What chiefly distinguishes a customs union from a free trade area?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "必须共同货币",
            "en": "A compulsory common currency"
          },
          {
            "id": "b",
            "zh-CN": "必须相同人口",
            "en": "Identical populations"
          },
          {
            "id": "c",
            "zh-CN": "禁止内部贸易",
            "en": "Banning internal trade"
          },
          {
            "id": "d",
            "zh-CN": "共同对外关税",
            "en": "A common external tariff"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "共同对外关税。 成员降低内部壁垒；自由贸易区需原产地规则；共同对外关税形成关税同盟 内部自由贸易本身不意味着共同对外关税或共同货币。",
          "en": "A common external tariff. Members lower internal barriers; free trade areas need rules of origin; a common external tariff creates a customs union Internal free trade alone does not imply a common external tariff or currency."
        }
      },
      {
        "id": "u4-16-trading-blocs-short-1",
        "knowledgePointId": "u4-16-trading-blocs",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释优惠协定、自由贸易区与关税同盟的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Preferential agreements, free trade areas and customs unions and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "优惠协定降低部分成员壁垒；自由贸易区取消成员间贸易壁垒但保留各自对外关税；关税同盟另有共同对外关税。 成员降低内部壁垒；自由贸易区需原产地规则；共同对外关税形成关税同盟 原创假设：A 与 B 内部免税但对 C 税率不同，属于自由贸易区；原产地规则防止经最低税率成员转运规避关税。",
          "en": "Preferential agreements reduce selected member barriers. Free trade areas remove internal barriers while retaining separate external tariffs; customs unions add a common external tariff. Members lower internal barriers; free trade areas need rules of origin; a common external tariff creates a customs union Hypothetical scenario: A and B trade duty-free but tax C differently. This is a free trade area; rules of origin limit tariff circumvention through the lowest-tariff member."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "内部",
              "en": "internal"
            },
            "alternatives": {
              "zh-CN": [
                "内部",
                "成员降低内部壁垒"
              ],
              "en": [
                "internal",
                "Members lower internal barriers"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "对外关税",
              "en": "external tariff"
            },
            "alternatives": {
              "zh-CN": [
                "对外关税",
                "自由贸易区需原产地规则"
              ],
              "en": [
                "external tariff",
                "free trade areas need rules of origin"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "原产地",
              "en": "origin"
            },
            "alternatives": {
              "zh-CN": [
                "原产地",
                "共同对外关税形成关税同盟"
              ],
              "en": [
                "origin",
                "a common external tariff creates a customs union"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-17-common-market",
      "slug": "common-market",
      "section": "4.4",
      "level": "core",
      "syllabusRefs": [
        "4.4 Economic integration"
      ],
      "textbookRefs": [
        {
          "chapter": "15",
          "section": "15.2",
          "pages": [
            472
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-15-wto",
        "u4-16-trading-blocs",
        "u4-18-trade-creation-diversion"
      ],
      "terms": [
        "共同市场与经济一体化",
        "Common markets and economic integration",
        "要素",
        "factors",
        "流动",
        "mobility",
        "协调",
        "coordination"
      ],
      "synonyms": {
        "zh-CN": [
          "要素",
          "流动",
          "协调"
        ],
        "en": [
          "factors",
          "mobility",
          "coordination"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-17-common-market-flash-1",
        "u4-17-common-market-mcq-1",
        "u4-17-common-market-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-17-common-market",
        "locale": "zh-CN",
        "title": "共同市场与经济一体化",
        "takeaway": "共同市场在贸易一体化基础上允许生产要素跨成员流动；更深一体化涉及政策协调和自主权权衡。",
        "definition": "共同市场在贸易一体化基础上允许生产要素跨成员流动；更深一体化涉及政策协调和自主权权衡。",
        "causalChain": [
          "壁垒下降扩展市场",
          "劳动资本流向回报较高处",
          "协调政策降低跨境摩擦"
        ],
        "misconceptions": [
          "要素自由流动不保证地区收益均衡；基础设施和制度差异仍存在。"
        ],
        "examApplication": [
          "准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
        ],
        "summary": [
          "共同市场在贸易一体化基础上允许生产要素跨成员流动；更深一体化涉及政策协调和自主权权衡。",
          "要素自由流动不保证地区收益均衡；基础设施和制度差异仍存在。"
        ],
        "explanation": "壁垒下降扩展市场。劳动资本流向回报较高处。协调政策降低跨境摩擦。\n\n### 原创情境与推导\n\n原创假设：工程师跨成员就业改善技能匹配，但人才流出地区可能失去税基，资格互认与公共服务协调因此重要。\n\n要素自由流动不保证地区收益均衡；基础设施和制度差异仍存在。\n\n准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
      },
      "en": {
        "id": "u4-17-common-market",
        "locale": "en",
        "title": "Common markets and economic integration",
        "takeaway": "A common market adds factor mobility to trade integration. Deeper integration brings policy coordination and trade-offs over autonomy.",
        "definition": "A common market adds factor mobility to trade integration. Deeper integration brings policy coordination and trade-offs over autonomy.",
        "causalChain": [
          "Lower barriers expand markets",
          "labour and capital move toward higher returns",
          "policy coordination reduces cross-border frictions"
        ],
        "misconceptions": [
          "Factor mobility does not ensure equal regional gains; infrastructure and institutional differences remain."
        ],
        "examApplication": [
          "Distinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
        ],
        "summary": [
          "A common market adds factor mobility to trade integration. Deeper integration brings policy coordination and trade-offs over autonomy.",
          "Factor mobility does not ensure equal regional gains; infrastructure and institutional differences remain."
        ],
        "explanation": "Lower barriers expand markets.  labour and capital move toward higher returns.  policy coordination reduces cross-border frictions.\n\n### Original scenario and reasoning\n\nHypothetical scenario: engineers moving between members improve skill matching, while origin regions may lose tax revenue. Qualification recognition and service coordination matter.\n\nFactor mobility does not ensure equal regional gains; infrastructure and institutional differences remain.\n\nDistinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
      }
    },
    "practice": [
      {
        "id": "u4-17-common-market-flash-1",
        "knowledgePointId": "u4-17-common-market",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“共同市场与经济一体化”，并说明一个关键条件。",
          "en": "Explain Common markets and economic integration and state one important condition."
        },
        "answer": {
          "zh-CN": "共同市场在贸易一体化基础上允许生产要素跨成员流动；更深一体化涉及政策协调和自主权权衡。",
          "en": "A common market adds factor mobility to trade integration. Deeper integration brings policy coordination and trade-offs over autonomy."
        },
        "explanation": {
          "zh-CN": "要素自由流动不保证地区收益均衡；基础设施和制度差异仍存在。",
          "en": "Factor mobility does not ensure equal regional gains; infrastructure and institutional differences remain."
        }
      },
      {
        "id": "u4-17-common-market-mcq-1",
        "knowledgePointId": "u4-17-common-market",
        "type": "mcq",
        "prompt": {
          "zh-CN": "共同市场在关税同盟基础上增加什么？",
          "en": "What does a common market add to a customs union?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "生产要素流动",
            "en": "Factor mobility"
          },
          {
            "id": "b",
            "zh-CN": "必然无失业",
            "en": "Guaranteed zero unemployment"
          },
          {
            "id": "c",
            "zh-CN": "世界统一价格",
            "en": "A single price for everything worldwide"
          },
          {
            "id": "d",
            "zh-CN": "禁止迁移",
            "en": "A ban on migration"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "生产要素流动。 壁垒下降扩展市场；劳动资本流向回报较高处；协调政策降低跨境摩擦 要素自由流动不保证地区收益均衡；基础设施和制度差异仍存在。",
          "en": "Factor mobility. Lower barriers expand markets; labour and capital move toward higher returns; policy coordination reduces cross-border frictions Factor mobility does not ensure equal regional gains; infrastructure and institutional differences remain."
        }
      },
      {
        "id": "u4-17-common-market-short-1",
        "knowledgePointId": "u4-17-common-market",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释共同市场与经济一体化的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Common markets and economic integration and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "共同市场在贸易一体化基础上允许生产要素跨成员流动；更深一体化涉及政策协调和自主权权衡。 壁垒下降扩展市场；劳动资本流向回报较高处；协调政策降低跨境摩擦 原创假设：工程师跨成员就业改善技能匹配，但人才流出地区可能失去税基，资格互认与公共服务协调因此重要。",
          "en": "A common market adds factor mobility to trade integration. Deeper integration brings policy coordination and trade-offs over autonomy. Lower barriers expand markets; labour and capital move toward higher returns; policy coordination reduces cross-border frictions Hypothetical scenario: engineers moving between members improve skill matching, while origin regions may lose tax revenue. Qualification recognition and service coordination matter."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "要素",
              "en": "factors"
            },
            "alternatives": {
              "zh-CN": [
                "要素",
                "壁垒下降扩展市场"
              ],
              "en": [
                "factors",
                "Lower barriers expand markets"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "流动",
              "en": "mobility"
            },
            "alternatives": {
              "zh-CN": [
                "流动",
                "劳动资本流向回报较高处"
              ],
              "en": [
                "mobility",
                "labour and capital move toward higher returns"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "协调",
              "en": "coordination"
            },
            "alternatives": {
              "zh-CN": [
                "协调",
                "协调政策降低跨境摩擦"
              ],
              "en": [
                "coordination",
                "policy coordination reduces cross-border frictions"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-18-trade-creation-diversion",
      "slug": "trade-creation-diversion",
      "section": "4.4",
      "level": "hl",
      "syllabusRefs": [
        "4.4 Economic integration"
      ],
      "textbookRefs": [
        {
          "chapter": "15",
          "section": "15.2",
          "pages": [
            472
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-15-wto",
        "u4-16-trading-blocs",
        "u4-17-common-market"
      ],
      "terms": [
        "贸易创造与贸易转移",
        "Trade creation and trade diversion",
        "成本",
        "costs",
        "成员",
        "member",
        "转移",
        "diversion"
      ],
      "synonyms": {
        "zh-CN": [
          "成本",
          "成员",
          "转移"
        ],
        "en": [
          "costs",
          "member",
          "diversion"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-18-trade-creation-diversion-flash-1",
        "u4-18-trade-creation-diversion-mcq-1",
        "u4-18-trade-creation-diversion-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-18-trade-creation-diversion",
        "locale": "zh-CN",
        "title": "贸易创造与贸易转移",
        "takeaway": "贸易创造以低成本成员进口替代高成本本国产出；贸易转移则以较高成本成员进口替代低成本非成员进口。",
        "definition": "贸易创造以低成本成员进口替代高成本本国产出；贸易转移则以较高成本成员进口替代低成本非成员进口。",
        "causalChain": [
          "内部关税取消改变相对价格",
          "采购来源改变",
          "比较真实资源成本与关税收入变化"
        ],
        "misconceptions": [
          "消费者价格降低不充分证明全球配置效率提高；还要看供应者真实成本。"
        ],
        "examApplication": [
          "准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
        ],
        "summary": [
          "贸易创造以低成本成员进口替代高成本本国产出；贸易转移则以较高成本成员进口替代低成本非成员进口。",
          "消费者价格降低不充分证明全球配置效率提高；还要看供应者真实成本。"
        ],
        "explanation": "内部关税取消改变相对价格。采购来源改变。比较真实资源成本与关税收入变化。\n\n### 原创情境与推导\n\n原创假设：非成员成本 8、成员成本 10，对外税 4。入盟后免税成员价 10 低于非成员含税价 12，转向成员属于贸易转移。\n\n消费者价格降低不充分证明全球配置效率提高；还要看供应者真实成本。\n\n准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
      },
      "en": {
        "id": "u4-18-trade-creation-diversion",
        "locale": "en",
        "title": "Trade creation and trade diversion",
        "takeaway": "Trade creation replaces costly domestic output with cheaper member imports. Trade diversion replaces cheaper non-member imports with higher-cost member imports.",
        "definition": "Trade creation replaces costly domestic output with cheaper member imports. Trade diversion replaces cheaper non-member imports with higher-cost member imports.",
        "causalChain": [
          "Removing internal tariffs changes relative prices",
          "sourcing changes",
          "compare real resource costs and tariff revenue changes"
        ],
        "misconceptions": [
          "A lower consumer price alone does not establish better global allocation; compare suppliers' real costs."
        ],
        "examApplication": [
          "Distinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
        ],
        "summary": [
          "Trade creation replaces costly domestic output with cheaper member imports. Trade diversion replaces cheaper non-member imports with higher-cost member imports.",
          "A lower consumer price alone does not establish better global allocation; compare suppliers' real costs."
        ],
        "explanation": "Removing internal tariffs changes relative prices.  sourcing changes.  compare real resource costs and tariff revenue changes.\n\n### Original scenario and reasoning\n\nHypothetical scenario: a non-member costs eight and a member ten; the external tariff is four. After integration, the member price ten undercuts the non-member landed price twelve. Switching is trade diversion.\n\nA lower consumer price alone does not establish better global allocation; compare suppliers' real costs.\n\nDistinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
      }
    },
    "practice": [
      {
        "id": "u4-18-trade-creation-diversion-flash-1",
        "knowledgePointId": "u4-18-trade-creation-diversion",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“贸易创造与贸易转移”，并说明一个关键条件。",
          "en": "Explain Trade creation and trade diversion and state one important condition."
        },
        "answer": {
          "zh-CN": "贸易创造以低成本成员进口替代高成本本国产出；贸易转移则以较高成本成员进口替代低成本非成员进口。",
          "en": "Trade creation replaces costly domestic output with cheaper member imports. Trade diversion replaces cheaper non-member imports with higher-cost member imports."
        },
        "explanation": {
          "zh-CN": "消费者价格降低不充分证明全球配置效率提高；还要看供应者真实成本。",
          "en": "A lower consumer price alone does not establish better global allocation; compare suppliers' real costs."
        }
      },
      {
        "id": "u4-18-trade-creation-diversion-mcq-1",
        "knowledgePointId": "u4-18-trade-creation-diversion",
        "type": "mcq",
        "prompt": {
          "zh-CN": "从成本 8 的非成员转向成本 10 的成员，属于什么？",
          "en": "Switching from a non-member costing eight to a member costing ten is what?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "贸易创造",
            "en": "Trade creation"
          },
          {
            "id": "b",
            "zh-CN": "贸易转移",
            "en": "Trade diversion"
          },
          {
            "id": "c",
            "zh-CN": "绝对优势自动提高",
            "en": "Automatically higher absolute advantage"
          },
          {
            "id": "d",
            "zh-CN": "货币贬值",
            "en": "Currency depreciation"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "贸易转移。 内部关税取消改变相对价格；采购来源改变；比较真实资源成本与关税收入变化 消费者价格降低不充分证明全球配置效率提高；还要看供应者真实成本。",
          "en": "Trade diversion. Removing internal tariffs changes relative prices; sourcing changes; compare real resource costs and tariff revenue changes A lower consumer price alone does not establish better global allocation; compare suppliers' real costs."
        }
      },
      {
        "id": "u4-18-trade-creation-diversion-short-1",
        "knowledgePointId": "u4-18-trade-creation-diversion",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释贸易创造与贸易转移的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Trade creation and trade diversion and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "贸易创造以低成本成员进口替代高成本本国产出；贸易转移则以较高成本成员进口替代低成本非成员进口。 内部关税取消改变相对价格；采购来源改变；比较真实资源成本与关税收入变化 原创假设：非成员成本 8、成员成本 10，对外税 4。入盟后免税成员价 10 低于非成员含税价 12，转向成员属于贸易转移。",
          "en": "Trade creation replaces costly domestic output with cheaper member imports. Trade diversion replaces cheaper non-member imports with higher-cost member imports. Removing internal tariffs changes relative prices; sourcing changes; compare real resource costs and tariff revenue changes Hypothetical scenario: a non-member costs eight and a member ten; the external tariff is four. After integration, the member price ten undercuts the non-member landed price twelve. Switching is trade diversion."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "成本",
              "en": "costs"
            },
            "alternatives": {
              "zh-CN": [
                "成本",
                "内部关税取消改变相对价格"
              ],
              "en": [
                "costs",
                "Removing internal tariffs changes relative prices"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "成员",
              "en": "member"
            },
            "alternatives": {
              "zh-CN": [
                "成员",
                "采购来源改变"
              ],
              "en": [
                "member",
                "sourcing changes"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "转移",
              "en": "diversion"
            },
            "alternatives": {
              "zh-CN": [
                "转移",
                "比较真实资源成本与关税收入变化"
              ],
              "en": [
                "diversion",
                "compare real resource costs and tariff revenue changes"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-19-monetary-union",
      "slug": "monetary-union",
      "section": "4.4",
      "level": "core",
      "syllabusRefs": [
        "4.4 Economic integration"
      ],
      "textbookRefs": [
        {
          "chapter": "15",
          "section": "15.3",
          "pages": [
            482
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-15-wto",
        "u4-16-trading-blocs",
        "u4-17-common-market"
      ],
      "terms": [
        "货币联盟的含义",
        "The meaning of monetary union",
        "共同货币",
        "shared currency",
        "货币政策",
        "monetary policy",
        "成员",
        "members"
      ],
      "synonyms": {
        "zh-CN": [
          "共同货币",
          "货币政策",
          "成员"
        ],
        "en": [
          "shared currency",
          "monetary policy",
          "members"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-19-monetary-union-flash-1",
        "u4-19-monetary-union-mcq-1",
        "u4-19-monetary-union-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-19-monetary-union",
        "locale": "zh-CN",
        "title": "货币联盟的含义",
        "takeaway": "货币联盟采用共同货币及共同货币政策，成员不再各自发行可独立调整汇率的货币。收益、代价与非对称冲击评价属于 HL。",
        "definition": "货币联盟采用共同货币及共同货币政策，成员不再各自发行可独立调整汇率的货币。收益、代价与非对称冲击评价属于 HL。",
        "causalChain": [
          "成员采用共同货币",
          "共同机构制定货币政策",
          "区别于只有内部自由贸易的贸易区"
        ],
        "misconceptions": [
          "自由贸易区不等于货币联盟，共同货币也不自动意味着财政统一。"
        ],
        "examApplication": [
          "准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
        ],
        "summary": [
          "货币联盟采用共同货币及共同货币政策，成员不再各自发行可独立调整汇率的货币。收益、代价与非对称冲击评价属于 HL。",
          "自由贸易区不等于货币联盟，共同货币也不自动意味着财政统一。"
        ],
        "explanation": "成员采用共同货币。共同机构制定货币政策。区别于只有内部自由贸易的贸易区。\n\n### 原创情境与推导\n\n原创假设：A 与 B 内部免税仍可保留不同货币；只有采用共同货币和共同货币政策才符合本卡的货币联盟定义。\n\n自由贸易区不等于货币联盟，共同货币也不自动意味着财政统一。\n\n准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
      },
      "en": {
        "id": "u4-19-monetary-union",
        "locale": "en",
        "title": "The meaning of monetary union",
        "takeaway": "A monetary union uses a shared currency and monetary policy; members no longer issue separate currencies with independently adjustable exchange rates. Evaluating benefits, costs and asymmetric shocks is HL.",
        "definition": "A monetary union uses a shared currency and monetary policy; members no longer issue separate currencies with independently adjustable exchange rates. Evaluating benefits, costs and asymmetric shocks is HL.",
        "causalChain": [
          "Members adopt one currency",
          "a shared institution sets monetary policy",
          "distinguish this from an area with internal free trade only"
        ],
        "misconceptions": [
          "A free trade area is not a monetary union; a common currency does not automatically mean fiscal unification."
        ],
        "examApplication": [
          "Distinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
        ],
        "summary": [
          "A monetary union uses a shared currency and monetary policy; members no longer issue separate currencies with independently adjustable exchange rates. Evaluating benefits, costs and asymmetric shocks is HL.",
          "A free trade area is not a monetary union; a common currency does not automatically mean fiscal unification."
        ],
        "explanation": "Members adopt one currency.  a shared institution sets monetary policy.  distinguish this from an area with internal free trade only.\n\n### Original scenario and reasoning\n\nHypothetical scenario: A and B can trade duty-free while retaining different currencies. A common currency and monetary policy distinguish monetary union here.\n\nA free trade area is not a monetary union; a common currency does not automatically mean fiscal unification.\n\nDistinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
      }
    },
    "practice": [
      {
        "id": "u4-19-monetary-union-flash-1",
        "knowledgePointId": "u4-19-monetary-union",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“货币联盟的含义”，并说明一个关键条件。",
          "en": "Explain The meaning of monetary union and state one important condition."
        },
        "answer": {
          "zh-CN": "货币联盟采用共同货币及共同货币政策，成员不再各自发行可独立调整汇率的货币。收益、代价与非对称冲击评价属于 HL。",
          "en": "A monetary union uses a shared currency and monetary policy; members no longer issue separate currencies with independently adjustable exchange rates. Evaluating benefits, costs and asymmetric shocks is HL."
        },
        "explanation": {
          "zh-CN": "自由贸易区不等于货币联盟，共同货币也不自动意味着财政统一。",
          "en": "A free trade area is not a monetary union; a common currency does not automatically mean fiscal unification."
        }
      },
      {
        "id": "u4-19-monetary-union-mcq-1",
        "knowledgePointId": "u4-19-monetary-union",
        "type": "mcq",
        "prompt": {
          "zh-CN": "货币联盟的识别特征是什么？",
          "en": "What identifies a monetary union?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "仅内部免关税",
            "en": "Internal tariff removal alone"
          },
          {
            "id": "b",
            "zh-CN": "仅共同对外关税",
            "en": "A common external tariff alone"
          },
          {
            "id": "c",
            "zh-CN": "共同货币与共同货币政策",
            "en": "A shared currency and monetary policy"
          },
          {
            "id": "d",
            "zh-CN": "仅人口相同",
            "en": "Identical populations alone"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "共同货币与共同货币政策。 成员采用共同货币；共同机构制定货币政策；区别于只有内部自由贸易的贸易区 自由贸易区不等于货币联盟，共同货币也不自动意味着财政统一。",
          "en": "A shared currency and monetary policy. Members adopt one currency; a shared institution sets monetary policy; distinguish this from an area with internal free trade only A free trade area is not a monetary union; a common currency does not automatically mean fiscal unification."
        }
      },
      {
        "id": "u4-19-monetary-union-short-1",
        "knowledgePointId": "u4-19-monetary-union",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释货币联盟的含义的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of The meaning of monetary union and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "货币联盟采用共同货币及共同货币政策，成员不再各自发行可独立调整汇率的货币。收益、代价与非对称冲击评价属于 HL。 成员采用共同货币；共同机构制定货币政策；区别于只有内部自由贸易的贸易区 原创假设：A 与 B 内部免税仍可保留不同货币；只有采用共同货币和共同货币政策才符合本卡的货币联盟定义。",
          "en": "A monetary union uses a shared currency and monetary policy; members no longer issue separate currencies with independently adjustable exchange rates. Evaluating benefits, costs and asymmetric shocks is HL. Members adopt one currency; a shared institution sets monetary policy; distinguish this from an area with internal free trade only Hypothetical scenario: A and B can trade duty-free while retaining different currencies. A common currency and monetary policy distinguish monetary union here."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "共同货币",
              "en": "shared currency"
            },
            "alternatives": {
              "zh-CN": [
                "共同货币",
                "成员采用共同货币"
              ],
              "en": [
                "shared currency",
                "Members adopt one currency"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "货币政策",
              "en": "monetary policy"
            },
            "alternatives": {
              "zh-CN": [
                "货币政策",
                "共同机构制定货币政策"
              ],
              "en": [
                "monetary policy",
                "a shared institution sets monetary policy"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "成员",
              "en": "members"
            },
            "alternatives": {
              "zh-CN": [
                "成员",
                "区别于只有内部自由贸易的贸易区"
              ],
              "en": [
                "members",
                "distinguish this from an area with internal free trade only"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-20-integration-evaluation",
      "slug": "integration-evaluation",
      "section": "4.4",
      "level": "core",
      "syllabusRefs": [
        "4.4 Economic integration"
      ],
      "textbookRefs": [
        {
          "chapter": "15",
          "section": "15.2",
          "pages": [
            472
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-15-wto",
        "u4-16-trading-blocs",
        "u4-17-common-market"
      ],
      "terms": [
        "一体化的动态评价",
        "Dynamic evaluation of integration",
        "投资",
        "investment",
        "生产率",
        "productivity",
        "分配",
        "distribution"
      ],
      "synonyms": {
        "zh-CN": [
          "投资",
          "生产率",
          "分配"
        ],
        "en": [
          "investment",
          "productivity",
          "distribution"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-20-integration-evaluation-flash-1",
        "u4-20-integration-evaluation-mcq-1",
        "u4-20-integration-evaluation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-20-integration-evaluation",
        "locale": "zh-CN",
        "title": "一体化的动态评价",
        "takeaway": "经济一体化可能增强竞争、投资和规模经济；收益取决于成员差异、制度质量、地区分配和实施条件。",
        "definition": "经济一体化可能增强竞争、投资和规模经济；收益取决于成员差异、制度质量、地区分配和实施条件。",
        "causalChain": [
          "市场扩大吸引投资",
          "竞争促进生产率",
          "地区集中和政策约束改变分配"
        ],
        "misconceptions": [
          "更多区域内贸易不充分证明福利提高，还需评价成本、竞争和分配；贸易创造与转移的分析属于 HL。"
        ],
        "examApplication": [
          "准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
        ],
        "summary": [
          "经济一体化可能增强竞争、投资和规模经济；收益取决于成员差异、制度质量、地区分配和实施条件。",
          "更多区域内贸易不充分证明福利提高，还需评价成本、竞争和分配；贸易创造与转移的分析属于 HL。"
        ],
        "explanation": "市场扩大吸引投资。竞争促进生产率。地区集中和政策约束改变分配。\n\n### 原创情境与推导\n\n原创假设：共同市场吸引汽车投资，但就业集中在港口地区；评估时加入地区基金、技能和跨境公共品，而非只看贸易总额。\n\n更多区域内贸易不充分证明福利提高，还需评价成本、竞争和分配；贸易创造与转移的分析属于 HL。\n\n准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
      },
      "en": {
        "id": "u4-20-integration-evaluation",
        "locale": "en",
        "title": "Dynamic evaluation of integration",
        "takeaway": "Integration may strengthen competition, investment and scale economies; gains depend on member differences, institutional quality, regional distribution and implementation.",
        "definition": "Integration may strengthen competition, investment and scale economies; gains depend on member differences, institutional quality, regional distribution and implementation.",
        "causalChain": [
          "A larger market attracts investment",
          "competition encourages productivity",
          "regional concentration and policy constraints alter distribution"
        ],
        "misconceptions": [
          "More intraregional trade alone does not establish welfare gains; evaluate costs, competition and distribution. Trade creation and diversion analysis is HL."
        ],
        "examApplication": [
          "Distinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
        ],
        "summary": [
          "Integration may strengthen competition, investment and scale economies; gains depend on member differences, institutional quality, regional distribution and implementation.",
          "More intraregional trade alone does not establish welfare gains; evaluate costs, competition and distribution. Trade creation and diversion analysis is HL."
        ],
        "explanation": "A larger market attracts investment.  competition encourages productivity.  regional concentration and policy constraints alter distribution.\n\n### Original scenario and reasoning\n\nHypothetical scenario: a common market attracts car investment, concentrated near ports. Evaluate regional funds, skills and cross-border public goods alongside trade volumes.\n\nMore intraregional trade alone does not establish welfare gains; evaluate costs, competition and distribution. Trade creation and diversion analysis is HL.\n\nDistinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
      }
    },
    "practice": [
      {
        "id": "u4-20-integration-evaluation-flash-1",
        "knowledgePointId": "u4-20-integration-evaluation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“一体化的动态评价”，并说明一个关键条件。",
          "en": "Explain Dynamic evaluation of integration and state one important condition."
        },
        "answer": {
          "zh-CN": "经济一体化可能增强竞争、投资和规模经济；收益取决于成员差异、制度质量、地区分配和实施条件。",
          "en": "Integration may strengthen competition, investment and scale economies; gains depend on member differences, institutional quality, regional distribution and implementation."
        },
        "explanation": {
          "zh-CN": "更多区域内贸易不充分证明福利提高，还需评价成本、竞争和分配；贸易创造与转移的分析属于 HL。",
          "en": "More intraregional trade alone does not establish welfare gains; evaluate costs, competition and distribution. Trade creation and diversion analysis is HL."
        }
      },
      {
        "id": "u4-20-integration-evaluation-mcq-1",
        "knowledgePointId": "u4-20-integration-evaluation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪项最能支持长期一体化收益？",
          "en": "What most supports long-run integration gains?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "贸易量增加就足够",
            "en": "Higher trade volume alone suffices"
          },
          {
            "id": "b",
            "zh-CN": "永久保护所有低效企业",
            "en": "Permanently protecting every inefficient firm"
          },
          {
            "id": "c",
            "zh-CN": "不需协调制度",
            "en": "No institutional coordination is needed"
          },
          {
            "id": "d",
            "zh-CN": "竞争与技能投资提高生产率",
            "en": "Competition and skill investment raise productivity"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "竞争与技能投资提高生产率。 市场扩大吸引投资；竞争促进生产率；地区集中和政策约束改变分配 更多区域内贸易不充分证明福利提高，还需评价成本、竞争和分配；贸易创造与转移的分析属于 HL。",
          "en": "Competition and skill investment raise productivity. A larger market attracts investment; competition encourages productivity; regional concentration and policy constraints alter distribution More intraregional trade alone does not establish welfare gains; evaluate costs, competition and distribution. Trade creation and diversion analysis is HL."
        }
      },
      {
        "id": "u4-20-integration-evaluation-short-1",
        "knowledgePointId": "u4-20-integration-evaluation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释一体化的动态评价的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Dynamic evaluation of integration and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "经济一体化可能增强竞争、投资和规模经济；收益取决于成员差异、制度质量、地区分配和实施条件。 市场扩大吸引投资；竞争促进生产率；地区集中和政策约束改变分配 原创假设：共同市场吸引汽车投资，但就业集中在港口地区；评估时加入地区基金、技能和跨境公共品，而非只看贸易总额。",
          "en": "Integration may strengthen competition, investment and scale economies; gains depend on member differences, institutional quality, regional distribution and implementation. A larger market attracts investment; competition encourages productivity; regional concentration and policy constraints alter distribution Hypothetical scenario: a common market attracts car investment, concentrated near ports. Evaluate regional funds, skills and cross-border public goods alongside trade volumes."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "投资",
              "en": "investment"
            },
            "alternatives": {
              "zh-CN": [
                "投资",
                "市场扩大吸引投资"
              ],
              "en": [
                "investment",
                "A larger market attracts investment"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "生产率",
              "en": "productivity"
            },
            "alternatives": {
              "zh-CN": [
                "生产率",
                "竞争促进生产率"
              ],
              "en": [
                "productivity",
                "competition encourages productivity"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "分配",
              "en": "distribution"
            },
            "alternatives": {
              "zh-CN": [
                "分配",
                "地区集中和政策约束改变分配"
              ],
              "en": [
                "distribution",
                "regional concentration and policy constraints alter distribution"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-21-floating-exchange-rate",
      "slug": "floating-exchange-rate",
      "section": "4.5",
      "level": "core",
      "syllabusRefs": [
        "4.5 Exchange rates"
      ],
      "textbookRefs": [
        {
          "chapter": "16",
          "section": "16.1",
          "pages": [
            491
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-22-currency-demand-supply",
        "u4-23-exchange-rate-effects",
        "u4-24-fixed-exchange-rate"
      ],
      "terms": [
        "浮动汇率与报价方向",
        "Floating exchange rates and quotation",
        "报价",
        "quotation",
        "需求",
        "demand",
        "升值",
        "appreciation"
      ],
      "synonyms": {
        "zh-CN": [
          "报价",
          "需求",
          "升值"
        ],
        "en": [
          "quotation",
          "demand",
          "appreciation"
        ]
      },
      "diagramIds": [
        "global-currency"
      ],
      "quizIds": [
        "u4-21-floating-exchange-rate-flash-1",
        "u4-21-floating-exchange-rate-mcq-1",
        "u4-21-floating-exchange-rate-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-21-floating-exchange-rate",
        "locale": "zh-CN",
        "title": "浮动汇率与报价方向",
        "takeaway": "汇率是一种货币以另一种货币表示的价格；以美元每本币报价时，数值上升表示本币升值。",
        "definition": "汇率是一种货币以另一种货币表示的价格；以美元每本币报价时，数值上升表示本币升值。",
        "causalChain": [
          "先定义报价单位",
          "外汇需求与供给交点确定汇率",
          "比较同一报价下的新旧价格"
        ],
        "misconceptions": [
          "不先说明分子分母，汇率上升可能被误读；浮动制称升值或贬值。"
        ],
        "examApplication": [
          "先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
        ],
        "summary": [
          "汇率是一种货币以另一种货币表示的价格；以美元每本币报价时，数值上升表示本币升值。",
          "不先说明分子分母，汇率上升可能被误读；浮动制称升值或贬值。"
        ],
        "explanation": "先定义报价单位。外汇需求与供给交点确定汇率。比较同一报价下的新旧价格。\n\n### 原创情境与推导\n\n原创假设：1 本币从 0.50 美元变为 0.60 美元，本币升值 20%；倒数报价从每美元 2 本币变为约 1.67，百分比并不对称。\n\n不先说明分子分母，汇率上升可能被误读；浮动制称升值或贬值。\n\n先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
      },
      "en": {
        "id": "u4-21-floating-exchange-rate",
        "locale": "en",
        "title": "Floating exchange rates and quotation",
        "takeaway": "An exchange rate is one currency's price in another. With dollars per home currency unit, a rise means home-currency appreciation.",
        "definition": "An exchange rate is one currency's price in another. With dollars per home currency unit, a rise means home-currency appreciation.",
        "causalChain": [
          "Define quotation units",
          "currency demand and supply determine equilibrium",
          "compare prices using the same quotation"
        ],
        "misconceptions": [
          "Without stating numerator and denominator, a rising rate can be misread; floating-rate changes are appreciation or depreciation."
        ],
        "examApplication": [
          "State the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
        ],
        "summary": [
          "An exchange rate is one currency's price in another. With dollars per home currency unit, a rise means home-currency appreciation.",
          "Without stating numerator and denominator, a rising rate can be misread; floating-rate changes are appreciation or depreciation."
        ],
        "explanation": "Define quotation units.  currency demand and supply determine equilibrium.  compare prices using the same quotation.\n\n### Original scenario and reasoning\n\nHypothetical scenario: one home unit rises from 0.50 to 0.60 dollars, a 20% appreciation. The inverse falls from two home units per dollar to about 1.67; percentage changes are not symmetric.\n\nWithout stating numerator and denominator, a rising rate can be misread; floating-rate changes are appreciation or depreciation.\n\nState the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
      }
    },
    "practice": [
      {
        "id": "u4-21-floating-exchange-rate-flash-1",
        "knowledgePointId": "u4-21-floating-exchange-rate",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“浮动汇率与报价方向”，并说明一个关键条件。",
          "en": "Explain Floating exchange rates and quotation and state one important condition."
        },
        "answer": {
          "zh-CN": "汇率是一种货币以另一种货币表示的价格；以美元每本币报价时，数值上升表示本币升值。",
          "en": "An exchange rate is one currency's price in another. With dollars per home currency unit, a rise means home-currency appreciation."
        },
        "explanation": {
          "zh-CN": "不先说明分子分母，汇率上升可能被误读；浮动制称升值或贬值。",
          "en": "Without stating numerator and denominator, a rising rate can be misread; floating-rate changes are appreciation or depreciation."
        }
      },
      {
        "id": "u4-21-floating-exchange-rate-mcq-1",
        "knowledgePointId": "u4-21-floating-exchange-rate",
        "type": "mcq",
        "prompt": {
          "zh-CN": "美元每本币从 0.4 到 0.5，发生什么？",
          "en": "Dollars per home unit rise from 0.4 to 0.5. What happens?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "本币升值 25%",
            "en": "Home currency appreciates 25%"
          },
          {
            "id": "b",
            "zh-CN": "本币贬值 25%",
            "en": "Home currency depreciates 25%"
          },
          {
            "id": "c",
            "zh-CN": "本币升值 20%",
            "en": "Home currency appreciates 20%"
          },
          {
            "id": "d",
            "zh-CN": "报价毫无意义",
            "en": "The quotation has no meaning"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "本币升值 25%。 (0.5 − 0.4) / 0.4 × 100 = 25% (USD/home ↑) 不先说明分子分母，汇率上升可能被误读；浮动制称升值或贬值。",
          "en": "Home currency appreciates 25%. (0.5 − 0.4) / 0.4 × 100 = 25% (USD/home ↑) Without stating numerator and denominator, a rising rate can be misread; floating-rate changes are appreciation or depreciation."
        }
      },
      {
        "id": "u4-21-floating-exchange-rate-short-1",
        "knowledgePointId": "u4-21-floating-exchange-rate",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释浮动汇率与报价方向的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Floating exchange rates and quotation and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "汇率是一种货币以另一种货币表示的价格；以美元每本币报价时，数值上升表示本币升值。 先定义报价单位；外汇需求与供给交点确定汇率；比较同一报价下的新旧价格 原创假设：1 本币从 0.50 美元变为 0.60 美元，本币升值 20%；倒数报价从每美元 2 本币变为约 1.67，百分比并不对称。",
          "en": "An exchange rate is one currency's price in another. With dollars per home currency unit, a rise means home-currency appreciation. Define quotation units; currency demand and supply determine equilibrium; compare prices using the same quotation Hypothetical scenario: one home unit rises from 0.50 to 0.60 dollars, a 20% appreciation. The inverse falls from two home units per dollar to about 1.67; percentage changes are not symmetric."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "报价",
              "en": "quotation"
            },
            "alternatives": {
              "zh-CN": [
                "报价",
                "先定义报价单位"
              ],
              "en": [
                "quotation",
                "Define quotation units"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "需求",
              "en": "demand"
            },
            "alternatives": {
              "zh-CN": [
                "需求",
                "外汇需求与供给交点确定汇率"
              ],
              "en": [
                "demand",
                "currency demand and supply determine equilibrium"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "升值",
              "en": "appreciation"
            },
            "alternatives": {
              "zh-CN": [
                "升值",
                "比较同一报价下的新旧价格"
              ],
              "en": [
                "appreciation",
                "compare prices using the same quotation"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-22-currency-demand-supply",
      "slug": "currency-demand-supply",
      "section": "4.5",
      "level": "core",
      "syllabusRefs": [
        "4.5 Exchange rates"
      ],
      "textbookRefs": [
        {
          "chapter": "16",
          "section": "16.1",
          "pages": [
            491
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-21-floating-exchange-rate",
        "u4-23-exchange-rate-effects",
        "u4-24-fixed-exchange-rate"
      ],
      "terms": [
        "外汇需求与供给的决定因素",
        "Determinants of currency demand and supply",
        "出口",
        "exports",
        "资产",
        "assets",
        "需求",
        "demand"
      ],
      "synonyms": {
        "zh-CN": [
          "出口",
          "资产",
          "需求"
        ],
        "en": [
          "exports",
          "assets",
          "demand"
        ]
      },
      "diagramIds": [
        "global-currency"
      ],
      "quizIds": [
        "u4-22-currency-demand-supply-flash-1",
        "u4-22-currency-demand-supply-mcq-1",
        "u4-22-currency-demand-supply-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-22-currency-demand-supply",
        "locale": "zh-CN",
        "title": "外汇需求与供给的决定因素",
        "takeaway": "外国购买本国出口和资产形成对本币需求；本国购买进口和外国资产形成本币供给。",
        "definition": "外国购买本国出口和资产形成对本币需求；本国购买进口和外国资产形成本币供给。",
        "causalChain": [
          "外国需求或相对回报改变",
          "本币需求或供给移动",
          "浮动汇率调整"
        ],
        "misconceptions": [
          "利率与汇率关系有条件；投机、通胀预期和资本限制也会改变资金流。"
        ],
        "examApplication": [
          "先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
        ],
        "summary": [
          "外国购买本国出口和资产形成对本币需求；本国购买进口和外国资产形成本币供给。",
          "利率与汇率关系有条件；投机、通胀预期和资本限制也会改变资金流。"
        ],
        "explanation": "外国需求或相对回报改变。本币需求或供给移动。浮动汇率调整。\n\n### 原创情境与推导\n\n原创假设：在风险与预期不变时，本国利率相对上升吸引资产购买，本币需求增加，可能升值；风险溢价上升可抵消此效应。\n\n利率与汇率关系有条件；投机、通胀预期和资本限制也会改变资金流。\n\n先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
      },
      "en": {
        "id": "u4-22-currency-demand-supply",
        "locale": "en",
        "title": "Determinants of currency demand and supply",
        "takeaway": "Foreign purchases of home exports and assets create demand for home currency; home purchases of imports and foreign assets create its supply.",
        "definition": "Foreign purchases of home exports and assets create demand for home currency; home purchases of imports and foreign assets create its supply.",
        "causalChain": [
          "Foreign demand or relative returns change",
          "home-currency demand or supply shifts",
          "the floating rate adjusts"
        ],
        "misconceptions": [
          "The interest-rate link is conditional; speculation, inflation expectations and capital restrictions also affect flows."
        ],
        "examApplication": [
          "State the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
        ],
        "summary": [
          "Foreign purchases of home exports and assets create demand for home currency; home purchases of imports and foreign assets create its supply.",
          "The interest-rate link is conditional; speculation, inflation expectations and capital restrictions also affect flows."
        ],
        "explanation": "Foreign demand or relative returns change.  home-currency demand or supply shifts.  the floating rate adjusts.\n\n### Original scenario and reasoning\n\nHypothetical scenario: holding risk and expectations constant, a higher relative home interest rate attracts asset purchases and can appreciate the currency. A rising risk premium may offset this.\n\nThe interest-rate link is conditional; speculation, inflation expectations and capital restrictions also affect flows.\n\nState the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
      }
    },
    "practice": [
      {
        "id": "u4-22-currency-demand-supply-flash-1",
        "knowledgePointId": "u4-22-currency-demand-supply",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“外汇需求与供给的决定因素”，并说明一个关键条件。",
          "en": "Explain Determinants of currency demand and supply and state one important condition."
        },
        "answer": {
          "zh-CN": "外国购买本国出口和资产形成对本币需求；本国购买进口和外国资产形成本币供给。",
          "en": "Foreign purchases of home exports and assets create demand for home currency; home purchases of imports and foreign assets create its supply."
        },
        "explanation": {
          "zh-CN": "利率与汇率关系有条件；投机、通胀预期和资本限制也会改变资金流。",
          "en": "The interest-rate link is conditional; speculation, inflation expectations and capital restrictions also affect flows."
        }
      },
      {
        "id": "u4-22-currency-demand-supply-mcq-1",
        "knowledgePointId": "u4-22-currency-demand-supply",
        "type": "mcq",
        "prompt": {
          "zh-CN": "其他条件不变，外国更想购买本国资产会怎样？",
          "en": "Other things equal, what follows greater foreign demand for home assets?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "本币需求必左移",
            "en": "Currency demand must shift left"
          },
          {
            "id": "b",
            "zh-CN": "本币需求右移",
            "en": "Demand for home currency shifts right"
          },
          {
            "id": "c",
            "zh-CN": "进口自动为零",
            "en": "Imports automatically become zero"
          },
          {
            "id": "d",
            "zh-CN": "汇率必不变",
            "en": "The rate cannot change"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "本币需求右移。 外国需求或相对回报改变；本币需求或供给移动；浮动汇率调整 利率与汇率关系有条件；投机、通胀预期和资本限制也会改变资金流。",
          "en": "Demand for home currency shifts right. Foreign demand or relative returns change; home-currency demand or supply shifts; the floating rate adjusts The interest-rate link is conditional; speculation, inflation expectations and capital restrictions also affect flows."
        }
      },
      {
        "id": "u4-22-currency-demand-supply-short-1",
        "knowledgePointId": "u4-22-currency-demand-supply",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释外汇需求与供给的决定因素的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Determinants of currency demand and supply and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "外国购买本国出口和资产形成对本币需求；本国购买进口和外国资产形成本币供给。 外国需求或相对回报改变；本币需求或供给移动；浮动汇率调整 原创假设：在风险与预期不变时，本国利率相对上升吸引资产购买，本币需求增加，可能升值；风险溢价上升可抵消此效应。",
          "en": "Foreign purchases of home exports and assets create demand for home currency; home purchases of imports and foreign assets create its supply. Foreign demand or relative returns change; home-currency demand or supply shifts; the floating rate adjusts Hypothetical scenario: holding risk and expectations constant, a higher relative home interest rate attracts asset purchases and can appreciate the currency. A rising risk premium may offset this."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "出口",
              "en": "exports"
            },
            "alternatives": {
              "zh-CN": [
                "出口",
                "外国需求或相对回报改变"
              ],
              "en": [
                "exports",
                "Foreign demand or relative returns change"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "资产",
              "en": "assets"
            },
            "alternatives": {
              "zh-CN": [
                "资产",
                "本币需求或供给移动"
              ],
              "en": [
                "assets",
                "home-currency demand or supply shifts"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "需求",
              "en": "demand"
            },
            "alternatives": {
              "zh-CN": [
                "需求",
                "浮动汇率调整"
              ],
              "en": [
                "demand",
                "the floating rate adjusts"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-23-exchange-rate-effects",
      "slug": "exchange-rate-effects",
      "section": "4.5",
      "level": "core",
      "syllabusRefs": [
        "4.5 Exchange rates"
      ],
      "textbookRefs": [
        {
          "chapter": "16",
          "section": "16.2",
          "pages": [
            500
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-21-floating-exchange-rate",
        "u4-22-currency-demand-supply",
        "u4-24-fixed-exchange-rate"
      ],
      "terms": [
        "升贬值的经济影响",
        "Effects of appreciation and depreciation",
        "贬值",
        "depreciation",
        "进口成本",
        "import costs",
        "弹性",
        "elasticities"
      ],
      "synonyms": {
        "zh-CN": [
          "贬值",
          "进口成本",
          "弹性"
        ],
        "en": [
          "depreciation",
          "import costs",
          "elasticities"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-23-exchange-rate-effects-flash-1",
        "u4-23-exchange-rate-effects-mcq-1",
        "u4-23-exchange-rate-effects-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-23-exchange-rate-effects",
        "locale": "zh-CN",
        "title": "升贬值的经济影响",
        "takeaway": "本币贬值可降低出口外币价格并提高进口本币价格，但净出口、通胀和增长效果取决于弹性、传导与产能。",
        "definition": "本币贬值可降低出口外币价格并提高进口本币价格，但净出口、通胀和增长效果取决于弹性、传导与产能。",
        "causalChain": [
          "本币贬值改变相对价格",
          "出口与进口数量逐步调整",
          "净出口和进口成本共同影响 AD 与 AS"
        ],
        "misconceptions": [
          "贬值不保证贸易余额改善，也可能提高外币债务的本币负担。"
        ],
        "examApplication": [
          "先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
        ],
        "summary": [
          "本币贬值可降低出口外币价格并提高进口本币价格，但净出口、通胀和增长效果取决于弹性、传导与产能。",
          "贬值不保证贸易余额改善，也可能提高外币债务的本币负担。"
        ],
        "explanation": "本币贬值改变相对价格。出口与进口数量逐步调整。净出口和进口成本共同影响 AD 与 AS。\n\n### 原创情境与推导\n\n原创假设：依赖进口燃料的企业成本上升，可能左移 SRAS；同时出口订单增加可右移 AD，不能只看一个渠道。\n\n贬值不保证贸易余额改善，也可能提高外币债务的本币负担。\n\n先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
      },
      "en": {
        "id": "u4-23-exchange-rate-effects",
        "locale": "en",
        "title": "Effects of appreciation and depreciation",
        "takeaway": "Depreciation can lower foreign-currency export prices and raise home-currency import prices, while net exports, inflation and growth depend on elasticities, pass-through and capacity.",
        "definition": "Depreciation can lower foreign-currency export prices and raise home-currency import prices, while net exports, inflation and growth depend on elasticities, pass-through and capacity.",
        "causalChain": [
          "Depreciation changes relative prices",
          "export and import volumes adjust gradually",
          "net exports and import costs affect AD and AS"
        ],
        "misconceptions": [
          "Depreciation does not guarantee a better trade balance and can raise the home-currency burden of foreign-currency debt."
        ],
        "examApplication": [
          "State the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
        ],
        "summary": [
          "Depreciation can lower foreign-currency export prices and raise home-currency import prices, while net exports, inflation and growth depend on elasticities, pass-through and capacity.",
          "Depreciation does not guarantee a better trade balance and can raise the home-currency burden of foreign-currency debt."
        ],
        "explanation": "Depreciation changes relative prices.  export and import volumes adjust gradually.  net exports and import costs affect AD and AS.\n\n### Original scenario and reasoning\n\nHypothetical scenario: imported fuel becomes dearer, potentially shifting SRAS left, while more export orders may shift AD right. Both channels matter.\n\nDepreciation does not guarantee a better trade balance and can raise the home-currency burden of foreign-currency debt.\n\nState the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
      }
    },
    "practice": [
      {
        "id": "u4-23-exchange-rate-effects-flash-1",
        "knowledgePointId": "u4-23-exchange-rate-effects",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“升贬值的经济影响”，并说明一个关键条件。",
          "en": "Explain Effects of appreciation and depreciation and state one important condition."
        },
        "answer": {
          "zh-CN": "本币贬值可降低出口外币价格并提高进口本币价格，但净出口、通胀和增长效果取决于弹性、传导与产能。",
          "en": "Depreciation can lower foreign-currency export prices and raise home-currency import prices, while net exports, inflation and growth depend on elasticities, pass-through and capacity."
        },
        "explanation": {
          "zh-CN": "贬值不保证贸易余额改善，也可能提高外币债务的本币负担。",
          "en": "Depreciation does not guarantee a better trade balance and can raise the home-currency burden of foreign-currency debt."
        }
      },
      {
        "id": "u4-23-exchange-rate-effects-mcq-1",
        "knowledgePointId": "u4-23-exchange-rate-effects",
        "type": "mcq",
        "prompt": {
          "zh-CN": "本币贬值对外币债务可能有何影响？",
          "en": "What can depreciation do to foreign-currency debt?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "自动取消债务",
            "en": "Automatically cancel it"
          },
          {
            "id": "b",
            "zh-CN": "必使进口燃料变便宜",
            "en": "Necessarily cheapen imported fuel"
          },
          {
            "id": "c",
            "zh-CN": "增加本币偿债负担",
            "en": "Increase its home-currency repayment burden"
          },
          {
            "id": "d",
            "zh-CN": "必消除通胀",
            "en": "Necessarily remove inflation"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "增加本币偿债负担。 本币贬值改变相对价格；出口与进口数量逐步调整；净出口和进口成本共同影响 AD 与 AS 贬值不保证贸易余额改善，也可能提高外币债务的本币负担。",
          "en": "Increase its home-currency repayment burden. Depreciation changes relative prices; export and import volumes adjust gradually; net exports and import costs affect AD and AS Depreciation does not guarantee a better trade balance and can raise the home-currency burden of foreign-currency debt."
        }
      },
      {
        "id": "u4-23-exchange-rate-effects-short-1",
        "knowledgePointId": "u4-23-exchange-rate-effects",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释升贬值的经济影响的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Effects of appreciation and depreciation and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "本币贬值可降低出口外币价格并提高进口本币价格，但净出口、通胀和增长效果取决于弹性、传导与产能。 本币贬值改变相对价格；出口与进口数量逐步调整；净出口和进口成本共同影响 AD 与 AS 原创假设：依赖进口燃料的企业成本上升，可能左移 SRAS；同时出口订单增加可右移 AD，不能只看一个渠道。",
          "en": "Depreciation can lower foreign-currency export prices and raise home-currency import prices, while net exports, inflation and growth depend on elasticities, pass-through and capacity. Depreciation changes relative prices; export and import volumes adjust gradually; net exports and import costs affect AD and AS Hypothetical scenario: imported fuel becomes dearer, potentially shifting SRAS left, while more export orders may shift AD right. Both channels matter."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "贬值",
              "en": "depreciation"
            },
            "alternatives": {
              "zh-CN": [
                "贬值",
                "本币贬值改变相对价格"
              ],
              "en": [
                "depreciation",
                "Depreciation changes relative prices"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "进口成本",
              "en": "import costs"
            },
            "alternatives": {
              "zh-CN": [
                "进口成本",
                "出口与进口数量逐步调整"
              ],
              "en": [
                "import costs",
                "export and import volumes adjust gradually"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "弹性",
              "en": "elasticities"
            },
            "alternatives": {
              "zh-CN": [
                "弹性",
                "净出口和进口成本共同影响 AD 与 AS"
              ],
              "en": [
                "elasticities",
                "net exports and import costs affect AD and AS"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-24-fixed-exchange-rate",
      "slug": "fixed-exchange-rate",
      "section": "4.5",
      "level": "core",
      "syllabusRefs": [
        "4.5 Exchange rates"
      ],
      "textbookRefs": [
        {
          "chapter": "16",
          "section": "16.3",
          "pages": [
            504
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-21-floating-exchange-rate",
        "u4-22-currency-demand-supply",
        "u4-23-exchange-rate-effects"
      ],
      "terms": [
        "固定汇率与储备干预",
        "Fixed exchange rates and reserve intervention",
        "平价",
        "parity",
        "储备",
        "reserves",
        "买本币",
        "buy home currency"
      ],
      "synonyms": {
        "zh-CN": [
          "平价",
          "储备",
          "买本币"
        ],
        "en": [
          "parity",
          "reserves",
          "buy home currency"
        ]
      },
      "diagramIds": [
        "audit-fixed-rate"
      ],
      "quizIds": [
        "u4-24-fixed-exchange-rate-flash-1",
        "u4-24-fixed-exchange-rate-mcq-1",
        "u4-24-fixed-exchange-rate-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-24-fixed-exchange-rate",
        "locale": "zh-CN",
        "title": "固定汇率与储备干预",
        "takeaway": "固定汇率由当局维持目标平价；本币面临贬值压力时，央行可卖外汇储备买本币，但储备有限。",
        "definition": "固定汇率由当局维持目标平价；本币面临贬值压力时，央行可卖外汇储备买本币，但储备有限。",
        "causalChain": [
          "市场汇率低于目标",
          "央行买本币增加需求",
          "外汇储备下降以支持平价"
        ],
        "misconceptions": [
          "官方下调固定平价称法定贬值；这不同于浮动市场的贬值。"
        ],
        "examApplication": [
          "先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
        ],
        "summary": [
          "固定汇率由当局维持目标平价；本币面临贬值压力时，央行可卖外汇储备买本币，但储备有限。",
          "官方下调固定平价称法定贬值；这不同于浮动市场的贬值。"
        ],
        "explanation": "市场汇率低于目标。央行买本币增加需求。外汇储备下降以支持平价。\n\n### 原创情境与推导\n\n原创假设：目标 1 本币=0.5 美元，市场需求下滑；卖美元买本币可支持目标，持续干预可能需要加息或政策调整。\n\n官方下调固定平价称法定贬值；这不同于浮动市场的贬值。\n\n先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
      },
      "en": {
        "id": "u4-24-fixed-exchange-rate",
        "locale": "en",
        "title": "Fixed exchange rates and reserve intervention",
        "takeaway": "Authorities maintain a target parity in a fixed regime. Under downward pressure they can sell foreign reserves and buy home currency, but reserves are finite.",
        "definition": "Authorities maintain a target parity in a fixed regime. Under downward pressure they can sell foreign reserves and buy home currency, but reserves are finite.",
        "causalChain": [
          "The market rate falls below parity",
          "central-bank home-currency purchases add demand",
          "foreign reserves decline to defend the peg"
        ],
        "misconceptions": [
          "An official reduction of fixed parity is devaluation, distinct from market depreciation."
        ],
        "examApplication": [
          "State the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
        ],
        "summary": [
          "Authorities maintain a target parity in a fixed regime. Under downward pressure they can sell foreign reserves and buy home currency, but reserves are finite.",
          "An official reduction of fixed parity is devaluation, distinct from market depreciation."
        ],
        "explanation": "The market rate falls below parity.  central-bank home-currency purchases add demand.  foreign reserves decline to defend the peg.\n\n### Original scenario and reasoning\n\nHypothetical scenario: the target is 0.5 dollars per home unit and demand falls. Selling dollars to buy home currency supports the target; sustained pressure may require higher rates or policy adjustment.\n\nAn official reduction of fixed parity is devaluation, distinct from market depreciation.\n\nState the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
      }
    },
    "practice": [
      {
        "id": "u4-24-fixed-exchange-rate-flash-1",
        "knowledgePointId": "u4-24-fixed-exchange-rate",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“固定汇率与储备干预”，并说明一个关键条件。",
          "en": "Explain Fixed exchange rates and reserve intervention and state one important condition."
        },
        "answer": {
          "zh-CN": "固定汇率由当局维持目标平价；本币面临贬值压力时，央行可卖外汇储备买本币，但储备有限。",
          "en": "Authorities maintain a target parity in a fixed regime. Under downward pressure they can sell foreign reserves and buy home currency, but reserves are finite."
        },
        "explanation": {
          "zh-CN": "官方下调固定平价称法定贬值；这不同于浮动市场的贬值。",
          "en": "An official reduction of fixed parity is devaluation, distinct from market depreciation."
        }
      },
      {
        "id": "u4-24-fixed-exchange-rate-mcq-1",
        "knowledgePointId": "u4-24-fixed-exchange-rate",
        "type": "mcq",
        "prompt": {
          "zh-CN": "如何用储备抵抗本币贬值压力？",
          "en": "How can reserves resist downward pressure on home currency?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "卖本币买外币",
            "en": "Sell home currency and buy foreign currency"
          },
          {
            "id": "b",
            "zh-CN": "完全不交易且保证平价",
            "en": "Never trade yet guarantee parity"
          },
          {
            "id": "c",
            "zh-CN": "印本币必提高其价格",
            "en": "Print home currency to necessarily raise its price"
          },
          {
            "id": "d",
            "zh-CN": "卖外币买本币",
            "en": "Sell foreign currency and buy home currency"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "卖外币买本币。 市场汇率低于目标；央行买本币增加需求；外汇储备下降以支持平价 官方下调固定平价称法定贬值；这不同于浮动市场的贬值。",
          "en": "Sell foreign currency and buy home currency. The market rate falls below parity; central-bank home-currency purchases add demand; foreign reserves decline to defend the peg An official reduction of fixed parity is devaluation, distinct from market depreciation."
        }
      },
      {
        "id": "u4-24-fixed-exchange-rate-short-1",
        "knowledgePointId": "u4-24-fixed-exchange-rate",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释固定汇率与储备干预的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Fixed exchange rates and reserve intervention and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "固定汇率由当局维持目标平价；本币面临贬值压力时，央行可卖外汇储备买本币，但储备有限。 市场汇率低于目标；央行买本币增加需求；外汇储备下降以支持平价 原创假设：目标 1 本币=0.5 美元，市场需求下滑；卖美元买本币可支持目标，持续干预可能需要加息或政策调整。",
          "en": "Authorities maintain a target parity in a fixed regime. Under downward pressure they can sell foreign reserves and buy home currency, but reserves are finite. The market rate falls below parity; central-bank home-currency purchases add demand; foreign reserves decline to defend the peg Hypothetical scenario: the target is 0.5 dollars per home unit and demand falls. Selling dollars to buy home currency supports the target; sustained pressure may require higher rates or policy adjustment."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "平价",
              "en": "parity"
            },
            "alternatives": {
              "zh-CN": [
                "平价",
                "市场汇率低于目标"
              ],
              "en": [
                "parity",
                "The market rate falls below parity"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "储备",
              "en": "reserves"
            },
            "alternatives": {
              "zh-CN": [
                "储备",
                "央行买本币增加需求"
              ],
              "en": [
                "reserves",
                "central-bank home-currency purchases add demand"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "买本币",
              "en": "buy home currency"
            },
            "alternatives": {
              "zh-CN": [
                "买本币",
                "外汇储备下降以支持平价"
              ],
              "en": [
                "buy home currency",
                "foreign reserves decline to defend the peg"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-25-managed-exchange-rate",
      "slug": "managed-exchange-rate",
      "section": "4.5",
      "level": "core",
      "syllabusRefs": [
        "4.5 Exchange rates"
      ],
      "textbookRefs": [
        {
          "chapter": "16",
          "section": "16.3",
          "pages": [
            504
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-21-floating-exchange-rate",
        "u4-22-currency-demand-supply",
        "u4-23-exchange-rate-effects"
      ],
      "terms": [
        "管理浮动与干预",
        "Managed exchange rates and intervention",
        "市场",
        "market",
        "干预",
        "intervention",
        "自主性",
        "autonomy"
      ],
      "synonyms": {
        "zh-CN": [
          "市场",
          "干预",
          "自主性"
        ],
        "en": [
          "market",
          "intervention",
          "autonomy"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-25-managed-exchange-rate-flash-1",
        "u4-25-managed-exchange-rate-mcq-1",
        "u4-25-managed-exchange-rate-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-25-managed-exchange-rate",
        "locale": "zh-CN",
        "title": "管理浮动与干预",
        "takeaway": "管理浮动允许市场定价并由当局选择性干预；相对于维持目标或基本面基准，货币可被视为高估或低估。不同制度的优劣比较属于 HL。",
        "definition": "管理浮动允许市场定价并由当局选择性干预；相对于维持目标或基本面基准，货币可被视为高估或低估。不同制度的优劣比较属于 HL。",
        "causalChain": [
          "市场冲击引起波动",
          "当局选择性干预",
          "汇率风险与政策成本重新分配"
        ],
        "misconceptions": [
          "固定并非永久稳定，浮动也非完全无干预；应说明实际制度与条件。"
        ],
        "examApplication": [
          "先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
        ],
        "summary": [
          "管理浮动允许市场定价并由当局选择性干预；相对于维持目标或基本面基准，货币可被视为高估或低估。不同制度的优劣比较属于 HL。",
          "固定并非永久稳定，浮动也非完全无干预；应说明实际制度与条件。"
        ],
        "explanation": "市场冲击引起波动。当局选择性干预。汇率风险与政策成本重新分配。\n\n### 原创情境与推导\n\n原创假设：本币面临升值，当局卖本币买外币可限制升幅并增加储备；面对贬值压力则可反向操作，但储备有限。高估和低估均须说明比较基准。\n\n固定并非永久稳定，浮动也非完全无干预；应说明实际制度与条件。\n\n先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
      },
      "en": {
        "id": "u4-25-managed-exchange-rate",
        "locale": "en",
        "title": "Managed exchange rates and intervention",
        "takeaway": "Managed floating combines market determination with selective intervention; a currency can be overvalued or undervalued relative to a target or fundamentals benchmark. Comparing regime advantages and disadvantages is HL.",
        "definition": "Managed floating combines market determination with selective intervention; a currency can be overvalued or undervalued relative to a target or fundamentals benchmark. Comparing regime advantages and disadvantages is HL.",
        "causalChain": [
          "Market shocks create volatility",
          "authorities intervene selectively",
          "exchange risk and policy costs are redistributed"
        ],
        "misconceptions": [
          "Fixed does not mean permanently stable, nor floating entirely intervention-free; specify the actual regime and conditions."
        ],
        "examApplication": [
          "State the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
        ],
        "summary": [
          "Managed floating combines market determination with selective intervention; a currency can be overvalued or undervalued relative to a target or fundamentals benchmark. Comparing regime advantages and disadvantages is HL.",
          "Fixed does not mean permanently stable, nor floating entirely intervention-free; specify the actual regime and conditions."
        ],
        "explanation": "Market shocks create volatility.  authorities intervene selectively.  exchange risk and policy costs are redistributed.\n\n### Original scenario and reasoning\n\nHypothetical scenario: selling home currency for foreign currency can limit appreciation and build reserves; reverse intervention can resist depreciation but uses finite reserves. Overvaluation and undervaluation require an explicit benchmark.\n\nFixed does not mean permanently stable, nor floating entirely intervention-free; specify the actual regime and conditions.\n\nState the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
      }
    },
    "practice": [
      {
        "id": "u4-25-managed-exchange-rate-flash-1",
        "knowledgePointId": "u4-25-managed-exchange-rate",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“管理浮动与干预”，并说明一个关键条件。",
          "en": "Explain Managed exchange rates and intervention and state one important condition."
        },
        "answer": {
          "zh-CN": "管理浮动允许市场定价并由当局选择性干预；相对于维持目标或基本面基准，货币可被视为高估或低估。不同制度的优劣比较属于 HL。",
          "en": "Managed floating combines market determination with selective intervention; a currency can be overvalued or undervalued relative to a target or fundamentals benchmark. Comparing regime advantages and disadvantages is HL."
        },
        "explanation": {
          "zh-CN": "固定并非永久稳定，浮动也非完全无干预；应说明实际制度与条件。",
          "en": "Fixed does not mean permanently stable, nor floating entirely intervention-free; specify the actual regime and conditions."
        }
      },
      {
        "id": "u4-25-managed-exchange-rate-mcq-1",
        "knowledgePointId": "u4-25-managed-exchange-rate",
        "type": "mcq",
        "prompt": {
          "zh-CN": "管理浮动最符合哪种描述？",
          "en": "Which description fits managed floating?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "市场定价加选择性干预",
            "en": "Market pricing with selective intervention"
          },
          {
            "id": "b",
            "zh-CN": "永远固定同一平价",
            "en": "Always one fixed parity"
          },
          {
            "id": "c",
            "zh-CN": "完全禁止外汇交易",
            "en": "All currency trading banned"
          },
          {
            "id": "d",
            "zh-CN": "自动加入货币联盟",
            "en": "Automatic monetary-union membership"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "市场定价加选择性干预。 市场冲击引起波动；当局选择性干预；汇率风险与政策成本重新分配 固定并非永久稳定，浮动也非完全无干预；应说明实际制度与条件。",
          "en": "Market pricing with selective intervention. Market shocks create volatility; authorities intervene selectively; exchange risk and policy costs are redistributed Fixed does not mean permanently stable, nor floating entirely intervention-free; specify the actual regime and conditions."
        }
      },
      {
        "id": "u4-25-managed-exchange-rate-short-1",
        "knowledgePointId": "u4-25-managed-exchange-rate",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释管理浮动与干预的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Managed exchange rates and intervention and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "管理浮动允许市场定价并由当局选择性干预；相对于维持目标或基本面基准，货币可被视为高估或低估。不同制度的优劣比较属于 HL。 市场冲击引起波动；当局选择性干预；汇率风险与政策成本重新分配 原创假设：本币面临升值，当局卖本币买外币可限制升幅并增加储备；面对贬值压力则可反向操作，但储备有限。高估和低估均须说明比较基准。",
          "en": "Managed floating combines market determination with selective intervention; a currency can be overvalued or undervalued relative to a target or fundamentals benchmark. Comparing regime advantages and disadvantages is HL. Market shocks create volatility; authorities intervene selectively; exchange risk and policy costs are redistributed Hypothetical scenario: selling home currency for foreign currency can limit appreciation and build reserves; reverse intervention can resist depreciation but uses finite reserves. Overvaluation and undervaluation require an explicit benchmark."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "市场",
              "en": "market"
            },
            "alternatives": {
              "zh-CN": [
                "市场",
                "市场冲击引起波动"
              ],
              "en": [
                "market",
                "Market shocks create volatility"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "干预",
              "en": "intervention"
            },
            "alternatives": {
              "zh-CN": [
                "干预",
                "当局选择性干预"
              ],
              "en": [
                "intervention",
                "authorities intervene selectively"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "自主性",
              "en": "autonomy"
            },
            "alternatives": {
              "zh-CN": [
                "自主性",
                "汇率风险与政策成本重新分配"
              ],
              "en": [
                "autonomy",
                "exchange risk and policy costs are redistributed"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-26-exchange-calculations",
      "slug": "exchange-calculations",
      "section": "4.5",
      "level": "core",
      "syllabusRefs": [
        "4.5 Exchange rates"
      ],
      "textbookRefs": [
        {
          "chapter": "16",
          "section": "16.1",
          "pages": [
            491
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-21-floating-exchange-rate",
        "u4-22-currency-demand-supply",
        "u4-23-exchange-rate-effects"
      ],
      "terms": [
        "汇率换算与百分比",
        "Currency conversion and percentage changes",
        "单位",
        "units",
        "换算",
        "conversion",
        "初始",
        "initial"
      ],
      "synonyms": {
        "zh-CN": [
          "单位",
          "换算",
          "初始"
        ],
        "en": [
          "units",
          "conversion",
          "initial"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-26-exchange-calculations-flash-1",
        "u4-26-exchange-calculations-mcq-1",
        "u4-26-exchange-calculations-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-26-exchange-calculations",
        "locale": "zh-CN",
        "title": "汇率换算与百分比",
        "takeaway": "按报价单位相乘或相除完成换算；百分比变动以初始汇率为分母，倒数报价须重新计算。",
        "definition": "按报价单位相乘或相除完成换算；百分比变动以初始汇率为分母，倒数报价须重新计算。",
        "causalChain": [
          "写清金额单位",
          "使换算单位约去",
          "用新减旧除以旧计算变动"
        ],
        "misconceptions": [
          "进口账单变化可能还含数量与外币价格变化；应控制条件。"
        ],
        "examApplication": [
          "先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
        ],
        "summary": [
          "按报价单位相乘或相除完成换算；百分比变动以初始汇率为分母，倒数报价须重新计算。",
          "进口账单变化可能还含数量与外币价格变化；应控制条件。"
        ],
        "explanation": "写清金额单位。使换算单位约去。用新减旧除以旧计算变动。\n\n### 原创情境与推导\n\n原创假设：每美元 8 本币，240 本币可换 30 美元；变为每美元 10 本币，同额只能换 24 美元。本币的美元价值下降 20%，不是 25%。\n\n进口账单变化可能还含数量与外币价格变化；应控制条件。\n\n先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
      },
      "en": {
        "id": "u4-26-exchange-calculations",
        "locale": "en",
        "title": "Currency conversion and percentage changes",
        "takeaway": "Convert by multiplying or dividing according to units. Percentage changes use the initial rate; inverse quotations need a separate calculation.",
        "definition": "Convert by multiplying or dividing according to units. Percentage changes use the initial rate; inverse quotations need a separate calculation.",
        "causalChain": [
          "Write amount units",
          "cancel units in conversion",
          "calculate change as new minus old divided by old"
        ],
        "misconceptions": [
          "An import bill can also change with quantity and foreign price; hold these conditions constant."
        ],
        "examApplication": [
          "State the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
        ],
        "summary": [
          "Convert by multiplying or dividing according to units. Percentage changes use the initial rate; inverse quotations need a separate calculation.",
          "An import bill can also change with quantity and foreign price; hold these conditions constant."
        ],
        "explanation": "Write amount units.  cancel units in conversion.  calculate change as new minus old divided by old.\n\n### Original scenario and reasoning\n\nHypothetical scenario: at eight home units per dollar, 240 home units buy thirty dollars; at ten, they buy twenty-four. The home currency's dollar value falls 20%, not 25%.\n\nAn import bill can also change with quantity and foreign price; hold these conditions constant.\n\nState the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
      }
    },
    "practice": [
      {
        "id": "u4-26-exchange-calculations-flash-1",
        "knowledgePointId": "u4-26-exchange-calculations",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“汇率换算与百分比”，并说明一个关键条件。",
          "en": "Explain Currency conversion and percentage changes and state one important condition."
        },
        "answer": {
          "zh-CN": "按报价单位相乘或相除完成换算；百分比变动以初始汇率为分母，倒数报价须重新计算。",
          "en": "Convert by multiplying or dividing according to units. Percentage changes use the initial rate; inverse quotations need a separate calculation."
        },
        "explanation": {
          "zh-CN": "进口账单变化可能还含数量与外币价格变化；应控制条件。",
          "en": "An import bill can also change with quantity and foreign price; hold these conditions constant."
        }
      },
      {
        "id": "u4-26-exchange-calculations-mcq-1",
        "knowledgePointId": "u4-26-exchange-calculations",
        "type": "mcq",
        "prompt": {
          "zh-CN": "每美元 5 本币，100 本币换多少美元？",
          "en": "At five home units per dollar, how many dollars do 100 home units buy?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "500 美元",
            "en": "Five hundred dollars"
          },
          {
            "id": "b",
            "zh-CN": "20 美元",
            "en": "Twenty dollars"
          },
          {
            "id": "c",
            "zh-CN": "95 美元",
            "en": "Ninety-five dollars"
          },
          {
            "id": "d",
            "zh-CN": "105 美元",
            "en": "One hundred and five dollars"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "20 美元。 100 / 5 = 20 USD 进口账单变化可能还含数量与外币价格变化；应控制条件。",
          "en": "Twenty dollars. 100 / 5 = 20 USD An import bill can also change with quantity and foreign price; hold these conditions constant."
        }
      },
      {
        "id": "u4-26-exchange-calculations-short-1",
        "knowledgePointId": "u4-26-exchange-calculations",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释汇率换算与百分比的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Currency conversion and percentage changes and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "按报价单位相乘或相除完成换算；百分比变动以初始汇率为分母，倒数报价须重新计算。 写清金额单位；使换算单位约去；用新减旧除以旧计算变动 原创假设：每美元 8 本币，240 本币可换 30 美元；变为每美元 10 本币，同额只能换 24 美元。本币的美元价值下降 20%，不是 25%。",
          "en": "Convert by multiplying or dividing according to units. Percentage changes use the initial rate; inverse quotations need a separate calculation. Write amount units; cancel units in conversion; calculate change as new minus old divided by old Hypothetical scenario: at eight home units per dollar, 240 home units buy thirty dollars; at ten, they buy twenty-four. The home currency's dollar value falls 20%, not 25%."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "单位",
              "en": "units"
            },
            "alternatives": {
              "zh-CN": [
                "单位",
                "写清金额单位"
              ],
              "en": [
                "units",
                "Write amount units"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "换算",
              "en": "conversion"
            },
            "alternatives": {
              "zh-CN": [
                "换算",
                "使换算单位约去"
              ],
              "en": [
                "conversion",
                "cancel units in conversion"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "初始",
              "en": "initial"
            },
            "alternatives": {
              "zh-CN": [
                "初始",
                "用新减旧除以旧计算变动"
              ],
              "en": [
                "initial",
                "calculate change as new minus old divided by old"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-27-exchange-policy-trilemma",
      "slug": "exchange-policy-trilemma",
      "section": "4.5",
      "level": "hl",
      "syllabusRefs": [
        "4.5 Exchange rates"
      ],
      "textbookRefs": [
        {
          "chapter": "17",
          "section": "17.2",
          "pages": [
            523
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-21-floating-exchange-rate",
        "u4-22-currency-demand-supply",
        "u4-23-exchange-rate-effects"
      ],
      "terms": [
        "汇率制度与政策约束",
        "Exchange regimes and policy constraints",
        "资本流动",
        "capital mobility",
        "固定汇率",
        "fixed exchange rate",
        "货币政策",
        "monetary policy"
      ],
      "synonyms": {
        "zh-CN": [
          "资本流动",
          "固定汇率",
          "货币政策"
        ],
        "en": [
          "capital mobility",
          "fixed exchange rate",
          "monetary policy"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-27-exchange-policy-trilemma-flash-1",
        "u4-27-exchange-policy-trilemma-mcq-1",
        "u4-27-exchange-policy-trilemma-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-27-exchange-policy-trilemma",
        "locale": "zh-CN",
        "title": "汇率制度与政策约束",
        "takeaway": "资本自由流动下，固定汇率约束独立货币政策；利差会引发资金流并迫使当局干预或调整政策。",
        "definition": "资本自由流动下，固定汇率约束独立货币政策；利差会引发资金流并迫使当局干预或调整政策。",
        "causalChain": [
          "独立降息降低相对回报",
          "资本流出增加贬值压力",
          "捍卫固定汇率限制降息空间"
        ],
        "misconceptions": [
          "该约束依赖资本流动、风险与可信度，不表示所有国家任何时刻利率完全相同。"
        ],
        "examApplication": [
          "先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
        ],
        "summary": [
          "资本自由流动下，固定汇率约束独立货币政策；利差会引发资金流并迫使当局干预或调整政策。",
          "该约束依赖资本流动、风险与可信度，不表示所有国家任何时刻利率完全相同。"
        ],
        "explanation": "独立降息降低相对回报。资本流出增加贬值压力。捍卫固定汇率限制降息空间。\n\n### 原创情境与推导\n\n原创假设：一国希望降息刺激就业，又维持平价且允许资本自由流动；持续资本外流暴露三目标难以同时保持。\n\n该约束依赖资本流动、风险与可信度，不表示所有国家任何时刻利率完全相同。\n\n先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
      },
      "en": {
        "id": "u4-27-exchange-policy-trilemma",
        "locale": "en",
        "title": "Exchange regimes and policy constraints",
        "takeaway": "With free capital mobility, a fixed exchange rate constrains independent monetary policy: interest differentials trigger flows requiring intervention or policy adjustment.",
        "definition": "With free capital mobility, a fixed exchange rate constrains independent monetary policy: interest differentials trigger flows requiring intervention or policy adjustment.",
        "causalChain": [
          "Independent rate cuts reduce relative returns",
          "outflows add depreciation pressure",
          "defending parity restricts rate cuts"
        ],
        "misconceptions": [
          "The constraint depends on mobility, risk and credibility; it does not imply identical interest rates everywhere at every moment."
        ],
        "examApplication": [
          "State the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
        ],
        "summary": [
          "With free capital mobility, a fixed exchange rate constrains independent monetary policy: interest differentials trigger flows requiring intervention or policy adjustment.",
          "The constraint depends on mobility, risk and credibility; it does not imply identical interest rates everywhere at every moment."
        ],
        "explanation": "Independent rate cuts reduce relative returns.  outflows add depreciation pressure.  defending parity restricts rate cuts.\n\n### Original scenario and reasoning\n\nHypothetical scenario: an economy wants lower rates for jobs, a fixed parity and free capital flows. Persistent outflows expose the difficulty of sustaining all three.\n\nThe constraint depends on mobility, risk and credibility; it does not imply identical interest rates everywhere at every moment.\n\nState the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
      }
    },
    "practice": [
      {
        "id": "u4-27-exchange-policy-trilemma-flash-1",
        "knowledgePointId": "u4-27-exchange-policy-trilemma",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“汇率制度与政策约束”，并说明一个关键条件。",
          "en": "Explain Exchange regimes and policy constraints and state one important condition."
        },
        "answer": {
          "zh-CN": "资本自由流动下，固定汇率约束独立货币政策；利差会引发资金流并迫使当局干预或调整政策。",
          "en": "With free capital mobility, a fixed exchange rate constrains independent monetary policy: interest differentials trigger flows requiring intervention or policy adjustment."
        },
        "explanation": {
          "zh-CN": "该约束依赖资本流动、风险与可信度，不表示所有国家任何时刻利率完全相同。",
          "en": "The constraint depends on mobility, risk and credibility; it does not imply identical interest rates everywhere at every moment."
        }
      },
      {
        "id": "u4-27-exchange-policy-trilemma-mcq-1",
        "knowledgePointId": "u4-27-exchange-policy-trilemma",
        "type": "mcq",
        "prompt": {
          "zh-CN": "固定汇率和自由资本流动下，什么受约束？",
          "en": "What is constrained with a fixed rate and free capital flows?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "所有国内生产",
            "en": "All domestic production"
          },
          {
            "id": "b",
            "zh-CN": "任何教育支出",
            "en": "Any education spending"
          },
          {
            "id": "c",
            "zh-CN": "独立货币政策",
            "en": "Independent monetary policy"
          },
          {
            "id": "d",
            "zh-CN": "所有国际贸易",
            "en": "All international trade"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "独立货币政策。 独立降息降低相对回报；资本流出增加贬值压力；捍卫固定汇率限制降息空间 该约束依赖资本流动、风险与可信度，不表示所有国家任何时刻利率完全相同。",
          "en": "Independent monetary policy. Independent rate cuts reduce relative returns; outflows add depreciation pressure; defending parity restricts rate cuts The constraint depends on mobility, risk and credibility; it does not imply identical interest rates everywhere at every moment."
        }
      },
      {
        "id": "u4-27-exchange-policy-trilemma-short-1",
        "knowledgePointId": "u4-27-exchange-policy-trilemma",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释汇率制度与政策约束的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Exchange regimes and policy constraints and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "资本自由流动下，固定汇率约束独立货币政策；利差会引发资金流并迫使当局干预或调整政策。 独立降息降低相对回报；资本流出增加贬值压力；捍卫固定汇率限制降息空间 原创假设：一国希望降息刺激就业，又维持平价且允许资本自由流动；持续资本外流暴露三目标难以同时保持。",
          "en": "With free capital mobility, a fixed exchange rate constrains independent monetary policy: interest differentials trigger flows requiring intervention or policy adjustment. Independent rate cuts reduce relative returns; outflows add depreciation pressure; defending parity restricts rate cuts Hypothetical scenario: an economy wants lower rates for jobs, a fixed parity and free capital flows. Persistent outflows expose the difficulty of sustaining all three."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "资本流动",
              "en": "capital mobility"
            },
            "alternatives": {
              "zh-CN": [
                "资本流动",
                "独立降息降低相对回报"
              ],
              "en": [
                "capital mobility",
                "Independent rate cuts reduce relative returns"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "固定汇率",
              "en": "fixed exchange rate"
            },
            "alternatives": {
              "zh-CN": [
                "固定汇率",
                "资本流出增加贬值压力"
              ],
              "en": [
                "fixed exchange rate",
                "outflows add depreciation pressure"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "货币政策",
              "en": "monetary policy"
            },
            "alternatives": {
              "zh-CN": [
                "货币政策",
                "捍卫固定汇率限制降息空间"
              ],
              "en": [
                "monetary policy",
                "defending parity restricts rate cuts"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-28-current-account",
      "slug": "current-account",
      "section": "4.6",
      "level": "core",
      "syllabusRefs": [
        "4.6 Balance of payments"
      ],
      "textbookRefs": [
        {
          "chapter": "16",
          "section": "16.4",
          "pages": [
            509
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-29-capital-financial-account",
        "u4-30-bop-identity",
        "u4-31-current-account-imbalances"
      ],
      "terms": [
        "经常账户的构成",
        "Components of the current account",
        "货物",
        "goods",
        "收入",
        "income",
        "经常账户",
        "current account"
      ],
      "synonyms": {
        "zh-CN": [
          "货物",
          "收入",
          "经常账户"
        ],
        "en": [
          "goods",
          "income",
          "current account"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-28-current-account-flash-1",
        "u4-28-current-account-mcq-1",
        "u4-28-current-account-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-28-current-account",
        "locale": "zh-CN",
        "title": "经常账户的构成",
        "takeaway": "经常账户记录货物、服务、初次收入及二次收入的跨境净流量；贸易余额只是其中一部分。",
        "definition": "经常账户记录货物、服务、初次收入及二次收入的跨境净流量；贸易余额只是其中一部分。",
        "causalChain": [
          "货物服务出口形成贷项",
          "向国外支付收入形成借项",
          "各项净额相加得到经常账户余额"
        ],
        "misconceptions": [
          "海外投资利润属初次收入，购买海外股份属金融账户，不要混淆。"
        ],
        "examApplication": [
          "声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
        ],
        "summary": [
          "经常账户记录货物、服务、初次收入及二次收入的跨境净流量；贸易余额只是其中一部分。",
          "海外投资利润属初次收入，购买海外股份属金融账户，不要混淆。"
        ],
        "explanation": "货物服务出口形成贷项。向国外支付收入形成借项。各项净额相加得到经常账户余额。\n\n### 原创情境与推导\n\n原创假设：货物 −20、服务 +10、初次收入 −5、二次收入 +3，经常账户为 −12；收到海外亲属汇款通常属二次收入。\n\n海外投资利润属初次收入，购买海外股份属金融账户，不要混淆。\n\n声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
      },
      "en": {
        "id": "u4-28-current-account",
        "locale": "en",
        "title": "Components of the current account",
        "takeaway": "The current account records net cross-border goods, services, primary income and secondary income flows. The trade balance is only part of it.",
        "definition": "The current account records net cross-border goods, services, primary income and secondary income flows. The trade balance is only part of it.",
        "causalChain": [
          "Goods and service exports create credits",
          "income paid abroad creates debits",
          "component balances sum to the current account"
        ],
        "misconceptions": [
          "Income on foreign investment is primary income; purchasing foreign shares belongs to the financial account."
        ],
        "examApplication": [
          "Declare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
        ],
        "summary": [
          "The current account records net cross-border goods, services, primary income and secondary income flows. The trade balance is only part of it.",
          "Income on foreign investment is primary income; purchasing foreign shares belongs to the financial account."
        ],
        "explanation": "Goods and service exports create credits.  income paid abroad creates debits.  component balances sum to the current account.\n\n### Original scenario and reasoning\n\nHypothetical scenario: goods −20, services +10, primary income −5 and secondary income +3 give a current-account balance of −12. Family remittances received normally enter secondary income.\n\nIncome on foreign investment is primary income; purchasing foreign shares belongs to the financial account.\n\nDeclare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
      }
    },
    "practice": [
      {
        "id": "u4-28-current-account-flash-1",
        "knowledgePointId": "u4-28-current-account",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“经常账户的构成”，并说明一个关键条件。",
          "en": "Explain Components of the current account and state one important condition."
        },
        "answer": {
          "zh-CN": "经常账户记录货物、服务、初次收入及二次收入的跨境净流量；贸易余额只是其中一部分。",
          "en": "The current account records net cross-border goods, services, primary income and secondary income flows. The trade balance is only part of it."
        },
        "explanation": {
          "zh-CN": "海外投资利润属初次收入，购买海外股份属金融账户，不要混淆。",
          "en": "Income on foreign investment is primary income; purchasing foreign shares belongs to the financial account."
        }
      },
      {
        "id": "u4-28-current-account-mcq-1",
        "knowledgePointId": "u4-28-current-account",
        "type": "mcq",
        "prompt": {
          "zh-CN": "货物 −10、服务 +4、收入净额 +2，经常账户多少？",
          "en": "Goods −10, services +4 and combined income +2 give what current balance?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "16",
            "en": "16"
          },
          {
            "id": "b",
            "zh-CN": "−16",
            "en": "−16"
          },
          {
            "id": "c",
            "zh-CN": "4",
            "en": "4"
          },
          {
            "id": "d",
            "zh-CN": "−4",
            "en": "−4"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "−4。 −10 + 4 + 2 = −4 海外投资利润属初次收入，购买海外股份属金融账户，不要混淆。",
          "en": "−4. −10 + 4 + 2 = −4 Income on foreign investment is primary income; purchasing foreign shares belongs to the financial account."
        }
      },
      {
        "id": "u4-28-current-account-short-1",
        "knowledgePointId": "u4-28-current-account",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释经常账户的构成的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Components of the current account and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "经常账户记录货物、服务、初次收入及二次收入的跨境净流量；贸易余额只是其中一部分。 货物服务出口形成贷项；向国外支付收入形成借项；各项净额相加得到经常账户余额 原创假设：货物 −20、服务 +10、初次收入 −5、二次收入 +3，经常账户为 −12；收到海外亲属汇款通常属二次收入。",
          "en": "The current account records net cross-border goods, services, primary income and secondary income flows. The trade balance is only part of it. Goods and service exports create credits; income paid abroad creates debits; component balances sum to the current account Hypothetical scenario: goods −20, services +10, primary income −5 and secondary income +3 give a current-account balance of −12. Family remittances received normally enter secondary income."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "货物",
              "en": "goods"
            },
            "alternatives": {
              "zh-CN": [
                "货物",
                "货物服务出口形成贷项"
              ],
              "en": [
                "goods",
                "Goods and service exports create credits"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "收入",
              "en": "income"
            },
            "alternatives": {
              "zh-CN": [
                "收入",
                "向国外支付收入形成借项"
              ],
              "en": [
                "income",
                "income paid abroad creates debits"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "经常账户",
              "en": "current account"
            },
            "alternatives": {
              "zh-CN": [
                "经常账户",
                "各项净额相加得到经常账户余额"
              ],
              "en": [
                "current account",
                "component balances sum to the current account"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-29-capital-financial-account",
      "slug": "capital-financial-account",
      "section": "4.6",
      "level": "core",
      "syllabusRefs": [
        "4.6 Balance of payments"
      ],
      "textbookRefs": [
        {
          "chapter": "16",
          "section": "16.4",
          "pages": [
            509
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-28-current-account",
        "u4-30-bop-identity",
        "u4-31-current-account-imbalances"
      ],
      "terms": [
        "资本账户与金融账户",
        "Capital and financial accounts",
        "资产",
        "assets",
        "负债",
        "liabilities",
        "金融账户",
        "financial account"
      ],
      "synonyms": {
        "zh-CN": [
          "资产",
          "负债",
          "金融账户"
        ],
        "en": [
          "assets",
          "liabilities",
          "financial account"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-29-capital-financial-account-flash-1",
        "u4-29-capital-financial-account-mcq-1",
        "u4-29-capital-financial-account-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-29-capital-financial-account",
        "locale": "zh-CN",
        "title": "资本账户与金融账户",
        "takeaway": "资本账户记录资本转移及非生产非金融资产交易；金融账户记录跨境金融资产与负债交易，包括直接投资、证券投资、其他投资和储备。",
        "definition": "资本账户记录资本转移及非生产非金融资产交易；金融账户记录跨境金融资产与负债交易，包括直接投资、证券投资、其他投资和储备。",
        "causalChain": [
          "跨境融资改变资产负债",
          "按投资性质分类",
          "与经常项目形成对应记录"
        ],
        "misconceptions": [
          "日常所说资本流入大多属于金融账户，不应把资本账户当作所有投资的总称。"
        ],
        "examApplication": [
          "声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
        ],
        "summary": [
          "资本账户记录资本转移及非生产非金融资产交易；金融账户记录跨境金融资产与负债交易，包括直接投资、证券投资、其他投资和储备。",
          "日常所说资本流入大多属于金融账户，不应把资本账户当作所有投资的总称。"
        ],
        "explanation": "跨境融资改变资产负债。按投资性质分类。与经常项目形成对应记录。\n\n### 原创情境与推导\n\n原创假设：外国企业建厂属直接投资，居民买外国债券属证券投资；贷款本金偿还是金融交易，利息是初次收入。\n\n日常所说资本流入大多属于金融账户，不应把资本账户当作所有投资的总称。\n\n声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
      },
      "en": {
        "id": "u4-29-capital-financial-account",
        "locale": "en",
        "title": "Capital and financial accounts",
        "takeaway": "The capital account records capital transfers and non-produced non-financial assets. The financial account records cross-border asset and liability transactions, including direct, portfolio, other investment and reserves.",
        "definition": "The capital account records capital transfers and non-produced non-financial assets. The financial account records cross-border asset and liability transactions, including direct, portfolio, other investment and reserves.",
        "causalChain": [
          "Cross-border finance changes assets and liabilities",
          "classify the type of investment",
          "record counterparts to current transactions"
        ],
        "misconceptions": [
          "Most everyday capital inflows belong to the financial account; the capital account is not a catch-all for investment."
        ],
        "examApplication": [
          "Declare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
        ],
        "summary": [
          "The capital account records capital transfers and non-produced non-financial assets. The financial account records cross-border asset and liability transactions, including direct, portfolio, other investment and reserves.",
          "Most everyday capital inflows belong to the financial account; the capital account is not a catch-all for investment."
        ],
        "explanation": "Cross-border finance changes assets and liabilities.  classify the type of investment.  record counterparts to current transactions.\n\n### Original scenario and reasoning\n\nHypothetical scenario: a foreign firm building a factory is direct investment and residents buying foreign bonds is portfolio investment. Loan principal repayment is financial, while interest is primary income.\n\nMost everyday capital inflows belong to the financial account; the capital account is not a catch-all for investment.\n\nDeclare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
      }
    },
    "practice": [
      {
        "id": "u4-29-capital-financial-account-flash-1",
        "knowledgePointId": "u4-29-capital-financial-account",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“资本账户与金融账户”，并说明一个关键条件。",
          "en": "Explain Capital and financial accounts and state one important condition."
        },
        "answer": {
          "zh-CN": "资本账户记录资本转移及非生产非金融资产交易；金融账户记录跨境金融资产与负债交易，包括直接投资、证券投资、其他投资和储备。",
          "en": "The capital account records capital transfers and non-produced non-financial assets. The financial account records cross-border asset and liability transactions, including direct, portfolio, other investment and reserves."
        },
        "explanation": {
          "zh-CN": "日常所说资本流入大多属于金融账户，不应把资本账户当作所有投资的总称。",
          "en": "Most everyday capital inflows belong to the financial account; the capital account is not a catch-all for investment."
        }
      },
      {
        "id": "u4-29-capital-financial-account-mcq-1",
        "knowledgePointId": "u4-29-capital-financial-account",
        "type": "mcq",
        "prompt": {
          "zh-CN": "偿还海外贷款本金记在哪里？",
          "en": "Where is foreign loan principal repayment recorded?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "金融账户",
            "en": "The financial account"
          },
          {
            "id": "b",
            "zh-CN": "货物出口",
            "en": "Goods exports"
          },
          {
            "id": "c",
            "zh-CN": "二次收入",
            "en": "Secondary income"
          },
          {
            "id": "d",
            "zh-CN": "国内消费 CPI",
            "en": "Domestic consumption CPI"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "金融账户。 跨境融资改变资产负债；按投资性质分类；与经常项目形成对应记录 日常所说资本流入大多属于金融账户，不应把资本账户当作所有投资的总称。",
          "en": "The financial account. Cross-border finance changes assets and liabilities; classify the type of investment; record counterparts to current transactions Most everyday capital inflows belong to the financial account; the capital account is not a catch-all for investment."
        }
      },
      {
        "id": "u4-29-capital-financial-account-short-1",
        "knowledgePointId": "u4-29-capital-financial-account",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释资本账户与金融账户的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Capital and financial accounts and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "资本账户记录资本转移及非生产非金融资产交易；金融账户记录跨境金融资产与负债交易，包括直接投资、证券投资、其他投资和储备。 跨境融资改变资产负债；按投资性质分类；与经常项目形成对应记录 原创假设：外国企业建厂属直接投资，居民买外国债券属证券投资；贷款本金偿还是金融交易，利息是初次收入。",
          "en": "The capital account records capital transfers and non-produced non-financial assets. The financial account records cross-border asset and liability transactions, including direct, portfolio, other investment and reserves. Cross-border finance changes assets and liabilities; classify the type of investment; record counterparts to current transactions Hypothetical scenario: a foreign firm building a factory is direct investment and residents buying foreign bonds is portfolio investment. Loan principal repayment is financial, while interest is primary income."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "资产",
              "en": "assets"
            },
            "alternatives": {
              "zh-CN": [
                "资产",
                "跨境融资改变资产负债"
              ],
              "en": [
                "assets",
                "Cross-border finance changes assets and liabilities"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "负债",
              "en": "liabilities"
            },
            "alternatives": {
              "zh-CN": [
                "负债",
                "按投资性质分类"
              ],
              "en": [
                "liabilities",
                "classify the type of investment"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "金融账户",
              "en": "financial account"
            },
            "alternatives": {
              "zh-CN": [
                "金融账户",
                "与经常项目形成对应记录"
              ],
              "en": [
                "financial account",
                "record counterparts to current transactions"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-30-bop-identity",
      "slug": "bop-identity",
      "section": "4.6",
      "level": "core",
      "syllabusRefs": [
        "4.6 Balance of payments"
      ],
      "textbookRefs": [
        {
          "chapter": "17",
          "section": "17.1",
          "pages": [
            520
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-28-current-account",
        "u4-29-capital-financial-account",
        "u4-31-current-account-imbalances"
      ],
      "terms": [
        "国际收支恒等式与符号",
        "Balance-of-payments identity and signs",
        "符号",
        "convention",
        "对应",
        "counterparts",
        "储备",
        "reserves"
      ],
      "synonyms": {
        "zh-CN": [
          "符号",
          "对应",
          "储备"
        ],
        "en": [
          "convention",
          "counterparts",
          "reserves"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-30-bop-identity-flash-1",
        "u4-30-bop-identity-mcq-1",
        "u4-30-bop-identity-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-30-bop-identity",
        "locale": "zh-CN",
        "title": "国际收支恒等式与符号",
        "takeaway": "采用金融账户为净资本流入的教学符号时，CA+KA+FA+误差遗漏=0；官方净资产获得减负债增加的符号则相反。",
        "definition": "采用金融账户为净资本流入的教学符号时，CA+KA+FA+误差遗漏=0；官方净资产获得减负债增加的符号则相反。",
        "causalChain": [
          "声明金融账户符号",
          "记录交易对应项",
          "用误差遗漏协调统计差异"
        ],
        "misconceptions": [
          "不要既把储备计入金融账户又另加一次；国际收支平衡不等于经常账户余额为零。"
        ],
        "examApplication": [
          "声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
        ],
        "summary": [
          "采用金融账户为净资本流入的教学符号时，CA+KA+FA+误差遗漏=0；官方净资产获得减负债增加的符号则相反。",
          "不要既把储备计入金融账户又另加一次；国际收支平衡不等于经常账户余额为零。"
        ],
        "explanation": "声明金融账户符号。记录交易对应项。用误差遗漏协调统计差异。\n\n### 原创情境与推导\n\n原创假设：CA=−30、KA=0、误差=0，则教学净流入 FA=+30；官方净借出符号下 FA=−30。储备交易已经包含在金融账户中。\n\n不要既把储备计入金融账户又另加一次；国际收支平衡不等于经常账户余额为零。\n\n声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
      },
      "en": {
        "id": "u4-30-bop-identity",
        "locale": "en",
        "title": "Balance-of-payments identity and signs",
        "takeaway": "With a teaching convention that defines FA as net financial inflows, CA+KA+FA+errors=0. The official net-acquisition-of-assets-minus-liabilities convention uses the opposite FA sign.",
        "definition": "With a teaching convention that defines FA as net financial inflows, CA+KA+FA+errors=0. The official net-acquisition-of-assets-minus-liabilities convention uses the opposite FA sign.",
        "causalChain": [
          "State the financial-account sign convention",
          "record transaction counterparts",
          "use errors and omissions for statistical discrepancies"
        ],
        "misconceptions": [
          "Do not count reserves inside FA and then add them again; balanced accounts do not imply a zero current account."
        ],
        "examApplication": [
          "Declare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
        ],
        "summary": [
          "With a teaching convention that defines FA as net financial inflows, CA+KA+FA+errors=0. The official net-acquisition-of-assets-minus-liabilities convention uses the opposite FA sign.",
          "Do not count reserves inside FA and then add them again; balanced accounts do not imply a zero current account."
        ],
        "explanation": "State the financial-account sign convention.  record transaction counterparts.  use errors and omissions for statistical discrepancies.\n\n### Original scenario and reasoning\n\nHypothetical scenario: CA=−30, KA=0 and no errors imply teaching-convention inflows FA=+30, or official net-lending FA=−30. Reserve transactions are already within the financial account.\n\nDo not count reserves inside FA and then add them again; balanced accounts do not imply a zero current account.\n\nDeclare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
      }
    },
    "practice": [
      {
        "id": "u4-30-bop-identity-flash-1",
        "knowledgePointId": "u4-30-bop-identity",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“国际收支恒等式与符号”，并说明一个关键条件。",
          "en": "Explain Balance-of-payments identity and signs and state one important condition."
        },
        "answer": {
          "zh-CN": "采用金融账户为净资本流入的教学符号时，CA+KA+FA+误差遗漏=0；官方净资产获得减负债增加的符号则相反。",
          "en": "With a teaching convention that defines FA as net financial inflows, CA+KA+FA+errors=0. The official net-acquisition-of-assets-minus-liabilities convention uses the opposite FA sign."
        },
        "explanation": {
          "zh-CN": "不要既把储备计入金融账户又另加一次；国际收支平衡不等于经常账户余额为零。",
          "en": "Do not count reserves inside FA and then add them again; balanced accounts do not imply a zero current account."
        }
      },
      {
        "id": "u4-30-bop-identity-mcq-1",
        "knowledgePointId": "u4-30-bop-identity",
        "type": "mcq",
        "prompt": {
          "zh-CN": "净流入符号下 CA=−12、KA=0、无误差，FA 为多少？",
          "en": "Using net inflows, CA=−12, KA=0 and no errors imply what FA?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "−12",
            "en": "−12"
          },
          {
            "id": "b",
            "zh-CN": "+12",
            "en": "+12"
          },
          {
            "id": "c",
            "zh-CN": "0",
            "en": "0"
          },
          {
            "id": "d",
            "zh-CN": "必须再重复加储备",
            "en": "Reserves must be added again"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "+12。 −12 + 0 + FA = 0; FA = +12 (FA: inflow +) 不要既把储备计入金融账户又另加一次；国际收支平衡不等于经常账户余额为零。",
          "en": "+12. −12 + 0 + FA = 0; FA = +12 (FA: inflow +) Do not count reserves inside FA and then add them again; balanced accounts do not imply a zero current account."
        }
      },
      {
        "id": "u4-30-bop-identity-short-1",
        "knowledgePointId": "u4-30-bop-identity",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释国际收支恒等式与符号的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Balance-of-payments identity and signs and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "采用金融账户为净资本流入的教学符号时，CA+KA+FA+误差遗漏=0；官方净资产获得减负债增加的符号则相反。 声明金融账户符号；记录交易对应项；用误差遗漏协调统计差异 原创假设：CA=−30、KA=0、误差=0，则教学净流入 FA=+30；官方净借出符号下 FA=−30。储备交易已经包含在金融账户中。",
          "en": "With a teaching convention that defines FA as net financial inflows, CA+KA+FA+errors=0. The official net-acquisition-of-assets-minus-liabilities convention uses the opposite FA sign. State the financial-account sign convention; record transaction counterparts; use errors and omissions for statistical discrepancies Hypothetical scenario: CA=−30, KA=0 and no errors imply teaching-convention inflows FA=+30, or official net-lending FA=−30. Reserve transactions are already within the financial account."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "符号",
              "en": "convention"
            },
            "alternatives": {
              "zh-CN": [
                "符号",
                "声明金融账户符号"
              ],
              "en": [
                "convention",
                "State the financial-account sign convention"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "对应",
              "en": "counterparts"
            },
            "alternatives": {
              "zh-CN": [
                "对应",
                "记录交易对应项"
              ],
              "en": [
                "counterparts",
                "record transaction counterparts"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "储备",
              "en": "reserves"
            },
            "alternatives": {
              "zh-CN": [
                "储备",
                "用误差遗漏协调统计差异"
              ],
              "en": [
                "reserves",
                "use errors and omissions for statistical discrepancies"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-31-current-account-imbalances",
      "slug": "current-account-imbalances",
      "section": "4.6",
      "level": "hl",
      "syllabusRefs": [
        "4.6 Balance of payments"
      ],
      "textbookRefs": [
        {
          "chapter": "17",
          "section": "17.4",
          "pages": [
            530
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-28-current-account",
        "u4-29-capital-financial-account",
        "u4-30-bop-identity"
      ],
      "terms": [
        "经常账户失衡的原因与可持续性",
        "Causes and sustainability of current-account imbalances",
        "融资",
        "financing",
        "可持续性",
        "sustainability",
        "债务",
        "debt"
      ],
      "synonyms": {
        "zh-CN": [
          "融资",
          "可持续性",
          "债务"
        ],
        "en": [
          "financing",
          "sustainability",
          "debt"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-31-current-account-imbalances-flash-1",
        "u4-31-current-account-imbalances-mcq-1",
        "u4-31-current-account-imbalances-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-31-current-account-imbalances",
        "locale": "zh-CN",
        "title": "经常账户失衡的原因与可持续性",
        "takeaway": "经常账户逆差可能反映投资进口、竞争力不足或内需强劲；其可持续性取决于融资结构、偿债能力与资金用途。",
        "definition": "经常账户逆差可能反映投资进口、竞争力不足或内需强劲；其可持续性取决于融资结构、偿债能力与资金用途。",
        "causalChain": [
          "进口或收入支付超过相应收入",
          "外部融资或储备变化对应缺口",
          "未来收益与融资稳定性决定风险"
        ],
        "misconceptions": [
          "逆差不必然坏，顺差也可能反映内需不足；应比较规模、期限、币种与结构。"
        ],
        "examApplication": [
          "声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
        ],
        "summary": [
          "经常账户逆差可能反映投资进口、竞争力不足或内需强劲；其可持续性取决于融资结构、偿债能力与资金用途。",
          "逆差不必然坏，顺差也可能反映内需不足；应比较规模、期限、币种与结构。"
        ],
        "explanation": "进口或收入支付超过相应收入。外部融资或储备变化对应缺口。未来收益与融资稳定性决定风险。\n\n### 原创情境与推导\n\n原创假设：设备进口支持未来出口，与短期外币借款资助消费具有不同风险；长期直接投资通常比易撤出的短期融资更稳定。\n\n逆差不必然坏，顺差也可能反映内需不足；应比较规模、期限、币种与结构。\n\n声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
      },
      "en": {
        "id": "u4-31-current-account-imbalances",
        "locale": "en",
        "title": "Causes and sustainability of current-account imbalances",
        "takeaway": "A current deficit may reflect investment imports, weak competitiveness or strong domestic demand. Sustainability depends on financing structure, repayment capacity and how funds are used.",
        "definition": "A current deficit may reflect investment imports, weak competitiveness or strong domestic demand. Sustainability depends on financing structure, repayment capacity and how funds are used.",
        "causalChain": [
          "Imports or income payments exceed receipts",
          "external financing or reserves correspond to the gap",
          "future returns and financing stability determine risks"
        ],
        "misconceptions": [
          "Deficits are not automatically bad, nor surpluses always good; compare size, maturity, currency and structure."
        ],
        "examApplication": [
          "Declare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
        ],
        "summary": [
          "A current deficit may reflect investment imports, weak competitiveness or strong domestic demand. Sustainability depends on financing structure, repayment capacity and how funds are used.",
          "Deficits are not automatically bad, nor surpluses always good; compare size, maturity, currency and structure."
        ],
        "explanation": "Imports or income payments exceed receipts.  external financing or reserves correspond to the gap.  future returns and financing stability determine risks.\n\n### Original scenario and reasoning\n\nHypothetical scenario: machinery imports supporting future exports differ from short-term foreign-currency borrowing funding consumption. Long-term direct investment is generally more stable than easily reversed short-term finance.\n\nDeficits are not automatically bad, nor surpluses always good; compare size, maturity, currency and structure.\n\nDeclare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
      }
    },
    "practice": [
      {
        "id": "u4-31-current-account-imbalances-flash-1",
        "knowledgePointId": "u4-31-current-account-imbalances",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“经常账户失衡的原因与可持续性”，并说明一个关键条件。",
          "en": "Explain Causes and sustainability of current-account imbalances and state one important condition."
        },
        "answer": {
          "zh-CN": "经常账户逆差可能反映投资进口、竞争力不足或内需强劲；其可持续性取决于融资结构、偿债能力与资金用途。",
          "en": "A current deficit may reflect investment imports, weak competitiveness or strong domestic demand. Sustainability depends on financing structure, repayment capacity and how funds are used."
        },
        "explanation": {
          "zh-CN": "逆差不必然坏，顺差也可能反映内需不足；应比较规模、期限、币种与结构。",
          "en": "Deficits are not automatically bad, nor surpluses always good; compare size, maturity, currency and structure."
        }
      },
      {
        "id": "u4-31-current-account-imbalances-mcq-1",
        "knowledgePointId": "u4-31-current-account-imbalances",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪种情况通常增加逆差融资脆弱性？",
          "en": "What normally increases deficit-financing vulnerability?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "高回报生产性投资本身",
            "en": "Productive high-return investment alone"
          },
          {
            "id": "b",
            "zh-CN": "期限延长本身",
            "en": "Longer maturity alone"
          },
          {
            "id": "c",
            "zh-CN": "短期外币债务依赖",
            "en": "Dependence on short-term foreign-currency debt"
          },
          {
            "id": "d",
            "zh-CN": "出口多样化本身",
            "en": "Export diversification alone"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "短期外币债务依赖。 进口或收入支付超过相应收入；外部融资或储备变化对应缺口；未来收益与融资稳定性决定风险 逆差不必然坏，顺差也可能反映内需不足；应比较规模、期限、币种与结构。",
          "en": "Dependence on short-term foreign-currency debt. Imports or income payments exceed receipts; external financing or reserves correspond to the gap; future returns and financing stability determine risks Deficits are not automatically bad, nor surpluses always good; compare size, maturity, currency and structure."
        }
      },
      {
        "id": "u4-31-current-account-imbalances-short-1",
        "knowledgePointId": "u4-31-current-account-imbalances",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释经常账户失衡的原因与可持续性的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Causes and sustainability of current-account imbalances and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "经常账户逆差可能反映投资进口、竞争力不足或内需强劲；其可持续性取决于融资结构、偿债能力与资金用途。 进口或收入支付超过相应收入；外部融资或储备变化对应缺口；未来收益与融资稳定性决定风险 原创假设：设备进口支持未来出口，与短期外币借款资助消费具有不同风险；长期直接投资通常比易撤出的短期融资更稳定。",
          "en": "A current deficit may reflect investment imports, weak competitiveness or strong domestic demand. Sustainability depends on financing structure, repayment capacity and how funds are used. Imports or income payments exceed receipts; external financing or reserves correspond to the gap; future returns and financing stability determine risks Hypothetical scenario: machinery imports supporting future exports differ from short-term foreign-currency borrowing funding consumption. Long-term direct investment is generally more stable than easily reversed short-term finance."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "融资",
              "en": "financing"
            },
            "alternatives": {
              "zh-CN": [
                "融资",
                "进口或收入支付超过相应收入"
              ],
              "en": [
                "financing",
                "Imports or income payments exceed receipts"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "可持续性",
              "en": "sustainability"
            },
            "alternatives": {
              "zh-CN": [
                "可持续性",
                "外部融资或储备变化对应缺口"
              ],
              "en": [
                "sustainability",
                "external financing or reserves correspond to the gap"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "债务",
              "en": "debt"
            },
            "alternatives": {
              "zh-CN": [
                "债务",
                "未来收益与融资稳定性决定风险"
              ],
              "en": [
                "debt",
                "future returns and financing stability determine risks"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-32-marshall-lerner",
      "slug": "marshall-lerner",
      "section": "4.6",
      "level": "hl",
      "syllabusRefs": [
        "4.6 Balance of payments"
      ],
      "textbookRefs": [
        {
          "chapter": "17",
          "section": "17.4",
          "pages": [
            530
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-28-current-account",
        "u4-29-capital-financial-account",
        "u4-30-bop-identity"
      ],
      "terms": [
        "马歇尔—勒纳条件",
        "The Marshall–Lerner condition",
        "贬值",
        "depreciation",
        "弹性",
        "elasticities",
        "大于1",
        "greater than one"
      ],
      "synonyms": {
        "zh-CN": [
          "贬值",
          "弹性",
          "大于1"
        ],
        "en": [
          "depreciation",
          "elasticities",
          "greater than one"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-32-marshall-lerner-flash-1",
        "u4-32-marshall-lerner-mcq-1",
        "u4-32-marshall-lerner-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-32-marshall-lerner",
        "locale": "zh-CN",
        "title": "马歇尔—勒纳条件",
        "takeaway": "在初始贸易平衡等标准假设下，贬值改善贸易余额要求出口与进口需求价格弹性的绝对值之和大于 1。",
        "definition": "在初始贸易平衡等标准假设下，贬值改善贸易余额要求出口与进口需求价格弹性的绝对值之和大于 1。",
        "causalChain": [
          "贬值改变相对价格",
          "数量按需求弹性调整",
          "数量效应超过进口单位成本效应时余额改善"
        ],
        "misconceptions": [
          "条件针对贸易余额，不自动覆盖投资收益和转移；弹性不是百分比数量变化本身。"
        ],
        "examApplication": [
          "声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
        ],
        "summary": [
          "在初始贸易平衡等标准假设下，贬值改善贸易余额要求出口与进口需求价格弹性的绝对值之和大于 1。",
          "条件针对贸易余额，不自动覆盖投资收益和转移；弹性不是百分比数量变化本身。"
        ],
        "explanation": "贬值改变相对价格。数量按需求弹性调整。数量效应超过进口单位成本效应时余额改善。\n\n### 原创情境与推导\n\n原创假设：出口弹性 0.7、进口弹性 0.6，总和 1.3，在充分供给反应和相关模型假设下支持改善；不意味着一定立即改善。\n\n条件针对贸易余额，不自动覆盖投资收益和转移；弹性不是百分比数量变化本身。\n\n声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
      },
      "en": {
        "id": "u4-32-marshall-lerner",
        "locale": "en",
        "title": "The Marshall–Lerner condition",
        "takeaway": "Under standard assumptions including initial trade balance, depreciation improves the trade balance when absolute export and import demand elasticities sum to more than one.",
        "definition": "Under standard assumptions including initial trade balance, depreciation improves the trade balance when absolute export and import demand elasticities sum to more than one.",
        "causalChain": [
          "Depreciation changes relative prices",
          "volumes respond to demand elasticities",
          "the balance improves when volume effects outweigh the import unit-cost effect"
        ],
        "misconceptions": [
          "The condition concerns the trade balance, not all income and transfers; an elasticity is not the quantity percentage change itself."
        ],
        "examApplication": [
          "Declare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
        ],
        "summary": [
          "Under standard assumptions including initial trade balance, depreciation improves the trade balance when absolute export and import demand elasticities sum to more than one.",
          "The condition concerns the trade balance, not all income and transfers; an elasticity is not the quantity percentage change itself."
        ],
        "explanation": "Depreciation changes relative prices.  volumes respond to demand elasticities.  the balance improves when volume effects outweigh the import unit-cost effect.\n\n### Original scenario and reasoning\n\nHypothetical scenario: elasticities 0.7 and 0.6 sum to 1.3, supporting improvement with sufficient supply response and the model's assumptions; improvement need not be immediate.\n\nThe condition concerns the trade balance, not all income and transfers; an elasticity is not the quantity percentage change itself.\n\nDeclare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
      }
    },
    "practice": [
      {
        "id": "u4-32-marshall-lerner-flash-1",
        "knowledgePointId": "u4-32-marshall-lerner",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“马歇尔—勒纳条件”，并说明一个关键条件。",
          "en": "Explain The Marshall–Lerner condition and state one important condition."
        },
        "answer": {
          "zh-CN": "在初始贸易平衡等标准假设下，贬值改善贸易余额要求出口与进口需求价格弹性的绝对值之和大于 1。",
          "en": "Under standard assumptions including initial trade balance, depreciation improves the trade balance when absolute export and import demand elasticities sum to more than one."
        },
        "explanation": {
          "zh-CN": "条件针对贸易余额，不自动覆盖投资收益和转移；弹性不是百分比数量变化本身。",
          "en": "The condition concerns the trade balance, not all income and transfers; an elasticity is not the quantity percentage change itself."
        }
      },
      {
        "id": "u4-32-marshall-lerner-mcq-1",
        "knowledgePointId": "u4-32-marshall-lerner",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪组弹性满足标准条件？",
          "en": "Which elasticity pair satisfies the standard condition?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "0.2 与 0.3",
            "en": "0.2 and 0.3"
          },
          {
            "id": "b",
            "zh-CN": "0.4 与 0.4",
            "en": "0.4 and 0.4"
          },
          {
            "id": "c",
            "zh-CN": "0.1 与 0.2",
            "en": "0.1 and 0.2"
          },
          {
            "id": "d",
            "zh-CN": "0.7 与 0.6",
            "en": "0.7 and 0.6"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "0.7 与 0.6。 贬值改变相对价格；数量按需求弹性调整；数量效应超过进口单位成本效应时余额改善 条件针对贸易余额，不自动覆盖投资收益和转移；弹性不是百分比数量变化本身。",
          "en": "0.7 and 0.6. Depreciation changes relative prices; volumes respond to demand elasticities; the balance improves when volume effects outweigh the import unit-cost effect The condition concerns the trade balance, not all income and transfers; an elasticity is not the quantity percentage change itself."
        }
      },
      {
        "id": "u4-32-marshall-lerner-short-1",
        "knowledgePointId": "u4-32-marshall-lerner",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释马歇尔—勒纳条件的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of The Marshall–Lerner condition and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "在初始贸易平衡等标准假设下，贬值改善贸易余额要求出口与进口需求价格弹性的绝对值之和大于 1。 贬值改变相对价格；数量按需求弹性调整；数量效应超过进口单位成本效应时余额改善 原创假设：出口弹性 0.7、进口弹性 0.6，总和 1.3，在充分供给反应和相关模型假设下支持改善；不意味着一定立即改善。",
          "en": "Under standard assumptions including initial trade balance, depreciation improves the trade balance when absolute export and import demand elasticities sum to more than one. Depreciation changes relative prices; volumes respond to demand elasticities; the balance improves when volume effects outweigh the import unit-cost effect Hypothetical scenario: elasticities 0.7 and 0.6 sum to 1.3, supporting improvement with sufficient supply response and the model's assumptions; improvement need not be immediate."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "贬值",
              "en": "depreciation"
            },
            "alternatives": {
              "zh-CN": [
                "贬值",
                "贬值改变相对价格"
              ],
              "en": [
                "depreciation",
                "Depreciation changes relative prices"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "弹性",
              "en": "elasticities"
            },
            "alternatives": {
              "zh-CN": [
                "弹性",
                "数量按需求弹性调整"
              ],
              "en": [
                "elasticities",
                "volumes respond to demand elasticities"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "大于1",
              "en": "greater than one"
            },
            "alternatives": {
              "zh-CN": [
                "大于1",
                "数量效应超过进口单位成本效应时余额改善"
              ],
              "en": [
                "greater than one",
                "the balance improves when volume effects outweigh the import unit-cost effect"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-33-j-curve",
      "slug": "j-curve",
      "section": "4.6",
      "level": "hl",
      "syllabusRefs": [
        "4.6 Balance of payments"
      ],
      "textbookRefs": [
        {
          "chapter": "17",
          "section": "17.4",
          "pages": [
            530
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-28-current-account",
        "u4-29-capital-financial-account",
        "u4-30-bop-identity"
      ],
      "terms": [
        "J 曲线与调整时滞",
        "The J-curve and adjustment lags",
        "合同",
        "contracts",
        "时滞",
        "lags",
        "数量",
        "volumes"
      ],
      "synonyms": {
        "zh-CN": [
          "合同",
          "时滞",
          "数量"
        ],
        "en": [
          "contracts",
          "lags",
          "volumes"
        ]
      },
      "diagramIds": [
        "global-j-curve"
      ],
      "quizIds": [
        "u4-33-j-curve-flash-1",
        "u4-33-j-curve-mcq-1",
        "u4-33-j-curve-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-33-j-curve",
        "locale": "zh-CN",
        "title": "J 曲线与调整时滞",
        "takeaway": "贬值后贸易余额可能先恶化后改善，因为合同与消费习惯使数量反应滞后于进口价格变化。",
        "definition": "贬值后贸易余额可能先恶化后改善，因为合同与消费习惯使数量反应滞后于进口价格变化。",
        "causalChain": [
          "进口本币单价先上升",
          "短期合同使数量调整缓慢",
          "长期弹性增大可能改善余额"
        ],
        "misconceptions": [
          "J 形只是可能路径；若长期弹性不足或供给受限，余额可能始终不改善。"
        ],
        "examApplication": [
          "声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
        ],
        "summary": [
          "贬值后贸易余额可能先恶化后改善，因为合同与消费习惯使数量反应滞后于进口价格变化。",
          "J 形只是可能路径；若长期弹性不足或供给受限，余额可能始终不改善。"
        ],
        "explanation": "进口本币单价先上升。短期合同使数量调整缓慢。长期弹性增大可能改善余额。\n\n### 原创情境与推导\n\n原创假设：进口燃料合同量短期固定，贬值先增加账单；之后企业节能并改用本地投入，进口量才下降。\n\nJ 形只是可能路径；若长期弹性不足或供给受限，余额可能始终不改善。\n\n声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
      },
      "en": {
        "id": "u4-33-j-curve",
        "locale": "en",
        "title": "The J-curve and adjustment lags",
        "takeaway": "After depreciation the trade balance may first worsen and later improve because contracts and habits delay quantity responses relative to import-price changes.",
        "definition": "After depreciation the trade balance may first worsen and later improve because contracts and habits delay quantity responses relative to import-price changes.",
        "causalChain": [
          "Home-currency import prices rise first",
          "contracts slow initial volume adjustment",
          "higher long-run elasticities may improve the balance"
        ],
        "misconceptions": [
          "The J shape is only a possible path; weak long-run elasticities or supply constraints can prevent improvement."
        ],
        "examApplication": [
          "Declare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
        ],
        "summary": [
          "After depreciation the trade balance may first worsen and later improve because contracts and habits delay quantity responses relative to import-price changes.",
          "The J shape is only a possible path; weak long-run elasticities or supply constraints can prevent improvement."
        ],
        "explanation": "Home-currency import prices rise first.  contracts slow initial volume adjustment.  higher long-run elasticities may improve the balance.\n\n### Original scenario and reasoning\n\nHypothetical scenario: contracted fuel volumes initially remain fixed, so depreciation raises the bill first. Firms later conserve energy and substitute domestic inputs, reducing imports.\n\nThe J shape is only a possible path; weak long-run elasticities or supply constraints can prevent improvement.\n\nDeclare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
      }
    },
    "practice": [
      {
        "id": "u4-33-j-curve-flash-1",
        "knowledgePointId": "u4-33-j-curve",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“J 曲线与调整时滞”，并说明一个关键条件。",
          "en": "Explain The J-curve and adjustment lags and state one important condition."
        },
        "answer": {
          "zh-CN": "贬值后贸易余额可能先恶化后改善，因为合同与消费习惯使数量反应滞后于进口价格变化。",
          "en": "After depreciation the trade balance may first worsen and later improve because contracts and habits delay quantity responses relative to import-price changes."
        },
        "explanation": {
          "zh-CN": "J 形只是可能路径；若长期弹性不足或供给受限，余额可能始终不改善。",
          "en": "The J shape is only a possible path; weak long-run elasticities or supply constraints can prevent improvement."
        }
      },
      {
        "id": "u4-33-j-curve-mcq-1",
        "knowledgePointId": "u4-33-j-curve",
        "type": "mcq",
        "prompt": {
          "zh-CN": "J 曲线初期恶化主要反映什么？",
          "en": "What chiefly explains initial J-curve deterioration?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "数量调整慢于价格",
            "en": "Quantities adjust more slowly than prices"
          },
          {
            "id": "b",
            "zh-CN": "出口永远消失",
            "en": "Exports vanish forever"
          },
          {
            "id": "c",
            "zh-CN": "进口单价必下降",
            "en": "Import unit prices must fall"
          },
          {
            "id": "d",
            "zh-CN": "弹性总等于零",
            "en": "Elasticities are always zero"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "数量调整慢于价格。 进口本币单价先上升；短期合同使数量调整缓慢；长期弹性增大可能改善余额 J 形只是可能路径；若长期弹性不足或供给受限，余额可能始终不改善。",
          "en": "Quantities adjust more slowly than prices. Home-currency import prices rise first; contracts slow initial volume adjustment; higher long-run elasticities may improve the balance The J shape is only a possible path; weak long-run elasticities or supply constraints can prevent improvement."
        }
      },
      {
        "id": "u4-33-j-curve-short-1",
        "knowledgePointId": "u4-33-j-curve",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释J 曲线与调整时滞的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of The J-curve and adjustment lags and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "贬值后贸易余额可能先恶化后改善，因为合同与消费习惯使数量反应滞后于进口价格变化。 进口本币单价先上升；短期合同使数量调整缓慢；长期弹性增大可能改善余额 原创假设：进口燃料合同量短期固定，贬值先增加账单；之后企业节能并改用本地投入，进口量才下降。",
          "en": "After depreciation the trade balance may first worsen and later improve because contracts and habits delay quantity responses relative to import-price changes. Home-currency import prices rise first; contracts slow initial volume adjustment; higher long-run elasticities may improve the balance Hypothetical scenario: contracted fuel volumes initially remain fixed, so depreciation raises the bill first. Firms later conserve energy and substitute domestic inputs, reducing imports."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "合同",
              "en": "contracts"
            },
            "alternatives": {
              "zh-CN": [
                "合同",
                "进口本币单价先上升"
              ],
              "en": [
                "contracts",
                "Home-currency import prices rise first"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "时滞",
              "en": "lags"
            },
            "alternatives": {
              "zh-CN": [
                "时滞",
                "短期合同使数量调整缓慢"
              ],
              "en": [
                "lags",
                "contracts slow initial volume adjustment"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "数量",
              "en": "volumes"
            },
            "alternatives": {
              "zh-CN": [
                "数量",
                "长期弹性增大可能改善余额"
              ],
              "en": [
                "volumes",
                "higher long-run elasticities may improve the balance"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-34-imbalance-policies",
      "slug": "imbalance-policies",
      "section": "4.6",
      "level": "hl",
      "syllabusRefs": [
        "4.6 Balance of payments"
      ],
      "textbookRefs": [
        {
          "chapter": "17",
          "section": "17.4",
          "pages": [
            530
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-28-current-account",
        "u4-29-capital-financial-account",
        "u4-30-bop-identity"
      ],
      "terms": [
        "支出转换、支出减少与供给侧措施",
        "Expenditure switching, reduction and supply policies",
        "转换",
        "switching",
        "紧缩",
        "contraction",
        "生产率",
        "productivity"
      ],
      "synonyms": {
        "zh-CN": [
          "转换",
          "紧缩",
          "生产率"
        ],
        "en": [
          "switching",
          "contraction",
          "productivity"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-34-imbalance-policies-flash-1",
        "u4-34-imbalance-policies-mcq-1",
        "u4-34-imbalance-policies-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-34-imbalance-policies",
        "locale": "zh-CN",
        "title": "支出转换、支出减少与供给侧措施",
        "takeaway": "经常账户政策可转换支出来源、减少总支出或改善供给竞争力，各有时滞和宏观目标代价。",
        "definition": "经常账户政策可转换支出来源、减少总支出或改善供给竞争力，各有时滞和宏观目标代价。",
        "causalChain": [
          "转换政策改变相对价格",
          "紧缩减少进口需求",
          "生产率政策改善长期竞争力"
        ],
        "misconceptions": [
          "不能忽略汇率的反向渠道，也不能把需求压缩导致的逆差改善当作无成本成功。"
        ],
        "examApplication": [
          "声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
        ],
        "summary": [
          "经常账户政策可转换支出来源、减少总支出或改善供给竞争力，各有时滞和宏观目标代价。",
          "不能忽略汇率的反向渠道，也不能把需求压缩导致的逆差改善当作无成本成功。"
        ],
        "explanation": "转换政策改变相对价格。紧缩减少进口需求。生产率政策改善长期竞争力。\n\n### 原创情境与推导\n\n原创假设：加息压低消费和进口可能缩小逆差，却增加失业且可能吸引资本升值；培训与物流改善较慢但可提高出口能力。\n\n不能忽略汇率的反向渠道，也不能把需求压缩导致的逆差改善当作无成本成功。\n\n声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
      },
      "en": {
        "id": "u4-34-imbalance-policies",
        "locale": "en",
        "title": "Expenditure switching, reduction and supply policies",
        "takeaway": "Current-account policies can switch spending sources, reduce total expenditure or improve supply competitiveness, each with lags and macroeconomic trade-offs.",
        "definition": "Current-account policies can switch spending sources, reduce total expenditure or improve supply competitiveness, each with lags and macroeconomic trade-offs.",
        "causalChain": [
          "Switching policies alter relative prices",
          "contraction reduces import demand",
          "productivity policy improves long-run competitiveness"
        ],
        "misconceptions": [
          "Do not omit the exchange-rate counterchannel or treat deficit reduction through demand compression as costless."
        ],
        "examApplication": [
          "Declare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
        ],
        "summary": [
          "Current-account policies can switch spending sources, reduce total expenditure or improve supply competitiveness, each with lags and macroeconomic trade-offs.",
          "Do not omit the exchange-rate counterchannel or treat deficit reduction through demand compression as costless."
        ],
        "explanation": "Switching policies alter relative prices.  contraction reduces import demand.  productivity policy improves long-run competitiveness.\n\n### Original scenario and reasoning\n\nHypothetical scenario: higher rates may cut consumption and imports but raise unemployment and attract appreciating capital flows. Training and logistics take longer but can improve export capacity.\n\nDo not omit the exchange-rate counterchannel or treat deficit reduction through demand compression as costless.\n\nDeclare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
      }
    },
    "practice": [
      {
        "id": "u4-34-imbalance-policies-flash-1",
        "knowledgePointId": "u4-34-imbalance-policies",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“支出转换、支出减少与供给侧措施”，并说明一个关键条件。",
          "en": "Explain Expenditure switching, reduction and supply policies and state one important condition."
        },
        "answer": {
          "zh-CN": "经常账户政策可转换支出来源、减少总支出或改善供给竞争力，各有时滞和宏观目标代价。",
          "en": "Current-account policies can switch spending sources, reduce total expenditure or improve supply competitiveness, each with lags and macroeconomic trade-offs."
        },
        "explanation": {
          "zh-CN": "不能忽略汇率的反向渠道，也不能把需求压缩导致的逆差改善当作无成本成功。",
          "en": "Do not omit the exchange-rate counterchannel or treat deficit reduction through demand compression as costless."
        }
      },
      {
        "id": "u4-34-imbalance-policies-mcq-1",
        "knowledgePointId": "u4-34-imbalance-policies",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪项属于长期供给改善？",
          "en": "Which is a long-run supply improvement?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只减少消费",
            "en": "Only reducing consumption"
          },
          {
            "id": "b",
            "zh-CN": "提高技能和物流效率",
            "en": "Improving skills and logistics"
          },
          {
            "id": "c",
            "zh-CN": "直接配给所有进口",
            "en": "Directly rationing every import"
          },
          {
            "id": "d",
            "zh-CN": "仅改变记账符号",
            "en": "Only changing accounting signs"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "提高技能和物流效率。 转换政策改变相对价格；紧缩减少进口需求；生产率政策改善长期竞争力 不能忽略汇率的反向渠道，也不能把需求压缩导致的逆差改善当作无成本成功。",
          "en": "Improving skills and logistics. Switching policies alter relative prices; contraction reduces import demand; productivity policy improves long-run competitiveness Do not omit the exchange-rate counterchannel or treat deficit reduction through demand compression as costless."
        }
      },
      {
        "id": "u4-34-imbalance-policies-short-1",
        "knowledgePointId": "u4-34-imbalance-policies",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释支出转换、支出减少与供给侧措施的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Expenditure switching, reduction and supply policies and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "经常账户政策可转换支出来源、减少总支出或改善供给竞争力，各有时滞和宏观目标代价。 转换政策改变相对价格；紧缩减少进口需求；生产率政策改善长期竞争力 原创假设：加息压低消费和进口可能缩小逆差，却增加失业且可能吸引资本升值；培训与物流改善较慢但可提高出口能力。",
          "en": "Current-account policies can switch spending sources, reduce total expenditure or improve supply competitiveness, each with lags and macroeconomic trade-offs. Switching policies alter relative prices; contraction reduces import demand; productivity policy improves long-run competitiveness Hypothetical scenario: higher rates may cut consumption and imports but raise unemployment and attract appreciating capital flows. Training and logistics take longer but can improve export capacity."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "转换",
              "en": "switching"
            },
            "alternatives": {
              "zh-CN": [
                "转换",
                "转换政策改变相对价格"
              ],
              "en": [
                "switching",
                "Switching policies alter relative prices"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "紧缩",
              "en": "contraction"
            },
            "alternatives": {
              "zh-CN": [
                "紧缩",
                "紧缩减少进口需求"
              ],
              "en": [
                "contraction",
                "contraction reduces import demand"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "生产率",
              "en": "productivity"
            },
            "alternatives": {
              "zh-CN": [
                "生产率",
                "生产率政策改善长期竞争力"
              ],
              "en": [
                "productivity",
                "productivity policy improves long-run competitiveness"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-35-sustainable-development",
      "slug": "sustainable-development",
      "section": "4.7",
      "level": "core",
      "syllabusRefs": [
        "4.7 Sustainable development"
      ],
      "textbookRefs": [
        {
          "chapter": "18",
          "section": "18.1",
          "pages": [
            540
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-36-environment-poverty",
        "u4-37-sdg-policy"
      ],
      "terms": [
        "增长、发展与可持续性",
        "Growth, development and sustainability",
        "发展",
        "development",
        "自然资本",
        "natural capital",
        "后代",
        "future generations"
      ],
      "synonyms": {
        "zh-CN": [
          "发展",
          "自然资本",
          "后代"
        ],
        "en": [
          "development",
          "natural capital",
          "future generations"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-35-sustainable-development-flash-1",
        "u4-35-sustainable-development-mcq-1",
        "u4-35-sustainable-development-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-35-sustainable-development",
        "locale": "zh-CN",
        "title": "增长、发展与可持续性",
        "takeaway": "经济发展涵盖健康、教育、机会和生活质量；可持续发展要求满足当前需要而不损害后代满足需要的能力。",
        "definition": "经济发展涵盖健康、教育、机会和生活质量；可持续发展要求满足当前需要而不损害后代满足需要的能力。",
        "causalChain": [
          "产出增长扩大可用资源",
          "分配与公共服务影响能力",
          "自然资本保护维持未来选择"
        ],
        "misconceptions": [
          "增长可能资助发展，但并非充分条件；可持续性也包含代际公平。"
        ],
        "examApplication": [
          "连接当代、代际公平与自然资本，说明政策协同、机会成本和可观察指标。"
        ],
        "summary": [
          "经济发展涵盖健康、教育、机会和生活质量；可持续发展要求满足当前需要而不损害后代满足需要的能力。",
          "增长可能资助发展，但并非充分条件；可持续性也包含代际公平。"
        ],
        "explanation": "产出增长扩大可用资源。分配与公共服务影响能力。自然资本保护维持未来选择。\n\n### 原创情境与推导\n\n原创假设：采矿提高 GDP，但污染水源并挤压农业，不能只用产出增长判断发展；需衡量健康、收入分配和生态损失。\n\n增长可能资助发展，但并非充分条件；可持续性也包含代际公平。\n\n连接当代、代际公平与自然资本，说明政策协同、机会成本和可观察指标。"
      },
      "en": {
        "id": "u4-35-sustainable-development",
        "locale": "en",
        "title": "Growth, development and sustainability",
        "takeaway": "Development concerns health, education, opportunity and quality of life. Sustainable development meets present needs without compromising future generations' ability to meet theirs.",
        "definition": "Development concerns health, education, opportunity and quality of life. Sustainable development meets present needs without compromising future generations' ability to meet theirs.",
        "causalChain": [
          "Output growth expands available resources",
          "distribution and public services shape capabilities",
          "natural-capital protection preserves future options"
        ],
        "misconceptions": [
          "Growth can finance development but is not sufficient; sustainability includes intergenerational equity."
        ],
        "examApplication": [
          "Connect current and intergenerational equity with natural capital, explaining synergies, opportunity costs and observable indicators."
        ],
        "summary": [
          "Development concerns health, education, opportunity and quality of life. Sustainable development meets present needs without compromising future generations' ability to meet theirs.",
          "Growth can finance development but is not sufficient; sustainability includes intergenerational equity."
        ],
        "explanation": "Output growth expands available resources.  distribution and public services shape capabilities.  natural-capital protection preserves future options.\n\n### Original scenario and reasoning\n\nHypothetical scenario: mining raises GDP but pollutes water and harms farming. Evaluate health, distribution and ecological losses alongside output.\n\nGrowth can finance development but is not sufficient; sustainability includes intergenerational equity.\n\nConnect current and intergenerational equity with natural capital, explaining synergies, opportunity costs and observable indicators."
      }
    },
    "practice": [
      {
        "id": "u4-35-sustainable-development-flash-1",
        "knowledgePointId": "u4-35-sustainable-development",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“增长、发展与可持续性”，并说明一个关键条件。",
          "en": "Explain Growth, development and sustainability and state one important condition."
        },
        "answer": {
          "zh-CN": "经济发展涵盖健康、教育、机会和生活质量；可持续发展要求满足当前需要而不损害后代满足需要的能力。",
          "en": "Development concerns health, education, opportunity and quality of life. Sustainable development meets present needs without compromising future generations' ability to meet theirs."
        },
        "explanation": {
          "zh-CN": "增长可能资助发展，但并非充分条件；可持续性也包含代际公平。",
          "en": "Growth can finance development but is not sufficient; sustainability includes intergenerational equity."
        }
      },
      {
        "id": "u4-35-sustainable-development-mcq-1",
        "knowledgePointId": "u4-35-sustainable-development",
        "type": "mcq",
        "prompt": {
          "zh-CN": "GDP 增长但水源污染扩大，应补充衡量什么？",
          "en": "If GDP rises while water pollution worsens, what else should be measured?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只看 GDP 总量",
            "en": "Only total GDP"
          },
          {
            "id": "b",
            "zh-CN": "只看出口收入",
            "en": "Only export receipts"
          },
          {
            "id": "c",
            "zh-CN": "健康与自然资本损失",
            "en": "Health and natural-capital losses"
          },
          {
            "id": "d",
            "zh-CN": "不需考虑未来",
            "en": "No need to consider the future"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "健康与自然资本损失。 产出增长扩大可用资源；分配与公共服务影响能力；自然资本保护维持未来选择 增长可能资助发展，但并非充分条件；可持续性也包含代际公平。",
          "en": "Health and natural-capital losses. Output growth expands available resources; distribution and public services shape capabilities; natural-capital protection preserves future options Growth can finance development but is not sufficient; sustainability includes intergenerational equity."
        }
      },
      {
        "id": "u4-35-sustainable-development-short-1",
        "knowledgePointId": "u4-35-sustainable-development",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释增长、发展与可持续性的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Growth, development and sustainability and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "经济发展涵盖健康、教育、机会和生活质量；可持续发展要求满足当前需要而不损害后代满足需要的能力。 产出增长扩大可用资源；分配与公共服务影响能力；自然资本保护维持未来选择 原创假设：采矿提高 GDP，但污染水源并挤压农业，不能只用产出增长判断发展；需衡量健康、收入分配和生态损失。",
          "en": "Development concerns health, education, opportunity and quality of life. Sustainable development meets present needs without compromising future generations' ability to meet theirs. Output growth expands available resources; distribution and public services shape capabilities; natural-capital protection preserves future options Hypothetical scenario: mining raises GDP but pollutes water and harms farming. Evaluate health, distribution and ecological losses alongside output."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "发展",
              "en": "development"
            },
            "alternatives": {
              "zh-CN": [
                "发展",
                "产出增长扩大可用资源"
              ],
              "en": [
                "development",
                "Output growth expands available resources"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "自然资本",
              "en": "natural capital"
            },
            "alternatives": {
              "zh-CN": [
                "自然资本",
                "分配与公共服务影响能力"
              ],
              "en": [
                "natural capital",
                "distribution and public services shape capabilities"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "后代",
              "en": "future generations"
            },
            "alternatives": {
              "zh-CN": [
                "后代",
                "自然资本保护维持未来选择"
              ],
              "en": [
                "future generations",
                "natural-capital protection preserves future options"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-36-environment-poverty",
      "slug": "environment-poverty",
      "section": "4.7",
      "level": "hl",
      "syllabusRefs": [
        "4.7 Sustainable development"
      ],
      "textbookRefs": [
        {
          "chapter": "18",
          "section": "18.1",
          "pages": [
            540
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-35-sustainable-development",
        "u4-37-sdg-policy"
      ],
      "terms": [
        "贫困、环境与共同资源",
        "Poverty, environment and common resources",
        "贫困",
        "poverty",
        "资源",
        "resources",
        "生计",
        "livelihoods"
      ],
      "synonyms": {
        "zh-CN": [
          "贫困",
          "资源",
          "生计"
        ],
        "en": [
          "poverty",
          "resources",
          "livelihoods"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-36-environment-poverty-flash-1",
        "u4-36-environment-poverty-mcq-1",
        "u4-36-environment-poverty-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-36-environment-poverty",
        "locale": "zh-CN",
        "title": "贫困、环境与共同资源",
        "takeaway": "贫困可能迫使家庭依赖短期资源开采，环境退化又削弱生计；产权、替代收入和公共服务影响这一循环。",
        "definition": "贫困可能迫使家庭依赖短期资源开采，环境退化又削弱生计；产权、替代收入和公共服务影响这一循环。",
        "causalChain": [
          "低收入限制替代选择",
          "过度使用共同资源",
          "资源退化使收入更脆弱"
        ],
        "misconceptions": [
          "环境破坏也可能来自富裕群体的高消费；不能把责任全部归于穷人。"
        ],
        "examApplication": [
          "连接当代、代际公平与自然资本，说明政策协同、机会成本和可观察指标。"
        ],
        "summary": [
          "贫困可能迫使家庭依赖短期资源开采，环境退化又削弱生计；产权、替代收入和公共服务影响这一循环。",
          "环境破坏也可能来自富裕群体的高消费；不能把责任全部归于穷人。"
        ],
        "explanation": "低收入限制替代选择。过度使用共同资源。资源退化使收入更脆弱。\n\n### 原创情境与推导\n\n原创假设：缺乏可靠电力的村庄依赖薪柴，单独禁伐可能伤害穷人；社区管理与清洁能源可同时改善激励和选择。\n\n环境破坏也可能来自富裕群体的高消费；不能把责任全部归于穷人。\n\n连接当代、代际公平与自然资本，说明政策协同、机会成本和可观察指标。"
      },
      "en": {
        "id": "u4-36-environment-poverty",
        "locale": "en",
        "title": "Poverty, environment and common resources",
        "takeaway": "Poverty can push households toward short-run resource extraction, while degradation undermines livelihoods. Property rights, alternative incomes and public services influence the cycle.",
        "definition": "Poverty can push households toward short-run resource extraction, while degradation undermines livelihoods. Property rights, alternative incomes and public services influence the cycle.",
        "causalChain": [
          "Low income restricts alternatives",
          "common resources are overused",
          "degradation makes income more vulnerable"
        ],
        "misconceptions": [
          "High consumption among wealthy groups can also damage the environment; responsibility cannot be assigned solely to poor people."
        ],
        "examApplication": [
          "Connect current and intergenerational equity with natural capital, explaining synergies, opportunity costs and observable indicators."
        ],
        "summary": [
          "Poverty can push households toward short-run resource extraction, while degradation undermines livelihoods. Property rights, alternative incomes and public services influence the cycle.",
          "High consumption among wealthy groups can also damage the environment; responsibility cannot be assigned solely to poor people."
        ],
        "explanation": "Low income restricts alternatives.  common resources are overused.  degradation makes income more vulnerable.\n\n### Original scenario and reasoning\n\nHypothetical scenario: a village without reliable power relies on fuelwood. A logging ban alone may harm poor households; community management and clean energy improve incentives and alternatives together.\n\nHigh consumption among wealthy groups can also damage the environment; responsibility cannot be assigned solely to poor people.\n\nConnect current and intergenerational equity with natural capital, explaining synergies, opportunity costs and observable indicators."
      }
    },
    "practice": [
      {
        "id": "u4-36-environment-poverty-flash-1",
        "knowledgePointId": "u4-36-environment-poverty",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“贫困、环境与共同资源”，并说明一个关键条件。",
          "en": "Explain Poverty, environment and common resources and state one important condition."
        },
        "answer": {
          "zh-CN": "贫困可能迫使家庭依赖短期资源开采，环境退化又削弱生计；产权、替代收入和公共服务影响这一循环。",
          "en": "Poverty can push households toward short-run resource extraction, while degradation undermines livelihoods. Property rights, alternative incomes and public services influence the cycle."
        },
        "explanation": {
          "zh-CN": "环境破坏也可能来自富裕群体的高消费；不能把责任全部归于穷人。",
          "en": "High consumption among wealthy groups can also damage the environment; responsibility cannot be assigned solely to poor people."
        }
      },
      {
        "id": "u4-36-environment-poverty-mcq-1",
        "knowledgePointId": "u4-36-environment-poverty",
        "type": "mcq",
        "prompt": {
          "zh-CN": "什么最可能兼顾生计和资源保护？",
          "en": "What can best support livelihoods and conservation together?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "无补偿全面禁用",
            "en": "A blanket ban without support"
          },
          {
            "id": "b",
            "zh-CN": "放任无限开采",
            "en": "Unlimited unregulated extraction"
          },
          {
            "id": "c",
            "zh-CN": "忽略资源产权",
            "en": "Ignoring resource rights"
          },
          {
            "id": "d",
            "zh-CN": "替代能源加社区管理",
            "en": "Alternative energy plus community management"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "替代能源加社区管理。 低收入限制替代选择；过度使用共同资源；资源退化使收入更脆弱 环境破坏也可能来自富裕群体的高消费；不能把责任全部归于穷人。",
          "en": "Alternative energy plus community management. Low income restricts alternatives; common resources are overused; degradation makes income more vulnerable High consumption among wealthy groups can also damage the environment; responsibility cannot be assigned solely to poor people."
        }
      },
      {
        "id": "u4-36-environment-poverty-short-1",
        "knowledgePointId": "u4-36-environment-poverty",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释贫困、环境与共同资源的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Poverty, environment and common resources and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "贫困可能迫使家庭依赖短期资源开采，环境退化又削弱生计；产权、替代收入和公共服务影响这一循环。 低收入限制替代选择；过度使用共同资源；资源退化使收入更脆弱 原创假设：缺乏可靠电力的村庄依赖薪柴，单独禁伐可能伤害穷人；社区管理与清洁能源可同时改善激励和选择。",
          "en": "Poverty can push households toward short-run resource extraction, while degradation undermines livelihoods. Property rights, alternative incomes and public services influence the cycle. Low income restricts alternatives; common resources are overused; degradation makes income more vulnerable Hypothetical scenario: a village without reliable power relies on fuelwood. A logging ban alone may harm poor households; community management and clean energy improve incentives and alternatives together."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "贫困",
              "en": "poverty"
            },
            "alternatives": {
              "zh-CN": [
                "贫困",
                "低收入限制替代选择"
              ],
              "en": [
                "poverty",
                "Low income restricts alternatives"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "资源",
              "en": "resources"
            },
            "alternatives": {
              "zh-CN": [
                "资源",
                "过度使用共同资源"
              ],
              "en": [
                "resources",
                "common resources are overused"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "生计",
              "en": "livelihoods"
            },
            "alternatives": {
              "zh-CN": [
                "生计",
                "资源退化使收入更脆弱"
              ],
              "en": [
                "livelihoods",
                "degradation makes income more vulnerable"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-37-sdg-policy",
      "slug": "sdg-policy",
      "section": "4.7",
      "level": "core",
      "syllabusRefs": [
        "4.7 Sustainable development"
      ],
      "textbookRefs": [
        {
          "chapter": "18",
          "section": "18.1",
          "pages": [
            540
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-35-sustainable-development",
        "u4-36-environment-poverty"
      ],
      "terms": [
        "可持续发展目标与政策权衡",
        "Sustainable development goals and policy trade-offs",
        "目标",
        "goals",
        "指标",
        "indicators",
        "权衡",
        "trade-offs"
      ],
      "synonyms": {
        "zh-CN": [
          "目标",
          "指标",
          "权衡"
        ],
        "en": [
          "goals",
          "indicators",
          "trade-offs"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-37-sdg-policy-flash-1",
        "u4-37-sdg-policy-mcq-1",
        "u4-37-sdg-policy-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-37-sdg-policy",
        "locale": "zh-CN",
        "title": "可持续发展目标与政策权衡",
        "takeaway": "发展政策需要同时评价减贫、健康、教育、环境和制度目标，用明确指标检验协同与冲突。",
        "definition": "发展政策需要同时评价减贫、健康、教育、环境和制度目标，用明确指标检验协同与冲突。",
        "causalChain": [
          "确定具体目标与基线",
          "识别协同及机会成本",
          "用分组指标追踪结果"
        ],
        "misconceptions": [
          "宣布目标不等于观察到进展；要注明指标、年份和群体。"
        ],
        "examApplication": [
          "连接当代、代际公平与自然资本，说明政策协同、机会成本和可观察指标。"
        ],
        "summary": [
          "发展政策需要同时评价减贫、健康、教育、环境和制度目标，用明确指标检验协同与冲突。",
          "宣布目标不等于观察到进展；要注明指标、年份和群体。"
        ],
        "explanation": "确定具体目标与基线。识别协同及机会成本。用分组指标追踪结果。\n\n### 原创情境与推导\n\n原创假设：清洁公交可减少污染并改善就业可达性，但票价上涨可能排斥低收入者；比较定向补助与财政成本。\n\n宣布目标不等于观察到进展；要注明指标、年份和群体。\n\n连接当代、代际公平与自然资本，说明政策协同、机会成本和可观察指标。"
      },
      "en": {
        "id": "u4-37-sdg-policy",
        "locale": "en",
        "title": "Sustainable development goals and policy trade-offs",
        "takeaway": "Development policy should evaluate poverty, health, education, environment and institutions together, using explicit indicators to test synergies and conflicts.",
        "definition": "Development policy should evaluate poverty, health, education, environment and institutions together, using explicit indicators to test synergies and conflicts.",
        "causalChain": [
          "Set specific goals and baselines",
          "identify synergies and opportunity costs",
          "track outcomes with disaggregated indicators"
        ],
        "misconceptions": [
          "Announcing a goal is not observing progress; specify indicators, years and groups."
        ],
        "examApplication": [
          "Connect current and intergenerational equity with natural capital, explaining synergies, opportunity costs and observable indicators."
        ],
        "summary": [
          "Development policy should evaluate poverty, health, education, environment and institutions together, using explicit indicators to test synergies and conflicts.",
          "Announcing a goal is not observing progress; specify indicators, years and groups."
        ],
        "explanation": "Set specific goals and baselines.  identify synergies and opportunity costs.  track outcomes with disaggregated indicators.\n\n### Original scenario and reasoning\n\nHypothetical scenario: clean buses reduce pollution and improve job access, but higher fares may exclude low-income riders. Compare targeted support with fiscal costs.\n\nAnnouncing a goal is not observing progress; specify indicators, years and groups.\n\nConnect current and intergenerational equity with natural capital, explaining synergies, opportunity costs and observable indicators."
      }
    },
    "practice": [
      {
        "id": "u4-37-sdg-policy-flash-1",
        "knowledgePointId": "u4-37-sdg-policy",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“可持续发展目标与政策权衡”，并说明一个关键条件。",
          "en": "Explain Sustainable development goals and policy trade-offs and state one important condition."
        },
        "answer": {
          "zh-CN": "发展政策需要同时评价减贫、健康、教育、环境和制度目标，用明确指标检验协同与冲突。",
          "en": "Development policy should evaluate poverty, health, education, environment and institutions together, using explicit indicators to test synergies and conflicts."
        },
        "explanation": {
          "zh-CN": "宣布目标不等于观察到进展；要注明指标、年份和群体。",
          "en": "Announcing a goal is not observing progress; specify indicators, years and groups."
        }
      },
      {
        "id": "u4-37-sdg-policy-mcq-1",
        "knowledgePointId": "u4-37-sdg-policy",
        "type": "mcq",
        "prompt": {
          "zh-CN": "判断项目是否促进发展最需要什么？",
          "en": "What is most needed to judge a project's development effect?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "有基线的多维结果指标",
            "en": "Multidimensional outcomes with a baseline"
          },
          {
            "id": "b",
            "zh-CN": "只有项目名称",
            "en": "Only the project name"
          },
          {
            "id": "c",
            "zh-CN": "只统计宣传数量",
            "en": "Only publicity counts"
          },
          {
            "id": "d",
            "zh-CN": "只看支出越多越好",
            "en": "Assume more spending is always better"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "有基线的多维结果指标。 确定具体目标与基线；识别协同及机会成本；用分组指标追踪结果 宣布目标不等于观察到进展；要注明指标、年份和群体。",
          "en": "Multidimensional outcomes with a baseline. Set specific goals and baselines; identify synergies and opportunity costs; track outcomes with disaggregated indicators Announcing a goal is not observing progress; specify indicators, years and groups."
        }
      },
      {
        "id": "u4-37-sdg-policy-short-1",
        "knowledgePointId": "u4-37-sdg-policy",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释可持续发展目标与政策权衡的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Sustainable development goals and policy trade-offs and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "发展政策需要同时评价减贫、健康、教育、环境和制度目标，用明确指标检验协同与冲突。 确定具体目标与基线；识别协同及机会成本；用分组指标追踪结果 原创假设：清洁公交可减少污染并改善就业可达性，但票价上涨可能排斥低收入者；比较定向补助与财政成本。",
          "en": "Development policy should evaluate poverty, health, education, environment and institutions together, using explicit indicators to test synergies and conflicts. Set specific goals and baselines; identify synergies and opportunity costs; track outcomes with disaggregated indicators Hypothetical scenario: clean buses reduce pollution and improve job access, but higher fares may exclude low-income riders. Compare targeted support with fiscal costs."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "目标",
              "en": "goals"
            },
            "alternatives": {
              "zh-CN": [
                "目标",
                "确定具体目标与基线"
              ],
              "en": [
                "goals",
                "Set specific goals and baselines"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "指标",
              "en": "indicators"
            },
            "alternatives": {
              "zh-CN": [
                "指标",
                "识别协同及机会成本"
              ],
              "en": [
                "indicators",
                "identify synergies and opportunity costs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "权衡",
              "en": "trade-offs"
            },
            "alternatives": {
              "zh-CN": [
                "权衡",
                "用分组指标追踪结果"
              ],
              "en": [
                "trade-offs",
                "track outcomes with disaggregated indicators"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-38-development-indicators",
      "slug": "development-indicators",
      "section": "4.8",
      "level": "core",
      "syllabusRefs": [
        "4.8 Measuring development"
      ],
      "textbookRefs": [
        {
          "chapter": "18",
          "section": "18.2",
          "pages": [
            541
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-39-hdi",
        "u4-40-multidimensional-poverty",
        "u4-41-measurement-limits"
      ],
      "terms": [
        "人均收入与 PPP 比较",
        "Income per capita and PPP comparison",
        "人均",
        "per capita",
        "价格水平",
        "price levels",
        "购买力",
        "purchasing power"
      ],
      "synonyms": {
        "zh-CN": [
          "人均",
          "价格水平",
          "购买力"
        ],
        "en": [
          "per capita",
          "price levels",
          "purchasing power"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-38-development-indicators-flash-1",
        "u4-38-development-indicators-mcq-1",
        "u4-38-development-indicators-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-38-development-indicators",
        "locale": "zh-CN",
        "title": "人均收入与 PPP 比较",
        "takeaway": "人均 GNI 衡量平均居民收入，PPP 调整价格水平差异；两者都不能充分揭示分配、公共服务或环境质量。",
        "definition": "人均 GNI 衡量平均居民收入，PPP 调整价格水平差异；两者都不能充分揭示分配、公共服务或环境质量。",
        "causalChain": [
          "总收入除以人口",
          "按购买力调整跨国可比性",
          "用其他指标补充平均数局限"
        ],
        "misconceptions": [
          "PPP 不是外汇市场可交易的汇率，人均收入也不是典型家庭的实际收入。"
        ],
        "examApplication": [
          "说明指标维度、单位、年份及均值局限，用多种证据比较而非只报排名。"
        ],
        "summary": [
          "人均 GNI 衡量平均居民收入，PPP 调整价格水平差异；两者都不能充分揭示分配、公共服务或环境质量。",
          "PPP 不是外汇市场可交易的汇率，人均收入也不是典型家庭的实际收入。"
        ],
        "explanation": "总收入除以人口。按购买力调整跨国可比性。用其他指标补充平均数局限。\n\n### 原创情境与推导\n\n原创假设：A 与 B 汇率换算收入相同，但 A 的基本生活篮子更便宜，PPP 比较可能显示 A 购买力更高；仍需看地区差距。\n\nPPP 不是外汇市场可交易的汇率，人均收入也不是典型家庭的实际收入。\n\n说明指标维度、单位、年份及均值局限，用多种证据比较而非只报排名。"
      },
      "en": {
        "id": "u4-38-development-indicators",
        "locale": "en",
        "title": "Income per capita and PPP comparison",
        "takeaway": "GNI per capita measures average resident income; PPP adjusts for price-level differences. Neither fully captures distribution, public services or environmental quality.",
        "definition": "GNI per capita measures average resident income; PPP adjusts for price-level differences. Neither fully captures distribution, public services or environmental quality.",
        "causalChain": [
          "Divide total income by population",
          "adjust purchasing power for cross-country comparison",
          "add indicators to address average-income limits"
        ],
        "misconceptions": [
          "PPP is not a tradable market exchange rate; average income is not necessarily a typical household's income."
        ],
        "examApplication": [
          "State dimensions, units, years and average-value limits; compare using multiple indicators rather than rankings alone."
        ],
        "summary": [
          "GNI per capita measures average resident income; PPP adjusts for price-level differences. Neither fully captures distribution, public services or environmental quality.",
          "PPP is not a tradable market exchange rate; average income is not necessarily a typical household's income."
        ],
        "explanation": "Divide total income by population.  adjust purchasing power for cross-country comparison.  add indicators to address average-income limits.\n\n### Original scenario and reasoning\n\nHypothetical scenario: A and B have equal exchange-rate-converted income, but basic goods are cheaper in A. PPP may show greater purchasing power in A; regional inequality still matters.\n\nPPP is not a tradable market exchange rate; average income is not necessarily a typical household's income.\n\nState dimensions, units, years and average-value limits; compare using multiple indicators rather than rankings alone."
      }
    },
    "practice": [
      {
        "id": "u4-38-development-indicators-flash-1",
        "knowledgePointId": "u4-38-development-indicators",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“人均收入与 PPP 比较”，并说明一个关键条件。",
          "en": "Explain Income per capita and PPP comparison and state one important condition."
        },
        "answer": {
          "zh-CN": "人均 GNI 衡量平均居民收入，PPP 调整价格水平差异；两者都不能充分揭示分配、公共服务或环境质量。",
          "en": "GNI per capita measures average resident income; PPP adjusts for price-level differences. Neither fully captures distribution, public services or environmental quality."
        },
        "explanation": {
          "zh-CN": "PPP 不是外汇市场可交易的汇率，人均收入也不是典型家庭的实际收入。",
          "en": "PPP is not a tradable market exchange rate; average income is not necessarily a typical household's income."
        }
      },
      {
        "id": "u4-38-development-indicators-mcq-1",
        "knowledgePointId": "u4-38-development-indicators",
        "type": "mcq",
        "prompt": {
          "zh-CN": "PPP 调整主要解决什么问题？",
          "en": "What does PPP adjustment chiefly address?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "自动消除不平等",
            "en": "Automatically eliminating inequality"
          },
          {
            "id": "b",
            "zh-CN": "跨国价格水平差异",
            "en": "Cross-country price-level differences"
          },
          {
            "id": "c",
            "zh-CN": "使所有寿命相等",
            "en": "Equalising all lifespans"
          },
          {
            "id": "d",
            "zh-CN": "衡量全部污染",
            "en": "Measuring all pollution"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "跨国价格水平差异。 总收入除以人口；按购买力调整跨国可比性；用其他指标补充平均数局限 PPP 不是外汇市场可交易的汇率，人均收入也不是典型家庭的实际收入。",
          "en": "Cross-country price-level differences. Divide total income by population; adjust purchasing power for cross-country comparison; add indicators to address average-income limits PPP is not a tradable market exchange rate; average income is not necessarily a typical household's income."
        }
      },
      {
        "id": "u4-38-development-indicators-short-1",
        "knowledgePointId": "u4-38-development-indicators",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释人均收入与 PPP 比较的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Income per capita and PPP comparison and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "人均 GNI 衡量平均居民收入，PPP 调整价格水平差异；两者都不能充分揭示分配、公共服务或环境质量。 总收入除以人口；按购买力调整跨国可比性；用其他指标补充平均数局限 原创假设：A 与 B 汇率换算收入相同，但 A 的基本生活篮子更便宜，PPP 比较可能显示 A 购买力更高；仍需看地区差距。",
          "en": "GNI per capita measures average resident income; PPP adjusts for price-level differences. Neither fully captures distribution, public services or environmental quality. Divide total income by population; adjust purchasing power for cross-country comparison; add indicators to address average-income limits Hypothetical scenario: A and B have equal exchange-rate-converted income, but basic goods are cheaper in A. PPP may show greater purchasing power in A; regional inequality still matters."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "人均",
              "en": "per capita"
            },
            "alternatives": {
              "zh-CN": [
                "人均",
                "总收入除以人口"
              ],
              "en": [
                "per capita",
                "Divide total income by population"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "价格水平",
              "en": "price levels"
            },
            "alternatives": {
              "zh-CN": [
                "价格水平",
                "按购买力调整跨国可比性"
              ],
              "en": [
                "price levels",
                "adjust purchasing power for cross-country comparison"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "购买力",
              "en": "purchasing power"
            },
            "alternatives": {
              "zh-CN": [
                "购买力",
                "用其他指标补充平均数局限"
              ],
              "en": [
                "purchasing power",
                "add indicators to address average-income limits"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-39-hdi",
      "slug": "hdi",
      "section": "4.8",
      "level": "core",
      "syllabusRefs": [
        "4.8 Measuring development"
      ],
      "textbookRefs": [
        {
          "chapter": "18",
          "section": "18.2",
          "pages": [
            541
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-38-development-indicators",
        "u4-40-multidimensional-poverty",
        "u4-41-measurement-limits"
      ],
      "terms": [
        "人类发展指数",
        "The Human Development Index",
        "健康",
        "health",
        "教育",
        "education",
        "收入",
        "income"
      ],
      "synonyms": {
        "zh-CN": [
          "健康",
          "教育",
          "收入"
        ],
        "en": [
          "health",
          "education",
          "income"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-39-hdi-flash-1",
        "u4-39-hdi-mcq-1",
        "u4-39-hdi-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-39-hdi",
        "locale": "zh-CN",
        "title": "人类发展指数",
        "takeaway": "HDI 综合健康、教育与生活水平，使用预期寿命、预期和平均受教育年限、PPP 人均 GNI，并以几何平均组合维度指数。",
        "definition": "HDI 综合健康、教育与生活水平，使用预期寿命、预期和平均受教育年限、PPP 人均 GNI，并以几何平均组合维度指数。",
        "causalChain": [
          "将各维度标准化",
          "教育指标组成教育维度",
          "几何平均限制单一高维度完全补偿低维度"
        ],
        "misconceptions": [
          "HDI 不是三个原始单位直接相加，也不是完整的生态或政治自由指标。"
        ],
        "examApplication": [
          "说明指标维度、单位、年份及均值局限，用多种证据比较而非只报排名。"
        ],
        "summary": [
          "HDI 综合健康、教育与生活水平，使用预期寿命、预期和平均受教育年限、PPP 人均 GNI，并以几何平均组合维度指数。",
          "HDI 不是三个原始单位直接相加，也不是完整的生态或政治自由指标。"
        ],
        "explanation": "将各维度标准化。教育指标组成教育维度。几何平均限制单一高维度完全补偿低维度。\n\n### 原创情境与推导\n\n原创假设：甲乙收入类似，甲的寿命与教育更高，HDI 可能更高；但国平均仍掩盖性别与地区差距。\n\nHDI 不是三个原始单位直接相加，也不是完整的生态或政治自由指标。\n\n说明指标维度、单位、年份及均值局限，用多种证据比较而非只报排名。"
      },
      "en": {
        "id": "u4-39-hdi",
        "locale": "en",
        "title": "The Human Development Index",
        "takeaway": "HDI combines health, education and living standards using life expectancy, expected and mean schooling years, and PPP GNI per capita, with a geometric mean of dimension indices.",
        "definition": "HDI combines health, education and living standards using life expectancy, expected and mean schooling years, and PPP GNI per capita, with a geometric mean of dimension indices.",
        "causalChain": [
          "Normalise dimensions",
          "combine schooling indicators into education",
          "the geometric mean limits full compensation of a weak dimension by a strong one"
        ],
        "misconceptions": [
          "HDI does not add raw units directly and is not a comprehensive ecological or political-freedom measure."
        ],
        "examApplication": [
          "State dimensions, units, years and average-value limits; compare using multiple indicators rather than rankings alone."
        ],
        "summary": [
          "HDI combines health, education and living standards using life expectancy, expected and mean schooling years, and PPP GNI per capita, with a geometric mean of dimension indices.",
          "HDI does not add raw units directly and is not a comprehensive ecological or political-freedom measure."
        ],
        "explanation": "Normalise dimensions.  combine schooling indicators into education.  the geometric mean limits full compensation of a weak dimension by a strong one.\n\n### Original scenario and reasoning\n\nHypothetical scenario: two economies have similar income but one has better longevity and education, potentially giving it higher HDI. National averages still hide gender and regional gaps.\n\nHDI does not add raw units directly and is not a comprehensive ecological or political-freedom measure.\n\nState dimensions, units, years and average-value limits; compare using multiple indicators rather than rankings alone."
      }
    },
    "practice": [
      {
        "id": "u4-39-hdi-flash-1",
        "knowledgePointId": "u4-39-hdi",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“人类发展指数”，并说明一个关键条件。",
          "en": "Explain The Human Development Index and state one important condition."
        },
        "answer": {
          "zh-CN": "HDI 综合健康、教育与生活水平，使用预期寿命、预期和平均受教育年限、PPP 人均 GNI，并以几何平均组合维度指数。",
          "en": "HDI combines health, education and living standards using life expectancy, expected and mean schooling years, and PPP GNI per capita, with a geometric mean of dimension indices."
        },
        "explanation": {
          "zh-CN": "HDI 不是三个原始单位直接相加，也不是完整的生态或政治自由指标。",
          "en": "HDI does not add raw units directly and is not a comprehensive ecological or political-freedom measure."
        }
      },
      {
        "id": "u4-39-hdi-mcq-1",
        "knowledgePointId": "u4-39-hdi",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪个属于 HDI 的健康指标？",
          "en": "Which is HDI's health indicator?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "货物出口",
            "en": "Goods exports"
          },
          {
            "id": "b",
            "zh-CN": "汇率波动",
            "en": "Exchange-rate volatility"
          },
          {
            "id": "c",
            "zh-CN": "出生时预期寿命",
            "en": "Life expectancy at birth"
          },
          {
            "id": "d",
            "zh-CN": "关税收入",
            "en": "Tariff revenue"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "出生时预期寿命。 将各维度标准化；教育指标组成教育维度；几何平均限制单一高维度完全补偿低维度 HDI 不是三个原始单位直接相加，也不是完整的生态或政治自由指标。",
          "en": "Life expectancy at birth. Normalise dimensions; combine schooling indicators into education; the geometric mean limits full compensation of a weak dimension by a strong one HDI does not add raw units directly and is not a comprehensive ecological or political-freedom measure."
        }
      },
      {
        "id": "u4-39-hdi-short-1",
        "knowledgePointId": "u4-39-hdi",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释人类发展指数的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of The Human Development Index and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "HDI 综合健康、教育与生活水平，使用预期寿命、预期和平均受教育年限、PPP 人均 GNI，并以几何平均组合维度指数。 将各维度标准化；教育指标组成教育维度；几何平均限制单一高维度完全补偿低维度 原创假设：甲乙收入类似，甲的寿命与教育更高，HDI 可能更高；但国平均仍掩盖性别与地区差距。",
          "en": "HDI combines health, education and living standards using life expectancy, expected and mean schooling years, and PPP GNI per capita, with a geometric mean of dimension indices. Normalise dimensions; combine schooling indicators into education; the geometric mean limits full compensation of a weak dimension by a strong one Hypothetical scenario: two economies have similar income but one has better longevity and education, potentially giving it higher HDI. National averages still hide gender and regional gaps."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "健康",
              "en": "health"
            },
            "alternatives": {
              "zh-CN": [
                "健康",
                "将各维度标准化"
              ],
              "en": [
                "health",
                "Normalise dimensions"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "教育",
              "en": "education"
            },
            "alternatives": {
              "zh-CN": [
                "教育",
                "教育指标组成教育维度"
              ],
              "en": [
                "education",
                "combine schooling indicators into education"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "收入",
              "en": "income"
            },
            "alternatives": {
              "zh-CN": [
                "收入",
                "几何平均限制单一高维度完全补偿低维度"
              ],
              "en": [
                "income",
                "the geometric mean limits full compensation of a weak dimension by a strong one"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-40-multidimensional-poverty",
      "slug": "multidimensional-poverty",
      "section": "4.8",
      "level": "core",
      "syllabusRefs": [
        "4.8 Measuring development"
      ],
      "textbookRefs": [
        {
          "chapter": "18",
          "section": "18.2",
          "pages": [
            541
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-38-development-indicators",
        "u4-39-hdi",
        "u4-41-measurement-limits"
      ],
      "terms": [
        "多维贫困与不平等调整",
        "Multidimensional poverty and inequality adjustment",
        "剥夺",
        "deprivations",
        "发生率",
        "incidence",
        "强度",
        "intensity"
      ],
      "synonyms": {
        "zh-CN": [
          "剥夺",
          "发生率",
          "强度"
        ],
        "en": [
          "deprivations",
          "incidence",
          "intensity"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-40-multidimensional-poverty-flash-1",
        "u4-40-multidimensional-poverty-mcq-1",
        "u4-40-multidimensional-poverty-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-40-multidimensional-poverty",
        "locale": "zh-CN",
        "title": "多维贫困与不平等调整",
        "takeaway": "多维贫困指标结合健康、教育和生活条件的重叠剥夺；不平等调整的 HDI 则反映各维度分配差异。",
        "definition": "多维贫困指标结合健康、教育和生活条件的重叠剥夺；不平等调整的 HDI 则反映各维度分配差异。",
        "causalChain": [
          "识别家庭剥夺",
          "按明确权重和阈值分类",
          "结合发生率与强度判断贫困"
        ],
        "misconceptions": [
          "不同指标回答不同问题，不能把多维贫困率、Gini 与 HDI 当成同一种量。"
        ],
        "examApplication": [
          "说明指标维度、单位、年份及均值局限，用多种证据比较而非只报排名。"
        ],
        "summary": [
          "多维贫困指标结合健康、教育和生活条件的重叠剥夺；不平等调整的 HDI 则反映各维度分配差异。",
          "不同指标回答不同问题，不能把多维贫困率、Gini 与 HDI 当成同一种量。"
        ],
        "explanation": "识别家庭剥夺。按明确权重和阈值分类。结合发生率与强度判断贫困。\n\n### 原创情境与推导\n\n原创假设：收入略高于贫困线的家庭仍可能缺安全饮水和教育；只用收入会漏掉这些剥夺。指标权重会影响排名。\n\n不同指标回答不同问题，不能把多维贫困率、Gini 与 HDI 当成同一种量。\n\n说明指标维度、单位、年份及均值局限，用多种证据比较而非只报排名。"
      },
      "en": {
        "id": "u4-40-multidimensional-poverty",
        "locale": "en",
        "title": "Multidimensional poverty and inequality adjustment",
        "takeaway": "Multidimensional poverty measures overlapping deprivations in health, education and living conditions; inequality-adjusted HDI reflects distribution within dimensions.",
        "definition": "Multidimensional poverty measures overlapping deprivations in health, education and living conditions; inequality-adjusted HDI reflects distribution within dimensions.",
        "causalChain": [
          "Identify household deprivations",
          "classify using explicit weights and thresholds",
          "combine incidence and intensity to assess poverty"
        ],
        "misconceptions": [
          "Different indicators answer different questions; multidimensional poverty, Gini and HDI are not interchangeable."
        ],
        "examApplication": [
          "State dimensions, units, years and average-value limits; compare using multiple indicators rather than rankings alone."
        ],
        "summary": [
          "Multidimensional poverty measures overlapping deprivations in health, education and living conditions; inequality-adjusted HDI reflects distribution within dimensions.",
          "Different indicators answer different questions; multidimensional poverty, Gini and HDI are not interchangeable."
        ],
        "explanation": "Identify household deprivations.  classify using explicit weights and thresholds.  combine incidence and intensity to assess poverty.\n\n### Original scenario and reasoning\n\nHypothetical scenario: a household just above an income poverty line may still lack safe water and schooling. Income alone misses these deprivations, while indicator weights affect rankings.\n\nDifferent indicators answer different questions; multidimensional poverty, Gini and HDI are not interchangeable.\n\nState dimensions, units, years and average-value limits; compare using multiple indicators rather than rankings alone."
      }
    },
    "practice": [
      {
        "id": "u4-40-multidimensional-poverty-flash-1",
        "knowledgePointId": "u4-40-multidimensional-poverty",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“多维贫困与不平等调整”，并说明一个关键条件。",
          "en": "Explain Multidimensional poverty and inequality adjustment and state one important condition."
        },
        "answer": {
          "zh-CN": "多维贫困指标结合健康、教育和生活条件的重叠剥夺；不平等调整的 HDI 则反映各维度分配差异。",
          "en": "Multidimensional poverty measures overlapping deprivations in health, education and living conditions; inequality-adjusted HDI reflects distribution within dimensions."
        },
        "explanation": {
          "zh-CN": "不同指标回答不同问题，不能把多维贫困率、Gini 与 HDI 当成同一种量。",
          "en": "Different indicators answer different questions; multidimensional poverty, Gini and HDI are not interchangeable."
        }
      },
      {
        "id": "u4-40-multidimensional-poverty-mcq-1",
        "knowledgePointId": "u4-40-multidimensional-poverty",
        "type": "mcq",
        "prompt": {
          "zh-CN": "为何要补充多维贫困指标？",
          "en": "Why add multidimensional poverty indicators?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "收入完全无用",
            "en": "Income is entirely useless"
          },
          {
            "id": "b",
            "zh-CN": "所有权重天然唯一",
            "en": "Weights are uniquely predetermined"
          },
          {
            "id": "c",
            "zh-CN": "可以不采集数据",
            "en": "No data collection is needed"
          },
          {
            "id": "d",
            "zh-CN": "收入未显示所有基本服务剥夺",
            "en": "Income misses some basic-service deprivations"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "收入未显示所有基本服务剥夺。 识别家庭剥夺；按明确权重和阈值分类；结合发生率与强度判断贫困 不同指标回答不同问题，不能把多维贫困率、Gini 与 HDI 当成同一种量。",
          "en": "Income misses some basic-service deprivations. Identify household deprivations; classify using explicit weights and thresholds; combine incidence and intensity to assess poverty Different indicators answer different questions; multidimensional poverty, Gini and HDI are not interchangeable."
        }
      },
      {
        "id": "u4-40-multidimensional-poverty-short-1",
        "knowledgePointId": "u4-40-multidimensional-poverty",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释多维贫困与不平等调整的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Multidimensional poverty and inequality adjustment and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "多维贫困指标结合健康、教育和生活条件的重叠剥夺；不平等调整的 HDI 则反映各维度分配差异。 识别家庭剥夺；按明确权重和阈值分类；结合发生率与强度判断贫困 原创假设：收入略高于贫困线的家庭仍可能缺安全饮水和教育；只用收入会漏掉这些剥夺。指标权重会影响排名。",
          "en": "Multidimensional poverty measures overlapping deprivations in health, education and living conditions; inequality-adjusted HDI reflects distribution within dimensions. Identify household deprivations; classify using explicit weights and thresholds; combine incidence and intensity to assess poverty Hypothetical scenario: a household just above an income poverty line may still lack safe water and schooling. Income alone misses these deprivations, while indicator weights affect rankings."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "剥夺",
              "en": "deprivations"
            },
            "alternatives": {
              "zh-CN": [
                "剥夺",
                "识别家庭剥夺"
              ],
              "en": [
                "deprivations",
                "Identify household deprivations"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "发生率",
              "en": "incidence"
            },
            "alternatives": {
              "zh-CN": [
                "发生率",
                "按明确权重和阈值分类"
              ],
              "en": [
                "incidence",
                "classify using explicit weights and thresholds"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "强度",
              "en": "intensity"
            },
            "alternatives": {
              "zh-CN": [
                "强度",
                "结合发生率与强度判断贫困"
              ],
              "en": [
                "intensity",
                "combine incidence and intensity to assess poverty"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-41-measurement-limits",
      "slug": "measurement-limits",
      "section": "4.8",
      "level": "core",
      "syllabusRefs": [
        "4.8 Measuring development"
      ],
      "textbookRefs": [
        {
          "chapter": "18",
          "section": "18.2",
          "pages": [
            541
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-38-development-indicators",
        "u4-39-hdi",
        "u4-40-multidimensional-poverty"
      ],
      "terms": [
        "发展数据的可比性与局限",
        "Comparability and limits of development data",
        "可比",
        "comparable",
        "数据",
        "data",
        "局限",
        "limits"
      ],
      "synonyms": {
        "zh-CN": [
          "可比",
          "数据",
          "局限"
        ],
        "en": [
          "comparable",
          "data",
          "limits"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-41-measurement-limits-flash-1",
        "u4-41-measurement-limits-mcq-1",
        "u4-41-measurement-limits-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-41-measurement-limits",
        "locale": "zh-CN",
        "title": "发展数据的可比性与局限",
        "takeaway": "发展比较应使用可比年份、定义和人口组，注意非正规经济、统计能力、均值掩盖差异与相关不等于因果。",
        "definition": "发展比较应使用可比年份、定义和人口组，注意非正规经济、统计能力、均值掩盖差异与相关不等于因果。",
        "causalChain": [
          "检查来源和定义",
          "统一年份与可比单位",
          "结合定量指标和情境解释"
        ],
        "misconceptions": [
          "两个指标同时改善不能单独证明某政策造成改善；缺失数据不等于零。"
        ],
        "examApplication": [
          "说明指标维度、单位、年份及均值局限，用多种证据比较而非只报排名。"
        ],
        "summary": [
          "发展比较应使用可比年份、定义和人口组，注意非正规经济、统计能力、均值掩盖差异与相关不等于因果。",
          "两个指标同时改善不能单独证明某政策造成改善；缺失数据不等于零。"
        ],
        "explanation": "检查来源和定义。统一年份与可比单位。结合定量指标和情境解释。\n\n### 原创情境与推导\n\n原创假设：农村调查遗漏偏远家庭，可能高估全国服务覆盖；比较政策前后还需考虑经济周期和其他政策。\n\n两个指标同时改善不能单独证明某政策造成改善；缺失数据不等于零。\n\n说明指标维度、单位、年份及均值局限，用多种证据比较而非只报排名。"
      },
      "en": {
        "id": "u4-41-measurement-limits",
        "locale": "en",
        "title": "Comparability and limits of development data",
        "takeaway": "Development comparisons need comparable years, definitions and population groups, with attention to informality, statistical capacity, hidden disparities and correlation versus causation.",
        "definition": "Development comparisons need comparable years, definitions and population groups, with attention to informality, statistical capacity, hidden disparities and correlation versus causation.",
        "causalChain": [
          "Check sources and definitions",
          "align years and comparable units",
          "combine quantitative measures with context"
        ],
        "misconceptions": [
          "Two improving indicators alone do not prove a policy caused improvement; missing data are not zero."
        ],
        "examApplication": [
          "State dimensions, units, years and average-value limits; compare using multiple indicators rather than rankings alone."
        ],
        "summary": [
          "Development comparisons need comparable years, definitions and population groups, with attention to informality, statistical capacity, hidden disparities and correlation versus causation.",
          "Two improving indicators alone do not prove a policy caused improvement; missing data are not zero."
        ],
        "explanation": "Check sources and definitions.  align years and comparable units.  combine quantitative measures with context.\n\n### Original scenario and reasoning\n\nHypothetical scenario: omitting remote households can overstate national service coverage. Before-after policy comparisons also need business-cycle and other-policy context.\n\nTwo improving indicators alone do not prove a policy caused improvement; missing data are not zero.\n\nState dimensions, units, years and average-value limits; compare using multiple indicators rather than rankings alone."
      }
    },
    "practice": [
      {
        "id": "u4-41-measurement-limits-flash-1",
        "knowledgePointId": "u4-41-measurement-limits",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“发展数据的可比性与局限”，并说明一个关键条件。",
          "en": "Explain Comparability and limits of development data and state one important condition."
        },
        "answer": {
          "zh-CN": "发展比较应使用可比年份、定义和人口组，注意非正规经济、统计能力、均值掩盖差异与相关不等于因果。",
          "en": "Development comparisons need comparable years, definitions and population groups, with attention to informality, statistical capacity, hidden disparities and correlation versus causation."
        },
        "explanation": {
          "zh-CN": "两个指标同时改善不能单独证明某政策造成改善；缺失数据不等于零。",
          "en": "Two improving indicators alone do not prove a policy caused improvement; missing data are not zero."
        }
      },
      {
        "id": "u4-41-measurement-limits-mcq-1",
        "knowledgePointId": "u4-41-measurement-limits",
        "type": "mcq",
        "prompt": {
          "zh-CN": "某地区没有卫生数据应如何处理？",
          "en": "How should missing health data for a region be handled?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "标明缺失并限制结论",
            "en": "Mark it missing and limit conclusions"
          },
          {
            "id": "b",
            "zh-CN": "填为零并排名",
            "en": "Insert zero and rank"
          },
          {
            "id": "c",
            "zh-CN": "默认全国平均完全适用",
            "en": "Assume the national mean applies exactly"
          },
          {
            "id": "d",
            "zh-CN": "宣称没有健康问题",
            "en": "Declare no health problems"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "标明缺失并限制结论。 检查来源和定义；统一年份与可比单位；结合定量指标和情境解释 两个指标同时改善不能单独证明某政策造成改善；缺失数据不等于零。",
          "en": "Mark it missing and limit conclusions. Check sources and definitions; align years and comparable units; combine quantitative measures with context Two improving indicators alone do not prove a policy caused improvement; missing data are not zero."
        }
      },
      {
        "id": "u4-41-measurement-limits-short-1",
        "knowledgePointId": "u4-41-measurement-limits",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释发展数据的可比性与局限的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Comparability and limits of development data and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "发展比较应使用可比年份、定义和人口组，注意非正规经济、统计能力、均值掩盖差异与相关不等于因果。 检查来源和定义；统一年份与可比单位；结合定量指标和情境解释 原创假设：农村调查遗漏偏远家庭，可能高估全国服务覆盖；比较政策前后还需考虑经济周期和其他政策。",
          "en": "Development comparisons need comparable years, definitions and population groups, with attention to informality, statistical capacity, hidden disparities and correlation versus causation. Check sources and definitions; align years and comparable units; combine quantitative measures with context Hypothetical scenario: omitting remote households can overstate national service coverage. Before-after policy comparisons also need business-cycle and other-policy context."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "可比",
              "en": "comparable"
            },
            "alternatives": {
              "zh-CN": [
                "可比",
                "检查来源和定义"
              ],
              "en": [
                "comparable",
                "Check sources and definitions"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "数据",
              "en": "data"
            },
            "alternatives": {
              "zh-CN": [
                "数据",
                "统一年份与可比单位"
              ],
              "en": [
                "data",
                "align years and comparable units"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "局限",
              "en": "limits"
            },
            "alternatives": {
              "zh-CN": [
                "局限",
                "结合定量指标和情境解释"
              ],
              "en": [
                "limits",
                "combine quantitative measures with context"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-42-poverty-cycle",
      "slug": "poverty-cycle",
      "section": "4.9",
      "level": "core",
      "syllabusRefs": [
        "4.9 Barriers to economic growth and development"
      ],
      "textbookRefs": [
        {
          "chapter": "19",
          "section": "19.1",
          "pages": [
            564
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-43-human-capital-infrastructure",
        "u4-44-primary-dependence",
        "u4-45-debt-finance-barriers"
      ],
      "terms": [
        "贫困循环与资本形成",
        "Poverty cycles and capital formation",
        "收入",
        "income",
        "投资",
        "investment",
        "生产率",
        "productivity"
      ],
      "synonyms": {
        "zh-CN": [
          "收入",
          "投资",
          "生产率"
        ],
        "en": [
          "income",
          "investment",
          "productivity"
        ]
      },
      "diagramIds": [
        "global-poverty-cycle"
      ],
      "quizIds": [
        "u4-42-poverty-cycle-flash-1",
        "u4-42-poverty-cycle-mcq-1",
        "u4-42-poverty-cycle-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-42-poverty-cycle",
        "locale": "zh-CN",
        "title": "贫困循环与资本形成",
        "takeaway": "低收入可能导致低储蓄、低投资与低生产率，进而维持低收入；这是一种可能自我强化的机制而非不可改变的命运。",
        "definition": "低收入可能导致低储蓄、低投资与低生产率，进而维持低收入；这是一种可能自我强化的机制而非不可改变的命运。",
        "causalChain": [
          "低收入限制储蓄",
          "资金不足抑制资本形成",
          "低生产率维持低收入"
        ],
        "misconceptions": [
          "低储蓄只是障碍之一；信贷不能替代可靠项目、产权和市场需求。"
        ],
        "examApplication": [
          "解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
        ],
        "summary": [
          "低收入可能导致低储蓄、低投资与低生产率，进而维持低收入；这是一种可能自我强化的机制而非不可改变的命运。",
          "低储蓄只是障碍之一；信贷不能替代可靠项目、产权和市场需求。"
        ],
        "explanation": "低收入限制储蓄。资金不足抑制资本形成。低生产率维持低收入。\n\n### 原创情境与推导\n\n原创假设：农户无法承担灌溉投资，旱季低产又使下年投资更难；公共灌溉、风险保险或适当融资可打断循环。\n\n低储蓄只是障碍之一；信贷不能替代可靠项目、产权和市场需求。\n\n解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
      },
      "en": {
        "id": "u4-42-poverty-cycle",
        "locale": "en",
        "title": "Poverty cycles and capital formation",
        "takeaway": "Low income can limit saving and investment, keeping productivity and income low. This is a potentially reinforcing mechanism, not an inevitable destiny.",
        "definition": "Low income can limit saving and investment, keeping productivity and income low. This is a potentially reinforcing mechanism, not an inevitable destiny.",
        "causalChain": [
          "Low income restricts saving",
          "limited finance constrains capital formation",
          "low productivity sustains low income"
        ],
        "misconceptions": [
          "Low saving is only one barrier; credit cannot substitute for viable projects, rights and demand."
        ],
        "examApplication": [
          "Explain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
        ],
        "summary": [
          "Low income can limit saving and investment, keeping productivity and income low. This is a potentially reinforcing mechanism, not an inevitable destiny.",
          "Low saving is only one barrier; credit cannot substitute for viable projects, rights and demand."
        ],
        "explanation": "Low income restricts saving.  limited finance constrains capital formation.  low productivity sustains low income.\n\n### Original scenario and reasoning\n\nHypothetical scenario: a farmer cannot finance irrigation, and low dry-season yields reduce next year's investment capacity. Public irrigation, insurance or suitable finance can interrupt the cycle.\n\nLow saving is only one barrier; credit cannot substitute for viable projects, rights and demand.\n\nExplain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
      }
    },
    "practice": [
      {
        "id": "u4-42-poverty-cycle-flash-1",
        "knowledgePointId": "u4-42-poverty-cycle",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“贫困循环与资本形成”，并说明一个关键条件。",
          "en": "Explain Poverty cycles and capital formation and state one important condition."
        },
        "answer": {
          "zh-CN": "低收入可能导致低储蓄、低投资与低生产率，进而维持低收入；这是一种可能自我强化的机制而非不可改变的命运。",
          "en": "Low income can limit saving and investment, keeping productivity and income low. This is a potentially reinforcing mechanism, not an inevitable destiny."
        },
        "explanation": {
          "zh-CN": "低储蓄只是障碍之一；信贷不能替代可靠项目、产权和市场需求。",
          "en": "Low saving is only one barrier; credit cannot substitute for viable projects, rights and demand."
        }
      },
      {
        "id": "u4-42-poverty-cycle-mcq-1",
        "knowledgePointId": "u4-42-poverty-cycle",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪条链说明贫困循环？",
          "en": "Which chain illustrates a poverty cycle?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "高收入必致低寿命",
            "en": "High income must lower longevity"
          },
          {
            "id": "b",
            "zh-CN": "低收入→低投资→低生产率",
            "en": "Low income → low investment → low productivity"
          },
          {
            "id": "c",
            "zh-CN": "贷款总能消除贫困",
            "en": "Loans always remove poverty"
          },
          {
            "id": "d",
            "zh-CN": "储蓄必直接消失",
            "en": "Saving must vanish"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "低收入→低投资→低生产率。 低收入限制储蓄；资金不足抑制资本形成；低生产率维持低收入 低储蓄只是障碍之一；信贷不能替代可靠项目、产权和市场需求。",
          "en": "Low income → low investment → low productivity. Low income restricts saving; limited finance constrains capital formation; low productivity sustains low income Low saving is only one barrier; credit cannot substitute for viable projects, rights and demand."
        }
      },
      {
        "id": "u4-42-poverty-cycle-short-1",
        "knowledgePointId": "u4-42-poverty-cycle",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释贫困循环与资本形成的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Poverty cycles and capital formation and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "低收入可能导致低储蓄、低投资与低生产率，进而维持低收入；这是一种可能自我强化的机制而非不可改变的命运。 低收入限制储蓄；资金不足抑制资本形成；低生产率维持低收入 原创假设：农户无法承担灌溉投资，旱季低产又使下年投资更难；公共灌溉、风险保险或适当融资可打断循环。",
          "en": "Low income can limit saving and investment, keeping productivity and income low. This is a potentially reinforcing mechanism, not an inevitable destiny. Low income restricts saving; limited finance constrains capital formation; low productivity sustains low income Hypothetical scenario: a farmer cannot finance irrigation, and low dry-season yields reduce next year's investment capacity. Public irrigation, insurance or suitable finance can interrupt the cycle."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "收入",
              "en": "income"
            },
            "alternatives": {
              "zh-CN": [
                "收入",
                "低收入限制储蓄"
              ],
              "en": [
                "income",
                "Low income restricts saving"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "投资",
              "en": "investment"
            },
            "alternatives": {
              "zh-CN": [
                "投资",
                "资金不足抑制资本形成"
              ],
              "en": [
                "investment",
                "limited finance constrains capital formation"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "生产率",
              "en": "productivity"
            },
            "alternatives": {
              "zh-CN": [
                "生产率",
                "低生产率维持低收入"
              ],
              "en": [
                "productivity",
                "low productivity sustains low income"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-43-human-capital-infrastructure",
      "slug": "human-capital-infrastructure",
      "section": "4.9",
      "level": "core",
      "syllabusRefs": [
        "4.9 Barriers to economic growth and development"
      ],
      "textbookRefs": [
        {
          "chapter": "19",
          "section": "19.2",
          "pages": [
            566
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-42-poverty-cycle",
        "u4-44-primary-dependence",
        "u4-45-debt-finance-barriers"
      ],
      "terms": [
        "人力资本与基础设施不足",
        "Human-capital and infrastructure gaps",
        "健康",
        "health",
        "基础设施",
        "infrastructure",
        "成本",
        "costs"
      ],
      "synonyms": {
        "zh-CN": [
          "健康",
          "基础设施",
          "成本"
        ],
        "en": [
          "health",
          "infrastructure",
          "costs"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-43-human-capital-infrastructure-flash-1",
        "u4-43-human-capital-infrastructure-mcq-1",
        "u4-43-human-capital-infrastructure-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-43-human-capital-infrastructure",
        "locale": "zh-CN",
        "title": "人力资本与基础设施不足",
        "takeaway": "健康、教育、电力、交通和数字基础设施不足可提高成本、限制生产率并阻碍进入市场。",
        "definition": "健康、教育、电力、交通和数字基础设施不足可提高成本、限制生产率并阻碍进入市场。",
        "causalChain": [
          "服务缺口限制能力",
          "停电和运输延误提高成本",
          "低回报抑制投资与就业"
        ],
        "misconceptions": [
          "建设数量不等于服务质量；维护、师资和可负担性影响真实覆盖。"
        ],
        "examApplication": [
          "解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
        ],
        "summary": [
          "健康、教育、电力、交通和数字基础设施不足可提高成本、限制生产率并阻碍进入市场。",
          "建设数量不等于服务质量；维护、师资和可负担性影响真实覆盖。"
        ],
        "explanation": "服务缺口限制能力。停电和运输延误提高成本。低回报抑制投资与就业。\n\n### 原创情境与推导\n\n原创假设：学校扩招但学生因疾病缺勤、企业因停电停工，单独增加学位未必转化为生产率；需要互补投入。\n\n建设数量不等于服务质量；维护、师资和可负担性影响真实覆盖。\n\n解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
      },
      "en": {
        "id": "u4-43-human-capital-infrastructure",
        "locale": "en",
        "title": "Human-capital and infrastructure gaps",
        "takeaway": "Gaps in health, education, electricity, transport and digital infrastructure can raise costs, restrict productivity and limit market access.",
        "definition": "Gaps in health, education, electricity, transport and digital infrastructure can raise costs, restrict productivity and limit market access.",
        "causalChain": [
          "Service gaps restrict capabilities",
          "outages and transport delays raise costs",
          "weak returns discourage investment and jobs"
        ],
        "misconceptions": [
          "Construction counts do not establish service quality; maintenance, teachers and affordability determine effective access."
        ],
        "examApplication": [
          "Explain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
        ],
        "summary": [
          "Gaps in health, education, electricity, transport and digital infrastructure can raise costs, restrict productivity and limit market access.",
          "Construction counts do not establish service quality; maintenance, teachers and affordability determine effective access."
        ],
        "explanation": "Service gaps restrict capabilities.  outages and transport delays raise costs.  weak returns discourage investment and jobs.\n\n### Original scenario and reasoning\n\nHypothetical scenario: schooling expands but illness causes absence and outages halt firms. More school places alone may not raise productivity without complementary investments.\n\nConstruction counts do not establish service quality; maintenance, teachers and affordability determine effective access.\n\nExplain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
      }
    },
    "practice": [
      {
        "id": "u4-43-human-capital-infrastructure-flash-1",
        "knowledgePointId": "u4-43-human-capital-infrastructure",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“人力资本与基础设施不足”，并说明一个关键条件。",
          "en": "Explain Human-capital and infrastructure gaps and state one important condition."
        },
        "answer": {
          "zh-CN": "健康、教育、电力、交通和数字基础设施不足可提高成本、限制生产率并阻碍进入市场。",
          "en": "Gaps in health, education, electricity, transport and digital infrastructure can raise costs, restrict productivity and limit market access."
        },
        "explanation": {
          "zh-CN": "建设数量不等于服务质量；维护、师资和可负担性影响真实覆盖。",
          "en": "Construction counts do not establish service quality; maintenance, teachers and affordability determine effective access."
        }
      },
      {
        "id": "u4-43-human-capital-infrastructure-mcq-1",
        "knowledgePointId": "u4-43-human-capital-infrastructure",
        "type": "mcq",
        "prompt": {
          "zh-CN": "为什么道路建设后仍应观察运输服务？",
          "en": "Why assess transport services after road construction?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "建设支出就是最终福利",
            "en": "Construction spending is final welfare"
          },
          {
            "id": "b",
            "zh-CN": "所有地区必同等受益",
            "en": "Every region must gain equally"
          },
          {
            "id": "c",
            "zh-CN": "维护与使用条件决定实际收益",
            "en": "Maintenance and access determine actual benefits"
          },
          {
            "id": "d",
            "zh-CN": "不再需测量结果",
            "en": "Outcomes need no measurement"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "维护与使用条件决定实际收益。 服务缺口限制能力；停电和运输延误提高成本；低回报抑制投资与就业 建设数量不等于服务质量；维护、师资和可负担性影响真实覆盖。",
          "en": "Maintenance and access determine actual benefits. Service gaps restrict capabilities; outages and transport delays raise costs; weak returns discourage investment and jobs Construction counts do not establish service quality; maintenance, teachers and affordability determine effective access."
        }
      },
      {
        "id": "u4-43-human-capital-infrastructure-short-1",
        "knowledgePointId": "u4-43-human-capital-infrastructure",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释人力资本与基础设施不足的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Human-capital and infrastructure gaps and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "健康、教育、电力、交通和数字基础设施不足可提高成本、限制生产率并阻碍进入市场。 服务缺口限制能力；停电和运输延误提高成本；低回报抑制投资与就业 原创假设：学校扩招但学生因疾病缺勤、企业因停电停工，单独增加学位未必转化为生产率；需要互补投入。",
          "en": "Gaps in health, education, electricity, transport and digital infrastructure can raise costs, restrict productivity and limit market access. Service gaps restrict capabilities; outages and transport delays raise costs; weak returns discourage investment and jobs Hypothetical scenario: schooling expands but illness causes absence and outages halt firms. More school places alone may not raise productivity without complementary investments."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "健康",
              "en": "health"
            },
            "alternatives": {
              "zh-CN": [
                "健康",
                "服务缺口限制能力"
              ],
              "en": [
                "health",
                "Service gaps restrict capabilities"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "基础设施",
              "en": "infrastructure"
            },
            "alternatives": {
              "zh-CN": [
                "基础设施",
                "停电和运输延误提高成本"
              ],
              "en": [
                "infrastructure",
                "outages and transport delays raise costs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "成本",
              "en": "costs"
            },
            "alternatives": {
              "zh-CN": [
                "成本",
                "低回报抑制投资与就业"
              ],
              "en": [
                "costs",
                "weak returns discourage investment and jobs"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-44-primary-dependence",
      "slug": "primary-dependence",
      "section": "4.9",
      "level": "core",
      "syllabusRefs": [
        "4.9 Barriers to economic growth and development"
      ],
      "textbookRefs": [
        {
          "chapter": "19",
          "section": "19.2",
          "pages": [
            566
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-42-poverty-cycle",
        "u4-43-human-capital-infrastructure",
        "u4-45-debt-finance-barriers"
      ],
      "terms": [
        "初级产品依赖与收入波动",
        "Primary-product dependence and revenue volatility",
        "集中",
        "concentration",
        "波动",
        "volatility",
        "外汇",
        "foreign exchange"
      ],
      "synonyms": {
        "zh-CN": [
          "集中",
          "波动",
          "外汇"
        ],
        "en": [
          "concentration",
          "volatility",
          "foreign exchange"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-44-primary-dependence-flash-1",
        "u4-44-primary-dependence-mcq-1",
        "u4-44-primary-dependence-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-44-primary-dependence",
        "locale": "zh-CN",
        "title": "初级产品依赖与收入波动",
        "takeaway": "出口集中于少数初级产品会使外汇、税收与投资暴露于价格和需求冲击；多样化可降低某些集中风险。",
        "definition": "出口集中于少数初级产品会使外汇、税收与投资暴露于价格和需求冲击；多样化可降低某些集中风险。",
        "causalChain": [
          "出口集中放大外部冲击",
          "外汇和税收随价格数量变化",
          "公共投资与进口融资受限"
        ],
        "misconceptions": [
          "贸易条件不是汇率，也不是出口总额除以进口总额；长期价格下降并非每种商品必然发生。"
        ],
        "examApplication": [
          "解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
        ],
        "summary": [
          "出口集中于少数初级产品会使外汇、税收与投资暴露于价格和需求冲击；多样化可降低某些集中风险。",
          "贸易条件不是汇率，也不是出口总额除以进口总额；长期价格下降并非每种商品必然发生。"
        ],
        "explanation": "出口集中放大外部冲击。外汇和税收随价格数量变化。公共投资与进口融资受限。\n\n### 原创情境与推导\n\n原创假设：咖啡价格下降时，依赖咖啡的家庭、出口商和政府收入可同时受损，设备进口也更难融资；价格、数量及成本共同决定净收益。贸易条件指数另列为扩展内容。\n\n贸易条件不是汇率，也不是出口总额除以进口总额；长期价格下降并非每种商品必然发生。\n\n解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
      },
      "en": {
        "id": "u4-44-primary-dependence",
        "locale": "en",
        "title": "Primary-product dependence and revenue volatility",
        "takeaway": "Concentration in a few primary exports exposes foreign exchange, tax revenue and investment to price and demand shocks; diversification may reduce some concentration risk.",
        "definition": "Concentration in a few primary exports exposes foreign exchange, tax revenue and investment to price and demand shocks; diversification may reduce some concentration risk.",
        "causalChain": [
          "Export concentration magnifies external shocks",
          "foreign exchange and tax receipts vary with prices and volumes",
          "public investment and import finance are constrained"
        ],
        "misconceptions": [
          "Terms of trade are neither an exchange rate nor total export receipts divided by imports; long-run deterioration is not inevitable for every commodity."
        ],
        "examApplication": [
          "Explain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
        ],
        "summary": [
          "Concentration in a few primary exports exposes foreign exchange, tax revenue and investment to price and demand shocks; diversification may reduce some concentration risk.",
          "Terms of trade are neither an exchange rate nor total export receipts divided by imports; long-run deterioration is not inevitable for every commodity."
        ],
        "explanation": "Export concentration magnifies external shocks.  foreign exchange and tax receipts vary with prices and volumes.  public investment and import finance are constrained.\n\n### Original scenario and reasoning\n\nHypothetical scenario: a coffee-price fall can hit households, exporters and public revenue together, constraining finance for equipment imports. Price, quantity and costs jointly determine net returns. A terms-of-trade index is listed separately as enrichment.\n\nTerms of trade are neither an exchange rate nor total export receipts divided by imports; long-run deterioration is not inevitable for every commodity.\n\nExplain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
      }
    },
    "practice": [
      {
        "id": "u4-44-primary-dependence-flash-1",
        "knowledgePointId": "u4-44-primary-dependence",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“初级产品依赖与收入波动”，并说明一个关键条件。",
          "en": "Explain Primary-product dependence and revenue volatility and state one important condition."
        },
        "answer": {
          "zh-CN": "出口集中于少数初级产品会使外汇、税收与投资暴露于价格和需求冲击；多样化可降低某些集中风险。",
          "en": "Concentration in a few primary exports exposes foreign exchange, tax revenue and investment to price and demand shocks; diversification may reduce some concentration risk."
        },
        "explanation": {
          "zh-CN": "贸易条件不是汇率，也不是出口总额除以进口总额；长期价格下降并非每种商品必然发生。",
          "en": "Terms of trade are neither an exchange rate nor total export receipts divided by imports; long-run deterioration is not inevitable for every commodity."
        }
      },
      {
        "id": "u4-44-primary-dependence-mcq-1",
        "knowledgePointId": "u4-44-primary-dependence",
        "type": "mcq",
        "prompt": {
          "zh-CN": "为何单一初级产品出口依赖增加风险？",
          "en": "Why does dependence on one primary export raise risk?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "出口收入不受价格影响",
            "en": "Export receipts never depend on price"
          },
          {
            "id": "b",
            "zh-CN": "数量与成本无关紧要",
            "en": "Volumes and costs never matter"
          },
          {
            "id": "c",
            "zh-CN": "多样化必定增加所有风险",
            "en": "Diversification must increase every risk"
          },
          {
            "id": "d",
            "zh-CN": "一次产品价格冲击可同时打击多个收入来源",
            "en": "One commodity-price shock can hit several income sources"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "一次产品价格冲击可同时打击多个收入来源。 出口集中放大外部冲击；外汇和税收随价格数量变化；公共投资与进口融资受限 贸易条件不是汇率，也不是出口总额除以进口总额；长期价格下降并非每种商品必然发生。",
          "en": "One commodity-price shock can hit several income sources. Export concentration magnifies external shocks; foreign exchange and tax receipts vary with prices and volumes; public investment and import finance are constrained Terms of trade are neither an exchange rate nor total export receipts divided by imports; long-run deterioration is not inevitable for every commodity."
        }
      },
      {
        "id": "u4-44-primary-dependence-short-1",
        "knowledgePointId": "u4-44-primary-dependence",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释初级产品依赖与收入波动的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Primary-product dependence and revenue volatility and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "出口集中于少数初级产品会使外汇、税收与投资暴露于价格和需求冲击；多样化可降低某些集中风险。 出口集中放大外部冲击；外汇和税收随价格数量变化；公共投资与进口融资受限 原创假设：咖啡价格下降时，依赖咖啡的家庭、出口商和政府收入可同时受损，设备进口也更难融资；价格、数量及成本共同决定净收益。贸易条件指数另列为扩展内容。",
          "en": "Concentration in a few primary exports exposes foreign exchange, tax revenue and investment to price and demand shocks; diversification may reduce some concentration risk. Export concentration magnifies external shocks; foreign exchange and tax receipts vary with prices and volumes; public investment and import finance are constrained Hypothetical scenario: a coffee-price fall can hit households, exporters and public revenue together, constraining finance for equipment imports. Price, quantity and costs jointly determine net returns. A terms-of-trade index is listed separately as enrichment."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "集中",
              "en": "concentration"
            },
            "alternatives": {
              "zh-CN": [
                "集中",
                "出口集中放大外部冲击"
              ],
              "en": [
                "concentration",
                "Export concentration magnifies external shocks"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "波动",
              "en": "volatility"
            },
            "alternatives": {
              "zh-CN": [
                "波动",
                "外汇和税收随价格数量变化"
              ],
              "en": [
                "volatility",
                "foreign exchange and tax receipts vary with prices and volumes"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "外汇",
              "en": "foreign exchange"
            },
            "alternatives": {
              "zh-CN": [
                "外汇",
                "公共投资与进口融资受限"
              ],
              "en": [
                "foreign exchange",
                "public investment and import finance are constrained"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-45-debt-finance-barriers",
      "slug": "debt-finance-barriers",
      "section": "4.9",
      "level": "core",
      "syllabusRefs": [
        "4.9 Barriers to economic growth and development"
      ],
      "textbookRefs": [
        {
          "chapter": "19",
          "section": "19.2",
          "pages": [
            566
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-42-poverty-cycle",
        "u4-43-human-capital-infrastructure",
        "u4-44-primary-dependence"
      ],
      "terms": [
        "债务、金融排斥与资本外逃",
        "Debt, financial exclusion and capital flight",
        "融资",
        "finance",
        "债务",
        "debt",
        "偿债",
        "debt service"
      ],
      "synonyms": {
        "zh-CN": [
          "融资",
          "债务",
          "偿债"
        ],
        "en": [
          "finance",
          "debt",
          "debt service"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-45-debt-finance-barriers-flash-1",
        "u4-45-debt-finance-barriers-mcq-1",
        "u4-45-debt-finance-barriers-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-45-debt-finance-barriers",
        "locale": "zh-CN",
        "title": "债务、金融排斥与资本外逃",
        "takeaway": "高偿债负担可挤压公共投资；缺少抵押、保险和支付服务限制家庭企业投资；资本外逃削弱国内融资。",
        "definition": "高偿债负担可挤压公共投资；缺少抵押、保险和支付服务限制家庭企业投资；资本外逃削弱国内融资。",
        "causalChain": [
          "融资约束限制项目",
          "外币债务暴露汇率风险",
          "偿债挤压健康教育预算"
        ],
        "misconceptions": [
          "借债并非必然有害；应比较投资回报、利率、期限、币种和偿付能力。"
        ],
        "examApplication": [
          "解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
        ],
        "summary": [
          "高偿债负担可挤压公共投资；缺少抵押、保险和支付服务限制家庭企业投资；资本外逃削弱国内融资。",
          "借债并非必然有害；应比较投资回报、利率、期限、币种和偿付能力。"
        ],
        "explanation": "融资约束限制项目。外币债务暴露汇率风险。偿债挤压健康教育预算。\n\n### 原创情境与推导\n\n原创假设：政府外币债务本息不变，本币贬值后本币税收需覆盖更多偿付；债务重组可缓解但涉及债权人协调与未来融资。\n\n借债并非必然有害；应比较投资回报、利率、期限、币种和偿付能力。\n\n解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
      },
      "en": {
        "id": "u4-45-debt-finance-barriers",
        "locale": "en",
        "title": "Debt, financial exclusion and capital flight",
        "takeaway": "Heavy debt service can crowd out public investment; missing collateral, insurance and payments constrain private investment, while capital flight weakens domestic finance.",
        "definition": "Heavy debt service can crowd out public investment; missing collateral, insurance and payments constrain private investment, while capital flight weakens domestic finance.",
        "causalChain": [
          "Finance constraints restrict projects",
          "foreign-currency debt exposes exchange risk",
          "debt service squeezes health and education budgets"
        ],
        "misconceptions": [
          "Borrowing is not inherently harmful; compare returns, rates, maturity, currency and repayment capacity."
        ],
        "examApplication": [
          "Explain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
        ],
        "summary": [
          "Heavy debt service can crowd out public investment; missing collateral, insurance and payments constrain private investment, while capital flight weakens domestic finance.",
          "Borrowing is not inherently harmful; compare returns, rates, maturity, currency and repayment capacity."
        ],
        "explanation": "Finance constraints restrict projects.  foreign-currency debt exposes exchange risk.  debt service squeezes health and education budgets.\n\n### Original scenario and reasoning\n\nHypothetical scenario: unchanged foreign-currency debt service requires more home-currency tax revenue after depreciation. Restructuring may help but involves creditor coordination and future borrowing access.\n\nBorrowing is not inherently harmful; compare returns, rates, maturity, currency and repayment capacity.\n\nExplain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
      }
    },
    "practice": [
      {
        "id": "u4-45-debt-finance-barriers-flash-1",
        "knowledgePointId": "u4-45-debt-finance-barriers",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“债务、金融排斥与资本外逃”，并说明一个关键条件。",
          "en": "Explain Debt, financial exclusion and capital flight and state one important condition."
        },
        "answer": {
          "zh-CN": "高偿债负担可挤压公共投资；缺少抵押、保险和支付服务限制家庭企业投资；资本外逃削弱国内融资。",
          "en": "Heavy debt service can crowd out public investment; missing collateral, insurance and payments constrain private investment, while capital flight weakens domestic finance."
        },
        "explanation": {
          "zh-CN": "借债并非必然有害；应比较投资回报、利率、期限、币种和偿付能力。",
          "en": "Borrowing is not inherently harmful; compare returns, rates, maturity, currency and repayment capacity."
        }
      },
      {
        "id": "u4-45-debt-finance-barriers-mcq-1",
        "knowledgePointId": "u4-45-debt-finance-barriers",
        "type": "mcq",
        "prompt": {
          "zh-CN": "何种组合最增加偿债脆弱性？",
          "en": "Which combination most increases debt vulnerability?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "外币债务高且本币贬值",
            "en": "High foreign-currency debt and home depreciation"
          },
          {
            "id": "b",
            "zh-CN": "币种匹配改善",
            "en": "Improved currency matching"
          },
          {
            "id": "c",
            "zh-CN": "投资回报提高",
            "en": "Higher investment returns"
          },
          {
            "id": "d",
            "zh-CN": "期限风险降低",
            "en": "Lower maturity risk"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "外币债务高且本币贬值。 融资约束限制项目；外币债务暴露汇率风险；偿债挤压健康教育预算 借债并非必然有害；应比较投资回报、利率、期限、币种和偿付能力。",
          "en": "High foreign-currency debt and home depreciation. Finance constraints restrict projects; foreign-currency debt exposes exchange risk; debt service squeezes health and education budgets Borrowing is not inherently harmful; compare returns, rates, maturity, currency and repayment capacity."
        }
      },
      {
        "id": "u4-45-debt-finance-barriers-short-1",
        "knowledgePointId": "u4-45-debt-finance-barriers",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释债务、金融排斥与资本外逃的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Debt, financial exclusion and capital flight and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "高偿债负担可挤压公共投资；缺少抵押、保险和支付服务限制家庭企业投资；资本外逃削弱国内融资。 融资约束限制项目；外币债务暴露汇率风险；偿债挤压健康教育预算 原创假设：政府外币债务本息不变，本币贬值后本币税收需覆盖更多偿付；债务重组可缓解但涉及债权人协调与未来融资。",
          "en": "Heavy debt service can crowd out public investment; missing collateral, insurance and payments constrain private investment, while capital flight weakens domestic finance. Finance constraints restrict projects; foreign-currency debt exposes exchange risk; debt service squeezes health and education budgets Hypothetical scenario: unchanged foreign-currency debt service requires more home-currency tax revenue after depreciation. Restructuring may help but involves creditor coordination and future borrowing access."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "融资",
              "en": "finance"
            },
            "alternatives": {
              "zh-CN": [
                "融资",
                "融资约束限制项目"
              ],
              "en": [
                "finance",
                "Finance constraints restrict projects"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "债务",
              "en": "debt"
            },
            "alternatives": {
              "zh-CN": [
                "债务",
                "外币债务暴露汇率风险"
              ],
              "en": [
                "debt",
                "foreign-currency debt exposes exchange risk"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "偿债",
              "en": "debt service"
            },
            "alternatives": {
              "zh-CN": [
                "偿债",
                "偿债挤压健康教育预算"
              ],
              "en": [
                "debt service",
                "debt service squeezes health and education budgets"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-46-institutions-barriers",
      "slug": "institutions-barriers",
      "section": "4.9",
      "level": "core",
      "syllabusRefs": [
        "4.9 Barriers to economic growth and development"
      ],
      "textbookRefs": [
        {
          "chapter": "19",
          "section": "19.3",
          "pages": [
            581
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-42-poverty-cycle",
        "u4-43-human-capital-infrastructure",
        "u4-44-primary-dependence"
      ],
      "terms": [
        "制度、冲突与社会排斥",
        "Institutions, conflict and social exclusion",
        "规则",
        "rules",
        "排斥",
        "exclusion",
        "投资",
        "investment"
      ],
      "synonyms": {
        "zh-CN": [
          "规则",
          "排斥",
          "投资"
        ],
        "en": [
          "rules",
          "exclusion",
          "investment"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-46-institutions-barriers-flash-1",
        "u4-46-institutions-barriers-mcq-1",
        "u4-46-institutions-barriers-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-46-institutions-barriers",
        "locale": "zh-CN",
        "title": "制度、冲突与社会排斥",
        "takeaway": "腐败、产权不清、冲突和歧视可增加交易风险、降低投资并限制人们参与教育和就业。",
        "definition": "腐败、产权不清、冲突和歧视可增加交易风险、降低投资并限制人们参与教育和就业。",
        "causalChain": [
          "规则不透明增加不确定性",
          "排斥限制人才配置",
          "低投资与低信任阻碍发展"
        ],
        "misconceptions": [
          "制度不能只用一个排名解释；改革效果取决于历史、执行能力与当地参与。"
        ],
        "examApplication": [
          "解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
        ],
        "summary": [
          "腐败、产权不清、冲突和歧视可增加交易风险、降低投资并限制人们参与教育和就业。",
          "制度不能只用一个排名解释；改革效果取决于历史、执行能力与当地参与。"
        ],
        "explanation": "规则不透明增加不确定性。排斥限制人才配置。低投资与低信任阻碍发展。\n\n### 原创情境与推导\n\n原创假设：女性难以持有土地或取得贷款，使高回报项目无法融资；法律改革还需执行、信息和安全保障。\n\n制度不能只用一个排名解释；改革效果取决于历史、执行能力与当地参与。\n\n解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
      },
      "en": {
        "id": "u4-46-institutions-barriers",
        "locale": "en",
        "title": "Institutions, conflict and social exclusion",
        "takeaway": "Corruption, insecure rights, conflict and discrimination can raise transaction risk, discourage investment and restrict access to education and jobs.",
        "definition": "Corruption, insecure rights, conflict and discrimination can raise transaction risk, discourage investment and restrict access to education and jobs.",
        "causalChain": [
          "Opaque rules increase uncertainty",
          "exclusion misallocates talent",
          "weak investment and trust obstruct development"
        ],
        "misconceptions": [
          "A single ranking cannot explain institutions; reform depends on history, implementation capacity and local participation."
        ],
        "examApplication": [
          "Explain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
        ],
        "summary": [
          "Corruption, insecure rights, conflict and discrimination can raise transaction risk, discourage investment and restrict access to education and jobs.",
          "A single ranking cannot explain institutions; reform depends on history, implementation capacity and local participation."
        ],
        "explanation": "Opaque rules increase uncertainty.  exclusion misallocates talent.  weak investment and trust obstruct development.\n\n### Original scenario and reasoning\n\nHypothetical scenario: women unable to own land or obtain credit cannot finance high-return projects. Legal reform also needs enforcement, information and safety.\n\nA single ranking cannot explain institutions; reform depends on history, implementation capacity and local participation.\n\nExplain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
      }
    },
    "practice": [
      {
        "id": "u4-46-institutions-barriers-flash-1",
        "knowledgePointId": "u4-46-institutions-barriers",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“制度、冲突与社会排斥”，并说明一个关键条件。",
          "en": "Explain Institutions, conflict and social exclusion and state one important condition."
        },
        "answer": {
          "zh-CN": "腐败、产权不清、冲突和歧视可增加交易风险、降低投资并限制人们参与教育和就业。",
          "en": "Corruption, insecure rights, conflict and discrimination can raise transaction risk, discourage investment and restrict access to education and jobs."
        },
        "explanation": {
          "zh-CN": "制度不能只用一个排名解释；改革效果取决于历史、执行能力与当地参与。",
          "en": "A single ranking cannot explain institutions; reform depends on history, implementation capacity and local participation."
        }
      },
      {
        "id": "u4-46-institutions-barriers-mcq-1",
        "knowledgePointId": "u4-46-institutions-barriers",
        "type": "mcq",
        "prompt": {
          "zh-CN": "产权改革促进投资还需要什么？",
          "en": "What else is needed for property-rights reform to support investment?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只有书面法律即可",
            "en": "Written law alone suffices"
          },
          {
            "id": "b",
            "zh-CN": "可信执行与可获得的司法",
            "en": "Credible enforcement and accessible justice"
          },
          {
            "id": "c",
            "zh-CN": "完全忽略弱势群体",
            "en": "Ignore excluded groups"
          },
          {
            "id": "d",
            "zh-CN": "无需市场需求",
            "en": "No market demand"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "可信执行与可获得的司法。 规则不透明增加不确定性；排斥限制人才配置；低投资与低信任阻碍发展 制度不能只用一个排名解释；改革效果取决于历史、执行能力与当地参与。",
          "en": "Credible enforcement and accessible justice. Opaque rules increase uncertainty; exclusion misallocates talent; weak investment and trust obstruct development A single ranking cannot explain institutions; reform depends on history, implementation capacity and local participation."
        }
      },
      {
        "id": "u4-46-institutions-barriers-short-1",
        "knowledgePointId": "u4-46-institutions-barriers",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释制度、冲突与社会排斥的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Institutions, conflict and social exclusion and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "腐败、产权不清、冲突和歧视可增加交易风险、降低投资并限制人们参与教育和就业。 规则不透明增加不确定性；排斥限制人才配置；低投资与低信任阻碍发展 原创假设：女性难以持有土地或取得贷款，使高回报项目无法融资；法律改革还需执行、信息和安全保障。",
          "en": "Corruption, insecure rights, conflict and discrimination can raise transaction risk, discourage investment and restrict access to education and jobs. Opaque rules increase uncertainty; exclusion misallocates talent; weak investment and trust obstruct development Hypothetical scenario: women unable to own land or obtain credit cannot finance high-return projects. Legal reform also needs enforcement, information and safety."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "规则",
              "en": "rules"
            },
            "alternatives": {
              "zh-CN": [
                "规则",
                "规则不透明增加不确定性"
              ],
              "en": [
                "rules",
                "Opaque rules increase uncertainty"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "排斥",
              "en": "exclusion"
            },
            "alternatives": {
              "zh-CN": [
                "排斥",
                "排斥限制人才配置"
              ],
              "en": [
                "exclusion",
                "exclusion misallocates talent"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "投资",
              "en": "investment"
            },
            "alternatives": {
              "zh-CN": [
                "投资",
                "低投资与低信任阻碍发展"
              ],
              "en": [
                "investment",
                "weak investment and trust obstruct development"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-47-geography-informality",
      "slug": "geography-informality",
      "section": "4.9",
      "level": "core",
      "syllabusRefs": [
        "4.9 Barriers to economic growth and development"
      ],
      "textbookRefs": [
        {
          "chapter": "19",
          "section": "19.2",
          "pages": [
            566
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-42-poverty-cycle",
        "u4-43-human-capital-infrastructure",
        "u4-44-primary-dependence"
      ],
      "terms": [
        "地理、非正规经济与多重障碍",
        "Geography, informality and interacting barriers",
        "成本",
        "costs",
        "非正规",
        "informal",
        "约束",
        "constraints"
      ],
      "synonyms": {
        "zh-CN": [
          "成本",
          "非正规",
          "约束"
        ],
        "en": [
          "costs",
          "informal",
          "constraints"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-47-geography-informality-flash-1",
        "u4-47-geography-informality-mcq-1",
        "u4-47-geography-informality-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-47-geography-informality",
        "locale": "zh-CN",
        "title": "地理、非正规经济与多重障碍",
        "takeaway": "内陆位置、气候风险和市场距离可能提高成本；非正规就业可提供生计，却常缺社会保障、融资和统计覆盖。",
        "definition": "内陆位置、气候风险和市场距离可能提高成本；非正规就业可提供生计，却常缺社会保障、融资和统计覆盖。",
        "causalChain": [
          "距离与风险提高交易成本",
          "企业留在小规模非正规经营",
          "税基与公共服务能力受限"
        ],
        "misconceptions": [
          "地理不等于命运，非正规活动也不都非法；政策应降低正规化成本并提供实际收益。"
        ],
        "examApplication": [
          "解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
        ],
        "summary": [
          "内陆位置、气候风险和市场距离可能提高成本；非正规就业可提供生计，却常缺社会保障、融资和统计覆盖。",
          "地理不等于命运，非正规活动也不都非法；政策应降低正规化成本并提供实际收益。"
        ],
        "explanation": "距离与风险提高交易成本。企业留在小规模非正规经营。税基与公共服务能力受限。\n\n### 原创情境与推导\n\n原创假设：内陆农户同时面临差路、洪灾和无保险，仅取消营业许可费未必解决主要瓶颈；需识别互补约束。\n\n地理不等于命运，非正规活动也不都非法；政策应降低正规化成本并提供实际收益。\n\n解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
      },
      "en": {
        "id": "u4-47-geography-informality",
        "locale": "en",
        "title": "Geography, informality and interacting barriers",
        "takeaway": "Landlocked locations, climate risks and distance can raise costs. Informal work provides livelihoods but often lacks protection, finance and statistical coverage.",
        "definition": "Landlocked locations, climate risks and distance can raise costs. Informal work provides livelihoods but often lacks protection, finance and statistical coverage.",
        "causalChain": [
          "Distance and risk raise transaction costs",
          "firms remain small and informal",
          "the tax base and public-service capacity are constrained"
        ],
        "misconceptions": [
          "Geography is not destiny, and informal activity is not all illegal; formalisation should reduce costs and offer real benefits."
        ],
        "examApplication": [
          "Explain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
        ],
        "summary": [
          "Landlocked locations, climate risks and distance can raise costs. Informal work provides livelihoods but often lacks protection, finance and statistical coverage.",
          "Geography is not destiny, and informal activity is not all illegal; formalisation should reduce costs and offer real benefits."
        ],
        "explanation": "Distance and risk raise transaction costs.  firms remain small and informal.  the tax base and public-service capacity are constrained.\n\n### Original scenario and reasoning\n\nHypothetical scenario: landlocked farmers face poor roads, floods and no insurance. Removing licence fees alone may not address binding constraints; identify complementary barriers.\n\nGeography is not destiny, and informal activity is not all illegal; formalisation should reduce costs and offer real benefits.\n\nExplain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
      }
    },
    "practice": [
      {
        "id": "u4-47-geography-informality-flash-1",
        "knowledgePointId": "u4-47-geography-informality",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“地理、非正规经济与多重障碍”，并说明一个关键条件。",
          "en": "Explain Geography, informality and interacting barriers and state one important condition."
        },
        "answer": {
          "zh-CN": "内陆位置、气候风险和市场距离可能提高成本；非正规就业可提供生计，却常缺社会保障、融资和统计覆盖。",
          "en": "Landlocked locations, climate risks and distance can raise costs. Informal work provides livelihoods but often lacks protection, finance and statistical coverage."
        },
        "explanation": {
          "zh-CN": "地理不等于命运，非正规活动也不都非法；政策应降低正规化成本并提供实际收益。",
          "en": "Geography is not destiny, and informal activity is not all illegal; formalisation should reduce costs and offer real benefits."
        }
      },
      {
        "id": "u4-47-geography-informality-mcq-1",
        "knowledgePointId": "u4-47-geography-informality",
        "type": "mcq",
        "prompt": {
          "zh-CN": "多重障碍同时存在时应怎样选政策？",
          "en": "How should policies be chosen with interacting barriers?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "假设一个措施必解决全部",
            "en": "Assume one measure solves everything"
          },
          {
            "id": "b",
            "zh-CN": "只处罚所有小商贩",
            "en": "Only penalise every small trader"
          },
          {
            "id": "c",
            "zh-CN": "识别主要瓶颈和互补投入",
            "en": "Identify binding constraints and complementary inputs"
          },
          {
            "id": "d",
            "zh-CN": "认定地理无法改变任何结果",
            "en": "Assume geography prevents any improvement"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "识别主要瓶颈和互补投入。 距离与风险提高交易成本；企业留在小规模非正规经营；税基与公共服务能力受限 地理不等于命运，非正规活动也不都非法；政策应降低正规化成本并提供实际收益。",
          "en": "Identify binding constraints and complementary inputs. Distance and risk raise transaction costs; firms remain small and informal; the tax base and public-service capacity are constrained Geography is not destiny, and informal activity is not all illegal; formalisation should reduce costs and offer real benefits."
        }
      },
      {
        "id": "u4-47-geography-informality-short-1",
        "knowledgePointId": "u4-47-geography-informality",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释地理、非正规经济与多重障碍的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Geography, informality and interacting barriers and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "内陆位置、气候风险和市场距离可能提高成本；非正规就业可提供生计，却常缺社会保障、融资和统计覆盖。 距离与风险提高交易成本；企业留在小规模非正规经营；税基与公共服务能力受限 原创假设：内陆农户同时面临差路、洪灾和无保险，仅取消营业许可费未必解决主要瓶颈；需识别互补约束。",
          "en": "Landlocked locations, climate risks and distance can raise costs. Informal work provides livelihoods but often lacks protection, finance and statistical coverage. Distance and risk raise transaction costs; firms remain small and informal; the tax base and public-service capacity are constrained Hypothetical scenario: landlocked farmers face poor roads, floods and no insurance. Removing licence fees alone may not address binding constraints; identify complementary barriers."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "成本",
              "en": "costs"
            },
            "alternatives": {
              "zh-CN": [
                "成本",
                "距离与风险提高交易成本"
              ],
              "en": [
                "costs",
                "Distance and risk raise transaction costs"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "非正规",
              "en": "informal"
            },
            "alternatives": {
              "zh-CN": [
                "非正规",
                "企业留在小规模非正规经营"
              ],
              "en": [
                "informal",
                "firms remain small and informal"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "约束",
              "en": "constraints"
            },
            "alternatives": {
              "zh-CN": [
                "约束",
                "税基与公共服务能力受限"
              ],
              "en": [
                "constraints",
                "the tax base and public-service capacity are constrained"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-48-trade-strategies",
      "slug": "trade-strategies",
      "section": "4.10",
      "level": "core",
      "syllabusRefs": [
        "4.10 Economic growth and development strategies"
      ],
      "textbookRefs": [
        {
          "chapter": "20",
          "section": "20.1",
          "pages": [
            595
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-49-diversification-enterprise",
        "u4-50-market-based-development",
        "u4-51-public-services-development"
      ],
      "terms": [
        "进口替代与出口导向",
        "Import substitution and export promotion",
        "进口替代",
        "import substitution",
        "出口",
        "exports",
        "竞争",
        "competition"
      ],
      "synonyms": {
        "zh-CN": [
          "进口替代",
          "出口",
          "竞争"
        ],
        "en": [
          "import substitution",
          "exports",
          "competition"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-48-trade-strategies-flash-1",
        "u4-48-trade-strategies-mcq-1",
        "u4-48-trade-strategies-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-48-trade-strategies",
        "locale": "zh-CN",
        "title": "进口替代与出口导向",
        "takeaway": "进口替代扶持本地生产替代进口；出口导向帮助企业进入国际市场，两者的成效取决于竞争、学习和政策纪律。",
        "definition": "进口替代扶持本地生产替代进口；出口导向帮助企业进入国际市场，两者的成效取决于竞争、学习和政策纪律。",
        "causalChain": [
          "选择产业与政策工具",
          "市场与学习激励影响成本",
          "出口收入或进口节约支持资本品需求"
        ],
        "misconceptions": [
          "两者不是只能二选一的标签；具体工具、退出机制与产业条件更重要。"
        ],
        "examApplication": [
          "把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
        ],
        "summary": [
          "进口替代扶持本地生产替代进口；出口导向帮助企业进入国际市场，两者的成效取决于竞争、学习和政策纪律。",
          "两者不是只能二选一的标签；具体工具、退出机制与产业条件更重要。"
        ],
        "explanation": "选择产业与政策工具。市场与学习激励影响成本。出口收入或进口节约支持资本品需求。\n\n### 原创情境与推导\n\n原创假设：关税扶持小市场汽车业可能限制规模；出口支持若要求绩效并改善物流，可保留竞争压力，但也暴露于外需波动。\n\n两者不是只能二选一的标签；具体工具、退出机制与产业条件更重要。\n\n把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
      },
      "en": {
        "id": "u4-48-trade-strategies",
        "locale": "en",
        "title": "Import substitution and export promotion",
        "takeaway": "Import substitution supports domestic production replacing imports; export promotion helps firms reach world markets. Outcomes depend on competition, learning and policy discipline.",
        "definition": "Import substitution supports domestic production replacing imports; export promotion helps firms reach world markets. Outcomes depend on competition, learning and policy discipline.",
        "causalChain": [
          "Choose sectors and instruments",
          "market and learning incentives affect costs",
          "export earnings or import savings support capital imports"
        ],
        "misconceptions": [
          "These are not mutually exclusive labels; instruments, exit rules and sector conditions matter."
        ],
        "examApplication": [
          "Match policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
        ],
        "summary": [
          "Import substitution supports domestic production replacing imports; export promotion helps firms reach world markets. Outcomes depend on competition, learning and policy discipline.",
          "These are not mutually exclusive labels; instruments, exit rules and sector conditions matter."
        ],
        "explanation": "Choose sectors and instruments.  market and learning incentives affect costs.  export earnings or import savings support capital imports.\n\n### Original scenario and reasoning\n\nHypothetical scenario: tariff-supported car production in a small market may lack scale. Export support tied to performance and logistics can preserve competition but exposes firms to world-demand volatility.\n\nThese are not mutually exclusive labels; instruments, exit rules and sector conditions matter.\n\nMatch policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
      }
    },
    "practice": [
      {
        "id": "u4-48-trade-strategies-flash-1",
        "knowledgePointId": "u4-48-trade-strategies",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“进口替代与出口导向”，并说明一个关键条件。",
          "en": "Explain Import substitution and export promotion and state one important condition."
        },
        "answer": {
          "zh-CN": "进口替代扶持本地生产替代进口；出口导向帮助企业进入国际市场，两者的成效取决于竞争、学习和政策纪律。",
          "en": "Import substitution supports domestic production replacing imports; export promotion helps firms reach world markets. Outcomes depend on competition, learning and policy discipline."
        },
        "explanation": {
          "zh-CN": "两者不是只能二选一的标签；具体工具、退出机制与产业条件更重要。",
          "en": "These are not mutually exclusive labels; instruments, exit rules and sector conditions matter."
        }
      },
      {
        "id": "u4-48-trade-strategies-mcq-1",
        "knowledgePointId": "u4-48-trade-strategies",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪项能降低进口替代的长期低效风险？",
          "en": "What can reduce long-run inefficiency under import substitution?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "永久无条件保护",
            "en": "Permanent unconditional protection"
          },
          {
            "id": "b",
            "zh-CN": "禁止所有技术进口",
            "en": "Ban all technology imports"
          },
          {
            "id": "c",
            "zh-CN": "不衡量成本",
            "en": "Never measure costs"
          },
          {
            "id": "d",
            "zh-CN": "绩效条件和明确退出机制",
            "en": "Performance conditions and a credible exit"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "绩效条件和明确退出机制。 选择产业与政策工具；市场与学习激励影响成本；出口收入或进口节约支持资本品需求 两者不是只能二选一的标签；具体工具、退出机制与产业条件更重要。",
          "en": "Performance conditions and a credible exit. Choose sectors and instruments; market and learning incentives affect costs; export earnings or import savings support capital imports These are not mutually exclusive labels; instruments, exit rules and sector conditions matter."
        }
      },
      {
        "id": "u4-48-trade-strategies-short-1",
        "knowledgePointId": "u4-48-trade-strategies",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释进口替代与出口导向的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Import substitution and export promotion and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "进口替代扶持本地生产替代进口；出口导向帮助企业进入国际市场，两者的成效取决于竞争、学习和政策纪律。 选择产业与政策工具；市场与学习激励影响成本；出口收入或进口节约支持资本品需求 原创假设：关税扶持小市场汽车业可能限制规模；出口支持若要求绩效并改善物流，可保留竞争压力，但也暴露于外需波动。",
          "en": "Import substitution supports domestic production replacing imports; export promotion helps firms reach world markets. Outcomes depend on competition, learning and policy discipline. Choose sectors and instruments; market and learning incentives affect costs; export earnings or import savings support capital imports Hypothetical scenario: tariff-supported car production in a small market may lack scale. Export support tied to performance and logistics can preserve competition but exposes firms to world-demand volatility."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "进口替代",
              "en": "import substitution"
            },
            "alternatives": {
              "zh-CN": [
                "进口替代",
                "选择产业与政策工具"
              ],
              "en": [
                "import substitution",
                "Choose sectors and instruments"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "出口",
              "en": "exports"
            },
            "alternatives": {
              "zh-CN": [
                "出口",
                "市场与学习激励影响成本"
              ],
              "en": [
                "exports",
                "market and learning incentives affect costs"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "竞争",
              "en": "competition"
            },
            "alternatives": {
              "zh-CN": [
                "竞争",
                "出口收入或进口节约支持资本品需求"
              ],
              "en": [
                "competition",
                "export earnings or import savings support capital imports"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-49-diversification-enterprise",
      "slug": "diversification-enterprise",
      "section": "4.10",
      "level": "core",
      "syllabusRefs": [
        "4.10 Economic growth and development strategies"
      ],
      "textbookRefs": [
        {
          "chapter": "20",
          "section": "20.2",
          "pages": [
            599
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-48-trade-strategies",
        "u4-50-market-based-development",
        "u4-51-public-services-development"
      ],
      "terms": [
        "多样化与社会企业",
        "Diversification and social enterprise",
        "多样化",
        "diversification",
        "风险",
        "risk",
        "社会目标",
        "social goals"
      ],
      "synonyms": {
        "zh-CN": [
          "多样化",
          "风险",
          "社会目标"
        ],
        "en": [
          "diversification",
          "risk",
          "social goals"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-49-diversification-enterprise-flash-1",
        "u4-49-diversification-enterprise-mcq-1",
        "u4-49-diversification-enterprise-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-49-diversification-enterprise",
        "locale": "zh-CN",
        "title": "多样化与社会企业",
        "takeaway": "产业和出口多样化减少对单一收入来源的依赖；社会企业以商业活动支持社会目标，但仍面临成本和治理约束。",
        "definition": "产业和出口多样化减少对单一收入来源的依赖；社会企业以商业活动支持社会目标，但仍面临成本和治理约束。",
        "causalChain": [
          "开发不同市场和产品",
          "降低高度相关的收入风险",
          "技能和融资支持新活动"
        ],
        "misconceptions": [
          "项目数量增加不一定分散风险；社会目标也不保证经营或影响有效。"
        ],
        "examApplication": [
          "把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
        ],
        "summary": [
          "产业和出口多样化减少对单一收入来源的依赖；社会企业以商业活动支持社会目标，但仍面临成本和治理约束。",
          "项目数量增加不一定分散风险；社会目标也不保证经营或影响有效。"
        ],
        "explanation": "开发不同市场和产品。降低高度相关的收入风险。技能和融资支持新活动。\n\n### 原创情境与推导\n\n原创假设：咖啡合作社增加加工和生态旅游，可能提高附加值并分散风险；若两者都依赖同一气候或游客市场，风险分散有限。\n\n项目数量增加不一定分散风险；社会目标也不保证经营或影响有效。\n\n把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
      },
      "en": {
        "id": "u4-49-diversification-enterprise",
        "locale": "en",
        "title": "Diversification and social enterprise",
        "takeaway": "Diversification reduces reliance on a single income source. Social enterprises use business activity to pursue social goals but still face cost and governance constraints.",
        "definition": "Diversification reduces reliance on a single income source. Social enterprises use business activity to pursue social goals but still face cost and governance constraints.",
        "causalChain": [
          "Develop different products and markets",
          "reduce highly correlated revenue risks",
          "skills and finance support new activities"
        ],
        "misconceptions": [
          "More projects do not necessarily diversify risk; social intent does not guarantee operational or impact success."
        ],
        "examApplication": [
          "Match policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
        ],
        "summary": [
          "Diversification reduces reliance on a single income source. Social enterprises use business activity to pursue social goals but still face cost and governance constraints.",
          "More projects do not necessarily diversify risk; social intent does not guarantee operational or impact success."
        ],
        "explanation": "Develop different products and markets.  reduce highly correlated revenue risks.  skills and finance support new activities.\n\n### Original scenario and reasoning\n\nHypothetical scenario: a coffee cooperative adds processing and ecotourism, potentially adding value and spreading risk. Diversification is limited if both remain exposed to the same climate or visitor market.\n\nMore projects do not necessarily diversify risk; social intent does not guarantee operational or impact success.\n\nMatch policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
      }
    },
    "practice": [
      {
        "id": "u4-49-diversification-enterprise-flash-1",
        "knowledgePointId": "u4-49-diversification-enterprise",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“多样化与社会企业”，并说明一个关键条件。",
          "en": "Explain Diversification and social enterprise and state one important condition."
        },
        "answer": {
          "zh-CN": "产业和出口多样化减少对单一收入来源的依赖；社会企业以商业活动支持社会目标，但仍面临成本和治理约束。",
          "en": "Diversification reduces reliance on a single income source. Social enterprises use business activity to pursue social goals but still face cost and governance constraints."
        },
        "explanation": {
          "zh-CN": "项目数量增加不一定分散风险；社会目标也不保证经营或影响有效。",
          "en": "More projects do not necessarily diversify risk; social intent does not guarantee operational or impact success."
        }
      },
      {
        "id": "u4-49-diversification-enterprise-mcq-1",
        "knowledgePointId": "u4-49-diversification-enterprise",
        "type": "mcq",
        "prompt": {
          "zh-CN": "何种多样化更能降低风险？",
          "en": "What diversification most reduces risk?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "收入来源受不同冲击影响",
            "en": "Income sources exposed to different shocks"
          },
          {
            "id": "b",
            "zh-CN": "仅更改同一商品名称",
            "en": "Only renaming the same commodity"
          },
          {
            "id": "c",
            "zh-CN": "所有活动依赖同一买家",
            "en": "Every activity depends on one buyer"
          },
          {
            "id": "d",
            "zh-CN": "完全不看需求",
            "en": "Ignore demand entirely"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "收入来源受不同冲击影响。 开发不同市场和产品；降低高度相关的收入风险；技能和融资支持新活动 项目数量增加不一定分散风险；社会目标也不保证经营或影响有效。",
          "en": "Income sources exposed to different shocks. Develop different products and markets; reduce highly correlated revenue risks; skills and finance support new activities More projects do not necessarily diversify risk; social intent does not guarantee operational or impact success."
        }
      },
      {
        "id": "u4-49-diversification-enterprise-short-1",
        "knowledgePointId": "u4-49-diversification-enterprise",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释多样化与社会企业的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Diversification and social enterprise and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "产业和出口多样化减少对单一收入来源的依赖；社会企业以商业活动支持社会目标，但仍面临成本和治理约束。 开发不同市场和产品；降低高度相关的收入风险；技能和融资支持新活动 原创假设：咖啡合作社增加加工和生态旅游，可能提高附加值并分散风险；若两者都依赖同一气候或游客市场，风险分散有限。",
          "en": "Diversification reduces reliance on a single income source. Social enterprises use business activity to pursue social goals but still face cost and governance constraints. Develop different products and markets; reduce highly correlated revenue risks; skills and finance support new activities Hypothetical scenario: a coffee cooperative adds processing and ecotourism, potentially adding value and spreading risk. Diversification is limited if both remain exposed to the same climate or visitor market."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "多样化",
              "en": "diversification"
            },
            "alternatives": {
              "zh-CN": [
                "多样化",
                "开发不同市场和产品"
              ],
              "en": [
                "diversification",
                "Develop different products and markets"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "风险",
              "en": "risk"
            },
            "alternatives": {
              "zh-CN": [
                "风险",
                "降低高度相关的收入风险"
              ],
              "en": [
                "risk",
                "reduce highly correlated revenue risks"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "社会目标",
              "en": "social goals"
            },
            "alternatives": {
              "zh-CN": [
                "社会目标",
                "技能和融资支持新活动"
              ],
              "en": [
                "social goals",
                "skills and finance support new activities"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-50-market-based-development",
      "slug": "market-based-development",
      "section": "4.10",
      "level": "core",
      "syllabusRefs": [
        "4.10 Economic growth and development strategies"
      ],
      "textbookRefs": [
        {
          "chapter": "20",
          "section": "20.3",
          "pages": [
            602
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-48-trade-strategies",
        "u4-49-diversification-enterprise",
        "u4-51-public-services-development"
      ],
      "terms": [
        "市场导向的发展政策",
        "Market-based development policies",
        "竞争",
        "competition",
        "激励",
        "incentives",
        "监管",
        "regulation"
      ],
      "synonyms": {
        "zh-CN": [
          "竞争",
          "激励",
          "监管"
        ],
        "en": [
          "competition",
          "incentives",
          "regulation"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-50-market-based-development-flash-1",
        "u4-50-market-based-development-mcq-1",
        "u4-50-market-based-development-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-50-market-based-development",
        "locale": "zh-CN",
        "title": "市场导向的发展政策",
        "takeaway": "自由化、私有化和放松不必要监管可增强竞争与激励，但需要竞争政策、公共利益保护和可执行制度。",
        "definition": "自由化、私有化和放松不必要监管可增强竞争与激励，但需要竞争政策、公共利益保护和可执行制度。",
        "causalChain": [
          "降低进入障碍",
          "竞争与产权激励改善效率",
          "监管处理垄断与外部性"
        ],
        "misconceptions": [
          "私有化不是竞争的同义词；一次出售收入也不是持续财政改善的充分证据。"
        ],
        "examApplication": [
          "把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
        ],
        "summary": [
          "自由化、私有化和放松不必要监管可增强竞争与激励，但需要竞争政策、公共利益保护和可执行制度。",
          "私有化不是竞争的同义词；一次出售收入也不是持续财政改善的充分证据。"
        ],
        "explanation": "降低进入障碍。竞争与产权激励改善效率。监管处理垄断与外部性。\n\n### 原创情境与推导\n\n原创假设：出售国有供水企业若不设置价格和质量监管，可能仅把公共垄断变为私人垄断；结果要看覆盖、质量和价格。\n\n私有化不是竞争的同义词；一次出售收入也不是持续财政改善的充分证据。\n\n把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
      },
      "en": {
        "id": "u4-50-market-based-development",
        "locale": "en",
        "title": "Market-based development policies",
        "takeaway": "Liberalisation, privatisation and removal of unnecessary regulation may improve competition and incentives, supported by competition policy, public-interest safeguards and effective institutions.",
        "definition": "Liberalisation, privatisation and removal of unnecessary regulation may improve competition and incentives, supported by competition policy, public-interest safeguards and effective institutions.",
        "causalChain": [
          "Lower entry barriers",
          "competition and ownership incentives improve efficiency",
          "regulation addresses monopoly and externalities"
        ],
        "misconceptions": [
          "Privatisation is not synonymous with competition; one-off sale revenue does not prove lasting fiscal improvement."
        ],
        "examApplication": [
          "Match policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
        ],
        "summary": [
          "Liberalisation, privatisation and removal of unnecessary regulation may improve competition and incentives, supported by competition policy, public-interest safeguards and effective institutions.",
          "Privatisation is not synonymous with competition; one-off sale revenue does not prove lasting fiscal improvement."
        ],
        "explanation": "Lower entry barriers.  competition and ownership incentives improve efficiency.  regulation addresses monopoly and externalities.\n\n### Original scenario and reasoning\n\nHypothetical scenario: selling a public water supplier without price or quality regulation may merely create a private monopoly. Assess coverage, quality and prices.\n\nPrivatisation is not synonymous with competition; one-off sale revenue does not prove lasting fiscal improvement.\n\nMatch policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
      }
    },
    "practice": [
      {
        "id": "u4-50-market-based-development-flash-1",
        "knowledgePointId": "u4-50-market-based-development",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“市场导向的发展政策”，并说明一个关键条件。",
          "en": "Explain Market-based development policies and state one important condition."
        },
        "answer": {
          "zh-CN": "自由化、私有化和放松不必要监管可增强竞争与激励，但需要竞争政策、公共利益保护和可执行制度。",
          "en": "Liberalisation, privatisation and removal of unnecessary regulation may improve competition and incentives, supported by competition policy, public-interest safeguards and effective institutions."
        },
        "explanation": {
          "zh-CN": "私有化不是竞争的同义词；一次出售收入也不是持续财政改善的充分证据。",
          "en": "Privatisation is not synonymous with competition; one-off sale revenue does not prove lasting fiscal improvement."
        }
      },
      {
        "id": "u4-50-market-based-development-mcq-1",
        "knowledgePointId": "u4-50-market-based-development",
        "type": "mcq",
        "prompt": {
          "zh-CN": "自然垄断私有化应重点配合什么？",
          "en": "What particularly needs to accompany natural-monopoly privatisation?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "自动取消所有监管",
            "en": "Automatically remove all regulation"
          },
          {
            "id": "b",
            "zh-CN": "价格质量监管与问责",
            "en": "Price-quality regulation and accountability"
          },
          {
            "id": "c",
            "zh-CN": "保证企业无成本",
            "en": "Guarantee zero costs"
          },
          {
            "id": "d",
            "zh-CN": "只比较出售当天收入",
            "en": "Only compare sale-day revenue"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "价格质量监管与问责。 降低进入障碍；竞争与产权激励改善效率；监管处理垄断与外部性 私有化不是竞争的同义词；一次出售收入也不是持续财政改善的充分证据。",
          "en": "Price-quality regulation and accountability. Lower entry barriers; competition and ownership incentives improve efficiency; regulation addresses monopoly and externalities Privatisation is not synonymous with competition; one-off sale revenue does not prove lasting fiscal improvement."
        }
      },
      {
        "id": "u4-50-market-based-development-short-1",
        "knowledgePointId": "u4-50-market-based-development",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释市场导向的发展政策的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Market-based development policies and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "自由化、私有化和放松不必要监管可增强竞争与激励，但需要竞争政策、公共利益保护和可执行制度。 降低进入障碍；竞争与产权激励改善效率；监管处理垄断与外部性 原创假设：出售国有供水企业若不设置价格和质量监管，可能仅把公共垄断变为私人垄断；结果要看覆盖、质量和价格。",
          "en": "Liberalisation, privatisation and removal of unnecessary regulation may improve competition and incentives, supported by competition policy, public-interest safeguards and effective institutions. Lower entry barriers; competition and ownership incentives improve efficiency; regulation addresses monopoly and externalities Hypothetical scenario: selling a public water supplier without price or quality regulation may merely create a private monopoly. Assess coverage, quality and prices."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "竞争",
              "en": "competition"
            },
            "alternatives": {
              "zh-CN": [
                "竞争",
                "降低进入障碍"
              ],
              "en": [
                "competition",
                "Lower entry barriers"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "激励",
              "en": "incentives"
            },
            "alternatives": {
              "zh-CN": [
                "激励",
                "竞争与产权激励改善效率"
              ],
              "en": [
                "incentives",
                "competition and ownership incentives improve efficiency"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "监管",
              "en": "regulation"
            },
            "alternatives": {
              "zh-CN": [
                "监管",
                "监管处理垄断与外部性"
              ],
              "en": [
                "regulation",
                "regulation addresses monopoly and externalities"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-51-public-services-development",
      "slug": "public-services-development",
      "section": "4.10",
      "level": "core",
      "syllabusRefs": [
        "4.10 Economic growth and development strategies"
      ],
      "textbookRefs": [
        {
          "chapter": "20",
          "section": "20.4",
          "pages": [
            606
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-48-trade-strategies",
        "u4-49-diversification-enterprise",
        "u4-50-market-based-development"
      ],
      "terms": [
        "公共服务、再分配与发展",
        "Public services, redistribution and development",
        "服务",
        "services",
        "能力",
        "capabilities",
        "质量",
        "quality"
      ],
      "synonyms": {
        "zh-CN": [
          "服务",
          "能力",
          "质量"
        ],
        "en": [
          "services",
          "capabilities",
          "quality"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-51-public-services-development-flash-1",
        "u4-51-public-services-development-mcq-1",
        "u4-51-public-services-development-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-51-public-services-development",
        "locale": "zh-CN",
        "title": "公共服务、再分配与发展",
        "takeaway": "教育、健康、基础设施和定向转移可改善能力与机会，但财政空间、服务质量和执行决定结果。",
        "definition": "教育、健康、基础设施和定向转移可改善能力与机会，但财政空间、服务质量和执行决定结果。",
        "causalChain": [
          "公共服务降低个人进入障碍",
          "健康技能提高参与和生产率",
          "公平与增长可能相互促进"
        ],
        "misconceptions": [
          "政府支出不是自动有效，必须比较机会成本、漏损和受益群体。"
        ],
        "examApplication": [
          "把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
        ],
        "summary": [
          "教育、健康、基础设施和定向转移可改善能力与机会，但财政空间、服务质量和执行决定结果。",
          "政府支出不是自动有效，必须比较机会成本、漏损和受益群体。"
        ],
        "explanation": "公共服务降低个人进入障碍。健康技能提高参与和生产率。公平与增长可能相互促进。\n\n### 原创情境与推导\n\n原创假设：儿童现金补助配合附近有质量的学校，可能改善出勤；若学校缺师资，仅要求出勤会增加家庭负担。\n\n政府支出不是自动有效，必须比较机会成本、漏损和受益群体。\n\n把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
      },
      "en": {
        "id": "u4-51-public-services-development",
        "locale": "en",
        "title": "Public services, redistribution and development",
        "takeaway": "Education, health, infrastructure and targeted transfers can improve capabilities and opportunities; fiscal space, service quality and implementation determine outcomes.",
        "definition": "Education, health, infrastructure and targeted transfers can improve capabilities and opportunities; fiscal space, service quality and implementation determine outcomes.",
        "causalChain": [
          "Services lower individual barriers",
          "health and skills improve participation and productivity",
          "equity and growth may reinforce each other"
        ],
        "misconceptions": [
          "Public spending is not automatically effective; assess opportunity cost, leakage and beneficiaries."
        ],
        "examApplication": [
          "Match policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
        ],
        "summary": [
          "Education, health, infrastructure and targeted transfers can improve capabilities and opportunities; fiscal space, service quality and implementation determine outcomes.",
          "Public spending is not automatically effective; assess opportunity cost, leakage and beneficiaries."
        ],
        "explanation": "Services lower individual barriers.  health and skills improve participation and productivity.  equity and growth may reinforce each other.\n\n### Original scenario and reasoning\n\nHypothetical scenario: child transfers combined with accessible quality schools may improve attendance. Requiring attendance where teachers are absent can burden families.\n\nPublic spending is not automatically effective; assess opportunity cost, leakage and beneficiaries.\n\nMatch policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
      }
    },
    "practice": [
      {
        "id": "u4-51-public-services-development-flash-1",
        "knowledgePointId": "u4-51-public-services-development",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“公共服务、再分配与发展”，并说明一个关键条件。",
          "en": "Explain Public services, redistribution and development and state one important condition."
        },
        "answer": {
          "zh-CN": "教育、健康、基础设施和定向转移可改善能力与机会，但财政空间、服务质量和执行决定结果。",
          "en": "Education, health, infrastructure and targeted transfers can improve capabilities and opportunities; fiscal space, service quality and implementation determine outcomes."
        },
        "explanation": {
          "zh-CN": "政府支出不是自动有效，必须比较机会成本、漏损和受益群体。",
          "en": "Public spending is not automatically effective; assess opportunity cost, leakage and beneficiaries."
        }
      },
      {
        "id": "u4-51-public-services-development-mcq-1",
        "knowledgePointId": "u4-51-public-services-development",
        "type": "mcq",
        "prompt": {
          "zh-CN": "评估教育支出应看什么？",
          "en": "What should be assessed for education spending?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只看预算增加",
            "en": "Only budget increases"
          },
          {
            "id": "b",
            "zh-CN": "不看服务质量",
            "en": "Ignore service quality"
          },
          {
            "id": "c",
            "zh-CN": "学习成果、覆盖和机会成本",
            "en": "Learning outcomes, access and opportunity cost"
          },
          {
            "id": "d",
            "zh-CN": "只统计建筑面积",
            "en": "Only floor area"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "学习成果、覆盖和机会成本。 公共服务降低个人进入障碍；健康技能提高参与和生产率；公平与增长可能相互促进 政府支出不是自动有效，必须比较机会成本、漏损和受益群体。",
          "en": "Learning outcomes, access and opportunity cost. Services lower individual barriers; health and skills improve participation and productivity; equity and growth may reinforce each other Public spending is not automatically effective; assess opportunity cost, leakage and beneficiaries."
        }
      },
      {
        "id": "u4-51-public-services-development-short-1",
        "knowledgePointId": "u4-51-public-services-development",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释公共服务、再分配与发展的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Public services, redistribution and development and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "教育、健康、基础设施和定向转移可改善能力与机会，但财政空间、服务质量和执行决定结果。 公共服务降低个人进入障碍；健康技能提高参与和生产率；公平与增长可能相互促进 原创假设：儿童现金补助配合附近有质量的学校，可能改善出勤；若学校缺师资，仅要求出勤会增加家庭负担。",
          "en": "Education, health, infrastructure and targeted transfers can improve capabilities and opportunities; fiscal space, service quality and implementation determine outcomes. Services lower individual barriers; health and skills improve participation and productivity; equity and growth may reinforce each other Hypothetical scenario: child transfers combined with accessible quality schools may improve attendance. Requiring attendance where teachers are absent can burden families."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "服务",
              "en": "services"
            },
            "alternatives": {
              "zh-CN": [
                "服务",
                "公共服务降低个人进入障碍"
              ],
              "en": [
                "services",
                "Services lower individual barriers"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "能力",
              "en": "capabilities"
            },
            "alternatives": {
              "zh-CN": [
                "能力",
                "健康技能提高参与和生产率"
              ],
              "en": [
                "capabilities",
                "health and skills improve participation and productivity"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "质量",
              "en": "quality"
            },
            "alternatives": {
              "zh-CN": [
                "质量",
                "公平与增长可能相互促进"
              ],
              "en": [
                "quality",
                "equity and growth may reinforce each other"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-52-fdi-mncs",
      "slug": "fdi-mncs",
      "section": "4.10",
      "level": "core",
      "syllabusRefs": [
        "4.10 Economic growth and development strategies"
      ],
      "textbookRefs": [
        {
          "chapter": "20",
          "section": "20.5",
          "pages": [
            611
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-48-trade-strategies",
        "u4-49-diversification-enterprise",
        "u4-50-market-based-development"
      ],
      "terms": [
        "外国直接投资与跨国公司",
        "Foreign direct investment and multinational firms",
        "资本",
        "capital",
        "技术",
        "technology",
        "联系",
        "linkages"
      ],
      "synonyms": {
        "zh-CN": [
          "资本",
          "技术",
          "联系"
        ],
        "en": [
          "capital",
          "technology",
          "linkages"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-52-fdi-mncs-flash-1",
        "u4-52-fdi-mncs-mcq-1",
        "u4-52-fdi-mncs-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-52-fdi-mncs",
        "locale": "zh-CN",
        "title": "外国直接投资与跨国公司",
        "takeaway": "FDI 可带来资本、就业、技术和出口联系，也可能伴随利润汇出、市场势力、环境成本与有限本地联系。",
        "definition": "FDI 可带来资本、就业、技术和出口联系，也可能伴随利润汇出、市场势力、环境成本与有限本地联系。",
        "causalChain": [
          "跨国企业投入资本技术",
          "雇佣与采购产生本地联系",
          "制度与吸收能力影响技术溢出"
        ],
        "misconceptions": [
          "FDI 流入不等于当年经常账户收入；后续利润汇出通常影响初次收入。"
        ],
        "examApplication": [
          "把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
        ],
        "summary": [
          "FDI 可带来资本、就业、技术和出口联系，也可能伴随利润汇出、市场势力、环境成本与有限本地联系。",
          "FDI 流入不等于当年经常账户收入；后续利润汇出通常影响初次收入。"
        ],
        "explanation": "跨国企业投入资本技术。雇佣与采购产生本地联系。制度与吸收能力影响技术溢出。\n\n### 原创情境与推导\n\n原创假设：外资厂培训本地员工并采购本地零件，可扩散技能；若全部进口投入并获长期免税，本地净收益可能较小。\n\nFDI 流入不等于当年经常账户收入；后续利润汇出通常影响初次收入。\n\n把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
      },
      "en": {
        "id": "u4-52-fdi-mncs",
        "locale": "en",
        "title": "Foreign direct investment and multinational firms",
        "takeaway": "FDI can bring capital, jobs, technology and export linkages, alongside profit repatriation, market power, environmental costs and weak local linkages.",
        "definition": "FDI can bring capital, jobs, technology and export linkages, alongside profit repatriation, market power, environmental costs and weak local linkages.",
        "causalChain": [
          "Multinationals bring capital and technology",
          "hiring and procurement create local linkages",
          "institutions and absorptive capacity shape spillovers"
        ],
        "misconceptions": [
          "FDI inflow is not current-account income; later repatriated profits normally affect primary income."
        ],
        "examApplication": [
          "Match policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
        ],
        "summary": [
          "FDI can bring capital, jobs, technology and export linkages, alongside profit repatriation, market power, environmental costs and weak local linkages.",
          "FDI inflow is not current-account income; later repatriated profits normally affect primary income."
        ],
        "explanation": "Multinationals bring capital and technology.  hiring and procurement create local linkages.  institutions and absorptive capacity shape spillovers.\n\n### Original scenario and reasoning\n\nHypothetical scenario: training local staff and buying local parts can spread skills. Importing all inputs with prolonged tax holidays may leave smaller local net gains.\n\nFDI inflow is not current-account income; later repatriated profits normally affect primary income.\n\nMatch policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
      }
    },
    "practice": [
      {
        "id": "u4-52-fdi-mncs-flash-1",
        "knowledgePointId": "u4-52-fdi-mncs",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“外国直接投资与跨国公司”，并说明一个关键条件。",
          "en": "Explain Foreign direct investment and multinational firms and state one important condition."
        },
        "answer": {
          "zh-CN": "FDI 可带来资本、就业、技术和出口联系，也可能伴随利润汇出、市场势力、环境成本与有限本地联系。",
          "en": "FDI can bring capital, jobs, technology and export linkages, alongside profit repatriation, market power, environmental costs and weak local linkages."
        },
        "explanation": {
          "zh-CN": "FDI 流入不等于当年经常账户收入；后续利润汇出通常影响初次收入。",
          "en": "FDI inflow is not current-account income; later repatriated profits normally affect primary income."
        }
      },
      {
        "id": "u4-52-fdi-mncs-mcq-1",
        "knowledgePointId": "u4-52-fdi-mncs",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪项最可能增强 FDI 的本地技术收益？",
          "en": "What most supports local technology gains from FDI?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "完全隔离本地企业",
            "en": "Complete isolation from local firms"
          },
          {
            "id": "b",
            "zh-CN": "无条件永久免税",
            "en": "Unconditional permanent tax exemption"
          },
          {
            "id": "c",
            "zh-CN": "只统计流入金额",
            "en": "Only count inflow value"
          },
          {
            "id": "d",
            "zh-CN": "员工培训与本地供应商联系",
            "en": "Staff training and local supplier linkages"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "员工培训与本地供应商联系。 跨国企业投入资本技术；雇佣与采购产生本地联系；制度与吸收能力影响技术溢出 FDI 流入不等于当年经常账户收入；后续利润汇出通常影响初次收入。",
          "en": "Staff training and local supplier linkages. Multinationals bring capital and technology; hiring and procurement create local linkages; institutions and absorptive capacity shape spillovers FDI inflow is not current-account income; later repatriated profits normally affect primary income."
        }
      },
      {
        "id": "u4-52-fdi-mncs-short-1",
        "knowledgePointId": "u4-52-fdi-mncs",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释外国直接投资与跨国公司的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Foreign direct investment and multinational firms and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "FDI 可带来资本、就业、技术和出口联系，也可能伴随利润汇出、市场势力、环境成本与有限本地联系。 跨国企业投入资本技术；雇佣与采购产生本地联系；制度与吸收能力影响技术溢出 原创假设：外资厂培训本地员工并采购本地零件，可扩散技能；若全部进口投入并获长期免税，本地净收益可能较小。",
          "en": "FDI can bring capital, jobs, technology and export linkages, alongside profit repatriation, market power, environmental costs and weak local linkages. Multinationals bring capital and technology; hiring and procurement create local linkages; institutions and absorptive capacity shape spillovers Hypothetical scenario: training local staff and buying local parts can spread skills. Importing all inputs with prolonged tax holidays may leave smaller local net gains."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "资本",
              "en": "capital"
            },
            "alternatives": {
              "zh-CN": [
                "资本",
                "跨国企业投入资本技术"
              ],
              "en": [
                "capital",
                "Multinationals bring capital and technology"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "技术",
              "en": "technology"
            },
            "alternatives": {
              "zh-CN": [
                "技术",
                "雇佣与采购产生本地联系"
              ],
              "en": [
                "technology",
                "hiring and procurement create local linkages"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "联系",
              "en": "linkages"
            },
            "alternatives": {
              "zh-CN": [
                "联系",
                "制度与吸收能力影响技术溢出"
              ],
              "en": [
                "linkages",
                "institutions and absorptive capacity shape spillovers"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-53-aid-ngos",
      "slug": "aid-ngos",
      "section": "4.10",
      "level": "core",
      "syllabusRefs": [
        "4.10 Economic growth and development strategies"
      ],
      "textbookRefs": [
        {
          "chapter": "20",
          "section": "20.6",
          "pages": [
            615
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-48-trade-strategies",
        "u4-49-diversification-enterprise",
        "u4-50-market-based-development"
      ],
      "terms": [
        "援助、非政府组织与本地参与",
        "Aid, NGOs and local participation",
        "援助",
        "aid",
        "能力",
        "capacity",
        "问责",
        "accountability"
      ],
      "synonyms": {
        "zh-CN": [
          "援助",
          "能力",
          "问责"
        ],
        "en": [
          "aid",
          "capacity",
          "accountability"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-53-aid-ngos-flash-1",
        "u4-53-aid-ngos-mcq-1",
        "u4-53-aid-ngos-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-53-aid-ngos",
        "locale": "zh-CN",
        "title": "援助、非政府组织与本地参与",
        "takeaway": "人道援助应对紧急需要，发展援助支持长期能力；赠款、贷款及附带条件的援助对受援者影响不同。",
        "definition": "人道援助应对紧急需要，发展援助支持长期能力；赠款、贷款及附带条件的援助对受援者影响不同。",
        "causalChain": [
          "外部资源缓解约束",
          "项目设计影响本地所有权",
          "问责与评估决定持续效果"
        ],
        "misconceptions": [
          "援助不都是免费资金；贷款增加偿还义务，附带采购条件可能提高成本。"
        ],
        "examApplication": [
          "把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
        ],
        "summary": [
          "人道援助应对紧急需要，发展援助支持长期能力；赠款、贷款及附带条件的援助对受援者影响不同。",
          "援助不都是免费资金；贷款增加偿还义务，附带采购条件可能提高成本。"
        ],
        "explanation": "外部资源缓解约束。项目设计影响本地所有权。问责与评估决定持续效果。\n\n### 原创情境与推导\n\n原创假设：灾后供水赠款能救急；若只采购捐助国昂贵设备且无本地维修培训，长期效果可能有限。NGO 也需协调和问责。\n\n援助不都是免费资金；贷款增加偿还义务，附带采购条件可能提高成本。\n\n把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
      },
      "en": {
        "id": "u4-53-aid-ngos",
        "locale": "en",
        "title": "Aid, NGOs and local participation",
        "takeaway": "Humanitarian aid addresses emergencies, while development aid supports long-term capabilities. Grants, loans and tied aid have different effects on recipients.",
        "definition": "Humanitarian aid addresses emergencies, while development aid supports long-term capabilities. Grants, loans and tied aid have different effects on recipients.",
        "causalChain": [
          "External resources relax constraints",
          "project design shapes local ownership",
          "accountability and evaluation determine lasting effects"
        ],
        "misconceptions": [
          "Aid is not all free money; loans create repayment obligations and tied procurement may raise costs."
        ],
        "examApplication": [
          "Match policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
        ],
        "summary": [
          "Humanitarian aid addresses emergencies, while development aid supports long-term capabilities. Grants, loans and tied aid have different effects on recipients.",
          "Aid is not all free money; loans create repayment obligations and tied procurement may raise costs."
        ],
        "explanation": "External resources relax constraints.  project design shapes local ownership.  accountability and evaluation determine lasting effects.\n\n### Original scenario and reasoning\n\nHypothetical scenario: emergency water grants help after disaster, but expensive donor-country equipment without local repair training may not last. NGOs also need coordination and accountability.\n\nAid is not all free money; loans create repayment obligations and tied procurement may raise costs.\n\nMatch policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
      }
    },
    "practice": [
      {
        "id": "u4-53-aid-ngos-flash-1",
        "knowledgePointId": "u4-53-aid-ngos",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“援助、非政府组织与本地参与”，并说明一个关键条件。",
          "en": "Explain Aid, NGOs and local participation and state one important condition."
        },
        "answer": {
          "zh-CN": "人道援助应对紧急需要，发展援助支持长期能力；赠款、贷款及附带条件的援助对受援者影响不同。",
          "en": "Humanitarian aid addresses emergencies, while development aid supports long-term capabilities. Grants, loans and tied aid have different effects on recipients."
        },
        "explanation": {
          "zh-CN": "援助不都是免费资金；贷款增加偿还义务，附带采购条件可能提高成本。",
          "en": "Aid is not all free money; loans create repayment obligations and tied procurement may raise costs."
        }
      },
      {
        "id": "u4-53-aid-ngos-mcq-1",
        "knowledgePointId": "u4-53-aid-ngos",
        "type": "mcq",
        "prompt": {
          "zh-CN": "什么最可能提高供水援助的持续性？",
          "en": "What most improves the durability of water aid?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "本地维修能力和参与",
            "en": "Local repair capacity and participation"
          },
          {
            "id": "b",
            "zh-CN": "只举行交付仪式",
            "en": "Only a handover ceremony"
          },
          {
            "id": "c",
            "zh-CN": "不提供维护经费",
            "en": "No maintenance funding"
          },
          {
            "id": "d",
            "zh-CN": "不问居民需求",
            "en": "No assessment of residents' needs"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "本地维修能力和参与。 外部资源缓解约束；项目设计影响本地所有权；问责与评估决定持续效果 援助不都是免费资金；贷款增加偿还义务，附带采购条件可能提高成本。",
          "en": "Local repair capacity and participation. External resources relax constraints; project design shapes local ownership; accountability and evaluation determine lasting effects Aid is not all free money; loans create repayment obligations and tied procurement may raise costs."
        }
      },
      {
        "id": "u4-53-aid-ngos-short-1",
        "knowledgePointId": "u4-53-aid-ngos",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释援助、非政府组织与本地参与的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Aid, NGOs and local participation and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "人道援助应对紧急需要，发展援助支持长期能力；赠款、贷款及附带条件的援助对受援者影响不同。 外部资源缓解约束；项目设计影响本地所有权；问责与评估决定持续效果 原创假设：灾后供水赠款能救急；若只采购捐助国昂贵设备且无本地维修培训，长期效果可能有限。NGO 也需协调和问责。",
          "en": "Humanitarian aid addresses emergencies, while development aid supports long-term capabilities. Grants, loans and tied aid have different effects on recipients. External resources relax constraints; project design shapes local ownership; accountability and evaluation determine lasting effects Hypothetical scenario: emergency water grants help after disaster, but expensive donor-country equipment without local repair training may not last. NGOs also need coordination and accountability."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "援助",
              "en": "aid"
            },
            "alternatives": {
              "zh-CN": [
                "援助",
                "外部资源缓解约束"
              ],
              "en": [
                "aid",
                "External resources relax constraints"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "能力",
              "en": "capacity"
            },
            "alternatives": {
              "zh-CN": [
                "能力",
                "项目设计影响本地所有权"
              ],
              "en": [
                "capacity",
                "project design shapes local ownership"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "问责",
              "en": "accountability"
            },
            "alternatives": {
              "zh-CN": [
                "问责",
                "问责与评估决定持续效果"
              ],
              "en": [
                "accountability",
                "accountability and evaluation determine lasting effects"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-54-multilateral-debt-relief",
      "slug": "multilateral-debt-relief",
      "section": "4.10",
      "level": "core",
      "syllabusRefs": [
        "4.10 Economic growth and development strategies"
      ],
      "textbookRefs": [
        {
          "chapter": "20",
          "section": "20.7",
          "pages": [
            623
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-48-trade-strategies",
        "u4-49-diversification-enterprise",
        "u4-50-market-based-development"
      ],
      "terms": [
        "多边机构与债务减免",
        "Multilateral institutions and debt relief",
        "融资",
        "finance",
        "条件",
        "conditions",
        "财政空间",
        "fiscal space"
      ],
      "synonyms": {
        "zh-CN": [
          "融资",
          "条件",
          "财政空间"
        ],
        "en": [
          "finance",
          "conditions",
          "fiscal space"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-54-multilateral-debt-relief-flash-1",
        "u4-54-multilateral-debt-relief-mcq-1",
        "u4-54-multilateral-debt-relief-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-54-multilateral-debt-relief",
        "locale": "zh-CN",
        "title": "多边机构与债务减免",
        "takeaway": "多边发展融资可支持长期项目，国际收支支持可缓解外部融资压力；贷款条件和债务减免需评价财政空间与社会代价。",
        "definition": "多边发展融资可支持长期项目，国际收支支持可缓解外部融资压力；贷款条件和债务减免需评价财政空间与社会代价。",
        "causalChain": [
          "外部融资缓解短缺",
          "条件改变政策路径",
          "债务重组或减免影响未来支出与融资激励"
        ],
        "misconceptions": [
          "不能把 IMF、世界银行和 WTO 当作同一机构；项目条款与现行职责须查原始资料。"
        ],
        "examApplication": [
          "把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
        ],
        "summary": [
          "多边发展融资可支持长期项目，国际收支支持可缓解外部融资压力；贷款条件和债务减免需评价财政空间与社会代价。",
          "不能把 IMF、世界银行和 WTO 当作同一机构；项目条款与现行职责须查原始资料。"
        ],
        "explanation": "外部融资缓解短缺。条件改变政策路径。债务重组或减免影响未来支出与融资激励。\n\n### 原创情境与推导\n\n原创假设：债务减免释放卫生预算，但若治理和税基问题未变，新债仍可能累积；紧缩条件也需保护基本服务。\n\n不能把 IMF、世界银行和 WTO 当作同一机构；项目条款与现行职责须查原始资料。\n\n把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
      },
      "en": {
        "id": "u4-54-multilateral-debt-relief",
        "locale": "en",
        "title": "Multilateral institutions and debt relief",
        "takeaway": "Multilateral development finance can support long-term projects, while balance-of-payments support eases external financing pressure. Conditions and debt relief require evaluation of fiscal space and social costs.",
        "definition": "Multilateral development finance can support long-term projects, while balance-of-payments support eases external financing pressure. Conditions and debt relief require evaluation of fiscal space and social costs.",
        "causalChain": [
          "External finance eases shortages",
          "conditions alter policy paths",
          "restructuring or relief affects future spending and financing incentives"
        ],
        "misconceptions": [
          "The IMF, World Bank and WTO are distinct institutions; project terms and current mandates require primary-source checks."
        ],
        "examApplication": [
          "Match policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
        ],
        "summary": [
          "Multilateral development finance can support long-term projects, while balance-of-payments support eases external financing pressure. Conditions and debt relief require evaluation of fiscal space and social costs.",
          "The IMF, World Bank and WTO are distinct institutions; project terms and current mandates require primary-source checks."
        ],
        "explanation": "External finance eases shortages.  conditions alter policy paths.  restructuring or relief affects future spending and financing incentives.\n\n### Original scenario and reasoning\n\nHypothetical scenario: debt relief frees health spending, but new debt can build up if governance and revenue problems remain. Fiscal conditions also need protection for essential services.\n\nThe IMF, World Bank and WTO are distinct institutions; project terms and current mandates require primary-source checks.\n\nMatch policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
      }
    },
    "practice": [
      {
        "id": "u4-54-multilateral-debt-relief-flash-1",
        "knowledgePointId": "u4-54-multilateral-debt-relief",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“多边机构与债务减免”，并说明一个关键条件。",
          "en": "Explain Multilateral institutions and debt relief and state one important condition."
        },
        "answer": {
          "zh-CN": "多边发展融资可支持长期项目，国际收支支持可缓解外部融资压力；贷款条件和债务减免需评价财政空间与社会代价。",
          "en": "Multilateral development finance can support long-term projects, while balance-of-payments support eases external financing pressure. Conditions and debt relief require evaluation of fiscal space and social costs."
        },
        "explanation": {
          "zh-CN": "不能把 IMF、世界银行和 WTO 当作同一机构；项目条款与现行职责须查原始资料。",
          "en": "The IMF, World Bank and WTO are distinct institutions; project terms and current mandates require primary-source checks."
        }
      },
      {
        "id": "u4-54-multilateral-debt-relief-mcq-1",
        "knowledgePointId": "u4-54-multilateral-debt-relief",
        "type": "mcq",
        "prompt": {
          "zh-CN": "债务减免的一个可能发展收益是什么？",
          "en": "What is one potential development gain from debt relief?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "永久消除一切融资约束",
            "en": "Permanently removing all financing constraints"
          },
          {
            "id": "b",
            "zh-CN": "释放基本服务的财政空间",
            "en": "Freeing fiscal space for essential services"
          },
          {
            "id": "c",
            "zh-CN": "保证没有治理问题",
            "en": "Guaranteeing no governance problems"
          },
          {
            "id": "d",
            "zh-CN": "自动使所有进口免费",
            "en": "Automatically making all imports free"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "释放基本服务的财政空间。 外部融资缓解短缺；条件改变政策路径；债务重组或减免影响未来支出与融资激励 不能把 IMF、世界银行和 WTO 当作同一机构；项目条款与现行职责须查原始资料。",
          "en": "Freeing fiscal space for essential services. External finance eases shortages; conditions alter policy paths; restructuring or relief affects future spending and financing incentives The IMF, World Bank and WTO are distinct institutions; project terms and current mandates require primary-source checks."
        }
      },
      {
        "id": "u4-54-multilateral-debt-relief-short-1",
        "knowledgePointId": "u4-54-multilateral-debt-relief",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释多边机构与债务减免的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Multilateral institutions and debt relief and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "多边发展融资可支持长期项目，国际收支支持可缓解外部融资压力；贷款条件和债务减免需评价财政空间与社会代价。 外部融资缓解短缺；条件改变政策路径；债务重组或减免影响未来支出与融资激励 原创假设：债务减免释放卫生预算，但若治理和税基问题未变，新债仍可能累积；紧缩条件也需保护基本服务。",
          "en": "Multilateral development finance can support long-term projects, while balance-of-payments support eases external financing pressure. Conditions and debt relief require evaluation of fiscal space and social costs. External finance eases shortages; conditions alter policy paths; restructuring or relief affects future spending and financing incentives Hypothetical scenario: debt relief frees health spending, but new debt can build up if governance and revenue problems remain. Fiscal conditions also need protection for essential services."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "融资",
              "en": "finance"
            },
            "alternatives": {
              "zh-CN": [
                "融资",
                "外部融资缓解短缺"
              ],
              "en": [
                "finance",
                "External finance eases shortages"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "条件",
              "en": "conditions"
            },
            "alternatives": {
              "zh-CN": [
                "条件",
                "条件改变政策路径"
              ],
              "en": [
                "conditions",
                "conditions alter policy paths"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "财政空间",
              "en": "fiscal space"
            },
            "alternatives": {
              "zh-CN": [
                "财政空间",
                "债务重组或减免影响未来支出与融资激励"
              ],
              "en": [
                "fiscal space",
                "restructuring or relief affects future spending and financing incentives"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-55-institutional-change",
      "slug": "institutional-change",
      "section": "4.10",
      "level": "core",
      "syllabusRefs": [
        "4.10 Economic growth and development strategies"
      ],
      "textbookRefs": [
        {
          "chapter": "20",
          "section": "20.8",
          "pages": [
            627
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-48-trade-strategies",
        "u4-49-diversification-enterprise",
        "u4-50-market-based-development"
      ],
      "terms": [
        "制度改革、包容性金融与赋权",
        "Institutional reform, inclusive finance and empowerment",
        "规则",
        "rules",
        "融资",
        "finance",
        "参与",
        "participation"
      ],
      "synonyms": {
        "zh-CN": [
          "规则",
          "融资",
          "参与"
        ],
        "en": [
          "rules",
          "finance",
          "participation"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-55-institutional-change-flash-1",
        "u4-55-institutional-change-mcq-1",
        "u4-55-institutional-change-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-55-institutional-change",
        "locale": "zh-CN",
        "title": "制度改革、包容性金融与赋权",
        "takeaway": "可信法治、透明预算、可获得的金融服务和性别平等可改善参与和投资，但改革需结合当地执行能力。",
        "definition": "可信法治、透明预算、可获得的金融服务和性别平等可改善参与和投资，但改革需结合当地执行能力。",
        "causalChain": [
          "规则与信息改善降低风险",
          "弱势群体获得融资和机会",
          "监督与执行维持信任"
        ],
        "misconceptions": [
          "数字账户数量不等于有效金融包容；费用、识字、安全和实际使用同样关键。"
        ],
        "examApplication": [
          "把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
        ],
        "summary": [
          "可信法治、透明预算、可获得的金融服务和性别平等可改善参与和投资，但改革需结合当地执行能力。",
          "数字账户数量不等于有效金融包容；费用、识字、安全和实际使用同样关键。"
        ],
        "explanation": "规则与信息改善降低风险。弱势群体获得融资和机会。监督与执行维持信任。\n\n### 原创情境与推导\n\n原创假设：小额贷款配合储蓄、保险和培训可帮助经营；对无稳定现金流的家庭高息放贷可能加重负担，不能假设借款即脱贫。\n\n数字账户数量不等于有效金融包容；费用、识字、安全和实际使用同样关键。\n\n把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
      },
      "en": {
        "id": "u4-55-institutional-change",
        "locale": "en",
        "title": "Institutional reform, inclusive finance and empowerment",
        "takeaway": "Credible rule of law, transparent budgets, accessible finance and gender equality can improve participation and investment, with reforms adapted to local implementation capacity.",
        "definition": "Credible rule of law, transparent budgets, accessible finance and gender equality can improve participation and investment, with reforms adapted to local implementation capacity.",
        "causalChain": [
          "Better rules and information reduce risk",
          "excluded groups gain finance and opportunities",
          "oversight and enforcement maintain trust"
        ],
        "misconceptions": [
          "Account counts do not establish effective inclusion; fees, literacy, safety and actual use matter."
        ],
        "examApplication": [
          "Match policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
        ],
        "summary": [
          "Credible rule of law, transparent budgets, accessible finance and gender equality can improve participation and investment, with reforms adapted to local implementation capacity.",
          "Account counts do not establish effective inclusion; fees, literacy, safety and actual use matter."
        ],
        "explanation": "Better rules and information reduce risk.  excluded groups gain finance and opportunities.  oversight and enforcement maintain trust.\n\n### Original scenario and reasoning\n\nHypothetical scenario: microcredit combined with saving, insurance and training may support enterprise. High-interest lending to households without stable cash flow can worsen burdens; borrowing does not itself establish poverty reduction.\n\nAccount counts do not establish effective inclusion; fees, literacy, safety and actual use matter.\n\nMatch policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
      }
    },
    "practice": [
      {
        "id": "u4-55-institutional-change-flash-1",
        "knowledgePointId": "u4-55-institutional-change",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“制度改革、包容性金融与赋权”，并说明一个关键条件。",
          "en": "Explain Institutional reform, inclusive finance and empowerment and state one important condition."
        },
        "answer": {
          "zh-CN": "可信法治、透明预算、可获得的金融服务和性别平等可改善参与和投资，但改革需结合当地执行能力。",
          "en": "Credible rule of law, transparent budgets, accessible finance and gender equality can improve participation and investment, with reforms adapted to local implementation capacity."
        },
        "explanation": {
          "zh-CN": "数字账户数量不等于有效金融包容；费用、识字、安全和实际使用同样关键。",
          "en": "Account counts do not establish effective inclusion; fees, literacy, safety and actual use matter."
        }
      },
      {
        "id": "u4-55-institutional-change-mcq-1",
        "knowledgePointId": "u4-55-institutional-change",
        "type": "mcq",
        "prompt": {
          "zh-CN": "评估小额信贷最应看哪项？",
          "en": "What most matters when evaluating microcredit?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只看发放笔数",
            "en": "Only number of loans"
          },
          {
            "id": "b",
            "zh-CN": "贷款越大必越好",
            "en": "Larger loans are always better"
          },
          {
            "id": "c",
            "zh-CN": "净收入、还款压力与实际用途",
            "en": "Net income, repayment stress and actual use"
          },
          {
            "id": "d",
            "zh-CN": "不看利率与风险",
            "en": "Ignore rates and risks"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "净收入、还款压力与实际用途。 规则与信息改善降低风险；弱势群体获得融资和机会；监督与执行维持信任 数字账户数量不等于有效金融包容；费用、识字、安全和实际使用同样关键。",
          "en": "Net income, repayment stress and actual use. Better rules and information reduce risk; excluded groups gain finance and opportunities; oversight and enforcement maintain trust Account counts do not establish effective inclusion; fees, literacy, safety and actual use matter."
        }
      },
      {
        "id": "u4-55-institutional-change-short-1",
        "knowledgePointId": "u4-55-institutional-change",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释制度改革、包容性金融与赋权的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Institutional reform, inclusive finance and empowerment and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "可信法治、透明预算、可获得的金融服务和性别平等可改善参与和投资，但改革需结合当地执行能力。 规则与信息改善降低风险；弱势群体获得融资和机会；监督与执行维持信任 原创假设：小额贷款配合储蓄、保险和培训可帮助经营；对无稳定现金流的家庭高息放贷可能加重负担，不能假设借款即脱贫。",
          "en": "Credible rule of law, transparent budgets, accessible finance and gender equality can improve participation and investment, with reforms adapted to local implementation capacity. Better rules and information reduce risk; excluded groups gain finance and opportunities; oversight and enforcement maintain trust Hypothetical scenario: microcredit combined with saving, insurance and training may support enterprise. High-interest lending to households without stable cash flow can worsen burdens; borrowing does not itself establish poverty reduction."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "规则",
              "en": "rules"
            },
            "alternatives": {
              "zh-CN": [
                "规则",
                "规则与信息改善降低风险"
              ],
              "en": [
                "rules",
                "Better rules and information reduce risk"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "融资",
              "en": "finance"
            },
            "alternatives": {
              "zh-CN": [
                "融资",
                "弱势群体获得融资和机会"
              ],
              "en": [
                "finance",
                "excluded groups gain finance and opportunities"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "参与",
              "en": "participation"
            },
            "alternatives": {
              "zh-CN": [
                "参与",
                "监督与执行维持信任"
              ],
              "en": [
                "participation",
                "oversight and enforcement maintain trust"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-56-development-policy-mix",
      "slug": "development-policy-mix",
      "section": "4.10",
      "level": "core",
      "syllabusRefs": [
        "4.10 Economic growth and development strategies"
      ],
      "textbookRefs": [
        {
          "chapter": "20",
          "section": "20.9",
          "pages": [
            633
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-48-trade-strategies",
        "u4-49-diversification-enterprise",
        "u4-50-market-based-development"
      ],
      "terms": [
        "发展战略组合与证据评价",
        "Development policy mixes and evidence",
        "约束",
        "constraints",
        "政策",
        "policies",
        "证据",
        "evidence"
      ],
      "synonyms": {
        "zh-CN": [
          "约束",
          "政策",
          "证据"
        ],
        "en": [
          "constraints",
          "policies",
          "evidence"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-56-development-policy-mix-flash-1",
        "u4-56-development-policy-mix-mcq-1",
        "u4-56-development-policy-mix-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-56-development-policy-mix",
        "locale": "zh-CN",
        "title": "发展战略组合与证据评价",
        "takeaway": "有效战略应针对主要约束，结合市场激励与公共投入，按公平、可持续性、成本和可观察结果评价。",
        "definition": "有效战略应针对主要约束，结合市场激励与公共投入，按公平、可持续性、成本和可观察结果评价。",
        "causalChain": [
          "识别约束与目标",
          "选择互补政策并明确时序",
          "用可信结果证据修正措施"
        ],
        "misconceptions": [
          "没有适用于所有国家的唯一配方；投入和宣布不能替代结果证据。"
        ],
        "examApplication": [
          "把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
        ],
        "summary": [
          "有效战略应针对主要约束，结合市场激励与公共投入，按公平、可持续性、成本和可观察结果评价。",
          "没有适用于所有国家的唯一配方；投入和宣布不能替代结果证据。"
        ],
        "explanation": "识别约束与目标。选择互补政策并明确时序。用可信结果证据修正措施。\n\n### 原创情境与推导\n\n原创假设：出口加工需要道路、供电、技能与海关协同；设立对照或分期实施有助判断效果，还应检查地区和性别受益差异。\n\n没有适用于所有国家的唯一配方；投入和宣布不能替代结果证据。\n\n把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
      },
      "en": {
        "id": "u4-56-development-policy-mix",
        "locale": "en",
        "title": "Development policy mixes and evidence",
        "takeaway": "Effective strategies target binding constraints, combine market incentives with public investment, and are evaluated through equity, sustainability, cost and observed outcomes.",
        "definition": "Effective strategies target binding constraints, combine market incentives with public investment, and are evaluated through equity, sustainability, cost and observed outcomes.",
        "causalChain": [
          "Identify constraints and goals",
          "choose complementary policies and sequencing",
          "revise measures using credible outcome evidence"
        ],
        "misconceptions": [
          "There is no single recipe for every country; spending and announcements cannot replace outcome evidence."
        ],
        "examApplication": [
          "Match policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
        ],
        "summary": [
          "Effective strategies target binding constraints, combine market incentives with public investment, and are evaluated through equity, sustainability, cost and observed outcomes.",
          "There is no single recipe for every country; spending and announcements cannot replace outcome evidence."
        ],
        "explanation": "Identify constraints and goals.  choose complementary policies and sequencing.  revise measures using credible outcome evidence.\n\n### Original scenario and reasoning\n\nHypothetical scenario: export processing needs roads, power, skills and customs coordination. Comparison groups or phased introduction help assess effects, alongside regional and gender differences.\n\nThere is no single recipe for every country; spending and announcements cannot replace outcome evidence.\n\nMatch policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
      }
    },
    "practice": [
      {
        "id": "u4-56-development-policy-mix-flash-1",
        "knowledgePointId": "u4-56-development-policy-mix",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“发展战略组合与证据评价”，并说明一个关键条件。",
          "en": "Explain Development policy mixes and evidence and state one important condition."
        },
        "answer": {
          "zh-CN": "有效战略应针对主要约束，结合市场激励与公共投入，按公平、可持续性、成本和可观察结果评价。",
          "en": "Effective strategies target binding constraints, combine market incentives with public investment, and are evaluated through equity, sustainability, cost and observed outcomes."
        },
        "explanation": {
          "zh-CN": "没有适用于所有国家的唯一配方；投入和宣布不能替代结果证据。",
          "en": "There is no single recipe for every country; spending and announcements cannot replace outcome evidence."
        }
      },
      {
        "id": "u4-56-development-policy-mix-mcq-1",
        "knowledgePointId": "u4-56-development-policy-mix",
        "type": "mcq",
        "prompt": {
          "zh-CN": "怎样最能判断战略是否有效？",
          "en": "How can a strategy's effectiveness best be assessed?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只按计划支出排名",
            "en": "Rank only planned spending"
          },
          {
            "id": "b",
            "zh-CN": "复制他国全部政策",
            "en": "Copy every policy from another country"
          },
          {
            "id": "c",
            "zh-CN": "忽略机会成本",
            "en": "Ignore opportunity cost"
          },
          {
            "id": "d",
            "zh-CN": "结合基线、可比结果与分配影响",
            "en": "Combine baselines, comparable outcomes and distributional effects"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "结合基线、可比结果与分配影响。 识别约束与目标；选择互补政策并明确时序；用可信结果证据修正措施 没有适用于所有国家的唯一配方；投入和宣布不能替代结果证据。",
          "en": "Combine baselines, comparable outcomes and distributional effects. Identify constraints and goals; choose complementary policies and sequencing; revise measures using credible outcome evidence There is no single recipe for every country; spending and announcements cannot replace outcome evidence."
        }
      },
      {
        "id": "u4-56-development-policy-mix-short-1",
        "knowledgePointId": "u4-56-development-policy-mix",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释发展战略组合与证据评价的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Development policy mixes and evidence and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "有效战略应针对主要约束，结合市场激励与公共投入，按公平、可持续性、成本和可观察结果评价。 识别约束与目标；选择互补政策并明确时序；用可信结果证据修正措施 原创假设：出口加工需要道路、供电、技能与海关协同；设立对照或分期实施有助判断效果，还应检查地区和性别受益差异。",
          "en": "Effective strategies target binding constraints, combine market incentives with public investment, and are evaluated through equity, sustainability, cost and observed outcomes. Identify constraints and goals; choose complementary policies and sequencing; revise measures using credible outcome evidence Hypothetical scenario: export processing needs roads, power, skills and customs coordination. Comparison groups or phased introduction help assess effects, alongside regional and gender differences."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "约束",
              "en": "constraints"
            },
            "alternatives": {
              "zh-CN": [
                "约束",
                "识别约束与目标"
              ],
              "en": [
                "constraints",
                "Identify constraints and goals"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "政策",
              "en": "policies"
            },
            "alternatives": {
              "zh-CN": [
                "政策",
                "选择互补政策并明确时序"
              ],
              "en": [
                "policies",
                "choose complementary policies and sequencing"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "证据",
              "en": "evidence"
            },
            "alternatives": {
              "zh-CN": [
                "证据",
                "用可信结果证据修正措施"
              ],
              "en": [
                "evidence",
                "revise measures using credible outcome evidence"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-57-monetary-union-evaluation",
      "slug": "monetary-union-evaluation",
      "section": "4.4",
      "level": "hl",
      "syllabusRefs": [
        "4.4 Economic integration"
      ],
      "textbookRefs": [
        {
          "chapter": "15",
          "section": "15.3",
          "pages": [
            482
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-15-wto",
        "u4-16-trading-blocs",
        "u4-17-common-market"
      ],
      "terms": [
        "货币联盟的评价",
        "Evaluating monetary union",
        "共同利率",
        "one interest rate",
        "冲击",
        "shocks",
        "调整",
        "adjustment"
      ],
      "synonyms": {
        "zh-CN": [
          "共同利率",
          "冲击",
          "调整"
        ],
        "en": [
          "one interest rate",
          "shocks",
          "adjustment"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-57-monetary-union-evaluation-flash-1",
        "u4-57-monetary-union-evaluation-mcq-1",
        "u4-57-monetary-union-evaluation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-57-monetary-union-evaluation",
        "locale": "zh-CN",
        "title": "货币联盟的评价",
        "takeaway": "共同货币可降低交易成本和汇率风险，但独立货币政策的丧失使非对称冲击更难调整；收益取决于成员结构和调整机制。",
        "definition": "共同货币可降低交易成本和汇率风险，但独立货币政策的丧失使非对称冲击更难调整；收益取决于成员结构和调整机制。",
        "causalChain": [
          "统一货币减少汇兑摩擦",
          "共同利率难适配所有冲击",
          "流动性与财政转移帮助调整"
        ],
        "misconceptions": [
          "不能只列收益而不说明非对称冲击和自主性成本。"
        ],
        "examApplication": [
          "准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
        ],
        "summary": [
          "共同货币可降低交易成本和汇率风险，但独立货币政策的丧失使非对称冲击更难调整；收益取决于成员结构和调整机制。",
          "不能只列收益而不说明非对称冲击和自主性成本。"
        ],
        "explanation": "统一货币减少汇兑摩擦。共同利率难适配所有冲击。流动性与财政转移帮助调整。\n\n### 原创情境与推导\n\n原创假设：A 过热而 B 衰退，统一利率不能同时完全适合二者；劳动力流动、工资价格弹性和财政风险分担影响代价。共同货币不自动消除信用风险。\n\n不能只列收益而不说明非对称冲击和自主性成本。\n\n准确区分一体化层次；比较贸易创造、转移、政策自主性与调整机制。"
      },
      "en": {
        "id": "u4-57-monetary-union-evaluation",
        "locale": "en",
        "title": "Evaluating monetary union",
        "takeaway": "A shared currency can lower transaction costs and exchange risk, while lost policy autonomy complicates asymmetric-shock adjustment. Gains depend on member structures and adjustment mechanisms.",
        "definition": "A shared currency can lower transaction costs and exchange risk, while lost policy autonomy complicates asymmetric-shock adjustment. Gains depend on member structures and adjustment mechanisms.",
        "causalChain": [
          "One currency reduces conversion frictions",
          "one interest rate may not suit all shocks",
          "mobility and fiscal transfers aid adjustment"
        ],
        "misconceptions": [
          "Do not list gains without considering asymmetric shocks and autonomy costs."
        ],
        "examApplication": [
          "Distinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
        ],
        "summary": [
          "A shared currency can lower transaction costs and exchange risk, while lost policy autonomy complicates asymmetric-shock adjustment. Gains depend on member structures and adjustment mechanisms.",
          "Do not list gains without considering asymmetric shocks and autonomy costs."
        ],
        "explanation": "One currency reduces conversion frictions.  one interest rate may not suit all shocks.  mobility and fiscal transfers aid adjustment.\n\n### Original scenario and reasoning\n\nHypothetical scenario: A overheats while B contracts, so one interest rate cannot perfectly suit both. Labour mobility, price-wage flexibility and fiscal risk sharing affect costs; a common currency does not eliminate credit risk.\n\nDo not list gains without considering asymmetric shocks and autonomy costs.\n\nDistinguish levels of integration; compare trade creation, diversion, policy autonomy and adjustment mechanisms."
      }
    },
    "practice": [
      {
        "id": "u4-57-monetary-union-evaluation-flash-1",
        "knowledgePointId": "u4-57-monetary-union-evaluation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“货币联盟的评价”，并说明一个关键条件。",
          "en": "Explain Evaluating monetary union and state one important condition."
        },
        "answer": {
          "zh-CN": "共同货币可降低交易成本和汇率风险，但独立货币政策的丧失使非对称冲击更难调整；收益取决于成员结构和调整机制。",
          "en": "A shared currency can lower transaction costs and exchange risk, while lost policy autonomy complicates asymmetric-shock adjustment. Gains depend on member structures and adjustment mechanisms."
        },
        "explanation": {
          "zh-CN": "不能只列收益而不说明非对称冲击和自主性成本。",
          "en": "Do not list gains without considering asymmetric shocks and autonomy costs."
        }
      },
      {
        "id": "u4-57-monetary-union-evaluation-mcq-1",
        "knowledgePointId": "u4-57-monetary-union-evaluation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "成员遇到非对称冲击时失去哪项工具？",
          "en": "Which instrument is lost when members face asymmetric shocks?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "独立本币贬值",
            "en": "Independent currency depreciation"
          },
          {
            "id": "b",
            "zh-CN": "所有财政政策",
            "en": "All fiscal policy"
          },
          {
            "id": "c",
            "zh-CN": "所有贸易",
            "en": "All trade"
          },
          {
            "id": "d",
            "zh-CN": "所有劳动流动",
            "en": "All labour mobility"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "独立本币贬值。 统一货币减少汇兑摩擦；共同利率难适配所有冲击；流动性与财政转移帮助调整 不能只列收益而不说明非对称冲击和自主性成本。",
          "en": "Independent currency depreciation. One currency reduces conversion frictions; one interest rate may not suit all shocks; mobility and fiscal transfers aid adjustment Do not list gains without considering asymmetric shocks and autonomy costs."
        }
      },
      {
        "id": "u4-57-monetary-union-evaluation-short-1",
        "knowledgePointId": "u4-57-monetary-union-evaluation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释货币联盟的评价的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Evaluating monetary union and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "共同货币可降低交易成本和汇率风险，但独立货币政策的丧失使非对称冲击更难调整；收益取决于成员结构和调整机制。 统一货币减少汇兑摩擦；共同利率难适配所有冲击；流动性与财政转移帮助调整 原创假设：A 过热而 B 衰退，统一利率不能同时完全适合二者；劳动力流动、工资价格弹性和财政风险分担影响代价。共同货币不自动消除信用风险。",
          "en": "A shared currency can lower transaction costs and exchange risk, while lost policy autonomy complicates asymmetric-shock adjustment. Gains depend on member structures and adjustment mechanisms. One currency reduces conversion frictions; one interest rate may not suit all shocks; mobility and fiscal transfers aid adjustment Hypothetical scenario: A overheats while B contracts, so one interest rate cannot perfectly suit both. Labour mobility, price-wage flexibility and fiscal risk sharing affect costs; a common currency does not eliminate credit risk."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "共同利率",
              "en": "one interest rate"
            },
            "alternatives": {
              "zh-CN": [
                "共同利率",
                "统一货币减少汇兑摩擦"
              ],
              "en": [
                "one interest rate",
                "One currency reduces conversion frictions"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "冲击",
              "en": "shocks"
            },
            "alternatives": {
              "zh-CN": [
                "冲击",
                "共同利率难适配所有冲击"
              ],
              "en": [
                "shocks",
                "one interest rate may not suit all shocks"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "调整",
              "en": "adjustment"
            },
            "alternatives": {
              "zh-CN": [
                "调整",
                "流动性与财政转移帮助调整"
              ],
              "en": [
                "adjustment",
                "mobility and fiscal transfers aid adjustment"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-58-exchange-regime-evaluation",
      "slug": "exchange-regime-evaluation",
      "section": "4.5",
      "level": "hl",
      "syllabusRefs": [
        "4.5 Exchange rates"
      ],
      "textbookRefs": [
        {
          "chapter": "17",
          "section": "17.2",
          "pages": [
            523
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-21-floating-exchange-rate",
        "u4-22-currency-demand-supply",
        "u4-23-exchange-rate-effects"
      ],
      "terms": [
        "固定与浮动汇率的评价",
        "Evaluating fixed and floating exchange rates",
        "制度",
        "regimes",
        "储备",
        "reserves",
        "自主性",
        "autonomy"
      ],
      "synonyms": {
        "zh-CN": [
          "制度",
          "储备",
          "自主性"
        ],
        "en": [
          "regimes",
          "reserves",
          "autonomy"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-58-exchange-regime-evaluation-flash-1",
        "u4-58-exchange-regime-evaluation-mcq-1",
        "u4-58-exchange-regime-evaluation-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-58-exchange-regime-evaluation",
        "locale": "zh-CN",
        "title": "固定与浮动汇率的评价",
        "takeaway": "固定汇率可减少名义汇率不确定性但需要可信政策与储备；浮动允许外部调整与较大政策自主性，却可能波动并传递进口通胀。",
        "definition": "固定汇率可减少名义汇率不确定性但需要可信政策与储备；浮动允许外部调整与较大政策自主性，却可能波动并传递进口通胀。",
        "causalChain": [
          "制度改变调整渠道",
          "固定制需捍卫平价",
          "浮动制让汇率吸收部分冲击"
        ],
        "misconceptions": [
          "没有对所有经济体都最优的汇率制度；管理浮动也不保证没有波动。"
        ],
        "examApplication": [
          "先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
        ],
        "summary": [
          "固定汇率可减少名义汇率不确定性但需要可信政策与储备；浮动允许外部调整与较大政策自主性，却可能波动并传递进口通胀。",
          "没有对所有经济体都最优的汇率制度；管理浮动也不保证没有波动。"
        ],
        "explanation": "制度改变调整渠道。固定制需捍卫平价。浮动制让汇率吸收部分冲击。\n\n### 原创情境与推导\n\n原创假设：进口依赖高的经济体可能重视汇率稳定，但自由资本流动下独立降息会给平价施压；储备、信誉和供给适应能力决定可行性。\n\n没有对所有经济体都最优的汇率制度；管理浮动也不保证没有波动。\n\n先写汇率报价与制度，再标明需求供给移动，区分价格、数量和时滞效应。"
      },
      "en": {
        "id": "u4-58-exchange-regime-evaluation",
        "locale": "en",
        "title": "Evaluating fixed and floating exchange rates",
        "takeaway": "Fixed rates can reduce nominal exchange uncertainty but need credible policy and reserves. Floating permits external adjustment and more policy autonomy, while risking volatility and imported inflation.",
        "definition": "Fixed rates can reduce nominal exchange uncertainty but need credible policy and reserves. Floating permits external adjustment and more policy autonomy, while risking volatility and imported inflation.",
        "causalChain": [
          "Regimes alter adjustment channels",
          "pegs need parity defence",
          "floating lets exchange rates absorb some shocks"
        ],
        "misconceptions": [
          "No regime is best for every economy; managed floating does not guarantee zero volatility."
        ],
        "examApplication": [
          "State the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
        ],
        "summary": [
          "Fixed rates can reduce nominal exchange uncertainty but need credible policy and reserves. Floating permits external adjustment and more policy autonomy, while risking volatility and imported inflation.",
          "No regime is best for every economy; managed floating does not guarantee zero volatility."
        ],
        "explanation": "Regimes alter adjustment channels.  pegs need parity defence.  floating lets exchange rates absorb some shocks.\n\n### Original scenario and reasoning\n\nHypothetical scenario: an import-dependent economy values stability, but independent rate cuts with mobile capital can pressure a peg. Reserves, credibility and supply adaptability determine feasibility.\n\nNo regime is best for every economy; managed floating does not guarantee zero volatility.\n\nState the quotation and regime first, label demand/supply shifts, and distinguish price, quantity and lag effects."
      }
    },
    "practice": [
      {
        "id": "u4-58-exchange-regime-evaluation-flash-1",
        "knowledgePointId": "u4-58-exchange-regime-evaluation",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“固定与浮动汇率的评价”，并说明一个关键条件。",
          "en": "Explain Evaluating fixed and floating exchange rates and state one important condition."
        },
        "answer": {
          "zh-CN": "固定汇率可减少名义汇率不确定性但需要可信政策与储备；浮动允许外部调整与较大政策自主性，却可能波动并传递进口通胀。",
          "en": "Fixed rates can reduce nominal exchange uncertainty but need credible policy and reserves. Floating permits external adjustment and more policy autonomy, while risking volatility and imported inflation."
        },
        "explanation": {
          "zh-CN": "没有对所有经济体都最优的汇率制度；管理浮动也不保证没有波动。",
          "en": "No regime is best for every economy; managed floating does not guarantee zero volatility."
        }
      },
      {
        "id": "u4-58-exchange-regime-evaluation-mcq-1",
        "knowledgePointId": "u4-58-exchange-regime-evaluation",
        "type": "mcq",
        "prompt": {
          "zh-CN": "评价汇率制度时最合理的做法是什么？",
          "en": "What best evaluates an exchange regime?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "只按制度名称排名",
            "en": "Rank by regime name alone"
          },
          {
            "id": "b",
            "zh-CN": "比较开放度、储备、冲击与政策自主性",
            "en": "Compare openness, reserves, shocks and policy autonomy"
          },
          {
            "id": "c",
            "zh-CN": "假设储备无限",
            "en": "Assume unlimited reserves"
          },
          {
            "id": "d",
            "zh-CN": "忽略进口价格",
            "en": "Ignore import prices"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "比较开放度、储备、冲击与政策自主性。 制度改变调整渠道；固定制需捍卫平价；浮动制让汇率吸收部分冲击 没有对所有经济体都最优的汇率制度；管理浮动也不保证没有波动。",
          "en": "Compare openness, reserves, shocks and policy autonomy. Regimes alter adjustment channels; pegs need parity defence; floating lets exchange rates absorb some shocks No regime is best for every economy; managed floating does not guarantee zero volatility."
        }
      },
      {
        "id": "u4-58-exchange-regime-evaluation-short-1",
        "knowledgePointId": "u4-58-exchange-regime-evaluation",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释固定与浮动汇率的评价的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Evaluating fixed and floating exchange rates and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "固定汇率可减少名义汇率不确定性但需要可信政策与储备；浮动允许外部调整与较大政策自主性，却可能波动并传递进口通胀。 制度改变调整渠道；固定制需捍卫平价；浮动制让汇率吸收部分冲击 原创假设：进口依赖高的经济体可能重视汇率稳定，但自由资本流动下独立降息会给平价施压；储备、信誉和供给适应能力决定可行性。",
          "en": "Fixed rates can reduce nominal exchange uncertainty but need credible policy and reserves. Floating permits external adjustment and more policy autonomy, while risking volatility and imported inflation. Regimes alter adjustment channels; pegs need parity defence; floating lets exchange rates absorb some shocks Hypothetical scenario: an import-dependent economy values stability, but independent rate cuts with mobile capital can pressure a peg. Reserves, credibility and supply adaptability determine feasibility."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "制度",
              "en": "regimes"
            },
            "alternatives": {
              "zh-CN": [
                "制度",
                "制度改变调整渠道"
              ],
              "en": [
                "regimes",
                "Regimes alter adjustment channels"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "储备",
              "en": "reserves"
            },
            "alternatives": {
              "zh-CN": [
                "储备",
                "固定制需捍卫平价"
              ],
              "en": [
                "reserves",
                "pegs need parity defence"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "自主性",
              "en": "autonomy"
            },
            "alternatives": {
              "zh-CN": [
                "自主性",
                "浮动制让汇率吸收部分冲击"
              ],
              "en": [
                "autonomy",
                "floating lets exchange rates absorb some shocks"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-59-development-composite-indices",
      "slug": "development-composite-indices",
      "section": "4.8",
      "level": "core",
      "syllabusRefs": [
        "4.8 Measuring development"
      ],
      "textbookRefs": [
        {
          "chapter": "18",
          "section": "18.2",
          "pages": [
            541
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-38-development-indicators",
        "u4-39-hdi",
        "u4-40-multidimensional-poverty"
      ],
      "terms": [
        "GII、IHDI 与快乐星球指数",
        "GII, IHDI and the Happy Planet Index",
        "性别",
        "gender",
        "分配",
        "distribution",
        "环境",
        "environment"
      ],
      "synonyms": {
        "zh-CN": [
          "性别",
          "分配",
          "环境"
        ],
        "en": [
          "gender",
          "distribution",
          "environment"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-59-development-composite-indices-flash-1",
        "u4-59-development-composite-indices-mcq-1",
        "u4-59-development-composite-indices-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-59-development-composite-indices",
        "locale": "zh-CN",
        "title": "GII、IHDI 与快乐星球指数",
        "takeaway": "GII 衡量生殖健康、赋权和劳动力市场的性别不平等；IHDI 调整 HDI 各维度分配；快乐星球指数衡量有限环境资源下实现长寿和福祉的表现。",
        "definition": "GII 衡量生殖健康、赋权和劳动力市场的性别不平等；IHDI 调整 HDI 各维度分配；快乐星球指数衡量有限环境资源下实现长寿和福祉的表现。",
        "causalChain": [
          "指标选择不同维度",
          "维度与权重决定比较含义",
          "结合多种证据评价发展"
        ],
        "misconceptions": [
          "GII 不是男女 HDI 的简单比值；HPI 不是 HDI，也不是只问主观幸福的排名。"
        ],
        "examApplication": [
          "说明指标维度、单位、年份及均值局限，用多种证据比较而非只报排名。"
        ],
        "summary": [
          "GII 衡量生殖健康、赋权和劳动力市场的性别不平等；IHDI 调整 HDI 各维度分配；快乐星球指数衡量有限环境资源下实现长寿和福祉的表现。",
          "GII 不是男女 HDI 的简单比值；HPI 不是 HDI，也不是只问主观幸福的排名。"
        ],
        "explanation": "指标选择不同维度。维度与权重决定比较含义。结合多种证据评价发展。\n\n### 原创情境与推导\n\n原创假设：相似 HDI 的两国若收入、教育和健康的分配不同，IHDI 可不同；相似寿命与幸福评价而环境负担不同，HPI 也可不同。指标不能互换，比较须采用同一版本的方法。\n\nGII 不是男女 HDI 的简单比值；HPI 不是 HDI，也不是只问主观幸福的排名。\n\n说明指标维度、单位、年份及均值局限，用多种证据比较而非只报排名。"
      },
      "en": {
        "id": "u4-59-development-composite-indices",
        "locale": "en",
        "title": "GII, IHDI and the Happy Planet Index",
        "takeaway": "GII measures gender inequality in reproductive health, empowerment and labour markets; IHDI adjusts HDI for distribution; the Happy Planet Index assesses delivery of long lives and well-being using limited environmental resources.",
        "definition": "GII measures gender inequality in reproductive health, empowerment and labour markets; IHDI adjusts HDI for distribution; the Happy Planet Index assesses delivery of long lives and well-being using limited environmental resources.",
        "causalChain": [
          "Indices select different dimensions",
          "dimensions and weights determine comparisons",
          "combine evidence to assess development"
        ],
        "misconceptions": [
          "GII is not simply a ratio of male and female HDI; HPI is neither HDI nor a subjective-happiness-only ranking."
        ],
        "examApplication": [
          "State dimensions, units, years and average-value limits; compare using multiple indicators rather than rankings alone."
        ],
        "summary": [
          "GII measures gender inequality in reproductive health, empowerment and labour markets; IHDI adjusts HDI for distribution; the Happy Planet Index assesses delivery of long lives and well-being using limited environmental resources.",
          "GII is not simply a ratio of male and female HDI; HPI is neither HDI nor a subjective-happiness-only ranking."
        ],
        "explanation": "Indices select different dimensions.  dimensions and weights determine comparisons.  combine evidence to assess development.\n\n### Original scenario and reasoning\n\nHypothetical scenario: equal HDI can coexist with different IHDI when income, health and education are distributed differently. Similar longevity and well-being with different environmental pressure can yield different HPI. Use the same methodology edition for comparisons.\n\nGII is not simply a ratio of male and female HDI; HPI is neither HDI nor a subjective-happiness-only ranking.\n\nState dimensions, units, years and average-value limits; compare using multiple indicators rather than rankings alone."
      }
    },
    "practice": [
      {
        "id": "u4-59-development-composite-indices-flash-1",
        "knowledgePointId": "u4-59-development-composite-indices",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“GII、IHDI 与快乐星球指数”，并说明一个关键条件。",
          "en": "Explain GII, IHDI and the Happy Planet Index and state one important condition."
        },
        "answer": {
          "zh-CN": "GII 衡量生殖健康、赋权和劳动力市场的性别不平等；IHDI 调整 HDI 各维度分配；快乐星球指数衡量有限环境资源下实现长寿和福祉的表现。",
          "en": "GII measures gender inequality in reproductive health, empowerment and labour markets; IHDI adjusts HDI for distribution; the Happy Planet Index assesses delivery of long lives and well-being using limited environmental resources."
        },
        "explanation": {
          "zh-CN": "GII 不是男女 HDI 的简单比值；HPI 不是 HDI，也不是只问主观幸福的排名。",
          "en": "GII is not simply a ratio of male and female HDI; HPI is neither HDI nor a subjective-happiness-only ranking."
        }
      },
      {
        "id": "u4-59-development-composite-indices-mcq-1",
        "knowledgePointId": "u4-59-development-composite-indices",
        "type": "mcq",
        "prompt": {
          "zh-CN": "哪种指标明确纳入生殖健康、赋权和劳动力市场？",
          "en": "Which index explicitly covers reproductive health, empowerment and labour markets?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "GDP 平减指数",
            "en": "GDP deflator"
          },
          {
            "id": "b",
            "zh-CN": "CPI",
            "en": "CPI"
          },
          {
            "id": "c",
            "zh-CN": "GII",
            "en": "GII"
          },
          {
            "id": "d",
            "zh-CN": "贸易条件指数",
            "en": "Terms-of-trade index"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "GII。 指标选择不同维度；维度与权重决定比较含义；结合多种证据评价发展 GII 不是男女 HDI 的简单比值；HPI 不是 HDI，也不是只问主观幸福的排名。",
          "en": "GII. Indices select different dimensions; dimensions and weights determine comparisons; combine evidence to assess development GII is not simply a ratio of male and female HDI; HPI is neither HDI nor a subjective-happiness-only ranking."
        }
      },
      {
        "id": "u4-59-development-composite-indices-short-1",
        "knowledgePointId": "u4-59-development-composite-indices",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释GII、IHDI 与快乐星球指数的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of GII, IHDI and the Happy Planet Index and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "GII 衡量生殖健康、赋权和劳动力市场的性别不平等；IHDI 调整 HDI 各维度分配；快乐星球指数衡量有限环境资源下实现长寿和福祉的表现。 指标选择不同维度；维度与权重决定比较含义；结合多种证据评价发展 原创假设：相似 HDI 的两国若收入、教育和健康的分配不同，IHDI 可不同；相似寿命与幸福评价而环境负担不同，HPI 也可不同。指标不能互换，比较须采用同一版本的方法。",
          "en": "GII measures gender inequality in reproductive health, empowerment and labour markets; IHDI adjusts HDI for distribution; the Happy Planet Index assesses delivery of long lives and well-being using limited environmental resources. Indices select different dimensions; dimensions and weights determine comparisons; combine evidence to assess development Hypothetical scenario: equal HDI can coexist with different IHDI when income, health and education are distributed differently. Similar longevity and well-being with different environmental pressure can yield different HPI. Use the same methodology edition for comparisons."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "性别",
              "en": "gender"
            },
            "alternatives": {
              "zh-CN": [
                "性别",
                "指标选择不同维度"
              ],
              "en": [
                "gender",
                "Indices select different dimensions"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "分配",
              "en": "distribution"
            },
            "alternatives": {
              "zh-CN": [
                "分配",
                "维度与权重决定比较含义"
              ],
              "en": [
                "distribution",
                "dimensions and weights determine comparisons"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "环境",
              "en": "environment"
            },
            "alternatives": {
              "zh-CN": [
                "环境",
                "结合多种证据评价发展"
              ],
              "en": [
                "environment",
                "combine evidence to assess development"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-60-sdg-country-comparison",
      "slug": "sdg-country-comparison",
      "section": "4.10",
      "level": "core",
      "syllabusRefs": [
        "4.10 Economic growth and development strategies"
      ],
      "textbookRefs": [
        {
          "chapter": "20",
          "section": "20.10",
          "pages": [
            636
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-48-trade-strategies",
        "u4-49-diversification-enterprise",
        "u4-50-market-based-development"
      ],
      "terms": [
        "用两国数据评价健康发展",
        "Evaluating health development using two countries",
        "指标",
        "indicator",
        "年份",
        "years",
        "因果",
        "causal"
      ],
      "synonyms": {
        "zh-CN": [
          "指标",
          "年份",
          "因果"
        ],
        "en": [
          "indicator",
          "years",
          "causal"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-60-sdg-country-comparison-flash-1",
        "u4-60-sdg-country-comparison-mcq-1",
        "u4-60-sdg-country-comparison-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-60-sdg-country-comparison",
        "locale": "zh-CN",
        "realWorldExample": {
          "title": "用两国数据评价健康发展",
          "sourceUrl": "https://data.worldbank.org/indicator/SH.DYN.MORT?locations=CN-IN",
          "observedAt": "2026-10-18",
          "explanation": "世界银行 SH.DYN.MORT 数据（2026-10-18 核验，来源为联合国儿童死亡率估计机构间小组）：每千活产五岁以下死亡率，中国 2000 年 36.6、2022 年 6.6；印度同期 91.8、29.5。两国均下降，但初始水平、降幅及末期水平不同。这与 SDG 3 儿童健康相关，不代表所有健康目标均已实现。来源：https://data.worldbank.org/indicator/SH.DYN.MORT?locations=CN-IN 。"
        },
        "title": "用两国数据评价健康发展",
        "takeaway": "比较发展进展需固定指标定义、单位、年份和来源；儿童死亡率下降显示健康结果改善，但不能单独证明某项政策的因果作用。",
        "definition": "比较发展进展需固定指标定义、单位、年份和来源；儿童死亡率下降显示健康结果改善，但不能单独证明某项政策的因果作用。",
        "causalChain": [
          "选择相同指标与年份",
          "比较水平和变化",
          "结合制度与政策证据解释"
        ],
        "misconceptions": [
          "每千活产不是人口百分比；全国均值会掩盖地区差距，数据也可修订。"
        ],
        "examApplication": [
          "把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
        ],
        "summary": [
          "比较发展进展需固定指标定义、单位、年份和来源；儿童死亡率下降显示健康结果改善，但不能单独证明某项政策的因果作用。",
          "每千活产不是人口百分比；全国均值会掩盖地区差距，数据也可修订。"
        ],
        "explanation": "选择相同指标与年份。比较水平和变化。结合制度与政策证据解释。\n\n### 原创情境与推导\n\n世界银行 SH.DYN.MORT 数据（2026-10-18 核验，来源为联合国儿童死亡率估计机构间小组）：每千活产五岁以下死亡率，中国 2000 年 36.6、2022 年 6.6；印度同期 91.8、29.5。两国均下降，但初始水平、降幅及末期水平不同。这与 SDG 3 儿童健康相关，不代表所有健康目标均已实现。来源：https://data.worldbank.org/indicator/SH.DYN.MORT?locations=CN-IN 。\n\n每千活产不是人口百分比；全国均值会掩盖地区差距，数据也可修订。\n\n把政策与具体约束匹配，评价执行、资金、时滞、公平与可持续性，给出有条件判断。"
      },
      "en": {
        "id": "u4-60-sdg-country-comparison",
        "locale": "en",
        "realWorldExample": {
          "title": "Evaluating health development using two countries",
          "sourceUrl": "https://data.worldbank.org/indicator/SH.DYN.MORT?locations=CN-IN",
          "observedAt": "2026-10-18",
          "explanation": "World Bank SH.DYN.MORT data, checked 2026-10-18 and sourced from the UN Inter-agency Group for Child Mortality Estimation: under-five deaths per 1,000 live births were 36.6 in China in 2000 and 6.6 in 2022; India recorded 91.8 and 29.5. Both declined but differed in starting levels, reductions and final levels. This concerns SDG 3 child health, not achievement of all health goals. Source: https://data.worldbank.org/indicator/SH.DYN.MORT?locations=CN-IN ."
        },
        "title": "Evaluating health development using two countries",
        "takeaway": "Comparing development progress requires consistent indicator definitions, units, years and sources. Lower child mortality indicates better health outcomes but does not alone establish a policy’s causal effect.",
        "definition": "Comparing development progress requires consistent indicator definitions, units, years and sources. Lower child mortality indicates better health outcomes but does not alone establish a policy’s causal effect.",
        "causalChain": [
          "Choose the same indicator and years",
          "compare levels and changes",
          "interpret using institutional and policy evidence"
        ],
        "misconceptions": [
          "Per 1,000 live births is not a population percentage; national averages hide regional gaps and estimates can be revised."
        ],
        "examApplication": [
          "Match policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
        ],
        "summary": [
          "Comparing development progress requires consistent indicator definitions, units, years and sources. Lower child mortality indicates better health outcomes but does not alone establish a policy’s causal effect.",
          "Per 1,000 live births is not a population percentage; national averages hide regional gaps and estimates can be revised."
        ],
        "explanation": "Choose the same indicator and years.  compare levels and changes.  interpret using institutional and policy evidence.\n\n### Original scenario and reasoning\n\nWorld Bank SH.DYN.MORT data, checked 2026-10-18 and sourced from the UN Inter-agency Group for Child Mortality Estimation: under-five deaths per 1,000 live births were 36.6 in China in 2000 and 6.6 in 2022; India recorded 91.8 and 29.5. Both declined but differed in starting levels, reductions and final levels. This concerns SDG 3 child health, not achievement of all health goals. Source: https://data.worldbank.org/indicator/SH.DYN.MORT?locations=CN-IN .\n\nPer 1,000 live births is not a population percentage; national averages hide regional gaps and estimates can be revised.\n\nMatch policy to constraints; evaluate implementation, finance, lags, equity and sustainability, then give a conditional judgement."
      }
    },
    "practice": [
      {
        "id": "u4-60-sdg-country-comparison-flash-1",
        "knowledgePointId": "u4-60-sdg-country-comparison",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“用两国数据评价健康发展”，并说明一个关键条件。",
          "en": "Explain Evaluating health development using two countries and state one important condition."
        },
        "answer": {
          "zh-CN": "比较发展进展需固定指标定义、单位、年份和来源；儿童死亡率下降显示健康结果改善，但不能单独证明某项政策的因果作用。",
          "en": "Comparing development progress requires consistent indicator definitions, units, years and sources. Lower child mortality indicates better health outcomes but does not alone establish a policy’s causal effect."
        },
        "explanation": {
          "zh-CN": "每千活产不是人口百分比；全国均值会掩盖地区差距，数据也可修订。",
          "en": "Per 1,000 live births is not a population percentage; national averages hide regional gaps and estimates can be revised."
        }
      },
      {
        "id": "u4-60-sdg-country-comparison-mcq-1",
        "knowledgePointId": "u4-60-sdg-country-comparison",
        "type": "mcq",
        "prompt": {
          "zh-CN": "两国儿童死亡率同时下降能单独证明什么？",
          "en": "What does falling child mortality in both countries establish on its own?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "所有 SDG 均实现",
            "en": "Every SDG is achieved"
          },
          {
            "id": "b",
            "zh-CN": "两国所有群体均受益相同",
            "en": "Every group benefits equally"
          },
          {
            "id": "c",
            "zh-CN": "某一政策必是唯一原因",
            "en": "One policy must be the sole cause"
          },
          {
            "id": "d",
            "zh-CN": "所列健康指标改善，而非某政策已被证明有效",
            "en": "Improvement in that health indicator, not proof of a particular policy effect"
          }
        ],
        "correctOptionId": "d",
        "explanation": {
          "zh-CN": "所列健康指标改善，而非某政策已被证明有效。 选择相同指标与年份；比较水平和变化；结合制度与政策证据解释 每千活产不是人口百分比；全国均值会掩盖地区差距，数据也可修订。",
          "en": "Improvement in that health indicator, not proof of a particular policy effect. Choose the same indicator and years; compare levels and changes; interpret using institutional and policy evidence Per 1,000 live births is not a population percentage; national averages hide regional gaps and estimates can be revised."
        }
      },
      {
        "id": "u4-60-sdg-country-comparison-short-1",
        "knowledgePointId": "u4-60-sdg-country-comparison",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释用两国数据评价健康发展的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Evaluating health development using two countries and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "比较发展进展需固定指标定义、单位、年份和来源；儿童死亡率下降显示健康结果改善，但不能单独证明某项政策的因果作用。 选择相同指标与年份；比较水平和变化；结合制度与政策证据解释 世界银行 SH.DYN.MORT 数据（2026-10-18 核验，来源为联合国儿童死亡率估计机构间小组）：每千活产五岁以下死亡率，中国 2000 年 36.6、2022 年 6.6；印度同期 91.8、29.5。两国均下降，但初始水平、降幅及末期水平不同。这与 SDG 3 儿童健康相关，不代表所有健康目标均已实现。来源：https://data.worldbank.org/indicator/SH.DYN.MORT?locations=CN-IN 。",
          "en": "Comparing development progress requires consistent indicator definitions, units, years and sources. Lower child mortality indicates better health outcomes but does not alone establish a policy’s causal effect. Choose the same indicator and years; compare levels and changes; interpret using institutional and policy evidence World Bank SH.DYN.MORT data, checked 2026-10-18 and sourced from the UN Inter-agency Group for Child Mortality Estimation: under-five deaths per 1,000 live births were 36.6 in China in 2000 and 6.6 in 2022; India recorded 91.8 and 29.5. Both declined but differed in starting levels, reductions and final levels. This concerns SDG 3 child health, not achievement of all health goals. Source: https://data.worldbank.org/indicator/SH.DYN.MORT?locations=CN-IN ."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "指标",
              "en": "indicator"
            },
            "alternatives": {
              "zh-CN": [
                "指标",
                "选择相同指标与年份"
              ],
              "en": [
                "indicator",
                "Choose the same indicator and years"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "年份",
              "en": "years"
            },
            "alternatives": {
              "zh-CN": [
                "年份",
                "比较水平和变化"
              ],
              "en": [
                "years",
                "compare levels and changes"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "因果",
              "en": "causal"
            },
            "alternatives": {
              "zh-CN": [
                "因果",
                "结合制度与政策证据解释"
              ],
              "en": [
                "causal",
                "interpret using institutional and policy evidence"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-61-current-account-surplus",
      "slug": "current-account-surplus",
      "section": "4.6",
      "level": "hl",
      "syllabusRefs": [
        "4.6 Balance of payments"
      ],
      "textbookRefs": [
        {
          "chapter": "17",
          "section": "17.4",
          "pages": [
            530
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-28-current-account",
        "u4-29-capital-financial-account",
        "u4-30-bop-identity"
      ],
      "terms": [
        "持续经常账户顺差的影响",
        "Implications of persistent current-account surpluses",
        "顺差",
        "surplus",
        "内需",
        "domestic demand",
        "汇率",
        "exchange rate"
      ],
      "synonyms": {
        "zh-CN": [
          "顺差",
          "内需",
          "汇率"
        ],
        "en": [
          "surplus",
          "domestic demand",
          "exchange rate"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-61-current-account-surplus-flash-1",
        "u4-61-current-account-surplus-mcq-1",
        "u4-61-current-account-surplus-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-61-current-account-surplus",
        "locale": "zh-CN",
        "title": "持续经常账户顺差的影响",
        "takeaway": "经常账户顺差可能伴随对外资产积累、强出口或国内支出不足；其就业、汇率和通胀影响依赖产能、制度与资本流。",
        "definition": "经常账户顺差可能伴随对外资产积累、强出口或国内支出不足；其就业、汇率和通胀影响依赖产能、制度与资本流。",
        "causalChain": [
          "国外净需求支持本国产出",
          "资金与储备流形成对应",
          "汇率和内需调整改变未来顺差"
        ],
        "misconceptions": [
          "顺差不自动等于最优，也不保证本币一定升值；需考虑金融流与干预。"
        ],
        "examApplication": [
          "声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
        ],
        "summary": [
          "经常账户顺差可能伴随对外资产积累、强出口或国内支出不足；其就业、汇率和通胀影响依赖产能、制度与资本流。",
          "顺差不自动等于最优，也不保证本币一定升值；需考虑金融流与干预。"
        ],
        "explanation": "国外净需求支持本国产出。资金与储备流形成对应。汇率和内需调整改变未来顺差。\n\n### 原创情境与推导\n\n原创假设：出口需求旺盛可提高就业并推动浮动本币升值，削弱价格竞争力；另一国顺差却可能来自衰退中的进口下降。政府积累外汇储备可改变升值路径。\n\n顺差不自动等于最优，也不保证本币一定升值；需考虑金融流与干预。\n\n声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
      },
      "en": {
        "id": "u4-61-current-account-surplus",
        "locale": "en",
        "title": "Implications of persistent current-account surpluses",
        "takeaway": "A current-account surplus may accompany foreign-asset accumulation, strong exports or weak domestic spending. Employment, exchange-rate and inflation effects depend on capacity, regimes and capital flows.",
        "definition": "A current-account surplus may accompany foreign-asset accumulation, strong exports or weak domestic spending. Employment, exchange-rate and inflation effects depend on capacity, regimes and capital flows.",
        "causalChain": [
          "Net foreign demand supports home output",
          "financial and reserve flows form counterparts",
          "currency and domestic-demand adjustment affect future surpluses"
        ],
        "misconceptions": [
          "A surplus is not automatically optimal and does not guarantee appreciation; financial flows and intervention matter."
        ],
        "examApplication": [
          "Declare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
        ],
        "summary": [
          "A current-account surplus may accompany foreign-asset accumulation, strong exports or weak domestic spending. Employment, exchange-rate and inflation effects depend on capacity, regimes and capital flows.",
          "A surplus is not automatically optimal and does not guarantee appreciation; financial flows and intervention matter."
        ],
        "explanation": "Net foreign demand supports home output.  financial and reserve flows form counterparts.  currency and domestic-demand adjustment affect future surpluses.\n\n### Original scenario and reasoning\n\nHypothetical scenario: strong exports may support employment and appreciate a floating currency, weakening price competitiveness. Another economy’s surplus may instead reflect recession-driven import compression. Reserve accumulation can alter appreciation.\n\nA surplus is not automatically optimal and does not guarantee appreciation; financial flows and intervention matter.\n\nDeclare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
      }
    },
    "practice": [
      {
        "id": "u4-61-current-account-surplus-flash-1",
        "knowledgePointId": "u4-61-current-account-surplus",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“持续经常账户顺差的影响”，并说明一个关键条件。",
          "en": "Explain Implications of persistent current-account surpluses and state one important condition."
        },
        "answer": {
          "zh-CN": "经常账户顺差可能伴随对外资产积累、强出口或国内支出不足；其就业、汇率和通胀影响依赖产能、制度与资本流。",
          "en": "A current-account surplus may accompany foreign-asset accumulation, strong exports or weak domestic spending. Employment, exchange-rate and inflation effects depend on capacity, regimes and capital flows."
        },
        "explanation": {
          "zh-CN": "顺差不自动等于最优，也不保证本币一定升值；需考虑金融流与干预。",
          "en": "A surplus is not automatically optimal and does not guarantee appreciation; financial flows and intervention matter."
        }
      },
      {
        "id": "u4-61-current-account-surplus-mcq-1",
        "knowledgePointId": "u4-61-current-account-surplus",
        "type": "mcq",
        "prompt": {
          "zh-CN": "为何顺差不能自动视为发展成功？",
          "en": "Why is a surplus not automatically development success?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "它可能反映内需和进口低迷",
            "en": "It may reflect weak domestic demand and imports"
          },
          {
            "id": "b",
            "zh-CN": "顺差永不与出口有关",
            "en": "Surpluses never relate to exports"
          },
          {
            "id": "c",
            "zh-CN": "所有顺差都导致失业为零",
            "en": "Every surplus means zero unemployment"
          },
          {
            "id": "d",
            "zh-CN": "顺差必说明没有储蓄",
            "en": "A surplus means no saving"
          }
        ],
        "correctOptionId": "a",
        "explanation": {
          "zh-CN": "它可能反映内需和进口低迷。 国外净需求支持本国产出；资金与储备流形成对应；汇率和内需调整改变未来顺差 顺差不自动等于最优，也不保证本币一定升值；需考虑金融流与干预。",
          "en": "It may reflect weak domestic demand and imports. Net foreign demand supports home output; financial and reserve flows form counterparts; currency and domestic-demand adjustment affect future surpluses A surplus is not automatically optimal and does not guarantee appreciation; financial flows and intervention matter."
        }
      },
      {
        "id": "u4-61-current-account-surplus-short-1",
        "knowledgePointId": "u4-61-current-account-surplus",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释持续经常账户顺差的影响的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Implications of persistent current-account surpluses and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "经常账户顺差可能伴随对外资产积累、强出口或国内支出不足；其就业、汇率和通胀影响依赖产能、制度与资本流。 国外净需求支持本国产出；资金与储备流形成对应；汇率和内需调整改变未来顺差 原创假设：出口需求旺盛可提高就业并推动浮动本币升值，削弱价格竞争力；另一国顺差却可能来自衰退中的进口下降。政府积累外汇储备可改变升值路径。",
          "en": "A current-account surplus may accompany foreign-asset accumulation, strong exports or weak domestic spending. Employment, exchange-rate and inflation effects depend on capacity, regimes and capital flows. Net foreign demand supports home output; financial and reserve flows form counterparts; currency and domestic-demand adjustment affect future surpluses Hypothetical scenario: strong exports may support employment and appreciate a floating currency, weakening price competitiveness. Another economy’s surplus may instead reflect recession-driven import compression. Reserve accumulation can alter appreciation."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "顺差",
              "en": "surplus"
            },
            "alternatives": {
              "zh-CN": [
                "顺差",
                "国外净需求支持本国产出"
              ],
              "en": [
                "surplus",
                "Net foreign demand supports home output"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "内需",
              "en": "domestic demand"
            },
            "alternatives": {
              "zh-CN": [
                "内需",
                "资金与储备流形成对应"
              ],
              "en": [
                "domestic demand",
                "financial and reserve flows form counterparts"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "汇率",
              "en": "exchange rate"
            },
            "alternatives": {
              "zh-CN": [
                "汇率",
                "汇率和内需调整改变未来顺差"
              ],
              "en": [
                "exchange rate",
                "currency and domestic-demand adjustment affect future surpluses"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-62-external-accounts-exchange-rate",
      "slug": "external-accounts-exchange-rate",
      "section": "4.6",
      "level": "hl",
      "syllabusRefs": [
        "4.6 Balance of payments"
      ],
      "textbookRefs": [
        {
          "chapter": "17",
          "section": "17.1",
          "pages": [
            520
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-28-current-account",
        "u4-29-capital-financial-account",
        "u4-30-bop-identity"
      ],
      "terms": [
        "外部账户与汇率的联系",
        "External accounts and exchange rates",
        "经常账户",
        "current account",
        "金融流",
        "financial flows",
        "汇率",
        "exchange rate"
      ],
      "synonyms": {
        "zh-CN": [
          "经常账户",
          "金融流",
          "汇率"
        ],
        "en": [
          "current account",
          "financial flows",
          "exchange rate"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-62-external-accounts-exchange-rate-flash-1",
        "u4-62-external-accounts-exchange-rate-mcq-1",
        "u4-62-external-accounts-exchange-rate-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-62-external-accounts-exchange-rate",
        "locale": "zh-CN",
        "title": "外部账户与汇率的联系",
        "takeaway": "出口收入与对本国资产的需求可增加本币需求，进口与对外资产购买可增加本币供给；不同账户资金流共同影响汇率，因果也可反向。",
        "definition": "出口收入与对本国资产的需求可增加本币需求，进口与对外资产购买可增加本币供给；不同账户资金流共同影响汇率，因果也可反向。",
        "causalChain": [
          "交易形成货币买卖",
          "经常和金融流共同作用",
          "汇率调整又影响贸易与资产回报"
        ],
        "misconceptions": [
          "会计恒等式不证明贸易逆差单独决定汇率，需说明时序和其他条件。"
        ],
        "examApplication": [
          "声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
        ],
        "summary": [
          "出口收入与对本国资产的需求可增加本币需求，进口与对外资产购买可增加本币供给；不同账户资金流共同影响汇率，因果也可反向。",
          "会计恒等式不证明贸易逆差单独决定汇率，需说明时序和其他条件。"
        ],
        "explanation": "交易形成货币买卖。经常和金融流共同作用。汇率调整又影响贸易与资产回报。\n\n### 原创情境与推导\n\n原创假设：经常账户逆差造成的本币卖压可被外国资产购买形成的资本流入抵消，因此不一定贬值；在固定汇率下，储备操作也会改变结果。\n\n会计恒等式不证明贸易逆差单独决定汇率，需说明时序和其他条件。\n\n声明金融账户符号和储备处理；区分贸易余额与经常账户、会计恒等式与经济因果。"
      },
      "en": {
        "id": "u4-62-external-accounts-exchange-rate",
        "locale": "en",
        "title": "External accounts and exchange rates",
        "takeaway": "Export receipts and demand for home assets can raise currency demand, while imports and foreign-asset purchases can raise its supply. Flows across accounts jointly affect exchange rates, with causation also running in reverse.",
        "definition": "Export receipts and demand for home assets can raise currency demand, while imports and foreign-asset purchases can raise its supply. Flows across accounts jointly affect exchange rates, with causation also running in reverse.",
        "causalChain": [
          "Transactions generate currency purchases and sales",
          "current and financial flows interact",
          "exchange changes affect trade and asset returns in turn"
        ],
        "misconceptions": [
          "An accounting identity does not prove a trade deficit alone determines the exchange rate; specify timing and other conditions."
        ],
        "examApplication": [
          "Declare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
        ],
        "summary": [
          "Export receipts and demand for home assets can raise currency demand, while imports and foreign-asset purchases can raise its supply. Flows across accounts jointly affect exchange rates, with causation also running in reverse.",
          "An accounting identity does not prove a trade deficit alone determines the exchange rate; specify timing and other conditions."
        ],
        "explanation": "Transactions generate currency purchases and sales.  current and financial flows interact.  exchange changes affect trade and asset returns in turn.\n\n### Original scenario and reasoning\n\nHypothetical scenario: currency selling associated with a current deficit can be offset by foreign purchases of home assets. Depreciation need not follow; reserve transactions also matter under a peg.\n\nAn accounting identity does not prove a trade deficit alone determines the exchange rate; specify timing and other conditions.\n\nDeclare the financial-account sign and reserve treatment; distinguish trade from current balances and accounting identities from economic causation."
      }
    },
    "practice": [
      {
        "id": "u4-62-external-accounts-exchange-rate-flash-1",
        "knowledgePointId": "u4-62-external-accounts-exchange-rate",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“外部账户与汇率的联系”，并说明一个关键条件。",
          "en": "Explain External accounts and exchange rates and state one important condition."
        },
        "answer": {
          "zh-CN": "出口收入与对本国资产的需求可增加本币需求，进口与对外资产购买可增加本币供给；不同账户资金流共同影响汇率，因果也可反向。",
          "en": "Export receipts and demand for home assets can raise currency demand, while imports and foreign-asset purchases can raise its supply. Flows across accounts jointly affect exchange rates, with causation also running in reverse."
        },
        "explanation": {
          "zh-CN": "会计恒等式不证明贸易逆差单独决定汇率，需说明时序和其他条件。",
          "en": "An accounting identity does not prove a trade deficit alone determines the exchange rate; specify timing and other conditions."
        }
      },
      {
        "id": "u4-62-external-accounts-exchange-rate-mcq-1",
        "knowledgePointId": "u4-62-external-accounts-exchange-rate",
        "type": "mcq",
        "prompt": {
          "zh-CN": "逆差同时出现大量金融流入，能断言本币必贬值吗？",
          "en": "With a deficit and large financial inflows, must home currency depreciate?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "能，其他资金流无影响",
            "en": "Yes; other flows have no effect"
          },
          {
            "id": "b",
            "zh-CN": "不能，汇率取决于合并的供需与制度",
            "en": "No; combined demand, supply and the regime matter"
          },
          {
            "id": "c",
            "zh-CN": "能，储备不可能变化",
            "en": "Yes; reserves cannot change"
          },
          {
            "id": "d",
            "zh-CN": "能，因为金融账户不是交易",
            "en": "Yes; the financial account records no transactions"
          }
        ],
        "correctOptionId": "b",
        "explanation": {
          "zh-CN": "不能，汇率取决于合并的供需与制度。 交易形成货币买卖；经常和金融流共同作用；汇率调整又影响贸易与资产回报 会计恒等式不证明贸易逆差单独决定汇率，需说明时序和其他条件。",
          "en": "No; combined demand, supply and the regime matter. Transactions generate currency purchases and sales; current and financial flows interact; exchange changes affect trade and asset returns in turn An accounting identity does not prove a trade deficit alone determines the exchange rate; specify timing and other conditions."
        }
      },
      {
        "id": "u4-62-external-accounts-exchange-rate-short-1",
        "knowledgePointId": "u4-62-external-accounts-exchange-rate",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释外部账户与汇率的联系的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of External accounts and exchange rates and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "出口收入与对本国资产的需求可增加本币需求，进口与对外资产购买可增加本币供给；不同账户资金流共同影响汇率，因果也可反向。 交易形成货币买卖；经常和金融流共同作用；汇率调整又影响贸易与资产回报 原创假设：经常账户逆差造成的本币卖压可被外国资产购买形成的资本流入抵消，因此不一定贬值；在固定汇率下，储备操作也会改变结果。",
          "en": "Export receipts and demand for home assets can raise currency demand, while imports and foreign-asset purchases can raise its supply. Flows across accounts jointly affect exchange rates, with causation also running in reverse. Transactions generate currency purchases and sales; current and financial flows interact; exchange changes affect trade and asset returns in turn Hypothetical scenario: currency selling associated with a current deficit can be offset by foreign purchases of home assets. Depreciation need not follow; reserve transactions also matter under a peg."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "经常账户",
              "en": "current account"
            },
            "alternatives": {
              "zh-CN": [
                "经常账户",
                "交易形成货币买卖"
              ],
              "en": [
                "current account",
                "Transactions generate currency purchases and sales"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "金融流",
              "en": "financial flows"
            },
            "alternatives": {
              "zh-CN": [
                "金融流",
                "经常和金融流共同作用"
              ],
              "en": [
                "financial flows",
                "current and financial flows interact"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "汇率",
              "en": "exchange rate"
            },
            "alternatives": {
              "zh-CN": [
                "汇率",
                "汇率调整又影响贸易与资产回报"
              ],
              "en": [
                "exchange rate",
                "exchange changes affect trade and asset returns in turn"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  },
  {
    "meta": {
      "id": "u4-63-terms-of-trade-enrichment",
      "slug": "terms-of-trade-enrichment",
      "section": "4.9",
      "level": "extension",
      "syllabusRefs": [
        "4.9 Barriers to economic growth and development"
      ],
      "textbookRefs": [
        {
          "chapter": "19",
          "section": "19.2",
          "pages": [
            566
          ]
        }
      ],
      "prerequisites": [
        "u1-14-opportunity-cost"
      ],
      "related": [
        "u4-42-poverty-cycle",
        "u4-43-human-capital-infrastructure",
        "u4-44-primary-dependence"
      ],
      "terms": [
        "贸易条件指数（扩展）",
        "Terms-of-trade index (enrichment)",
        "出口价格",
        "export prices",
        "进口价格",
        "import prices",
        "指数",
        "index"
      ],
      "synonyms": {
        "zh-CN": [
          "出口价格",
          "进口价格",
          "指数"
        ],
        "en": [
          "export prices",
          "import prices",
          "index"
        ]
      },
      "diagramIds": [],
      "quizIds": [
        "u4-63-terms-of-trade-enrichment-flash-1",
        "u4-63-terms-of-trade-enrichment-mcq-1",
        "u4-63-terms-of-trade-enrichment-short-1"
      ]
    },
    "content": {
      "zh-CN": {
        "id": "u4-63-terms-of-trade-enrichment",
        "locale": "zh-CN",
        "title": "贸易条件指数（扩展）",
        "takeaway": "贸易条件指数为出口价格指数除以进口价格指数再乘 100，描述一单位出口交换进口的相对价格；本卡作为扩展，不标作本考纲必修计算。",
        "definition": "贸易条件指数为出口价格指数除以进口价格指数再乘 100，描述一单位出口交换进口的相对价格；本卡作为扩展，不标作本考纲必修计算。",
        "causalChain": [
          "比较出口与进口价格",
          "计算同基期指数之比",
          "用数量与成本补充解释收入"
        ],
        "misconceptions": [
          "不要把贸易条件指数当汇率或出口额除进口额。"
        ],
        "examApplication": [
          "解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
        ],
        "summary": [
          "贸易条件指数为出口价格指数除以进口价格指数再乘 100，描述一单位出口交换进口的相对价格；本卡作为扩展，不标作本考纲必修计算。",
          "不要把贸易条件指数当汇率或出口额除进口额。"
        ],
        "explanation": "比较出口与进口价格。计算同基期指数之比。用数量与成本补充解释收入。\n\n### 原创情境与推导\n\n原创假设：出口价指数 90、进口价指数 120，贸易条件为 75；这不是贸易余额 −25，也不单独决定出口总收入。\n\n不要把贸易条件指数当汇率或出口额除进口额。\n\n解释障碍如何相互强化，识别主要约束，避免对国家或群体作决定论推断。"
      },
      "en": {
        "id": "u4-63-terms-of-trade-enrichment",
        "locale": "en",
        "title": "Terms-of-trade index (enrichment)",
        "takeaway": "The terms-of-trade index is the export price index divided by the import price index times 100, describing relative export purchasing power. This card is enrichment, not labelled a required calculation in this syllabus.",
        "definition": "The terms-of-trade index is the export price index divided by the import price index times 100, describing relative export purchasing power. This card is enrichment, not labelled a required calculation in this syllabus.",
        "causalChain": [
          "Compare export and import prices",
          "divide indices with the same base",
          "add quantities and costs to explain receipts"
        ],
        "misconceptions": [
          "Do not confuse terms of trade with an exchange rate or exports divided by imports."
        ],
        "examApplication": [
          "Explain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
        ],
        "summary": [
          "The terms-of-trade index is the export price index divided by the import price index times 100, describing relative export purchasing power. This card is enrichment, not labelled a required calculation in this syllabus.",
          "Do not confuse terms of trade with an exchange rate or exports divided by imports."
        ],
        "explanation": "Compare export and import prices.  divide indices with the same base.  add quantities and costs to explain receipts.\n\n### Original scenario and reasoning\n\nHypothetical scenario: export price index ninety and import price index 120 give terms of trade 75. This is not a trade balance of −25 and does not alone determine export receipts.\n\nDo not confuse terms of trade with an exchange rate or exports divided by imports.\n\nExplain reinforcing barriers, identify binding constraints and avoid deterministic claims about countries or groups."
      }
    },
    "practice": [
      {
        "id": "u4-63-terms-of-trade-enrichment-flash-1",
        "knowledgePointId": "u4-63-terms-of-trade-enrichment",
        "type": "flashcard",
        "prompt": {
          "zh-CN": "解释“贸易条件指数（扩展）”，并说明一个关键条件。",
          "en": "Explain Terms-of-trade index (enrichment) and state one important condition."
        },
        "answer": {
          "zh-CN": "贸易条件指数为出口价格指数除以进口价格指数再乘 100，描述一单位出口交换进口的相对价格；本卡作为扩展，不标作本考纲必修计算。",
          "en": "The terms-of-trade index is the export price index divided by the import price index times 100, describing relative export purchasing power. This card is enrichment, not labelled a required calculation in this syllabus."
        },
        "explanation": {
          "zh-CN": "不要把贸易条件指数当汇率或出口额除进口额。",
          "en": "Do not confuse terms of trade with an exchange rate or exports divided by imports."
        }
      },
      {
        "id": "u4-63-terms-of-trade-enrichment-mcq-1",
        "knowledgePointId": "u4-63-terms-of-trade-enrichment",
        "type": "mcq",
        "prompt": {
          "zh-CN": "出口价指数 110、进口价指数 100，贸易条件多少？",
          "en": "Export price index 110 and import price index 100 give what terms of trade?"
        },
        "options": [
          {
            "id": "a",
            "zh-CN": "90.9",
            "en": "90.9"
          },
          {
            "id": "b",
            "zh-CN": "10",
            "en": "10"
          },
          {
            "id": "c",
            "zh-CN": "110",
            "en": "110"
          },
          {
            "id": "d",
            "zh-CN": "210",
            "en": "210"
          }
        ],
        "correctOptionId": "c",
        "explanation": {
          "zh-CN": "110。 110 / 100 × 100 = 110 不要把贸易条件指数当汇率或出口额除进口额。",
          "en": "110. 110 / 100 × 100 = 110 Do not confuse terms of trade with an exchange rate or exports divided by imports."
        }
      },
      {
        "id": "u4-63-terms-of-trade-enrichment-short-1",
        "knowledgePointId": "u4-63-terms-of-trade-enrichment",
        "type": "short-answer",
        "prompt": {
          "zh-CN": "解释贸易条件指数（扩展）的机制，并用一个自己设计的情境说明其含义。",
          "en": "Explain the mechanism of Terms-of-trade index (enrichment) and apply it to an example of your own."
        },
        "modelAnswer": {
          "zh-CN": "贸易条件指数为出口价格指数除以进口价格指数再乘 100，描述一单位出口交换进口的相对价格；本卡作为扩展，不标作本考纲必修计算。 比较出口与进口价格；计算同基期指数之比；用数量与成本补充解释收入 原创假设：出口价指数 90、进口价指数 120，贸易条件为 75；这不是贸易余额 −25，也不单独决定出口总收入。",
          "en": "The terms-of-trade index is the export price index divided by the import price index times 100, describing relative export purchasing power. This card is enrichment, not labelled a required calculation in this syllabus. Compare export and import prices; divide indices with the same base; add quantities and costs to explain receipts Hypothetical scenario: export price index ninety and import price index 120 give terms of trade 75. This is not a trade balance of −25 and does not alone determine export receipts."
        },
        "keywordGroups": [
          {
            "id": "mechanism-1",
            "label": {
              "zh-CN": "出口价格",
              "en": "export prices"
            },
            "alternatives": {
              "zh-CN": [
                "出口价格",
                "比较出口与进口价格"
              ],
              "en": [
                "export prices",
                "Compare export and import prices"
              ]
            }
          },
          {
            "id": "mechanism-2",
            "label": {
              "zh-CN": "进口价格",
              "en": "import prices"
            },
            "alternatives": {
              "zh-CN": [
                "进口价格",
                "计算同基期指数之比"
              ],
              "en": [
                "import prices",
                "divide indices with the same base"
              ]
            }
          },
          {
            "id": "mechanism-3",
            "label": {
              "zh-CN": "指数",
              "en": "index"
            },
            "alternatives": {
              "zh-CN": [
                "指数",
                "用数量与成本补充解释收入"
              ],
              "en": [
                "index",
                "add quantities and costs to explain receipts"
              ]
            }
          }
        ],
        "explanation": {
          "zh-CN": "关键词覆盖是辅助提示，不是 IB 官方评分。检查条件、因果关系和情境应用后，可手动修正判定。",
          "en": "Keyword coverage is a study aid, not official IB marking. Check assumptions, causation and application, then override the judgement if needed."
        }
      }
    ]
  }
] as KnowledgePoint[];
